/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 502);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(510);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(538);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(753),
    util = __webpack_require__(755);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "actionTypes", function() { return actionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayInsert", function() { return arrayInsert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMove", function() { return arrayMove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayPop", function() { return arrayPop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayPush", function() { return arrayPush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayRemove", function() { return arrayRemove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayRemoveAll", function() { return arrayRemoveAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayShift", function() { return arrayShift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arraySplice", function() { return arraySplice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arraySwap", function() { return arraySwap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayUnshift", function() { return arrayUnshift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "autofill", function() { return autofill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "blur", function() { return blur; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "change", function() { return change; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearSubmitErrors", function() { return clearSubmitErrors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroy", function() { return destroy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focus", function() { return focus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialize", function() { return initialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerField", function() { return registerField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubmitFailed", function() { return setSubmitFailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSubmitSucceeded", function() { return setSubmitSucceeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startAsyncValidation", function() { return startAsyncValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startSubmit", function() { return startSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopAsyncValidation", function() { return stopAsyncValidation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopSubmit", function() { return stopSubmit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "submit", function() { return submit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "touch", function() { return touch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unregisterField", function() { return unregisterField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "untouch", function() { return untouch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__ = __webpack_require__(292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultShouldAsyncValidate", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultShouldValidate", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultShouldError", function() { return __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__ = __webpack_require__(295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultShouldWarn", function() { return __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(579);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_6__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormSection__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormSection", function() { return __WEBPACK_IMPORTED_MODULE_7__FormSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SubmissionError__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SubmissionError", function() { return __WEBPACK_IMPORTED_MODULE_8__SubmissionError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__propTypes__ = __webpack_require__(582);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "propTypes", function() { return __WEBPACK_IMPORTED_MODULE_9__propTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldInputPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_9__propTypes__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldMetaPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_9__propTypes__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_9__propTypes__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldArrayFieldsPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_9__propTypes__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldArrayMetaPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_9__propTypes__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "fieldArrayPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_9__propTypes__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_9__propTypes__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Field__ = __webpack_require__(583);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Field", function() { return __WEBPACK_IMPORTED_MODULE_10__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Fields__ = __webpack_require__(652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Fields", function() { return __WEBPACK_IMPORTED_MODULE_11__Fields__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FieldArray__ = __webpack_require__(655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldArray", function() { return __WEBPACK_IMPORTED_MODULE_12__FieldArray__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__formValueSelector__ = __webpack_require__(673);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formValueSelector", function() { return __WEBPACK_IMPORTED_MODULE_13__formValueSelector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formValues__ = __webpack_require__(675);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formValues", function() { return __WEBPACK_IMPORTED_MODULE_14__formValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__getFormError__ = __webpack_require__(677);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormError", function() { return __WEBPACK_IMPORTED_MODULE_15__getFormError__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getFormNames__ = __webpack_require__(679);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormNames", function() { return __WEBPACK_IMPORTED_MODULE_16__getFormNames__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getFormValues__ = __webpack_require__(681);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormValues", function() { return __WEBPACK_IMPORTED_MODULE_17__getFormValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getFormInitialValues__ = __webpack_require__(683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormInitialValues", function() { return __WEBPACK_IMPORTED_MODULE_18__getFormInitialValues__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getFormSyncErrors__ = __webpack_require__(685);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormSyncErrors", function() { return __WEBPACK_IMPORTED_MODULE_19__getFormSyncErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__getFormMeta__ = __webpack_require__(687);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormMeta", function() { return __WEBPACK_IMPORTED_MODULE_20__getFormMeta__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__getFormAsyncErrors__ = __webpack_require__(689);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormAsyncErrors", function() { return __WEBPACK_IMPORTED_MODULE_21__getFormAsyncErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__getFormSyncWarnings__ = __webpack_require__(691);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormSyncWarnings", function() { return __WEBPACK_IMPORTED_MODULE_22__getFormSyncWarnings__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__getFormSubmitErrors__ = __webpack_require__(693);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getFormSubmitErrors", function() { return __WEBPACK_IMPORTED_MODULE_23__getFormSubmitErrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__isDirty__ = __webpack_require__(695);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isDirty", function() { return __WEBPACK_IMPORTED_MODULE_24__isDirty__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isInvalid__ = __webpack_require__(697);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isInvalid", function() { return __WEBPACK_IMPORTED_MODULE_25__isInvalid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isPristine__ = __webpack_require__(700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isPristine", function() { return __WEBPACK_IMPORTED_MODULE_26__isPristine__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isValid__ = __webpack_require__(701);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValid", function() { return __WEBPACK_IMPORTED_MODULE_27__isValid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isSubmitting__ = __webpack_require__(702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSubmitting", function() { return __WEBPACK_IMPORTED_MODULE_28__isSubmitting__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__hasSubmitSucceeded__ = __webpack_require__(704);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hasSubmitSucceeded", function() { return __WEBPACK_IMPORTED_MODULE_29__hasSubmitSucceeded__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__hasSubmitFailed__ = __webpack_require__(706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hasSubmitFailed", function() { return __WEBPACK_IMPORTED_MODULE_30__hasSubmitFailed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__reduxForm__ = __webpack_require__(708);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reduxForm", function() { return __WEBPACK_IMPORTED_MODULE_31__reduxForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__reducer__ = __webpack_require__(740);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "reducer", function() { return __WEBPACK_IMPORTED_MODULE_32__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__values__ = __webpack_require__(743);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "values", function() { return __WEBPACK_IMPORTED_MODULE_33__values__["a"]; });









// alias for propTypes

























var actionTypes = __WEBPACK_IMPORTED_MODULE_1__actionTypes__;
var arrayInsert = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayInsert;
var arrayMove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayMove;
var arrayPop = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPop;
var arrayPush = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPush;
var arrayRemove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemove;
var arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemoveAll;
var arrayShift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayShift;
var arraySplice = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySplice;
var arraySwap = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySwap;
var arrayUnshift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayUnshift;
var autofill = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].autofill;
var blur = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].blur;
var change = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].change;
var clearSubmitErrors = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearSubmitErrors;
var destroy = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].destroy;
var focus = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].focus;
var initialize = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].initialize;
var registerField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].registerField;
var reset = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].reset;
var setSubmitFailed = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitFailed;
var setSubmitSucceeded = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitSucceeded;
var startAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startAsyncValidation;
var startSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startSubmit;
var stopAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopAsyncValidation;
var stopSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopSubmit;
var submit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].submit;
var touch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].touch;
var unregisterField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].unregisterField;
var untouch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].untouch;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('map', __webpack_require__(371));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.DELETE=exports.PUT=exports.POST=exports.GET=exports.apiBase=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _errorHandler=__webpack_require__(752);var _errorHandler2=_interopRequireDefault(_errorHandler);var _jsCookie=__webpack_require__(227);var _jsCookie2=_interopRequireDefault(_jsCookie);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {Dispatch} from 'redux';*/var apiBase=exports.apiBase='/api';var getAuthorizationHeader=function getAuthorizationHeader(){var token=_jsCookie2.default.get('token');return token?{Authorization:'Bearer '+token}:{};};/*:: type Body = ?string | FormData | Object;*//*:: type RequestConfig = {
  endpoint: string,
  body?: Body,
  expectBody?: boolean,
};*//*:: type FetchOptions = {
  body?: ?string | FormData,
  headers?: {[key: string]: string},
  method?: string,
};*/var mergeConfig=function mergeConfig()/*: FetchOptions*/{var config/*:: ?: FetchOptions*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return _extends({},config,{headers:_extends({},config.headers,getAuthorizationHeader())});};var addBody=function addBody(body/*: ?Body*/)/*: ?FetchOptions*/{return body?{body:typeof body==='string'||body instanceof FormData?body:JSON.stringify(body),headers:body instanceof FormData?{}:{'Content-Type':'application/json'}}:null;};var GET=exports.GET=function GET()/*: Promise<any>*/{var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},endpoint=_ref.endpoint;var dispatch/*: Dispatch<*>*/=arguments[1];return fetch(''+apiBase+endpoint,_extends({},mergeConfig())).then((0,_errorHandler2.default)(dispatch),(0,_errorHandler.handleIEBugs)(dispatch));};var POST=exports.POST=function POST()/*: Promise<any>*/{var _ref2=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},endpoint=_ref2.endpoint,body=_ref2.body,_ref2$expectBody=_ref2.expectBody,expectBody=_ref2$expectBody===undefined?true:_ref2$expectBody;var dispatch/*: Dispatch<*>*/=arguments[1];return fetch(''+apiBase+endpoint,_extends({},mergeConfig(_extends({method:'POST'},addBody(body))))).then((0,_errorHandler2.default)(dispatch,expectBody),(0,_errorHandler.handleIEBugs)(dispatch));};var PUT=exports.PUT=function PUT()/*: Promise<any>*/{var _ref3=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},endpoint=_ref3.endpoint,body=_ref3.body,_ref3$expectBody=_ref3.expectBody,expectBody=_ref3$expectBody===undefined?true:_ref3$expectBody;var dispatch/*: Dispatch<*>*/=arguments[1];return fetch(''+apiBase+endpoint,_extends({},mergeConfig(_extends({method:'PUT'},addBody(body))))).then((0,_errorHandler2.default)(dispatch,expectBody),(0,_errorHandler.handleIEBugs)(dispatch));};var DELETE=exports.DELETE=function DELETE()/*: Promise<any>*/{var _ref4=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},endpoint=_ref4.endpoint;var dispatch/*: Dispatch<*>*/=arguments[1];return fetch(''+apiBase+endpoint,_extends({},mergeConfig({method:'DELETE'}))).then((0,_errorHandler2.default)(dispatch,false),(0,_errorHandler.handleIEBugs)(dispatch));};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toNumber2=__webpack_require__(84);var _toNumber3=_interopRequireDefault(_toNumber2);var _isNumber2=__webpack_require__(960);var _isNumber3=_interopRequireDefault(_isNumber2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(962);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  isLoading: boolean,
  isGlobal?: boolean,
  hideSpinner?: boolean,
  progress?: number,
};*/var _ref2=_react2.default.createElement('div',{className:'sk-three-bounce'},_react2.default.createElement('div',{className:'sk-child sk-bounce1'}),_react2.default.createElement('div',{className:'sk-child sk-bounce2'}),_react2.default.createElement('div',{className:'sk-child sk-bounce3'}));var LoadingIndicator=function LoadingIndicator(_ref){var isLoading=_ref.isLoading,progress=_ref.progress,_ref$isGlobal=_ref.isGlobal,isGlobal=_ref$isGlobal===undefined?false:_ref$isGlobal,_ref$hideSpinner=_ref.hideSpinner,hideSpinner=_ref$hideSpinner===undefined?false:_ref$hideSpinner;return _react2.default.createElement('div',{className:(0,_classnames2.default)({LoadingIndicator:true,isLoading:isLoading,isGlobal:isGlobal})},(0,_isNumber3.default)(progress)&&_react2.default.createElement('div',{className:'success progress'},_react2.default.createElement('div',{className:'progress-meter',style:{width:(0,_toNumber3.default)(progress)+'%'}})),!hideSpinner&&_react2.default.createElement('div',{className:(0,_classnames2.default)({spinner:true,small:(0,_isNumber3.default)(progress)})},_ref2));};exports.default=LoadingIndicator;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('filter', __webpack_require__(854));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(532)();
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserRouter", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(555);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HashRouter", function() { return __WEBPACK_IMPORTED_MODULE_1__HashRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(557);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(560);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NavLink", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(563);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Prompt", function() { return __WEBPACK_IMPORTED_MODULE_5__Prompt__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(565);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(571);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StaticRouter", function() { return __WEBPACK_IMPORTED_MODULE_9__StaticRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(573);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Switch", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(575);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "matchPath", function() { return __WEBPACK_IMPORTED_MODULE_11__matchPath__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(576);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(750);


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _find3=__webpack_require__(20);var _find4=_interopRequireDefault(_find3);var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _reactSelect=__webpack_require__(428);var _reactSelect2=_interopRequireDefault(_reactSelect);__webpack_require__(1020);__webpack_require__(1021);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  input: any,
  label?: string,
  placeholder?: string,
  disabled?: boolean,
  meta: any,
  options: any[],
  multi?: boolean,
  labelKey: string,
  valueKey: string,
  isLoading?: boolean,
  clearable?: boolean,
  keepOpen?: boolean,
};*//*:: export type State = {
  selectRef?: any,
};*/var SelectFormInput=function(_Component){_inherits(SelectFormInput,_Component);function SelectFormInput(props/*: Props*/){_classCallCheck(this,SelectFormInput);var _this=_possibleConstructorReturn(this,(SelectFormInput.__proto__||Object.getPrototypeOf(SelectFormInput)).call(this,props));_this.onGetSelectRef=function(ref/*: any*/){_this.setState(_extends({},_this.state,{selectRef:ref}));};_this.keepSelectOpen=function(){if(_this.props.keepOpen&&_this.state.selectRef){_this.state.selectRef.setState({isOpen:true});}};_this.state={selectRef:null};return _this;}_createClass(SelectFormInput,[{key:'render',value:function render(){var _this2=this;var _props=this.props,input=_props.input,_props$label=_props.label,label=_props$label===undefined?'':_props$label,placeholder=_props.placeholder,_props$disabled=_props.disabled,disabled=_props$disabled===undefined?false:_props$disabled,_props$meta=_props.meta,touched=_props$meta.touched,error=_props$meta.error,options=_props.options,labelKey=_props.labelKey,valueKey=_props.valueKey,multi=_props.multi,_props$isLoading=_props.isLoading,isLoading=_props$isLoading===undefined?false:_props$isLoading,_props$clearable=_props.clearable,clearable=_props$clearable===undefined?false:_props$clearable;return _react2.default.createElement('div',null,label&&_react2.default.createElement('label',{className:(0,_classnames2.default)({'is-invalid-label':touched&&error})},label),_react2.default.createElement('div',null,_react2.default.createElement(_reactSelect2.default,{ref:this.onGetSelectRef,value:input.value,onChange:function onChange(value){_this2.keepSelectOpen();input.onChange(!(0,_isEmpty3.default)(value)?value:multi?[]:null);},options:options,placeholder:placeholder||label,clearable:clearable,labelKey:labelKey,valueKey:valueKey,isLoading:isLoading,disabled:!!disabled,valueRenderer:function valueRenderer(option){if(!option[labelKey]&&!(options&&options.length)){return'Laddar...';}else if(!option[labelKey]){return((0,_find4.default)(_defineProperty({},valueKey,option[valueKey]),options)||{})[labelKey];}else{return option[labelKey];}},className:(0,_classnames2.default)({'is-invalid-input':touched&&error}),multi:multi||false,noResultsText:'Inga resultat hittades'}),touched&&error&&_react2.default.createElement('span',{className:'form-error is-visible'},error)));}}]);return SelectFormInput;}(_react.Component);SelectFormInput.defaultProps={isLoading:false,clearable:false,keepOpen:false};exports.default=SelectFormInput;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splice__ = __webpack_require__(588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getIn__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setIn__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepEqual__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deleteIn__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(651);








var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: __WEBPACK_IMPORTED_MODULE_1__getIn__["a" /* default */],
  setIn: __WEBPACK_IMPORTED_MODULE_2__setIn__["a" /* default */],
  deepEqual: __WEBPACK_IMPORTED_MODULE_3__deepEqual__["a" /* default */],
  deleteIn: __WEBPACK_IMPORTED_MODULE_4__deleteIn__["a" /* default */],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: __WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: __WEBPACK_IMPORTED_MODULE_0__splice__["a" /* default */],
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('flow', __webpack_require__(848));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(280);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _values2=__webpack_require__(67);var _values3=_interopRequireDefault(_values2);var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _flatMap2=__webpack_require__(54);var _flatMap3=_interopRequireDefault(_flatMap2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {ErrorDto} from '../../dtos';*/var mapWithIndex=_map3.default.convert({cap:false});var flatMapWithIndex=_flatMap3.default.convert({cap:false});/*:: export type ErrorItemsProps = {
  errors: string[],
  startIndex?: number,
};*/var ErrorItems=function ErrorItems(_ref){var errors=_ref.errors,_ref$startIndex=_ref.startIndex,startIndex=_ref$startIndex===undefined?0:_ref$startIndex;return mapWithIndex(function(m,i){return _react2.default.createElement('li',{key:startIndex+i},m);},errors);};/*:: export type Props = {
  error: ?ErrorDto,
};*/var ServerError=function ServerError(_ref2){var error=_ref2.error;return _react2.default.createElement('div',{className:'ServerError'},error&&_react2.default.createElement('div',{className:'callout alert'},_react2.default.createElement('h5',null,error.message),!!error.errors&&!(0,_isEmpty3.default)(error.errors)&&_react2.default.createElement('ul',null,Array.isArray(error.errors)?_react2.default.createElement(ErrorItems,{errors:error.errors}):flatMapWithIndex(function(e,i){return _react2.default.createElement(ErrorItems,{key:i,errors:e,startIndex:i});},(0,_values3.default)(error.errors)))));};exports.default=ServerError;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var SET_DIRTY=exports.SET_DIRTY='@form/SET_DIRTY';/*:: export type FormAction = {
  type: '@form/SET_DIRTY',
  dirty: boolean,
  form: string,
};*/var setDirty=exports.setDirty=function setDirty(dirty/*: boolean*/,form/*: string*/)/*: FormAction*/{return{type:SET_DIRTY,dirty:dirty,form:form};};

/***/ }),
/* 18 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('find', __webpack_require__(386));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reduce2=__webpack_require__(123);var _reduce3=_interopRequireDefault(_reduce2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _reactRedux=__webpack_require__(2);var _actionConfirmation=__webpack_require__(406);__webpack_require__(1057);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var reduceWithKey=_reduce3.default.convert({cap:false});/*:: import type {Element} from 'react';*//*:: export type Props = {
  message?: string,
  messages?: Array<string>,
  id: string,
  className?: string,
  buttonText?: string,
  action: Function,
  actionConfirmation: Object,
  toggleDialog: Function,
  wrapperClassName?: string,
  children?: number | string | Element<*> | Array<any>,
};*/var ActionConfirmation=function(_Component){_inherits(ActionConfirmation,_Component);function ActionConfirmation(){_classCallCheck(this,ActionConfirmation);return _possibleConstructorReturn(this,(ActionConfirmation.__proto__||Object.getPrototypeOf(ActionConfirmation)).apply(this,arguments));}_createClass(ActionConfirmation,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.toggleDialog(this.props.id,false);}},{key:'render',value:function render(){var _props=this.props,id=_props.id,action=_props.action,actionConfirmation=_props.actionConfirmation,toggleDialog=_props.toggleDialog,_props$className=_props.className,className=_props$className===undefined?'':_props$className,buttonText=_props.buttonText,_props$message=_props.message,message=_props$message===undefined?null:_props$message,_props$messages=_props.messages,messages=_props$messages===undefined?[]:_props$messages,_props$wrapperClassNa=_props.wrapperClassName,wrapperClassName=_props$wrapperClassNa===undefined?'':_props$wrapperClassNa,children=_props.children;return _react2.default.createElement('div',{className:'ActionConfirmation '+wrapperClassName},_react2.default.createElement('button',{className:'button '+className,type:'button',onClick:function onClick(){return toggleDialog(id,true);}},children||buttonText),_react2.default.createElement(_ModalDialog2.default,{onClose:function onClose(){return toggleDialog(id,false);},className:'ActionConfirmationDialog',show:!!actionConfirmation[id]},_react2.default.createElement('div',{className:'callout warning text-center'},_react2.default.createElement('p',null,!!message?message:!!messages.length?reduceWithKey(function(x,y,i){return!!x.length?[].concat(_toConsumableArray(x),[_react2.default.createElement('br',{key:i}),y]):[y];},[],messages):'Är du säker?')),_react2.default.createElement('button',{type:'button',className:'expanded success button',onClick:function onClick(){toggleDialog(id,false);action();}},'Ja'),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:function onClick(){return toggleDialog(id,false);}},'Avbryt')));}}]);return ActionConfirmation;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var actionConfirmation=_ref.actionConfirmation;return{actionConfirmation:actionConfirmation};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggleDialog:function toggleDialog(id,show){return dispatch((0,_actionConfirmation.toggleDialog)(id,show));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ActionConfirmation);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('noop', __webpack_require__(209), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});//  weak
var ADD=exports.ADD='@notification/ADD';var REMOVE=exports.REMOVE='@notification/REMOVE';/*:: export type OptionalNavigationAction = {
  '@notification/ADD'?: {
    message: string,
    level?: 'success' | 'error',
  },
};*/var addNotification=exports.addNotification=function addNotification(message,level){return{type:ADD,message:message,level:level};};var removeNotification=exports.removeNotification=function removeNotification(id){return{type:REMOVE,id:id};};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(828),
    baseMatchesProperty = __webpack_require__(836),
    identity = __webpack_require__(62),
    isArray = __webpack_require__(18),
    property = __webpack_require__(840);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('some', __webpack_require__(865));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('keys', __webpack_require__(59), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  input: any,
  label: string,
  type: string,
  meta: any,
};*/var BasicFormInput=function BasicFormInput(_ref){var input=_ref.input,label=_ref.label,type=_ref.type,_ref$meta=_ref.meta,touched=_ref$meta.touched,error=_ref$meta.error;return _react2.default.createElement('div',null,_react2.default.createElement('label',{className:(0,_classnames2.default)({'is-invalid-label':touched&&error})},label),_react2.default.createElement('div',null,_react2.default.createElement('input',_extends({},input,{onChange:function onChange(e){input.onChange(e.target.value);},placeholder:label,type:type,className:(0,_classnames2.default)({'is-invalid-input':touched&&error})})),touched&&error&&_react2.default.createElement('span',{className:'form-error is-visible'},error)));};exports.default=BasicFormInput;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _mapValues2=__webpack_require__(66);var _mapValues3=_interopRequireDefault(_mapValues2);var _isBoolean2=__webpack_require__(1025);var _isBoolean3=_interopRequireDefault(_isBoolean2);var _flat=__webpack_require__(1027);var _validatorjs=__webpack_require__(1029);var _validatorjs2=_interopRequireDefault(_validatorjs);var _moment=__webpack_require__(256);var _moment2=_interopRequireDefault(_moment);var _lang=__webpack_require__(1036);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}_validatorjs2.default.setMessages('se',_lang.validationErrors);_validatorjs2.default.useLang('se');_validatorjs2.default.register('archivable',function(value,requirement,attribute){return(0,_isBoolean3.default)(value)||(0,_moment2.default)(value,_moment2.default.ISO_8601).isValid();},_lang.validationErrors.archivable);var mapRules=(0,_mapValues3.default)('rule');var mapLabels=(0,_mapValues3.default)('label');exports.default=function(validation,data){var rules=mapRules(validation);var attributes=mapLabels(validation);var validator=new _validatorjs2.default(data,rules);validator.setAttributeNames(attributes);validator.passes();return(0,_flat.unflatten)(validator.errors.all());};

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('isEmpty', __webpack_require__(852), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _findIndex2=__webpack_require__(99);var _findIndex3=_interopRequireDefault(_findIndex2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _Button=__webpack_require__(258);var _Button2=_interopRequireDefault(_Button);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//  weak
var navigation=function navigation(list,current){var previous=void 0,next=void 0;if(!!current&&!!list&&!!list.length){var currIdx=(0,_findIndex3.default)(function(x){return x.id===current.id;},list);if(currIdx>0){previous=list[currIdx-1];}if(currIdx<list.length-1){next=list[currIdx+1];}}return{previous:previous,next:next};};/*:: export type Props = {
  history: Object,
  prevPath?: string,
  current?: ?any,
  list?: any[],
  clear?: Function,
  fetchData?: (id: ?any) => any,
  hideNavigation?: bool,
};*/var _ref=_react2.default.createElement(_Button2.default,{key:'back',icon:'bars'});var Navigation=function(_Component){_inherits(Navigation,_Component);function Navigation(){_classCallCheck(this,Navigation);return _possibleConstructorReturn(this,(Navigation.__proto__||Object.getPrototypeOf(Navigation)).apply(this,arguments));}_createClass(Navigation,[{key:'goTo',value:function goTo(entity){var _props=this.props,history=_props.history,prevPath=_props.prevPath,clear=_props.clear,fetchData=_props.fetchData;if(!clear||!fetchData||!prevPath){return null;}return function(){// eslint-disable-next-line
history.replace(prevPath+'/'+entity.id);clear();fetchData(entity.id);};}},{key:'render',value:function render(){var _props2=this.props,clear=_props2.clear,current=_props2.current,fetchData=_props2.fetchData,list=_props2.list,prevPath=_props2.prevPath,_props2$hideNavigatio=_props2.hideNavigation,hideNavigation=_props2$hideNavigatio===undefined?false:_props2$hideNavigatio;var _navigation=navigation(list,current),previous=_navigation.previous,next=_navigation.next;var disabled=!clear||!fetchData||!prevPath;return[_ref].concat(_toConsumableArray(hideNavigation?[]:[_react2.default.createElement(_Button2.default,{key:'previous',disabled:!!disabled||!previous,onClick:!!previous?this.goTo(previous):null,icon:'chevron-left'}),_react2.default.createElement(_Button2.default,{key:'next',disabled:!!disabled||!next,onClick:!!next?this.goTo(next):null,icon:'chevron-right'})]));}}]);return Navigation;}(_react.Component);var none=function none(){return{};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(none,none)(Navigation));

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _get2=__webpack_require__(122);var _get3=_interopRequireDefault(_get2);var _includes2=__webpack_require__(97);var _includes3=_interopRequireDefault(_includes2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _toLower2=__webpack_require__(65);var _toLower3=_interopRequireDefault(_toLower2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isEqual2=__webpack_require__(400);var _isEqual3=_interopRequireDefault(_isEqual2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//eslint-disable-line lodash-fp/use-fp
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactabularTable=__webpack_require__(1095);var Table=_interopRequireWildcard(_reactabularTable);var _sortabular=__webpack_require__(1104);var sort=_interopRequireWildcard(_sortabular);var _tableResolver=__webpack_require__(1113);var resolve=_interopRequireWildcard(_tableResolver);var _Paginator=__webpack_require__(477);var _Paginator2=_interopRequireDefault(_Paginator);var _orderBy=__webpack_require__(390);var _orderBy2=_interopRequireDefault(_orderBy);__webpack_require__(1135);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapWithIndex=_map3.default.convert({cap:false});var sortingOrder={FIRST:'asc',asc:'desc',desc:'asc'};var mapColumns=function mapColumns(sortable,columns){return(0,_map3.default)(function(c){return _extends({},c,{header:_extends({},c.header,{transforms:[sortable]})});},columns);};/*:: export type Props = {
  query?: ?string,
  columns: any[],
  footer?: any[],
  rows: any[],
  onRowSelected?: Function,
  pagination?: bool,
  rowKey?: string | Function,
  onSort?: Function,
  sortColumnIndex?: string,
};*//*:: type SortingColumn = {
  direction: 'asc' | 'desc',
  position: number,
};*//*:: type SortingColumns = {
  [string]: SortingColumn,
};*//*:: type Pagination = {
  page: number,
  perPage: number,
  enabled: bool,
};*//*:: export type State = {
  sortingColumns: SortingColumns,
  pagination: Pagination,
};*//*:: type PaginatedResult = {
  amount: number,
  rows: any[],
};*/var _ref=_react2.default.createElement(Table.Header,null);var _ref2=_react2.default.createElement('div',{className:'callout secondary'},'Inga resultat hittades');var AdminList=function(_Component){_inherits(AdminList,_Component);function AdminList(props/*: Props*/){_classCallCheck(this,AdminList);var _this=_possibleConstructorReturn(this,(AdminList.__proto__||Object.getPrototypeOf(AdminList)).call(this,props));_this.sortable=sort.sort({getSortingColumns:function getSortingColumns(){return _this.state.sortingColumns||[];},onSort:function onSort(selectedColumn){var sortingColumns=sort.byColumn({sortingColumns:_this.state.sortingColumns,sortingOrder:sortingOrder,selectedColumn:selectedColumn});_this.setState({sortingColumns:sortingColumns});_this.onSort(sortingColumns);}});_this.columns=mapColumns(_this.sortable,props.columns);var columnKey=''+(typeof props.sortColumnIndex!=='undefined'?props.sortColumnIndex:0);_this.state={sortingColumns:_defineProperty({},columnKey,{direction:'asc',position:0}),pagination:{page:1,perPage:30,enabled:_this.props.pagination||true}};return _this;}_createClass(AdminList,[{key:'componentDidMount',value:function componentDidMount(){this.onSort(this.state.sortingColumns);}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps/*: Props*/){if(!(0,_isEqual3.default)(nextProps.columns,this.props.columns)){this.columns=mapColumns(this.sortable,nextProps.columns);}if(!(0,_isEqual3.default)(nextProps.query,this.props.query)){this.setState({pagination:_extends({},this.state.pagination,{page:1})});}}},{key:'onSort',value:function onSort(sortingColumns){var _this2=this;var onSort=this.props.onSort;if(!!onSort){onSort(function(rows){var sorted=(0,_flow3.default)(resolve.resolve({columns:_this2.columns,method:resolve.nested}),sort.sorter({columns:_this2.columns,sortingColumns:sortingColumns,sort:_orderBy2.default}))(rows);return(0,_map3.default)(function(x){return(0,_find3.default)(function(y){return y.id===x.id;},rows);},sorted);});}}},{key:'onPageSelect',value:function onPageSelect(page/*: number*/){this.setState({pagination:_extends({},this.state.pagination,{page:page})});}},{key:'onRowClick',value:function onRowClick(row/*: any*/){if(this.props.onRowSelected){this.props.onRowSelected(row);}}},{key:'paginateRows',value:function paginateRows(pagination/*: Pagination*/)/*: (rows: any[]) => PaginatedResult*/{if(!pagination.enabled){return function(){var rows/*: any[]*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return{amount:1,rows:rows};};}return function(){var rows/*: any[]*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var amountOfPages=Math.ceil(rows.length/pagination.perPage);var currentPage=pagination.page<=amountOfPages?pagination.page:1;var beginSlice=(currentPage-1)*pagination.perPage;var endSlice=beginSlice+pagination.perPage;return{amount:amountOfPages,rows:rows.slice(beginSlice,endSlice)};};}},{key:'searchRows',value:function searchRows(query/*: ?string*/,columns/*: any[]*/){return function(){var rows/*: any[]*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var formattedRows=resolve.resolve({columns:columns,method:resolve.nested})(rows);if(!query){return formattedRows;}var lowerQuery=(0,_toLower3.default)(query);return(0,_filter3.default)(function(r){return(0,_some3.default)(function(c){return(0,_includes3.default)(lowerQuery,(0,_toLower3.default)((0,_get3.default)(c.property,r)));},columns);},formattedRows);};}},{key:'render',value:function render(){var _this3=this;var _state=this.state,pagination=_state.pagination,sortingColumns=_state.sortingColumns;var _props=this.props,rows=_props.rows,query=_props.query,footer=_props.footer,_props$rowKey=_props.rowKey,rowKey=_props$rowKey===undefined?'id':_props$rowKey;var paginated=(0,_flow3.default)(this.searchRows(query,this.columns),sort.sorter({columns:this.columns,sortingColumns:sortingColumns,sort:_orderBy2.default}),this.paginateRows(pagination))(rows);return _react2.default.createElement('div',{className:'AdminList'},_react2.default.createElement(Table.Provider,{className:'table',columns:this.columns},_ref,_react2.default.createElement(Table.Body,{rows:paginated.rows,onRow:function onRow(row){return{onClick:function onClick(){return _this3.onRowClick(row);}};},rowKey:rowKey}),footer&&_react2.default.createElement('tfoot',null,_react2.default.createElement('tr',null,mapWithIndex(function(item,index){return _react2.default.createElement('td',{key:index},item);},footer)))),!paginated.rows.length&&_ref2,_react2.default.createElement('div',{className:'row align-center'},_react2.default.createElement(_Paginator2.default,{pagination:pagination,pages:paginated.amount,onSelect:function onSelect(page){return _this3.onPageSelect(page);}})));}}]);return AdminList;}(_react.Component);AdminList.defaultProps={rowKey:'id'};exports.default=AdminList;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(325);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('identity', __webpack_require__(62), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(959);var _reactRouterDom=__webpack_require__(10);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  isLoading?: boolean,
  onDiscard: Function,
  onSave: Function,
};*/var _ref2=_react2.default.createElement('div',{className:'shrink column SaveMenu-text'},_react2.default.createElement('div',null,'Du har osparade \xE4ndringar'));var _ref3=_react2.default.createElement(_reactRouterDom.Prompt,{message:'Du har osparade \xE4ndringar, l\xE4mna \xE4nd\xE5?'});var SaveMenu=function SaveMenu(_ref){var onSave=_ref.onSave,onDiscard=_ref.onDiscard,_ref$isLoading=_ref.isLoading,isLoading=_ref$isLoading===undefined?false:_ref$isLoading;return _react2.default.createElement('div',{className:'SaveMenu'},_react2.default.createElement('div',{className:'SaveMenu-inner-content'},_ref2,_react2.default.createElement('div',{className:'shrink column horizontal-button-list'},_react2.default.createElement('button',{className:'button warning',type:'button',onClick:function onClick(){return onDiscard();}},'\xC5ngra'),_react2.default.createElement('button',{className:'button success',type:'button',onClick:function onClick(){return onSave();}},'Spara'))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isLoading,hideSpinner:true}),_ref3);};exports.default=SaveMenu;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1037);var _reactModal=__webpack_require__(1038);var _reactModal2=_interopRequireDefault(_reactModal);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {Element} from 'react';*//*:: export type Props = {
  show: boolean,
  onClose: Function,
  className?: string,
  showCloseButton?: boolean,
  onOpen?: Function,
  children?: number | string | Element<*> | Array<any>,
  size?: string,
};*/var _ref2=_react2.default.createElement('span',null,'\xD7');var ModalDialog=function ModalDialog(_ref){var show=_ref.show,onClose=_ref.onClose,onOpen=_ref.onOpen,children=_ref.children,_ref$className=_ref.className,className=_ref$className===undefined?'':_ref$className,_ref$showCloseButton=_ref.showCloseButton,showCloseButton=_ref$showCloseButton===undefined?false:_ref$showCloseButton,_ref$size=_ref.size,size=_ref$size===undefined?'small':_ref$size;return _react2.default.createElement('div',{className:'ModalDialog'},_react2.default.createElement(_reactModal2.default,{isOpen:show,contentLabel:'Modal',overlayClassName:'modal-overlay',className:'modal modal-'+size+' '+className,onRequestClose:onClose,onAfterOpen:function onAfterOpen(){return onOpen&&onOpen();}},showCloseButton&&_react2.default.createElement('button',{onClick:onClose,className:'close-button'},_ref2),children));};exports.default=ModalDialog;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactTooltip=__webpack_require__(91);var _reactTooltip2=_interopRequireDefault(_reactTooltip);__webpack_require__(1076);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {Element} from 'react';*//*:: export type Props = {
  disabled: boolean,
  children?: number | string | Element<*> | Array<any>,
};*/var _ref2=_react2.default.createElement('div',{className:'DisableContent-overlay','data-tip':true,'data-for':'disable-content'},_react2.default.createElement(_reactTooltip2.default,{id:'disable-content','class':'DisableContent-tooltip'},_react2.default.createElement('span',null,'Du har osparade \xE4ndringar')));var DisableContent=function DisableContent(_ref){var disabled=_ref.disabled,children=_ref.children;return _react2.default.createElement('div',{className:'DisableContent'},children,disabled&&_ref2);};exports.default=DisableContent;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var booleanValues=[{value:true,label:'Ja'},{value:false,label:'Nej'}];exports.default=booleanValues;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1045);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  input: any,
  label: string,
  type: string,
  meta: any,
};*/var TextAreaFormInput=function TextAreaFormInput(_ref){var input=_ref.input,label=_ref.label,_ref$meta=_ref.meta,touched=_ref$meta.touched,error=_ref$meta.error;return _react2.default.createElement('div',{className:'TextAreaFormInput'},_react2.default.createElement('label',{className:(0,_classnames2.default)({'is-invalid-label':touched&&error})},label),_react2.default.createElement('div',null,_react2.default.createElement('textarea',_extends({},input,{onChange:function onChange(e){return input.onChange(e.target.value);},placeholder:label,className:(0,_classnames2.default)({'is-invalid-input':touched&&error})})),touched&&error&&_react2.default.createElement('span',{className:'form-error is-visible'},error)));};exports.default=TextAreaFormInput;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('sortBy', __webpack_require__(871));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1136);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: type Props = {
  placeholder?: string,
  value: ?string,
  onChange: (e: SyntheticInputEvent<*>) => void,
  onClear?: () => void
};*/var SearchField=function SearchField(_ref){var placeholder=_ref.placeholder,value=_ref.value,onChange=_ref.onChange,onClear=_ref.onClear;return _react2.default.createElement('div',{className:'SearchField'},_react2.default.createElement('input',{type:'search',name:'query',placeholder:placeholder,value:value,onChange:onChange}),onClear&&!(0,_isEmpty3.default)(value)&&_react2.default.createElement('span',{className:'clear-wrapper'},_react2.default.createElement('span',{className:'Select-clear',onClick:onClear},'\xD7')));};SearchField.defaultProps={placeHolder:'Sök'};exports.default=SearchField;

/***/ }),
/* 45 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 46 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93),
    getRawTag = __webpack_require__(758),
    objectToString = __webpack_require__(759);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('isString', __webpack_require__(360), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _roleLabels;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var ADMIN=exports.ADMIN=0;var CUSTOMER=exports.CUSTOMER=1;var SITE_MANAGER=exports.SITE_MANAGER=2;var DEMO=exports.DEMO=3;var roleLabels=exports.roleLabels=(_roleLabels={},_defineProperty(_roleLabels,ADMIN,'Administratör'),_defineProperty(_roleLabels,CUSTOMER,'Kund'),_defineProperty(_roleLabels,SITE_MANAGER,'Platschef'),_defineProperty(_roleLabels,DEMO,'Demo'),_roleLabels);var roles=exports.roles=[{id:ADMIN,label:roleLabels[ADMIN]},{id:CUSTOMER,label:roleLabels[CUSTOMER]},{id:SITE_MANAGER,label:roleLabels[SITE_MANAGER]},{id:DEMO,label:roleLabels[DEMO]}];

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(277);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isObject = __webpack_require__(45);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(859);
var v4 = __webpack_require__(860);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('flatMap', __webpack_require__(869));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _assortmentLabels;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var STANDARD=exports.STANDARD=0;var ADDITIONAL=exports.ADDITIONAL=1;var SPECIAL=exports.SPECIAL=2;var assortmentLabels=exports.assortmentLabels=(_assortmentLabels={},_defineProperty(_assortmentLabels,STANDARD,'Standard'),_defineProperty(_assortmentLabels,ADDITIONAL,'Tilläggsprodukter'),_defineProperty(_assortmentLabels,SPECIAL,'Specialprodukter'),_assortmentLabels);var assortments=exports.assortments=[{id:STANDARD,label:assortmentLabels[STANDARD]},{id:ADDITIONAL,label:assortmentLabels[ADDITIONAL]},{id:SPECIAL,label:assortmentLabels[SPECIAL]}];

/***/ }),
/* 56 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getSelf=exports.logout=exports.login=exports.demoLogin=exports.SELF_FAILURE=exports.SELF_SUCCESS=exports.SELF_REQUEST=exports.LOGOUT_SUCCESS=exports.LOGOUT_REQUEST=exports.LOGIN_FAILURE=exports.LOGIN_SUCCESS=exports.LOGIN_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);var _jsCookie=__webpack_require__(227);var _jsCookie2=_interopRequireDefault(_jsCookie);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var LOGIN_REQUEST=exports.LOGIN_REQUEST='LOGIN_REQUEST';var LOGIN_SUCCESS=exports.LOGIN_SUCCESS='LOGIN_SUCCESS';var LOGIN_FAILURE=exports.LOGIN_FAILURE='LOGIN_FAILURE';var LOGOUT_REQUEST=exports.LOGOUT_REQUEST='LOGOUT_REQUEST';var LOGOUT_SUCCESS=exports.LOGOUT_SUCCESS='LOGOUT_SUCCESS';var SELF_REQUEST=exports.SELF_REQUEST='SELF_REQUEST';var SELF_SUCCESS=exports.SELF_SUCCESS='SELF_SUCCESS';var SELF_FAILURE=exports.SELF_FAILURE='SELF_FAILURE';var requestLogin=function requestLogin(){return{type:LOGIN_REQUEST};};var receiveLogin=function receiveLogin(user){return{type:LOGIN_SUCCESS,user:user};};var loginError=function loginError(error){return{type:LOGIN_FAILURE,error:error};};var requestLogout=function requestLogout(){return{type:LOGOUT_REQUEST};};var receiveLogout=function receiveLogout(){return{type:LOGOUT_SUCCESS};};var selfRequest=function selfRequest(){return{type:SELF_REQUEST};};var selfSuccess=function selfSuccess(user){return{type:SELF_SUCCESS,user:user};};var selfFailure=function selfFailure(error){return{type:SELF_FAILURE,error:error};};var demoLogin=exports.demoLogin=function demoLogin(projectName){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var user;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(requestLogin());_context.prev=1;_context.next=4;return(0,_request.POST)({endpoint:'/auth/demologin',body:{projectName:projectName}},dispatch);case 4:user=_context.sent;_jsCookie2.default.set('token',user.token,{expires:365});dispatch(receiveLogin(user));_context.next=12;break;case 9:_context.prev=9;_context.t0=_context['catch'](1);dispatch(loginError(_context.t0.message));case 12:case'end':return _context.stop();}}},_callee,undefined,[[1,9]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var login=exports.login=function login(username,password){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var user;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(requestLogin());_context2.prev=1;_context2.next=4;return(0,_request.POST)({endpoint:'/auth',body:{username:username,password:password}},dispatch);case 4:user=_context2.sent;_jsCookie2.default.set('token',user.token,{expires:365});dispatch(receiveLogin(user));_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);dispatch(loginError(_context2.t0.message));case 12:case'end':return _context2.stop();}}},_callee2,undefined,[[1,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var logout=exports.logout=function logout(){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(requestLogout());_context3.prev=1;_context3.next=4;return(0,_request.POST)({endpoint:'/auth/logout',expectBody:false},dispatch);case 4:_context3.next=9;break;case 6:_context3.prev=6;_context3.t0=_context3['catch'](1);console.log(_context3.t0);case 9:_jsCookie2.default.remove('token');dispatch(receiveLogout());case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,6]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var getSelf=exports.getSelf=function getSelf(){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch){var user;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(selfRequest());_context4.prev=1;_context4.next=4;return(0,_request.GET)({endpoint:'/users/me'},dispatch);case 4:user=_context4.sent;dispatch(selfSuccess(user));_context4.next=11;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](1);dispatch(selfFailure(_context4.t0));case 11:case'end':return _context4.stop();}}},_callee4,undefined,[[1,8]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(779);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(339),
    baseKeys = __webpack_require__(215),
    isArrayLike = __webpack_require__(60);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(52),
    isLength = __webpack_require__(214);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 62 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(76);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('toLower', __webpack_require__(853), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('mapValues', __webpack_require__(862));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('values', __webpack_require__(361), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('reject', __webpack_require__(886));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _stateLabels,_stateClasses;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var NEW=exports.NEW=0;var COMPLETED=exports.COMPLETED=1;var CONFIRMED=exports.CONFIRMED=2;var CLOSED=exports.CLOSED=3;var stateLabels=exports.stateLabels=(_stateLabels={},_defineProperty(_stateLabels,NEW,'Väntar på tillval'),_defineProperty(_stateLabels,COMPLETED,'Väntar på säljare'),_defineProperty(_stateLabels,CONFIRMED,'Väntar på inköp'),_defineProperty(_stateLabels,CLOSED,'Avslutad'),_stateLabels);var stateClasses=exports.stateClasses=(_stateClasses={},_defineProperty(_stateClasses,NEW,'new'),_defineProperty(_stateClasses,COMPLETED,'completed'),_defineProperty(_stateClasses,CONFIRMED,'confirmed'),_defineProperty(_stateClasses,CLOSED,'closed'),_stateClasses);var states=exports.states=[{id:NEW,label:stateLabels[NEW]},{id:COMPLETED,label:stateLabels[COMPLETED]},{id:CONFIRMED,label:stateLabels[CONFIRMED]},{id:CLOSED,label:stateLabels[CLOSED]}];

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _reactNumberFormat=__webpack_require__(414);var _reactNumberFormat2=_interopRequireDefault(_reactNumberFormat);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  disabled?: boolean,
  input: any,
  label: string,
  meta: any,
  onChangeTransform?: Function,
  valueTransform?: Function,
};*/var DecimalFormInput=function DecimalFormInput(_ref){var input=_ref.input,label=_ref.label,_ref$meta=_ref.meta,touched=_ref$meta.touched,error=_ref$meta.error,onChangeTransform=_ref.onChangeTransform,valueTransform=_ref.valueTransform,disabled=_ref.disabled;return _react2.default.createElement('div',null,_react2.default.createElement('label',{className:(0,_classnames2.default)({'is-invalid-label':touched&&error})},label),_react2.default.createElement('div',null,_react2.default.createElement(_reactNumberFormat2.default,{value:!input.value?input.value:valueTransform?valueTransform(input.value):input.value,onValueChange:function onValueChange(val,evt){input.onChange((0,_isEmpty3.default)(val.value)?null:onChangeTransform?onChangeTransform(val.floatValue):val.floatValue);},disabled:!!disabled,onBlur:function onBlur(){return input.onBlur(input.value);},decimalSeparator:',',decimalScale:5,placeholder:label,className:(0,_classnames2.default)({'is-invalid-input':touched&&error})}),touched&&error&&_react2.default.createElement('span',{className:'form-error is-visible'},error)));};exports.default=DecimalFormInput;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(514);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(598);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(757),
    getValue = __webpack_require__(762);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(813),
    Map = __webpack_require__(216),
    Promise = __webpack_require__(814),
    Set = __webpack_require__(346),
    WeakMap = __webpack_require__(324),
    baseGetTag = __webpack_require__(47),
    toSource = __webpack_require__(326);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(18),
    isKey = __webpack_require__(226),
    stringToPath = __webpack_require__(355),
    toString = __webpack_require__(79);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(117);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(363),
    createBaseEach = __webpack_require__(856);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.ABORT_UPLOAD=exports.FILE_UPLOAD=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _file=__webpack_require__(367);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var FILE_UPLOAD=exports.FILE_UPLOAD='File upload';var ABORT_UPLOAD=exports.ABORT_UPLOAD='Abort upload';var chunkSize=2e6;var uploads={};var sliceFunction=File.prototype.webkitSlice||File.prototype.mozSlice||File.prototype.slice;var slice=function slice(file){for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}return sliceFunction.call.apply(sliceFunction,[file].concat(args));};var checkAborted=function checkAborted(tempId,store){if(!uploads[tempId]||uploads[tempId].aborted){delete uploads[tempId];return true;}return false;};var initializeUpload=function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(tempId,file,store,successAction){var fileName,fileSize,_ref2,id,completedBytes,lastProgress,chunkCount,i,isLastChunk,start,end,blob,body,metadata,progress;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!checkAborted(tempId,store)){_context.next=2;break;}return _context.abrupt('return');case 2:_context.prev=2;fileName=file.name,fileSize=file.size;_context.next=6;return(0,_request.POST)({endpoint:'/files',body:{fileName:fileName,fileSize:fileSize}},store.dispatch);case 6:_ref2=_context.sent;id=_ref2.id;if(!checkAborted(tempId,store)){_context.next=10;break;}return _context.abrupt('return');case 10:store.dispatch((0,_file.uploadInitialized)(tempId,id));completedBytes=0;lastProgress=0;chunkCount=Math.max(Math.ceil(fileSize/chunkSize),1);i=0;case 15:if(!(i<chunkCount)){_context.next=34;break;}isLastChunk=i===chunkCount-1;start=i*chunkSize;end=Math.min(fileSize,start+chunkSize);blob=slice(file,start,end);body=new FormData();body.append('file',blob);_context.next=24;return(0,_request.POST)({endpoint:'/files/'+id,body:body,expectBody:isLastChunk});case 24:metadata=_context.sent;if(!checkAborted(tempId,store)){_context.next=27;break;}return _context.abrupt('return');case 27:completedBytes+=blob.size;progress=Math.floor(completedBytes/fileSize*100);if(isLastChunk){store.dispatch((0,_file.uploadSuccess)(tempId,metadata));if(successAction){store.dispatch(successAction(tempId,metadata));}}else if(lastProgress!==progress){store.dispatch((0,_file.uploadProgress)(tempId,progress));}lastProgress=progress;case 31:i++;_context.next=15;break;case 34:_context.next=39;break;case 36:_context.prev=36;_context.t0=_context['catch'](2);if(!checkAborted(tempId,store)){store.dispatch((0,_file.uploadError)(tempId,_context.t0));}case 39:case'end':return _context.stop();}}},_callee,undefined,[[2,36]]);}));return function initializeUpload(_x,_x2,_x3,_x4){return _ref.apply(this,arguments);};}();exports.default=function(store){return function(next){return function(action){var result=next(action);var tempId=action.tempId;if(!tempId){return result;}var file=action[FILE_UPLOAD];if(file){uploads[tempId]={aborted:false};var successAction=null;if(file.success){successAction=file.success;file=file.file;}store.dispatch((0,_file.uploadFile)(tempId,file));setTimeout(function(){return initializeUpload(tempId,file,store,successAction);});}if(action[ABORT_UPLOAD]){var upload=uploads[action.tempId];if(upload){upload.aborted=true;}}return result;};};};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.updateProductSlots=exports.updateRooms=exports.updateProductSlot=exports.createProductSlot=exports.updateRoom=exports.createRoom=exports.createApartmentConfig=exports.updateApartmentConfig=exports.fetchData=exports.filterAndSort=exports.sortByName=exports.selectProductSlot=exports.selectRoom=exports.reset=exports.clear=exports.closeDialog=exports.openDialog=exports.toggleVariant=exports.clearStandardProduct=exports.setStandardProduct=exports.updateRelatedVariant=exports.navigateToVariant=exports.popDialogNavigation=exports.toggleProduct=exports.checkAllVariants=exports.checkProduct=exports.updateVariantsForType=exports.updateVariants=exports.UPDATE_VARIANTS_FOR_TYPE=exports.PRODUCT_SLOTS_UPDATE_SUCCESS=exports.PRODUCT_SLOTS_UPDATE_FAILURE=exports.PRODUCT_SLOTS_UPDATE_REQUEST=exports.ROOMS_UPDATE_SUCCESS=exports.ROOMS_UPDATE_FAILURE=exports.ROOMS_UPDATE_REQUEST=exports.UPDATE_VARIANTS=exports.CHECK_PRODUCT=exports.CLEAR_STANDARD_PRODUCT=exports.CHECK_ALL_VARIANTS=exports.TOGGLE_PRODUCT=exports.SET_STANDARD_PRODUCT=exports.TOGGLE_VARIANT_SUCCESS=exports.TOGGLE_VARIANT_FAILURE=exports.TOGGLE_VARIANT_REQUEST=exports.UPDATE_RELATED_VARIANT=exports.NAVIGATE_TO_VARIANT_SUCCESS=exports.NAVIGATE_TO_VARIANT_FAILURE=exports.NAVIGATE_TO_VARIANT_REQUEST=exports.POP_DIALOG_NAVIGATION=exports.CLOSE_DIALOG=exports.OPEN_DIALOG_SUCCESS=exports.OPEN_DIALOG_FAILURE=exports.OPEN_DIALOG_REQUEST=exports.CLEAR=exports.RESET=exports.SELECT_PRODUCT_SLOT=exports.SELECT_ROOM=exports.PRODUCT_SLOT_CREATE_FAILURE=exports.PRODUCT_SLOT_CREATE_SUCCESS=exports.PRODUCT_SLOT_CREATE_REQUEST=exports.PRODUCT_SLOT_UPDATE_FAILURE=exports.PRODUCT_SLOT_UPDATE_SUCCESS=exports.PRODUCT_SLOT_UPDATE_REQUEST=exports.ROOM_CREATE_FAILURE=exports.ROOM_CREATE_SUCCESS=exports.ROOM_CREATE_REQUEST=exports.ROOM_UPDATE_FAILURE=exports.ROOM_UPDATE_SUCCESS=exports.ROOM_UPDATE_REQUEST=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _toLower2=__webpack_require__(65);var _toLower3=_interopRequireDefault(_toLower2);var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _request=__webpack_require__(6);var _notification=__webpack_require__(23);var _assortments=__webpack_require__(55);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var GET_REQUEST=exports.GET_REQUEST='@apartmentConfigView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@apartmentConfigView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@apartmentConfigView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@apartmentConfigView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@apartmentConfigView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@apartmentConfigView/UPDATE_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@apartmentConfigView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@apartmentConfigView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@apartmentConfigView/CREATE_FAILURE';var ROOM_UPDATE_REQUEST=exports.ROOM_UPDATE_REQUEST='@apartmentConfigView/ROOM_UPDATE_REQUEST';var ROOM_UPDATE_SUCCESS=exports.ROOM_UPDATE_SUCCESS='@apartmentConfigView/ROOM_UPDATE_SUCCESS';var ROOM_UPDATE_FAILURE=exports.ROOM_UPDATE_FAILURE='@apartmentConfigView/ROOM_UPDATE_FAILURE';var ROOM_CREATE_REQUEST=exports.ROOM_CREATE_REQUEST='@apartmentConfigView/ROOM_CREATE_REQUEST';var ROOM_CREATE_SUCCESS=exports.ROOM_CREATE_SUCCESS='@apartmentConfigView/ROOM_CREATE_SUCCESS';var ROOM_CREATE_FAILURE=exports.ROOM_CREATE_FAILURE='@apartmentConfigView/ROOM_CREATE_FAILURE';var PRODUCT_SLOT_UPDATE_REQUEST=exports.PRODUCT_SLOT_UPDATE_REQUEST='@apartmentConfigView/PRODUCT_SLOT_UPDATE_REQUEST';var PRODUCT_SLOT_UPDATE_SUCCESS=exports.PRODUCT_SLOT_UPDATE_SUCCESS='@apartmentConfigView/PRODUCT_SLOT_UPDATE_SUCCESS';var PRODUCT_SLOT_UPDATE_FAILURE=exports.PRODUCT_SLOT_UPDATE_FAILURE='@apartmentConfigView/PRODUCT_SLOT_UPDATE_FAILURE';var PRODUCT_SLOT_CREATE_REQUEST=exports.PRODUCT_SLOT_CREATE_REQUEST='@apartmentConfigView/PRODUCT_SLOT_CREATE_REQUEST';var PRODUCT_SLOT_CREATE_SUCCESS=exports.PRODUCT_SLOT_CREATE_SUCCESS='@apartmentConfigView/PRODUCT_SLOT_CREATE_SUCCESS';var PRODUCT_SLOT_CREATE_FAILURE=exports.PRODUCT_SLOT_CREATE_FAILURE='@apartmentConfigView/PRODUCT_SLOT_CREATE_FAILURE';var SELECT_ROOM=exports.SELECT_ROOM='@apartmentConfigView/SELECT_ROOM';var SELECT_PRODUCT_SLOT=exports.SELECT_PRODUCT_SLOT='@apartmentConfigView/SELECT_PRODUCT_SLOT';var RESET=exports.RESET='@apartmentConfigView/RESET';var CLEAR=exports.CLEAR='@apartmentConfigView/CLEAR';var OPEN_DIALOG_REQUEST=exports.OPEN_DIALOG_REQUEST='@apartmentConfigView/OPEN_DIALOG_REQUEST';var OPEN_DIALOG_FAILURE=exports.OPEN_DIALOG_FAILURE='@apartmentConfigView/OPEN_DIALOG_FAILURE';var OPEN_DIALOG_SUCCESS=exports.OPEN_DIALOG_SUCCESS='@apartmentConfigView/OPEN_DIALOG_SUCCESS';var CLOSE_DIALOG=exports.CLOSE_DIALOG='@apartmentConfigView/CLOSE_DIALOG';var POP_DIALOG_NAVIGATION=exports.POP_DIALOG_NAVIGATION='@apartmentConfigView/POP_DIALOG_NAVIGATION';var NAVIGATE_TO_VARIANT_REQUEST=exports.NAVIGATE_TO_VARIANT_REQUEST='@apartmentConfigView/NAVIGATE_TO_VARIANT_REQUEST';var NAVIGATE_TO_VARIANT_FAILURE=exports.NAVIGATE_TO_VARIANT_FAILURE='@apartmentConfigView/NAVIGATE_TO_VARIANT_FAILURE';var NAVIGATE_TO_VARIANT_SUCCESS=exports.NAVIGATE_TO_VARIANT_SUCCESS='@apartmentConfigView/NAVIGATE_TO_VARIANT_SUCCESS';var UPDATE_RELATED_VARIANT=exports.UPDATE_RELATED_VARIANT='@apartmentConfigView/UPDATE_RELATED_VARIANT';var TOGGLE_VARIANT_REQUEST=exports.TOGGLE_VARIANT_REQUEST='@apartmentConfigView/TOGGLE_VARIANT_REQUEST';var TOGGLE_VARIANT_FAILURE=exports.TOGGLE_VARIANT_FAILURE='@apartmentConfigView/TOGGLE_VARIANT_FAILURE';var TOGGLE_VARIANT_SUCCESS=exports.TOGGLE_VARIANT_SUCCESS='@apartmentConfigView/TOGGLE_VARIANT_SUCCESS';var SET_STANDARD_PRODUCT=exports.SET_STANDARD_PRODUCT='@apartmentConfigView/SET_STANDARD_PRODUCT';var TOGGLE_PRODUCT=exports.TOGGLE_PRODUCT='@apartmentConfigView/TOGGLE_PRODUCT';var CHECK_ALL_VARIANTS=exports.CHECK_ALL_VARIANTS='@apartmentConfigView/CHECK_ALL_VARIANTS';var CLEAR_STANDARD_PRODUCT=exports.CLEAR_STANDARD_PRODUCT='@apartmentConfigView/CLEAR_STANDARD_PRODUCT';var CHECK_PRODUCT=exports.CHECK_PRODUCT='@apartmentConfigView/CHECK_PRODUCT';var UPDATE_VARIANTS=exports.UPDATE_VARIANTS='@apartmentConfigView/UPDATE_VARIANTS';var ROOMS_UPDATE_REQUEST=exports.ROOMS_UPDATE_REQUEST='@apartmentConfigView/ROOMS_UPDATE_REQUEST';var ROOMS_UPDATE_FAILURE=exports.ROOMS_UPDATE_FAILURE='@apartmentConfigView/ROOMS_UPDATE_FAILURE';var ROOMS_UPDATE_SUCCESS=exports.ROOMS_UPDATE_SUCCESS='@apartmentConfigView/ROOMS_UPDATE_SUCCESS';var PRODUCT_SLOTS_UPDATE_REQUEST=exports.PRODUCT_SLOTS_UPDATE_REQUEST='@apartmentConfigView/PRODUCT_SLOTS_UPDATE_REQUEST';var PRODUCT_SLOTS_UPDATE_FAILURE=exports.PRODUCT_SLOTS_UPDATE_FAILURE='@apartmentConfigView/PRODUCT_SLOTS_UPDATE_FAILURE';var PRODUCT_SLOTS_UPDATE_SUCCESS=exports.PRODUCT_SLOTS_UPDATE_SUCCESS='@apartmentConfigView/PRODUCT_SLOTS_UPDATE_SUCCESS';var UPDATE_VARIANTS_FOR_TYPE=exports.UPDATE_VARIANTS_FOR_TYPE='@apartmentConfigView/UPDATE_VARIANTS_FOR_TYPE';var roomsUpdateRequest=function roomsUpdateRequest(){return{type:ROOMS_UPDATE_REQUEST};};var roomsUpdateFailure=function roomsUpdateFailure(error){return{type:ROOMS_UPDATE_FAILURE,error:error};};var roomsUpdateSuccess=function roomsUpdateSuccess(rooms){return{type:ROOMS_UPDATE_SUCCESS,rooms:rooms};};var productSlotsUpdateRequest=function productSlotsUpdateRequest(){return{type:PRODUCT_SLOTS_UPDATE_REQUEST};};var productSlotsUpdateFailure=function productSlotsUpdateFailure(error){return{type:PRODUCT_SLOTS_UPDATE_FAILURE,error:error};};var productSlotsUpdateSuccess=function productSlotsUpdateSuccess(roomId,productSlotId,productSlots){return{type:PRODUCT_SLOTS_UPDATE_SUCCESS,roomId:roomId,productSlotId:productSlotId,productSlots:productSlots};};var updateVariants=exports.updateVariants=function updateVariants(productId/*: number*/,data/*: any*/){return{type:UPDATE_VARIANTS,productId:productId,data:data};};var updateVariantsForType=exports.updateVariantsForType=function updateVariantsForType(productTypeId/*: number*/,data/*: any*/){return{type:UPDATE_VARIANTS_FOR_TYPE,productTypeId:productTypeId,data:data};};var checkProduct=exports.checkProduct=function checkProduct(productId/*: number*/,checked/*: boolean*/){return{type:CHECK_PRODUCT,productId:productId,checked:checked};};var checkAllVariants=exports.checkAllVariants=function checkAllVariants(checked){return{type:CHECK_ALL_VARIANTS,checked:checked};};var toggleProduct=exports.toggleProduct=function toggleProduct(product){return{type:TOGGLE_PRODUCT,product:product};};var popDialogNavigation=exports.popDialogNavigation=function popDialogNavigation(depth){return{type:POP_DIALOG_NAVIGATION,depth:depth};};var navigateToVariantRequest=function navigateToVariantRequest(){return{type:NAVIGATE_TO_VARIANT_REQUEST};};var navigateToVariantFailure=function navigateToVariantFailure(error){return{type:NAVIGATE_TO_VARIANT_FAILURE,error:error};};var navigateToVariantSuccess=function navigateToVariantSuccess(variant){return{type:NAVIGATE_TO_VARIANT_SUCCESS,variant:variant};};var navigateToVariant=exports.navigateToVariant=function navigateToVariant(variant){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var fullVariant;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(navigateToVariantRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/productvariants/'+variant.id},dispatch);case 4:fullVariant=_context.sent;dispatch(navigateToVariantSuccess(_extends({},fullVariant,{uuid:variant.uuid})));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(navigateToVariantFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var updateRelatedVariant=exports.updateRelatedVariant=function updateRelatedVariant(variant,data){return{type:UPDATE_RELATED_VARIANT,variant:variant,data:data};};var setStandardProduct=exports.setStandardProduct=function setStandardProduct(product,productType){return{type:SET_STANDARD_PRODUCT,product:product,productType:productType};};var clearStandardProduct=exports.clearStandardProduct=function clearStandardProduct(productType){return{type:CLEAR_STANDARD_PRODUCT,productType:productType};};var toggleVariantRequest=function toggleVariantRequest(){return{type:TOGGLE_VARIANT_REQUEST};};var toggleVariantFailure=function toggleVariantFailure(error){return{type:TOGGLE_VARIANT_FAILURE,error:error};};var toggleVariantSuccess=function toggleVariantSuccess(variant,expand){return{type:TOGGLE_VARIANT_SUCCESS,variant:variant,expand:expand};};var toggleVariant=exports.toggleVariant=function toggleVariant(variant,expand){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var fullVariant;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!expand){_context2.next=14;break;}dispatch(toggleVariantRequest());_context2.prev=2;_context2.next=5;return(0,_request.GET)({endpoint:'/productvariants/'+variant.id},dispatch);case 5:fullVariant=_context2.sent;dispatch(toggleVariantSuccess(_extends({},fullVariant,{uuid:variant.uuid}),expand));_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](2);dispatch(toggleVariantFailure(_context2.t0));case 12:_context2.next=15;break;case 14:dispatch(toggleVariantSuccess(variant,expand));case 15:case'end':return _context2.stop();}}},_callee2,undefined,[[2,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var openDialogRequest=function openDialogRequest(){return{type:OPEN_DIALOG_REQUEST};};var openDialogFailure=function openDialogFailure(error){return{type:OPEN_DIALOG_FAILURE,error:error};};var openDialogSuccess=function openDialogSuccess(products,rootName,productType){return{type:OPEN_DIALOG_SUCCESS,products:products,rootName:rootName,productType:productType};};var openDialog=exports.openDialog=function openDialog(productTypeId,rootName){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var productType,products;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(openDialogRequest());_context3.prev=1;_context3.next=4;return(0,_request.GET)({endpoint:'/producttypes/'+productTypeId},dispatch);case 4:productType=_context3.sent;_context3.next=7;return(0,_request.GET)({endpoint:'/products?productTypeId='+productTypeId+'&assortment='+_assortments.STANDARD},dispatch);case 7:products=_context3.sent;dispatch(openDialogSuccess(products,rootName,productType));_context3.next=14;break;case 11:_context3.prev=11;_context3.t0=_context3['catch'](1);dispatch(openDialogFailure(_context3.t0));case 14:case'end':return _context3.stop();}}},_callee3,undefined,[[1,11]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var closeDialog=exports.closeDialog=function closeDialog(){return{type:CLOSE_DIALOG};};var dataRequest=function dataRequest(){return{type:GET_REQUEST};};var dataSuccess=function dataSuccess(apartmentConfig,project,roomTypes,products,productTypes,apartmentConfigs,configTemplates,roomTemplates,projects){return{type:GET_SUCCESS,apartmentConfig:apartmentConfig,project:project,roomTypes:roomTypes,products:products,productTypes:productTypes,apartmentConfigs:apartmentConfigs,configTemplates:configTemplates,roomTemplates:roomTemplates,projects:projects};};var dataFailure=function dataFailure(error){return{type:GET_FAILURE,error:error};};var apartmentConfigUpdateRequest=function apartmentConfigUpdateRequest(){return{type:UPDATE_REQUEST};};var apartmentConfigUpdateSuccess=function apartmentConfigUpdateSuccess(apartmentConfig){return _defineProperty({type:UPDATE_SUCCESS,apartmentConfig:apartmentConfig},_notification.ADD,{message:'Lägenhetskonfiguration uppdaterad'});};var apartmentConfigUpdateFailure=function apartmentConfigUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var apartmentConfigCreateRequest=function apartmentConfigCreateRequest(){return{type:CREATE_REQUEST};};var apartmentConfigCreateSuccess=function apartmentConfigCreateSuccess(apartmentConfig){return _defineProperty({type:CREATE_SUCCESS,apartmentConfig:apartmentConfig},_notification.ADD,{message:'L\xE4genhetskonfiguration "'+apartmentConfig.name+'" skapad'});};var apartmentConfigCreateFailure=function apartmentConfigCreateFailure(error){return{type:CREATE_FAILURE,error:error};};var roomUpdateRequest=function roomUpdateRequest(){return{type:ROOM_UPDATE_REQUEST};};var roomUpdateSuccess=function roomUpdateSuccess(room){return _defineProperty({type:ROOM_UPDATE_SUCCESS,room:room},_notification.ADD,{message:'Rum uppdaterat'});};var roomUpdateFailure=function roomUpdateFailure(error){return{type:ROOM_UPDATE_FAILURE,error:error};};var roomCreateRequest=function roomCreateRequest(){return{type:ROOM_CREATE_REQUEST};};var roomCreateSuccess=function roomCreateSuccess(room){return _defineProperty({type:ROOM_CREATE_SUCCESS,room:room},_notification.ADD,{message:'Rum "'+room.name+'" skapat'});};var roomCreateFailure=function roomCreateFailure(error){return{type:ROOM_CREATE_FAILURE,error:error};};var productSlotUpdateRequest=function productSlotUpdateRequest(){return{type:PRODUCT_SLOT_UPDATE_REQUEST};};var productSlotUpdateSuccess=function productSlotUpdateSuccess(productSlot){return _defineProperty({type:PRODUCT_SLOT_UPDATE_SUCCESS,productSlot:productSlot},_notification.ADD,{message:'Produktplats uppdaterad'});};var productSlotUpdateFailure=function productSlotUpdateFailure(error){return{type:PRODUCT_SLOT_UPDATE_FAILURE,error:error};};var productSlotCreateRequest=function productSlotCreateRequest(){return{type:PRODUCT_SLOT_CREATE_REQUEST};};var productSlotCreateSuccess=function productSlotCreateSuccess(productSlot,roomId){return _defineProperty({type:PRODUCT_SLOT_CREATE_SUCCESS,productSlot:productSlot,roomId:roomId},_notification.ADD,{message:'Produktplats "'+productSlot.name+'" skapad'});};var productSlotCreateFailure=function productSlotCreateFailure(error){return{type:PRODUCT_SLOT_CREATE_FAILURE,error:error};};var clear=exports.clear=function clear(){return{type:CLEAR};};var reset=exports.reset=function reset(){return{type:RESET};};var selectRoom=exports.selectRoom=function selectRoom(room){return{type:SELECT_ROOM,room:room};};var selectProductSlot=exports.selectProductSlot=function selectProductSlot(roomId,productSlot){return{type:SELECT_PRODUCT_SLOT,roomId:roomId,productSlot:productSlot};};var sortByName=exports.sortByName=(0,_sortBy3.default)([function(x){return(0,_toLower3.default)(x.name);}]);var filterAndSort=exports.filterAndSort=(0,_flow3.default)((0,_filter3.default)({archived:null}),sortByName);var fetchData=exports.fetchData=function fetchData(id,projectId){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch){var roomTypes,products,productTypes,roomTemplates,projects,apartmentConfig,project,apartmentConfigs,configTemplates;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(dataRequest());_context4.prev=1;_context4.t0=sortByName;_context4.next=5;return(0,_request.GET)({endpoint:'/roomtypes'},dispatch);case 5:_context4.t1=_context4.sent;roomTypes=(0,_context4.t0)(_context4.t1);_context4.next=9;return(0,_request.GET)({endpoint:'/products?assortment='+_assortments.STANDARD},dispatch);case 9:products=_context4.sent;_context4.t2=sortByName;_context4.next=13;return(0,_request.GET)({endpoint:'/producttypes'},dispatch);case 13:_context4.t3=_context4.sent;productTypes=(0,_context4.t2)(_context4.t3);_context4.t4=filterAndSort;_context4.next=18;return(0,_request.GET)({endpoint:'/roomtemplates'},dispatch);case 18:_context4.t5=_context4.sent;roomTemplates=(0,_context4.t4)(_context4.t5);_context4.t6=sortByName;_context4.t7=_map3.default;_context4.t8=function(x){return _extends({},x,{apartmentConfigs:sortByName(x.apartmentConfigs)});};_context4.next=25;return(0,_request.GET)({endpoint:'/projects/rooms'},dispatch);case 25:_context4.t9=_context4.sent;_context4.t10=(0,_context4.t7)(_context4.t8,_context4.t9);projects=(0,_context4.t6)(_context4.t10);apartmentConfig=void 0,project=void 0;apartmentConfigs=[];configTemplates=[];if(!id){_context4.next=40;break;}_context4.next=34;return(0,_request.GET)({endpoint:'/apartmentconfigs/'+id},dispatch);case 34:apartmentConfig=_context4.sent;_context4.next=37;return(0,_request.GET)({endpoint:'/projects/'+apartmentConfig.projectId},dispatch);case 37:project=_context4.sent;_context4.next=54;break;case 40:if(!projectId){_context4.next=54;break;}_context4.next=43;return(0,_request.GET)({endpoint:'/projects/'+projectId},dispatch);case 43:project=_context4.sent;_context4.t11=filterAndSort;_context4.next=47;return(0,_request.GET)({endpoint:'/projects/'+projectId+'/apartmentconfigs'},dispatch);case 47:_context4.t12=_context4.sent;apartmentConfigs=(0,_context4.t11)(_context4.t12);_context4.t13=filterAndSort;_context4.next=52;return(0,_request.GET)({endpoint:'/configtemplates'},dispatch);case 52:_context4.t14=_context4.sent;configTemplates=(0,_context4.t13)(_context4.t14);case 54:dispatch(dataSuccess(apartmentConfig,project,roomTypes,products,productTypes,apartmentConfigs,configTemplates,roomTemplates,projects));_context4.next=60;break;case 57:_context4.prev=57;_context4.t15=_context4['catch'](1);dispatch(dataFailure(_context4.t15));case 60:case'end':return _context4.stop();}}},_callee4,undefined,[[1,57]]);}));return function(_x4){return _ref10.apply(this,arguments);};}();};var updateApartmentConfig=exports.updateApartmentConfig=function updateApartmentConfig(id,body){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch){var apartmentConfig;return _regenerator2.default.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(apartmentConfigUpdateRequest());_context5.prev=1;_context5.next=4;return(0,_request.PUT)({endpoint:'/apartmentconfigs/'+id,body:body},dispatch);case 4:apartmentConfig=_context5.sent;dispatch(apartmentConfigUpdateSuccess(apartmentConfig));_context5.next=11;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](1);dispatch(apartmentConfigUpdateFailure(_context5.t0));case 11:case'end':return _context5.stop();}}},_callee5,undefined,[[1,8]]);}));return function(_x5){return _ref11.apply(this,arguments);};}();};var createApartmentConfig=exports.createApartmentConfig=function createApartmentConfig(projectId,body){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch){var apartmentConfig;return _regenerator2.default.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch(apartmentConfigCreateRequest());_context6.prev=1;_context6.next=4;return(0,_request.POST)({endpoint:'/projects/'+projectId+'/apartmentconfigs',body:body},dispatch);case 4:apartmentConfig=_context6.sent;dispatch(apartmentConfigCreateSuccess(apartmentConfig));_context6.next=11;break;case 8:_context6.prev=8;_context6.t0=_context6['catch'](1);dispatch(apartmentConfigCreateFailure(_context6.t0));case 11:case'end':return _context6.stop();}}},_callee6,undefined,[[1,8]]);}));return function(_x6){return _ref12.apply(this,arguments);};}();};var createRoom=exports.createRoom=function createRoom(configId,body){return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch){var room;return _regenerator2.default.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch(roomCreateRequest());_context7.prev=1;_context7.next=4;return(0,_request.POST)({endpoint:'/apartmentconfigs/'+configId+'/rooms',body:body},dispatch);case 4:room=_context7.sent;dispatch(roomCreateSuccess(room));_context7.next=11;break;case 8:_context7.prev=8;_context7.t0=_context7['catch'](1);dispatch(roomCreateFailure(_context7.t0));case 11:case'end':return _context7.stop();}}},_callee7,undefined,[[1,8]]);}));return function(_x7){return _ref13.apply(this,arguments);};}();};var updateRoom=exports.updateRoom=function updateRoom(id,body){return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch){var room;return _regenerator2.default.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch(roomUpdateRequest());_context8.prev=1;_context8.next=4;return(0,_request.PUT)({endpoint:'/rooms/'+id,body:body},dispatch);case 4:room=_context8.sent;dispatch(roomUpdateSuccess(room));_context8.next=11;break;case 8:_context8.prev=8;_context8.t0=_context8['catch'](1);dispatch(roomUpdateFailure(_context8.t0));case 11:case'end':return _context8.stop();}}},_callee8,undefined,[[1,8]]);}));return function(_x8){return _ref14.apply(this,arguments);};}();};var createProductSlot=exports.createProductSlot=function createProductSlot(roomId,body){return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch){var productslot;return _regenerator2.default.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch(productSlotCreateRequest());_context9.prev=1;_context9.next=4;return(0,_request.POST)({endpoint:'/rooms/'+roomId+'/productslots',body:body},dispatch);case 4:productslot=_context9.sent;dispatch(productSlotCreateSuccess(productslot,roomId));_context9.next=11;break;case 8:_context9.prev=8;_context9.t0=_context9['catch'](1);dispatch(productSlotCreateFailure(_context9.t0));case 11:case'end':return _context9.stop();}}},_callee9,undefined,[[1,8]]);}));return function(_x9){return _ref15.apply(this,arguments);};}();};var updateProductSlot=exports.updateProductSlot=function updateProductSlot(id,body){return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch){var productslot;return _regenerator2.default.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:dispatch(productSlotUpdateRequest());_context10.prev=1;_context10.next=4;return(0,_request.PUT)({endpoint:'/productslots/'+id,body:body},dispatch);case 4:productslot=_context10.sent;dispatch(productSlotUpdateSuccess(productslot));_context10.next=11;break;case 8:_context10.prev=8;_context10.t0=_context10['catch'](1);dispatch(productSlotUpdateFailure(_context10.t0));case 11:case'end':return _context10.stop();}}},_callee10,undefined,[[1,8]]);}));return function(_x10){return _ref16.apply(this,arguments);};}();};var updateRooms=exports.updateRooms=function updateRooms(apartmentConfigId,roomId,sortDirection/*: 'up' | 'down'*/){return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch){var rooms;return _regenerator2.default.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch(roomsUpdateRequest());_context11.prev=1;_context11.next=4;return(0,_request.PUT)({endpoint:'/apartmentconfigs/'+apartmentConfigId+'/rooms',body:{roomId:roomId,sortDirection:sortDirection}},dispatch);case 4:rooms=_context11.sent;dispatch(roomsUpdateSuccess(rooms));_context11.next=11;break;case 8:_context11.prev=8;_context11.t0=_context11['catch'](1);dispatch(roomsUpdateFailure(_context11.t0));case 11:case'end':return _context11.stop();}}},_callee11,undefined,[[1,8]]);}));return function(_x11){return _ref17.apply(this,arguments);};}();};var updateProductSlots=exports.updateProductSlots=function updateProductSlots(roomId,productSlotId,sortDirection/*: 'up' | 'down'*/){return function(){var _ref18=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee12(dispatch){var productSlots;return _regenerator2.default.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:dispatch(productSlotsUpdateRequest());_context12.prev=1;_context12.next=4;return(0,_request.PUT)({endpoint:'/rooms/'+roomId+'/productslots',body:{productSlotId:productSlotId,sortDirection:sortDirection}},dispatch);case 4:productSlots=_context12.sent;dispatch(productSlotsUpdateSuccess(roomId,productSlotId,productSlots));_context12.next=11;break;case 8:_context12.prev=8;_context12.t0=_context12['catch'](1);dispatch(productSlotsUpdateFailure(_context12.t0));case 11:case'end':return _context12.stop();}}},_callee12,undefined,[[1,8]]);}));return function(_x12){return _ref18.apply(this,arguments);};}();};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(62),
    overRest = __webpack_require__(359),
    setToString = __webpack_require__(211);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('toNumber', __webpack_require__(151), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.addVAT=exports.removeVAT=exports.totalPrice=exports.sumExtraRow=exports.sumRow=exports.productUnit=exports.productPrice=undefined;var _round2=__webpack_require__(923);var _round3=_interopRequireDefault(_round2);var _clamp2=__webpack_require__(926);var _clamp3=_interopRequireDefault(_clamp2);var _sumBy2=__webpack_require__(121);var _sumBy3=_interopRequireDefault(_sumBy2);var _add2=__webpack_require__(928);var _add3=_interopRequireDefault(_add2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _isNil2=__webpack_require__(166);var _isNil3=_interopRequireDefault(_isNil2);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var shouldUseOrderRowPrice=function shouldUseOrderRowPrice(variant/*: any*/,slot/*: any*/,row/*: ?any*/,variantConfig/*: ?any*/,config/*: ?any*/)/*: boolean*/{return!!row&&(slot.advanced&&!!config&&!!variantConfig?row.configId===variantConfig.id:row.productVariantId===variant.id)&&row.productSlotId===slot.id&&!(0,_isNil3.default)(row.orderedPrice)&&!(0,_isNil3.default)(row.orderedQuantity);};var productPrice=exports.productPrice=function productPrice(variant/*: any*/,slot/*: any*/,row/*: ?any*/,variantConfig/*: ?any*/,config/*: ?any*/)/*: number*/{return shouldUseOrderRowPrice(variant,slot,row,variantConfig,config)&&!!row?row.orderedPrice*row.orderedQuantity:(!!variantConfig&&variantConfig.customPrice!==null?variantConfig.customPrice:variant.sellingPrice)*(!!variantConfig?variantConfig.quantity:slot.quantity);};var formatUnit=function formatUnit(quantity,unit)/*: string*/{return quantity===1?unit:(0,_isEmpty3.default)(unit)?quantity:quantity+' '+unit;};var productUnit=exports.productUnit=function productUnit(variant/*: any*/,slot/*: any*/,row/*: ?any*/,variantConfig/*: ?any*/,config/*: ?any*/)/*: string*/{return shouldUseOrderRowPrice(variant,slot,row,variantConfig,config)&&!!row?formatUnit(row.orderedQuantity,row.ordererdUnit):!!variantConfig?formatUnit(variantConfig.quantity,variantConfig.unit):formatUnit(slot.quantity,slot.unit);};var sumRow=exports.sumRow=function sumRow(order/*: any*/){return function(row/*: any*/)/*: number*/{return row.orderedPrice===null?row.price*row.quantity:row.orderedPrice*row.orderedQuantity;};};var sumExtraRow=exports.sumExtraRow=function sumExtraRow(order/*: any*/){return function(row/*: any*/)/*: number*/{return row.orderedPrice===null?row.price*row.quantity:row.orderedPrice*row.quantity;};};var totalPrice=exports.totalPrice=function totalPrice(order/*: any*/)/*: number*/{return(0,_flow3.default)((0,_add3.default)((0,_sumBy3.default)(sumRow(order),order.rows)),(0,_add3.default)((0,_sumBy3.default)(sumExtraRow(order),order.extraRows)),(0,_add3.default)((0,_sumBy3.default)(function(r){return r.totalSellingPrice;},order.customRows)),(0,_add3.default)(-order.discount),(0,_clamp3.default)(0,Infinity),_round3.default)(0);};// Transform value to add VAT or remove VAT with guarantee of MAX two decimals
var removeVAT=exports.removeVAT=function removeVAT(val/*: number*/)/*: number*/{return Math.round(val*80)/100;};var addVAT=exports.addVAT=function addVAT(val/*: number*/)/*: number*/{return Math.round(val*125)/100;};

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('pick', __webpack_require__(956));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(71);
var core = __webpack_require__(56);
var ctx = __webpack_require__(415);
var hide = __webpack_require__(100);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(125);
var IE8_DOM_DEFINE = __webpack_require__(416);
var toPrimitive = __webpack_require__(242);
var dP = Object.defineProperty;

exports.f = __webpack_require__(89) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(101)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 90 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _class2, _temp;

/* Decoraters */


/* Utils */


/* CSS */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1060);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(72);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _staticMethods = __webpack_require__(1065);

var _staticMethods2 = _interopRequireDefault(_staticMethods);

var _windowListener = __webpack_require__(1066);

var _windowListener2 = _interopRequireDefault(_windowListener);

var _customEvent = __webpack_require__(1067);

var _customEvent2 = _interopRequireDefault(_customEvent);

var _isCapture = __webpack_require__(1068);

var _isCapture2 = _interopRequireDefault(_isCapture);

var _getEffect = __webpack_require__(1069);

var _getEffect2 = _interopRequireDefault(_getEffect);

var _trackRemoval = __webpack_require__(1070);

var _trackRemoval2 = _interopRequireDefault(_trackRemoval);

var _getPosition = __webpack_require__(1071);

var _getPosition2 = _interopRequireDefault(_getPosition);

var _getTipContent = __webpack_require__(1072);

var _getTipContent2 = _interopRequireDefault(_getTipContent);

var _aria = __webpack_require__(1073);

var _nodeListToArray = __webpack_require__(1074);

var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);

var _style = __webpack_require__(1075);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_Component) {
  _inherits(ReactTooltip, _Component);

  function ReactTooltip(props) {
    _classCallCheck(this, ReactTooltip);

    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));

    _this.state = {
      place: 'top', // Direction of tooltip
      type: 'dark', // Color theme of tooltip
      effect: 'float', // float or fixed
      show: false,
      border: false,
      placeholder: '',
      offset: {},
      extraClass: '',
      html: false,
      delayHide: 0,
      delayShow: 0,
      event: props.event || null,
      eventOff: props.eventOff || null,
      currentEvent: null, // Current mouse event
      currentTarget: null, // Current target of mouse event
      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
      isEmptyTip: false,
      disable: false
    };

    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize']);

    _this.mount = true;
    _this.delayShowLoop = null;
    _this.delayHideLoop = null;
    _this.intervalUpdateContent = null;
    return _this;
  }

  /**
   * For unify the bind and unbind listener
   */


  _createClass(ReactTooltip, [{
    key: 'bind',
    value: function bind(methodArray) {
      var _this2 = this;

      methodArray.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          insecure = _props.insecure,
          resizeHide = _props.resizeHide;

      if (insecure) {
        this.setStyleHeader(); // Set the style to the <link>
      }
      this.bindListener(); // Bind listener for tooltip
      this.bindWindowEvents(resizeHide); // Bind global event for static method
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var ariaProps = this.state.ariaProps;

      var newAriaProps = (0, _aria.parseAria)(props);

      var isChanged = Object.keys(newAriaProps).some(function (props) {
        return newAriaProps[props] !== ariaProps[props];
      });
      if (isChanged) {
        this.setState({ ariaProps: newAriaProps });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mount = false;

      this.clearTimer();

      this.unbindListener();
      this.removeScrollListener();
      this.unbindWindowEvents();
    }

    /**
     * Pick out corresponded target elements
     */

  }, {
    key: 'getTargetArray',
    value: function getTargetArray(id) {
      var targetArray = void 0;
      if (!id) {
        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
      } else {
        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
      }
      // targetArray is a NodeList, convert it to a real array
      return (0, _nodeListToArray2.default)(targetArray);
    }

    /**
     * Bind listener to the target elements
     * These listeners used to trigger showing or hiding the tooltip
     */

  }, {
    key: 'bindListener',
    value: function bindListener() {
      var _this3 = this;

      var _props2 = this.props,
          id = _props2.id,
          globalEventOff = _props2.globalEventOff;

      var targetArray = this.getTargetArray(id);

      targetArray.forEach(function (target) {
        var isCaptureMode = _this3.isCapture(target);
        var effect = _this3.getEffect(target);
        if (target.getAttribute('currentItem') === null) {
          target.setAttribute('currentItem', 'false');
        }
        _this3.unbindBasicListener(target);

        if (_this3.isCustomEvent(target)) {
          _this3.customBindListener(target);
          return;
        }

        target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
        if (effect === 'float') {
          target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
        }
        target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
      });

      // Global event to hide tooltip
      if (globalEventOff) {
        window.removeEventListener(globalEventOff, this.hideTooltip);
        window.addEventListener(globalEventOff, this.hideTooltip, false);
      }

      // Track removal of targetArray elements from DOM
      this.bindRemovalTracker();
    }

    /**
     * Unbind listeners on target elements
     */

  }, {
    key: 'unbindListener',
    value: function unbindListener() {
      var _this4 = this;

      var _props3 = this.props,
          id = _props3.id,
          globalEventOff = _props3.globalEventOff;

      var targetArray = this.getTargetArray(id);
      targetArray.forEach(function (target) {
        _this4.unbindBasicListener(target);
        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
      });

      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
      this.unbindRemovalTracker();
    }

    /**
     * Invoke this before bind listener and ummount the compont
     * it is necessary to invloke this even when binding custom event
     * so that the tooltip can switch between custom and default listener
     */

  }, {
    key: 'unbindBasicListener',
    value: function unbindBasicListener(target) {
      var isCaptureMode = this.isCapture(target);
      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
    }

    /**
     * When mouse enter, show the tooltip
     */

  }, {
    key: 'showTooltip',
    value: function showTooltip(e, isGlobalCall) {
      var _this5 = this;

      if (isGlobalCall) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || this.state.show) return;
      }
      // Get the tooltip content
      // calculate in this phrase so that tip width height can be detected
      var _props4 = this.props,
          children = _props4.children,
          multiline = _props4.multiline,
          getContent = _props4.getContent;

      var originTooltip = e.currentTarget.getAttribute('data-tip');
      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;

      // Generate tootlip content
      var content = void 0;
      if (getContent) {
        if (Array.isArray(getContent)) {
          content = getContent[0] && getContent[0]();
        } else {
          content = getContent();
        }
      }
      var placeholder = (0, _getTipContent2.default)(originTooltip, children, content, isMultiline);
      var isEmptyTip = typeof placeholder === 'string' && placeholder === '' || placeholder === null;

      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;

      // if it needs to skip adding hide listener to scroll
      var scrollHide = true;
      if (e.currentTarget.getAttribute('data-scroll-hide')) {
        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
      } else if (this.props.scrollHide != null) {
        scrollHide = this.props.scrollHide;
      }

      // To prevent previously created timers from triggering
      this.clearTimer();

      this.setState({
        placeholder: placeholder,
        isEmptyTip: isEmptyTip,
        place: e.currentTarget.getAttribute('data-place') || this.props.place || 'top',
        type: e.currentTarget.getAttribute('data-type') || this.props.type || 'dark',
        effect: switchToSolid && 'solid' || this.getEffect(e.currentTarget),
        offset: e.currentTarget.getAttribute('data-offset') || this.props.offset || {},
        html: e.currentTarget.getAttribute('data-html') ? e.currentTarget.getAttribute('data-html') === 'true' : this.props.html || false,
        delayShow: e.currentTarget.getAttribute('data-delay-show') || this.props.delayShow || 0,
        delayHide: e.currentTarget.getAttribute('data-delay-hide') || this.props.delayHide || 0,
        border: e.currentTarget.getAttribute('data-border') ? e.currentTarget.getAttribute('data-border') === 'true' : this.props.border || false,
        extraClass: e.currentTarget.getAttribute('data-class') || this.props.class || this.props.className || '',
        disable: e.currentTarget.getAttribute('data-tip-disable') ? e.currentTarget.getAttribute('data-tip-disable') === 'true' : this.props.disable || false
      }, function () {
        if (scrollHide) _this5.addScrollListener(e);
        _this5.updateTooltip(e);

        if (getContent && Array.isArray(getContent)) {
          _this5.intervalUpdateContent = setInterval(function () {
            if (_this5.mount) {
              var _getContent = _this5.props.getContent;

              var _placeholder = (0, _getTipContent2.default)(originTooltip, _getContent[0](), isMultiline);
              var _isEmptyTip = typeof _placeholder === 'string' && _placeholder === '';
              _this5.setState({
                placeholder: _placeholder,
                isEmptyTip: _isEmptyTip
              });
            }
          }, getContent[1]);
        }
      });
    }

    /**
     * When mouse hover, updatetooltip
     */

  }, {
    key: 'updateTooltip',
    value: function updateTooltip(e) {
      var _this6 = this;

      var _state = this.state,
          delayShow = _state.delayShow,
          show = _state.show,
          isEmptyTip = _state.isEmptyTip,
          disable = _state.disable;
      var afterShow = this.props.afterShow;
      var placeholder = this.state.placeholder;

      var delayTime = show ? 0 : parseInt(delayShow, 10);
      var eventTarget = e.currentTarget;

      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
      var updateState = function updateState() {
        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
          var isInvisible = !_this6.state.show;
          _this6.setState({
            currentEvent: e,
            currentTarget: eventTarget,
            show: true
          }, function () {
            _this6.updatePosition();
            if (isInvisible && afterShow) afterShow();
          });
        }
      };

      clearTimeout(this.delayShowLoop);
      if (delayShow) {
        this.delayShowLoop = setTimeout(updateState, delayTime);
      } else {
        updateState();
      }
    }

    /**
     * When mouse leave, hide tooltip
     */

  }, {
    key: 'hideTooltip',
    value: function hideTooltip(e, hasTarget) {
      var _this7 = this;

      var _state2 = this.state,
          delayHide = _state2.delayHide,
          isEmptyTip = _state2.isEmptyTip,
          disable = _state2.disable;
      var afterHide = this.props.afterHide;

      if (!this.mount) return;
      if (isEmptyTip || disable) return; // if the tooltip is empty, disable the tooltip
      if (hasTarget) {
        // Don't trigger other elements belongs to other ReactTooltip
        var targetArray = this.getTargetArray(this.props.id);
        var isMyElement = targetArray.some(function (ele) {
          return ele === e.currentTarget;
        });
        if (!isMyElement || !this.state.show) return;
      }
      var resetState = function resetState() {
        var isVisible = _this7.state.show;
        _this7.setState({
          show: false
        }, function () {
          _this7.removeScrollListener();
          if (isVisible && afterHide) afterHide();
        });
      };

      this.clearTimer();
      if (delayHide) {
        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
      } else {
        resetState();
      }
    }

    /**
     * Add scroll eventlistener when tooltip show
     * automatically hide the tooltip when scrolling
     */

  }, {
    key: 'addScrollListener',
    value: function addScrollListener(e) {
      var isCaptureMode = this.isCapture(e.currentTarget);
      window.addEventListener('scroll', this.hideTooltip, isCaptureMode);
    }
  }, {
    key: 'removeScrollListener',
    value: function removeScrollListener() {
      window.removeEventListener('scroll', this.hideTooltip);
    }

    // Calculation the position

  }, {
    key: 'updatePosition',
    value: function updatePosition() {
      var _this8 = this;

      var _state3 = this.state,
          currentEvent = _state3.currentEvent,
          currentTarget = _state3.currentTarget,
          place = _state3.place,
          effect = _state3.effect,
          offset = _state3.offset;

      var node = _reactDom2.default.findDOMNode(this);
      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, effect, offset);

      if (result.isNewState) {
        // Switch to reverse placement
        return this.setState(result.newState, function () {
          _this8.updatePosition();
        });
      }
      // Set tooltip position
      node.style.left = result.position.left + 'px';
      node.style.top = result.position.top + 'px';
    }

    /**
     * Set style tag in header
     * in this way we can insert default css
     */

  }, {
    key: 'setStyleHeader',
    value: function setStyleHeader() {
      if (!document.getElementsByTagName('head')[0].querySelector('style[id="react-tooltip"]')) {
        var tag = document.createElement('style');
        tag.id = 'react-tooltip';
        tag.innerHTML = _style2.default;
        document.getElementsByTagName('head')[0].appendChild(tag);
      }
    }

    /**
     * CLear all kinds of timeout of interval
     */

  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      clearTimeout(this.delayShowLoop);
      clearTimeout(this.delayHideLoop);
      clearInterval(this.intervalUpdateContent);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state4 = this.state,
          placeholder = _state4.placeholder,
          extraClass = _state4.extraClass,
          html = _state4.html,
          ariaProps = _state4.ariaProps,
          disable = _state4.disable,
          isEmptyTip = _state4.isEmptyTip;

      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' });

      var Wrapper = this.props.wrapper;
      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
        Wrapper = ReactTooltip.defaultProps.wrapper;
      }

      if (html) {
        return _react2.default.createElement(Wrapper, _extends({ className: tooltipClass + ' ' + extraClass
        }, ariaProps, {
          'data-id': 'tooltip',
          dangerouslySetInnerHTML: { __html: placeholder } }));
      } else {
        return _react2.default.createElement(
          Wrapper,
          _extends({ className: tooltipClass + ' ' + extraClass
          }, ariaProps, {
            'data-id': 'tooltip' }),
          placeholder
        );
      }
    }
  }]);

  return ReactTooltip;
}(_react.Component), _class2.propTypes = {
  children: _propTypes2.default.any,
  place: _propTypes2.default.string,
  type: _propTypes2.default.string,
  effect: _propTypes2.default.string,
  offset: _propTypes2.default.object,
  multiline: _propTypes2.default.bool,
  border: _propTypes2.default.bool,
  insecure: _propTypes2.default.bool,
  class: _propTypes2.default.string,
  className: _propTypes2.default.string,
  id: _propTypes2.default.string,
  html: _propTypes2.default.bool,
  delayHide: _propTypes2.default.number,
  delayShow: _propTypes2.default.number,
  event: _propTypes2.default.string,
  eventOff: _propTypes2.default.string,
  watchWindow: _propTypes2.default.bool,
  isCapture: _propTypes2.default.bool,
  globalEventOff: _propTypes2.default.string,
  getContent: _propTypes2.default.any,
  afterShow: _propTypes2.default.func,
  afterHide: _propTypes2.default.func,
  disable: _propTypes2.default.bool,
  scrollHide: _propTypes2.default.bool,
  resizeHide: _propTypes2.default.bool,
  wrapper: _propTypes2.default.string
}, _class2.defaultProps = {
  insecure: true,
  resizeHide: true,
  wrapper: 'div'
}, _class2.supportedWrappers = ['div', 'span'], _temp)) || _class) || _class) || _class) || _class) || _class) || _class;

/* export default not fit for standalone, it will exports {default:...} */


module.exports = ReactTooltip;

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(542);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(36);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(213),
    baseAssignValue = __webpack_require__(95);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(336);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(165);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('includes', __webpack_require__(850));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(114),
    isArrayLike = __webpack_require__(60),
    isIndex = __webpack_require__(113),
    isObject = __webpack_require__(45);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('findIndex', __webpack_require__(387));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(88);
var createDesc = __webpack_require__(172);
module.exports = __webpack_require__(89) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(419);
var defined = __webpack_require__(243);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(246)('wks');
var uid = __webpack_require__(173);
var Symbol = __webpack_require__(71).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;


  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};


/* harmony default export */ __webpack_exports__["a"] = (formatName);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(136);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 111 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(337),
    baseIsNaN = __webpack_require__(774),
    strictIndexOf = __webpack_require__(775);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 113 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(781),
    isObjectLike = __webpack_require__(33);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(36),
    stubFalse = __webpack_require__(782);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105)(module)))

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93),
    arrayMap = __webpack_require__(46),
    isArray = __webpack_require__(18),
    isSymbol = __webpack_require__(76);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(358),
    overRest = __webpack_require__(359),
    setToString = __webpack_require__(211);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(220),
    isFlattenable = __webpack_require__(844);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('uniqBy', __webpack_require__(883));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('sumBy', __webpack_require__(897));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('get', __webpack_require__(96));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('reduce', __webpack_require__(910));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.defaultDialogState=exports.checkProduct=exports.checkAllVariants=exports.toggleProduct=exports.resetDialog=exports.closeDialog=exports.prepareDialog=exports.clearStandardProduct=exports.setStandardProduct=exports.updateVariantsForType=exports.updateVariants=exports.updateRelatedVariant=exports.toggleVariant=exports.popNavigation=exports.navigateToVariant=exports.openDialog=exports.navigateToVariantRequest=exports.toggleVariantRequest=exports.openDialogRequest=exports.handleError=exports.sortRoomList=exports.sortByIndex=undefined;var _reject2=__webpack_require__(68);var _reject3=_interopRequireDefault(_reject2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _mapValues2=__webpack_require__(66);var _mapValues3=_interopRequireDefault(_mapValues2);var _keyBy2=__webpack_require__(167);var _keyBy3=_interopRequireDefault(_keyBy2);var _flatMap2=__webpack_require__(54);var _flatMap3=_interopRequireDefault(_flatMap2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _values2=__webpack_require__(67);var _values3=_interopRequireDefault(_values2);var _groupBy2=__webpack_require__(168);var _groupBy3=_interopRequireDefault(_groupBy2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _toLower2=__webpack_require__(65);var _toLower3=_interopRequireDefault(_toLower2);var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _configTemplateView=__webpack_require__(394);var _form=__webpack_require__(17);var _uuid=__webpack_require__(53);var _uuid2=_interopRequireDefault(_uuid);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}/*:: import type {
  ConfigTemplateAction,
} from '../actions/configTemplateView';*//*:: import type {
  FormAction,
} from '../actions/form';*//*:: import type {
  ErrorDto,
  ConfigTemplateDto,
  LimitedProjectDto,
  RoomTemplateDto,
  RoomDto,
  RoomTypeDto,
} from '../dtos';*//*:: export type ConfigTemplateState = {
  active: ?any,
  error: ?ErrorDto,
  isDirty: bool,
  isFetching: bool,
};*//*:: type StandardProductsState = {
  [key: number]: ?number,
};*//*:: type ConfigEntry = {
  checked: bool,
  expanded: bool,
  id: ?number,
  parentId: ?number,
  parentUuid: ?string,
  productSlotId: ?number,
  productVariantId: number,
  quantity: ?number,
  related: any[],
  standardProducts: StandardProductsState,
  unit: ?string,
  uuid: string,
  customPrice: ?number,
};*//*:: export type ModifiedState = {
  [key: string]: ConfigEntry,
};*//*:: export type NavigationState = {
  active: any[],
  currentUuid: ?string,
  name: string,
  previous: ?NavigationState,
  standardProducts: StandardProductsState,
};*//*:: export type DialogState = {
  config: any[],
  error: ?ErrorDto,
  isFetching: bool,
  modifiedData: ModifiedState,
  navigation: ?NavigationState,
  show: bool,
  sharedChecked: ?bool,
  standardProductId: ?number,
};*//*:: export type ProductsState = any[];*//*:: export type ConfigTemplatesState = ConfigTemplateDto[];*//*:: export type ProjectsState = LimitedProjectDto[];*//*:: export type ProductSlotState = {
  active: ?any,
  dialog: DialogState,
  error: ?ErrorDto,
  isDirty: bool,
  isFetching: bool,
  roomId: ?number,
};*//*:: export type ProductTypesState = any[];*//*:: export type RoomState = {
  active: ?any,
  error: ?ErrorDto,
  isDirty: bool,
  isFetching: bool,
};*//*:: export type RoomsState = RoomDto[];*//*:: export type RoomTypesState = RoomTypeDto[];*//*:: export type RoomTemplatesState = RoomTemplateDto[];*//*:: export type State_ = {
  configTemplate: ConfigTemplateState,
  products: ProductsState,
  productSlot: ProductSlotState,
  productTypes: ProductTypesState,
  room: RoomState,
  rooms: RoomsState,
  roomTypes: RoomTypesState,
  configTemplates: ConfigTemplatesState,
  projects: ProjectsState,
  roomTemplates: RoomTemplatesState,
};*//*:: export type Exact<T> = T & $Shape<T>;*//*:: type State = {
  configTemplate: Exact<ConfigTemplateState>,
  products: ProductsState,
  productSlot: Exact<ProductSlotState>,
  productTypes: ProductTypesState,
  room: Exact<RoomState>,
  rooms: RoomsState,
  roomTypes: RoomTypesState,
  configTemplates: ConfigTemplatesState,
  projects: ProjectsState,
  roomTemplates: RoomTemplatesState,
};*/var sortByName=(0,_sortBy3.default)([function(s){return(0,_toLower3.default)(s.name);}]);var sortByIndex=exports.sortByIndex=(0,_sortBy3.default)([function(x){return x.sortIndex;}]);var sortRoomList/*: (rooms: any[]) => any[]*/=exports.sortRoomList=(0,_flow3.default)((0,_map3.default)(function(r){return _extends({},r,{productSlots:sortByIndex(r.productSlots)});}),sortByIndex);var popState=function popState(state/*: ?NavigationState*/)/*: ?Exact<NavigationState>*/{var depth/*: number*/=arguments.length>1&&arguments[1]!==undefined?arguments[1]:1;if(!state){return null;}else if(depth>0){return popState(state.previous,depth-1)||state;}return state;};var notArchived=(0,_filter3.default)(function(x){return!x.archived;});var mapRelated=function mapRelated(config/*: any[]*/,variant/*: any*/)/*: any[]*/{return(0,_flow3.default)((0,_groupBy3.default)(function(x){return x.productTypeId;}),_values3.default,sortByName,(0,_map3.default)(function(_ref){var _ref2=_toArray(_ref),head=_ref2[0],tail=_ref2.slice(1);return{id:head.productTypeId,name:head.productTypeName,products:(0,_flow3.default)((0,_groupBy3.default)(function(x){return x.productId;}),_values3.default,notArchived,sortByName,(0,_map3.default)(function(_ref3){var _ref4=_toArray(_ref3),head=_ref4[0],tail=_ref4.slice(1);return{id:head.productId,name:head.productName,mainVariantId:head.mainVariantId,variants:(0,_flow3.default)(notArchived,sortByName,(0,_map3.default)(function(_ref5){var id=_ref5.id,name=_ref5.name,itemNumber=_ref5.itemNumber,hasRelated=_ref5.hasRelated,productId=_ref5.productId,sellingPrice=_ref5.sellingPrice;var existingConfig=(0,_find3.default)({productVariantId:id,parentUuid:variant.uuid},config);return{id:id,name:name,itemNumber:itemNumber,hasRelated:hasRelated,productId:productId,uuid:existingConfig?existingConfig.uuid:_uuid2.default.v4(),sellingPrice:sellingPrice};}))([head].concat(_toConsumableArray(tail))),expanded:true};}))([head].concat(_toConsumableArray(tail)))};}))(variant.related);};var handleError=exports.handleError=function handleError(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{return _extends({},state,{error:action.error,isFetching:false});};var openDialogRequest=exports.openDialogRequest=function openDialogRequest(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{return _extends({},state,{isFetching:true,navigation:null,show:true});};var toggleVariantRequest=exports.toggleVariantRequest=function toggleVariantRequest(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{return _extends({},state,{isFetching:true});};var navigateToVariantRequest=exports.navigateToVariantRequest=toggleVariantRequest;var mapConfigEntries=function mapConfigEntries(modifiedData,parentId,parentUuid,productSlot){return(0,_flow3.default)((0,_flatMap3.default)(function(x){return(0,_map3.default)(function(y){return{productType:x,product:y};},x.products);}),(0,_flatMap3.default)(function(x){return(0,_map3.default)(function(y){return _extends({},x,{variant:y});},x.product.variants);}),(0,_filter3.default)(function(x){return!modifiedData[x.variant.uuid];}),(0,_keyBy3.default)(function(x){return x.variant.uuid;}),(0,_mapValues3.default)(function(x){var allVariants=(0,_flatMap3.default)(function(y){return y.variants;},x.productType.products);var firstWithQuantity=(0,_flow3.default)((0,_map3.default)(function(v){return modifiedData[v.uuid];}),(0,_filter3.default)(function(v){return!!v&&v.quantity!==null;}))(x.product.variants);if(!firstWithQuantity.length){firstWithQuantity=(0,_flow3.default)((0,_map3.default)(function(v){return modifiedData[v.uuid];}),(0,_filter3.default)(function(v){return!!v&&v.quantity!==null;}))(allVariants);}var firstQuantity=!!firstWithQuantity.length?firstWithQuantity[0].quantity:1;var firstWithUnit=(0,_flow3.default)((0,_map3.default)(function(v){return modifiedData[v.uuid];}),(0,_filter3.default)(function(v){return!!v&&!!v.unit;}))(x.product.variants);if(!firstWithQuantity.length){firstWithUnit=(0,_flow3.default)((0,_map3.default)(function(v){return modifiedData[v.uuid];}),(0,_filter3.default)(function(v){return!!v&&!!v.unit;}))(allVariants);}var firstUnit=!!firstWithUnit.length?firstWithUnit[0].unit||'':'';return{checked:false,expanded:false,id:null,parentId:parentId,parentUuid:parentUuid,productId:x.variant.productId,productSlotId:productSlot?productSlot.id:null,productVariantId:x.variant.id,quantity:firstQuantity,related:[],standardProducts:{},unit:firstUnit,uuid:x.variant.uuid,customPrice:null};}));};var getSharedChecked=function getSharedChecked(productTypes,modifiedData){var variants=(0,_flow3.default)((0,_flatMap3.default)(function(x){return x.products;}),(0,_flatMap3.default)(function(x){return x.variants;}))(productTypes);var checkedCount=(0,_filter3.default)(function(v){return modifiedData[v.uuid]&&modifiedData[v.uuid].checked;},variants).length;return checkedCount===variants.length?true:checkedCount===0?false:null;};var openDialog=exports.openDialog=function openDialog(state/*: DialogState*/,action/*: any*/,active/*: ?any*/)/*: Exact<DialogState>*/{var newActive=[{id:action.productType.id,name:action.productType.name,products:(0,_flow3.default)(notArchived,sortByName,(0,_map3.default)(function(_ref6){var id=_ref6.id,name=_ref6.name,mainVariantId=_ref6.mainVariantId,variants=_ref6.variants;return{id:id,name:name,mainVariantId:mainVariantId,variants:(0,_flow3.default)(notArchived,sortByName,(0,_map3.default)(function(_ref7){var variantId=_ref7.id,name=_ref7.name,itemNumber=_ref7.itemNumber,hasRelated=_ref7.hasRelated,sellingPrice=_ref7.sellingPrice;var existingConfig=(0,_flow3.default)(_values3.default,(0,_find3.default)({productVariantId:variantId,parentId:null}))(state.modifiedData);return{id:variantId,name:name,itemNumber:itemNumber,hasRelated:hasRelated,productId:id,uuid:!!existingConfig?existingConfig.uuid:_uuid2.default.v4(),sellingPrice:sellingPrice};}))(variants),expanded:true};}))(action.products)}];var modifiedData=_extends({},state.modifiedData,mapConfigEntries(state.modifiedData,null,null,active)(newActive));return _extends({},state,{error:null,isFetching:false,modifiedData:modifiedData,navigation:{active:newActive,previous:null,currentUuid:null,name:action.rootName,standardProducts:_defineProperty({},action.productType.id,state.standardProductId)},sharedChecked:getSharedChecked(newActive,modifiedData)});};var navigateToVariant=exports.navigateToVariant=function navigateToVariant(state/*: DialogState*/,action/*: any*/,active/*: ?any*/)/*: Exact<DialogState>*/{var existingData=state.modifiedData[action.variant.uuid];var hasExistingRelated=!!existingData&&!!existingData.related.length;var newActive=hasExistingRelated?existingData.related:mapRelated(state.config,action.variant);var modifiedData=_extends({},state.modifiedData,_defineProperty({},action.variant.uuid,_extends({},state.modifiedData[action.variant.uuid],{related:newActive})),hasExistingRelated?{}:mapConfigEntries(state.modifiedData,!!existingData?existingData.id:null,action.variant.uuid,active)(newActive));return _extends({},state,{error:null,isFetching:false,modifiedData:modifiedData,navigation:{active:newActive,currentUuid:action.variant.uuid,name:action.variant.productName+' - '+action.variant.name,previous:state.navigation,standardProducts:existingData?_extends({},existingData.standardProducts):{}},sharedChecked:getSharedChecked(newActive,modifiedData)});};var popNavigation=exports.popNavigation=function popNavigation(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{var navigation=popState(state.navigation,action.depth);return _extends({},state,{navigation:navigation,sharedChecked:getSharedChecked(!!navigation?navigation.active:[],state.modifiedData)});};var toggleVariant=exports.toggleVariant=function toggleVariant(state/*: DialogState*/,action/*: any*/,active/*: ?any*/)/*: Exact<DialogState>*/{var existingData=state.modifiedData[action.variant.uuid];var hasExistingRelated=!!existingData&&!!existingData.related&&!!existingData.related.length;var newRelated=hasExistingRelated?existingData.related:mapRelated(state.config,action.variant);return _extends({},state,{error:null,isFetching:false,modifiedData:_extends({},state.modifiedData,_defineProperty({},action.variant.uuid,_extends({},state.modifiedData[action.variant.uuid],{expanded:action.expand,related:newRelated})),hasExistingRelated?{}:mapConfigEntries(state.modifiedData,!!existingData?existingData.id:null,action.variant.uuid,active)(newRelated))});};var updateRelatedVariant=exports.updateRelatedVariant=function updateRelatedVariant(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{var modifiedData=_extends({},state.modifiedData,_defineProperty({},action.variant.uuid,_extends({},state.modifiedData[action.variant.uuid],action.data)));return _extends({},state,{modifiedData:modifiedData,sharedChecked:getSharedChecked(!!state.navigation?state.navigation.active:[],modifiedData)});};var updateVariants=exports.updateVariants=function updateVariants(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{var modifiedData=_extends({},state.modifiedData,(0,_flow3.default)((0,_map3.default)(function(t){return _extends({},t,{products:(0,_map3.default)(function(p){return _extends({},p,{variants:(0,_filter3.default)(function(v){return!!state.modifiedData[v.uuid];},p.variants)});},t.products)});}),(0,_flatMap3.default)(function(t){return(0,_flatMap3.default)(function(p){return(0,_map3.default)(function(v){return _extends({},state.modifiedData[v.uuid],p.id===action.productId?action.data:{});},p.variants);},t.products);}),(0,_keyBy3.default)(function(x){return x.uuid;}))(!!state.navigation?state.navigation.active:[]));return _extends({},state,{modifiedData:modifiedData,sharedChecked:getSharedChecked(!!state.navigation?state.navigation.active:[],modifiedData)});};var updateVariantsForType=exports.updateVariantsForType=function updateVariantsForType(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{var modifiedData=_extends({},state.modifiedData,(0,_flow3.default)((0,_map3.default)(function(t){return _extends({},t,{products:(0,_map3.default)(function(p){return _extends({},p,{variants:(0,_filter3.default)(function(v){return!!state.modifiedData[v.uuid];},p.variants)});},t.products)});}),(0,_flatMap3.default)(function(t){return(0,_flatMap3.default)(function(p){return(0,_map3.default)(function(v){return _extends({},state.modifiedData[v.uuid],t.id===action.productTypeId?action.data:{});},p.variants);},t.products);}),(0,_keyBy3.default)(function(x){return x.uuid;}))(!!state.navigation?state.navigation.active:[]));return _extends({},state,{modifiedData:modifiedData,sharedChecked:getSharedChecked(!!state.navigation?state.navigation.active:[],modifiedData)});};var setStandardProduct=exports.setStandardProduct=function setStandardProduct(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{var navigation=state.navigation;if(navigation){if(!!navigation.currentUuid){var parent=state.modifiedData[navigation.currentUuid];if(!!parent){var _modifiedData=_extends({},state.modifiedData,_defineProperty({},navigation.currentUuid,_extends({},parent,{standardProducts:_extends({},parent.standardProducts,_defineProperty({},action.productType.id,action.product.id))})));var matchingVariants=(0,_filter3.default)(function(x){return(0,_some3.default)({uuid:x.uuid},action.product.variants);},_modifiedData);if(!(0,_some3.default)(function(x){return x.checked;},matchingVariants)){_modifiedData=_extends({},_modifiedData,(0,_flow3.default)((0,_map3.default)(function(v){return _extends({},v,{checked:true});}),(0,_keyBy3.default)(function(x){return x.uuid;}))(matchingVariants));}else{var mainVariant=(0,_find3.default)({productVariantId:action.product.mainVariantId},matchingVariants);if(!!mainVariant&&!mainVariant.checked){_modifiedData=_extends({},_modifiedData,_defineProperty({},mainVariant.uuid,_extends({},mainVariant,{checked:true})));}}return _extends({},state,{modifiedData:_modifiedData,navigation:_extends({},state.navigation,{standardProducts:_extends({},!!state.navigation?state.navigation.standardProducts:{},_defineProperty({},action.productType.id,action.product.id))}),sharedChecked:getSharedChecked(navigation.active,_modifiedData)});}}else{var _matchingVariants=(0,_filter3.default)(function(x){return(0,_some3.default)({uuid:x.uuid},action.product.variants);},state.modifiedData);var _modifiedData2=state.modifiedData;if(!(0,_some3.default)(function(x){return x.checked;},_matchingVariants)){_modifiedData2=_extends({},_modifiedData2,(0,_flow3.default)((0,_map3.default)(function(v){return _extends({},v,{checked:true});}),(0,_keyBy3.default)('uuid'))(_matchingVariants));}else{var _mainVariant=(0,_find3.default)({productVariantId:action.product.mainVariantId},_matchingVariants);if(!!_mainVariant&&!_mainVariant.checked){_modifiedData2=_extends({},_modifiedData2,_defineProperty({},_mainVariant.uuid,_extends({},_mainVariant,{checked:true})));}}return _extends({},state,{modifiedData:_modifiedData2,navigation:_extends({},state.navigation,{standardProducts:_extends({},!!state.navigation?state.navigation.standardProducts:{},_defineProperty({},action.productType.id,action.product.id))}),standardProductId:action.product.id,sharedChecked:getSharedChecked(navigation.active,_modifiedData2)});}}return state;};var clearStandardProduct=exports.clearStandardProduct=function clearStandardProduct(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{var navigation=state.navigation;if(navigation){if(!!navigation.currentUuid){var parent=state.modifiedData[navigation.currentUuid];if(!!parent){return _extends({},state,{modifiedData:_extends({},state.modifiedData,_defineProperty({},navigation.currentUuid,_extends({},parent,{standardProducts:_extends({},parent.standardProducts,_defineProperty({},action.productType.id,null))}))),navigation:_extends({},state.navigation,{standardProducts:_extends({},!!state.navigation?state.navigation.standardProducts:{},_defineProperty({},action.productType.id,null))})});}}else{return _extends({},state,{navigation:_extends({},state.navigation,{standardProducts:_extends({},!!state.navigation?state.navigation.standardProducts:{},_defineProperty({},action.productType.id,null))}),standardProductId:null});}}return state;};var prepareDialog=exports.prepareDialog=function prepareDialog(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{var config/*: ConfigEntry[]*/=(0,_flow3.default)((0,_sortBy3.default)([function(x){return x.id;}]),(0,_map3.default)(function(c){return _extends({},c,{uuid:_uuid2.default.v4()});}))((action.productSlot||{}).config);var configWithUuids=(0,_map3.default)(function(c){var parent/*: ?ConfigEntry*/=!!c.parentId?(0,_find3.default)({id:c.parentId},config):null;return _extends({},c,{parentUuid:!!parent?parent.uuid:null});},config);var modifiedData=(0,_flow3.default)((0,_keyBy3.default)(function(x){return x.uuid;}),(0,_mapValues3.default)(function(c){return _extends({},c,{checked:true,expanded:false,related:[],standardProducts:(0,_flow3.default)((0,_keyBy3.default)(function(x){return x.productTypeId;}),(0,_mapValues3.default)(function(x){return x.productId;}))(c.standardProducts)});}))(configWithUuids);return _extends({},state,{config:configWithUuids,modifiedData:modifiedData,standardProductId:!!action.productSlot?action.productSlot.standardProductId:null,sharedChecked:getSharedChecked(!!state.navigation?state.navigation.active:[],modifiedData)});};var closeDialog=exports.closeDialog=function closeDialog(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{return _extends({},state,{navigation:null,show:false});};var resetDialog=exports.resetDialog=function resetDialog(state/*: DialogState*/,action/*: any*/,active/*: ?any*/)/*: Exact<DialogState>*/{return _extends({},state,{modifiedData:(0,_flow3.default)((0,_keyBy3.default)(function(x){return x.uuid;}),(0,_mapValues3.default)(function(c){return _extends({},c,{checked:true,expanded:false,related:[],standardProducts:(0,_flow3.default)((0,_keyBy3.default)(function(x){return x.productTypeId;}),(0,_mapValues3.default)(function(x){return x.productId;}))(c.standardProducts)});}))(state.config),navigation:null,show:false,standardProductId:!!active?active.standardProductId:null,sharedChecked:false});};var toggleProduct=exports.toggleProduct=function toggleProduct(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{return _extends({},state,{navigation:!!state.navigation?_extends({},state.navigation,{active:(0,_map3.default)(function(p){return _extends({},p,{expanded:p.id===action.product.id?!p.expanded:p.expanded});},state.navigation.active)}):state.navigation});};var checkAllVariants=exports.checkAllVariants=function checkAllVariants(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{var standardProducts=!!state.navigation?state.navigation.standardProducts:{};var modifiedData=_extends({},state.modifiedData,(0,_flow3.default)((0,_map3.default)(function(t){return _extends({},t,{products:(0,_map3.default)(function(p){return _extends({},p,{variants:(0,_filter3.default)(function(v){return!!state.modifiedData[v.uuid];},p.variants)});},t.products)});}),(0,_flatMap3.default)(function(t){return(0,_flatMap3.default)(function(p){return(0,_map3.default)(function(v){return _extends({},state.modifiedData[v.uuid],{checked:!!action.checked||standardProducts[t.id]===p.id&&v.id===p.mainVariantId});},p.variants);},t.products);}),(0,_keyBy3.default)(function(x){return x.uuid;}))(!!state.navigation?state.navigation.active:[]));return _extends({},state,{modifiedData:modifiedData,sharedChecked:getSharedChecked(!!state.navigation?state.navigation.active:[],modifiedData)});};var checkProduct=exports.checkProduct=function checkProduct(state/*: DialogState*/,action/*: any*/)/*: Exact<DialogState>*/{var standardProducts=!!state.navigation?state.navigation.standardProducts:{};var modifiedData=_extends({},state.modifiedData,(0,_flow3.default)((0,_map3.default)(function(t){return _extends({},t,{products:(0,_map3.default)(function(p){return _extends({},p,{variants:(0,_filter3.default)(function(v){return!!state.modifiedData[v.uuid];},p.variants)});},t.products)});}),(0,_flatMap3.default)(function(t){return(0,_flatMap3.default)(function(p){return(0,_map3.default)(function(v){return _extends({},state.modifiedData[v.uuid],{checked:p.id===action.productId?!!action.checked||standardProducts[t.id]===p.id&&v.id===p.mainVariantId:state.modifiedData[v.uuid].checked});},p.variants);},t.products);}),(0,_keyBy3.default)(function(x){return x.uuid;}))(!!state.navigation?state.navigation.active:[]));return _extends({},state,{modifiedData:modifiedData,sharedChecked:getSharedChecked(!!state.navigation?state.navigation.active:[],modifiedData)});};var defaultConfigTemplateState/*: ConfigTemplateState*/={active:null,error:null,isDirty:false,isFetching:false};var defaultRoomsState/*: RoomsState*/=[];var defaultRoomState/*: RoomState*/={active:null,error:null,isDirty:false,isFetching:false};var defaultDialogState/*: DialogState*/=exports.defaultDialogState={config:[],error:null,isFetching:false,modifiedData:{},navigation:null,show:false,standardProductId:null,sharedChecked:false};var defaultProductSlotState/*: ProductSlotState*/={active:null,dialog:defaultDialogState,error:null,isDirty:false,isFetching:false,roomId:null};var defaultRoomTypesState/*: RoomTypesState*/=[];var defaultProductTypesState/*: ProductTypesState*/=[];var defaultProductsState/*: ProductsState*/=[];var defaultConfigTemplatesState/*: ConfigTemplatesState*/=[];var defaultProjectsState/*: ProjectsState*/=[];var defaultRoomTemplatesState/*: RoomTemplatesState*/=[];var defaultState/*: State_*/={configTemplate:defaultConfigTemplateState,products:defaultProductsState,productSlot:defaultProductSlotState,productTypes:defaultProductTypesState,room:defaultRoomState,rooms:defaultRoomsState,roomTypes:defaultRoomTypesState,configTemplates:defaultConfigTemplatesState,projects:defaultProjectsState,roomTemplates:defaultRoomTemplatesState};var configTemplateView=function configTemplateView()/*: Exact<State>*/{var state/*: State_*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action/*: ConfigTemplateAction | FormAction*/=arguments[1];switch(action.type){case _configTemplateView.GET_REQUEST:return _extends({},state,{configTemplate:_extends({},state.configTemplate,{active:null,error:null,isFetching:true}),products:defaultProductsState,productTypes:defaultProductTypesState,roomTypes:defaultRoomTypesState,projects:defaultProjectsState,roomTemplates:defaultRoomTemplatesState});case _configTemplateView.CREATE_REQUEST:case _configTemplateView.UPDATE_REQUEST:return _extends({},state,{configTemplate:_extends({},state.configTemplate,{error:null,isFetching:true})});case _configTemplateView.CREATE_FAILURE:case _configTemplateView.GET_FAILURE:case _configTemplateView.UPDATE_FAILURE:return _extends({},state,{configTemplate:_extends({},state.configTemplate,{error:action.error,isFetching:false})});case _configTemplateView.CREATE_SUCCESS:return _extends({},state,{configTemplate:_extends({},state.configTemplate,{active:action.configTemplate,error:null,isDirty:false,isFetching:false}),rooms:action.configTemplate?sortRoomList(action.configTemplate.rooms):[]});case _configTemplateView.GET_SUCCESS:{return _extends({},state,{configTemplate:_extends({},state.configTemplate,{active:action.configTemplate,error:null,isDirty:false,isFetching:false}),products:action.products,productTypes:action.productTypes,rooms:action.configTemplate?sortRoomList(action.configTemplate.rooms):[],roomTypes:action.roomTypes,configTemplates:action.configTemplates||[],projects:action.projects,roomTemplates:action.roomTemplates});}case _configTemplateView.UPDATE_SUCCESS:return _extends({},state,{configTemplate:_extends({},state.configTemplate,{active:action.configTemplate,error:null,isDirty:false,isFetching:false})});case _configTemplateView.CLOSE_DIALOG:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:closeDialog(state.productSlot.dialog,action)})});case _configTemplateView.RESET:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:resetDialog(state.productSlot.dialog,action,state.productSlot.active)})});case _configTemplateView.NAVIGATE_TO_VARIANT_FAILURE:case _configTemplateView.OPEN_DIALOG_FAILURE:case _configTemplateView.TOGGLE_VARIANT_FAILURE:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:handleError(state.productSlot.dialog,action)})});case _configTemplateView.NAVIGATE_TO_VARIANT_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:navigateToVariantRequest(state.productSlot.dialog,action)})});case _configTemplateView.NAVIGATE_TO_VARIANT_SUCCESS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:navigateToVariant(state.productSlot.dialog,action,state.productSlot.active)})});case _configTemplateView.OPEN_DIALOG_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:openDialogRequest(state.productSlot.dialog,action)})});case _configTemplateView.OPEN_DIALOG_SUCCESS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:openDialog(state.productSlot.dialog,action,state.productSlot.active)})});case _configTemplateView.POP_DIALOG_NAVIGATION:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:popNavigation(state.productSlot.dialog,action)})});case _configTemplateView.SET_STANDARD_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:setStandardProduct(state.productSlot.dialog,action)})});case _configTemplateView.CLEAR_STANDARD_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:clearStandardProduct(state.productSlot.dialog,action)})});case _configTemplateView.TOGGLE_VARIANT_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:toggleVariantRequest(state.productSlot.dialog,action)})});case _configTemplateView.TOGGLE_VARIANT_SUCCESS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:toggleVariant(state.productSlot.dialog,action,state.productSlot.active)})});case _configTemplateView.UPDATE_RELATED_VARIANT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:updateRelatedVariant(state.productSlot.dialog,action)})});case _configTemplateView.TOGGLE_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:toggleProduct(state.productSlot.dialog,action)})});case _configTemplateView.CHECK_ALL_VARIANTS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:checkAllVariants(state.productSlot.dialog,action)})});case _configTemplateView.CHECK_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:checkProduct(state.productSlot.dialog,action)})});case _configTemplateView.PRODUCT_SLOT_CREATE_REQUEST:case _configTemplateView.PRODUCT_SLOT_UPDATE_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{error:null,isFetching:true})});case _configTemplateView.PRODUCT_SLOT_CREATE_FAILURE:case _configTemplateView.PRODUCT_SLOT_UPDATE_FAILURE:return _extends({},state,{productSlot:_extends({},state.productSlot,{error:action.error,isFetching:false})});case _configTemplateView.PRODUCT_SLOT_CREATE_SUCCESS:{var _productSlot=action.productSlot,_id=action.roomId;var currentRoom=_extends({},(0,_find3.default)({id:_id},state.rooms));currentRoom.productSlots=currentRoom.productSlots?sortByIndex([].concat(_toConsumableArray(currentRoom.productSlots),[_productSlot])):[_productSlot];return _extends({},state,{productSlot:_extends({},state.productSlot,{active:_productSlot,dialog:prepareDialog(state.productSlot.dialog,action),error:null,isDirty:false,isFetching:false,roomId:_id}),rooms:sortRoomList([].concat(_toConsumableArray((0,_reject3.default)({id:currentRoom.id},state.rooms)),[currentRoom]))});}case _configTemplateView.PRODUCT_SLOT_UPDATE_SUCCESS:{var _productSlot2=action.productSlot;var _currentRoom=_extends({},(0,_find3.default)(function(r){return(0,_some3.default)({id:_productSlot2.id},r.productSlots);},state.rooms));_currentRoom.productSlots=sortByIndex([].concat(_toConsumableArray((0,_reject3.default)({id:_productSlot2.id},_currentRoom.productSlots)),[_productSlot2]));return _extends({},state,{productSlot:_extends({},state.productSlot,{active:_productSlot2,dialog:prepareDialog(state.productSlot.dialog,action),error:null,isDirty:false,isFetching:false}),rooms:sortRoomList([].concat(_toConsumableArray((0,_reject3.default)({id:_currentRoom.id},state.rooms)),[_currentRoom]))});}case _configTemplateView.ROOM_CREATE_REQUEST:case _configTemplateView.ROOM_UPDATE_REQUEST:return _extends({},state,{room:_extends({},state.room,{error:null,isFetching:true})});case _configTemplateView.ROOM_CREATE_FAILURE:case _configTemplateView.ROOM_UPDATE_FAILURE:return _extends({},state,{room:_extends({},state.room,{error:action.error,isFetching:false})});case _configTemplateView.ROOM_CREATE_SUCCESS:return _extends({},state,{room:_extends({},state.room,{active:action.room,error:null,isDirty:false,isFetching:false}),rooms:sortRoomList([].concat(_toConsumableArray(state.rooms),[action.room]))});case _configTemplateView.ROOM_UPDATE_SUCCESS:return _extends({},state,{room:_extends({},state.room,{active:action.room,error:null,isDirty:false,isFetching:false}),rooms:sortRoomList([].concat(_toConsumableArray((0,_reject3.default)({id:action.room.id},state.rooms)),[action.room]))});case _configTemplateView.SELECT_PRODUCT_SLOT:return _extends({},state,{productSlot:_extends({},state.productSlot,{active:action.productSlot||{uuid:_uuid2.default.v4(),advanced:false},dialog:prepareDialog(state.productSlot.dialog,action),roomId:action.roomId}),room:_extends({},state.room,{active:null,error:null,isFetching:false})});case _configTemplateView.SELECT_ROOM:return _extends({},state,{productSlot:_extends({},state.productSlot,{active:null,dialog:defaultDialogState,error:null,isFetching:false,roomId:null}),room:_extends({},state.room,{active:action.room||{}})});case _form.SET_DIRTY:return _extends({},state,{configTemplate:_extends({},state.configTemplate,{isDirty:action.form==='configTemplate'?action.dirty:state.configTemplate.isDirty}),productSlot:_extends({},state.productSlot,{isDirty:action.form==='configTemplateProductSlot'?action.dirty:state.productSlot.isDirty}),room:_extends({},state.room,{isDirty:action.form==='configTemplateRoom'?action.dirty:state.room.isDirty})});case _configTemplateView.UPDATE_VARIANTS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:updateVariants(state.productSlot.dialog,action)})});case _configTemplateView.UPDATE_VARIANTS_FOR_TYPE:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:updateVariantsForType(state.productSlot.dialog,action)})});case _configTemplateView.ROOMS_UPDATE_REQUEST:return _extends({},state,{room:_extends({},state.room,{error:null,isFetching:true})});case _configTemplateView.ROOMS_UPDATE_FAILURE:return _extends({},state,{room:_extends({},state.room,{error:action.error,isFetching:false})});case _configTemplateView.ROOMS_UPDATE_SUCCESS:return _extends({},state,{room:_extends({},state.room,{active:!!state.room.active?(0,_find3.default)({id:state.room.active.id},action.rooms):state.room.active,isDirty:false,isFetching:false,error:null}),rooms:sortRoomList(action.rooms)});case _configTemplateView.PRODUCT_SLOTS_UPDATE_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{error:null,isFetching:true})});case _configTemplateView.PRODUCT_SLOTS_UPDATE_FAILURE:return _extends({},state,{productSlot:_extends({},state.productSlot,{error:action.error,isFetching:false})});case _configTemplateView.PRODUCT_SLOTS_UPDATE_SUCCESS:{var _productSlot3=_extends({},(0,_find3.default)({id:action.productSlotId},action.productSlots))||state.productSlot.active;var _currentRoom2=_extends({},(0,_find3.default)({id:action.roomId},state.rooms),{productSlots:action.productSlots});return _extends({},state,{productSlot:_extends({},state.productSlot,{active:_productSlot3,dialog:prepareDialog(state.productSlot.dialog,_extends({},action,{productSlot:_productSlot3})),error:null,isDirty:false,isFetching:false}),rooms:sortRoomList([].concat(_toConsumableArray((0,_reject3.default)({id:action.roomId},state.rooms)),[_currentRoom2]))});}case _configTemplateView.CLEAR:return defaultState;default:return state;}};exports.default=configTemplateView;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(126);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(418);
var enumBugKeys = __webpack_require__(247);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDropzone=__webpack_require__(257);var _reactDropzone2=_interopRequireDefault(_reactDropzone);var _FilePreview=__webpack_require__(1051);var _FilePreview2=_interopRequireDefault(_FilePreview);var _FileUpload=__webpack_require__(458);var _FileUpload2=_interopRequireDefault(_FileUpload);__webpack_require__(1054);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fileUrl=_request.apiBase+'/files';/*:: export type Props = {
  onUpload: Function,
  onRemove: Function,
  onUploadAbort: Function,
  label: string,
  onChange?: Function,
  file?: any,
  upload?: any,
  preview?: boolean,
  accept?: string,
  editable?: boolean,
  onEdit?: Function,
};*/var _ref=_react2.default.createElement('i',{className:'fa fa-pencil'});var _ref2=_react2.default.createElement('i',{className:'fa fa-trash'});var _ref3=_react2.default.createElement('i',{className:'fa fa-upload'});var FileDropzone=function(_Component){_inherits(FileDropzone,_Component);function FileDropzone(){_classCallCheck(this,FileDropzone);return _possibleConstructorReturn(this,(FileDropzone.__proto__||Object.getPrototypeOf(FileDropzone)).apply(this,arguments));}_createClass(FileDropzone,[{key:'openDropzone',value:function openDropzone(){if(this._dropzone){this._dropzone.open();}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,label=_props.label,file=_props.file,preview=_props.preview,accept=_props.accept,upload=_props.upload,onUpload=_props.onUpload,onRemove=_props.onRemove,onChange=_props.onChange,onUploadAbort=_props.onUploadAbort,_props$editable=_props.editable,editable=_props$editable===undefined?false:_props$editable,onEdit=_props.onEdit;return _react2.default.createElement('div',{className:'FileDropzone'},_react2.default.createElement('label',null,label),_react2.default.createElement(_reactDropzone2.default,{accept:accept,onDrop:function onDrop(files){onUpload(files);if(onChange){onChange();}},disableClick:true,multiple:false,ref:function ref(_ref4){return _this2._dropzone=_ref4;},className:'zone'},preview&&_react2.default.createElement(_FilePreview2.default,{file:file,onClickEmpty:function onClickEmpty(){return _this2.openDropzone();}}),upload&&upload.progress<100?_react2.default.createElement(_FileUpload2.default,{upload:upload,onUploadAbort:function(_onUploadAbort){function onUploadAbort(){return _onUploadAbort.apply(this,arguments);}onUploadAbort.toString=function(){return _onUploadAbort.toString();};return onUploadAbort;}(function(){return onUploadAbort(upload);})}):_react2.default.createElement('div',{className:'row no-row-margins expand'},!file&&_react2.default.createElement('div',{onClick:function onClick(){return _this2.openDropzone();},className:'column no-file'},'Ingen fil'),file&&_react2.default.createElement('div',{className:'row no-row-margins expand'},_react2.default.createElement('a',{href:fileUrl+'/'+file.id+'?download',target:'_blank',className:'file column text-truncate'},file.name+file.extension),!!editable&&!!onEdit&&_react2.default.createElement('button',{onClick:onEdit,type:'button',className:'button column shrink'},_ref),_react2.default.createElement('button',{onClick:function onClick(){if(onChange){onChange();}onRemove();},type:'button',className:'button column shrink'},_ref2)),_react2.default.createElement('button',{onClick:function onClick(){return _this2.openDropzone();},type:'button',className:'button column shrink'},_ref3))));}}]);return FileDropzone;}(_react.Component);exports.default=FileDropzone;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tableDefaults = exports.tableHeaderRowDefaults = exports.tableHeaderRowTypes = exports.tableHeaderContextTypes = exports.tableHeaderTypes = exports.tableBodyRowDefaults = exports.tableBodyRowTypes = exports.tableBodyContextTypes = exports.tableBodyDefaults = exports.tableBodyTypes = exports.tableContextTypes = exports.tableTypes = undefined;

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var arrayOfObjectColumns = _propTypes2.default.arrayOf(_propTypes2.default.shape({
  header: _propTypes2.default.shape({
    label: _propTypes2.default.string,
    transforms: _propTypes2.default.arrayOf(_propTypes2.default.func),
    formatters: _propTypes2.default.arrayOf(_propTypes2.default.func),
    props: _propTypes2.default.object
  }),
  cell: _propTypes2.default.shape({
    property: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    transforms: _propTypes2.default.arrayOf(_propTypes2.default.func),
    formatters: _propTypes2.default.arrayOf(_propTypes2.default.func),
    props: _propTypes2.default.object
  })
}));
var arrayOfArrayColumns = _propTypes2.default.arrayOf(_propTypes2.default.array);
var rowsType = _propTypes2.default.oneOfType([arrayOfObjectColumns, arrayOfArrayColumns]);
var rowKeyType = _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]);
var rowDataType = _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]);
var tableTypes = {
  columns: _propTypes2.default.array.isRequired,
  components: _propTypes2.default.object
};
var tableContextTypes = {
  columns: _propTypes2.default.array.isRequired,
  components: _propTypes2.default.object
};
var tableBodyDefaults = {
  onRow: function onRow() {}
};
var tableBodyTypes = {
  onRow: _propTypes2.default.func,
  rows: rowsType.isRequired,
  rowKey: rowKeyType
};
var tableBodyContextTypes = {
  columns: _propTypes2.default.array.isRequired,
  components: _propTypes2.default.object
};
var tableBodyRowDefaults = {
  onRow: function onRow() {
    return {};
  }
};
var tableBodyRowTypes = {
  columns: _propTypes2.default.array.isRequired,
  components: _propTypes2.default.object,
  onRow: _propTypes2.default.func,
  rowIndex: _propTypes2.default.number.isRequired,
  rowData: rowDataType.isRequired,
  rowKey: _propTypes2.default.string.isRequired
};
var tableHeaderTypes = {
  headerRows: _propTypes2.default.arrayOf(arrayOfObjectColumns),
  children: _propTypes2.default.any
};
var tableHeaderContextTypes = {
  columns: _propTypes2.default.array.isRequired,
  components: _propTypes2.default.object
};
var tableHeaderRowDefaults = {
  onRow: function onRow() {
    return {};
  }
};
var tableHeaderRowTypes = {
  components: _propTypes2.default.object,
  onRow: _propTypes2.default.func,
  rowIndex: _propTypes2.default.number.isRequired,
  rowData: rowDataType.isRequired
};
var tableDefaults = {
  components: {
    table: 'table',
    header: {
      wrapper: 'thead',
      row: 'tr',
      cell: 'th'
    },
    body: {
      wrapper: 'tbody',
      row: 'tr',
      cell: 'td'
    }
  }
};

exports.tableTypes = tableTypes;
exports.tableContextTypes = tableContextTypes;
exports.tableBodyTypes = tableBodyTypes;
exports.tableBodyDefaults = tableBodyDefaults;
exports.tableBodyContextTypes = tableBodyContextTypes;
exports.tableBodyRowTypes = tableBodyRowTypes;
exports.tableBodyRowDefaults = tableBodyRowDefaults;
exports.tableHeaderTypes = tableHeaderTypes;
exports.tableHeaderContextTypes = tableHeaderContextTypes;
exports.tableHeaderRowTypes = tableHeaderRowTypes;
exports.tableHeaderRowDefaults = tableHeaderRowDefaults;
exports.tableDefaults = tableDefaults;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _strategies = __webpack_require__(474);

var _strategies2 = _interopRequireDefault(_strategies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _strategies2.default.byIndex;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _numbro=__webpack_require__(1191);var _numbro2=_interopRequireDefault(_numbro);var _svSE=__webpack_require__(485);var _svSE2=_interopRequireDefault(_svSE);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var formatter=_numbro2.default.culture('sv-SE',_svSE2.default).culture('sv-SE');/*:: export type Props = {
  value: number | string,
  unit?: number | string,
  className?: string,
};*/var FormattedPrice=function FormattedPrice(_ref){var value=_ref.value,unit=_ref.unit,className=_ref.className;return _react2.default.createElement('span',{className:className},formatter(value).formatCurrency('0,0.[00] $'),!!unit?' / '+unit:'');};exports.default=FormattedPrice;

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(73);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(50);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(107);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["default"])(a.state, b.state);
};

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(305);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(73);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(74);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(607);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(109);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(609);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(199);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(312);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(322),
    createBind = __webpack_require__(763),
    createCurry = __webpack_require__(764),
    createHybrid = __webpack_require__(327),
    createPartial = __webpack_require__(777),
    getData = __webpack_require__(208),
    mergeData = __webpack_require__(778),
    setData = __webpack_require__(333),
    setWrapToString = __webpack_require__(335),
    toInteger = __webpack_require__(58);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(146),
    isObject = __webpack_require__(45);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(45);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 148 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(112);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 150 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(45),
    isSymbol = __webpack_require__(76);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(783),
    baseUnary = __webpack_require__(63),
    nodeUtil = __webpack_require__(153);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(325);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105)(module)))

/***/ }),
/* 154 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(156),
    arrayEach = __webpack_require__(148),
    assignValue = __webpack_require__(213),
    baseAssign = __webpack_require__(338),
    baseAssignIn = __webpack_require__(808),
    cloneBuffer = __webpack_require__(341),
    copyArray = __webpack_require__(111),
    copySymbols = __webpack_require__(811),
    copySymbolsIn = __webpack_require__(812),
    getAllKeys = __webpack_require__(344),
    getAllKeysIn = __webpack_require__(222),
    getTag = __webpack_require__(77),
    initCloneArray = __webpack_require__(815),
    initCloneByTag = __webpack_require__(816),
    initCloneObject = __webpack_require__(349),
    isArray = __webpack_require__(18),
    isBuffer = __webpack_require__(116),
    isMap = __webpack_require__(820),
    isObject = __webpack_require__(45),
    isSet = __webpack_require__(822),
    keys = __webpack_require__(59);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(157),
    stackClear = __webpack_require__(791),
    stackDelete = __webpack_require__(792),
    stackGet = __webpack_require__(793),
    stackHas = __webpack_require__(794),
    stackSet = __webpack_require__(795);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(786),
    listCacheDelete = __webpack_require__(787),
    listCacheGet = __webpack_require__(788),
    listCacheHas = __webpack_require__(789),
    listCacheSet = __webpack_require__(790);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(114);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(804);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(339),
    baseKeysIn = __webpack_require__(809),
    isArrayLike = __webpack_require__(60);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(830),
    isObjectLike = __webpack_require__(33);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(217),
    setCacheAdd = __webpack_require__(831),
    setCacheHas = __webpack_require__(832);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 164 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(78),
    toKey = __webpack_require__(64);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('isNil', __webpack_require__(884), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('keyBy', __webpack_require__(893));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('groupBy', __webpack_require__(896));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.filterArchived=exports.fetchProductTypes=exports.fetchWorkerTypes=exports.fetchRoomTypes=exports.fetchSuppliers=exports.setActiveVariantImage=exports.setDefaultVariantImage=exports.removeVariantImage=exports.variantImage=exports.clear=exports.reset=exports.removeVariantLinkedAdditionalVariant=exports.updateVariantLinkedAdditionalVariant=exports.addVariantLinkedAdditionalVariant=exports.setActiveVariantLinkedAdditionalVariant=exports.removeProductLinkedAdditionalVariant=exports.updateProductLinkedAdditionalVariant=exports.addProductLinkedAdditionalVariant=exports.setActiveProductLinkedAdditionalVariant=exports.toggleReplacementDialog=exports.setActiveVariant=exports.fetchAdditionalVariants=exports.fetchAdditionalProducts=undefined;exports.fetchReplacementVariants=exports.fetchReplacementProducts=exports.updateProductVariants=exports.updateProductVariant=exports.createProduct=exports.updateProduct=exports.fetchProduct=exports.setSharedRelatedProductType=exports.addSharedRelatedProductType=exports.sharedRelatedProductTypeToggle=exports.sharedRelatedProductToggle=exports.sharedRelatedVariantSelected=exports.sharedRelatedProductTypeSelected=exports.relatedProductTypeSelected=exports.sharedRelatedProductSelected=exports.setRelatedProductType=exports.addRelatedProductType=exports.relatedProductTypeToggle=exports.relatedProductToggle=exports.relatedVariantSelected=exports.relatedProductSelected=exports.sharedRemoveProductType=exports.removeProductType=exports.unlockShared=exports.UNLOCK_SHARED=exports.SHARED_REMOVE_PRODUCT_TYPE=exports.REMOVE_PRODUCT_TYPE=exports.SHARED_RELATED_PRODUCT_TYPE_SELECTED=exports.RELATED_PRODUCT_TYPE_SELECTED=exports.VARIANTS_UPDATE_FAILURE=exports.VARIANTS_UPDATE_SUCCESS=exports.VARIANTS_UPDATE_REQUEST=exports.ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS=exports.SHARED_RELATED_PRODUCT_TYPE_TOGGLE=exports.SHARED_RELATED_PRODUCT_TOGGLE=exports.SHARED_RELATED_VARIANT_SELECTED=exports.SHARED_RELATED_PRODUCT_SELECTED=exports.SET_SHARED_RELATED_PRODUCT_TYPE=exports.ADD_RELATED_PRODUCT_TYPE_FAILURE=exports.ADD_RELATED_PRODUCT_TYPE_SUCCESS=exports.ADD_RELATED_PRODUCT_TYPE_REQUEST=exports.RELATED_PRODUCT_TYPE_TOGGLE=exports.RELATED_PRODUCT_TOGGLE=exports.RELATED_VARIANT_SELECTED=exports.RELATED_PRODUCT_SELECTED=exports.SET_RELATED_PRODUCT_TYPE=exports.FILTER_ARCHIVED=exports.PRODUCT_TYPES_FAILURE=exports.PRODUCT_TYPES_SUCCESS=exports.PRODUCT_TYPES_REQUEST=exports.WORKER_TYPES_FAILURE=exports.WORKER_TYPES_SUCCESS=exports.WORKER_TYPES_REQUEST=exports.ROOM_TYPES_FAILURE=exports.ROOM_TYPES_SUCCESS=exports.ROOM_TYPES_REQUEST=exports.SUPPLIERS_FAILURE=exports.SUPPLIERS_SUCCESS=exports.SUPPLIERS_REQUEST=exports.SET_ACTIVE_VARIANT_IMAGE=exports.SET_DEFAULT_VARIANT_IMAGE=exports.VARIANT_IMAGE_UPLOADED=exports.VARIANT_IMAGE=exports.REMOVE_VARIANT_IMAGE=exports.ADDITIONAL_VARIANTS_FAILURE=exports.ADDITIONAL_VARIANTS_SUCCESS=exports.ADDITIONAL_VARIANTS_REQUEST=exports.ADDITIONAL_PRODUCTS_FAILURE=exports.ADDITIONAL_PRODUCTS_SUCCESS=exports.ADDITIONAL_PRODUCTS_REQUEST=exports.UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT=exports.ADD_VARIANT_LINKED_ADDITIONAL_VARIANT=exports.REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT=exports.SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT=exports.UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT=exports.ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT=exports.REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT=exports.SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT=exports.REPLACEMENT_VARIANTS_FAILURE=exports.REPLACEMENT_VARIANTS_SUCCESS=exports.REPLACEMENT_VARIANTS_REQUEST=exports.REPLACEMENT_PRODUCTS_FAILURE=exports.REPLACEMENT_PRODUCTS_SUCCESS=exports.REPLACEMENT_PRODUCTS_REQUEST=exports.TOGGLE_REPLACEMENT_DIALOG=exports.CLEAR=exports.RESET=exports.SET_ACTIVE_VARIANT=exports.VARIANT_UPDATE_FAILURE=exports.VARIANT_UPDATE_SUCCESS=exports.VARIANT_UPDATE_REQUEST=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.FAILURE=exports.SUCCESS=exports.REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _request=__webpack_require__(6);var _notification=__webpack_require__(23);var _fileUploader=__webpack_require__(81);var _assortments=__webpack_require__(55);var _uuid=__webpack_require__(53);var _uuid2=_interopRequireDefault(_uuid);var _apartmentConfigView=__webpack_require__(82);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var REQUEST=exports.REQUEST='@productView/REQUEST';var SUCCESS=exports.SUCCESS='@productView/SUCCESS';var FAILURE=exports.FAILURE='@productView/FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@productView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@productView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@productView/UPDATE_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@productView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@productView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@productView/CREATE_FAILURE';var VARIANT_UPDATE_REQUEST=exports.VARIANT_UPDATE_REQUEST='@productView/VARIANT_UPDATE_REQUEST';var VARIANT_UPDATE_SUCCESS=exports.VARIANT_UPDATE_SUCCESS='@productView/VARIANT_UPDATE_SUCCESS';var VARIANT_UPDATE_FAILURE=exports.VARIANT_UPDATE_FAILURE='@productView/VARIANT_UPDATE_FAILURE';var SET_ACTIVE_VARIANT=exports.SET_ACTIVE_VARIANT='@productView/SET_ACTIVE_VARIANT';var RESET=exports.RESET='@productView/RESET';var CLEAR=exports.CLEAR='@productView/CLEAR';var TOGGLE_REPLACEMENT_DIALOG=exports.TOGGLE_REPLACEMENT_DIALOG='@productView/TOGGLE_REPLACEMENT_DIALOG';var REPLACEMENT_PRODUCTS_REQUEST=exports.REPLACEMENT_PRODUCTS_REQUEST='@productView/REPLACEMENT_PRODUCTS_REQUEST';var REPLACEMENT_PRODUCTS_SUCCESS=exports.REPLACEMENT_PRODUCTS_SUCCESS='@productView/REPLACEMENT_PRODUCTS_SUCCESS';var REPLACEMENT_PRODUCTS_FAILURE=exports.REPLACEMENT_PRODUCTS_FAILURE='@productView/REPLACEMENT_PRODUCTS_FAILURE';var REPLACEMENT_VARIANTS_REQUEST=exports.REPLACEMENT_VARIANTS_REQUEST='@productView/REPLACEMENT_VARIANTS_REQUEST';var REPLACEMENT_VARIANTS_SUCCESS=exports.REPLACEMENT_VARIANTS_SUCCESS='@productView/REPLACEMENT_VARIANTS_SUCCESS';var REPLACEMENT_VARIANTS_FAILURE=exports.REPLACEMENT_VARIANTS_FAILURE='@productView/REPLACEMENT_VARIANTS_FAILURE';var SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT=exports.SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT='@productView/SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT';var REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT=exports.REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT='@productView/REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT';var ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT=exports.ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT='@productView/ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT';var UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT=exports.UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT='@productView/UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT';var SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT=exports.SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT='@productView/SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT';var REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT=exports.REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT='@productView/REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT';var ADD_VARIANT_LINKED_ADDITIONAL_VARIANT=exports.ADD_VARIANT_LINKED_ADDITIONAL_VARIANT='@productView/ADD_VARIANT_LINKED_ADDITIONAL_VARIANT';var UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT=exports.UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT='@productView/UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT';var ADDITIONAL_PRODUCTS_REQUEST=exports.ADDITIONAL_PRODUCTS_REQUEST='@productView/ADDITIONAL_PRODUCTS_REQUEST';var ADDITIONAL_PRODUCTS_SUCCESS=exports.ADDITIONAL_PRODUCTS_SUCCESS='@productView/ADDITIONAL_PRODUCTS_SUCCESS';var ADDITIONAL_PRODUCTS_FAILURE=exports.ADDITIONAL_PRODUCTS_FAILURE='@productView/ADDITIONAL_PRODUCTS_FAILURE';var ADDITIONAL_VARIANTS_REQUEST=exports.ADDITIONAL_VARIANTS_REQUEST='@productView/ADDITIONAL_VARIANTS_REQUEST';var ADDITIONAL_VARIANTS_SUCCESS=exports.ADDITIONAL_VARIANTS_SUCCESS='@productView/ADDITIONAL_VARIANTS_SUCCESS';var ADDITIONAL_VARIANTS_FAILURE=exports.ADDITIONAL_VARIANTS_FAILURE='@productView/ADDITIONAL_VARIANTS_FAILURE';var REMOVE_VARIANT_IMAGE=exports.REMOVE_VARIANT_IMAGE='@productView/REMOVE_VARIANT_IMAGE';var VARIANT_IMAGE=exports.VARIANT_IMAGE='@productView/VARIANT_IMAGE';var VARIANT_IMAGE_UPLOADED=exports.VARIANT_IMAGE_UPLOADED='@productView/VARIANT_IMAGE_UPLOADED';var SET_DEFAULT_VARIANT_IMAGE=exports.SET_DEFAULT_VARIANT_IMAGE='@productView/SET_DEFAULT_VARIANT_IMAGE';var SET_ACTIVE_VARIANT_IMAGE=exports.SET_ACTIVE_VARIANT_IMAGE='@productView/SET_ACTIVE_VARIANT_IMAGE';var SUPPLIERS_REQUEST=exports.SUPPLIERS_REQUEST='@productView/SUPPLIERS_REQUEST';var SUPPLIERS_SUCCESS=exports.SUPPLIERS_SUCCESS='@productView/SUPPLIERS_SUCCESS';var SUPPLIERS_FAILURE=exports.SUPPLIERS_FAILURE='@productView/SUPPLIERS_FAILURE';var ROOM_TYPES_REQUEST=exports.ROOM_TYPES_REQUEST='@productView/ROOM_TYPES_REQUEST';var ROOM_TYPES_SUCCESS=exports.ROOM_TYPES_SUCCESS='@productView/ROOM_TYPES_SUCCESS';var ROOM_TYPES_FAILURE=exports.ROOM_TYPES_FAILURE='@productView/ROOM_TYPES_FAILURE';var WORKER_TYPES_REQUEST=exports.WORKER_TYPES_REQUEST='@productView/WORKER_TYPES_REQUEST';var WORKER_TYPES_SUCCESS=exports.WORKER_TYPES_SUCCESS='@productView/WORKER_TYPES_SUCCESS';var WORKER_TYPES_FAILURE=exports.WORKER_TYPES_FAILURE='@productView/WORKER_TYPES_FAILURE';var PRODUCT_TYPES_REQUEST=exports.PRODUCT_TYPES_REQUEST='@productView/PRODUCT_TYPES_REQUEST';var PRODUCT_TYPES_SUCCESS=exports.PRODUCT_TYPES_SUCCESS='@productView/PRODUCT_TYPES_SUCCESS';var PRODUCT_TYPES_FAILURE=exports.PRODUCT_TYPES_FAILURE='@productView/PRODUCT_TYPES_FAILURE';var FILTER_ARCHIVED=exports.FILTER_ARCHIVED='@productView/FILTER_ARCHIVED';var SET_RELATED_PRODUCT_TYPE=exports.SET_RELATED_PRODUCT_TYPE='@productView/SET_RELATED_PRODUCT_TYPE';var RELATED_PRODUCT_SELECTED=exports.RELATED_PRODUCT_SELECTED='@productView/RELATED_PRODUCT_SELECTED';var RELATED_VARIANT_SELECTED=exports.RELATED_VARIANT_SELECTED='@productView/RELATED_VARIANT_SELECTED';var RELATED_PRODUCT_TOGGLE=exports.RELATED_PRODUCT_TOGGLE='@productView/RELATED_PRODUCT_TOGGLE';var RELATED_PRODUCT_TYPE_TOGGLE=exports.RELATED_PRODUCT_TYPE_TOGGLE='@productView/RELATED_PRODUCT_TYPE_TOGGLE';var ADD_RELATED_PRODUCT_TYPE_REQUEST=exports.ADD_RELATED_PRODUCT_TYPE_REQUEST='@productView/ADD_RELATED_PRODUCT_TYPE_REQUEST';var ADD_RELATED_PRODUCT_TYPE_SUCCESS=exports.ADD_RELATED_PRODUCT_TYPE_SUCCESS='@productView/ADD_RELATED_PRODUCT_TYPE_SUCCESS';var ADD_RELATED_PRODUCT_TYPE_FAILURE=exports.ADD_RELATED_PRODUCT_TYPE_FAILURE='@productView/ADD_RELATED_PRODUCT_TYPE_FAILURE';var SET_SHARED_RELATED_PRODUCT_TYPE=exports.SET_SHARED_RELATED_PRODUCT_TYPE='@productView/SET_SHARED_RELATED_PRODUCT_TYPE';var SHARED_RELATED_PRODUCT_SELECTED=exports.SHARED_RELATED_PRODUCT_SELECTED='@productView/SHARED_RELATED_PRODUCT_SELECTED';var SHARED_RELATED_VARIANT_SELECTED=exports.SHARED_RELATED_VARIANT_SELECTED='@productView/SHARED_RELATED_VARIANT_SELECTED';var SHARED_RELATED_PRODUCT_TOGGLE=exports.SHARED_RELATED_PRODUCT_TOGGLE='@productView/SHARED_RELATED_PRODUCT_TOGGLE';var SHARED_RELATED_PRODUCT_TYPE_TOGGLE=exports.SHARED_RELATED_PRODUCT_TYPE_TOGGLE='@productView/SHARED_RELATED_PRODUCT_TYPE_TOGGLE';var ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS=exports.ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS='@productView/ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS';var VARIANTS_UPDATE_REQUEST=exports.VARIANTS_UPDATE_REQUEST='@productView/VARIANTS_UPDATE_REQUEST';var VARIANTS_UPDATE_SUCCESS=exports.VARIANTS_UPDATE_SUCCESS='@productView/VARIANTS_UPDATE_SUCCESS';var VARIANTS_UPDATE_FAILURE=exports.VARIANTS_UPDATE_FAILURE='@productView/VARIANTS_UPDATE_FAILURE';var RELATED_PRODUCT_TYPE_SELECTED=exports.RELATED_PRODUCT_TYPE_SELECTED='@productView/RELATED_PRODUCT_TYPE_SELECTED';var SHARED_RELATED_PRODUCT_TYPE_SELECTED=exports.SHARED_RELATED_PRODUCT_TYPE_SELECTED='@productView/SHARED_RELATED_PRODUCT_TYPE_SELECTED';var REMOVE_PRODUCT_TYPE=exports.REMOVE_PRODUCT_TYPE='@productView/REMOVE_PRODUCT_TYPE';var SHARED_REMOVE_PRODUCT_TYPE=exports.SHARED_REMOVE_PRODUCT_TYPE='@productView/SHARED_REMOVE_PRODUCT_TYPE';var UNLOCK_SHARED=exports.UNLOCK_SHARED='@productView/UNLOCK_SHARED';var unlockShared=exports.unlockShared=function unlockShared(){return{type:UNLOCK_SHARED};};var removeProductType=exports.removeProductType=function removeProductType(variantId,id){return{type:REMOVE_PRODUCT_TYPE,id:id,variantId:variantId};};var sharedRemoveProductType=exports.sharedRemoveProductType=function sharedRemoveProductType(id){return{type:SHARED_REMOVE_PRODUCT_TYPE,id:id};};var relatedProductSelected=exports.relatedProductSelected=function relatedProductSelected(variantId,id,selected){return{type:RELATED_PRODUCT_SELECTED,id:id,selected:selected,variantId:variantId};};var relatedVariantSelected=exports.relatedVariantSelected=function relatedVariantSelected(variantId,id,selected){return{type:RELATED_VARIANT_SELECTED,id:id,selected:selected,variantId:variantId};};var relatedProductToggle=exports.relatedProductToggle=function relatedProductToggle(variantId,id){return{type:RELATED_PRODUCT_TOGGLE,id:id,variantId:variantId};};var relatedProductTypeToggle=exports.relatedProductTypeToggle=function relatedProductTypeToggle(variantId,id){return{type:RELATED_PRODUCT_TYPE_TOGGLE,id:id,variantId:variantId};};var addRelatedProductTypeRequest=function addRelatedProductTypeRequest(){return{type:ADD_RELATED_PRODUCT_TYPE_REQUEST};};var addRelatedProductTypeSuccess=function addRelatedProductTypeSuccess(variantId,productType,products){return{type:ADD_RELATED_PRODUCT_TYPE_SUCCESS,productType:productType,products:products,variantId:variantId};};var addRelatedProductTypeFailure=function addRelatedProductTypeFailure(error){return{type:ADD_RELATED_PRODUCT_TYPE_FAILURE,error:error};};var addRelatedProductType=exports.addRelatedProductType=function addRelatedProductType(variantId,productType){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var products;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(addRelatedProductTypeRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/products?productTypeId='+productType.id+'&assortment='+_assortments.STANDARD},dispatch);case 4:products=_context.sent;dispatch(addRelatedProductTypeSuccess(variantId,productType,products));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(addRelatedProductTypeFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var setRelatedProductType=exports.setRelatedProductType=function setRelatedProductType(relatedProductType){return{type:SET_RELATED_PRODUCT_TYPE,relatedProductType:relatedProductType};};var sharedRelatedProductSelectedSuccess=function sharedRelatedProductSelectedSuccess(id,productType,products,selected){return{type:SHARED_RELATED_PRODUCT_SELECTED,id:id,productType:productType,products:products,selected:selected};};var sharedRelatedProductSelected=exports.sharedRelatedProductSelected=function sharedRelatedProductSelected(id,productType,selected){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var products;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(addRelatedProductTypeRequest());_context2.prev=1;_context2.next=4;return(0,_request.GET)({endpoint:'/products?productTypeId='+productType.id+'&assortment='+_assortments.STANDARD},dispatch);case 4:products=_context2.sent;dispatch(sharedRelatedProductSelectedSuccess(id,productType,products,selected));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(addRelatedProductTypeFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var relatedProductTypeSelected=exports.relatedProductTypeSelected=function relatedProductTypeSelected(variantId,id,selected){return{type:RELATED_PRODUCT_TYPE_SELECTED,id:id,selected:selected,variantId:variantId};};var sharedRelatedProductTypeSelectedSuccess=function sharedRelatedProductTypeSelectedSuccess(productType,products,selected){return{type:SHARED_RELATED_PRODUCT_TYPE_SELECTED,productType:productType,products:products,selected:selected};};var sharedRelatedProductTypeSelected=exports.sharedRelatedProductTypeSelected=function sharedRelatedProductTypeSelected(productType,selected){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var products;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(addRelatedProductTypeRequest());_context3.prev=1;_context3.next=4;return(0,_request.GET)({endpoint:'/products?productTypeId='+productType.id+'&assortment='+_assortments.STANDARD},dispatch);case 4:products=_context3.sent;dispatch(sharedRelatedProductTypeSelectedSuccess(productType,products,selected));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);dispatch(addRelatedProductTypeFailure(_context3.t0));case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var sharedRelatedVariantSelectedSuccess=function sharedRelatedVariantSelectedSuccess(id,productType,products,selected){return{type:SHARED_RELATED_VARIANT_SELECTED,id:id,productType:productType,products:products,selected:selected};};var sharedRelatedVariantSelected=exports.sharedRelatedVariantSelected=function sharedRelatedVariantSelected(id,productType,selected){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch){var products;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(addRelatedProductTypeRequest());_context4.prev=1;_context4.next=4;return(0,_request.GET)({endpoint:'/products?productTypeId='+productType.id+'&assortment='+_assortments.STANDARD},dispatch);case 4:products=_context4.sent;dispatch(sharedRelatedVariantSelectedSuccess(id,productType,products,selected));_context4.next=11;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](1);dispatch(addRelatedProductTypeFailure(_context4.t0));case 11:case'end':return _context4.stop();}}},_callee4,undefined,[[1,8]]);}));return function(_x4){return _ref4.apply(this,arguments);};}();};var sharedRelatedProductToggle=exports.sharedRelatedProductToggle=function sharedRelatedProductToggle(id){return{type:SHARED_RELATED_PRODUCT_TOGGLE,id:id};};var sharedRelatedProductTypeToggle=exports.sharedRelatedProductTypeToggle=function sharedRelatedProductTypeToggle(id){return{type:SHARED_RELATED_PRODUCT_TYPE_TOGGLE,id:id};};var addSharedRelatedProductTypeSuccess=function addSharedRelatedProductTypeSuccess(productType,products){return{type:ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS,productType:productType,products:products};};var addSharedRelatedProductType=exports.addSharedRelatedProductType=function addSharedRelatedProductType(productType){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch){var products;return _regenerator2.default.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(addRelatedProductTypeRequest());_context5.prev=1;_context5.next=4;return(0,_request.GET)({endpoint:'/products?productTypeId='+productType.id+'&assortment='+_assortments.STANDARD},dispatch);case 4:products=_context5.sent;dispatch(addSharedRelatedProductTypeSuccess(productType,products));_context5.next=11;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](1);dispatch(addRelatedProductTypeFailure(_context5.t0));case 11:case'end':return _context5.stop();}}},_callee5,undefined,[[1,8]]);}));return function(_x5){return _ref5.apply(this,arguments);};}();};var setSharedRelatedProductType=exports.setSharedRelatedProductType=function setSharedRelatedProductType(relatedProductType){return{type:SET_SHARED_RELATED_PRODUCT_TYPE,relatedProductType:relatedProductType};};var productRequest=function productRequest(){return{type:REQUEST};};var productSuccess=function productSuccess(product,variants,variantId){return{type:SUCCESS,product:product,variants:variants,variantId:variantId};};var productFailure=function productFailure(error){return{type:FAILURE,error:error};};var productUpdateRequest=function productUpdateRequest(){return{type:UPDATE_REQUEST};};var productUpdateSuccess=function productUpdateSuccess(product){return _defineProperty({type:UPDATE_SUCCESS,product:product},_notification.ADD,{message:'Produkt uppdaterad'});};var productUpdateFailure=function productUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var productCreateRequest=function productCreateRequest(){return{type:CREATE_REQUEST};};var productCreateSuccess=function productCreateSuccess(product,variants){return _defineProperty({type:CREATE_SUCCESS,product:product,variants:variants},_notification.ADD,{message:'Produkt "'+product.name+'" skapad'});};var productCreateFailure=function productCreateFailure(error){return{type:CREATE_FAILURE,error:error};};var productVariantUpdateRequest=function productVariantUpdateRequest(){return{type:VARIANT_UPDATE_REQUEST};};var productVariantUpdateSuccess=function productVariantUpdateSuccess(variant){return _defineProperty({type:VARIANT_UPDATE_SUCCESS,variant:variant},_notification.ADD,{message:'Variant uppdaterad'});};var productVariantUpdateFailure=function productVariantUpdateFailure(error){return{type:VARIANT_UPDATE_FAILURE,error:error};};var productVariantsUpdateRequest=function productVariantsUpdateRequest(){return{type:VARIANTS_UPDATE_REQUEST};};var productVariantsUpdateSuccess=function productVariantsUpdateSuccess(variants){return _defineProperty({type:VARIANTS_UPDATE_SUCCESS,variants:variants},_notification.ADD,{message:'Variant uppdaterad'});};var productVariantsUpdateFailure=function productVariantsUpdateFailure(error){return{type:VARIANTS_UPDATE_FAILURE,error:error};};var replacementProductsRequest=function replacementProductsRequest(){return{type:REPLACEMENT_PRODUCTS_REQUEST};};var replacementProductsSuccess=function replacementProductsSuccess(products){return{type:REPLACEMENT_PRODUCTS_SUCCESS,products:products};};var replacementProductsFailure=function replacementProductsFailure(error){return{type:REPLACEMENT_PRODUCTS_FAILURE,error:error};};var replacementVariantsRequest=function replacementVariantsRequest(){return{type:REPLACEMENT_VARIANTS_REQUEST};};var replacementVariantsSuccess=function replacementVariantsSuccess(variants){return{type:REPLACEMENT_VARIANTS_SUCCESS,variants:variants};};var replacementVariantsFailure=function replacementVariantsFailure(error){return{type:REPLACEMENT_VARIANTS_FAILURE,error:error};};var additionalProductsRequest=function additionalProductsRequest(){return{type:ADDITIONAL_PRODUCTS_REQUEST};};var additionalProductsSuccess=function additionalProductsSuccess(products){return{type:ADDITIONAL_PRODUCTS_SUCCESS,products:products};};var additionalProductsFailure=function additionalProductsFailure(error){return{type:ADDITIONAL_PRODUCTS_FAILURE,error:error};};var additionalVariantsRequest=function additionalVariantsRequest(){return{type:ADDITIONAL_VARIANTS_REQUEST};};var additionalVariantsSuccess=function additionalVariantsSuccess(variants){return{type:ADDITIONAL_VARIANTS_SUCCESS,variants:variants};};var additionalVariantsFailure=function additionalVariantsFailure(error){return{type:ADDITIONAL_VARIANTS_FAILURE,error:error};};var fetchProduct=exports.fetchProduct=function fetchProduct(id,variantId,copy){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch){var product,variants,_product,_variants;return _regenerator2.default.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch(productRequest());_context6.prev=1;if(!copy){_context6.next=12;break;}_context6.next=5;return(0,_request.GET)({endpoint:'/products/'+id+'/copy'},dispatch);case 5:product=_context6.sent;_context6.next=8;return(0,_request.GET)({endpoint:'/products/'+id+'/variants/copy?fullRelated=1'},dispatch);case 8:variants=_context6.sent;dispatch(productSuccess(product,variants,product.mainVariantId));_context6.next=19;break;case 12:_context6.next=14;return(0,_request.GET)({endpoint:'/products/'+id},dispatch);case 14:_product=_context6.sent;_context6.next=17;return(0,_request.GET)({endpoint:'/products/'+id+'/variants?fullRelated=1'},dispatch);case 17:_variants=_context6.sent;dispatch(productSuccess(_product,_variants,variantId?parseInt(variantId,10):null));case 19:_context6.next=24;break;case 21:_context6.prev=21;_context6.t0=_context6['catch'](1);dispatch(productFailure(_context6.t0));case 24:case'end':return _context6.stop();}}},_callee6,undefined,[[1,21]]);}));return function(_x6){return _ref10.apply(this,arguments);};}();};var updateProduct=exports.updateProduct=function updateProduct(id,body){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch){var product;return _regenerator2.default.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch(productUpdateRequest());_context7.prev=1;_context7.next=4;return(0,_request.PUT)({endpoint:'/products/'+id,body:body},dispatch);case 4:product=_context7.sent;dispatch(productUpdateSuccess(product));_context7.next=11;break;case 8:_context7.prev=8;_context7.t0=_context7['catch'](1);dispatch(productUpdateFailure(_context7.t0));case 11:case'end':return _context7.stop();}}},_callee7,undefined,[[1,8]]);}));return function(_x7){return _ref11.apply(this,arguments);};}();};var createProduct=exports.createProduct=function createProduct(body){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch){var product,variants;return _regenerator2.default.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch(productCreateRequest());_context8.prev=1;product=void 0;if(body.copy){_context8.next=9;break;}_context8.next=6;return(0,_request.POST)({endpoint:'/products',body:body},dispatch);case 6:product=_context8.sent;_context8.next=13;break;case 9:delete body.variants;_context8.next=12;return(0,_request.POST)({endpoint:'/products/copy',body:body},dispatch);case 12:product=_context8.sent;case 13:_context8.next=15;return(0,_request.GET)({endpoint:'/products/'+product.id+'/variants?fullRelated=1'},dispatch);case 15:variants=_context8.sent;dispatch(productCreateSuccess(product,variants));_context8.next=22;break;case 19:_context8.prev=19;_context8.t0=_context8['catch'](1);dispatch(productCreateFailure(_context8.t0));case 22:case'end':return _context8.stop();}}},_callee8,undefined,[[1,19]]);}));return function(_x8){return _ref12.apply(this,arguments);};}();};var updateProductVariant=exports.updateProductVariant=function updateProductVariant(id,body){return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch){var variant;return _regenerator2.default.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch(productVariantUpdateRequest());_context9.prev=1;_context9.next=4;return(0,_request.PUT)({endpoint:'/productvariants/'+id,body:body},dispatch);case 4:variant=_context9.sent;dispatch(productVariantUpdateSuccess(variant));_context9.next=11;break;case 8:_context9.prev=8;_context9.t0=_context9['catch'](1);dispatch(productVariantUpdateFailure(_context9.t0));case 11:case'end':return _context9.stop();}}},_callee9,undefined,[[1,8]]);}));return function(_x9){return _ref13.apply(this,arguments);};}();};var updateProductVariants=exports.updateProductVariants=function updateProductVariants(id,body){return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch){var variants;return _regenerator2.default.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:dispatch(productVariantsUpdateRequest());_context10.prev=1;_context10.next=4;return(0,_request.PUT)({endpoint:'/products/'+id+'/variants',body:body},dispatch);case 4:variants=_context10.sent;dispatch(productVariantsUpdateSuccess(variants));_context10.next=11;break;case 8:_context10.prev=8;_context10.t0=_context10['catch'](1);dispatch(productVariantsUpdateFailure(_context10.t0));case 11:case'end':return _context10.stop();}}},_callee10,undefined,[[1,8]]);}));return function(_x10){return _ref14.apply(this,arguments);};}();};var fetchReplacementProducts=exports.fetchReplacementProducts=function fetchReplacementProducts(){return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch){var products;return _regenerator2.default.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch(replacementProductsRequest());_context11.prev=1;_context11.next=4;return(0,_request.GET)({endpoint:'/products?assortment='+_assortments.STANDARD},dispatch);case 4:products=_context11.sent;dispatch(replacementProductsSuccess(products));_context11.next=11;break;case 8:_context11.prev=8;_context11.t0=_context11['catch'](1);dispatch(replacementProductsFailure(_context11.t0));case 11:case'end':return _context11.stop();}}},_callee11,undefined,[[1,8]]);}));return function(_x11){return _ref15.apply(this,arguments);};}();};var fetchReplacementVariants=exports.fetchReplacementVariants=function fetchReplacementVariants(id){return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee12(dispatch){var variants;return _regenerator2.default.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:dispatch(replacementVariantsRequest());_context12.prev=1;_context12.next=4;return(0,_request.GET)({endpoint:'/products/'+id+'/variants'},dispatch);case 4:variants=_context12.sent;dispatch(replacementVariantsSuccess(variants));_context12.next=11;break;case 8:_context12.prev=8;_context12.t0=_context12['catch'](1);dispatch(replacementVariantsFailure(_context12.t0));case 11:case'end':return _context12.stop();}}},_callee12,undefined,[[1,8]]);}));return function(_x12){return _ref16.apply(this,arguments);};}();};var fetchAdditionalProducts=exports.fetchAdditionalProducts=function fetchAdditionalProducts(){return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee13(dispatch){var products,nonArchivedProducts;return _regenerator2.default.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:dispatch(additionalProductsRequest());_context13.prev=1;_context13.next=4;return(0,_request.GET)({endpoint:'/products?assortment='+_assortments.ADDITIONAL},dispatch);case 4:products=_context13.sent;nonArchivedProducts=(0,_filter3.default)({archived:null},products);dispatch(additionalProductsSuccess(nonArchivedProducts));_context13.next=12;break;case 9:_context13.prev=9;_context13.t0=_context13['catch'](1);dispatch(additionalProductsFailure(_context13.t0));case 12:case'end':return _context13.stop();}}},_callee13,undefined,[[1,9]]);}));return function(_x13){return _ref17.apply(this,arguments);};}();};var fetchAdditionalVariants=exports.fetchAdditionalVariants=function fetchAdditionalVariants(id){return function(){var _ref18=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee14(dispatch){var variants,nonArchivedVariants;return _regenerator2.default.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:dispatch(additionalVariantsRequest());_context14.prev=1;_context14.next=4;return(0,_request.GET)({endpoint:'/products/'+id+'/variants'},dispatch);case 4:variants=_context14.sent;nonArchivedVariants=(0,_filter3.default)({archived:null},variants);dispatch(additionalVariantsSuccess(nonArchivedVariants));_context14.next=12;break;case 9:_context14.prev=9;_context14.t0=_context14['catch'](1);dispatch(additionalVariantsFailure(_context14.t0));case 12:case'end':return _context14.stop();}}},_callee14,undefined,[[1,9]]);}));return function(_x14){return _ref18.apply(this,arguments);};}();};var setActiveVariant=exports.setActiveVariant=function setActiveVariant(variant){return{type:SET_ACTIVE_VARIANT,variant:variant};};var toggleReplacementDialog=exports.toggleReplacementDialog=function toggleReplacementDialog(show){return{type:TOGGLE_REPLACEMENT_DIALOG,show:show};};var setActiveProductLinkedAdditionalVariant=exports.setActiveProductLinkedAdditionalVariant=function setActiveProductLinkedAdditionalVariant(additional){return{type:SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT,additional:additional};};var addProductLinkedAdditionalVariant=exports.addProductLinkedAdditionalVariant=function addProductLinkedAdditionalVariant(additional){return{type:ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT,additional:additional};};var updateProductLinkedAdditionalVariant=exports.updateProductLinkedAdditionalVariant=function updateProductLinkedAdditionalVariant(additional){return{type:UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT,additional:additional};};var removeProductLinkedAdditionalVariant=exports.removeProductLinkedAdditionalVariant=function removeProductLinkedAdditionalVariant(additional){return{type:REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT,additional:additional};};var setActiveVariantLinkedAdditionalVariant=exports.setActiveVariantLinkedAdditionalVariant=function setActiveVariantLinkedAdditionalVariant(additional){return{type:SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT,additional:additional};};var addVariantLinkedAdditionalVariant=exports.addVariantLinkedAdditionalVariant=function addVariantLinkedAdditionalVariant(additional){return{type:ADD_VARIANT_LINKED_ADDITIONAL_VARIANT,additional:additional};};var updateVariantLinkedAdditionalVariant=exports.updateVariantLinkedAdditionalVariant=function updateVariantLinkedAdditionalVariant(additional){return{type:UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT,additional:additional};};var removeVariantLinkedAdditionalVariant=exports.removeVariantLinkedAdditionalVariant=function removeVariantLinkedAdditionalVariant(additional){return{type:REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT,additional:additional};};var reset=exports.reset=function reset(){return{type:RESET};};var clear=exports.clear=function clear(){return{type:CLEAR};};var variantImageUploaded=function variantImageUploaded(variantId){return function(tempId,metadata){return{type:VARIANT_IMAGE_UPLOADED,variantId:variantId,tempId:tempId,metadata:metadata};};};var variantImage=exports.variantImage=function variantImage(variantId,file){return _defineProperty({type:VARIANT_IMAGE,tempId:_uuid2.default.v4(),variantId:variantId},_fileUploader.FILE_UPLOAD,{file:file,success:variantImageUploaded(variantId)});};var removeVariantImage=exports.removeVariantImage=function removeVariantImage(variantId,imageId){var isTemp=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return{type:REMOVE_VARIANT_IMAGE,variantId:variantId,imageId:imageId,isTemp:isTemp};};var setDefaultVariantImage=exports.setDefaultVariantImage=function setDefaultVariantImage(image){return{type:SET_DEFAULT_VARIANT_IMAGE,image:image};};var setActiveVariantImage=exports.setActiveVariantImage=function setActiveVariantImage(image){return{type:SET_ACTIVE_VARIANT_IMAGE,image:image};};var suppliersRequest=function suppliersRequest(){return{type:SUPPLIERS_REQUEST};};var suppliersSuccess=function suppliersSuccess(suppliers){return{type:SUPPLIERS_SUCCESS,suppliers:suppliers};};var suppliersFailure=function suppliersFailure(error){return{type:SUPPLIERS_FAILURE,error:error};};var fetchSuppliers=exports.fetchSuppliers=function fetchSuppliers(){return function(){var _ref20=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee15(dispatch){var suppliers;return _regenerator2.default.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:dispatch(suppliersRequest());_context15.prev=1;_context15.t0=_apartmentConfigView.sortByName;_context15.next=5;return(0,_request.GET)({endpoint:'/suppliers'},dispatch);case 5:_context15.t1=_context15.sent;suppliers=(0,_context15.t0)(_context15.t1);dispatch(suppliersSuccess(suppliers));_context15.next=13;break;case 10:_context15.prev=10;_context15.t2=_context15['catch'](1);dispatch(suppliersFailure(_context15.t2));case 13:case'end':return _context15.stop();}}},_callee15,undefined,[[1,10]]);}));return function(_x16){return _ref20.apply(this,arguments);};}();};var roomTypesRequest=function roomTypesRequest(){return{type:ROOM_TYPES_REQUEST};};var roomTypesSuccess=function roomTypesSuccess(roomTypes){return{type:ROOM_TYPES_SUCCESS,roomTypes:roomTypes};};var roomTypesFailure=function roomTypesFailure(error){return{type:ROOM_TYPES_FAILURE,error:error};};var fetchRoomTypes=exports.fetchRoomTypes=function fetchRoomTypes(){return function(){var _ref21=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee16(dispatch){var roomTypes;return _regenerator2.default.wrap(function _callee16$(_context16){while(1){switch(_context16.prev=_context16.next){case 0:dispatch(roomTypesRequest());_context16.prev=1;_context16.t0=_apartmentConfigView.sortByName;_context16.next=5;return(0,_request.GET)({endpoint:'/roomtypes'},dispatch);case 5:_context16.t1=_context16.sent;roomTypes=(0,_context16.t0)(_context16.t1);dispatch(roomTypesSuccess(roomTypes));_context16.next=13;break;case 10:_context16.prev=10;_context16.t2=_context16['catch'](1);dispatch(roomTypesFailure(_context16.t2));case 13:case'end':return _context16.stop();}}},_callee16,undefined,[[1,10]]);}));return function(_x17){return _ref21.apply(this,arguments);};}();};var workerTypesRequest=function workerTypesRequest(){return{type:WORKER_TYPES_REQUEST};};var workerTypesSuccess=function workerTypesSuccess(workerTypes){return{type:WORKER_TYPES_SUCCESS,workerTypes:workerTypes};};var workerTypesFailure=function workerTypesFailure(error){return{type:WORKER_TYPES_FAILURE,error:error};};var fetchWorkerTypes=exports.fetchWorkerTypes=function fetchWorkerTypes(){return function(){var _ref22=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee17(dispatch){var workerTypes;return _regenerator2.default.wrap(function _callee17$(_context17){while(1){switch(_context17.prev=_context17.next){case 0:dispatch(workerTypesRequest());_context17.prev=1;_context17.t0=_apartmentConfigView.sortByName;_context17.next=5;return(0,_request.GET)({endpoint:'/workertypes'},dispatch);case 5:_context17.t1=_context17.sent;workerTypes=(0,_context17.t0)(_context17.t1);dispatch(workerTypesSuccess(workerTypes));_context17.next=13;break;case 10:_context17.prev=10;_context17.t2=_context17['catch'](1);dispatch(workerTypesFailure(_context17.t2));case 13:case'end':return _context17.stop();}}},_callee17,undefined,[[1,10]]);}));return function(_x18){return _ref22.apply(this,arguments);};}();};var productTypesRequest=function productTypesRequest(){return{type:PRODUCT_TYPES_REQUEST};};var productTypesSuccess=function productTypesSuccess(productTypes){return{type:PRODUCT_TYPES_SUCCESS,productTypes:productTypes};};var productTypesFailure=function productTypesFailure(error){return{type:PRODUCT_TYPES_FAILURE,error:error};};var fetchProductTypes=exports.fetchProductTypes=function fetchProductTypes(){return function(){var _ref23=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee18(dispatch){var productTypes;return _regenerator2.default.wrap(function _callee18$(_context18){while(1){switch(_context18.prev=_context18.next){case 0:dispatch(productTypesRequest());_context18.prev=1;_context18.t0=_apartmentConfigView.sortByName;_context18.next=5;return(0,_request.GET)({endpoint:'/producttypes'},dispatch);case 5:_context18.t1=_context18.sent;productTypes=(0,_context18.t0)(_context18.t1);dispatch(productTypesSuccess(productTypes));_context18.next=13;break;case 10:_context18.prev=10;_context18.t2=_context18['catch'](1);dispatch(productTypesFailure(_context18.t2));case 13:case'end':return _context18.stop();}}},_callee18,undefined,[[1,10]]);}));return function(_x19){return _ref23.apply(this,arguments);};}();};var filterArchived=exports.filterArchived=function filterArchived(includeArchived){return{type:FILTER_ARCHIVED,includeArchived:includeArchived};};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.updateOrder=exports.fetchOrder=exports.clear=exports.toggleMenu=exports.CLEAR=exports.TOGGLE_MENU=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);var _notification=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var GET_REQUEST=exports.GET_REQUEST='@customerView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@customerView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@customerView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@customerView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@customerView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@customerView/UPDATE_FAILURE';var TOGGLE_MENU=exports.TOGGLE_MENU='@customerView/TOGGLE_MENU';var CLEAR=exports.CLEAR='@customerView/CLEAR';var orderRequest=function orderRequest(){return{type:GET_REQUEST};};var orderSuccess=function orderSuccess(order,project,apartment){return{type:GET_SUCCESS,order:order,project:project,apartment:apartment};};var orderFailure=function orderFailure(error){return{type:GET_FAILURE,error:error};};var toggleMenu=exports.toggleMenu=function toggleMenu(show){return{type:TOGGLE_MENU,show:show};};var clear=exports.clear=function clear(){return{type:CLEAR};};var orderUpdateRequest=function orderUpdateRequest(){return{type:UPDATE_REQUEST};};var orderUpdateSuccess=function orderUpdateSuccess(order){return _defineProperty({type:UPDATE_SUCCESS,order:order},_notification.ADD,{message:'Beställning uppdaterad'});};var orderUpdateFailure=function orderUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var fetchOrder=exports.fetchOrder=function fetchOrder(id){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var order,apartment,project;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(orderRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/orders/'+id},dispatch);case 4:order=_context.sent;_context.next=7;return(0,_request.GET)({endpoint:'/apartments/'+order.apartmentId},dispatch);case 7:apartment=_context.sent;_context.next=10;return(0,_request.GET)({endpoint:'/projects/'+apartment.projectId},dispatch);case 10:project=_context.sent;dispatch(orderSuccess(order,project,apartment));_context.next=17;break;case 14:_context.prev=14;_context.t0=_context['catch'](1);dispatch(orderFailure(_context.t0));case 17:case'end':return _context.stop();}}},_callee,undefined,[[1,14]]);}));return function(_x){return _ref2.apply(this,arguments);};}();};var updateOrder=exports.updateOrder=function updateOrder(id,state){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var order;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(orderUpdateRequest());_context2.prev=1;_context2.next=4;return(0,_request.PUT)({endpoint:'/orders/'+id,body:{state:state}},dispatch);case 4:order=_context2.sent;dispatch(orderUpdateSuccess(order));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(orderUpdateFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref3.apply(this,arguments);};}();};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(60),
    isObjectLike = __webpack_require__(33);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 173 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(243);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(72);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactInputAutosize = __webpack_require__(1015);

var _reactInputAutosize2 = _interopRequireDefault(_reactInputAutosize);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultArrowRenderer = __webpack_require__(1016);

var _defaultArrowRenderer2 = _interopRequireDefault(_defaultArrowRenderer);

var _defaultFilterOptions = __webpack_require__(429);

var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);

var _defaultMenuRenderer = __webpack_require__(431);

var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);

var _defaultClearRenderer = __webpack_require__(1017);

var _defaultClearRenderer2 = _interopRequireDefault(_defaultClearRenderer);

var _Option = __webpack_require__(1018);

var _Option2 = _interopRequireDefault(_Option);

var _Value = __webpack_require__(432);

var _Value2 = _interopRequireDefault(_Value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*!
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Copyright (c) 2017 Jed Watson.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 Licensed under the MIT License (MIT), see
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 http://jedwatson.github.io/react-select
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]);

var instanceId = 1;

var Select = function (_React$Component) {
	_inherits(Select, _React$Component);

	function Select(props) {
		_classCallCheck(this, Select);

		var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleRequired', 'handleTouchOutside', 'handleTouchMove', 'handleTouchStart', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleValueClick', 'getOptionLabel', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	_createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: this.handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}
		}
	}, {
		key: 'componentWillUpdate',
		value: function componentWillUpdate(nextProps, nextState) {
			if (nextState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(nextState.isOpen);
				var handler = nextState.isOpen ? nextProps.onOpen : nextProps.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = _reactDom2.default.findDOMNode(this.focused);
				var menuNode = _reactDom2.default.findDOMNode(this.menu);
				menuNode.scrollTop = focusedOptionNode.offsetTop;
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = _reactDom2.default.findDOMNode(this.focused);
				var menuDOM = _reactDom2.default.findDOMNode(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			if (!document.removeEventListener && document.detachEvent) {
				document.detachEvent('ontouchstart', this.handleTouchOutside);
			} else {
				document.removeEventListener('touchstart', this.handleTouchOutside);
			}
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			if (enabled) {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.addEventListener('touchstart', this.handleTouchOutside);
				}
			} else {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('ontouchstart', this.handleTouchOutside);
				} else {
					document.removeEventListener('touchstart', this.handleTouchOutside);
				}
			}
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				return;
			}

			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// TODO: This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: true,
					isPseudoFocused: false
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If the menu isn't open, let the event bubble to the main handleMouseDown
			if (!this.state.isOpen) {
				return;
			}
			// prevent default event handlers
			event.stopPropagation();
			event.preventDefault();
			// close the menu
			this.closeMenu();
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi,
					inputValue: this.handleInputValueChange('')
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;
			var isOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
			this.setState({
				isFocused: true,
				isOpen: isOpen
			});
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				isOpen: true,
				isPseudoFocused: false,
				inputValue: newInputValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						return;
					}
					this.selectFocusedOption();
					return;
				case 13:
					// enter
					if (!this.state.isOpen) return;
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 27:
					// escape
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 38:
					// up
					this.focusPreviousOption();
					break;
				case 40:
					// down
					this.focusNextOption();
					break;
				case 33:
					// page up
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						return;
					}
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						return;
					}
					this.focusStartOption();
					break;
				case 46:
					// backspace
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					return;
				default:
					return;
			}
			event.preventDefault();
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'handleRequired',
		value: function handleRequired(value, multi) {
			if (!value) return true;
			return multi ? value.length === 0 : Object.keys(value).length === 0;
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param	{String|Number|Array}	value		- the value of the select input
   * @param	{Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value, nextProps) {
			var _this2 = this;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') value = value.split(props.delimiter);
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return _this2.expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = this.expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}

		/**
   * Retrieve a value from the given options and valueKey
   * @param	{String|Number|Array}	value	- the selected value(s)
   * @param	{Object}		props	- the Select component's props (or nextProps)
   */

	}, {
		key: 'expandValue',
		value: function expandValue(value, props) {
			var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
			if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
			var options = props.options,
			    valueKey = props.valueKey;

			if (!options) return;
			for (var i = 0; i < options.length; i++) {
				if (options[i][valueKey] === value) return options[i];
			}
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this3 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = this.handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.onChange) {
				if (this.props.simpleValue && value) {
					value = this.props.multi ? value.map(function (i) {
						return i[_this3.props.valueKey];
					}).join(this.props.delimiter) : value[this.props.valueKey];
				}
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this4 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			if (this.props.multi) {
				var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					_this4.addValue(value);
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this4.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i !== value;
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(this.getResetValue());
			this.setState({
				isOpen: false,
				inputValue: this.handleInputValueChange('')
			}, this.focus);
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null)
				});
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var potentialIndex = focusedIndex + this.props.pageSize;
				if (potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'getInputValue',
		value: function getInputValue() {
			return this.state.inputValue;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return _react2.default.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				_react2.default.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				return !this.state.inputValue ? _react2.default.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return _react2.default.createElement(
						ValueComponent,
						{
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							disabled: _this5.props.disabled || value.clearableValue === false,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							value: value
						},
						renderLabel(value, i),
						_react2.default.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (!this.state.inputValue) {
				if (isOpen) onClick = null;
				return _react2.default.createElement(
					ValueComponent,
					{
						id: this._instancePrefix + '-value-item',
						disabled: this.props.disabled,
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = (0, _classnames2.default)('Select-input', this.props.inputProps.className);
			var isOpen = !!this.state.isOpen;

			var ariaOwns = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, this._instancePrefix + '-list', isOpen), _defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var inputProps = _extends({}, this.props.inputProps, {
				role: 'combobox',
				'aria-expanded': '' + isOpen,
				'aria-owns': ariaOwns,
				'aria-haspopup': '' + isOpen,
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-label': this.props['aria-label'],
				className: className,
				tabIndex: this.props.tabIndex,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				required: this.state.required,
				value: this.state.inputValue
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var _props$inputProps = this.props.inputProps,
				    inputClassName = _props$inputProps.inputClassName,
				    divProps = _objectWithoutProperties(_props$inputProps, ['inputClassName']);

				var _ariaOwns = (0, _classnames2.default)(_defineProperty({}, this._instancePrefix + '-list', isOpen));

				return _react2.default.createElement('div', _extends({}, divProps, {
					role: 'combobox',
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					className: className,
					tabIndex: this.props.tabIndex || 0,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					'aria-readonly': '' + !!this.props.disabled,
					style: { border: 0, width: 1, display: 'inline-block' } }));
			}

			if (this.props.autosize) {
				return _react2.default.createElement(_reactInputAutosize2.default, _extends({}, inputProps, { minWidth: '5' }));
			}
			return _react2.default.createElement(
				'div',
				{ className: className },
				_react2.default.createElement('input', inputProps)
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			if (!this.props.clearable || this.props.value === undefined || this.props.value === null || this.props.multi && !this.props.value.length || this.props.disabled || this.props.isLoading) return;
			var clear = this.props.clearRenderer();

			return _react2.default.createElement(
				'span',
				{ className: 'Select-clear-zone', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText,
					onMouseDown: this.clearValue,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEndClearValue
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			return _react2.default.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : _defaultFilterOptions2.default;

				return filterOptions(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey,
					onOptionRef: this.onOptionRef
				});
			} else if (this.props.noResultsText) {
				return _react2.default.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return _react2.default.createElement('input', {
					type: 'hidden',
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					name: this.props.name,
					value: value,
					disabled: this.props.disabled });
			}
			return valueArray.map(function (item, index) {
				return _react2.default.createElement('input', { key: 'hidden.' + index,
					type: 'hidden',
					ref: 'value' + index,
					name: _this7.props.name,
					value: stringifyValue(item[_this7.props.valueKey]),
					disabled: _this7.props.disabled });
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return _react2.default.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				_react2.default.createElement(
					'div',
					{ ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						}, role: 'listbox', tabIndex: -1, className: 'Select-menu', id: this._instancePrefix + '-list',
						style: this.props.menuStyle,
						onScroll: this.handleMenuScroll,
						onMouseDown: this.handleMouseDownOnMenu },
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi ? this.getValueArray(this.props.value) : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = (0, _classnames2.default)('Select', this.props.className, {
				'Select--multi': this.props.multi,
				'Select--single': !this.props.multi,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'has-value': valueArray.length
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = _react2.default.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return _react2.default.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				_react2.default.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						style: this.props.style,
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchStart: this.handleTouchStart,
						onTouchMove: this.handleTouchMove
					},
					_react2.default.createElement(
						'span',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, !this.props.multi ? valueArray : null, focusedOption) : null
			);
		}
	}]);

	return Select;
}(_react2.default.Component);

;

Select.propTypes = {
	'aria-describedby': _propTypes2.default.string, // HTML ID(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': _propTypes2.default.string, // Aria label (for assistive tech)
	'aria-labelledby': _propTypes2.default.string, // HTML ID of an element that should be used as the label (for assistive tech)
	addLabelText: _propTypes2.default.string, // placeholder displayed when you want to add a label on a multi-value input
	arrowRenderer: _propTypes2.default.func, // Create drop-down caret element
	autoBlur: _propTypes2.default.bool, // automatically blur the component when an option is selected
	autofocus: _propTypes2.default.bool, // autofocus the component on mount
	autosize: _propTypes2.default.bool, // whether to enable autosizing or not
	backspaceRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: _propTypes2.default.string, // Message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: _propTypes2.default.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: _propTypes2.default.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: _propTypes2.default.bool, // should it be possible to reset value
	closeOnSelect: _propTypes2.default.bool, // whether to close the menu when a value is selected
	deleteRemoves: _propTypes2.default.bool, // whether backspace removes an item if there is no text input
	delimiter: _propTypes2.default.string, // delimiter to use to join multiple values for the hidden field value
	disabled: _propTypes2.default.bool, // whether the Select is disabled or not
	escapeClearsValue: _propTypes2.default.bool, // whether escape clears the value when the menu is closed
	filterOption: _propTypes2.default.func, // method to filter a single option (option, filterString)
	filterOptions: _propTypes2.default.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	ignoreAccents: _propTypes2.default.bool, // whether to strip diacritics when filtering
	ignoreCase: _propTypes2.default.bool, // whether to perform case-insensitive filtering
	inputProps: _propTypes2.default.object, // custom attributes for the Input
	inputRenderer: _propTypes2.default.func, // returns a custom input component
	instanceId: _propTypes2.default.string, // set the components instanceId
	isLoading: _propTypes2.default.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: _propTypes2.default.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: _propTypes2.default.string, // path of the label value in option objects
	matchPos: _propTypes2.default.string, // (any|start) match the start or entire string when filtering
	matchProp: _propTypes2.default.string, // (any|label|value) which option property to filter on
	menuBuffer: _propTypes2.default.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: _propTypes2.default.object, // optional style to apply to the menu container
	menuRenderer: _propTypes2.default.func, // renders a custom menu with options
	menuStyle: _propTypes2.default.object, // optional style to apply to the menu
	multi: _propTypes2.default.bool, // multi-value input
	name: _propTypes2.default.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: _propTypes2.default.func, // onBlur handler: function (event) {}
	onBlurResetsInput: _propTypes2.default.bool, // whether input is cleared on blur
	onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
	onClose: _propTypes2.default.func, // fires when the menu is closed
	onCloseResetsInput: _propTypes2.default.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: _propTypes2.default.func, // onFocus handler: function (event) {}
	onInputChange: _propTypes2.default.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: _propTypes2.default.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: _propTypes2.default.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: _propTypes2.default.func, // fires when the menu is opened
	onSelectResetsInput: _propTypes2.default.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: _propTypes2.default.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: _propTypes2.default.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: _propTypes2.default.bool, // always open options menu on focus
	optionClassName: _propTypes2.default.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: _propTypes2.default.func, // option component to render in dropdown
	optionRenderer: _propTypes2.default.func, // optionRenderer: function (option) {}
	options: _propTypes2.default.array, // array of options
	pageSize: _propTypes2.default.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	required: _propTypes2.default.bool, // applies HTML5 required attribute when needed
	resetValue: _propTypes2.default.any, // value to use when you clear the control
	scrollMenuIntoView: _propTypes2.default.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: _propTypes2.default.bool, // whether to enable searching feature or not
	simpleValue: _propTypes2.default.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: _propTypes2.default.object, // optional style to apply to the control
	tabIndex: _propTypes2.default.string, // optional tab index of the control
	tabSelectsValue: _propTypes2.default.bool, // whether to treat tabbing out while focused to be value selection
	value: _propTypes2.default.any, // initial field value
	valueComponent: _propTypes2.default.func, // value component to render
	valueKey: _propTypes2.default.string, // path of the label value in option objects
	valueRenderer: _propTypes2.default.func, // valueRenderer: function (option) {}
	wrapperStyle: _propTypes2.default.object // optional style to apply to the component wrapper
};

Select.defaultProps = {
	addLabelText: 'Add "{label}"?',
	arrowRenderer: _defaultArrowRenderer2.default,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: _defaultClearRenderer2.default,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: _defaultFilterOptions2.default,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: _defaultMenuRenderer2.default,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onSelectResetsInput: true,
	onCloseResetsInput: true,
	openOnClick: true,
	optionComponent: _Option2.default,
	pageSize: 5,
	placeholder: 'Select...',
	required: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	valueComponent: _Value2.default,
	valueKey: 'value'
};

exports.default = Select;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mergeWith2 = __webpack_require__(1099);

var _mergeWith3 = _interopRequireDefault(_mergeWith2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function mergePropPair() {
  for (var _len = arguments.length, props = Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }

  var firstProps = props[0];
  var restProps = props.slice(1);

  if (!restProps.length) {
    return (0, _mergeWith3.default)({}, firstProps);
  }

  // Avoid mutating the first prop collection
  return _mergeWith3.default.apply(undefined, [(0, _mergeWith3.default)({}, firstProps)].concat(_toConsumableArray(restProps), [function (a, b, key) {
    if (key === 'children') {
      // Children have to be merged in reverse order for Reactabular
      // logic to work.
      return _extends({}, b, a);
    }

    if (key === 'className') {
      // Process class names through classNames to merge properly
      // as a string.
      return (0, _classnames2.default)(a, b);
    }

    return undefined;
  }]));
}

exports.default = mergePropPair;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getUrl=undefined;var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _join2=__webpack_require__(241);var _join3=_interopRequireDefault(_join2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _request=__webpack_require__(6);var _purchaseReportView=__webpack_require__(410);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: import type {PurchaseReportState} from '../../reducers/purchaseReportView';*//*:: import type {
  Entity,
  Project,
} from '../../actions/purchaseReportView';*/var fileUrl=_request.apiBase+'/files';var getUrl=exports.getUrl=function getUrl(projectId/*: number*/,apartmentIds/*: number[]*/,supplierId/*: ?number*/){var includeFileName/*:: ?: boolean*/=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var withPlans/*:: ?: boolean*/=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var linebreakPerApartment/*:: ?: boolean*/=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;var url=fileUrl+'/export/projects/'+projectId+'/purchase';if(!!includeFileName){url+='/project_'+projectId+'_purchase_export.pdf';}var params=[];if(!!apartmentIds.length){params.push('apartmentIds='+(0,_join3.default)(',',apartmentIds));}if(!!withPlans){params.push('withPlans=1');}if(!!linebreakPerApartment){params.push('linebreakPerApartment=1');}if(!!supplierId){params.push('supplierId='+supplierId);}if(params.length>0){url+='?'+params.join('&');}return url;};/*:: export type Props = {
  apartmentIds: number[],
  apartments: any[],
  applyFilter: typeof applyFilter,
  fetchData: typeof fetchData,
  isFetching: boolean,
  projectId?: number,
  projects: Project[],
  supplierId?: number,
  suppliers: any[],
  includePlans: boolean,
  linebreakPerApartment: boolean,
};*/var PurchaseOrderReportContainer=function(_Component){_inherits(PurchaseOrderReportContainer,_Component);function PurchaseOrderReportContainer(){_classCallCheck(this,PurchaseOrderReportContainer);return _possibleConstructorReturn(this,(PurchaseOrderReportContainer.__proto__||Object.getPrototypeOf(PurchaseOrderReportContainer)).apply(this,arguments));}_createClass(PurchaseOrderReportContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData();}},{key:'render',value:function render(){var _props=this.props,apartmentIds=_props.apartmentIds,apartments=_props.apartments,applyFilter=_props.applyFilter,isFetching=_props.isFetching,projectId=_props.projectId,projects=_props.projects,suppliers=_props.suppliers,supplierId=_props.supplierId,includePlans=_props.includePlans,linebreakPerApartment=_props.linebreakPerApartment;return _react2.default.createElement('div',{className:'PurchaseOrderReportContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:projectId,onBlur:_noop3.default,onChange:function onChange(project){return applyFilter(apartmentIds,project?project.id:null,supplierId,includePlans,linebreakPerApartment);}},placeholder:'V\xE4lj projekt',meta:{},valueKey:'id',labelKey:'name',multi:false,options:projects,clearable:false,isLoading:isFetching})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:apartmentIds,onBlur:_noop3.default,onChange:function onChange(apartments/*: Entity[]*/){return applyFilter((0,_map3.default)('id',apartments),projectId,supplierId,(apartments||[]).length===1?includePlans:false,linebreakPerApartment);}},placeholder:'V\xE4lj l\xE4genheter',meta:{},valueKey:'id',labelKey:'objectId',multi:true,options:apartments,clearable:true,isLoading:isFetching,keepOpen:true}),apartmentIds.length===1&&_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!includePlans,onBlur:_noop3.default,onChange:function onChange(includePlans){return applyFilter(apartmentIds,projectId,supplierId,includePlans?apartmentIds.length===1&&includePlans.value:false,linebreakPerApartment);}},label:'Inkludera ritningar',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),(apartmentIds.length===0||apartmentIds.length>1)&&_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!linebreakPerApartment,onBlur:_noop3.default,onChange:function onChange(linebreakPerApartment){return applyFilter(apartmentIds,projectId,supplierId,includePlans,linebreakPerApartment?(apartmentIds.length===0||apartmentIds.length>1)&&linebreakPerApartment.value:false);}},label:'Radbrytning f\xF6r varje l\xE4genhet',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default})))),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:supplierId,onBlur:_noop3.default,onChange:function onChange(supplier){return applyFilter(apartmentIds,projectId,supplier?supplier.id:null,includePlans,linebreakPerApartment);}},placeholder:'V\xE4lj leverant\xF6r',meta:{},valueKey:'id',labelKey:'name',multi:false,options:suppliers,clearable:true,isLoading:isFetching})),!!projectId&&_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('a',{href:getUrl(projectId,apartmentIds,supplierId,true,includePlans,linebreakPerApartment),target:'_blank',className:'button success'},'Ladda ner'))));}}]);return PurchaseOrderReportContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$purchaseReportVi=_ref.purchaseReportView,apartmentIds=_ref$purchaseReportVi.apartmentIds,apartments=_ref$purchaseReportVi.apartments,isFetching=_ref$purchaseReportVi.isFetching,projectId=_ref$purchaseReportVi.projectId,projects=_ref$purchaseReportVi.projects,supplierId=_ref$purchaseReportVi.supplierId,suppliers=_ref$purchaseReportVi.suppliers,includePlans=_ref$purchaseReportVi.includePlans,linebreakPerApartment=_ref$purchaseReportVi.linebreakPerApartment;return{apartmentIds:apartmentIds,apartments:apartments,isFetching:isFetching,projectId:projectId,projects:projects,supplierId:supplierId,suppliers:suppliers,includePlans:includePlans,linebreakPerApartment:linebreakPerApartment};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{applyFilter:function applyFilter(apartmentIds,projectId,supplierId,includePlans,linebreakPerApartment){return dispatch((0,_purchaseReportView.applyFilter)(apartmentIds,projectId,supplierId,includePlans,linebreakPerApartment));},fetchData:function fetchData(){return dispatch((0,_purchaseReportView.fetchData)());}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(PurchaseOrderReportContainer);

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkify = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _linkifyIt = __webpack_require__(1269);

var _linkifyIt2 = _interopRequireDefault(_linkifyIt);

var _tlds = __webpack_require__(1275);

var _tlds2 = _interopRequireDefault(_tlds);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var linkify = exports.linkify = new _linkifyIt2.default();
linkify.tlds(_tlds2.default);

var Linkify = function (_React$Component) {
  _inherits(Linkify, _React$Component);

  function Linkify() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Linkify);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Linkify.__proto__ || Object.getPrototypeOf(Linkify)).call.apply(_ref, [this].concat(args))), _this), _this.parseCounter = 0, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Linkify, [{
    key: 'getMatches',
    value: function getMatches(string) {
      return linkify.match(string);
    }
  }, {
    key: 'parseString',
    value: function parseString(string) {
      var _this2 = this;

      var elements = [];
      if (string === '') {
        return elements;
      }

      var matches = this.getMatches(string);
      if (!matches) {
        return string;
      }

      var lastIndex = 0;
      matches.forEach(function (match, idx) {
        // Push the preceding text if there is any
        if (match.index > lastIndex) {
          elements.push(string.substring(lastIndex, match.index));
        }
        // Shallow update values that specified the match
        var props = { href: match.url, key: 'parse' + _this2.parseCounter + 'match' + idx };
        for (var key in _this2.props.properties) {
          var val = _this2.props.properties[key];
          if (val === Linkify.MATCH) {
            val = match.url;
          }

          props[key] = val;
        }
        elements.push(_react2.default.createElement(_this2.props.component, props, match.text));
        lastIndex = match.lastIndex;
      });

      if (lastIndex < string.length) {
        elements.push(string.substring(lastIndex));
      }

      return elements.length === 1 ? elements[0] : elements;
    }
  }, {
    key: 'parse',
    value: function parse(children) {
      var _this3 = this;

      var parsed = children;

      if (typeof children === 'string') {
        parsed = this.parseString(children);
      } else if (_react2.default.isValidElement(children) && children.type !== 'a' && children.type !== 'button') {
        parsed = _react2.default.cloneElement(children, { key: 'parse' + ++this.parseCounter }, this.parse(children.props.children));
      } else if (children instanceof Array) {
        parsed = children.map(function (child) {
          return _this3.parse(child);
        });
      }

      return parsed;
    }
  }, {
    key: 'render',
    value: function render() {
      this.parseCounter = 0;
      var parsedChildren = this.parse(this.props.children);

      return _react2.default.createElement(
        'span',
        { className: this.props.className },
        parsedChildren
      );
    }
  }]);

  return Linkify;
}(_react2.default.Component);

Linkify.MATCH = 'LINKIFY_MATCH';
Linkify.propTypes = {
  className: _propTypes2.default.string,
  component: _propTypes2.default.any,
  properties: _propTypes2.default.object,
  urlRegex: _propTypes2.default.object,
  emailRegex: _propTypes2.default.object
};
Linkify.defaultProps = {
  className: 'Linkify',
  component: 'a',
  properties: {}
};
exports.default = Linkify;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.createLocation = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _resolvePathname = __webpack_require__(284);

var _resolvePathname2 = _interopRequireDefault(_resolvePathname);

var _valueEqual = __webpack_require__(285);

var _valueEqual2 = _interopRequireDefault(_valueEqual);

var _PathUtils = __webpack_require__(106);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = (0, _PathUtils.parsePath)(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
};

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(32);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

exports.default = createTransitionManager;

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(185);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_POP", function() { return ARRAY_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOFILL", function() { return AUTOFILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLUR", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTROY", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT", function() { return START_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT", function() { return SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH", function() { return TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNTOUCH", function() { return UNTOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(612);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(61);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(50);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(73);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(621);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(142);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(73);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(639);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(141)(module)))

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(642);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(136);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasError__ = __webpack_require__(699);



var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = Object(__WEBPACK_IMPORTED_MODULE_0__hasError__["a" /* default */])(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsValid);

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('getOr', __webpack_require__(96));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(146),
    baseLodash = __webpack_require__(207);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(323),
    noop = __webpack_require__(209);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 209 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(146),
    baseLodash = __webpack_require__(207);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(771),
    shortOut = __webpack_require__(334);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 212 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(95),
    eq = __webpack_require__(114);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 214 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(154),
    nativeKeys = __webpack_require__(784);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75),
    root = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(796),
    mapCacheDelete = __webpack_require__(803),
    mapCacheGet = __webpack_require__(805),
    mapCacheHas = __webpack_require__(806),
    mapCacheSet = __webpack_require__(807);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(219),
    stubArray = __webpack_require__(342);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 219 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 220 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(340);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(345),
    getSymbolsIn = __webpack_require__(343),
    keysIn = __webpack_require__(161);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(347);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    getPrototype = __webpack_require__(221),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 225 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(18),
    isSymbol = __webpack_require__(76);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader = false;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function init (converter) {
		function api (key, value, attributes) {
			var result;
			if (typeof document === 'undefined') {
				return;
			}

			// Write

			if (arguments.length > 1) {
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);

				if (typeof attributes.expires === 'number') {
					var expires = new Date();
					expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
					attributes.expires = expires;
				}

				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

				try {
					result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}

				if (!converter.write) {
					value = encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
				} else {
					value = converter.write(value, key);
				}

				key = encodeURIComponent(String(key));
				key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
				key = key.replace(/[\(\)]/g, escape);

				var stringifiedAttributes = '';

				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
					stringifiedAttributes += '=' + attributes[attributeName];
				}
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}

			// Read

			if (!key) {
				result = {};
			}

			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all. Also prevents odd result when
			// calling "get()"
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var rdecode = /(%[0-9A-Z]{2})+/g;
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!this.json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = parts[0].replace(rdecode, decodeURIComponent);
					cookie = converter.read ?
						converter.read(cookie, name) : converter(cookie, name) ||
						cookie.replace(rdecode, decodeURIComponent);

					if (this.json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					if (key === name) {
						result = cookie;
						break;
					}

					if (!key) {
						result[name] = cookie;
					}
				} catch (e) {}
			}

			return result;
		}

		api.set = api;
		api.get = function (key) {
			return api.call(api, key);
		};
		api.getJSON = function () {
			return api.apply({
				json: true
			}, [].slice.call(arguments));
		};
		api.defaults = {};

		api.remove = function (key, attributes) {
			api(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.abortUpload=exports.removeFile=exports.uploadFile=exports.importProjects=exports.toggleImportDialog=exports.filterProjects=exports.fetchProjects=exports.FILE_UPLOADED=exports.ABORT_FILE_UPLOAD=exports.REMOVE_FILE=exports.UPLOAD_FILE=exports.TOGGLE_IMPORT_DIALOG=exports.IMPORT_FAILURE=exports.IMPORT_SUCCESS=exports.IMPORT_REQUEST=exports.SORT=exports.FILTER=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _forEach2=__webpack_require__(229);var _forEach3=_interopRequireDefault(_forEach2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _uuid=__webpack_require__(53);var _uuid2=_interopRequireDefault(_uuid);var _request=__webpack_require__(6);var _notification=__webpack_require__(23);var _fileUploader=__webpack_require__(81);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var GET_REQUEST=exports.GET_REQUEST='@projectList/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@projectList/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@projectList/GET_FAILURE';var FILTER=exports.FILTER='@projectList/FILTER';var SORT=exports.SORT='@projectList/SORT';var IMPORT_REQUEST=exports.IMPORT_REQUEST='@projectList/IMPORT_REQUEST';var IMPORT_SUCCESS=exports.IMPORT_SUCCESS='@projectList/IMPORT_SUCCESS';var IMPORT_FAILURE=exports.IMPORT_FAILURE='@projectList/IMPORT_FAILURE';var TOGGLE_IMPORT_DIALOG=exports.TOGGLE_IMPORT_DIALOG='@projectList/TOGGLE_IMPORT_DIALOG';var UPLOAD_FILE=exports.UPLOAD_FILE='@projectList/UPLOAD_FILE';var REMOVE_FILE=exports.REMOVE_FILE='@projectList/REMOVE_FILE';var ABORT_FILE_UPLOAD=exports.ABORT_FILE_UPLOAD='@projectList/ABORT_FILE_UPLOAD';var FILE_UPLOADED=exports.FILE_UPLOADED='@projectList/FILE_UPLOADED';var projectsRequest=function projectsRequest(){return{type:GET_REQUEST};};var projectsSuccess=function projectsSuccess(projects){return{type:GET_SUCCESS,projects:projects};};var projectsFailure=function projectsFailure(error){return{type:GET_FAILURE,error:error};};var projectsImportRequest=function projectsImportRequest(){return{type:IMPORT_REQUEST};};var projectsImportSuccess=function projectsImportSuccess(){return{type:IMPORT_SUCCESS};};var projectsImportFailure=function projectsImportFailure(error){return{type:IMPORT_FAILURE,error:error};};var fetchProjects=exports.fetchProjects=function fetchProjects(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var projects;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(projectsRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/projects'},dispatch);case 4:projects=_context.sent;dispatch(projectsSuccess(projects));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(projectsFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var filterProjects=exports.filterProjects=function filterProjects(filter){return _extends({type:FILTER},filter);};var toggleImportDialog=exports.toggleImportDialog=function toggleImportDialog(show){return{type:TOGGLE_IMPORT_DIALOG,show:show};};var dispatchNotifications=function dispatchNotifications(dispatch,importInfo){if(!importInfo.length){return;}var newProjects=(0,_filter3.default)(function(p){return p.isNew;},importInfo);if(!!newProjects.length){(0,_forEach3.default)(function(project){var multipleApartments=project.newApartments>1;var multipleUsers=project.newUsers>1;dispatch((0,_notification.addNotification)(project.name+' skapat med '+(project.newApartments+' l\xE4genhet'+(multipleApartments?'er':'')+' ')+('och '+project.newUsers+' best\xE4llning'+(multipleUsers?'ar':''))));},newProjects);}var updatedProjects=(0,_filter3.default)(function(p){return!p.isNew&&(!!p.newUsers||!!p.updatedUsers);},importInfo);if(!!updatedProjects.length){(0,_forEach3.default)(function(project){var message='';if(!!project.newUsers){var multiple=project.newUsers>1;message=project.newUsers+' ny'+(multiple?'a':'')+' '+('best\xE4llning'+(multiple?'ar':''));}if(!!project.updatedUsers){var _multiple=project.updatedUsers>1;message+=''+(!!project.newUsers?' och ':'')+(project.updatedUsers+' uppdaterad'+(_multiple?'e':'')+' anv\xE4ndare');}if(!(0,_isEmpty3.default)(message)){dispatch((0,_notification.addNotification)(message+' f\xF6r '+project.name));}},updatedProjects);}};var importProjects=exports.importProjects=function importProjects(file){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var importInfo;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(projectsImportRequest());_context2.prev=1;_context2.next=4;return(0,_request.POST)({endpoint:'/projects/import/'+file.id},dispatch);case 4:importInfo=_context2.sent;dispatch(projectsImportSuccess());dispatch(toggleImportDialog(false));dispatch(fetchProjects());dispatchNotifications(dispatch,importInfo);_context2.next=14;break;case 11:_context2.prev=11;_context2.t0=_context2['catch'](1);dispatch(projectsImportFailure(_context2.t0));case 14:case'end':return _context2.stop();}}},_callee2,undefined,[[1,11]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var fileUploaded=function fileUploaded(tempId,metadata){return{type:FILE_UPLOADED,tempId:tempId,metadata:metadata};};var uploadFile=exports.uploadFile=function uploadFile(file){return _defineProperty({type:UPLOAD_FILE,tempId:_uuid2.default.v4()},_fileUploader.FILE_UPLOAD,{file:file,success:fileUploaded});};var removeFile=exports.removeFile=function removeFile(){return{type:REMOVE_FILE};};var abortUpload=exports.abortUpload=function abortUpload(tempId){return _defineProperty({type:ABORT_FILE_UPLOAD,tempId:tempId},_fileUploader.ABORT_UPLOAD,true);};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('forEach', __webpack_require__(857));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('omitBy', __webpack_require__(863));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('uniq', __webpack_require__(867), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(163),
    arrayIncludes = __webpack_require__(149),
    arrayIncludesWith = __webpack_require__(233),
    cacheHas = __webpack_require__(164),
    createSet = __webpack_require__(868),
    setToArray = __webpack_require__(225);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 233 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.notifyLinkCopied=exports.sendActivationLinks=exports.fetchRoomTypes=exports.fetchProducts=exports.updateProject=exports.createProject=exports.fetchProject=exports.clear=exports.reset=exports.abortAllUploads=exports.setActiveRoomType=exports.filterApartments=exports.abortFileUpload=exports.removeRoomTypeImage=exports.uploadRoomTypeImage=exports.removeProjectFile=exports.uploadProjectFile=exports.LINK_COPY_MESSAGE=exports.ACTIVATION_FAILURE=exports.ACTIVATION_SUCCESS=exports.ACTIVATION_REQUEST=exports.SORT=exports.CLEAR=exports.SET_ACTIVE_ROOM_TYPE=exports.FILTER_APARTMENTS=exports.ABORT_FILE_UPLOAD=exports.RESET=exports.UPLOAD_PROJECT_FILE=exports.REMOVE_PROJECT_FILE=exports.ADD_PROJECT_FILE=exports.UPLOAD_ROOM_TYPE_IMAGE=exports.REMOVE_ROOM_TYPE_IMAGE=exports.ADD_ROOM_TYPE_IMAGE=exports.ROOM_TYPES_FAILURE=exports.ROOM_TYPES_SUCCESS=exports.ROOM_TYPES_REQUEST=exports.PRODUCTS_FAILURE=exports.PRODUCTS_SUCCESS=exports.PRODUCTS_REQUEST=exports.PROJECT_UPDATE_FAILURE=exports.PROJECT_UPDATE_SUCCESS=exports.PROJECT_UPDATE_REQUEST=exports.PROJECT_CREATE_FAILURE=exports.PROJECT_CREATE_SUCCESS=exports.PROJECT_CREATE_REQUEST=exports.PROJECT_GET_FAILURE=exports.PROJECT_GET_SUCCESS=exports.PROJECT_GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _values2=__webpack_require__(67);var _values3=_interopRequireDefault(_values2);var _flatten2=__webpack_require__(870);var _flatten3=_interopRequireDefault(_flatten2);var _forEach2=__webpack_require__(229);var _forEach3=_interopRequireDefault(_forEach2);var _uuid=__webpack_require__(53);var _uuid2=_interopRequireDefault(_uuid);var _notification=__webpack_require__(23);var _request=__webpack_require__(6);var _fileUploader=__webpack_require__(81);var _assortments=__webpack_require__(55);var _apartmentConfigView=__webpack_require__(82);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var PROJECT_GET_REQUEST=exports.PROJECT_GET_REQUEST='@projectView/PROJECT_GET_REQUEST';var PROJECT_GET_SUCCESS=exports.PROJECT_GET_SUCCESS='@projectView/PROJECT_GET_SUCCESS';var PROJECT_GET_FAILURE=exports.PROJECT_GET_FAILURE='@projectView/PROJECT_GET_FAILURE';var PROJECT_CREATE_REQUEST=exports.PROJECT_CREATE_REQUEST='@projectView/PROJECT_CREATE_REQUEST';var PROJECT_CREATE_SUCCESS=exports.PROJECT_CREATE_SUCCESS='@projectView/PROJECT_CREATE_SUCCESS';var PROJECT_CREATE_FAILURE=exports.PROJECT_CREATE_FAILURE='@projectView/PROJECT_CREATE_FAILURE';var PROJECT_UPDATE_REQUEST=exports.PROJECT_UPDATE_REQUEST='@projectView/PROJECT_UPDATE_REQUEST';var PROJECT_UPDATE_SUCCESS=exports.PROJECT_UPDATE_SUCCESS='@projectView/PROJECT_UPDATE_SUCCESS';var PROJECT_UPDATE_FAILURE=exports.PROJECT_UPDATE_FAILURE='@projectView/PROJECT_UPDATE_FAILURE';var PRODUCTS_REQUEST=exports.PRODUCTS_REQUEST='@projectView/PRODUCTS_REQUEST';var PRODUCTS_SUCCESS=exports.PRODUCTS_SUCCESS='@projectView/PRODUCTS_SUCCESS';var PRODUCTS_FAILURE=exports.PRODUCTS_FAILURE='@projectView/PRODUCTS_FAILURE';var ROOM_TYPES_REQUEST=exports.ROOM_TYPES_REQUEST='@projectView/ROOM_TYPES_REQUEST';var ROOM_TYPES_SUCCESS=exports.ROOM_TYPES_SUCCESS='@projectView/ROOM_TYPES_SUCCESS';var ROOM_TYPES_FAILURE=exports.ROOM_TYPES_FAILURE='@projectView/ROOM_TYPES_FAILURE';var ADD_ROOM_TYPE_IMAGE=exports.ADD_ROOM_TYPE_IMAGE='@projectView/ADD_ROOM_TYPE_IMAGE';var REMOVE_ROOM_TYPE_IMAGE=exports.REMOVE_ROOM_TYPE_IMAGE='@projectView/REMOVE_ROOM_TYPE_IMAGE';var UPLOAD_ROOM_TYPE_IMAGE=exports.UPLOAD_ROOM_TYPE_IMAGE='@projectView/UPLOAD_ROOM_TYPE_IMAGE';var ADD_PROJECT_FILE=exports.ADD_PROJECT_FILE='@projectView/ADD_PROJECT_FILE';var REMOVE_PROJECT_FILE=exports.REMOVE_PROJECT_FILE='@projectView/REMOVE_PROJECT_FILE';var UPLOAD_PROJECT_FILE=exports.UPLOAD_PROJECT_FILE='@projectView/UPLOAD_PROJECT_FILE';var RESET=exports.RESET='@projectView/RESET';var ABORT_FILE_UPLOAD=exports.ABORT_FILE_UPLOAD='@projectView/ABORT_FILE_UPLOAD';var FILTER_APARTMENTS=exports.FILTER_APARTMENTS='@projectView/FILTER_APARTMENTS';var SET_ACTIVE_ROOM_TYPE=exports.SET_ACTIVE_ROOM_TYPE='@projectView/SET_ACTIVE_ROOM_TYPE';var CLEAR=exports.CLEAR='@projectView/CLEAR';var SORT=exports.SORT='@projectView/SORT';var ACTIVATION_REQUEST=exports.ACTIVATION_REQUEST='@projectView/ACTIVATION_REQUEST';var ACTIVATION_SUCCESS=exports.ACTIVATION_SUCCESS='@projectView/ACTIVATION_SUCCESS';var ACTIVATION_FAILURE=exports.ACTIVATION_FAILURE='@projectView/ACTIVATION_FAILURE';var LINK_COPY_MESSAGE=exports.LINK_COPY_MESSAGE='@projectView/LINK_COPY_MESSAGE';var activationRequest=function activationRequest(){return{type:ACTIVATION_REQUEST};};var activationSuccess=function activationSuccess(){return _defineProperty({type:ACTIVATION_SUCCESS},_notification.ADD,{message:'Aktiveringslänk(ar) skickad(e)'});};var activationFailure=function activationFailure(error){return{type:ACTIVATION_FAILURE,error:error};};var projectRequest=function projectRequest(){return{type:PROJECT_GET_REQUEST};};var projectSuccess=function projectSuccess(project,apartmentConfigurations,apartments){return{type:PROJECT_GET_SUCCESS,project:project,apartmentConfigurations:apartmentConfigurations,apartments:apartments};};var projectFailure=function projectFailure(error){return{type:PROJECT_GET_FAILURE,error:error};};var projectCreateRequest=function projectCreateRequest(){return{type:PROJECT_CREATE_REQUEST};};var projectCreateSuccess=function projectCreateSuccess(project){return _defineProperty({type:PROJECT_CREATE_SUCCESS,project:project},_notification.ADD,{message:'Projekt "'+project.name+'" skapad'});};var projectCreateFailure=function projectCreateFailure(error){return{type:PROJECT_CREATE_FAILURE,error:error};};var projectUpdateRequest=function projectUpdateRequest(){return{type:PROJECT_UPDATE_REQUEST};};var projectUpdateSuccess=function projectUpdateSuccess(project){return _defineProperty({type:PROJECT_UPDATE_SUCCESS,project:project},_notification.ADD,{message:'Projekt uppdaterat'});};var projectUpdateFailure=function projectUpdateFailure(error){return{type:PROJECT_UPDATE_FAILURE,error:error};};var productsRequest=function productsRequest(){return{type:PRODUCTS_REQUEST};};var productsSuccess=function productsSuccess(products){return{type:PRODUCTS_SUCCESS,products:products};};var productsFailure=function productsFailure(error){return{type:PRODUCTS_FAILURE,error:error};};var roomTypesRequest=function roomTypesRequest(){return{type:ROOM_TYPES_REQUEST};};var roomTypesSuccess=function roomTypesSuccess(roomTypes){return{type:ROOM_TYPES_SUCCESS,roomTypes:roomTypes};};var roomTypesFailure=function roomTypesFailure(error){return{type:ROOM_TYPES_FAILURE,error:error};};var addProjectFile=function addProjectFile(name){return function(tempId,metadata){return{type:ADD_PROJECT_FILE,name:name,tempId:tempId,metadata:metadata};};};var addRoomTypeImage=function addRoomTypeImage(roomTypeId){return function(tempId,metadata){return{type:ADD_ROOM_TYPE_IMAGE,roomTypeId:roomTypeId,metadata:metadata};};};var linkCopied=function linkCopied(){return _defineProperty({type:LINK_COPY_MESSAGE},_notification.ADD,{message:'Länk kopierad!'});};var uploadProjectFile=exports.uploadProjectFile=function uploadProjectFile(name,file){return _defineProperty({type:UPLOAD_PROJECT_FILE,tempId:_uuid2.default.v4(),name:name},_fileUploader.FILE_UPLOAD,{file:file,success:addProjectFile(name)});};var removeProjectFile=exports.removeProjectFile=function removeProjectFile(name){return{type:REMOVE_PROJECT_FILE,name:name};};var uploadRoomTypeImage=exports.uploadRoomTypeImage=function uploadRoomTypeImage(roomTypeId,file){return _defineProperty({type:UPLOAD_ROOM_TYPE_IMAGE,tempId:_uuid2.default.v4(),roomTypeId:roomTypeId},_fileUploader.FILE_UPLOAD,{file:file,success:addRoomTypeImage(roomTypeId)});};var removeRoomTypeImage=exports.removeRoomTypeImage=function removeRoomTypeImage(fileId){return{type:REMOVE_ROOM_TYPE_IMAGE,fileId:fileId};};var abortFileUpload=exports.abortFileUpload=function abortFileUpload(tempId){return _defineProperty({type:ABORT_FILE_UPLOAD,tempId:tempId},_fileUploader.ABORT_UPLOAD,true);};var filterApartments=exports.filterApartments=function filterApartments(query){return{type:FILTER_APARTMENTS,query:query};};var setActiveRoomType=exports.setActiveRoomType=function setActiveRoomType(roomType){return{type:SET_ACTIVE_ROOM_TYPE,roomType:roomType};};var abortAllUploads=exports.abortAllUploads=function abortAllUploads(uploads,roomTypeImageUploads){return function(dispatch){(0,_forEach3.default)(function(u){return dispatch(abortFileUpload(u));},uploads);(0,_forEach3.default)(function(u){return dispatch(abortFileUpload(u));},(0,_flatten3.default)((0,_values3.default)(roomTypeImageUploads)));};};var reset=exports.reset=function reset(){return{type:RESET};};var clear=exports.clear=function clear(){return{type:CLEAR};};var fetchProject=exports.fetchProject=function fetchProject(id){return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var project,apartmentConfigurations,apartments;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(projectRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/projects/'+id},dispatch);case 4:project=_context.sent;_context.t0=_apartmentConfigView.sortByName;_context.next=8;return(0,_request.GET)({endpoint:'/projects/'+id+'/apartmentconfigs'},dispatch);case 8:_context.t1=_context.sent;apartmentConfigurations=(0,_context.t0)(_context.t1);_context.next=12;return(0,_request.GET)({endpoint:'/projects/'+id+'/apartments'},dispatch);case 12:apartments=_context.sent;dispatch(projectSuccess(project,apartmentConfigurations,apartments));_context.next=19;break;case 16:_context.prev=16;_context.t2=_context['catch'](1);dispatch(projectFailure(_context.t2));case 19:case'end':return _context.stop();}}},_callee,undefined,[[1,16]]);}));return function(_x){return _ref8.apply(this,arguments);};}();};var createProject=exports.createProject=function createProject(body){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var project;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(projectCreateRequest());_context2.prev=1;_context2.next=4;return(0,_request.POST)({endpoint:'/projects',body:body},dispatch);case 4:project=_context2.sent;dispatch(projectCreateSuccess(project));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(projectCreateFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref9.apply(this,arguments);};}();};var updateProject=exports.updateProject=function updateProject(id,body){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var project;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(projectUpdateRequest());_context3.prev=1;_context3.next=4;return(0,_request.PUT)({endpoint:'/projects/'+id,body:body},dispatch);case 4:project=_context3.sent;dispatch(projectUpdateSuccess(project));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);dispatch(projectUpdateFailure(_context3.t0));case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref10.apply(this,arguments);};}();};var fetchProducts=exports.fetchProducts=function fetchProducts(){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch){var products;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(productsRequest());_context4.prev=1;_context4.next=4;return(0,_request.GET)({endpoint:'/products?assortment='+_assortments.STANDARD},dispatch);case 4:products=_context4.sent;dispatch(productsSuccess(products));_context4.next=11;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](1);dispatch(productsFailure(_context4.t0));case 11:case'end':return _context4.stop();}}},_callee4,undefined,[[1,8]]);}));return function(_x4){return _ref11.apply(this,arguments);};}();};var fetchRoomTypes=exports.fetchRoomTypes=function fetchRoomTypes(){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch){var roomTypes;return _regenerator2.default.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(roomTypesRequest());_context5.prev=1;_context5.t0=_apartmentConfigView.sortByName;_context5.next=5;return(0,_request.GET)({endpoint:'/roomtypes'},dispatch);case 5:_context5.t1=_context5.sent;roomTypes=(0,_context5.t0)(_context5.t1);dispatch(roomTypesSuccess(roomTypes));_context5.next=13;break;case 10:_context5.prev=10;_context5.t2=_context5['catch'](1);dispatch(roomTypesFailure(_context5.t2));case 13:case'end':return _context5.stop();}}},_callee5,undefined,[[1,10]]);}));return function(_x5){return _ref12.apply(this,arguments);};}();};var sendActivationLinks=exports.sendActivationLinks=function sendActivationLinks(projectId/*: number*/){return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch){return _regenerator2.default.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch(activationRequest());_context6.prev=1;_context6.next=4;return(0,_request.POST)({endpoint:'/projects/'+projectId+'/activate',expectBody:false},dispatch);case 4:dispatch(activationSuccess());_context6.next=10;break;case 7:_context6.prev=7;_context6.t0=_context6['catch'](1);dispatch(activationFailure(_context6.t0));case 10:case'end':return _context6.stop();}}},_callee6,undefined,[[1,7]]);}));return function(_x6){return _ref13.apply(this,arguments);};}();};var notifyLinkCopied=exports.notifyLinkCopied=function notifyLinkCopied(){return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch){return _regenerator2.default.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch(linkCopied());case 1:case'end':return _context7.stop();}}},_callee7,undefined);}));return function(_x7){return _ref14.apply(this,arguments);};}();};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.updateFile=exports.reset=exports.fetchDeviations=exports.fetchProject=exports.updateApartment=exports.createApartment=exports.fetchApartment=exports.fetchApartmentConfigurations=exports.abortAllUploads=exports.abortUpload=exports.clear=exports.removeFile=exports.addFile=exports.closeApartmentDeviation=exports.openApartmentDeviation=exports.removeApartmentDeviation=exports.updateApartmentDeviation=exports.addApartmentDeviation=exports.toggleCopyDialog=exports.toggleRenameDialog=exports.deleteFile=exports.DELETE_FILE_FAILURE=exports.DELETE_FILE_SUCCESS=exports.DELETE_FILE_REQUEST=exports.TOGGLE_RENAME_DIALOG=exports.FILE_UPDATE_FAILURE=exports.FILE_UPDATE_SUCCESS=exports.FILE_UPDATE_REQUEST=exports.CLEAR=exports.RESET=exports.TOGGLE_COPY_DIALOG=exports.FILE_UPLOADED=exports.ABORT_FILE_UPLOAD=exports.REMOVE_FILE=exports.ADD_FILE=exports.CLOSE_DEVIATION=exports.OPEN_DEVIATION=exports.REMOVE_DEVIATION=exports.UPDATE_DEVIATION=exports.ADD_DEVIATION=exports.DEVIATIONS_FAILURE=exports.DEVIATIONS_SUCCESS=exports.DEVIATIONS_REQUEST=exports.CONFIGURATIONS_FAILURE=exports.CONFIGURATIONS_SUCCESS=exports.CONFIGURATIONS_REQUEST=exports.PROJECT_GET_FAILURE=exports.PROJECT_GET_SUCCESS=exports.PROJECT_GET_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _forEach2=__webpack_require__(229);var _forEach3=_interopRequireDefault(_forEach2);var _uuid=__webpack_require__(53);var _uuid2=_interopRequireDefault(_uuid);var _notification=__webpack_require__(23);var _request=__webpack_require__(6);var _fileUploader=__webpack_require__(81);var _apartmentConfigView=__webpack_require__(82);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var GET_REQUEST=exports.GET_REQUEST='@apartmentView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@apartmentView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@apartmentView/GET_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@apartmentView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@apartmentView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@apartmentView/CREATE_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@apartmentView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@apartmentView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@apartmentView/UPDATE_FAILURE';var PROJECT_GET_REQUEST=exports.PROJECT_GET_REQUEST='@apartmentView/PROJECT_GET_REQUEST';var PROJECT_GET_SUCCESS=exports.PROJECT_GET_SUCCESS='@apartmentView/PROJECT_GET_SUCCESS';var PROJECT_GET_FAILURE=exports.PROJECT_GET_FAILURE='@apartmentView/PROJECT_GET_FAILURE';var CONFIGURATIONS_REQUEST=exports.CONFIGURATIONS_REQUEST='@apartmentView/CONFIGURATIONS_REQUEST';var CONFIGURATIONS_SUCCESS=exports.CONFIGURATIONS_SUCCESS='@apartmentView/CONFIGURATIONS_SUCCESS';var CONFIGURATIONS_FAILURE=exports.CONFIGURATIONS_FAILURE='@apartmentView/CONFIGURATIONS_FAILURE';var DEVIATIONS_REQUEST=exports.DEVIATIONS_REQUEST='@apartmentView/DEVIATIONS_REQUEST';var DEVIATIONS_SUCCESS=exports.DEVIATIONS_SUCCESS='@apartmentView/DEVIATIONS_SUCCESS';var DEVIATIONS_FAILURE=exports.DEVIATIONS_FAILURE='@apartmentView/DEVIATIONS_FAILURE';var ADD_DEVIATION=exports.ADD_DEVIATION='@apartmentView/ADD_DEVIATION';var UPDATE_DEVIATION=exports.UPDATE_DEVIATION='@apartmentView/UPDATE_DEVIATION';var REMOVE_DEVIATION=exports.REMOVE_DEVIATION='@apartmentView/REMOVE_DEVIATION';var OPEN_DEVIATION=exports.OPEN_DEVIATION='@apartmentView/OPEN_DEVIATION';var CLOSE_DEVIATION=exports.CLOSE_DEVIATION='@apartmentView/CLOSE_DEVIATION';var ADD_FILE=exports.ADD_FILE='@apartmentView/ADD_FILE';var REMOVE_FILE=exports.REMOVE_FILE='@apartmentView/REMOVE_FILE';var ABORT_FILE_UPLOAD=exports.ABORT_FILE_UPLOAD='@apartmentView/ABORT_FILE_UPLOAD';var FILE_UPLOADED=exports.FILE_UPLOADED='@apartmentView/FILE_UPLOADED';var TOGGLE_COPY_DIALOG=exports.TOGGLE_COPY_DIALOG='@apartmentView/TOGGLE_COPY_DIALOG';var RESET=exports.RESET='@apartmentView/RESET';var CLEAR=exports.CLEAR='@apartmentView/CLEAR';var FILE_UPDATE_REQUEST=exports.FILE_UPDATE_REQUEST='@apartmentView/FILE_UPDATE_REQUEST';var FILE_UPDATE_SUCCESS=exports.FILE_UPDATE_SUCCESS='@apartmentView/FILE_UPDATE_SUCCESS';var FILE_UPDATE_FAILURE=exports.FILE_UPDATE_FAILURE='@apartmentView/FILE_UPDATE_FAILURE';var TOGGLE_RENAME_DIALOG=exports.TOGGLE_RENAME_DIALOG='@apartmentView/TOGGLE_RENAME_DIALOG';var DELETE_FILE_REQUEST=exports.DELETE_FILE_REQUEST='@apartmentView/DELETE_FILE_REQUEST';var DELETE_FILE_SUCCESS=exports.DELETE_FILE_SUCCESS='@apartmentView/DELETE_FILE_SUCCESS';var DELETE_FILE_FAILURE=exports.DELETE_FILE_FAILURE='@apartmentView/DELETE_FILE_FAILURE';var deleteFileRequest=function deleteFileRequest(){return{type:DELETE_FILE_REQUEST};};var deleteFileSuccess=function deleteFileSuccess(apartment/*: any*/){return{type:DELETE_FILE_SUCCESS,apartment:apartment};};var deleteFileFailure=function deleteFileFailure(error/*: any*/){return{type:DELETE_FILE_FAILURE,error:error};};var deleteFile=exports.deleteFile=function deleteFile(apartmentId/*: number*/,file/*: any*/){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var apartment;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(deleteFileRequest());_context.prev=1;_context.next=4;return(0,_request.DELETE)({endpoint:'/files/'+file.id},dispatch);case 4:_context.next=6;return(0,_request.GET)({endpoint:'/apartments/'+apartmentId},dispatch);case 6:apartment=_context.sent;dispatch(deleteFileSuccess(apartment));_context.next=13;break;case 10:_context.prev=10;_context.t0=_context['catch'](1);dispatch(deleteFileFailure(_context.t0));case 13:case'end':return _context.stop();}}},_callee,undefined,[[1,10]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var updateFileRequest=function updateFileRequest(){return{type:FILE_UPDATE_REQUEST};};var updateFileSuccess=function updateFileSuccess(name/*: 'contract' | 'floorPlan' | 'kitchenPlan'*/,metadata){return{type:FILE_UPDATE_SUCCESS,name:name,metadata:metadata};};var updateFileFailure=function updateFileFailure(error){return{type:FILE_UPDATE_FAILURE,error:error};};var toggleRenameDialog=exports.toggleRenameDialog=function toggleRenameDialog(show/*: false | 'contract' | 'floorPlan' | 'kitchenPlan'*/){return{type:TOGGLE_RENAME_DIALOG,show:show};};var apartmentRequest=function apartmentRequest(){return{type:GET_REQUEST};};var apartmentSuccess=function apartmentSuccess(apartment,project,apartmentConfigurations){return{type:GET_SUCCESS,apartment:apartment,project:project};};var apartmentFailure=function apartmentFailure(error){return{type:GET_FAILURE,error:error};};var apartmentCreateRequest=function apartmentCreateRequest(){return{type:CREATE_REQUEST};};var apartmentCreateSuccess=function apartmentCreateSuccess(apartment){return _defineProperty({type:CREATE_SUCCESS,apartment:apartment},_notification.ADD,{message:'Lägenhet skapad'});};var apartmentCreateFailure=function apartmentCreateFailure(error){return{type:CREATE_FAILURE,error:error};};var apartmentUpdateRequest=function apartmentUpdateRequest(){return{type:UPDATE_REQUEST};};var apartmentUpdateSuccess=function apartmentUpdateSuccess(apartment){return _defineProperty({type:UPDATE_SUCCESS,apartment:apartment},_notification.ADD,{message:'Lägenhet uppdaterad'});};var apartmentUpdateFailure=function apartmentUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var projectRequest=function projectRequest(){return{type:PROJECT_GET_REQUEST};};var projectSuccess=function projectSuccess(project){return{type:PROJECT_GET_SUCCESS,project:project};};var projectFailure=function projectFailure(error){return{type:PROJECT_GET_FAILURE,error:error};};var deviationsRequest=function deviationsRequest(){return{type:DEVIATIONS_REQUEST};};var deviationsSuccess=function deviationsSuccess(deviations){return{type:DEVIATIONS_SUCCESS,deviations:deviations};};var deviationsFailure=function deviationsFailure(error){return{type:DEVIATIONS_FAILURE,error:error};};var apartmentConfigurationsRequest=function apartmentConfigurationsRequest(){return{type:CONFIGURATIONS_REQUEST};};var apartmentConfigurationsSuccess=function apartmentConfigurationsSuccess(apartmentConfigurations){return{type:CONFIGURATIONS_SUCCESS,apartmentConfigurations:apartmentConfigurations};};var apartmentConfigurationsFailure=function apartmentConfigurationsFailure(error){return{type:CONFIGURATIONS_FAILURE,error:error};};var fileUploaded=function fileUploaded(name){return function(tempId,metadata){return{type:FILE_UPLOADED,name:name,tempId:tempId,metadata:metadata};};};var toggleCopyDialog=exports.toggleCopyDialog=function toggleCopyDialog(show){return{type:TOGGLE_COPY_DIALOG,show:show};};var addApartmentDeviation=exports.addApartmentDeviation=function addApartmentDeviation(deviation){return{type:ADD_DEVIATION,deviation:deviation};};var updateApartmentDeviation=exports.updateApartmentDeviation=function updateApartmentDeviation(deviationId,data){return{type:UPDATE_DEVIATION,deviationId:deviationId,data:data};};var removeApartmentDeviation=exports.removeApartmentDeviation=function removeApartmentDeviation(deviationId){return{type:REMOVE_DEVIATION,deviationId:deviationId};};var openApartmentDeviation=exports.openApartmentDeviation=function openApartmentDeviation(deviation){return{type:OPEN_DEVIATION,deviation:deviation};};var closeApartmentDeviation=exports.closeApartmentDeviation=function closeApartmentDeviation(){return{type:CLOSE_DEVIATION};};var addFile=exports.addFile=function addFile(name,file){return _defineProperty({type:ADD_FILE,tempId:_uuid2.default.v4(),name:name},_fileUploader.FILE_UPLOAD,{file:file,success:fileUploaded(name)});};var removeFile=exports.removeFile=function removeFile(name){return{type:REMOVE_FILE,name:name};};var clear=exports.clear=function clear(){return{type:CLEAR};};var abortUpload=exports.abortUpload=function abortUpload(tempId){return _defineProperty({type:ABORT_FILE_UPLOAD,tempId:tempId},_fileUploader.ABORT_UPLOAD,true);};var abortAllUploads=exports.abortAllUploads=function abortAllUploads(uploads){return function(dispatch){(0,_forEach3.default)(function(u){return dispatch(abortUpload(u));},uploads);};};var fetchApartmentConfigurations=exports.fetchApartmentConfigurations=function fetchApartmentConfigurations(projectId){var apartmentConfigId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var apartmentConfigurations,apartmentConfig;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(apartmentConfigurationsRequest());_context2.prev=1;_context2.next=4;return(0,_request.GET)({endpoint:'/projects/'+projectId+'/apartmentconfigs'},dispatch);case 4:apartmentConfigurations=_context2.sent;if(!(!!apartmentConfigId&&!(0,_some3.default)(function(x){return x.id===apartmentConfigId;},apartmentConfigurations))){_context2.next=10;break;}_context2.next=8;return(0,_request.GET)({endpoint:'/apartmentconfigs/'+apartmentConfigId},dispatch);case 8:apartmentConfig=_context2.sent;if(!!apartmentConfig){apartmentConfigurations=[].concat(_toConsumableArray(apartmentConfigurations),[apartmentConfig]);}case 10:dispatch(apartmentConfigurationsSuccess((0,_apartmentConfigView.sortByName)(apartmentConfigurations)));_context2.next=16;break;case 13:_context2.prev=13;_context2.t0=_context2['catch'](1);dispatch(apartmentConfigurationsFailure(_context2.t0));case 16:case'end':return _context2.stop();}}},_callee2,undefined,[[1,13]]);}));return function(_x3){return _ref6.apply(this,arguments);};}();};var fetchApartment=exports.fetchApartment=function fetchApartment(id){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var apartment,project;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(apartmentRequest());_context3.prev=1;_context3.next=4;return(0,_request.GET)({endpoint:'/apartments/'+id},dispatch);case 4:apartment=_context3.sent;_context3.next=7;return(0,_request.GET)({endpoint:'/projects/'+apartment.projectId},dispatch);case 7:project=_context3.sent;dispatch(fetchApartmentConfigurations(project.id,apartment.apartmentConfigId));dispatch(apartmentSuccess(apartment,project));_context3.next=15;break;case 12:_context3.prev=12;_context3.t0=_context3['catch'](1);dispatch(apartmentFailure(_context3.t0));case 15:case'end':return _context3.stop();}}},_callee3,undefined,[[1,12]]);}));return function(_x4){return _ref7.apply(this,arguments);};}();};var createApartment=exports.createApartment=function createApartment(projectId,body){return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch){var apartment;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(apartmentCreateRequest());_context4.prev=1;_context4.next=4;return(0,_request.POST)({endpoint:'/projects/'+projectId+'/apartments',body:body},dispatch);case 4:apartment=_context4.sent;dispatch(apartmentCreateSuccess(apartment));_context4.next=11;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](1);dispatch(apartmentCreateFailure(_context4.t0));case 11:case'end':return _context4.stop();}}},_callee4,undefined,[[1,8]]);}));return function(_x5){return _ref8.apply(this,arguments);};}();};var updateApartment=exports.updateApartment=function updateApartment(id,body){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch){var apartment;return _regenerator2.default.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(apartmentUpdateRequest());_context5.prev=1;_context5.next=4;return(0,_request.PUT)({endpoint:'/apartments/'+id,body:body},dispatch);case 4:apartment=_context5.sent;dispatch(apartmentUpdateSuccess(apartment));_context5.next=11;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](1);dispatch(apartmentUpdateFailure(_context5.t0));case 11:case'end':return _context5.stop();}}},_callee5,undefined,[[1,8]]);}));return function(_x6){return _ref9.apply(this,arguments);};}();};var fetchProject=exports.fetchProject=function fetchProject(id){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch){var project;return _regenerator2.default.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch(projectRequest());_context6.prev=1;_context6.next=4;return(0,_request.GET)({endpoint:'/projects/'+id},dispatch);case 4:project=_context6.sent;dispatch(projectSuccess(project));_context6.next=11;break;case 8:_context6.prev=8;_context6.t0=_context6['catch'](1);dispatch(projectFailure(_context6.t0));case 11:case'end':return _context6.stop();}}},_callee6,undefined,[[1,8]]);}));return function(_x7){return _ref10.apply(this,arguments);};}();};var fetchDeviations=exports.fetchDeviations=function fetchDeviations(){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch){var deviations;return _regenerator2.default.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch(deviationsRequest());_context7.prev=1;_context7.next=4;return(0,_request.GET)({endpoint:'/deviations'},dispatch);case 4:deviations=_context7.sent;dispatch(deviationsSuccess(deviations));_context7.next=11;break;case 8:_context7.prev=8;_context7.t0=_context7['catch'](1);dispatch(deviationsFailure(_context7.t0));case 11:case'end':return _context7.stop();}}},_callee7,undefined,[[1,8]]);}));return function(_x8){return _ref11.apply(this,arguments);};}();};var reset=exports.reset=function reset(){return{type:RESET};};var updateFile=exports.updateFile=function updateFile(id,name/*: 'contract' | 'floorPlan' | 'kitchenPlan'*/,body){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch){var file;return _regenerator2.default.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch(updateFileRequest());_context8.prev=1;_context8.next=4;return(0,_request.PUT)({endpoint:'/files/'+id,body:body},dispatch);case 4:file=_context8.sent;dispatch(updateFileSuccess(name,file));_context8.next=11;break;case 8:_context8.prev=8;_context8.t0=_context8['catch'](1);dispatch(updateFileFailure(_context8.t0));case 11:case'end':return _context8.stop();}}},_callee8,undefined,[[1,8]]);}));return function(_x9){return _ref12.apply(this,arguments);};}();};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getParentConfig=exports.groupSlots=undefined;var _head2=__webpack_require__(237);var _head3=_interopRequireDefault(_head2);var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _overEvery2=__webpack_require__(903);var _overEvery3=_interopRequireDefault(_overEvery2);var _includes2=__webpack_require__(97);var _includes3=_interopRequireDefault(_includes2);var _uniq2=__webpack_require__(231);var _uniq3=_interopRequireDefault(_uniq2);var _keyBy2=__webpack_require__(167);var _keyBy3=_interopRequireDefault(_keyBy2);var _every2=__webpack_require__(238);var _every3=_interopRequireDefault(_every2);var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _groupBy2=__webpack_require__(168);var _groupBy3=_interopRequireDefault(_groupBy2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _sum2=__webpack_require__(908);var _sum3=_interopRequireDefault(_sum2);var _reduce2=__webpack_require__(123);var _reduce3=_interopRequireDefault(_reduce2);var _sumBy2=__webpack_require__(121);var _sumBy3=_interopRequireDefault(_sumBy2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _toLower2=__webpack_require__(65);var _toLower3=_interopRequireDefault(_toLower2);var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _isNil2=__webpack_require__(166);var _isNil3=_interopRequireDefault(_isNil2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _values2=__webpack_require__(67);var _values3=_interopRequireDefault(_values2);var _startsWith2=__webpack_require__(913);var _startsWith3=_interopRequireDefault(_startsWith2);var _pickBy2=__webpack_require__(915);var _pickBy3=_interopRequireDefault(_pickBy2);var _flatMap2=__webpack_require__(54);var _flatMap3=_interopRequireDefault(_flatMap2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _customerOrderView=__webpack_require__(393);var _customerView=__webpack_require__(170);var _uuid=__webpack_require__(53);var _uuid2=_interopRequireDefault(_uuid);var _configTemplateView=__webpack_require__(124);var _orderView=__webpack_require__(395);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}/*:: import type {Exact} from './configTemplateView';*//*:: import type {
  OrderRowDto,
  ProductSlotDto,
  ProductSlotConfigDto,
} from '../dtos';*//*:: type ActiveSelectionState = {
  additional: bool,
  room: ?any,
  slot: ?any,
  orderRow: ?any,
  config: ?any,
  parentConfig: ?any,
  canChoose: bool,
};*//*:: type OrderRowsBySlotIdState = {
  [key: string]: any,
};*//*:: type OrderRowsState = {
  bySlotId: OrderRowsBySlotIdState,
  isFetching: bool,
  error: ?any,
};*//*:: type ExtraRowsState = {
  isFetching: bool,
  list: any[],
};*//*:: type CustomRowsState = {
  isFetching: bool,
  list: any[],
};*//*:: type PaginationState = {
  page: number,
  perPage: number,
  showAll: bool,
};*//*:: type ProductState = {
  activeImage: ?any,
  activeProduct: ?any,
  activeVariant: ?any,
  show: bool,
};*//*:: type ProductsState = {
  isFetching: bool,
  list: any[],
  error: ?any,
  products: any[],
};*//*:: type AdditionalPriceState = {
  open: boolean,
  price: number,
};*//*:: type PricesState = {
  roomPrices: any[],
  additionalTotalPrice: AdditionalPriceState,
  discount: number,
  total: number,
  open: boolean,
};*//*:: type RoomsExpandedState = {
  [key: string]: bool,
};*//*:: type RoomsState = {
  expanded: RoomsExpandedState,
  list: any[],
  isFetching: bool,
};*//*:: export type State_ = {
  activeSelection: ActiveSelectionState,
  help: bool,
  menuVisibility: bool,
  orderComplete: bool,
  orderRows: OrderRowsState,
  extraRows: ExtraRowsState,
  customRows: CustomRowsState,
  pagination: PaginationState,
  product: ProductState,
  products: ProductsState,
  prices: PricesState,
  rooms: RoomsState,
};*//*:: type State = {
  activeSelection: Exact<ActiveSelectionState>,
  help: bool,
  menuVisibility: bool,
  orderComplete: bool,
  orderRows: Exact<OrderRowsState>,
  extraRows: Exact<ExtraRowsState>,
  customRows: Exact<CustomRowsState>,
  pagination: Exact<PaginationState>,
  product: Exact<ProductState>,
  products: Exact<ProductsState>,
  prices: Exact<PricesState>,
  rooms: Exact<RoomsState>,
};*/var getProductSlotsPrice=function getProductSlotsPrice(rowsBySlotId,productSlots){return(0,_flow3.default)((0,_flatMap3.default)(function(slot){return(0,_flow3.default)((0,_pickBy3.default)(function(x,k/*: string*/){return(0,_startsWith3.default)(slot.id+'_',k);}),_values3.default,(0,_map3.default)(function(existingRow){return{id:existingRow.id,name:existingRow.productName+' - '+existingRow.productVariantName,totalPrice:!(0,_isNil3.default)(existingRow.orderedPrice)&&!(0,_isNil3.default)(existingRow.orderedQuantity)?existingRow.orderedPrice*existingRow.orderedQuantity:existingRow.price*existingRow.quantity};}))(rowsBySlotId);}),(0,_sortBy3.default)([function(x){return(0,_toLower3.default)(x.name);}]))(productSlots);};var getTotalExtraRowPriceByRoomId=function getTotalExtraRowPriceByRoomId(roomId,extraRows){var currentExtraRows=(0,_filter3.default)({roomId:roomId},extraRows);return(0,_sumBy3.default)(function(extraRow){var isOrdered=!(0,_isNil3.default)(extraRow.orderedPrice);var price=isOrdered?extraRow.orderedPrice:extraRow.price;return price*extraRow.quantity;},currentExtraRows);};var getRoomPrice=function getRoomPrice(room,bySlotId,extraRows){var orderRows=getProductSlotsPrice(bySlotId,room.productSlots);var totalExtraPrice=getTotalExtraRowPriceByRoomId(room.id,extraRows);return{orderRows:orderRows,totalExtraPrice:totalExtraPrice,totalPrice:(0,_sumBy3.default)(function(x){return x.totalPrice;},orderRows)+totalExtraPrice};};var getOrderPrice=function getOrderPrice(rooms,bySlotId,extraRows,discount){var customRows=arguments.length>4&&arguments[4]!==undefined?arguments[4]:[];var roomPrices=(0,_reduce3.default)(function(roomPrices,room){return _extends({},roomPrices,_defineProperty({},room.id,getRoomPrice(room,bySlotId,extraRows)));},{},rooms);var roomTotalPrice=(0,_flow3.default)(_values3.default,(0,_map3.default)(function(x){return x.totalPrice;}),_sum3.default)(roomPrices);var additionalTotalPrice=(0,_sumBy3.default)(function(x){return x.totalSellingPrice;},customRows);var totalPrice=Math.round(roomTotalPrice+additionalTotalPrice);var finalPrice=Math.round(Math.max(totalPrice-discount,0));return{roomPrices:roomPrices,additionalTotalPrice:{open:false,price:additionalTotalPrice},totalPrice:finalPrice};};var formatRoomPrices=function formatRoomPrices(pricesByRoomId){return(0,_map3.default)(function(_ref){var id=_ref.id,name=_ref.name;return{id:id,name:name,open:false,prices:pricesByRoomId[id]};});};var values/*: (x: {
  [key: number]: ProductSlotConfigDto[],
}) => ProductSlotConfigDto[][]*/=_values3.default;var buildConfigTree=function buildConfigTree(slot/*: ProductSlotDto*/,config/*: ProductSlotConfigDto[]*/,orderRows/*: OrderRowDto[]*/){var parents/*: $Shape<ProductSlotConfigDto>[]*/=arguments.length>3&&arguments[3]!==undefined?arguments[3]:[{id:-1}];return(0,_flow3.default)((0,_map3.default)(function(c){return{config:c,parent:(0,_find3.default)({id:c.parentId||-1},parents)};}),(0,_filter3.default)(function(x){return!!x.parent&&(x.parent.id===-1||(0,_some3.default)({id:x.config.productVariant.id},x.parent.productVariant.related)||!!(0,_find3.default)({productSlotId:x.config.productSlotId,parentConfigId:x.parent.id,productTypeId:x.config.productType.id,configId:x.config.id},orderRows));}),(0,_map3.default)(function(x){return _extends({},x.config,{productType:!!x.parent&&x.parent.id===-1&&x.config.productType.id!==slot.productTypeId?{id:slot.productTypeId,name:slot.name,archived:null}:x.config.productType});}),(0,_groupBy3.default)(function(x){return x.productType.id;}),values,(0,_sortBy3.default)([function(_ref2){var _ref3=_toArray(_ref2),name=_ref3[0].productType.name,tail=_ref3.slice(1);return name;}]),(0,_map3.default)(function(_ref4){var _ref5=_toArray(_ref4),head=_ref5[0],tail=_ref5.slice(1);return _extends({},head.productType,{uuid:_uuid2.default.v4(),configs:[head].concat(_toConsumableArray(tail)),children:buildConfigTree(slot,config,orderRows,[head].concat(_toConsumableArray(tail)))});}))(config);};var mapConfigTree=function mapConfigTree(orderRows){return(0,_map3.default)(function(r){return _extends({},r,{productSlots:(0,_map3.default)(function(s){return _extends({},s,{configTree:!!s.advanced?buildConfigTree(s,s.config,orderRows):s.config});})(r.productSlots)});});};var calculateIsOptional=function calculateIsOptional(productSlots)/*: bool*/{return!(0,_isEmpty3.default)(productSlots)&&(0,_every3.default)(function(p){return!p.advanced?!p.defaultProductId:!p.standardProductId&&(0,_every3.default)(function(c){return(0,_isEmpty3.default)(c.standardProducts);},p.config);},productSlots);};var calculateAdvancedComplete=function calculateAdvancedComplete(bySlotId,slotId,productType,standardProductId,parentId){var orderRow=bySlotId[slotId+'_'+(parentId||'')+'_'+productType.id];if(!!standardProductId&&!orderRow){return false;}if(!!orderRow){var _config=(0,_find3.default)({id:orderRow.configId},productType.configs);if(!!_config.standardProducts.length){var requiredChildren=(0,_flow3.default)((0,_map3.default)(function(x){return{type:x,standardProduct:(0,_find3.default)({productTypeId:x.id},_config.standardProducts)};}),(0,_filter3.default)(function(x){return!!x.standardProduct&&(0,_some3.default)({productTypeId:x.standardProduct.productTypeId},_config.productVariant.related);}))(productType.children);return!requiredChildren.length||(0,_every3.default)(function(x){return calculateAdvancedComplete(bySlotId,slotId,x.type,x.standardProduct.productId,_config.id);},requiredChildren);}}return true;};var calculateIsComplete=function calculateIsComplete(bySlotId,isOptional,productSlots)/*: bool*/{return(0,_every3.default)(function(slot){if(!!slot.advanced&&!!slot.configTree.length){return calculateAdvancedComplete(bySlotId,slot.id,slot.configTree[0],slot.standardProductId,null);}else{return!!bySlotId[slot.id+'__']||!!isOptional||!slot.defaultProductId;}},productSlots);};var mapStatusFlags=function mapStatusFlags(bySlotId){return(0,_map3.default)(function(r){var isOptional=calculateIsOptional(r.productSlots);var isComplete=calculateIsComplete(bySlotId,isOptional,r.productSlots);return _extends({},r,{isComplete:isComplete,isOptional:isOptional});});};var groupSlots/*: any[] => OrderRowsBySlotIdState*/=exports.groupSlots=(0,_keyBy3.default)(function(r){return r.productSlotId+'_'+(r.parentConfigId||'')+'_'+(r.productTypeId||'');});var defaultActiveSelectionState={room:null,slot:null,orderRow:null,config:null,parentConfig:null,canChoose:false,additional:false};var defaultOrderRows={bySlotId:{},isFetching:false,error:null};var defaultExtraOrderRows={list:[],isFetching:false};var defaultCustomOrderRows={list:[],isFetching:false};var defaultPagination={page:1,perPage:12,showAll:true};var defaultProductState={activeImage:null,activeProduct:null,activeVariant:null,show:false};var defaultProductsState={isFetching:false,list:[],error:null,products:[]};var defaultAdditionalPriceState={open:false,price:0};var defaultPrices={roomPrices:[],additionalTotalPrice:defaultAdditionalPriceState,discount:0,total:0,open:false};var defaultRoomsState={expanded:{},list:[],isFetching:false};var defaultCustomerOrderViewState={activeSelection:defaultActiveSelectionState,help:false,menuVisibility:true,orderComplete:false,orderRows:defaultOrderRows,extraRows:defaultExtraOrderRows,customRows:defaultCustomOrderRows,pagination:defaultPagination,product:defaultProductState,products:defaultProductsState,prices:defaultPrices,rooms:defaultRoomsState};var getParentConfig=exports.getParentConfig=function getParentConfig(bySlotId/*: OrderRowsBySlotIdState*/,productType/*: ?any*/,slot/*: ?any*/)/*: ?any*/{if(!!productType&&!!slot){var parentIds=(0,_flow3.default)((0,_map3.default)('parentId'),_uniq3.default)(productType.configs);var parentRow=(0,_find3.default)(function(r){return(0,_includes3.default)(r.configId,parentIds);},bySlotId);if(!!parentRow){return(0,_find3.default)({id:parentRow.configId},slot.config);}}return null;};var getCurrentRow=function getCurrentRow(rows/*: any[]*/,activeSelection/*: ActiveSelectionState*/)/*: ?any*/{var slot=activeSelection.slot,config=activeSelection.config;return!!slot?!!config?(0,_find3.default)(function(r){return r.productSlotId===slot.id&&(0,_some3.default)({id:r.configId},config.configs);},rows):(0,_find3.default)({productSlotId:slot.id},rows):null;};var sortIdToTop=function sortIdToTop(id){return(0,_sortBy3.default)([function(i){return i.id!==id;}]);};var sortIdsToTop=function sortIdsToTop(ids){return(0,_sortBy3.default)([function(_ref6){var id=_ref6.id;return!(0,_includes3.default)(id,ids);}]);};var sortByMainVariantItemNumber=(0,_sortBy3.default)([function(i){var mainVariant=(0,_find3.default)({id:i.mainVariantId},i.variants);return mainVariant?(0,_toLower3.default)(mainVariant.itemNumber):'';}]);var sortByItemNumber=(0,_sortBy3.default)([function(i){return(0,_toLower3.default)(i.itemNumber);}]);var sortWithConfig=function sortWithConfig(parentConfig,type){return(0,_sortBy3.default)([function(x){return!type||!(0,_find3.default)({parentId:!!parentConfig?parentConfig.id:null,productVariantId:x.variant.id},type.configs);}]);};var sortAndMapVariants=function sortAndMapVariants(products/*: any[]*/,slot/*: any*/,productType/*: ?any*/,parentConfig/*: ?any*/,orderRow/*: ?any*/)/*: any[]*/{var type=productType;return(0,_flow3.default)(sortByMainVariantItemNumber,!!slot.advanced?!!parentConfig?sortIdsToTop((0,_map3.default)('productId',parentConfig.standardProducts)):sortIdToTop(slot.standardProductId):sortIdToTop(slot.defaultProductId),(0,_map3.default)(function(p){return _extends({},p,{variants:(0,_flow3.default)(sortByItemNumber,sortIdToTop(p.mainVariantId))(p.variants)});}),(0,_flatMap3.default)(function(product){return(0,_map3.default)(function(variant){return{variant:variant,product:product};},product.variants);}),(0,_filter3.default)((0,_overEvery3.default)([function(_ref7){var variant=_ref7.variant;return!slot.advanced||!type||(0,_some3.default)({productVariantId:variant.id},type.configs);},function(_ref8){var product=_ref8.product,variant=_ref8.variant;if(!product.archived&&!variant.archived||!!variant.replacement){return true;}if(!!orderRow){if(!!orderRow.advanced&&!!type){var rowConfig=(0,_find3.default)({id:orderRow.configId},type.configs);return!!rowConfig&&rowConfig.productVariantId===variant.id;}else if(!orderRow.advanced&&orderRow.productVariantId===variant.id){return true;}}return false;}])),!!slot.advanced?sortWithConfig(parentConfig,type):_identity3.default)(products);};var closePrices=function closePrices(prices){return{open:false,roomPrices:(0,_map3.default)(function(x){return _extends({},x,{open:false});},prices.roomPrices),additionalTotalPrice:_extends({},prices.additionalTotalPrice,{open:false})};};var customerOrderView=function customerOrderView()/*: State*/{var state/*: State_*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultCustomerOrderViewState;var action/*: any*/=arguments[1];switch(action.type){case _customerOrderView.SELECT_REQUEST:{var _orderRow=!action.productType?state.orderRows.bySlotId[action.slot.id+'__']:(0,_find3.default)(function(r){return r.productSlotId===action.slot.id&&(0,_some3.default)({id:r.configId},action.productType.configs);},state.orderRows.bySlotId);var _parentConfig=getParentConfig(state.orderRows.bySlotId,action.productType,action.slot);var _canChoose=!!_parentConfig||!!action.productType&&(0,_some3.default)({parentId:null},action.productType.configs);return _extends({},state,{activeSelection:_extends({},state.activeSelection,{orderRow:_orderRow,room:action.room,slot:action.slot,config:action.productType||null,parentConfig:_parentConfig,canChoose:_canChoose,additional:false}),products:_extends({},state.products,{error:null,isFetching:true,list:[],products:[]}),prices:_extends({},state.prices,closePrices(state.prices))});}case _customerOrderView.SELECT_FAILURE:return _extends({},state,{products:_extends({},state.products,{error:action.error,isFetching:false})});case _customerOrderView.SET_SELECTION:case _customerOrderView.SET_ADVANCED_SELECTION:return _extends({},state,{menuVisibility:false,pagination:defaultPagination,products:_extends({},state.products,{error:null,isFetching:false,list:sortAndMapVariants(action.products,action.slot,state.activeSelection.config,state.activeSelection.parentConfig,state.activeSelection.orderRow),products:action.products})});case _customerOrderView.SET_ADDITIONAL_SELECTION:return _extends({},state,{menuVisibility:false,activeSelection:_extends({},defaultActiveSelectionState,{additional:true})});case _customerOrderView.OPEN_PRODUCT:return _extends({},state,{product:_extends({},state.product,{activeImage:(0,_find3.default)('isDefault',action.variant.images)||(0,_head3.default)(action.variant.images)||null,activeProduct:action.product||null,activeVariant:action.variant||null,show:true}),prices:_extends({},state.prices,closePrices(state.prices))});case _customerOrderView.CLOSE_PRODUCT:return _extends({},state,{product:_extends({},state.product,{activeProduct:null,activeVariant:null,show:false})});case _customerOrderView.SELECT_IMAGE:return _extends({},state,{product:_extends({},state.product,{activeImage:action.image})});case _customerOrderView.TOGGLE_ROOM:return _extends({},state,{rooms:_extends({},state.rooms,{expanded:_defineProperty({},action.roomId,action.expanded)}),prices:_extends({},state.prices,closePrices(state.prices))});case _customerOrderView.SET_PAGE:return _extends({},state,{pagination:_extends({},state.pagination,{page:action.page}),prices:_extends({},state.prices,closePrices(state.prices))});case _customerOrderView.SHOW_ALL:return _extends({},state,{pagination:_extends({},state.pagination,{showAll:true}),prices:_extends({},state.prices,closePrices(state.prices))});case _customerOrderView.ORDER_DATA_GET_REQUEST:{var _list=[];var orderPrice=getOrderPrice(_list,state.orderRows.bySlotId,state.extraRows.list,action.order.discount);return _extends({},state,{orderComplete:false,orderRows:_extends({},state.orderRows,{error:null,isFetching:true}),rooms:_extends({},state.rooms,{isFetching:true,list:_list}),prices:_extends({},state.prices,{open:false,discount:action.order.discount,roomPrices:formatRoomPrices(orderPrice.roomPrices)(_list),additionalTotalPrice:orderPrice.additionalTotalPrice,total:orderPrice.totalPrice})});}case _customerOrderView.ORDER_DATA_GET_SUCCESS:{var _bySlotId=groupSlots(action.orderRows);var _list2=(0,_flow3.default)(_configTemplateView.sortRoomList,mapConfigTree(action.orderRows),mapStatusFlags(_bySlotId))(action.apartmentConfig.rooms);var _orderPrice=getOrderPrice(_list2,_bySlotId,action.extraRows,state.prices.discount,action.customRows);return _extends({},state,{orderComplete:(0,_orderView.calculateOrderCompleteState)(_bySlotId,_list2,action.orderRows),customRows:_extends({},state.customRows,{isFetching:false,list:action.customRows}),extraRows:_extends({},state.extraRows,{isFetching:false,list:action.extraRows}),orderRows:_extends({},state.orderRows,{bySlotId:_bySlotId,error:null,isFetching:false}),rooms:_extends({},state.rooms,{isFetching:false,list:_list2}),prices:_extends({},state.prices,{roomPrices:formatRoomPrices(_orderPrice.roomPrices)(_list2),additionalTotalPrice:_orderPrice.additionalTotalPrice,total:_orderPrice.totalPrice})});}case _customerOrderView.ORDER_DATA_GET_FAILURE:return _extends({},state,{orderRows:_extends({},state.orderRows,{error:action.error,isFetching:false}),rooms:_extends({},state.rooms,{isFetching:false})});case _customerOrderView.ORDER_ROW_CREATE_REQUEST:case _customerOrderView.ORDER_ROW_UPDATE_REQUEST:case _customerOrderView.ORDER_ROW_REMOVE_REQUEST:case _customerOrderView.ORDER_ROWS_UPDATE_REQUEST:case _customerOrderView.ORDER_ROWS_CLEAR_REQUEST:return _extends({},state,{orderRows:_extends({},state.orderRows,{error:null,isFetching:true}),prices:_extends({},state.prices,closePrices(state.prices))});case _customerOrderView.ORDER_ROW_CREATE_SUCCESS:case _customerOrderView.ORDER_ROW_UPDATE_SUCCESS:case _customerOrderView.ORDER_ROW_REMOVE_SUCCESS:case _customerOrderView.ORDER_ROWS_UPDATE_SUCCESS:{var _bySlotId2=groupSlots(action.rows);var _list3=mapStatusFlags(_bySlotId2)(state.rooms.list);var _orderPrice2=getOrderPrice(_list3,_bySlotId2,state.extraRows.list,state.prices.discount,state.customRows.list);var _parentConfig2=getParentConfig(_bySlotId2,state.activeSelection.config,state.activeSelection.slot);var _canChoose2=!!_parentConfig2||!!state.activeSelection.config&&(0,_some3.default)({parentId:null},state.activeSelection.config.configs);var _orderRow2=action.row||getCurrentRow(action.rows,state.activeSelection);return _extends({},state,{activeSelection:_extends({},state.activeSelection,{orderRow:_orderRow2,parentConfig:_parentConfig2,canChoose:_canChoose2}),orderComplete:(0,_orderView.calculateOrderCompleteState)(_bySlotId2,_list3,action.rows),orderRows:_extends({},state.orderRows,{bySlotId:_bySlotId2,error:null,isFetching:false}),rooms:_extends({},state.rooms,{isFetching:false,list:_list3}),prices:_extends({},state.prices,{roomPrices:formatRoomPrices(_orderPrice2.roomPrices)(_list3),additionalTotalPrice:_orderPrice2.additionalTotalPrice,total:_orderPrice2.totalPrice}),product:_extends({},state.product,{activeProduct:null,activeVariant:null,show:false}),products:_extends({},state.products,{list:sortAndMapVariants(state.products.products,state.activeSelection.slot||{},state.activeSelection.config,_parentConfig2,_orderRow2)})});}case _customerOrderView.ORDER_ROWS_CLEAR_SUCCESS:{var rowsById=defaultOrderRows.bySlotId;var _extraRows=[];var _list4=mapStatusFlags(rowsById)(state.rooms.list);var _orderPrice3=getOrderPrice(_list4,rowsById,_extraRows,state.prices.discount,state.customRows.list);return _extends({},state,{extraRows:defaultExtraOrderRows,activeSelection:defaultActiveSelectionState,orderComplete:(0,_orderView.calculateOrderCompleteState)(rowsById,_list4,[]),orderRows:defaultOrderRows,rooms:_extends({},state.rooms,{expanded:defaultRoomsState.expanded,isFetching:false,list:_list4}),prices:_extends({},state.prices,{roomPrices:formatRoomPrices(_orderPrice3.roomPrices)(_list4),additionalTotalPrice:_orderPrice3.additionalTotalPrice,total:_orderPrice3.totalPrice}),product:defaultProductState,products:defaultProductsState});}case _customerOrderView.ORDER_ROW_CREATE_FAILURE:case _customerOrderView.ORDER_ROW_UPDATE_FAILURE:case _customerOrderView.ORDER_ROW_REMOVE_FAILURE:case _customerOrderView.ORDER_ROWS_UPDATE_FAILURE:case _customerOrderView.ORDER_ROWS_CLEAR_FAILURE:return _extends({},state,{orderRows:_extends({},state.orderRows,{error:action.error,isFetching:false})});case _customerOrderView.SEND_EMAIL_SUCCESS:case _customerOrderView.SEND_EMAIL_FAILURE:return _extends({},state,{help:false});case _customerOrderView.TOGGLE_MENU:return _extends({},state,{menuVisibility:!!action.show});case _customerOrderView.TOGGLE_HELP:return _extends({},state,{help:!!action.show,prices:_extends({},state.prices,closePrices(state.prices))});case _customerView.UPDATE_SUCCESS:{var _bySlotId3=groupSlots(action.order.rows);var _list5=mapStatusFlags(_bySlotId3)(state.rooms.list);var _orderPrice4=getOrderPrice(_list5,_bySlotId3,state.extraRows.list,state.prices.discount,state.customRows.list);return _extends({},state,{activeSelection:defaultActiveSelectionState,orderComplete:(0,_orderView.calculateOrderCompleteState)(_bySlotId3,_list5,action.order.rows),orderRows:_extends({},state.orderRows,{bySlotId:_bySlotId3}),rooms:_extends({},state.rooms,{list:_list5}),prices:_extends({},state.prices,{open:false,roomPrices:formatRoomPrices(_orderPrice4.roomPrices)(_list5),additionalTotalPrice:_orderPrice4.additionalTotalPrice,total:_orderPrice4.totalPrice}),products:_extends({},state.products,{list:[],products:[]})});}case _customerOrderView.TOGGLE_ROOM_PRICE:return _extends({},state,{prices:_extends({},state.prices,{roomPrices:(0,_map3.default)(function(x){return _extends({},x,{open:x.id===action.roomId&&!x.open});},state.prices.roomPrices),additionalTotalPrice:_extends({},state.prices.additionalTotalPrice,{open:false})})});case _customerOrderView.TOGGLE_ADDITIONAL_PRICE:return _extends({},state,{prices:_extends({},state.prices,{roomPrices:(0,_map3.default)(function(x){return _extends({},x,{open:false});},state.prices.roomPrices),additionalTotalPrice:_extends({},state.prices.additionalTotalPrice,{open:!state.prices.additionalTotalPrice.open})})});case _customerOrderView.TOGGLE_PRICES:return _extends({},state,{prices:_extends({},state.prices,!!state.prices.open?closePrices(state.prices):{open:true})});case _customerOrderView.CLEAR:return _extends({},state,{activeSelection:defaultActiveSelectionState,menuVisibility:true,orderComplete:false,orderRows:defaultOrderRows,pagination:defaultPagination,product:defaultProductState,products:defaultProductsState,prices:defaultPrices,rooms:defaultRoomsState});default:return state;}};exports.default=customerOrderView;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('head', __webpack_require__(902), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('every', __webpack_require__(906));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(162);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('join', __webpack_require__(943));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(126);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 243 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 244 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(246)('keys');
var uid = __webpack_require__(173);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(71);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 247 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 248 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(125);
var dPs = __webpack_require__(987);
var enumBugKeys = __webpack_require__(247);
var IE_PROTO = __webpack_require__(245)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(417)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(988).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(88).f;
var has = __webpack_require__(90);
var TAG = __webpack_require__(103)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(103);


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(71);
var core = __webpack_require__(56);
var LIBRARY = __webpack_require__(249);
var wksExt = __webpack_require__(253);
var defineProperty = __webpack_require__(88).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'The :attribute must be accepted.',
  after: 'The :attribute must be after :after.',
  after_or_equal: 'The :attribute must be equal or after :after_or_equal.',
  alpha: 'The :attribute field must contain only alphabetic characters.',
  alpha_dash: 'The :attribute field may only contain alpha-numeric characters, as well as dashes and underscores.',
  alpha_num: 'The :attribute field must be alphanumeric.',
  before: 'The :attribute must be before :before.',
  before_or_equal: 'The :attribute must be equal or before :before_or_equal.',
  between: 'The :attribute field must be between :min and :max.',
  confirmed: 'The :attribute confirmation does not match.',
  email: 'The :attribute format is invalid.',
  date: 'The :attribute is not a valid date format.',
  def: 'The :attribute attribute has errors.',
  digits: 'The :attribute must be :digits digits.',
  different: 'The :attribute and :different must be different.',
  'in': 'The selected :attribute is invalid.',
  integer: 'The :attribute must be an integer.',
  min: {
    numeric: 'The :attribute must be at least :min.',
    string: 'The :attribute must be at least :min characters.'
  },
  max: {
    numeric: 'The :attribute may not be greater than :max.',
    string: 'The :attribute may not be greater than :max characters.'
  },
  not_in: 'The selected :attribute is invalid.',
  numeric: 'The :attribute must be a number.',
  present: 'The :attribute field must be present (but can be empty).',
  required: 'The :attribute field is required.',
  required_if: 'The :attribute field is required when :other is :value.',
  required_unless: 'The :attribute field is required when :other is not :value.',
  required_with: 'The :attribute field is required when :field is not empty.',
  required_with_all: 'The :attribute field is required when :fields are not empty.',
  required_without: 'The :attribute field is required when :field is empty.',
  required_without_all: 'The :attribute field is required when :fields are empty.',
  same: 'The :attribute and :same fields must match.',
  size: {
    numeric: 'The :attribute must be :size.',
    string: 'The :attribute must be :size characters.'
  },
  string: 'The :attribute must be a string.',
  url: 'The :attribute format is invalid.',
  regex: 'The :attribute format is invalid.',
  attributes: {}
};


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.19.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

var hookCallback;

function hooks () {
    return hookCallback.apply(null, arguments);
}

// This is done to register the method called with moment()
// without creating circular dependencies.
function setHookCallback (callback) {
    hookCallback = callback;
}

function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
}

function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
}

function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
        return (Object.getOwnPropertyNames(obj).length === 0);
    } else {
        var k;
        for (k in obj) {
            if (obj.hasOwnProperty(k)) {
                return false;
            }
        }
        return true;
    }
}

function isUndefined(input) {
    return input === void 0;
}

function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
}

function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
}

function map(arr, fn) {
    var res = [], i;
    for (i = 0; i < arr.length; ++i) {
        res.push(fn(arr[i], i));
    }
    return res;
}

function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}

function extend(a, b) {
    for (var i in b) {
        if (hasOwnProp(b, i)) {
            a[i] = b[i];
        }
    }

    if (hasOwnProp(b, 'toString')) {
        a.toString = b.toString;
    }

    if (hasOwnProp(b, 'valueOf')) {
        a.valueOf = b.valueOf;
    }

    return a;
}

function createUTC (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
}

function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
        empty           : false,
        unusedTokens    : [],
        unusedInput     : [],
        overflow        : -2,
        charsLeftOver   : 0,
        nullInput       : false,
        invalidMonth    : null,
        invalidFormat   : false,
        userInvalidated : false,
        iso             : false,
        parsedDateParts : [],
        meridiem        : null,
        rfc2822         : false,
        weekdayMismatch : false
    };
}

function getParsingFlags(m) {
    if (m._pf == null) {
        m._pf = defaultParsingFlags();
    }
    return m._pf;
}

var some;
if (Array.prototype.some) {
    some = Array.prototype.some;
} else {
    some = function (fun) {
        var t = Object(this);
        var len = t.length >>> 0;

        for (var i = 0; i < len; i++) {
            if (i in t && fun.call(this, t[i], i, t)) {
                return true;
            }
        }

        return false;
    };
}

function isValid(m) {
    if (m._isValid == null) {
        var flags = getParsingFlags(m);
        var parsedParts = some.call(flags.parsedDateParts, function (i) {
            return i != null;
        });
        var isNowValid = !isNaN(m._d.getTime()) &&
            flags.overflow < 0 &&
            !flags.empty &&
            !flags.invalidMonth &&
            !flags.invalidWeekday &&
            !flags.weekdayMismatch &&
            !flags.nullInput &&
            !flags.invalidFormat &&
            !flags.userInvalidated &&
            (!flags.meridiem || (flags.meridiem && parsedParts));

        if (m._strict) {
            isNowValid = isNowValid &&
                flags.charsLeftOver === 0 &&
                flags.unusedTokens.length === 0 &&
                flags.bigHour === undefined;
        }

        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        }
        else {
            return isNowValid;
        }
    }
    return m._isValid;
}

function createInvalid (flags) {
    var m = createUTC(NaN);
    if (flags != null) {
        extend(getParsingFlags(m), flags);
    }
    else {
        getParsingFlags(m).userInvalidated = true;
    }

    return m;
}

// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var momentProperties = hooks.momentProperties = [];

function copyConfig(to, from) {
    var i, prop, val;

    if (!isUndefined(from._isAMomentObject)) {
        to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
        to._i = from._i;
    }
    if (!isUndefined(from._f)) {
        to._f = from._f;
    }
    if (!isUndefined(from._l)) {
        to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
        to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
        to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
        to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
        to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
        to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
        to._locale = from._locale;
    }

    if (momentProperties.length > 0) {
        for (i = 0; i < momentProperties.length; i++) {
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) {
                to[prop] = val;
            }
        }
    }

    return to;
}

var updateInProgress = false;

// Moment prototype object
function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
        this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
        updateInProgress = true;
        hooks.updateOffset(this);
        updateInProgress = false;
    }
}

function isMoment (obj) {
    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
}

function absFloor (number) {
    if (number < 0) {
        // -0 -> 0
        return Math.ceil(number) || 0;
    } else {
        return Math.floor(number);
    }
}

function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
        value = 0;

    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
        value = absFloor(coercedNumber);
    }

    return value;
}

// compare two arrays, return the number of differences
function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
        lengthDiff = Math.abs(array1.length - array2.length),
        diffs = 0,
        i;
    for (i = 0; i < len; i++) {
        if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
            diffs++;
        }
    }
    return diffs + lengthDiff;
}

function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false &&
            (typeof console !==  'undefined') && console.warn) {
        console.warn('Deprecation warning: ' + msg);
    }
}

function deprecate(msg, fn) {
    var firstTime = true;

    return extend(function () {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(null, msg);
        }
        if (firstTime) {
            var args = [];
            var arg;
            for (var i = 0; i < arguments.length; i++) {
                arg = '';
                if (typeof arguments[i] === 'object') {
                    arg += '\n[' + i + '] ';
                    for (var key in arguments[0]) {
                        arg += key + ': ' + arguments[0][key] + ', ';
                    }
                    arg = arg.slice(0, -2); // Remove trailing comma and space
                } else {
                    arg = arguments[i];
                }
                args.push(arg);
            }
            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
            firstTime = false;
        }
        return fn.apply(this, arguments);
    }, fn);
}

var deprecations = {};

function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
        warn(msg);
        deprecations[name] = true;
    }
}

hooks.suppressDeprecationWarnings = false;
hooks.deprecationHandler = null;

function isFunction(input) {
    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
}

function set (config) {
    var prop, i;
    for (i in config) {
        prop = config[i];
        if (isFunction(prop)) {
            this[i] = prop;
        } else {
            this['_' + i] = prop;
        }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp(
        (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
            '|' + (/\d{1,2}/).source);
}

function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig), prop;
    for (prop in childConfig) {
        if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) {
                res[prop] = childConfig[prop];
            } else {
                delete res[prop];
            }
        }
    }
    for (prop in parentConfig) {
        if (hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])) {
            // make sure changes to properties don't modify parent config
            res[prop] = extend({}, res[prop]);
        }
    }
    return res;
}

function Locale(config) {
    if (config != null) {
        this.set(config);
    }
}

var keys;

if (Object.keys) {
    keys = Object.keys;
} else {
    keys = function (obj) {
        var i, res = [];
        for (i in obj) {
            if (hasOwnProp(obj, i)) {
                res.push(i);
            }
        }
        return res;
    };
}

var defaultCalendar = {
    sameDay : '[Today at] LT',
    nextDay : '[Tomorrow at] LT',
    nextWeek : 'dddd [at] LT',
    lastDay : '[Yesterday at] LT',
    lastWeek : '[Last] dddd [at] LT',
    sameElse : 'L'
};

function calendar (key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
}

var defaultLongDateFormat = {
    LTS  : 'h:mm:ss A',
    LT   : 'h:mm A',
    L    : 'MM/DD/YYYY',
    LL   : 'MMMM D, YYYY',
    LLL  : 'MMMM D, YYYY h:mm A',
    LLLL : 'dddd, MMMM D, YYYY h:mm A'
};

function longDateFormat (key) {
    var format = this._longDateFormat[key],
        formatUpper = this._longDateFormat[key.toUpperCase()];

    if (format || !formatUpper) {
        return format;
    }

    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
        return val.slice(1);
    });

    return this._longDateFormat[key];
}

var defaultInvalidDate = 'Invalid date';

function invalidDate () {
    return this._invalidDate;
}

var defaultOrdinal = '%d';
var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

function ordinal (number) {
    return this._ordinal.replace('%d', number);
}

var defaultRelativeTime = {
    future : 'in %s',
    past   : '%s ago',
    s  : 'a few seconds',
    ss : '%d seconds',
    m  : 'a minute',
    mm : '%d minutes',
    h  : 'an hour',
    hh : '%d hours',
    d  : 'a day',
    dd : '%d days',
    M  : 'a month',
    MM : '%d months',
    y  : 'a year',
    yy : '%d years'
};

function relativeTime (number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return (isFunction(output)) ?
        output(number, withoutSuffix, string, isFuture) :
        output.replace(/%d/i, number);
}

function pastFuture (diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
}

var aliases = {};

function addUnitAlias (unit, shorthand) {
    var lowerCase = unit.toLowerCase();
    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
}

function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
}

function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
        normalizedProp,
        prop;

    for (prop in inputObject) {
        if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) {
                normalizedInput[normalizedProp] = inputObject[prop];
            }
        }
    }

    return normalizedInput;
}

var priorities = {};

function addUnitPriority(unit, priority) {
    priorities[unit] = priority;
}

function getPrioritizedUnits(unitsObj) {
    var units = [];
    for (var u in unitsObj) {
        units.push({unit: u, priority: priorities[u]});
    }
    units.sort(function (a, b) {
        return a.priority - b.priority;
    });
    return units;
}

function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
        zerosToFill = targetLength - absNumber.length,
        sign = number >= 0;
    return (sign ? (forceSign ? '+' : '') : '-') +
        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
}

var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

var formatFunctions = {};

var formatTokenFunctions = {};

// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function addFormatToken (token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
        func = function () {
            return this[callback]();
        };
    }
    if (token) {
        formatTokenFunctions[token] = func;
    }
    if (padded) {
        formatTokenFunctions[padded[0]] = function () {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
    }
    if (ordinal) {
        formatTokenFunctions[ordinal] = function () {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
}

function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
        return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
}

function makeFormatFunction(format) {
    var array = format.match(formattingTokens), i, length;

    for (i = 0, length = array.length; i < length; i++) {
        if (formatTokenFunctions[array[i]]) {
            array[i] = formatTokenFunctions[array[i]];
        } else {
            array[i] = removeFormattingTokens(array[i]);
        }
    }

    return function (mom) {
        var output = '', i;
        for (i = 0; i < length; i++) {
            output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
        }
        return output;
    };
}

// format date using native date object
function formatMoment(m, format) {
    if (!m.isValid()) {
        return m.localeData().invalidDate();
    }

    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

    return formatFunctions[format](m);
}

function expandFormat(format, locale) {
    var i = 5;

    function replaceLongDateFormatTokens(input) {
        return locale.longDateFormat(input) || input;
    }

    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
        localFormattingTokens.lastIndex = 0;
        i -= 1;
    }

    return format;
}

var match1         = /\d/;            //       0 - 9
var match2         = /\d\d/;          //      00 - 99
var match3         = /\d{3}/;         //     000 - 999
var match4         = /\d{4}/;         //    0000 - 9999
var match6         = /[+-]?\d{6}/;    // -999999 - 999999
var match1to2      = /\d\d?/;         //       0 - 99
var match3to4      = /\d\d\d\d?/;     //     999 - 9999
var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
var match1to3      = /\d{1,3}/;       //       0 - 999
var match1to4      = /\d{1,4}/;       //       0 - 9999
var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

var matchUnsigned  = /\d+/;           //       0 - inf
var matchSigned    = /[+-]?\d+/;      //    -inf - inf

var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

// any word (or two) characters or numbers including two/three word month in arabic.
// includes scottish gaelic two word and hyphenated months
var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;


var regexes = {};

function addRegexToken (token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
        return (isStrict && strictRegex) ? strictRegex : regex;
    };
}

function getParseRegexForToken (token, config) {
    if (!hasOwnProp(regexes, token)) {
        return new RegExp(unescapeFormat(token));
    }

    return regexes[token](config._strict, config._locale);
}

// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
        return p1 || p2 || p3 || p4;
    }));
}

function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
}

var tokens = {};

function addParseToken (token, callback) {
    var i, func = callback;
    if (typeof token === 'string') {
        token = [token];
    }
    if (isNumber(callback)) {
        func = function (input, array) {
            array[callback] = toInt(input);
        };
    }
    for (i = 0; i < token.length; i++) {
        tokens[token[i]] = func;
    }
}

function addWeekParseToken (token, callback) {
    addParseToken(token, function (input, array, config, token) {
        config._w = config._w || {};
        callback(input, config._w, config, token);
    });
}

function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
        tokens[token](input, config._a, config, token);
    }
}

var YEAR = 0;
var MONTH = 1;
var DATE = 2;
var HOUR = 3;
var MINUTE = 4;
var SECOND = 5;
var MILLISECOND = 6;
var WEEK = 7;
var WEEKDAY = 8;

// FORMATTING

addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? '' + y : '+' + y;
});

addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
});

addFormatToken(0, ['YYYY',   4],       0, 'year');
addFormatToken(0, ['YYYYY',  5],       0, 'year');
addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

// ALIASES

addUnitAlias('year', 'y');

// PRIORITIES

addUnitPriority('year', 1);

// PARSING

addRegexToken('Y',      matchSigned);
addRegexToken('YY',     match1to2, match2);
addRegexToken('YYYY',   match1to4, match4);
addRegexToken('YYYYY',  match1to6, match6);
addRegexToken('YYYYYY', match1to6, match6);

addParseToken(['YYYYY', 'YYYYYY'], YEAR);
addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
});
addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
});
addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
});

// HELPERS

function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
}

function isLeapYear(year) {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
}

// HOOKS

hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
};

// MOMENTS

var getSetYear = makeGetSet('FullYear', true);

function getIsLeapYear () {
    return isLeapYear(this.year());
}

function makeGetSet (unit, keepTime) {
    return function (value) {
        if (value != null) {
            set$1(this, unit, value);
            hooks.updateOffset(this, keepTime);
            return this;
        } else {
            return get(this, unit);
        }
    };
}

function get (mom, unit) {
    return mom.isValid() ?
        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
}

function set$1 (mom, unit, value) {
    if (mom.isValid() && !isNaN(value)) {
        if (unit === 'FullYear' && isLeapYear(mom.year())) {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
        }
        else {
            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }
}

// MOMENTS

function stringGet (units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
        return this[units]();
    }
    return this;
}


function stringSet (units, value) {
    if (typeof units === 'object') {
        units = normalizeObjectUnits(units);
        var prioritized = getPrioritizedUnits(units);
        for (var i = 0; i < prioritized.length; i++) {
            this[prioritized[i].unit](units[prioritized[i].unit]);
        }
    } else {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units](value);
        }
    }
    return this;
}

function mod(n, x) {
    return ((n % x) + x) % x;
}

var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
        return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
}

// FORMATTING

addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
});

addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
});

addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
});

// ALIASES

addUnitAlias('month', 'M');

// PRIORITY

addUnitPriority('month', 8);

// PARSING

addRegexToken('M',    match1to2);
addRegexToken('MM',   match1to2, match2);
addRegexToken('MMM',  function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
});
addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
});

addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
});

addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
        array[MONTH] = month;
    } else {
        getParsingFlags(config).invalidMonth = input;
    }
});

// LOCALES

var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
function localeMonths (m, format) {
    if (!m) {
        return isArray(this._months) ? this._months :
            this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] :
        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
}

var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
function localeMonthsShort (m, format) {
    if (!m) {
        return isArray(this._monthsShort) ? this._monthsShort :
            this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
}

function handleStrictParse(monthName, format, strict) {
    var i, ii, mom, llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
        // this is not used
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
        for (i = 0; i < 12; ++i) {
            mom = createUTC([2000, i]);
            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeMonthsParse (monthName, format, strict) {
    var i, mom, regex;

    if (this._monthsParseExact) {
        return handleStrictParse.call(this, monthName, format, strict);
    }

    if (!this._monthsParse) {
        this._monthsParse = [];
        this._longMonthsParse = [];
        this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        if (strict && !this._longMonthsParse[i]) {
            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
        }
        if (!strict && !this._monthsParse[i]) {
            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
            return i;
        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
            return i;
        } else if (!strict && this._monthsParse[i].test(monthName)) {
            return i;
        }
    }
}

// MOMENTS

function setMonth (mom, value) {
    var dayOfMonth;

    if (!mom.isValid()) {
        // No op
        return mom;
    }

    if (typeof value === 'string') {
        if (/^\d+$/.test(value)) {
            value = toInt(value);
        } else {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (!isNumber(value)) {
                return mom;
            }
        }
    }

    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
    return mom;
}

function getSetMonth (value) {
    if (value != null) {
        setMonth(this, value);
        hooks.updateOffset(this, true);
        return this;
    } else {
        return get(this, 'Month');
    }
}

function getDaysInMonth () {
    return daysInMonth(this.year(), this.month());
}

var defaultMonthsShortRegex = matchWord;
function monthsShortRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsShortStrictRegex;
        } else {
            return this._monthsShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsShortRegex')) {
            this._monthsShortRegex = defaultMonthsShortRegex;
        }
        return this._monthsShortStrictRegex && isStrict ?
            this._monthsShortStrictRegex : this._monthsShortRegex;
    }
}

var defaultMonthsRegex = matchWord;
function monthsRegex (isStrict) {
    if (this._monthsParseExact) {
        if (!hasOwnProp(this, '_monthsRegex')) {
            computeMonthsParse.call(this);
        }
        if (isStrict) {
            return this._monthsStrictRegex;
        } else {
            return this._monthsRegex;
        }
    } else {
        if (!hasOwnProp(this, '_monthsRegex')) {
            this._monthsRegex = defaultMonthsRegex;
        }
        return this._monthsStrictRegex && isStrict ?
            this._monthsStrictRegex : this._monthsRegex;
    }
}

function computeMonthsParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom;
    for (i = 0; i < 12; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, i]);
        shortPieces.push(this.monthsShort(mom, ''));
        longPieces.push(this.months(mom, ''));
        mixedPieces.push(this.months(mom, ''));
        mixedPieces.push(this.monthsShort(mom, ''));
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 12; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
    }
    for (i = 0; i < 24; i++) {
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
}

function createDate (y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date = new Date(y, m, d, h, M, s, ms);

    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
        date.setFullYear(y);
    }
    return date;
}

function createUTCDate (y) {
    var date = new Date(Date.UTC.apply(null, arguments));

    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
    }
    return date;
}

// start-of-first-week - start-of-year
function firstWeekOffset(year, dow, doy) {
    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
        fwd = 7 + dow - doy,
        // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

    return -fwdlw + fwd - 1;
}

// https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
        weekOffset = firstWeekOffset(year, dow, doy),
        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
        resYear, resDayOfYear;

    if (dayOfYear <= 0) {
        resYear = year - 1;
        resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
        resYear = year + 1;
        resDayOfYear = dayOfYear - daysInYear(year);
    } else {
        resYear = year;
        resDayOfYear = dayOfYear;
    }

    return {
        year: resYear,
        dayOfYear: resDayOfYear
    };
}

function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
        resWeek, resYear;

    if (week < 1) {
        resYear = mom.year() - 1;
        resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
        resWeek = week - weeksInYear(mom.year(), dow, doy);
        resYear = mom.year() + 1;
    } else {
        resYear = mom.year();
        resWeek = week;
    }

    return {
        week: resWeek,
        year: resYear
    };
}

function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
}

// FORMATTING

addFormatToken('w', ['ww', 2], 'wo', 'week');
addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

// ALIASES

addUnitAlias('week', 'w');
addUnitAlias('isoWeek', 'W');

// PRIORITIES

addUnitPriority('week', 5);
addUnitPriority('isoWeek', 5);

// PARSING

addRegexToken('w',  match1to2);
addRegexToken('ww', match1to2, match2);
addRegexToken('W',  match1to2);
addRegexToken('WW', match1to2, match2);

addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
});

// HELPERS

// LOCALES

function localeWeek (mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
}

var defaultLocaleWeek = {
    dow : 0, // Sunday is the first day of the week.
    doy : 6  // The week that contains Jan 1st is the first week of the year.
};

function localeFirstDayOfWeek () {
    return this._week.dow;
}

function localeFirstDayOfYear () {
    return this._week.doy;
}

// MOMENTS

function getSetWeek (input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
}

function getSetISOWeek (input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
}

// FORMATTING

addFormatToken('d', 0, 'do', 'day');

addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
});

addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
});

addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
});

addFormatToken('e', 0, 0, 'weekday');
addFormatToken('E', 0, 0, 'isoWeekday');

// ALIASES

addUnitAlias('day', 'd');
addUnitAlias('weekday', 'e');
addUnitAlias('isoWeekday', 'E');

// PRIORITY
addUnitPriority('day', 11);
addUnitPriority('weekday', 11);
addUnitPriority('isoWeekday', 11);

// PARSING

addRegexToken('d',    match1to2);
addRegexToken('e',    match1to2);
addRegexToken('E',    match1to2);
addRegexToken('dd',   function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
});
addRegexToken('ddd',   function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
});
addRegexToken('dddd',   function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
});

addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
        week.d = weekday;
    } else {
        getParsingFlags(config).invalidWeekday = input;
    }
});

addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
});

// HELPERS

function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
        return input;
    }

    if (!isNaN(input)) {
        return parseInt(input, 10);
    }

    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
        return input;
    }

    return null;
}

function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
        return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
}

// LOCALES

var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
function localeWeekdays (m, format) {
    if (!m) {
        return isArray(this._weekdays) ? this._weekdays :
            this._weekdays['standalone'];
    }
    return isArray(this._weekdays) ? this._weekdays[m.day()] :
        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
}

var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
function localeWeekdaysShort (m) {
    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
}

var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
function localeWeekdaysMin (m) {
    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
}

function handleStrictParse$1(weekdayName, format, strict) {
    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._minWeekdaysParse = [];

        for (i = 0; i < 7; ++i) {
            mom = createUTC([2000, 1]).day(i);
            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
        }
    }

    if (strict) {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    } else {
        if (format === 'dddd') {
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else if (format === 'ddd') {
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._minWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._minWeekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._weekdaysParse, llc);
            if (ii !== -1) {
                return ii;
            }
            ii = indexOf.call(this._shortWeekdaysParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
}

function localeWeekdaysParse (weekdayName, format, strict) {
    var i, mom, regex;

    if (this._weekdaysParseExact) {
        return handleStrictParse$1.call(this, weekdayName, format, strict);
    }

    if (!this._weekdaysParse) {
        this._weekdaysParse = [];
        this._minWeekdaysParse = [];
        this._shortWeekdaysParse = [];
        this._fullWeekdaysParse = [];
    }

    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already

        mom = createUTC([2000, 1]).day(i);
        if (strict && !this._fullWeekdaysParse[i]) {
            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
        }
        if (!this._weekdaysParse[i]) {
            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
        }
        // test the regex
        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
            return i;
        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
            return i;
        }
    }
}

// MOMENTS

function getSetDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
    if (input != null) {
        input = parseWeekday(input, this.localeData());
        return this.add(input - day, 'd');
    } else {
        return day;
    }
}

function getSetLocaleDayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
}

function getSetISODayOfWeek (input) {
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
        var weekday = parseIsoWeekday(input, this.localeData());
        return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
        return this.day() || 7;
    }
}

var defaultWeekdaysRegex = matchWord;
function weekdaysRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysStrictRegex;
        } else {
            return this._weekdaysRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            this._weekdaysRegex = defaultWeekdaysRegex;
        }
        return this._weekdaysStrictRegex && isStrict ?
            this._weekdaysStrictRegex : this._weekdaysRegex;
    }
}

var defaultWeekdaysShortRegex = matchWord;
function weekdaysShortRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysShortStrictRegex;
        } else {
            return this._weekdaysShortRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
        }
        return this._weekdaysShortStrictRegex && isStrict ?
            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
}

var defaultWeekdaysMinRegex = matchWord;
function weekdaysMinRegex (isStrict) {
    if (this._weekdaysParseExact) {
        if (!hasOwnProp(this, '_weekdaysRegex')) {
            computeWeekdaysParse.call(this);
        }
        if (isStrict) {
            return this._weekdaysMinStrictRegex;
        } else {
            return this._weekdaysMinRegex;
        }
    } else {
        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
        }
        return this._weekdaysMinStrictRegex && isStrict ?
            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
}


function computeWeekdaysParse () {
    function cmpLenRev(a, b) {
        return b.length - a.length;
    }

    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
        i, mom, minp, shortp, longp;
    for (i = 0; i < 7; i++) {
        // make the regex if we don't have it already
        mom = createUTC([2000, 1]).day(i);
        minp = this.weekdaysMin(mom, '');
        shortp = this.weekdaysShort(mom, '');
        longp = this.weekdays(mom, '');
        minPieces.push(minp);
        shortPieces.push(shortp);
        longPieces.push(longp);
        mixedPieces.push(minp);
        mixedPieces.push(shortp);
        mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    for (i = 0; i < 7; i++) {
        shortPieces[i] = regexEscape(shortPieces[i]);
        longPieces[i] = regexEscape(longPieces[i]);
        mixedPieces[i] = regexEscape(mixedPieces[i]);
    }

    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;

    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
}

// FORMATTING

function hFormat() {
    return this.hours() % 12 || 12;
}

function kFormat() {
    return this.hours() || 24;
}

addFormatToken('H', ['HH', 2], 0, 'hour');
addFormatToken('h', ['hh', 2], 0, hFormat);
addFormatToken('k', ['kk', 2], 0, kFormat);

addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
});

addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
});

addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) +
        zeroFill(this.seconds(), 2);
});

function meridiem (token, lowercase) {
    addFormatToken(token, 0, 0, function () {
        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
}

meridiem('a', true);
meridiem('A', false);

// ALIASES

addUnitAlias('hour', 'h');

// PRIORITY
addUnitPriority('hour', 13);

// PARSING

function matchMeridiem (isStrict, locale) {
    return locale._meridiemParse;
}

addRegexToken('a',  matchMeridiem);
addRegexToken('A',  matchMeridiem);
addRegexToken('H',  match1to2);
addRegexToken('h',  match1to2);
addRegexToken('k',  match1to2);
addRegexToken('HH', match1to2, match2);
addRegexToken('hh', match1to2, match2);
addRegexToken('kk', match1to2, match2);

addRegexToken('hmm', match3to4);
addRegexToken('hmmss', match5to6);
addRegexToken('Hmm', match3to4);
addRegexToken('Hmmss', match5to6);

addParseToken(['H', 'HH'], HOUR);
addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
});
addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
});
addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
});
addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
});
addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
});
addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4;
    var pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
});

// LOCALES

function localeIsPM (input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return ((input + '').toLowerCase().charAt(0) === 'p');
}

var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
function localeMeridiem (hours, minutes, isLower) {
    if (hours > 11) {
        return isLower ? 'pm' : 'PM';
    } else {
        return isLower ? 'am' : 'AM';
    }
}


// MOMENTS

// Setting the hour should keep the time, because the user explicitly
// specified which hour he wants. So trying to maintain the same hour (in
// a new timezone) makes sense. Adding/subtracting hours does not follow
// this rule.
var getSetHour = makeGetSet('Hours', true);

// months
// week
// weekdays
// meridiem
var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,

    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,

    week: defaultLocaleWeek,

    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,

    meridiemParse: defaultLocaleMeridiemParse
};

// internal storage for locale config files
var locales = {};
var localeFamilies = {};
var globalLocale;

function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
}

// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function chooseLocale(names) {
    var i = 0, j, next, locale, split;

    while (i < names.length) {
        split = normalizeLocale(names[i]).split('-');
        j = split.length;
        next = normalizeLocale(names[i + 1]);
        next = next ? next.split('-') : null;
        while (j > 0) {
            locale = loadLocale(split.slice(0, j).join('-'));
            if (locale) {
                return locale;
            }
            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                //the next array item is better than a shallower substring of this one
                break;
            }
            j--;
        }
        i++;
    }
    return null;
}

function loadLocale(name) {
    var oldLocale = null;
    // TODO: Find a better way to register and load all the locales in Node
    if (!locales[name] && (typeof module !== 'undefined') &&
            module && module.exports) {
        try {
            oldLocale = globalLocale._abbr;
            var aliasedRequire = require;
            !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
            getSetGlobalLocale(oldLocale);
        } catch (e) {}
    }
    return locales[name];
}

// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function getSetGlobalLocale (key, values) {
    var data;
    if (key) {
        if (isUndefined(values)) {
            data = getLocale(key);
        }
        else {
            data = defineLocale(key, values);
        }

        if (data) {
            // moment.duration._locale = moment._locale = data;
            globalLocale = data;
        }
    }

    return globalLocale._abbr;
}

function defineLocale (name, config) {
    if (config !== null) {
        var parentConfig = baseConfig;
        config.abbr = name;
        if (locales[name] != null) {
            deprecateSimple('defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                    'an existing locale. moment.defineLocale(localeName, ' +
                    'config) should only be used for creating a new locale ' +
                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
            parentConfig = locales[name]._config;
        } else if (config.parentLocale != null) {
            if (locales[config.parentLocale] != null) {
                parentConfig = locales[config.parentLocale]._config;
            } else {
                if (!localeFamilies[config.parentLocale]) {
                    localeFamilies[config.parentLocale] = [];
                }
                localeFamilies[config.parentLocale].push({
                    name: name,
                    config: config
                });
                return null;
            }
        }
        locales[name] = new Locale(mergeConfigs(parentConfig, config));

        if (localeFamilies[name]) {
            localeFamilies[name].forEach(function (x) {
                defineLocale(x.name, x.config);
            });
        }

        // backwards compat for now: also set the locale
        // make sure we set the locale AFTER all child locales have been
        // created, so we won't end up with the child locale set.
        getSetGlobalLocale(name);


        return locales[name];
    } else {
        // useful for testing
        delete locales[name];
        return null;
    }
}

function updateLocale(name, config) {
    if (config != null) {
        var locale, parentConfig = baseConfig;
        // MERGE
        if (locales[name] != null) {
            parentConfig = locales[name]._config;
        }
        config = mergeConfigs(parentConfig, config);
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;

        // backwards compat for now: also set the locale
        getSetGlobalLocale(name);
    } else {
        // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
            } else if (locales[name] != null) {
                delete locales[name];
            }
        }
    }
    return locales[name];
}

// returns locale data
function getLocale (key) {
    var locale;

    if (key && key._locale && key._locale._abbr) {
        key = key._locale._abbr;
    }

    if (!key) {
        return globalLocale;
    }

    if (!isArray(key)) {
        //short-circuit everything else
        locale = loadLocale(key);
        if (locale) {
            return locale;
        }
        key = [key];
    }

    return chooseLocale(key);
}

function listLocales() {
    return keys(locales);
}

function checkOverflow (m) {
    var overflow;
    var a = m._a;

    if (a && getParsingFlags(m).overflow === -2) {
        overflow =
            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
            -1;

        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
            overflow = DATE;
        }
        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
            overflow = WEEK;
        }
        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
            overflow = WEEKDAY;
        }

        getParsingFlags(m).overflow = overflow;
    }

    return m;
}

// Pick the first defined of two or three arguments.
function defaults(a, b, c) {
    if (a != null) {
        return a;
    }
    if (b != null) {
        return b;
    }
    return c;
}

function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
}

// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function configFromArray (config) {
    var i, date, input = [], currentDate, yearToUse;

    if (config._d) {
        return;
    }

    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
        dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

        if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
            getParsingFlags(config)._overflowDayOfYear = true;
        }

        date = createUTCDate(yearToUse, 0, config._dayOfYear);
        config._a[MONTH] = date.getUTCMonth();
        config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
        config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0) {
        config._nextDay = true;
        config._a[HOUR] = 0;
    }

    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }

    if (config._nextDay) {
        config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== config._d.getDay()) {
        getParsingFlags(config).weekdayMismatch = true;
    }
}

function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
        dow = 1;
        doy = 4;

        // TODO: We need to take the current isoWeekYear, but that depends on
        // how we interpret now (local, utc, fixed offset). So create
        // a now version of current config (take local/utc/offset flags, and
        // create now).
        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
        week = defaults(w.W, 1);
        weekday = defaults(w.E, 1);
        if (weekday < 1 || weekday > 7) {
            weekdayOverflow = true;
        }
    } else {
        dow = config._locale._week.dow;
        doy = config._locale._week.doy;

        var curWeek = weekOfYear(createLocal(), dow, doy);

        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

        // Default to current week.
        week = defaults(w.w, curWeek.week);

        if (w.d != null) {
            // weekday -- low day numbers are considered next week
            weekday = w.d;
            if (weekday < 0 || weekday > 6) {
                weekdayOverflow = true;
            }
        } else if (w.e != null) {
            // local weekday -- counting starts from begining of week
            weekday = w.e + dow;
            if (w.e < 0 || w.e > 6) {
                weekdayOverflow = true;
            }
        } else {
            // default to begining of week
            weekday = dow;
        }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
        getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
        getParsingFlags(config)._overflowWeekday = true;
    } else {
        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }
}

// iso 8601 regex
// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

var isoDates = [
    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
    ['YYYY-DDD', /\d{4}-\d{3}/],
    ['YYYY-MM', /\d{4}-\d\d/, false],
    ['YYYYYYMMDD', /[+-]\d{10}/],
    ['YYYYMMDD', /\d{8}/],
    // YYYYMM is NOT allowed by the standard
    ['GGGG[W]WWE', /\d{4}W\d{3}/],
    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
    ['YYYYDDD', /\d{7}/]
];

// iso time formats and regexes
var isoTimes = [
    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
    ['HH:mm', /\d\d:\d\d/],
    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
    ['HHmmss', /\d\d\d\d\d\d/],
    ['HHmm', /\d\d\d\d/],
    ['HH', /\d\d/]
];

var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

// date from iso format
function configFromISO(config) {
    var i, l,
        string = config._i,
        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
        allowTime, dateFormat, timeFormat, tzFormat;

    if (match) {
        getParsingFlags(config).iso = true;

        for (i = 0, l = isoDates.length; i < l; i++) {
            if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
        }
        if (dateFormat == null) {
            config._isValid = false;
            return;
        }
        if (match[3]) {
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
            }
            if (timeFormat == null) {
                config._isValid = false;
                return;
            }
        }
        if (!allowTime && timeFormat != null) {
            config._isValid = false;
            return;
        }
        if (match[4]) {
            if (tzRegex.exec(match[4])) {
                tzFormat = 'Z';
            } else {
                config._isValid = false;
                return;
            }
        }
        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
        configFromStringAndFormat(config);
    } else {
        config._isValid = false;
    }
}

// RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [
        untruncateYear(yearStr),
        defaultLocaleMonthsShort.indexOf(monthStr),
        parseInt(dayStr, 10),
        parseInt(hourStr, 10),
        parseInt(minuteStr, 10)
    ];

    if (secondStr) {
        result.push(parseInt(secondStr, 10));
    }

    return result;
}

function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
        return 2000 + year;
    } else if (year <= 999) {
        return 1900 + year;
    }
    return year;
}

function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').trim();
}

function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
        // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
        var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
            weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
        if (weekdayProvided !== weekdayActual) {
            getParsingFlags(config).weekdayMismatch = true;
            config._isValid = false;
            return false;
        }
    }
    return true;
}

var obsOffsets = {
    UT: 0,
    GMT: 0,
    EDT: -4 * 60,
    EST: -5 * 60,
    CDT: -5 * 60,
    CST: -6 * 60,
    MDT: -6 * 60,
    MST: -7 * 60,
    PDT: -7 * 60,
    PST: -8 * 60
};

function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
        return obsOffsets[obsOffset];
    } else if (militaryOffset) {
        // the only allowed military tz is Z
        return 0;
    } else {
        var hm = parseInt(numOffset, 10);
        var m = hm % 100, h = (hm - m) / 100;
        return h * 60 + m;
    }
}

// date and time from ref 2822 format
function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i));
    if (match) {
        var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
        if (!checkWeekday(match[1], parsedArray, config)) {
            return;
        }

        config._a = parsedArray;
        config._tzm = calculateOffset(match[8], match[9], match[10]);

        config._d = createUTCDate.apply(null, config._a);
        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

        getParsingFlags(config).rfc2822 = true;
    } else {
        config._isValid = false;
    }
}

// date from iso format or fallback
function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);

    if (matched !== null) {
        config._d = new Date(+matched[1]);
        return;
    }

    configFromISO(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    configFromRFC2822(config);
    if (config._isValid === false) {
        delete config._isValid;
    } else {
        return;
    }

    // Final attempt, use Input Fallback
    hooks.createFromInputFallback(config);
}

hooks.createFromInputFallback = deprecate(
    'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
    'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
    'discouraged and will be removed in an upcoming major release. Please refer to ' +
    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
    function (config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    }
);

// constant that refers to the ISO standard
hooks.ISO_8601 = function () {};

// constant that refers to the RFC 2822 form
hooks.RFC_2822 = function () {};

// date from string and format string
function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
        configFromISO(config);
        return;
    }
    if (config._f === hooks.RFC_2822) {
        configFromRFC2822(config);
        return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
        i, parsedInput, tokens, token, skipped,
        stringLength = string.length,
        totalParsedInputLength = 0;

    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

    for (i = 0; i < tokens.length; i++) {
        token = tokens[i];
        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
        // console.log('token', token, 'parsedInput', parsedInput,
        //         'regex', getParseRegexForToken(token, config));
        if (parsedInput) {
            skipped = string.substr(0, string.indexOf(parsedInput));
            if (skipped.length > 0) {
                getParsingFlags(config).unusedInput.push(skipped);
            }
            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
            totalParsedInputLength += parsedInput.length;
        }
        // don't parse if it's not a known token
        if (formatTokenFunctions[token]) {
            if (parsedInput) {
                getParsingFlags(config).empty = false;
            }
            else {
                getParsingFlags(config).unusedTokens.push(token);
            }
            addTimeToArrayFromToken(token, parsedInput, config);
        }
        else if (config._strict && !parsedInput) {
            getParsingFlags(config).unusedTokens.push(token);
        }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
        getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 &&
        getParsingFlags(config).bigHour === true &&
        config._a[HOUR] > 0) {
        getParsingFlags(config).bigHour = undefined;
    }

    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    configFromArray(config);
    checkOverflow(config);
}


function meridiemFixWrap (locale, hour, meridiem) {
    var isPm;

    if (meridiem == null) {
        // nothing to do
        return hour;
    }
    if (locale.meridiemHour != null) {
        return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
        // Fallback
        isPm = locale.isPM(meridiem);
        if (isPm && hour < 12) {
            hour += 12;
        }
        if (!isPm && hour === 12) {
            hour = 0;
        }
        return hour;
    } else {
        // this is not supposed to happen
        return hour;
    }
}

// date from string and array of format strings
function configFromStringAndArray(config) {
    var tempConfig,
        bestMoment,

        scoreToBeat,
        i,
        currentScore;

    if (config._f.length === 0) {
        getParsingFlags(config).invalidFormat = true;
        config._d = new Date(NaN);
        return;
    }

    for (i = 0; i < config._f.length; i++) {
        currentScore = 0;
        tempConfig = copyConfig({}, config);
        if (config._useUTC != null) {
            tempConfig._useUTC = config._useUTC;
        }
        tempConfig._f = config._f[i];
        configFromStringAndFormat(tempConfig);

        if (!isValid(tempConfig)) {
            continue;
        }

        // if there is any input that was not parsed add a penalty for that format
        currentScore += getParsingFlags(tempConfig).charsLeftOver;

        //or tokens
        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

        getParsingFlags(tempConfig).score = currentScore;

        if (scoreToBeat == null || currentScore < scoreToBeat) {
            scoreToBeat = currentScore;
            bestMoment = tempConfig;
        }
    }

    extend(config, bestMoment || tempConfig);
}

function configFromObject(config) {
    if (config._d) {
        return;
    }

    var i = normalizeObjectUnits(config._i);
    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
        return obj && parseInt(obj, 10);
    });

    configFromArray(config);
}

function createFromConfig (config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
        // Adding is smart enough around DST
        res.add(1, 'd');
        res._nextDay = undefined;
    }

    return res;
}

function prepareConfig (config) {
    var input = config._i,
        format = config._f;

    config._locale = config._locale || getLocale(config._l);

    if (input === null || (format === undefined && input === '')) {
        return createInvalid({nullInput: true});
    }

    if (typeof input === 'string') {
        config._i = input = config._locale.preparse(input);
    }

    if (isMoment(input)) {
        return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
        config._d = input;
    } else if (isArray(format)) {
        configFromStringAndArray(config);
    } else if (format) {
        configFromStringAndFormat(config);
    }  else {
        configFromInput(config);
    }

    if (!isValid(config)) {
        config._d = null;
    }

    return config;
}

function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
        config._d = new Date(hooks.now());
    } else if (isDate(input)) {
        config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
        configFromString(config);
    } else if (isArray(input)) {
        config._a = map(input.slice(0), function (obj) {
            return parseInt(obj, 10);
        });
        configFromArray(config);
    } else if (isObject(input)) {
        configFromObject(config);
    } else if (isNumber(input)) {
        // from milliseconds
        config._d = new Date(input);
    } else {
        hooks.createFromInputFallback(config);
    }
}

function createLocalOrUTC (input, format, locale, strict, isUTC) {
    var c = {};

    if (locale === true || locale === false) {
        strict = locale;
        locale = undefined;
    }

    if ((isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)) {
        input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;

    return createFromConfig(c);
}

function createLocal (input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
}

var prototypeMin = deprecate(
    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other < this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

var prototypeMax = deprecate(
    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
    function () {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) {
            return other > this ? this : other;
        } else {
            return createInvalid();
        }
    }
);

// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
        moments = moments[0];
    }
    if (!moments.length) {
        return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
        if (!moments[i].isValid() || moments[i][fn](res)) {
            res = moments[i];
        }
    }
    return res;
}

// TODO: Use [].sort instead?
function min () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isBefore', args);
}

function max () {
    var args = [].slice.call(arguments, 0);

    return pickBy('isAfter', args);
}

var now = function () {
    return Date.now ? Date.now() : +(new Date());
};

var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

function isDurationValid(m) {
    for (var key in m) {
        if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
            return false;
        }
    }

    var unitHasDecimal = false;
    for (var i = 0; i < ordering.length; ++i) {
        if (m[ordering[i]]) {
            if (unitHasDecimal) {
                return false; // only allow non-integers for smallest unit
            }
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                unitHasDecimal = true;
            }
        }
    }

    return true;
}

function isValid$1() {
    return this._isValid;
}

function createInvalid$1() {
    return createDuration(NaN);
}

function Duration (duration) {
    var normalizedInput = normalizeObjectUnits(duration),
        years = normalizedInput.year || 0,
        quarters = normalizedInput.quarter || 0,
        months = normalizedInput.month || 0,
        weeks = normalizedInput.week || 0,
        days = normalizedInput.day || 0,
        hours = normalizedInput.hour || 0,
        minutes = normalizedInput.minute || 0,
        seconds = normalizedInput.second || 0,
        milliseconds = normalizedInput.millisecond || 0;

    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds +
        seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days +
        weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months +
        quarters * 3 +
        years * 12;

    this._data = {};

    this._locale = getLocale();

    this._bubble();
}

function isDuration (obj) {
    return obj instanceof Duration;
}

function absRound (number) {
    if (number < 0) {
        return Math.round(-1 * number) * -1;
    } else {
        return Math.round(number);
    }
}

// FORMATTING

function offset (token, separator) {
    addFormatToken(token, 0, 0, function () {
        var offset = this.utcOffset();
        var sign = '+';
        if (offset < 0) {
            offset = -offset;
            sign = '-';
        }
        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
    });
}

offset('Z', ':');
offset('ZZ', '');

// PARSING

addRegexToken('Z',  matchShortOffset);
addRegexToken('ZZ', matchShortOffset);
addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
});

// HELPERS

// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var chunkOffset = /([\+\-]|\d\d)/gi;

function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher);

    if (matches === null) {
        return null;
    }

    var chunk   = matches[matches.length - 1] || [];
    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    var minutes = +(parts[1] * 60) + toInt(parts[2]);

    return minutes === 0 ?
      0 :
      parts[0] === '+' ? minutes : -minutes;
}

// Return a moment from input, that is local/utc/zone equivalent to model.
function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
        res = model.clone();
        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
        // Use low-level api, because this fn is low-level api.
        res._d.setTime(res._d.valueOf() + diff);
        hooks.updateOffset(res, false);
        return res;
    } else {
        return createLocal(input).local();
    }
}

function getDateOffset (m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
}

// HOOKS

// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
hooks.updateOffset = function () {};

// MOMENTS

// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function getSetOffset (input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
        localAdjust;
    if (!this.isValid()) {
        return input != null ? this : NaN;
    }
    if (input != null) {
        if (typeof input === 'string') {
            input = offsetFromString(matchShortOffset, input);
            if (input === null) {
                return this;
            }
        } else if (Math.abs(input) < 16 && !keepMinutes) {
            input = input * 60;
        }
        if (!this._isUTC && keepLocalTime) {
            localAdjust = getDateOffset(this);
        }
        this._offset = input;
        this._isUTC = true;
        if (localAdjust != null) {
            this.add(localAdjust, 'm');
        }
        if (offset !== input) {
            if (!keepLocalTime || this._changeInProgress) {
                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
            } else if (!this._changeInProgress) {
                this._changeInProgress = true;
                hooks.updateOffset(this, true);
                this._changeInProgress = null;
            }
        }
        return this;
    } else {
        return this._isUTC ? offset : getDateOffset(this);
    }
}

function getSetZone (input, keepLocalTime) {
    if (input != null) {
        if (typeof input !== 'string') {
            input = -input;
        }

        this.utcOffset(input, keepLocalTime);

        return this;
    } else {
        return -this.utcOffset();
    }
}

function setOffsetToUTC (keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
}

function setOffsetToLocal (keepLocalTime) {
    if (this._isUTC) {
        this.utcOffset(0, keepLocalTime);
        this._isUTC = false;

        if (keepLocalTime) {
            this.subtract(getDateOffset(this), 'm');
        }
    }
    return this;
}

function setOffsetToParsedOffset () {
    if (this._tzm != null) {
        this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
        var tZone = offsetFromString(matchOffset, this._i);
        if (tZone != null) {
            this.utcOffset(tZone);
        }
        else {
            this.utcOffset(0, true);
        }
    }
    return this;
}

function hasAlignedHourOffset (input) {
    if (!this.isValid()) {
        return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;

    return (this.utcOffset() - input) % 60 === 0;
}

function isDaylightSavingTime () {
    return (
        this.utcOffset() > this.clone().month(0).utcOffset() ||
        this.utcOffset() > this.clone().month(5).utcOffset()
    );
}

function isDaylightSavingTimeShifted () {
    if (!isUndefined(this._isDSTShifted)) {
        return this._isDSTShifted;
    }

    var c = {};

    copyConfig(c, this);
    c = prepareConfig(c);

    if (c._a) {
        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
        this._isDSTShifted = this.isValid() &&
            compareArrays(c._a, other.toArray()) > 0;
    } else {
        this._isDSTShifted = false;
    }

    return this._isDSTShifted;
}

function isLocal () {
    return this.isValid() ? !this._isUTC : false;
}

function isUtcOffset () {
    return this.isValid() ? this._isUTC : false;
}

function isUtc () {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
}

// ASP.NET json date format regex
var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
// and further modified to allow for strings containing both week and day
var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

function createDuration (input, key) {
    var duration = input,
        // matching against regexp is expensive, do it on demand
        match = null,
        sign,
        ret,
        diffRes;

    if (isDuration(input)) {
        duration = {
            ms : input._milliseconds,
            d  : input._days,
            M  : input._months
        };
    } else if (isNumber(input)) {
        duration = {};
        if (key) {
            duration[key] = input;
        } else {
            duration.milliseconds = input;
        }
    } else if (!!(match = aspNetRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : 1;
        duration = {
            y  : 0,
            d  : toInt(match[DATE])                         * sign,
            h  : toInt(match[HOUR])                         * sign,
            m  : toInt(match[MINUTE])                       * sign,
            s  : toInt(match[SECOND])                       * sign,
            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
        };
    } else if (!!(match = isoRegex.exec(input))) {
        sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
        duration = {
            y : parseIso(match[2], sign),
            M : parseIso(match[3], sign),
            w : parseIso(match[4], sign),
            d : parseIso(match[5], sign),
            h : parseIso(match[6], sign),
            m : parseIso(match[7], sign),
            s : parseIso(match[8], sign)
        };
    } else if (duration == null) {// checks for null or undefined
        duration = {};
    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

        duration = {};
        duration.ms = diffRes.milliseconds;
        duration.M = diffRes.months;
    }

    ret = new Duration(duration);

    if (isDuration(input) && hasOwnProp(input, '_locale')) {
        ret._locale = input._locale;
    }

    return ret;
}

createDuration.fn = Duration.prototype;
createDuration.invalid = createInvalid$1;

function parseIso (inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
}

function positiveMomentsDifference(base, other) {
    var res = {milliseconds: 0, months: 0};

    res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
        --res.months;
    }

    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

    return res;
}

function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
        return {milliseconds: 0, months: 0};
    }

    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
        res = positiveMomentsDifference(base, other);
    } else {
        res = positiveMomentsDifference(other, base);
        res.milliseconds = -res.milliseconds;
        res.months = -res.months;
    }

    return res;
}

// TODO: remove 'name' arg after deprecation is removed
function createAdder(direction, name) {
    return function (val, period) {
        var dur, tmp;
        //invert the arguments, but complain about it
        if (period !== null && !isNaN(+period)) {
            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
            tmp = val; val = period; period = tmp;
        }

        val = typeof val === 'string' ? +val : val;
        dur = createDuration(val, period);
        addSubtract(this, dur, direction);
        return this;
    };
}

function addSubtract (mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
        days = absRound(duration._days),
        months = absRound(duration._months);

    if (!mom.isValid()) {
        // No op
        return;
    }

    updateOffset = updateOffset == null ? true : updateOffset;

    if (months) {
        setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
        hooks.updateOffset(mom, days || months);
    }
}

var add      = createAdder(1, 'add');
var subtract = createAdder(-1, 'subtract');

function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' :
            diff < -1 ? 'lastWeek' :
            diff < 0 ? 'lastDay' :
            diff < 1 ? 'sameDay' :
            diff < 2 ? 'nextDay' :
            diff < 7 ? 'nextWeek' : 'sameElse';
}

function calendar$1 (time, formats) {
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
        sod = cloneWithOffset(now, this).startOf('day'),
        format = hooks.calendarFormat(this, sod) || 'sameElse';

    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
}

function clone () {
    return new Moment(this);
}

function isAfter (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() > localInput.valueOf();
    } else {
        return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
}

function isBefore (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() < localInput.valueOf();
    } else {
        return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
}

function isBetween (from, to, units, inclusivity) {
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
}

function isSame (input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
        inputMs;
    if (!(this.isValid() && localInput.isValid())) {
        return false;
    }
    units = normalizeUnits(units || 'millisecond');
    if (units === 'millisecond') {
        return this.valueOf() === localInput.valueOf();
    } else {
        inputMs = localInput.valueOf();
        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
}

function isSameOrAfter (input, units) {
    return this.isSame(input, units) || this.isAfter(input,units);
}

function isSameOrBefore (input, units) {
    return this.isSame(input, units) || this.isBefore(input,units);
}

function diff (input, units, asFloat) {
    var that,
        zoneDelta,
        delta, output;

    if (!this.isValid()) {
        return NaN;
    }

    that = cloneWithOffset(input, this);

    if (!that.isValid()) {
        return NaN;
    }

    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

    units = normalizeUnits(units);

    switch (units) {
        case 'year': output = monthDiff(this, that) / 12; break;
        case 'month': output = monthDiff(this, that); break;
        case 'quarter': output = monthDiff(this, that) / 3; break;
        case 'second': output = (this - that) / 1e3; break; // 1000
        case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
        case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
        case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
        case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
        default: output = this - that;
    }

    return asFloat ? output : absFloor(output);
}

function monthDiff (a, b) {
    // difference in months
    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
        // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'),
        anchor2, adjust;

    if (b - anchor < 0) {
        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
        // linear across the month
        adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
}

hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

function toString () {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
}

function toISOString() {
    if (!this.isValid()) {
        return null;
    }
    var m = this.clone().utc();
    if (m.year() < 0 || m.year() > 9999) {
        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
    }
    if (isFunction(Date.prototype.toISOString)) {
        // native implementation is ~50x faster, use it when we can
        return this.toDate().toISOString();
    }
    return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
}

/**
 * Return a human readable representation of a moment that can
 * also be evaluated to get a new moment which is the same
 *
 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
 */
function inspect () {
    if (!this.isValid()) {
        return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment';
    var zone = '';
    if (!this.isLocal()) {
        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
        zone = 'Z';
    }
    var prefix = '[' + func + '("]';
    var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
    var suffix = zone + '[")]';

    return this.format(prefix + year + datetime + suffix);
}

function format (inputString) {
    if (!inputString) {
        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
}

function from (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function fromNow (withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
}

function to (time, withoutSuffix) {
    if (this.isValid() &&
            ((isMoment(time) && time.isValid()) ||
             createLocal(time).isValid())) {
        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
    } else {
        return this.localeData().invalidDate();
    }
}

function toNow (withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
}

// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function locale (key) {
    var newLocaleData;

    if (key === undefined) {
        return this._locale._abbr;
    } else {
        newLocaleData = getLocale(key);
        if (newLocaleData != null) {
            this._locale = newLocaleData;
        }
        return this;
    }
}

var lang = deprecate(
    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
    function (key) {
        if (key === undefined) {
            return this.localeData();
        } else {
            return this.locale(key);
        }
    }
);

function localeData () {
    return this._locale;
}

function startOf (units) {
    units = normalizeUnits(units);
    // the following switch intentionally omits break keywords
    // to utilize falling through the cases.
    switch (units) {
        case 'year':
            this.month(0);
            /* falls through */
        case 'quarter':
        case 'month':
            this.date(1);
            /* falls through */
        case 'week':
        case 'isoWeek':
        case 'day':
        case 'date':
            this.hours(0);
            /* falls through */
        case 'hour':
            this.minutes(0);
            /* falls through */
        case 'minute':
            this.seconds(0);
            /* falls through */
        case 'second':
            this.milliseconds(0);
    }

    // weeks are a special case
    if (units === 'week') {
        this.weekday(0);
    }
    if (units === 'isoWeek') {
        this.isoWeekday(1);
    }

    // quarters are also special
    if (units === 'quarter') {
        this.month(Math.floor(this.month() / 3) * 3);
    }

    return this;
}

function endOf (units) {
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond') {
        return this;
    }

    // 'date' is an alias for 'day', so it should be considered as such.
    if (units === 'date') {
        units = 'day';
    }

    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
}

function valueOf () {
    return this._d.valueOf() - ((this._offset || 0) * 60000);
}

function unix () {
    return Math.floor(this.valueOf() / 1000);
}

function toDate () {
    return new Date(this.valueOf());
}

function toArray () {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
}

function toObject () {
    var m = this;
    return {
        years: m.year(),
        months: m.month(),
        date: m.date(),
        hours: m.hours(),
        minutes: m.minutes(),
        seconds: m.seconds(),
        milliseconds: m.milliseconds()
    };
}

function toJSON () {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
}

function isValid$2 () {
    return isValid(this);
}

function parsingFlags () {
    return extend({}, getParsingFlags(this));
}

function invalidAt () {
    return getParsingFlags(this).overflow;
}

function creationData() {
    return {
        input: this._i,
        format: this._f,
        locale: this._locale,
        isUTC: this._isUTC,
        strict: this._strict
    };
}

// FORMATTING

addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
});

addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
});

function addWeekYearFormatToken (token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
}

addWeekYearFormatToken('gggg',     'weekYear');
addWeekYearFormatToken('ggggg',    'weekYear');
addWeekYearFormatToken('GGGG',  'isoWeekYear');
addWeekYearFormatToken('GGGGG', 'isoWeekYear');

// ALIASES

addUnitAlias('weekYear', 'gg');
addUnitAlias('isoWeekYear', 'GG');

// PRIORITY

addUnitPriority('weekYear', 1);
addUnitPriority('isoWeekYear', 1);


// PARSING

addRegexToken('G',      matchSigned);
addRegexToken('g',      matchSigned);
addRegexToken('GG',     match1to2, match2);
addRegexToken('gg',     match1to2, match2);
addRegexToken('GGGG',   match1to4, match4);
addRegexToken('gggg',   match1to4, match4);
addRegexToken('GGGGG',  match1to6, match6);
addRegexToken('ggggg',  match1to6, match6);

addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
});

addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
});

// MOMENTS

function getSetWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy);
}

function getSetISOWeekYear (input) {
    return getSetWeekYearHelper.call(this,
            input, this.isoWeek(), this.isoWeekday(), 1, 4);
}

function getISOWeeksInYear () {
    return weeksInYear(this.year(), 1, 4);
}

function getWeeksInYear () {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
}

function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
        return weekOfYear(this, dow, doy).year;
    } else {
        weeksTarget = weeksInYear(input, dow, doy);
        if (week > weeksTarget) {
            week = weeksTarget;
        }
        return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
}

function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
}

// FORMATTING

addFormatToken('Q', 0, 'Qo', 'quarter');

// ALIASES

addUnitAlias('quarter', 'Q');

// PRIORITY

addUnitPriority('quarter', 7);

// PARSING

addRegexToken('Q', match1);
addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
});

// MOMENTS

function getSetQuarter (input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
}

// FORMATTING

addFormatToken('D', ['DD', 2], 'Do', 'date');

// ALIASES

addUnitAlias('date', 'D');

// PRIOROITY
addUnitPriority('date', 9);

// PARSING

addRegexToken('D',  match1to2);
addRegexToken('DD', match1to2, match2);
addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ?
      (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
      locale._dayOfMonthOrdinalParseLenient;
});

addParseToken(['D', 'DD'], DATE);
addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0], 10);
});

// MOMENTS

var getSetDayOfMonth = makeGetSet('Date', true);

// FORMATTING

addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

// ALIASES

addUnitAlias('dayOfYear', 'DDD');

// PRIORITY
addUnitPriority('dayOfYear', 4);

// PARSING

addRegexToken('DDD',  match1to3);
addRegexToken('DDDD', match3);
addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
});

// HELPERS

// MOMENTS

function getSetDayOfYear (input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
}

// FORMATTING

addFormatToken('m', ['mm', 2], 0, 'minute');

// ALIASES

addUnitAlias('minute', 'm');

// PRIORITY

addUnitPriority('minute', 14);

// PARSING

addRegexToken('m',  match1to2);
addRegexToken('mm', match1to2, match2);
addParseToken(['m', 'mm'], MINUTE);

// MOMENTS

var getSetMinute = makeGetSet('Minutes', false);

// FORMATTING

addFormatToken('s', ['ss', 2], 0, 'second');

// ALIASES

addUnitAlias('second', 's');

// PRIORITY

addUnitPriority('second', 15);

// PARSING

addRegexToken('s',  match1to2);
addRegexToken('ss', match1to2, match2);
addParseToken(['s', 'ss'], SECOND);

// MOMENTS

var getSetSecond = makeGetSet('Seconds', false);

// FORMATTING

addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
});

addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
});

addFormatToken(0, ['SSS', 3], 0, 'millisecond');
addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
});
addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
});
addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
});
addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
});
addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
});
addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
});


// ALIASES

addUnitAlias('millisecond', 'ms');

// PRIORITY

addUnitPriority('millisecond', 16);

// PARSING

addRegexToken('S',    match1to3, match1);
addRegexToken('SS',   match1to3, match2);
addRegexToken('SSS',  match1to3, match3);

var token;
for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
}

function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
}

for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
}
// MOMENTS

var getSetMillisecond = makeGetSet('Milliseconds', false);

// FORMATTING

addFormatToken('z',  0, 0, 'zoneAbbr');
addFormatToken('zz', 0, 0, 'zoneName');

// MOMENTS

function getZoneAbbr () {
    return this._isUTC ? 'UTC' : '';
}

function getZoneName () {
    return this._isUTC ? 'Coordinated Universal Time' : '';
}

var proto = Moment.prototype;

proto.add               = add;
proto.calendar          = calendar$1;
proto.clone             = clone;
proto.diff              = diff;
proto.endOf             = endOf;
proto.format            = format;
proto.from              = from;
proto.fromNow           = fromNow;
proto.to                = to;
proto.toNow             = toNow;
proto.get               = stringGet;
proto.invalidAt         = invalidAt;
proto.isAfter           = isAfter;
proto.isBefore          = isBefore;
proto.isBetween         = isBetween;
proto.isSame            = isSame;
proto.isSameOrAfter     = isSameOrAfter;
proto.isSameOrBefore    = isSameOrBefore;
proto.isValid           = isValid$2;
proto.lang              = lang;
proto.locale            = locale;
proto.localeData        = localeData;
proto.max               = prototypeMax;
proto.min               = prototypeMin;
proto.parsingFlags      = parsingFlags;
proto.set               = stringSet;
proto.startOf           = startOf;
proto.subtract          = subtract;
proto.toArray           = toArray;
proto.toObject          = toObject;
proto.toDate            = toDate;
proto.toISOString       = toISOString;
proto.inspect           = inspect;
proto.toJSON            = toJSON;
proto.toString          = toString;
proto.unix              = unix;
proto.valueOf           = valueOf;
proto.creationData      = creationData;

// Year
proto.year       = getSetYear;
proto.isLeapYear = getIsLeapYear;

// Week Year
proto.weekYear    = getSetWeekYear;
proto.isoWeekYear = getSetISOWeekYear;

// Quarter
proto.quarter = proto.quarters = getSetQuarter;

// Month
proto.month       = getSetMonth;
proto.daysInMonth = getDaysInMonth;

// Week
proto.week           = proto.weeks        = getSetWeek;
proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
proto.weeksInYear    = getWeeksInYear;
proto.isoWeeksInYear = getISOWeeksInYear;

// Day
proto.date       = getSetDayOfMonth;
proto.day        = proto.days             = getSetDayOfWeek;
proto.weekday    = getSetLocaleDayOfWeek;
proto.isoWeekday = getSetISODayOfWeek;
proto.dayOfYear  = getSetDayOfYear;

// Hour
proto.hour = proto.hours = getSetHour;

// Minute
proto.minute = proto.minutes = getSetMinute;

// Second
proto.second = proto.seconds = getSetSecond;

// Millisecond
proto.millisecond = proto.milliseconds = getSetMillisecond;

// Offset
proto.utcOffset            = getSetOffset;
proto.utc                  = setOffsetToUTC;
proto.local                = setOffsetToLocal;
proto.parseZone            = setOffsetToParsedOffset;
proto.hasAlignedHourOffset = hasAlignedHourOffset;
proto.isDST                = isDaylightSavingTime;
proto.isLocal              = isLocal;
proto.isUtcOffset          = isUtcOffset;
proto.isUtc                = isUtc;
proto.isUTC                = isUtc;

// Timezone
proto.zoneAbbr = getZoneAbbr;
proto.zoneName = getZoneName;

// Deprecations
proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

function createUnix (input) {
    return createLocal(input * 1000);
}

function createInZone () {
    return createLocal.apply(null, arguments).parseZone();
}

function preParsePostFormat (string) {
    return string;
}

var proto$1 = Locale.prototype;

proto$1.calendar        = calendar;
proto$1.longDateFormat  = longDateFormat;
proto$1.invalidDate     = invalidDate;
proto$1.ordinal         = ordinal;
proto$1.preparse        = preParsePostFormat;
proto$1.postformat      = preParsePostFormat;
proto$1.relativeTime    = relativeTime;
proto$1.pastFuture      = pastFuture;
proto$1.set             = set;

// Month
proto$1.months            =        localeMonths;
proto$1.monthsShort       =        localeMonthsShort;
proto$1.monthsParse       =        localeMonthsParse;
proto$1.monthsRegex       = monthsRegex;
proto$1.monthsShortRegex  = monthsShortRegex;

// Week
proto$1.week = localeWeek;
proto$1.firstDayOfYear = localeFirstDayOfYear;
proto$1.firstDayOfWeek = localeFirstDayOfWeek;

// Day of Week
proto$1.weekdays       =        localeWeekdays;
proto$1.weekdaysMin    =        localeWeekdaysMin;
proto$1.weekdaysShort  =        localeWeekdaysShort;
proto$1.weekdaysParse  =        localeWeekdaysParse;

proto$1.weekdaysRegex       =        weekdaysRegex;
proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

// Hours
proto$1.isPM = localeIsPM;
proto$1.meridiem = localeMeridiem;

function get$1 (format, index, field, setter) {
    var locale = getLocale();
    var utc = createUTC().set(setter, index);
    return locale[field](utc, format);
}

function listMonthsImpl (format, index, field) {
    if (isNumber(format)) {
        index = format;
        format = undefined;
    }

    format = format || '';

    if (index != null) {
        return get$1(format, index, field, 'month');
    }

    var i;
    var out = [];
    for (i = 0; i < 12; i++) {
        out[i] = get$1(format, i, field, 'month');
    }
    return out;
}

// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function listWeekdaysImpl (localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    } else {
        format = localeSorted;
        index = format;
        localeSorted = false;

        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';
    }

    var locale = getLocale(),
        shift = localeSorted ? locale._week.dow : 0;

    if (index != null) {
        return get$1(format, (index + shift) % 7, field, 'day');
    }

    var i;
    var out = [];
    for (i = 0; i < 7; i++) {
        out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
}

function listMonths (format, index) {
    return listMonthsImpl(format, index, 'months');
}

function listMonthsShort (format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
}

function listWeekdays (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
}

function listWeekdaysShort (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
}

function listWeekdaysMin (localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
}

getSetGlobalLocale('en', {
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal : function (number) {
        var b = number % 10,
            output = (toInt(number % 100 / 10) === 1) ? 'th' :
            (b === 1) ? 'st' :
            (b === 2) ? 'nd' :
            (b === 3) ? 'rd' : 'th';
        return number + output;
    }
});

// Side effect imports
hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

var mathAbs = Math.abs;

function abs () {
    var data           = this._data;

    this._milliseconds = mathAbs(this._milliseconds);
    this._days         = mathAbs(this._days);
    this._months       = mathAbs(this._months);

    data.milliseconds  = mathAbs(data.milliseconds);
    data.seconds       = mathAbs(data.seconds);
    data.minutes       = mathAbs(data.minutes);
    data.hours         = mathAbs(data.hours);
    data.months        = mathAbs(data.months);
    data.years         = mathAbs(data.years);

    return this;
}

function addSubtract$1 (duration, input, value, direction) {
    var other = createDuration(input, value);

    duration._milliseconds += direction * other._milliseconds;
    duration._days         += direction * other._days;
    duration._months       += direction * other._months;

    return duration._bubble();
}

// supports only 2.0-style add(1, 's') or add(duration)
function add$1 (input, value) {
    return addSubtract$1(this, input, value, 1);
}

// supports only 2.0-style subtract(1, 's') or subtract(duration)
function subtract$1 (input, value) {
    return addSubtract$1(this, input, value, -1);
}

function absCeil (number) {
    if (number < 0) {
        return Math.floor(number);
    } else {
        return Math.ceil(number);
    }
}

function bubble () {
    var milliseconds = this._milliseconds;
    var days         = this._days;
    var months       = this._months;
    var data         = this._data;
    var seconds, minutes, hours, years, monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
            (milliseconds <= 0 && days <= 0 && months <= 0))) {
        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
        days = 0;
        months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;

    seconds           = absFloor(milliseconds / 1000);
    data.seconds      = seconds % 60;

    minutes           = absFloor(seconds / 60);
    data.minutes      = minutes % 60;

    hours             = absFloor(minutes / 60);
    data.hours        = hours % 24;

    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    data.days   = days;
    data.months = months;
    data.years  = years;

    return this;
}

function daysToMonths (days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
}

function monthsToDays (months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
}

function as (units) {
    if (!this.isValid()) {
        return NaN;
    }
    var days;
    var months;
    var milliseconds = this._milliseconds;

    units = normalizeUnits(units);

    if (units === 'month' || units === 'year') {
        days   = this._days   + milliseconds / 864e5;
        months = this._months + daysToMonths(days);
        return units === 'month' ? months : months / 12;
    } else {
        // handle milliseconds separately because of floating point math errors (issue #1867)
        days = this._days + Math.round(monthsToDays(this._months));
        switch (units) {
            case 'week'   : return days / 7     + milliseconds / 6048e5;
            case 'day'    : return days         + milliseconds / 864e5;
            case 'hour'   : return days * 24    + milliseconds / 36e5;
            case 'minute' : return days * 1440  + milliseconds / 6e4;
            case 'second' : return days * 86400 + milliseconds / 1000;
            // Math.floor prevents floating point math errors here
            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
            default: throw new Error('Unknown unit ' + units);
        }
    }
}

// TODO: Use this.as('ms')?
function valueOf$1 () {
    if (!this.isValid()) {
        return NaN;
    }
    return (
        this._milliseconds +
        this._days * 864e5 +
        (this._months % 12) * 2592e6 +
        toInt(this._months / 12) * 31536e6
    );
}

function makeAs (alias) {
    return function () {
        return this.as(alias);
    };
}

var asMilliseconds = makeAs('ms');
var asSeconds      = makeAs('s');
var asMinutes      = makeAs('m');
var asHours        = makeAs('h');
var asDays         = makeAs('d');
var asWeeks        = makeAs('w');
var asMonths       = makeAs('M');
var asYears        = makeAs('y');

function clone$1 () {
    return createDuration(this);
}

function get$2 (units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
}

function makeGetter(name) {
    return function () {
        return this.isValid() ? this._data[name] : NaN;
    };
}

var milliseconds = makeGetter('milliseconds');
var seconds      = makeGetter('seconds');
var minutes      = makeGetter('minutes');
var hours        = makeGetter('hours');
var days         = makeGetter('days');
var months       = makeGetter('months');
var years        = makeGetter('years');

function weeks () {
    return absFloor(this.days() / 7);
}

var round = Math.round;
var thresholds = {
    ss: 44,         // a few seconds to seconds
    s : 45,         // seconds to minute
    m : 45,         // minutes to hour
    h : 22,         // hours to day
    d : 26,         // days to month
    M : 11          // months to year
};

// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
}

function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
    var duration = createDuration(posNegDuration).abs();
    var seconds  = round(duration.as('s'));
    var minutes  = round(duration.as('m'));
    var hours    = round(duration.as('h'));
    var days     = round(duration.as('d'));
    var months   = round(duration.as('M'));
    var years    = round(duration.as('y'));

    var a = seconds <= thresholds.ss && ['s', seconds]  ||
            seconds < thresholds.s   && ['ss', seconds] ||
            minutes <= 1             && ['m']           ||
            minutes < thresholds.m   && ['mm', minutes] ||
            hours   <= 1             && ['h']           ||
            hours   < thresholds.h   && ['hh', hours]   ||
            days    <= 1             && ['d']           ||
            days    < thresholds.d   && ['dd', days]    ||
            months  <= 1             && ['M']           ||
            months  < thresholds.M   && ['MM', months]  ||
            years   <= 1             && ['y']           || ['yy', years];

    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
}

// This function allows you to set the rounding function for relative time strings
function getSetRelativeTimeRounding (roundingFunction) {
    if (roundingFunction === undefined) {
        return round;
    }
    if (typeof(roundingFunction) === 'function') {
        round = roundingFunction;
        return true;
    }
    return false;
}

// This function allows you to set a threshold for relative time strings
function getSetRelativeTimeThreshold (threshold, limit) {
    if (thresholds[threshold] === undefined) {
        return false;
    }
    if (limit === undefined) {
        return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
        thresholds.ss = limit - 1;
    }
    return true;
}

function humanize (withSuffix) {
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var locale = this.localeData();
    var output = relativeTime$1(this, !withSuffix, locale);

    if (withSuffix) {
        output = locale.pastFuture(+this, output);
    }

    return locale.postformat(output);
}

var abs$1 = Math.abs;

function sign(x) {
    return ((x > 0) - (x < 0)) || +x;
}

function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
        return this.localeData().invalidDate();
    }

    var seconds = abs$1(this._milliseconds) / 1000;
    var days         = abs$1(this._days);
    var months       = abs$1(this._months);
    var minutes, hours, years;

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes           = absFloor(seconds / 60);
    hours             = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years  = absFloor(months / 12);
    months %= 12;


    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    var Y = years;
    var M = months;
    var D = days;
    var h = hours;
    var m = minutes;
    var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    var total = this.asSeconds();

    if (!total) {
        // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
    }

    var totalSign = total < 0 ? '-' : '';
    var ymSign = sign(this._months) !== sign(total) ? '-' : '';
    var daysSign = sign(this._days) !== sign(total) ? '-' : '';
    var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

    return totalSign + 'P' +
        (Y ? ymSign + Y + 'Y' : '') +
        (M ? ymSign + M + 'M' : '') +
        (D ? daysSign + D + 'D' : '') +
        ((h || m || s) ? 'T' : '') +
        (h ? hmsSign + h + 'H' : '') +
        (m ? hmsSign + m + 'M' : '') +
        (s ? hmsSign + s + 'S' : '');
}

var proto$2 = Duration.prototype;

proto$2.isValid        = isValid$1;
proto$2.abs            = abs;
proto$2.add            = add$1;
proto$2.subtract       = subtract$1;
proto$2.as             = as;
proto$2.asMilliseconds = asMilliseconds;
proto$2.asSeconds      = asSeconds;
proto$2.asMinutes      = asMinutes;
proto$2.asHours        = asHours;
proto$2.asDays         = asDays;
proto$2.asWeeks        = asWeeks;
proto$2.asMonths       = asMonths;
proto$2.asYears        = asYears;
proto$2.valueOf        = valueOf$1;
proto$2._bubble        = bubble;
proto$2.clone          = clone$1;
proto$2.get            = get$2;
proto$2.milliseconds   = milliseconds;
proto$2.seconds        = seconds;
proto$2.minutes        = minutes;
proto$2.hours          = hours;
proto$2.days           = days;
proto$2.weeks          = weeks;
proto$2.months         = months;
proto$2.years          = years;
proto$2.humanize       = humanize;
proto$2.toISOString    = toISOString$1;
proto$2.toString       = toISOString$1;
proto$2.toJSON         = toISOString$1;
proto$2.locale         = locale;
proto$2.localeData     = localeData;

// Deprecations
proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
proto$2.lang = lang;

// Side effect imports

// FORMATTING

addFormatToken('X', 0, 0, 'unix');
addFormatToken('x', 0, 0, 'valueOf');

// PARSING

addRegexToken('x', matchSigned);
addRegexToken('X', matchTimestamp);
addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input, 10) * 1000);
});
addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
});

// Side effect imports


hooks.version = '2.19.1';

setHookCallback(createLocal);

hooks.fn                    = proto;
hooks.min                   = min;
hooks.max                   = max;
hooks.now                   = now;
hooks.utc                   = createUTC;
hooks.unix                  = createUnix;
hooks.months                = listMonths;
hooks.isDate                = isDate;
hooks.locale                = getSetGlobalLocale;
hooks.invalid               = createInvalid;
hooks.duration              = createDuration;
hooks.isMoment              = isMoment;
hooks.weekdays              = listWeekdays;
hooks.parseZone             = createInZone;
hooks.localeData            = getLocale;
hooks.isDuration            = isDuration;
hooks.monthsShort           = listMonthsShort;
hooks.weekdaysMin           = listWeekdaysMin;
hooks.defineLocale          = defineLocale;
hooks.updateLocale          = updateLocale;
hooks.locales               = listLocales;
hooks.weekdaysShort         = listWeekdaysShort;
hooks.normalizeUnits        = normalizeUnits;
hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
hooks.calendarFormat        = getCalendarFormat;
hooks.prototype             = proto;

return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105)(module)))

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_styles__ = __webpack_require__(1050);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint prefer-template: 0 */






var Dropzone = function (_React$Component) {
  _inherits(Dropzone, _React$Component);

  function Dropzone(props, context) {
    _classCallCheck(this, Dropzone);

    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));

    _this.renderChildren = function (children, isDragActive, isDragAccept, isDragReject) {
      if (typeof children === 'function') {
        return children(_extends({}, _this.state, {
          isDragActive: isDragActive,
          isDragAccept: isDragAccept,
          isDragReject: isDragReject
        }));
      }
      return children;
    };

    _this.composeHandlers = _this.composeHandlers.bind(_this);
    _this.onClick = _this.onClick.bind(_this);
    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
    _this.onDragEnter = _this.onDragEnter.bind(_this);
    _this.onDragLeave = _this.onDragLeave.bind(_this);
    _this.onDragOver = _this.onDragOver.bind(_this);
    _this.onDragStart = _this.onDragStart.bind(_this);
    _this.onDrop = _this.onDrop.bind(_this);
    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
    _this.onInputElementClick = _this.onInputElementClick.bind(_this);

    _this.setRef = _this.setRef.bind(_this);
    _this.setRefs = _this.setRefs.bind(_this);

    _this.isFileDialogActive = false;

    _this.state = {
      draggedFiles: [],
      acceptedFiles: [],
      rejectedFiles: []
    };
    return _this;
  }

  _createClass(Dropzone, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      this.dragTargets = [];

      if (preventDropOnDocument) {
        document.addEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* onDocumentDragOver */], false);
        document.addEventListener('drop', this.onDocumentDrop, false);
      }
      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
      // Tried implementing addEventListener, but didn't work out
      document.body.onfocus = this.onFileDialogCancel;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preventDropOnDocument = this.props.preventDropOnDocument;

      if (preventDropOnDocument) {
        document.removeEventListener('dragover', __WEBPACK_IMPORTED_MODULE_2__utils__["e" /* onDocumentDragOver */]);
        document.removeEventListener('drop', this.onDocumentDrop);
      }
      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
      // Can be replaced with removeEventListener, if addEventListener works
      document.body.onfocus = null;
    }
  }, {
    key: 'composeHandlers',
    value: function composeHandlers(handler) {
      if (this.props.disabled) {
        return null;
      }

      return handler;
    }
  }, {
    key: 'onDocumentDrop',
    value: function onDocumentDrop(evt) {
      if (this.node && this.node.contains(evt.target)) {
        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }
      evt.preventDefault();
      this.dragTargets = [];
    }
  }, {
    key: 'onDragStart',
    value: function onDragStart(evt) {
      if (this.props.onDragStart) {
        this.props.onDragStart.call(this, evt);
      }
    }
  }, {
    key: 'onDragEnter',
    value: function onDragEnter(evt) {
      evt.preventDefault();

      // Count the dropzone and any children that are entered.
      if (this.dragTargets.indexOf(evt.target) === -1) {
        this.dragTargets.push(evt.target);
      }

      this.setState({
        isDragActive: true, // Do not rely on files for the drag state. It doesn't work in Safari.
        draggedFiles: Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */])(evt)
      });

      if (this.props.onDragEnter) {
        this.props.onDragEnter.call(this, evt);
      }
    }
  }, {
    key: 'onDragOver',
    value: function onDragOver(evt) {
      // eslint-disable-line class-methods-use-this
      evt.preventDefault();
      evt.stopPropagation();
      try {
        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
      } catch (err) {
        // continue regardless of error
      }

      if (this.props.onDragOver) {
        this.props.onDragOver.call(this, evt);
      }
      return false;
    }
  }, {
    key: 'onDragLeave',
    value: function onDragLeave(evt) {
      var _this2 = this;

      evt.preventDefault();

      // Only deactivate once the dropzone and all children have been left.
      this.dragTargets = this.dragTargets.filter(function (el) {
        return el !== evt.target && _this2.node.contains(el);
      });
      if (this.dragTargets.length > 0) {
        return;
      }

      // Clear dragging files state
      this.setState({
        isDragActive: false,
        draggedFiles: []
      });

      if (this.props.onDragLeave) {
        this.props.onDragLeave.call(this, evt);
      }
    }
  }, {
    key: 'onDrop',
    value: function onDrop(evt) {
      var _this3 = this;

      var _props = this.props,
          onDrop = _props.onDrop,
          onDropAccepted = _props.onDropAccepted,
          onDropRejected = _props.onDropRejected,
          multiple = _props.multiple,
          disablePreview = _props.disablePreview,
          accept = _props.accept;

      var fileList = Object(__WEBPACK_IMPORTED_MODULE_2__utils__["d" /* getDataTransferItems */])(evt);
      var acceptedFiles = [];
      var rejectedFiles = [];

      // Stop default browser behavior
      evt.preventDefault();

      // Reset the counter along with the drag on a drop.
      this.dragTargets = [];
      this.isFileDialogActive = false;

      fileList.forEach(function (file) {
        if (!disablePreview) {
          try {
            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
          } catch (err) {
            if (false) {
              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
            }
          }
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* fileAccepted */])(file, accept) && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* fileMatchSize */])(file, _this3.props.maxSize, _this3.props.minSize)) {
          acceptedFiles.push(file);
        } else {
          rejectedFiles.push(file);
        }
      });

      if (!multiple) {
        // if not in multi mode add any extra accepted files to rejected.
        // This will allow end users to easily ignore a multi file drop in "single" mode.
        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
      }

      if (onDrop) {
        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
      }

      if (rejectedFiles.length > 0 && onDropRejected) {
        onDropRejected.call(this, rejectedFiles, evt);
      }

      if (acceptedFiles.length > 0 && onDropAccepted) {
        onDropAccepted.call(this, acceptedFiles, evt);
      }

      // Clear files value
      this.draggedFiles = null;

      // Reset drag state
      this.setState({
        isDragActive: false,
        draggedFiles: [],
        acceptedFiles: acceptedFiles,
        rejectedFiles: rejectedFiles
      });
    }
  }, {
    key: 'onClick',
    value: function onClick(evt) {
      var _props2 = this.props,
          onClick = _props2.onClick,
          disableClick = _props2.disableClick;

      if (!disableClick) {
        evt.stopPropagation();

        if (onClick) {
          onClick.call(this, evt);
        }

        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
        // this is so react can handle state changes in the onClick prop above above
        // see: https://github.com/react-dropzone/react-dropzone/issues/450
        setTimeout(this.open.bind(this), 0);
      }
    }
  }, {
    key: 'onInputElementClick',
    value: function onInputElementClick(evt) {
      evt.stopPropagation();
      if (this.props.inputProps && this.props.inputProps.onClick) {
        this.props.inputProps.onClick();
      }
    }
  }, {
    key: 'onFileDialogCancel',
    value: function onFileDialogCancel() {
      // timeout will not recognize context of this method
      var onFileDialogCancel = this.props.onFileDialogCancel;
      var fileInputEl = this.fileInputEl;
      var isFileDialogActive = this.isFileDialogActive;
      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
      // is opened in the browser

      if (onFileDialogCancel && isFileDialogActive) {
        setTimeout(function () {
          // Returns an object as FileList
          var FileList = fileInputEl.files;
          if (!FileList.length) {
            isFileDialogActive = false;
            onFileDialogCancel();
          }
        }, 300);
      }
    }
  }, {
    key: 'setRef',
    value: function setRef(ref) {
      this.node = ref;
    }
  }, {
    key: 'setRefs',
    value: function setRefs(ref) {
      this.fileInputEl = ref;
    }
    /**
     * Open system file upload dialog.
     *
     * @public
     */

  }, {
    key: 'open',
    value: function open() {
      this.isFileDialogActive = true;
      this.fileInputEl.value = null;
      this.fileInputEl.click();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          accept = _props3.accept,
          acceptClassName = _props3.acceptClassName,
          activeClassName = _props3.activeClassName,
          children = _props3.children,
          disabled = _props3.disabled,
          disabledClassName = _props3.disabledClassName,
          inputProps = _props3.inputProps,
          multiple = _props3.multiple,
          name = _props3.name,
          rejectClassName = _props3.rejectClassName,
          rest = _objectWithoutProperties(_props3, ['accept', 'acceptClassName', 'activeClassName', 'children', 'disabled', 'disabledClassName', 'inputProps', 'multiple', 'name', 'rejectClassName']);

      var acceptStyle = rest.acceptStyle,
          activeStyle = rest.activeStyle,
          className = rest.className,
          disabledStyle = rest.disabledStyle,
          rejectStyle = rest.rejectStyle,
          style = rest.style,
          props = _objectWithoutProperties(rest, ['acceptStyle', 'activeStyle', 'className', 'disabledStyle', 'rejectStyle', 'style']);

      var _state = this.state,
          isDragActive = _state.isDragActive,
          draggedFiles = _state.draggedFiles;

      var filesCount = draggedFiles.length;
      var isMultipleAllowed = multiple || filesCount <= 1;
      var isDragAccept = filesCount > 0 && Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* allFilesAccepted */])(draggedFiles, this.props.accept);
      var isDragReject = filesCount > 0 && (!isDragAccept || !isMultipleAllowed);
      className = className || '';
      var noStyles = !className && !style && !activeStyle && !acceptStyle && !rejectStyle && !disabledStyle;

      if (isDragActive && activeClassName) {
        className += ' ' + activeClassName;
      }
      if (isDragAccept && acceptClassName) {
        className += ' ' + acceptClassName;
      }
      if (isDragReject && rejectClassName) {
        className += ' ' + rejectClassName;
      }
      if (disabled && disabledClassName) {
        className += ' ' + disabledClassName;
      }

      if (noStyles) {
        style = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].default;
        activeStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].active;
        acceptStyle = style.active;
        rejectStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].rejected;
        disabledStyle = __WEBPACK_IMPORTED_MODULE_3__utils_styles__["a" /* default */].disabled;
      }

      var appliedStyle = _extends({}, style);
      if (activeStyle && isDragActive) {
        appliedStyle = _extends({}, style, activeStyle);
      }
      if (acceptStyle && isDragAccept) {
        appliedStyle = _extends({}, appliedStyle, acceptStyle);
      }
      if (rejectStyle && isDragReject) {
        appliedStyle = _extends({}, appliedStyle, rejectStyle);
      }
      if (disabledStyle && disabled) {
        appliedStyle = _extends({}, style, disabledStyle);
      }

      var inputAttributes = {
        accept: accept,
        disabled: disabled,
        type: 'file',
        style: { display: 'none' },
        multiple: __WEBPACK_IMPORTED_MODULE_2__utils__["f" /* supportMultiple */] && multiple,
        ref: this.setRefs,
        onChange: this.onDrop,
        autoComplete: 'off'
      };

      if (name && name.length) {
        inputAttributes.name = name;
      }

      // Remove custom properties before passing them to the wrapper div element
      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'activeClassName', 'acceptClassName', 'rejectClassName', 'disabledClassName', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
      var divProps = _extends({}, props);
      customProps.forEach(function (prop) {
        return delete divProps[prop];
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        _extends({
          className: className,
          style: appliedStyle
        }, divProps /* expand user provided props first so event handlers are never overridden */, {
          onClick: this.composeHandlers(this.onClick),
          onDragStart: this.composeHandlers(this.onDragStart),
          onDragEnter: this.composeHandlers(this.onDragEnter),
          onDragOver: this.composeHandlers(this.onDragOver),
          onDragLeave: this.composeHandlers(this.onDragLeave),
          onDrop: this.composeHandlers(this.onDrop),
          ref: this.setRef,
          'aria-disabled': disabled
        }),
        this.renderChildren(children, isDragActive, isDragAccept, isDragReject),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
      );
    }
  }]);

  return Dropzone;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/* harmony default export */ __webpack_exports__["default"] = (Dropzone);

Dropzone.propTypes = {
  /**
   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Contents of the dropzone
   */
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),

  /**
   * Disallow clicking on the dropzone container to open file dialog
   */
  disableClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
  * Enable/disable the dropzone entirely
  */
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Enable/disable preview generation
   */
  disablePreview: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * Pass additional attributes to the `<input type="file"/>` tag
   */
  inputProps: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * Allow dropping multiple files
   */
  multiple: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  /**
   * `name` attribute for the input tag
   */
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * Maximum file size
   */
  maxSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * Minimum file size
   */
  minSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,

  /**
   * className
   */
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for active state
   */
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for accepted state
   */
  acceptClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for rejected state
   */
  rejectClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * className for disabled state
   */
  disabledClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  /**
   * CSS styles to apply
   */
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drag is active
   */
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be accepted
   */
  acceptStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when drop will be rejected
   */
  rejectStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * CSS styles to apply when dropzone is disabled
   */
  disabledStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,

  /**
   * onClick callback
   * @param {Event} event
   */
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDrop callback
   */
  onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropAccepted callback
   */
  onDropAccepted: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDropRejected callback
   */
  onDropRejected: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragStart callback
   */
  onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragEnter callback
   */
  onDragEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragOver callback
   */
  onDragOver: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * onDragLeave callback
   */
  onDragLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,

  /**
   * Provide a callback on clicking the cancel button of the file dialog
   */
  onFileDialogCancel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

Dropzone.defaultProps = {
  preventDropOnDocument: true,
  disabled: false,
  disablePreview: false,
  disableClick: false,
  multiple: true,
  maxSize: Infinity,
  minSize: 0
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reactRedux=__webpack_require__(2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(10);__webpack_require__(1059);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  history: Object,
  disabled?: boolean,
  onClick?: ?Function,
  icon: string,
};*/var Button=function Button(_ref){var history=_ref.history,_ref$disabled=_ref.disabled,disabled=_ref$disabled===undefined?false:_ref$disabled,onClick=_ref.onClick,icon=_ref.icon;return _react2.default.createElement('div',{className:'Button'},_react2.default.createElement('button',{onClick:onClick||history.goBack,type:'button',className:'button secondary flat',disabled:!!disabled},_react2.default.createElement('i',{className:'fa fa-'+icon})));};var none=function none(){return{};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(none,none)(Button));

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('toPairs', __webpack_require__(1080), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _unionBy2=__webpack_require__(464);var _unionBy3=_interopRequireDefault(_unionBy2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _DecimalFormInput=__webpack_require__(70);var _DecimalFormInput2=_interopRequireDefault(_DecimalFormInput);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _AdvancedProductSlotDialog=__webpack_require__(1090);var _AdvancedProductSlotDialog2=_interopRequireDefault(_AdvancedProductSlotDialog);var _reactTooltip=__webpack_require__(91);var _reactTooltip2=_interopRequireDefault(_reactTooltip);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);__webpack_require__(1092);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: import type {
  ModifiedState,
  NavigationState,
} from '../../reducers/configTemplateView';*//*:: import type {
  ErrorDto,
  ProductDto,
  ProductSlotDto,
  ProductTypeDto,
  RoomDto,
} from '../../dtos';*/var productSlotTypes=[{value:true,label:'Avancerad'},{value:false,label:'Enkel'}];var notArchived=(0,_filter3.default)({archived:null});var includeProductType=function includeProductType(productSlot){return(0,_filter3.default)(function(t){return t.id===productSlot.productTypeId||!t.archived;});};var filterProductTypes=function filterProductTypes(productSlot){return productSlot?includeProductType(productSlot):notArchived;};var getRootName=function getRootName(formValues,productSlot,productTypes){var productType=!!formValues.productTypeId?(0,_find3.default)({id:formValues.productTypeId},productTypes):null;var rootName=!!formValues.name?'Produktplats '+formValues.name:'Produktplats';return!!productType?rootName+' ('+productType.name+')':rootName;};/*:: export type Props = {
  productSlot: ?ProductSlotDto,
  room: ?RoomDto,
  formValues: any,
  productTypes: ProductTypeDto[],
  products: ProductDto[],
  onArchive: () => any,
  onUserChange: () => any,
  change: Function,
  openDialog: Function,
  closeDialog: Function,
  dialogError: ?ErrorDto,
  dialogIsFetching: boolean,
  showDialog: boolean,
  navigateToVariant: Function,
  popDialogNavigation: Function,
  dialogNavigation: ?NavigationState,
  updateRelatedVariant: Function,
  toggleVariant: Function,
  setStandardProduct: Function,
  modifiedData: ModifiedState,
  toggleProduct: Function,
  sharedChecked: ?boolean,
  checkAllVariants: Function,
  clearStandardProduct: Function,
  isDirty: boolean,
  checkProduct: Function,
  updateVariants: Function,
  updateProductSlots: (sortDirection: 'up' | 'down') => void,
  sortDownDisabled: boolean,
  sortUpDisabled: boolean,
  updateVariantsForType: Function,
};*/var _ref=_react2.default.createElement('i',{className:'fa fa-arrow-up'});var _ref2=_react2.default.createElement('i',{className:'fa fa-arrow-down'});var _ref3=_react2.default.createElement(_reactTooltip2.default,{id:'advanced-tip',effect:'solid'},_react2.default.createElement('span',null,'Produktplatsen m\xE5ste sparas innan den kan konfigureras'));var ProductSlotForm=function(_Component){_inherits(ProductSlotForm,_Component);function ProductSlotForm(){_classCallCheck(this,ProductSlotForm);return _possibleConstructorReturn(this,(ProductSlotForm.__proto__||Object.getPrototypeOf(ProductSlotForm)).apply(this,arguments));}_createClass(ProductSlotForm,[{key:'onProductTypeIdChange',value:function onProductTypeIdChange(value/*: ?number*/){var _props=this.props,formValues=_props.formValues,change=_props.change;if(value!==formValues.productTypeId){change('blacklistedProducts',[]);change('defaultProductId',null);}}},{key:'getSlotProducts',value:function getSlotProducts(){var _props2=this.props,products=_props2.products,formValues=_props2.formValues,room=_props2.room;if(!formValues||!formValues.productTypeId){return[];}var roomProducts=!!room?(0,_filter3.default)(function(p){return!p.roomTypes.length||(0,_some3.default)({id:room.roomTypeId},p.roomTypes);},products):products;return(0,_filter3.default)({productTypeId:formValues.productTypeId},roomProducts);}},{key:'getCurrentDefaultProduct',value:function getCurrentDefaultProduct(){var _props3=this.props,productSlot=_props3.productSlot,products=_props3.products;return!!productSlot?(0,_find3.default)({id:productSlot.defaultProductId},products):null;}},{key:'getDefaultProductOptions',value:function getDefaultProductOptions(){var options=this.getSlotProducts();var current=this.getCurrentDefaultProduct();return current?(0,_unionBy3.default)('id',options,[current]):options;}},{key:'getCurrentBlacklistProducts',value:function getCurrentBlacklistProducts(){var _props4=this.props,productSlot=_props4.productSlot,products=_props4.products;return!!productSlot?(0,_filter3.default)(function(p){return(0,_some3.default)({id:p.id},productSlot.blacklistedProducts);},products):products;}},{key:'getBlacklistOptions',value:function getBlacklistOptions(){var options=this.getSlotProducts();var current=this.getCurrentBlacklistProducts();return(0,_unionBy3.default)('id',options,current);}},{key:'render',value:function render(){var _this2=this;var _props5=this.props,productSlot=_props5.productSlot,room=_props5.room,productTypes=_props5.productTypes,onArchive=_props5.onArchive,onUserChange=_props5.onUserChange,formValues=_props5.formValues,openDialog=_props5.openDialog,closeDialog=_props5.closeDialog,dialogIsFetching=_props5.dialogIsFetching,dialogError=_props5.dialogError,showDialog=_props5.showDialog,navigateToVariant=_props5.navigateToVariant,popDialogNavigation=_props5.popDialogNavigation,dialogNavigation=_props5.dialogNavigation,updateRelatedVariant=_props5.updateRelatedVariant,toggleVariant=_props5.toggleVariant,setStandardProduct=_props5.setStandardProduct,modifiedData=_props5.modifiedData,toggleProduct=_props5.toggleProduct,sharedChecked=_props5.sharedChecked,checkAllVariants=_props5.checkAllVariants,clearStandardProduct=_props5.clearStandardProduct,isDirty=_props5.isDirty,checkProduct=_props5.checkProduct,updateVariants=_props5.updateVariants,updateProductSlots=_props5.updateProductSlots,sortDownDisabled=_props5.sortDownDisabled,sortUpDisabled=_props5.sortUpDisabled,updateVariantsForType=_props5.updateVariantsForType;return _react2.default.createElement('div',{className:'ProductSlotForm'},_react2.default.createElement('div',{className:'row align-justify align-middle box-header'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('span',{className:'box-title'},!!room?room.name:'',' - ',productSlot&&productSlot.name||'Ny produktplats')),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},productSlot&&productSlot.id&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},[_react2.default.createElement('button',{key:0,type:'button',className:'button secondary small',disabled:sortUpDisabled,onClick:function onClick(){return updateProductSlots('up');}},_ref),_react2.default.createElement('button',{key:1,type:'button',className:'button secondary small',disabled:sortDownDisabled,onClick:function onClick(){return updateProductSlots('down');}},_ref2),_react2.default.createElement(_ActionConfirmation2.default,{key:2,id:'archiveProductSlot',className:'secondary small',message:'Vill du verkligen '+(productSlot.archived?'av':'')+'arkivera den h\xE4r produktplatsen?',buttonText:productSlot.archived?'Avarkivera':'Arkivera',action:onArchive})]))),_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'productTypeId',label:'Produkttyp',disabled:!!(productSlot&&productSlot.id),normalize:function normalize(v){var value=v?v.id:null;_this2.onProductTypeIdChange(value);return value;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:filterProductTypes(productSlot)(productTypes)}),formValues&&formValues.productTypeId&&_react2.default.createElement(_reduxForm.Field,{name:'advanced',label:'Typ av produktplats',normalize:function normalize(x){return x?x.value:false;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'value',labelKey:'label',options:productSlotTypes}),formValues&&formValues.productTypeId&&!formValues.advanced&&_react2.default.createElement('div',null,_react2.default.createElement(_reduxForm.Field,{name:'defaultProductId',label:'Standardprodukt',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:this.getDefaultProductOptions()}),_react2.default.createElement(_reduxForm.Field,{name:'unit',label:'Enhet',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'quantity',label:'Antal',onChange:onUserChange,component:_DecimalFormInput2.default}),_react2.default.createElement(_reduxForm.Field,{name:'blacklistedProducts',label:'Otill\xE5tna produkter',onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:this.getBlacklistOptions(),multi:true})),formValues&&formValues.productTypeId&&!!formValues.advanced&&_react2.default.createElement('div',{'data-tip':true,'data-for':'advanced-tip'},_react2.default.createElement('button',{type:'button',className:'button small expanded',disabled:!productSlot||!productSlot.id,onClick:function onClick(){return openDialog(formValues.productTypeId,getRootName(formValues,productSlot,productTypes));}},'Redigera avancerad produktplats'),(!productSlot||!productSlot.id)&&_ref3,!!showDialog&&!!dialogNavigation&&_react2.default.createElement(_AdvancedProductSlotDialog2.default,{isFetching:dialogIsFetching,error:dialogError,onClose:closeDialog,navigateToVariant:navigateToVariant,popDialogNavigation:popDialogNavigation,navigationStack:dialogNavigation,updateRelatedVariant:function(_updateRelatedVariant){function updateRelatedVariant(_x,_x2){return _updateRelatedVariant.apply(this,arguments);}updateRelatedVariant.toString=function(){return _updateRelatedVariant.toString();};return updateRelatedVariant;}(function(variant,data){onUserChange();updateRelatedVariant(variant,data);}),toggleVariant:toggleVariant,setStandardProduct:function(_setStandardProduct){function setStandardProduct(_x3,_x4){return _setStandardProduct.apply(this,arguments);}setStandardProduct.toString=function(){return _setStandardProduct.toString();};return setStandardProduct;}(function(product,productType){onUserChange();setStandardProduct(product,productType);}),modifiedData:modifiedData,toggleProduct:toggleProduct,sharedChecked:sharedChecked,checkAllVariants:function(_checkAllVariants){function checkAllVariants(_x5){return _checkAllVariants.apply(this,arguments);}checkAllVariants.toString=function(){return _checkAllVariants.toString();};return checkAllVariants;}(function(checked){onUserChange();checkAllVariants(checked);}),clearStandardProduct:function(_clearStandardProduct){function clearStandardProduct(_x6){return _clearStandardProduct.apply(this,arguments);}clearStandardProduct.toString=function(){return _clearStandardProduct.toString();};return clearStandardProduct;}(function(productType){onUserChange();clearStandardProduct(productType);}),checkProduct:function(_checkProduct){function checkProduct(_x7,_x8){return _checkProduct.apply(this,arguments);}checkProduct.toString=function(){return _checkProduct.toString();};return checkProduct;}(function(productId,checked){onUserChange();checkProduct(productId,checked);}),updateVariants:function(_updateVariants){function updateVariants(_x9,_x10){return _updateVariants.apply(this,arguments);}updateVariants.toString=function(){return _updateVariants.toString();};return updateVariants;}(function(productId,data){onUserChange();updateVariants(productId,data);}),updateVariantsForType:function(_updateVariantsForType){function updateVariantsForType(_x11,_x12){return _updateVariantsForType.apply(this,arguments);}updateVariantsForType.toString=function(){return _updateVariantsForType.toString();};return updateVariantsForType;}(function(productTypeId,data){onUserChange();updateVariantsForType(productTypeId,data);})})));}}]);return ProductSlotForm;}(_react.Component);exports.default=ProductSlotForm;

/***/ }),
/* 261 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function evaluateFormatters(formatters) {
  return function (value, extra) {
    return formatters.reduce(function (parameters, formatter) {
      return {
        value: formatter(parameters.value, parameters.extra),
        extra: extra
      };
    }, { value: value, extra: extra }).value;
  };
}

exports.default = evaluateFormatters;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction2 = __webpack_require__(52);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _mergeProps = __webpack_require__(177);

var _mergeProps2 = _interopRequireDefault(_mergeProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function evaluateTransforms() {
  var transforms = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var value = arguments[1];
  var extraParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (false) {
    if (!transforms.every(_isFunction3.default)) {
      throw new Error('All transforms weren\'t functions!', transforms);
    }
  }

  if (transforms.length === 0) {
    return {};
  }

  return _mergeProps2.default.apply(undefined, _toConsumableArray(transforms.map(function (transform) {
    return transform(value, extraParameters);
  })));
}

exports.default = evaluateTransforms;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var defaultOrder = {
  FIRST: 'asc',
  '': 'asc',
  asc: 'desc',
  desc: ''
};

exports.default = defaultOrder;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reduce2=__webpack_require__(123);var _reduce3=_interopRequireDefault(_reduce2);var _split2=__webpack_require__(1276);var _split3=_interopRequireDefault(_split2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1282);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fileUrl=_request.apiBase+'/files';/*:: export type Props = {
  file?: any,
  className?: string,
  size?: ?string,
  onClick?: ?Function,
  showOverlay?: boolean,
};*/var _ref2=_react2.default.createElement('div',{className:'no-image'},_react2.default.createElement('i',{className:'fa fa-file-image-o'}));var _ref3=_react2.default.createElement('div',{className:'CustomerProductImage-popup-info'},'Tryck f\xF6r att zooma');var _ref4=_react2.default.createElement('span',{className:'CustomerProductImage-popup-info-icon'},_react2.default.createElement('i',{className:'fa fa-search-plus'}));var CustomerProductImage=function CustomerProductImage(_ref){var file=_ref.file,className=_ref.className,size=_ref.size,onClick=_ref.onClick,_ref$showOverlay=_ref.showOverlay,showOverlay=_ref$showOverlay===undefined?false:_ref$showOverlay;return _react2.default.createElement('div',{className:(0,_classnames2.default)(_extends({CustomerProductImage:true,clickable:!!onClick},!!className?(0,_flow3.default)((0,_split3.default)(' '),(0,_reduce3.default)(function(a,b){a[b]=true;return a;},{}))(className):{})),onClick:function(_onClick){function onClick(){return _onClick.apply(this,arguments);}onClick.toString=function(){return _onClick.toString();};return onClick;}(function(){if(!!onClick){onClick();}})},!file&&_ref2,file&&!showOverlay&&_react2.default.createElement('img',{src:fileUrl+'/preview/'+file.id+'/'+(size||600),alt:''}),file&&showOverlay&&_react2.default.createElement('div',{className:'center-wrapper'},_react2.default.createElement('img',{src:fileUrl+'/preview/'+file.id+'/'+(size||600),alt:''}),_ref3,_ref4));};exports.default=CustomerProductImage;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1296)();
}


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(457);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1312);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _ref=_react2.default.createElement('div',{className:'WarningText-warning-box'},'Vi reserverar oss f\xF6r utg\xE5ende produkter och f\xF6r\xE4ndringar av fabrikat. F\xE4rg\xE5tergivning kan variera.');var WarningText=function WarningText(){return _ref;};exports.default=WarningText;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.bd1097e1.png";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(505);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(274);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(104)))

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(279);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(283);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(181);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(289);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(186);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(188);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"],
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"],
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"],
    meta: { form: form, field: field }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"],
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"],
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"],
    meta: { form: form, field: field }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"],
    meta: { form: form, field: field }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"],
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"],
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"],
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"],
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"],
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"],
    meta: { form: form }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"],
    meta: { form: form }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"],
    meta: { form: form, field: field }
  };
};

var destroy = function destroy() {
  for (var _len = arguments.length, form = Array(_len), _key = 0; _key < _len; _key++) {
    form[_key] = arguments[_key];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"],
    meta: { form: form }
  };
};

var focus = function focus(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"],
    meta: { form: form, field: field }
  };
};

var initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"],
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = function reset(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"],
    meta: { form: form }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"],
    meta: { form: form, field: field }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"],
    meta: { form: form }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"],
    meta: { form: form }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len2 = arguments.length, fields = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    fields[_key2 - 1] = arguments[_key2];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"],
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len3 = arguments.length, fields = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    fields[_key3 - 1] = arguments[_key3];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"],
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"],
    meta: { form: form, fields: fields }
  };
};

var unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = function untouch(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"],
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"],
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"],
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldAsyncValidate);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldValidate);

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldError);

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldWarn);

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_error__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(__WEBPACK_IMPORTED_MODULE_0_es6_error___default.a);

/* harmony default export */ __webpack_exports__["a"] = (SubmissionError);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS,
      deepEqual = _ref2.deepEqual;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldProps);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getValue__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isReactNative__ = __webpack_require__(300);




var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__getValue__["a" /* default */])(event, __WEBPACK_IMPORTED_MODULE_1__isReactNative__["a" /* default */]);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (onChangeValue);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ __webpack_exports__["a"] = (isEvent);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ __webpack_exports__["a"] = (isReactNative);

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(590);


/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(613);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(192);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(626);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(50);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(198);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(306);



var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  return !Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.props, nextProps, customizer) || !Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.state, nextState, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (shallowCompare);

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(660);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(74);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(659);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(61);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(110);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(305);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsPristine);

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(109);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(142);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(299);


var silenceEvent = function silenceEvent(event) {
  var is = Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvent);

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(62),
    metaMap = __webpack_require__(323);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(324);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75),
    root = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),
/* 326 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(328),
    composeArgsRight = __webpack_require__(329),
    countHolders = __webpack_require__(765),
    createCtor = __webpack_require__(145),
    createRecurry = __webpack_require__(330),
    getHolder = __webpack_require__(212),
    reorder = __webpack_require__(776),
    replaceHolders = __webpack_require__(150),
    root = __webpack_require__(36);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 329 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(331),
    setData = __webpack_require__(333),
    setWrapToString = __webpack_require__(335);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(206),
    getData = __webpack_require__(208),
    getFuncName = __webpack_require__(332),
    lodash = __webpack_require__(767);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(766);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(322),
    shortOut = __webpack_require__(334);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 334 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(769),
    insertWrapDetails = __webpack_require__(770),
    setToString = __webpack_require__(211),
    updateWrapDetails = __webpack_require__(773);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 337 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(94),
    keys = __webpack_require__(59);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(780),
    isArguments = __webpack_require__(115),
    isArray = __webpack_require__(18),
    isBuffer = __webpack_require__(116),
    isIndex = __webpack_require__(113),
    isTypedArray = __webpack_require__(152);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 340 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(36);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(105)(module)))

/***/ }),
/* 342 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(220),
    getPrototype = __webpack_require__(221),
    getSymbols = __webpack_require__(218),
    stubArray = __webpack_require__(342);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(345),
    getSymbols = __webpack_require__(218),
    keys = __webpack_require__(59);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(220),
    isArray = __webpack_require__(18);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75),
    root = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(36);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(223);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(146),
    getPrototype = __webpack_require__(221),
    isPrototype = __webpack_require__(154);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(163),
    arraySome = __webpack_require__(351),
    cacheHas = __webpack_require__(164);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(45);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(837);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(839),
    hasPath = __webpack_require__(357);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(78),
    isArguments = __webpack_require__(115),
    isArray = __webpack_require__(18),
    isIndex = __webpack_require__(113),
    isLength = __webpack_require__(214),
    toKey = __webpack_require__(64);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(119);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(147);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isArray = __webpack_require__(18),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(851),
    keys = __webpack_require__(59);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(80);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(364),
    keys = __webpack_require__(59);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(855);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
var rng;

var crypto = global.crypto || global.msCrypto; // for IE 11
if (crypto && crypto.getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
  rng = function whatwgRNG() {
    crypto.getRandomValues(rnds8);
    return rnds8;
  };
}

if (!rng) {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);
  rng = function() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

module.exports = rng;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),
/* 366 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.uploadFile=exports.removeUpload=exports.uploadError=exports.uploadSuccess=exports.uploadProgress=exports.uploadInitialized=exports.REMOVE_UPLOAD=exports.UPLOAD_ERROR=exports.UPLOAD_SUCCESS=exports.UPLOAD_PROGRESS=exports.UPLOAD_INITIALIZED=exports.FILE_ADDED=undefined;var _fileUploader=__webpack_require__(81);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var FILE_ADDED=exports.FILE_ADDED='FILE_ADDED';var UPLOAD_INITIALIZED=exports.UPLOAD_INITIALIZED='UPLOAD_INITIALIZED';var UPLOAD_PROGRESS=exports.UPLOAD_PROGRESS='UPLOAD_PROGRESS';var UPLOAD_SUCCESS=exports.UPLOAD_SUCCESS='UPLOAD_SUCCESS';var UPLOAD_ERROR=exports.UPLOAD_ERROR='UPLOAD_ERROR';var REMOVE_UPLOAD=exports.REMOVE_UPLOAD='REMOVE_UPLOAD';var uploadInitialized=exports.uploadInitialized=function uploadInitialized(tempId,id){return{type:UPLOAD_INITIALIZED,tempId:tempId,id:id};};var uploadProgress=exports.uploadProgress=function uploadProgress(tempId,progress){return{type:UPLOAD_PROGRESS,tempId:tempId,progress:progress};};var uploadSuccess=exports.uploadSuccess=function uploadSuccess(tempId,metadata){return{type:UPLOAD_SUCCESS,tempId:tempId,metadata:metadata};};var uploadError=exports.uploadError=function uploadError(tempId,error){return{type:UPLOAD_ERROR,tempId:tempId,error:error};};var removeUpload=exports.removeUpload=function removeUpload(tempId){return _defineProperty({type:REMOVE_UPLOAD,tempId:tempId},_fileUploader.ABORT_UPLOAD,true);};var uploadFile=exports.uploadFile=function uploadFile(tempId,file){return{type:FILE_ADDED,tempId:tempId,file:file};};

/***/ }),
/* 368 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(46),
    baseIteratee = __webpack_require__(24),
    basePickBy = __webpack_require__(370),
    getAllKeysIn = __webpack_require__(222);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(165),
    baseSet = __webpack_require__(864),
    castPath = __webpack_require__(78);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(46),
    baseIteratee = __webpack_require__(24),
    baseMap = __webpack_require__(372),
    isArray = __webpack_require__(18);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(80),
    isArrayLike = __webpack_require__(60);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(46),
    baseIteratee = __webpack_require__(24),
    baseMap = __webpack_require__(372),
    baseSortBy = __webpack_require__(872),
    baseUnary = __webpack_require__(63),
    compareMultiple = __webpack_require__(873),
    identity = __webpack_require__(62);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  var index = -1;
  iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.createDeviation=exports.updateDeviation=exports.fetchDeviation=exports.clearDeviation=exports.reset=exports.CLEAR=exports.RESET=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);var _notification=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var GET_REQUEST=exports.GET_REQUEST='@deviationView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@deviationView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@deviationView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@deviationView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@deviationView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@deviationView/UPDATE_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@deviationView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@deviationView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@deviationView/CREATE_FAILURE';var RESET=exports.RESET='@deviationView/RESET';var CLEAR=exports.CLEAR='@deviationView/CLEAR';var deviationRequest=function deviationRequest(){return{type:GET_REQUEST};};var deviationSuccess=function deviationSuccess(deviation){return{type:GET_SUCCESS,deviation:deviation};};var deviationFailure=function deviationFailure(error){return{type:GET_FAILURE,error:error};};var deviationUpdateRequest=function deviationUpdateRequest(){return{type:UPDATE_REQUEST};};var deviationUpdateSuccess=function deviationUpdateSuccess(deviation){return _defineProperty({type:UPDATE_SUCCESS,deviation:deviation},_notification.ADD,{message:'Avvikelse uppdaterad'});};var deviationUpdateFailure=function deviationUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var deviationCreateRequest=function deviationCreateRequest(){return{type:CREATE_REQUEST};};var deviationCreateSuccess=function deviationCreateSuccess(deviation){return _defineProperty({type:CREATE_SUCCESS,deviation:deviation},_notification.ADD,{message:'Avvikelse "'+deviation.name+'" skapad'});};var deviationCreateFailure=function deviationCreateFailure(error){return{type:CREATE_FAILURE,error:error};};var reset=exports.reset=function reset(){return{type:RESET};};var clearDeviation=exports.clearDeviation=function clearDeviation(){return{type:CLEAR};};var fetchDeviation=exports.fetchDeviation=function fetchDeviation(id){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var deviation;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(deviationRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/deviations/'+id},dispatch);case 4:deviation=_context.sent;dispatch(deviationSuccess(deviation));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(deviationFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref3.apply(this,arguments);};}();};var updateDeviation=exports.updateDeviation=function updateDeviation(id,body){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var deviation;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(deviationUpdateRequest());_context2.prev=1;_context2.next=4;return(0,_request.PUT)({endpoint:'/deviations/'+id,body:body},dispatch);case 4:deviation=_context2.sent;dispatch(deviationUpdateSuccess(deviation));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(deviationUpdateFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref4.apply(this,arguments);};}();};var createDeviation=exports.createDeviation=function createDeviation(body){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var deviation;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(deviationCreateRequest());_context3.prev=1;_context3.next=4;return(0,_request.POST)({endpoint:'/deviations',body:body},dispatch);case 4:deviation=_context3.sent;dispatch(deviationCreateSuccess(deviation));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);dispatch(deviationCreateFailure(_context3.t0));case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref5.apply(this,arguments);};}();};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.filterDeviations=exports.fetchDeviations=exports.SORT=exports.FILTER=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var GET_REQUEST=exports.GET_REQUEST='@deviationList/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@deviationList/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@deviationList/GET_FAILURE';var FILTER=exports.FILTER='@deviationList/FILTER';var SORT=exports.SORT='@deviationList/SORT';var deviationsRequest=function deviationsRequest(){return{type:GET_REQUEST};};var deviationsSuccess=function deviationsSuccess(deviations){return{type:GET_SUCCESS,deviations:deviations};};var deviationsFailure=function deviationsFailure(error){return{type:GET_FAILURE,error:error};};var fetchDeviations=exports.fetchDeviations=function fetchDeviations(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var deviations;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(deviationsRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/deviations'},dispatch);case 4:deviations=_context.sent;dispatch(deviationsSuccess(deviations));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(deviationsFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var filterDeviations=exports.filterDeviations=function filterDeviations(query,archived){return{type:FILTER,archived:archived,query:query};};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.reset=exports.clearProductType=exports.createProductType=exports.updateProductType=exports.fetchProductType=exports.CLEAR=exports.RESET=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);var _notification=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var GET_REQUEST=exports.GET_REQUEST='@productTypeView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@productTypeView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@productTypeView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@productTypeView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@productTypeView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@productTypeView/UPDATE_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@productTypeView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@productTypeView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@productTypeView/CREATE_FAILURE';var RESET=exports.RESET='@productTypeView/RESET';var CLEAR=exports.CLEAR='@productTypeView/CLEAR';var productTypeRequest=function productTypeRequest(){return{type:GET_REQUEST};};var productTypeSuccess=function productTypeSuccess(productType){return{type:GET_SUCCESS,productType:productType};};var productTypeFailure=function productTypeFailure(error){return{type:GET_FAILURE,error:error};};var productTypeUpdateRequest=function productTypeUpdateRequest(){return{type:UPDATE_REQUEST};};var productTypeUpdateSuccess=function productTypeUpdateSuccess(productType){return _defineProperty({type:UPDATE_SUCCESS,productType:productType},_notification.ADD,{message:'Produkttyp uppdaterad'});};var productTypeUpdateFailure=function productTypeUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var productTypeCreateRequest=function productTypeCreateRequest(){return{type:CREATE_REQUEST};};var productTypeCreateSuccess=function productTypeCreateSuccess(productType){return _defineProperty({type:CREATE_SUCCESS,productType:productType},_notification.ADD,{message:'Produkttyp "'+productType.name+'" skapad'});};var productTypeCreateFailure=function productTypeCreateFailure(error){return{type:CREATE_FAILURE,error:error};};var fetchProductType=exports.fetchProductType=function fetchProductType(id){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var productType;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(productTypeRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/producttypes/'+id},dispatch);case 4:productType=_context.sent;dispatch(productTypeSuccess(productType));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(productTypeFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref3.apply(this,arguments);};}();};var updateProductType=exports.updateProductType=function updateProductType(id,body){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var productType;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(productTypeUpdateRequest());_context2.prev=1;_context2.next=4;return(0,_request.PUT)({endpoint:'/producttypes/'+id,body:body},dispatch);case 4:productType=_context2.sent;dispatch(productTypeUpdateSuccess(productType));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(productTypeUpdateFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref4.apply(this,arguments);};}();};var createProductType=exports.createProductType=function createProductType(body){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var productType;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(productTypeCreateRequest());_context3.prev=1;_context3.next=4;return(0,_request.POST)({endpoint:'/producttypes',body:body},dispatch);case 4:productType=_context3.sent;dispatch(productTypeCreateSuccess(productType));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);dispatch(productTypeCreateFailure(_context3.t0));case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref5.apply(this,arguments);};}();};var clearProductType=exports.clearProductType=function clearProductType(){return{type:CLEAR};};var reset=exports.reset=function reset(){return{type:RESET};};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.filterProductTypes=exports.fetchProductTypes=exports.SORT=exports.FILTER=exports.FAILURE=exports.SUCCESS=exports.REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var REQUEST=exports.REQUEST='@productTypeList/REQUEST';var SUCCESS=exports.SUCCESS='@productTypeList/SUCCESS';var FAILURE=exports.FAILURE='@productTypeList/FAILURE';var FILTER=exports.FILTER='@productTypeList/FILTER';var SORT=exports.SORT='@productTypeList/SORT';var productTypesRequest=function productTypesRequest(){return{type:REQUEST};};var productTypesSuccess=function productTypesSuccess(productTypes){return{type:SUCCESS,productTypes:productTypes};};var productTypesFailure=function productTypesFailure(error){return{type:FAILURE,error:error};};var fetchProductTypes=exports.fetchProductTypes=function fetchProductTypes(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var productTypes;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(productTypesRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/producttypes'},dispatch);case 4:productTypes=_context.sent;dispatch(productTypesSuccess(productTypes));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(productTypesFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var filterProductTypes=exports.filterProductTypes=function filterProductTypes(query,archived){return{type:FILTER,archived:archived,query:query};};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.reset=exports.clearRoomType=exports.createRoomType=exports.updateRoomType=exports.fetchRoomType=exports.CLEAR=exports.RESET=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);var _notification=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var GET_REQUEST=exports.GET_REQUEST='@roomTypeView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@roomTypeView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@roomTypeView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@roomTypeView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@roomTypeView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@roomTypeView/UPDATE_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@roomTypeView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@roomTypeView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@roomTypeView/CREATE_FAILURE';var RESET=exports.RESET='@roomTypeView/RESET';var CLEAR=exports.CLEAR='@roomTypeView/CLEAR';var roomTypeRequest=function roomTypeRequest(){return{type:GET_REQUEST};};var roomTypeSuccess=function roomTypeSuccess(roomType){return{type:GET_SUCCESS,roomType:roomType};};var roomTypeFailure=function roomTypeFailure(error){return{type:GET_FAILURE,error:error};};var roomTypeUpdateRequest=function roomTypeUpdateRequest(){return{type:UPDATE_REQUEST};};var roomTypeUpdateSuccess=function roomTypeUpdateSuccess(roomType){return _defineProperty({type:UPDATE_SUCCESS,roomType:roomType},_notification.ADD,{message:'Rumstyp uppdaterad'});};var roomTypeUpdateFailure=function roomTypeUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var roomTypeCreateRequest=function roomTypeCreateRequest(){return{type:CREATE_REQUEST};};var roomTypeCreateSuccess=function roomTypeCreateSuccess(roomType){return _defineProperty({type:CREATE_SUCCESS,roomType:roomType},_notification.ADD,{message:'Rumstyp "'+roomType.name+'" skapad'});};var roomTypeCreateFailure=function roomTypeCreateFailure(error){return{type:CREATE_FAILURE,error:error};};var fetchRoomType=exports.fetchRoomType=function fetchRoomType(id){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var roomType;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(roomTypeRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/roomtypes/'+id},dispatch);case 4:roomType=_context.sent;dispatch(roomTypeSuccess(roomType));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(roomTypeFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref3.apply(this,arguments);};}();};var updateRoomType=exports.updateRoomType=function updateRoomType(id,body){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var roomType;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(roomTypeUpdateRequest());_context2.prev=1;_context2.next=4;return(0,_request.PUT)({endpoint:'/roomtypes/'+id,body:body},dispatch);case 4:roomType=_context2.sent;dispatch(roomTypeUpdateSuccess(roomType));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(roomTypeUpdateFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref4.apply(this,arguments);};}();};var createRoomType=exports.createRoomType=function createRoomType(body){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var roomType;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(roomTypeCreateRequest());_context3.prev=1;_context3.next=4;return(0,_request.POST)({endpoint:'/roomtypes',body:body},dispatch);case 4:roomType=_context3.sent;dispatch(roomTypeCreateSuccess(roomType));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);dispatch(roomTypeCreateFailure(_context3.t0));case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref5.apply(this,arguments);};}();};var clearRoomType=exports.clearRoomType=function clearRoomType(){return{type:CLEAR};};var reset=exports.reset=function reset(){return{type:RESET};};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.filterRoomTypes=exports.fetchRoomTypes=exports.SORT=exports.FILTER=exports.FAILURE=exports.SUCCESS=exports.REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var REQUEST=exports.REQUEST='@roomTypeList/REQUEST';var SUCCESS=exports.SUCCESS='@roomTypeList/SUCCESS';var FAILURE=exports.FAILURE='@roomTypeList/FAILURE';var FILTER=exports.FILTER='@roomTypeList/FILTER';var SORT=exports.SORT='@roomTypeList/SORT';var roomTypesRequest=function roomTypesRequest(){return{type:REQUEST};};var roomTypesSuccess=function roomTypesSuccess(roomTypes){return{type:SUCCESS,roomTypes:roomTypes};};var roomTypesFailure=function roomTypesFailure(error){return{type:FAILURE,error:error};};var fetchRoomTypes=exports.fetchRoomTypes=function fetchRoomTypes(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var roomTypes;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(roomTypesRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/roomtypes'},dispatch);case 4:roomTypes=_context.sent;dispatch(roomTypesSuccess(roomTypes));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(roomTypesFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var filterRoomTypes=exports.filterRoomTypes=function filterRoomTypes(query,archived){return{type:FILTER,archived:archived,query:query};};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.reset=exports.clearUser=exports.sendActiviationLink=exports.createUser=exports.updateUser=exports.fetchUser=exports.CLEAR=exports.RESET=exports.ACTIVATION_FAILURE=exports.ACTIVATION_SUCCESS=exports.ACTIVATION_REQUEST=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);var _notification=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var GET_REQUEST=exports.GET_REQUEST='@userView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@userView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@userView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@userView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@userView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@userView/UPDATE_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@userView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@userView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@userView/CREATE_FAILURE';var ACTIVATION_REQUEST=exports.ACTIVATION_REQUEST='@userView/ACTIVATION_REQUEST';var ACTIVATION_SUCCESS=exports.ACTIVATION_SUCCESS='@userView/ACTIVATION_SUCCESS';var ACTIVATION_FAILURE=exports.ACTIVATION_FAILURE='@userView/ACTIVATION_FAILURE';var RESET=exports.RESET='@userView/RESET';var CLEAR=exports.CLEAR='@userView/CLEAR';var userRequest=function userRequest(){return{type:GET_REQUEST};};var userSuccess=function userSuccess(user){return{type:GET_SUCCESS,user:user};};var userFailure=function userFailure(error){return{type:GET_FAILURE,error:error};};var userUpdateRequest=function userUpdateRequest(){return{type:UPDATE_REQUEST};};var userUpdateSuccess=function userUpdateSuccess(user){return _defineProperty({type:UPDATE_SUCCESS,user:user},_notification.ADD,{message:'Användare uppdaterad'});};var userUpdateFailure=function userUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var userCreateRequest=function userCreateRequest(){return{type:CREATE_REQUEST};};var userCreateSuccess=function userCreateSuccess(user){return _defineProperty({type:CREATE_SUCCESS,user:user},_notification.ADD,{message:'Anv\xE4ndare "'+user.username+'" skapad'});};var userCreateFailure=function userCreateFailure(error){return{type:CREATE_FAILURE,error:error};};var activationRequest=function activationRequest(){return{type:ACTIVATION_REQUEST};};var activationSuccess=function activationSuccess(){return _defineProperty({type:ACTIVATION_SUCCESS},_notification.ADD,{message:'Aktiveringslänk skickad'});};var activationFailure=function activationFailure(error){return{type:ACTIVATION_FAILURE,error:error};};var fetchUser=exports.fetchUser=function fetchUser(id){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var user;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(userRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/users/'+id},dispatch);case 4:user=_context.sent;dispatch(userSuccess(user));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(userFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref4.apply(this,arguments);};}();};var updateUser=exports.updateUser=function updateUser(id,body){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var user;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(userUpdateRequest());_context2.prev=1;_context2.next=4;return(0,_request.PUT)({endpoint:'/users/'+id,body:body},dispatch);case 4:user=_context2.sent;dispatch(userUpdateSuccess(user));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(userUpdateFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref5.apply(this,arguments);};}();};var createUser=exports.createUser=function createUser(body){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var user;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(userCreateRequest());_context3.prev=1;_context3.next=4;return(0,_request.POST)({endpoint:'/users',body:body},dispatch);case 4:user=_context3.sent;dispatch(userCreateSuccess(user));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);dispatch(userCreateFailure(_context3.t0));case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref6.apply(this,arguments);};}();};var sendActiviationLink=exports.sendActiviationLink=function sendActiviationLink(userId){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch){return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(activationRequest());_context4.prev=1;_context4.next=4;return(0,_request.POST)({endpoint:'/users/'+userId+'/activate',expectBody:false},dispatch);case 4:dispatch(activationSuccess());_context4.next=10;break;case 7:_context4.prev=7;_context4.t0=_context4['catch'](1);dispatch(activationFailure(_context4.t0));case 10:case'end':return _context4.stop();}}},_callee4,undefined,[[1,7]]);}));return function(_x4){return _ref7.apply(this,arguments);};}();};var clearUser=exports.clearUser=function clearUser(){return{type:CLEAR};};var reset=exports.reset=function reset(){return{type:RESET};};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.filterUsers=exports.fetchUsers=exports.SORT=exports.FILTER=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/*:: import type {Dispatch} from 'redux';*/var GET_REQUEST=exports.GET_REQUEST='@userList/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@userList/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@userList/GET_FAILURE';var FILTER=exports.FILTER='@userList/FILTER';var SORT=exports.SORT='@userList/SORT';/*:: type UserListGetRequestAction = {
  type: '@userList/GET_REQUEST'
};*//*:: type UserListGetSuccessAction = {
  type: '@userList/GET_SUCCESS',
  users: any[]
};*//*:: type UserListGetFailureAction = {
  type: '@userList/GET_FAILURE',
  error: any
};*//*:: type UserListFilterAction = {
  type: '@userList/FILTER',
  archived: bool,
  project: ?number,
  query: ?string,
};*//*:: type UserListSortAction = {
  type: '@userList/SORT',
  sorter: Function,
};*//*:: export type UserListAction
  = UserListGetRequestAction
  | UserListGetSuccessAction
  | UserListGetFailureAction
  | UserListFilterAction
  | UserListSortAction;*/var usersRequest=function usersRequest()/*: UserListGetRequestAction*/{return{type:GET_REQUEST};};var usersSuccess=function usersSuccess(users/*: any[]*/)/*: UserListGetSuccessAction*/{return{type:GET_SUCCESS,users:users};};var usersFailure=function usersFailure(error/*: any*/)/*: UserListGetFailureAction*/{return{type:GET_FAILURE,error:error};};var fetchUsers=exports.fetchUsers=function fetchUsers(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch/*: Dispatch<UserListAction>*/){var _users;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(usersRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/users'},dispatch);case 4:_users=_context.sent;dispatch(usersSuccess(_users));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(usersFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var filterUsers=exports.filterUsers=function filterUsers(query/*: ?string*/,project/*: ?number*/,archived/*: bool*/)/*: UserListFilterAction*/{return{type:FILTER,archived:archived,project:project,query:query};};var sortItems=exports.sortItems=function sortItems(sorter/*: Function*/)/*: UserListSortAction*/{return{type:SORT,sorter:sorter};};

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.reset=exports.clearWorkerType=exports.createWorkerType=exports.updateWorkerType=exports.fetchWorkerType=exports.CLEAR=exports.RESET=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);var _notification=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var GET_REQUEST=exports.GET_REQUEST='@workerTypeView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@workerTypeView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@workerTypeView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@workerTypeView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@workerTypeView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@workerTypeView/UPDATE_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@workerTypeView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@workerTypeView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@workerTypeView/CREATE_FAILURE';var RESET=exports.RESET='@workerTypeView/RESET';var CLEAR=exports.CLEAR='@workerTypeView/CLEAR';var workerTypeRequest=function workerTypeRequest(){return{type:GET_REQUEST};};var workerTypeSuccess=function workerTypeSuccess(workerType){return{type:GET_SUCCESS,workerType:workerType};};var workerTypeFailure=function workerTypeFailure(error){return{type:GET_FAILURE,error:error};};var workerTypeUpdateRequest=function workerTypeUpdateRequest(){return{type:UPDATE_REQUEST};};var workerTypeUpdateSuccess=function workerTypeUpdateSuccess(workerType){return _defineProperty({type:UPDATE_SUCCESS,workerType:workerType},_notification.ADD,{message:'Yrkeskategori uppdaterad'});};var workerTypeUpdateFailure=function workerTypeUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var workerTypeCreateRequest=function workerTypeCreateRequest(){return{type:CREATE_REQUEST};};var workerTypeCreateSuccess=function workerTypeCreateSuccess(workerType){return _defineProperty({type:CREATE_SUCCESS,workerType:workerType},_notification.ADD,{message:'Yrkeskategori '+workerType.name+' skapad'});};var workerTypeCreateFailure=function workerTypeCreateFailure(error){return{type:CREATE_FAILURE,error:error};};var fetchWorkerType=exports.fetchWorkerType=function fetchWorkerType(id){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var workerType;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(workerTypeRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/workertypes/'+id},dispatch);case 4:workerType=_context.sent;dispatch(workerTypeSuccess(workerType));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(workerTypeFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref3.apply(this,arguments);};}();};var updateWorkerType=exports.updateWorkerType=function updateWorkerType(id,body){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var workerType;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(workerTypeUpdateRequest());_context2.prev=1;_context2.next=4;return(0,_request.PUT)({endpoint:'/workertypes/'+id,body:body},dispatch);case 4:workerType=_context2.sent;dispatch(workerTypeUpdateSuccess(workerType));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(workerTypeUpdateFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref4.apply(this,arguments);};}();};var createWorkerType=exports.createWorkerType=function createWorkerType(body){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var workerType;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(workerTypeCreateRequest());_context3.prev=1;_context3.next=4;return(0,_request.POST)({endpoint:'/workertypes',body:body},dispatch);case 4:workerType=_context3.sent;dispatch(workerTypeCreateSuccess(workerType));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);dispatch(workerTypeCreateFailure(_context3.t0));case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref5.apply(this,arguments);};}();};var clearWorkerType=exports.clearWorkerType=function clearWorkerType(){return{type:CLEAR};};var reset=exports.reset=function reset(){return{type:RESET};};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.filterWorkerTypes=exports.fetchWorkerTypes=exports.SORT=exports.FILTER=exports.FAILURE=exports.SUCCESS=exports.REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var REQUEST=exports.REQUEST='@workerTypeList/REQUEST';var SUCCESS=exports.SUCCESS='@workerTypeList/SUCCESS';var FAILURE=exports.FAILURE='@workerTypeList/FAILURE';var FILTER=exports.FILTER='@workerTypeList/FILTER';var SORT=exports.SORT='@workerTypeList/SORT';var workerTypesRequest=function workerTypesRequest(){return{type:REQUEST};};var workerTypesSuccess=function workerTypesSuccess(workerTypes){return{type:SUCCESS,workerTypes:workerTypes};};var workerTypesFailure=function workerTypesFailure(error){return{type:FAILURE,error:error};};var fetchWorkerTypes=exports.fetchWorkerTypes=function fetchWorkerTypes(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var workerTypes;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(workerTypesRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/workertypes'},dispatch);case 4:workerTypes=_context.sent;dispatch(workerTypesSuccess(workerTypes));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(workerTypesFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var filterWorkerTypes=exports.filterWorkerTypes=function filterWorkerTypes(query,archived){return{type:FILTER,archived:archived,query:query};};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var arrayAggregator = __webpack_require__(894),
    baseAggregator = __webpack_require__(895),
    baseIteratee = __webpack_require__(24),
    isArray = __webpack_require__(18);

/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = isArray(collection) ? arrayAggregator : baseAggregator,
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
  };
}

module.exports = createAggregator;


/***/ }),
/* 385 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(898),
    findIndex = __webpack_require__(387);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(337),
    baseIteratee = __webpack_require__(24),
    toInteger = __webpack_require__(58);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.fetchProductTypes=exports.filterProducts=exports.fetchProducts=exports.SORT=exports.FILTER=exports.PRODUCT_TYPES_FAILURE=exports.PRODUCT_TYPES_SUCCESS=exports.PRODUCT_TYPES_REQUEST=exports.FAILURE=exports.SUCCESS=exports.REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var REQUEST=exports.REQUEST='@productList/REQUEST';var SUCCESS=exports.SUCCESS='@productList/SUCCESS';var FAILURE=exports.FAILURE='@productList/FAILURE';var PRODUCT_TYPES_REQUEST=exports.PRODUCT_TYPES_REQUEST='@productList/PRODUCT_TYPES_REQUEST';var PRODUCT_TYPES_SUCCESS=exports.PRODUCT_TYPES_SUCCESS='@productList/PRODUCT_TYPES_SUCCESS';var PRODUCT_TYPES_FAILURE=exports.PRODUCT_TYPES_FAILURE='@productList/PRODUCT_TYPES_FAILURE';var FILTER=exports.FILTER='@productList/FILTER';var SORT=exports.SORT='@productList/SORT';var productsRequest=function productsRequest(){return{type:REQUEST};};var productsSuccess=function productsSuccess(products){return{type:SUCCESS,products:products};};var productsFailure=function productsFailure(error){return{type:FAILURE,error:error};};var fetchProducts=exports.fetchProducts=function fetchProducts(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var products;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(productsRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/products'},dispatch);case 4:products=_context.sent;dispatch(productsSuccess(products));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(productsFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var filterProducts=exports.filterProducts=function filterProducts(filter){return _extends({type:FILTER},filter);};var productTypesRequest=function productTypesRequest(){return{type:PRODUCT_TYPES_REQUEST};};var productTypesSuccess=function productTypesSuccess(productTypes){return{type:PRODUCT_TYPES_SUCCESS,productTypes:productTypes};};var productTypesFailure=function productTypesFailure(error){return{type:PRODUCT_TYPES_FAILURE,error:error};};var fetchProductTypes=exports.fetchProductTypes=function fetchProductTypes(){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var productTypes;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(productTypesRequest());_context2.prev=1;_context2.next=4;return(0,_request.GET)({endpoint:'/producttypes'},dispatch);case 4:productTypes=_context2.sent;dispatch(productTypesSuccess(productTypes));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(productTypesFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('orderBy', __webpack_require__(390));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(373),
    isArray = __webpack_require__(18);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),
/* 391 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.togglePrices=exports.toggleAdditionalPrice=exports.toggleRoomPrice=exports.clearOrderRows=exports.updateOrderRows=exports.removeOrderRow=exports.updateOrderRow=exports.createOrderRow=exports.fetchOrderData=exports.selectSlot=exports.sendEmail=exports.selectAdvanced=exports.selectAdditional=exports.sendEmailSuccess=exports.sendEmailFailure=exports.sendEmailRequest=exports.clear=exports.showAll=exports.selectImage=exports.closeProduct=exports.openProduct=exports.setPage=exports.toggleRoom=exports.toggleHelp=exports.toggleMenu=exports.TOGGLE_PRICES=exports.TOGGLE_ADDITIONAL_PRICE=exports.TOGGLE_ROOM_PRICE=exports.SET_ADDITIONAL_SELECTION=exports.SET_ADVANCED_SELECTION=exports.CLEAR=exports.SET_SELECTION=exports.SET_PAGE=exports.SHOW_ALL=exports.ORDER_ROWS_CLEAR_FAILURE=exports.ORDER_ROWS_CLEAR_SUCCESS=exports.ORDER_ROWS_CLEAR_REQUEST=exports.ORDER_ROWS_UPDATE_FAILURE=exports.ORDER_ROWS_UPDATE_SUCCESS=exports.ORDER_ROWS_UPDATE_REQUEST=exports.ORDER_ROW_REMOVE_FAILURE=exports.ORDER_ROW_REMOVE_SUCCESS=exports.ORDER_ROW_REMOVE_REQUEST=exports.ORDER_ROW_CREATE_FAILURE=exports.ORDER_ROW_CREATE_SUCCESS=exports.ORDER_ROW_CREATE_REQUEST=exports.ORDER_ROW_UPDATE_FAILURE=exports.ORDER_ROW_UPDATE_SUCCESS=exports.ORDER_ROW_UPDATE_REQUEST=exports.ORDER_DATA_GET_FAILURE=exports.ORDER_DATA_GET_SUCCESS=exports.ORDER_DATA_GET_REQUEST=exports.SELECT_IMAGE=exports.CLOSE_PRODUCT=exports.OPEN_PRODUCT=exports.SEND_EMAIL_FAILURE=exports.SEND_EMAIL_SUCCESS=exports.SEND_EMAIL_REQUEST=exports.TOGGLE_HELP=exports.TOGGLE_MENU=exports.TOGGLE_ROOM=exports.APARTMENT_CONFIG_GET_FAILURE=exports.APARTMENT_CONFIG_GET_SUCCESS=exports.APARTMENT_CONFIG_GET_REQUEST=exports.SELECT_FAILURE=exports.SELECT_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _request=__webpack_require__(6);var _notification=__webpack_require__(23);var _assortments=__webpack_require__(55);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var SELECT_REQUEST=exports.SELECT_REQUEST='@customerOrderView/SELECT_REQUEST';var SELECT_FAILURE=exports.SELECT_FAILURE='@customerOrderView/SELECT_FAILURE';var APARTMENT_CONFIG_GET_REQUEST=exports.APARTMENT_CONFIG_GET_REQUEST='@customerOrderView/APARTMENT_CONFIG_GET_REQUEST';var APARTMENT_CONFIG_GET_SUCCESS=exports.APARTMENT_CONFIG_GET_SUCCESS='@customerOrderView/APARTMENT_CONFIG_GET_SUCCESS';var APARTMENT_CONFIG_GET_FAILURE=exports.APARTMENT_CONFIG_GET_FAILURE='@customerOrderView/APARTMENT_CONFIG_GET_FAILURE';var TOGGLE_ROOM=exports.TOGGLE_ROOM='@customerOrderView/TOGGLE_ROOM';var TOGGLE_MENU=exports.TOGGLE_MENU='@customerOrderView/TOGGLE_MENU';var TOGGLE_HELP=exports.TOGGLE_HELP='@customerOrderView/TOGGLE_HELP';var SEND_EMAIL_REQUEST=exports.SEND_EMAIL_REQUEST='@customerOrderView/SEND_EMAIL_REQUEST';var SEND_EMAIL_SUCCESS=exports.SEND_EMAIL_SUCCESS='@customerOrderView/SEND_EMAIL_SUCCESS';var SEND_EMAIL_FAILURE=exports.SEND_EMAIL_FAILURE='@customerOrderView/SEND_EMAIL_FAILURE';var OPEN_PRODUCT=exports.OPEN_PRODUCT='@customerOrderView/OPEN_PRODUCT';var CLOSE_PRODUCT=exports.CLOSE_PRODUCT='@customerOrderView/CLOSE_PRODUCT';var SELECT_IMAGE=exports.SELECT_IMAGE='@customerOrderView/SELECT_IMAGE';var ORDER_DATA_GET_REQUEST=exports.ORDER_DATA_GET_REQUEST='@customerOrderView/ORDER_DATA_GET_REQUEST';var ORDER_DATA_GET_SUCCESS=exports.ORDER_DATA_GET_SUCCESS='@customerOrderView/ORDER_DATA_GET_SUCCESS';var ORDER_DATA_GET_FAILURE=exports.ORDER_DATA_GET_FAILURE='@customerOrderView/ORDER_DATA_GET_FAILURE';var ORDER_ROW_UPDATE_REQUEST=exports.ORDER_ROW_UPDATE_REQUEST='@customerOrderView/ORDER_ROW_UPDATE_REQUEST';var ORDER_ROW_UPDATE_SUCCESS=exports.ORDER_ROW_UPDATE_SUCCESS='@customerOrderView/ORDER_ROW_UPDATE_SUCCESS';var ORDER_ROW_UPDATE_FAILURE=exports.ORDER_ROW_UPDATE_FAILURE='@customerOrderView/ORDER_ROW_UPDATE_FAILURE';var ORDER_ROW_CREATE_REQUEST=exports.ORDER_ROW_CREATE_REQUEST='@customerOrderView/ORDER_ROW_CREATE_REQUEST';var ORDER_ROW_CREATE_SUCCESS=exports.ORDER_ROW_CREATE_SUCCESS='@customerOrderView/ORDER_ROW_CREATE_SUCCESS';var ORDER_ROW_CREATE_FAILURE=exports.ORDER_ROW_CREATE_FAILURE='@customerOrderView/ORDER_ROW_CREATE_FAILURE';var ORDER_ROW_REMOVE_REQUEST=exports.ORDER_ROW_REMOVE_REQUEST='@customerOrderView/ORDER_ROW_REMOVE_REQUEST';var ORDER_ROW_REMOVE_SUCCESS=exports.ORDER_ROW_REMOVE_SUCCESS='@customerOrderView/ORDER_ROW_REMOVE_SUCCESS';var ORDER_ROW_REMOVE_FAILURE=exports.ORDER_ROW_REMOVE_FAILURE='@customerOrderView/ORDER_ROW_REMOVE_FAILURE';var ORDER_ROWS_UPDATE_REQUEST=exports.ORDER_ROWS_UPDATE_REQUEST='@customerOrderView/ORDER_ROWS_UPDATE_REQUEST';var ORDER_ROWS_UPDATE_SUCCESS=exports.ORDER_ROWS_UPDATE_SUCCESS='@customerOrderView/ORDER_ROWS_UPDATE_SUCCESS';var ORDER_ROWS_UPDATE_FAILURE=exports.ORDER_ROWS_UPDATE_FAILURE='@customerOrderView/ORDER_ROWS_UPDATE_FAILURE';var ORDER_ROWS_CLEAR_REQUEST=exports.ORDER_ROWS_CLEAR_REQUEST='@customerOrderView/ORDER_ROWS_CLEAR_REQUEST';var ORDER_ROWS_CLEAR_SUCCESS=exports.ORDER_ROWS_CLEAR_SUCCESS='@customerOrderView/ORDER_ROWS_CLEAR_SUCCESS';var ORDER_ROWS_CLEAR_FAILURE=exports.ORDER_ROWS_CLEAR_FAILURE='@customerOrderView/ORDER_ROWS_CLEAR_FAILURE';var SHOW_ALL=exports.SHOW_ALL='@customerOrderView/SHOW_ALL';var SET_PAGE=exports.SET_PAGE='@customerOrderView/SET_PAGE';var SET_SELECTION=exports.SET_SELECTION='@customerOrderView/SET_SELECTION';var CLEAR=exports.CLEAR='@customerOrderView/CLEAR';var SET_ADVANCED_SELECTION=exports.SET_ADVANCED_SELECTION='@customerOrderView/SET_ADVANCED_SELECTION';var SET_ADDITIONAL_SELECTION=exports.SET_ADDITIONAL_SELECTION='@customerOrderView/SET_ADDITIONAL_SELECTION';var TOGGLE_ROOM_PRICE=exports.TOGGLE_ROOM_PRICE='@customerOrderView/TOGGLE_ROOM_PRICE';var TOGGLE_ADDITIONAL_PRICE=exports.TOGGLE_ADDITIONAL_PRICE='@customerOrderView/TOGGLE_ADDITIONAL_PRICE';var TOGGLE_PRICES=exports.TOGGLE_PRICES='@customerOrderView/TOGGLE_PRICES';var selectAdvancedSuccess=function selectAdvancedSuccess(products,slot){return{type:SET_ADVANCED_SELECTION,products:products,slot:slot};};var selectRequest=function selectRequest(room,slot,productType){return{type:SELECT_REQUEST,room:room,slot:slot,productType:productType};};var selectSlotSuccess=function selectSlotSuccess(products,slot){return{type:SET_SELECTION,products:products,slot:slot};};var selectFailure=function selectFailure(error){return{type:SELECT_FAILURE,error:error};};var orderDataRequest=function orderDataRequest(order){return{type:ORDER_DATA_GET_REQUEST,order:order};};var orderDataSuccess=function orderDataSuccess(apartmentConfig,orderRows,customRows,extraRows){return{type:ORDER_DATA_GET_SUCCESS,apartmentConfig:apartmentConfig,orderRows:orderRows,customRows:customRows,extraRows:extraRows};};var orderDataFailure=function orderDataFailure(error){return{type:ORDER_DATA_GET_FAILURE,error:error};};var orderRowRemoveRequest=function orderRowRemoveRequest(){return{type:ORDER_ROW_REMOVE_REQUEST};};var orderRowRemoveSuccess=function orderRowRemoveSuccess(rows){return _defineProperty({type:ORDER_ROW_REMOVE_SUCCESS,rows:rows},_notification.ADD,{message:'Order uppdaterad'});};var orderRowRemoveFailure=function orderRowRemoveFailure(error){return _defineProperty({type:ORDER_ROW_REMOVE_FAILURE,error:error},_notification.ADD,{message:'Nätverksfel, vänligen försök igen'});};var orderRowUpdateRequest=function orderRowUpdateRequest(){return{type:ORDER_ROW_UPDATE_REQUEST};};var orderRowUpdateSuccess=function orderRowUpdateSuccess(rows,row){return _defineProperty({type:ORDER_ROW_UPDATE_SUCCESS,row:row,rows:rows},_notification.ADD,{message:'Order uppdaterad'});};var orderRowUpdateFailure=function orderRowUpdateFailure(error){return _defineProperty({type:ORDER_ROW_UPDATE_FAILURE,error:error},_notification.ADD,{message:'Nätverksfel, vänligen försök igen',level:'error'});};var orderRowCreateRequest=function orderRowCreateRequest(){return{type:ORDER_ROW_CREATE_REQUEST};};var orderRowCreateSuccess=function orderRowCreateSuccess(rows,row){return _defineProperty({type:ORDER_ROW_CREATE_SUCCESS,row:row,rows:rows},_notification.ADD,{message:'Order uppdaterad'});};var orderRowCreateFailure=function orderRowCreateFailure(error){return _defineProperty({type:ORDER_ROW_CREATE_FAILURE,error:error},_notification.ADD,{message:'Nätverksfel, vänligen försök igen',level:'error'});};var orderRowsUpdateRequest=function orderRowsUpdateRequest(){return{type:ORDER_ROWS_UPDATE_REQUEST};};var orderRowsUpdateSuccess=function orderRowsUpdateSuccess(rows,row){return _defineProperty({type:ORDER_ROWS_UPDATE_SUCCESS,row:row,rows:rows},_notification.ADD,{message:'Order uppdaterad'});};var orderRowsUpdateFailure=function orderRowsUpdateFailure(error){return _defineProperty({type:ORDER_ROWS_UPDATE_FAILURE,error:error},_notification.ADD,{message:'Nätverksfel, vänligen försök igen',level:'error'});};var orderRowsClearRequest=function orderRowsClearRequest(){return{type:ORDER_ROWS_CLEAR_REQUEST};};var orderRowsClearSuccess=function orderRowsClearSuccess(){return _defineProperty({type:ORDER_ROWS_CLEAR_SUCCESS},_notification.ADD,{message:'Order uppdaterad'});};var orderRowsClearFailure=function orderRowsClearFailure(error){return{type:ORDER_ROWS_CLEAR_FAILURE,error:error};};var toggleMenu=exports.toggleMenu=function toggleMenu(show){return{type:TOGGLE_MENU,show:show};};var toggleHelp=exports.toggleHelp=function toggleHelp(show){return{type:TOGGLE_HELP,show:show};};var toggleRoom=exports.toggleRoom=function toggleRoom(roomId,expanded){return{type:TOGGLE_ROOM,roomId:roomId,expanded:expanded};};var setPage=exports.setPage=function setPage(page){return{type:SET_PAGE,page:page};};var openProduct=exports.openProduct=function openProduct(product,variant){return{type:OPEN_PRODUCT,product:product,variant:variant};};var closeProduct=exports.closeProduct=function closeProduct(){return{type:CLOSE_PRODUCT};};var selectImage=exports.selectImage=function selectImage(image){return{type:SELECT_IMAGE,image:image};};var showAll=exports.showAll=function showAll(){return{type:SHOW_ALL};};var clear=exports.clear=function clear(){return{type:CLEAR};};var sendEmailRequest=exports.sendEmailRequest=function sendEmailRequest(){return{type:SEND_EMAIL_REQUEST};};var sendEmailFailure=exports.sendEmailFailure=function sendEmailFailure(error){var _ref10;return _ref10={type:SEND_EMAIL_FAILURE},_defineProperty(_ref10,_notification.ADD,{message:'Nätverksfel, vänligen försök igen',level:'error'}),_defineProperty(_ref10,'error',error),_ref10;};var sendEmailSuccess=exports.sendEmailSuccess=function sendEmailSuccess(){return _defineProperty({type:SEND_EMAIL_SUCCESS},_notification.ADD,{message:'Mail skickat till säljare'});};var selectAdditional=exports.selectAdditional=function selectAdditional(){return{type:SET_ADDITIONAL_SELECTION};};var selectAdvanced=exports.selectAdvanced=function selectAdvanced(room,slot,productType){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var products;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(selectRequest(room,slot,productType));_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/products?productTypeId='+productType.id+'&images=1&assortment='+_assortments.STANDARD+'&forceOrderDto=1'},dispatch);case 4:products=_context.sent;dispatch(selectAdvancedSuccess(products,slot));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(selectFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref12.apply(this,arguments);};}();};var sendEmail=exports.sendEmail=function sendEmail(orderId,message){return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(sendEmailRequest());_context2.prev=1;_context2.next=4;return(0,_request.POST)({endpoint:'/orders/'+orderId+'/help',body:{message:message},expectBody:false},dispatch);case 4:dispatch(sendEmailSuccess());_context2.next=10;break;case 7:_context2.prev=7;_context2.t0=_context2['catch'](1);dispatch(sendEmailFailure(_context2.t0));case 10:case'end':return _context2.stop();}}},_callee2,undefined,[[1,7]]);}));return function(_x2){return _ref13.apply(this,arguments);};}();};var selectSlot=exports.selectSlot=function selectSlot(orderId,room,slot){return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var products;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(selectRequest(room,slot));_context3.prev=1;_context3.next=4;return(0,_request.GET)({endpoint:'/orders/'+orderId+'/productslots/'+slot.id+'/products'},dispatch);case 4:products=_context3.sent;dispatch(selectSlotSuccess(products,slot));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);dispatch(selectFailure(_context3.t0));case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref14.apply(this,arguments);};}();};var fetchOrderData=exports.fetchOrderData=function fetchOrderData(order,apartment){return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch){var fullOrder,apartmentConfig;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(orderDataRequest(order));_context4.prev=1;_context4.next=4;return(0,_request.GET)({endpoint:'/orders/'+order.id},dispatch);case 4:fullOrder=_context4.sent;_context4.next=7;return(0,_request.GET)({endpoint:'/apartmentconfigs/'+apartment.apartmentConfigId},dispatch);case 7:apartmentConfig=_context4.sent;dispatch(orderDataSuccess(apartmentConfig,fullOrder.rows,fullOrder.customRows,fullOrder.extraRows));_context4.next=14;break;case 11:_context4.prev=11;_context4.t0=_context4['catch'](1);dispatch(orderDataFailure(_context4.t0));case 14:case'end':return _context4.stop();}}},_callee4,undefined,[[1,11]]);}));return function(_x4){return _ref15.apply(this,arguments);};}();};var createOrderRow=exports.createOrderRow=function createOrderRow(orderId,slot,variant,config,parentConfig){return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch){var rows;return _regenerator2.default.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(orderRowCreateRequest());_context5.prev=1;_context5.next=4;return(0,_request.POST)({endpoint:'/orders/'+orderId+'/rows',body:{productSlotId:slot.id,productVariantId:!!config?null:variant.id,parentConfigId:!!parentConfig?parentConfig.id:null,configId:!!config?config.id:null}},dispatch);case 4:rows=_context5.sent;dispatch(orderRowCreateSuccess(rows,(0,_find3.default)({productSlotId:slot.id,productVariantId:!!config?null:variant.id,parentConfigId:!!parentConfig?parentConfig.id:null,configId:!!config?config.id:null},rows)));_context5.next=11;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](1);dispatch(orderRowCreateFailure(_context5.t0));case 11:case'end':return _context5.stop();}}},_callee5,undefined,[[1,8]]);}));return function(_x5){return _ref16.apply(this,arguments);};}();};var updateOrderRow=exports.updateOrderRow=function updateOrderRow(row,slot,variant,config,parentConfig){return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch){var rows;return _regenerator2.default.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch(orderRowUpdateRequest());_context6.prev=1;_context6.next=4;return(0,_request.PUT)({endpoint:'/orderrows/'+row.id,body:{productSlotId:slot.id,productVariantId:!!config?null:variant.id,parentConfigId:!!parentConfig?parentConfig.id:null,configId:!!config?config.id:null}},dispatch);case 4:rows=_context6.sent;dispatch(orderRowUpdateSuccess(rows,(0,_find3.default)({id:row.id},rows)));_context6.next=11;break;case 8:_context6.prev=8;_context6.t0=_context6['catch'](1);dispatch(orderRowUpdateFailure(_context6.t0));case 11:case'end':return _context6.stop();}}},_callee6,undefined,[[1,8]]);}));return function(_x6){return _ref17.apply(this,arguments);};}();};var removeOrderRow=exports.removeOrderRow=function removeOrderRow(rowId,slotId){return function(){var _ref18=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch){var rows;return _regenerator2.default.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch(orderRowRemoveRequest());_context7.prev=1;_context7.next=4;return(0,_request.DELETE)({endpoint:'/orderrows/'+rowId},dispatch);case 4:rows=_context7.sent;dispatch(orderRowRemoveSuccess(rows));_context7.next=11;break;case 8:_context7.prev=8;_context7.t0=_context7['catch'](1);dispatch(orderRowRemoveFailure(_context7.t0));case 11:case'end':return _context7.stop();}}},_callee7,undefined,[[1,8]]);}));return function(_x7){return _ref18.apply(this,arguments);};}();};var updateOrderRows=exports.updateOrderRows=function updateOrderRows(orderId){var _ref19=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},standard=_ref19.standard,clear=_ref19.clear;return function(){var _ref20=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch){var rows;return _regenerator2.default.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch(orderRowsUpdateRequest());_context8.prev=1;_context8.next=4;return(0,_request.PUT)({endpoint:'/orders/'+orderId+'/rows',body:{standard:standard,clear:clear}},dispatch);case 4:rows=_context8.sent;dispatch(orderRowsUpdateSuccess(rows));_context8.next=11;break;case 8:_context8.prev=8;_context8.t0=_context8['catch'](1);dispatch(orderRowsUpdateFailure(_context8.t0));case 11:case'end':return _context8.stop();}}},_callee8,undefined,[[1,8]]);}));return function(_x9){return _ref20.apply(this,arguments);};}();};var clearOrderRows=exports.clearOrderRows=function clearOrderRows(orderId){return function(){var _ref21=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch){return _regenerator2.default.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch(orderRowsClearRequest());_context9.prev=1;_context9.next=4;return(0,_request.POST)({endpoint:'/orders/'+orderId+'/clearorderrows',expectBody:false},dispatch);case 4:dispatch(orderRowsClearSuccess());_context9.next=10;break;case 7:_context9.prev=7;_context9.t0=_context9['catch'](1);dispatch(orderRowsClearFailure(_context9.t0));case 10:case'end':return _context9.stop();}}},_callee9,undefined,[[1,7]]);}));return function(_x10){return _ref21.apply(this,arguments);};}();};var toggleRoomPrice=exports.toggleRoomPrice=function toggleRoomPrice(roomId){return{type:TOGGLE_ROOM_PRICE,roomId:roomId};};var toggleAdditionalPrice=exports.toggleAdditionalPrice=function toggleAdditionalPrice(){return{type:TOGGLE_ADDITIONAL_PRICE};};var togglePrices=exports.togglePrices=function togglePrices(){return{type:TOGGLE_PRICES};};

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.updateProductSlots=exports.updateRooms=exports.updateProductSlot=exports.createProductSlot=exports.updateRoom=exports.createRoom=exports.createConfigTemplate=exports.updateConfigTemplate=exports.fetchData=exports.selectProductSlot=exports.selectRoom=exports.reset=exports.clear=exports.closeDialog=exports.openDialog=exports.toggleVariant=exports.clearStandardProduct=exports.setStandardProduct=exports.updateRelatedVariant=exports.navigateToVariant=exports.popDialogNavigation=exports.toggleProduct=exports.checkAllVariants=exports.checkProduct=exports.updateVariantsForType=exports.updateVariants=exports.UPDATE_VARIANTS_FOR_TYPE=exports.PRODUCT_SLOTS_UPDATE_SUCCESS=exports.PRODUCT_SLOTS_UPDATE_FAILURE=exports.PRODUCT_SLOTS_UPDATE_REQUEST=exports.ROOMS_UPDATE_SUCCESS=exports.ROOMS_UPDATE_FAILURE=exports.ROOMS_UPDATE_REQUEST=exports.UPDATE_VARIANTS=exports.CHECK_PRODUCT=exports.CLEAR_STANDARD_PRODUCT=exports.CHECK_ALL_VARIANTS=exports.TOGGLE_PRODUCT=exports.SET_STANDARD_PRODUCT=exports.TOGGLE_VARIANT_SUCCESS=exports.TOGGLE_VARIANT_FAILURE=exports.TOGGLE_VARIANT_REQUEST=exports.UPDATE_RELATED_VARIANT=exports.NAVIGATE_TO_VARIANT_SUCCESS=exports.NAVIGATE_TO_VARIANT_FAILURE=exports.NAVIGATE_TO_VARIANT_REQUEST=exports.POP_DIALOG_NAVIGATION=exports.CLOSE_DIALOG=exports.OPEN_DIALOG_SUCCESS=exports.OPEN_DIALOG_FAILURE=exports.OPEN_DIALOG_REQUEST=exports.CLEAR=exports.RESET=exports.SELECT_PRODUCT_SLOT=exports.SELECT_ROOM=exports.PRODUCT_SLOT_CREATE_FAILURE=exports.PRODUCT_SLOT_CREATE_SUCCESS=exports.PRODUCT_SLOT_CREATE_REQUEST=exports.PRODUCT_SLOT_UPDATE_FAILURE=exports.PRODUCT_SLOT_UPDATE_SUCCESS=exports.PRODUCT_SLOT_UPDATE_REQUEST=exports.ROOM_CREATE_FAILURE=exports.ROOM_CREATE_SUCCESS=exports.ROOM_CREATE_REQUEST=exports.ROOM_UPDATE_FAILURE=exports.ROOM_UPDATE_SUCCESS=exports.ROOM_UPDATE_REQUEST=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _request=__webpack_require__(6);var _notification=__webpack_require__(23);var _assortments=__webpack_require__(55);var _apartmentConfigView=__webpack_require__(82);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/*:: import type {Dispatch} from 'redux';*//*:: import type {Exact} from '../reducers/configTemplateView';*//*:: import type {OptionalNavigationAction} from './notification';*//*:: import type {
  ConfigTemplateDto,
  ErrorDto,
  ProductDto,
  ProductSlotDto,
  ProductTypeDto,
  RoomDto,
  RoomTypeDto,
  VariantDto,
  LimitedProjectDto,
  RoomTemplateDto,
} from '../dtos';*/var GET_REQUEST=exports.GET_REQUEST='@configTemplateView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@configTemplateView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@configTemplateView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@configTemplateView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@configTemplateView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@configTemplateView/UPDATE_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@configTemplateView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@configTemplateView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@configTemplateView/CREATE_FAILURE';var ROOM_UPDATE_REQUEST=exports.ROOM_UPDATE_REQUEST='@configTemplateView/ROOM_UPDATE_REQUEST';var ROOM_UPDATE_SUCCESS=exports.ROOM_UPDATE_SUCCESS='@configTemplateView/ROOM_UPDATE_SUCCESS';var ROOM_UPDATE_FAILURE=exports.ROOM_UPDATE_FAILURE='@configTemplateView/ROOM_UPDATE_FAILURE';var ROOM_CREATE_REQUEST=exports.ROOM_CREATE_REQUEST='@configTemplateView/ROOM_CREATE_REQUEST';var ROOM_CREATE_SUCCESS=exports.ROOM_CREATE_SUCCESS='@configTemplateView/ROOM_CREATE_SUCCESS';var ROOM_CREATE_FAILURE=exports.ROOM_CREATE_FAILURE='@configTemplateView/ROOM_CREATE_FAILURE';var PRODUCT_SLOT_UPDATE_REQUEST=exports.PRODUCT_SLOT_UPDATE_REQUEST='@configTemplateView/PRODUCT_SLOT_UPDATE_REQUEST';var PRODUCT_SLOT_UPDATE_SUCCESS=exports.PRODUCT_SLOT_UPDATE_SUCCESS='@configTemplateView/PRODUCT_SLOT_UPDATE_SUCCESS';var PRODUCT_SLOT_UPDATE_FAILURE=exports.PRODUCT_SLOT_UPDATE_FAILURE='@configTemplateView/PRODUCT_SLOT_UPDATE_FAILURE';var PRODUCT_SLOT_CREATE_REQUEST=exports.PRODUCT_SLOT_CREATE_REQUEST='@configTemplateView/PRODUCT_SLOT_CREATE_REQUEST';var PRODUCT_SLOT_CREATE_SUCCESS=exports.PRODUCT_SLOT_CREATE_SUCCESS='@configTemplateView/PRODUCT_SLOT_CREATE_SUCCESS';var PRODUCT_SLOT_CREATE_FAILURE=exports.PRODUCT_SLOT_CREATE_FAILURE='@configTemplateView/PRODUCT_SLOT_CREATE_FAILURE';var SELECT_ROOM=exports.SELECT_ROOM='@configTemplateView/SELECT_ROOM';var SELECT_PRODUCT_SLOT=exports.SELECT_PRODUCT_SLOT='@configTemplateView/SELECT_PRODUCT_SLOT';var RESET=exports.RESET='@configTemplateView/RESET';var CLEAR=exports.CLEAR='@configTemplateView/CLEAR';var OPEN_DIALOG_REQUEST=exports.OPEN_DIALOG_REQUEST='@configTemplateView/OPEN_DIALOG_REQUEST';var OPEN_DIALOG_FAILURE=exports.OPEN_DIALOG_FAILURE='@configTemplateView/OPEN_DIALOG_FAILURE';var OPEN_DIALOG_SUCCESS=exports.OPEN_DIALOG_SUCCESS='@configTemplateView/OPEN_DIALOG_SUCCESS';var CLOSE_DIALOG=exports.CLOSE_DIALOG='@configTemplateView/CLOSE_DIALOG';var POP_DIALOG_NAVIGATION=exports.POP_DIALOG_NAVIGATION='@configTemplateView/POP_DIALOG_NAVIGATION';var NAVIGATE_TO_VARIANT_REQUEST=exports.NAVIGATE_TO_VARIANT_REQUEST='@configTemplateView/NAVIGATE_TO_VARIANT_REQUEST';var NAVIGATE_TO_VARIANT_FAILURE=exports.NAVIGATE_TO_VARIANT_FAILURE='@configTemplateView/NAVIGATE_TO_VARIANT_FAILURE';var NAVIGATE_TO_VARIANT_SUCCESS=exports.NAVIGATE_TO_VARIANT_SUCCESS='@configTemplateView/NAVIGATE_TO_VARIANT_SUCCESS';var UPDATE_RELATED_VARIANT=exports.UPDATE_RELATED_VARIANT='@configTemplateView/UPDATE_RELATED_VARIANT';var TOGGLE_VARIANT_REQUEST=exports.TOGGLE_VARIANT_REQUEST='@configTemplateView/TOGGLE_VARIANT_REQUEST';var TOGGLE_VARIANT_FAILURE=exports.TOGGLE_VARIANT_FAILURE='@configTemplateView/TOGGLE_VARIANT_FAILURE';var TOGGLE_VARIANT_SUCCESS=exports.TOGGLE_VARIANT_SUCCESS='@configTemplateView/TOGGLE_VARIANT_SUCCESS';var SET_STANDARD_PRODUCT=exports.SET_STANDARD_PRODUCT='@configTemplateView/SET_STANDARD_PRODUCT';var TOGGLE_PRODUCT=exports.TOGGLE_PRODUCT='@configTemplateView/TOGGLE_PRODUCT';var CHECK_ALL_VARIANTS=exports.CHECK_ALL_VARIANTS='@configTemplateView/CHECK_ALL_VARIANTS';var CLEAR_STANDARD_PRODUCT=exports.CLEAR_STANDARD_PRODUCT='@configTemplateView/CLEAR_STANDARD_PRODUCT';var CHECK_PRODUCT=exports.CHECK_PRODUCT='@configTemplateView/CHECK_PRODUCT';var UPDATE_VARIANTS=exports.UPDATE_VARIANTS='@configTemplateView/UPDATE_VARIANTS';var ROOMS_UPDATE_REQUEST=exports.ROOMS_UPDATE_REQUEST='@configTemplateView/ROOMS_UPDATE_REQUEST';var ROOMS_UPDATE_FAILURE=exports.ROOMS_UPDATE_FAILURE='@configTemplateView/ROOMS_UPDATE_FAILURE';var ROOMS_UPDATE_SUCCESS=exports.ROOMS_UPDATE_SUCCESS='@configTemplateView/ROOMS_UPDATE_SUCCESS';var PRODUCT_SLOTS_UPDATE_REQUEST=exports.PRODUCT_SLOTS_UPDATE_REQUEST='@configTemplateView/PRODUCT_SLOTS_UPDATE_REQUEST';var PRODUCT_SLOTS_UPDATE_FAILURE=exports.PRODUCT_SLOTS_UPDATE_FAILURE='@configTemplateView/PRODUCT_SLOTS_UPDATE_FAILURE';var PRODUCT_SLOTS_UPDATE_SUCCESS=exports.PRODUCT_SLOTS_UPDATE_SUCCESS='@configTemplateView/PRODUCT_SLOTS_UPDATE_SUCCESS';var UPDATE_VARIANTS_FOR_TYPE=exports.UPDATE_VARIANTS_FOR_TYPE='@configTemplateView/UPDATE_VARIANTS_FOR_TYPE';/*:: export type ConfigTemplateGetRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/GET_REQUEST',
};*//*:: export type ConfigTemplateGetSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/GET_SUCCESS',
  configTemplate: ?ConfigTemplateDto,
  roomTypes: RoomTypeDto[],
  products: ProductDto[],
  productTypes: ProductTypeDto[],
  configTemplates: ConfigTemplateDto[],
  projects: LimitedProjectDto[],
  roomTemplates: RoomTemplateDto[],
};*//*:: export type ConfigTemplateGetFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/GET_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateUpdateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_REQUEST',
};*//*:: export type ConfigTemplateUpdateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_SUCCESS',
  configTemplate: ConfigTemplateDto,
};*//*:: export type ConfigTemplateUpdateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateCreateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/CREATE_REQUEST',
};*//*:: export type ConfigTemplateCreateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/CREATE_SUCCESS',
  configTemplate: ConfigTemplateDto,
};*//*:: export type ConfigTemplateCreateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/CREATE_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateRoomUpdateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_UPDATE_REQUEST',
};*//*:: export type ConfigTemplateRoomUpdateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_UPDATE_SUCCESS',
  room: RoomDto,
};*//*:: export type ConfigTemplateRoomUpdateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_UPDATE_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateRoomCreateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_CREATE_REQUEST',
};*//*:: export type ConfigTemplateRoomCreateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_CREATE_SUCCESS',
  room: RoomDto,
};*//*:: export type ConfigTemplateRoomCreateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOM_CREATE_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateProductSlotUpdateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_UPDATE_REQUEST',
};*//*:: export type ConfigTemplateProductSlotUpdateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_UPDATE_SUCCESS',
  productSlot: ProductSlotDto,
};*//*:: export type ConfigTemplateProductSlotUpdateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_UPDATE_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateProductSlotCreateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_CREATE_REQUEST',
};*//*:: export type ConfigTemplateProductSlotCreateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_CREATE_SUCCESS',
  productSlot: ProductSlotDto,
  roomId: number,
};*//*:: export type ConfigTemplateProductSlotCreateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOT_CREATE_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateSelectRoomAction = OptionalNavigationAction & {
  type: '@configTemplateView/SELECT_ROOM',
  room: ?RoomDto,
};*//*:: export type ConfigTemplateSelectProductSlotAction = OptionalNavigationAction & {
  type: '@configTemplateView/SELECT_PRODUCT_SLOT',
  roomId: number,
  productSlot: ?ProductSlotDto,
};*//*:: export type ConfigTemplateResetAction = OptionalNavigationAction & {
  type: '@configTemplateView/RESET',
};*//*:: export type ConfigTemplateClearAction = OptionalNavigationAction & {
  type: '@configTemplateView/CLEAR',
};*//*:: export type ConfigTemplateOpenDialogRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/OPEN_DIALOG_REQUEST',
};*//*:: export type ConfigTemplateOpenDialogFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/OPEN_DIALOG_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateOpenDialogSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/OPEN_DIALOG_SUCCESS',
  products: ProductDto[],
  rootName: string,
  productType: ProductTypeDto,
};*//*:: export type ConfigTemplateCloseDialogAction = OptionalNavigationAction & {
  type: '@configTemplateView/CLOSE_DIALOG',
};*//*:: export type ConfigTemplatePopDialogNavigationAction = OptionalNavigationAction & {
  type: '@configTemplateView/POP_DIALOG_NAVIGATION',
  depth: number,
};*//*:: export type ConfigTemplateNavigateToVariantRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/NAVIGATE_TO_VARIANT_REQUEST',
};*//*:: export type ConfigTemplateNavigateToVariantFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/NAVIGATE_TO_VARIANT_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateNavigateToVariantSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/NAVIGATE_TO_VARIANT_SUCCESS',
  variant: VariantDto,
};*//*:: export type ConfigTemplateUpdateRelatedVariantAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_RELATED_VARIANT',
  variant: VariantDto,
  data: any,
};*//*:: export type ConfigTemplateToggleVariantRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/TOGGLE_VARIANT_REQUEST',
};*//*:: export type ConfigTemplateToggleVariantFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/TOGGLE_VARIANT_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateToggleVariantSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/TOGGLE_VARIANT_SUCCESS',
  variant: VariantDto,
  expand: boolean,
};*//*:: export type ConfigTemplateSetStandardProductAction = OptionalNavigationAction & {
  type: '@configTemplateView/SET_STANDARD_PRODUCT',
  product: ProductDto,
  productType: ProductTypeDto,
};*//*:: export type ConfigTemplateToggleProductAction = OptionalNavigationAction & {
  type: '@configTemplateView/TOGGLE_PRODUCT',
  product: ProductDto,
};*//*:: export type ConfigTemplateCheckAllVariantsAction = OptionalNavigationAction & {
  type: '@configTemplateView/CHECK_ALL_VARIANTS',
  checked: boolean,
};*//*:: export type ConfigTemplateClearStandardProductAction = OptionalNavigationAction & {
  type: '@configTemplateView/CLEAR_STANDARD_PRODUCT',
  productType: ProductTypeDto,
};*//*:: export type ConfigTemplateCheckProductAction = OptionalNavigationAction & {
  type: '@configTemplateView/CHECK_PRODUCT',
  productId: number,
  checked: boolean,
};*//*:: export type ConfigTemplateUpdateVariantsAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_VARIANTS',
  productId: number,
  data: any,
};*//*:: export type ConfigTemplateUpdateVariantsForTypeAction = OptionalNavigationAction & {
  type: '@configTemplateView/UPDATE_VARIANTS_FOR_TYPE',
  productTypeId: number,
  data: any,
};*//*:: export type ConfigTemplateRoomsUpdateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOMS_UPDATE_REQUEST',
};*//*:: export type ConfigTemplateRoomsUpdateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOMS_UPDATE_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateRoomsUpdateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/ROOMS_UPDATE_SUCCESS',
  rooms: RoomDto[],
};*//*:: export type ConfigTemplateProductSlotsUpdateRequestAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOTS_UPDATE_REQUEST',
};*//*:: export type ConfigTemplateProductSlotsUpdateFailureAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOTS_UPDATE_FAILURE',
  error: ErrorDto,
};*//*:: export type ConfigTemplateProductSlotsUpdateSuccessAction = OptionalNavigationAction & {
  type: '@configTemplateView/PRODUCT_SLOTS_UPDATE_SUCCESS',
  roomId: number,
  productSlotId: number,
  productSlots: ProductSlotDto[],
};*//*:: export type ConfigTemplateAction
  = ConfigTemplateGetRequestAction
  | ConfigTemplateGetSuccessAction
  | ConfigTemplateGetFailureAction
  | ConfigTemplateUpdateRequestAction
  | ConfigTemplateUpdateSuccessAction
  | ConfigTemplateUpdateFailureAction
  | ConfigTemplateCreateRequestAction
  | ConfigTemplateCreateSuccessAction
  | ConfigTemplateCreateFailureAction
  | ConfigTemplateRoomUpdateRequestAction
  | ConfigTemplateRoomUpdateSuccessAction
  | ConfigTemplateRoomUpdateFailureAction
  | ConfigTemplateRoomCreateRequestAction
  | ConfigTemplateRoomCreateSuccessAction
  | ConfigTemplateRoomCreateFailureAction
  | ConfigTemplateProductSlotUpdateRequestAction
  | ConfigTemplateProductSlotUpdateSuccessAction
  | ConfigTemplateProductSlotUpdateFailureAction
  | ConfigTemplateProductSlotCreateRequestAction
  | ConfigTemplateProductSlotCreateSuccessAction
  | ConfigTemplateProductSlotCreateFailureAction
  | ConfigTemplateSelectRoomAction
  | ConfigTemplateSelectProductSlotAction
  | ConfigTemplateResetAction
  | ConfigTemplateClearAction
  | ConfigTemplateOpenDialogRequestAction
  | ConfigTemplateOpenDialogFailureAction
  | ConfigTemplateOpenDialogSuccessAction
  | ConfigTemplateCloseDialogAction
  | ConfigTemplatePopDialogNavigationAction
  | ConfigTemplateNavigateToVariantRequestAction
  | ConfigTemplateNavigateToVariantFailureAction
  | ConfigTemplateNavigateToVariantSuccessAction
  | ConfigTemplateUpdateRelatedVariantAction
  | ConfigTemplateToggleVariantRequestAction
  | ConfigTemplateToggleVariantFailureAction
  | ConfigTemplateToggleVariantSuccessAction
  | ConfigTemplateSetStandardProductAction
  | ConfigTemplateToggleProductAction
  | ConfigTemplateCheckAllVariantsAction
  | ConfigTemplateClearStandardProductAction
  | ConfigTemplateCheckProductAction
  | ConfigTemplateUpdateVariantsAction
  | ConfigTemplateUpdateVariantsForTypeAction
  | ConfigTemplateRoomsUpdateRequestAction
  | ConfigTemplateRoomsUpdateFailureAction
  | ConfigTemplateRoomsUpdateSuccessAction
  | ConfigTemplateProductSlotsUpdateRequestAction
  | ConfigTemplateProductSlotsUpdateFailureAction
  | ConfigTemplateProductSlotsUpdateSuccessAction;*/var roomsUpdateRequest=function roomsUpdateRequest()/*: Exact<ConfigTemplateRoomsUpdateRequestAction>*/{return{type:ROOMS_UPDATE_REQUEST};};var roomsUpdateFailure=function roomsUpdateFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateRoomsUpdateFailureAction>*/{return{type:ROOMS_UPDATE_FAILURE,error:error};};var roomsUpdateSuccess=function roomsUpdateSuccess(rooms/*: RoomDto[]*/)/*: Exact<ConfigTemplateRoomsUpdateSuccessAction>*/{return{type:ROOMS_UPDATE_SUCCESS,rooms:rooms};};var productSlotsUpdateRequest=function productSlotsUpdateRequest()/*: Exact<ConfigTemplateProductSlotsUpdateRequestAction>*/{return{type:PRODUCT_SLOTS_UPDATE_REQUEST};};var productSlotsUpdateFailure=function productSlotsUpdateFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateProductSlotsUpdateFailureAction>*/{return{type:PRODUCT_SLOTS_UPDATE_FAILURE,error:error};};var productSlotsUpdateSuccess=function productSlotsUpdateSuccess(roomId/*: number*/,productSlotId/*: number*/,productSlots/*: ProductSlotDto[]*/)/*: Exact<ConfigTemplateProductSlotsUpdateSuccessAction>*/{return{type:PRODUCT_SLOTS_UPDATE_SUCCESS,roomId:roomId,productSlotId:productSlotId,productSlots:productSlots};};var updateVariants=exports.updateVariants=function updateVariants(productId/*: number*/,data/*: any*/)/*: Exact<ConfigTemplateUpdateVariantsAction>*/{return{type:UPDATE_VARIANTS,productId:productId,data:data};};var updateVariantsForType=exports.updateVariantsForType=function updateVariantsForType(productTypeId/*: number*/,data/*: any*/)/*: Exact<ConfigTemplateUpdateVariantsForTypeAction>*/{return{type:UPDATE_VARIANTS_FOR_TYPE,productTypeId:productTypeId,data:data};};var checkProduct=exports.checkProduct=function checkProduct(productId/*: number*/,checked/*: boolean*/)/*: Exact<ConfigTemplateCheckProductAction>*/{return{type:CHECK_PRODUCT,productId:productId,checked:checked};};var checkAllVariants=exports.checkAllVariants=function checkAllVariants(checked/*: boolean*/)/*: Exact<ConfigTemplateCheckAllVariantsAction>*/{return{type:CHECK_ALL_VARIANTS,checked:checked};};var toggleProduct=exports.toggleProduct=function toggleProduct(product/*: ProductDto*/)/*: Exact<ConfigTemplateToggleProductAction>*/{return{type:TOGGLE_PRODUCT,product:product};};var popDialogNavigation=exports.popDialogNavigation=function popDialogNavigation(depth/*: number*/)/*: Exact<ConfigTemplatePopDialogNavigationAction>*/{return{type:POP_DIALOG_NAVIGATION,depth:depth};};var navigateToVariantRequest=function navigateToVariantRequest()/*: Exact<ConfigTemplateNavigateToVariantRequestAction>*/{return{type:NAVIGATE_TO_VARIANT_REQUEST};};var navigateToVariantFailure=function navigateToVariantFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateNavigateToVariantFailureAction>*/{return{type:NAVIGATE_TO_VARIANT_FAILURE,error:error};};var navigateToVariantSuccess=function navigateToVariantSuccess(variant/*: VariantDto*/)/*: Exact<ConfigTemplateNavigateToVariantSuccessAction>*/{return{type:NAVIGATE_TO_VARIANT_SUCCESS,variant:variant};};var navigateToVariant=exports.navigateToVariant=function navigateToVariant(variant/*: VariantDto*/){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch/*: Dispatch<ConfigTemplateAction>*/){var fullVariant;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(navigateToVariantRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/productvariants/'+variant.id},dispatch);case 4:fullVariant=_context.sent;dispatch(navigateToVariantSuccess(_extends({},fullVariant,{uuid:variant.uuid})));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(navigateToVariantFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var updateRelatedVariant=exports.updateRelatedVariant=function updateRelatedVariant(variant/*: VariantDto*/,data/*: any*/)/*: Exact<ConfigTemplateUpdateRelatedVariantAction>*/{return{type:UPDATE_RELATED_VARIANT,variant:variant,data:data};};var setStandardProduct=exports.setStandardProduct=function setStandardProduct(product/*: ProductDto*/,productType/*: ProductTypeDto*/)/*: Exact<ConfigTemplateSetStandardProductAction>*/{return{type:SET_STANDARD_PRODUCT,product:product,productType:productType};};var clearStandardProduct=exports.clearStandardProduct=function clearStandardProduct(productType/*: ProductTypeDto*/)/*: Exact<ConfigTemplateClearStandardProductAction>*/{return{type:CLEAR_STANDARD_PRODUCT,productType:productType};};var toggleVariantRequest=function toggleVariantRequest()/*: Exact<ConfigTemplateToggleVariantRequestAction>*/{return{type:TOGGLE_VARIANT_REQUEST};};var toggleVariantFailure=function toggleVariantFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateToggleVariantFailureAction>*/{return{type:TOGGLE_VARIANT_FAILURE,error:error};};var toggleVariantSuccess=function toggleVariantSuccess(variant/*: VariantDto*/,expand/*: boolean*/)/*: Exact<ConfigTemplateToggleVariantSuccessAction>*/{return{type:TOGGLE_VARIANT_SUCCESS,variant:variant,expand:expand};};var toggleVariant=exports.toggleVariant=function toggleVariant(variant/*: VariantDto*/,expand/*: boolean*/){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch/*: Dispatch<ConfigTemplateAction>*/){var fullVariant;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!expand){_context2.next=14;break;}dispatch(toggleVariantRequest());_context2.prev=2;_context2.next=5;return(0,_request.GET)({endpoint:'/productvariants/'+variant.id},dispatch);case 5:fullVariant=_context2.sent;dispatch(toggleVariantSuccess(_extends({},fullVariant,{uuid:variant.uuid}),expand));_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](2);dispatch(toggleVariantFailure(_context2.t0));case 12:_context2.next=15;break;case 14:dispatch(toggleVariantSuccess(variant,expand));case 15:case'end':return _context2.stop();}}},_callee2,undefined,[[2,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var openDialogRequest=function openDialogRequest()/*: Exact<ConfigTemplateOpenDialogRequestAction>*/{return{type:OPEN_DIALOG_REQUEST};};var openDialogFailure=function openDialogFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateOpenDialogFailureAction>*/{return{type:OPEN_DIALOG_FAILURE,error:error};};var openDialogSuccess=function openDialogSuccess(products/*: ProductDto[]*/,rootName/*: string*/,productType/*: ProductTypeDto*/)/*: Exact<ConfigTemplateOpenDialogSuccessAction>*/{return{type:OPEN_DIALOG_SUCCESS,products:products,rootName:rootName,productType:productType};};var openDialog=exports.openDialog=function openDialog(productTypeId/*: number*/,rootName/*: string*/){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch/*: Dispatch<ConfigTemplateAction>*/){var _productType,_products;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(openDialogRequest());_context3.prev=1;_context3.next=4;return(0,_request.GET)({endpoint:'/producttypes/'+productTypeId},dispatch);case 4:_productType=_context3.sent;_context3.next=7;return(0,_request.GET)({endpoint:'/products?productTypeId='+productTypeId+'&assortment='+_assortments.STANDARD},dispatch);case 7:_products=_context3.sent;dispatch(openDialogSuccess(_products,rootName,_productType));_context3.next=14;break;case 11:_context3.prev=11;_context3.t0=_context3['catch'](1);dispatch(openDialogFailure(_context3.t0));case 14:case'end':return _context3.stop();}}},_callee3,undefined,[[1,11]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var closeDialog=exports.closeDialog=function closeDialog()/*: Exact<ConfigTemplateCloseDialogAction>*/{return{type:CLOSE_DIALOG};};var configTemplateRequest=function configTemplateRequest()/*: Exact<ConfigTemplateGetRequestAction>*/{return{type:GET_REQUEST};};var configTemplateSuccess=function configTemplateSuccess(configTemplate/*: ?ConfigTemplateDto*/,roomTypes/*: RoomTypeDto[]*/,products/*: ProductDto[]*/,productTypes/*: ProductTypeDto[]*/,configTemplates/*: ConfigTemplateDto[]*/,projects/*: LimitedProjectDto[]*/,roomTemplates/*: RoomTemplateDto[]*/)/*: Exact<ConfigTemplateGetSuccessAction>*/{return{type:GET_SUCCESS,configTemplate:configTemplate,roomTypes:roomTypes,products:products,productTypes:productTypes,configTemplates:configTemplates,projects:projects,roomTemplates:roomTemplates};};var configTemplateFailure=function configTemplateFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateGetFailureAction>*/{return{type:GET_FAILURE,error:error};};var configTemplateUpdateRequest=function configTemplateUpdateRequest()/*: Exact<ConfigTemplateUpdateRequestAction>*/{return{type:UPDATE_REQUEST};};var configTemplateUpdateSuccess=function configTemplateUpdateSuccess(configTemplate/*: ConfigTemplateDto*/)/*: Exact<ConfigTemplateUpdateSuccessAction>*/{return _defineProperty({type:UPDATE_SUCCESS,configTemplate:configTemplate},_notification.ADD,{message:'Mall uppdaterad'});};var configTemplateUpdateFailure=function configTemplateUpdateFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateUpdateFailureAction>*/{return{type:UPDATE_FAILURE,error:error};};var configTemplateCreateRequest=function configTemplateCreateRequest()/*: Exact<ConfigTemplateCreateRequestAction>*/{return{type:CREATE_REQUEST};};var configTemplateCreateSuccess=function configTemplateCreateSuccess(configTemplate/*: ConfigTemplateDto*/)/*: Exact<ConfigTemplateCreateSuccessAction>*/{return _defineProperty({type:CREATE_SUCCESS,configTemplate:configTemplate},_notification.ADD,{message:'Mall "'+configTemplate.name+'" skapad'});};var configTemplateCreateFailure=function configTemplateCreateFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateCreateFailureAction>*/{return{type:CREATE_FAILURE,error:error};};var roomUpdateRequest=function roomUpdateRequest()/*: Exact<ConfigTemplateRoomUpdateRequestAction>*/{return{type:ROOM_UPDATE_REQUEST};};var roomUpdateSuccess=function roomUpdateSuccess(room/*: RoomDto*/)/*: Exact<ConfigTemplateRoomUpdateSuccessAction>*/{return _defineProperty({type:ROOM_UPDATE_SUCCESS,room:room},_notification.ADD,{message:'Rum uppdaterat'});};var roomUpdateFailure=function roomUpdateFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateRoomUpdateFailureAction>*/{return{type:ROOM_UPDATE_FAILURE,error:error};};var roomCreateRequest=function roomCreateRequest()/*: Exact<ConfigTemplateRoomCreateRequestAction>*/{return{type:ROOM_CREATE_REQUEST};};var roomCreateSuccess=function roomCreateSuccess(room/*: RoomDto*/)/*: Exact<ConfigTemplateRoomCreateSuccessAction>*/{return _defineProperty({type:ROOM_CREATE_SUCCESS,room:room},_notification.ADD,{message:'Rum "'+room.name+'" skapat'});};var roomCreateFailure=function roomCreateFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateRoomCreateFailureAction>*/{return{type:ROOM_CREATE_FAILURE,error:error};};var productSlotUpdateRequest=function productSlotUpdateRequest()/*: Exact<ConfigTemplateProductSlotUpdateRequestAction>*/{return{type:PRODUCT_SLOT_UPDATE_REQUEST};};var productSlotUpdateSuccess=function productSlotUpdateSuccess(productSlot/*: ProductSlotDto*/)/*: Exact<ConfigTemplateProductSlotUpdateSuccessAction>*/{return _defineProperty({type:PRODUCT_SLOT_UPDATE_SUCCESS,productSlot:productSlot},_notification.ADD,{message:'Produktplats uppdaterad'});};var productSlotUpdateFailure=function productSlotUpdateFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateProductSlotUpdateFailureAction>*/{return{type:PRODUCT_SLOT_UPDATE_FAILURE,error:error};};var productSlotCreateRequest=function productSlotCreateRequest()/*: Exact<ConfigTemplateProductSlotCreateRequestAction>*/{return{type:PRODUCT_SLOT_CREATE_REQUEST};};var productSlotCreateSuccess=function productSlotCreateSuccess(productSlot/*: ProductSlotDto*/,roomId/*: number*/)/*: Exact<ConfigTemplateProductSlotCreateSuccessAction>*/{return _defineProperty({type:PRODUCT_SLOT_CREATE_SUCCESS,productSlot:productSlot,roomId:roomId},_notification.ADD,{message:'Produktplats "'+productSlot.name+'" skapad'});};var productSlotCreateFailure=function productSlotCreateFailure(error/*: ErrorDto*/)/*: Exact<ConfigTemplateProductSlotCreateFailureAction>*/{return{type:PRODUCT_SLOT_CREATE_FAILURE,error:error};};var clear=exports.clear=function clear()/*: Exact<ConfigTemplateClearAction>*/{return{type:CLEAR};};var reset=exports.reset=function reset()/*: Exact<ConfigTemplateResetAction>*/{return{type:RESET};};var selectRoom=exports.selectRoom=function selectRoom(room/*: ?RoomDto*/)/*: Exact<ConfigTemplateSelectRoomAction>*/{return{type:SELECT_ROOM,room:room};};var selectProductSlot=exports.selectProductSlot=function selectProductSlot(roomId/*: number*/,productSlot/*: ?ProductSlotDto*/)/*: Exact<ConfigTemplateSelectProductSlotAction>*/{return{type:SELECT_PRODUCT_SLOT,roomId:roomId,productSlot:productSlot};};var fetchData=exports.fetchData=function fetchData(id/*: number*/){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch/*: Dispatch<ConfigTemplateAction>*/){var _roomTypes,_products2,_productTypes,_projects,_roomTemplates,_configTemplate,_configTemplates;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(configTemplateRequest());_context4.prev=1;_context4.t0=_apartmentConfigView.sortByName;_context4.next=5;return(0,_request.GET)({endpoint:'/roomtypes'},dispatch);case 5:_context4.t1=_context4.sent;_roomTypes=(0,_context4.t0)(_context4.t1);_context4.next=9;return(0,_request.GET)({endpoint:'/products?assortment='+_assortments.STANDARD},dispatch);case 9:_products2=_context4.sent;_context4.t2=_apartmentConfigView.sortByName;_context4.next=13;return(0,_request.GET)({endpoint:'/producttypes'},dispatch);case 13:_context4.t3=_context4.sent;_productTypes=(0,_context4.t2)(_context4.t3);_context4.t4=_apartmentConfigView.sortByName;_context4.t5=_map3.default;_context4.t6=function(x){return _extends({},x,{apartmentConfigs:(0,_apartmentConfigView.sortByName)(x.apartmentConfigs)});};_context4.next=20;return(0,_request.GET)({endpoint:'/projects/rooms'},dispatch);case 20:_context4.t7=_context4.sent;_context4.t8=(0,_context4.t5)(_context4.t6,_context4.t7);_projects=(0,_context4.t4)(_context4.t8);_context4.t9=_apartmentConfigView.filterAndSort;_context4.next=26;return(0,_request.GET)({endpoint:'/roomtemplates'},dispatch);case 26:_context4.t10=_context4.sent;_roomTemplates=(0,_context4.t9)(_context4.t10);_configTemplate=null;_configTemplates=[];if(!id){_context4.next=36;break;}_context4.next=33;return(0,_request.GET)({endpoint:'/configtemplates/'+id},dispatch);case 33:_configTemplate=_context4.sent;_context4.next=41;break;case 36:_context4.t11=_apartmentConfigView.filterAndSort;_context4.next=39;return(0,_request.GET)({endpoint:'/configtemplates'},dispatch);case 39:_context4.t12=_context4.sent;_configTemplates=(0,_context4.t11)(_context4.t12);case 41:dispatch(configTemplateSuccess(_configTemplate,_roomTypes,_products2,_productTypes,_configTemplates,_projects,_roomTemplates));_context4.next=47;break;case 44:_context4.prev=44;_context4.t13=_context4['catch'](1);dispatch(configTemplateFailure(_context4.t13));case 47:case'end':return _context4.stop();}}},_callee4,undefined,[[1,44]]);}));return function(_x4){return _ref10.apply(this,arguments);};}();};var updateConfigTemplate=exports.updateConfigTemplate=function updateConfigTemplate(id/*: number*/,body/*: any*/){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch/*: Dispatch<ConfigTemplateAction>*/){var _configTemplate2;return _regenerator2.default.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(configTemplateUpdateRequest());_context5.prev=1;_context5.next=4;return(0,_request.PUT)({endpoint:'/configtemplates/'+id,body:body},dispatch);case 4:_configTemplate2=_context5.sent;dispatch(configTemplateUpdateSuccess(_configTemplate2));_context5.next=11;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](1);dispatch(configTemplateUpdateFailure(_context5.t0));case 11:case'end':return _context5.stop();}}},_callee5,undefined,[[1,8]]);}));return function(_x5){return _ref11.apply(this,arguments);};}();};var createConfigTemplate=exports.createConfigTemplate=function createConfigTemplate(body/*: any*/){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch/*: Dispatch<ConfigTemplateAction>*/){var _configTemplate3;return _regenerator2.default.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch(configTemplateCreateRequest());_context6.prev=1;_context6.next=4;return(0,_request.POST)({endpoint:'/configtemplates',body:body},dispatch);case 4:_configTemplate3=_context6.sent;dispatch(configTemplateCreateSuccess(_configTemplate3));_context6.next=11;break;case 8:_context6.prev=8;_context6.t0=_context6['catch'](1);dispatch(configTemplateCreateFailure(_context6.t0));case 11:case'end':return _context6.stop();}}},_callee6,undefined,[[1,8]]);}));return function(_x6){return _ref12.apply(this,arguments);};}();};var createRoom=exports.createRoom=function createRoom(configId/*: number*/,body/*: any*/){return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch/*: Dispatch<ConfigTemplateAction>*/){var _room;return _regenerator2.default.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch(roomCreateRequest());_context7.prev=1;_context7.next=4;return(0,_request.POST)({endpoint:'/configtemplates/'+configId+'/rooms',body:body},dispatch);case 4:_room=_context7.sent;dispatch(roomCreateSuccess(_room));_context7.next=11;break;case 8:_context7.prev=8;_context7.t0=_context7['catch'](1);dispatch(roomCreateFailure(_context7.t0));case 11:case'end':return _context7.stop();}}},_callee7,undefined,[[1,8]]);}));return function(_x7){return _ref13.apply(this,arguments);};}();};var updateRoom=exports.updateRoom=function updateRoom(id/*: number*/,body/*: any*/){return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch/*: Dispatch<ConfigTemplateAction>*/){var _room2;return _regenerator2.default.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch(roomUpdateRequest());_context8.prev=1;_context8.next=4;return(0,_request.PUT)({endpoint:'/rooms/'+id,body:body},dispatch);case 4:_room2=_context8.sent;dispatch(roomUpdateSuccess(_room2));_context8.next=11;break;case 8:_context8.prev=8;_context8.t0=_context8['catch'](1);dispatch(roomUpdateFailure(_context8.t0));case 11:case'end':return _context8.stop();}}},_callee8,undefined,[[1,8]]);}));return function(_x8){return _ref14.apply(this,arguments);};}();};var createProductSlot=exports.createProductSlot=function createProductSlot(roomId/*: number*/,body/*: any*/){return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch/*: Dispatch<ConfigTemplateAction>*/){var productslot;return _regenerator2.default.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch(productSlotCreateRequest());_context9.prev=1;_context9.next=4;return(0,_request.POST)({endpoint:'/rooms/'+roomId+'/productslots',body:body},dispatch);case 4:productslot=_context9.sent;dispatch(productSlotCreateSuccess(productslot,roomId));_context9.next=11;break;case 8:_context9.prev=8;_context9.t0=_context9['catch'](1);dispatch(productSlotCreateFailure(_context9.t0));case 11:case'end':return _context9.stop();}}},_callee9,undefined,[[1,8]]);}));return function(_x9){return _ref15.apply(this,arguments);};}();};var updateProductSlot=exports.updateProductSlot=function updateProductSlot(id/*: number*/,body/*: any*/){return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch/*: Dispatch<ConfigTemplateAction>*/){var productslot;return _regenerator2.default.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:dispatch(productSlotUpdateRequest());_context10.prev=1;_context10.next=4;return(0,_request.PUT)({endpoint:'/productslots/'+id,body:body},dispatch);case 4:productslot=_context10.sent;dispatch(productSlotUpdateSuccess(productslot));_context10.next=11;break;case 8:_context10.prev=8;_context10.t0=_context10['catch'](1);dispatch(productSlotUpdateFailure(_context10.t0));case 11:case'end':return _context10.stop();}}},_callee10,undefined,[[1,8]]);}));return function(_x10){return _ref16.apply(this,arguments);};}();};var updateRooms=exports.updateRooms=function updateRooms(configId/*: number*/,roomId/*: number*/,sortDirection/*: 'up' | 'down'*/){return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch/*: Dispatch<ConfigTemplateAction>*/){var _rooms;return _regenerator2.default.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch(roomsUpdateRequest());_context11.prev=1;_context11.next=4;return(0,_request.PUT)({endpoint:'/configtemplates/'+configId+'/rooms',body:{roomId:roomId,sortDirection:sortDirection}},dispatch);case 4:_rooms=_context11.sent;dispatch(roomsUpdateSuccess(_rooms));_context11.next=11;break;case 8:_context11.prev=8;_context11.t0=_context11['catch'](1);dispatch(roomsUpdateFailure(_context11.t0));case 11:case'end':return _context11.stop();}}},_callee11,undefined,[[1,8]]);}));return function(_x11){return _ref17.apply(this,arguments);};}();};var updateProductSlots=exports.updateProductSlots=function updateProductSlots(roomId/*: number*/,productSlotId/*: number*/,sortDirection/*: 'up' | 'down'*/){return function(){var _ref18=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee12(dispatch/*: Dispatch<ConfigTemplateAction>*/){var _productSlots;return _regenerator2.default.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:dispatch(productSlotsUpdateRequest());_context12.prev=1;_context12.next=4;return(0,_request.PUT)({endpoint:'/rooms/'+roomId+'/productslots',body:{productSlotId:productSlotId,sortDirection:sortDirection}},dispatch);case 4:_productSlots=_context12.sent;dispatch(productSlotsUpdateSuccess(roomId,productSlotId,_productSlots));_context12.next=11;break;case 8:_context12.prev=8;_context12.t0=_context12['catch'](1);dispatch(productSlotsUpdateFailure(_context12.t0));case 11:case'end':return _context12.stop();}}},_callee12,undefined,[[1,8]]);}));return function(_x12){return _ref18.apply(this,arguments);};}();};

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.calculateOrderCompleteState=undefined;var _flatMap2=__webpack_require__(54);var _flatMap3=_interopRequireDefault(_flatMap2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _all2=__webpack_require__(916);var _all3=_interopRequireDefault(_all2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _uniq2=__webpack_require__(231);var _uniq3=_interopRequireDefault(_uniq2);var _intersection2=__webpack_require__(917);var _intersection3=_interopRequireDefault(_intersection2);var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _uniqBy2=__webpack_require__(120);var _uniqBy3=_interopRequireDefault(_uniqBy2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _groupBy2=__webpack_require__(168);var _groupBy3=_interopRequireDefault(_groupBy2);var _slice2=__webpack_require__(921);var _slice3=_interopRequireDefault(_slice2);var _findIndex2=__webpack_require__(99);var _findIndex3=_interopRequireDefault(_findIndex2);var _reject2=__webpack_require__(68);var _reject3=_interopRequireDefault(_reject2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _orderView=__webpack_require__(396);var _form=__webpack_require__(17);var _priceHelpers=__webpack_require__(85);var _helpers=__webpack_require__(397);var _customerOrderView=__webpack_require__(236);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var active=function active(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:case _orderView.CREATE_SUCCESS:case _orderView.UPDATE_SUCCESS:return!!action.order?_extends({},action.order,{projectId:action.order.apartment.projectId}):null;case _orderView.ORDER_COMMENT_CREATE_SUCCESS:{if(!state){return state;}return _extends({},state,{comments:[].concat(_toConsumableArray(state.comments),[action.comment])});}case _orderView.ORDER_COMMENT_REMOVE_SUCCESS:{if(!state){return state;}return _extends({},state,{comments:(0,_reject3.default)({id:action.id},state.comments)});}case _orderView.ORDER_COMMENT_UPDATE_SUCCESS:{if(!state){return state;}var idx=(0,_findIndex3.default)({id:action.comment.id},state.comments);return _extends({},state,{comments:[].concat(_toConsumableArray((0,_slice3.default)(0,idx,state.comments)),[action.comment],_toConsumableArray((0,_slice3.default)(idx+1,state.comments.length,state.comments)))});}case _orderView.ORDER_ROWS_UPDATE_SUCCESS:if(!state){return state;}return _extends({},state,{rows:action.rows});case _orderView.ORDER_ROWS_CLEAR_SUCCESS:if(!state){return state;}return _extends({},state,{rows:[]});case _orderView.GET_REQUEST:case _orderView.CLEAR:return null;default:return state;}};var orderRowsBySlotId=function orderRowsBySlotId(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:case _orderView.CREATE_SUCCESS:case _orderView.UPDATE_SUCCESS:return!!action.order?(0,_customerOrderView.groupSlots)(action.order.rows):{};case _orderView.ORDER_ROW_UPDATE_SUCCESS:case _orderView.ORDER_ROWS_UPDATE_SUCCESS:return(0,_customerOrderView.groupSlots)(action.rows);case _orderView.ORDER_ROWS_CLEAR_SUCCESS:case _orderView.GET_REQUEST:case _orderView.CLEAR:return{};default:return state;}};var rooms=function rooms(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return!!action.apartmentConfig?action.apartmentConfig.rooms||[]:[];case _orderView.GET_REQUEST:case _orderView.CLEAR:return[];default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderView.GET_REQUEST:case _orderView.CREATE_REQUEST:case _orderView.UPDATE_REQUEST:case _orderView.GET_SUCCESS:case _orderView.CREATE_SUCCESS:case _orderView.UPDATE_SUCCESS:case _orderView.EXTRA_ROW_REMOVE_REQUEST:case _orderView.EXTRA_ROW_REMOVE_SUCCESS:case _orderView.ORDER_ROWS_CLEAR_REQUEST:case _orderView.CLEAR:return null;case _orderView.GET_FAILURE:case _orderView.CREATE_FAILURE:case _orderView.UPDATE_FAILURE:case _orderView.EXTRA_ROW_REMOVE_FAILURE:case _orderView.ORDER_ROWS_CLEAR_FAILURE:return action.error;default:return state;}};var isDirty=function isDirty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _form.SET_DIRTY:return action.form==='order'?action.dirty:state;case _orderView.GET_SUCCESS:case _orderView.UPDATE_SUCCESS:case _orderView.CREATE_SUCCESS:case _orderView.RESET:case _orderView.CLEAR:return false;default:return state;}};var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _orderView.GET_REQUEST:case _orderView.CREATE_REQUEST:case _orderView.UPDATE_REQUEST:case _orderView.EXTRA_ROW_REMOVE_REQUEST:case _orderView.ORDER_ROWS_CLEAR_REQUEST:return true;case _orderView.GET_SUCCESS:case _orderView.CREATE_SUCCESS:case _orderView.UPDATE_SUCCESS:case _orderView.GET_FAILURE:case _orderView.CREATE_FAILURE:case _orderView.UPDATE_FAILURE:case _orderView.EXTRA_ROW_REMOVE_SUCCESS:case _orderView.EXTRA_ROW_REMOVE_FAILURE:case _orderView.ORDER_ROWS_CLEAR_SUCCESS:case _orderView.ORDER_ROWS_CLEAR_FAILURE:case _orderView.CLEAR:return false;default:return state;}};var groupByProjectId=(0,_groupBy3.default)('projectId');var apartmentsByProjectId=function apartmentsByProjectId(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return groupByProjectId(action.apartments);case _orderView.CLEAR:return{};default:return state;}};var mapUniqueProjects=(0,_flow3.default)((0,_map3.default)('project'),(0,_uniqBy3.default)('id'));var projects=function projects(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return mapUniqueProjects(action.apartments);case _orderView.CLEAR:return[];default:return state;}};var apartments=(0,_redux.combineReducers)({byProjectId:apartmentsByProjectId,projects:projects});var users=function users(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return action.users;case _orderView.CLEAR:return[];default:return state;}};var salesUsers=function salesUsers(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return action.salesUsers;case _orderView.CLEAR:return[];default:return state;}};var groupByProductTypeId=(0,_groupBy3.default)('productTypeId');var productsByProductTypeId=function productsByProductTypeId(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return groupByProductTypeId(action.specialProducts);case _orderView.CLEAR:return{};default:return state;}};var mapUniqueProductTypes=(0,_flow3.default)((0,_map3.default)('productType'),(0,_uniqBy3.default)('id'));var productTypes=function productTypes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return mapUniqueProductTypes(action.specialProducts);case _orderView.CLEAR:return[];default:return state;}};var specialProducts=(0,_redux.combineReducers)({byProductTypeId:productsByProductTypeId,productTypes:productTypes});var defaultCustomRows={list:[]};var customRows=function customRows(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultCustomRows;var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return _extends({},state,{list:!!action.order?action.order.customRows:[]});case _orderView.CLEAR:return defaultCustomRows;default:return state;}};var defaultRowsState={rooms:[],rows:[],extraRows:[],allRowsByRoom:[]};var rows=function rows(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultRowsState;var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return!!action.order&&!!action.apartmentConfig?_extends({},state,{rooms:action.apartmentConfig.rooms,rows:action.order.rows,extraRows:action.order.extraRows,allRowsByRoom:(0,_helpers.productRowsByRoom)(action.apartmentConfig.rooms,action.order.rows,action.order.extraRows)}):defaultRowsState;case _orderView.CREATE_SUCCESS:case _orderView.UPDATE_SUCCESS:{return _extends({},state,{rows:action.order.rows,extraRows:action.order.extraRows,allRowsByRoom:(0,_helpers.productRowsByRoom)(state.rooms,action.order.rows,action.order.extraRows)});}case _orderView.ORDER_ROW_UPDATE_SUCCESS:case _orderView.ORDER_ROWS_UPDATE_SUCCESS:return _extends({},state,{rows:action.rows,allRowsByRoom:(0,_helpers.productRowsByRoom)(state.rooms,action.rows,state.extraRows)});case _orderView.EXTRA_ROW_CREATE_SUCCESS:{var _extraRows=[].concat(_toConsumableArray(state.extraRows),[action.row]);return _extends({},state,{extraRows:_extraRows,allRowsByRoom:(0,_helpers.productRowsByRoom)(state.rooms,state.rows,_extraRows)});}case _orderView.EXTRA_ROW_UPDATE_SUCCESS:{var _extraRows2=(0,_filter3.default)(function(r){return r.id!==action.row.id;},state.extraRows).concat([action.row]);return _extends({},state,{extraRows:_extraRows2,allRowsByRoom:(0,_helpers.productRowsByRoom)(state.rooms,state.rows,_extraRows2)});}case _orderView.EXTRA_ROW_REMOVE_SUCCESS:var extraRows=(0,_filter3.default)(function(r){return r.id!==action.id;},state.extraRows);return _extends({},state,{extraRows:extraRows,allRowsByRoom:(0,_helpers.productRowsByRoom)(state.rooms,state.rows,extraRows)});case _orderView.ORDER_ROWS_CLEAR_SUCCESS:return _extends({},state,{extraRows:defaultRowsState.extraRows,rows:defaultRowsState.rows,allRowsByRoom:defaultRowsState.allRowsByRoom});case _orderView.GET_REQUEST:case _orderView.CLEAR:return defaultRowsState;default:return state;}};var noteRowIsExtra=function noteRowIsExtra(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _orderView.SET_NOTE_ROW:return action.isExtra;case _orderView.CLEAR:return false;default:return state;}};var noteRowActive=function noteRowActive(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderView.SET_NOTE_ROW:return action.row;case _orderView.ORDER_ROW_UPDATE_SUCCESS:case _orderView.EXTRA_ROW_UPDATE_SUCCESS:case _orderView.CLEAR:return null;default:return state;}};var noteRowError=function noteRowError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderView.ORDER_ROW_UPDATE_FAILURE:case _orderView.EXTRA_ROW_UPDATE_FAILURE:return action.error;case _orderView.ORDER_ROW_UPDATE_SUCCESS:case _orderView.EXTRA_ROW_UPDATE_SUCCESS:case _orderView.SET_NOTE_ROW:case _orderView.CLEAR:return null;default:return state;}};var noteRowIsFetching=function noteRowIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _orderView.ORDER_ROW_UPDATE_REQUEST:case _orderView.EXTRA_ROW_UPDATE_REQUEST:return true;case _orderView.ORDER_ROW_UPDATE_SUCCESS:case _orderView.ORDER_ROW_UPDATE_FAILURE:case _orderView.EXTRA_ROW_UPDATE_SUCCESS:case _orderView.EXTRA_ROW_UPDATE_FAILURE:case _orderView.CLEAR:return false;default:return state;}};var noteRow=(0,_redux.combineReducers)({isExtra:noteRowIsExtra,active:noteRowActive,error:noteRowError,isFetching:noteRowIsFetching});var orderCommentActive=function orderCommentActive(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderView.SET_ACTIVE_COMMENT:return action.comment;case _orderView.ORDER_COMMENT_CREATE_SUCCESS:case _orderView.ORDER_COMMENT_REMOVE_SUCCESS:case _orderView.ORDER_COMMENT_UPDATE_SUCCESS:case _orderView.CLEAR:return null;default:return state;}};var orderCommentError=function orderCommentError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderView.ORDER_COMMENT_CREATE_FAILURE:case _orderView.ORDER_COMMENT_REMOVE_FAILURE:case _orderView.ORDER_COMMENT_UPDATE_FAILURE:return action.error;case _orderView.ORDER_COMMENT_CREATE_SUCCESS:case _orderView.ORDER_COMMENT_REMOVE_SUCCESS:case _orderView.ORDER_COMMENT_UPDATE_SUCCESS:case _orderView.SET_ACTIVE_COMMENT:case _orderView.CLEAR:return null;default:return state;}};var orderCommentIsFetching=function orderCommentIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _orderView.ORDER_COMMENT_CREATE_REQUEST:case _orderView.ORDER_COMMENT_REMOVE_REQUEST:case _orderView.ORDER_COMMENT_UPDATE_REQUEST:return true;case _orderView.ORDER_COMMENT_CREATE_SUCCESS:case _orderView.ORDER_COMMENT_CREATE_FAILURE:case _orderView.ORDER_COMMENT_REMOVE_SUCCESS:case _orderView.ORDER_COMMENT_REMOVE_FAILURE:case _orderView.ORDER_COMMENT_UPDATE_SUCCESS:case _orderView.ORDER_COMMENT_UPDATE_FAILURE:case _orderView.CLEAR:return false;default:return state;}};var orderCommentRoomTypes=function orderCommentRoomTypes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return action.roomTypes;case _orderView.CLEAR:return[];default:return state;}};var orderCommentWorkerTypes=function orderCommentWorkerTypes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:return action.workerTypes;case _orderView.CLEAR:return[];default:return state;}};var orderComment=(0,_redux.combineReducers)({active:orderCommentActive,error:orderCommentError,isFetching:orderCommentIsFetching,roomTypes:orderCommentRoomTypes,workerTypes:orderCommentWorkerTypes});var suppliers=function suppliers(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _orderView.GET_SUCCESS:case _orderView.CREATE_SUCCESS:case _orderView.UPDATE_SUCCESS:case _orderView.ORDER_ROW_UPDATE_SUCCESS:case _orderView.ORDER_ROWS_UPDATE_SUCCESS:case _orderView.ORDER_ROWS_CLEAR_SUCCESS:case _orderView.EXTRA_ROW_REMOVE_SUCCESS:case _orderView.EXTRA_ROW_UPDATE_SUCCESS:case _orderView.EXTRA_ROW_CREATE_SUCCESS:return(0,_flow3.default)((0,_filter3.default)(function(x){return!!x&&!!x.id;}),(0,_map3.default)(function(x){return x.supplier;}),(0,_filter3.default)(function(x){return!!x&&!!x.id;}),(0,_uniqBy3.default)('id'),(0,_sortBy3.default)([function(x){return x.name;}]))([].concat(_toConsumableArray((0,_map3.default)(function(x){return x.product;},state.rows.rows)),_toConsumableArray((0,_map3.default)(function(x){return x.product;},state.rows.extraRows)),_toConsumableArray(state.customRows.list)));case _orderView.CLEAR:return[];default:return state.suppliers;}};var defaultReportFilterState={includePlans:false,supplierId:null};var reportFilter=function reportFilter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultReportFilterState;var action=arguments[1];switch(action.type){case _orderView.UPDATE_REPORT_FILTER:return _extends({},state,{includePlans:!!action.includePlans,supplierId:action.supplierId});case _orderView.CLEAR:return defaultReportFilterState;default:return state;}};var defaultUserOrderFilterState={includePlans:false};var userOrderFilter=function userOrderFilter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultUserOrderFilterState;var action=arguments[1];switch(action.type){case _orderView.UPDATE_USER_ORDER_FILTER:return _extends({},state,{includePlans:!!action.includePlans});case _orderView.CLEAR:return defaultUserOrderFilterState;default:return state;}};var configHasRequiredOrderRows=function configHasRequiredOrderRows(config,rows){var id=config.id,productVariant=config.productVariant,standardProducts=config.standardProducts;var requiredProductTypes=(0,_intersection3.default)((0,_map3.default)('productTypeId',standardProducts),(0,_flow3.default)((0,_map3.default)(function(x){return x.productTypeId;}),_uniq3.default)(productVariant.related));if(!requiredProductTypes.length){return true;}var childRows=(0,_filter3.default)({parentConfigId:id},rows);var childRowsHasProductType=function childRowsHasProductType(type){return(0,_some3.default)({productTypeId:type},childRows);};var hasRequiredRows=(0,_all3.default)(childRowsHasProductType,requiredProductTypes);return hasRequiredRows;};var checkCompleteAdvancedRows=function checkCompleteAdvancedRows(slots,rows){var advancedRows=(0,_filter3.default)('advanced',rows);var allActiveConfigs=(0,_flow3.default)((0,_map3.default)(function(r){return{configId:r.configId,slot:(0,_find3.default)({id:r.productSlotId},slots)};}),(0,_filter3.default)(function(r){return!!r.slot;}),(0,_map3.default)(function(r){return(0,_find3.default)({id:r.configId},r.slot.config);}))(advancedRows);return(0,_all3.default)(function(c){return configHasRequiredOrderRows(c,rows);},allActiveConfigs);};var calculateOrderCompleteState=exports.calculateOrderCompleteState=function calculateOrderCompleteState(orderRowsBySlotId,rooms,orderRows){var complete=false;if(!!orderRowsBySlotId&&!!rooms){var productSlots=(0,_flatMap3.default)('productSlots',rooms);var slotsAreComplete=!(0,_some3.default)(function(i){return(!!i.defaultProductId&&!i.advanced||!!i.standardProductId&&!!i.advanced)&&!orderRowsBySlotId[i.id+'__'+(!!i.advanced?i.productTypeId:'')];},productSlots);var advancedOrderRowsAreComplete=checkCompleteAdvancedRows(productSlots,orderRows);complete=slotsAreComplete&&advancedOrderRowsAreComplete;}return complete;};var orderComplete=function orderComplete(state,action){switch(action.type){case _orderView.GET_SUCCESS:case _orderView.UPDATE_SUCCESS:case _orderView.CREATE_SUCCESS:case _orderView.ORDER_ROWS_UPDATE_SUCCESS:case _orderView.ORDER_ROW_UPDATE_SUCCESS:case _orderView.ORDER_ROWS_CLEAR_SUCCESS:return calculateOrderCompleteState(state.orderRowsBySlotId,state.rooms,state.active?state.active.rows:[]);case _orderView.CLEAR:return false;default:return state.orderComplete;}};var activeExtraRow=function activeExtraRow(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderView.SET_ACTIVE_EXTRA_ROW:return action.row;case _orderView.EXTRA_ROW_CREATE_SUCCESS:case _orderView.EXTRA_ROW_UPDATE_SUCCESS:case _orderView.CLEAR:return null;default:return state;}};var extraRowError=function extraRowError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderView.EXTRA_ROW_CREATE_SUCCESS:case _orderView.SET_ACTIVE_EXTRA_ROW:case _orderView.CLEAR:return null;case _orderView.EXTRA_ROW_CREATE_FAILURE:case _orderView.EXTRA_ROW_UPDATE_FAILURE:return action.error;default:return state;}};var extraRowIsFetching=function extraRowIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _orderView.EXTRA_ROW_CREATE_REQUEST:case _orderView.EXTRA_ROW_UPDATE_REQUEST:return true;case _orderView.EXTRA_ROW_CREATE_SUCCESS:case _orderView.EXTRA_ROW_CREATE_FAILURE:case _orderView.EXTRA_ROW_UPDATE_SUCCESS:case _orderView.EXTRA_ROW_UPDATE_FAILURE:case _orderView.CLEAR:return false;default:return state;}};var extraRow=(0,_redux.combineReducers)({error:extraRowError,isFetching:extraRowIsFetching,active:activeExtraRow});var activeExtraRowProductsIsFetching=function activeExtraRowProductsIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _orderView.ACTIVE_EXTRA_ROW_PRODUCTS_REQUEST:return true;case _orderView.ACTIVE_EXTRA_ROW_PRODUCTS_SUCCESS:case _orderView.ACTIVE_EXTRA_ROW_PRODUCTS_FAILURE:case _orderView.CLEAR:return false;default:return state;}};var activeExtraRowProductList=function activeExtraRowProductList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderView.ACTIVE_EXTRA_ROW_PRODUCTS_SUCCESS:return action.products;case _orderView.CLEAR:return[];default:return state;}};var activeExtraRowProducts=(0,_redux.combineReducers)({isFetching:activeExtraRowProductsIsFetching,list:activeExtraRowProductList});var activeExtraRowVariantsIsFetching=function activeExtraRowVariantsIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _orderView.ACTIVE_EXTRA_ROW_VARIANTS_REQUEST:return true;case _orderView.ACTIVE_EXTRA_ROW_VARIANTS_SUCCESS:case _orderView.ACTIVE_EXTRA_ROW_VARIANTS_FAILURE:case _orderView.CLEAR:return false;default:return state;}};var activeExtraRowVariantList=function activeExtraRowVariantList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderView.ACTIVE_EXTRA_ROW_VARIANTS_SUCCESS:return action.variants;case _orderView.CLEAR:return[];default:return state;}};var activeExtraRowVariants=(0,_redux.combineReducers)({isFetching:activeExtraRowVariantsIsFetching,list:activeExtraRowVariantList});var calculateOrderTotalPrice=function calculateOrderTotalPrice(state){if(!state.active){return 0;}return(0,_priceHelpers.totalPrice)(_extends({},state.active,{rows:state.rows.rows,extraRows:state.rows.extraRows,customRows:state.customRows.list}));};var orderTotalPrice=function orderTotalPrice(state,action){switch(action.type){case _orderView.GET_SUCCESS:case _orderView.UPDATE_SUCCESS:case _orderView.CREATE_SUCCESS:case _orderView.ORDER_ROWS_UPDATE_SUCCESS:case _orderView.ORDER_ROW_UPDATE_SUCCESS:case _orderView.EXTRA_ROW_CREATE_SUCCESS:case _orderView.EXTRA_ROW_UPDATE_SUCCESS:case _orderView.EXTRA_ROW_REMOVE_SUCCESS:case _orderView.ORDER_ROWS_CLEAR_SUCCESS:return calculateOrderTotalPrice(state);case _orderView.CLEAR:return 0;default:return state.orderTotalPrice;}};var reducers=(0,_redux.combineReducers)({active:active,orderRowsBySlotId:orderRowsBySlotId,rooms:rooms,error:error,isDirty:isDirty,isFetching:isFetching,specialProducts:specialProducts,apartments:apartments,users:users,salesUsers:salesUsers,customRows:customRows,orderComplete:function orderComplete(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;return s;},orderTotalPrice:function orderTotalPrice(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;return s;},rows:rows,extraRow:extraRow,activeExtraRowProducts:activeExtraRowProducts,activeExtraRowVariants:activeExtraRowVariants,noteRow:noteRow,orderComment:orderComment,suppliers:function suppliers(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return s;},reportFilter:reportFilter,userOrderFilter:userOrderFilter});var orderView=function orderView(state,action){var newState=reducers(state,action);return _extends({},newState,{orderComplete:orderComplete(newState,action),orderTotalPrice:orderTotalPrice(newState,action),suppliers:suppliers(newState,action)});};exports.default=orderView;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.clearOrderRows=exports.fetchActiveExtraRowVariants=exports.fetchActiveExtraRowProducts=exports.removeExtraRow=exports.updateExtraRow=exports.createExtraRow=exports.updateOrderComment=exports.removeOrderComment=exports.addOrderComment=exports.updateOrderRow=exports.updateOrderRows=exports.updateOrder=exports.createOrder=exports.fetchData=exports.reset=exports.clear=exports.setNoteRow=exports.setActiveExtraRow=exports.setActiveComment=exports.updateReportFilter=exports.updateUserOrderFilter=exports.UPDATE_USER_ORDER_FILTER=exports.UPDATE_REPORT_FILTER=exports.SET_ACTIVE_COMMENT=exports.ACTIVE_EXTRA_ROW_VARIANTS_FAILURE=exports.ACTIVE_EXTRA_ROW_VARIANTS_SUCCESS=exports.ACTIVE_EXTRA_ROW_VARIANTS_REQUEST=exports.ACTIVE_EXTRA_ROW_PRODUCTS_FAILURE=exports.ACTIVE_EXTRA_ROW_PRODUCTS_SUCCESS=exports.ACTIVE_EXTRA_ROW_PRODUCTS_REQUEST=exports.EXTRA_ROW_REMOVE_FAILURE=exports.EXTRA_ROW_REMOVE_SUCCESS=exports.EXTRA_ROW_REMOVE_REQUEST=exports.EXTRA_ROW_CREATE_FAILURE=exports.EXTRA_ROW_CREATE_SUCCESS=exports.EXTRA_ROW_CREATE_REQUEST=exports.EXTRA_ROW_UPDATE_FAILURE=exports.EXTRA_ROW_UPDATE_SUCCESS=exports.EXTRA_ROW_UPDATE_REQUEST=exports.SET_ACTIVE_EXTRA_ROW=exports.ORDER_COMMENT_UPDATE_FAILURE=exports.ORDER_COMMENT_UPDATE_SUCCESS=exports.ORDER_COMMENT_UPDATE_REQUEST=exports.ORDER_COMMENT_REMOVE_FAILURE=exports.ORDER_COMMENT_REMOVE_SUCCESS=exports.ORDER_COMMENT_REMOVE_REQUEST=exports.ORDER_COMMENT_CREATE_FAILURE=exports.ORDER_COMMENT_CREATE_SUCCESS=exports.ORDER_COMMENT_CREATE_REQUEST=exports.SET_NOTE_ROW=exports.ORDER_ROW_UPDATE_FAILURE=exports.ORDER_ROW_UPDATE_SUCCESS=exports.ORDER_ROW_UPDATE_REQUEST=exports.CLEAR=exports.RESET=exports.ORDER_ROWS_CLEAR_FAILURE=exports.ORDER_ROWS_CLEAR_SUCCESS=exports.ORDER_ROWS_CLEAR_REQUEST=exports.ORDER_ROWS_UPDATE_FAILURE=exports.ORDER_ROWS_UPDATE_SUCCESS=exports.ORDER_ROWS_UPDATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _includes2=__webpack_require__(97);var _includes3=_interopRequireDefault(_includes2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isNil2=__webpack_require__(166);var _isNil3=_interopRequireDefault(_isNil2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _notification=__webpack_require__(23);var _request=__webpack_require__(6);var _assortments=__webpack_require__(55);var _roles=__webpack_require__(49);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var GET_REQUEST=exports.GET_REQUEST='@orderView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@orderView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@orderView/GET_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@orderView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@orderView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@orderView/CREATE_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@orderView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@orderView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@orderView/UPDATE_FAILURE';var ORDER_ROWS_UPDATE_REQUEST=exports.ORDER_ROWS_UPDATE_REQUEST='@orderView/ORDER_ROWS_UPDATE_REQUEST';var ORDER_ROWS_UPDATE_SUCCESS=exports.ORDER_ROWS_UPDATE_SUCCESS='@orderView/ORDER_ROWS_UPDATE_SUCCESS';var ORDER_ROWS_UPDATE_FAILURE=exports.ORDER_ROWS_UPDATE_FAILURE='@orderView/ORDER_ROWS_UPDATE_FAILURE';var ORDER_ROWS_CLEAR_REQUEST=exports.ORDER_ROWS_CLEAR_REQUEST='@orderView/ORDER_ROWS_CLEAR_REQUEST';var ORDER_ROWS_CLEAR_SUCCESS=exports.ORDER_ROWS_CLEAR_SUCCESS='@orderView/ORDER_ROWS_CLEAR_SUCCESS';var ORDER_ROWS_CLEAR_FAILURE=exports.ORDER_ROWS_CLEAR_FAILURE='@orderView/ORDER_ROWS_CLEAR_FAILURE';var RESET=exports.RESET='@orderView/RESET';var CLEAR=exports.CLEAR='@orderView/CLEAR';var ORDER_ROW_UPDATE_REQUEST=exports.ORDER_ROW_UPDATE_REQUEST='@orderView/ORDER_ROW_UPDATE_REQUEST';var ORDER_ROW_UPDATE_SUCCESS=exports.ORDER_ROW_UPDATE_SUCCESS='@orderView/ORDER_ROW_UPDATE_SUCCESS';var ORDER_ROW_UPDATE_FAILURE=exports.ORDER_ROW_UPDATE_FAILURE='@orderView/ORDER_ROW_UPDATE_FAILURE';var SET_NOTE_ROW=exports.SET_NOTE_ROW='@orderView/SET_NOTE_ROW';var ORDER_COMMENT_CREATE_REQUEST=exports.ORDER_COMMENT_CREATE_REQUEST='@orderView/ORDER_COMMENT_CREATE_REQUEST';var ORDER_COMMENT_CREATE_SUCCESS=exports.ORDER_COMMENT_CREATE_SUCCESS='@orderView/ORDER_COMMENT_CREATE_SUCCESS';var ORDER_COMMENT_CREATE_FAILURE=exports.ORDER_COMMENT_CREATE_FAILURE='@orderView/ORDER_COMMENT_CREATE_FAILURE';var ORDER_COMMENT_REMOVE_REQUEST=exports.ORDER_COMMENT_REMOVE_REQUEST='@orderView/ORDER_COMMENT_REMOVE_REQUEST';var ORDER_COMMENT_REMOVE_SUCCESS=exports.ORDER_COMMENT_REMOVE_SUCCESS='@orderView/ORDER_COMMENT_REMOVE_SUCCESS';var ORDER_COMMENT_REMOVE_FAILURE=exports.ORDER_COMMENT_REMOVE_FAILURE='@orderView/ORDER_COMMENT_REMOVE_FAILURE';var ORDER_COMMENT_UPDATE_REQUEST=exports.ORDER_COMMENT_UPDATE_REQUEST='@orderView/ORDER_COMMENT_UPDATE_REQUEST';var ORDER_COMMENT_UPDATE_SUCCESS=exports.ORDER_COMMENT_UPDATE_SUCCESS='@orderView/ORDER_COMMENT_UPDATE_SUCCESS';var ORDER_COMMENT_UPDATE_FAILURE=exports.ORDER_COMMENT_UPDATE_FAILURE='@orderView/ORDER_COMMENT_UPDATE_FAILURE';var SET_ACTIVE_EXTRA_ROW=exports.SET_ACTIVE_EXTRA_ROW='@orderView/SET_ACTIVE_EXTRA_ROW';var EXTRA_ROW_UPDATE_REQUEST=exports.EXTRA_ROW_UPDATE_REQUEST='@orderView/EXTRA_ROW_UPDATE_REQUEST';var EXTRA_ROW_UPDATE_SUCCESS=exports.EXTRA_ROW_UPDATE_SUCCESS='@orderView/EXTRA_ROW_UPDATE_SUCCESS';var EXTRA_ROW_UPDATE_FAILURE=exports.EXTRA_ROW_UPDATE_FAILURE='@orderView/EXTRA_ROW_UPDATE_FAILURE';var EXTRA_ROW_CREATE_REQUEST=exports.EXTRA_ROW_CREATE_REQUEST='@orderView/EXTRA_ROW_CREATE_REQUEST';var EXTRA_ROW_CREATE_SUCCESS=exports.EXTRA_ROW_CREATE_SUCCESS='@orderView/EXTRA_ROW_CREATE_SUCCESS';var EXTRA_ROW_CREATE_FAILURE=exports.EXTRA_ROW_CREATE_FAILURE='@orderView/EXTRA_ROW_CREATE_FAILURE';var EXTRA_ROW_REMOVE_REQUEST=exports.EXTRA_ROW_REMOVE_REQUEST='@orderView/EXTRA_ROW_REMOVE_REQUEST';var EXTRA_ROW_REMOVE_SUCCESS=exports.EXTRA_ROW_REMOVE_SUCCESS='@orderView/EXTRA_ROW_REMOVE_SUCCESS';var EXTRA_ROW_REMOVE_FAILURE=exports.EXTRA_ROW_REMOVE_FAILURE='@orderView/EXTRA_ROW_REMOVE_FAILURE';var ACTIVE_EXTRA_ROW_PRODUCTS_REQUEST=exports.ACTIVE_EXTRA_ROW_PRODUCTS_REQUEST='@orderView/ACTIVE_EXTRA_ROW_PRODUCTS_REQUEST';var ACTIVE_EXTRA_ROW_PRODUCTS_SUCCESS=exports.ACTIVE_EXTRA_ROW_PRODUCTS_SUCCESS='@orderView/ACTIVE_EXTRA_ROW_PRODUCTS_SUCCESS';var ACTIVE_EXTRA_ROW_PRODUCTS_FAILURE=exports.ACTIVE_EXTRA_ROW_PRODUCTS_FAILURE='@orderView/ACTIVE_EXTRA_ROW_PRODUCTS_FAILURE';var ACTIVE_EXTRA_ROW_VARIANTS_REQUEST=exports.ACTIVE_EXTRA_ROW_VARIANTS_REQUEST='@orderView/ACTIVE_EXTRA_ROW_VARIANTS_REQUEST';var ACTIVE_EXTRA_ROW_VARIANTS_SUCCESS=exports.ACTIVE_EXTRA_ROW_VARIANTS_SUCCESS='@orderView/ACTIVE_EXTRA_ROW_VARIANTS_SUCCESS';var ACTIVE_EXTRA_ROW_VARIANTS_FAILURE=exports.ACTIVE_EXTRA_ROW_VARIANTS_FAILURE='@orderView/ACTIVE_EXTRA_ROW_VARIANTS_FAILURE';var SET_ACTIVE_COMMENT=exports.SET_ACTIVE_COMMENT='@orderView/SET_ACTIVE_COMMENT';var UPDATE_REPORT_FILTER=exports.UPDATE_REPORT_FILTER='@orderView/UPDATE_REPORT_FILTER';var UPDATE_USER_ORDER_FILTER=exports.UPDATE_USER_ORDER_FILTER='@orderView/UPDATE_USER_ORDER_FILTER';var updateUserOrderFilter=exports.updateUserOrderFilter=function updateUserOrderFilter(includePlans/*: boolean*/){return{type:UPDATE_USER_ORDER_FILTER,includePlans:includePlans};};var updateReportFilter=exports.updateReportFilter=function updateReportFilter(supplierId/*: ?number*/,includePlans/*: boolean*/){return{type:UPDATE_REPORT_FILTER,supplierId:supplierId,includePlans:includePlans};};var setActiveComment=exports.setActiveComment=function setActiveComment(comment){return{type:SET_ACTIVE_COMMENT,comment:comment};};var orderCommentCreateRequest=function orderCommentCreateRequest(){return{type:ORDER_COMMENT_CREATE_REQUEST};};var orderCommentCreateSuccess=function orderCommentCreateSuccess(comment){return _defineProperty({type:ORDER_COMMENT_CREATE_SUCCESS,comment:comment},_notification.ADD,{message:'Kommentar skapad'});};var orderCommentCreateFailure=function orderCommentCreateFailure(error){return{type:ORDER_COMMENT_CREATE_FAILURE,error:error};};var orderCommentRemoveRequest=function orderCommentRemoveRequest(){return{type:ORDER_COMMENT_REMOVE_REQUEST};};var orderCommentRemoveSuccess=function orderCommentRemoveSuccess(id){return _defineProperty({type:ORDER_COMMENT_REMOVE_SUCCESS,id:id},_notification.ADD,{message:'Kommentar borttagen'});};var orderCommentRemoveFailure=function orderCommentRemoveFailure(error){return{type:ORDER_COMMENT_REMOVE_FAILURE,error:error};};var orderCommentUpdateRequest=function orderCommentUpdateRequest(){return{type:ORDER_COMMENT_UPDATE_REQUEST};};var orderCommentUpdateSuccess=function orderCommentUpdateSuccess(comment){return _defineProperty({type:ORDER_COMMENT_UPDATE_SUCCESS,comment:comment},_notification.ADD,{message:'Kommentar uppdaterad'});};var orderCommentUpdateFailure=function orderCommentUpdateFailure(error){return{type:ORDER_COMMENT_UPDATE_FAILURE,error:error};};var extraRowUpdateRequest=function extraRowUpdateRequest(){return{type:EXTRA_ROW_UPDATE_REQUEST};};var extraRowUpdateSuccess=function extraRowUpdateSuccess(row){return{type:EXTRA_ROW_UPDATE_SUCCESS,row:row};};var extraRowUpdateFailure=function extraRowUpdateFailure(error){return{type:EXTRA_ROW_UPDATE_FAILURE,error:error};};var extraRowCreateRequest=function extraRowCreateRequest(){return{type:EXTRA_ROW_CREATE_REQUEST};};var extraRowCreateSuccess=function extraRowCreateSuccess(orderId,row){return{type:EXTRA_ROW_CREATE_SUCCESS,orderId:orderId,row:row};};var extraRowCreateFailure=function extraRowCreateFailure(error){return{type:EXTRA_ROW_CREATE_FAILURE,error:error};};var extraRowRemoveRequest=function extraRowRemoveRequest(){return{type:EXTRA_ROW_REMOVE_REQUEST};};var extraRowRemoveSuccess=function extraRowRemoveSuccess(id){return{type:EXTRA_ROW_REMOVE_SUCCESS,id:id};};var extraRowRemoveFailure=function extraRowRemoveFailure(error){return{type:EXTRA_ROW_REMOVE_FAILURE,error:error};};var activeExtraRowProductsRequest=function activeExtraRowProductsRequest(){return{type:ACTIVE_EXTRA_ROW_PRODUCTS_REQUEST};};var activeExtraRowProductsSuccess=function activeExtraRowProductsSuccess(products){return{type:ACTIVE_EXTRA_ROW_PRODUCTS_SUCCESS,products:products};};var activeExtraRowProductsFailure=function activeExtraRowProductsFailure(error){return{type:ACTIVE_EXTRA_ROW_PRODUCTS_FAILURE,error:error};};var activeExtraRowVariantsRequest=function activeExtraRowVariantsRequest(){return{type:ACTIVE_EXTRA_ROW_VARIANTS_REQUEST};};var activeExtraRowVariantsSuccess=function activeExtraRowVariantsSuccess(variants){return{type:ACTIVE_EXTRA_ROW_VARIANTS_SUCCESS,variants:variants};};var activeExtraRowVariantsFailure=function activeExtraRowVariantsFailure(error){return{type:ACTIVE_EXTRA_ROW_VARIANTS_FAILURE,error:error};};var setActiveExtraRow=exports.setActiveExtraRow=function setActiveExtraRow(row){return{type:SET_ACTIVE_EXTRA_ROW,row:row};};var setNoteRow=exports.setNoteRow=function setNoteRow(row){var isExtra=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return{type:SET_NOTE_ROW,row:row,isExtra:isExtra};};var orderRowUpdateRequest=function orderRowUpdateRequest(){return{type:ORDER_ROW_UPDATE_REQUEST};};var orderRowUpdateSuccess=function orderRowUpdateSuccess(rows){return _defineProperty({type:ORDER_ROW_UPDATE_SUCCESS,rows:rows},_notification.ADD,{message:'Anteckning uppdaterad'});};var orderRowUpdateFailure=function orderRowUpdateFailure(error){return{type:ORDER_ROW_UPDATE_FAILURE,error:error};};var orderRequest=function orderRequest(){return{type:GET_REQUEST};};var orderSuccess=function orderSuccess(order,apartments,users,specialProducts,salesUsers,apartmentConfig,roomTypes,workerTypes){return{type:GET_SUCCESS,apartmentConfig:apartmentConfig,apartments:apartments,users:users,salesUsers:salesUsers,specialProducts:specialProducts,order:order,roomTypes:roomTypes,workerTypes:workerTypes};};var orderFailure=function orderFailure(error){return{type:GET_FAILURE,error:error};};var orderCreateRequest=function orderCreateRequest(){return{type:CREATE_REQUEST};};var orderCreateSuccess=function orderCreateSuccess(order){return _defineProperty({type:CREATE_SUCCESS,order:order},_notification.ADD,{message:'Beställning skapad'});};var orderCreateFailure=function orderCreateFailure(error){return{type:CREATE_FAILURE,error:error};};var orderUpdateRequest=function orderUpdateRequest(){return{type:UPDATE_REQUEST};};var orderUpdateSuccess=function orderUpdateSuccess(order){return _defineProperty({type:UPDATE_SUCCESS,order:order},_notification.ADD,{message:'Beställning uppdaterad'});};var orderUpdateFailure=function orderUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var orderRowsUpdateRequest=function orderRowsUpdateRequest(){return{type:ORDER_ROWS_UPDATE_REQUEST};};var orderRowsUpdateSuccess=function orderRowsUpdateSuccess(rows){return _defineProperty({type:ORDER_ROWS_UPDATE_SUCCESS,rows:rows},_notification.ADD,{message:'Beställning uppdaterad'});};var orderRowsUpdateFailure=function orderRowsUpdateFailure(error){return _defineProperty({type:ORDER_ROWS_UPDATE_FAILURE,error:error},_notification.ADD,{message:'Nätverksfel, vänligen försök igen',level:'error'});};var orderRowsClearRequest=function orderRowsClearRequest(){return{type:ORDER_ROWS_CLEAR_REQUEST};};var orderRowsClearSuccess=function orderRowsClearSuccess(){return _defineProperty({type:ORDER_ROWS_CLEAR_SUCCESS},_notification.ADD,{message:'Order uppdaterad'});};var orderRowsClearFailure=function orderRowsClearFailure(error){return{type:ORDER_ROWS_CLEAR_FAILURE,error:error};};var clear=exports.clear=function clear(){return{type:CLEAR};};var reset=exports.reset=function reset(){return{type:RESET};};var filterArchived=(0,_filter3.default)({archived:null});var fetchData=exports.fetchData=function fetchData(orderId){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var order,apartmentConfig,apartments,users,salesUsers,specialProducts,roomTypes,workerTypes;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(orderRequest());_context.prev=1;order=null;apartmentConfig=null;if((0,_isNil3.default)(orderId)){_context.next=27;break;}_context.next=7;return(0,_request.GET)({endpoint:'/orders/'+orderId},dispatch);case 7:order=_context.sent;_context.next=10;return(0,_request.GET)({endpoint:'/orders/'+orderId+'/comments'},dispatch);case 10:order.comments=_context.sent;_context.next=13;return(0,_request.GET)({endpoint:'/orders/'+orderId+'/rows'},dispatch);case 13:order.rows=_context.sent;_context.next=16;return(0,_request.GET)({endpoint:'/orders/'+orderId+'/customrows'},dispatch);case 16:order.customRows=_context.sent;_context.next=19;return(0,_request.GET)({endpoint:'/orders/'+orderId+'/extrarows'},dispatch);case 19:order.extraRows=_context.sent;_context.next=22;return(0,_request.GET)({endpoint:'/apartmentconfigs/'+order.apartment.apartmentConfigId},dispatch);case 22:apartmentConfig=_context.sent;_context.next=25;return(0,_request.GET)({endpoint:'/orders/'+orderId+'/changes'},dispatch);case 25:order.changes=_context.sent;apartmentConfig.rooms=(0,_flow3.default)(filterArchived,(0,_map3.default)(function(r){return _extends({},r,{productSlots:filterArchived(r.productSlots)});}))(apartmentConfig.rooms);case 27:_context.next=29;return(0,_request.GET)({endpoint:'/orders/apartments'},dispatch);case 29:apartments=_context.sent;_context.next=32;return(0,_request.GET)({endpoint:'/orders/users'},dispatch);case 32:users=_context.sent;_context.next=35;return(0,_request.GET)({endpoint:'/users/?role='+_roles.ADMIN},dispatch);case 35:salesUsers=_context.sent;_context.next=38;return(0,_request.GET)({endpoint:'/products?assortment='+_assortments.SPECIAL},dispatch);case 38:specialProducts=_context.sent;_context.next=41;return(0,_request.GET)({endpoint:'/roomTypes'},dispatch);case 41:roomTypes=_context.sent;_context.next=44;return(0,_request.GET)({endpoint:'/workerTypes'},dispatch);case 44:workerTypes=_context.sent;dispatch(orderSuccess(order,apartments,users,filterArchived(specialProducts),salesUsers,apartmentConfig,filterArchived(roomTypes),filterArchived(workerTypes)));_context.next=51;break;case 48:_context.prev=48;_context.t0=_context['catch'](1);dispatch(orderFailure(_context.t0));case 51:case'end':return _context.stop();}}},_callee,undefined,[[1,48]]);}));return function(_x2){return _ref10.apply(this,arguments);};}();};var createOrder=exports.createOrder=function createOrder(body){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var order;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(orderCreateRequest());_context2.prev=1;_context2.next=4;return(0,_request.POST)({endpoint:'/orders',body:body},dispatch);case 4:order=_context2.sent;dispatch(orderCreateSuccess(order));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(orderCreateFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x3){return _ref11.apply(this,arguments);};}();};var updateOrder=exports.updateOrder=function updateOrder(id,body){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var order;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(orderUpdateRequest());_context3.prev=1;_context3.next=4;return(0,_request.PUT)({endpoint:'/orders/'+id,body:body},dispatch);case 4:order=_context3.sent;_context3.next=7;return(0,_request.GET)({endpoint:'/orders/'+id+'/rows'},dispatch);case 7:order.rows=_context3.sent;_context3.next=10;return(0,_request.GET)({endpoint:'/orders/'+id+'/extrarows'},dispatch);case 10:order.extraRows=_context3.sent;_context3.next=13;return(0,_request.GET)({endpoint:'/orders/'+id+'/customrows'},dispatch);case 13:order.customRows=_context3.sent;dispatch(orderUpdateSuccess(order));_context3.next=20;break;case 17:_context3.prev=17;_context3.t0=_context3['catch'](1);dispatch(orderUpdateFailure(_context3.t0));case 20:case'end':return _context3.stop();}}},_callee3,undefined,[[1,17]]);}));return function(_x4){return _ref12.apply(this,arguments);};}();};var updateOrderRows=exports.updateOrderRows=function updateOrderRows(orderId){var _ref13=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{},standard=_ref13.standard,clear=_ref13.clear;return function(){var _ref14=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch){var rows;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(orderRowsUpdateRequest());_context4.prev=1;_context4.next=4;return(0,_request.PUT)({endpoint:'/orders/'+orderId+'/rows',body:{standard:standard,clear:clear}},dispatch);case 4:rows=_context4.sent;dispatch(orderRowsUpdateSuccess(rows));_context4.next=11;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](1);dispatch(orderRowsUpdateFailure(_context4.t0));case 11:case'end':return _context4.stop();}}},_callee4,undefined,[[1,8]]);}));return function(_x6){return _ref14.apply(this,arguments);};}();};var updateOrderRow=exports.updateOrderRow=function updateOrderRow(id,body){return function(){var _ref15=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch){var rows;return _regenerator2.default.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(orderRowUpdateRequest());_context5.prev=1;_context5.next=4;return(0,_request.PUT)({endpoint:'/orderrows/'+id,body:body},dispatch);case 4:rows=_context5.sent;dispatch(orderRowUpdateSuccess(rows));_context5.next=11;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](1);dispatch(orderRowUpdateFailure(_context5.t0));case 11:case'end':return _context5.stop();}}},_callee5,undefined,[[1,8]]);}));return function(_x7){return _ref15.apply(this,arguments);};}();};var addOrderComment=exports.addOrderComment=function addOrderComment(id,body){return function(){var _ref16=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch){var comment;return _regenerator2.default.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch(orderCommentCreateRequest());_context6.prev=1;_context6.next=4;return(0,_request.POST)({endpoint:'/orders/'+id+'/comments',body:body},dispatch);case 4:comment=_context6.sent;dispatch(orderCommentCreateSuccess(comment));_context6.next=11;break;case 8:_context6.prev=8;_context6.t0=_context6['catch'](1);dispatch(orderCommentCreateFailure(_context6.t0));case 11:case'end':return _context6.stop();}}},_callee6,undefined,[[1,8]]);}));return function(_x8){return _ref16.apply(this,arguments);};}();};var removeOrderComment=exports.removeOrderComment=function removeOrderComment(id){return function(){var _ref17=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch){return _regenerator2.default.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch(orderCommentRemoveRequest());_context7.prev=1;_context7.next=4;return(0,_request.DELETE)({endpoint:'/ordercomments/'+id},dispatch);case 4:dispatch(orderCommentRemoveSuccess(id));_context7.next=10;break;case 7:_context7.prev=7;_context7.t0=_context7['catch'](1);dispatch(orderCommentRemoveFailure(_context7.t0));case 10:case'end':return _context7.stop();}}},_callee7,undefined,[[1,7]]);}));return function(_x9){return _ref17.apply(this,arguments);};}();};var updateOrderComment=exports.updateOrderComment=function updateOrderComment(id,body){return function(){var _ref18=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch){var comment;return _regenerator2.default.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch(orderCommentUpdateRequest());_context8.prev=1;_context8.next=4;return(0,_request.PUT)({endpoint:'/ordercomments/'+id,body:body},dispatch);case 4:comment=_context8.sent;dispatch(orderCommentUpdateSuccess(comment));_context8.next=11;break;case 8:_context8.prev=8;_context8.t0=_context8['catch'](1);dispatch(orderCommentUpdateFailure(_context8.t0));case 11:case'end':return _context8.stop();}}},_callee8,undefined,[[1,8]]);}));return function(_x10){return _ref18.apply(this,arguments);};}();};var createExtraRow=exports.createExtraRow=function createExtraRow(orderId,body){return function(){var _ref19=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch){var row;return _regenerator2.default.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch(extraRowCreateRequest());_context9.prev=1;_context9.next=4;return(0,_request.POST)({endpoint:'/orders/'+orderId+'/extrarows',body:body},dispatch);case 4:row=_context9.sent;dispatch(extraRowCreateSuccess(orderId,row));dispatch((0,_notification.addNotification)('Produkt tillagd','success'));_context9.next=12;break;case 9:_context9.prev=9;_context9.t0=_context9['catch'](1);dispatch(extraRowCreateFailure(_context9.t0));case 12:case'end':return _context9.stop();}}},_callee9,undefined,[[1,9]]);}));return function(_x11){return _ref19.apply(this,arguments);};}();};var updateExtraRow=exports.updateExtraRow=function updateExtraRow(id,body){return function(){var _ref20=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch){var row;return _regenerator2.default.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:dispatch(extraRowUpdateRequest());_context10.prev=1;_context10.next=4;return(0,_request.PUT)({endpoint:'/extraorderrows/'+id,body:body},dispatch);case 4:row=_context10.sent;dispatch(extraRowUpdateSuccess(row));dispatch((0,_notification.addNotification)('Produkt uppdaterad','success'));_context10.next=12;break;case 9:_context10.prev=9;_context10.t0=_context10['catch'](1);dispatch(extraRowUpdateFailure(_context10.t0));case 12:case'end':return _context10.stop();}}},_callee10,undefined,[[1,9]]);}));return function(_x12){return _ref20.apply(this,arguments);};}();};var removeExtraRow=exports.removeExtraRow=function removeExtraRow(rowId){return function(){var _ref21=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch){return _regenerator2.default.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch(extraRowRemoveRequest());_context11.prev=1;_context11.next=4;return(0,_request.DELETE)({endpoint:'/extraorderrows/'+rowId},dispatch);case 4:dispatch(extraRowRemoveSuccess(rowId));dispatch((0,_notification.addNotification)('Produkt borttagen','success'));_context11.next=11;break;case 8:_context11.prev=8;_context11.t0=_context11['catch'](1);dispatch(extraRowRemoveFailure(_context11.t0));case 11:case'end':return _context11.stop();}}},_callee11,undefined,[[1,8]]);}));return function(_x13){return _ref21.apply(this,arguments);};}();};var fetchActiveExtraRowProducts=exports.fetchActiveExtraRowProducts=function fetchActiveExtraRowProducts(){return function(){var _ref22=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee12(dispatch){var allowedAssortments,products,nonArchivedProducts,allowedProducts;return _regenerator2.default.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:dispatch(activeExtraRowProductsRequest());allowedAssortments=[_assortments.STANDARD,_assortments.SPECIAL];_context12.prev=2;_context12.next=5;return(0,_request.GET)({endpoint:'/products'},dispatch);case 5:products=_context12.sent;nonArchivedProducts=(0,_filter3.default)({archived:null},products);allowedProducts=(0,_filter3.default)(function(p){return(0,_includes3.default)(p.assortment,allowedAssortments);},nonArchivedProducts);dispatch(activeExtraRowProductsSuccess(allowedProducts));_context12.next=14;break;case 11:_context12.prev=11;_context12.t0=_context12['catch'](2);dispatch(activeExtraRowProductsFailure(_context12.t0));case 14:case'end':return _context12.stop();}}},_callee12,undefined,[[2,11]]);}));return function(_x14){return _ref22.apply(this,arguments);};}();};var fetchActiveExtraRowVariants=exports.fetchActiveExtraRowVariants=function fetchActiveExtraRowVariants(id){return function(){var _ref23=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee13(dispatch){var variants,nonArchivedVariants;return _regenerator2.default.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:dispatch(activeExtraRowVariantsRequest());_context13.prev=1;_context13.next=4;return(0,_request.GET)({endpoint:'/products/'+id+'/variants'},dispatch);case 4:variants=_context13.sent;nonArchivedVariants=(0,_filter3.default)({archived:null},variants);dispatch(activeExtraRowVariantsSuccess(nonArchivedVariants));_context13.next=12;break;case 9:_context13.prev=9;_context13.t0=_context13['catch'](1);dispatch(activeExtraRowVariantsFailure(_context13.t0));case 12:case'end':return _context13.stop();}}},_callee13,undefined,[[1,9]]);}));return function(_x15){return _ref23.apply(this,arguments);};}();};var clearOrderRows=exports.clearOrderRows=function clearOrderRows(orderId){return function(){var _ref24=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee14(dispatch){return _regenerator2.default.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:dispatch(orderRowsClearRequest());_context14.prev=1;_context14.next=4;return(0,_request.POST)({endpoint:'/orders/'+orderId+'/clearorderrows',expectBody:false},dispatch);case 4:dispatch(orderRowsClearSuccess());_context14.next=10;break;case 7:_context14.prev=7;_context14.t0=_context14['catch'](1);dispatch(orderRowsClearFailure(_context14.t0));case 10:case'end':return _context14.stop();}}},_callee14,undefined,[[1,7]]);}));return function(_x16){return _ref24.apply(this,arguments);};}();};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.productRowsByRoom=exports.rowsToProductRows=exports.getRoomBySlotId=undefined;var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _reduce2=__webpack_require__(123);var _reduce3=_interopRequireDefault(_reduce2);var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var getRoomBySlotId=exports.getRoomBySlotId=function getRoomBySlotId(rooms,id){return(0,_find3.default)(function(r){return(0,_some3.default)({id:id},r.productSlots);},rooms);};var slotRowsToProductRows=function slotRowsToProductRows(rooms){return(0,_map3.default)(function(row){var room=getRoomBySlotId(rooms,row.productSlotId);var slot=(0,_find3.default)({id:row.productSlotId},room.productSlots);return _extends({},row,{room:room,slot:slot,unit:row.unit||(!!slot?slot.unit:''),quantity:row.quantity||(!!slot?slot.quantity:0)});});};var rowsToProductRows=exports.rowsToProductRows=function rowsToProductRows(rooms){return(0,_map3.default)(function(row){return _extends({},row,{room:row.room||(0,_find3.default)({id:row.roomId},rooms)});});};var productRowsByRoom=exports.productRowsByRoom=function productRowsByRoom(rooms,rows,extraRows){var productRows=(0,_flow3.default)(slotRowsToProductRows(rooms),(0,_sortBy3.default)(['room.sortIndex','slot.sortIndex',function(r){return!!r.slot&&!!r.slot.advanced?!!r.parentConfigId:true;},function(r){return!!r.slot&&!!r.slot.advanced?r.productType.name:true;}]))(rows);var extraProductRows=(0,_flow3.default)(rowsToProductRows(rooms),(0,_sortBy3.default)(['room.sortIndex']))(extraRows);return(0,_flow3.default)((0,_reduce3.default)(function(list,room){var roomProductRows=(0,_filter3.default)(function(r){return r.room.id===room.id;},productRows);var roomExtraProductRows=(0,_filter3.default)(function(r){return r.room.id===room.id;},extraProductRows);if(roomProductRows.length||roomExtraProductRows.length){return[].concat(_toConsumableArray(list),[_extends({},room,{productRows:roomProductRows,extraProductRows:roomExtraProductRows})]);}return list;},[]),(0,_sortBy3.default)(['sortIndex']))(rooms);};

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.filterOrders=exports.fetchOrders=exports.SORT=exports.FILTER=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _roles=__webpack_require__(49);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var GET_REQUEST=exports.GET_REQUEST='@orderList/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@orderList/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@orderList/GET_FAILURE';var FILTER=exports.FILTER='@orderList/FILTER';var SORT=exports.SORT='@orderList/SORT';var ordersRequest=function ordersRequest(){return{type:GET_REQUEST};};var ordersSuccess=function ordersSuccess(orders,salesUsers){return{type:GET_SUCCESS,salesUsers:salesUsers,orders:orders};};var ordersFailure=function ordersFailure(error){return{type:GET_FAILURE,error:error};};var fetchOrders=exports.fetchOrders=function fetchOrders(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var orders,salesUsers;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(ordersRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/orders'},dispatch);case 4:orders=_context.sent;_context.next=7;return(0,_request.GET)({endpoint:'/users/?role='+_roles.ADMIN},dispatch);case 7:salesUsers=_context.sent;dispatch(ordersSuccess(orders,salesUsers));_context.next=14;break;case 11:_context.prev=11;_context.t0=_context['catch'](1);dispatch(ordersFailure(_context.t0));case 14:case'end':return _context.stop();}}},_callee,undefined,[[1,11]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var filterOrders=exports.filterOrders=function filterOrders(){var _ref2=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},_ref2$archived=_ref2.archived,archived=_ref2$archived===undefined?false:_ref2$archived,_ref2$orderState=_ref2.orderState,orderState=_ref2$orderState===undefined?null:_ref2$orderState,_ref2$salesUserId=_ref2.salesUserId,salesUserId=_ref2$salesUserId===undefined?null:_ref2$salesUserId,_ref2$query=_ref2.query,query=_ref2$query===undefined?null:_ref2$query,_ref2$projectId=_ref2.projectId,projectId=_ref2$projectId===undefined?null:_ref2$projectId;return{type:FILTER,archived:archived,orderState:orderState,salesUserId:salesUserId,query:query,projectId:projectId};};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.removeCustomRow=exports.updateCustomRow=exports.createCustomRow=exports.fetchData=exports.fetchCustomRow=exports.reset=exports.clear=exports.customRowAbortFileUpload=exports.customRowUploadFile=exports.customRowRemoveFile=exports.CLEAR=exports.RESET=exports.CUSTOM_ROW_ABORT_FILE_UPLOAD=exports.CUSTOM_ROW_UPLOAD_FILE=exports.CUSTOM_ROW_REMOVE_FILE=exports.CUSTOM_ROW_ADD_FILE=exports.CUSTOM_ROW_DATA_GET_FAILURE=exports.CUSTOM_ROW_DATA_GET_SUCCESS=exports.CUSTOM_ROW_DATA_GET_REQUEST=exports.CUSTOM_ROW_REMOVE_FAILURE=exports.CUSTOM_ROW_REMOVE_SUCCESS=exports.CUSTOM_ROW_REMOVE_REQUEST=exports.CUSTOM_ROW_CREATE_FAILURE=exports.CUSTOM_ROW_CREATE_SUCCESS=exports.CUSTOM_ROW_CREATE_REQUEST=exports.CUSTOM_ROW_UPDATE_FAILURE=exports.CUSTOM_ROW_UPDATE_SUCCESS=exports.CUSTOM_ROW_UPDATE_REQUEST=exports.CUSTOM_ROW_GET_FAILURE=exports.CUSTOM_ROW_GET_SUCCESS=exports.CUSTOM_ROW_GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _uuid=__webpack_require__(53);var _uuid2=_interopRequireDefault(_uuid);var _fileUploader=__webpack_require__(81);var _notification=__webpack_require__(23);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var CUSTOM_ROW_GET_REQUEST=exports.CUSTOM_ROW_GET_REQUEST='@customRowView/CUSTOM_ROW_GET_REQUEST';var CUSTOM_ROW_GET_SUCCESS=exports.CUSTOM_ROW_GET_SUCCESS='@customRowView/CUSTOM_ROW_GET_SUCCESS';var CUSTOM_ROW_GET_FAILURE=exports.CUSTOM_ROW_GET_FAILURE='@customRowView/CUSTOM_ROW_GET_FAILURE';var CUSTOM_ROW_UPDATE_REQUEST=exports.CUSTOM_ROW_UPDATE_REQUEST='@customRowView/CUSTOM_ROW_UPDATE_REQUEST';var CUSTOM_ROW_UPDATE_SUCCESS=exports.CUSTOM_ROW_UPDATE_SUCCESS='@customRowView/CUSTOM_ROW_UPDATE_SUCCESS';var CUSTOM_ROW_UPDATE_FAILURE=exports.CUSTOM_ROW_UPDATE_FAILURE='@customRowView/CUSTOM_ROW_UPDATE_FAILURE';var CUSTOM_ROW_CREATE_REQUEST=exports.CUSTOM_ROW_CREATE_REQUEST='@customRowView/CUSTOM_ROW_CREATE_REQUEST';var CUSTOM_ROW_CREATE_SUCCESS=exports.CUSTOM_ROW_CREATE_SUCCESS='@customRowView/CUSTOM_ROW_CREATE_SUCCESS';var CUSTOM_ROW_CREATE_FAILURE=exports.CUSTOM_ROW_CREATE_FAILURE='@customRowView/CUSTOM_ROW_CREATE_FAILURE';var CUSTOM_ROW_REMOVE_REQUEST=exports.CUSTOM_ROW_REMOVE_REQUEST='@customRowView/CUSTOM_ROW_REMOVE_REQUEST';var CUSTOM_ROW_REMOVE_SUCCESS=exports.CUSTOM_ROW_REMOVE_SUCCESS='@customRowView/CUSTOM_ROW_REMOVE_SUCCESS';var CUSTOM_ROW_REMOVE_FAILURE=exports.CUSTOM_ROW_REMOVE_FAILURE='@customRowView/CUSTOM_ROW_REMOVE_FAILURE';var CUSTOM_ROW_DATA_GET_REQUEST=exports.CUSTOM_ROW_DATA_GET_REQUEST='@customRowView/CUSTOM_ROW_DATA_GET_REQUEST';var CUSTOM_ROW_DATA_GET_SUCCESS=exports.CUSTOM_ROW_DATA_GET_SUCCESS='@customRowView/CUSTOM_ROW_DATA_GET_SUCCESS';var CUSTOM_ROW_DATA_GET_FAILURE=exports.CUSTOM_ROW_DATA_GET_FAILURE='@customRowView/CUSTOM_ROW_DATA_GET_FAILURE';var CUSTOM_ROW_ADD_FILE=exports.CUSTOM_ROW_ADD_FILE='@customRowView/CUSTOM_ROW_ADD_FILE';var CUSTOM_ROW_REMOVE_FILE=exports.CUSTOM_ROW_REMOVE_FILE='@customRowView/CUSTOM_ROW_REMOVE_FILE';var CUSTOM_ROW_UPLOAD_FILE=exports.CUSTOM_ROW_UPLOAD_FILE='@customRowView/CUSTOM_ROW_UPLOAD_FILE';var CUSTOM_ROW_ABORT_FILE_UPLOAD=exports.CUSTOM_ROW_ABORT_FILE_UPLOAD='@customRowView/CUSTOM_ROW_ABORT_FILE_UPLOAD';var RESET=exports.RESET='@customRowView/RESET';var CLEAR=exports.CLEAR='@customRowView/CLEAR';var customRowGetRequest=function customRowGetRequest(){return{type:CUSTOM_ROW_GET_REQUEST};};var customRowGetSuccess=function customRowGetSuccess(row,order){return{type:CUSTOM_ROW_GET_SUCCESS,row:row,order:order};};var customRowGetFailure=function customRowGetFailure(error){return{type:CUSTOM_ROW_GET_FAILURE,error:error};};var customRowUpdateRequest=function customRowUpdateRequest(){return{type:CUSTOM_ROW_UPDATE_REQUEST};};var customRowUpdateSuccess=function customRowUpdateSuccess(row){return _defineProperty({type:CUSTOM_ROW_UPDATE_SUCCESS,row:row},_notification.ADD,{message:'Friprodukt uppdaterad'});};var customRowUpdateFailure=function customRowUpdateFailure(error){return{type:CUSTOM_ROW_UPDATE_FAILURE,error:error};};var customRowCreateRequest=function customRowCreateRequest(){return{type:CUSTOM_ROW_CREATE_REQUEST};};var customRowCreateSuccess=function customRowCreateSuccess(orderId,row){return _defineProperty({type:CUSTOM_ROW_CREATE_SUCCESS,orderId:orderId,row:row},_notification.ADD,{message:'Friprodukt tillagd'});};var customRowCreateFailure=function customRowCreateFailure(error){return{type:CUSTOM_ROW_CREATE_FAILURE,error:error};};var customRowRemoveRequest=function customRowRemoveRequest(){return{type:CUSTOM_ROW_REMOVE_REQUEST};};var customRowRemoveSuccess=function customRowRemoveSuccess(id){return _defineProperty({type:CUSTOM_ROW_REMOVE_SUCCESS,id:id},_notification.ADD,{message:'Friprodukt borttagen'});};var customRowRemoveFailure=function customRowRemoveFailure(error){return{type:CUSTOM_ROW_REMOVE_FAILURE,error:error};};var customRowDataGetRequest=function customRowDataGetRequest(){return{type:CUSTOM_ROW_DATA_GET_REQUEST};};var customRowDataGetSuccess=function customRowDataGetSuccess(suppliers,productTypes,workerTypes,roomTypes,rooms){return{type:CUSTOM_ROW_DATA_GET_SUCCESS,suppliers:suppliers,productTypes:productTypes,workerTypes:workerTypes,roomTypes:roomTypes,rooms:rooms};};var customRowDataGetFailure=function customRowDataGetFailure(error){return{type:CUSTOM_ROW_DATA_GET_FAILURE,error:error};};var customRowAddFile=function customRowAddFile(name){return function(tempId,metadata){return{type:CUSTOM_ROW_ADD_FILE,name:name,tempId:tempId,metadata:metadata};};};var customRowRemoveFile=exports.customRowRemoveFile=function customRowRemoveFile(name){return{type:CUSTOM_ROW_REMOVE_FILE,name:name};};var customRowUploadFile=exports.customRowUploadFile=function customRowUploadFile(name,file){return _defineProperty({type:CUSTOM_ROW_UPLOAD_FILE,tempId:_uuid2.default.v4(),name:name},_fileUploader.FILE_UPLOAD,{file:file,success:customRowAddFile(name)});};var customRowAbortFileUpload=exports.customRowAbortFileUpload=function customRowAbortFileUpload(tempId){return _defineProperty({type:CUSTOM_ROW_ABORT_FILE_UPLOAD,tempId:tempId},_fileUploader.ABORT_UPLOAD,true);};var clear=exports.clear=function clear(){return{type:CLEAR};};var reset=exports.reset=function reset(){return{type:RESET};};var fetchCustomRow=exports.fetchCustomRow=function fetchCustomRow(customRowId,orderId){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var order,customRow;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(customRowGetRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/orders/'+orderId},dispatch);case 4:order=_context.sent;_context.next=7;return(0,_request.GET)({endpoint:'/customorderrows/'+customRowId},dispatch);case 7:customRow=_context.sent;dispatch(customRowGetSuccess(customRow,order));_context.next=14;break;case 11:_context.prev=11;_context.t0=_context['catch'](1);dispatch(customRowGetFailure(_context.t0));case 14:case'end':return _context.stop();}}},_callee,undefined,[[1,11]]);}));return function(_x){return _ref6.apply(this,arguments);};}();};var fetchData=exports.fetchData=function fetchData(orderId){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var suppliers,productTypes,workerTypes,roomTypes,rooms;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(customRowDataGetRequest());_context2.prev=1;_context2.next=4;return(0,_request.GET)({endpoint:'/suppliers'},dispatch);case 4:suppliers=_context2.sent;_context2.next=7;return(0,_request.GET)({endpoint:'/producttypes'},dispatch);case 7:productTypes=_context2.sent;_context2.next=10;return(0,_request.GET)({endpoint:'/workertypes'},dispatch);case 10:workerTypes=_context2.sent;_context2.next=13;return(0,_request.GET)({endpoint:'/roomtypes'},dispatch);case 13:roomTypes=_context2.sent;_context2.next=16;return(0,_request.GET)({endpoint:'/orders/'+orderId+'/rooms'},dispatch);case 16:rooms=_context2.sent;dispatch(customRowDataGetSuccess(suppliers,productTypes,workerTypes,roomTypes,rooms));_context2.next=23;break;case 20:_context2.prev=20;_context2.t0=_context2['catch'](1);dispatch(customRowDataGetFailure(_context2.t0));case 23:case'end':return _context2.stop();}}},_callee2,undefined,[[1,20]]);}));return function(_x2){return _ref7.apply(this,arguments);};}();};var createCustomRow=exports.createCustomRow=function createCustomRow(orderId,body){return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var row;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(customRowCreateRequest());_context3.prev=1;_context3.next=4;return(0,_request.POST)({endpoint:'/orders/'+orderId+'/customrows',body:body},dispatch);case 4:row=_context3.sent;dispatch(customRowCreateSuccess(orderId,row));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);dispatch(customRowCreateFailure(_context3.t0));case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref8.apply(this,arguments);};}();};var updateCustomRow=exports.updateCustomRow=function updateCustomRow(id,body){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch){var row;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(customRowUpdateRequest());_context4.prev=1;_context4.next=4;return(0,_request.PUT)({endpoint:'/customorderrows/'+id,body:body},dispatch);case 4:row=_context4.sent;dispatch(customRowUpdateSuccess(row));_context4.next=11;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](1);dispatch(customRowUpdateFailure(_context4.t0));case 11:case'end':return _context4.stop();}}},_callee4,undefined,[[1,8]]);}));return function(_x4){return _ref9.apply(this,arguments);};}();};var removeCustomRow=exports.removeCustomRow=function removeCustomRow(rowId){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch){return _regenerator2.default.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(customRowRemoveRequest());_context5.prev=1;_context5.next=4;return(0,_request.DELETE)({endpoint:'/customorderrows/'+rowId},dispatch);case 4:dispatch(customRowRemoveSuccess(rowId));_context5.next=10;break;case 7:_context5.prev=7;_context5.t0=_context5['catch'](1);dispatch(customRowRemoveFailure(_context5.t0));case 10:case'end':return _context5.stop();}}},_callee5,undefined,[[1,7]]);}));return function(_x5){return _ref10.apply(this,arguments);};}();};

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('isEqual', __webpack_require__(240));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.filterByPurchased=exports.filterByProjectId=exports.filterByQuery=exports.fetchOrders=exports.SORT=exports.FILTER_PURCHASED=exports.FILTER_PROJECT_ID=exports.FILTER_QUERY=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var GET_REQUEST=exports.GET_REQUEST='@purchaseOrderList/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@purchaseOrderList/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@purchaseOrderList/GET_FAILURE';var FILTER_QUERY=exports.FILTER_QUERY='@purchaseOrderList/FILTER_QUERY';var FILTER_PROJECT_ID=exports.FILTER_PROJECT_ID='@purchaseOrderList/FILTER_PROJECT_ID';var FILTER_PURCHASED=exports.FILTER_PURCHASED='@purchaseOrderList/FILTER_PURCHASED';var SORT=exports.SORT='@purchaseOrderList/SORT';var ordersRequest=function ordersRequest(){return{type:GET_REQUEST};};var ordersSuccess=function ordersSuccess(orders){return{type:GET_SUCCESS,orders:orders};};var ordersFailure=function ordersFailure(error){return{type:GET_FAILURE,error:error};};var fetchOrders=exports.fetchOrders=function fetchOrders(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var orders;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(ordersRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/orders'},dispatch);case 4:orders=_context.sent;dispatch(ordersSuccess(orders));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(ordersFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var filterByQuery=exports.filterByQuery=function filterByQuery(query){return{type:FILTER_QUERY,query:query};};var filterByProjectId=exports.filterByProjectId=function filterByProjectId(projectId){return{type:FILTER_PROJECT_ID,projectId:projectId};};var filterByPurchased=exports.filterByPurchased=function filterByPurchased(purchased){return{type:FILTER_PURCHASED,purchased:purchased};};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.updateExtraRow=exports.updateOrderRow=exports.removeLinkedAdditionalRow=exports.updateLinkedAdditionalRow=exports.removeAdditionalRow=exports.updateAdditionalRow=exports.createAdditionalRow=exports.fetchVariants=exports.fetchProducts=exports.updateOrder=exports.fetchOrderData=exports.clear=exports.setAdditionalProductRow=exports.setLinkedAdditionalRow=exports.setNoteRow=exports.updateReportFilter=exports.toggleReportDialog=exports.UPDATE_REPORT_FILTER=exports.TOGGLE_REPORT_DIALOG=exports.SET_NOTE_ROW=exports.EXTRA_ROW_UPDATE_FAILURE=exports.EXTRA_ROW_UPDATE_SUCCESS=exports.EXTRA_ROW_UPDATE_REQUEST=exports.ORDER_ROW_UPDATE_FAILURE=exports.ORDER_ROW_UPDATE_SUCCESS=exports.ORDER_ROW_UPDATE_REQUEST=exports.CLEAR=exports.SET_ACTIVE_LINKED_ADDITIONAL_ROW=exports.SET_ACTIVE_ADDITIONAL_ROW=exports.VARIANTS_FAILURE=exports.VARIANTS_SUCCESS=exports.VARIANTS_REQUEST=exports.PRODUCTS_FAILURE=exports.PRODUCTS_SUCCESS=exports.PRODUCTS_REQUEST=exports.LINKED_ADDITIONAL_ROW_REMOVE_FAILURE=exports.LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS=exports.LINKED_ADDITIONAL_ROW_REMOVE_REQUEST=exports.LINKED_ADDITIONAL_ROW_UPDATE_FAILURE=exports.LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS=exports.LINKED_ADDITIONAL_ROW_UPDATE_REQUEST=exports.ADDITIONAL_ROW_REMOVE_FAILURE=exports.ADDITIONAL_ROW_REMOVE_SUCCESS=exports.ADDITIONAL_ROW_REMOVE_REQUEST=exports.ADDITIONAL_ROW_CREATE_FAILURE=exports.ADDITIONAL_ROW_CREATE_SUCCESS=exports.ADDITIONAL_ROW_CREATE_REQUEST=exports.ADDITIONAL_ROW_UPDATE_FAILURE=exports.ADDITIONAL_ROW_UPDATE_SUCCESS=exports.ADDITIONAL_ROW_UPDATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _notification=__webpack_require__(23);var _request=__webpack_require__(6);var _assortments=__webpack_require__(55);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var GET_REQUEST=exports.GET_REQUEST='@purchaseOrderView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@purchaseOrderView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@purchaseOrderView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@purchaseOrderView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@purchaseOrderView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@purchaseOrderView/UPDATE_FAILURE';var ADDITIONAL_ROW_UPDATE_REQUEST=exports.ADDITIONAL_ROW_UPDATE_REQUEST='@purchaseOrderView/ADDITIONAL_ROW_UPDATE_REQUEST';var ADDITIONAL_ROW_UPDATE_SUCCESS=exports.ADDITIONAL_ROW_UPDATE_SUCCESS='@purchaseOrderView/ADDITIONAL_ROW_UPDATE_SUCCESS';var ADDITIONAL_ROW_UPDATE_FAILURE=exports.ADDITIONAL_ROW_UPDATE_FAILURE='@purchaseOrderView/ADDITIONAL_ROW_UPDATE_FAILURE';var ADDITIONAL_ROW_CREATE_REQUEST=exports.ADDITIONAL_ROW_CREATE_REQUEST='@purchaseOrderView/ADDITIONAL_ROW_CREATE_REQUEST';var ADDITIONAL_ROW_CREATE_SUCCESS=exports.ADDITIONAL_ROW_CREATE_SUCCESS='@purchaseOrderView/ADDITIONAL_ROW_CREATE_SUCCESS';var ADDITIONAL_ROW_CREATE_FAILURE=exports.ADDITIONAL_ROW_CREATE_FAILURE='@purchaseOrderView/ADDITIONAL_ROW_CREATE_FAILURE';var ADDITIONAL_ROW_REMOVE_REQUEST=exports.ADDITIONAL_ROW_REMOVE_REQUEST='@purchaseOrderView/ADDITIONAL_ROW_REMOVE_REQUEST';var ADDITIONAL_ROW_REMOVE_SUCCESS=exports.ADDITIONAL_ROW_REMOVE_SUCCESS='@purchaseOrderView/ADDITIONAL_ROW_REMOVE_SUCCESS';var ADDITIONAL_ROW_REMOVE_FAILURE=exports.ADDITIONAL_ROW_REMOVE_FAILURE='@purchaseOrderView/ADDITIONAL_ROW_REMOVE_FAILURE';var LINKED_ADDITIONAL_ROW_UPDATE_REQUEST=exports.LINKED_ADDITIONAL_ROW_UPDATE_REQUEST='@purchaseOrderView/LINKED_ADDITIONAL_ROW_UPDATE_REQUEST';var LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS=exports.LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS='@purchaseOrderView/LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS';var LINKED_ADDITIONAL_ROW_UPDATE_FAILURE=exports.LINKED_ADDITIONAL_ROW_UPDATE_FAILURE='@purchaseOrderView/LINKED_ADDITIONAL_ROW_UPDATE_FAILURE';var LINKED_ADDITIONAL_ROW_REMOVE_REQUEST=exports.LINKED_ADDITIONAL_ROW_REMOVE_REQUEST='@purchaseOrderView/LINKED_ADDITIONAL_ROW_REMOVE_REQUEST';var LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS=exports.LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS='@purchaseOrderView/LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS';var LINKED_ADDITIONAL_ROW_REMOVE_FAILURE=exports.LINKED_ADDITIONAL_ROW_REMOVE_FAILURE='@purchaseOrderView/LINKED_ADDITIONAL_ROW_REMOVE_FAILURE';var PRODUCTS_REQUEST=exports.PRODUCTS_REQUEST='@purchaseOrderView/PRODUCTS_REQUEST';var PRODUCTS_SUCCESS=exports.PRODUCTS_SUCCESS='@purchaseOrderView/PRODUCTS_SUCCESS';var PRODUCTS_FAILURE=exports.PRODUCTS_FAILURE='@purchaseOrderView/PRODUCTS_FAILURE';var VARIANTS_REQUEST=exports.VARIANTS_REQUEST='@purchaseOrderView/VARIANTS_REQUEST';var VARIANTS_SUCCESS=exports.VARIANTS_SUCCESS='@purchaseOrderView/VARIANTS_SUCCESS';var VARIANTS_FAILURE=exports.VARIANTS_FAILURE='@purchaseOrderView/VARIANTS_FAILURE';var SET_ACTIVE_ADDITIONAL_ROW=exports.SET_ACTIVE_ADDITIONAL_ROW='@purchaseOrderView/SET_ACTIVE_ADDITIONAL_ROW';var SET_ACTIVE_LINKED_ADDITIONAL_ROW=exports.SET_ACTIVE_LINKED_ADDITIONAL_ROW='@purchaseOrderView/SET_ACTIVE_LINKED_ADDITIONAL_ROW';var CLEAR=exports.CLEAR='@purchaseOrderView/CLEAR';var ORDER_ROW_UPDATE_REQUEST=exports.ORDER_ROW_UPDATE_REQUEST='@purchaseOrderView/ORDER_ROW_UPDATE_REQUEST';var ORDER_ROW_UPDATE_SUCCESS=exports.ORDER_ROW_UPDATE_SUCCESS='@purchaseOrderView/ORDER_ROW_UPDATE_SUCCESS';var ORDER_ROW_UPDATE_FAILURE=exports.ORDER_ROW_UPDATE_FAILURE='@purchaseOrderView/ORDER_ROW_UPDATE_FAILURE';var EXTRA_ROW_UPDATE_REQUEST=exports.EXTRA_ROW_UPDATE_REQUEST='@purchaseOrderView/EXTRA_ROW_UPDATE_REQUEST';var EXTRA_ROW_UPDATE_SUCCESS=exports.EXTRA_ROW_UPDATE_SUCCESS='@purchaseOrderView/EXTRA_ROW_UPDATE_SUCCESS';var EXTRA_ROW_UPDATE_FAILURE=exports.EXTRA_ROW_UPDATE_FAILURE='@purchaseOrderView/EXTRA_ROW_UPDATE_FAILURE';var SET_NOTE_ROW=exports.SET_NOTE_ROW='@purchaseOrderView/SET_NOTE_ROW';var TOGGLE_REPORT_DIALOG=exports.TOGGLE_REPORT_DIALOG='@purchaseOrderView/TOGGLE_REPORT_DIALOG';var UPDATE_REPORT_FILTER=exports.UPDATE_REPORT_FILTER='@purchaseOrderView/UPDATE_REPORT_FILTER';var toggleReportDialog=exports.toggleReportDialog=function toggleReportDialog(show/*: boolean*/){return{type:TOGGLE_REPORT_DIALOG,show:show};};var updateReportFilter=exports.updateReportFilter=function updateReportFilter(supplierId/*: ?number*/,includePlans/*: boolean*/){return{type:UPDATE_REPORT_FILTER,supplierId:supplierId,includePlans:includePlans};};var setNoteRow=exports.setNoteRow=function setNoteRow(row){var isExtra=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return{type:SET_NOTE_ROW,row:row,isExtra:isExtra};};var orderRowUpdateRequest=function orderRowUpdateRequest(){return{type:ORDER_ROW_UPDATE_REQUEST};};var orderRowUpdateSuccess=function orderRowUpdateSuccess(rows){return{type:ORDER_ROW_UPDATE_SUCCESS,rows:rows};};var orderRowUpdateFailure=function orderRowUpdateFailure(error){return{type:ORDER_ROW_UPDATE_FAILURE,error:error};};var orderDataRequest=function orderDataRequest(){return{type:GET_REQUEST};};var orderDataSuccess=function orderDataSuccess(order,rooms){return{type:GET_SUCCESS,order:order,rooms:rooms};};var orderDataFailure=function orderDataFailure(error){return{type:GET_FAILURE,error:error};};var orderUpdateRequest=function orderUpdateRequest(){return{type:UPDATE_REQUEST};};var orderUpdateSuccess=function orderUpdateSuccess(order){return{type:UPDATE_SUCCESS,order:order};};var orderUpdateFailure=function orderUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var additionalRowUpdateRequest=function additionalRowUpdateRequest(){return{type:ADDITIONAL_ROW_UPDATE_REQUEST};};var additionalRowUpdateSuccess=function additionalRowUpdateSuccess(row){return{type:ADDITIONAL_ROW_UPDATE_SUCCESS,row:row};};var additionalRowUpdateFailure=function additionalRowUpdateFailure(error){return{type:ADDITIONAL_ROW_UPDATE_FAILURE,error:error};};var additionalRowCreateRequest=function additionalRowCreateRequest(){return{type:ADDITIONAL_ROW_CREATE_REQUEST};};var additionalRowCreateSuccess=function additionalRowCreateSuccess(orderId,row){return{type:ADDITIONAL_ROW_CREATE_SUCCESS,orderId:orderId,row:row};};var additionalRowCreateFailure=function additionalRowCreateFailure(error){return{type:ADDITIONAL_ROW_CREATE_FAILURE,error:error};};var additionalRowRemoveRequest=function additionalRowRemoveRequest(){return{type:ADDITIONAL_ROW_REMOVE_REQUEST};};var additionalRowRemoveSuccess=function additionalRowRemoveSuccess(id){return{type:ADDITIONAL_ROW_REMOVE_SUCCESS,id:id};};var additionalRowRemoveFailure=function additionalRowRemoveFailure(error){return{type:ADDITIONAL_ROW_REMOVE_FAILURE,error:error};};var linkedAdditionalRowUpdateRequest=function linkedAdditionalRowUpdateRequest(){return{type:LINKED_ADDITIONAL_ROW_UPDATE_REQUEST};};var linkedAdditionalRowUpdateSuccess=function linkedAdditionalRowUpdateSuccess(row){return{type:LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS,row:row};};var linkedAdditionalRowUpdateFailure=function linkedAdditionalRowUpdateFailure(error){return{type:LINKED_ADDITIONAL_ROW_UPDATE_FAILURE,error:error};};var linkedAdditionalRowRemoveRequest=function linkedAdditionalRowRemoveRequest(){return{type:LINKED_ADDITIONAL_ROW_REMOVE_REQUEST};};var linkedAdditionalRowRemoveSuccess=function linkedAdditionalRowRemoveSuccess(id){return{type:LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS,id:id};};var linkedAdditionalRowRemoveFailure=function linkedAdditionalRowRemoveFailure(error){return{type:LINKED_ADDITIONAL_ROW_REMOVE_FAILURE,error:error};};var extraRowUpdateRequest=function extraRowUpdateRequest(){return{type:EXTRA_ROW_UPDATE_REQUEST};};var extraRowUpdateSuccess=function extraRowUpdateSuccess(row){return{type:EXTRA_ROW_UPDATE_SUCCESS,row:row};};var extraRowUpdateFailure=function extraRowUpdateFailure(error){return{type:EXTRA_ROW_UPDATE_FAILURE,error:error};};var productsRequest=function productsRequest(){return{type:PRODUCTS_REQUEST};};var productsSuccess=function productsSuccess(products){return{type:PRODUCTS_SUCCESS,products:products};};var productsFailure=function productsFailure(error){return{type:PRODUCTS_FAILURE,error:error};};var variantsRequest=function variantsRequest(){return{type:VARIANTS_REQUEST};};var variantsSuccess=function variantsSuccess(variants){return{type:VARIANTS_SUCCESS,variants:variants};};var variantsFailure=function variantsFailure(error){return{type:VARIANTS_FAILURE,error:error};};var setLinkedAdditionalRow=exports.setLinkedAdditionalRow=function setLinkedAdditionalRow(row){return{type:SET_ACTIVE_LINKED_ADDITIONAL_ROW,row:row};};var setAdditionalProductRow=exports.setAdditionalProductRow=function setAdditionalProductRow(row){return{type:SET_ACTIVE_ADDITIONAL_ROW,row:row};};var clear=exports.clear=function clear(){return{type:CLEAR};};var fetchOrderData=exports.fetchOrderData=function fetchOrderData(id){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var order,apartmentConfig;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(orderDataRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/orders/'+id},dispatch);case 4:order=_context.sent;_context.next=7;return(0,_request.GET)({endpoint:'/orders/'+id+'/rows'},dispatch);case 7:order.rows=_context.sent;_context.next=10;return(0,_request.GET)({endpoint:'/orders/'+id+'/additionalrows'},dispatch);case 10:order.additionalRows=_context.sent;_context.next=13;return(0,_request.GET)({endpoint:'/orders/'+id+'/linkedadditionalrows'},dispatch);case 13:order.linkedAdditionalRows=_context.sent;_context.next=16;return(0,_request.GET)({endpoint:'/orders/'+id+'/customrows'},dispatch);case 16:order.customRows=_context.sent;_context.next=19;return(0,_request.GET)({endpoint:'/orders/'+id+'/extrarows'},dispatch);case 19:order.extraRows=_context.sent;_context.next=22;return(0,_request.GET)({endpoint:'/apartmentconfigs/'+order.apartment.apartmentConfigId},dispatch);case 22:apartmentConfig=_context.sent;dispatch(orderDataSuccess(order,apartmentConfig.rooms));_context.next=29;break;case 26:_context.prev=26;_context.t0=_context['catch'](1);dispatch(orderDataFailure(_context.t0));case 29:case'end':return _context.stop();}}},_callee,undefined,[[1,26]]);}));return function(_x2){return _ref.apply(this,arguments);};}();};var updateOrder=exports.updateOrder=function updateOrder(id,body){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var order;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(orderUpdateRequest());_context2.prev=1;_context2.next=4;return(0,_request.PUT)({endpoint:'/orders/'+id,body:body},dispatch);case 4:order=_context2.sent;dispatch(orderUpdateSuccess(order));dispatch((0,_notification.addNotification)('Beställning uppdaterad','success'));_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);dispatch(orderUpdateFailure(_context2.t0));case 12:case'end':return _context2.stop();}}},_callee2,undefined,[[1,9]]);}));return function(_x3){return _ref2.apply(this,arguments);};}();};var fetchProducts=exports.fetchProducts=function fetchProducts(){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var products,additionalProducts;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(productsRequest());_context3.prev=1;_context3.next=4;return(0,_request.GET)({endpoint:'/products'},dispatch);case 4:products=_context3.sent;additionalProducts=(0,_filter3.default)({assortment:_assortments.ADDITIONAL},products);dispatch(productsSuccess(additionalProducts));_context3.next=12;break;case 9:_context3.prev=9;_context3.t0=_context3['catch'](1);dispatch(productsFailure(_context3.t0));case 12:case'end':return _context3.stop();}}},_callee3,undefined,[[1,9]]);}));return function(_x4){return _ref3.apply(this,arguments);};}();};var fetchVariants=exports.fetchVariants=function fetchVariants(id){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch){var variants;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(variantsRequest());_context4.prev=1;_context4.next=4;return(0,_request.GET)({endpoint:'/products/'+id+'/variants'},dispatch);case 4:variants=_context4.sent;dispatch(variantsSuccess(variants));_context4.next=11;break;case 8:_context4.prev=8;_context4.t0=_context4['catch'](1);dispatch(variantsFailure(_context4.t0));case 11:case'end':return _context4.stop();}}},_callee4,undefined,[[1,8]]);}));return function(_x5){return _ref4.apply(this,arguments);};}();};var createAdditionalRow=exports.createAdditionalRow=function createAdditionalRow(orderId,body){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch){var row;return _regenerator2.default.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(additionalRowCreateRequest());_context5.prev=1;_context5.next=4;return(0,_request.POST)({endpoint:'/orders/'+orderId+'/additionalrows',body:body},dispatch);case 4:row=_context5.sent;dispatch(additionalRowCreateSuccess(orderId,row));dispatch((0,_notification.addNotification)('Tilläggsprodukt tillagd','success'));_context5.next=12;break;case 9:_context5.prev=9;_context5.t0=_context5['catch'](1);dispatch(additionalRowCreateFailure(_context5.t0));case 12:case'end':return _context5.stop();}}},_callee5,undefined,[[1,9]]);}));return function(_x6){return _ref5.apply(this,arguments);};}();};var updateAdditionalRow=exports.updateAdditionalRow=function updateAdditionalRow(id,body){return function(){var _ref6=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch){var row;return _regenerator2.default.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch(additionalRowUpdateRequest());_context6.prev=1;_context6.next=4;return(0,_request.PUT)({endpoint:'/additionalorderrows/'+id,body:body},dispatch);case 4:row=_context6.sent;dispatch(additionalRowUpdateSuccess(row));dispatch((0,_notification.addNotification)('Tilläggsprodukt uppdaterad','success'));_context6.next=12;break;case 9:_context6.prev=9;_context6.t0=_context6['catch'](1);dispatch(additionalRowUpdateFailure(_context6.t0));case 12:case'end':return _context6.stop();}}},_callee6,undefined,[[1,9]]);}));return function(_x7){return _ref6.apply(this,arguments);};}();};var removeAdditionalRow=exports.removeAdditionalRow=function removeAdditionalRow(rowId){return function(){var _ref7=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch){return _regenerator2.default.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch(additionalRowRemoveRequest());_context7.prev=1;_context7.next=4;return(0,_request.DELETE)({endpoint:'/additionalorderrows/'+rowId},dispatch);case 4:dispatch(additionalRowRemoveSuccess(rowId));dispatch((0,_notification.addNotification)('Tilläggsprodukt borttagen','success'));_context7.next=11;break;case 8:_context7.prev=8;_context7.t0=_context7['catch'](1);dispatch(additionalRowRemoveFailure(_context7.t0));case 11:case'end':return _context7.stop();}}},_callee7,undefined,[[1,8]]);}));return function(_x8){return _ref7.apply(this,arguments);};}();};var updateLinkedAdditionalRow=exports.updateLinkedAdditionalRow=function updateLinkedAdditionalRow(id,body){return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch){var row;return _regenerator2.default.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch(linkedAdditionalRowUpdateRequest());_context8.prev=1;_context8.next=4;return(0,_request.PUT)({endpoint:'/linkedadditionalrows/'+id,body:body},dispatch);case 4:row=_context8.sent;dispatch(linkedAdditionalRowUpdateSuccess(row));dispatch((0,_notification.addNotification)('Tilläggsprodukt uppdaterad','success'));_context8.next=12;break;case 9:_context8.prev=9;_context8.t0=_context8['catch'](1);dispatch(linkedAdditionalRowUpdateFailure(_context8.t0));case 12:case'end':return _context8.stop();}}},_callee8,undefined,[[1,9]]);}));return function(_x9){return _ref8.apply(this,arguments);};}();};var removeLinkedAdditionalRow=exports.removeLinkedAdditionalRow=function removeLinkedAdditionalRow(rowId){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch){return _regenerator2.default.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch(linkedAdditionalRowRemoveRequest());_context9.prev=1;_context9.next=4;return(0,_request.DELETE)({endpoint:'/linkedadditionalrows/'+rowId},dispatch);case 4:dispatch(linkedAdditionalRowRemoveSuccess(rowId));dispatch((0,_notification.addNotification)('Tilläggsprodukt borttagen','success'));_context9.next=11;break;case 8:_context9.prev=8;_context9.t0=_context9['catch'](1);dispatch(linkedAdditionalRowRemoveFailure(_context9.t0));case 11:case'end':return _context9.stop();}}},_callee9,undefined,[[1,8]]);}));return function(_x10){return _ref9.apply(this,arguments);};}();};var updateOrderRow=exports.updateOrderRow=function updateOrderRow(id,body){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee10(dispatch){var rows;return _regenerator2.default.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:dispatch(orderRowUpdateRequest());_context10.prev=1;_context10.next=4;return(0,_request.PUT)({endpoint:'/orderrows/'+id,body:body},dispatch);case 4:rows=_context10.sent;dispatch(orderRowUpdateSuccess(rows));dispatch((0,_notification.addNotification)('Anteckning uppdaterad','success'));_context10.next=12;break;case 9:_context10.prev=9;_context10.t0=_context10['catch'](1);dispatch(orderRowUpdateFailure(_context10.t0));case 12:case'end':return _context10.stop();}}},_callee10,undefined,[[1,9]]);}));return function(_x11){return _ref10.apply(this,arguments);};}();};var updateExtraRow=exports.updateExtraRow=function updateExtraRow(id,body){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee11(dispatch){var row;return _regenerator2.default.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:dispatch(extraRowUpdateRequest());_context11.prev=1;_context11.next=4;return(0,_request.PUT)({endpoint:'/extraorderrows/'+id,body:body},dispatch);case 4:row=_context11.sent;dispatch(extraRowUpdateSuccess(row));dispatch((0,_notification.addNotification)('Anteckning uppdaterad','success'));_context11.next=12;break;case 9:_context11.prev=9;_context11.t0=_context11['catch'](1);dispatch(extraRowUpdateFailure(_context11.t0));case 12:case'end':return _context11.stop();}}},_callee11,undefined,[[1,9]]);}));return function(_x12){return _ref11.apply(this,arguments);};}();};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.fetchConfigTemplates=exports.filterConfigTemplates=exports.SORT=exports.FILTER=exports.FAILURE=exports.SUCCESS=exports.REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var REQUEST=exports.REQUEST='@configTemplateList/REQUEST';var SUCCESS=exports.SUCCESS='@configTemplateList/SUCCESS';var FAILURE=exports.FAILURE='@configTemplateList/FAILURE';var FILTER=exports.FILTER='@configTemplateList/FILTER';var SORT=exports.SORT='@configTemplateList/SORT';var configTemplatesRequest=function configTemplatesRequest(){return{type:REQUEST};};var configTemplatesSuccess=function configTemplatesSuccess(configTemplates){return{type:SUCCESS,configTemplates:configTemplates};};var configTemplatesFailure=function configTemplatesFailure(error){return{type:FAILURE,error:error};};var filterConfigTemplates=exports.filterConfigTemplates=function filterConfigTemplates(query,archived){return{type:FILTER,archived:archived,query:query};};var fetchConfigTemplates=exports.fetchConfigTemplates=function fetchConfigTemplates(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var configTemplates;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(configTemplatesRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/configtemplates'},dispatch);case 4:configTemplates=_context.sent;dispatch(configTemplatesSuccess(configTemplates));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(configTemplatesFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.createSupplier=exports.updateSupplier=exports.fetchSupplier=exports.clearSupplier=exports.reset=exports.CLEAR=exports.RESET=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);var _notification=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}//  weak
var GET_REQUEST=exports.GET_REQUEST='@supplierView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@supplierView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@supplierView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@supplierView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@supplierView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@supplierView/UPDATE_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@supplierView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@supplierView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@supplierView/CREATE_FAILURE';var RESET=exports.RESET='@supplierView/RESET';var CLEAR=exports.CLEAR='@supplierView/CLEAR';var supplierRequest=function supplierRequest(){return{type:GET_REQUEST};};var supplierSuccess=function supplierSuccess(supplier){return{type:GET_SUCCESS,supplier:supplier};};var supplierFailure=function supplierFailure(error){return{type:GET_FAILURE,error:error};};var supplierUpdateRequest=function supplierUpdateRequest(){return{type:UPDATE_REQUEST};};var supplierUpdateSuccess=function supplierUpdateSuccess(supplier){return _defineProperty({type:UPDATE_SUCCESS,supplier:supplier},_notification.ADD,{message:'Leverantör uppdaterad'});};var supplierUpdateFailure=function supplierUpdateFailure(error){return{type:UPDATE_FAILURE,error:error};};var supplierCreateRequest=function supplierCreateRequest(){return{type:CREATE_REQUEST};};var supplierCreateSuccess=function supplierCreateSuccess(supplier){return _defineProperty({type:CREATE_SUCCESS,supplier:supplier},_notification.ADD,{message:'Leverant\xF6r "'+supplier.name+'" skapad'});};var supplierCreateFailure=function supplierCreateFailure(error){return{type:CREATE_FAILURE,error:error};};var reset=exports.reset=function reset(){return{type:RESET};};var clearSupplier=exports.clearSupplier=function clearSupplier(){return{type:CLEAR};};var fetchSupplier=exports.fetchSupplier=function fetchSupplier(id){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var supplier;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(supplierRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/suppliers/'+id},dispatch);case 4:supplier=_context.sent;dispatch(supplierSuccess(supplier));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(supplierFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref3.apply(this,arguments);};}();};var updateSupplier=exports.updateSupplier=function updateSupplier(id,body){return function(){var _ref4=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var supplier;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(supplierUpdateRequest());_context2.prev=1;_context2.next=4;return(0,_request.PUT)({endpoint:'/suppliers/'+id,body:body},dispatch);case 4:supplier=_context2.sent;dispatch(supplierUpdateSuccess(supplier));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(supplierUpdateFailure(_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x2){return _ref4.apply(this,arguments);};}();};var createSupplier=exports.createSupplier=function createSupplier(body){return function(){var _ref5=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch){var supplier;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(supplierCreateRequest());_context3.prev=1;_context3.next=4;return(0,_request.POST)({endpoint:'/suppliers',body:body},dispatch);case 4:supplier=_context3.sent;dispatch(supplierCreateSuccess(supplier));_context3.next=11;break;case 8:_context3.prev=8;_context3.t0=_context3['catch'](1);dispatch(supplierCreateFailure(_context3.t0));case 11:case'end':return _context3.stop();}}},_callee3,undefined,[[1,8]]);}));return function(_x3){return _ref5.apply(this,arguments);};}();};

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.filterSuppliers=exports.fetchSuppliers=exports.SORT=exports.FILTER=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var GET_REQUEST=exports.GET_REQUEST='@supplierList/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@supplierList/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@supplierList/GET_FAILURE';var FILTER=exports.FILTER='@supplierList/FILTER';var SORT=exports.SORT='@supplierList/SORT';var suppliersRequest=function suppliersRequest(){return{type:GET_REQUEST};};var suppliersSuccess=function suppliersSuccess(suppliers){return{type:GET_SUCCESS,suppliers:suppliers};};var suppliersFailure=function suppliersFailure(error){return{type:GET_FAILURE,error:error};};var fetchSuppliers=exports.fetchSuppliers=function fetchSuppliers(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var suppliers;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(suppliersRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/suppliers'},dispatch);case 4:suppliers=_context.sent;dispatch(suppliersSuccess(suppliers));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(suppliersFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var filterSuppliers=exports.filterSuppliers=function filterSuppliers(query,archived){return{type:FILTER,archived:archived,query:query};};var sortItems=exports.sortItems=function sortItems(sorter){return{type:SORT,sorter:sorter};};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var TOGGLE_DIALOG=exports.TOGGLE_DIALOG='@actionConfirmation/TOGGLE_DIALOG';var toggleDialog=exports.toggleDialog=function toggleDialog(id/*: string*/,show/*: bool*/){return{type:TOGGLE_DIALOG,id:id,show:show};};

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.activate=exports.fetchUser=exports.ACTIVATION_FAILURE=exports.ACTIVATION_SUCCESS=exports.ACTIVATION_REQUEST=exports.GET_USER_FAILURE=exports.GET_USER_SUCCESS=exports.GET_USER_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);var _auth=__webpack_require__(57);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var GET_USER_REQUEST=exports.GET_USER_REQUEST='@activationView/GET_USER_REQUEST';var GET_USER_SUCCESS=exports.GET_USER_SUCCESS='@activationView/GET_USER_SUCCESS';var GET_USER_FAILURE=exports.GET_USER_FAILURE='@activationView/GET_USER_FAILURE';var ACTIVATION_REQUEST=exports.ACTIVATION_REQUEST='@activationView/ACTIVATION_REQUEST';var ACTIVATION_SUCCESS=exports.ACTIVATION_SUCCESS='@activationView/ACTIVATION_SUCCESS';var ACTIVATION_FAILURE=exports.ACTIVATION_FAILURE='@activationView/ACTIVATION_FAILURE';var activationRequest=function activationRequest(){return{type:ACTIVATION_REQUEST};};var activationSuccess=function activationSuccess(user){return{type:ACTIVATION_SUCCESS,user:user};};var activationFailure=function activationFailure(error){return{type:ACTIVATION_FAILURE,error:error};};var userRequest=function userRequest(){return{type:GET_USER_REQUEST};};var userSuccess=function userSuccess(user){return{type:GET_USER_SUCCESS,user:user};};var userFailure=function userFailure(error){return{type:GET_USER_FAILURE,error:error};};var fetchUser=exports.fetchUser=function fetchUser(token){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var user;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(userRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/activate/'+token},dispatch);case 4:user=_context.sent;dispatch(userSuccess(user));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(userFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var activate=exports.activate=function activate(token,data){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var user;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(activationRequest());_context2.prev=1;_context2.next=4;return(0,_request.POST)({endpoint:'/activate/'+token,body:data},dispatch);case 4:user=_context2.sent;dispatch(activationSuccess(user));dispatch((0,_auth.login)(user.username,data.password));_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](1);dispatch(activationFailure(_context2.t0.message));case 12:case'end':return _context2.stop();}}},_callee2,undefined,[[1,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchFilters=exports.fetchData=exports.requestError=exports.requestSuccess=exports.request=exports.SET_FILTER=exports.FETCH_DATA_FAILURE=exports.FETCH_DATA_SUCCESS=exports.FETCH_DATA_REQUEST=exports.GET_FILTERS_FAILURE=exports.GET_FILTERS_SUCCESS=exports.GET_FILTERS_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _join2=__webpack_require__(241);var _join3=_interopRequireDefault(_join2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var GET_FILTERS_REQUEST=exports.GET_FILTERS_REQUEST='@exports/GET_FILTERS_REQUEST';var GET_FILTERS_SUCCESS=exports.GET_FILTERS_SUCCESS='@exports/GET_FILTERS_SUCCESS';var GET_FILTERS_FAILURE=exports.GET_FILTERS_FAILURE='@exports/GET_FILTERS_FAILURE';var FETCH_DATA_REQUEST=exports.FETCH_DATA_REQUEST='@exports/FETCH_DATA_REQUEST';var FETCH_DATA_SUCCESS=exports.FETCH_DATA_SUCCESS='@exports/FETCH_DATA_SUCCESS';var FETCH_DATA_FAILURE=exports.FETCH_DATA_FAILURE='@exports/FETCH_DATA_FAILURE';var SET_FILTER=exports.SET_FILTER='@exports/SET_FILTER';var request=exports.request=function request(type){return{type:type};};var requestSuccess=exports.requestSuccess=function requestSuccess(type){var data=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;return{type:type,data:data};};var requestError=exports.requestError=function requestError(type,error){return{type:type,error:error};};var buildQueryString=function buildQueryString(currentSelection){var projects=currentSelection.projects,suppliers=currentSelection.suppliers,productTypes=currentSelection.productTypes,workerTypes=currentSelection.workerTypes,roomTypes=currentSelection.roomTypes,assortments=currentSelection.assortments;var flatten=function flatten(items){return Array.isArray(items)?(0,_join3.default)(',',(0,_map3.default)('id',items)):null;};var query='projects='+flatten(projects)+('&suppliers='+flatten(suppliers))+('&productTypes='+flatten(productTypes))+('&workerTypes='+flatten(workerTypes))+('&roomTypes='+flatten(roomTypes));if(assortments){query=query+'&assortments='+flatten(assortments);}return query;};var fetchData=exports.fetchData=function fetchData(currentSelection){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var query,data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(request(FETCH_DATA_REQUEST));_context.prev=1;query=buildQueryString(currentSelection);_context.next=5;return(0,_request.GET)({endpoint:'/dataexports/?'+query},dispatch);case 5:data=_context.sent;dispatch(requestSuccess(FETCH_DATA_SUCCESS,_extends({},currentSelection,{rows:data,downloadUri:_request.apiBase+'/dataexports/download/?'+query})));_context.next=12;break;case 9:_context.prev=9;_context.t0=_context['catch'](1);dispatch(requestError(FETCH_DATA_FAILURE,_context.t0));case 12:case'end':return _context.stop();}}},_callee,undefined,[[1,9]]);}));return function(_x2){return _ref.apply(this,arguments);};}();};var fetchFilters=exports.fetchFilters=function fetchFilters(){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch){var filters;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:dispatch(request(GET_FILTERS_REQUEST));_context2.prev=1;_context2.next=4;return(0,_request.GET)({endpoint:'/dataexports/filters'},dispatch);case 4:filters=_context2.sent;dispatch(requestSuccess(GET_FILTERS_SUCCESS,filters));_context2.next=11;break;case 8:_context2.prev=8;_context2.t0=_context2['catch'](1);dispatch(requestError(GET_FILTERS_FAILURE,_context2.t0));case 11:case'end':return _context2.stop();}}},_callee2,undefined,[[1,8]]);}));return function(_x3){return _ref2.apply(this,arguments);};}();};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchProjects=exports.filter=exports.projectsError=exports.projectsSuccess=exports.projectsRequest=exports.FILTER=exports.PROJECTS_FAILURE=exports.PROJECTS_SUCCESS=exports.PROJECTS_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
var PROJECTS_REQUEST=exports.PROJECTS_REQUEST='@sales/PROJECTS_REQUEST';var PROJECTS_SUCCESS=exports.PROJECTS_SUCCESS='@sales/PROJECTS_SUCCESS';var PROJECTS_FAILURE=exports.PROJECTS_FAILURE='@sales/PROJECTS_FAILURE';var FILTER=exports.FILTER='@sales/FILTER';var projectsRequest=exports.projectsRequest=function projectsRequest(){return{type:PROJECTS_REQUEST};};var projectsSuccess=exports.projectsSuccess=function projectsSuccess(projects){return{type:PROJECTS_SUCCESS,projects:projects};};var projectsError=exports.projectsError=function projectsError(error){return{type:PROJECTS_FAILURE,error:error};};var filter=exports.filter=function filter(projectId){return{type:FILTER,projectId:projectId};};var fetchProjects=exports.fetchProjects=function fetchProjects(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch){var projects;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(projectsRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/dataexports/projects'},dispatch);case 4:projects=_context.sent;dispatch(projectsSuccess((0,_sortBy3.default)('id',projects)));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(projectsError(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchData=exports.applyFilter=exports.dataError=exports.dataSuccess=exports.dataRequest=exports.FILTER=exports.DATA_FAILURE=exports.DATA_SUCCESS=exports.DATA_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/*:: import type {
  ErrorDto,
} from '../dtos';*/var DATA_REQUEST=exports.DATA_REQUEST='@purchaseReportView/DATA_REQUEST';var DATA_SUCCESS=exports.DATA_SUCCESS='@purchaseReportView/DATA_SUCCESS';var DATA_FAILURE=exports.DATA_FAILURE='@purchaseReportView/DATA_FAILURE';var FILTER=exports.FILTER='@purchaseReportView/FILTER';/*:: type PurchaseReportDataRequestAction = {
  type: '@purchaseReportView/DATA_REQUEST'
};*//*:: export type Entity = {
  id: number,
  name: string
};*//*:: export type Apartment = {
  id: number,
  objectId: string,
};*//*:: export type Project = Entity & {
  apartments: Apartment[]
};*//*:: export type Data = {
  projects: Project[],
  suppliers: Entity[]
};*//*:: type PurchaseReportDataSuccessAction = {
  type: '@purchaseReportView/DATA_SUCCESS',
  data: Data
};*//*:: type PurchaseReportDataFailureAction = {
  type: '@purchaseReportView/DATA_FAILURE',
  error: ErrorDto
};*//*:: type PurchaseReportFilterAction = {
  type: '@purchaseReportView/FILTER',
  apartmentIds: number[],
  projectId: ?number,
  supplierId: ?number,
  includePlans: boolean,
  linebreakPerApartment: boolean,
};*//*:: export type PurchaseReportAction
  = PurchaseReportDataRequestAction
  | PurchaseReportDataSuccessAction
  | PurchaseReportDataFailureAction
  | PurchaseReportFilterAction;*/var dataRequest=exports.dataRequest=function dataRequest()/*: PurchaseReportDataRequestAction*/{return{type:DATA_REQUEST};};var dataSuccess=exports.dataSuccess=function dataSuccess(data/*: Data*/)/*: PurchaseReportDataSuccessAction*/{return{type:DATA_SUCCESS,data:data};};var dataError=exports.dataError=function dataError(error/*: ErrorDto*/)/*: PurchaseReportDataFailureAction*/{return{type:DATA_FAILURE,error:error};};var applyFilter=exports.applyFilter=function applyFilter(apartmentIds/*: number[]*/,projectId/*: ?number*/,supplierId/*: ?number*/,includePlans/*: boolean*/,linebreakPerApartment/*: boolean*/)/*: PurchaseReportFilterAction*/{return{type:FILTER,apartmentIds:apartmentIds,projectId:projectId,supplierId:supplierId,includePlans:includePlans,linebreakPerApartment:linebreakPerApartment};};var fetchData=exports.fetchData=function fetchData(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch/*: PurchaseReportAction => void*/){var _data;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(dataRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/dataexports/purchasereport'},dispatch);case 4:_data=_context.sent;dispatch(dataSuccess(_data));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(dataError(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.fetchData=exports.applyFilter=exports.dataError=exports.dataSuccess=exports.dataRequest=exports.FILTER=exports.DATA_FAILURE=exports.DATA_SUCCESS=exports.DATA_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/*:: import type {Project} from './purchaseReportView';*//*:: import type {
  ErrorDto,
} from '../dtos';*//*:: import type {Exact} from '../reducers/configTemplateView';*/var DATA_REQUEST=exports.DATA_REQUEST='@siteManagerReport/DATA_REQUEST';var DATA_SUCCESS=exports.DATA_SUCCESS='@siteManagerReport/DATA_SUCCESS';var DATA_FAILURE=exports.DATA_FAILURE='@siteManagerReport/DATA_FAILURE';var FILTER=exports.FILTER='@siteManagerReport/FILTER';/*:: type SiteManagerDataRequestAction = {
  type: '@siteManagerReport/DATA_REQUEST'
};*//*:: type SiteManagerDataSuccessAction = {
  type: '@siteManagerReport/DATA_SUCCESS',
  projects: Project[]
};*//*:: type SiteManagerDataFailureAction = {
  type: '@siteManagerReport/DATA_FAILURE',
  error: ErrorDto
};*//*:: type SiteManagerFilterAction = {
  type: '@siteManagerReport/FILTER',
  apartmentIds: number[],
  projectId: ?number,
  includePlans: boolean,
};*//*:: export type SiteManagerReportAction
  = SiteManagerDataRequestAction
  | SiteManagerDataSuccessAction
  | SiteManagerDataFailureAction
  | SiteManagerFilterAction;*/var dataRequest=exports.dataRequest=function dataRequest()/*: Exact<SiteManagerDataRequestAction>*/{return{type:DATA_REQUEST};};var dataSuccess=exports.dataSuccess=function dataSuccess(projects/*: Project[]*/)/*: Exact<SiteManagerDataSuccessAction>*/{return{type:DATA_SUCCESS,projects:projects};};var dataError=exports.dataError=function dataError(error/*: ErrorDto*/)/*: Exact<SiteManagerDataFailureAction>*/{return{type:DATA_FAILURE,error:error};};var applyFilter=exports.applyFilter=function applyFilter(apartmentIds/*: number[]*/,projectId/*: ?number*/,includePlans/*: boolean*/)/*: Exact<SiteManagerFilterAction>*/{return{type:FILTER,apartmentIds:apartmentIds,projectId:projectId,includePlans:includePlans};};var fetchData=exports.fetchData=function fetchData(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch/*: Dispatch<SiteManagerReportAction>*/){var _projects;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(dataRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/dataexports/sitemanagerreport'},dispatch);case 4:_projects=_context.sent;dispatch(dataSuccess(_projects));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(dataError(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.sortItems=exports.fetchRoomTemplates=exports.filterRoomTemplates=exports.SORT=exports.FILTER=exports.FAILURE=exports.SUCCESS=exports.REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//  weak
/*:: import type {Dispatch} from 'redux';*//*:: import type {Exact} from '../reducers/configTemplateView';*//*:: import type {OptionalNavigationAction} from './notification';*//*:: import type {
  RoomTemplateDto,
  ErrorDto,
} from '../dtos';*/var REQUEST=exports.REQUEST='@roomTemplateList/REQUEST';var SUCCESS=exports.SUCCESS='@roomTemplateList/SUCCESS';var FAILURE=exports.FAILURE='@roomTemplateList/FAILURE';var FILTER=exports.FILTER='@roomTemplateList/FILTER';var SORT=exports.SORT='@roomTemplateList/SORT';/*:: export type RoomTemplateListRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateList/REQUEST',
};*//*:: export type RoomTemplateListSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateList/SUCCESS',
  roomTemplates: RoomTemplateDto[],
};*//*:: export type RoomTemplateListFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateList/FAILURE',
  error: ErrorDto,
};*//*:: export type RoomTemplateListFilterAction = OptionalNavigationAction & {
  type: '@roomTemplateList/FILTER',
  archived: boolean,
  query: ?string
};*//*:: export type RoomTemplateListSortAction = OptionalNavigationAction & {
  type: '@roomTemplateList/SORT',
  sorter: Function,
};*//*:: export type RoomTemplateListAction
  = RoomTemplateListRequestAction
  | RoomTemplateListSuccessAction
  | RoomTemplateListFailureAction
  | RoomTemplateListFilterAction
  | RoomTemplateListSortAction*/var roomTemplatesRequest=function roomTemplatesRequest()/*: Exact<RoomTemplateListRequestAction>*/{return{type:REQUEST};};var roomTemplatesSuccess=function roomTemplatesSuccess(roomTemplates/*: RoomTemplateDto[]*/)/*: Exact<RoomTemplateListSuccessAction>*/{return{type:SUCCESS,roomTemplates:roomTemplates};};var roomTemplatesFailure=function roomTemplatesFailure(error/*: ErrorDto*/)/*: Exact<RoomTemplateListFailureAction>*/{return{type:FAILURE,error:error};};var filterRoomTemplates=exports.filterRoomTemplates=function filterRoomTemplates(query/*: ?string*/,archived/*: boolean*/)/*: Exact<RoomTemplateListFilterAction>*/{return{type:FILTER,archived:archived,query:query};};var fetchRoomTemplates=exports.fetchRoomTemplates=function fetchRoomTemplates(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch/*: Dispatch<RoomTemplateListAction>*/){var _roomTemplates;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(roomTemplatesRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/roomtemplates'},dispatch);case 4:_roomTemplates=_context.sent;dispatch(roomTemplatesSuccess(_roomTemplates));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(roomTemplatesFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var sortItems=exports.sortItems=function sortItems(sorter/*: Function*/)/*: Exact<RoomTemplateListSortAction>*/{return{type:SORT,sorter:sorter};};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.updateProductSlots=exports.updateProductSlot=exports.createProductSlot=exports.createRoomTemplate=exports.updateRoomTemplate=exports.fetchData=exports.selectProductSlot=exports.reset=exports.clear=exports.closeDialog=exports.openDialog=exports.toggleVariant=exports.clearStandardProduct=exports.setStandardProduct=exports.updateRelatedVariant=exports.navigateToVariant=exports.popDialogNavigation=exports.toggleProduct=exports.checkAllVariants=exports.checkProduct=exports.updateVariantsForType=exports.updateVariants=exports.UPDATE_VARIANTS_FOR_TYPE=exports.PRODUCT_SLOTS_UPDATE_SUCCESS=exports.PRODUCT_SLOTS_UPDATE_FAILURE=exports.PRODUCT_SLOTS_UPDATE_REQUEST=exports.UPDATE_VARIANTS=exports.CHECK_PRODUCT=exports.CLEAR_STANDARD_PRODUCT=exports.CHECK_ALL_VARIANTS=exports.TOGGLE_PRODUCT=exports.SET_STANDARD_PRODUCT=exports.TOGGLE_VARIANT_SUCCESS=exports.TOGGLE_VARIANT_FAILURE=exports.TOGGLE_VARIANT_REQUEST=exports.UPDATE_RELATED_VARIANT=exports.NAVIGATE_TO_VARIANT_SUCCESS=exports.NAVIGATE_TO_VARIANT_FAILURE=exports.NAVIGATE_TO_VARIANT_REQUEST=exports.POP_DIALOG_NAVIGATION=exports.CLOSE_DIALOG=exports.OPEN_DIALOG_SUCCESS=exports.OPEN_DIALOG_FAILURE=exports.OPEN_DIALOG_REQUEST=exports.CLEAR=exports.RESET=exports.SELECT_PRODUCT_SLOT=exports.PRODUCT_SLOT_CREATE_FAILURE=exports.PRODUCT_SLOT_CREATE_SUCCESS=exports.PRODUCT_SLOT_CREATE_REQUEST=exports.PRODUCT_SLOT_UPDATE_FAILURE=exports.PRODUCT_SLOT_UPDATE_SUCCESS=exports.PRODUCT_SLOT_UPDATE_REQUEST=exports.CREATE_FAILURE=exports.CREATE_SUCCESS=exports.CREATE_REQUEST=exports.UPDATE_FAILURE=exports.UPDATE_SUCCESS=exports.UPDATE_REQUEST=exports.GET_FAILURE=exports.GET_SUCCESS=exports.GET_REQUEST=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _request=__webpack_require__(6);var _notification=__webpack_require__(23);var _assortments=__webpack_require__(55);var _apartmentConfigView=__webpack_require__(82);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/*:: import type {Dispatch} from 'redux';*//*:: import type {Exact} from '../reducers/configTemplateView';*//*:: import type {OptionalNavigationAction} from './notification';*//*:: import type {
  RoomTemplateDto,
  ErrorDto,
  ProductDto,
  ProductSlotDto,
  ProductTypeDto,
  RoomTypeDto,
  VariantDto,
  LimitedProjectDto,
} from '../dtos';*/var GET_REQUEST=exports.GET_REQUEST='@roomTemplateView/GET_REQUEST';var GET_SUCCESS=exports.GET_SUCCESS='@roomTemplateView/GET_SUCCESS';var GET_FAILURE=exports.GET_FAILURE='@roomTemplateView/GET_FAILURE';var UPDATE_REQUEST=exports.UPDATE_REQUEST='@roomTemplateView/UPDATE_REQUEST';var UPDATE_SUCCESS=exports.UPDATE_SUCCESS='@roomTemplateView/UPDATE_SUCCESS';var UPDATE_FAILURE=exports.UPDATE_FAILURE='@roomTemplateView/UPDATE_FAILURE';var CREATE_REQUEST=exports.CREATE_REQUEST='@roomTemplateView/CREATE_REQUEST';var CREATE_SUCCESS=exports.CREATE_SUCCESS='@roomTemplateView/CREATE_SUCCESS';var CREATE_FAILURE=exports.CREATE_FAILURE='@roomTemplateView/CREATE_FAILURE';var PRODUCT_SLOT_UPDATE_REQUEST=exports.PRODUCT_SLOT_UPDATE_REQUEST='@roomTemplateView/PRODUCT_SLOT_UPDATE_REQUEST';var PRODUCT_SLOT_UPDATE_SUCCESS=exports.PRODUCT_SLOT_UPDATE_SUCCESS='@roomTemplateView/PRODUCT_SLOT_UPDATE_SUCCESS';var PRODUCT_SLOT_UPDATE_FAILURE=exports.PRODUCT_SLOT_UPDATE_FAILURE='@roomTemplateView/PRODUCT_SLOT_UPDATE_FAILURE';var PRODUCT_SLOT_CREATE_REQUEST=exports.PRODUCT_SLOT_CREATE_REQUEST='@roomTemplateView/PRODUCT_SLOT_CREATE_REQUEST';var PRODUCT_SLOT_CREATE_SUCCESS=exports.PRODUCT_SLOT_CREATE_SUCCESS='@roomTemplateView/PRODUCT_SLOT_CREATE_SUCCESS';var PRODUCT_SLOT_CREATE_FAILURE=exports.PRODUCT_SLOT_CREATE_FAILURE='@roomTemplateView/PRODUCT_SLOT_CREATE_FAILURE';var SELECT_PRODUCT_SLOT=exports.SELECT_PRODUCT_SLOT='@roomTemplateView/SELECT_PRODUCT_SLOT';var RESET=exports.RESET='@roomTemplateView/RESET';var CLEAR=exports.CLEAR='@roomTemplateView/CLEAR';var OPEN_DIALOG_REQUEST=exports.OPEN_DIALOG_REQUEST='@roomTemplateView/OPEN_DIALOG_REQUEST';var OPEN_DIALOG_FAILURE=exports.OPEN_DIALOG_FAILURE='@roomTemplateView/OPEN_DIALOG_FAILURE';var OPEN_DIALOG_SUCCESS=exports.OPEN_DIALOG_SUCCESS='@roomTemplateView/OPEN_DIALOG_SUCCESS';var CLOSE_DIALOG=exports.CLOSE_DIALOG='@roomTemplateView/CLOSE_DIALOG';var POP_DIALOG_NAVIGATION=exports.POP_DIALOG_NAVIGATION='@roomTemplateView/POP_DIALOG_NAVIGATION';var NAVIGATE_TO_VARIANT_REQUEST=exports.NAVIGATE_TO_VARIANT_REQUEST='@roomTemplateView/NAVIGATE_TO_VARIANT_REQUEST';var NAVIGATE_TO_VARIANT_FAILURE=exports.NAVIGATE_TO_VARIANT_FAILURE='@roomTemplateView/NAVIGATE_TO_VARIANT_FAILURE';var NAVIGATE_TO_VARIANT_SUCCESS=exports.NAVIGATE_TO_VARIANT_SUCCESS='@roomTemplateView/NAVIGATE_TO_VARIANT_SUCCESS';var UPDATE_RELATED_VARIANT=exports.UPDATE_RELATED_VARIANT='@roomTemplateView/UPDATE_RELATED_VARIANT';var TOGGLE_VARIANT_REQUEST=exports.TOGGLE_VARIANT_REQUEST='@roomTemplateView/TOGGLE_VARIANT_REQUEST';var TOGGLE_VARIANT_FAILURE=exports.TOGGLE_VARIANT_FAILURE='@roomTemplateView/TOGGLE_VARIANT_FAILURE';var TOGGLE_VARIANT_SUCCESS=exports.TOGGLE_VARIANT_SUCCESS='@roomTemplateView/TOGGLE_VARIANT_SUCCESS';var SET_STANDARD_PRODUCT=exports.SET_STANDARD_PRODUCT='@roomTemplateView/SET_STANDARD_PRODUCT';var TOGGLE_PRODUCT=exports.TOGGLE_PRODUCT='@roomTemplateView/TOGGLE_PRODUCT';var CHECK_ALL_VARIANTS=exports.CHECK_ALL_VARIANTS='@roomTemplateView/CHECK_ALL_VARIANTS';var CLEAR_STANDARD_PRODUCT=exports.CLEAR_STANDARD_PRODUCT='@roomTemplateView/CLEAR_STANDARD_PRODUCT';var CHECK_PRODUCT=exports.CHECK_PRODUCT='@roomTemplateView/CHECK_PRODUCT';var UPDATE_VARIANTS=exports.UPDATE_VARIANTS='@roomTemplateView/UPDATE_VARIANTS';var PRODUCT_SLOTS_UPDATE_REQUEST=exports.PRODUCT_SLOTS_UPDATE_REQUEST='@roomTemplateView/PRODUCT_SLOTS_UPDATE_REQUEST';var PRODUCT_SLOTS_UPDATE_FAILURE=exports.PRODUCT_SLOTS_UPDATE_FAILURE='@roomTemplateView/PRODUCT_SLOTS_UPDATE_FAILURE';var PRODUCT_SLOTS_UPDATE_SUCCESS=exports.PRODUCT_SLOTS_UPDATE_SUCCESS='@roomTemplateView/PRODUCT_SLOTS_UPDATE_SUCCESS';var UPDATE_VARIANTS_FOR_TYPE=exports.UPDATE_VARIANTS_FOR_TYPE='@roomTemplateView/UPDATE_VARIANTS_FOR_TYPE';/*:: export type RoomTemplateViewGetRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/GET_REQUEST',
};*//*:: export type RoomTemplateViewGetSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/GET_SUCCESS',
  roomTemplate: ?RoomTemplateDto,
  roomTypes: RoomTypeDto[],
  products: ProductDto[],
  productTypes: ProductTypeDto[],
  roomTemplates: RoomTemplateDto[],
  projects: LimitedProjectDto[],
};*//*:: export type RoomTemplateViewGetFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/GET_FAILURE',
  error: ErrorDto,
};*//*:: export type RoomTemplateViewUpdateRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_REQUEST',
};*//*:: export type RoomTemplateViewUpdateSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_SUCCESS',
  roomTemplate: RoomTemplateDto,
};*//*:: export type RoomTemplateViewUpdateFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_FAILURE',
  error: ErrorDto,
};*//*:: export type RoomTemplateViewCreateRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CREATE_REQUEST',
};*//*:: export type RoomTemplateViewCreateSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CREATE_SUCCESS',
  roomTemplate: RoomTemplateDto,
};*//*:: export type RoomTemplateViewCreateFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CREATE_FAILURE',
  error: ErrorDto,
};*//*:: export type RoomTemplateViewProductSlotUpdateRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_UPDATE_REQUEST',
};*//*:: export type RoomTemplateViewProductSlotUpdateSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_UPDATE_SUCCESS',
  productSlot: ProductSlotDto,
};*//*:: export type RoomTemplateViewProductSlotUpdateFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_UPDATE_FAILURE',
  error: ErrorDto,
};*//*:: export type RoomTemplateViewProductSlotCreateRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_CREATE_REQUEST',
};*//*:: export type RoomTemplateViewProductSlotCreateSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_CREATE_SUCCESS',
  productSlot: ProductSlotDto,
  roomTemplateId: number,
};*//*:: export type RoomTemplateViewProductSlotCreateFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOT_CREATE_FAILURE',
  error: ErrorDto,
};*//*:: export type RoomTemplateViewSelectProductSlotAction = OptionalNavigationAction & {
  type: '@roomTemplateView/SELECT_PRODUCT_SLOT',
  productSlot: ?ProductSlotDto,
};*//*:: export type RoomTemplateViewResetAction = OptionalNavigationAction & {
  type: '@roomTemplateView/RESET',
};*//*:: export type RoomTemplateViewClearAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CLEAR',
};*//*:: export type RoomTemplateViewOpenDialogRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/OPEN_DIALOG_REQUEST',
};*//*:: export type RoomTemplateViewOpenDialogFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/OPEN_DIALOG_FAILURE',
  error: ErrorDto,
};*//*:: export type RoomTemplateViewOpenDialogSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/OPEN_DIALOG_SUCCESS',
  products: ProductDto[],
  rootName: string,
  productType: ProductTypeDto,
};*//*:: export type RoomTemplateViewCloseDialogAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CLOSE_DIALOG',
};*//*:: export type RoomTemplateViewPopDialogNavigationAction = OptionalNavigationAction & {
  type: '@roomTemplateView/POP_DIALOG_NAVIGATION',
  depth: number,
};*//*:: export type RoomTemplateViewNavigateToVariantRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/NAVIGATE_TO_VARIANT_REQUEST',
};*//*:: export type RoomTemplateViewNavigateToVariantFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/NAVIGATE_TO_VARIANT_FAILURE',
  error: ErrorDto,
};*//*:: export type RoomTemplateViewNavigateToVariantSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/NAVIGATE_TO_VARIANT_SUCCESS',
  variant: VariantDto,
};*//*:: export type RoomTemplateViewUpdateRelatedVariantAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_RELATED_VARIANT',
  variant: VariantDto,
  data: any,
};*//*:: export type RoomTemplateViewToggleVariantRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/TOGGLE_VARIANT_REQUEST',
};*//*:: export type RoomTemplateViewToggleVariantFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/TOGGLE_VARIANT_FAILURE',
  error: ErrorDto,
};*//*:: export type RoomTemplateViewToggleVariantSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/TOGGLE_VARIANT_SUCCESS',
  variant: VariantDto,
  expand: boolean,
};*//*:: export type RoomTemplateViewSetStandardProductAction = OptionalNavigationAction & {
  type: '@roomTemplateView/SET_STANDARD_PRODUCT',
  product: ProductDto,
  productType: ProductTypeDto,
};*//*:: export type RoomTemplateViewToggleProductAction = OptionalNavigationAction & {
  type: '@roomTemplateView/TOGGLE_PRODUCT',
  product: ProductDto,
};*//*:: export type RoomTemplateViewCheckAllVariantsAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CHECK_ALL_VARIANTS',
  checked: boolean,
};*//*:: export type RoomTemplateViewClearStandardProductAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CLEAR_STANDARD_PRODUCT',
  productType: ProductTypeDto,
};*//*:: export type RoomTemplateViewCheckProductAction = OptionalNavigationAction & {
  type: '@roomTemplateView/CHECK_PRODUCT',
  productId: number,
  checked: boolean,
};*//*:: export type RoomTemplateViewUpdateVariantsAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_VARIANTS',
  productId: number,
  data: any,
};*//*:: export type RoomTemplateViewUpdateVariantsForTypeAction = OptionalNavigationAction & {
  type: '@roomTemplateView/UPDATE_VARIANTS_FOR_TYPE',
  productTypeId: number,
  data: any,
};*//*:: export type RoomTemplateViewProductSlotsUpdateRequestAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOTS_UPDATE_REQUEST',
};*//*:: export type RoomTemplateViewProductSlotsUpdateFailureAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOTS_UPDATE_FAILURE',
  error: ErrorDto,
};*//*:: export type RoomTemplateViewProductSlotsUpdateSuccessAction = OptionalNavigationAction & {
  type: '@roomTemplateView/PRODUCT_SLOTS_UPDATE_SUCCESS',
  roomTemplateId: number,
  productSlotId: number,
  productSlots: ProductSlotDto[],
};*//*:: export type RoomTemplateViewAction
  = RoomTemplateViewGetRequestAction
  | RoomTemplateViewGetSuccessAction
  | RoomTemplateViewGetFailureAction
  | RoomTemplateViewUpdateRequestAction
  | RoomTemplateViewUpdateSuccessAction
  | RoomTemplateViewUpdateFailureAction
  | RoomTemplateViewCreateRequestAction
  | RoomTemplateViewCreateSuccessAction
  | RoomTemplateViewCreateFailureAction
  | RoomTemplateViewProductSlotUpdateRequestAction
  | RoomTemplateViewProductSlotUpdateSuccessAction
  | RoomTemplateViewProductSlotUpdateFailureAction
  | RoomTemplateViewProductSlotCreateRequestAction
  | RoomTemplateViewProductSlotCreateSuccessAction
  | RoomTemplateViewProductSlotCreateFailureAction
  | RoomTemplateViewSelectProductSlotAction
  | RoomTemplateViewResetAction
  | RoomTemplateViewClearAction
  | RoomTemplateViewOpenDialogRequestAction
  | RoomTemplateViewOpenDialogFailureAction
  | RoomTemplateViewOpenDialogSuccessAction
  | RoomTemplateViewCloseDialogAction
  | RoomTemplateViewPopDialogNavigationAction
  | RoomTemplateViewNavigateToVariantRequestAction
  | RoomTemplateViewNavigateToVariantFailureAction
  | RoomTemplateViewNavigateToVariantSuccessAction
  | RoomTemplateViewUpdateRelatedVariantAction
  | RoomTemplateViewToggleVariantRequestAction
  | RoomTemplateViewToggleVariantFailureAction
  | RoomTemplateViewToggleVariantSuccessAction
  | RoomTemplateViewSetStandardProductAction
  | RoomTemplateViewToggleProductAction
  | RoomTemplateViewCheckAllVariantsAction
  | RoomTemplateViewClearStandardProductAction
  | RoomTemplateViewCheckProductAction
  | RoomTemplateViewUpdateVariantsAction
  | RoomTemplateViewUpdateVariantsForTypeAction
  | RoomTemplateViewProductSlotsUpdateRequestAction
  | RoomTemplateViewProductSlotsUpdateFailureAction
  | RoomTemplateViewProductSlotsUpdateSuccessAction;*/var productSlotsUpdateRequest=function productSlotsUpdateRequest()/*: Exact<RoomTemplateViewProductSlotsUpdateRequestAction>*/{return{type:PRODUCT_SLOTS_UPDATE_REQUEST};};var productSlotsUpdateFailure=function productSlotsUpdateFailure(error/*: ErrorDto*/)/*: Exact<RoomTemplateViewProductSlotsUpdateFailureAction>*/{return{type:PRODUCT_SLOTS_UPDATE_FAILURE,error:error};};var productSlotsUpdateSuccess=function productSlotsUpdateSuccess(roomTemplateId/*: number*/,productSlotId/*: number*/,productSlots/*: ProductSlotDto[]*/)/*: Exact<RoomTemplateViewProductSlotsUpdateSuccessAction>*/{return{type:PRODUCT_SLOTS_UPDATE_SUCCESS,roomTemplateId:roomTemplateId,productSlotId:productSlotId,productSlots:productSlots};};var updateVariants=exports.updateVariants=function updateVariants(productId/*: number*/,data/*: any*/)/*: Exact<RoomTemplateViewUpdateVariantsAction>*/{return{type:UPDATE_VARIANTS,productId:productId,data:data};};var updateVariantsForType=exports.updateVariantsForType=function updateVariantsForType(productTypeId/*: number*/,data/*: any*/)/*: Exact<RoomTemplateViewUpdateVariantsForTypeAction>*/{return{type:UPDATE_VARIANTS_FOR_TYPE,productTypeId:productTypeId,data:data};};var checkProduct=exports.checkProduct=function checkProduct(productId/*: number*/,checked/*: boolean*/)/*: Exact<RoomTemplateViewCheckProductAction>*/{return{type:CHECK_PRODUCT,productId:productId,checked:checked};};var checkAllVariants=exports.checkAllVariants=function checkAllVariants(checked/*: boolean*/)/*: Exact<RoomTemplateViewCheckAllVariantsAction>*/{return{type:CHECK_ALL_VARIANTS,checked:checked};};var toggleProduct=exports.toggleProduct=function toggleProduct(product/*: ProductDto*/)/*: Exact<RoomTemplateViewToggleProductAction>*/{return{type:TOGGLE_PRODUCT,product:product};};var popDialogNavigation=exports.popDialogNavigation=function popDialogNavigation(depth/*: number*/)/*: Exact<RoomTemplateViewPopDialogNavigationAction>*/{return{type:POP_DIALOG_NAVIGATION,depth:depth};};var navigateToVariantRequest=function navigateToVariantRequest()/*: Exact<RoomTemplateViewNavigateToVariantRequestAction>*/{return{type:NAVIGATE_TO_VARIANT_REQUEST};};var navigateToVariantFailure=function navigateToVariantFailure(error/*: ErrorDto*/)/*: Exact<RoomTemplateViewNavigateToVariantFailureAction>*/{return{type:NAVIGATE_TO_VARIANT_FAILURE,error:error};};var navigateToVariantSuccess=function navigateToVariantSuccess(variant/*: VariantDto*/)/*: Exact<RoomTemplateViewNavigateToVariantSuccessAction>*/{return{type:NAVIGATE_TO_VARIANT_SUCCESS,variant:variant};};var navigateToVariant=exports.navigateToVariant=function navigateToVariant(variant/*: VariantDto*/){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch/*: Dispatch<RoomTemplateViewAction>*/){var fullVariant;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:dispatch(navigateToVariantRequest());_context.prev=1;_context.next=4;return(0,_request.GET)({endpoint:'/productvariants/'+variant.id},dispatch);case 4:fullVariant=_context.sent;dispatch(navigateToVariantSuccess(_extends({},fullVariant,{uuid:variant.uuid})));_context.next=11;break;case 8:_context.prev=8;_context.t0=_context['catch'](1);dispatch(navigateToVariantFailure(_context.t0));case 11:case'end':return _context.stop();}}},_callee,undefined,[[1,8]]);}));return function(_x){return _ref.apply(this,arguments);};}();};var updateRelatedVariant=exports.updateRelatedVariant=function updateRelatedVariant(variant/*: VariantDto*/,data/*: any*/)/*: Exact<RoomTemplateViewUpdateRelatedVariantAction>*/{return{type:UPDATE_RELATED_VARIANT,variant:variant,data:data};};var setStandardProduct=exports.setStandardProduct=function setStandardProduct(product/*: ProductDto*/,productType/*: ProductTypeDto*/)/*: Exact<RoomTemplateViewSetStandardProductAction>*/{return{type:SET_STANDARD_PRODUCT,product:product,productType:productType};};var clearStandardProduct=exports.clearStandardProduct=function clearStandardProduct(productType/*: ProductTypeDto*/)/*: Exact<RoomTemplateViewClearStandardProductAction>*/{return{type:CLEAR_STANDARD_PRODUCT,productType:productType};};var toggleVariantRequest=function toggleVariantRequest()/*: Exact<RoomTemplateViewToggleVariantRequestAction>*/{return{type:TOGGLE_VARIANT_REQUEST};};var toggleVariantFailure=function toggleVariantFailure(error/*: ErrorDto*/)/*: Exact<RoomTemplateViewToggleVariantFailureAction>*/{return{type:TOGGLE_VARIANT_FAILURE,error:error};};var toggleVariantSuccess=function toggleVariantSuccess(variant/*: VariantDto*/,expand/*: boolean*/)/*: Exact<RoomTemplateViewToggleVariantSuccessAction>*/{return{type:TOGGLE_VARIANT_SUCCESS,variant:variant,expand:expand};};var toggleVariant=exports.toggleVariant=function toggleVariant(variant/*: VariantDto*/,expand/*: boolean*/){return function(){var _ref2=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee2(dispatch/*: Dispatch<RoomTemplateViewAction>*/){var fullVariant;return _regenerator2.default.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!expand){_context2.next=14;break;}dispatch(toggleVariantRequest());_context2.prev=2;_context2.next=5;return(0,_request.GET)({endpoint:'/productvariants/'+variant.id},dispatch);case 5:fullVariant=_context2.sent;dispatch(toggleVariantSuccess(_extends({},fullVariant,{uuid:variant.uuid}),expand));_context2.next=12;break;case 9:_context2.prev=9;_context2.t0=_context2['catch'](2);dispatch(toggleVariantFailure(_context2.t0));case 12:_context2.next=15;break;case 14:dispatch(toggleVariantSuccess(variant,expand));case 15:case'end':return _context2.stop();}}},_callee2,undefined,[[2,9]]);}));return function(_x2){return _ref2.apply(this,arguments);};}();};var openDialogRequest=function openDialogRequest()/*: Exact<RoomTemplateViewOpenDialogRequestAction>*/{return{type:OPEN_DIALOG_REQUEST};};var openDialogFailure=function openDialogFailure(error/*: ErrorDto*/)/*: Exact<RoomTemplateViewOpenDialogFailureAction>*/{return{type:OPEN_DIALOG_FAILURE,error:error};};var openDialogSuccess=function openDialogSuccess(products/*: ProductDto[]*/,rootName/*: string*/,productType/*: ProductTypeDto*/)/*: Exact<RoomTemplateViewOpenDialogSuccessAction>*/{return{type:OPEN_DIALOG_SUCCESS,products:products,rootName:rootName,productType:productType};};var openDialog=exports.openDialog=function openDialog(productTypeId/*: number*/,rootName/*: string*/){return function(){var _ref3=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee3(dispatch/*: Dispatch<RoomTemplateViewAction>*/){var _productType,_products;return _regenerator2.default.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:dispatch(openDialogRequest());_context3.prev=1;_context3.next=4;return(0,_request.GET)({endpoint:'/producttypes/'+productTypeId},dispatch);case 4:_productType=_context3.sent;_context3.next=7;return(0,_request.GET)({endpoint:'/products?productTypeId='+productTypeId+'&assortment='+_assortments.STANDARD},dispatch);case 7:_products=_context3.sent;dispatch(openDialogSuccess(_products,rootName,_productType));_context3.next=14;break;case 11:_context3.prev=11;_context3.t0=_context3['catch'](1);dispatch(openDialogFailure(_context3.t0));case 14:case'end':return _context3.stop();}}},_callee3,undefined,[[1,11]]);}));return function(_x3){return _ref3.apply(this,arguments);};}();};var closeDialog=exports.closeDialog=function closeDialog()/*: Exact<RoomTemplateViewCloseDialogAction>*/{return{type:CLOSE_DIALOG};};var roomTemplateRequest=function roomTemplateRequest()/*: Exact<RoomTemplateViewGetRequestAction>*/{return{type:GET_REQUEST};};var roomTemplateSuccess=function roomTemplateSuccess(roomTemplate/*: ?RoomTemplateDto*/,roomTypes/*: RoomTypeDto[]*/,products/*: ProductDto[]*/,productTypes/*: ProductTypeDto[]*/,roomTemplates/*: RoomTemplateDto[]*/,projects/*: LimitedProjectDto[]*/)/*: Exact<RoomTemplateViewGetSuccessAction>*/{return{type:GET_SUCCESS,roomTemplate:roomTemplate,roomTypes:roomTypes,products:products,productTypes:productTypes,roomTemplates:roomTemplates,projects:projects};};var roomTemplateFailure=function roomTemplateFailure(error/*: ErrorDto*/)/*: Exact<RoomTemplateViewGetFailureAction>*/{return{type:GET_FAILURE,error:error};};var roomTemplateUpdateRequest=function roomTemplateUpdateRequest()/*: Exact<RoomTemplateViewUpdateRequestAction>*/{return{type:UPDATE_REQUEST};};var roomTemplateUpdateSuccess=function roomTemplateUpdateSuccess(roomTemplate/*: RoomTemplateDto*/)/*: Exact<RoomTemplateViewUpdateSuccessAction>*/{return _defineProperty({type:UPDATE_SUCCESS,roomTemplate:roomTemplate},_notification.ADD,{message:'Mall uppdaterad'});};var roomTemplateUpdateFailure=function roomTemplateUpdateFailure(error/*: ErrorDto*/)/*: Exact<RoomTemplateViewUpdateFailureAction>*/{return{type:UPDATE_FAILURE,error:error};};var roomTemplateCreateRequest=function roomTemplateCreateRequest()/*: Exact<RoomTemplateViewCreateRequestAction>*/{return{type:CREATE_REQUEST};};var roomTemplateCreateSuccess=function roomTemplateCreateSuccess(roomTemplate/*: RoomTemplateDto*/)/*: Exact<RoomTemplateViewCreateSuccessAction>*/{return _defineProperty({type:CREATE_SUCCESS,roomTemplate:roomTemplate},_notification.ADD,{message:'Mall "'+roomTemplate.name+'" skapad'});};var roomTemplateCreateFailure=function roomTemplateCreateFailure(error/*: ErrorDto*/)/*: Exact<RoomTemplateViewCreateFailureAction>*/{return{type:CREATE_FAILURE,error:error};};var productSlotUpdateRequest=function productSlotUpdateRequest()/*: Exact<RoomTemplateViewProductSlotUpdateRequestAction>*/{return{type:PRODUCT_SLOT_UPDATE_REQUEST};};var productSlotUpdateSuccess=function productSlotUpdateSuccess(productSlot/*: ProductSlotDto*/)/*: Exact<RoomTemplateViewProductSlotUpdateSuccessAction>*/{return _defineProperty({type:PRODUCT_SLOT_UPDATE_SUCCESS,productSlot:productSlot},_notification.ADD,{message:'Produktplats uppdaterad'});};var productSlotUpdateFailure=function productSlotUpdateFailure(error/*: ErrorDto*/)/*: Exact<RoomTemplateViewProductSlotUpdateFailureAction>*/{return{type:PRODUCT_SLOT_UPDATE_FAILURE,error:error};};var productSlotCreateRequest=function productSlotCreateRequest()/*: Exact<RoomTemplateViewProductSlotCreateRequestAction>*/{return{type:PRODUCT_SLOT_CREATE_REQUEST};};var productSlotCreateSuccess=function productSlotCreateSuccess(productSlot/*: ProductSlotDto*/,roomTemplateId/*: number*/)/*: Exact<RoomTemplateViewProductSlotCreateSuccessAction>*/{return _defineProperty({type:PRODUCT_SLOT_CREATE_SUCCESS,productSlot:productSlot,roomTemplateId:roomTemplateId},_notification.ADD,{message:'Produktplats "'+productSlot.name+'" skapad'});};var productSlotCreateFailure=function productSlotCreateFailure(error/*: ErrorDto*/)/*: Exact<RoomTemplateViewProductSlotCreateFailureAction>*/{return{type:PRODUCT_SLOT_CREATE_FAILURE,error:error};};var clear=exports.clear=function clear()/*: Exact<RoomTemplateViewClearAction>*/{return{type:CLEAR};};var reset=exports.reset=function reset()/*: Exact<RoomTemplateViewResetAction>*/{return{type:RESET};};var selectProductSlot=exports.selectProductSlot=function selectProductSlot(productSlot/*: ?ProductSlotDto*/)/*: Exact<RoomTemplateViewSelectProductSlotAction>*/{return{type:SELECT_PRODUCT_SLOT,productSlot:productSlot};};var fetchData=exports.fetchData=function fetchData(id/*: number*/){return function(){var _ref8=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee4(dispatch/*: Dispatch<RoomTemplateViewAction>*/){var _roomTypes,_products2,_productTypes,_roomTemplate,_roomTemplates,_projects;return _regenerator2.default.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:dispatch(roomTemplateRequest());_context4.prev=1;_context4.t0=_apartmentConfigView.sortByName;_context4.next=5;return(0,_request.GET)({endpoint:'/roomtypes'},dispatch);case 5:_context4.t1=_context4.sent;_roomTypes=(0,_context4.t0)(_context4.t1);_context4.next=9;return(0,_request.GET)({endpoint:'/products?assortment='+_assortments.STANDARD},dispatch);case 9:_products2=_context4.sent;_context4.t2=_apartmentConfigView.sortByName;_context4.next=13;return(0,_request.GET)({endpoint:'/producttypes'},dispatch);case 13:_context4.t3=_context4.sent;_productTypes=(0,_context4.t2)(_context4.t3);_roomTemplate=null;_roomTemplates=[];_projects=[];if(!id){_context4.next=24;break;}_context4.next=21;return(0,_request.GET)({endpoint:'/roomtemplates/'+id},dispatch);case 21:_roomTemplate=_context4.sent;_context4.next=37;break;case 24:_context4.t4=_apartmentConfigView.sortByName;_context4.t5=_map3.default;_context4.t6=function(x){return _extends({},x,{apartmentConfigs:(0,_apartmentConfigView.sortByName)(x.apartmentConfigs)});};_context4.next=29;return(0,_request.GET)({endpoint:'/projects/rooms'},dispatch);case 29:_context4.t7=_context4.sent;_context4.t8=(0,_context4.t5)(_context4.t6,_context4.t7);_projects=(0,_context4.t4)(_context4.t8);_context4.t9=_apartmentConfigView.filterAndSort;_context4.next=35;return(0,_request.GET)({endpoint:'/roomtemplates'},dispatch);case 35:_context4.t10=_context4.sent;_roomTemplates=(0,_context4.t9)(_context4.t10);case 37:dispatch(roomTemplateSuccess(_roomTemplate,_roomTypes,_products2,_productTypes,_roomTemplates,_projects));_context4.next=43;break;case 40:_context4.prev=40;_context4.t11=_context4['catch'](1);dispatch(roomTemplateFailure(_context4.t11));case 43:case'end':return _context4.stop();}}},_callee4,undefined,[[1,40]]);}));return function(_x4){return _ref8.apply(this,arguments);};}();};var updateRoomTemplate=exports.updateRoomTemplate=function updateRoomTemplate(id/*: number*/,body/*: any*/){return function(){var _ref9=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee5(dispatch/*: Dispatch<RoomTemplateViewAction>*/){var _roomTemplate2;return _regenerator2.default.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:dispatch(roomTemplateUpdateRequest());_context5.prev=1;_context5.next=4;return(0,_request.PUT)({endpoint:'/roomtemplates/'+id,body:body},dispatch);case 4:_roomTemplate2=_context5.sent;dispatch(roomTemplateUpdateSuccess(_roomTemplate2));_context5.next=11;break;case 8:_context5.prev=8;_context5.t0=_context5['catch'](1);dispatch(roomTemplateUpdateFailure(_context5.t0));case 11:case'end':return _context5.stop();}}},_callee5,undefined,[[1,8]]);}));return function(_x5){return _ref9.apply(this,arguments);};}();};var createRoomTemplate=exports.createRoomTemplate=function createRoomTemplate(body/*: any*/){return function(){var _ref10=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee6(dispatch/*: Dispatch<RoomTemplateViewAction>*/){var _roomTemplate3;return _regenerator2.default.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:dispatch(roomTemplateCreateRequest());_context6.prev=1;_context6.next=4;return(0,_request.POST)({endpoint:'/roomtemplates',body:body},dispatch);case 4:_roomTemplate3=_context6.sent;dispatch(roomTemplateCreateSuccess(_roomTemplate3));_context6.next=11;break;case 8:_context6.prev=8;_context6.t0=_context6['catch'](1);dispatch(roomTemplateCreateFailure(_context6.t0));case 11:case'end':return _context6.stop();}}},_callee6,undefined,[[1,8]]);}));return function(_x6){return _ref10.apply(this,arguments);};}();};var createProductSlot=exports.createProductSlot=function createProductSlot(roomTemplateId/*: number*/,body/*: any*/){return function(){var _ref11=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee7(dispatch/*: Dispatch<RoomTemplateViewAction>*/){var productslot;return _regenerator2.default.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:dispatch(productSlotCreateRequest());_context7.prev=1;_context7.next=4;return(0,_request.POST)({endpoint:'/roomtemplates/'+roomTemplateId+'/productslots',body:body},dispatch);case 4:productslot=_context7.sent;dispatch(productSlotCreateSuccess(productslot,roomTemplateId));_context7.next=11;break;case 8:_context7.prev=8;_context7.t0=_context7['catch'](1);dispatch(productSlotCreateFailure(_context7.t0));case 11:case'end':return _context7.stop();}}},_callee7,undefined,[[1,8]]);}));return function(_x7){return _ref11.apply(this,arguments);};}();};var updateProductSlot=exports.updateProductSlot=function updateProductSlot(id/*: number*/,body/*: any*/){return function(){var _ref12=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee8(dispatch/*: Dispatch<RoomTemplateViewAction>*/){var productslot;return _regenerator2.default.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:dispatch(productSlotUpdateRequest());_context8.prev=1;_context8.next=4;return(0,_request.PUT)({endpoint:'/productslots/'+id,body:body},dispatch);case 4:productslot=_context8.sent;dispatch(productSlotUpdateSuccess(productslot));_context8.next=11;break;case 8:_context8.prev=8;_context8.t0=_context8['catch'](1);dispatch(productSlotUpdateFailure(_context8.t0));case 11:case'end':return _context8.stop();}}},_callee8,undefined,[[1,8]]);}));return function(_x8){return _ref12.apply(this,arguments);};}();};var updateProductSlots=exports.updateProductSlots=function updateProductSlots(roomTemplateId/*: number*/,productSlotId/*: number*/,sortDirection/*: 'up' | 'down'*/){return function(){var _ref13=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee9(dispatch/*: Dispatch<RoomTemplateViewAction>*/){var _productSlots;return _regenerator2.default.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:dispatch(productSlotsUpdateRequest());_context9.prev=1;_context9.next=4;return(0,_request.PUT)({endpoint:'/roomtemplates/'+roomTemplateId+'/productslots',body:{productSlotId:productSlotId,sortDirection:sortDirection}},dispatch);case 4:_productSlots=_context9.sent;dispatch(productSlotsUpdateSuccess(roomTemplateId,productSlotId,_productSlots));_context9.next=11;break;case 8:_context9.prev=8;_context9.t0=_context9['catch'](1);dispatch(productSlotsUpdateFailure(_context9.t0));case 11:case'end':return _context9.stop();}}},_callee9,undefined,[[1,8]]);}));return function(_x9){return _ref13.apply(this,arguments);};}();};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends2 = __webpack_require__(964);

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = __webpack_require__(973);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(976);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(977);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(981);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(1003);

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1011);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  thousandSeparator: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.oneOf([true])]),
  decimalSeparator: _propTypes2.default.string,
  decimalScale: _propTypes2.default.number,
  fixedDecimalScale: _propTypes2.default.bool,
  displayType: _propTypes2.default.oneOf(['input', 'text']),
  prefix: _propTypes2.default.string,
  suffix: _propTypes2.default.string,
  format: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  removeFormatting: _propTypes2.default.func,
  mask: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.arrayOf(_propTypes2.default.string)]),
  value: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  isNumericString: _propTypes2.default.bool,
  customInput: _propTypes2.default.func,
  allowNegative: _propTypes2.default.bool,
  allowEmptyFormatting: _propTypes2.default.bool,
  onValueChange: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  type: _propTypes2.default.oneOf(['text', 'tel']),
  isAllowed: _propTypes2.default.func,
  renderText: _propTypes2.default.func,
  getInputRef: _propTypes2.default.func
};


var defaultProps = {
  displayType: 'input',
  decimalSeparator: '.',
  fixedDecimalScale: false,
  prefix: '',
  suffix: '',
  allowNegative: true,
  allowEmptyFormatting: false,
  isNumericString: false,
  type: 'text',
  onValueChange: _utils.noop,
  onChange: _utils.noop,
  onKeyDown: _utils.noop,
  onMouseUp: _utils.noop,
  onFocus: _utils.noop,
  onBlur: _utils.noop,
  isAllowed: _utils.returnTrue,
  getInputRef: _utils.noop
};

var NumberFormat = function (_React$Component) {
  (0, _inherits3.default)(NumberFormat, _React$Component);

  function NumberFormat(props) {
    (0, _classCallCheck3.default)(this, NumberFormat);

    //validate props
    var _this = (0, _possibleConstructorReturn3.default)(this, (NumberFormat.__proto__ || (0, _getPrototypeOf2.default)(NumberFormat)).call(this, props));

    _this.validateProps();

    var formattedValue = _this.formatValueProp();

    _this.state = {
      value: formattedValue,
      numAsString: _this.removeFormatting(formattedValue)
    };

    _this.selectionBeforeInput = {
      selectionStart: 0,
      selectionEnd: 0
    };

    _this.onChange = _this.onChange.bind(_this);
    _this.onKeyDown = _this.onKeyDown.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);
    _this.onFocus = _this.onFocus.bind(_this);
    _this.onBlur = _this.onBlur.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(NumberFormat, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      this.updateValueIfRequired(prevProps);
    }
  }, {
    key: 'updateValueIfRequired',
    value: function updateValueIfRequired(prevProps) {
      var props = this.props,
          state = this.state;


      if (prevProps !== props) {
        //validate props
        this.validateProps();

        var stateValue = state.value;

        var lastNumStr = state.numAsString || '';
        var lastValueWithNewFormat = this.formatNumString(lastNumStr);

        var formattedValue = props.value === undefined ? lastValueWithNewFormat : this.formatValueProp();
        var _numAsString = this.removeFormatting(formattedValue);

        var floatValue = parseFloat(_numAsString);
        var lastFloatValue = parseFloat(lastNumStr);

        if ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue || lastValueWithNewFormat !== stateValue) {
          this.setState({
            value: formattedValue,
            numAsString: _numAsString
          });
        }
      }
    }

    /** Misc methods **/

  }, {
    key: 'getFloatString',
    value: function getFloatString() {
      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var decimalScale = this.props.decimalScale;

      var _getSeparators = this.getSeparators(),
          decimalSeparator = _getSeparators.decimalSeparator;

      var numRegex = this.getNumberRegex(true);

      //remove negation for regex check
      var hasNegation = num[0] === '-';
      if (hasNegation) num = num.replace('-', '');

      //if decimal scale is zero remove decimal and number after decimalSeparator
      if (decimalSeparator && decimalScale === 0) {
        num = num.split(decimalSeparator)[0];
      }

      num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.');

      //remove extra decimals
      var firstDecimalIndex = num.indexOf('.');

      if (firstDecimalIndex !== -1) {
        num = num.substring(0, firstDecimalIndex) + '.' + num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp((0, _utils.escapeRegExp)(decimalSeparator), 'g'), '');
      }

      //add negation back
      if (hasNegation) num = '-' + num;

      return num;
    }

    //returned regex assumes decimalSeparator is as per prop

  }, {
    key: 'getNumberRegex',
    value: function getNumberRegex(g, ignoreDecimalSeparator) {
      var _props = this.props,
          format = _props.format,
          decimalScale = _props.decimalScale;

      var _getSeparators2 = this.getSeparators(),
          decimalSeparator = _getSeparators2.decimalSeparator;

      return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + (0, _utils.escapeRegExp)(decimalSeparator) : ''), g ? 'g' : undefined);
    }
  }, {
    key: 'getSeparators',
    value: function getSeparators() {
      var decimalSeparator = this.props.decimalSeparator;
      var thousandSeparator = this.props.thousandSeparator;


      if (thousandSeparator === true) {
        thousandSeparator = ',';
      }

      return {
        decimalSeparator: decimalSeparator,
        thousandSeparator: thousandSeparator
      };
    }
  }, {
    key: 'getMaskAtIndex',
    value: function getMaskAtIndex(index) {
      var _props$mask = this.props.mask,
          mask = _props$mask === undefined ? ' ' : _props$mask;

      if (typeof mask === 'string') {
        return mask;
      }

      return mask[index] || ' ';
    }
  }, {
    key: 'getValueObject',
    value: function getValueObject(formattedValue, numAsString) {
      var floatValue = parseFloat(numAsString);

      return {
        formattedValue: formattedValue,
        value: numAsString,
        floatValue: isNaN(floatValue) ? undefined : floatValue
      };
    }
  }, {
    key: 'validateProps',
    value: function validateProps() {
      var mask = this.props.mask;

      //validate decimalSeparator and thousandSeparator

      var _getSeparators3 = this.getSeparators(),
          decimalSeparator = _getSeparators3.decimalSeparator,
          thousandSeparator = _getSeparators3.thousandSeparator;

      if (decimalSeparator === thousandSeparator) {
        throw new Error('\n          Decimal separator can\'t be same as thousand separator.\n\n          thousandSeparator: ' + thousandSeparator + ' (thousandSeparator = {true} is same as thousandSeparator = ",")\n          decimalSeparator: ' + decimalSeparator + ' (default value for decimalSeparator is .)\n       ');
      }

      //validate mask
      if (mask) {
        var maskAsStr = mask === 'string' ? mask : mask.toString();
        if (maskAsStr.match(/\d/g)) {
          throw new Error('\n          Mask ' + mask + ' should not contain numeric character;\n        ');
        }
      }
    }
    /** Misc methods end **/

    /** caret specific methods **/

  }, {
    key: 'setPatchedCaretPosition',
    value: function setPatchedCaretPosition(el, caretPos, currentValue) {
      /* setting caret position within timeout of 0ms is required for mobile chrome,
      otherwise browser resets the caret position after we set it
      We are also setting it without timeout so that in normal browser we don't see the flickering */
      (0, _utils.setCaretPosition)(el, caretPos);
      setTimeout(function () {
        if (el.value === currentValue) (0, _utils.setCaretPosition)(el, caretPos);
      }, 0);
    }

    /* This keeps the caret within typing area so people can't type in between prefix or suffix */

  }, {
    key: 'correctCaretPosition',
    value: function correctCaretPosition(value, caretPos, direction) {
      var _props2 = this.props,
          prefix = _props2.prefix,
          suffix = _props2.suffix,
          format = _props2.format;

      //if value is empty return 0

      if (value === '') return 0;

      //caret position should be between 0 and value length
      caretPos = (0, _utils.clamp)(caretPos, 0, value.length);

      //in case of format as number limit between prefix and suffix
      if (!format) {
        var hasNegation = value[0] === '-';
        return (0, _utils.clamp)(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
      }

      //in case if custom format method don't do anything
      if (typeof format === 'function') return caretPos;

      /* in case format is string find the closest # position from the caret position */

      //in case the caretPos have input value on it don't do anything
      if (format[caretPos] === '#' && (0, _utils.charIsNumber)(value[caretPos])) return caretPos;

      //if caretPos is just after input value don't do anything
      if (format[caretPos - 1] === '#' && (0, _utils.charIsNumber)(value[caretPos - 1])) return caretPos;

      //find the nearest caret position
      var firstHashPosition = format.indexOf('#');
      var lastHashPosition = format.lastIndexOf('#');

      //limit the cursor between the first # position and the last # position
      caretPos = (0, _utils.clamp)(caretPos, firstHashPosition, lastHashPosition + 1);

      var nextPos = format.substring(caretPos, format.length).indexOf('#');
      var caretLeftBound = caretPos;
      var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos);

      //get the position where the last number is present
      while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !(0, _utils.charIsNumber)(value[caretLeftBound]))) {
        caretLeftBound -= 1;
      }

      var goToLeft = !(0, _utils.charIsNumber)(value[caretRightBound]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBound - caretPos;

      if (goToLeft) {
        //check if number should be taken after the bound or after it
        //if number preceding a valid number keep it after
        return (0, _utils.charIsNumber)(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
      }

      return caretRightBound;
    }
  }, {
    key: 'getCaretPosition',
    value: function getCaretPosition(inputValue, formattedValue, caretPos) {
      var format = this.props.format;

      var stateValue = this.state.value;
      var numRegex = this.getNumberRegex(true);
      var inputNumber = (inputValue.match(numRegex) || []).join('');
      var formattedNumber = (formattedValue.match(numRegex) || []).join('');
      var j = void 0,
          i = void 0;

      j = 0;

      for (i = 0; i < caretPos; i++) {
        var currentInputChar = inputValue[i] || '';
        var currentFormatChar = formattedValue[j] || '';
        //no need to increase new cursor position if formatted value does not have those characters
        //case inputValue = 1a23 and formattedValue =  123
        if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue;

        //When we are striping out leading zeros maintain the new cursor position
        //Case inputValue = 00023 and formattedValue = 23;
        if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue;

        //we are not using currentFormatChar because j can change here
        while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
          j++;
        }j++;
      }

      if (typeof format === 'string' && !stateValue) {
        //set it to the maximum value so it goes after the last number
        j = formattedValue.length;
      }

      //correct caret position if its outside of editable area
      j = this.correctCaretPosition(formattedValue, j);

      return j;
    }
    /** caret specific methods ends **/

    /** methods to remove formattting **/

  }, {
    key: 'removePrefixAndSuffix',
    value: function removePrefixAndSuffix(val) {
      var _props3 = this.props,
          format = _props3.format,
          prefix = _props3.prefix,
          suffix = _props3.suffix;

      //remove prefix and suffix

      if (!format && val) {
        var isNegative = val[0] === '-';

        //remove negation sign
        if (isNegative) val = val.substring(1, val.length);

        //remove prefix
        val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val;

        //remove suffix
        var suffixLastIndex = val.lastIndexOf(suffix);
        val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val;

        //add negation sign back
        if (isNegative) val = '-' + val;
      }

      return val;
    }
  }, {
    key: 'removePatternFormatting',
    value: function removePatternFormatting(val) {
      var format = this.props.format;

      var formatArray = format.split('#').filter(function (str) {
        return str !== '';
      });
      var start = 0;
      var numStr = '';

      for (var i = 0, ln = formatArray.length; i <= ln; i++) {
        var part = formatArray[i] || '';

        //if i is the last fragment take the index of end of the value
        //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
        var index = i === ln ? val.length : val.indexOf(part, start);

        /* in any case if we don't find the pattern part in the value assume the val as numeric string
        This will be also in case if user has started typing, in any other case it will not be -1
        unless wrong prop value is provided */
        if (index === -1) {
          numStr = val;
          break;
        } else {
          numStr += val.substring(start, index);
          start = index + part.length;
        }
      }

      return (numStr.match(/\d/g) || []).join('');
    }
  }, {
    key: 'removeFormatting',
    value: function removeFormatting(val) {
      var _props4 = this.props,
          format = _props4.format,
          removeFormatting = _props4.removeFormatting;

      if (!val) return val;

      if (!format) {
        val = this.removePrefixAndSuffix(val);
        val = this.getFloatString(val);
      } else if (typeof format === 'string') {
        val = this.removePatternFormatting(val);
      } else if (typeof removeFormatting === 'function') {
        //condition need to be handled if format method is provide,
        val = removeFormatting(val);
      } else {
        val = (val.match(/\d/g) || []).join('');
      }
      return val;
    }
    /** methods to remove formattting end **/

    /*** format specific methods start ***/
    /**
     * Format when # based string is provided
     * @param  {string} numStr Numeric String
     * @return {string}        formatted Value
     */

  }, {
    key: 'formatWithPattern',
    value: function formatWithPattern(numStr) {
      var format = this.props.format;

      var hashCount = 0;
      var formattedNumberAry = format.split('');
      for (var i = 0, ln = format.length; i < ln; i++) {
        if (format[i] === '#') {
          formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
          hashCount += 1;
        }
      }
      return formattedNumberAry.join('');
    }
    /**
     * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
     * @return {string} formatted Value
     */

  }, {
    key: 'formatAsNumber',
    value: function formatAsNumber(numStr) {
      var _props5 = this.props,
          decimalScale = _props5.decimalScale,
          fixedDecimalScale = _props5.fixedDecimalScale,
          prefix = _props5.prefix,
          suffix = _props5.suffix,
          allowNegative = _props5.allowNegative;

      var _getSeparators4 = this.getSeparators(),
          thousandSeparator = _getSeparators4.thousandSeparator,
          decimalSeparator = _getSeparators4.decimalSeparator;

      var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;

      var _splitDecimal = (0, _utils.splitDecimal)(numStr, allowNegative),
          beforeDecimal = _splitDecimal.beforeDecimal,
          afterDecimal = _splitDecimal.afterDecimal,
          addNegation = _splitDecimal.addNegation; // eslint-disable-line prefer-const

      //apply decimal precision if its defined


      if (decimalScale !== undefined) afterDecimal = (0, _utils.limitToScale)(afterDecimal, decimalScale, fixedDecimalScale);

      if (thousandSeparator) {
        beforeDecimal = beforeDecimal.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandSeparator);
      }

      //add prefix and suffix
      if (prefix) beforeDecimal = prefix + beforeDecimal;
      if (suffix) afterDecimal = afterDecimal + suffix;

      //restore negation sign
      if (addNegation) beforeDecimal = '-' + beforeDecimal;

      numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;

      return numStr;
    }
  }, {
    key: 'formatNumString',
    value: function formatNumString() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _props6 = this.props,
          format = _props6.format,
          allowEmptyFormatting = _props6.allowEmptyFormatting;

      var formattedValue = value;

      if (value === '' && !allowEmptyFormatting) {
        formattedValue = '';
      } else if (value === '-' && !format) {
        formattedValue = '-';
        value = '';
      } else if (typeof format === 'string') {
        formattedValue = this.formatWithPattern(formattedValue);
      } else if (typeof format === 'function') {
        formattedValue = format(formattedValue);
      } else {
        formattedValue = this.formatAsNumber(formattedValue);
      }

      return formattedValue;
    }
  }, {
    key: 'formatValueProp',
    value: function formatValueProp() {
      var _props7 = this.props,
          format = _props7.format,
          decimalScale = _props7.decimalScale,
          fixedDecimalScale = _props7.fixedDecimalScale,
          allowEmptyFormatting = _props7.allowEmptyFormatting;
      var _props8 = this.props,
          value = _props8.value,
          isNumericString = _props8.isNumericString;


      var isNonNumericFalsy = !value && value !== 0;

      if (isNonNumericFalsy && allowEmptyFormatting) {
        value = '';
      }

      // if value is not defined return empty string
      if (isNonNumericFalsy && !allowEmptyFormatting) return '';

      if (typeof value === 'number') {
        value = value.toString();
        isNumericString = true;
      }

      //round the number based on decimalScale
      //format only if non formatted value is provided
      if (isNumericString && !format && typeof decimalScale === 'number') {
        value = (0, _utils.roundToPrecision)(value, decimalScale, fixedDecimalScale);
      }

      var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);

      return formattedValue;
    }
  }, {
    key: 'formatNegation',
    value: function formatNegation() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var allowNegative = this.props.allowNegative;

      var negationRegex = new RegExp('(-)');
      var doubleNegationRegex = new RegExp('(-)(.)*(-)');

      // Check number has '-' value
      var hasNegation = negationRegex.test(value);

      // Check number has 2 or more '-' values
      var removeNegation = doubleNegationRegex.test(value);

      //remove negation
      value = value.replace(/-/g, '');

      if (hasNegation && !removeNegation && allowNegative) {
        value = '-' + value;
      }

      return value;
    }
  }, {
    key: 'formatInput',
    value: function formatInput() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var format = this.props.format;

      //format negation only if we are formatting as number

      if (!format) {
        value = this.formatNegation(value);
      }

      //remove formatting from number
      value = this.removeFormatting(value);

      return this.formatNumString(value);
    }

    /*** format specific methods end ***/

  }, {
    key: 'isCharacterAFormat',
    value: function isCharacterAFormat(caretPos, value) {
      var _props9 = this.props,
          format = _props9.format,
          prefix = _props9.prefix,
          suffix = _props9.suffix,
          decimalScale = _props9.decimalScale,
          fixedDecimalScale = _props9.fixedDecimalScale;

      var _getSeparators5 = this.getSeparators(),
          decimalSeparator = _getSeparators5.decimalSeparator;

      //check within format pattern


      if (typeof format === 'string' && format[caretPos] !== '#') return true;

      //check in number format
      if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
        return true;
      }

      return false;
    }
  }, {
    key: 'checkIfFormatGotDeleted',
    value: function checkIfFormatGotDeleted(start, end, value) {
      for (var i = start; i < end; i++) {
        if (this.isCharacterAFormat(i, value)) return true;
      }
      return false;
    }

    /**
     * This will check if any formatting got removed by the delete or backspace and reset the value
     * It will also work as fallback if android chome keyDown handler does not work
     **/

  }, {
    key: 'correctInputValue',
    value: function correctInputValue(caretPos, lastValue, value) {
      var _props10 = this.props,
          format = _props10.format,
          decimalSeparator = _props10.decimalSeparator,
          allowNegative = _props10.allowNegative;

      var lastNumStr = this.state.numAsString || '';
      var _selectionBeforeInput = this.selectionBeforeInput,
          selectionStart = _selectionBeforeInput.selectionStart,
          selectionEnd = _selectionBeforeInput.selectionEnd;

      var _findChangedIndex = (0, _utils.findChangedIndex)(lastValue, value),
          start = _findChangedIndex.start,
          end = _findChangedIndex.end;

      /* don't do anyhting if something got added,
       or if value is empty string (when whole input is cleared)
       or whole input is replace with a number
      */


      if (value.length > lastValue.length || !value.length || start === end || start === 0 && end === lastValue.length || selectionStart === 0 && selectionEnd === lastValue.length) {
        return value;
      }

      //if format got deleted reset the value to last value
      if (this.checkIfFormatGotDeleted(start, end, lastValue)) {
        value = lastValue;
      }

      //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
      //clear all numbers in such case while keeping the - sign
      if (!format) {
        var numericString = this.removeFormatting(value);

        var _splitDecimal2 = (0, _utils.splitDecimal)(numericString, allowNegative),
            beforeDecimal = _splitDecimal2.beforeDecimal,
            afterDecimal = _splitDecimal2.afterDecimal,
            addNegation = _splitDecimal2.addNegation; // eslint-disable-line prefer-const

        //clear only if something got deleted


        var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
        if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === '' && !parseFloat(afterDecimal)) {
          return addNegation ? '-' : '';
        }
      }

      return value;
    }
  }, {
    key: 'onChange',
    value: function onChange(e) {
      e.persist();
      var el = e.target;
      var inputValue = el.value;
      var state = this.state,
          props = this.props;
      var isAllowed = props.isAllowed;

      var lastValue = state.value || '';

      /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
      var currentCaretPosition = Math.max(el.selectionStart, el.selectionEnd);

      inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);

      var formattedValue = this.formatInput(inputValue) || '';
      var numAsString = this.removeFormatting(formattedValue);

      var valueObj = this.getValueObject(formattedValue, numAsString);

      if (!isAllowed(valueObj)) {
        formattedValue = lastValue;
      }

      //set the value imperatively, this is required for IE fix
      el.value = formattedValue;

      //get the caret position
      var caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition);

      //set caret position
      this.setPatchedCaretPosition(el, caretPos, formattedValue);

      //change the state
      if (formattedValue !== lastValue) {
        this.setState({ value: formattedValue, numAsString: numAsString }, function () {
          props.onValueChange(valueObj, e);
          props.onChange(e);
        });
      } else {
        props.onChange(e);
      }
    }
  }, {
    key: 'onBlur',
    value: function onBlur(e) {
      var _this2 = this;

      var props = this.props,
          state = this.state;
      var format = props.format,
          onBlur = props.onBlur;
      var numAsString = state.numAsString;

      var lastValue = state.value;
      if (!format) {
        numAsString = (0, _utils.fixLeadingZero)(numAsString);
        var formattedValue = this.formatNumString(numAsString);

        //change the state
        if (formattedValue !== lastValue) {
          // the event needs to be persisted because its properties can be accessed in an asynchronous way
          e.persist();
          this.setState({ value: formattedValue, numAsString: numAsString }, function () {
            var valueObj = _this2.getValueObject(formattedValue, numAsString);
            props.onValueChange(valueObj, e);
            onBlur(e);
          });
          return;
        }
      }
      onBlur(e);
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      var _this3 = this;

      var el = e.target;
      var key = e.key;
      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          _el$value = el.value,
          value = _el$value === undefined ? '' : _el$value;

      var expectedCaretPosition = void 0;
      var _props11 = this.props,
          decimalScale = _props11.decimalScale,
          fixedDecimalScale = _props11.fixedDecimalScale,
          prefix = _props11.prefix,
          suffix = _props11.suffix,
          format = _props11.format,
          onKeyDown = _props11.onKeyDown,
          onValueChange = _props11.onValueChange;

      var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
      var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
      var negativeRegex = new RegExp('-');
      var isPatternFormat = typeof format === 'string';

      this.selectionBeforeInput = {
        selectionStart: selectionStart,
        selectionEnd: selectionEnd

        //Handle backspace and delete against non numerical/decimal characters or arrow keys
      };if (key === 'ArrowLeft' || key === 'Backspace') {
        expectedCaretPosition = selectionStart - 1;
      } else if (key === 'ArrowRight') {
        expectedCaretPosition = selectionStart + 1;
      } else if (key === 'Delete') {
        expectedCaretPosition = selectionStart;
      }

      //if expectedCaretPosition is not set it means we don't want to Handle keyDown
      //also if multiple characters are selected don't handle
      if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
        onKeyDown(e);
        return;
      }

      var newCaretPosition = expectedCaretPosition;
      var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
      var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;

      if (key === 'ArrowLeft' || key === 'ArrowRight') {
        var direction = key === 'ArrowLeft' ? 'left' : 'right';
        newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
      } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
        while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
          newCaretPosition++;
        }
      } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
        /* NOTE: This is special case when backspace is pressed on a 
        negative value while the cursor position is after prefix. We can't handle it on onChange because
        we will not have any information of keyPress
        */
        if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
          var newValue = value.substring(1);
          var _numAsString2 = this.removeFormatting(newValue);
          var valueObj = this.getValueObject(newValue, _numAsString2);

          this.setState({ value: newValue, numAsString: _numAsString2 }, function () {
            _this3.setPatchedCaretPosition(el, newCaretPosition, newValue);
            onValueChange(valueObj, e);
          });
        } else if (!negativeRegex.test(value[expectedCaretPosition])) {
          while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
            newCaretPosition--;
          }
          newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
        }
      }

      if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
        e.preventDefault();
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }

      /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
              Remove this when you find different solution */
      if (e.isUnitTestRun) {
        this.setPatchedCaretPosition(el, newCaretPosition, value);
      }

      this.props.onKeyDown(e);
    }

    /** required to handle the caret position when click anywhere within the input **/

  }, {
    key: 'onMouseUp',
    value: function onMouseUp(e) {
      var el = e.target;

      /** 
       * NOTE: we have to give default value for value as in case when custom input is provided 
       * value can come as undefined when nothing is provided on value prop.
      */
      var selectionStart = el.selectionStart,
          selectionEnd = el.selectionEnd,
          _el$value2 = el.value,
          value = _el$value2 === undefined ? '' : _el$value2;


      if (selectionStart === selectionEnd) {
        var caretPosition = this.correctCaretPosition(value, selectionStart);
        if (caretPosition !== selectionStart) {
          this.setPatchedCaretPosition(el, caretPosition, value);
        }
      }

      this.props.onMouseUp(e);
    }
  }, {
    key: 'onFocus',
    value: function onFocus(e) {
      var _this4 = this;

      // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
      // (onFocus event target selectionStart is always 0 before setTimeout)
      e.persist();
      setTimeout(function () {
        var el = e.target;
        var selectionStart = el.selectionStart,
            _el$value3 = el.value,
            value = _el$value3 === undefined ? '' : _el$value3;


        var caretPosition = _this4.correctCaretPosition(value, selectionStart);
        if (caretPosition !== selectionStart) {
          _this4.setPatchedCaretPosition(el, caretPosition, value);
        }

        _this4.props.onFocus(e);
      }, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props12 = this.props,
          type = _props12.type,
          displayType = _props12.displayType,
          customInput = _props12.customInput,
          renderText = _props12.renderText,
          getInputRef = _props12.getInputRef;
      var value = this.state.value;


      var otherProps = (0, _utils.omit)(this.props, propTypes);

      var inputProps = (0, _extends3.default)({}, otherProps, {
        type: type,
        value: value,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onMouseUp: this.onMouseUp,
        onFocus: this.onFocus,
        onBlur: this.onBlur
      });

      if (displayType === 'text') {
        return renderText ? renderText(value) || null : _react2.default.createElement(
          'span',
          (0, _extends3.default)({}, otherProps, { ref: getInputRef }),
          value
        );
      } else if (customInput) {
        var CustomInput = customInput;
        return _react2.default.createElement(CustomInput, inputProps);
      }

      return _react2.default.createElement('input', (0, _extends3.default)({}, inputProps, {
        ref: getInputRef
      }));
    }
  }]);
  return NumberFormat;
}(_react2.default.Component);

NumberFormat.propTypes = propTypes;
NumberFormat.defaultProps = defaultProps;

module.exports = NumberFormat;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(968);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(89) && !__webpack_require__(101)(function () {
  return Object.defineProperty(__webpack_require__(417)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(126);
var document = __webpack_require__(71).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(90);
var toIObject = __webpack_require__(102);
var arrayIndexOf = __webpack_require__(970)(false);
var IE_PROTO = __webpack_require__(245)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(420);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 420 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(90);
var toObject = __webpack_require__(175);
var IE_PROTO = __webpack_require__(245)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(87);
var core = __webpack_require__(56);
var fails = __webpack_require__(101);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(982);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(993);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(249);
var $export = __webpack_require__(87);
var redefine = __webpack_require__(425);
var hide = __webpack_require__(100);
var has = __webpack_require__(90);
var Iterators = __webpack_require__(250);
var $iterCreate = __webpack_require__(986);
var setToStringTag = __webpack_require__(252);
var getPrototypeOf = __webpack_require__(421);
var ITERATOR = __webpack_require__(103)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(100);


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(418);
var hiddenKeys = __webpack_require__(247).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(174);
var createDesc = __webpack_require__(172);
var toIObject = __webpack_require__(102);
var toPrimitive = __webpack_require__(242);
var has = __webpack_require__(90);
var IE8_DOM_DEFINE = __webpack_require__(416);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(89) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Value = exports.Creatable = exports.AsyncCreatable = exports.Async = undefined;

var _Select = __webpack_require__(176);

var _Select2 = _interopRequireDefault(_Select);

var _Async = __webpack_require__(433);

var _Async2 = _interopRequireDefault(_Async);

var _AsyncCreatable = __webpack_require__(1019);

var _AsyncCreatable2 = _interopRequireDefault(_AsyncCreatable);

var _Creatable = __webpack_require__(434);

var _Creatable2 = _interopRequireDefault(_Creatable);

var _Value = __webpack_require__(432);

var _Value2 = _interopRequireDefault(_Value);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_Select2.default.Async = _Async2.default;
_Select2.default.AsyncCreatable = _AsyncCreatable2.default;
_Select2.default.Creatable = _Creatable2.default;
_Select2.default.Value = _Value2.default;

exports.default = _Select2.default;
exports.Async = _Async2.default;
exports.AsyncCreatable = _AsyncCreatable2.default;
exports.Creatable = _Creatable2.default;
exports.Value = _Value2.default;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _stripDiacritics = __webpack_require__(430);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function filterOptions(options, filterValue, excludeOptions, props) {
	var _this = this;

	if (props.ignoreAccents) {
		filterValue = (0, _stripDiacritics2.default)(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(_this, option, filterValue);
		if (!filterValue) return true;
		var valueTest = String(option[props.valueKey]);
		var labelTest = String(option[props.labelKey]);
		if (props.ignoreAccents) {
			if (props.matchProp !== 'label') valueTest = (0, _stripDiacritics2.default)(valueTest);
			if (props.matchProp !== 'value') labelTest = (0, _stripDiacritics2.default)(labelTest);
		}
		if (props.ignoreCase) {
			if (props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}
		return props.matchPos === 'start' ? props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
}

exports.default = filterOptions;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = stripDiacritics;
var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    instancePrefix = _ref.instancePrefix,
	    labelKey = _ref.labelKey,
	    onFocus = _ref.onFocus,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey,
	    onOptionRef = _ref.onOptionRef;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.indexOf(option) > -1;
		var isFocused = option === focusedOption;
		var optionClass = (0, _classnames2.default)(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return _react2.default.createElement(
			Option,
			{
				className: optionClass,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				}
			},
			optionRenderer(option, i)
		);
	});
}

exports.default = menuRenderer;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Value = function (_React$Component) {
	_inherits(Value, _React$Component);

	function Value(props) {
		_classCallCheck(this, Value);

		var _this = _possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	_createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return _react2.default.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? _react2.default.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : _react2.default.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: (0, _classnames2.default)('Select-value', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);

	return Value;
}(_react2.default.Component);

;

Value.propTypes = {
	children: _propTypes2.default.node,
	disabled: _propTypes2.default.bool, // disabled prop passed to ReactSelect
	id: _propTypes2.default.string, // Unique id for the value - used for aria
	onClick: _propTypes2.default.func, // method to handle click on value label
	onRemove: _propTypes2.default.func, // method to handle removal of the value
	value: _propTypes2.default.object.isRequired // the option object for this value
};

exports.default = Value;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(176);

var _Select2 = _interopRequireDefault(_Select);

var _stripDiacritics = __webpack_require__(430);

var _stripDiacritics2 = _interopRequireDefault(_stripDiacritics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
	autoload: _propTypes2.default.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: _propTypes2.default.any, // object to use to cache results; set to null/false to disable caching
	children: _propTypes2.default.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: _propTypes2.default.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: _propTypes2.default.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: _propTypes2.default.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: _propTypes2.default.oneOfType([// replaces the placeholder while options are loading
	_propTypes2.default.string, _propTypes2.default.node]),
	multi: _propTypes2.default.bool, // multi-value input
	noResultsText: _propTypes2.default.oneOfType([// field noResultsText, displayed when no options come back from the server
	_propTypes2.default.string, _propTypes2.default.node]),
	onChange: _propTypes2.default.func, // onChange handler: function (newValue) {}
	onInputChange: _propTypes2.default.func, // optional for keeping track of what is being typed
	options: _propTypes2.default.array.isRequired, // array of options
	placeholder: _propTypes2.default.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	_propTypes2.default.string, _propTypes2.default.node]),
	searchPromptText: _propTypes2.default.oneOfType([// label to prompt for search input
	_propTypes2.default.string, _propTypes2.default.node]),
	value: _propTypes2.default.any // initial field value
};

var defaultCache = {};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	_inherits(Async, _Component);

	function Async(props, context) {
		_classCallCheck(this, Async);

		var _this = _possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	_createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this.setState({
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				if (callback === _this2._callback) {
					_this2._callback = null;

					var options = data && data.options || [];

					if (cache) {
						cache[inputValue] = options;
					}

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var transformedInputValue = inputValue;

			if (ignoreAccents) {
				transformedInputValue = (0, _stripDiacritics2.default)(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			if (onInputChange) {
				onInputChange(transformedInputValue);
			}

			this.setState({ inputValue: inputValue });
			this.loadOptions(transformedInputValue);

			// Return the original input value to avoid modifying the user's view of the input while typing.
			return inputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    multi = _props3.multi,
			    onChange = _props3.onChange,
			    placeholder = _props3.placeholder,
			    value = _props3.value;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);

	return Async;
}(_react.Component);

exports.default = Async;


Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

function defaultChildren(props) {
	return _react2.default.createElement(_Select2.default, props);
}

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = __webpack_require__(176);

var _Select2 = _interopRequireDefault(_Select);

var _defaultFilterOptions = __webpack_require__(429);

var _defaultFilterOptions2 = _interopRequireDefault(_defaultFilterOptions);

var _defaultMenuRenderer = __webpack_require__(431);

var _defaultMenuRenderer2 = _interopRequireDefault(_defaultMenuRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatableSelect = function (_React$Component) {
	_inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		_classCallCheck(this, CreatableSelect);

		var _this = _possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	_createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options,
			    shouldKeyDownEventCreateNewOption = _props.shouldKeyDownEventCreateNewOption;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions() {
			var _props2 = this.props,
			    filterOptions = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    options = _props2.options,
			    promptTextCreator = _props2.promptTextCreator;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					filteredOptions.unshift(this._createPlaceholderOption);
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.select.filterOptions();

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer(params) {
			var menuRenderer = this.props.menuRenderer;


			return menuRenderer(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;


			if (onInputChange) {
				onInputChange(input);
			}

			// This value may be needed in between Select mounts (when this.select is null)
			this.inputValue = input;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption({ keyCode: event.keyCode })) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option, event) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    newOptionCreator = _props4.newOptionCreator,
			    shouldKeyDownEventCreateNewOption = _props4.shouldKeyDownEventCreateNewOption,
			    restProps = _objectWithoutProperties(_props4, ['newOptionCreator', 'shouldKeyDownEventCreateNewOption']);

			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
				}
			});

			return children(props);
		}
	}]);

	return CreatableSelect;
}(_react2.default.Component);

;

function defaultChildren(props) {
	return _react2.default.createElement(_Select2.default, props);
};

function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

function isValidNewOption(_ref4) {
	var label = _ref4.label;

	return !!label;
};

function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';
	return option;
};

function promptTextCreator(label) {
	return 'Create option "' + label + '"';
}

function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
	}

	return false;
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: _defaultFilterOptions2.default,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: _defaultMenuRenderer2.default,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: _propTypes2.default.func,

	// See Select.propTypes.filterOptions
	filterOptions: _propTypes2.default.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: _propTypes2.default.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: _propTypes2.default.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: _propTypes2.default.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: _propTypes2.default.func,

	// input change handler: function (inputValue) {}
	onInputChange: _propTypes2.default.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: _propTypes2.default.func,

	// new option click handler: function (option) {}
	onNewOptionClick: _propTypes2.default.func,

	// See Select.propTypes.options
	options: _propTypes2.default.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: _propTypes2.default.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: _propTypes2.default.func
};

exports.default = CreatableSelect;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

var replacements = {

  /**
   * Between replacement (replaces :min and :max)
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  between: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      min: parameters[0],
      max: parameters[1]
    });
  },

  /**
   * Required_if replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_if: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      other: this._getAttributeName(parameters[0]),
      value: parameters[1]
    });
  },

  /**
   * Required_unless replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_unless: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      other: this._getAttributeName(parameters[0]),
      value: parameters[1]
    });
  },

  /**
   * Required_with replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_with: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      field: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Required_with_all replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_with_all: function(template, rule) {
    var parameters = rule.getParameters();
    var getAttributeName = this._getAttributeName.bind(this);
    return this._replacePlaceholders(rule, template, {
      fields: parameters.map(getAttributeName).join(', ')
    });
  },

  /**
   * Required_without replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_without: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      field: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Required_without_all replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  required_without_all: function(template, rule) {
    var parameters = rule.getParameters();
    var getAttributeName = this._getAttributeName.bind(this);
    return this._replacePlaceholders(rule, template, {
      fields: parameters.map(getAttributeName).join(', ')
    });
  },

 /**
   * After replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  after: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      after: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Before replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  before: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      before: this._getAttributeName(parameters[0])
    });
  },

  /**
   * After_or_equal replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  after_or_equal: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      after_or_equal: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Before_or_equal replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  before_or_equal: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      before_or_equal: this._getAttributeName(parameters[0])
    });
  },

  /**
   * Same replacement.
   *
   * @param  {string} template
   * @param  {Rule} rule
   * @return {string}
   */
  same: function(template, rule) {
    var parameters = rule.getParameters();
    return this._replacePlaceholders(rule, template, {
      same: this._getAttributeName(parameters[0])
    });
  },
};

function formatter(attribute) {
  return attribute.replace(/[_\[]/g, ' ').replace(/]/g, '');
}

module.exports = {
  replacements: replacements,
  formatter: formatter
};


/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Das :attribute Feld muss akzeptiert werden.',
  after: 'Das :attribute muss ein Datum nach dem :after sein.',
  after_or_equal: 'Das :attribute Datum muss kleiner oder gleich dem :after_or_equal sein.',
  alpha: 'Das :attribute Feld darf nur aus Buchstaben bestehen.',
  alpha_dash: 'Das :attribute Feld darf nur aus Buchstaben, Zahlen, Binde- und Unterstrichen bestehen.',
  alpha_num: 'Das :attribute Feld darf nur aus Buchstaben und Zahlen bestehen.',
  before: 'Das :attribute muss ein Datum vor dem :before sein.',
  before_or_equal: 'Das :attribute Datum muss größer oder gleich dem :before_or_equal sein.',
  between: 'Das :attribute Feld muss zwischen :min und :max liegen.',
  confirmed: 'Das :attribute Feld stimmt nicht mit der Bestätigung überein.',
  email: 'Das :attribute Format ist ungültig.',
  date: 'Das :attribute Feld muss ein gültiges Datum sein.',
  def: 'Das :attribute Feld hat Fehler.',
  digits: 'Das :attribute Feld muss :digits Stellen haben.',
  different: 'Die Felder :attribute und :different müssen sich unterscheiden.',
  'in': 'Der gewählte Wert für :attribute ist ungültig.',
  integer: 'Das :attribute Feld muss eine ganze Zahl sein.',
  min: {
    numeric: 'Das :attribute Feld muss mindestens :min sein.',
    string: 'Das :attribute Feld muss mindestens :min Zeichen lang sein.'
  },
  max: {
    numeric: 'Das :attribute Feld darf maximal :max sein.',
    string: 'Das :attribute Feld darf maximal :max Zeichen haben.'
  },
  not_in: 'Der gewählte Wert für :attribute ist ungültig.',
  numeric: 'Das :attribute Feld muss eine Zahl sein.',
  present: 'Das Feld :attribute muss vorhanden sein (kann aber leer sein).',
  required: 'Das :attribute Feld muss ausgefüllt sein.',
  required_if: 'Das :attribute Feld muss ausgefüllt sein, wenn :other :value ist.',
  same: 'Die Felder :attribute und :same müssen übereinstimmen.',
  size: {
    numeric: 'Das :attribute Feld muss gleich :size sein.',
    string: 'Das :attribute Feld muss :size Zeichen lang sein.'
  },
  string: 'Das :attribute Feld muss ein Satz sein.',
  url: 'Das Format von :attribute ist ungültig.',
  regex: 'Das :attribute Format ist ungültig.',
  attributes: {}
};


/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Το πεδίο :attribute πρέπει να γίνει αποδεκτό.',
  after: 'Το πεδίο :attribute πρέπει να είναι μία ημερομηνία μετά από :after.',
  alpha: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα.',
  alpha_dash: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα, αριθμούς, και παύλες.',
  alpha_num: 'Το πεδίο :attribute μπορεί να περιέχει μόνο γράμματα και αριθμούς.',
  between: 'Το πεδίο :attribute πρέπει να είναι μεταξύ :min και :max.',
  confirmed: 'Η επιβεβαίωση του :attribute δεν ταιριάζει.',
  email: 'Το πεδίο :attribute πρέπει να είναι μία έγκυρη διεύθυνση email.',
  date: 'Το πεδίο :attribute δεν είναι έγκυρη ημερομηνία.',
  def: 'Το πεδίο :attribute περιέχει σφάλματα.',
  digits: 'Το πεδίο :attribute πρέπει να είναι :digits ψηφία.',
  different: 'Το πεδίο :attribute  και :different πρέπει να είναι διαφορετικά.',
  'in': 'Το επιλεγμένο :attribute δεν είναι έγκυρο.',
  integer: 'Το πεδίο :attribute πρέπει να είναι ακέραιος.',
  min: {
    numeric: 'Το πεδίο :attribute πρέπει να είναι τουλάχιστον :min.',
    string: 'Το πεδίο :attribute πρέπει να έχει τουλάχιστον :min χαρακτήρες.'
  },
  max: {
    numeric: 'Το πεδίο :attribute δεν μπορεί να είναι μεγαλύτερο από :max.',
    string: 'Το πεδίο :attribute δεν μπορεί να έχει περισσότερους από :max χαρακτήρες.'
  },
  not_in: 'Το επιλεγμένο :attribute δεν είναι αποδεκτό.',
  numeric: 'Το πεδίο :attribute πρέπει να είναι αριθμός.',
  present: 'The :attribute field must be present (but can be empty).',
  required: 'Το πεδίο :attribute είναι απαραίτητο.',
  required_if: 'Το πεδίο :attribute είναι απαραίτητο όταν το πεδίο :other είναι :value.',
  same: 'Τα πεδία :attribute και :same πρέπει να είναι ίδια.',
  size: {
    numeric: 'Το πεδίο :attribute πρέπει να είναι :size.',
    string: 'Το πεδίο :attribute πρέπει να είναι :size χαρακτήρες.'
  },
  string: 'Το πεδίο :attribute πρέπει να είναι αλφαριθμητικό.',
  url: 'Το πεδίο :attribute δεν είναι έγκυρη διεύθυνση URL.',
  regex: 'Η μορφή του :attribute δεν είναι αποδεκτή.',
  attributes: {}
};


/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'El campo :attribute debe ser aceptado.',
  after: 'El campo :attribute debe ser una fecha posterior a :after.',
  alpha: 'El campo :attribute solo debe contener letras.',
  alpha_dash: 'El campo :attribute solo debe contener letras, números y guiones.',
  alpha_num: 'El campo :attribute solo debe contener letras y números.',
  attributes: {},
  between: 'El campo :attribute tiene que estar entre :min - :max.',
  confirmed: 'La confirmación de :attribute no coincide.',
  different: 'El campo :attribute y :other deben ser diferentes.',
  digits: 'El campo :attribute debe tener :digits dígitos.',
  email: 'El campo :attribute no es un correo válido.',
  'in': 'El campo :attribute es inválido.',
  integer: 'El campo :attribute debe ser un número entero.',
  max: {
    numeric: 'El campo :attribute no debe ser mayor a :max.',
    string: 'El campo :attribute no debe ser mayor que :max caracteres.'
  },
  min: {
    numeric: 'El tamaño del campo :attribute debe ser de al menos :min.',
    string: 'El campo :attribute debe contener al menos :min caracteres.'
  },
  not_in: 'El campo :attribute es inválido.',
  numeric: 'El campo :attribute debe ser numérico.',
  present: 'El campo de :attribute debe estar presente (pero puede estar vacío).',
  regex: 'El formato del campo :attribute es inválido.',
  required: 'El campo :attribute es obligatorio.',
  required_if: 'El campo :attribute es obligatorio cuando :other es :value.',
  same: 'El campo :attribute y :other deben coincidir.',
  size: {
    numeric: 'El tamaño del campo :attribute debe ser :size.',
    string: 'El campo :attribute debe contener :size caracteres.'
  },
  url: 'El formato de :attribute es inválido.'
};


/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'فیلد :attribute می بایست تایید شود',
  alpha: 'فیلد :attribute می بایست فقط شامل حروف انگلیسی باشد',
  alpha_dash: 'فیلد :attribute می بایست فقط شامل حروف انگلیسی و خط تیره و زیرخط باشد',
  alpha_num: 'فیلد :attribute می بایست فقط شامل حروف و اعداد باشد',
  between: 'فیلد :attribute می بایست بزرگتر از :min و کوچکتر از :max باشد',
  confirmed: 'تطبیق فیلد :attribute صحیح نمی باشد',
  email: 'فرمت ایمیل وارد شده در :attribute صحیح نمی‌باشد',
  date: 'تاریخ درج شده در فیلد :attribute صحیح نیست',
  def: 'فیلد :attribute اشکال دارد',
  digits: 'فیلد :attribute می بایست شامل :digits رقم باشد',
  different: 'فیلد :attribute می بایست مقداری غیر از :different داشته باشد',
  'in': 'فیلد :attribute انتخاب شده صحیح نمی باشد',
  integer: 'فیلد :attribute می بایست عددی باشد',
  min: {
    numeric: 'فیلد :attribute می بایست از :min بزرگتر باشد',
    string: 'فیلد :attribute بایستی حداقل :min کاراکتر طول داشته باشد'
  },
  max: {
    numeric: 'فیلد :attribute می بایست از :max کوچکتر باشد',
    string: 'فیلد :attribute نباید بیشتر از :max کاراکتر طول داشته باشد'
  },
  not_in: 'فیلد :attribute انتخاب شده صحیح نمی باشد',
  numeric: 'فیلد :attribute می بایست عددی باشد',
  present: 'The :attribute field must be present (but can be empty).',
  required: 'فیلد :attribute الزامی است',
  required_if: 'در صورت دادن :value به :other تکمیل فیلد :attribute الزامی است',
  same: 'فیلد :attribute می بایست با فیلد :same یکی باشد',
  size: {
    numeric: 'فیلد :attribute می بایست :size باشد',
    string: 'فیلد :attribute می بایست :size کاراکتر طول داشته باشد'
  },
  string: 'فیلد :attribute می بایست متنی باشد',
  url: 'آدرس فیلد :attribute صحیح نمی باشد',
  regex: 'فرمت آدرس :attribute صحیح نمی باشد',
  attributes: {}
};


/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Le champ :attribute doit être accepté.',
  alpha: 'Le champ :attribute ne peut contenir que des caractères alphabétiques.',
  alpha_dash: 'Le champ :attribute ne peut contenir que des caractères alphanumériques, des tirets et des underscores.',
  alpha_num: 'Le champ :attribute ne peut contenir que des caractères alphanumériques.',
  between: 'La longueur du champ :attribute doit être comprise entre :min and :max.',
  confirmed: 'Le champ :attribute n\'est pas confirmé.',
  email: 'Le champ :attribute contient un format invalide.',
  def: 'Le champ :attribute contient un attribut erroné.',
  digits: 'Le champ :attribute doit être composé de :digits chiffres.',
  different: 'Les champs :attribute et :different doivent être différents.',
  'in': 'Le champ :attribute est invalide.',
  integer: 'Le champ :attribute doit être un entier.',
  min: {
    numeric: 'Le champ :attribute doit être supérieur à :min.',
    string: 'Le champ :attribute doit contenir plus de :min caractères.'
  },
  max: {
    numeric: 'Le champ :attribute doit être inférieur à :max.',
    string: 'Le champ :attribute doit contenir moins de :max caractères.'
  },
  not_in: 'Le champ :attribute est invalide.',
  numeric: 'Le champ :attribute doit être un chiffre.',
  present: 'Le champ :attribute doit être présent (mais peut être vide).',
  required: 'Le champ :attribute est requis.',
  required_if: 'Le champ :attribute est requis quand :other est :value.',
  same: 'Les champs :attribute et :same doivent correspondre.',
  size: {
    numeric: 'Le champ :attribute doit être égal à :size.',
    string: 'Le champ :attribute doit contenir :size caractères.'
  },
  url: 'Le format du champ :attribute est invalide.',
  regex: 'Le format du champ :attribute est invalide.',
  attributes: {}
};


/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Il campo :attribute deve essere accettato.',
  alpha: 'Il campo :attribute deve contenere sono caratteri alfabetici.',
  alpha_dash: 'Il campo :attribute può contenere solo caratteri alfanumerici oltre a trattini e trattini bassi.',
  alpha_num: 'Il campo :attribute deve essere alfanumerico.',
  between: 'Il campo :attribute deve essere compreso tra :min e :max.',
  confirmed: 'Il campo conferma :attribute non è uguale.',
  email: 'Il formato dell\'attributo :attribute non è valido.',
  def: 'Gli attributi del campo :attribute contengono degli errori.',
  digits: 'Il campo :attribute deve essere di :digits cifre.',
  different: 'Il campo :attribute e :different devo essere diversi.',
  'in': 'Il valore del campo :attribute non è valido.',
  integer: 'Il campo :attribute deve essere un valore intero.',
  min: {
    numeric: 'Il campo :attribute deve essere maggiore o uguale di :min.',
    string: 'Il campo :attribute deve essere composto da almeno :min caratteri.'
  },
  max: {
    numeric: 'Il campo :attribute deve essere minore o uguale di :max.',
    string: 'Il campo :attribute deve essere composto da massimo :max caratteri.'
  },
  not_in: 'Il campo :attribute non è valido.',
  numeric: 'Il campo :attribute deve essere un numero.',
  present: 'Il campo :attribute deve essere presente (ma può essere vuoto).',
  required: 'Il campo :attribute è richiesto.',
  required_if: 'Il campo :attribute è richiesto quando il campo :other è uguale a :value.',
  same: 'I campi :attribute e :same devono essere uguali.',
  size: {
    numeric: 'La dimensione del campo :attribute deve essere uguale a :size.',
    string: 'Il campo :attribute deve essere di :size caratteri.'
  },
  string: 'Il campo :attribute deve essere una stringa.',
  url: 'Il formato del campo :attribute non è valido.',
  regex: 'Il formato del campo :attribute non è valido.',
  attributes: {}
};


/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = {
    accepted: ':attributeを確認してください。',
    alpha: ':attributeは英字のみで入力してください。',
    alpha_dash: ':attributeは英字とダッシュと下線のみで入力してください。',
    alpha_num: ':attributeは英数字のみで入力してください。',
    between: ':attributeは:min〜:max文字で入力してください。',
    confirmed: ':attributeは確認が一致しません。',
    email: ':attributeは正しいメールアドレスを入力してください。',
    date: ':attributeは正しい日付形式を入力してください',
    def: ':attributeは検証エラーが含まれています。',
    digits: ':attributeは:digitsの数字のみで入力してください。',
    different: ':attributeと:differentは同じであってはなりません。',
    'in': '選択された:attributeは無効です。',
    integer: ':attributeは整数で入力してください。',
    min        : {
        numeric : ":attributeは:min以上で入力してください。",
        string  : ":attributeは:min文字以上で入力してください。"
    },
    max : {
        numeric : ":attributeは:max以下で入力してください。",
        string  : ":attributeは:max文字以下で入力してください。"
    },
    not_in      : "選択された:attributeは無効です。",
    numeric     : ":attributeは数値で入力してください。",
    present: 'The :attribute field must be present (but can be empty).',
    required    : ":attributeは必須です。",
    required_if : ":otherは:valueになったら:attributeは必須です。",
    same        : ":attributeと:sameは同じでなければなりません。",
    size        : {
        numeric : ":attributeは:sizeを入力してください。",
        string  : ":attributeは:size文字で入力してください。"
    },
    url        : ":attributeは正しいURIを入力してください。",
    regex      : ":attributeの値 \":value\" はパターンにマッチする必要があります。",
    attributes : {}
};


/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute må være akseptert.',
  alpha: ':attribute feltet kan kun inneholde alfabetiske tegn.',
  alpha_dash: ':attribute feltet kan kun inneholde alfanumeriske tegn, i tillegg til bindestreker og understreker.',
  alpha_num: ':attribute feltet må være alfanumerisk.',
  between: ':attribute feltet må være mellom :min og :max.',
  confirmed: ':attribute feltet stemmer ikke overens med bekreftelsen.',
  email: ':attribute formatet er ugyldig.',
  date: ':attribute er et ugyldig datoformat.',
  def: ':attribute attributtet har feil.',
  digits: ':attribute må være på :digits siffer.',
  different: ':attribute og :different må være forskjellige.',
  'in': 'Den oppgitte verdien for :attribute er ugyldig.',
  integer: ':attribute må være et heltall.',
  min: {
    numeric: ':attribute må minst være :min.',
    string: ':attribute må være på minst :min tegn.'
  },
  max: {
    numeric: ':attribute kan ikke være større enn :max.',
    string: ':attribute kan maks ha :max tegn.'
  },
  'not_in': 'Den oppgitte verdien for :attribute er ugyldig.',
  numeric: ':attribute må være et tall.',
  present: 'The :attribute field must be present (but can be empty).',
  required: ':attribute feltet er påkrevd.',
  required_if: ':attribute er påkrevd når :other er :value.',
  same: ':attribute og :same må være like.',
  size: {
    numeric: ':attribute må ha størrelsen :size.',
    string: ':attribute må ha :size tegn.'
  },
  string: ':attribute må være tekst.',
  url: ':attribute formatet er ugyldig.',
  regex: ':attribute formatet er ugyldig.',
  attributes: {}
};


/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Het :attribute veld moet geaccepteerd worden.',
  after: ':attribute moet een datum na :after zijn.',
  after_or_equal: 'De :attribute datum moet op of na :after_or_equal zijn.',
  alpha: 'Het :attribute veld mag alleen maar letters bevatten.',
  alpha_dash: 'Het :attribute veld mag alleen maar letters, cijfers en (liggende) streepjes bevatten.',
  alpha_num: 'Het :attribute veld mag alleen maar letters en cijfers bevatten.',
  before: ':attribute moet vòòr :before zijn.',
  before_or_equal: ':attribute moet vòòr of op :before_or_equal zijn.',
  between: 'Het :attribute veld moet tussen :min en :max liggen.',
  confirmed: 'Het :attribute veld komt niet met de bevestiging overeen.',
  email: 'Het :attribute formaat is ongeldig.',
  date: 'Het :attribute veld moet een geldige datum zijn.',
  def: 'Het :attribute veld bevat fouten.',
  digits: 'Het :attribute veld moet :digits cijfers hebben.',
  different: 'Het :attribute en :different veld moeten verschillend zijn.',
  'in': 'De gekozen waarde voor :attribute is ongeldig.',
  integer: 'Het :attribute veld moet een geheel getal zijn.',
  min: {
    numeric: 'Het :attribute veld moet minstens :min zijn.',
    string: 'Het :attribute veld moet minstens :min karakters bevatten.'
  },
  max: {
    numeric: 'Het :attribute veld mag maximaal :max zijn.',
    string: 'Het :attribute veld mag niet meer dan :max karakters bevatten.'
  },
  not_in: 'De gekozen waarde voor :attribute is ongeldig.',
  numeric: 'Het :attribute veld moet een getal zijn.',
  present: 'Het :attribute veld moet aanwezig zijn (maar mag leeg zijn).',
  required: 'Het :attribute veld moet ingevuld zijn.',
  required_if: 'Het :attribute veld moet ingevuld zijn, wanneer :other :value is.',
  required_unless: 'Het :attribute veld moet ingevuld zijn, wanneer :other niet :value is.',
  required_with: 'Het :attribute veld moet ingevuld zijn, wanneer :field niet leeg is.',
  required_with_all: 'Het :attribute veld moet ingevuld zijn, wanneer :fields niet leeg zijn.',
  required_without: 'Het :attribute veld moet ingevuld zijn, wanneer :field leeg is.',
  required_without_all: 'Het :attribute veld moet ingevuld zijn, wanneer :fields leeg zijn.',
  same: 'De :attribute en :same velden moeten overeenkomen.',
  size: {
    numeric: 'Het :attribute veld moet :size zijn.',
    string: 'Het :attribute veld moet :size karakters bevatten.'
  },
  string: 'Het :attribute veld moet een woord of zin zijn.',
  url: 'Het :attribute veld heeft een ongeldig formaat.',
  regex: 'Het :attribute veld heeft een ongeldig formaat.',
  attributes: {}
};


/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = {
    accepted: 'Pole :attribute musi być zaakceptowane.',
    alpha: 'Pole :attribute może zawierać tylko litery.',
    alpha_dash: 'Pole :attribute moze zawierać tylko litery, myślnik i podrkeślenie.',
    alpha_num: 'Pole :attribute moze zawierac tylko znaki alfanumeryczne.',
    between: 'Pole :attribute musi mieć długość od :min do :max.',
    confirmed: 'Pole :attribute nie spełnia warunku potwierdzenia.',
    email: 'Pole :attribute ma niepoprawny format adresu email.',
    date: 'Pole :attribute musi mieć poprawny format daty.',
    def: 'Pole :attribute zawiera błędy.',
    digits: 'Pole :attribute może zawierać tylko cyfry ze zbioru :digits.',
    different: 'Pola :attribute i :different muszą się różnić.',
    'in': 'Pole :attribute musi należeć do zbioru :in.',
    integer: 'Pole :attribute musi być liczbą całkowitą.',
    min: {
        numeric: 'Pole :attribute musi być równe conajmniej :min.',
        string: 'Pole :attribute musi zawierać conajmniej :min znaków.'
    },
    max: {
        numeric: 'Pole :attribute nie moze być większe :max.',
        string: 'Pole :attribute nie moze być dłuższe niż :max znaków.'
    },
    not_in: 'Pole :attribute nie może należeć do zbioru :not_in.',
    numeric: 'Pole :attribute musi być liczbą.',
    present: 'Polu :attribute musi być obecny (ale może być pusta).',
    required: 'Pole :attribute jest wymagane.',
    required_if: 'Pole :attribute jest wymagane jeśli pole :other jest równe :value.',
    same: 'Pola :attribute i :same muszą być takie same.',
    size: {
        numeric: 'Pole :attribute musi być równe :size.',
        string: 'Pole :attribute musi zawierać :size znaków.'
    },
    string: 'Pole :attribute musi być ciągiem znaków.',
    url: 'Pole :attribute musi być poprawnym adresem URL.',
    regex: 'Pole :attribute nie spełnia warunku.',
    attributes: {}
};


/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'O :attribute precisa ser aceito.',
  alpha: 'O campo :attribute só pode conter letras.',
  alpha_dash: 'O campo :attribute só pode conter letras, números, hífens e sublinha.',
  alpha_num: 'O campo :attribute só pode conter letras e números.',
  between: 'O campo :attribute precisa estar entre :min e :max.',
  confirmed: 'A confirmação de :attribute não coincide.',
  email: 'O formato de :attribute é inválido.',
  date: 'O :attribute não é um formato de data válido',
  def: 'O atributo :attribute contém erros.',
  digits: 'O atributo :attribute precisa ter :digits dígitos.',
  different: 'O :attribute e :different precisam ser diferentes.',
  'in': 'O atributo selecionado :attribute é inválido.',
  integer: 'O :attribute precisa ser um inteiro.',
  min: {
    numeric: 'O :attribute precisa ser no mínimo :min.',
    string: 'O :attribute precisa ter no mínimo :min caracteres.'
  },
  max: {
    numeric: 'O :attribute não pode ser maior que :max.',
    string: 'O :attribute não pode ter mais que :max caracteres.'
  },
  not_in: 'O :attribute selecionado é inválido.',
  numeric: 'O :attribute precisa ser um número.',
  present: 'O campo :attribute deve estar presente (mas pode estar vazio).',
  required: 'O campo :attribute é obrigatório.',
  required_if: 'O campo :attribute é obrigatório quando :other é :value.',
  same: 'Os campos :attribute e :same precisam ser iguais.',
  size: {
    numeric: 'O :attribute precisa ser :size.',
    string: 'O :attribute precisa ter :size caracteres.'
  },
  string: 'O :attribute precisa ser uma palavra.',
  url: 'O formato de :attribute é inválido.',
  regex: 'O formato de :attribute é inválido.',
  attributes: {}
};


/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = {
  accepted: 'Вы должны принять :attribute.',
  alpha: 'Поле :attribute может содержать только буквы.',
  alpha_dash: 'Поле :attribute может содержать только буквы, цифры, дефисы и символы подчёркивания.',
  alpha_num: 'Поле :attribute может содержать только буквы и цифры.',
  between: 'Поле :attribute должно быть между :min и :max.',
  confirmed: 'Поле :attribute не совпадает с подтверждением.',
  email: 'Поле :attribute должно быть действительным электронным адресом.',
  def: 'Поле :attribute содержит ошибки.',
  digits: 'Длина цифрового поля :attribute должна быть :digits.',
  different: 'Поля :attribute и :different должны различаться.',
  'in': 'Выбранное значение для :attribute ошибочно.',
  integer: 'Поле :attribute должно быть целым числом.',
  min: {
    numeric: 'Значение поля :attribute должно быть больше или равно :min.',
    string: 'Количество символов в поле :attribute должно быть не менее :min.'
  },
  max: {
    numeric: 'Значение поля :attribute должно быть меньше или равно :max.',
    string: 'Количество символов в поле :attribute не может превышать :max.'
  },
  not_in: 'Выбранное значение для :attribute ошибочно.',
  numeric: 'Поле :attribute должно быть числом.',
  present: 'Поле :attribute должно присутствовать (но может быть пустым).',
  required: 'Поле :attribute обязательно для заполнения.',
  required_if: 'Поле :attribute требуется когда значения поля :other равно :value.',
  same: 'Значение :attribute должно совпадать с :same.',
  size: {
    numeric: 'Значение поля :attribute должно быть равным :size.',
    string: 'Количество символов в поле :attribute должно быть равно :size.'
  },
  url: 'Поле :attribute должно содержать валидный URL.',
  regex: 'Неверный формат поля :attribute.',
  attributes: {}
};


/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute kabul edilmeli.',
  alpha: ':attribute alanı sadece harflerden oluşabilir.',
  alpha_dash: ':attribute alanı sadece alfa-nümerik, tire ve alt çizgi karakterlerden oluşabilir.',
  alpha_num: ':attribute alanı alfa-nümerik olmalıdır.',
  between: ':attribute alanı :min ile :max arasında olabilir.',
  confirmed: ':attribute uyuşmuyor.',
  email: ':attribute formatı geçersiz.',
  date: ':attribute geöerli bir tarih alanı değil.',
  def: ':attribute hatalar içeriyor.',
  digits: ':attribute sadece rakamlardan oluşabilir.',
  different: ':attribute ve :different farklı olmalı.',
  'in': 'Seçilen :attribute geçerli değil.',
  integer: ':attribute tam sayı olmalı.',
  min: {
    numeric: ':attribute en az :min olmalı.',
    string: ':attribute en az :min karakter uzunluğunda olmalı.'
  },
  max: {
    numeric: ':attribute en çok :max olabilir.',
    string: ':attribute uzunluğu en çok :max karakter uzunluğunda olabilir.'
  },
  not_in: 'Seçilen :attribute geçerli değil.',
  numeric: ':attribute sayı olmalı.',
  present: ':attribute alanı bulunmalıdır (ancak boş olabilir).',
  required: ':attribute alanı gerekli.',
  required_if: ':attribute alanı :other alanı :value olduğunda gerekli.',
  same: ':attribute ve :same aynı olmalı.',
  size: {
    numeric: ':attribute :size olmalı.',
    string: ':attribute :size karakter uzunluğunda olmalı.'
  },
  string: ':attribute alfa-numerik olmalı.',
  url: ':attribute formatı geçersiz.',
  regex: ':attribute formatı geçersiz.',
  attributes: {}
};


/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute повиннен бути прийнятий.',
  alpha: 'Поле :attribute може складатись тільки з літер.',
  alpha_dash: 'Поле :attribute може складатись тільки з літер, чисел, дефісів та символів підкреслення.',
  alpha_num: 'Поле :attribute може складатись тільки з літер та чисел.',
  between: 'Значення поля :attribute повинно знаходитись між :min і :max.',
  confirmed: 'Поле :attribute не співпадає з підтвердженням.',
  email: 'Значення поля :attribute повинно бути існуючою електронною адресою.',
  def: 'Поле :attribute містить помилки.',
  digits: 'Довжина числового поля :attribute повинна бути :digits.',
  different: 'Поля :attribute і :different повинні відрізнятись.',
  'in': 'Обране значення для :attribute помилкове.',
  integer: 'Значення поля :attribute повинно бути цілим числом.',
  min: {
    numeric: 'Значення поля :attribute повинно бути більшим або рівним :min.',
    string: 'Кількість символів в полі :attribute повинна бути не менше :min.'
  },
  max: {
    numeric: 'Значення поля :attribute повинно бути менше або рівне :max.',
    string: 'Кількість символів в полі :attribute не може превищувати :max.'
  },
  not_in: 'Обране значення для :attribute помилкове.',
  numeric: 'Значення поля :attribute повинно бути числом.',
  present: 'Поле :attribute повинно бути присутнім (але може бути пустим).',
  required: 'Поле :attribute обов\'язкове для заповнення.',
  required_if: 'Поле :attribute потрібне у випадку коли значення поля :other рівне :value.',
  same: 'Значеня поля :attribute повинно співпадати з :same.',
  size: {
    numeric: 'Значення поля :attribute повинно бути рівним :size.',
    string: 'Кількість символів в полі :attribute повинна бути рівною :size.'
  },
  url: 'Поле :attribute повинне містити валідний URL.',
  regex: 'Неправильний формат значення :attribute.',
  attributes: {}
};


/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute phải được chấp nhận.',
  alpha: 'Trường :attribute phải là ký tự',
  alpha_dash: ':attribute chỉ chấp nhận ký tự chữ cái, số, dấu gạch chéo và gạch dưới.',
  alpha_num: ':attribute phải là ký tự chữ cái hoặc chữ số.',
  between: ':attribute phải nằm trong khoảng :min và :max.',
  confirmed: ':attribute xác nhận không trùng khớp.',
  email: ':attribute không phải là email.',
  date: ':attribute không phải là ngày hợp lệ',
  def: 'Thuộc tính :attribute có lỗi.',
  digits: ':attribute phải là số và có chiều dài bằng :digits.',
  different: 'Giá trị của hai trường :attribute và :different phải khác nhau.',
  'in': 'Giá trị được chọn của :attribute không hợp lệ.',
  integer: ':attribute phải là số nguyên.',
  min: {
    numeric: ':attribute phải lớn hơn hoặc bằng :min.',
    string: ':attribute phải có ít nhất :min ký tự.'
  },
  max: {
    numeric: ':attribute phải nhỏ hơn hoặc bằng :max.',
    string: ':attribute phải có ít hơn :max ký tự.'
  },
  not_in: 'Giá trị được chọn của trường :attribute không hợp lệ.',
  numeric: ':attribute phải là số.',
  present: 'Trường :attribute phải có mặt (nhưng có thể để trống).',
  required: ':attribute bắt buộc nhập.',
  required_if: ':attribute là bắt buộc khi :other có giá trị :value.',
  same: 'Giá trị của :attribute và :same phải như nhau.',
  size: {
    numeric: ':attribute phải có chiều dài của bằng :size.',
    string: 'Số ký tự của :attribute phải là :size ký tự.'
  },
  string: ':attribute không phải là một chuỗi',
  url: ':attribute không phải là một Url hợp lệ.',
  regex: ':attribute không đúng định dạng',
  attributes: {}
};


/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute必须是可接受的.',
  alpha: ':attribute只能包含字母.',
  alpha_dash: ':attribute只能包含字母,连字符和下划线.',
  alpha_num: ':attribute只能包含字母和数字.',
  between: ':attribute的(大小,长度等)只能在:min和:max之间.',
  confirmed: ':attribute确认不一致.',
  email: ':attribute格式不正确.',
  date: ':attribute日期格式错误.',
  def: ':attribute属性错误.',
  digits: ':attribute必须是:digits位小数.',
  different: ':attribute和:different必须不同.',
  'in': '选择的:attribute无效',
  integer: ':attribute必须是一个整数.',
  min: {
    numeric: ':attribute不能小于:min.',
    string: ':attribute长度不能小于:min.'
  },
  max: {
    numeric: ':attribute不能大于:max.',
    string: ':attribute长度不能大于:max.'
  },
  not_in: '所选的:attribute无效.',
  numeric: ':attribute必须是一个数字.',
  present: 'The :attribute field must be present (but can be empty).',
  required: ':attribute不能为空.',
  required_if: '当:other是:value时,:attribute不能为空.',
  same: ':attribute和:same必须一致.',
  size: {
    numeric: ':attribute必须等于:size.',
    string: ':attribute的长度必须等于:size.'
  },
  string: ':attribute必须是一个字符串.',
  url: ':attribute格式不正确.',
  regex: ':attribute格式不正确.',
  attributes: {}
};


/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = {
  accepted: ':attribute必須接受。',
  alpha: ':attribute只能包含字母。',
  alpha_dash: ':attribute只能包含字母，連字符和下划線。',
  alpha_num: ':attribute只能包含字母和數字。',
  between: ':attribute的值只能在:min和:max之間。',
  confirmed: ':attribute與確認輸入不一致。',
  email: ':attribute的格式錯誤。',
  date: ':attribute的日期格式錯誤。',
  def: ':attribute屬性錯誤。',
  digits: ':attribute必須是:digits位小數。',
  different: ':attribute和:different必須不同。',
  'in': '選擇的:attribute無效',
  integer: ':attribute必須是一個整數。',
  min: {
    numeric: ':attribute不能小於:min。',
    string: ':attribute的長度不能小於:min.'
  },
  max: {
    numeric: ':attribute不能大於:max。',
    string: ':attribute的長度不能大於:max.'
  },
  not_in: '所選的:attribute無效。',
  numeric: ':attribute必須是一個數字。',
  present: 'The :attribute field must be present (but can be empty).',
  required: ':attribute不能空白。',
  required_if: '當:other是:value時,:attribute不能空白。',
  same: ':attribute和:same必須一致。',
  size: {
    numeric: ':attribute必須等於:size。',
    string: ':attribute的長度必須等於:size.'
  },
  string: ':attribute必須是一個字串。',
  url: ':attribute格式不正確。',
  regex: ':attribute格式不正確。',
  attributes: {}
};


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidden(el) {
  return el.offsetWidth <= 0 && el.offsetHeight <= 0 || el.style.display === "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidden(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.tryForceFallback = tryForceFallback;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;
var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string") {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function tryForceFallback() {
  if (document && document.body) {
    // force fallback to document.body
    setElement(document.body);
    return true;
  }
  return false;
}

function validateElement(appElement) {
  if (!appElement && !globalElement && !tryForceFallback()) {
    throw new Error(["react-modal: Cannot fallback to `document.body`, because it is not", "ready or available. If you are doing server-side rendering, use this", "function to defined an element. `Modal.setAppElement(el)` to make", "this accessible"].join(" "));
  }
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || globalElement).setAttribute("aria-hidden", "true");
}

function show(appElement) {
  validateElement(appElement);
  (appElement || globalElement).removeAttribute("aria-hidden");
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = document.body;
}

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = get;
exports.add = add;
exports.remove = remove;
exports.totalCount = totalCount;
var classListMap = {};

function get() {
  return classListMap;
}

function add(bodyClass) {
  // Set variable and default if none
  if (!classListMap[bodyClass]) {
    classListMap[bodyClass] = 0;
  }
  classListMap[bodyClass] += 1;
  return bodyClass;
}

function remove(bodyClass) {
  if (classListMap[bodyClass]) {
    classListMap[bodyClass] -= 1;
  }
  return bodyClass;
}

function totalCount() {
  return Object.keys(classListMap).reduce(function (acc, curr) {
    return acc + classListMap[curr];
  }, 0);
}

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseDOM = undefined;

var _exenv = __webpack_require__(457);

var _exenv2 = _interopRequireDefault(_exenv);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EE = _exenv2.default;

var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};

var canUseDOM = exports.canUseDOM = EE.canUseDOM;

exports.default = SafeHTMLElement;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);__webpack_require__(1053);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  upload: Object,
  onUploadAbort: Function,
};*/var _ref2=_react2.default.createElement('div',{className:'file-error column'},'Filen kunde inte laddas upp');var _ref3=_react2.default.createElement('i',{className:'fa fa-times'});var FileUpload=function FileUpload(_ref){var upload=_ref.upload,onUploadAbort=_ref.onUploadAbort;return _react2.default.createElement('div',{className:'FileUpload row no-row-margins expand'},upload.error?_ref2:_react2.default.createElement('div',{className:'loading-progress column'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:true,progress:upload.progress})),_react2.default.createElement('button',{onClick:function onClick(){return onUploadAbort();},type:'button',className:'button column shrink'},_ref3));};exports.default=FileUpload;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(10);__webpack_require__(1055);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  project: ?any,
  history: Object,
};*/var BreadcrumbsContainer=function BreadcrumbsContainer(props/*: Props*/){var project=props.project,history=props.history;return _react2.default.createElement('div',{className:'BreadcrumbsContainer'},project&&_react2.default.createElement('span',{onClick:function onClick(){return history.push('/projects/'+project.id);}},project.name));};exports.default=(0,_reactRouterDom.withRouter)(BreadcrumbsContainer);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _moment=__webpack_require__(256);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  value?: Date | string,
  className?: string,
};*/var FormattedDate=function FormattedDate(_ref){var value=_ref.value,className=_ref.className;return _react2.default.createElement('span',{className:className},(0,_moment2.default)(value).format('YYYY-MM-DD'));};exports.default=FormattedDate;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  GLOBAL: {
    HIDE: '__react_tooltip_hide_event',
    REBUILD: '__react_tooltip_rebuild_event',
    SHOW: '__react_tooltip_show_event'
  }
};

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1085);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {
  ProductSlotDto,
  RoomDto,
} from '../../dtos';*//*:: export type Props = {
  rooms: RoomDto[],
  selectedRoom: ?RoomDto,
  selectedProductSlot: ?ProductSlotDto,
  selectedProductSlotRoomId: ?number,
  onSelectRoom: (room: RoomDto) => any,
  onSelectProductSlot: (roomId: number, productSlot: ProductSlotDto) => any,
  onAddRoom: () => any,
  onAddProductSlot: (roomId: number) => any,
};*/var _ref2=_react2.default.createElement('div',{className:'title'},_react2.default.createElement('span',null,'Produktplatser'));var _ref3=_react2.default.createElement('i',{className:'fa fa-plus'});var _ref4=_react2.default.createElement('div',{className:'no-room-label'},'Inga rum');var Rooms=function Rooms(_ref){var rooms=_ref.rooms,onSelectRoom=_ref.onSelectRoom,onSelectProductSlot=_ref.onSelectProductSlot,onAddRoom=_ref.onAddRoom,onAddProductSlot=_ref.onAddProductSlot,selectedRoom=_ref.selectedRoom,selectedProductSlot=_ref.selectedProductSlot,selectedProductSlotRoomId=_ref.selectedProductSlotRoomId;return _react2.default.createElement('div',{className:'Rooms'},_ref2,_react2.default.createElement('div',{className:'rooms'},(0,_map3.default)(function(r){return _react2.default.createElement('div',{key:r.id,className:'room'},_react2.default.createElement('div',{className:(0,_classnames2.default)({active:selectedRoom&&selectedRoom.id===r.id,'room-label':true}),onClick:function onClick(){return onSelectRoom(r);}},r.name),_react2.default.createElement('div',{className:'product-slots'},(0,_map3.default)(function(p){return _react2.default.createElement('div',{className:(0,_classnames2.default)({'product-slot-label':true,active:selectedProductSlot&&selectedProductSlot.id===p.id}),onClick:function onClick(){return onSelectProductSlot(r.id,p);},key:p.id},p.name);},(0,_filter3.default)({archived:null},r.productSlots)),_react2.default.createElement('div',{className:(0,_classnames2.default)({'new-product-slot':true,active:selectedProductSlot&&!selectedProductSlot.id&&selectedProductSlotRoomId===r.id}),onClick:function onClick(){return onAddProductSlot(r.id);}},_ref3,' Ny produktplats')));},rooms),!rooms.length&&_ref4),_react2.default.createElement('div',{className:'tools'},_react2.default.createElement('button',{onClick:function onClick(){return onAddRoom();},disabled:!!(selectedRoom&&!selectedRoom.id),type:'button',className:'button small expanded'},'L\xE4gg till rum')));};exports.default=Rooms;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);__webpack_require__(1087);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {
  LimitedProjectDto,
  RoomDto,
  RoomTemplateDto,
  RoomTypeDto,
} from '../../dtos';*/var notArchived=(0,_filter3.default)({archived:null});var includeRoom=function includeRoom(room){return(0,_filter3.default)(function(t){return t.id===room.roomTypeId||!t.archived;});};var filterRooms=function filterRooms(room){return room?includeRoom(room):notArchived;};/*:: export type Props = {
  room: ?RoomDto,
  roomTypes: RoomTypeDto[],
  onUserChange: () => any,
  onArchive: () => any,
  isDirty: boolean,
  updateRooms: (sortDirection: 'up' | 'down') => void,
  sortDownDisabled: boolean,
  sortUpDisabled: boolean,
  projects: LimitedProjectDto[],
  roomTemplates: RoomTemplateDto[],
  formValues: any,
};*/var _ref2=_react2.default.createElement('i',{className:'fa fa-arrow-up'});var _ref3=_react2.default.createElement('i',{className:'fa fa-arrow-down'});var _ref4=_react2.default.createElement('label',null,'Produktplatser');var _ref5=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'slots',component:'input',type:'radio',value:'NONE'}),' L\xE4gg till manuellt');var _ref6=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'slots',component:'input',type:'radio',value:'ROOM'}),' Kopiera fr\xE5n rum');var _ref7=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'slots',component:'input',type:'radio',value:'TEMPLATE'}),' Basera p\xE5 mall');var RoomForm=function RoomForm(_ref){var room=_ref.room,onArchive=_ref.onArchive,roomTypes=_ref.roomTypes,onUserChange=_ref.onUserChange,isDirty=_ref.isDirty,updateRooms=_ref.updateRooms,sortDownDisabled=_ref.sortDownDisabled,sortUpDisabled=_ref.sortUpDisabled,projects=_ref.projects,roomTemplates=_ref.roomTemplates,formValues=_ref.formValues;return _react2.default.createElement('div',{className:'RoomForm'},_react2.default.createElement('div',{className:'row align-justify align-middle box-header'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('span',{className:'box-title'},room&&room.name||'Nytt rum')),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},room&&room.id&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},[_react2.default.createElement('button',{key:0,type:'button',className:'button secondary small',disabled:sortUpDisabled,onClick:function onClick(){return updateRooms('up');}},_ref2),_react2.default.createElement('button',{key:1,type:'button',className:'button secondary small',disabled:sortDownDisabled,onClick:function onClick(){return updateRooms('down');}},_ref3),_react2.default.createElement(_ActionConfirmation2.default,{key:2,id:'archiveRoom',className:'secondary small',message:'Vill du verkligen '+(room.archived?'av':'')+'arkivera det h\xE4r rummet?',buttonText:room.archived?'Avarkivera':'Arkivera',action:onArchive})]))),_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),room&&room.id&&_react2.default.createElement(_reduxForm.Field,{name:'roomTypeId',label:'Rumstyp',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:filterRooms(room)(roomTypes)}),(!room||!room.id)&&_react2.default.createElement('div',{onChange:onUserChange},_ref4,_ref5,_react2.default.createElement(_reduxForm.Field,{name:'roomTypeId',label:'Rumstyp',normalize:function normalize(value){return value?value.id:null;},disabled:!formValues||formValues.slots!=='NONE',onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:roomTypes}),_ref6,_react2.default.createElement(_reduxForm.Field,{name:'project',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value:null;},disabled:!formValues||formValues.slots!=='ROOM',placeholder:'V\xE4lj projekt',valueKey:'id',labelKey:'name',options:projects}),_react2.default.createElement(_reduxForm.Field,{name:'config',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value:null;},disabled:!formValues||formValues.slots!=='ROOM'||!formValues.project,placeholder:'V\xE4lj konfiguration',valueKey:'id',labelKey:'name',options:!!formValues&&!!formValues.project?formValues.project.apartmentConfigs:[]}),_react2.default.createElement(_reduxForm.Field,{name:'basedOnRoomId',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value.id:null;},disabled:!formValues||formValues.slots!=='ROOM'||!formValues.project||!formValues.config,placeholder:'V\xE4lj rum',valueKey:'id',labelKey:'name',options:!!formValues&&!!formValues.config?formValues.config.rooms:[]}),_ref7,_react2.default.createElement(_reduxForm.Field,{name:'basedOnTemplateId',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value.id:null;},disabled:!formValues||formValues.slots!=='TEMPLATE',placeholder:'V\xE4lj mall',valueKey:'id',labelKey:'name',options:roomTemplates})));};exports.default=RoomForm;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('unionBy', __webpack_require__(1089));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  checked: ?boolean,
  onChange: Function,
};*/var Checkbox=function(_Component){_inherits(Checkbox,_Component);function Checkbox(){_classCallCheck(this,Checkbox);return _possibleConstructorReturn(this,(Checkbox.__proto__||Object.getPrototypeOf(Checkbox)).apply(this,arguments));}_createClass(Checkbox,[{key:"componentDidMount",value:function componentDidMount(){this.el.indeterminate=this.props.checked===null;}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps/*: Props*/){if(prevProps.checked!==this.props.checked){this.el.indeterminate=this.props.checked===null;}}},{key:"render",value:function render(){var _this2=this;var _props=this.props,checked=_props.checked,attrs=_objectWithoutProperties(_props,["checked"]);return _react2.default.createElement("input",_extends({ref:function ref(el){_this2.el=el;},type:"checkbox",checked:!!checked},attrs));}}]);return Checkbox;}(_react.Component);exports.default=Checkbox;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(156),
    assignMergeValue = __webpack_require__(467),
    baseFor = __webpack_require__(364),
    baseMergeDeep = __webpack_require__(1100),
    isObject = __webpack_require__(45),
    keysIn = __webpack_require__(161),
    safeGet = __webpack_require__(468);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(95),
    eq = __webpack_require__(114);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(83),
    isIterateeCall = __webpack_require__(98);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction2 = __webpack_require__(52);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isEqual2 = __webpack_require__(240);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _columnsAreEqual = __webpack_require__(471);

var _columnsAreEqual2 = _interopRequireDefault(_columnsAreEqual);

var _evaluateFormatters = __webpack_require__(262);

var _evaluateFormatters2 = _interopRequireDefault(_evaluateFormatters);

var _evaluateTransforms = __webpack_require__(263);

var _evaluateTransforms2 = _interopRequireDefault(_evaluateTransforms);

var _mergeProps = __webpack_require__(177);

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _types = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BodyRow = function (_React$Component) {
  _inherits(BodyRow, _React$Component);

  function BodyRow() {
    _classCallCheck(this, BodyRow);

    return _possibleConstructorReturn(this, (BodyRow.__proto__ || Object.getPrototypeOf(BodyRow)).apply(this, arguments));
  }

  _createClass(BodyRow, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      // eslint-disable-line no-unused-vars
      var previousProps = this.props;

      // Check for row based override.
      var components = nextProps.components;


      if (components && components.row && components.row.shouldComponentUpdate) {
        if ((0, _isFunction3.default)(components.row.shouldComponentUpdate)) {
          return components.row.shouldComponentUpdate.call(this, nextProps);
        }

        return true;
      }

      return !((0, _columnsAreEqual2.default)(previousProps.columns, nextProps.columns) && (0, _isEqual3.default)(previousProps.rowData, nextProps.rowData));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          columns = _props.columns,
          components = _props.components,
          onRow = _props.onRow,
          rowKey = _props.rowKey,
          rowIndex = _props.rowIndex,
          rowData = _props.rowData;


      return _react2.default.createElement(components.row, onRow(rowData, { rowIndex: rowIndex, rowKey: rowKey }), columns.map(function (column, columnIndex) {
        var property = column.property,
            cell = column.cell,
            props = column.props;

        var evaluatedProperty = property || cell && cell.property;

        var _ref = cell || {},
            _ref$transforms = _ref.transforms,
            transforms = _ref$transforms === undefined ? [] : _ref$transforms,
            _ref$formatters = _ref.formatters,
            formatters = _ref$formatters === undefined ? [] : _ref$formatters; // TODO: test against this case


        var extraParameters = {
          columnIndex: columnIndex,
          property: evaluatedProperty,
          column: column,
          rowData: rowData,
          rowIndex: rowIndex,
          rowKey: rowKey
        };
        var transformed = (0, _evaluateTransforms2.default)(transforms, rowData[evaluatedProperty], extraParameters);

        if (!transformed) {
          console.warn('Table.Body - Failed to receive a transformed result'); // eslint-disable-line max-len, no-console
        }

        return _react2.default.createElement(components.cell, _extends({
          key: columnIndex + '-cell'
        }, (0, _mergeProps2.default)(props, cell && cell.props, transformed)), transformed.children || (0, _evaluateFormatters2.default)(formatters)(rowData['_' + evaluatedProperty] || rowData[evaluatedProperty], extraParameters));
      }));
    }
  }]);

  return BodyRow;
}(_react2.default.Component);

BodyRow.defaultProps = _types.tableBodyRowDefaults;
 false ? BodyRow.propTypes = _types.tableBodyRowTypes : void 0;

exports.default = BodyRow;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEqualWith2 = __webpack_require__(1103);

var _isEqualWith3 = _interopRequireDefault(_isEqualWith2);

var _isFunction2 = __webpack_require__(52);

var _isFunction3 = _interopRequireDefault(_isFunction2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function columnsAreEqual(oldColumns, newColumns) {
  return (0, _isEqualWith3.default)(oldColumns, newColumns, function (a, b) {
    if ((0, _isFunction3.default)(a) && (0, _isFunction3.default)(b)) {
      return true;
    }

    return undefined;
  });
}

exports.default = columnsAreEqual;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isArray2 = __webpack_require__(18);

var _isArray3 = _interopRequireDefault(_isArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function resolveRowKey(_ref) {
  var rowData = _ref.rowData,
      rowIndex = _ref.rowIndex,
      rowKey = _ref.rowKey;

  if (typeof rowKey === 'function') {
    return rowKey({ rowData: rowData, rowIndex: rowIndex }) + '-row';
  } else if (false) {
    // Arrays cannot have rowKeys by definition so we have to go by index there.
    if (!(0, _isArray3.default)(rowData) && rowData[rowKey] === undefined) {
      console.warn( // eslint-disable-line no-console
      'Table.Body - Missing valid rowKey!', rowData, rowKey);
    }
  }

  if (rowData[rowKey] === 0) {
    return rowData[rowKey] + '-row';
  }

  return (rowData[rowKey] || rowIndex) + '-row';
}

exports.default = resolveRowKey;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(155);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = __webpack_require__(386);

var _find3 = _interopRequireDefault(_find2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var byIndex = {
  fieldName: 'columnIndex',
  getColumn: function getColumn(columns, sortingColumnKey) {
    return columns[sortingColumnKey];
  }
};

var byProperty = {
  fieldName: 'property',
  getColumn: function getColumn(columns, property) {
    return (0, _find3.default)(columns, { property: property });
  }
};

exports.default = {
  byIndex: byIndex,
  byProperty: byProperty
};

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/prop-types */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _defaultStrategy = __webpack_require__(130);

var _defaultStrategy2 = _interopRequireDefault(_defaultStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var order = function order(_ref) {
  var getSortingColumns = _ref.getSortingColumns,
      _ref$props = _ref.props,
      props = _ref$props === undefined ? {} : _ref$props,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === undefined ? _defaultStrategy2.default : _ref$strategy;

  if (!getSortingColumns) {
    throw new Error('order - Missing getSortingColumns!');
  }

  return function (value, extra) {
    var sortingColumns = getSortingColumns();
    var sortingColumn = sortingColumns && sortingColumns[extra[strategy.fieldName]] || {};
    var sortingPosition = sortingColumn.position;

    return {}.hasOwnProperty.call(sortingColumn, 'position') ? _react2.default.createElement(
      'span',
      _extends({ className: 'sort-order' }, props),
      sortingPosition + 1
    ) : null;
  };
};

exports.default = order;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function countRowSpan(columns) {
  var maximumCount = 0;

  columns.forEach(function (column) {
    if (column.children && column.children.length) {
      maximumCount = Math.max(maximumCount, countRowSpan(column.children));
    }
  });

  return maximumCount + 1;
}

exports.default = countRowSpan;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactPagify=__webpack_require__(1126);var _reactPagify2=_interopRequireDefault(_reactPagify);var _segmentize=__webpack_require__(1133);var _segmentize2=_interopRequireDefault(_segmentize);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1134);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  pagination: Object,
  pages: number,
  onSelect: Function,
};*/var _ref=_react2.default.createElement(_reactPagify2.default.Segment,{field:'beginPages'});var _ref2=_react2.default.createElement(_reactPagify2.default.Ellipsis,{className:'pagify-ellipsis',previousField:'beginPages',nextField:'previousPages'});var _ref3=_react2.default.createElement(_reactPagify2.default.Segment,{field:'previousPages'});var _ref4=_react2.default.createElement(_reactPagify2.default.Segment,{field:'centerPage',className:'selected'});var _ref5=_react2.default.createElement(_reactPagify2.default.Segment,{field:'nextPages'});var _ref6=_react2.default.createElement(_reactPagify2.default.Ellipsis,{className:'pagify-ellipsis',previousField:'nextPages',nextField:'endPages'});var _ref7=_react2.default.createElement(_reactPagify2.default.Segment,{field:'endPages'});var Paginator=function(_Component){_inherits(Paginator,_Component);function Paginator(){_classCallCheck(this,Paginator);return _possibleConstructorReturn(this,(Paginator.__proto__||Object.getPrototypeOf(Paginator)).apply(this,arguments));}_createClass(Paginator,[{key:'selectPage',value:function selectPage(page/*: number*/){var activePage=Math.min(Math.max(page,1),this.props.pages);if(this.props.pagination.page!==activePage){this.props.onSelect(activePage);}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,page=_props.pagination.page,pages=_props.pages;return _react2.default.createElement('div',{className:'pagination'},pages>1&&_react2.default.createElement(_reactPagify2.default.Context,{className:'pagify-pagination',segments:(0,_segmentize2.default)({page:page,pages:pages,beginPages:1,endPages:1,sidePages:1}),onSelect:function onSelect(page){return _this2.selectPage(page);}},_react2.default.createElement(_reactPagify2.default.Button,{page:page-1,className:(0,_classnames2.default)({disabled:page===1})},'F\xF6reg\xE5ende'),_ref,_ref2,_ref3,_ref4,_ref5,_ref6,_ref7,_react2.default.createElement(_reactPagify2.default.Button,{page:page+1,className:(0,_classnames2.default)({disabled:page===pages})},'N\xE4sta')));}}]);return Paginator;}(_react.Component);exports.default=Paginator;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _ImagesDropzone=__webpack_require__(1144);var _ImagesDropzone2=_interopRequireDefault(_ImagesDropzone);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  activeRoomType: ?any,
  roomTypes: any[],
  images: any[],
  uploads: Object,
  onRoomTypeSelect: Function,
  onUpload: Function,
  onUploadAbort: Function,
  onRemove: Function,
};*/var _ref2=_react2.default.createElement('label',null,'Inspirationsbilder');var RoomTypeImages=function RoomTypeImages(_ref){var activeRoomType=_ref.activeRoomType,roomTypes=_ref.roomTypes,images=_ref.images,uploads=_ref.uploads,onRoomTypeSelect=_ref.onRoomTypeSelect,onUpload=_ref.onUpload,onUploadAbort=_ref.onUploadAbort,onRemove=_ref.onRemove;return _react2.default.createElement('div',{className:'RoomTypeImages'},_ref2,_react2.default.createElement(_SelectFormInput2.default,{input:{value:activeRoomType,onBlur:_noop3.default,onChange:function onChange(roomType){return onRoomTypeSelect(roomType);}},placeholder:'Rumstyp',meta:{},valueKey:'id',labelKey:'name',options:roomTypes}),_react2.default.createElement('div',{className:'list'},activeRoomType&&_react2.default.createElement(_ImagesDropzone2.default,{images:(0,_filter3.default)({roomTypeId:activeRoomType.id},images),uploads:uploads[activeRoomType.id]||[],onUpload:onUpload,onRemove:onRemove,onUploadAbort:onUploadAbort})));};exports.default=RoomTypeImages;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  onUserChange: Function,
};*/var ProjectForm=function ProjectForm(_ref){var onUserChange=_ref.onUserChange;return _react2.default.createElement('div',{className:'ProjectForm'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'propertyNumber',label:'Fastighetsnummer',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'propertyDescription',label:'Fastighetsbeteckning',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'description',label:'Beskrivning',onChange:onUserChange,component:_TextAreaFormInput2.default}))));};exports.default=(0,_reduxForm.reduxForm)({form:'project',enableReinitialize:true})(ProjectForm);

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactSelect=__webpack_require__(428);var _reactSelect2=_interopRequireDefault(_reactSelect);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _Checkbox=__webpack_require__(465);var _Checkbox2=_interopRequireDefault(_Checkbox);var _reactTooltip=__webpack_require__(91);var _reactTooltip2=_interopRequireDefault(_reactTooltip);__webpack_require__(1159);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type VariantProps = {
  variant: Object,
  variantSelected: Function,
  productType: Object,
  hasVariantDiffs: boolean,
  isMain: boolean,
};*/var _ref2=_react2.default.createElement('span',null,'Kan ej v\xE4lja bort varianten d\xE5 det \xE4r en visningsartikel');var Variant=function Variant(_ref){var variant=_ref.variant,variantSelected=_ref.variantSelected,productType=_ref.productType,hasVariantDiffs=_ref.hasVariantDiffs,isMain=_ref.isMain;return _react2.default.createElement('div',{className:'row item'},_react2.default.createElement('div',{className:'small-2 column'},_react2.default.createElement('div',{'data-tip':true,'data-for':'checked-disabled-tip-'+variant.id},_react2.default.createElement(_Checkbox2.default,{checked:variant.selected,disabled:!!hasVariantDiffs||!!isMain,onChange:function onChange(e){return variantSelected(variant.id,productType,e.target.checked);}}),!!isMain&&_react2.default.createElement(_reactTooltip2.default,{id:'checked-disabled-tip-'+variant.id,effect:'solid'},_ref2))),_react2.default.createElement('div',{className:'small-6 column'},variant.name),_react2.default.createElement('div',{className:'small-4 column'},variant.itemNumber));};/*:: export type VariantListProps = {
  product: Object,
  variantSelected: Function,
  productType: Object,
  hasVariantDiffs: boolean,
};*/var _ref4=_react2.default.createElement('div',{className:'row header'},_react2.default.createElement('div',{className:'small-8 column'},'Produktvariant'),_react2.default.createElement('div',{className:'small-4 column'},'Artikelnummer'));var VariantList=function VariantList(_ref3){var product=_ref3.product,variantSelected=_ref3.variantSelected,productType=_ref3.productType,hasVariantDiffs=_ref3.hasVariantDiffs;return _react2.default.createElement('div',{className:'row variant-row'},_react2.default.createElement('div',{className:'small-8 small-offset-4 column variant-grid'},_ref4,(0,_map3.default)(function(variant){return _react2.default.createElement(Variant,{key:variant.id,productType:productType,variant:variant,isMain:product.mainVariantId===variant.id,variantSelected:variantSelected,hasVariantDiffs:hasVariantDiffs});},product.variants)));};/*:: export type ProductProps = {
  product: Object,
  productSelected: Function,
  variantSelected: Function,
  productToggle: Function,
  productType: Object,
  hasVariantDiffs: boolean,
};*/var Product=function Product(_ref5){var product=_ref5.product,productSelected=_ref5.productSelected,variantSelected=_ref5.variantSelected,productToggle=_ref5.productToggle,productType=_ref5.productType,hasVariantDiffs=_ref5.hasVariantDiffs;return _react2.default.createElement('div',{className:'row product'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'row item',onClick:function onClick(e){if(!!e.target&&e.target.type==='checkbox'){return;}productToggle(product.id);}},_react2.default.createElement('div',{className:'small-1 small-offset-1 column'},_react2.default.createElement('i',{className:'fa fa-chevron-'+(!!product.opened?'down':'right')})),_react2.default.createElement('div',{className:'small-1 column'},_react2.default.createElement(_Checkbox2.default,{checked:product.selected,disabled:!!hasVariantDiffs,onChange:function onChange(e){return productSelected(product.id,productType,e.target.checked);}})),_react2.default.createElement('div',{className:'small-9 column name-column'},product.name)),!!product.opened&&_react2.default.createElement(VariantList,{productType:productType,product:product,variantSelected:variantSelected,hasVariantDiffs:hasVariantDiffs})));};/*:: export type ProductTypeProps = {
  productType: Object,
  productSelected: Function,
  variantSelected: Function,
  productToggle: Function,
  productTypeToggle: Function,
  productTypeSelected: Function,
  removeProductType: Function,
  hasVariantDiffs: boolean,
};*/var _ref7=_react2.default.createElement('i',{className:'fa fa-trash fa-lg'});var _ref8=_react2.default.createElement('div',{className:'row header'},_react2.default.createElement('div',{className:'small-2 small-offset-1 column'},'Tillg\xE4nglig'),_react2.default.createElement('div',{className:'small-9 column'},'Produkt'));var ProductType=function ProductType(_ref6){var productType=_ref6.productType,productSelected=_ref6.productSelected,variantSelected=_ref6.variantSelected,productToggle=_ref6.productToggle,productTypeToggle=_ref6.productTypeToggle,productTypeSelected=_ref6.productTypeSelected,removeProductType=_ref6.removeProductType,hasVariantDiffs=_ref6.hasVariantDiffs;return _react2.default.createElement('div',{className:'row product-type'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'row item',onClick:function onClick(e){if(!!e.target&&(e.target.type==='checkbox'||e.target.type==='button'||e.target.localName==='i'&&!!e.target.parentNode&&e.target.parentNode.type==='button')){return;}productTypeToggle(productType.id);}},_react2.default.createElement('div',{className:'small-1 column'},_react2.default.createElement('i',{className:'fa fa-chevron-'+(!!productType.opened?'down':'right')})),_react2.default.createElement('div',{className:'small-1 column'},_react2.default.createElement(_Checkbox2.default,{checked:productType.selected,disabled:!!hasVariantDiffs,onChange:function onChange(e){return productTypeSelected(productType,e.target.checked);}})),_react2.default.createElement('div',{className:'small-5 column'},productType.name),_react2.default.createElement('div',{className:'small-4 column'},productType.selectedCount),_react2.default.createElement('div',{className:'small-1 column'},_react2.default.createElement('button',{type:'button',className:'button small',disabled:!!hasVariantDiffs,onClick:function onClick(){return removeProductType(productType.id);}},_ref7))),productType.opened&&!!productType.products.length&&_ref8,productType.opened&&!!productType.products.length&&(0,_map3.default)(function(product){return _react2.default.createElement(Product,{key:product.id,product:product,productType:productType,productSelected:productSelected,variantSelected:variantSelected,productToggle:productToggle,hasVariantDiffs:hasVariantDiffs});},productType.products)));};/*:: export type ProductTypeListProps = {
  productSelected: Function,
  variantSelected: Function,
  productToggle: Function,
  productTypeToggle: Function,
  related: any[],
  productTypeSelected: Function,
  removeProductType: Function,
  hasVariantDiffs: boolean,
};*/var _ref10=_react2.default.createElement('div',{className:'row header'},_react2.default.createElement('div',{className:'small-5 small-offset-2 column'},'Produkttyp'),_react2.default.createElement('div',{className:'small-5 column'},'Antal valda varianter'));var ProductTypeList=function ProductTypeList(_ref9){var productSelected=_ref9.productSelected,variantSelected=_ref9.variantSelected,productToggle=_ref9.productToggle,productTypeToggle=_ref9.productTypeToggle,related=_ref9.related,productTypeSelected=_ref9.productTypeSelected,removeProductType=_ref9.removeProductType,hasVariantDiffs=_ref9.hasVariantDiffs;return!!related.length?_react2.default.createElement('div',{className:'related'},_ref10,(0,_map3.default)(function(productType){return _react2.default.createElement(ProductType,{key:productType.id,productType:productType,productSelected:productSelected,variantSelected:variantSelected,productToggle:productToggle,productTypeToggle:productTypeToggle,productTypeSelected:productTypeSelected,removeProductType:removeProductType,hasVariantDiffs:hasVariantDiffs});},related)):null;};/*:: export type RelatedVariantsInputProps = {
  input: any,
  label: string,
  meta: any,
  productTypes: any[],
  relatedProductType: ?{ id: number },
  setRelatedProductType: Function,
  addRelatedProductType: Function,
  productSelected: Function,
  variantSelected: Function,
  productToggle: Function,
  productTypeToggle: Function,
  related: any[],
  productTypeSelected: Function,
  removeProductType: Function,
  unlockShared: ?Function,
  hasVariantDiffs: boolean,
};*/var _ref12=_react2.default.createElement(_reactTooltip2.default,{id:'variant-diffs-tip',effect:'solid'},_react2.default.createElement('span',null,'Det finns skillnader mellan varianterna, tryck p\xE5 L\xE5s upp f\xF6r att till\xE5ta \xE4ndringar'));var RelatedVariantsInput=function RelatedVariantsInput(_ref11){var input=_ref11.input,label=_ref11.label,_ref11$meta=_ref11.meta,touched=_ref11$meta.touched,error=_ref11$meta.error,productTypes=_ref11.productTypes,relatedProductType=_ref11.relatedProductType,setRelatedProductType=_ref11.setRelatedProductType,addRelatedProductType=_ref11.addRelatedProductType,productSelected=_ref11.productSelected,variantSelected=_ref11.variantSelected,productToggle=_ref11.productToggle,productTypeToggle=_ref11.productTypeToggle,related=_ref11.related,productTypeSelected=_ref11.productTypeSelected,removeProductType=_ref11.removeProductType,unlockShared=_ref11.unlockShared,hasVariantDiffs=_ref11.hasVariantDiffs;return _react2.default.createElement('div',{className:'RelatedVariantsInput','data-tip':true,'data-tip-disable':!hasVariantDiffs,'data-for':'variant-diffs-tip'},_react2.default.createElement('label',{className:(0,_classnames2.default)({'is-invalid-label':touched&&error,'related-variant-label':true})},label),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reactSelect2.default,{value:relatedProductType,onChange:setRelatedProductType,options:productTypes,clearable:false,disabled:!!hasVariantDiffs,labelKey:'name',valueKey:'id',noResultsText:'Inga produkttyper hittades'})),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement('button',{type:'button',className:'button small expanded',disabled:!!hasVariantDiffs,onClick:function onClick(){return addRelatedProductType(relatedProductType);}},'L\xE4gg till'))),_react2.default.createElement(ProductTypeList,{productSelected:productSelected,variantSelected:variantSelected,productToggle:productToggle,productTypeToggle:productTypeToggle,related:related,productTypeSelected:productTypeSelected,removeProductType:removeProductType,hasVariantDiffs:hasVariantDiffs}),touched&&error&&_react2.default.createElement('div',{className:'row'},_react2.default.createElement('span',{className:'form-error is-visible'},error)),!!hasVariantDiffs&&_react2.default.createElement('div',{className:'row unlock-button'},_react2.default.createElement('div',{className:'small-4 small-offset-4 column end'},_react2.default.createElement('button',{type:'button',className:'button small expanded',onClick:unlockShared},'L\xE5s upp'))),!!unlockShared&&_ref12);};exports.default=RelatedVariantsInput;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _join2=__webpack_require__(241);var _join3=_interopRequireDefault(_join2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _request=__webpack_require__(6);var _siteManagerReportView=__webpack_require__(411);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);__webpack_require__(1181);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: import type {SiteManagerReportState} from '../../reducers/siteManagerReportView';*//*:: import type {ErrorDto} from '../../dtos';*//*:: import type {Entity, Project} from '../../actions/purchaseReportView';*/var fileUrl=_request.apiBase+'/files';var getUrl=function getUrl(apartmentIds/*: number[]*/,projectId/*: number*/,includePlans/*: boolean*/)/*: string*/{var url=fileUrl+'/export/projects/'+projectId+'/sitemanager/project_'+projectId+'_site_manager_export.pdf';if(!!apartmentIds.length){url+='?apartmentIds='+(0,_join3.default)(',',apartmentIds);}if(!!includePlans){url+=(!!apartmentIds.length?'&':'?')+'withPlans=1';}return url;};var getPlansUrl=function getPlansUrl(apartmentIds/*: number[]*/,projectId/*: number*/)/*: string*/{var url=fileUrl+'/export/projects/'+projectId+'/sitemanagerplans/project_'+projectId+'_site_manager_export.pdf';if(!!apartmentIds.length){url+='?apartmentIds='+(0,_join3.default)(',',apartmentIds);}return url;};/*:: export type Props = {
  apartmentIds: number[],
  apartments: Entity[],
  applyFilter: typeof applyFilter,
  fetchData: typeof fetchData,
  isFetching: boolean,
  projectId?: number,
  projects: Project[],
  error: ?ErrorDto,
  includePlans: boolean,
};*/var SiteManagerReportContainer=function(_Component){_inherits(SiteManagerReportContainer,_Component);function SiteManagerReportContainer(){_classCallCheck(this,SiteManagerReportContainer);return _possibleConstructorReturn(this,(SiteManagerReportContainer.__proto__||Object.getPrototypeOf(SiteManagerReportContainer)).apply(this,arguments));}_createClass(SiteManagerReportContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData();}},{key:'render',value:function render(){var _props=this.props,apartments=_props.apartments,apartmentIds=_props.apartmentIds,applyFilter=_props.applyFilter,isFetching=_props.isFetching,projects=_props.projects,projectId=_props.projectId,error=_props.error,includePlans=_props.includePlans;return _react2.default.createElement('div',{className:'SiteManagerReportContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:projectId,onBlur:_noop3.default,onChange:function onChange(project/*: ?Project*/){return applyFilter(apartmentIds,project?project.id:null,includePlans);}},label:'Projekt',placeholder:'V\xE4lj projekt',meta:{},valueKey:'id',labelKey:'name',multi:false,options:projects,clearable:false,isLoading:isFetching})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:apartmentIds,onBlur:_noop3.default,onChange:function onChange(apartments/*: Entity[]*/){return applyFilter((0,_map3.default)('id',apartments),projectId,includePlans);}},label:'L\xE4genheter',placeholder:'V\xE4lj l\xE4genheter',meta:{},valueKey:'id',labelKey:'objectId',multi:true,options:apartments,clearable:true,isLoading:isFetching,keepOpen:true})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!includePlans,onBlur:_noop3.default,onChange:function onChange(includePlans){return applyFilter(apartmentIds,projectId,includePlans?includePlans.value:false);}},label:'Inkludera ritningar',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default})),!!projectId&&_react2.default.createElement('div',{className:'column shrink top-margin'},_react2.default.createElement('a',{href:getUrl(apartmentIds,projectId,includePlans),target:'_blank',className:'button success'},'Ladda ner')),!!projectId&&_react2.default.createElement('div',{className:'column shrink top-margin'},_react2.default.createElement('a',{href:getPlansUrl(apartmentIds,projectId),target:'_blank',className:'button success'},'Ladda ner ritningar'))));}}]);return SiteManagerReportContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$siteManagerRepor=_ref.siteManagerReportView,apartments=_ref$siteManagerRepor.apartments,apartmentIds=_ref$siteManagerRepor.apartmentIds,isFetching=_ref$siteManagerRepor.isFetching,projects=_ref$siteManagerRepor.projects,projectId=_ref$siteManagerRepor.projectId,error=_ref$siteManagerRepor.error,includePlans=_ref$siteManagerRepor.includePlans;return{apartments:apartments,apartmentIds:apartmentIds,isFetching:isFetching,projects:projects,projectId:projectId,error:error,includePlans:includePlans};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{applyFilter:function applyFilter(apartmentIds/*: number[]*/,projectId/*: ?number*/,includePlans/*: boolean*/){return dispatch((0,_siteManagerReportView.applyFilter)(apartmentIds,projectId,includePlans));},fetchData:function fetchData(){return dispatch((0,_siteManagerReportView.fetchData)());}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(SiteManagerReportContainer);

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1187);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  onLogoutClick: Function,
};*/var _ref2=_react2.default.createElement('div',{className:'align-self-middle shrink column'},_react2.default.createElement('div',{className:'AdminNavbar-header'},'H\xF6kerum Bygg'));var AdminNavbar=function AdminNavbar(_ref){var onLogoutClick=_ref.onLogoutClick;return _react2.default.createElement('div',{className:'AdminNavbar'},_react2.default.createElement('div',{className:'row fill-height align-justify'},_ref2,_react2.default.createElement('div',{className:'align-self-middle shrink column'},_react2.default.createElement('button',{type:'button',className:'AdminNavbar-logout',onClick:function onClick(){return onLogoutClick();}},'Logga ut'))));};exports.default=AdminNavbar;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _orderList=__webpack_require__(398);var _orderStates=__webpack_require__(69);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);var _tableHelpers=__webpack_require__(484);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fixedStates=(0,_map3.default)(function(s){return _extends({},s,{id:s.id+1});},_orderStates.states);var columns=[{property:'apartment.project.name',header:{label:'Projekt'}},{property:'apartment.objectId',header:{label:'Lägenhet'}},{property:'user.person.name',header:{label:'Kund'}},{property:'totalPrice',header:{label:'Värde'}},{property:'state',header:{label:'Status'},cell:{formatters:[_tableHelpers.formatOrderState]}}];/*:: export type Props = {
  history: Object,
  salesUsers: any[],
  error: ?any,
  fetchOrders: Function,
  filter: {
    archived: boolean,
    orderState: ?number,
    salesUserId: ?number,
    projectId: ?number,
    query: ?string,
  },
  filterOrders: Function,
  isFetching: boolean,
  orders: any[],
  location: { pathname: string },
  projects: any[],
  sortItems: typeof sortItems,
  readonly: boolean,
};*/var _ref2=_react2.default.createElement('div',{className:'callout secondary'},'G\xF6r ett val eller en s\xF6kning f\xF6r att se resultat.');var OrdersContainer=function(_Component){_inherits(OrdersContainer,_Component);function OrdersContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,OrdersContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=OrdersContainer.__proto__||Object.getPrototypeOf(OrdersContainer)).call.apply(_ref,[this].concat(args))),_this),_this.filterByQuery=function(e){var _this$props=_this.props,filter=_this$props.filter,filterOrders=_this$props.filterOrders;filterOrders(_extends({},filter,{query:e.target.value}));},_this.clearQuery=function(){_this.filterByQuery({target:{value:''}});},_this.filterByProjectId=function(project){var _this$props2=_this.props,filter=_this$props2.filter,filterOrders=_this$props2.filterOrders;filterOrders(_extends({},filter,{projectId:project?project.id:null}));},_this.filterBySalesUserId=function(user){var _this$props3=_this.props,filter=_this$props3.filter,filterOrders=_this$props3.filterOrders;filterOrders(_extends({},filter,{salesUserId:user?user.id:null}));},_this.filterByOrderState=function(state){var _this$props4=_this.props,filter=_this$props4.filter,filterOrders=_this$props4.filterOrders;filterOrders(_extends({},filter,{orderState:state?state.id:null}));},_this.filterByArchived=function(archived){var _this$props5=_this.props,filter=_this$props5.filter,filterOrders=_this$props5.filterOrders;filterOrders(_extends({},filter,{archived:archived?archived.value:false}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(OrdersContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchOrders();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,error=_props.error,filter=_props.filter,isFetching=_props.isFetching,orders=_props.orders,salesUsers=_props.salesUsers,pathname=_props.location.pathname,projects=_props.projects,sortItems=_props.sortItems,readonly=_props.readonly;return _react2.default.createElement('div',{className:'OrdersContainer relative'},_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:this.clearQuery,onChange:this.filterByQuery})),readonly?null:_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa ny'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},projects&&_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:filter.projectId||null,onBlur:_noop3.default,onChange:this.filterByProjectId},label:'Projekt',meta:{},valueKey:'id',labelKey:'name',clearable:true,options:projects,placeholder:'Alla',isLoading:isFetching})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:filter.salesUserId,onBlur:_noop3.default,onChange:this.filterBySalesUserId},label:'S\xE4ljare',meta:{},valueKey:'id',labelKey:'username',clearable:true,options:salesUsers,placeholder:'Alla',isLoading:isFetching})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:filter.orderState,onBlur:_noop3.default,onChange:this.filterByOrderState},label:'Status',meta:{},valueKey:'id',labelKey:'label',clearable:true,options:fixedStates,placeholder:'Alla'})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:this.filterByArchived},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),orders&&(filter.orderState!==null||filter.salesUserId!==null||filter.projectId!==null||filter.query!==null&&filter.query!=='')?_react2.default.createElement(_AdminList2.default,{query:filter.query,columns:columns,rows:orders,onSort:sortItems,onRowSelected:function onRowSelected(row){return readonly?null:history.push(pathname+'/'+row.id);},sortColumnIndex:'1'}):_ref2));}}]);return OrdersContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref3){var _ref3$orderList=_ref3.orderList,salesUsers=_ref3$orderList.salesUsers,error=_ref3$orderList.error,filter=_ref3$orderList.filter,isFetching=_ref3$orderList.isFetching,orders=_ref3$orderList.filteredOrders,projects=_ref3$orderList.projects;return{salesUsers:salesUsers,error:error,filter:filter,isFetching:isFetching,orders:orders,projects:projects};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchOrders:function fetchOrders(){return dispatch((0,_orderList.fetchOrders)());},filterOrders:function filterOrders(filter){return dispatch((0,_orderList.filterOrders)(filter));},sortItems:function sortItems(sorter){return dispatch((0,_orderList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(OrdersContainer));

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.formatOrderState=undefined;var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _orderStates=__webpack_require__(69);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var formatOrderState=exports.formatOrderState=function formatOrderState(state/*: number*/){return _react2.default.createElement('span',null,_react2.default.createElement('i',{className:'fa fa-circle order-status '+_orderStates.stateClasses[state]}),_orderStates.stateLabels[state]);};

/***/ }),
/* 485 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Swedish
 * locale : Sweden
 * author : Benjamin Van Ryseghem (benjamin.vanryseghem.com)
 */
(function() {
    'use strict';

    var language = {
        langLocaleCode: 'sv-SE',
        cultureCode: 'sv-SE',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 't',
            million: 'M',
            billion: 'md',
            trillion: 'tmd'
        },
        currency: {
            symbol: 'kr',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _ProductRowForm=__webpack_require__(1258);var _ProductRowForm2=_interopRequireDefault(_ProductRowForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  products: any[],
  variants: any[],
  existingRows: any[],
  rooms: any[],
  activeRow: Object,
  formValues: any,
  validate: Function,
  isLoading: boolean,
  error: ?any,
  onSave: Function,
  onSelectProduct: Function,
  onClose: Function,
  onOpen: ?Function,
  combineProduct: boolean,
};*/var ProductRowDialog=function ProductRowDialog(_ref){var activeRow=_ref.activeRow,products=_ref.products,variants=_ref.variants,rooms=_ref.rooms,formValues=_ref.formValues,validate=_ref.validate,isLoading=_ref.isLoading,error=_ref.error,existingRows=_ref.existingRows,onSave=_ref.onSave,onSelectProduct=_ref.onSelectProduct,onOpen=_ref.onOpen,onClose=_ref.onClose,combineProduct=_ref.combineProduct;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onOpen:onOpen?onOpen:_noop3.default,onClose:onClose,className:'AdditionalRowDialog',show:true},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isLoading}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_ProductRowForm2.default,{initialValues:activeRow,existingRows:existingRows,activeRow:activeRow,products:products,variants:variants,rooms:rooms,formValues:formValues,onSelectProduct:onSelectProduct,validate:validate,combineProduct:combineProduct}),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onSave},activeRow.id?'Uppdatera':'Lägg till'),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onClose},'Avbryt')));};exports.default=ProductRowDialog;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);__webpack_require__(1259);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/*:: export type RowProps = {
  row: any,
  uniqueRowName: string,
  onSelect: Function,
  onRemove?: Function,
  isExtra: boolean,
};*/var _ref2=_react2.default.createElement('div',null,_react2.default.createElement('i',{className:'fa  fa-user-plus'}));var _ref3=_react2.default.createElement('i',{className:'fa fa-trash'});var _ref4=_react2.default.createElement('i',{className:'fa fa-comment-o'});var ProductRowListRow=function ProductRowListRow(_ref){var row=_ref.row,onSelect=_ref.onSelect,onRemove=_ref.onRemove,isExtra=_ref.isExtra,uniqueRowName=_ref.uniqueRowName;var hasNote=!!row.note;return[_react2.default.createElement('tr',{key:uniqueRowName,onClick:function onClick(){return onSelect(row);},className:'ProductRowList-product-row'},_react2.default.createElement('td',{rowSpan:hasNote?2:1},isExtra&&_ref2),_react2.default.createElement('td',null,row.productVariant.itemNumber),_react2.default.createElement('td',{className:'ProductRowList-name'},row.product.name,' - ',row.productVariant.name),_react2.default.createElement('td',{className:'ProductRowList-number-column'},row.orderedPrice===0?'Standard':Math.round(row.orderedPrice)+' kr'),_react2.default.createElement('td',{className:'ProductRowList-number-column'},row.quantity),_react2.default.createElement('td',{onClick:function onClick(e){return e.stopPropagation();},rowSpan:hasNote?2:1},onRemove&&_react2.default.createElement(_ActionConfirmation2.default,{id:uniqueRowName,className:'secondary ProductRowList-remove-button',message:'Vill du verkligen ta bort den h\xE4r raden?',action:function action(){return onRemove&&onRemove(row);}},_ref3)))].concat(_toConsumableArray(hasNote?[_react2.default.createElement('tr',{key:'row-comment-'+row.id,onClick:function onClick(){return onSelect(row);},className:'ProductRowList-comment'},_react2.default.createElement('td',{colSpan:'7'},_ref4,_react2.default.createElement('span',{className:'comment-text'},row.note)))]:[]));};/*:: export type Props = {
  allRowsByRoom: any[],
  onSelectRow: Function,
  onSelectExtraRow: Function,
  onRemoveExtraRow?: Function,
  canRemoveExtraRows?: boolean,
};*/var _ref6=_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null),_react2.default.createElement('th',null,'Artikelnr.'),_react2.default.createElement('th',null,'Namn'),_react2.default.createElement('th',{className:'ProductRowList-number-column'},'Pris'),_react2.default.createElement('th',{className:'ProductRowList-number-column'},'Antal'),_react2.default.createElement('th',null)));var _ref7=_react2.default.createElement('div',{className:'callout secondary'},'Inga produkter');var ProductRowList=function ProductRowList(_ref5){var allRowsByRoom=_ref5.allRowsByRoom,onSelectRow=_ref5.onSelectRow,onSelectExtraRow=_ref5.onSelectExtraRow,onRemoveExtraRow=_ref5.onRemoveExtraRow,canRemoveExtraRows=_ref5.canRemoveExtraRows;return _react2.default.createElement('div',{className:'ProductRowList'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('table',{className:'table'},_ref6,_react2.default.createElement('tbody',null,(0,_map3.default)(function(room){return[_react2.default.createElement('tr',{key:'room-'+room.id},_react2.default.createElement('td',{className:'ProductRowList-room',colSpan:'7'},room.name))].concat(_toConsumableArray((0,_flow3.default)((0,_sortBy3.default)(['productVariant.itemNumber','id']),(0,_map3.default)(function(row){return _react2.default.createElement(ProductRowListRow,{key:'extraProductRows-'+row.id,uniqueRowName:'linkedProductRows-'+row.id,row:row,onSelect:onSelectExtraRow,onRemove:canRemoveExtraRows?onRemoveExtraRow:undefined,isExtra:true});}))(room.extraProductRows)),_toConsumableArray((0,_map3.default)(function(row){return _react2.default.createElement(ProductRowListRow,{key:'productRows-'+row.id,uniqueRowName:'productRows-'+row.id,row:row,onSelect:onSelectRow,isExtra:false});},room.productRows)));},allRowsByRoom))),!allRowsByRoom.length&&_ref7)));};exports.default=ProductRowList;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _OrderRowNoteForm=__webpack_require__(1260);var _OrderRowNoteForm2=_interopRequireDefault(_OrderRowNoteForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  error: ?any,
  formValues: any,
  isLoading: boolean,
  onClose: Function,
  onSave: Function,
  orderRow: any,
  validate: Function,
};*/var OrderRowNoteDialog=function OrderRowNoteDialog(_ref){var error=_ref.error,formValues=_ref.formValues,isLoading=_ref.isLoading,onClose=_ref.onClose,onSave=_ref.onSave,orderRow=_ref.orderRow,validate=_ref.validate;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:onClose,className:'OrderRowNoteDialog',show:true},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isLoading}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_OrderRowNoteForm2.default,{initialValues:orderRow,validate:validate}),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onSave},'Spara'),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onClose},'Avbryt')));};exports.default=OrderRowNoteDialog;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _customerOrderView=__webpack_require__(393);var _HelpForm=__webpack_require__(1267);var _HelpForm2=_interopRequireDefault(_HelpForm);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _CustomerProductList=__webpack_require__(1268);var _CustomerProductList2=_interopRequireDefault(_CustomerProductList);var _CustomerCustomProductList=__webpack_require__(1286);var _CustomerCustomProductList2=_interopRequireDefault(_CustomerCustomProductList);var _CoverImage=__webpack_require__(495);var _CoverImage2=_interopRequireDefault(_CoverImage);var _CustomerProductSlotList=__webpack_require__(1289);var _CustomerProductSlotList2=_interopRequireDefault(_CustomerProductSlotList);var _CustomerProductDialog=__webpack_require__(1291);var _CustomerProductDialog2=_interopRequireDefault(_CustomerProductDialog);var _CustomerOrderPrice=__webpack_require__(1310);var _CustomerOrderPrice2=_interopRequireDefault(_CustomerOrderPrice);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _orderStates=__webpack_require__(69);var _roles=__webpack_require__(49);var _WarningText=__webpack_require__(268);var _WarningText2=_interopRequireDefault(_WarningText);__webpack_require__(1313);var _scrollHelper=__webpack_require__(1314);var _scrollHelper2=_interopRequireDefault(_scrollHelper);var _DemoInfoBox=__webpack_require__(498);var _DemoInfoBox2=_interopRequireDefault(_DemoInfoBox);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: import type {State_ as CustomerOrderViewState} from '../../reducers/customerOrderView';*//*:: export type Props = {
  project: Object,
  apartment: Object,
  order: Object,
  rooms: any[],
  roomsIsFetching: boolean,
  activeSelection: any,
  products: any[],
  productsIsFetching: boolean,
  showMenu: boolean,
  activeProduct?: any,
  activeVariant?: any,
  activeImage?: any,
  showActiveProduct: boolean,
  expanedRooms: Object,
  pagination: Object,
  orderRowBySlotId: Object,
  orderRowIsFetching: boolean,
  customRows: any[],
  roomPrices: any[],
  additionalTotalPrice: {
    open: boolean,
    price: number,
  },
  totalPrice: number,
  discount: number,
  selectSlot: typeof selectSlot,
  openProduct: typeof openProduct,
  closeProduct: typeof closeProduct,
  selectImage: typeof selectImage,
  toggleRoom: typeof toggleRoom,
  setPage: typeof setPage,
  showAll: typeof showAll,
  toggleMenu: typeof toggleMenu,
  updateOrderRow: typeof updateOrderRow,
  createOrderRow: typeof createOrderRow,
  removeOrderRow: typeof removeOrderRow,
  updateOrderRows: typeof updateOrderRows,
  clearOrderRows: typeof clearOrderRows,
  fetchOrderData: typeof fetchOrderData,
  clear: typeof clear,
  updateOrder: (number, any) => void,
  userRole: number,
  orderComplete: boolean,
  showHeader?: boolean,
  sendEmail: typeof sendEmail,
  showHelp: boolean,
  toggleHelp: typeof toggleHelp,
  selectAdvanced: typeof selectAdvanced,
  selectAdditional: typeof selectAdditional,
  toggleRoomPrice: typeof toggleRoomPrice,
  toggleAdditionalPrice: typeof toggleAdditionalPrice,
  togglePrices: typeof togglePrices,
  pricesExpanded: boolean,
};*/var _ref=_react2.default.createElement(_DemoInfoBox2.default,null);var _ref2=_react2.default.createElement('div',{className:'callout warning text-center'},_react2.default.createElement('div',null,'Den h\xE4r ordern \xE4r l\xE5st av inredningsansvarig'));var _ref3=_react2.default.createElement('div',{className:'callout success text-center'},_react2.default.createElement('h4',null,'Str\xE5lande, du har nu gjort ett komplett urval!'),'\xC4ndringar \xE4r m\xF6jliga fram tills inredningsansvarig l\xE5ser best\xE4llningen.');var _ref4=_react2.default.createElement('i',{className:'fa fa-bars'});var _ref5=_react2.default.createElement('span',null,'Mina tillval');var _ref6=_react2.default.createElement('div',{className:'additional-choices-check'},_react2.default.createElement('i',{className:'fa fa-check-square'}));var _ref7=_react2.default.createElement('div',{className:'additional-choices-title'},'Extra tillvalsprodukter');var _ref8=_react2.default.createElement('div',{className:'order-complete'},'Nu har du gjort ett komplett urval. \xC4ndringar \xE4r m\xF6jliga fram tills inredningsansvarig l\xE5ser best\xE4llningen.');var _ref9=_react2.default.createElement(_WarningText2.default,null);var CustomerOrderContainer=function(_Component){_inherits(CustomerOrderContainer,_Component);function CustomerOrderContainer(){_classCallCheck(this,CustomerOrderContainer);return _possibleConstructorReturn(this,(CustomerOrderContainer.__proto__||Object.getPrototypeOf(CustomerOrderContainer)).apply(this,arguments));}_createClass(CustomerOrderContainer,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,apartment=_props.apartment,order=_props.order,fetchOrderData=_props.fetchOrderData;if(apartment&&order){fetchOrderData(order,apartment);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clear();}},{key:'getRoomCoverImage',value:function getRoomCoverImage(roomTypeId){var project=this.props.project;return(0,_find3.default)({roomTypeId:roomTypeId},project.images);}},{key:'orderVariant',value:function orderVariant(slot,variant){var _props2=this.props,order=_props2.order,orderRowBySlotId=_props2.orderRowBySlotId,updateOrderRow=_props2.updateOrderRow,createOrderRow=_props2.createOrderRow,activeSelection=_props2.activeSelection;var existingRow=void 0,existingConfig=void 0;if(!!slot.advanced&&!!activeSelection.config){existingRow=(0,_find3.default)(function(r){return r.productSlotId===slot.id&&(0,_some3.default)({id:r.configId},activeSelection.config.configs);},orderRowBySlotId);existingConfig=(0,_find3.default)({parentId:!!activeSelection.parentConfig?activeSelection.parentConfig.id:null,productVariantId:variant.id},activeSelection.config.configs);}else if(!slot.advanced){existingRow=orderRowBySlotId[slot.id+'__'];}if(existingRow&&existingRow.productVariantId===variant.id){return;}if(existingRow){updateOrderRow(existingRow,slot,variant,existingConfig,activeSelection.parentConfig);}else{createOrderRow(order.id,slot,variant,existingConfig,activeSelection.parentConfig);}}},{key:'render',value:function render(){var _this2=this;var _props3=this.props,sendEmail=_props3.sendEmail,showHelp=_props3.showHelp,toggleHelp=_props3.toggleHelp,productsIsFetching=_props3.productsIsFetching,activeSelection=_props3.activeSelection,products=_props3.products,activeProduct=_props3.activeProduct,activeVariant=_props3.activeVariant,activeImage=_props3.activeImage,showActiveProduct=_props3.showActiveProduct,openProduct=_props3.openProduct,closeProduct=_props3.closeProduct,selectImage=_props3.selectImage,toggleRoom=_props3.toggleRoom,expanedRooms=_props3.expanedRooms,pagination=_props3.pagination,setPage=_props3.setPage,showAll=_props3.showAll,orderRowBySlotId=_props3.orderRowBySlotId,showMenu=_props3.showMenu,toggleMenu=_props3.toggleMenu,roomPrices=_props3.roomPrices,additionalTotalPrice=_props3.additionalTotalPrice,totalPrice=_props3.totalPrice,discount=_props3.discount,orderRowIsFetching=_props3.orderRowIsFetching,customRows=_props3.customRows,rooms=_props3.rooms,roomsIsFetching=_props3.roomsIsFetching,removeOrderRow=_props3.removeOrderRow,updateOrderRows=_props3.updateOrderRows,updateOrder=_props3.updateOrder,order=_props3.order,userRole=_props3.userRole,orderComplete=_props3.orderComplete,_props3$showHeader=_props3.showHeader,showHeader=_props3$showHeader===undefined?true:_props3$showHeader,selectAdvanced=_props3.selectAdvanced,selectSlot=_props3.selectSlot,selectAdditional=_props3.selectAdditional,clearOrderRows=_props3.clearOrderRows,toggleRoomPrice=_props3.toggleRoomPrice,toggleAdditionalPrice=_props3.toggleAdditionalPrice,togglePrices=_props3.togglePrices,pricesExpanded=_props3.pricesExpanded;return _react2.default.createElement('div',{id:'scroll-anchor',className:'CustomerOrderContainer'},_react2.default.createElement('div',{className:'w-100 f-14'},userRole===_roles.DEMO&&_ref),showHeader&&_react2.default.createElement('div',{className:'page-header'},order.state!==_orderStates.NEW&&_ref2,order.state===_orderStates.NEW&&!!orderComplete&&userRole===_roles.CUSTOMER&&_ref3,_react2.default.createElement('div',{className:'page-title'},_react2.default.createElement('div',{className:'toggle-menu show-for-small-only',onClick:function onClick(){return toggleMenu(!showMenu);}},_ref4),activeSelection.room&&activeSelection.slot&&_react2.default.createElement('span',null,activeSelection.room.name,' - ',activeSelection.slot.name),!activeSelection.room&&_ref5,!!rooms.length&&_react2.default.createElement(_CustomerOrderPrice2.default,{discount:discount,additionalTotalPrice:additionalTotalPrice,roomPrices:roomPrices,totalPrice:totalPrice,toggleRoomPrice:toggleRoomPrice,toggleAdditionalPrice:toggleAdditionalPrice,togglePrices:togglePrices,expanded:pricesExpanded,customRows:customRows,userRole:userRole}))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:(0,_classnames2.default)({'room-menu-container column shrink':true,'hide-for-small-only':!showMenu})},!!rooms.length&&_react2.default.createElement(_CustomerProductSlotList2.default,{rooms:rooms,expanedRooms:expanedRooms,orderRowBySlotId:orderRowBySlotId,onRoomClick:function onRoomClick(roomId){return toggleRoom(roomId,!expanedRooms[roomId]);},onSlotClick:function onSlotClick(room,slot){(0,_scrollHelper2.default)('scroll-anchor');selectSlot(order.id,room,slot);},onAdvancedClick:function onAdvancedClick(room,slot,productType){(0,_scrollHelper2.default)('scroll-anchor');selectAdvanced(room,slot,productType);},activeSelection:activeSelection}),!!customRows.length&&_react2.default.createElement('div',null,_react2.default.createElement('div',{onClick:function onClick(){(0,_scrollHelper2.default)('scroll-anchor');selectAdditional();},className:(0,_classnames2.default)({'additional-choices':true,'active':activeSelection.additional})},_ref6,_ref7)),!!orderComplete&&userRole===_roles.CUSTOMER&&_ref8,userRole!==_roles.DEMO&&_react2.default.createElement('div',null,!orderComplete&&userRole!==_roles.CUSTOMER&&_react2.default.createElement(_ActionConfirmation2.default,{id:'fillStandard',className:'expanded warning column shrink',message:'Vill du verkligen fylla resterande produktplatser med standardval?',buttonText:'Fyll med standardval',action:function action(){return updateOrderRows(order.id,{standard:true});}}),userRole!==_roles.CUSTOMER&&order.state===_orderStates.NEW&&!(0,_isEmpty3.default)(orderRowBySlotId)&&_react2.default.createElement(_ActionConfirmation2.default,{id:'clearRows',className:'expanded warning column shrink',message:'Vill du verkligen rensa alla val som redan gjorts?',buttonText:'Rensa alla val',action:function action(){return clearOrderRows(order.id);}}),userRole!==_roles.CUSTOMER&&order.state===_orderStates.NEW&&_react2.default.createElement(_ActionConfirmation2.default,{id:'lockOrder',className:'expanded success column shrink',message:'Vill du verkligen l\xE5sa best\xE4llningen?',buttonText:'L\xE5s best\xE4llning',action:function action(){return updateOrder(order.id,_orderStates.COMPLETED);},disabled:!orderComplete}),userRole!==_roles.CUSTOMER&&order.state===_orderStates.COMPLETED&&_react2.default.createElement(_ActionConfirmation2.default,{id:'unlockOrder',className:'expanded alert column shrink',message:'Vill du verkligen l\xE5sa upp best\xE4llningen?',buttonText:'L\xE5s upp best\xE4llning',action:function action(){return updateOrder(order.id,_orderStates.NEW);}}),userRole!==_roles.CUSTOMER&&order.state===_orderStates.COMPLETED&&_react2.default.createElement(_ActionConfirmation2.default,{id:'confirmPurchase',className:'expanded success column shrink',messages:['Är de aktuella plan- och köksritningarna kopplade?','Vill du verkligen bekräfta beställningen för inköp?'],buttonText:'Bekr\xE4fta f\xF6r ink\xF6p',action:function action(){return updateOrder(order.id,_orderStates.CONFIRMED);}}),userRole!==_roles.CUSTOMER&&order.state===_orderStates.CONFIRMED&&_react2.default.createElement(_ActionConfirmation2.default,{id:'cancelPurchase',className:'expanded alert column shrink',message:'Vill du verkligen avbryta best\xE4llningen f\xF6r ink\xF6p?',buttonText:'Avbryt f\xF6r ink\xF6p',action:function action(){return updateOrder(order.id,_orderStates.COMPLETED);}}),userRole===_roles.CUSTOMER&&_react2.default.createElement('button',{onClick:function onClick(){return toggleHelp(true);},className:'button expanded secondary column shrink'},'Kontakta s\xE4ljare'),_ref9)),_react2.default.createElement('div',{className:'column right-col'},!showHeader&&!!rooms.length&&_react2.default.createElement(_CustomerOrderPrice2.default,{discount:discount,additionalTotalPrice:additionalTotalPrice,roomPrices:roomPrices,totalPrice:totalPrice,toggleRoomPrice:toggleRoomPrice,toggleAdditionalPrice:toggleAdditionalPrice,togglePrices:togglePrices,expanded:pricesExpanded,customRows:customRows,userRole:userRole}),activeSelection.room&&function(){var coverImage=_this2.getRoomCoverImage(activeSelection.room.roomTypeId);return!!coverImage&&_react2.default.createElement('div',{className:'room-cover-image'},_react2.default.createElement(_CoverImage2.default,{imageId:coverImage.id}));}(),activeSelection.slot&&_react2.default.createElement(_CustomerProductList2.default,{products:products,isLoading:productsIsFetching,pagination:pagination,setPage:setPage,showAll:showAll,onSelectProduct:function onSelectProduct(v){return _this2.orderVariant(activeSelection.slot,v);},onOpenProduct:openProduct,onRemoveProduct:function onRemoveProduct(){return removeOrderRow(activeSelection.orderRow.id,activeSelection.slot.id);},enabled:order.state===_orderStates.NEW&&(!activeSelection.slot.advanced||!!activeSelection.canChoose),activeSelection:activeSelection,userRole:userRole}),activeSelection.additional&&_react2.default.createElement(_CustomerCustomProductList2.default,{customProducts:customRows})),showActiveProduct&&activeProduct&&activeVariant&&activeSelection.slot&&_react2.default.createElement(_CustomerProductDialog2.default,{activeImage:activeImage,variant:activeVariant,product:activeProduct,onSelectProduct:function onSelectProduct(v){return _this2.orderVariant(activeSelection.slot,v);},onRemoveProduct:function onRemoveProduct(){return removeOrderRow(activeSelection.orderRow.id,activeSelection.slot.id);},onImageSelect:selectImage,onClose:closeProduct,enabled:order.state===_orderStates.NEW&&(!activeSelection.slot.advanced||!!activeSelection.canChoose),activeSelection:activeSelection,userRole:userRole})),showHelp&&_react2.default.createElement(_ModalDialog2.default,{onClose:function onClose(){return toggleHelp(false);},showCloseButton:true,className:'HelpFormDialog',show:true},_react2.default.createElement(_HelpForm2.default,{onSubmit:function onSubmit(v){return sendEmail(order.id,v.message);}})),_react2.default.createElement(_LoadingIndicator2.default,{isGlobal:true,isLoading:productsIsFetching||roomsIsFetching||orderRowIsFetching}));}}]);return CustomerOrderContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref10){var userRole=_ref10.auth.currentUser.role,_ref10$customerOrderV=_ref10.customerOrderView,_ref10$customerOrderV2=_ref10$customerOrderV.products,products=_ref10$customerOrderV2.list,productsIsFetching=_ref10$customerOrderV2.isFetching,_ref10$customerOrderV3=_ref10$customerOrderV.product,activeProduct=_ref10$customerOrderV3.activeProduct,activeVariant=_ref10$customerOrderV3.activeVariant,activeImage=_ref10$customerOrderV3.activeImage,showActiveProduct=_ref10$customerOrderV3.show,activeSelection=_ref10$customerOrderV.activeSelection,pagination=_ref10$customerOrderV.pagination,_ref10$customerOrderV4=_ref10$customerOrderV.rooms,expanedRooms=_ref10$customerOrderV4.expanded,rooms=_ref10$customerOrderV4.list,roomsIsFetching=_ref10$customerOrderV4.isFetching,_ref10$customerOrderV5=_ref10$customerOrderV.orderRows,orderRowBySlotId=_ref10$customerOrderV5.bySlotId,orderRowIsFetching=_ref10$customerOrderV5.isFetching,customRows=_ref10$customerOrderV.customRows.list,_ref10$customerOrderV6=_ref10$customerOrderV.prices,pricesExpanded=_ref10$customerOrderV6.open,roomPrices=_ref10$customerOrderV6.roomPrices,additionalTotalPrice=_ref10$customerOrderV6.additionalTotalPrice,totalPrice=_ref10$customerOrderV6.total,discount=_ref10$customerOrderV6.discount,showMenu=_ref10$customerOrderV.menuVisibility,orderComplete=_ref10$customerOrderV.orderComplete,showHelp=_ref10$customerOrderV.help;return{products:products,productsIsFetching:productsIsFetching,rooms:rooms,roomsIsFetching:roomsIsFetching,customRows:customRows,activeProduct:activeProduct,activeVariant:activeVariant,activeImage:activeImage,showActiveProduct:showActiveProduct,activeSelection:activeSelection,expanedRooms:expanedRooms,pagination:pagination,orderRowBySlotId:orderRowBySlotId,orderRowIsFetching:orderRowIsFetching,roomPrices:roomPrices,additionalTotalPrice:additionalTotalPrice,totalPrice:totalPrice,discount:discount,showMenu:showMenu,userRole:userRole,orderComplete:orderComplete,showHelp:showHelp,pricesExpanded:pricesExpanded};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchOrderData:function fetchOrderData(order,apartment){return dispatch((0,_customerOrderView.fetchOrderData)(order,apartment));},selectSlot:function selectSlot(orderId,room,slot){return dispatch((0,_customerOrderView.selectSlot)(orderId,room,slot));},setPage:function setPage(page){return dispatch((0,_customerOrderView.setPage)(page));},openProduct:function openProduct(product,variant){return dispatch((0,_customerOrderView.openProduct)(product,variant));},closeProduct:function closeProduct(){return dispatch((0,_customerOrderView.closeProduct)());},selectImage:function selectImage(image){return dispatch((0,_customerOrderView.selectImage)(image));},toggleRoom:function toggleRoom(room,expanded){return dispatch((0,_customerOrderView.toggleRoom)(room,expanded));},showAll:function showAll(){return dispatch((0,_customerOrderView.showAll)());},createOrderRow:function createOrderRow(orderId,slot,variant,config,parentConfig){return dispatch((0,_customerOrderView.createOrderRow)(orderId,slot,variant,config,parentConfig));},updateOrderRow:function updateOrderRow(row,slot,variant,config,parentConfig){return dispatch((0,_customerOrderView.updateOrderRow)(row,slot,variant,config,parentConfig));},removeOrderRow:function removeOrderRow(rowId,slotId){return dispatch((0,_customerOrderView.removeOrderRow)(rowId,slotId));},updateOrderRows:function updateOrderRows(rowId,data){return dispatch((0,_customerOrderView.updateOrderRows)(rowId,data));},toggleMenu:function toggleMenu(show){return dispatch((0,_customerOrderView.toggleMenu)(show));},toggleHelp:function toggleHelp(show){return dispatch((0,_customerOrderView.toggleHelp)(show));},sendEmail:function sendEmail(orderId,message){return dispatch((0,_customerOrderView.sendEmail)(orderId,message));},clear:function clear(){return dispatch((0,_customerOrderView.clear)());},selectAdvanced:function selectAdvanced(room,slot,productType){return dispatch((0,_customerOrderView.selectAdvanced)(room,slot,productType));},selectAdditional:function selectAdditional(){return dispatch((0,_customerOrderView.selectAdditional)());},clearOrderRows:function clearOrderRows(rowId){return dispatch((0,_customerOrderView.clearOrderRows)(rowId));},toggleRoomPrice:function toggleRoomPrice(roomId){return dispatch((0,_customerOrderView.toggleRoomPrice)(roomId));},toggleAdditionalPrice:function toggleAdditionalPrice(){return dispatch((0,_customerOrderView.toggleAdditionalPrice)());},togglePrices:function togglePrices(){return dispatch((0,_customerOrderView.togglePrices)());}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(CustomerOrderContainer);

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.getVariantOptions=undefined;var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLinkify=__webpack_require__(179);var _reactLinkify2=_interopRequireDefault(_reactLinkify);var _priceHelpers=__webpack_require__(85);var _CustomerProductImage=__webpack_require__(265);var _CustomerProductImage2=_interopRequireDefault(_CustomerProductImage);var _CustomerProductOrderButton=__webpack_require__(494);var _CustomerProductOrderButton2=_interopRequireDefault(_CustomerProductOrderButton);var _FormattedPrice=__webpack_require__(131);var _FormattedPrice2=_interopRequireDefault(_FormattedPrice);var _roles=__webpack_require__(49);__webpack_require__(1284);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var warningText='Ej valbart p.g.a. tidigare val.';var getVariantOptions=exports.getVariantOptions=function getVariantOptions(activeSelection/*: any*/,enabled/*: boolean*/,product/*: any*/,variant/*: any*/){var variantEnabled=true;var isDefault=false;var isSelected=false;var variantConfig=null;var showWarning=!!enabled?false:warningText;if(!!activeSelection.slot.advanced&&!!activeSelection.config){variantConfig=(0,_find3.default)({parentId:!!activeSelection.parentConfig?activeSelection.parentConfig.id:null,productVariantId:variant.id},activeSelection.config.configs);if(!!variantEnabled){variantEnabled=!!variantConfig;}if(!!enabled&&!variantEnabled){showWarning=warningText;}isDefault=!!activeSelection.parentConfig?(0,_some3.default)({productId:product.id,productTypeId:activeSelection.config.id},activeSelection.parentConfig.standardProducts):activeSelection.slot.standardProductId===product.id;if(!!variantConfig){isSelected=!!activeSelection.orderRow?activeSelection.orderRow.configId===variantConfig.id:false;}}else{isDefault=activeSelection.slot.defaultProductId===product.id;isSelected=!!activeSelection.orderRow?activeSelection.orderRow.productVariantId===variant.id:false;}return{variantEnabled:variantEnabled,isDefault:isDefault,isSelected:isSelected,variantConfig:variantConfig,showWarning:showWarning};};/*:: export type Props = {
  product: Object,
  variant: Object,
  onOpenProduct: Function,
  onSelectProduct: Function,
  onRemoveProduct: Function,
  enabled: boolean,
  variantOptions: Object,
  activeSelection: Object,
  userRole: Number,
};*/var _ref2=_react2.default.createElement('div',{className:'CustomerProductCard-popup-info'},'Klicka f\xF6r mer info');var _ref3=_react2.default.createElement('span',{className:'CustomerProductCard-popup-info-icon'},_react2.default.createElement('i',{className:'fa fa-info-circle'}));var _ref4=_react2.default.createElement('td',null,'F\xE4rg:');var _ref5=_react2.default.createElement('td',null,'Bredd:');var _ref6=_react2.default.createElement('td',null,'H\xF6jd:');var _ref7=_react2.default.createElement('td',null,'Djup:');var _ref8=_react2.default.createElement('div',null,'Ersatt av:');var _ref9=_react2.default.createElement('div',{className:'CustomerProductCard-information'},_react2.default.createElement('div',null,'Produkten har utg\xE5tt'));var _ref10=_react2.default.createElement('div',{className:'label CustomerProductCard-label'},'Standard');var _ref11=_react2.default.createElement('div',{className:'ribbon ribbon-small'},_react2.default.createElement('i',{className:'fa fa-check-circle-o'}));var CustomerProductCard=function CustomerProductCard(_ref){var product=_ref.product,variant=_ref.variant,onOpenProduct=_ref.onOpenProduct,onSelectProduct=_ref.onSelectProduct,onRemoveProduct=_ref.onRemoveProduct,enabled=_ref.enabled,variantOptions=_ref.variantOptions,activeSelection=_ref.activeSelection,userRole=_ref.userRole;var variantEnabled=variantOptions.variantEnabled,isDefault=variantOptions.isDefault,isSelected=variantOptions.isSelected,variantConfig=variantOptions.variantConfig,showWarning=variantOptions.showWarning;return _react2.default.createElement('div',{className:'CustomerProductCard'},_react2.default.createElement('div',{className:'CustomerProductCard-content'},_react2.default.createElement('div',{className:'CustomerProductCard-info',onClick:function onClick(){return onOpenProduct(product,variant);}},_react2.default.createElement('div',{className:'CustomerProductCard-image'},_react2.default.createElement(_CustomerProductImage2.default,{className:'fill-container',file:(0,_find3.default)({isDefault:true},variant.images),size:'240h'}),_ref2,!isSelected&&_ref3),_react2.default.createElement('div',{className:'CustomerProductCard-name'},product.name,' - ',variant.name),_react2.default.createElement(_reactLinkify2.default,{className:'CustomerProductCard-description shrink',properties:{target:'_blank'}},_react2.default.createElement('p',null,variant.externalDescription||product.externalDescription)),_react2.default.createElement('div',{className:'CustomerProductCard-specifications'},_react2.default.createElement('table',null,_react2.default.createElement('tbody',null,!(0,_isEmpty3.default)(variant.color)&&_react2.default.createElement('tr',null,_ref4,_react2.default.createElement('td',null,variant.color)),!!variant.sizeWidth&&_react2.default.createElement('tr',null,_ref5,_react2.default.createElement('td',null,variant.sizeWidth,' cm')),!!variant.sizeHeight&&_react2.default.createElement('tr',null,_ref6,_react2.default.createElement('td',null,variant.sizeHeight,' cm')),!!variant.sizeDepth&&_react2.default.createElement('tr',null,_ref7,_react2.default.createElement('td',null,variant.sizeDepth,' cm'))))),_react2.default.createElement('div',{className:'CustomerProductCard-price'},!isDefault&&(!activeSelection.slot.advanced||!!variantConfig)&&_react2.default.createElement('span',null,'Pris: ',_react2.default.createElement(_FormattedPrice2.default,{value:(0,_priceHelpers.productPrice)(variant,activeSelection.slot,activeSelection.orderRow,variantConfig,activeSelection.config),unit:(0,_priceHelpers.productUnit)(variant,activeSelection.slot,activeSelection.orderRow,variantConfig,activeSelection.config)}))),variant.replacement&&_react2.default.createElement('div',{className:'CustomerProductCard-information'},_ref8,_react2.default.createElement('div',{className:'CustomerProductCard-replacement-name'},variant.replacement.productName,' - ',variant.replacement.variantName)),!variant.replacement&&(product.archived||variant.archived)&&_ref9),isDefault&&_ref10,userRole!==_roles.DEMO&&_react2.default.createElement(_CustomerProductOrderButton2.default,{isOrdered:isSelected,onSelectProduct:function(_onSelectProduct){function onSelectProduct(){return _onSelectProduct.apply(this,arguments);}onSelectProduct.toString=function(){return _onSelectProduct.toString();};return onSelectProduct;}(function(){return onSelectProduct(variant);}),onRemoveProduct:function(_onRemoveProduct){function onRemoveProduct(){return _onRemoveProduct.apply(this,arguments);}onRemoveProduct.toString=function(){return _onRemoveProduct.toString();};return onRemoveProduct;}(function(){return onRemoveProduct(variant);}),enabled:enabled&&variantEnabled,showWarning:showWarning}),userRole!==_roles.DEMO&&isSelected&&_ref11));};exports.default=CustomerProductCard;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(239);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 492 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(1280),
    hasUnicode = __webpack_require__(492),
    unicodeToArray = __webpack_require__(1281);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactTooltip=__webpack_require__(91);var _reactTooltip2=_interopRequireDefault(_reactTooltip);__webpack_require__(1283);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  isOrdered: boolean,
  onSelectProduct: Function,
  onRemoveProduct: Function,
  enabled: boolean,
  showWarning: string | boolean,
};*/var _ref2=_react2.default.createElement('i',{className:'remove-icon fa fa-remove'});var CustomerProductOrderButton=function CustomerProductOrderButton(_ref){var isOrdered=_ref.isOrdered,onSelectProduct=_ref.onSelectProduct,onRemoveProduct=_ref.onRemoveProduct,enabled=_ref.enabled,showWarning=_ref.showWarning;return _react2.default.createElement('div',_extends({className:'CustomerProductOrderButton'},!!showWarning?{'data-tip':'','data-for':'order-warning-tip'}:{}),!isOrdered&&_react2.default.createElement('button',{type:'button',className:'expanded button secondary',disabled:!enabled,onClick:onSelectProduct},'V\xE4lj produkt'),isOrdered&&_react2.default.createElement('button',{type:'button',className:'expanded button success',onClick:onRemoveProduct,disabled:!enabled},_ref2,' Ta bort val'),typeof showWarning==='string'&&_react2.default.createElement(_reactTooltip2.default,{id:'order-warning-tip',effect:'solid'},_react2.default.createElement('span',null,showWarning)));};exports.default=CustomerProductOrderButton;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1288);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fileUrl=_request.apiBase+'/files';/*:: export type Props = {
  imageId: string,
};*/var CoverImage=function CoverImage(_ref){var imageId=_ref.imageId;return _react2.default.createElement('div',{className:'CoverImage',style:{backgroundImage:'url('+fileUrl+'/preview/'+imageId+')'}});};exports.default=CoverImage;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

var tabbableNode = /input|select|textarea|button|object/;

function hidesContents(element) {
  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;

  // If the node is empty, this is good enough
  if (zeroSize && !element.innerHTML) return true;

  // Otherwise we need to check some styles
  var style = window.getComputedStyle(element);
  return zeroSize ? style.getPropertyValue("overflow") !== "visible" : style.getPropertyValue("display") == "none";
}

function visible(element) {
  var parentElement = element;
  while (parentElement) {
    if (parentElement === document.body) break;
    if (hidesContents(parentElement)) return false;
    parentElement = parentElement.parentNode;
  }
  return true;
}

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
  return res && visible(element);
}

function tabbable(element) {
  var tabIndex = element.getAttribute("tabindex");
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
}
module.exports = exports["default"];

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertNodeList = assertNodeList;
exports.setElement = setElement;
exports.validateElement = validateElement;
exports.hide = hide;
exports.show = show;
exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
exports.resetForTesting = resetForTesting;

var _warning = __webpack_require__(32);

var _warning2 = _interopRequireDefault(_warning);

var _safeHTMLElement = __webpack_require__(267);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var globalElement = null;

function assertNodeList(nodeList, selector) {
  if (!nodeList || !nodeList.length) {
    throw new Error("react-modal: No elements were found for selector " + selector + ".");
  }
}

function setElement(element) {
  var useElement = element;
  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
    var el = document.querySelectorAll(useElement);
    assertNodeList(el, useElement);
    useElement = "length" in el ? el[0] : el;
  }
  globalElement = useElement || globalElement;
  return globalElement;
}

function validateElement(appElement) {
  if (!appElement && !globalElement) {
    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));

    return false;
  }

  return true;
}

function hide(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).setAttribute("aria-hidden", "true");
  }
}

function show(appElement) {
  if (validateElement(appElement)) {
    (appElement || globalElement).removeAttribute("aria-hidden");
  }
}

function documentNotReadyOrSSRTesting() {
  globalElement = null;
}

function resetForTesting() {
  globalElement = null;
}

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _ref=_react2.default.createElement("div",{className:"callout warning"},_react2.default.createElement("div",{className:"f-bold"},"Demol\xE4ge/Visningsl\xE4ge"),_react2.default.createElement("p",null,"Du \xE4r inloggad i ett visningsl\xE4ge f\xF6r det aktuella bostadsprojektet, det ger en \xF6verblick \xF6ver tillvalssystemet och det aktuella produktsortimentet. Observera att utbudet kan variera n\xE4r man sedan som kund loggar in p\xE5 sin specifika l\xE4genhet, m\xF6jliga tillval \xE4r d\xE5 anpassade efter l\xE4genhetens placering, utformning och storlek. Vi reserverar oss f\xF6r utg\xE5ende produkter samt pris- och fabrikat\xE4ndringar. F\xE4rg\xE5tergivning kan variera."));var DemoInfoBox=function DemoInfoBox(){return _ref;};exports.default=DemoInfoBox;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bg.88f0ffc0.jpg";

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _defaultPropTypes = __webpack_require__(501);

var _defaultPropTypes2 = _interopRequireDefault(_defaultPropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Notification = function (_Component) {
  _inherits(Notification, _Component);

  function Notification(props) {
    _classCallCheck(this, Notification);

    var _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, props));

    _this.getBarStyle = _this.getBarStyle.bind(_this);
    _this.getActionStyle = _this.getActionStyle.bind(_this);
    _this.getTitleStyle = _this.getTitleStyle.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);

    if (props.onDismiss && props.isActive) {
      _this.dismissTimeout = setTimeout(props.onDismiss, props.dismissAfter);
    }
    return _this;
  }

  _createClass(Notification, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dismissAfter === false) return;

      // See http://eslint.org/docs/rules/no-prototype-builtins
      if (!{}.hasOwnProperty.call(nextProps, 'isLast')) {
        clearTimeout(this.dismissTimeout);
      }

      if (nextProps.onDismiss) {
        if (nextProps.isActive && !this.props.isActive || nextProps.dismissAfter && this.props.dismissAfter === false) {
          this.dismissTimeout = setTimeout(nextProps.onDismiss, nextProps.dismissAfter);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.dismissAfter) clearTimeout(this.dismissTimeout);
    }

    /*
    * @description Dynamically get the styles for the bar.
    * @returns {object} result The style.
    */

  }, {
    key: 'getBarStyle',
    value: function getBarStyle() {
      if (this.props.style === false) return {};

      var _props = this.props,
          isActive = _props.isActive,
          barStyle = _props.barStyle,
          activeBarStyle = _props.activeBarStyle;


      var baseStyle = {
        position: 'fixed',
        bottom: '2rem',
        left: '-100%',
        width: 'auto',
        padding: '1rem',
        margin: 0,
        color: '#fafafa',
        font: '1rem normal Roboto, sans-serif',
        borderRadius: '5px',
        background: '#212121',
        borderSizing: 'border-box',
        boxShadow: '0 0 1px 1px rgba(10, 10, 11, .125)',
        cursor: 'default',
        WebKitTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
        MozTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
        msTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
        OTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
        transition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
        WebkitTransform: 'translatez(0)',
        MozTransform: 'translatez(0)',
        msTransform: 'translatez(0)',
        OTransform: 'translatez(0)',
        transform: 'translatez(0)'
      };

      return isActive ? _extends({}, baseStyle, { left: '1rem' }, barStyle, activeBarStyle) : _extends({}, baseStyle, barStyle);
    }

    /*
    * @function getActionStyle
    * @description Dynamically get the styles for the action text.
    * @returns {object} result The style.
    */

  }, {
    key: 'getActionStyle',
    value: function getActionStyle() {
      return this.props.style !== false ? _extends({}, {
        padding: '0.125rem',
        marginLeft: '1rem',
        color: '#f44336',
        font: '.75rem normal Roboto, sans-serif',
        lineHeight: '1rem',
        letterSpacing: '.125ex',
        textTransform: 'uppercase',
        borderRadius: '5px',
        cursor: 'pointer'
      }, this.props.actionStyle) : {};
    }

    /*
    * @function getTitleStyle
    * @description Dynamically get the styles for the title.
    * @returns {object} result The style.
    */

  }, {
    key: 'getTitleStyle',
    value: function getTitleStyle() {
      return this.props.style !== false ? _extends({}, {
        fontWeight: '700',
        marginRight: '.5rem'
      }, this.props.titleStyle) : {};
    }

    /*
    * @function handleClick
    * @description Handle click events on the action button.
    */

  }, {
    key: 'handleClick',
    value: function handleClick() {
      if (this.props.onClick && typeof this.props.onClick === 'function') {
        return this.props.onClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = 'notification-bar';

      if (this.props.isActive) className += ' ' + this.props.activeClassName;
      if (this.props.className) className += ' ' + this.props.className;

      return _react2.default.createElement(
        'div',
        { className: className, style: this.getBarStyle() },
        _react2.default.createElement(
          'div',
          { className: 'notification-bar-wrapper' },
          this.props.title ? _react2.default.createElement(
            'span',
            {
              className: 'notification-bar-title',
              style: this.getTitleStyle()
            },
            this.props.title
          ) : null,
          _react2.default.createElement(
            'span',
            { className: 'notification-bar-message' },
            this.props.message
          ),
          this.props.action ? _react2.default.createElement(
            'span',
            {
              className: 'notification-bar-action',
              onClick: this.handleClick,
              style: this.getActionStyle()
            },
            this.props.action
          ) : null
        )
      );
    }
  }]);

  return Notification;
}(_react.Component);

Notification.propTypes = _defaultPropTypes2.default;

Notification.defaultProps = {
  isActive: false,
  dismissAfter: 2000,
  activeClassName: 'notification-bar-active'
};

exports.default = Notification;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
  action: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.node]),
  onClick: _propTypes2.default.func,
  style: _propTypes2.default.bool,
  actionStyle: _propTypes2.default.object,
  titleStyle: _propTypes2.default.object,
  barStyle: _propTypes2.default.object,
  activeBarStyle: _propTypes2.default.object,
  dismissAfter: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),
  onDismiss: _propTypes2.default.func,
  className: _propTypes2.default.string,
  activeClassName: _propTypes2.default.string,
  isActive: _propTypes2.default.bool,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
};

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(503);
module.exports = __webpack_require__(508);


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(504).enable();
  window.Promise = __webpack_require__(506);
}

// fetch() polyfill for making API calls.
__webpack_require__(507);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(180);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(270);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104)))

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(270);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 507 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};__webpack_require__(509);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDom=__webpack_require__(72);var _reactDom2=_interopRequireDefault(_reactDom);var _reactTapEventPlugin=__webpack_require__(525);var _reactTapEventPlugin2=_interopRequireDefault(_reactTapEventPlugin);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _redux=__webpack_require__(15);var _reduxForm=__webpack_require__(4);var _reduxThunk=__webpack_require__(745);var _reduxThunk2=_interopRequireDefault(_reduxThunk);var _reduxDevtoolsExtension=__webpack_require__(746);var _reducers=__webpack_require__(747);var reducers=_interopRequireWildcard(_reducers);var _fileUploader=__webpack_require__(81);var _fileUploader2=_interopRequireDefault(_fileUploader);var _AuthenticationWrapper=__webpack_require__(951);var _AuthenticationWrapper2=_interopRequireDefault(_AuthenticationWrapper);var _LoginContainer=__webpack_require__(1351);var _LoginContainer2=_interopRequireDefault(_LoginContainer);var _DemoRedirectContainer=__webpack_require__(1358);var _DemoRedirectContainer2=_interopRequireDefault(_DemoRedirectContainer);var _ActivationContainer=__webpack_require__(1360);var _ActivationContainer2=_interopRequireDefault(_ActivationContainer);var _NotificationContainer=__webpack_require__(1364);var _NotificationContainer2=_interopRequireDefault(_NotificationContainer);var _registerServiceWorker=__webpack_require__(1370);__webpack_require__(1371);__webpack_require__(1372);__webpack_require__(1373);__webpack_require__(1374);__webpack_require__(1375);__webpack_require__(1376);__webpack_require__(1377);__webpack_require__(1378);__webpack_require__(1379);function _interopRequireWildcard(obj){if(obj&&obj.__esModule){return obj;}else{var newObj={};if(obj!=null){for(var key in obj){if(Object.prototype.hasOwnProperty.call(obj,key))newObj[key]=obj[key];}}newObj.default=obj;return newObj;}}function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}(0,_reactTapEventPlugin2.default)();var store=(0,_redux.createStore)((0,_redux.combineReducers)(_extends({},reducers,{form:_reduxForm.reducer})),(0,_reduxDevtoolsExtension.composeWithDevTools)((0,_redux.applyMiddleware)(_reduxThunk2.default,_fileUploader2.default)));_reactDom2.default.render(_react2.default.createElement(_reactRedux.Provider,{store:store},_react2.default.createElement(_reactRouterDom.BrowserRouter,null,_react2.default.createElement('div',null,_react2.default.createElement(_NotificationContainer2.default,null),_react2.default.createElement(_reactRouterDom.Switch,null,_react2.default.createElement(_reactRouterDom.Route,{path:'/login',exact:true,component:_LoginContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:'/activate/:token',exact:true,render:function render(_ref){var params=_ref.match.params;return _react2.default.createElement(_ActivationContainer2.default,{token:params.token});}}),_react2.default.createElement(_reactRouterDom.Route,{path:'/demo/:projectName',exact:true,render:function render(_ref2){var params=_ref2.match.params;return _react2.default.createElement(_DemoRedirectContainer2.default,{projectName:params.projectName});}}),_react2.default.createElement(_reactRouterDom.Route,{component:_AuthenticationWrapper2.default}))))),document.getElementById('root'));if(true){Raygun.init("C1IHkXKl64Wv533mZyM9kg==").attach().withTags(['frontend']).setVersion("\"1.0.0\"");}(0,_registerServiceWorker.unregister)();

/***/ }),
/* 509 */
/***/ (function(module, exports) {

/*! Raygun4js - v1.18.7 - 2015-10-20
* https://github.com/MindscapeHQ/raygun4js
* Copyright (c) 2015 MindscapeHQ; Licensed MIT */
(function(window, undefined) {


var TraceKit = {};
var _oldTraceKit = window.TraceKit;

// global reference to slice
var _slice = [].slice;
var UNKNOWN_FUNCTION = '?';


/**
 * _has, a better form of hasOwnProperty
 * Example: _has(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */
function _has(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
}

function _isUndefined(what) {
    return typeof what === 'undefined';
}

/**
 * TraceKit.noConflict: Export TraceKit out to another variable
 * Example: var TK = TraceKit.noConflict()
 */
TraceKit.noConflict = function noConflict() {
    window.TraceKit = _oldTraceKit;
    return TraceKit;
};

/**
 * TraceKit.wrap: Wrap any function in a TraceKit reporter
 * Example: func = TraceKit.wrap(func);
 *
 * @param {Function} func Function to be wrapped
 * @return {Function} The wrapped func
 */
TraceKit.wrap = function traceKitWrapper(func) {
    function wrapped() {
        try {
            return func.apply(this, arguments);
        } catch (e) {
            TraceKit.report(e);
            throw e;
        }
    }
    return wrapped;
};

/**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */
TraceKit.report = (function reportModuleWrapper() {
    var handlers = [],
        lastException = null,
        lastExceptionStack = null;

    /**
     * Add a crash handler.
     * @param {Function} handler
     */
    function subscribe(handler) {
        installGlobalHandler();
        handlers.push(handler);
    }

    /**
     * Remove a crash handler.
     * @param {Function} handler
     */
    function unsubscribe(handler) {
        for (var i = handlers.length - 1; i >= 0; --i) {
            if (handlers[i] === handler) {
                handlers.splice(i, 1);
            }
        }
    }

    /**
     * Dispatch stack information to all handlers.
     * @param {Object.<string, *>} stack
     */
    function notifyHandlers(stack, windowError) {
        var exception = null;
        if (windowError && !TraceKit.collectWindowErrors) {
          return;
        }
        for (var i in handlers) {
            if (_has(handlers, i)) {
                try {
                    handlers[i].apply(null, [stack].concat(_slice.call(arguments, 2)));
                } catch (inner) {
                    exception = inner;
                }
            }
        }

        if (exception) {
            throw exception;
        }
    }

    var _oldOnerrorHandler, _onErrorHandlerInstalled;

    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} message Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error
     * occurred.
     */
    function traceKitWindowOnError(message, url, lineNo, columnNo, errorObj) {
        var stack = null;

        if (errorObj) {
          stack = TraceKit.computeStackTrace(errorObj);
        }
        else
        {
            if (lastExceptionStack) {
                TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
                stack = lastExceptionStack;
                lastExceptionStack = null;
                lastException = null;
            } else {
                var location = {
                    'url': url,
                    'line': lineNo,
                    'column': columnNo
                };
                location.func = TraceKit.computeStackTrace.guessFunctionName(location.url, location.line);
                location.context = TraceKit.computeStackTrace.gatherContext(location.url, location.line);
                stack = {
                    'mode': 'onerror',
                    'message': message,
                    'url': document.location.href,
                    'stack': [location],
                    'useragent': navigator.userAgent
                };
            }
        }

        notifyHandlers(stack, 'from window.onerror');

        if (_oldOnerrorHandler) {
            return _oldOnerrorHandler.apply(this, arguments);
        }

        return false;
    }

    function installGlobalHandler ()
    {
        if (_onErrorHandlerInstalled === true) {
           return;
        }
        _oldOnerrorHandler = window.onerror;
        window.onerror = traceKitWindowOnError;
        _onErrorHandlerInstalled = true;
    }

    /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     */
    function report(ex) {
        var args = _slice.call(arguments, 1);
        if (lastExceptionStack) {
            if (lastException === ex) {
                return; // already caught by an inner catch block, ignore
            } else {
                var s = lastExceptionStack;
                lastExceptionStack = null;
                lastException = null;
                notifyHandlers.apply(null, [s, null].concat(args));
            }
        }

        var stack = TraceKit.computeStackTrace(ex);
        lastExceptionStack = stack;
        lastException = ex;

        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        window.setTimeout(function () {
            if (lastException === ex) {
                lastExceptionStack = null;
                lastException = null;
                notifyHandlers.apply(null, [stack, null].concat(args));
            }
        }, (stack.incomplete ? 2000 : 0));

        throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }

    report.subscribe = subscribe;
    report.unsubscribe = unsubscribe;
    return report;
}());

/**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace.ofCaller([depth])
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *   s.stack[i].context  - an array of source code lines; the middle element corresponds to the correct line#
 *   s.mode              - 'stack', 'stacktrace', 'multiline', 'callers', 'onerror', or 'failed' -- method used to collect the stack trace
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 * Tracing example:
 *     function trace(message) {
 *         var stackInfo = TraceKit.computeStackTrace.ofCaller();
 *         var data = message + "\n";
 *         for(var i in stackInfo.stack) {
 *             var item = stackInfo.stack[i];
 *             data += (item.func || '[anonymous]') + "() in " + item.url + ":" + (item.line || '0') + "\n";
 *         }
 *         if (window.console)
 *             console.info(data);
 *         else
 *             alert(data);
 *     }
 */
TraceKit.computeStackTrace = (function computeStackTraceWrapper() {
    var debug = false,
        sourceCache = {};

    /**
     * Attempts to retrieve source code via XMLHttpRequest, which is used
     * to look up anonymous function names.
     * @param {string} url URL of source code.
     * @return {string} Source contents.
     */
    function loadSource(url) {
        if (typeof url !== 'string') {
          return [];
        }
        
        if (!TraceKit.remoteFetching) { //Only attempt request if remoteFetching is on.
            return '';
        }
        try {
            var getXHR = function() {
                try {
                    return new window.XMLHttpRequest();
                } catch (e) {
                    // explicitly bubble up the exception if not found
                    return new window.ActiveXObject('Microsoft.XMLHTTP');
                }
            };

            var request = getXHR();
            request.open('GET', url, false);
            request.send('');
            return request.responseText;
        } catch (e) {
            return '';
        }
    }

    /**
     * Retrieves source code from the source code cache.
     * @param {string} url URL of source code.
     * @return {Array.<string>} Source contents.
     */
    function getSource(url) {
        if (!_has(sourceCache, url)) {
            // URL needs to be able to fetched within the acceptable domain.  Otherwise,
            // cross-domain errors will be triggered.
            var source = '';

            url = url || "";

            if (url.indexOf && url.indexOf(document.domain) !== -1) {
                source = loadSource(url);
            }
            sourceCache[url] = source ? source.split('\n') : [];
        }

        return sourceCache[url];
    }

    /**
     * Tries to use an externally loaded copy of source code to determine
     * the name of a function by looking at the name of the variable it was
     * assigned to, if any.
     * @param {string} url URL of source code.
     * @param {(string|number)} lineNo Line number in source code.
     * @return {string} The function name, if discoverable.
     */
    function guessFunctionName(url, lineNo) {
        var reFunctionArgNames = /function ([^(]*)\(([^)]*)\)/,
            reGuessFunction = /['"]?([0-9A-Za-z$_]+)['"]?\s*[:=]\s*(function|eval|new Function)/,
            line = '',
            maxLines = 10,
            source = getSource(url),
            m;

        if (!source.length) {
            return UNKNOWN_FUNCTION;
        }

        // Walk backwards from the first line in the function until we find the line which
        // matches the pattern above, which is the function definition
        for (var i = 0; i < maxLines; ++i) {
            line = source[lineNo - i] + line;

            if (!_isUndefined(line)) {
                if ((m = reGuessFunction.exec(line))) {
                    return m[1];
                } else if ((m = reFunctionArgNames.exec(line))) {
                    return m[1];
                }
            }
        }

        return UNKNOWN_FUNCTION;
    }

    /**
     * Retrieves the surrounding lines from where an exception occurred.
     * @param {string} url URL of source code.
     * @param {(string|number)} line Line number in source code to centre
     * around for context.
     * @return {?Array.<string>} Lines of source code.
     */
    function gatherContext(url, line) {
        var source = getSource(url);

        if (!source.length) {
            return null;
        }

        var context = [],
            // linesBefore & linesAfter are inclusive with the offending line.
            // if linesOfContext is even, there will be one extra line
            //   *before* the offending line.
            linesBefore = Math.floor(TraceKit.linesOfContext / 2),
            // Add one extra line if linesOfContext is odd
            linesAfter = linesBefore + (TraceKit.linesOfContext % 2),
            start = Math.max(0, line - linesBefore - 1),
            end = Math.min(source.length, line + linesAfter - 1);

        line -= 1; // convert to 0-based index

        for (var i = start; i < end; ++i) {
            if (!_isUndefined(source[i])) {
                context.push(source[i]);
            }
        }

        return context.length > 0 ? context : null;
    }

    /**
     * Escapes special characters, except for whitespace, in a string to be
     * used inside a regular expression as a string literal.
     * @param {string} text The string.
     * @return {string} The escaped string literal.
     */
    function escapeRegExp(text) {
        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, '\\$&');
    }

    /**
     * Escapes special characters in a string to be used inside a regular
     * expression as a string literal. Also ensures that HTML entities will
     * be matched the same as their literal friends.
     * @param {string} body The string.
     * @return {string} The escaped string.
     */
    function escapeCodeAsRegExpForMatchingInsideHTML(body) {
        return escapeRegExp(body).replace('<', '(?:<|&lt;)').replace('>', '(?:>|&gt;)').replace('&', '(?:&|&amp;)').replace('"', '(?:"|&quot;)').replace(/\s+/g, '\\s+');
    }

    /**
     * Determines where a code fragment occurs in the source code.
     * @param {RegExp} re The function definition.
     * @param {Array.<string>} urls A list of URLs to search.
     * @return {?Object.<string, (string|number)>} An object containing
     * the url, line, and column number of the defined function.
     */
    function findSourceInUrls(re, urls) {
        var source, m;
        for (var i = 0, j = urls.length; i < j; ++i) {
            // console.log('searching', urls[i]);
            if ((source = getSource(urls[i])).length) {
                source = source.join('\n');
                if ((m = re.exec(source))) {
                    // console.log('Found function in ' + urls[i]);

                    return {
                        'url': urls[i],
                        'line': source.substring(0, m.index).split('\n').length,
                        'column': m.index - source.lastIndexOf('\n', m.index) - 1
                    };
                }
            }
        }

        // console.log('no match');

        return null;
    }

    /**
     * Determines at which column a code fragment occurs on a line of the
     * source code.
     * @param {string} fragment The code fragment.
     * @param {string} url The URL to search.
     * @param {(string|number)} line The line number to examine.
     * @return {?number} The column number.
     */
    function findSourceInLine(fragment, url, line) {
        var source = getSource(url),
            re = new RegExp('\\b' + escapeRegExp(fragment) + '\\b'),
            m;

        line -= 1;

        if (source && source.length > line && (m = re.exec(source[line]))) {
            return m.index;
        }

        return null;
    }

    /**
     * Determines where a function was defined within the source code.
     * @param {(Function|string)} func A function reference or serialized
     * function definition.
     * @return {?Object.<string, (string|number)>} An object containing
     * the url, line, and column number of the defined function.
     */
    function findSourceByFunctionBody(func) {
        var urls = [window.location.href],
            scripts = document.getElementsByTagName('script'),
            body,
            code = '' + func,
            codeRE = /^function(?:\s+([\w$]+))?\s*\(([\w\s,]*)\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
            eventRE = /^function on([\w$]+)\s*\(event\)\s*\{\s*(\S[\s\S]*\S)\s*\}\s*$/,
            re,
            parts,
            result;

        for (var i = 0; i < scripts.length; ++i) {
            var script = scripts[i];
            if (script.src) {
                urls.push(script.src);
            }
        }

        if (!(parts = codeRE.exec(code))) {
            re = new RegExp(escapeRegExp(code).replace(/\s+/g, '\\s+'));
        }

        // not sure if this is really necessary, but I don’t have a test
        // corpus large enough to confirm that and it was in the original.
        else {
            var name = parts[1] ? '\\s+' + parts[1] : '',
                args = parts[2].split(',').join('\\s*,\\s*');

            body = escapeRegExp(parts[3]).replace(/;$/, ';?'); // semicolon is inserted if the function ends with a comment.replace(/\s+/g, '\\s+');
            re = new RegExp('function' + name + '\\s*\\(\\s*' + args + '\\s*\\)\\s*{\\s*' + body + '\\s*}');
        }

        // look for a normal function definition
        if ((result = findSourceInUrls(re, urls))) {
            return result;
        }

        // look for an old-school event handler function
        if ((parts = eventRE.exec(code))) {
            var event = parts[1];
            body = escapeCodeAsRegExpForMatchingInsideHTML(parts[2]);

            // look for a function defined in HTML as an onXXX handler
            re = new RegExp('on' + event + '=[\\\'"]\\s*' + body + '\\s*[\\\'"]', 'i');

            if ((result = findSourceInUrls(re, urls[0]))) {
                return result;
            }

            // look for ???
            re = new RegExp(body);

            if ((result = findSourceInUrls(re, urls))) {
                return result;
            }
        }

        return null;
    }

    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'

    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * Added WinJS regex for Raygun4JS's offline caching support
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceFromStackProp(ex) {
        if (!ex.stack) {
            return null;
        }

        var chrome = /^\s*at (.*?) ?\(?((?:file|http|https|chrome-extension):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
            gecko = /^\s*(.*?)(?:\((.*?)\))?@?((?:file|http|https|chrome):.*?):(\d+)(?::(\d+))?\s*$/i,
            winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:ms-appx|http|https):.*?):(\d+)(?::(\d+))?\)?\s*$/i,
            lines = ex.stack.split('\n'),
            stack = [],
            parts,
            element,
            reference = /^(.*) is undefined$/.exec(ex.message);

        for (var i = 0, j = lines.length; i < j; ++i) {
            if ((parts = gecko.exec(lines[i]))) {
                element = {
                    'url': parts[3],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'args': parts[2] ? parts[2].split(',') : '',
                    'line': +parts[4],
                    'column': parts[5] ? +parts[5] : null
                };
            } else if ((parts = chrome.exec(lines[i]))) {
                element = {
                    'url': parts[2],
                    'func': parts[1] || UNKNOWN_FUNCTION,
                    'line': +parts[3],
                    'column': parts[4] ? +parts[4] : null
                };
            } else if ((parts = winjs.exec(lines[i]))) {
              element = {
                'url': parts[2],
                'func': parts[1] || UNKNOWN_FUNCTION,
                'line': +parts[3],
                'column': parts[4] ? +parts[4] : null
              };
            } else {
                continue;
            }

            if (!element.func && element.line) {
                element.func = guessFunctionName(element.url, element.line);
            }

            if (element.line) {
                element.context = gatherContext(element.url, element.line);
            }

            stack.push(element);
        }

        if (stack[0] && stack[0].line && !stack[0].column && reference) {
            stack[0].column = findSourceInLine(reference[1], stack[0].url, stack[0].line);
        } else if (!stack[0].column && typeof ex.columnNumber !== 'undefined') {
            // Firefox column number
            stack[0].column = ex.columnNumber + 1;
        }

        if (!stack.length) {
            return null;
        }

        return {
            'mode': 'stack',
            'name': ex.name,
            'message': ex.message,
            'url': document.location.href,
            'stack': stack,
            'useragent': navigator.userAgent
        };
    }

    /**
     * Computes stack trace information from the stacktrace property.
     * Opera 10 uses this property.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceFromStacktraceProp(ex) {
        // Access and store the stacktrace property before doing ANYTHING
        // else to it because Opera is not very good at providing it
        // reliably in other circumstances.
        var stacktrace = ex.stacktrace;

        var testRE = / line (\d+), column (\d+) in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\) in (.*):\s*$/i,
            lines = stacktrace !== null ? stacktrace.split('\n') : stacktrace,
            stack = [],
            parts;

        for (var i = 0, j = lines.length; i < j; i += 2) {
            if ((parts = testRE.exec(lines[i]))) {
                var element = {
                    'line': +parts[1],
                    'column': +parts[2],
                    'func': parts[3] || parts[4],
                    'args': parts[5] ? parts[5].split(',') : [],
                    'url': parts[6]
                };

                if (!element.func && element.line) {
                    element.func = guessFunctionName(element.url, element.line);
                }
                if (element.line) {
                    try {
                        element.context = gatherContext(element.url, element.line);
                    } catch (exc) {}
                }

                if (!element.context) {
                    element.context = [lines[i + 1]];
                }

                stack.push(element);
            }
        }

        if (!stack.length) {
            return null;
        }

        return {
            'mode': 'stacktrace',
            'name': ex.name,
            'message': ex.message,
            'url': document.location.href,
            'stack': stack,
            'useragent': navigator.userAgent
        };
    }

    /**
     * NOT TESTED.
     * Computes stack trace information from an error message that includes
     * the stack trace.
     * Opera 9 and earlier use this method if the option to show stack
     * traces is turned on in opera:config.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack information.
     */
    function computeStackTraceFromOperaMultiLineMessage(ex) {
        // Opera includes a stack trace into the exception message. An example is:
        //
        // Statement on line 3: Undefined variable: undefinedFunc
        // Backtrace:
        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
        //         undefinedFunc(a);
        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
        //           zzz(x, y, z);
        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
        //           yyy(a, a, a);
        //   Line 1 of function script
        //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
        //   ...

        var lines = ex.message.split('\n');
        if (lines.length < 4) {
            return null;
        }

        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,
            lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|http|https)\S+)(?:: in function (\S+))?\s*$/i,
            lineRE3 = /^\s*Line (\d+) of function script\s*$/i,
            stack = [],
            scripts = document.getElementsByTagName('script'),
            inlineScriptBlocks = [],
            parts,
            i,
            len,
            source;

        for (i in scripts) {
            if (_has(scripts, i) && !scripts[i].src) {
                inlineScriptBlocks.push(scripts[i]);
            }
        }

        for (i = 2, len = lines.length; i < len; i += 2) {
            var item = null;
            if ((parts = lineRE1.exec(lines[i]))) {
                item = {
                    'url': parts[2],
                    'func': parts[3],
                    'line': +parts[1]
                };
            } else if ((parts = lineRE2.exec(lines[i]))) {
                item = {
                    'url': parts[3],
                    'func': parts[4]
                };
                var relativeLine = (+parts[1]); // relative to the start of the <SCRIPT> block
                var script = inlineScriptBlocks[parts[2] - 1];
                if (script) {
                    source = getSource(item.url);
                    if (source) {
                        source = source.join('\n');
                        var pos = source.indexOf(script.innerText);
                        if (pos >= 0) {
                            item.line = relativeLine + source.substring(0, pos).split('\n').length;
                        }
                    }
                }
            } else if ((parts = lineRE3.exec(lines[i]))) {
                var url = window.location.href.replace(/#.*$/, ''),
                    line = parts[1];
                var re = new RegExp(escapeCodeAsRegExpForMatchingInsideHTML(lines[i + 1]));
                source = findSourceInUrls(re, [url]);
                item = {
                    'url': url,
                    'line': source ? source.line : line,
                    'func': ''
                };
            }

            if (item) {
                if (!item.func) {
                    item.func = guessFunctionName(item.url, item.line);
                }
                var context = gatherContext(item.url, item.line);
                var midline = (context ? context[Math.floor(context.length / 2)] : null);
                if (context && midline.replace(/^\s*/, '') === lines[i + 1].replace(/^\s*/, '')) {
                    item.context = context;
                } else {
                    // if (context) alert("Context mismatch. Correct midline:\n" + lines[i+1] + "\n\nMidline:\n" + midline + "\n\nContext:\n" + context.join("\n") + "\n\nURL:\n" + item.url);
                    item.context = [lines[i + 1]];
                }
                stack.push(item);
            }
        }
        if (!stack.length) {
            return null; // could not parse multiline exception message as Opera stack trace
        }

        return {
            'mode': 'multiline',
            'name': ex.name,
            'message': lines[0],
            'url': document.location.href,
            'stack': stack,
            'useragent': navigator.userAgent
        };
    }

    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {Object.<string, *>} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     */
    function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            'url': url,
            'line': lineNo
        };

        if (initial.url && initial.line) {
            stackInfo.incomplete = false;

            if (!initial.func) {
                initial.func = guessFunctionName(initial.url, initial.line);
            }

            if (!initial.context) {
                initial.context = gatherContext(initial.url, initial.line);
            }

            var reference = / '([^']+)' /.exec(message);
            if (reference) {
                initial.column = findSourceInLine(reference[1], initial.url, initial.line);
            }

            if (stackInfo.stack.length > 0) {
                if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                        return false; // already in stack trace
                    } else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                        stackInfo.stack[0].line = initial.line;
                        stackInfo.stack[0].context = initial.context;
                        return false;
                    }
                }
            }

            stackInfo.stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        } else {
            stackInfo.incomplete = true;
        }

        return false;
    }

    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {?Object.<string, *>} Stack trace information.
     */
    function computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i,
            stack = [],
            funcs = {},
            recursion = false,
            parts,
            item,
            source;

        for (var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
            if (curr === computeStackTrace || curr === TraceKit.report) {
                // console.log('skipping internal function');
                continue;
            }

            item = {
                'url': null,
                'func': UNKNOWN_FUNCTION,
                'line': null,
                'column': null
            };

            if (curr.name) {
                item.func = curr.name;
            } else if ((parts = functionName.exec(curr.toString()))) {
                item.func = parts[1];
            }

            if (typeof item.func === 'undefined') {
              try {
                item.func = parts.input.substring(0, parts.input.indexOf('{'))
              } catch (e) { }
            }

            if ((source = findSourceByFunctionBody(curr))) {
                item.url = source.url;
                item.line = source.line;

                if (item.func === UNKNOWN_FUNCTION) {
                    item.func = guessFunctionName(item.url, item.line);
                }

                var reference = / '([^']+)' /.exec(ex.message || ex.description);
                if (reference) {
                    item.column = findSourceInLine(reference[1], source.url, source.line);
                }
            }

            if (funcs['' + curr]) {
                recursion = true;
            }else{
                funcs['' + curr] = true;
            }

            stack.push(item);
        }

        if (depth) {
            // console.log('depth is ' + depth);
            // console.log('stack is ' + stack.length);
            stack.splice(0, depth);
        }

        var result = {
            'mode': 'callers',
            'name': ex.name,
            'message': ex.message,
            'url': document.location.href,
            'stack': stack,
            'useragent': navigator.userAgent
        };
        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }

    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     */
    function computeStackTrace(ex, depth) {
        var stack = null;
        depth = (depth == null ? 0 : +depth);

        try {
            // This must be tried first because Opera 10 *destroys*
            // its stacktrace property if you try to access the stack
            // property first!!
            stack = computeStackTraceFromStacktraceProp(ex);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (debug) {
                throw e;
            }
        }

        try {
            stack = computeStackTraceFromStackProp(ex);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (debug) {
                throw e;
            }
        }

        try {
            stack = computeStackTraceFromOperaMultiLineMessage(ex);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (debug) {
                throw e;
            }
        }

        try {
            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
            if (stack) {
                return stack;
            }
        } catch (e) {
            if (debug) {
                throw e;
            }
        }

        return {
            'mode': 'failed'
        };
    }

    /**
     * Logs a stacktrace starting from the previous call and working down.
     * @param {(number|string)=} depth How many frames deep to trace.
     * @return {Object.<string, *>} Stack trace information.
     */
    function computeStackTraceOfCaller(depth) {
        depth = (depth == null ? 0 : +depth) + 1; // "+ 1" because "ofCaller" should drop one frame
        try {
            throw new Error();
        } catch (ex) {
            return computeStackTrace(ex, depth + 1);
        }
    }

    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
    computeStackTrace.guessFunctionName = guessFunctionName;
    computeStackTrace.gatherContext = gatherContext;
    computeStackTrace.ofCaller = computeStackTraceOfCaller;

    return computeStackTrace;
}());

/**
 * Extends support for global error handling for asynchronous browser
 * functions. Adopted from Closure Library's errorhandler.js
 */
TraceKit.extendToAsynchronousCallbacks = function () {
    var _helper = function _helper(fnName) {
        var originalFn = window[fnName];
        window[fnName] = function traceKitAsyncExtension() {
            // Make a copy of the arguments
            var args = _slice.call(arguments);
            var originalCallback = args[0];
            if (typeof (originalCallback) === 'function') {
                args[0] = TraceKit.wrap(originalCallback);
            }
            // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
            // also only supports 2 argument and doesn't care what "this" is, so we
            // can just call the original function directly.
            if (originalFn.apply) {
                return originalFn.apply(this, args);
            } else {
                return originalFn(args[0], args[1]);
            }
        };
    };

    _helper('setTimeout');
    _helper('setInterval');
};

//Default options:
if (!TraceKit.remoteFetching) {
  TraceKit.remoteFetching = true;
}
if (!TraceKit.collectWindowErrors) {
  TraceKit.collectWindowErrors = true;
}
if (!TraceKit.linesOfContext || TraceKit.linesOfContext < 1) {
  // 5 lines before, the offending line, 5 lines after
  TraceKit.linesOfContext = 11;
}



// Export to global object
window.TraceKit = TraceKit;

}(window));

var raygunFactory = function (window, $, undefined) {


  // pull local copy of TraceKit to handle stack trace collection
  var _traceKit = TraceKit,
      _raygun = window.Raygun,
      _raygunApiKey,
      _debugMode = false,
      _allowInsecureSubmissions = false,
      _ignoreAjaxAbort = false,
      _ignoreAjaxError = false,
      _enableOfflineSave = false,
      _ignore3rdPartyErrors = false,
      _disableAnonymousUserTracking = false,
      _wrapAsynchronousCallbacks = false,
      _customData = {},
      _tags = [],
      _user,
      _version,
      _filteredKeys,
      _whitelistedScriptDomains = [],
      _beforeSendCallback,
      _raygunApiUrl = 'https://api.raygun.io',
      _excludedHostnames = null,
      _excludedUserAgents = null,
      _filterScope = 'customData',
      $document;

  if ($) {
    $document = $(document);
  }

  var Raygun =
  {
    noConflict: function () {
      window.Raygun = _raygun;
      return Raygun;
    },

    constructNewRaygun: function () {
      var rgInstance = window.raygunFactory(window, window.jQuery);
      window.raygunJsUrlFactory(window, rgInstance);

      return rgInstance;
    },


    init: function(key, options, customdata) {
      _raygunApiKey = key;
      _traceKit.remoteFetching = false;
      _customData = customdata;

      if (options)
      {
        _allowInsecureSubmissions = options.allowInsecureSubmissions || false;
        _ignoreAjaxAbort = options.ignoreAjaxAbort || false;
        _ignoreAjaxError = options.ignoreAjaxError || false;
        _disableAnonymousUserTracking = options.disableAnonymousUserTracking || false;
        _excludedHostnames = options.excludedHostnames || false;
        _excludedUserAgents = options.excludedUserAgents || false;

        if (typeof options.wrapAsynchronousCallbacks !== 'undefined') {
          _wrapAsynchronousCallbacks = options.wrapAsynchronousCallbacks;
        }

        if (options.debugMode)
        {
          _debugMode = options.debugMode;
        }
        if (options.ignore3rdPartyErrors)
        {
          _ignore3rdPartyErrors = true;
        }
      }

      sendSavedErrors();

      return Raygun;
    },

    withCustomData: function (customdata) {
      _customData = customdata;
      return Raygun;
    },

    withTags: function (tags) {
      _tags = tags;
      return Raygun;
    },

    attach: function () {
      if (!isApiKeyConfigured()) {
        return Raygun;
      }
      _traceKit.report.subscribe(processUnhandledException);

      if (_wrapAsynchronousCallbacks) {
        _traceKit.extendToAsynchronousCallbacks();
      }

      if ($document && !_ignoreAjaxError) {
        $document.ajaxError(processJQueryAjaxError);
      }
      return Raygun;
    },

    detach: function () {
      _traceKit.report.unsubscribe(processUnhandledException);
      if ($document) {
        $document.unbind('ajaxError', processJQueryAjaxError);
      }
      return Raygun;
    },

    send: function (ex, customData, tags) {
      try {
        processUnhandledException(_traceKit.computeStackTrace(ex), {
          customData: typeof _customData === 'function' ?
            merge(_customData(), customData) :
            merge(_customData, customData),
          tags: mergeArray(_tags, tags)
        });
      }
      catch (traceKitException) {
        if (ex !== traceKitException) {
          throw traceKitException;
        }
      }
      return Raygun;
    },

    setUser: function (user, isAnonymous, email, fullName, firstName, uuid) {
      _user = {
        'Identifier': user
      };
      if(typeof isAnonymous !== 'undefined') {
        _user['IsAnonymous'] = isAnonymous;
      }
      if(typeof email !== 'undefined') {
        _user['Email'] = email;
      }
      if(typeof fullName !== 'undefined') {
        _user['FullName'] = fullName;
      }
      if(typeof firstName !== 'undefined') {
        _user['FirstName'] = firstName;
      }
      if(typeof uuid !== 'undefined') {
        _user['UUID'] = uuid;
      }

      return Raygun;
    },

    resetAnonymousUser: function () {
      _private.clearCookie('raygun4js-userid');
    },

    setVersion: function (version) {
      _version = version;
      return Raygun;
    },

    saveIfOffline: function (enableOffline) {
      if (typeof enableOffline !== 'undefined' && typeof enableOffline === 'boolean') {
        _enableOfflineSave = enableOffline;
      }

      return Raygun;
    },

    filterSensitiveData: function (filteredKeys) {
      _filteredKeys = filteredKeys;
      return Raygun;
    },

    setFilterScope: function (scope) {
      if (scope === 'customData' || scope === 'all') {
        _filterScope = scope;
      }
      return Raygun;
    },

    whitelistCrossOriginDomains: function (whitelist) {
      _whitelistedScriptDomains = whitelist;
      return Raygun;
    },

    onBeforeSend: function (callback) {
      _beforeSendCallback = callback;

      return Raygun;
    }
  };

  var _private = Raygun._private = Raygun._private || {},
    _seal = Raygun._seal = Raygun._seal || function () {
      delete Raygun._private;
      delete Raygun._seal;
      delete Raygun._unseal;
    },
    _unseal = Raygun._unseal = Raygun._unseal || function () {
      Raygun._private = _private;
      Raygun._seal = _seal;
      Raygun._unseal = _unseal;
    };

  _private.getUuid = function () {
      function _p8(s) {
          var p = (Math.random().toString(16)+"000000000").substr(2,8);
          return s ? "-" + p.substr(0,4) + "-" + p.substr(4,4) : p ;
      }
      return _p8() + _p8(true) + _p8(true) + _p8();
  };

  _private.createCookie = function (name,value,hours) {
    var expires;
      if (hours) {
        var date = new Date();
        date.setTime(date.getTime()+(hours*60*60*1000));
        expires = "; expires="+date.toGMTString();
      }
      else {
        expires = "";
      }

      document.cookie = name+"="+value+expires+"; path=/";
  };

  _private.readCookie = function (name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for(var i=0;i < ca.length;i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1,c.length);
          }
          if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length,c.length);
          }
      }
      return null;
  };

  _private.clearCookie = function (key) {
      _private.createCookie(key, '',-1);
  };

  _private.log = function(message, data) {
    if (window.console && window.console.log && _debugMode) {
      window.console.log(message);

      if (data) {
        window.console.log(data);
      }
    }
  };

  /* internals */

  function truncateURL(url){
      // truncate after fourth /, or 24 characters, whichever is shorter
      // /api/1/diagrams/xyz/server becomes
      // /api/1/diagrams/...
      var truncated = url;
      var path = url.split('//')[1];

      if (path) {
        var queryStart = path.indexOf('?');
        var sanitizedPath = path.toString().substring(0, queryStart);
        var truncated_parts = sanitizedPath.split('/').slice(0, 4).join('/');
        var truncated_length = sanitizedPath.substring(0, 48);
        truncated = truncated_parts.length < truncated_length.length?
                        truncated_parts : truncated_length;
        if (truncated !== sanitizedPath) {
            truncated += '..';
        }
      }

      return truncated;
  }

  function processJQueryAjaxError(event, jqXHR, ajaxSettings, thrownError) {
    var message = 'AJAX Error: ' +
        (jqXHR.statusText || 'unknown') +' '+
        (ajaxSettings.type || 'unknown') + ' '+
        (truncateURL(ajaxSettings.url) || 'unknown');

    // ignore ajax abort if set in the options
    if (_ignoreAjaxAbort) {
      if (!jqXHR.getAllResponseHeaders()) {
         return;
       }
    }

    Raygun.send(thrownError || event.type, {
        status: jqXHR.status,
        statusText: jqXHR.statusText,
        type: ajaxSettings.type,
        url: ajaxSettings.url,
        ajaxErrorMessage: message,
        contentType: ajaxSettings.contentType,
        requestData: ajaxSettings.data && ajaxSettings.data.slice ? ajaxSettings.data.slice(0, 10240) : undefined,
        responseData: jqXHR.responseText && jqXHR.responseText.slice ? jqXHR.responseText.slice(0, 10240) : undefined,
        activeTarget: event.target && event.target.activeElement && event.target.activeElement.outerHTML && event.target.activeElement.outerHTML.slice ? event.target.activeElement.outerHTML.slice(0, 10240) : undefined
      });
  }



  function isApiKeyConfigured() {
    if (_raygunApiKey && _raygunApiKey !== '') {
      return true;
    }
    _private.log("Raygun API key has not been configured, make sure you call Raygun.init(yourApiKey)");
    return false;
  }

  function merge(o1, o2) {
    var a, o3 = {};
    for (a in o1) { o3[a] = o1[a]; }
    for (a in o2) { o3[a] = o2[a]; }
    return o3;
  }

  function mergeArray(t0, t1) {
    if (t1 != null) {
      return t0.concat(t1);
    }
    return t0;
  }

  function forEach(set, func) {
    for (var i = 0; i < set.length; i++) {
      func.call(null, i, set[i]);
    }
  }

  function isEmpty(o) {
    for (var p in o) {
      if (o.hasOwnProperty(p)) {
        return false;
      }
    }
    return true;
  }

  function getRandomInt() {
    return Math.floor(Math.random() * 9007199254740993);
  }

  function getViewPort () {
    var e = document.documentElement,
    g = document.getElementsByTagName('body')[0],
    x = window.innerWidth || e.clientWidth || g.clientWidth,
    y = window.innerHeight || e.clientHeight || g.clientHeight;
    return { width: x, height: y };
  }

  function offlineSave (data) {
    var dateTime = new Date().toJSON();

    try {
      var key = 'raygunjs=' + dateTime + '=' + getRandomInt();

      if (typeof localStorage[key] === 'undefined') {
        localStorage[key] = data;
      }
    } catch (e) {
      _private.log('Raygun4JS: LocalStorage full, cannot save exception');
    }
  }

  function localStorageAvailable(){
    try {
      return ('localStorage' in window) && window['localStorage'] !== null;
    } catch(e){
      return false;
    }
  }

  function sendSavedErrors() {
    if (localStorageAvailable() && localStorage && localStorage.length > 0) {
        for (var key in localStorage) {
        if (key.substring(0, 9) === 'raygunjs=') {
          try {
            sendToRaygun(JSON.parse(localStorage[key]));
          } catch(e) {
            _private.log('Raygun4JS: Invalid JSON object in LocalStorage');
          }
          
          try {
            localStorage.removeItem(key);
          } catch(e) {
            _private.log('Raygun4JS: Unable to remove error');
          }
        }
      }
    }
  }

  function ensureUser() {
    if (!_user && !_disableAnonymousUserTracking) {
      var userKey = 'raygun4js-userid';
      var rgUserId = _private.readCookie(userKey);
      var anonymousUuid;

      if (!rgUserId) {
        anonymousUuid = _private.getUuid();

        _private.createCookie(userKey, anonymousUuid, 24 * 31);
      } else {
        anonymousUuid = rgUserId;
      }

      Raygun.setUser(anonymousUuid, true, null, null, null, anonymousUuid);
    }
  }

  function filterValue(key, value) {
    if (_filteredKeys) {
      for (var i = 0; i < _filteredKeys.length; i++) {
        if (typeof _filteredKeys[i] === 'object' && typeof _filteredKeys[i].exec === 'function') {
          if (_filteredKeys[i].exec(key) !== null) {
            return '[removed by filter]';
          }
        }
        else if (_filteredKeys[i] === key) {
            return '[removed by filter]';
        }
      }
    }

    return value;
  }

  function filterObject(reference, parentKey) {
    if (reference == null) {
        return reference;
    }

    if (Object.prototype.toString.call(reference) !== '[object Object]') {
        return reference;
    }

    var filteredObject = {};

    for (var propertyName in reference) {
        var propertyValue = reference[propertyName];

        if (propertyValue == null) {
            continue;
        }

        if (Object.prototype.toString.call(propertyValue) === '[object Object]') {
            if ((parentKey !== 'Details' || propertyName !== 'Client')) {
                filteredObject[propertyName] = filterObject(filterValue(propertyName, propertyValue), propertyName);
            }
        } else if (Object.prototype.toString.call(propertyValue) !== '[object Function]') {
            if (typeof parentKey !== 'undefined' || propertyName !== 'OccurredOn') {
                filteredObject[propertyName] = filterValue(propertyName, propertyValue);
            }
        }
    }

    return filteredObject;
}

  function processUnhandledException(stackTrace, options) {
    var stack = [],
        qs = {};

    if (_ignore3rdPartyErrors) {
      if (!stackTrace.stack || !stackTrace.stack.length) {
        _private.log('Raygun4JS: Cancelling send due to null stacktrace');
        return;
      }

      var domain = _private.parseUrl('domain');

      var scriptError = 'Script error';
      var msg = stackTrace.message || options.status || scriptError;
      if (msg.substring(0, scriptError.length) === scriptError &&
        stackTrace.stack[0].url !== null &&
        stackTrace.stack[0].url.indexOf(domain) === -1 &&
        (stackTrace.stack[0].line === 0 || stackTrace.stack[0].func === '?')) {
        _private.log('Raygun4JS: cancelling send due to third-party script error with no stacktrace and message');
        return;
      }


      if (stackTrace.stack[0].url !== null && stackTrace.stack[0].url.indexOf(domain) === -1) {
        var allowedDomainFound = false;

        for (var i in _whitelistedScriptDomains) {
          if (stackTrace.stack[0].url.indexOf(_whitelistedScriptDomains[i]) > -1) {
            allowedDomainFound = true;
          }
        }

        if (!allowedDomainFound) {
          _private.log('Raygun4JS: cancelling send due to error on non-origin, non-whitelisted domain');

          return;
        }
      }
    }

    if (_excludedHostnames instanceof Array) {
      for (var hostIndex in _excludedHostnames) {
        if (_excludedHostnames.hasOwnProperty(hostIndex)) {
          if (window.location.hostname && window.location.hostname.match(_excludedHostnames[hostIndex])) {
            _private.log('Raygun4JS: cancelling send as error originates from an excluded hostname');

            return;
          }
        }
      }
    }

    if (_excludedUserAgents instanceof Array) {
      for(var userAgentIndex in _excludedUserAgents) {
        if (_excludedUserAgents.hasOwnProperty(userAgentIndex)) {
          if(navigator.userAgent.match(_excludedUserAgents[userAgentIndex])) {
            _private.log('Raygun4JS: cancelling send as error originates from an excluded user agent');

            return;
          }
        }
      }
    }

    if (stackTrace.stack && stackTrace.stack.length) {
      forEach(stackTrace.stack, function (i, frame) {
        stack.push({
          'LineNumber': frame.line,
          'ColumnNumber': frame.column,
          'ClassName': 'line ' + frame.line + ', column ' + frame.column,
          'FileName': frame.url,
          'MethodName': frame.func || '[anonymous]'
        });
      });
    }

    var queryString = _private.parseUrl('?');

    if (queryString.length > 0) {
      forEach(queryString.split('&'), function (i, segment) {
        var parts = segment.split('=');
        if (parts && parts.length === 2) {
          var key = decodeURIComponent(parts[0]);
          var value = filterValue(key, parts[1]);

          qs[key] = value;
        }
      });
    }

    if (options === undefined) {
      options = {};
    }

    if (isEmpty(options.customData)) {
      if (typeof _customData === 'function') {
        options.customData = _customData();
      } else {
        options.customData = _customData;
      }
    }

    if (isEmpty(options.tags)) {
      if (typeof _tags === 'function') {
        options.tags = _tags();
      } else {
        options.tags = _tags;
      }
    }

    var screen = window.screen || { width: getViewPort().width, height: getViewPort().height, colorDepth: 8 };
    var custom_message = options.customData && options.customData.ajaxErrorMessage;

    var finalCustomData;
    if (_filterScope === 'customData') {
      finalCustomData = filterObject(options.customData, 'UserCustomData');
    } else {
      finalCustomData = options.customData;
    }

    try {
      JSON.stringify(finalCustomData);
    } catch (e) {
      var msg = 'Cannot add custom data; may contain circular reference';
      finalCustomData = { error: msg };
      _private.log('Raygun4JS: ' + msg);
    }

    var finalMessage = custom_message || stackTrace.message || options.status || 'Script error';
    finalMessage = finalMessage.substring(0, 512);

    var payload = {
      'OccurredOn': new Date(),
      'Details': {
        'Error': {
          'ClassName': stackTrace.name,
          'Message': finalMessage,
          'StackTrace': stack
        },
        'Environment': {
          'UtcOffset': new Date().getTimezoneOffset() / -60.0,
          'User-Language': navigator.userLanguage,
          'Document-Mode': document.documentMode,
          'Browser-Width': getViewPort().width,
          'Browser-Height': getViewPort().height,
          'Screen-Width': screen.width,
          'Screen-Height': screen.height,
          'Color-Depth': screen.colorDepth,
          'Browser': navigator.appCodeName,
          'Browser-Name': navigator.appName,
          'Browser-Version': navigator.appVersion,
          'Platform': navigator.platform
        },
        'Client': {
          'Name': 'raygun-js',
          'Version': '1.18.7'
        },
        'UserCustomData': finalCustomData,
        'Tags': options.tags,
        'Request': {
          'Url': [location.protocol, '//', location.host, location.pathname, location.hash].join(''),
          'QueryString': qs,
          'Headers': {
            'User-Agent': navigator.userAgent,
            'Referer': document.referrer,
            'Host': document.domain
          }
        },
        'Version': _version || 'Not supplied'
      }
    };

    ensureUser();
    payload.Details.User = _user;

    if (_filterScope === 'all') {
      payload = filterObject(payload);
    }

    if (typeof _beforeSendCallback === 'function') {
      var mutatedPayload = _beforeSendCallback(payload);

      if (mutatedPayload) {
        sendToRaygun(mutatedPayload);
      }
    } else {
      sendToRaygun(payload);
    }
  }

  function sendToRaygun(data) {
    if (!isApiKeyConfigured()) {
      return;
    }

    _private.log('Sending exception data to Raygun:', data);
    var url = _raygunApiUrl + '/entries?apikey=' + encodeURIComponent(_raygunApiKey);
    makePostCorsRequest(url, JSON.stringify(data));
  }

  // Create the XHR object.
  function createCORSRequest(method, url) {
    var xhr;

    xhr = new window.XMLHttpRequest();
    if ("withCredentials" in xhr) {
      // XHR for Chrome/Firefox/Opera/Safari.
      xhr.open(method, url, true);

    } else if (window.XDomainRequest) {
      // XDomainRequest for IE.
      if (_allowInsecureSubmissions) {
        // remove 'https:' and use relative protocol
        // this allows IE8 to post messages when running
        // on http
        url = url.slice(6);
      }

      xhr = new window.XDomainRequest();
      xhr.open(method, url);
    }

    xhr.timeout = 10000;

    return xhr;
  }

  // Make the actual CORS request.
  function makePostCorsRequest(url, data) {
    var xhr = createCORSRequest('POST', url, data);

    if ('withCredentials' in xhr) {

      xhr.onreadystatechange = function() {
        if (xhr.readyState !== 4) {
          return;
        }

        if (xhr.status === 202) {
          sendSavedErrors();
        } else if (_enableOfflineSave && xhr.status !== 403 &&
                   xhr.status !== 400 && xhr.status !== 429) {
          offlineSave(data);
        }
      };

      xhr.onload = function () {
        _private.log('logged error to Raygun');
      };

    } else if (window.XDomainRequest) {
      xhr.ontimeout = function () {
        if (_enableOfflineSave) {
          _private.log('Raygun: saved error locally');
          offlineSave(data);
        }
      };

      xhr.onload = function () {
        _private.log('logged error to Raygun');
        sendSavedErrors();
      };
    }

    xhr.onerror = function () {
      _private.log('failed to log error to Raygun');
    };

    if (!xhr) {
      _private.log('CORS not supported');
      return;
    }

    xhr.send(data);
  }

  if (!window.Raygun) {
    window.Raygun = Raygun;
  }

  return Raygun;

};

raygunFactory(window, window.jQuery);


// js-url - see LICENSE file

var raygunJsUrlFactory = function (window, Raygun) {

  Raygun._private.parseUrl = function(arg, url) {
    function isNumeric(arg) {
      return !isNaN(parseFloat(arg)) && isFinite(arg);
    }

    return (function(arg, url) {
        var _ls = url || window.location.toString();

        if (!arg) { return _ls; }
        else { arg = arg.toString(); }

        if (_ls.substring(0,2) === '//') { _ls = 'http:' + _ls; }
        else if (_ls.split('://').length === 1) { _ls = 'http://' + _ls; }

        url = _ls.split('/');
        var _l = {auth:''}, host = url[2].split('@');

        if (host.length === 1) { host = host[0].split(':'); }
        else { _l.auth = host[0]; host = host[1].split(':'); }

        _l.protocol=url[0];
        _l.hostname=host[0];
        _l.port=(host[1] || ((_l.protocol.split(':')[0].toLowerCase() === 'https') ? '443' : '80'));
        _l.pathname=( (url.length > 3 ? '/' : '') + url.slice(3, url.length).join('/').split('?')[0].split('#')[0]);
        var _p = _l.pathname;

        if (_p.charAt(_p.length-1) === '/') { _p=_p.substring(0, _p.length-1); }
        var _h = _l.hostname, _hs = _h.split('.'), _ps = _p.split('/');

        if (arg === 'hostname') { return _h; }
        else if (arg === 'domain') {
            if (/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/.test(_h)) { return _h; }
            return _hs.slice(-2).join('.');
        }
        //else if (arg === 'tld') { return _hs.slice(-1).join('.'); }
        else if (arg === 'sub') { return _hs.slice(0, _hs.length - 2).join('.'); }
        else if (arg === 'port') { return _l.port; }
        else if (arg === 'protocol') { return _l.protocol.split(':')[0]; }
        else if (arg === 'auth') { return _l.auth; }
        else if (arg === 'user') { return _l.auth.split(':')[0]; }
        else if (arg === 'pass') { return _l.auth.split(':')[1] || ''; }
        else if (arg === 'path') { return _l.pathname; }
        else if (arg.charAt(0) === '.')
        {
            arg = arg.substring(1);
            if(isNumeric(arg)) {arg = parseInt(arg, 10); return _hs[arg < 0 ? _hs.length + arg : arg-1] || ''; }
        }
        else if (isNumeric(arg)) { arg = parseInt(arg, 10); return _ps[arg < 0 ? _ps.length + arg : arg] || ''; }
        else if (arg === 'file') { return _ps.slice(-1)[0]; }
        else if (arg === 'filename') { return _ps.slice(-1)[0].split('.')[0]; }
        else if (arg === 'fileext') { return _ps.slice(-1)[0].split('.')[1] || ''; }
        else if (arg.charAt(0) === '?' || arg.charAt(0) === '#')
        {
            var params = _ls, param = null;

            if(arg.charAt(0) === '?') { params = (params.split('?')[1] || '').split('#')[0]; }
            else if(arg.charAt(0) === '#') { params = (params.split('#')[1] || ''); }

            if(!arg.charAt(1)) { return params; }

            arg = arg.substring(1);
            params = params.split('&');

            for(var i=0,ii=params.length; i<ii; i++)
            {
                param = params[i].split('=');
                if(param[0] === arg) { return param[1] || ''; }
            }

            return null;
        }

        return '';
    })(arg, url);
};

};

raygunJsUrlFactory(window, window.Raygun);
window.Raygun._seal();

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
*/
var f=__webpack_require__(180),p=__webpack_require__(511);__webpack_require__(512);var r=__webpack_require__(513);
function t(a){for(var b=arguments.length-1,d="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,e=0;e<b;e++)d+="\x26args[]\x3d"+encodeURIComponent(arguments[e+1]);b=Error(d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
var u={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function v(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}v.prototype.isReactComponent={};v.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?t("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};v.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function w(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}function x(){}x.prototype=v.prototype;var y=w.prototype=new x;y.constructor=w;f(y,v.prototype);y.isPureReactComponent=!0;function z(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}var A=z.prototype=new x;A.constructor=z;f(A,v.prototype);A.unstable_isAsyncReactComponent=!0;A.render=function(){return this.props.children};
var B={Component:v,PureComponent:w,AsyncComponent:z},C={current:null},D=Object.prototype.hasOwnProperty,E="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103,F={key:!0,ref:!0,__self:!0,__source:!0};function G(a,b,d,e,c,g,k){return{$$typeof:E,type:a,key:b,ref:d,props:k,_owner:g}}
G.createElement=function(a,b,d){var e,c={},g=null,k=null,m=null,q=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),m=void 0===b.__self?null:b.__self,q=void 0===b.__source?null:b.__source,b)D.call(b,e)&&!F.hasOwnProperty(e)&&(c[e]=b[e]);var l=arguments.length-2;if(1===l)c.children=d;else if(1<l){for(var h=Array(l),n=0;n<l;n++)h[n]=arguments[n+2];c.children=h}if(a&&a.defaultProps)for(e in l=a.defaultProps,l)void 0===c[e]&&(c[e]=l[e]);return G(a,g,k,m,q,C.current,c)};
G.createFactory=function(a){var b=G.createElement.bind(null,a);b.type=a;return b};G.cloneAndReplaceKey=function(a,b){return G(a.type,b,a.ref,a._self,a._source,a._owner,a.props)};
G.cloneElement=function(a,b,d){var e=f({},a.props),c=a.key,g=a.ref,k=a._self,m=a._source,q=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,q=C.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var l=a.type.defaultProps;for(h in b)D.call(b,h)&&!F.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==l?l[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=d;else if(1<h){l=Array(h);for(var n=0;n<h;n++)l[n]=arguments[n+2];e.children=l}return G(a.type,c,g,k,m,q,e)};
G.isValidElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===E};var H="function"===typeof Symbol&&Symbol.iterator,I="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var J=/\/+/g,K=[];
function L(a,b,d,e){if(K.length){var c=K.pop();c.result=a;c.keyPrefix=b;c.func=d;c.context=e;c.count=0;return c}return{result:a,keyPrefix:b,func:d,context:e,count:0}}function M(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>K.length&&K.push(a)}
function N(a,b,d,e){var c=typeof a;if("undefined"===c||"boolean"===c)a=null;if(null===a||"string"===c||"number"===c||"object"===c&&a.$$typeof===I)return d(e,a,""===b?"."+O(a,0):b),1;var g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){c=a[k];var m=b+O(c,k);g+=N(c,m,d,e)}else if(m=H&&a[H]||a["@@iterator"],"function"===typeof m)for(a=m.call(a),k=0;!(c=a.next()).done;)c=c.value,m=b+O(c,k++),g+=N(c,m,d,e);else"object"===c&&(d=""+a,t("31","[object Object]"===d?"object with keys {"+
Object.keys(a).join(", ")+"}":d,""));return g}function O(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function P(a,b){a.func.call(a.context,b,a.count++)}function Q(a,b,d){var e=a.result,c=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?R(a,e,d,r.thatReturnsArgument):null!=a&&(G.isValidElement(a)&&(a=G.cloneAndReplaceKey(a,c+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(J,"$\x26/")+"/")+d)),e.push(a))}
function R(a,b,d,e,c){var g="";null!=d&&(g=(""+d).replace(J,"$\x26/")+"/");b=L(b,g,e,c);null==a||N(a,"",Q,b);M(b)}var S={forEach:function(a,b,d){if(null==a)return a;b=L(null,null,b,d);null==a||N(a,"",P,b);M(b)},map:function(a,b,d){if(null==a)return a;var e=[];R(a,e,null,b,d);return e},count:function(a){return null==a?0:N(a,"",r.thatReturnsNull,null)},toArray:function(a){var b=[];R(a,b,null,r.thatReturnsArgument);return b}};
module.exports={Children:{map:S.map,forEach:S.forEach,count:S.count,toArray:S.toArray,only:function(a){G.isValidElement(a)?void 0:t("143");return a}},Component:B.Component,PureComponent:B.PureComponent,unstable_AsyncComponent:B.AsyncComponent,createElement:G.createElement,cloneElement:G.cloneElement,isValidElement:G.isValidElement,createFactory:G.createFactory,version:"16.0.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:C,assign:f}};


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 React v16.0.0
 react-dom.production.min.js

 Copyright (c) 2013-present, Facebook, Inc.

 This source code is licensed under the MIT license found in the
 LICENSE file in the root directory of this source tree.
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0);__webpack_require__(515);var l=__webpack_require__(516),n=__webpack_require__(180),ba=__webpack_require__(517),ca=__webpack_require__(271),da=__webpack_require__(518),ea=__webpack_require__(519),fa=__webpack_require__(520),ha=__webpack_require__(523),ia=__webpack_require__(524);
function w(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:w("227");
function ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
var ka={Namespaces:{html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"},getIntrinsicNamespace:ja,getChildNamespace:function(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ja(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}},la=null,oa={};
function pa(){if(la)for(var a in oa){var b=oa[a],c=la.indexOf(a);-1<c?void 0:w("96",a);if(!qa.plugins[c]){b.extractEvents?void 0:w("97",a);qa.plugins[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.eventNameDispatchConfigs.hasOwnProperty(h)?w("99",h):void 0;qa.eventNameDispatchConfigs[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:w("98",d,a)}}}}
function ra(a,b,c){qa.registrationNameModules[a]?w("100",a):void 0;qa.registrationNameModules[a]=b;qa.registrationNameDependencies[a]=b.eventTypes[c].dependencies}
var qa={plugins:[],eventNameDispatchConfigs:{},registrationNameModules:{},registrationNameDependencies:{},possibleRegistrationNames:null,injectEventPluginOrder:function(a){la?w("101"):void 0;la=Array.prototype.slice.call(a);pa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];oa.hasOwnProperty(c)&&oa[c]===d||(oa[c]?w("102",c):void 0,oa[c]=d,b=!0)}b&&pa()}},sa=qa,ta={children:!0,dangerouslySetInnerHTML:!0,autoFocus:!0,defaultValue:!0,defaultChecked:!0,
innerHTML:!0,suppressContentEditableWarning:!0,style:!0};function ua(a,b){return(a&b)===b}
var wa={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=wa,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){xa.properties.hasOwnProperty(f)?w("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:ua(h,b.MUST_USE_PROPERTY),
hasBooleanValue:ua(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:ua(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:ua(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:ua(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:ua(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:w("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);xa.properties[f]=
g}}},xa={ID_ATTRIBUTE_NAME:"data-reactid",ROOT_ATTRIBUTE_NAME:"data-reactroot",ATTRIBUTE_NAME_START_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",ATTRIBUTE_NAME_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
properties:{},shouldSetAttribute:function(a,b){if(xa.isReservedProp(a)||!("o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return xa.shouldAttributeAcceptBooleanValue(a);case "undefined":case "number":case "string":case "object":return!0;default:return!1}},getPropertyInfo:function(a){return xa.properties.hasOwnProperty(a)?xa.properties[a]:null},shouldAttributeAcceptBooleanValue:function(a){if(xa.isReservedProp(a))return!0;var b=xa.getPropertyInfo(a);
if(b)return b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue;a=a.toLowerCase().slice(0,5);return"data-"===a||"aria-"===a},isReservedProp:function(a){return ta.hasOwnProperty(a)},injection:wa},A=xa,E={IndeterminateComponent:0,FunctionalComponent:1,ClassComponent:2,HostRoot:3,HostPortal:4,HostComponent:5,HostText:6,CoroutineComponent:7,CoroutineHandlerPhase:8,YieldComponent:9,Fragment:10},F={ELEMENT_NODE:1,TEXT_NODE:3,COMMENT_NODE:8,DOCUMENT_NODE:9,DOCUMENT_FRAGMENT_NODE:11},
ya=E.HostComponent,za=E.HostText,Aa=F.ELEMENT_NODE,Ba=F.COMMENT_NODE,Ea=A.ID_ATTRIBUTE_NAME,Fa={hasCachedChildNodes:1},Ga=Math.random().toString(36).slice(2),Ha="__reactInternalInstance$"+Ga,Ia="__reactEventHandlers$"+Ga;function La(a){for(var b;b=a._renderedComponent;)a=b;return a}function Ma(a,b){a=La(a);a._hostNode=b;b[Ha]=a}
function Na(a,b){if(!(a._flags&Fa.hasCachedChildNodes)){var c=a._renderedChildren;b=b.firstChild;var d;a:for(d in c)if(c.hasOwnProperty(d)){var e=c[d],f=La(e)._domID;if(0!==f){for(;null!==b;b=b.nextSibling){var g=b,h=f;if(g.nodeType===Aa&&g.getAttribute(Ea)===""+h||g.nodeType===Ba&&g.nodeValue===" react-text: "+h+" "||g.nodeType===Ba&&g.nodeValue===" react-empty: "+h+" "){Ma(e,b);continue a}}w("32",f)}}a._flags|=Fa.hasCachedChildNodes}}
function Oa(a){if(a[Ha])return a[Ha];for(var b=[];!a[Ha];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=a[Ha];if(c.tag===ya||c.tag===za)return c;for(;a&&(c=a[Ha]);a=b.pop()){var d=c;b.length&&Na(c,a)}return d}
var G={getClosestInstanceFromNode:Oa,getInstanceFromNode:function(a){var b=a[Ha];if(b)return b.tag===ya||b.tag===za?b:b._hostNode===a?b:null;b=Oa(a);return null!=b&&b._hostNode===a?b:null},getNodeFromInstance:function(a){if(a.tag===ya||a.tag===za)return a.stateNode;void 0===a._hostNode?w("33"):void 0;if(a._hostNode)return a._hostNode;for(var b=[];!a._hostNode;)b.push(a),a._hostParent?void 0:w("34"),a=a._hostParent;for(;b.length;a=b.pop())Na(a,a._hostNode);return a._hostNode},precacheChildNodes:Na,
precacheNode:Ma,uncacheNode:function(a){var b=a._hostNode;b&&(delete b[Ha],a._hostNode=null)},precacheFiberNode:function(a,b){b[Ha]=a},getFiberCurrentPropsFromNode:function(a){return a[Ia]||null},updateFiberProps:function(a,b){a[Ia]=b}},Pa={remove:function(a){a._reactInternalFiber=void 0},get:function(a){return a._reactInternalFiber},has:function(a){return void 0!==a._reactInternalFiber},set:function(a,b){a._reactInternalFiber=b}},Qa={ReactCurrentOwner:aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner};
function Ra(a){if("function"===typeof a.getName)return a.getName();if("number"===typeof a.tag){a=a.type;if("string"===typeof a)return a;if("function"===typeof a)return a.displayName||a.name}return null}var J={NoEffect:0,PerformedWork:1,Placement:2,Update:4,PlacementAndUpdate:6,Deletion:8,ContentReset:16,Callback:32,Err:64,Ref:128},Sa=E.HostComponent,Ta=E.HostRoot,Ua=E.HostPortal,Va=E.HostText,Wa=J.NoEffect,Xa=J.Placement;
function Za(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if((b.effectTag&Xa)!==Wa)return 1;for(;b["return"];)if(b=b["return"],(b.effectTag&Xa)!==Wa)return 1}return b.tag===Ta?2:3}function $a(a){2!==Za(a)?w("188"):void 0}
function ab(a){var b=a.alternate;if(!b)return b=Za(a),3===b?w("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return $a(e),a;if(g===d)return $a(e),b;g=g.sibling}w("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:w("189")}}c.alternate!==d?w("190"):void 0}c.tag!==Ta?w("188"):void 0;return c.stateNode.current===c?a:b}
var bb={isFiberMounted:function(a){return 2===Za(a)},isMounted:function(a){return(a=Pa.get(a))?2===Za(a):!1},findCurrentFiberUsingSlowPath:ab,findCurrentHostFiber:function(a){a=ab(a);if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null},findCurrentHostFiberWithNoPortals:function(a){a=ab(a);
if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child&&b.tag!==Ua)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}},K={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?w("197"):void 0;cb=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,
b,c,d,e,f,g,h,k){cb.apply(K,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){K.invokeGuardedCallback.apply(this,arguments);if(K.hasCaughtError()){var p=K.clearCaughtError();K._hasRethrowError||(K._hasRethrowError=!0,K._rethrowError=p)}},rethrowCaughtError:function(){return db.apply(K,arguments)},hasCaughtError:function(){return K._hasCaughtError},clearCaughtError:function(){if(K._hasCaughtError){var a=K._caughtError;K._caughtError=null;K._hasCaughtError=!1;return a}w("198")}};
function cb(a,b,c,d,e,f,g,h,k){K._hasCaughtError=!1;K._caughtError=null;var p=Array.prototype.slice.call(arguments,3);try{b.apply(c,p)}catch(x){K._caughtError=x,K._hasCaughtError=!0}}function db(){if(K._hasRethrowError){var a=K._rethrowError;K._rethrowError=null;K._hasRethrowError=!1;throw a;}}var eb=K,fb;function gb(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=hb.getNodeFromInstance(d);eb.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
var hb={isEndish:function(a){return"topMouseUp"===a||"topTouchEnd"===a||"topTouchCancel"===a},isMoveish:function(a){return"topMouseMove"===a||"topTouchMove"===a},isStartish:function(a){return"topMouseDown"===a||"topTouchStart"===a},executeDirectDispatch:function(a){var b=a._dispatchListeners,c=a._dispatchInstances;Array.isArray(b)?w("103"):void 0;a.currentTarget=b?hb.getNodeFromInstance(c):null;b=b?b(a):null;a.currentTarget=null;a._dispatchListeners=null;a._dispatchInstances=null;return b},executeDispatchesInOrder:function(a,
b){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)gb(a,b,c[e],d[e]);else c&&gb(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null},executeDispatchesInOrderStopAtTrue:function(a){a:{var b=a._dispatchListeners;var c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++){if(b[d](a,c[d])){b=c[d];break a}}else if(b&&b(a,c)){b=c;break a}b=null}a._dispatchInstances=null;a._dispatchListeners=
null;return b},hasDispatches:function(a){return!!a._dispatchListeners},getFiberCurrentPropsFromNode:function(a){return fb.getFiberCurrentPropsFromNode(a)},getInstanceFromNode:function(a){return fb.getInstanceFromNode(a)},getNodeFromInstance:function(a){return fb.getNodeFromInstance(a)},injection:{injectComponentTree:function(a){fb=a}}},ib=hb,jb=null,kb=null,lb=null;
function mb(a){if(a=ib.getInstanceFromNode(a))if("number"===typeof a.tag){jb&&"function"===typeof jb.restoreControlledState?void 0:w("194");var b=ib.getFiberCurrentPropsFromNode(a.stateNode);jb.restoreControlledState(a.stateNode,a.type,b)}else"function"!==typeof a.restoreControlledState?w("195"):void 0,a.restoreControlledState()}
var nb={injection:{injectFiberControlledHostComponent:function(a){jb=a}},enqueueStateRestore:function(a){kb?lb?lb.push(a):lb=[a]:kb=a},restoreStateIfNeeded:function(){if(kb){var a=kb,b=lb;lb=kb=null;mb(a);if(b)for(a=0;a<b.length;a++)mb(b[a])}}};function ob(a,b,c,d,e,f){return a(b,c,d,e,f)}function pb(a,b){return a(b)}function qb(a,b){return pb(a,b)}
var rb=!1,sb={batchedUpdates:function(a,b){if(rb)return ob(qb,a,b);rb=!0;try{return ob(qb,a,b)}finally{rb=!1,nb.restoreStateIfNeeded()}},injection:{injectStackBatchedUpdates:function(a){ob=a},injectFiberBatchedUpdates:function(a){pb=a}}},tb=F.TEXT_NODE;function ub(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return a.nodeType===tb?a.parentNode:a}var vb=E.HostRoot,wb=[];
function xb(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c=b;if("number"===typeof c.tag){for(;c["return"];)c=c["return"];c=c.tag!==vb?null:c.stateNode.containerInfo}else{for(;c._hostParent;)c=c._hostParent;c=G.getNodeFromInstance(c).parentNode}if(!c)break;a.ancestors.push(b);b=G.getClosestInstanceFromNode(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],yb._handleTopLevel(a.topLevelType,b,a.nativeEvent,ub(a.nativeEvent))}
var yb={_enabled:!0,_handleTopLevel:null,setHandleTopLevel:function(a){yb._handleTopLevel=a},setEnabled:function(a){yb._enabled=!!a},isEnabled:function(){return yb._enabled},trapBubbledEvent:function(a,b,c){return c?ba.listen(c,b,yb.dispatchEvent.bind(null,a)):null},trapCapturedEvent:function(a,b,c){return c?ba.capture(c,b,yb.dispatchEvent.bind(null,a)):null},dispatchEvent:function(a,b){if(yb._enabled){var c=ub(b);c=G.getClosestInstanceFromNode(c);null===c||"number"!==typeof c.tag||bb.isFiberMounted(c)||
(c=null);if(wb.length){var d=wb.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{sb.batchedUpdates(xb,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>wb.length&&wb.push(a)}}}},L=yb;function Cb(a,b){null==b?w("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function Db(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Eb=null;function Fb(a,b){a&&(ib.executeDispatchesInOrder(a,b),a.isPersistent()||a.constructor.release(a))}function Gb(a){return Fb(a,!0)}function Hb(a){return Fb(a,!1)}
function Ib(a,b,c){switch(a){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":return!(!c.disabled||"button"!==b&&"input"!==b&&"select"!==b&&"textarea"!==b);default:return!1}}
var Jb={injection:{injectEventPluginOrder:sa.injectEventPluginOrder,injectEventPluginsByName:sa.injectEventPluginsByName},getListener:function(a,b){if("number"===typeof a.tag){var c=a.stateNode;if(!c)return null;var d=ib.getFiberCurrentPropsFromNode(c);if(!d)return null;c=d[b];if(Ib(b,a.type,d))return null}else{d=a._currentElement;if("string"===typeof d||"number"===typeof d||!a._rootNodeID)return null;a=d.props;c=a[b];if(Ib(b,d.type,a))return null}c&&"function"!==typeof c?w("231",b,typeof c):void 0;
return c},extractEvents:function(a,b,c,d){for(var e,f=sa.plugins,g=0;g<f.length;g++){var h=f[g];h&&(h=h.extractEvents(a,b,c,d))&&(e=Cb(e,h))}return e},enqueueEvents:function(a){a&&(Eb=Cb(Eb,a))},processEventQueue:function(a){var b=Eb;Eb=null;a?Db(b,Gb):Db(b,Hb);Eb?w("95"):void 0;eb.rethrowCaughtError()}},Kb;l.canUseDOM&&(Kb=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
function Lb(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&Kb&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function Mb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
var Nb={animationend:Mb("Animation","AnimationEnd"),animationiteration:Mb("Animation","AnimationIteration"),animationstart:Mb("Animation","AnimationStart"),transitionend:Mb("Transition","TransitionEnd")},Ob={},Pb={};l.canUseDOM&&(Pb=document.createElement("div").style,"AnimationEvent"in window||(delete Nb.animationend.animation,delete Nb.animationiteration.animation,delete Nb.animationstart.animation),"TransitionEvent"in window||delete Nb.transitionend.transition);
function Qb(a){if(Ob[a])return Ob[a];if(!Nb[a])return a;var b=Nb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Pb)return Ob[a]=b[c];return""}
var Rb={topAbort:"abort",topAnimationEnd:Qb("animationend")||"animationend",topAnimationIteration:Qb("animationiteration")||"animationiteration",topAnimationStart:Qb("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
topTouchStart:"touchstart",topTransitionEnd:Qb("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Sb={},Tb=0,Ub="_reactListenersID"+(""+Math.random()).slice(2);function Vb(a){Object.prototype.hasOwnProperty.call(a,Ub)||(a[Ub]=Tb++,Sb[a[Ub]]={});return Sb[a[Ub]]}
var M=n({},{handleTopLevel:function(a,b,c,d){a=Jb.extractEvents(a,b,c,d);Jb.enqueueEvents(a);Jb.processEventQueue(!1)}},{setEnabled:function(a){L&&L.setEnabled(a)},isEnabled:function(){return!(!L||!L.isEnabled())},listenTo:function(a,b){var c=Vb(b);a=sa.registrationNameDependencies[a];for(var d=0;d<a.length;d++){var e=a[d];c.hasOwnProperty(e)&&c[e]||("topWheel"===e?Lb("wheel")?L.trapBubbledEvent("topWheel","wheel",b):Lb("mousewheel")?L.trapBubbledEvent("topWheel","mousewheel",b):L.trapBubbledEvent("topWheel",
"DOMMouseScroll",b):"topScroll"===e?L.trapCapturedEvent("topScroll","scroll",b):"topFocus"===e||"topBlur"===e?(L.trapCapturedEvent("topFocus","focus",b),L.trapCapturedEvent("topBlur","blur",b),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(Lb("cancel",!0)&&L.trapCapturedEvent("topCancel","cancel",b),c.topCancel=!0):"topClose"===e?(Lb("close",!0)&&L.trapCapturedEvent("topClose","close",b),c.topClose=!0):Rb.hasOwnProperty(e)&&L.trapBubbledEvent(e,Rb[e],b),c[e]=!0)}},isListeningToAllDependencies:function(a,
b){b=Vb(b);a=sa.registrationNameDependencies[a];for(var c=0;c<a.length;c++){var d=a[c];if(!b.hasOwnProperty(d)||!b[d])return!1}return!0},trapBubbledEvent:function(a,b,c){return L.trapBubbledEvent(a,b,c)},trapCapturedEvent:function(a,b,c){return L.trapCapturedEvent(a,b,c)}}),Wb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,
flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Xb=["Webkit","ms","Moz","O"];
Object.keys(Wb).forEach(function(a){Xb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Wb[b]=Wb[a]})});
var Yb={isUnitlessNumber:Wb,shorthandPropertyExpansions:{background:{backgroundAttachment:!0,backgroundColor:!0,backgroundImage:!0,backgroundPositionX:!0,backgroundPositionY:!0,backgroundRepeat:!0},backgroundPosition:{backgroundPositionX:!0,backgroundPositionY:!0},border:{borderWidth:!0,borderStyle:!0,borderColor:!0},borderBottom:{borderBottomWidth:!0,borderBottomStyle:!0,borderBottomColor:!0},borderLeft:{borderLeftWidth:!0,borderLeftStyle:!0,borderLeftColor:!0},borderRight:{borderRightWidth:!0,borderRightStyle:!0,
borderRightColor:!0},borderTop:{borderTopWidth:!0,borderTopStyle:!0,borderTopColor:!0},font:{fontStyle:!0,fontVariant:!0,fontWeight:!0,fontSize:!0,lineHeight:!0,fontFamily:!0},outline:{outlineWidth:!0,outlineStyle:!0,outlineColor:!0}}},Zb=Yb.isUnitlessNumber,$b=!1;if(l.canUseDOM){var ac=document.createElement("div").style;try{ac.font=""}catch(a){$b=!0}}
var bc={createDangerousStringForStyles:function(){},setValueForStyles:function(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Zb.hasOwnProperty(e)&&Zb[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");if(d)a.setProperty(c,e);else if(e)a[c]=e;else if(d=$b&&Yb.shorthandPropertyExpansions[c])for(var g in d)a[g]="";else a[c]=""}}},cc=new RegExp("^["+A.ATTRIBUTE_NAME_START_CHAR+
"]["+A.ATTRIBUTE_NAME_CHAR+"]*$"),dc={},ec={};function fc(a){if(ec.hasOwnProperty(a))return!0;if(dc.hasOwnProperty(a))return!1;if(cc.test(a))return ec[a]=!0;dc[a]=!0;return!1}
var gc={setAttributeForID:function(a,b){a.setAttribute(A.ID_ATTRIBUTE_NAME,b)},setAttributeForRoot:function(a){a.setAttribute(A.ROOT_ATTRIBUTE_NAME,"")},getValueForProperty:function(){},getValueForAttribute:function(){},setValueForProperty:function(a,b,c){var d=A.getPropertyInfo(b);if(d&&A.shouldSetAttribute(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?gc.deleteValueForProperty(a,
b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else gc.setValueForAttribute(a,b,A.shouldSetAttribute(b,c)?c:null)},setValueForAttribute:function(a,b,c){fc(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))},deleteValueForAttribute:function(a,b){a.removeAttribute(b)},deleteValueForProperty:function(a,b){var c=A.getPropertyInfo(b);
c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}},hc=gc,ic=Qa.ReactDebugCurrentFrame;function jc(){return null}
var kc={current:null,phase:null,resetCurrentFiber:function(){ic.getCurrentStack=null;kc.current=null;kc.phase=null},setCurrentFiber:function(a,b){ic.getCurrentStack=jc;kc.current=a;kc.phase=b},getCurrentFiberOwnerName:function(){return null},getCurrentFiberStackAddendum:jc},lc=kc,mc={getHostProps:function(a,b){var c=b.value,d=b.checked;return n({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?
d:a._wrapperState.initialChecked})},initWrapperState:function(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}},updateWrapper:function(a,b){var c=b.checked;null!=c&&hc.setValueForProperty(a,"checked",c||!1);c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=
c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)},postMountWrapper:function(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==
b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)},restoreControlledState:function(a,b){mc.updateWrapper(a,b);var c=b.name;if("radio"===b.type&&null!=c){for(b=a;b.parentNode;)b=b.parentNode;c=b.querySelectorAll("input[name\x3d"+JSON.stringify(""+c)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=G.getFiberCurrentPropsFromNode(d);e?void 0:w("90");mc.updateWrapper(d,e)}}}}},qc=mc;
function rc(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}var sc={validateProps:function(){},postMountWrapper:function(a,b){null!=b.value&&a.setAttribute("value",b.value)},getHostProps:function(a,b){a=n({children:void 0},b);if(b=rc(b.children))a.children=b;return a}};
function tc(a,b,c){a=a.options;if(b){b={};for(var d=0;d<c.length;d++)b["$"+c[d]]=!0;for(c=0;c<a.length;c++)d=b.hasOwnProperty("$"+a[c].value),a[c].selected!==d&&(a[c].selected=d)}else{c=""+c;b=null;for(d=0;d<a.length;d++){if(a[d].value===c){a[d].selected=!0;return}null!==b||a[d].disabled||(b=a[d])}null!==b&&(b.selected=!0)}}
var uc={getHostProps:function(a,b){return n({},b,{value:void 0})},initWrapperState:function(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}},postMountWrapper:function(a,b){a.multiple=!!b.multiple;var c=b.value;null!=c?tc(a,!!b.multiple,c):null!=b.defaultValue&&tc(a,!!b.multiple,b.defaultValue)},postUpdateWrapper:function(a,b){a._wrapperState.initialValue=void 0;var c=a._wrapperState.wasMultiple;a._wrapperState.wasMultiple=!!b.multiple;var d=b.value;
null!=d?tc(a,!!b.multiple,d):c!==!!b.multiple&&(null!=b.defaultValue?tc(a,!!b.multiple,b.defaultValue):tc(a,!!b.multiple,b.multiple?[]:""))},restoreControlledState:function(a,b){var c=b.value;null!=c&&tc(a,!!b.multiple,c)}},vc={getHostProps:function(a,b){null!=b.dangerouslySetInnerHTML?w("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})},initWrapperState:function(a,b){var c=b.value,d=c;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?
w("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:w("93"),b=b[0]),c=""+b),null==c&&(c=""),d=c);a._wrapperState={initialValue:""+d}},updateWrapper:function(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)},postMountWrapper:function(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)},restoreControlledState:function(a,b){vc.updateWrapper(a,b)}},wc=vc,xc=n({menuitem:!0},{area:!0,
base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function yc(a,b){b&&(xc[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?w("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?w("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:w("61")),null!=b.style&&"object"!==typeof b.style?w("62",""):void 0)}
function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
var Bc={_getTrackerFromNode:function(a){return a._valueTracker},track:function(a){a._valueTracker||(a._valueTracker=Ac(a))},updateValueIfChanged:function(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1},stopTracking:function(a){(a=a._valueTracker)&&a.stopTracking()}};
function Cc(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
var Dc=ka.Namespaces,Ec,Fc=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Dc.svg||"innerHTML"in a)a.innerHTML=b;else for(Ec=Ec||document.createElement("div"),Ec.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e",b=Ec.firstChild;b.firstChild;)a.appendChild(b.firstChild)}),Gc=/["'&<>]/,Hc=F.TEXT_NODE;
function Ic(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&c.nodeType===Hc){c.nodeValue=b;return}}a.textContent=b}
l.canUseDOM&&("textContent"in document.documentElement||(Ic=function(a,b){if(a.nodeType===Hc)a.nodeValue=b;else{if("boolean"===typeof b||"number"===typeof b)b=""+b;else{b=""+b;var c=Gc.exec(b);if(c){var d="",e,f=0;for(e=c.index;e<b.length;e++){switch(b.charCodeAt(e)){case 34:c="\x26quot;";break;case 38:c="\x26amp;";break;case 39:c="\x26#x27;";break;case 60:c="\x26lt;";break;case 62:c="\x26gt;";break;default:continue}f!==e&&(d+=b.substring(f,e));f=e+1;d+=c}b=f!==e?d+b.substring(f,e):d}}Fc(a,b)}}));
var Jc=Ic,Kc=lc.getCurrentFiberOwnerName,Lc=F.DOCUMENT_NODE,Mc=F.DOCUMENT_FRAGMENT_NODE,Nc=M.listenTo,Oc=sa.registrationNameModules,Pc=ka.Namespaces.html,Qc=ka.getIntrinsicNamespace;function Rc(a,b){Nc(b,a.nodeType===Lc||a.nodeType===Mc?a:a.ownerDocument)}
var Sc={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
topWaiting:"waiting"},N={createElement:function(a,b,c,d){c=c.nodeType===Lc?c:c.ownerDocument;d===Pc&&(d=Qc(a));d===Pc?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a},createTextNode:function(a,b){return(b.nodeType===Lc?b:b.ownerDocument).createTextNode(a)},setInitialProperties:function(a,b,c,d){var e=Cc(b,c);switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
"load",a);var f=c;break;case "video":case "audio":for(f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);f=c;break;case "source":M.trapBubbledEvent("topError","error",a);f=c;break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);f=c;break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);f=c;break;case "details":M.trapBubbledEvent("topToggle","toggle",a);f=c;break;case "input":qc.initWrapperState(a,
c);f=qc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "option":sc.validateProps(a,c);f=sc.getHostProps(a,c);break;case "select":uc.initWrapperState(a,c);f=uc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "textarea":wc.initWrapperState(a,c);f=wc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;default:f=c}yc(b,f,Kc);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===
h?bc.setValueForStyles(a,k):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fc(a,k)):"children"===h?"string"===typeof k?Jc(a,k):"number"===typeof k&&Jc(a,""+k):"suppressContentEditableWarning"!==h&&(Oc.hasOwnProperty(h)?null!=k&&Rc(d,h):e?hc.setValueForAttribute(a,h,k):null!=k&&hc.setValueForProperty(a,h,k))}switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "option":sc.postMountWrapper(a,c);break;case "select":uc.postMountWrapper(a,
c);break;default:"function"===typeof f.onClick&&(a.onclick=ca)}},diffProperties:function(a,b,c,d,e){var f=null;switch(b){case "input":c=qc.getHostProps(a,c);d=qc.getHostProps(a,d);f=[];break;case "option":c=sc.getHostProps(a,c);d=sc.getHostProps(a,d);f=[];break;case "select":c=uc.getHostProps(a,c);d=uc.getHostProps(a,d);f=[];break;case "textarea":c=wc.getHostProps(a,c);d=wc.getHostProps(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=ca)}yc(b,d,Kc);
var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]="");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&
b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?(null!=k&&Rc(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f},updateProperties:function(a,b,c,d,e){Cc(c,d);d=Cc(c,e);for(var f=0;f<b.length;f+=
2){var g=b[f],h=b[f+1];"style"===g?bc.setValueForStyles(a,h):"dangerouslySetInnerHTML"===g?Fc(a,h):"children"===g?Jc(a,h):d?null!=h?hc.setValueForAttribute(a,g,h):hc.deleteValueForAttribute(a,g):null!=h?hc.setValueForProperty(a,g,h):hc.deleteValueForProperty(a,g)}switch(c){case "input":qc.updateWrapper(a,e);Bc.updateValueIfChanged(a);break;case "textarea":wc.updateWrapper(a,e);break;case "select":uc.postUpdateWrapper(a,e)}},diffHydratedProperties:function(a,b,c,d,e){switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
"load",a);break;case "video":case "audio":for(var f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);break;case "source":M.trapBubbledEvent("topError","error",a);break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);break;case "details":M.trapBubbledEvent("topToggle","toggle",a);break;case "input":qc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid",
"invalid",a);Rc(e,"onChange");break;case "option":sc.validateProps(a,c);break;case "select":uc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(e,"onChange");break;case "textarea":wc.initWrapperState(a,c),M.trapBubbledEvent("topInvalid","invalid",a),Rc(e,"onChange")}yc(b,c,Kc);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Oc.hasOwnProperty(g)&&
null!=f&&Rc(e,g));switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=ca)}return d},diffHydratedText:function(a,b){return a.nodeValue!==b},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,
b,c){switch(b){case "input":qc.restoreControlledState(a,c);break;case "textarea":wc.restoreControlledState(a,c);break;case "select":uc.restoreControlledState(a,c)}}},Tc=void 0;
if(l.canUseDOM)if("function"!==typeof requestIdleCallback){var Uc=null,Vc=null,Wc=!1,Xc=!1,Yc=0,Zc=33,$c=33,ad={timeRemaining:"object"===typeof performance&&"function"===typeof performance.now?function(){return Yc-performance.now()}:function(){return Yc-Date.now()}},bd="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){a.source===window&&a.data===bd&&(Wc=!1,a=Vc,Vc=null,null!==a&&a(ad))},!1);var cd=function(a){Xc=!1;var b=a-Yc+$c;b<$c&&Zc<$c?(8>
b&&(b=8),$c=b<Zc?Zc:b):Zc=b;Yc=a+$c;Wc||(Wc=!0,window.postMessage(bd,"*"));b=Uc;Uc=null;null!==b&&b(a)};Tc=function(a){Vc=a;Xc||(Xc=!0,requestAnimationFrame(cd));return 0}}else Tc=requestIdleCallback;else Tc=function(a){setTimeout(function(){a({timeRemaining:function(){return Infinity}})});return 0};
var dd={rIC:Tc},ed={enableAsyncSubtreeAPI:!0},Q={NoWork:0,SynchronousPriority:1,TaskPriority:2,HighPriority:3,LowPriority:4,OffscreenPriority:5},fd=J.Callback,gd=Q.NoWork,hd=Q.SynchronousPriority,id=Q.TaskPriority,jd=E.ClassComponent,kd=E.HostRoot,md=void 0,nd=void 0;function od(a,b){return a!==id&&a!==hd||b!==id&&b!==hd?a===gd&&b!==gd?-255:a!==gd&&b===gd?255:a-b:0}function pd(){return{first:null,last:null,hasForceUpdate:!1,callbackList:null}}
function qd(a,b,c,d){null!==c?c.next=b:(b.next=a.first,a.first=b);null!==d?b.next=d:a.last=b}function rd(a,b){b=b.priorityLevel;var c=null;if(null!==a.last&&0>=od(a.last.priorityLevel,b))c=a.last;else for(a=a.first;null!==a&&0>=od(a.priorityLevel,b);)c=a,a=a.next;return c}
function sd(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=pd());null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=pd())):a=null;md=d;nd=a!==d?a:null;var e=md;c=nd;var f=rd(e,b),g=null!==f?f.next:e.first;if(null===c)return qd(e,b,f,g),null;d=rd(c,b);a=null!==d?d.next:c.first;qd(e,b,f,g);if(g===a&&null!==g||f===d&&null!==f)return null===d&&(c.first=b),null===a&&(c.last=null),null;b={priorityLevel:b.priorityLevel,partialState:b.partialState,callback:b.callback,isReplace:b.isReplace,
isForced:b.isForced,isTopLevelUnmount:b.isTopLevelUnmount,next:null};qd(c,b,d,a);return b}function td(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
var ud={addUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:!1,next:null})},addReplaceUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!0,isForced:!1,isTopLevelUnmount:!1,next:null})},addForceUpdate:function(a,b,c){sd(a,{priorityLevel:c,partialState:null,callback:b,isReplace:!1,isForced:!0,isTopLevelUnmount:!1,next:null})},getUpdatePriority:function(a){var b=a.updateQueue;return null===b||a.tag!==
jd&&a.tag!==kd?gd:null!==b.first?b.first.priorityLevel:gd},addTopLevelUpdate:function(a,b,c,d){var e=null===b.element;b={priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:e,next:null};a=sd(a,b);e&&(e=md,c=nd,null!==e&&null!==b.next&&(b.next=null,e.last=b),null!==c&&null!==a&&null!==a.next&&(a.next=null,c.last=b))},beginUpdateQueue:function(a,b,c,d,e,f,g){null!==a&&a.updateQueue===c&&(c=b.updateQueue={first:c.first,last:c.last,callbackList:null,hasForceUpdate:!1});
a=c.callbackList;for(var h=c.hasForceUpdate,k=!0,p=c.first;null!==p&&0>=od(p.priorityLevel,g);){c.first=p.next;null===c.first&&(c.last=null);var x;if(p.isReplace)e=td(p,d,e,f),k=!0;else if(x=td(p,d,e,f))e=k?n({},e,x):n(e,x),k=!1;p.isForced&&(h=!0);null===p.callback||p.isTopLevelUnmount&&null!==p.next||(a=null!==a?a:[],a.push(p.callback),b.effectTag|=fd);p=p.next}c.callbackList=a;c.hasForceUpdate=h;null!==c.first||null!==a||h||(b.updateQueue=null);return e},commitCallbacks:function(a,b,c){a=b.callbackList;
if(null!==a)for(b.callbackList=null,b=0;b<a.length;b++){var d=a[b];"function"!==typeof d?w("191",d):void 0;d.call(c)}}},vd=[],wd=-1,xd={createCursor:function(a){return{current:a}},isEmpty:function(){return-1===wd},pop:function(a){0>wd||(a.current=vd[wd],vd[wd]=null,wd--)},push:function(a,b){wd++;vd[wd]=a.current;a.current=b},reset:function(){for(;-1<wd;)vd[wd]=null,wd--}},yd=bb.isFiberMounted,zd=E.ClassComponent,Ad=E.HostRoot,Bd=xd.createCursor,Cd=xd.pop,Dd=xd.push,Ed=Bd(da),Fd=Bd(!1),Ld=da;
function Md(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function Nd(a){return a.tag===zd&&null!=a.type.childContextTypes}function Od(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:w("108",Ra(a)||"Unknown",e);return n({},b,c)}
var R={getUnmaskedContext:function(a){return Nd(a)?Ld:Ed.current},cacheContext:Md,getMaskedContext:function(a,b){var c=a.type.contextTypes;if(!c)return da;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&Md(a,b,e);return e},hasContextChanged:function(){return Fd.current},isContextConsumer:function(a){return a.tag===zd&&null!=a.type.contextTypes},isContextProvider:Nd,popContextProvider:function(a){Nd(a)&&
(Cd(Fd,a),Cd(Ed,a))},popTopLevelContextObject:function(a){Cd(Fd,a);Cd(Ed,a)},pushTopLevelContextObject:function(a,b,c){null!=Ed.cursor?w("168"):void 0;Dd(Ed,b,a);Dd(Fd,c,a)},processChildContext:Od,pushContextProvider:function(a){if(!Nd(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||da;Ld=Ed.current;Dd(Ed,b,a);Dd(Fd,Fd.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:w("169");if(b){var d=Od(a,Ld,!0);c.__reactInternalMemoizedMergedChildContext=
d;Cd(Fd,a);Cd(Ed,a);Dd(Ed,d,a)}else Cd(Fd,a);Dd(Fd,b,a)},resetContext:function(){Ld=da;Ed.current=da;Fd.current=!1},findCurrentUnmaskedContext:function(a){for(yd(a)&&a.tag===zd?void 0:w("170");a.tag!==Ad;){if(Nd(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:w("171")}return a.stateNode.context}},Pd={NoContext:0,AsyncUpdates:1},Qd=E.IndeterminateComponent,Rd=E.ClassComponent,Sd=E.HostRoot,Td=E.HostComponent,Ud=E.HostText,Vd=E.HostPortal,Wd=E.CoroutineComponent,
Xd=E.YieldComponent,Yd=E.Fragment,Zd=Q.NoWork,$d=Pd.NoContext,ae=J.NoEffect;function be(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=ae;this.lastEffect=this.firstEffect=this.nextEffect=null;this.pendingWorkPriority=Zd;this.alternate=null}
function ce(a,b,c){var d=void 0;"function"===typeof a?(d=a.prototype&&a.prototype.isReactComponent?new be(Rd,b,c):new be(Qd,b,c),d.type=a):"string"===typeof a?(d=new be(Td,b,c),d.type=a):"object"===typeof a&&null!==a&&"number"===typeof a.tag?d=a:w("130",null==a?a:typeof a,"");return d}
var de={createWorkInProgress:function(a,b){var c=a.alternate;null===c?(c=new be(a.tag,a.key,a.internalContextTag),c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.effectTag=ae,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.pendingWorkPriority=b;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c},createHostRootFiber:function(){return new be(Sd,null,$d)},
createFiberFromElement:function(a,b,c){b=ce(a.type,a.key,b,null);b.pendingProps=a.props;b.pendingWorkPriority=c;return b},createFiberFromFragment:function(a,b,c){b=new be(Yd,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromText:function(a,b,c){b=new be(Ud,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromElementType:ce,createFiberFromHostInstanceForDeletion:function(){var a=new be(Td,null,$d);a.type="DELETED";return a},createFiberFromCoroutine:function(a,
b,c){b=new be(Wd,a.key,b);b.type=a.handler;b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromYield:function(a,b){return new be(Xd,null,b)},createFiberFromPortal:function(a,b,c){b=new be(Vd,a.key,b);b.pendingProps=a.children||[];b.pendingWorkPriority=c;b.stateNode={containerInfo:a.containerInfo,implementation:a.implementation};return b},largerPriority:function(a,b){return a!==Zd&&(b===Zd||b>a)?a:b}},ee=de.createHostRootFiber,fe=E.IndeterminateComponent,ge=E.FunctionalComponent,he=E.ClassComponent,
ie=E.HostComponent,je,ke;"function"===typeof Symbol&&Symbol["for"]?(je=Symbol["for"]("react.coroutine"),ke=Symbol["for"]("react.yield")):(je=60104,ke=60105);
var le={createCoroutine:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:je,key:null==d?null:""+d,children:a,handler:b,props:c}},createYield:function(a){return{$$typeof:ke,value:a}},isCoroutine:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===je},isYield:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===ke},REACT_YIELD_TYPE:ke,REACT_COROUTINE_TYPE:je},me="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.portal")||
60106,ne={createPortal:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:me,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}},isPortal:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===me},REACT_PORTAL_TYPE:me},oe=le.REACT_COROUTINE_TYPE,pe=le.REACT_YIELD_TYPE,qe=ne.REACT_PORTAL_TYPE,re=de.createWorkInProgress,se=de.createFiberFromElement,te=de.createFiberFromFragment,ue=de.createFiberFromText,ve=de.createFiberFromCoroutine,
we=de.createFiberFromYield,xe=de.createFiberFromPortal,ye=Array.isArray,ze=E.FunctionalComponent,Ae=E.ClassComponent,Be=E.HostText,Ce=E.HostPortal,De=E.CoroutineComponent,Ee=E.YieldComponent,Fe=E.Fragment,Ge=J.NoEffect,He=J.Placement,Ie=J.Deletion,Je="function"===typeof Symbol&&Symbol.iterator,Ke="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;
function Le(a){if(null===a||"undefined"===typeof a)return null;a=Je&&a[Je]||a["@@iterator"];return"function"===typeof a?a:null}
function Me(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&("number"===typeof b.tag?(b.tag!==Ae?w("110"):void 0,d=b.stateNode):d=b.getPublicInstance());d?void 0:w("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===da?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?w("148"):void 0;b._owner?void 0:w("149",c)}return c}
function Ne(a,b){"textarea"!==a.type&&w("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Oe(a,b){function c(c,d){if(b){if(!a){if(null===d.alternate)return;d=d.alternate}var m=c.lastEffect;null!==m?(m.nextEffect=d,c.lastEffect=d):c.firstEffect=c.lastEffect=d;d.nextEffect=null;d.effectTag=Ie}}function d(a,d){if(!b)return null;for(;null!==d;)c(a,d),d=d.sibling;return null}function e(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function f(b,c){if(a)return b=re(b,c),b.index=0,b.sibling=null,b;b.pendingWorkPriority=c;b.effectTag=Ge;
b.index=0;b.sibling=null;return b}function g(a,c,d){a.index=d;if(!b)return c;d=a.alternate;if(null!==d)return d=d.index,d<c?(a.effectTag=He,c):d;a.effectTag=He;return c}function h(a){b&&null===a.alternate&&(a.effectTag=He);return a}function k(a,b,c,d){if(null===b||b.tag!==Be)return c=ue(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function p(a,b,c,d){if(null===b||b.type!==c.type)return d=se(c,a.internalContextTag,d),d.ref=Me(b,c),d["return"]=a,d;d=f(b,
d);d.ref=Me(b,c);d.pendingProps=c.props;d["return"]=a;return d}function x(a,b,c,d){if(null===b||b.tag!==De)return c=ve(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function S(a,b,c,d){if(null===b||b.tag!==Ee)return b=we(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=f(b,d);b.type=c.value;b["return"]=a;return b}function D(a,b,c,d){if(null===b||b.tag!==Ce||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return c=
xe(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c.children||[];b["return"]=a;return b}function y(a,b,c,d){if(null===b||b.tag!==Fe)return c=te(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function B(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ue(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ke:return c=se(b,a.internalContextTag,c),c.ref=Me(null,b),c["return"]=
a,c;case oe:return b=ve(b,a.internalContextTag,c),b["return"]=a,b;case pe:return c=we(b,a.internalContextTag,c),c.type=b.value,c["return"]=a,c;case qe:return b=xe(b,a.internalContextTag,c),b["return"]=a,b}if(ye(b)||Le(b))return b=te(b,a.internalContextTag,c),b["return"]=a,b;Ne(a,b)}return null}function H(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:k(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ke:return c.key===e?p(a,
b,c,d):null;case oe:return c.key===e?x(a,b,c,d):null;case pe:return null===e?S(a,b,c,d):null;case qe:return c.key===e?D(a,b,c,d):null}if(ye(c)||Le(c))return null!==e?null:y(a,b,c,d);Ne(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,k(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ke:return a=a.get(null===d.key?c:d.key)||null,p(b,a,d,e);case oe:return a=a.get(null===d.key?c:d.key)||null,x(b,a,d,e);case pe:return a=a.get(c)||
null,S(b,a,d,e);case qe:return a=a.get(null===d.key?c:d.key)||null,D(b,a,d,e)}if(ye(d)||Le(d))return a=a.get(c)||null,y(b,a,d,e);Ne(b,d)}return null}function Ca(a,f,h,k){for(var m=null,t=null,q=f,r=f=0,p=null;null!==q&&r<h.length;r++){q.index>r?(p=q,q=null):p=q.sibling;var v=H(a,q,h[r],k);if(null===v){null===q&&(q=p);break}b&&q&&null===v.alternate&&c(a,q);f=g(v,f,r);null===t?m=v:t.sibling=v;t=v;q=p}if(r===h.length)return d(a,q),m;if(null===q){for(;r<h.length;r++)if(q=B(a,h[r],k))f=g(q,f,r),null===
t?m=q:t.sibling=q,t=q;return m}for(q=e(a,q);r<h.length;r++)if(p=C(q,a,r,h[r],k)){if(b&&null!==p.alternate)q["delete"](null===p.key?r:p.key);f=g(p,f,r);null===t?m=p:t.sibling=p;t=p}b&&q.forEach(function(b){return c(a,b)});return m}function r(a,f,h,r){var m=Le(h);"function"!==typeof m?w("150"):void 0;h=m.call(h);null==h?w("151"):void 0;for(var t=m=null,q=f,k=f=0,p=null,v=h.next();null!==q&&!v.done;k++,v=h.next()){q.index>k?(p=q,q=null):p=q.sibling;var V=H(a,q,v.value,r);if(null===V){q||(q=p);break}b&&
q&&null===V.alternate&&c(a,q);f=g(V,f,k);null===t?m=V:t.sibling=V;t=V;q=p}if(v.done)return d(a,q),m;if(null===q){for(;!v.done;k++,v=h.next())v=B(a,v.value,r),null!==v&&(f=g(v,f,k),null===t?m=v:t.sibling=v,t=v);return m}for(q=e(a,q);!v.done;k++,v=h.next())if(v=C(q,a,k,v.value,r),null!==v){if(b&&null!==v.alternate)q["delete"](null===v.key?k:v.key);f=g(v,f,k);null===t?m=v:t.sibling=v;t=v}b&&q.forEach(function(b){return c(a,b)});return m}return function(a,b,e,g){var m="object"===typeof e&&null!==e;if(m)switch(e.$$typeof){case Ke:a:{var C=
e.key;for(m=b;null!==m;){if(m.key===C)if(m.type===e.type){d(a,m.sibling);b=f(m,g);b.ref=Me(m,e);b.pendingProps=e.props;b["return"]=a;a=b;break a}else{d(a,m);break}else c(a,m);m=m.sibling}g=se(e,a.internalContextTag,g);g.ref=Me(b,e);g["return"]=a;a=g}return h(a);case oe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===De){d(a,b.sibling);b=f(b,g);b.pendingProps=e;b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=ve(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a);case pe:a:{if(null!==
b)if(b.tag===Ee){d(a,b.sibling);b=f(b,g);b.type=e.value;b["return"]=a;a=b;break a}else d(a,b);b=we(e,a.internalContextTag,g);b.type=e.value;b["return"]=a;a=b}return h(a);case qe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===Ce&&b.stateNode.containerInfo===e.containerInfo&&b.stateNode.implementation===e.implementation){d(a,b.sibling);b=f(b,g);b.pendingProps=e.children||[];b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=xe(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a)}if("string"===
typeof e||"number"===typeof e)return e=""+e,null!==b&&b.tag===Be?(d(a,b.sibling),b=f(b,g),b.pendingProps=e,b["return"]=a,a=b):(d(a,b),e=ue(e,a.internalContextTag,g),e["return"]=a,a=e),h(a);if(ye(e))return Ca(a,b,e,g);if(Le(e))return r(a,b,e,g);m&&Ne(a,e);if("undefined"===typeof e)switch(a.tag){case Ae:case ze:e=a.type,w("152",e.displayName||e.name||"Component")}return d(a,b)}}
var Pe=Oe(!0,!0),Qe=Oe(!1,!0),Re=Oe(!1,!1),Se={reconcileChildFibers:Pe,reconcileChildFibersInPlace:Qe,mountChildFibersInPlace:Re,cloneChildFibers:function(a,b){null!==a&&b.child!==a.child?w("153"):void 0;if(null!==b.child){a=b.child;var c=re(a,a.pendingWorkPriority);c.pendingProps=a.pendingProps;b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=re(a,a.pendingWorkPriority),c.pendingProps=a.pendingProps,c["return"]=b;c.sibling=null}}},Te=J.Update,Ue=Pd.AsyncUpdates,Ve=R.cacheContext,
We=R.getMaskedContext,Xe=R.getUnmaskedContext,Ye=R.isContextConsumer,Ze=ud.addUpdate,$e=ud.addReplaceUpdate,af=ud.addForceUpdate,bf=ud.beginUpdateQueue,cf=R.hasContextChanged,df=bb.isMounted;
function ef(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;Pa.set(b,a)}var f={isMounted:df,enqueueSetState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);Ze(c,d,void 0===e?null:e,f);a(c,f)},enqueueReplaceState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);$e(c,d,void 0===e?null:e,f);a(c,f)},enqueueForceUpdate:function(c,d){c=Pa.get(c);var e=b(c,!1);af(c,void 0===d?null:d,e);a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=Xe(a),f=Ye(a),g=f?We(a,d):da;b=new c(b,g);
e(a,b);f&&Ve(a,d,g);return b},mountClassInstance:function(a,b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:w("158");var h=Xe(a);d.props=g;d.state=e;d.refs=da;d.context=We(a,h);ed.enableAsyncSubtreeAPI&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=Ue);"function"===typeof d.componentWillMount&&(h=d.state,d.componentWillMount(),h!==d.state&&f.enqueueReplaceState(d,d.state,null),h=a.updateQueue,null!==
h&&(d.state=bf(c,a,h,d,e,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=Te)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?w("159"):void 0);var D=g.context,y=Xe(b);y=We(b,y);"function"!==typeof g.componentWillReceiveProps||h===k&&D===y||(D=g.state,g.componentWillReceiveProps(k,y),g.state!==D&&f.enqueueReplaceState(g,g.state,null));D=b.memoizedState;e=null!==b.updateQueue?bf(a,
b,b.updateQueue,g,D,k,e):D;if(!(h!==k||D!==e||cf()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),!1;var B=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)B=!0;else{var H=b.stateNode,C=b.type;B="function"===typeof H.shouldComponentUpdate?H.shouldComponentUpdate(B,e,y):C.prototype&&C.prototype.isPureReactComponent?!ea(h,B)||!ea(D,e):!0}B?("function"===typeof g.componentWillUpdate&&
g.componentWillUpdate(k,e,y),"function"===typeof g.componentDidUpdate&&(b.effectTag|=Te)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),c(b,k),d(b,e));g.props=k;g.state=e;g.context=y;return B}}}
var ff=Se.mountChildFibersInPlace,gf=Se.reconcileChildFibers,hf=Se.reconcileChildFibersInPlace,jf=Se.cloneChildFibers,kf=ud.beginUpdateQueue,lf=R.getMaskedContext,mf=R.getUnmaskedContext,nf=R.hasContextChanged,of=R.pushContextProvider,pf=R.pushTopLevelContextObject,qf=R.invalidateContextProvider,rf=E.IndeterminateComponent,sf=E.FunctionalComponent,tf=E.ClassComponent,uf=E.HostRoot,wf=E.HostComponent,xf=E.HostText,yf=E.HostPortal,zf=E.CoroutineComponent,Af=E.CoroutineHandlerPhase,Bf=E.YieldComponent,
Cf=E.Fragment,Df=Q.NoWork,Ef=Q.OffscreenPriority,Ff=J.PerformedWork,Gf=J.Placement,Hf=J.ContentReset,If=J.Err,Jf=J.Ref,Kf=Qa.ReactCurrentOwner;
function Lf(a,b,c,d,e){function f(a,b,c){g(a,b,c,b.pendingWorkPriority)}function g(a,b,c,d){b.child=null===a?ff(b,b.child,c,d):a.child===b.child?gf(b,b.child,c,d):hf(b,b.child,c,d)}function h(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=Jf)}function k(a,b,c,d){h(a,b);if(!c)return d&&qf(b,!1),x(a,b);c=b.stateNode;Kf.current=b;var e=c.render();b.effectTag|=Ff;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&qf(b,!0);return b.child}function p(a){var b=a.stateNode;b.pendingContext?
pf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&pf(a,b.context,!1);C(a,b.containerInfo)}function x(a,b){jf(a,b);return b.child}function S(a,b){switch(b.tag){case uf:p(b);break;case tf:of(b);break;case yf:C(b,b.stateNode.containerInfo)}return null}var D=a.shouldSetTextContent,y=a.useSyncScheduling,B=a.shouldDeprioritizeSubtree,H=b.pushHostContext,C=b.pushHostContainer,Ca=c.enterHydrationState,r=c.resetHydrationState,m=c.tryToClaimNextHydratableInstance;a=ef(d,e,function(a,b){a.memoizedProps=
b},function(a,b){a.memoizedState=b});var t=a.adoptClassInstance,v=a.constructClassInstance,V=a.mountClassInstance,ld=a.updateClassInstance;return{beginWork:function(a,b,c){if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);switch(b.tag){case rf:null!==a?w("155"):void 0;var d=b.type,e=b.pendingProps,g=mf(b);g=lf(b,g);d=d(e,g);b.effectTag|=Ff;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=tf,e=of(b),t(b,d),V(b,c),b=k(a,b,!0,e)):(b.tag=sf,f(a,b,d),b.memoizedProps=
e,b=b.child);return b;case sf:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(nf())null===c&&(c=d);else if(null===c||d===c){b=x(a,b);break a}d=mf(b);d=lf(b,d);e=e(c,d);b.effectTag|=Ff;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case tf:return e=of(b),d=void 0,null===a?b.stateNode?w("153"):(v(b,b.pendingProps),V(b,c),d=!0):d=ld(a,b,c),k(a,b,d,e);case uf:return p(b),d=b.updateQueue,null!==d?(e=b.memoizedState,d=kf(a,b,d,null,e,null,c),e===d?(r(),b=x(a,b)):(e=d.element,null!==a&&null!==a.child||
!Ca(b)?(r(),f(a,b,e)):(b.effectTag|=Gf,b.child=ff(b,b.child,e,c)),b.memoizedState=d,b=b.child)):(r(),b=x(a,b)),b;case wf:H(b);null===a&&m(b);e=b.type;var q=b.memoizedProps;d=b.pendingProps;null===d&&(d=q,null===d?w("154"):void 0);g=null!==a?a.memoizedProps:null;nf()||null!==d&&q!==d?(q=d.children,D(e,d)?q=null:g&&D(e,g)&&(b.effectTag|=Hf),h(a,b),c!==Ef&&!y&&B(e,d)?(b.pendingWorkPriority=Ef,b=null):(f(a,b,q),b.memoizedProps=d,b=b.child)):b=x(a,b);return b;case xf:return null===a&&m(b),a=b.pendingProps,
null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case Af:b.tag=zf;case zf:c=b.pendingProps;if(nf())null===c&&(c=a&&a.memoizedProps,null===c?w("154"):void 0);else if(null===c||b.memoizedProps===c)c=b.memoizedProps;e=c.children;d=b.pendingWorkPriority;b.stateNode=null===a?ff(b,b.stateNode,e,d):a.child===b.child?gf(b,b.stateNode,e,d):hf(b,b.stateNode,e,d);b.memoizedProps=c;return b.stateNode;case Bf:return null;case yf:a:{C(b,b.stateNode.containerInfo);c=b.pendingWorkPriority;e=b.pendingProps;if(nf())null===
e&&(e=a&&a.memoizedProps,null==e?w("154"):void 0);else if(null===e||b.memoizedProps===e){b=x(a,b);break a}null===a?b.child=hf(b,b.child,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case Cf:a:{c=b.pendingProps;if(nf())null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=x(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:w("156")}},beginFailedWork:function(a,b,c){switch(b.tag){case tf:of(b);break;case uf:p(b);break;default:w("157")}b.effectTag|=If;null===a?
b.child=null:b.child!==a.child&&(b.child=a.child);if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);b.firstEffect=null;b.lastEffect=null;g(a,b,null,c);b.tag===tf&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
var Mf=Se.reconcileChildFibers,Nf=R.popContextProvider,Of=R.popTopLevelContextObject,Pf=E.IndeterminateComponent,Qf=E.FunctionalComponent,Rf=E.ClassComponent,Sf=E.HostRoot,Tf=E.HostComponent,Uf=E.HostText,Vf=E.HostPortal,Wf=E.CoroutineComponent,Xf=E.CoroutineHandlerPhase,Yf=E.YieldComponent,Zf=E.Fragment,ag=J.Placement,bg=J.Ref,cg=J.Update,dg=Q.OffscreenPriority;
function eg(a,b,c){var d=a.createInstance,e=a.createTextInstance,f=a.appendInitialChild,g=a.finalizeInitialChildren,h=a.prepareUpdate,k=b.getRootHostContainer,p=b.popHostContext,x=b.getHostContext,S=b.popHostContainer,D=c.prepareToHydrateHostInstance,y=c.prepareToHydrateHostTextInstance,B=c.popHydrationState;return{completeWork:function(a,b,c){var r=b.pendingProps;if(null===r)r=b.memoizedProps;else if(b.pendingWorkPriority!==dg||c===dg)b.pendingProps=null;switch(b.tag){case Qf:return null;case Rf:return Nf(b),
null;case Sf:S(b);Of(b);r=b.stateNode;r.pendingContext&&(r.context=r.pendingContext,r.pendingContext=null);if(null===a||null===a.child)B(b),b.effectTag&=~ag;return null;case Tf:p(b);c=k();var m=b.type;if(null!==a&&null!=b.stateNode){var t=a.memoizedProps,C=b.stateNode,V=x();r=h(C,m,t,r,c,V);if(b.updateQueue=r)b.effectTag|=cg;a.ref!==b.ref&&(b.effectTag|=bg)}else{if(!r)return null===b.stateNode?w("166"):void 0,null;a=x();if(B(b))D(b,c,a)&&(b.effectTag|=cg);else{a=d(m,r,c,a,b);a:for(t=b.child;null!==
t;){if(t.tag===Tf||t.tag===Uf)f(a,t.stateNode);else if(t.tag!==Vf&&null!==t.child){t=t.child;continue}if(t===b)break a;for(;null===t.sibling;){if(null===t["return"]||t["return"]===b)break a;t=t["return"]}t=t.sibling}g(a,m,r,c)&&(b.effectTag|=cg);b.stateNode=a}null!==b.ref&&(b.effectTag|=bg)}return null;case Uf:if(a&&null!=b.stateNode)a.memoizedProps!==r&&(b.effectTag|=cg);else{if("string"!==typeof r)return null===b.stateNode?w("166"):void 0,null;a=k();c=x();B(b)?y(b)&&(b.effectTag|=cg):b.stateNode=
e(r,a,c,b)}return null;case Wf:(r=b.memoizedProps)?void 0:w("165");b.tag=Xf;c=[];a:for((m=b.stateNode)&&(m["return"]=b);null!==m;){if(m.tag===Tf||m.tag===Uf||m.tag===Vf)w("164");else if(m.tag===Yf)c.push(m.type);else if(null!==m.child){m.child["return"]=m;m=m.child;continue}for(;null===m.sibling;){if(null===m["return"]||m["return"]===b)break a;m=m["return"]}m.sibling["return"]=m["return"];m=m.sibling}m=r.handler;r=m(r.props,c);b.child=Mf(b,null!==a?a.child:null,r,b.pendingWorkPriority);return b.child;
case Xf:return b.tag=Wf,null;case Yf:return null;case Zf:return null;case Vf:return b.effectTag|=cg,S(b),null;case Pf:w("167");default:w("156")}}}}var fg=null,gg=null;function hg(a){return function(b){try{return a(b)}catch(c){}}}
var ig={injectInternals:function(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!b.supportsFiber)return!0;try{var c=b.inject(a);fg=hg(function(a){return b.onCommitFiberRoot(c,a)});gg=hg(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0},onCommitRoot:function(a){"function"===typeof fg&&fg(a)},onCommitUnmount:function(a){"function"===typeof gg&&gg(a)}},jg=E.ClassComponent,kg=E.HostRoot,lg=E.HostComponent,mg=E.HostText,ng=
E.HostPortal,og=E.CoroutineComponent,pg=ud.commitCallbacks,qg=ig.onCommitUnmount,rg=J.Placement,sg=J.Update,tg=J.Callback,ug=J.ContentReset;
function vg(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(t){b(a,t)}}function d(a){return a.tag===lg||a.tag===kg||a.tag===ng}function e(a){for(var b=a;;)if(g(b),null!==b.child&&b.tag!==ng)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}function f(a){for(var b=a,c=!1,d=void 0,f=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?w("160"):void 0;switch(c.tag){case lg:d=
c.stateNode;f=!1;break a;case kg:d=c.stateNode.containerInfo;f=!0;break a;case ng:d=c.stateNode.containerInfo;f=!0;break a}c=c["return"]}c=!0}if(b.tag===lg||b.tag===mg)e(b),f?C(d,b.stateNode):H(d,b.stateNode);else if(b.tag===ng?d=b.stateNode.containerInfo:g(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];b.tag===ng&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}function g(a){"function"===
typeof qg&&qg(a);switch(a.tag){case jg:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(t){b(a,t)}break;case lg:c(a);break;case og:e(a.stateNode);break;case ng:f(a)}}var h=a.commitMount,k=a.commitUpdate,p=a.resetTextContent,x=a.commitTextUpdate,S=a.appendChild,D=a.appendChildToContainer,y=a.insertBefore,B=a.insertInContainerBefore,H=a.removeChild,C=a.removeChildFromContainer,Ca=a.getPublicInstance;
return{commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(d(b)){var c=b;break a}b=b["return"]}w("160");c=void 0}var e=b=void 0;switch(c.tag){case lg:b=c.stateNode;e=!1;break;case kg:b=c.stateNode.containerInfo;e=!0;break;case ng:b=c.stateNode.containerInfo;e=!0;break;default:w("161")}c.effectTag&ug&&(p(b),c.effectTag&=~ug);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||d(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;c.tag!==
lg&&c.tag!==mg;){if(c.effectTag&rg)continue b;if(null===c.child||c.tag===ng)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&rg)){c=c.stateNode;break a}}for(var f=a;;){if(f.tag===lg||f.tag===mg)c?e?B(b,f.stateNode,c):y(b,f.stateNode,c):e?D(b,f.stateNode):S(b,f.stateNode);else if(f.tag!==ng&&null!==f.child){f.child["return"]=f;f=f.child;continue}if(f===a)break;for(;null===f.sibling;){if(null===f["return"]||f["return"]===a)return;f=f["return"]}f.sibling["return"]=f["return"];f=f.sibling}},
commitDeletion:function(a){f(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case jg:break;case lg:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&k(c,f,e,a,d,b)}break;case mg:null===b.stateNode?w("162"):void 0;c=b.memoizedProps;x(b.stateNode,null!==a?a.memoizedProps:c,c);break;case kg:break;case ng:break;default:w("163")}},
commitLifeCycles:function(a,b){switch(b.tag){case jg:var c=b.stateNode;if(b.effectTag&sg)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b.effectTag&tg&&null!==b.updateQueue&&pg(b,b.updateQueue,c);break;case kg:a=b.updateQueue;null!==a&&pg(b,a,b.child&&b.child.stateNode);break;case lg:c=b.stateNode;null===a&&b.effectTag&sg&&h(c,b.type,b.memoizedProps,
b);break;case mg:break;case ng:break;default:w("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case lg:b(Ca(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var wg=xd.createCursor,xg=xd.pop,yg=xd.push,zg={};
function Ag(a){function b(a){a===zg?w("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e=wg(zg),f=wg(zg),g=wg(zg);return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){xg(e,a);xg(f,a);xg(g,a)},popHostContext:function(a){f.current===a&&(xg(e,a),xg(f,a))},pushHostContainer:function(a,b){yg(g,b,a);b=d(b);yg(f,a,a);yg(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);d=c(h,a.type,
d);h!==d&&(yg(f,a,a),yg(e,d,a))},resetHostContainer:function(){e.current=zg;g.current=zg}}}var Bg=E.HostComponent,Cg=E.HostText,Dg=E.HostRoot,Eg=J.Deletion,Fg=J.Placement,Gg=de.createFiberFromHostInstanceForDeletion;
function Hg(a){function b(a,b){var c=Gg();c.stateNode=b;c["return"]=a;c.effectTag=Eg;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case Bg:return f(b,a.type,a.pendingProps);case Cg:return g(b,a.pendingProps);default:return!1}}function d(a){for(a=a["return"];null!==a&&a.tag!==Bg&&a.tag!==Dg;)a=a["return"];y=a}var e=a.shouldSetTextContent,f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,
p=a.hydrateInstance,x=a.hydrateTextInstance,S=a.didNotHydrateInstance,D=a.didNotFindHydratableInstance;a=a.didNotFindHydratableTextInstance;if(!(f&&g&&h&&k&&p&&x&&S&&D&&a))return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){w("175")},prepareToHydrateHostTextInstance:function(){w("176")},popHydrationState:function(){return!1}};var y=null,B=null,H=!1;return{enterHydrationState:function(a){B=
k(a.stateNode.containerInfo);y=a;return H=!0},resetHydrationState:function(){B=y=null;H=!1},tryToClaimNextHydratableInstance:function(a){if(H){var d=B;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=Fg;H=!1;y=a;return}b(y,B)}a.stateNode=d;y=a;B=k(d)}else a.effectTag|=Fg,H=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=p(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return x(a.stateNode,a.memoizedProps,a)},
popHydrationState:function(a){if(a!==y)return!1;if(!H)return d(a),H=!0,!1;var c=a.type;if(a.tag!==Bg||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=B;c;)b(a,c),c=h(c);d(a);B=y?h(a.stateNode):null;return!0}}}
var Ig=R.popContextProvider,Jg=xd.reset,Kg=Qa.ReactCurrentOwner,Lg=de.createWorkInProgress,Mg=de.largerPriority,Ng=ig.onCommitRoot,T=Q.NoWork,Og=Q.SynchronousPriority,U=Q.TaskPriority,Pg=Q.HighPriority,Qg=Q.LowPriority,Rg=Q.OffscreenPriority,Sg=Pd.AsyncUpdates,Tg=J.PerformedWork,Ug=J.Placement,Vg=J.Update,Wg=J.PlacementAndUpdate,Xg=J.Deletion,Yg=J.ContentReset,Zg=J.Callback,$g=J.Err,ah=J.Ref,bh=E.HostRoot,ch=E.HostComponent,dh=E.HostPortal,eh=E.ClassComponent,fh=ud.getUpdatePriority,gh=R.resetContext;
function hh(a){function b(){for(;null!==ma&&ma.current.pendingWorkPriority===T;){ma.isScheduled=!1;var a=ma.nextScheduledRoot;ma.nextScheduledRoot=null;if(ma===zb)return zb=ma=null,z=T,null;ma=a}a=ma;for(var b=null,c=T;null!==a;)a.current.pendingWorkPriority!==T&&(c===T||c>a.current.pendingWorkPriority)&&(c=a.current.pendingWorkPriority,b=a),a=a.nextScheduledRoot;null!==b?(z=c,Jg(),gh(),t(),I=Lg(b.current,c),b!==nc&&(oc=0,nc=b)):(z=T,nc=I=null)}function c(c){Hd=!0;na=null;var d=c.stateNode;d.current===
c?w("177"):void 0;z!==Og&&z!==U||oc++;Kg.current=null;if(c.effectTag>Tg)if(null!==c.lastEffect){c.lastEffect.nextEffect=c;var e=c.firstEffect}else e=c;else e=c.firstEffect;Ui();for(u=e;null!==u;){var f=!1,g=void 0;try{for(;null!==u;){var h=u.effectTag;h&Yg&&a.resetTextContent(u.stateNode);if(h&ah){var k=u.alternate;null!==k&&Ph(k)}switch(h&~(Zg|$g|Yg|ah|Tg)){case Ug:q(u);u.effectTag&=~Ug;break;case Wg:q(u);u.effectTag&=~Ug;vf(u.alternate,u);break;case Vg:vf(u.alternate,u);break;case Xg:Id=!0,Mh(u),
Id=!1}u=u.nextEffect}}catch(Jd){f=!0,g=Jd}f&&(null===u?w("178"):void 0,x(u,g),null!==u&&(u=u.nextEffect))}Vi();d.current=c;for(u=e;null!==u;){d=!1;e=void 0;try{for(;null!==u;){var Gd=u.effectTag;Gd&(Vg|Zg)&&Nh(u.alternate,u);Gd&ah&&Oh(u);if(Gd&$g)switch(f=u,g=void 0,null!==P&&(g=P.get(f),P["delete"](f),null==g&&null!==f.alternate&&(f=f.alternate,g=P.get(f),P["delete"](f))),null==g?w("184"):void 0,f.tag){case eh:f.stateNode.componentDidCatch(g.error,{componentStack:g.componentStack});break;case bh:null===
Ja&&(Ja=g.error);break;default:w("157")}var m=u.nextEffect;u.nextEffect=null;u=m}}catch(Jd){d=!0,e=Jd}d&&(null===u?w("178"):void 0,x(u,e),null!==u&&(u=u.nextEffect))}Hd=!1;"function"===typeof Ng&&Ng(c.stateNode);va&&(va.forEach(H),va=null);b()}function d(a){for(;;){var b=Lh(a.alternate,a,z),c=a["return"],d=a.sibling;var e=a;if(!(e.pendingWorkPriority!==T&&e.pendingWorkPriority>z)){for(var f=fh(e),g=e.child;null!==g;)f=Mg(f,g.pendingWorkPriority),g=g.sibling;e.pendingWorkPriority=f}if(null!==b)return b;
null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),a.effectTag>Tg&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{na=a;break}}return null}function e(a){var b=V(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}function f(a){var b=ld(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}
function g(a){p(Rg,a)}function h(){if(null!==P&&0<P.size&&z===U)for(;null!==I;){var a=I;I=null!==P&&(P.has(a)||null!==a.alternate&&P.has(a.alternate))?f(I):e(I);if(null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,null===P||0===P.size||z!==U))break}}function k(a,d){null!==na?(O=U,c(na),h()):null===I&&b();if(!(z===T||z>a)){O=z;a:do{if(z<=U)for(;null!==I&&!(I=e(I),null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,h(),z===T||z>a||z>U)););else if(null!==d)for(;null!==I&&!Ab;)if(1<d.timeRemaining()){if(I=
e(I),null===I)if(null===na?w("179"):void 0,1<d.timeRemaining()){if(O=U,c(na),O=z,h(),z===T||z>a||z<Pg)break}else Ab=!0}else Ab=!0;switch(z){case Og:case U:if(z<=a)continue a;break a;case Pg:case Qg:case Rg:if(null===d)break a;if(!Ab&&z<=a)continue a;break a;case T:break a;default:w("181")}}while(1)}}function p(a,b){Da?w("182"):void 0;Da=!0;var c=O,d=!1,e=null;try{k(a,b)}catch(Kd){d=!0,e=Kd}for(;d;){if(Ya){Ja=e;break}var h=I;if(null===h)Ya=!0;else{var p=x(h,e);null===p?w("183"):void 0;if(!Ya){try{d=
p;e=a;p=b;for(var q=d;null!==h;){switch(h.tag){case eh:Ig(h);break;case ch:m(h);break;case bh:r(h);break;case dh:r(h)}if(h===q||h.alternate===q)break;h=h["return"]}I=f(d);k(e,p)}catch(Kd){d=!0;e=Kd;continue}break}}}O=c;null!==b&&(Bb=!1);z>U&&!Bb&&($f(g),Bb=!0);a=Ja;Ya=Ab=Da=!1;nc=Ka=P=Ja=null;oc=0;if(null!==a)throw a;}function x(a,b){var c=Kg.current=null,d=!1,e=!1,f=null;if(a.tag===bh)c=a,S(a)&&(Ya=!0);else for(var g=a["return"];null!==g&&null===c;){g.tag===eh?"function"===typeof g.stateNode.componentDidCatch&&
(d=!0,f=Ra(g),c=g,e=!0):g.tag===bh&&(c=g);if(S(g)){if(Id||null!==va&&(va.has(g)||null!==g.alternate&&va.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===Ka&&(Ka=new Set);Ka.add(c);var h="";g=a;do{a:switch(g.tag){case fe:case ge:case he:case ie:var k=g._debugOwner,m=g._debugSource;var p=Ra(g);var q=null;k&&(q=Ra(k));k=m;p="\n    in "+(p||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":q?" (created by "+q+")":"");break a;default:p=""}h+=p;g=g["return"]}while(g);
g=h;a=Ra(a);null===P&&(P=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};P.set(c,b);try{console.error(b.error)}catch(Wi){console.error(Wi)}Hd?(null===va&&(va=new Set),va.add(c)):H(c);return c}null===Ja&&(Ja=b);return null}function S(a){return null!==Ka&&(Ka.has(a)||null!==a.alternate&&Ka.has(a.alternate))}function D(a,b){return y(a,b,!1)}function y(a,b){oc>Xi&&(Ya=!0,w("185"));!Da&&b<=z&&(I=null);for(var c=
!0;null!==a&&c;){c=!1;if(a.pendingWorkPriority===T||a.pendingWorkPriority>b)c=!0,a.pendingWorkPriority=b;null!==a.alternate&&(a.alternate.pendingWorkPriority===T||a.alternate.pendingWorkPriority>b)&&(c=!0,a.alternate.pendingWorkPriority=b);if(null===a["return"])if(a.tag===bh){var d=a.stateNode;b===T||d.isScheduled||(d.isScheduled=!0,zb?zb.nextScheduledRoot=d:ma=d,zb=d);if(!Da)switch(b){case Og:pc?p(Og,null):p(U,null);break;case U:W?void 0:w("186");break;default:Bb||($f(g),Bb=!0)}}else break;a=a["return"]}}
function B(a,b){var c=O;c===T&&(c=!Yi||a.internalContextTag&Sg||b?Qg:Og);return c===Og&&(Da||W)?U:c}function H(a){y(a,U,!0)}var C=Ag(a),Ca=Hg(a),r=C.popHostContainer,m=C.popHostContext,t=C.resetHostContainer,v=Lf(a,C,Ca,D,B),V=v.beginWork,ld=v.beginFailedWork,Lh=eg(a,C,Ca).completeWork;C=vg(a,x);var q=C.commitPlacement,Mh=C.commitDeletion,vf=C.commitWork,Nh=C.commitLifeCycles,Oh=C.commitAttachRef,Ph=C.commitDetachRef,$f=a.scheduleDeferredCallback,Yi=a.useSyncScheduling,Ui=a.prepareForCommit,Vi=a.resetAfterCommit,
O=T,Da=!1,Ab=!1,W=!1,pc=!1,I=null,z=T,u=null,na=null,ma=null,zb=null,Bb=!1,P=null,Ka=null,va=null,Ja=null,Ya=!1,Hd=!1,Id=!1,Xi=1E3,oc=0,nc=null;return{scheduleUpdate:D,getPriorityContext:B,batchedUpdates:function(a,b){var c=W;W=!0;try{return a(b)}finally{W=c,Da||W||p(U,null)}},unbatchedUpdates:function(a){var b=pc,c=W;pc=W;W=!1;try{return a()}finally{W=c,pc=b}},flushSync:function(a){var b=W,c=O;W=!0;O=Og;try{return a()}finally{W=b,O=c,Da?w("187"):void 0,p(U,null)}},deferredUpdates:function(a){var b=
O;O=Qg;try{return a()}finally{O=b}}}}function ih(){w("196")}function jh(a){if(!a)return da;a=Pa.get(a);return"number"===typeof a.tag?ih(a):a._processChildContext(a._context)}jh._injectFiber=function(a){ih=a};var kh=ud.addTopLevelUpdate,lh=R.findCurrentUnmaskedContext,mh=R.isContextProvider,nh=R.processChildContext,oh=E.HostComponent,ph=bb.findCurrentHostFiber,qh=bb.findCurrentHostFiberWithNoPortals;jh._injectFiber(function(a){var b=lh(a);return mh(a)?nh(a,b,!1):b});var rh=F.TEXT_NODE;
function sh(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function th(a,b){var c=sh(a);a=0;for(var d;c;){if(c.nodeType===rh){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=sh(c)}}var uh=null;function vh(){!uh&&l.canUseDOM&&(uh="textContent"in document.documentElement?"textContent":"innerText");return uh}
var wh={getOffsets:function(a){var b=window.getSelection&&window.getSelection();if(!b||0===b.rangeCount)return null;var c=b.anchorNode,d=b.anchorOffset,e=b.focusNode,f=b.focusOffset,g=b.getRangeAt(0);try{g.startContainer.nodeType,g.endContainer.nodeType}catch(k){return null}b=b.anchorNode===b.focusNode&&b.anchorOffset===b.focusOffset?0:g.toString().length;var h=g.cloneRange();h.selectNodeContents(a);h.setEnd(g.startContainer,g.startOffset);a=h.startContainer===h.endContainer&&h.startOffset===h.endOffset?
0:h.toString().length;g=a+b;b=document.createRange();b.setStart(c,d);b.setEnd(e,f);c=b.collapsed;return{start:c?g:a,end:c?a:g}},setOffsets:function(a,b){if(window.getSelection){var c=window.getSelection(),d=a[vh()].length,e=Math.min(b.start,d);b=void 0===b.end?e:Math.min(b.end,d);!c.extend&&e>b&&(d=b,b=e,e=d);d=th(a,e);a=th(a,b);if(d&&a){var f=document.createRange();f.setStart(d.node,d.offset);c.removeAllRanges();e>b?(c.addRange(f),c.extend(a.node,a.offset)):(f.setEnd(a.node,a.offset),c.addRange(f))}}}},
xh=F.ELEMENT_NODE,yh={hasSelectionCapabilities:function(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)},getSelectionInformation:function(){var a=ia();return{focusedElem:a,selectionRange:yh.hasSelectionCapabilities(a)?yh.getSelection(a):null}},restoreSelection:function(a){var b=ia(),c=a.focusedElem;a=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){yh.hasSelectionCapabilities(c)&&yh.setSelection(c,a);b=
[];for(a=c;a=a.parentNode;)a.nodeType===xh&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ha(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}},getSelection:function(a){return("selectionStart"in a?{start:a.selectionStart,end:a.selectionEnd}:wh.getOffsets(a))||{start:0,end:0}},setSelection:function(a,b){var c=b.start,d=b.end;void 0===d&&(d=c);"selectionStart"in a?(a.selectionStart=c,a.selectionEnd=Math.min(d,a.value.length)):wh.setOffsets(a,b)}},zh=yh,
Ah=F.ELEMENT_NODE;function Bh(){w("211")}function Ch(){w("212")}function Dh(a){if(null==a)return null;if(a.nodeType===Ah)return a;var b=Pa.get(a);if(b)return"number"===typeof b.tag?Bh(b):Ch(b);"function"===typeof a.render?w("188"):w("213",Object.keys(a))}Dh._injectFiber=function(a){Bh=a};Dh._injectStack=function(a){Ch=a};var Eh=E.HostComponent;function Fh(a){if(void 0!==a._hostParent)return a._hostParent;if("number"===typeof a.tag){do a=a["return"];while(a&&a.tag!==Eh);if(a)return a}return null}
function Gh(a,b){for(var c=0,d=a;d;d=Fh(d))c++;d=0;for(var e=b;e;e=Fh(e))d++;for(;0<c-d;)a=Fh(a),c--;for(;0<d-c;)b=Fh(b),d--;for(;c--;){if(a===b||a===b.alternate)return a;a=Fh(a);b=Fh(b)}return null}
var Hh={isAncestor:function(a,b){for(;b;){if(a===b||a===b.alternate)return!0;b=Fh(b)}return!1},getLowestCommonAncestor:Gh,getParentInstance:function(a){return Fh(a)},traverseTwoPhase:function(a,b,c){for(var d=[];a;)d.push(a),a=Fh(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)},traverseEnterLeave:function(a,b,c,d,e){for(var f=a&&b?Gh(a,b):null,g=[];a&&a!==f;)g.push(a),a=Fh(a);for(a=[];b&&b!==f;)a.push(b),b=Fh(b);for(b=0;b<g.length;b++)c(g[b],"bubbled",d);for(b=
a.length;0<b--;)c(a[b],"captured",e)}},Ih=Jb.getListener;function Jh(a,b,c){if(b=Ih(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a)}function Kh(a){a&&a.dispatchConfig.phasedRegistrationNames&&Hh.traverseTwoPhase(a._targetInst,Jh,a)}function Qh(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?Hh.getParentInstance(b):null;Hh.traverseTwoPhase(b,Jh,a)}}
function Rh(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ih(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a))}function Sh(a){a&&a.dispatchConfig.registrationName&&Rh(a._targetInst,null,a)}
var Th={accumulateTwoPhaseDispatches:function(a){Db(a,Kh)},accumulateTwoPhaseDispatchesSkipTarget:function(a){Db(a,Qh)},accumulateDirectDispatches:function(a){Db(a,Sh)},accumulateEnterLeaveDispatches:function(a,b,c,d){Hh.traverseEnterLeave(c,d,Rh,a,b)}},X={_root:null,_startText:null,_fallbackText:null},Uh={initialize:function(a){X._root=a;X._startText=Uh.getText();return!0},reset:function(){X._root=null;X._startText=null;X._fallbackText=null},getData:function(){if(X._fallbackText)return X._fallbackText;
var a,b=X._startText,c=b.length,d,e=Uh.getText(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);X._fallbackText=e.slice(a,1<d?1-d:void 0);return X._fallbackText},getText:function(){return"value"in X._root?X._root.value:X._root[vh()]}},Vh=Uh,Wh="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Xh={type:null,target:null,currentTarget:ca.thatReturnsNull,eventPhase:null,bubbles:null,
cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
function Y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?ca.thatReturnsTrue:ca.thatReturnsFalse;this.isPropagationStopped=ca.thatReturnsFalse;return this}
n(Y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=ca.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=ca.thatReturnsTrue)},persist:function(){this.isPersistent=ca.thatReturnsTrue},isPersistent:ca.thatReturnsFalse,
destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Wh.length;a++)this[Wh[a]]=null}});Y.Interface=Xh;Y.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;n(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=n({},this.Interface,b);a.augmentClass=this.augmentClass;Yh(a)};Yh(Y);function Zh(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function $h(a){a instanceof this?void 0:w("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Yh(a){a.eventPool=[];a.getPooled=Zh;a.release=$h}function ai(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ai,{data:null});function bi(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(bi,{data:null});var ci=[9,13,27,32],di=l.canUseDOM&&"CompositionEvent"in window,ei=null;l.canUseDOM&&"documentMode"in document&&(ei=document.documentMode);var fi;
if(fi=l.canUseDOM&&"TextEvent"in window&&!ei){var gi=window.opera;fi=!("object"===typeof gi&&"function"===typeof gi.version&&12>=parseInt(gi.version(),10))}
var hi=fi,ii=l.canUseDOM&&(!di||ei&&8<ei&&11>=ei),ji=String.fromCharCode(32),ki={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},li=!1;
function mi(a,b){switch(a){case "topKeyUp":return-1!==ci.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ni(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var oi=!1;function pi(a,b){switch(a){case "topCompositionEnd":return ni(b);case "topKeyPress":if(32!==b.which)return null;li=!0;return ji;case "topTextInput":return a=b.data,a===ji&&li?null:a;default:return null}}
function qi(a,b){if(oi)return"topCompositionEnd"===a||!di&&mi(a,b)?(a=Vh.getData(),Vh.reset(),oi=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return ii?null:b.data;default:return null}}
var ri={eventTypes:ki,extractEvents:function(a,b,c,d){var e;if(di)b:{switch(a){case "topCompositionStart":var f=ki.compositionStart;break b;case "topCompositionEnd":f=ki.compositionEnd;break b;case "topCompositionUpdate":f=ki.compositionUpdate;break b}f=void 0}else oi?mi(a,c)&&(f=ki.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=ki.compositionStart);f?(ii&&(oi||f!==ki.compositionStart?f===ki.compositionEnd&&oi&&(e=Vh.getData()):oi=Vh.initialize(d)),f=ai.getPooled(f,b,c,d),e?f.data=e:(e=ni(c),
null!==e&&(f.data=e)),Th.accumulateTwoPhaseDispatches(f),e=f):e=null;(a=hi?pi(a,c):qi(a,c))?(b=bi.getPooled(ki.beforeInput,b,c,d),b.data=a,Th.accumulateTwoPhaseDispatches(b)):b=null;return[e,b]}},si={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function ti(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!si[a.type]:"textarea"===b?!0:!1}
var ui={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function vi(a,b,c){a=Y.getPooled(ui.change,a,b,c);a.type="change";nb.enqueueStateRestore(c);Th.accumulateTwoPhaseDispatches(a);return a}var wi=null,xi=null;function yi(a){Jb.enqueueEvents(a);Jb.processEventQueue(!1)}
function zi(a){var b=G.getNodeFromInstance(a);if(Bc.updateValueIfChanged(b))return a}function Ai(a,b){if("topChange"===a)return b}var Bi=!1;l.canUseDOM&&(Bi=Lb("input")&&(!document.documentMode||9<document.documentMode));function Ci(){wi&&(wi.detachEvent("onpropertychange",Di),xi=wi=null)}function Di(a){"value"===a.propertyName&&zi(xi)&&(a=vi(xi,a,ub(a)),sb.batchedUpdates(yi,a))}function Ei(a,b,c){"topFocus"===a?(Ci(),wi=b,xi=c,wi.attachEvent("onpropertychange",Di)):"topBlur"===a&&Ci()}
function Fi(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return zi(xi)}function Gi(a,b){if("topClick"===a)return zi(b)}function Hi(a,b){if("topInput"===a||"topChange"===a)return zi(b)}
var Ii={eventTypes:ui,_isInputEventSupported:Bi,extractEvents:function(a,b,c,d){var e=b?G.getNodeFromInstance(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ai;else if(ti(e))if(Bi)g=Hi;else{g=Fi;var h=Ei}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Gi);if(g&&(g=g(a,b)))return vi(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,
e.getAttribute("value")!==a&&e.setAttribute("value",a))}};function Ji(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(Ji,{view:function(a){if(a.view)return a.view;a=ub(a);return a.window===a?a:(a=a.ownerDocument)?a.defaultView||a.parentWindow:window},detail:function(a){return a.detail||0}});var Ki={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Li(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Ki[a])?!!b[a]:!1}function Mi(){return Li}
function Ni(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(Ni,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Mi,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
var Oi={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},Pi={eventTypes:Oi,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?G.getClosestInstanceFromNode(b):
null):a=null;if(a===b)return null;var f=null==a?e:G.getNodeFromInstance(a);e=null==b?e:G.getNodeFromInstance(b);var g=Ni.getPooled(Oi.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=Ni.getPooled(Oi.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Th.accumulateEnterLeaveDispatches(g,c,a,b);return[g,c]}},Qi=F.DOCUMENT_NODE,Ri=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Si={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},
dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Ti=null,Zi=null,$i=null,aj=!1,bj=M.isListeningToAllDependencies;
function cj(a,b){if(aj||null==Ti||Ti!==ia())return null;var c=Ti;"selectionStart"in c&&zh.hasSelectionCapabilities(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $i&&ea($i,c)?null:($i=c,a=Y.getPooled(Si.select,Zi,a,b),a.type="select",a.target=Ti,Th.accumulateTwoPhaseDispatches(a),a)}
var dj={eventTypes:Si,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:d.nodeType===Qi?d:d.ownerDocument;if(!e||!bj("onSelect",e))return null;e=b?G.getNodeFromInstance(b):window;switch(a){case "topFocus":if(ti(e)||"true"===e.contentEditable)Ti=e,Zi=b,$i=null;break;case "topBlur":$i=Zi=Ti=null;break;case "topMouseDown":aj=!0;break;case "topContextMenu":case "topMouseUp":return aj=!1,cj(c,d);case "topSelectionChange":if(Ri)break;case "topKeyDown":case "topKeyUp":return cj(c,d)}return null}};
function ej(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ej,{animationName:null,elapsedTime:null,pseudoElement:null});function fj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(fj,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function gj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(gj,{relatedTarget:null});function hj(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
var ij={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},jj={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function kj(a,b,c,d){return Y.call(this,a,b,c,d)}
Ji.augmentClass(kj,{key:function(a){if(a.key){var b=ij[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=hj(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?jj[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Mi,charCode:function(a){return"keypress"===a.type?hj(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?hj(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function lj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(lj,{dataTransfer:null});function mj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(mj,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Mi});function nj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(nj,{propertyName:null,elapsedTime:null,pseudoElement:null});
function oj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(oj,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var pj={},qj={};
"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};pj[a]=c;qj[b]=c});
var rj={eventTypes:pj,extractEvents:function(a,b,c,d){var e=qj[a];if(!e)return null;switch(a){case "topAbort":case "topCancel":case "topCanPlay":case "topCanPlayThrough":case "topClose":case "topDurationChange":case "topEmptied":case "topEncrypted":case "topEnded":case "topError":case "topInput":case "topInvalid":case "topLoad":case "topLoadedData":case "topLoadedMetadata":case "topLoadStart":case "topPause":case "topPlay":case "topPlaying":case "topProgress":case "topRateChange":case "topReset":case "topSeeked":case "topSeeking":case "topStalled":case "topSubmit":case "topSuspend":case "topTimeUpdate":case "topToggle":case "topVolumeChange":case "topWaiting":var f=Y;
break;case "topKeyPress":if(0===hj(c))return null;case "topKeyDown":case "topKeyUp":f=kj;break;case "topBlur":case "topFocus":f=gj;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":f=Ni;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":f=lj;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":f=
mj;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":f=ej;break;case "topTransitionEnd":f=nj;break;case "topScroll":f=Ji;break;case "topWheel":f=oj;break;case "topCopy":case "topCut":case "topPaste":f=fj}f?void 0:w("86",a);a=f.getPooled(e,b,c,d);Th.accumulateTwoPhaseDispatches(a);return a}};L.setHandleTopLevel(M.handleTopLevel);Jb.injection.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ib.injection.injectComponentTree(G);Jb.injection.injectEventPluginsByName({SimpleEventPlugin:rj,EnterLeaveEventPlugin:Pi,ChangeEventPlugin:Ii,SelectEventPlugin:dj,BeforeInputEventPlugin:ri});
var sj=A.injection.MUST_USE_PROPERTY,Z=A.injection.HAS_BOOLEAN_VALUE,tj=A.injection.HAS_NUMERIC_VALUE,uj=A.injection.HAS_POSITIVE_NUMERIC_VALUE,vj=A.injection.HAS_STRING_BOOLEAN_VALUE,wj={Properties:{allowFullScreen:Z,allowTransparency:vj,async:Z,autoPlay:Z,capture:Z,checked:sj|Z,cols:uj,contentEditable:vj,controls:Z,"default":Z,defer:Z,disabled:Z,download:A.injection.HAS_OVERLOADED_BOOLEAN_VALUE,draggable:vj,formNoValidate:Z,hidden:Z,loop:Z,multiple:sj|Z,muted:sj|Z,noValidate:Z,open:Z,playsInline:Z,
readOnly:Z,required:Z,reversed:Z,rows:uj,rowSpan:tj,scoped:Z,seamless:Z,selected:sj|Z,size:uj,start:tj,span:uj,spellCheck:vj,style:0,itemScope:Z,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:vj},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&
a.ownerDocument.activeElement!==a&&a.setAttribute("value",""+b)}}},xj=A.injection.HAS_STRING_BOOLEAN_VALUE,yj={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},zj={Properties:{autoReverse:xj,externalResourcesRequired:xj,preserveAlpha:xj},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:yj.xlink,xlinkArcrole:yj.xlink,xlinkHref:yj.xlink,xlinkRole:yj.xlink,
xlinkShow:yj.xlink,xlinkTitle:yj.xlink,xlinkType:yj.xlink,xmlBase:yj.xml,xmlLang:yj.xml,xmlSpace:yj.xml}},Aj=/[\-\:]([a-z])/g;function Bj(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Aj,
Bj);zj.Properties[b]=0;zj.DOMAttributeNames[b]=a});A.injection.injectDOMPropertyConfig(wj);A.injection.injectDOMPropertyConfig(zj);
var Cj=ig.injectInternals,Dj=F.ELEMENT_NODE,Ej=F.TEXT_NODE,Fj=F.COMMENT_NODE,Gj=F.DOCUMENT_NODE,Hj=F.DOCUMENT_FRAGMENT_NODE,Ij=A.ROOT_ATTRIBUTE_NAME,Jj=ka.getChildNamespace,Kj=N.createElement,Lj=N.createTextNode,Mj=N.setInitialProperties,Nj=N.diffProperties,Oj=N.updateProperties,Pj=N.diffHydratedProperties,Qj=N.diffHydratedText,Rj=N.warnForDeletedHydratableElement,Sj=N.warnForDeletedHydratableText,Tj=N.warnForInsertedHydratedElement,Uj=N.warnForInsertedHydratedText,Vj=G.precacheFiberNode,Wj=G.updateFiberProps;
nb.injection.injectFiberControlledHostComponent(N);Dh._injectFiber(function(a){return Xj.findHostInstance(a)});var Yj=null,Zj=null;function ak(a){return!(!a||a.nodeType!==Dj&&a.nodeType!==Gj&&a.nodeType!==Hj&&(a.nodeType!==Fj||" react-mount-point-unstable "!==a.nodeValue))}function bk(a){a=a?a.nodeType===Gj?a.documentElement:a.firstChild:null;return!(!a||a.nodeType!==Dj||!a.hasAttribute(Ij))}
var Xj=function(a){var b=a.getPublicInstance;a=hh(a);var c=a.scheduleUpdate,d=a.getPriorityContext;return{createContainer:function(a){var b=ee();a={current:b,containerInfo:a,isScheduled:!1,nextScheduledRoot:null,context:null,pendingContext:null};return b.stateNode=a},updateContainer:function(a,b,g,h){var e=b.current;g=jh(g);null===b.context?b.context=g:b.pendingContext=g;b=h;h=d(e,ed.enableAsyncSubtreeAPI&&null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent);
a={element:a};kh(e,a,void 0===b?null:b,h);c(e,h)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case oh:return b(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:function(a){a=ph(a);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=qh(a);return null===a?null:a.stateNode}}}({getRootHostContext:function(a){if(a.nodeType===
Gj)a=(a=a.documentElement)?a.namespaceURI:Jj(null,"");else{var b=a.nodeType===Fj?a.parentNode:a;a=b.namespaceURI||null;b=b.tagName;a=Jj(a,b)}return a},getChildHostContext:function(a,b){return Jj(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){Yj=M.isEnabled();Zj=zh.getSelectionInformation();M.setEnabled(!1)},resetAfterCommit:function(){zh.restoreSelection(Zj);Zj=null;M.setEnabled(Yj);Yj=null},createInstance:function(a,b,c,d,e){a=Kj(a,b,c,d);Vj(e,a);Wj(a,b);return a},appendInitialChild:function(a,
b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){Mj(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return Nj(a,b,c,d,e)},commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){Wj(a,e);Oj(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&
"string"===typeof b.dangerouslySetInnerHTML.__html},resetTextContent:function(a){a.textContent=""},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=Lj(a,b);Vj(d,a);return a},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){a.nodeType===Fj?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,
b,c){a.nodeType===Fj?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){a.nodeType===Fj?a.parentNode.removeChild(b):a.removeChild(b)},canHydrateInstance:function(a,b){return a.nodeType===Dj&&b===a.nodeName.toLowerCase()},canHydrateTextInstance:function(a,b){return""===b?!1:a.nodeType===Ej},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=
a.firstChild;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){Vj(f,a);Wj(a,c);return Pj(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){Vj(c,a);return Qj(a,b)},didNotHydrateInstance:function(a,b){1===b.nodeType?Rj(a,b):Sj(a,b)},didNotFindHydratableInstance:function(a,b,c){Tj(a,b,c)},didNotFindHydratableTextInstance:function(a,b){Uj(a,b)},scheduleDeferredCallback:dd.rIC,useSyncScheduling:!0});sb.injection.injectFiberBatchedUpdates(Xj.batchedUpdates);
function ck(a,b,c,d,e){ak(c)?void 0:w("200");var f=c._reactRootContainer;if(f)Xj.updateContainer(b,f,a,e);else{if(!d&&!bk(c))for(d=void 0;d=c.lastChild;)c.removeChild(d);var g=Xj.createContainer(c);f=c._reactRootContainer=g;Xj.unbatchedUpdates(function(){Xj.updateContainer(b,g,a,e)})}return Xj.getPublicRootInstance(f)}function dk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ak(b)?void 0:w("200");return ne.createPortal(a,b,null,c)}
var ek={createPortal:dk,hydrate:function(a,b,c){return ck(null,a,b,!0,c)},render:function(a,b,c){return ck(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null!=a&&Pa.has(a)?void 0:w("38");return ck(a,b,c,!1,d)},unmountComponentAtNode:function(a){ak(a)?void 0:w("40");return a._reactRootContainer?(Xj.unbatchedUpdates(function(){ck(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},findDOMNode:Dh,unstable_createPortal:dk,unstable_batchedUpdates:sb.batchedUpdates,
unstable_deferredUpdates:Xj.deferredUpdates,flushSync:Xj.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Jb,EventPluginRegistry:sa,EventPropagators:Th,ReactControlledComponent:nb,ReactDOMComponentTree:G,ReactDOMEventListener:L}};Cj({findFiberByHostInstance:G.getClosestInstanceFromNode,findHostInstanceByFiber:Xj.findHostInstance,bundleType:0,version:"16.0.0",rendererPackageName:"react-dom"});module.exports=ek;


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(271);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(521);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(522);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(272);
var defaultClickRejectionStrategy = __webpack_require__(526);

var alreadyInjected = false;

module.exports = function injectTapEventPlugin(strategyOverrides) {
  strategyOverrides = strategyOverrides || {}
  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;

  if (false) {
    invariant(
      !alreadyInjected,
      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
It is recommended to call injectTapEventPlugin() just before you call \
ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
itself, please contact the maintainer as it shouldn\'t be called in library code and \
should be injected by the application.'
    )
  }

  alreadyInjected = true;

  __webpack_require__(72).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.EventPluginHub.injection.injectEventPluginsByName({
    'TapEventPlugin': __webpack_require__(527)(shouldRejectClick)
  });
};



/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule TapEventPlugin
 * @flow
 */



var EventPropagators = __webpack_require__(72).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.EventPropagators;
var TouchEventUtils = __webpack_require__(528);
var SyntheticEvent = __webpack_require__(529);

function isEndish(topLevelType) {
  return (
    topLevelType === 'topMouseUp' ||
    topLevelType === 'topTouchEnd' ||
    topLevelType === 'topTouchCancel'
  );
}

function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

/**
 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
 * in order to still be considered a 'tap' event.
 */
var tapMoveThreshold = 10;
var startCoords = {x: 0, y: 0};

var Axis = {
  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
};

function getAxisCoordOfEvent(
  axis,
  nativeEvent
) {
  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
  if (singleTouch) {
    return singleTouch[axis.page];
  }
  return nativeEvent[axis.page];
}

function getDistance(coords, nativeEvent) {
  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
  return Math.pow(
    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
    0.5
  );
}

var touchEvents = [
  'topTouchStart',
  'topTouchCancel',
  'topTouchEnd',
  'topTouchMove'
];

var dependencies = ['topMouseDown', 'topMouseMove', 'topMouseUp'].concat(
  touchEvents
);

var eventTypes = {
  touchTap: {
    phasedRegistrationNames: {
      bubbled: 'onTouchTap',
      captured: 'onTouchTapCapture'
    },
    dependencies: dependencies
  }
};

var usedTouchTime = 0;

// var TapEventPlugin = {
function createTapEventPlugin(shouldRejectClick) {
  return {
    tapMoveThreshold: tapMoveThreshold,

    eventTypes: eventTypes,

    extractEvents: function(
      topLevelType,
      targetInst,
      nativeEvent,
      nativeEventTarget
    ) {
      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
        return null;
      }
      // on ios, there is a delay after touch event and synthetic
      // mouse events, so that user can perform double tap
      // solution: ignore mouse events following touchevent within small timeframe
      if (touchEvents.indexOf(topLevelType) !== -1) {
        usedTouchTime = Date.now();
      } else {
        if (shouldRejectClick(usedTouchTime, Date.now())) {
          return null;
        }
      }
      var event = null;
      var distance = getDistance(startCoords, nativeEvent);
      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
        event = SyntheticEvent.getPooled(
          eventTypes.touchTap,
          targetInst,
          nativeEvent,
          nativeEventTarget
        );
      }
      if (isStartish(topLevelType)) {
        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
      } else if (isEndish(topLevelType)) {
        startCoords.x = 0;
        startCoords.y = 0;
      }
      EventPropagators.accumulateTwoPhaseDispatches(event);
      return event;
    }
  };
}

module.exports = createTapEventPlugin;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

var TouchEventUtils = {
  /**
   * Utility function for common case of extracting out the primary touch from a
   * touch event.
   * - `touchEnd` events usually do not have the `touches` property.
   *   http://stackoverflow.com/questions/3666929/
   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
   *
   * @param {Event} nativeEvent Native event that may or may not be a touch.
   * @return {TouchesObject?} an object with pageX and pageY or null.
   */
  extractSingleTouch: function extractSingleTouch(nativeEvent) {
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;

    return !hasTouches && hasChangedTouches ? changedTouches[0] : hasTouches ? touches[0] : nativeEvent;
  }
};

module.exports = TouchEventUtils;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SyntheticEvent
 */

/* eslint valid-typeof: 0 */



var emptyFunction = __webpack_require__(273);
var invariant = __webpack_require__(272);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';
var EVENT_POOL_SIZE = 10;

var __DEV__ = "production" !== 'production';

if (__DEV__) {
  var warning = __webpack_require__(530);
}

var shouldBeReleasedProperties = [
  'dispatchConfig',
  '_targetInst',
  'nativeEvent',
  'isDefaultPrevented',
  'isPropagationStopped',
  '_dispatchListeners',
  '_dispatchInstances'
];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function(event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(
  dispatchConfig,
  targetInst,
  nativeEvent,
  nativeEventTarget
) {
  if (__DEV__) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (__DEV__) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null
    ? nativeEvent.defaultPrevented
    : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

Object.assign(SyntheticEvent.prototype, {
  preventDefault: function() {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function() {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function() {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function() {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (__DEV__) {
        Object.defineProperty(
          this,
          propName,
          getPooledWarningPropertyDefinition(propName, Interface[propName])
        );
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (__DEV__) {
      Object.defineProperty(
        this,
        'nativeEvent',
        getPooledWarningPropertyDefinition('nativeEvent', null)
      );
      Object.defineProperty(
        this,
        'preventDefault',
        getPooledWarningPropertyDefinition('preventDefault', emptyFunction)
      );
      Object.defineProperty(
        this,
        'stopPropagation',
        getPooledWarningPropertyDefinition('stopPropagation', emptyFunction)
      );
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function(Class, Interface) {
  var Super = this;

  var E = function() {};
  E.prototype = Super.prototype;
  var prototype = new E();

  Object.assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = Object.assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;
  addEventPoolingTo(Class);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (__DEV__) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function(target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function(constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function(target, prop, value) {
            if (
              prop !== 'isPersistent' &&
              !target.constructor.Interface.hasOwnProperty(prop) &&
              shouldBeReleasedProperties.indexOf(prop) === -1
            ) {
              warning(
                didWarnForAddedNewProperty || target.isPersistent(),
                "This synthetic event is reused for performance reasons. If you're " +
                  "seeing this, you're adding a new property in the synthetic event object. " +
                  'The property is never released. See ' +
                  'https://fb.me/react-event-pooling for more information.'
              );
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

addEventPoolingTo(SyntheticEvent);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {String} propName
  * @param {?object} getVal
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction
      ? 'This is a no-op function'
      : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
    warning(
      warningCondition,
      "This synthetic event is reused for performance reasons. If you're seeing this, " +
        "you're %s `%s` on a released/nullified synthetic event. %s. " +
        'If you must keep the original synthetic event around, use event.persist(). ' +
        'See https://fb.me/react-event-pooling for more information.',
      action,
      propName,
      result
    );
  }
}

function getPooledEvent(dispatchConfig, targetInst, nativeEvent, nativeInst) {
  var EventConstructor = this;
  if (EventConstructor.eventPool.length) {
    var instance = EventConstructor.eventPool.pop();
    EventConstructor.call(
      instance,
      dispatchConfig,
      targetInst,
      nativeEvent,
      nativeInst
    );
    return instance;
  }
  return new EventConstructor(
    dispatchConfig,
    targetInst,
    nativeEvent,
    nativeInst
  );
}

function releasePooledEvent(event) {
  var EventConstructor = this;
  invariant(
    event instanceof EventConstructor,
    'Trying to release an event instance  into a pool of a different type.'
  );
  event.destructor();
  if (EventConstructor.eventPool.length < EVENT_POOL_SIZE) {
    EventConstructor.eventPool.push(event);
  }
}

function addEventPoolingTo(EventConstructor) {
  EventConstructor.eventPool = [];
  EventConstructor.getPooled = getPooledEvent;
  EventConstructor.release = releasePooledEvent;
}


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var emptyFunction = __webpack_require__(273);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  (function () {
    var printWarning = function printWarning(format) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function warning(condition, format) {
      if (format === undefined) {
        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
      }

      if (format.indexOf('Failed Composite propType: ') === 0) {
        return; // Ignore CompositeComponent proptype check.
      }

      if (!condition) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        printWarning.apply(undefined, [format].concat(args));
      }
    };
  })();
}

module.exports = warning;

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(181);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(533);
var invariant = __webpack_require__(534);
var ReactPropTypesSecret = __webpack_require__(535);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(551);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(282);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(133);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(544);


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(545);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var root; /* global window */


if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(104), __webpack_require__(105)(module)))

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(280);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(281);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(282);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(283);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(552);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(181);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(184);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(32);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(31);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(182);

var _PathUtils = __webpack_require__(106);

var _createTransitionManager = __webpack_require__(183);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(286);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = (0, _DOMUtils.supportsHistory)();
  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + (0, _PathUtils.createPath)(location);
  };

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createBrowserHistory;

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(184);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (HashRouter);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(32);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(31);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(182);

var _PathUtils = __webpack_require__(106);

var _createTransitionManager = __webpack_require__(183);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

var _DOMUtils = __webpack_require__(286);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: _PathUtils.stripLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  },
  slash: {
    encodePath: _PathUtils.addLeadingSlash,
    decodePath: _PathUtils.addLeadingSlash
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);

    return (0, _LocationUtils.createLocation)(path);
  };

  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
  };

  var push = function push(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = (0, _PathUtils.createPath)(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createHashHistory;

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(558);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(185);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(32);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(106);

var _LocationUtils = __webpack_require__(182);

var _createTransitionManager = __webpack_require__(183);

var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = (0, _createTransitionManager2.default)();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = _PathUtils.createPath;

  var push = function push(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

exports.default = createMemoryHistory;

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(287);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  ariaCurrent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['page', 'step', 'location', 'true'])
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(562)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(564);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(566);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(567);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;


    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(568);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(569);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(570);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(107);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(290);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;


    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;


      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createBrowserHistory);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(290);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;


  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createHashHistory);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(187);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;


  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* unused harmony default export */ var _unused_webpack_default_export = (createMemoryHistory);

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(572);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(185);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;


  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["parsePath"])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["createPath"])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["addLeadingSlash"])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(574);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(186);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(186);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(577);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(289);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', this.props);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
};
Form.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_prefixName__ = __webpack_require__(108);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: Object(__WEBPACK_IMPORTED_MODULE_2__util_prefixName__["a" /* default */])(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children)) {
        return children;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormSection.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* harmony default export */ __webpack_exports__["a"] = (FormSection);

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

exports.default = ExtendableError;
module.exports = exports['default'];


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return formPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fieldInputPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fieldMetaPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fieldArrayMetaPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fieldArrayFieldsPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fieldPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fieldArrayPropTypes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var any = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    bool = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    func = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape,
    string = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType,
    object = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    number = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number;


var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: string
};

var fieldArrayFieldsPropTypes = {
  name: string.isRequired,
  forEach: func.isRequired,
  get: func.isRequired,
  getAll: func.isRequired,
  insert: func.isRequired,
  length: number.isRequired,
  map: func.isRequired,
  move: func.isRequired,
  pop: func.isRequired,
  push: func.isRequired,
  reduce: func.isRequired,
  remove: func.isRequired,
  removeAll: func.isRequired,
  shift: func.isRequired,
  swap: func.isRequired,
  unshift: func.isRequired
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

var fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (formPropTypes);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createField__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createField__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectedField__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_shallowCompare__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_prefixName__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(13);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var createField = function createField(structure) {
  var ConnectedField = Object(__WEBPACK_IMPORTED_MODULE_3__ConnectedField__["a" /* default */])(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Field, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName ||
        // use deepEqual here because they could be a function or an array of functions
        !__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.validate, nextProps.validate) || !__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Field.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    normalize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onDragStart: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    onDrop: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  };
  Field.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  return Field;
};

/* harmony default export */ __webpack_exports__["a"] = (createField);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isReactNative__ = __webpack_require__(300);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onChange(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue);
          } else {
            onChange(event, newValue, previousValue);
          }
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;


        var defaultPrevented = false;
        if (onFocus) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onFocus(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }));
          } else {
            onFocus(event);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onBlur(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue);
          } else {
            onBlur(event, newValue, previousValue);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue);
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */], value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */]);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop']);

        var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, input, custom));
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedField.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedField);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(299);



var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ __webpack_exports__["a"] = (getValue);

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataKey; });
var dataKey = 'text';

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ __webpack_exports__["a"] = (splice);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(135);



var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(591);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(189);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(191);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(602);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(137);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(304);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(597);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(50);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(137);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(137);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(137);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(139);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(139);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(139);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(139);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(140);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(140);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(140);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(140);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(136);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(135);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field), 0);
};

/* harmony default export */ __webpack_exports__["a"] = (setIn);

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === undefined || obj === '';
    var otherIsEmpty = other === null || other === undefined || other === '';
    return objIsEmpty === otherIsEmpty;
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(obj) || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(a, b, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (deepEqual);

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(198);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(138);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(189);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(624);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(629);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(631);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(194);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(51);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(636);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(73);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(73);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(277);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(141)(module)))

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(644);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(279);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(304);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(50);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(50);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(50);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(50);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(135);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field))));
};

/* harmony default export */ __webpack_exports__["a"] = (deleteIn);

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}


/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFields__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFields__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectedFields__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_shallowCompare__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__structure_plain__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(108);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(structure) {
  var ConnectedFields = Object(__WEBPACK_IMPORTED_MODULE_3__ConnectedFields__["a" /* default */])(structure);

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentWillMount',
      value: function componentWillMount() {
        var error = validateNameProp(this.props.names);
        if (error) {
          throw error;
        }
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_5__structure_plain__["a" /* default */].deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    withRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  return Fields;
};

/* harmony default export */ __webpack_exports__["a"] = (createFields);

/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__structure_plain__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__ = __webpack_require__(298);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;


  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error') || __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_Component) {
    _inherits(ConnectedFields, _Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value);
        }
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.refs.renderedComponent;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = 'renderedComponent';
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedFields.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired,
    _fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFields);

/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFieldArray__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFieldArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ConnectedFieldArray__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_prefixName__ = __webpack_require__(108);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = Object(__WEBPACK_IMPORTED_MODULE_3__ConnectedFieldArray__["a" /* default */])(structure);

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_4__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_4__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_4__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : undefined;
      }
    }]);

    return FieldArray;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  FieldArray.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  return FieldArray;
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldArray);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(13);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_Component) {
    _inherits(ConnectedFieldArray, _Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function (val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
            return val !== thisValue[index];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = Object(__WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__["a" /* default */])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  ConnectedFieldArray.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    rerenderOnEveryChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["connect"])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["bindActionCreators"])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFieldArray);

/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(194);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(669);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(315);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(192);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(194);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(110);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(316);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(668);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(110);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(110);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(316);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};


/* harmony default export */ __webpack_exports__["a"] = (createFieldArrayProps);

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);




var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_0_invariant___default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : __WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */].setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFormValueSelector);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValues__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_prefixName__ = __webpack_require__(108);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          var valuesMap = void 0;
          var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
          if (typeof resolvedFirstArg === 'string') {
            valuesMap = [resolvedFirstArg].concat(_toConsumableArray(rest)).map(function (k) {
              return {
                prop: k,
                path: k
              };
            });
          } else {
            var config = resolvedFirstArg;
            valuesMap = Object.keys(config).map(function (k) {
              return {
                prop: k,
                path: config[k]
              };
            });
          }
          if (!valuesMap.length) {
            throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
          }
          var formValuesSelector = function formValuesSelector(_, _ref2) {
            var sectionPrefix = _ref2.sectionPrefix;

            // Yes, we're only using connect() for listening to updates.
            // The second argument needs to be there so that connect calls
            // the selector when props change
            var getValues = _this.context._reduxForm.getValues;

            var props = {};
            var values = getValues();
            valuesMap.forEach(function (_ref3) {
              var prop = _ref3.prop,
                  path = _ref3.path;
              return props[prop] = getIn(values, Object(__WEBPACK_IMPORTED_MODULE_3__util_prefixName__["a" /* default */])(_this.context, path));
            });
            return props;
          };
          _this.Component = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(formValuesSelector, function () {
            return {};
          } // ignore dispatch
          )(function (_ref4) {
            var sectionPrefix = _ref4.sectionPrefix,
                otherProps = _objectWithoutProperties(_ref4, ['sectionPrefix']);

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, otherProps);
          });
          return _this;
        }

        _createClass(FormValues, [{
          key: 'render',
          value: function render() {
            var Component = this.Component;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component
            // so that the connected component updates props when sectionPrefix has changed
            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }]);

        return FormValues;
      }(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

      FormValues.contextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormError = function createGetFormError(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.error');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormError);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;

  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createGetFormNames);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormValues);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormInitialValues);

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncErrors);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormMeta);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormAsyncErrors);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncWarnings);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSubmitErrors);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPristine__ = __webpack_require__(318);



var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = Object(__WEBPACK_IMPORTED_MODULE_0__isPristine__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isPristine(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsDirty);

/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid__ = __webpack_require__(203);



var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_0__isValid__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsInvalid);

/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};


var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ __webpack_exports__["a"] = (createHasError);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isValid__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isValid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsSubmitting);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitSucceeded);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitFailed);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduxForm__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduxForm__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_is_promise__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_redux__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__asyncValidation__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__defaultShouldAsyncValidate__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultShouldValidate__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultShouldError__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultShouldWarn__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__events_silenceEvent__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__events_silenceEvents__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__generateValidator__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__handleSubmit__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__selectors_isValid__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__structure_plain__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_getDisplayName__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_isHotReloading__ = __webpack_require__(739);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

























var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var arrayInsert = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].arrayInsert,
    arrayMove = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].arrayMove,
    arrayPop = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].arrayPop,
    arrayPush = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].arrayPush,
    arrayRemove = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].arrayRemove,
    arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].arrayRemoveAll,
    arrayShift = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].arrayShift,
    arraySplice = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].arraySplice,
    arraySwap = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].arraySwap,
    arrayUnshift = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].arrayUnshift,
    blur = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].blur,
    change = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].change,
    focus = __WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].focus,
    formActions = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */], ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */])), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = Object(__WEBPACK_IMPORTED_MODULE_19__selectors_isValid__["a" /* default */])(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: __WEBPACK_IMPORTED_MODULE_11__defaultShouldAsyncValidate__["a" /* default */],
      shouldValidate: __WEBPACK_IMPORTED_MODULE_12__defaultShouldValidate__["a" /* default */],
      shouldError: __WEBPACK_IMPORTED_MODULE_13__defaultShouldError__["a" /* default */],
      shouldWarn: __WEBPACK_IMPORTED_MODULE_14__defaultShouldWarn__["a" /* default */],
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  _unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                delete _this.fieldValidators[name];
                delete _this.fieldWarners[name];
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? Object(__WEBPACK_IMPORTED_MODULE_17__generateValidator__["a" /* default */])(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? Object(__WEBPACK_IMPORTED_MODULE_17__generateValidator__["a" /* default */])(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;

            var submitting = !name;
            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              var isBlurredField = !submitting && (!asyncBlurFields || ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]')));
              if ((isBlurredField || submitting) && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : 'blur',
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return Object(__WEBPACK_IMPORTED_MODULE_10__asyncValidation__["a" /* default */])(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            return error;
          }, _this.listenToSubmit = function (promise) {
            if (!__WEBPACK_IMPORTED_MODULE_4_is_promise___default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;


            if (!submitOrEvent || Object(__WEBPACK_IMPORTED_MODULE_15__events_silenceEvent__["a" /* default */])(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_18__handleSubmit__["a" /* default */])(checkSubmit(onSubmit), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return Object(__WEBPACK_IMPORTED_MODULE_16__events_silenceEvents__["a" /* default */])(function () {
                return !_this.submitPromise && _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_18__handleSubmit__["a" /* default */])(checkSubmit(submitOrEvent), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  lastInitialValues: this.props.initialValues
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize);
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!__WEBPACK_IMPORTED_MODULE_20__structure_plain__["a" /* default */].deepEqual(lastSyncErrors, nextSyncErrors) || !__WEBPACK_IMPORTED_MODULE_20__structure_plain__["a" /* default */].deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                shouldError = _props3.shouldError,
                validate = _props3.validate,
                values = _props3.values;

            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              };
              var shouldValidateResult = shouldValidate(validateParams);
              var shouldErrorResult = shouldError(validateParams);

              if (shouldValidateResult || shouldErrorResult) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props4 = this.props,
                warning = _props4.warning,
                syncWarnings = _props4.syncWarnings,
                updateSyncWarnings = _props4.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!__WEBPACK_IMPORTED_MODULE_20__structure_plain__["a" /* default */].deepEqual(lastSyncWarnings, nextSyncWarnings) || !__WEBPACK_IMPORTED_MODULE_20__structure_plain__["a" /* default */].deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props5 = this.props,
                shouldValidate = _props5.shouldValidate,
                shouldWarn = _props5.shouldWarn,
                warn = _props5.warn,
                values = _props5.values;

            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              };
              var shouldWarnResult = shouldWarn(validateParams);
              var shouldValidateResult = shouldValidate(validateParams);

              if (shouldValidateResult || shouldWarnResult) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_22__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
            // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608

            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props6 = this.props,
                destroyOnUnmount = _props6.destroyOnUnmount,
                destroy = _props6.destroy;

            if (destroyOnUnmount && !Object(__WEBPACK_IMPORTED_MODULE_22__util_isHotReloading__["a" /* default */])()) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props7 = this.props,
                anyTouched = _props7.anyTouched,
                arrayInsert = _props7.arrayInsert,
                arrayMove = _props7.arrayMove,
                arrayPop = _props7.arrayPop,
                arrayPush = _props7.arrayPush,
                arrayRemove = _props7.arrayRemove,
                arrayRemoveAll = _props7.arrayRemoveAll,
                arrayShift = _props7.arrayShift,
                arraySplice = _props7.arraySplice,
                arraySwap = _props7.arraySwap,
                arrayUnshift = _props7.arrayUnshift,
                asyncErrors = _props7.asyncErrors,
                asyncValidate = _props7.asyncValidate,
                asyncValidating = _props7.asyncValidating,
                blur = _props7.blur,
                change = _props7.change,
                clearSubmit = _props7.clearSubmit,
                destroy = _props7.destroy,
                destroyOnUnmount = _props7.destroyOnUnmount,
                forceUnregisterOnUnmount = _props7.forceUnregisterOnUnmount,
                dirty = _props7.dirty,
                dispatch = _props7.dispatch,
                enableReinitialize = _props7.enableReinitialize,
                error = _props7.error,
                focus = _props7.focus,
                form = _props7.form,
                getFormState = _props7.getFormState,
                initialize = _props7.initialize,
                initialized = _props7.initialized,
                initialValues = _props7.initialValues,
                invalid = _props7.invalid,
                keepDirtyOnReinitialize = _props7.keepDirtyOnReinitialize,
                pristine = _props7.pristine,
                propNamespace = _props7.propNamespace,
                registeredFields = _props7.registeredFields,
                registerField = _props7.registerField,
                reset = _props7.reset,
                setSubmitFailed = _props7.setSubmitFailed,
                setSubmitSucceeded = _props7.setSubmitSucceeded,
                shouldAsyncValidate = _props7.shouldAsyncValidate,
                shouldValidate = _props7.shouldValidate,
                shouldError = _props7.shouldError,
                shouldWarn = _props7.shouldWarn,
                startAsyncValidation = _props7.startAsyncValidation,
                startSubmit = _props7.startSubmit,
                stopAsyncValidation = _props7.stopAsyncValidation,
                stopSubmit = _props7.stopSubmit,
                submitting = _props7.submitting,
                submitFailed = _props7.submitFailed,
                submitSucceeded = _props7.submitSucceeded,
                touch = _props7.touch,
                touchOnBlur = _props7.touchOnBlur,
                touchOnChange = _props7.touchOnChange,
                persistentSubmitErrors = _props7.persistentSubmitErrors,
                syncErrors = _props7.syncErrors,
                syncWarnings = _props7.syncWarnings,
                unregisterField = _props7.unregisterField,
                untouch = _props7.untouch,
                updateSyncErrors = _props7.updateSyncErrors,
                updateSyncWarnings = _props7.updateSyncWarnings,
                valid = _props7.valid,
                validExceptSubmit = _props7.validExceptSubmit,
                values = _props7.values,
                warning = _props7.warning,
                rest = _objectWithoutProperties(_props7, ['anyTouched', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */


            var reduxFormProps = _extends({
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              propsToPass.ref = 'wrapped';
            }
            return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

      Form.displayName = 'Form(' + Object(__WEBPACK_IMPORTED_MODULE_21__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
        forceUnregisterOnUnmount: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
        form: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,
        initialValues: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
        getFormState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
        onSubmitFail: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
        onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
        propNamespace: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
        validate: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
        warn: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
        touchOnBlur: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
        touchOnChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
        triggerSubmit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
        persistentSubmitErrors: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
        registeredFields: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
      };

      var connector = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || {};
        var syncWarnings = getIn(formState, 'syncWarnings') || {};
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(formActions, bindForm);
        var boundArrayACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundArrayACs.arrayInsert, dispatch),
          move: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundArrayACs.arrayMove, dispatch),
          pop: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundArrayACs.arrayPop, dispatch),
          push: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundArrayACs.arrayPush, dispatch),
          remove: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundArrayACs.arrayShift, dispatch),
          splice: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundArrayACs.arraySplice, dispatch),
          swap: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(__WEBPACK_IMPORTED_MODULE_8_redux__["bindActionCreators"])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api

      var ReduxForm = function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this5 = this;

            var _props8 = this.props,
                initialValues = _props8.initialValues,
                rest = _objectWithoutProperties(_props8, ['initialValues']);

            return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(ConnectedForm, _extends({}, rest, {
              ref: function ref(_ref3) {
                return _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.ref && this.ref.getWrappedInstance().refs.wrapped;
          }
        }]);

        return ReduxForm;
      }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

      return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(ReduxForm, WrappedComponent);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createReduxForm);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(724);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(320);







/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__toPlainObject_js__ = __webpack_require__(719);















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = object[key],
      srcValue = source[key],
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_13__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || (srcIndex && Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue))) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(50);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(141)(module)))

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(715);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(308);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(200);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(61);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(73);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(320);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(143);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(109);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(723);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(732);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(728);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(727);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(731);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(202);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(61);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);


var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (errors && Object.keys(errors).length) {
        stop(errors);
        return errors;
      } else if (rejected) {
        stop();
        throw new Error('Asynchronous validation promise was rejected without errors.');
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ __webpack_exports__["a"] = (asyncValidation);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__silenceEvent__ = __webpack_require__(321);


var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__silenceEvent__["a" /* default */])(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvents);

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__structure_plain__ = __webpack_require__(13);



var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = __WEBPACK_IMPORTED_MODULE_0__structure_plain__["a" /* default */].setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (generateValidator);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionError__ = __webpack_require__(296);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;


  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    var errors = _extends({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleSubmit);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

/* harmony default export */ __webpack_exports__["a"] = (isHotReloading);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(141)(module)))

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReducer__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__structure_plain__ = __webpack_require__(13);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length && action.type.substring(0, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length) === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"];
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(structure);
  var plainDeleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */]);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].getIn(slice, field);
    return existing || force ? setIn(state, key, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].setIn(slice, field, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"], function (state, _ref) {
    var _ref$meta = _ref.meta,
        field = _ref$meta.field,
        index = _ref$meta.index,
        payload = _ref.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"], function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        from = _ref2$meta.from,
        to = _ref2$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"], function (state, _ref3) {
    var field = _ref3.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"], function (state, _ref4) {
    var field = _ref4.meta.field,
        payload = _ref4.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"], function (state, _ref5) {
    var _ref5$meta = _ref5.meta,
        field = _ref5$meta.field,
        index = _ref5$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"], function (state, _ref6) {
    var field = _ref6.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"], function (state, _ref7) {
    var field = _ref7.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"], function (state, _ref8) {
    var _ref8$meta = _ref8.meta,
        field = _ref8$meta.field,
        index = _ref8$meta.index,
        removeNum = _ref8$meta.removeNum,
        payload = _ref8.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        indexA = _ref9$meta.indexA,
        indexB = _ref9$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"], function (state, _ref10) {
    var field = _ref10.meta.field,
        payload = _ref10.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"], function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"], function (state, _ref12) {
    var _ref12$meta = _ref12.meta,
        field = _ref12$meta.field,
        touch = _ref12$meta.touch,
        payload = _ref12.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"], function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        persistentSubmitErrors = _ref13$meta.persistentSubmitErrors,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"], function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"], function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"], function (state, _ref14) {
    var field = _ref14.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"], function (state, _ref15) {
    var field = _ref15.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"], function (state, _ref16) {
    var payload = _ref16.payload,
        _ref16$meta = _ref16.meta,
        keepDirty = _ref16$meta.keepDirty,
        keepSubmitSucceeded = _ref16$meta.keepSubmitSucceeded;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');
    var newInitialValues = mapData;

    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        forEach(keys(registeredFields), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        });

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"], function (state, _ref17) {
    var _ref17$payload = _ref17.payload,
        name = _ref17$payload.name,
        type = _ref17$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"], function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"], function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"], function (state, _ref18) {
    var field = _ref18.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"], function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"], function (state, _ref19) {
    var payload = _ref19.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"], function (state, _ref20) {
    var payload = _ref20.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = setIn(result, 'submitSucceeded', true);
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"], function (state, _ref21) {
    var fields = _ref21.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"], function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"], function (state, _ref22) {
    var fields = _ref22.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"], function (state, _ref23) {
    var _ref23$payload = _ref23.payload,
        name = _ref23$payload.name,
        destroyOnUnmount = _ref23$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncErrors, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncWarnings, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"], function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"], function (state, _ref25) {
    var _ref25$payload = _ref25.payload,
        syncErrors = _ref25$payload.syncErrors,
        error = _ref25$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"], function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        syncWarnings = _ref26$payload.syncWarnings,
        warning = _ref26$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"] && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function (reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer
        var form = action && action.meta && action.meta.form;

        if (form) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(135);



function createDeleteInWithCleanUp(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn,
      deleteIn = _ref.deleteIn,
      setIn = _ref.setIn;

  var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
    if (path[path.length - 1] === ']') {
      // array path
      var pathTokens = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(path);
      pathTokens.pop();
      var parent = getIn(state, pathTokens.join('.'));
      return parent ? setIn(state, path) : state;
    }

    var result = state;
    if (getIn(state, path) !== undefined) {
      result = deleteIn(state, path);
    }

    var dotIndex = path.lastIndexOf('.');
    if (dotIndex > 0) {
      var parentPath = path.substring(0, dotIndex);
      if (parentPath[parentPath.length - 1] !== ']') {
        var _parent = getIn(result, parentPath);
        if (deepEqual(_parent, empty)) {
          return deleteInWithCleanUp(result, parentPath);
        }
      }
    }
    return result;
  };

  return deleteInWithCleanUp;
}

/* harmony default export */ __webpack_exports__["a"] = (createDeleteInWithCleanUp);

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValues__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(13);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(15).compose;

exports.__esModule = true;
exports.composeWithDevTools = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
    function() {
      if (arguments.length === 0) return undefined;
      if (typeof arguments[0] === 'object') return compose;
      return compose.apply(null, arguments);
    }
);

exports.devToolsEnhancer = (
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
    window.__REDUX_DEVTOOLS_EXTENSION__ :
    function() { return function(noop) { return noop; } }
);


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.roomTemplateView=exports.roomTemplateList=exports.siteManagerReportView=exports.purchaseReportView=exports.salesView=exports.exportsView=exports.activation=exports.actionConfirmation=exports.supplierList=exports.supplierView=exports.configTemplateView=exports.configTemplateList=exports.apartmentConfigView=exports.purchaseOrderView=exports.purchaseOrderList=exports.customRowView=exports.orderView=exports.orderList=exports.customerOrderView=exports.customerView=exports.apartmentView=exports.productList=exports.productView=exports.files=exports.workerTypeList=exports.workerTypeView=exports.notifications=exports.userList=exports.userView=exports.roomTypeList=exports.roomTypeView=exports.productTypeList=exports.productTypeView=exports.deviationList=exports.deviationView=exports.projectView=exports.projectList=exports.auth=exports.consoleLogErrors=undefined;var _consoleLogErrors=__webpack_require__(748);var _consoleLogErrors2=_interopRequireDefault(_consoleLogErrors);var _auth=__webpack_require__(749);var _auth2=_interopRequireDefault(_auth);var _projectList=__webpack_require__(847);var _projectList2=_interopRequireDefault(_projectList);var _projectView=__webpack_require__(861);var _projectView2=_interopRequireDefault(_projectView);var _deviationView=__webpack_require__(875);var _deviationView2=_interopRequireDefault(_deviationView);var _deviationList=__webpack_require__(876);var _deviationList2=_interopRequireDefault(_deviationList);var _productTypeView=__webpack_require__(877);var _productTypeView2=_interopRequireDefault(_productTypeView);var _productTypeList=__webpack_require__(878);var _productTypeList2=_interopRequireDefault(_productTypeList);var _roomTypeView=__webpack_require__(879);var _roomTypeView2=_interopRequireDefault(_roomTypeView);var _roomTypeList=__webpack_require__(880);var _roomTypeList2=_interopRequireDefault(_roomTypeList);var _userView=__webpack_require__(881);var _userView2=_interopRequireDefault(_userView);var _userList=__webpack_require__(882);var _userList2=_interopRequireDefault(_userList);var _notifications=__webpack_require__(885);var _notifications2=_interopRequireDefault(_notifications);var _workerTypeView=__webpack_require__(887);var _workerTypeView2=_interopRequireDefault(_workerTypeView);var _workerTypeList=__webpack_require__(888);var _workerTypeList2=_interopRequireDefault(_workerTypeList);var _files=__webpack_require__(889);var _files2=_interopRequireDefault(_files);var _productView=__webpack_require__(890);var _productView2=_interopRequireDefault(_productView);var _productList=__webpack_require__(899);var _productList2=_interopRequireDefault(_productList);var _apartmentView=__webpack_require__(900);var _apartmentView2=_interopRequireDefault(_apartmentView);var _customerView=__webpack_require__(901);var _customerView2=_interopRequireDefault(_customerView);var _customerOrderView=__webpack_require__(236);var _customerOrderView2=_interopRequireDefault(_customerOrderView);var _orderList=__webpack_require__(932);var _orderList2=_interopRequireDefault(_orderList);var _orderView=__webpack_require__(395);var _orderView2=_interopRequireDefault(_orderView);var _customRowView=__webpack_require__(933);var _customRowView2=_interopRequireDefault(_customRowView);var _purchaseOrderList=__webpack_require__(934);var _purchaseOrderList2=_interopRequireDefault(_purchaseOrderList);var _purchaseOrderView=__webpack_require__(935);var _purchaseOrderView2=_interopRequireDefault(_purchaseOrderView);var _apartmentConfigView=__webpack_require__(936);var _apartmentConfigView2=_interopRequireDefault(_apartmentConfigView);var _configTemplateList=__webpack_require__(937);var _configTemplateList2=_interopRequireDefault(_configTemplateList);var _configTemplateView=__webpack_require__(124);var _configTemplateView2=_interopRequireDefault(_configTemplateView);var _supplierView=__webpack_require__(938);var _supplierView2=_interopRequireDefault(_supplierView);var _supplierList=__webpack_require__(939);var _supplierList2=_interopRequireDefault(_supplierList);var _actionConfirmation=__webpack_require__(940);var _actionConfirmation2=_interopRequireDefault(_actionConfirmation);var _activation=__webpack_require__(941);var _activation2=_interopRequireDefault(_activation);var _exportsView=__webpack_require__(942);var _exportsView2=_interopRequireDefault(_exportsView);var _salesView=__webpack_require__(944);var _salesView2=_interopRequireDefault(_salesView);var _purchaseReportView=__webpack_require__(945);var _purchaseReportView2=_interopRequireDefault(_purchaseReportView);var _siteManagerReportView=__webpack_require__(946);var _siteManagerReportView2=_interopRequireDefault(_siteManagerReportView);var _roomTemplateList=__webpack_require__(947);var _roomTemplateList2=_interopRequireDefault(_roomTemplateList);var _roomTemplateView=__webpack_require__(948);var _roomTemplateView2=_interopRequireDefault(_roomTemplateView);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.consoleLogErrors=_consoleLogErrors2.default;exports.auth=_auth2.default;exports.projectList=_projectList2.default;exports.projectView=_projectView2.default;exports.deviationView=_deviationView2.default;exports.deviationList=_deviationList2.default;exports.productTypeView=_productTypeView2.default;exports.productTypeList=_productTypeList2.default;exports.roomTypeView=_roomTypeView2.default;exports.roomTypeList=_roomTypeList2.default;exports.userView=_userView2.default;exports.userList=_userList2.default;exports.notifications=_notifications2.default;exports.workerTypeView=_workerTypeView2.default;exports.workerTypeList=_workerTypeList2.default;exports.files=_files2.default;exports.productView=_productView2.default;exports.productList=_productList2.default;exports.apartmentView=_apartmentView2.default;exports.customerView=_customerView2.default;exports.customerOrderView=_customerOrderView2.default;exports.orderList=_orderList2.default;exports.orderView=_orderView2.default;exports.customRowView=_customRowView2.default;exports.purchaseOrderList=_purchaseOrderList2.default;exports.purchaseOrderView=_purchaseOrderView2.default;exports.apartmentConfigView=_apartmentConfigView2.default;exports.configTemplateList=_configTemplateList2.default;exports.configTemplateView=_configTemplateView2.default;exports.supplierView=_supplierView2.default;exports.supplierList=_supplierList2.default;exports.actionConfirmation=_actionConfirmation2.default;exports.activation=_activation2.default;exports.exportsView=_exportsView2.default;exports.salesView=_salesView2.default;exports.purchaseReportView=_purchaseReportView2.default;exports.siteManagerReportView=_siteManagerReportView2.default;exports.roomTemplateList=_roomTemplateList2.default;exports.roomTemplateView=_roomTemplateView2.default;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default= false?function(state,action){if(!!action.error){console.log(action.type,action.error);}return true;}:function(){return false;};

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _auth=__webpack_require__(57);var _jsCookie=__webpack_require__(227);var _jsCookie2=_interopRequireDefault(_jsCookie);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var auth=function auth(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{isFetching:false,isAuthenticated:!!_jsCookie2.default.get('token'),currentUser:null,error:null};var action=arguments[1];switch(action.type){case _auth.LOGIN_REQUEST:return _extends({},state,{isFetching:true,isAuthenticated:false});case _auth.LOGIN_SUCCESS:return{isFetching:false,isAuthenticated:true,error:null};case _auth.LOGIN_FAILURE:return{isFetching:false,isAuthenticated:false,error:action.error};case _auth.LOGOUT_REQUEST:return _extends({},state,{isFetching:true});case _auth.LOGOUT_SUCCESS:return{isFetching:false,isAuthenticated:false,currentUser:null,error:null};case _auth.SELF_REQUEST:return _extends({},state,{currentUser:null,isFetching:true});case _auth.SELF_SUCCESS:return _extends({},state,{isFetching:false,currentUser:action.user,error:null});case _auth.SELF_FAILURE:return _extends({},state,{isFetching:false,currentUser:null,error:action.error});default:return state;}};exports.default=auth;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(751);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 751 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.handleIEBugs=undefined;var _regenerator=__webpack_require__(11);var _regenerator2=_interopRequireDefault(_regenerator);var _getOr2=__webpack_require__(205);var _getOr3=_interopRequireDefault(_getOr2);var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _errors=__webpack_require__(846);var _auth=__webpack_require__(57);var _notification=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/*:: import type {Dispatch} from 'redux';*/var handleError=function handleError(dispatch/*: Dispatch<*>*/){var expectBody/*:: ?: boolean*/=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/_regenerator2.default.mark(function _callee(response/*: Response*/)/*: Promise<any>*/{var contentType,body,isError,message,errors;return _regenerator2.default.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:contentType=response.headers.get('content-type');body=null;isError=!response.ok;if(!(contentType&&contentType.indexOf('application/json')!==-1)){_context.next=9;break;}_context.next=6;return response.json();case 6:body=_context.sent;_context.next=17;break;case 9:if(!(isError&&contentType&&contentType.indexOf('text/plain')!==-1)){_context.next=15;break;}_context.next=12;return response.text();case 12:body=_context.sent;_context.next=17;break;case 15:if(!(expectBody&&response.ok)){_context.next=17;break;}throw new _errors.ValidationError('Ogiltigt svar från servern',[response]);case 17:if(!isError){_context.next=31;break;}message=!!body&&(typeof body==='undefined'?'undefined':_typeof(body))==='object'?(0,_getOr3.default)(body,'message',body):body;dispatch((0,_notification.addNotification)(message,'error'));if(!(response.status===401)){_context.next=25;break;}dispatch((0,_auth.logout)());throw new _errors.UnauthorizedError(message);case 25:if(!(response.status===400)){_context.next=30;break;}errors=!!body&&(typeof body==='undefined'?'undefined':_typeof(body))==='object'?(0,_getOr3.default)([],'errors',body):[];throw new _errors.ValidationError(message,errors);case 30:throw new Error(message);case 31:return _context.abrupt('return',body);case 32:case'end':return _context.stop();}}},_callee,undefined);}));return function(_x2){return _ref.apply(this,arguments);};}();};var handleIEBugs=exports.handleIEBugs=function handleIEBugs(dispatch/*: Dispatch<*>*/){return function(reason/*: any*/)/*: any*/{if(reason&&reason.name==='TypeMismatchError'){dispatch((0,_auth.logout)());throw new _errors.UnauthorizedError('Obehörig åtkomst');}else if(reason&&reason instanceof Error){throw reason;}else{throw new Error(reason);}};};exports.default=handleError;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(754),
    fallbackHolder = __webpack_require__(1);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var defaultHolder = isLib ? func : fallbackHolder,
      forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;

    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 754 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(756),
  'assign': __webpack_require__(338),
  'clone': __webpack_require__(785),
  'curry': __webpack_require__(824),
  'forEach': __webpack_require__(148),
  'isArray': __webpack_require__(18),
  'isError': __webpack_require__(825),
  'isFunction': __webpack_require__(52),
  'isWeakMap': __webpack_require__(826),
  'iteratee': __webpack_require__(827),
  'keys': __webpack_require__(215),
  'rearg': __webpack_require__(843),
  'toInteger': __webpack_require__(58),
  'toPath': __webpack_require__(845)
};


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(144);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(52),
    isMasked = __webpack_require__(760),
    isObject = __webpack_require__(45),
    toSource = __webpack_require__(326);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 759 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(761);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(36);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 762 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(145),
    root = __webpack_require__(36);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(147),
    createCtor = __webpack_require__(145),
    createHybrid = __webpack_require__(327),
    createRecurry = __webpack_require__(330),
    getHolder = __webpack_require__(212),
    replaceHolders = __webpack_require__(150),
    root = __webpack_require__(36);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 765 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 766 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(206),
    LodashWrapper = __webpack_require__(210),
    baseLodash = __webpack_require__(207),
    isArray = __webpack_require__(18),
    isObjectLike = __webpack_require__(33),
    wrapperClone = __webpack_require__(768);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(206),
    LodashWrapper = __webpack_require__(210),
    copyArray = __webpack_require__(111);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 769 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 770 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(772),
    defineProperty = __webpack_require__(336),
    identity = __webpack_require__(62);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 772 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(148),
    arrayIncludes = __webpack_require__(149);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 774 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 775 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(111),
    isIndex = __webpack_require__(113);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(147),
    createCtor = __webpack_require__(145),
    root = __webpack_require__(36);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(328),
    composeArgsRight = __webpack_require__(329),
    replaceHolders = __webpack_require__(150);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(151);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 780 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 782 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isLength = __webpack_require__(214),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(340);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(155);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 786 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(158);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(158);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(158);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(158);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(157);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 792 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 793 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(157),
    Map = __webpack_require__(216),
    MapCache = __webpack_require__(217);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(797),
    ListCache = __webpack_require__(157),
    Map = __webpack_require__(216);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(798),
    hashDelete = __webpack_require__(799),
    hashGet = __webpack_require__(800),
    hashHas = __webpack_require__(801),
    hashSet = __webpack_require__(802);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 799 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(159);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 804 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(160);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(94),
    keysIn = __webpack_require__(161);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(45),
    isPrototype = __webpack_require__(154),
    nativeKeysIn = __webpack_require__(810);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 810 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(94),
    getSymbols = __webpack_require__(218);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(94),
    getSymbolsIn = __webpack_require__(343);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75),
    root = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(75),
    root = __webpack_require__(36);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 815 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(223),
    cloneDataView = __webpack_require__(817),
    cloneRegExp = __webpack_require__(818),
    cloneSymbol = __webpack_require__(819),
    cloneTypedArray = __webpack_require__(348);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(223);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 818 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(821),
    baseUnary = __webpack_require__(63),
    nodeUtil = __webpack_require__(153);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(77),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(823),
    baseUnary = __webpack_require__(63),
    nodeUtil = __webpack_require__(153);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(77),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(144);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isObjectLike = __webpack_require__(33),
    isPlainObject = __webpack_require__(224);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(77),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(155),
    baseIteratee = __webpack_require__(24);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(829),
    getMatchData = __webpack_require__(835),
    matchesStrictComparable = __webpack_require__(354);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(156),
    baseIsEqual = __webpack_require__(162);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(156),
    equalArrays = __webpack_require__(350),
    equalByTag = __webpack_require__(833),
    equalObjects = __webpack_require__(834),
    getTag = __webpack_require__(77),
    isArray = __webpack_require__(18),
    isBuffer = __webpack_require__(116),
    isTypedArray = __webpack_require__(152);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 831 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 832 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93),
    Uint8Array = __webpack_require__(347),
    eq = __webpack_require__(114),
    equalArrays = __webpack_require__(350),
    mapToArray = __webpack_require__(352),
    setToArray = __webpack_require__(225);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(344);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(353),
    keys = __webpack_require__(59);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(162),
    get = __webpack_require__(96),
    hasIn = __webpack_require__(356),
    isKey = __webpack_require__(226),
    isStrictComparable = __webpack_require__(353),
    matchesStrictComparable = __webpack_require__(354),
    toKey = __webpack_require__(64);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(838);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(217);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 839 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(841),
    basePropertyDeep = __webpack_require__(842),
    isKey = __webpack_require__(226),
    toKey = __webpack_require__(64);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 841 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(165);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(144),
    flatRest = __webpack_require__(118);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(93),
    isArguments = __webpack_require__(115),
    isArray = __webpack_require__(18);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(46),
    copyArray = __webpack_require__(111),
    isArray = __webpack_require__(18),
    isSymbol = __webpack_require__(76),
    stringToPath = __webpack_require__(355),
    toKey = __webpack_require__(64),
    toString = __webpack_require__(79);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});function _extendableBuiltin3(cls){function ExtendableBuiltin(){var instance=Reflect.construct(cls,Array.from(arguments));Object.setPrototypeOf(instance,Object.getPrototypeOf(this));return instance;}ExtendableBuiltin.prototype=Object.create(cls.prototype,{constructor:{value:cls,enumerable:false,writable:true,configurable:true}});if(Object.setPrototypeOf){Object.setPrototypeOf(ExtendableBuiltin,cls);}else{ExtendableBuiltin.__proto__=cls;}return ExtendableBuiltin;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _extendableBuiltin(cls){function ExtendableBuiltin(){var instance=Reflect.construct(cls,Array.from(arguments));Object.setPrototypeOf(instance,Object.getPrototypeOf(this));return instance;}ExtendableBuiltin.prototype=Object.create(cls.prototype,{constructor:{value:cls,enumerable:false,writable:true,configurable:true}});if(Object.setPrototypeOf){Object.setPrototypeOf(ExtendableBuiltin,cls);}else{ExtendableBuiltin.__proto__=cls;}return ExtendableBuiltin;}var UnauthorizedError=exports.UnauthorizedError=function(_extendableBuiltin2){_inherits(UnauthorizedError,_extendableBuiltin2);function UnauthorizedError(){_classCallCheck(this,UnauthorizedError);return _possibleConstructorReturn(this,(UnauthorizedError.__proto__||Object.getPrototypeOf(UnauthorizedError)).apply(this,arguments));}return UnauthorizedError;}(_extendableBuiltin(Error));var ValidationError=exports.ValidationError=function(_extendableBuiltin4){_inherits(ValidationError,_extendableBuiltin4);function ValidationError(message){var errors=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];_classCallCheck(this,ValidationError);var _this2=_possibleConstructorReturn(this,(ValidationError.__proto__||Object.getPrototypeOf(ValidationError)).call(this,message));_this2.errors=errors;return _this2;}return ValidationError;}(_extendableBuiltin3(Error));

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _includes2=__webpack_require__(97);var _includes3=_interopRequireDefault(_includes2);var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _toLower2=__webpack_require__(65);var _toLower3=_interopRequireDefault(_toLower2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _projectList=__webpack_require__(228);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _projectList.GET_FAILURE:return action.error;case _projectList.GET_REQUEST:case _projectList.GET_SUCCESS:return null;default:return state;}};var archived=function archived(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _projectList.FILTER:return action.archived;default:return state;}};var query=function query(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _projectList.FILTER:return action.query;default:return state;}};var filter=(0,_redux.combineReducers)({archived:archived,query:query});var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _projectList.GET_REQUEST:return true;case _projectList.GET_FAILURE:case _projectList.GET_SUCCESS:return false;default:return state;}};var projects=function projects(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _projectList.GET_SUCCESS:return action.projects;default:return state;}};var notArchived=(0,_filter3.default)({archived:null});var isArchived=(0,_filter3.default)(function(p){return(0,_isString3.default)(p.archived);});var filterQuery=function filterQuery(_ref){var query=_ref.query;query=(0,_toLower3.default)(query||'');return(0,_isEmpty3.default)(query)?_identity3.default:(0,_filter3.default)(function(p){return(0,_includes3.default)(query,(0,_toLower3.default)(p.name));});};var filteredList=function filteredList(){var _ref2=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},filter=_ref2.filter,projects=_ref2.projects,sorter=_ref2.sorter,filtered=_ref2.filteredList;var action=arguments[1];switch(action.type){case _projectList.GET_SUCCESS:case _projectList.FILTER:case _projectList.SORT:return(0,_flow3.default)(filter.archived?isArchived:notArchived,filterQuery(filter),sorter)(projects);default:return filtered;}};var importError=function importError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _projectList.IMPORT_FAILURE:return action.error;case _projectList.IMPORT_SUCCESS:case _projectList.TOGGLE_IMPORT_DIALOG:return null;default:return state;}};var importIsFetching=function importIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _projectList.IMPORT_REQUEST:return true;case _projectList.IMPORT_FAILURE:case _projectList.IMPORT_SUCCESS:case _projectList.TOGGLE_IMPORT_DIALOG:return false;default:return state;}};var show=function show(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _projectList.TOGGLE_IMPORT_DIALOG:return!!action.show;default:return state;}};var tempUploadId=function tempUploadId(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _projectList.UPLOAD_FILE:return action.tempId;case _projectList.ABORT_FILE_UPLOAD:case _projectList.FILE_UPLOADED:case _projectList.REMOVE_FILE:case _projectList.TOGGLE_IMPORT_DIALOG:return null;default:return state;}};var uploadedFile=function uploadedFile(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _projectList.FILE_UPLOADED:return action.metadata;case _projectList.REMOVE_FILE:case _projectList.TOGGLE_IMPORT_DIALOG:case _projectList.UPLOAD_FILE:return null;default:return state;}};var imported=(0,_redux.combineReducers)({error:importError,isFetching:importIsFetching,show:show,tempUploadId:tempUploadId,uploadedFile:uploadedFile});var sorter=function sorter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_identity3.default;var action=arguments[1];switch(action.type){case _projectList.SORT:return action.sorter;default:return state;}};var reducers=(0,_redux.combineReducers)({error:error,filter:filter,imported:imported,isFetching:isFetching,projects:projects,sorter:sorter,filteredList:function filteredList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return state;}});var projectList=function projectList(state,action){var newState=reducers(state,action);return _extends({},newState,{filteredList:filteredList(newState,action)});};exports.default=projectList;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(849);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(210),
    flatRest = __webpack_require__(118),
    getData = __webpack_require__(208),
    getFuncName = __webpack_require__(332),
    isArray = __webpack_require__(18),
    isLaziable = __webpack_require__(331);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(112),
    isArrayLike = __webpack_require__(60),
    isString = __webpack_require__(360),
    toInteger = __webpack_require__(58),
    values = __webpack_require__(361);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(46);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(215),
    getTag = __webpack_require__(77),
    isArguments = __webpack_require__(115),
    isArray = __webpack_require__(18),
    isArrayLike = __webpack_require__(60),
    isBuffer = __webpack_require__(116),
    isPrototype = __webpack_require__(154),
    isTypedArray = __webpack_require__(152);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(79);

/**
 * Converts `string`, as a whole, to lower case just like
 * [String#toLowerCase](https://mdn.io/toLowerCase).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the lower cased string.
 * @example
 *
 * _.toLower('--Foo-Bar--');
 * // => '--foo-bar--'
 *
 * _.toLower('fooBar');
 * // => 'foobar'
 *
 * _.toLower('__FOO_BAR__');
 * // => '__foo_bar__'
 */
function toLower(value) {
  return toString(value).toLowerCase();
}

module.exports = toLower;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(219),
    baseFilter = __webpack_require__(362),
    baseIteratee = __webpack_require__(24),
    isArray = __webpack_require__(18);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 855 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(60);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(148),
    baseEach = __webpack_require__(80),
    castFunction = __webpack_require__(858),
    isArray = __webpack_require__(18);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(62);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(365);
var bytesToUuid = __webpack_require__(366);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

// random #'s we need to init node and clockseq
var _seedBytes = rng();

// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
var _nodeId = [
  _seedBytes[0] | 0x01,
  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
];

// Per 4.2.2, randomize (14 bit) clockseq
var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;

// Previous uuid creation time
var _lastMSecs = 0, _lastNSecs = 0;

// See https://github.com/broofa/node-uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};

  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  var node = options.node || _nodeId;
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(365);
var bytesToUuid = __webpack_require__(366);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options == 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _includes2=__webpack_require__(97);var _includes3=_interopRequireDefault(_includes2);var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _toLower2=__webpack_require__(65);var _toLower3=_interopRequireDefault(_toLower2);var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _mapValues2=__webpack_require__(66);var _mapValues3=_interopRequireDefault(_mapValues2);var _omitBy2=__webpack_require__(230);var _omitBy3=_interopRequireDefault(_omitBy2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _uniq2=__webpack_require__(231);var _uniq3=_interopRequireDefault(_uniq2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _flatMap2=__webpack_require__(54);var _flatMap3=_interopRequireDefault(_flatMap2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _projectView=__webpack_require__(234);var _form=__webpack_require__(17);var _redux=__webpack_require__(15);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var defaultProjectState={isFetching:false,active:null,apartments:[],apartmentConfigurations:[],error:null,files:{},roomTypeImages:[]};var project=function project(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultProjectState;var action=arguments[1];switch(action.type){case _projectView.PROJECT_GET_REQUEST:return _extends({},state,{isFetching:true,active:null,error:null,apartments:defaultProjectState.apartments,apartmentConfigurations:defaultProjectState.apartmentConfigurations});case _projectView.PROJECT_GET_SUCCESS:return _extends({},state,{isFetching:false,active:action.project,apartments:action.apartments,apartmentConfigurations:action.apartmentConfigurations,files:{coverImage:action.project.coverImage,brochure:action.project.brochure},roomTypeImages:action.project.images,error:null});case _projectView.ACTIVATION_REQUEST:return _extends({},state,{isFetching:true,error:null});case _projectView.ACTIVATION_SUCCESS:return _extends({},state,{isFetching:false,error:null});case _projectView.ACTIVATION_FAILURE:case _projectView.PROJECT_GET_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _projectView.PROJECT_CREATE_REQUEST:return _extends({},state,{isFetching:true,error:null});case _projectView.PROJECT_CREATE_SUCCESS:return _extends({},state,{isFetching:false,error:null,active:action.project,files:{coverImage:action.project.coverImage,brochure:action.project.brochure},roomTypeImages:action.project.images});case _projectView.PROJECT_CREATE_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _projectView.PROJECT_UPDATE_REQUEST:return _extends({},state,{isFetching:true,error:null});case _projectView.PROJECT_UPDATE_SUCCESS:return _extends({},state,{isFetching:false,active:action.project,files:{coverImage:action.project.coverImage,brochure:action.project.brochure},roomTypeImages:action.project.images,error:null});case _projectView.PROJECT_UPDATE_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _projectView.REMOVE_PROJECT_FILE:return _extends({},state,{files:_extends({},state.files,_defineProperty({},action.name,null))});case _projectView.ADD_PROJECT_FILE:return _extends({},state,{files:_extends({},state.files,_defineProperty({},action.name,action.metadata))});case _projectView.ADD_ROOM_TYPE_IMAGE:return _extends({},state,{roomTypeImages:[].concat(_toConsumableArray(state.roomTypeImages),[_extends({roomTypeId:action.roomTypeId},action.metadata)])});case _projectView.REMOVE_ROOM_TYPE_IMAGE:return _extends({},state,{roomTypeImages:(0,_filter3.default)(function(i){return i.id!==action.fileId;},state.roomTypeImages)});case _projectView.RESET:return _extends({},state,{files:state.active?{coverImage:state.active.coverImage,brochure:state.active.brochure}:{},roomTypeImages:state.active?state.active.images:[]});case _projectView.CLEAR:return _extends({},defaultProjectState,{apartments:state.apartments,apartmentConfigurations:state.apartmentConfigurations});default:return state;}};var defaultProductsState={isFetching:false,error:null,list:[]};var products=function products(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultProductsState;var action=arguments[1];switch(action.type){case _projectView.PRODUCTS_REQUEST:return _extends({},state,{isFetching:true,error:null,list:[]});case _projectView.PRODUCTS_SUCCESS:return _extends({},state,{isFetching:false,error:null,list:action.products});case _projectView.PRODUCTS_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _projectView.CLEAR:return defaultProductsState;default:return state;}};var getRoomTypeIds=(0,_flow3.default)((0,_flatMap3.default)('rooms'),(0,_map3.default)('roomTypeId'),_uniq3.default);var filteredRoomTypes=function filteredRoomTypes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var apartmentConfigurations=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var roomTypes=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var action=arguments[3];switch(action.type){case _projectView.PROJECT_GET_SUCCESS:case _projectView.ROOM_TYPES_SUCCESS:var roomTypeIds=getRoomTypeIds(apartmentConfigurations);return(0,_filter3.default)(function(t){return(0,_some3.default)(function(id){return id===t.id;},roomTypeIds);},roomTypes);case _projectView.ROOM_TYPES_REQUEST:case _projectView.CLEAR:return[];default:return state;}};var defaultRoomTypesState={isFetching:false,error:null,list:[]};var roomTypes=function roomTypes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultRoomTypesState;var action=arguments[1];switch(action.type){case _projectView.ROOM_TYPES_REQUEST:return _extends({},state,{isFetching:true,error:null,list:[]});case _projectView.ROOM_TYPES_SUCCESS:return _extends({},state,{isFetching:false,error:null,list:action.roomTypes});case _projectView.ROOM_TYPES_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _projectView.CLEAR:return defaultRoomTypesState;default:return state;}};var defaultRoomTypeState={active:null};var roomType=function roomType(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultRoomTypeState;var action=arguments[1];switch(action.type){case _projectView.SET_ACTIVE_ROOM_TYPE:return _extends({},state,{active:action.roomType});case _projectView.CLEAR:return defaultRoomTypeState;default:return state;}};var defaultUploadIdsState={projectFiles:{},roomTypeImages:{}};var uploadIds=function uploadIds(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultUploadIdsState;var action=arguments[1];switch(action.type){case _projectView.UPLOAD_PROJECT_FILE:return _extends({},state,{projectFiles:_extends({},state.projectFiles,_defineProperty({},action.name,action.tempId))});case _projectView.UPLOAD_ROOM_TYPE_IMAGE:var existing=state.roomTypeImages[action.roomTypeId]||[];return _extends({},state,{roomTypeImages:_extends({},state.roomTypeImages,_defineProperty({},action.roomTypeId,[].concat(_toConsumableArray(existing),[action.tempId])))});case _projectView.ABORT_FILE_UPLOAD:return _extends({},state,{projectFiles:(0,_omitBy3.default)(function(u){return u===action.tempId;},state.projectFiles),roomTypeImages:(0,_mapValues3.default)((0,_filter3.default)(function(u){return u!==action.tempId;}),state.roomTypeImages)});case _projectView.CLEAR:return defaultUploadIdsState;default:return state;}};var defaultApartmentsFilterState={query:'',sorter:_identity3.default};var apartmentsFilter=function apartmentsFilter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultApartmentsFilterState;var action=arguments[1];switch(action.type){case _projectView.FILTER_APARTMENTS:return _extends({},state,{query:action.query||''});case _projectView.SORT:return _extends({},state,{sorter:action.sorter});default:return state;}};var isDirty=function isDirty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _form.SET_DIRTY:return action.form==='project'?action.dirty:state;case _projectView.PROJECT_GET_SUCCESS:case _projectView.PROJECT_CREATE_SUCCESS:case _projectView.PROJECT_UPDATE_SUCCESS:case _projectView.CLEAR:return false;default:return state;}};var filterQuery=function filterQuery(query){query=(0,_toLower3.default)(query||'');return(0,_isEmpty3.default)(query)?_identity3.default:(0,_filter3.default)(function(x){return(0,_includes3.default)(query,(0,_toLower3.default)(x.objectId))||(0,_includes3.default)(query,(0,_toLower3.default)(x.area))||(0,_includes3.default)(query,(0,_toLower3.default)(x.address));});};var filteredApartments=function filteredApartments(_ref,action){var _ref$apartmentsFilter=_ref.apartmentsFilter,query=_ref$apartmentsFilter.query,sorter=_ref$apartmentsFilter.sorter,apartments=_ref.project.apartments;return(0,_flow3.default)(filterQuery(query),sorter)(apartments);};var reducers=(0,_redux.combineReducers)({project:project,products:products,roomTypes:roomTypes,filteredRoomTypes:function filteredRoomTypes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return state;},filteredApartments:function filteredApartments(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return state;},roomType:roomType,uploadIds:uploadIds,apartmentsFilter:apartmentsFilter,isDirty:isDirty});var projectView=function projectView(){var state/*: any*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action/*: any*/=arguments[1];var newState=reducers(state,action);return _extends({},newState,{filteredRoomTypes:filteredRoomTypes(newState.filteredRoomTypes,newState.project.apartmentConfigurations,newState.roomTypes.list,action),filteredApartments:filteredApartments(newState,action)});};exports.default=projectView;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(95),
    baseForOwn = __webpack_require__(363),
    baseIteratee = __webpack_require__(24);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(24),
    negate = __webpack_require__(368),
    pickBy = __webpack_require__(369);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(213),
    castPath = __webpack_require__(78),
    isIndex = __webpack_require__(113),
    isObject = __webpack_require__(45),
    toKey = __webpack_require__(64);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(351),
    baseIteratee = __webpack_require__(24),
    baseSome = __webpack_require__(866),
    isArray = __webpack_require__(18),
    isIterateeCall = __webpack_require__(98);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(80);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(232);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(346),
    noop = __webpack_require__(209),
    setToArray = __webpack_require__(225);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(119),
    map = __webpack_require__(371);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('flatten', __webpack_require__(358), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(119),
    baseOrderBy = __webpack_require__(373),
    baseRest = __webpack_require__(83),
    isIterateeCall = __webpack_require__(98);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 872 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(874);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(76);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _redux=__webpack_require__(15);var _deviationView=__webpack_require__(374);var _form=__webpack_require__(17);var active=function active(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _deviationView.GET_SUCCESS:case _deviationView.UPDATE_SUCCESS:case _deviationView.CREATE_SUCCESS:return action.deviation;case _deviationView.GET_REQUEST:case _deviationView.CLEAR:return null;default:return state;}};var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _deviationView.GET_REQUEST:case _deviationView.UPDATE_REQUEST:case _deviationView.CREATE_REQUEST:return true;case _deviationView.GET_SUCCESS:case _deviationView.GET_FAILURE:case _deviationView.UPDATE_SUCCESS:case _deviationView.UPDATE_FAILURE:case _deviationView.CREATE_SUCCESS:case _deviationView.CREATE_FAILURE:case _deviationView.CLEAR:return false;default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _deviationView.GET_FAILURE:case _deviationView.UPDATE_FAILURE:case _deviationView.CREATE_FAILURE:return action.error;case _deviationView.GET_REQUEST:case _deviationView.GET_SUCCESS:case _deviationView.UPDATE_REQUEST:case _deviationView.UPDATE_SUCCESS:case _deviationView.CREATE_REQUEST:case _deviationView.CREATE_SUCCESS:case _deviationView.CLEAR:return null;default:return state;}};var isDirty=function isDirty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _form.SET_DIRTY:return action.form==='deviation'?action.dirty:state;case _deviationView.GET_SUCCESS:case _deviationView.UPDATE_SUCCESS:case _deviationView.CREATE_SUCCESS:case _deviationView.CLEAR:return false;default:return state;}};var deviationView=(0,_redux.combineReducers)({active:active,error:error,isDirty:isDirty,isFetching:isFetching});exports.default=deviationView;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _deviationList=__webpack_require__(375);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultState={isFetching:false,deviations:[],error:null,filteredList:[],filter:{archived:false,query:null},sorter:_identity3.default};var isArchived=(0,_filter3.default)(function(s){return(0,_isString3.default)(s.archived);});var notArchived=(0,_filter3.default)({archived:null});var deviationsList=function deviationsList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case _deviationList.GET_REQUEST:return _extends({},state,{isFetching:true,error:null});case _deviationList.GET_SUCCESS:return _extends({},state,{filteredList:(0,_flow3.default)(state.filter.archived?isArchived:notArchived,state.sorter)(action.deviations),isFetching:false,deviations:action.deviations,error:null});case _deviationList.GET_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _deviationList.FILTER:return _extends({},state,{filteredList:(0,_flow3.default)(action.archived?isArchived:notArchived,state.sorter)(state.deviations),filter:{archived:action.archived,query:action.query}});case _deviationList.SORT:return _extends({},state,{sorter:action.sorter,filteredList:(0,_flow3.default)(state.filter.archived?isArchived:notArchived,action.sorter)(state.deviations)});default:return state;}};exports.default=deviationsList;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _redux=__webpack_require__(15);var _productTypeView=__webpack_require__(376);var _form=__webpack_require__(17);var active=function active(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productTypeView.GET_SUCCESS:case _productTypeView.UPDATE_SUCCESS:case _productTypeView.CREATE_SUCCESS:return action.productType;case _productTypeView.GET_REQUEST:case _productTypeView.CLEAR:return null;default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productTypeView.GET_FAILURE:case _productTypeView.UPDATE_FAILURE:case _productTypeView.CREATE_FAILURE:return action.error;case _productTypeView.GET_REQUEST:case _productTypeView.GET_SUCCESS:case _productTypeView.UPDATE_REQUEST:case _productTypeView.UPDATE_SUCCESS:case _productTypeView.CREATE_REQUEST:case _productTypeView.CREATE_SUCCESS:return null;default:return state;}};var isDirty=function isDirty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _form.SET_DIRTY:return action.form==='productType'?action.dirty:state;case _productTypeView.GET_SUCCESS:case _productTypeView.UPDATE_SUCCESS:case _productTypeView.CREATE_SUCCESS:case _productTypeView.CLEAR:return false;default:return state;}};var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _productTypeView.GET_REQUEST:case _productTypeView.UPDATE_REQUEST:case _productTypeView.CREATE_REQUEST:return true;case _productTypeView.GET_SUCCESS:case _productTypeView.GET_FAILURE:case _productTypeView.UPDATE_SUCCESS:case _productTypeView.UPDATE_FAILURE:case _productTypeView.CREATE_SUCCESS:case _productTypeView.CREATE_FAILURE:return false;default:return state;}};var productTypeView=(0,_redux.combineReducers)({active:active,error:error,isDirty:isDirty,isFetching:isFetching});exports.default=productTypeView;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _productTypeList=__webpack_require__(377);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productTypeList.REQUEST:case _productTypeList.SUCCESS:return null;case _productTypeList.FAILURE:return action.error;default:return state;}};var archived=function archived(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _productTypeList.FILTER:return action.archived;default:return state;}};var query=function query(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productTypeList.FILTER:return action.query;default:return state;}};var filter=(0,_redux.combineReducers)({archived:archived,query:query});var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _productTypeList.REQUEST:return true;case _productTypeList.SUCCESS:case _productTypeList.FAILURE:return false;default:return state;}};var list=function list(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _productTypeList.SUCCESS:return action.productTypes;default:return state;}};var isArchived=(0,_filter3.default)(function(t){return(0,_isString3.default)(t.archived);});var notArchived=(0,_filter3.default)({archived:null});var filteredList=function filteredList(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},archived=_ref.filter.archived,list=_ref.list,filtered=_ref.filteredList,sorter=_ref.sorter;var action=arguments[1];switch(action.type){case _productTypeList.SUCCESS:case _productTypeList.FILTER:case _productTypeList.SORT:return(0,_flow3.default)(archived?isArchived:notArchived,sorter)(list);default:return filtered;}};var sorter=function sorter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_identity3.default;var action=arguments[1];switch(action.type){case _productTypeList.SORT:return action.sorter;default:return state;}};var reducers=(0,_redux.combineReducers)({filteredList:function filteredList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return state;},error:error,filter:filter,isFetching:isFetching,list:list,sorter:sorter});var productTypeList=function productTypeList(state,action){var newState=reducers(state,action);return _extends({},newState,{filteredList:filteredList(newState,action)});};exports.default=productTypeList;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _redux=__webpack_require__(15);var _roomTypeView=__webpack_require__(378);var _form=__webpack_require__(17);var active=function active(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _roomTypeView.GET_SUCCESS:case _roomTypeView.UPDATE_SUCCESS:case _roomTypeView.CREATE_SUCCESS:return action.roomType;case _roomTypeView.GET_REQUEST:case _roomTypeView.CLEAR:return null;default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _roomTypeView.GET_FAILURE:case _roomTypeView.UPDATE_FAILURE:case _roomTypeView.CREATE_FAILURE:return action.error;case _roomTypeView.GET_REQUEST:case _roomTypeView.GET_SUCCESS:case _roomTypeView.UPDATE_REQUEST:case _roomTypeView.UPDATE_SUCCESS:case _roomTypeView.CREATE_REQUEST:case _roomTypeView.CREATE_SUCCESS:return null;default:return state;}};var isDirty=function isDirty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _form.SET_DIRTY:return action.form==='roomType'?action.dirty:state;case _roomTypeView.GET_SUCCESS:case _roomTypeView.UPDATE_SUCCESS:case _roomTypeView.CREATE_SUCCESS:case _roomTypeView.CLEAR:return false;default:return state;}};var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _roomTypeView.GET_REQUEST:case _roomTypeView.UPDATE_REQUEST:case _roomTypeView.CREATE_REQUEST:return true;case _roomTypeView.GET_SUCCESS:case _roomTypeView.GET_FAILURE:case _roomTypeView.UPDATE_SUCCESS:case _roomTypeView.UPDATE_FAILURE:case _roomTypeView.CREATE_SUCCESS:case _roomTypeView.CREATE_FAILURE:return false;default:return state;}};var roomTypeView=(0,_redux.combineReducers)({active:active,error:error,isDirty:isDirty,isFetching:isFetching});exports.default=roomTypeView;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _roomTypeList=__webpack_require__(379);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _roomTypeList.REQUEST:case _roomTypeList.SUCCESS:return null;case _roomTypeList.FAILURE:return action.error;default:return state;}};var archived=function archived(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _roomTypeList.FILTER:return action.archived;default:return state;}};var query=function query(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _roomTypeList.FILTER:return action.query;default:return state;}};var filter=(0,_redux.combineReducers)({archived:archived,query:query});var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _roomTypeList.REQUEST:return true;case _roomTypeList.SUCCESS:case _roomTypeList.FAILURE:return false;default:return state;}};var list=function list(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _roomTypeList.SUCCESS:return action.roomTypes;default:return state;}};var isArchived=(0,_filter3.default)(function(t){return(0,_isString3.default)(t.archived);});var notArchived=(0,_filter3.default)({archived:null});var filteredList=function filteredList(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},archived=_ref.filter.archived,list=_ref.list,filtered=_ref.filteredList,sorter=_ref.sorter;var action=arguments[1];switch(action.type){case _roomTypeList.SUCCESS:case _roomTypeList.FILTER:case _roomTypeList.SORT:return(0,_flow3.default)(archived?isArchived:notArchived,sorter)(list);default:return filtered;}};var sorter=function sorter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_identity3.default;var action=arguments[1];switch(action.type){case _roomTypeList.SORT:return action.sorter;default:return state;}};var reducers=(0,_redux.combineReducers)({filteredList:function filteredList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return state;},error:error,filter:filter,isFetching:isFetching,list:list,sorter:sorter});var roomTypeList=function roomTypeList(state,action){var newState=reducers(state,action);return _extends({},newState,{filteredList:filteredList(newState,action)});};exports.default=roomTypeList;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _redux=__webpack_require__(15);var _userView=__webpack_require__(380);var _form=__webpack_require__(17);var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _userView.GET_REQUEST:case _userView.UPDATE_REQUEST:case _userView.CREATE_REQUEST:case _userView.ACTIVATION_REQUEST:return true;case _userView.GET_SUCCESS:case _userView.GET_FAILURE:case _userView.UPDATE_SUCCESS:case _userView.UPDATE_FAILURE:case _userView.CREATE_SUCCESS:case _userView.CREATE_FAILURE:case _userView.ACTIVATION_SUCCESS:case _userView.ACTIVATION_FAILURE:return false;default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _userView.GET_FAILURE:case _userView.UPDATE_FAILURE:case _userView.CREATE_FAILURE:case _userView.ACTIVATION_FAILURE:return action.error;case _userView.GET_REQUEST:case _userView.GET_SUCCESS:case _userView.UPDATE_REQUEST:case _userView.UPDATE_SUCCESS:case _userView.CREATE_REQUEST:case _userView.CREATE_SUCCESS:case _userView.ACTIVATION_REQUEST:case _userView.ACTIVATION_SUCCESS:case _userView.CLEAR:return null;default:return state;}};var active=function active(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _userView.ACTIVATION_SUCCESS:if(state&&!state.notified){return _extends({},state,{notified:true});}return state;case _userView.GET_SUCCESS:case _userView.UPDATE_SUCCESS:case _userView.CREATE_SUCCESS:return action.user;case _userView.GET_REQUEST:case _userView.CLEAR:return null;default:return state;}};var isDirty=function isDirty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _form.SET_DIRTY:return action.form==='user'?action.dirty:state;case _userView.GET_SUCCESS:case _userView.UPDATE_SUCCESS:case _userView.CREATE_SUCCESS:case _userView.CLEAR:return false;default:return state;}};var userView=(0,_redux.combineReducers)({active:active,error:error,isDirty:isDirty,isFetching:isFetching});exports.default=userView;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _uniqBy2=__webpack_require__(120);var _uniqBy3=_interopRequireDefault(_uniqBy2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _isNil2=__webpack_require__(166);var _isNil3=_interopRequireDefault(_isNil2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _userList=__webpack_require__(381);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {UserListAction} from '../actions/userList';*//*:: export type UserListState = {
  error: any,
  filter: {
    archived: bool,
    project: ?number,
    query: ?string
  },
  filteredUsers: any[],
  isFetching: boolean,
  projects: any[],
  users: any[],
  sorter: Function,
}*/var defaultState/*: UserListState*/={error:null,filter:{archived:false,project:null,query:null},filteredUsers:[],isFetching:false,projects:[],users:[],sorter:_identity3.default};var isArchived=(0,_filter3.default)(function(u){return(0,_isString3.default)(u.archived);});var notArchived=(0,_filter3.default)({archived:null});var filterUsers=function filterUsers(projectId/*: ?number*/,archived/*: bool*/,sorter/*: Function*/,users/*: any[]*/)/*: any[]*/{var filterFunc=archived?isArchived:notArchived;if(projectId){filterFunc=(0,_flow3.default)(filterFunc,(0,_filter3.default)({projectId:projectId}));}return(0,_flow3.default)(filterFunc,sorter)(users);};var getProjects=(0,_flow3.default)((0,_filter3.default)(function(u){return!(0,_isNil3.default)(u.projectId);}),(0,_map3.default)(function(u){return{id:u.projectId,name:u.projectName};}),(0,_uniqBy3.default)('id'));var userList=function userList()/*: UserListState*/{var state/*: UserListState*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action/*: UserListAction*/=arguments[1];switch(action.type){case _userList.FILTER:return _extends({},state,{filter:{archived:action.archived,project:action.project,query:action.query},filteredUsers:filterUsers(action.project,action.archived,state.sorter,state.users)});case _userList.GET_FAILURE:return _extends({},state,{error:action.error,isFetching:false});case _userList.GET_REQUEST:return _extends({},state,{error:null,isFetching:true});case _userList.GET_SUCCESS:return _extends({},state,{error:null,filteredUsers:filterUsers(state.filter.project,state.filter.archived,state.sorter,action.users),isFetching:false,projects:getProjects(action.users),users:action.users});case _userList.SORT:return _extends({},state,{sorter:action.sorter,filteredUsers:filterUsers(state.filter.project,state.filter.archived,action.sorter,state.users)});default:return state;}};exports.default=userList;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(24),
    baseUniq = __webpack_require__(232);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 884 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reject2=__webpack_require__(68);var _reject3=_interopRequireDefault(_reject2);var _uuid=__webpack_require__(53);var _uuid2=_interopRequireDefault(_uuid);var _notification2=__webpack_require__(23);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//  weak
var newNotification=function newNotification(message){var level=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'success';return{id:_uuid2.default.v4(),message:message,level:level};};var notification=function notification(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _notification2.ADD:return[].concat(_toConsumableArray(state),[newNotification(action.message,action.level)]);case _notification2.REMOVE:return(0,_reject3.default)({id:action.id},state);default:var _notification=action[_notification2.ADD];if(_notification){return[].concat(_toConsumableArray(state),[newNotification(_notification.message,_notification.level)]);}return state;}};exports.default=notification;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(219),
    baseFilter = __webpack_require__(362),
    baseIteratee = __webpack_require__(24),
    isArray = __webpack_require__(18),
    negate = __webpack_require__(368);

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _redux=__webpack_require__(15);var _workerTypeView=__webpack_require__(382);var _form=__webpack_require__(17);var active=function active(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _workerTypeView.GET_SUCCESS:case _workerTypeView.UPDATE_SUCCESS:case _workerTypeView.CREATE_SUCCESS:return action.workerType;case _workerTypeView.GET_REQUEST:case _workerTypeView.CLEAR:return null;default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _workerTypeView.GET_FAILURE:case _workerTypeView.UPDATE_FAILURE:case _workerTypeView.CREATE_FAILURE:return action.error;case _workerTypeView.GET_REQUEST:case _workerTypeView.GET_SUCCESS:case _workerTypeView.UPDATE_REQUEST:case _workerTypeView.UPDATE_SUCCESS:case _workerTypeView.CREATE_REQUEST:case _workerTypeView.CREATE_SUCCESS:return null;default:return state;}};var isDirty=function isDirty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _form.SET_DIRTY:return action.form==='workerType'?action.dirty:state;case _workerTypeView.GET_SUCCESS:case _workerTypeView.UPDATE_SUCCESS:case _workerTypeView.CREATE_SUCCESS:case _workerTypeView.CLEAR:return false;default:return state;}};var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _workerTypeView.GET_REQUEST:case _workerTypeView.UPDATE_REQUEST:case _workerTypeView.CREATE_REQUEST:return true;case _workerTypeView.GET_SUCCESS:case _workerTypeView.GET_FAILURE:case _workerTypeView.UPDATE_SUCCESS:case _workerTypeView.UPDATE_FAILURE:case _workerTypeView.CREATE_SUCCESS:case _workerTypeView.CREATE_FAILURE:return false;default:return state;}};var workerTypeView=(0,_redux.combineReducers)({active:active,error:error,isDirty:isDirty,isFetching:isFetching});exports.default=workerTypeView;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _workerTypeList=__webpack_require__(383);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _workerTypeList.REQUEST:case _workerTypeList.SUCCESS:return null;case _workerTypeList.FAILURE:return action.error;default:return state;}};var archived=function archived(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _workerTypeList.FILTER:return!!action.archived;default:return state;}};var query=function query(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _workerTypeList.FILTER:return action.query;default:return state;}};var filter=(0,_redux.combineReducers)({archived:archived,query:query});var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _workerTypeList.REQUEST:return true;case _workerTypeList.SUCCESS:case _workerTypeList.FAILURE:return false;default:return state;}};var list=function list(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _workerTypeList.SUCCESS:return action.workerTypes;default:return state;}};var isArchived=(0,_filter3.default)(function(t){return(0,_isString3.default)(t.archived);});var notArchived=(0,_filter3.default)({archived:null});var filteredList=function filteredList(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},archived=_ref.filter.archived,list=_ref.list,filtered=_ref.filteredList,sorter=_ref.sorter;var action=arguments[1];switch(action.type){case _workerTypeList.SUCCESS:case _workerTypeList.FILTER:case _workerTypeList.SORT:return(0,_flow3.default)(archived?isArchived:notArchived,sorter)(list);default:return filtered;}};var sorter=function sorter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_identity3.default;var action=arguments[1];switch(action.type){case _workerTypeList.SORT:return action.sorter;default:return state;}};var reducers=(0,_redux.combineReducers)({filteredList:function filteredList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return state;},error:error,filter:filter,isFetching:isFetching,list:list,sorter:sorter});var workerTypeList=function workerTypeList(state,action){var newState=reducers(state,action);return _extends({},newState,{filteredList:filteredList(newState,action)});};exports.default=workerTypeList;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reject2=__webpack_require__(68);var _reject3=_interopRequireDefault(_reject2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _redux=__webpack_require__(15);var _file=__webpack_require__(367);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var filesById=function filesById(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _file.FILE_ADDED:return _extends({},state,_defineProperty({},action.tempId,{tempId:action.tempId,file:action.file,progress:0,metadata:null,error:null,id:null}));case _file.UPLOAD_INITIALIZED:return _extends({},state,_defineProperty({},action.tempId,_extends({},state[action.tempId],{id:action.id})));case _file.UPLOAD_PROGRESS:return _extends({},state,_defineProperty({},action.tempId,_extends({},state[action.tempId],{progress:action.progress})));case _file.UPLOAD_SUCCESS:return _extends({},state,_defineProperty({},action.tempId,_extends({},state[action.tempId],{progress:100,metadata:action.metadata,error:null})));case _file.UPLOAD_ERROR:return _extends({},state,_defineProperty({},action.tempId,_extends({},state[action.tempId],{error:action.error})));case _file.REMOVE_UPLOAD:return _extends({},state,_defineProperty({},action.tempId,undefined));default:return state;}};var allFileIds=function allFileIds(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _file.FILE_ADDED:return[].concat(_toConsumableArray(state),[action.tempId]);case _file.REMOVE_UPLOAD:return(0,_reject3.default)({tempId:action.tempId},state);default:return state;}};var files=(0,_redux.combineReducers)({byId:filesById,allIds:allFileIds});exports.default=files;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _reject2=__webpack_require__(68);var _reject3=_interopRequireDefault(_reject2);var _values2=__webpack_require__(67);var _values3=_interopRequireDefault(_values2);var _partial2=__webpack_require__(891);var _partial3=_interopRequireDefault(_partial2);var _mapValues2=__webpack_require__(66);var _mapValues3=_interopRequireDefault(_mapValues2);var _keyBy2=__webpack_require__(167);var _keyBy3=_interopRequireDefault(_keyBy2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _toNumber2=__webpack_require__(84);var _toNumber3=_interopRequireDefault(_toNumber2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _groupBy2=__webpack_require__(168);var _groupBy3=_interopRequireDefault(_groupBy2);var _sumBy2=__webpack_require__(121);var _sumBy3=_interopRequireDefault(_sumBy2);var _get2=__webpack_require__(122);var _get3=_interopRequireDefault(_get2);var _flatMap2=__webpack_require__(54);var _flatMap3=_interopRequireDefault(_flatMap2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _productView=__webpack_require__(169);var _form=__webpack_require__(17);var _redux=__webpack_require__(15);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}//  weak
var defaultProductState={filteredVariants:[],includeArchived:false,isDirty:false,isFetching:false,error:null,active:null,variants:[],linkedAdditionalVariants:[],relatedProductType:null};var sortByItemNumber=(0,_sortBy3.default)('itemNumber');var notArchived=(0,_filter3.default)({archived:null});var filterVariants=function filterVariants(variants,mainVariantId){var filtered=notArchived(variants);var main=(0,_find3.default)({id:mainVariantId},variants);if(main&&!(0,_some3.default)({id:mainVariantId},filtered)){filtered=sortByItemNumber([].concat(_toConsumableArray(filtered),[main]));}return filtered;};var product=function product(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultProductState;var action=arguments[1];switch(action.type){case _productView.FILTER_ARCHIVED:return _extends({},state,{includeArchived:action.includeArchived});case _productView.REQUEST:return _extends({},state,{isFetching:true,error:null,active:null,variants:[]});case _productView.SUCCESS:case _productView.CREATE_SUCCESS:{var variants=sortByItemNumber(action.variants);return _extends({},state,{isDirty:false,isFetching:false,error:null,active:action.product,filteredVariants:filterVariants(variants,action.product.mainVariantId),variants:variants,linkedAdditionalVariants:action.product.linkedAdditionalVariants,relatedProductType:null});}case _productView.FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _productView.UPDATE_REQUEST:return _extends({},state,{isFetching:true,error:null});case _productView.UPDATE_SUCCESS:return _extends({},state,{filteredVariants:filterVariants(sortByItemNumber(state.variants),action.product.mainVariantId),isDirty:false,isFetching:false,error:null,active:action.product,linkedAdditionalVariants:action.product.linkedAdditionalVariants});case _productView.UPDATE_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _productView.CREATE_REQUEST:return _extends({},state,{isFetching:true,error:null});case _productView.CREATE_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _productView.VARIANT_UPDATE_SUCCESS:{var _variant=action.variant;var _variants=sortByItemNumber([].concat(_toConsumableArray((0,_filter3.default)(function(v){return v.id!==_variant.id;},state.variants)),[_variant]));return _extends({},state,{filteredVariants:state.active?filterVariants(_variants,state.active.mainVariantId):_variants,variants:_variants,relatedProductType:null});}case _productView.VARIANTS_UPDATE_SUCCESS:{var _variants2=sortByItemNumber(action.variants);return _extends({},state,{filteredVariants:state.active?filterVariants(_variants2,state.active.mainVariantId):_variants2,variants:_variants2,relatedProductType:null});}case _form.SET_DIRTY:return _extends({},state,{isDirty:action.form==='product'?action.dirty:state.isDirty});case _productView.SET_SHARED_RELATED_PRODUCT_TYPE:return _extends({},state,{relatedProductType:action.relatedProductType});case _productView.ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS:return _extends({},state,{relatedProductType:!!state.relatedProductType&&action.productType.id===state.relatedProductType.id?null:state.relatedProductType});case _productView.ADD_PRODUCT_LINKED_ADDITIONAL_VARIANT:return _extends({},state,{linkedAdditionalVariants:[].concat(_toConsumableArray(state.linkedAdditionalVariants),[action.additional])});case _productView.REMOVE_PRODUCT_LINKED_ADDITIONAL_VARIANT:return _extends({},state,{linkedAdditionalVariants:(0,_filter3.default)(function(a){return a.productVariant.id!==action.additional.productVariant.id;},state.linkedAdditionalVariants)});case _productView.UPDATE_PRODUCT_LINKED_ADDITIONAL_VARIANT:return _extends({},state,{linkedAdditionalVariants:[].concat(_toConsumableArray((0,_filter3.default)(function(a){return a.productVariant.id!==action.additional.productVariant.id;},state.linkedAdditionalVariants)),[action.additional])});case _productView.RESET:return _extends({},state,{linkedAdditionalVariants:state.active?state.active.linkedAdditionalVariants:[],isDirty:false,relatedProductType:null});case _productView.CLEAR:return defaultProductState;default:return state;}};var filterPartialSelected=(0,_filter3.default)(function(v){return v.selected!==false;});var getSelectedVariantCount=(0,_flow3.default)((0,_flatMap3.default)('variants'),filterPartialSelected,(0,_get3.default)('length'));var countVariants=(0,_sumBy3.default)(function(p){return p.variants.length;});var getRelated=function getRelated(){var existingState=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var variant=arguments[1];var related=variant&&variant.related?(0,_groupBy3.default)('productTypeId',variant.related):{};var existing=!!variant?existingState[variant.id]:null;return(0,_map3.default)(function(id){var productTypeId=(0,_toNumber3.default)(id);var existingType=!!existing?(0,_find3.default)({id:productTypeId},existing):null;var productGroup=(0,_groupBy3.default)('productId',related[id]);var products=(0,_map3.default)(function(pKey){var productId=(0,_toNumber3.default)(pKey);var existingProduct=!!existingType?(0,_find3.default)({id:productId},existingType.products):null;var variants=(0,_map3.default)(function(v){return{id:v.id,name:v.name,itemNumber:v.itemNumber,selected:v.selected};},productGroup[pKey]);var fullSelectedCount=(0,_filter3.default)('selected',variants).length;var partialSelectedCount=filterPartialSelected(variants).length;return{id:productId,name:productGroup[pKey][0].productName,mainVariantId:productGroup[pKey][0].mainVariantId,variants:variants,opened:!!existingProduct?existingProduct.opened:false,selected:fullSelectedCount===variants.length?true:partialSelectedCount===0?false:null};},(0,_keys3.default)(productGroup));var selectedCount=getSelectedVariantCount(products);return{id:productTypeId,name:related[id][0].productTypeName,products:products,opened:!!existingType?existingType.opened:false,selectedCount:selectedCount,selected:selectedCount===0?false:products.length===(0,_filter3.default)('selected',products).length?true:null};},(0,_keys3.default)(related));};var getFullRelated=function getFullRelated(variants){var existingState=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return(0,_flow3.default)(notArchived,(0,_keyBy3.default)('id'),(0,_mapValues3.default)((0,_partial3.default)(getRelated,[existingState])))(variants);};var getSharedRelated=function getSharedRelated(variants){var existingState=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var variantCount=(0,_keys3.default)(variants).length;var grouped=(0,_flow3.default)((0,_flatMap3.default)(_values3.default),(0,_groupBy3.default)('id'))(variants);return(0,_map3.default)(function(key){var group=grouped[key];var name=group[0].name;var id=(0,_toNumber3.default)(key);var existingType=(0,_find3.default)({id:id},existingState);var groupedProducts=(0,_flow3.default)((0,_flatMap3.default)('products'),(0,_groupBy3.default)('id'))(group);var products=(0,_map3.default)(function(pKey){var productGroup=groupedProducts[pKey];var _productGroup$=productGroup[0],mainVariantId=_productGroup$.mainVariantId,productName=_productGroup$.name;var id=(0,_toNumber3.default)(pKey);var existingProduct=!!existingType?(0,_find3.default)({id:id},existingType.products):null;var groupedVariants=(0,_flow3.default)((0,_flatMap3.default)('variants'),(0,_groupBy3.default)('id'))(productGroup);var mappedVariants=(0,_map3.default)(function(vKey){var variantGroup=groupedVariants[vKey];var _variantGroup$=variantGroup[0],variantName=_variantGroup$.name,variantItemNumber=_variantGroup$.itemNumber;var selectedCount=(0,_filter3.default)('selected',variantGroup).length;return{id:(0,_toNumber3.default)(vKey),name:variantName,itemNumber:variantItemNumber,selected:selectedCount===variantCount?true:selectedCount===0?false:null};},(0,_keys3.default)(groupedVariants));var fullSelectedCount=(0,_filter3.default)('selected',mappedVariants).length;var partialSelectedCount=filterPartialSelected(mappedVariants).length;return{id:id,mainVariantId:mainVariantId,name:productName,opened:!!existingProduct?existingProduct.opened:false,selected:fullSelectedCount===mappedVariants.length?true:partialSelectedCount===0?false:null,variants:mappedVariants};},(0,_keys3.default)(groupedProducts));var selectedCount=getSelectedVariantCount(products);return{id:id,name:name,products:products,opened:!!existingType?existingType.opened:false,selectedCount:selectedCount,selected:selectedCount===0?false:products.length===(0,_filter3.default)('selected',products).length?true:null};},(0,_keys3.default)(grouped));};var hasVariantDiffs=function hasVariantDiffs(shared,list){var values=(0,_values3.default)(list);return(0,_some3.default)(function(_ref){var id=_ref.id,selected=_ref.selected,products=_ref.products;return(0,_some3.default)(function(typeList){var typeMatch=(0,_find3.default)({id:id,selected:selected},typeList);return!typeMatch||(0,_some3.default)(function(_ref2){var id=_ref2.id,selected=_ref2.selected,variants=_ref2.variants;var prodMatch=(0,_find3.default)({id:id,selected:selected},typeMatch.products);return!prodMatch||(0,_some3.default)(function(_ref3){var id=_ref3.id,selected=_ref3.selected;return!(0,_find3.default)({id:id,selected:selected},prodMatch.variants);},variants);},products);},values);},shared);};var defaultVariantState={isDirty:false,isFetching:false,error:null,active:null,activeImage:null,linkedAdditionalVariants:[],images:[],relatedProductType:null,related:{error:null,isFetching:false,list:{},shared:[],hasVariantDiffs:false},uploads:{}};var variant=function variant(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _productView.SUCCESS:case _productView.CREATE_SUCCESS:{var main=(0,_find3.default)({id:action.variantId||action.product.mainVariantId},action.variants);var newRelatedState=getFullRelated(action.variants,state.variant.related.list);var shared=getSharedRelated(newRelatedState);return _extends({},state.variant,{isDirty:false,active:main,related:_extends({},state.variant.related,{list:newRelatedState,shared:shared,hasVariantDiffs:hasVariantDiffs(shared,newRelatedState)}),relatedProductType:null,images:main&&main.images?[].concat(_toConsumableArray(main.images)):[],linkedAdditionalVariants:main&&main.linkedAdditionalVariants?[].concat(_toConsumableArray(main.linkedAdditionalVariants)):[],uploads:{}});}case _productView.VARIANT_UPDATE_REQUEST:return _extends({},state.variant,{isFetching:true,error:null});case _productView.VARIANT_UPDATE_SUCCESS:{var _variant2=action.variant;var _newRelatedState=_extends({},state.variant.related.list,_defineProperty({},_variant2.id,getRelated(state.variant.related.list,_variant2)));var _shared=getSharedRelated(_newRelatedState,state.variant.related.shared);return _extends({},state.variant,{isDirty:false,isFetching:false,error:null,active:_variant2,related:_extends({},state.variant.related,{list:_newRelatedState,shared:_shared,hasVariantDiffs:!!state.variant.related.hasVariantDiffs?hasVariantDiffs(_shared,_newRelatedState):state.variant.related.hasVariantDiffs}),relatedProductType:null,images:_variant2&&_variant2.images?[].concat(_toConsumableArray(_variant2.images)):[],linkedAdditionalVariants:_variant2&&_variant2.linkedAdditionalVariants?[].concat(_toConsumableArray(_variant2.linkedAdditionalVariants)):[]});}case _productView.VARIANT_UPDATE_FAILURE:return _extends({},state.variant,{isFetching:false,error:action.error});case _productView.VARIANTS_UPDATE_REQUEST:return _extends({},state.variant,{isFetching:true,error:null});case _productView.VARIANTS_UPDATE_SUCCESS:{var _main=(0,_find3.default)({id:!!state.variant.active?state.variant.active.id:state.product.active.mainVariantId},action.variants);var _newRelatedState2=getFullRelated(action.variants,state.variant.related.list);var _shared2=getSharedRelated(_newRelatedState2,state.variant.related.shared);return _extends({},state.variant,{isDirty:false,isFetching:false,active:_main,related:_extends({},state.variant.related,{list:_newRelatedState2,shared:_shared2,hasVariantDiffs:!!state.variant.related.hasVariantDiffs?hasVariantDiffs(_shared2,_newRelatedState2):state.variant.related.hasVariantDiffs}),relatedProductType:null,images:_main&&_main.images?[].concat(_toConsumableArray(_main.images)):[],linkedAdditionalVariants:_main&&_main.linkedAdditionalVariants?[].concat(_toConsumableArray(_main.linkedAdditionalVariants)):[],error:null});}case _productView.VARIANTS_UPDATE_FAILURE:return _extends({},state.variant,{isFetching:false,error:action.error});case _productView.SET_ACTIVE_VARIANT:return _extends({},state.variant,{active:action.variant,activeImage:null,relatedProductType:null,images:action.variant&&action.variant.images?[].concat(_toConsumableArray(action.variant.images)):[],linkedAdditionalVariants:action.variant&&action.variant.linkedAdditionalVariants?[].concat(_toConsumableArray(action.variant.linkedAdditionalVariants)):[],uploads:{}});case _productView.VARIANT_IMAGE:{var existing=state.variant.uploads[action.variantId]||[];return _extends({},state.variant,{uploads:_extends({},state.variant.uploads,_defineProperty({},action.variantId,[].concat(_toConsumableArray(existing),[action.tempId])))});}case _productView.REMOVE_VARIANT_IMAGE:if(action.isTemp){var _existing=state.variant.uploads[action.variantId]||[];return _extends({},state.variant,{uploads:_extends({},state.variant.uploads,_defineProperty({},action.variantId,(0,_filter3.default)(function(i){return i!==action.imageId;},_existing)))});}else if(state.variant.active&&state.variant.active.id===action.variantId){return _extends({},state.variant,{images:(0,_filter3.default)(function(i){return i.id!==action.imageId;},state.variant.images)});}return state.variant;case _productView.VARIANT_IMAGE_UPLOADED:if(state.variant.active&&state.variant.active.id===action.variantId||!state.variant.active&&action.variantId===0){return _extends({},state.variant,{images:[].concat(_toConsumableArray(state.variant.images),[action.metadata])});}return state.variant;case _productView.SET_DEFAULT_VARIANT_IMAGE:return _extends({},state.variant,{activeImage:state.variant.activeImage?_extends({},state.variant.activeImage,{isDefault:state.variant.activeImage.id===action.image.id}):null,images:(0,_map3.default)(function(image){return _extends({},image,{isDefault:image.id===action.image.id});},state.variant.images)});case _productView.SET_ACTIVE_VARIANT_IMAGE:return _extends({},state.variant,{activeImage:action.image});case _productView.ADD_VARIANT_LINKED_ADDITIONAL_VARIANT:return _extends({},state.variant,{linkedAdditionalVariants:[].concat(_toConsumableArray(state.variant.linkedAdditionalVariants),[action.additional])});case _productView.REMOVE_VARIANT_LINKED_ADDITIONAL_VARIANT:return _extends({},state.variant,{linkedAdditionalVariants:(0,_filter3.default)(function(a){return a.productVariant.id!==action.additional.productVariant.id;},state.variant.linkedAdditionalVariants)});case _productView.UPDATE_VARIANT_LINKED_ADDITIONAL_VARIANT:return _extends({},state.variant,{linkedAdditionalVariants:[].concat(_toConsumableArray((0,_filter3.default)(function(a){return a.productVariant.id!==action.additional.productVariant.id;},state.variant.linkedAdditionalVariants)),[action.additional])});case _productView.RESET:{var _newRelatedState3=getFullRelated(state.product.variants,state.variant.related.list);var _shared3=getSharedRelated(_newRelatedState3);return _extends({},state.variant,{isDirty:false,activeImage:null,related:_extends({},state.variant.related,{list:_newRelatedState3,shared:_shared3,hasVariantDiffs:hasVariantDiffs(_shared3,_newRelatedState3)}),relatedProductType:null,images:state.variant.active&&state.variant.active.images?[].concat(_toConsumableArray(state.variant.active.images)):[],linkedAdditionalVariants:state.variant.active&&state.variant.active.linkedAdditionalVariants?[].concat(_toConsumableArray(state.variant.active.linkedAdditionalVariants)):[],uploads:{}});}case _form.SET_DIRTY:return _extends({},state.variant,{isDirty:action.form==='productVariant'?action.dirty:state.variant.isDirty});case _productView.CLEAR:return defaultVariantState;case _productView.SET_RELATED_PRODUCT_TYPE:return _extends({},state.variant,{relatedProductType:action.relatedProductType});case _productView.ADD_RELATED_PRODUCT_TYPE_REQUEST:return _extends({},state.variant,{related:_extends({},state.variant.related,{isFetching:true})});case _productView.ADD_RELATED_PRODUCT_TYPE_SUCCESS:{var variantProductTypes=state.variant.related.list[action.variantId]||[];var _newRelatedState4=(0,_some3.default)({id:action.productType.id},variantProductTypes)?state.variant.related.list:_extends({},state.variant.related.list,_defineProperty({},action.variantId,[].concat(_toConsumableArray(variantProductTypes),[function(){var products=(0,_flow3.default)(notArchived,(0,_map3.default)(function(p){return{id:p.id,name:p.name,opened:false,selected:true,variants:(0,_flow3.default)(notArchived,(0,_map3.default)(function(v){return{id:v.id,name:v.name,itemNumber:v.itemNumber,selected:true};}))(p.variants)};}),(0,_filter3.default)(function(p){return!!p.variants.length;}))(action.products);return{id:action.productType.id,name:action.productType.name,opened:false,selectedCount:countVariants(products),products:products,selected:!!products.length};}()])));var _shared4=getSharedRelated(_newRelatedState4,state.variant.related.shared);return _extends({},state.variant,{relatedProductType:!!state.variant.relatedProductType&&action.productType.id===state.variant.relatedProductType.id?null:state.variant.relatedProductType,related:_extends({},state.variant.related,{error:null,isFetching:false,list:_newRelatedState4,shared:_shared4,hasVariantDiffs:hasVariantDiffs(_shared4,_newRelatedState4)})});}case _productView.ADD_RELATED_PRODUCT_TYPE_FAILURE:return _extends({},state.variant,{related:_extends({},state.variant.related,{error:action.error,isFetching:false})});case _productView.RELATED_PRODUCT_SELECTED:{var _newRelatedState5=_extends({},state.variant.related.list,_defineProperty({},action.variantId,(0,_map3.default)(function(t){var products=(0,_map3.default)(function(p){return _extends({},p,{selected:p.id===action.id?action.selected:p.selected,variants:p.id===action.id?(0,_map3.default)(function(v){return _extends({},v,{selected:action.selected});},p.variants):p.variants});},t.products);var selectedCount=getSelectedVariantCount(products);return _extends({},t,{products:products,selectedCount:selectedCount,selected:selectedCount===0?false:products.length===(0,_filter3.default)('selected',products).length?true:null});},state.variant.related.list[action.variantId]||[])));var _shared5=getSharedRelated(_newRelatedState5,state.variant.related.shared);return _extends({},state.variant,{related:_extends({},state.variant.related,{list:_newRelatedState5,shared:_shared5,hasVariantDiffs:hasVariantDiffs(_shared5,_newRelatedState5)})});}case _productView.RELATED_VARIANT_SELECTED:{var _newRelatedState6=_extends({},state.variant.related.list,_defineProperty({},action.variantId,(0,_map3.default)(function(t){var products=(0,_map3.default)(function(p){var variants=(0,_map3.default)(function(v){return _extends({},v,{selected:v.id===action.id?action.selected:v.selected});},p.variants);var selectedCount=(0,_filter3.default)('selected',variants).length;return _extends({},p,{variants:variants,selected:selectedCount===0?false:selectedCount===variants.length?true:null});},t.products);var selectedCount=getSelectedVariantCount(products);return _extends({},t,{products:products,selectedCount:selectedCount,selected:selectedCount===0?false:products.length===(0,_filter3.default)('selected',products).length?true:null});},state.variant.related.list[action.variantId]||[])));var _shared6=getSharedRelated(_newRelatedState6,state.variant.related.shared);return _extends({},state.variant,{related:_extends({},state.variant.related,{list:_newRelatedState6,shared:_shared6,hasVariantDiffs:hasVariantDiffs(_shared6,_newRelatedState6)})});}case _productView.RELATED_PRODUCT_TOGGLE:return _extends({},state.variant,{related:_extends({},state.variant.related,{list:_extends({},state.variant.related.list,_defineProperty({},action.variantId,(0,_map3.default)(function(t){return _extends({},t,{products:(0,_map3.default)(function(p){return _extends({},p,{opened:p.id===action.id?!p.opened:p.opened});},t.products)});},state.variant.related.list[action.variantId]||[])))})});case _productView.RELATED_PRODUCT_TYPE_TOGGLE:return _extends({},state.variant,{related:_extends({},state.variant.related,{list:_extends({},state.variant.related.list,_defineProperty({},action.variantId,(0,_map3.default)(function(t){return _extends({},t,{opened:t.id===action.id?!t.opened:t.opened});},state.variant.related.list[action.variantId]||[])))})});case _productView.ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS:{var _newRelatedState7=(0,_mapValues3.default)(function(v){return(0,_some3.default)({id:action.productType.id},v)?v:[].concat(_toConsumableArray(v),[function(){var products=(0,_flow3.default)(notArchived,(0,_map3.default)(function(p){return{id:p.id,name:p.name,mainVariantId:p.mainVariantId,opened:false,selected:true,variants:(0,_flow3.default)(notArchived,(0,_map3.default)(function(v){return{id:v.id,name:v.name,itemNumber:v.itemNumber,selected:true};}))(p.variants)};}),(0,_filter3.default)(function(p){return!!p.variants.length;}))(action.products);return{id:action.productType.id,name:action.productType.name,opened:false,selectedCount:countVariants(products),products:products,selected:!!products.length};}()]);},state.variant.related.list);var _shared7=getSharedRelated(_newRelatedState7,state.variant.related.shared);return _extends({},state.variant,{relatedProductType:!!state.variant.relatedProductType&&action.productType.id===state.variant.relatedProductType.id?null:state.variant.relatedProductType,related:_extends({},state.variant.related,{error:null,isFetching:false,list:_newRelatedState7,shared:_shared7,hasVariantDiffs:hasVariantDiffs(_shared7,_newRelatedState7)})});}case _productView.SHARED_RELATED_PRODUCT_SELECTED:{var _newRelatedState8=(0,_mapValues3.default)(function(x){return(0,_some3.default)({id:action.productType.id},x)?(0,_map3.default)(function(t){var products=(0,_map3.default)(function(p){return _extends({},p,{selected:p.id===action.id?action.selected:p.selected,variants:p.id===action.id?(0,_map3.default)(function(v){return _extends({},v,{selected:action.selected});},p.variants):p.variants});},t.products);var selectedCount=getSelectedVariantCount(products);return _extends({},t,{products:products,selectedCount:selectedCount,selected:selectedCount===0?false:products.length===(0,_filter3.default)('selected',products).length?true:null});},x):[].concat(_toConsumableArray(x),[function(){var products=(0,_flow3.default)(notArchived,(0,_map3.default)(function(p){return{id:p.id,name:p.name,opened:false,selected:p.id===action.id,variants:(0,_flow3.default)(notArchived,(0,_map3.default)(function(v){return{id:v.id,name:v.name,itemNumber:v.itemNumber,selected:p.id===action.id};}))(p.variants)};}),(0,_filter3.default)(function(p){return!!p.variants.length;}))(action.products);var selectedCount=(0,_flow3.default)((0,_filter3.default)({id:action.id}),(0,_sumBy3.default)(function(p){return p.variants.length;}))(products);return{id:action.productType.id,name:action.productType.name,opened:false,products:products,selectedCount:selectedCount,selected:selectedCount===0?false:products.length===(0,_filter3.default)('selected',products).length?true:null};}()]);},state.variant.related.list);return _extends({},state.variant,{related:_extends({},state.variant.related,{error:null,isFetching:false,list:_newRelatedState8,shared:getSharedRelated(_newRelatedState8,state.variant.related.shared)})});}case _productView.SHARED_RELATED_VARIANT_SELECTED:{var _newRelatedState9=(0,_mapValues3.default)(function(x){return(0,_some3.default)({id:action.productType.id},x)?(0,_map3.default)(function(t){var products=(0,_map3.default)(function(p){var variants=(0,_map3.default)(function(v){return _extends({},v,{selected:v.id===action.id?action.selected:v.selected});},p.variants);var selectedCount=(0,_filter3.default)('selected',variants).length;return _extends({},p,{variants:variants,selected:selectedCount===0?false:selectedCount===variants.length?true:null});},t.products);var selectedCount=getSelectedVariantCount(products);return _extends({},t,{products:products,selectedCount:selectedCount,selected:selectedCount===0?false:products.length===(0,_filter3.default)('selected',products).length?true:null});},x):[].concat(_toConsumableArray(x),[function(){var products=(0,_flow3.default)(notArchived,(0,_map3.default)(function(p){var variants=(0,_flow3.default)(notArchived,(0,_map3.default)(function(v){return{id:v.id,name:v.name,itemNumber:v.itemNumber,selected:v.id===action.id?action.selected:v.selected};}))(p.variants);var selectedCount=filterPartialSelected(variants).length;return{id:p.id,name:p.name,opened:false,selected:selectedCount===variants.length?true:selectedCount===0?false:null,variants:variants};}),(0,_filter3.default)(function(p){return!!p.variants.length;}))(action.products);var selectedCount=getSelectedVariantCount(products);return{id:action.productType.id,name:action.productType.name,opened:false,products:products,selectedCount:selectedCount,selected:selectedCount===0?false:products.length===(0,_filter3.default)('selected',products).length?true:null};}()]);},state.variant.related.list);return _extends({},state.variant,{related:_extends({},state.variant.related,{error:null,isFetching:false,list:_newRelatedState9,shared:getSharedRelated(_newRelatedState9,state.variant.related.shared)})});}case _productView.SHARED_RELATED_PRODUCT_TOGGLE:return _extends({},state.variant,{related:_extends({},state.variant.related,{shared:(0,_map3.default)(function(t){return _extends({},t,{products:(0,_map3.default)(function(p){return _extends({},p,{opened:p.id===action.id?!p.opened:p.opened});},t.products)});},state.variant.related.shared)})});case _productView.SHARED_RELATED_PRODUCT_TYPE_TOGGLE:return _extends({},state.variant,{related:_extends({},state.variant.related,{shared:(0,_map3.default)(function(t){return _extends({},t,{opened:t.id===action.id?!t.opened:t.opened});},state.variant.related.shared)})});case _productView.RELATED_PRODUCT_TYPE_SELECTED:{var _newRelatedState10=_extends({},state.variant.related.list,_defineProperty({},action.variantId,(0,_map3.default)(function(t){if(t.id!==action.id){return t;}var products=(0,_map3.default)(function(p){return _extends({},p,{selected:!!action.selected,variants:(0,_map3.default)(function(v){return _extends({},v,{selected:!!action.selected});},p.variants)});},t.products);var selectedCount=getSelectedVariantCount(products);return _extends({},t,{products:products,selectedCount:selectedCount,selected:selectedCount===0?false:products.length===(0,_filter3.default)('selected',products).length?true:null});},state.variant.related.list[action.variantId]||[])));var _shared8=getSharedRelated(_newRelatedState10,state.variant.related.shared);return _extends({},state.variant,{related:_extends({},state.variant.related,{list:_newRelatedState10,shared:_shared8,hasVariantDiffs:hasVariantDiffs(_shared8,_newRelatedState10)})});}case _productView.SHARED_RELATED_PRODUCT_TYPE_SELECTED:{var _newRelatedState11=(0,_mapValues3.default)(function(x){return(0,_some3.default)({id:action.productType.id},x)?(0,_map3.default)(function(t){if(t.id!==action.productType.id){return t;}var products=(0,_map3.default)(function(p){return _extends({},p,{selected:action.selected,variants:(0,_map3.default)(function(v){return _extends({},v,{selected:action.selected});},p.variants)});},t.products);return _extends({},t,{products:products,selectedCount:countVariants(products),selected:!!action.selected?!!products.length:false});},x):[].concat(_toConsumableArray(x),[function(){var products=(0,_flow3.default)(notArchived,(0,_map3.default)(function(p){return{id:p.id,name:p.name,opened:false,selected:!!action.selected,variants:(0,_flow3.default)(notArchived,(0,_map3.default)(function(v){return{id:v.id,name:v.name,itemNumber:v.itemNumber,selected:!!action.selected};}))(p.variants)};}),(0,_filter3.default)(function(p){return!!p.variants.length;}))(action.products);return{id:action.productType.id,name:action.productType.name,opened:false,selectedCount:!!action.selected?countVariants(products):0,products:products,selected:!!action.selected?!!products.length:false};}()]);},state.variant.related.list);return _extends({},state.variant,{related:_extends({},state.variant.related,{error:null,isFetching:false,list:_newRelatedState11,shared:getSharedRelated(_newRelatedState11,state.variant.related.shared)})});}case _productView.REMOVE_PRODUCT_TYPE:{var _newRelatedState12=_extends({},state.variant.related.list,_defineProperty({},action.variantId,(0,_reject3.default)({id:action.id},state.variant.related.list[action.variantId]||[])));var _shared9=getSharedRelated(_newRelatedState12,state.variant.related.shared);return _extends({},state.variant,{related:_extends({},state.variant.related,{list:_newRelatedState12,shared:_shared9,hasVariantDiffs:hasVariantDiffs(_shared9,_newRelatedState12)})});}case _productView.SHARED_REMOVE_PRODUCT_TYPE:{var _newRelatedState13=(0,_mapValues3.default)((0,_reject3.default)({id:action.id}),state.variant.related.list);return _extends({},state.variant,{related:_extends({},state.variant.related,{list:_newRelatedState13,shared:getSharedRelated(_newRelatedState13,state.variant.related.shared)})});}case _productView.UNLOCK_SHARED:return _extends({},state.variant,{related:_extends({},state.variant.related,{hasVariantDiffs:false})});default:return state.variant;}};var replacementVisibility=function replacementVisibility(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _productView.TOGGLE_REPLACEMENT_DIALOG:return!!action.show;default:return state;}};var defaultReplacementProductsState={isFetching:false,error:null,list:[]};var replacementProducts=function replacementProducts(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultReplacementProductsState;var action=arguments[1];switch(action.type){case _productView.REPLACEMENT_PRODUCTS_REQUEST:return _extends({},state,{isFetching:true,error:null,list:[]});case _productView.REPLACEMENT_PRODUCTS_SUCCESS:return _extends({},state,{isFetching:false,error:null,list:action.products});case _productView.REPLACEMENT_PRODUCTS_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _productView.CLEAR:return defaultReplacementProductsState;default:return state;}};var defaultReplacementVariantsState={isFetching:false,error:null,list:[]};var replacementVariants=function replacementVariants(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultReplacementVariantsState;var action=arguments[1];switch(action.type){case _productView.REPLACEMENT_PRODUCTS_REQUEST:return _extends({},state,{list:[]});case _productView.REPLACEMENT_VARIANTS_REQUEST:return _extends({},state,{isFetching:true,error:null,list:[]});case _productView.REPLACEMENT_VARIANTS_SUCCESS:return _extends({},state,{isFetching:false,error:null,list:action.variants});case _productView.REPLACEMENT_VARIANTS_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _productView.CLEAR:return defaultReplacementVariantsState;default:return state;}};var activeVariantLinkedAdditionalVariant=function activeVariantLinkedAdditionalVariant(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productView.SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT:return null;case _productView.SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT:return action.additional;default:return state;}};var activeProductLinkedAdditionalVariant=function activeProductLinkedAdditionalVariant(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productView.SET_ACTIVE_PRODUCT_LINKED_ADDITIONAL_VARIANT:return action.additional;case _productView.SET_ACTIVE_VARIANT_LINKED_ADDITIONAL_VARIANT:return null;default:return state;}};var defaultAdditionalProductsState={isFetching:false,error:null,list:[]};var additionalProducts=function additionalProducts(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultAdditionalProductsState;var action=arguments[1];switch(action.type){case _productView.ADDITIONAL_PRODUCTS_REQUEST:return _extends({},state,{isFetching:true,error:null,list:[]});case _productView.ADDITIONAL_PRODUCTS_SUCCESS:return _extends({},state,{isFetching:false,error:null,list:action.products});case _productView.ADDITIONAL_PRODUCTS_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _productView.CLEAR:return defaultAdditionalProductsState;default:return state;}};var defaultAdditionalVariantsState={isFetching:false,error:null,list:[]};var additionalVariants=function additionalVariants(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultAdditionalVariantsState;var action=arguments[1];switch(action.type){case _productView.ADDITIONAL_PRODUCTS_REQUEST:return _extends({},state,{list:[]});case _productView.ADDITIONAL_VARIANTS_REQUEST:return _extends({},state,{isFetching:true,error:null,list:[]});case _productView.ADDITIONAL_VARIANTS_SUCCESS:return _extends({},state,{isFetching:false,error:null,list:action.variants});case _productView.ADDITIONAL_VARIANTS_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _productView.CLEAR:return defaultAdditionalVariantsState;default:return state;}};var includeId=function includeId(id){return(0,_filter3.default)(function(t){return t.id===id||!t.archived;});};var filterSuppliers=function filterSuppliers(product){return product&&!!product.supplierId?includeId(product.supplierId):notArchived;};var defaultSupplierState={list:[],filteredList:[],error:null,isFetching:false};var suppliers=function suppliers(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _productView.SUPPLIERS_REQUEST:return _extends({},defaultSupplierState,{isFetching:true});case _productView.SUPPLIERS_FAILURE:return _extends({},state.suppliers,{error:action.error,isFetching:false});case _productView.SUPPLIERS_SUCCESS:return _extends({},defaultSupplierState,{list:action.suppliers,filteredList:filterSuppliers(state.product.active)(action.suppliers)});default:return state.suppliers;}};var roomTypesList=function roomTypesList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _productView.ROOM_TYPES_SUCCESS:return notArchived(action.roomTypes);case _productView.ROOM_TYPES_REQUEST:case _productView.CLEAR:return[];default:return state;}};var roomTypesIsFetching=function roomTypesIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _productView.ROOM_TYPES_REQUEST:return true;case _productView.ROOM_TYPES_SUCCESS:case _productView.ROOM_TYPES_FAILURE:case _productView.CLEAR:return false;default:return state;}};var roomTypesError=function roomTypesError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productView.ROOM_TYPES_FAILURE:return action.error;case _productView.ROOM_TYPES_REQUEST:case _productView.ROOM_TYPES_SUCCESS:case _productView.CLEAR:return null;default:return state;}};var roomTypes=(0,_redux.combineReducers)({list:roomTypesList,error:roomTypesError,isFetching:roomTypesIsFetching});var workerTypesList=function workerTypesList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _productView.WORKER_TYPES_SUCCESS:return notArchived(action.workerTypes);case _productView.WORKER_TYPES_REQUEST:case _productView.CLEAR:return[];default:return state;}};var workerTypesIsFetching=function workerTypesIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _productView.WORKER_TYPES_REQUEST:return true;case _productView.WORKER_TYPES_SUCCESS:case _productView.WORKER_TYPES_FAILURE:case _productView.CLEAR:return false;default:return state;}};var workerTypesError=function workerTypesError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productView.WORKER_TYPES_FAILURE:return action.error;case _productView.WORKER_TYPES_REQUEST:case _productView.WORKER_TYPES_SUCCESS:case _productView.CLEAR:return null;default:return state;}};var workerTypes=(0,_redux.combineReducers)({list:workerTypesList,error:workerTypesError,isFetching:workerTypesIsFetching});var filterProductTypes=function filterProductTypes(product){return product?includeId(product.productTypeId):notArchived;};var filterRelated=function filterRelated(product,related){return(0,_flow3.default)(notArchived,!!product?(0,_filter3.default)(function(t){return t.id!==product.productTypeId;}):_identity3.default,!(0,_isEmpty3.default)(related)?(0,_filter3.default)(function(t){return!(0,_some3.default)({id:t.id},related);}):_identity3.default);};var defaultProductTypesState={list:[],filteredList:[],relatedList:[],error:null,isFetching:false,sharedRelatedList:[]};var productTypes=function productTypes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _productView.PRODUCT_TYPES_REQUEST:return _extends({},defaultProductTypesState,{isFetching:true});case _productView.PRODUCT_TYPES_FAILURE:return _extends({},state.productTypes,{error:action.error,isFetching:false});case _productView.PRODUCT_TYPES_SUCCESS:return _extends({},defaultProductTypesState,{list:action.productTypes,relatedList:!!state.variant.active?filterRelated(state.product.active,state.variant.related.list[state.variant.active.id])(action.productTypes):[],filteredList:filterProductTypes(state.product.active)(action.productTypes),sharedRelatedList:filterRelated(state.product.active,state.variant.related.shared)(action.productTypes)});case _productView.SUCCESS:case _productView.VARIANT_UPDATE_SUCCESS:case _productView.SET_ACTIVE_VARIANT:case _productView.RESET:case _productView.ADD_RELATED_PRODUCT_TYPE_SUCCESS:case _productView.ADD_SHARED_RELATED_PRODUCT_TYPE_SUCCESS:case _productView.RELATED_PRODUCT_TYPE_TOGGLE:case _productView.SHARED_RELATED_PRODUCT_TYPE_TOGGLE:case _productView.REMOVE_PRODUCT_TYPE:case _productView.SHARED_REMOVE_PRODUCT_TYPE:case _productView.VARIANTS_UPDATE_SUCCESS:return _extends({},state.productTypes,{relatedList:!!state.variant.active?filterRelated(state.product.active,state.variant.related.list[state.variant.active.id])(state.productTypes.list):[],sharedRelatedList:filterRelated(state.product.active,state.variant.related.shared)(state.productTypes.list)});default:return state.productTypes;}};var reducers=(0,_redux.combineReducers)({product:product,variant:function variant(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultVariantState;return s;},suppliers:function suppliers(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultSupplierState;return s;},roomTypes:roomTypes,workerTypes:workerTypes,productTypes:function productTypes(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultProductTypesState;return s;},replacement:(0,_redux.combineReducers)({show:replacementVisibility,products:replacementProducts,variants:replacementVariants}),activeProductLinkedAdditionalVariant:activeProductLinkedAdditionalVariant,activeVariantLinkedAdditionalVariant:activeVariantLinkedAdditionalVariant,linkedAdditionalVariantDialog:(0,_redux.combineReducers)({products:additionalProducts,variants:additionalVariants})});var productView=function productView(state,action){var newState=reducers(state,action);var withVariantState=_extends({},newState,{variant:variant(newState,action)});return _extends({},withVariantState,{suppliers:suppliers(withVariantState,action),productTypes:productTypes(withVariantState,action)});};exports.default=productView;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('partial', __webpack_require__(892));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(83),
    createWrap = __webpack_require__(144),
    getHolder = __webpack_require__(212),
    replaceHolders = __webpack_require__(150);

/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with `partials` prepended to the
 * arguments it receives. This method is like `_.bind` except it does **not**
 * alter the `this` binding.
 *
 * The `_.partial.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 0.2.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var sayHelloTo = _.partial(greet, 'hello');
 * sayHelloTo('fred');
 * // => 'hello fred'
 *
 * // Partially applied with placeholders.
 * var greetFred = _.partial(greet, _, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 */
var partial = baseRest(function(func, partials) {
  var holders = replaceHolders(partials, getHolder(partial));
  return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partial.placeholder = {};

module.exports = partial;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(95),
    createAggregator = __webpack_require__(384);

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = createAggregator(function(result, value, key) {
  baseAssignValue(result, key, value);
});

module.exports = keyBy;


/***/ }),
/* 894 */
/***/ (function(module, exports) {

/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

module.exports = arrayAggregator;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(80);

/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  baseEach(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

module.exports = baseAggregator;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(95),
    createAggregator = __webpack_require__(384);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */
var groupBy = createAggregator(function(result, value, key) {
  if (hasOwnProperty.call(result, key)) {
    result[key].push(value);
  } else {
    baseAssignValue(result, key, [value]);
  }
});

module.exports = groupBy;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(24),
    baseSum = __webpack_require__(385);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(24),
    isArrayLike = __webpack_require__(60),
    keys = __webpack_require__(59);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _get2=__webpack_require__(122);var _get3=_interopRequireDefault(_get2);var _toLower2=__webpack_require__(65);var _toLower3=_interopRequireDefault(_toLower2);var _includes2=__webpack_require__(97);var _includes3=_interopRequireDefault(_includes2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _flatMap2=__webpack_require__(54);var _flatMap3=_interopRequireDefault(_flatMap2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _productList=__webpack_require__(388);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var notArchived=(0,_filter3.default)({archived:null});var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productList.REQUEST:case _productList.SUCCESS:return null;case _productList.FAILURE:return action.error;default:return state;}};var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _productList.REQUEST:return true;case _productList.SUCCESS:case _productList.FAILURE:return false;default:return state;}};var archived=function archived(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _productList.FILTER:return action.archived;default:return state;}};var productType=function productType(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productList.FILTER:return action.productType;default:return state;}};var query=function query(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productList.FILTER:return action.query;default:return state;}};var showVariants=function showVariants(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;var action=arguments[1];switch(action.type){case _productList.FILTER:return!!action.showVariants;default:return state;}};var filter=(0,_redux.combineReducers)({archived:archived,productType:productType,query:query,showVariants:showVariants});var list=function list(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _productList.SUCCESS:return(0,_map3.default)(function(p){return _extends({},p,{mainVariant:(0,_find3.default)({id:p.mainVariantId},p.variants),hasRelated:(0,_some3.default)('hasRelated',p.variants)});},action.products);default:return state;}};var variants=function variants(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _productList.SUCCESS:return(0,_flatMap3.default)(function(product){return(0,_map3.default)(function(v){return _extends({},v,{name:product.name+' - '+v.name,product:product});},product.variants);},action.products);default:return state;}};var productTypesList=function productTypesList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _productList.PRODUCT_TYPES_SUCCESS:return notArchived(action.productTypes);case _productList.PRODUCT_TYPES_REQUEST:return[];default:return state;}};var productTypesIsFetching=function productTypesIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _productList.PRODUCT_TYPES_REQUEST:return true;case _productList.PRODUCT_TYPES_SUCCESS:case _productList.PRODUCT_TYPES_FAILURE:return false;default:return state;}};var productTypesError=function productTypesError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _productList.PRODUCT_TYPES_FAILURE:return action.error;case _productList.PRODUCT_TYPES_REQUEST:case _productList.PRODUCT_TYPES_SUCCESS:return null;default:return state;}};var productTypes=(0,_redux.combineReducers)({list:productTypesList,error:productTypesError,isFetching:productTypesIsFetching});var filterVariantProductTypes=function filterVariantProductTypes(productType){return(0,_filter3.default)({product:{productTypeId:productType}});};var isVariantArchived=(0,_filter3.default)(function(v){return(0,_isString3.default)(v.archived)||(0,_isString3.default)(v.product.archived);});var variantNotArchived=(0,_filter3.default)({archived:null,product:{archived:null}});var isProductArchived=(0,_filter3.default)(function(p){return(0,_isString3.default)(p.archived);});var filterProductTypes=function filterProductTypes(productType){return(0,_filter3.default)({productTypeId:productType});};var variantColumns=['itemNumber','name','product.productType.name'];var productColumns=['name','productType.name'];var filterVariantQuery=function filterVariantQuery(query){return function(v){return(0,_some3.default)(function(c){return(0,_includes3.default)(query,(0,_toLower3.default)((0,_get3.default)(c,v)));},variantColumns);};};var filterProductQuery=function filterProductQuery(query){return function(p){return(0,_some3.default)(function(c){return(0,_includes3.default)(query,(0,_toLower3.default)((0,_get3.default)(c,p)));},productColumns)||(0,_some3.default)(filterVariantQuery(query),p.variants);};};var filterQuery=function filterQuery(_ref){var query=_ref.query,showVariants=_ref.showVariants;query=(0,_toLower3.default)(query);return(0,_isEmpty3.default)(query)?_identity3.default:(0,_filter3.default)(showVariants?filterVariantQuery(query):filterProductQuery(query));};var filteredList=function filteredList(){var _ref2=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},filter=_ref2.filter,list=_ref2.list,filtered=_ref2.filteredList,variants=_ref2.variants,sorter=_ref2.sorter;var action=arguments[1];switch(action.type){case _productList.SUCCESS:case _productList.FILTER:case _productList.SORT:var filterFunc=filter.archived?filter.showVariants?isVariantArchived:isProductArchived:filter.showVariants?variantNotArchived:notArchived;if(!!filter.productType){filterFunc=(0,_flow3.default)(filterFunc,filter.showVariants?filterVariantProductTypes(filter.productType):filterProductTypes(filter.productType));}return(0,_flow3.default)(filterFunc,filterQuery(filter),sorter)(filter.showVariants?variants:list);default:return filtered;}};var sorter=function sorter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_identity3.default;var action=arguments[1];switch(action.type){case _productList.SORT:return action.sorter;default:return state;}};var reducers=(0,_redux.combineReducers)({error:error,filter:filter,isFetching:isFetching,list:list,filteredList:function filteredList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return state;},productTypes:productTypes,variants:variants,sorter:sorter});var productList=function productList(state,action){var newState=reducers(state,action);return _extends({},newState,{filteredList:filteredList(newState,action)});};exports.default=productList;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _omitBy2=__webpack_require__(230);var _omitBy3=_interopRequireDefault(_omitBy2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _findIndex2=__webpack_require__(99);var _findIndex3=_interopRequireDefault(_findIndex2);var _orderBy2=__webpack_require__(389);var _orderBy3=_interopRequireDefault(_orderBy2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _redux=__webpack_require__(15);var _apartmentView=__webpack_require__(235);var _form=__webpack_require__(17);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var orderByArchived=(0,_orderBy3.default)(['archived'],['desc']);var apartmentActive=function apartmentActive(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _apartmentView.GET_SUCCESS:case _apartmentView.CREATE_SUCCESS:case _apartmentView.UPDATE_SUCCESS:case _apartmentView.DELETE_FILE_SUCCESS:return _extends({},action.apartment,{oldContracts:orderByArchived(action.apartment.oldContracts),oldFloorPlans:orderByArchived(action.apartment.oldFloorPlans),oldKitchenPlans:orderByArchived(action.apartment.oldKitchenPlans)});case _apartmentView.GET_REQUEST:case _apartmentView.CLEAR:return null;default:return state;}};var apartmentError=function apartmentError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _apartmentView.GET_FAILURE:case _apartmentView.CREATE_FAILURE:case _apartmentView.UPDATE_FAILURE:case _apartmentView.FILE_UPDATE_FAILURE:case _apartmentView.DELETE_FILE_FAILURE:return action.error;case _apartmentView.GET_REQUEST:case _apartmentView.GET_SUCCESS:case _apartmentView.CREATE_REQUEST:case _apartmentView.CREATE_SUCCESS:case _apartmentView.UPDATE_REQUEST:case _apartmentView.UPDATE_SUCCESS:case _apartmentView.FILE_UPDATE_REQUEST:case _apartmentView.FILE_UPDATE_SUCCESS:case _apartmentView.DELETE_FILE_SUCCESS:case _apartmentView.CLEAR:return null;default:return state;}};var apartmentDeviations=function apartmentDeviations(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _apartmentView.GET_SUCCESS:case _apartmentView.CREATE_SUCCESS:case _apartmentView.UPDATE_SUCCESS:return action.apartment.deviations?[].concat(_toConsumableArray(action.apartment.deviations)):[];case _apartmentView.ADD_DEVIATION:return[].concat(_toConsumableArray(state),[action.deviation]);case _apartmentView.UPDATE_DEVIATION:var index=(0,_findIndex3.default)({id:action.deviationId},state);return[].concat(_toConsumableArray(state.slice(0,index)),[_extends({},state[index],action.data)],_toConsumableArray(state.slice(index+1)));case _apartmentView.REMOVE_DEVIATION:return(0,_filter3.default)(function(d){return d.id!==action.deviationId;},state);case _apartmentView.CLEAR:return[];default:return state;}};var apartmentFiles=function apartmentFiles(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _apartmentView.GET_SUCCESS:case _apartmentView.CREATE_SUCCESS:case _apartmentView.UPDATE_SUCCESS:return{contract:action.apartment.contract,floorPlan:action.apartment.floorPlan,kitchenPlan:action.apartment.kitchenPlan};case _apartmentView.REMOVE_FILE:return _extends({},state,_defineProperty({},action.name,null));case _apartmentView.FILE_UPLOADED:case _apartmentView.FILE_UPDATE_SUCCESS:return _extends({},state,_defineProperty({},action.name,action.metadata));case _apartmentView.CLEAR:return{};default:return state;}};var apartmentIsDirty=function apartmentIsDirty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _form.SET_DIRTY:return action.form==='apartment'?action.dirty:state;case _apartmentView.ADD_DEVIATION:case _apartmentView.UPDATE_DEVIATION:case _apartmentView.REMOVE_DEVIATION:return true;case _apartmentView.GET_SUCCESS:case _apartmentView.UPDATE_SUCCESS:case _apartmentView.CREATE_SUCCESS:case _apartmentView.RESET:case _apartmentView.CLEAR:return false;default:return state;}};var apartmentIsFetching=function apartmentIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _apartmentView.GET_REQUEST:case _apartmentView.CREATE_REQUEST:case _apartmentView.UPDATE_REQUEST:case _apartmentView.FILE_UPDATE_REQUEST:case _apartmentView.DELETE_FILE_REQUEST:return true;case _apartmentView.GET_SUCCESS:case _apartmentView.GET_FAILURE:case _apartmentView.CREATE_SUCCESS:case _apartmentView.CREATE_FAILURE:case _apartmentView.UPDATE_SUCCESS:case _apartmentView.UPDATE_FAILURE:case _apartmentView.FILE_UPDATE_SUCCESS:case _apartmentView.FILE_UPDATE_FAILURE:case _apartmentView.DELETE_FILE_SUCCESS:case _apartmentView.DELETE_FILE_FAILURE:case _apartmentView.CLEAR:return false;default:return state;}};var apartmentUploads=function apartmentUploads(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _apartmentView.ADD_FILE:return _extends({},state,_defineProperty({},action.name,action.tempId));case _apartmentView.ABORT_FILE_UPLOAD:return(0,_omitBy3.default)(function(u){return u===action.tempId;},state);case _apartmentView.CLEAR:return{};default:return state;}};var apartmentReducers=(0,_redux.combineReducers)({active:apartmentActive,deviations:apartmentDeviations,error:apartmentError,files:apartmentFiles,isDirty:apartmentIsDirty,isFetching:apartmentIsFetching,uploads:apartmentUploads});var apartment=function apartment(state,action){var newState=apartmentReducers(state,action);if(action.type===_apartmentView.RESET){return _extends({},newState,{deviations:newState.active&&newState.active.deviations?[].concat(_toConsumableArray(newState.active.deviations)):[],files:newState.active?{contract:newState.active.contract,floorPlan:newState.active.floorPlan,kitchenPlan:newState.active.kitchenPlan}:{},uploads:{}});}return newState;};var projectActive=function projectActive(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _apartmentView.GET_SUCCESS:case _apartmentView.PROJECT_GET_SUCCESS:return action.project;case _apartmentView.PROJECT_GET_REQUEST:case _apartmentView.CLEAR:return null;default:return state;}};var projectError=function projectError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _apartmentView.PROJECT_GET_FAILURE:return action.error;case _apartmentView.PROJECT_GET_REQUEST:case _apartmentView.PROJECT_GET_SUCCESS:case _apartmentView.CLEAR:return null;default:return state;}};var projectIsFetching=function projectIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _apartmentView.PROJECT_GET_REQUEST:return true;case _apartmentView.PROJECT_GET_SUCCESS:case _apartmentView.PROJECT_GET_FAILURE:case _apartmentView.CLEAR:return false;default:return state;}};var project=(0,_redux.combineReducers)({active:projectActive,error:projectError,isFetching:projectIsFetching});var deviationActive=function deviationActive(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _apartmentView.OPEN_DEVIATION:return action.deviation||null;case _apartmentView.CLOSE_DEVIATION:case _apartmentView.CLEAR:return null;default:return state;}};var deviationShow=function deviationShow(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _apartmentView.OPEN_DEVIATION:return true;case _apartmentView.CLOSE_DEVIATION:case _apartmentView.CLEAR:return false;default:return state;}};var deviation=(0,_redux.combineReducers)({active:deviationActive,show:deviationShow});var deviationsError=function deviationsError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _apartmentView.DEVIATIONS_FAILURE:return action.error;case _apartmentView.DEVIATIONS_REQUEST:case _apartmentView.DEVIATIONS_SUCCESS:case _apartmentView.CLEAR:return null;default:return state;}};var deviationsIsFetching=function deviationsIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _apartmentView.DEVIATIONS_REQUEST:return true;case _apartmentView.DEVIATIONS_SUCCESS:case _apartmentView.DEVIATIONS_FAILURE:case _apartmentView.CLEAR:return false;default:return state;}};var notArchived=(0,_filter3.default)({archived:null});var deviationsList=function deviationsList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _apartmentView.DEVIATIONS_SUCCESS:return notArchived(action.deviations);case _apartmentView.DEVIATIONS_REQUEST:case _apartmentView.CLEAR:return[];default:return state;}};var deviations=(0,_redux.combineReducers)({error:deviationsError,isFetching:deviationsIsFetching,list:deviationsList});var configurationsError=function configurationsError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _apartmentView.CONFIGURATIONS_FAILURE:return action.error;case _apartmentView.CONFIGURATIONS_REQUEST:case _apartmentView.CONFIGURATIONS_SUCCESS:case _apartmentView.CLEAR:return null;default:return state;}};var configurationsIsFetching=function configurationsIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _apartmentView.CONFIGURATIONS_REQUEST:return true;case _apartmentView.CONFIGURATIONS_SUCCESS:case _apartmentView.CONFIGURATIONS_FAILURE:case _apartmentView.CLEAR:return false;default:return state;}};var configurationsList=function configurationsList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _apartmentView.CONFIGURATIONS_SUCCESS:return action.apartmentConfigurations;case _apartmentView.CONFIGURATIONS_REQUEST:case _apartmentView.CLEAR:return[];default:return state;}};var configurations=(0,_redux.combineReducers)({error:configurationsError,isFetching:configurationsIsFetching,list:configurationsList});var copyDialogVisibility=function copyDialogVisibility(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _apartmentView.TOGGLE_COPY_DIALOG:return!!action.show;case _apartmentView.CREATE_SUCCESS:return false;case _apartmentView.CLEAR:return false;default:return state;}};var fileRenameDialogVisibility=function fileRenameDialogVisibility(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _apartmentView.TOGGLE_RENAME_DIALOG:return action.show;case _apartmentView.FILE_UPDATE_SUCCESS:case _apartmentView.CLEAR:return false;default:return state;}};var apartmentView=(0,_redux.combineReducers)({apartment:apartment,project:project,deviations:deviations,deviation:deviation,configurations:configurations,copyDialogVisibility:copyDialogVisibility,fileRenameDialogVisibility:fileRenameDialogVisibility});exports.default=apartmentView;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _orderBy2=__webpack_require__(389);var _orderBy3=_interopRequireDefault(_orderBy2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _customerView=__webpack_require__(170);var _redux=__webpack_require__(15);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var orderArchived=(0,_orderBy3.default)(['archived'],['desc']);var defaultState={isFetching:false,order:null,project:null,apartment:null,error:null};var order=function order(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case _customerView.UPDATE_SUCCESS:return _extends({},state,{order:action.order,isFetching:false,error:null});case _customerView.UPDATE_REQUEST:return _extends({},state,{isFetching:true,error:null});case _customerView.GET_REQUEST:return _extends({},state,{isFetching:true,order:null,project:null,apartment:null,error:null});case _customerView.GET_SUCCESS:return _extends({},state,{isFetching:false,order:action.order,project:action.project,apartment:_extends({},action.apartment,{oldContracts:orderArchived(action.apartment.oldContracts),oldFloorPlans:orderArchived(action.apartment.oldFloorPlans),oldKitchenPlans:orderArchived(action.apartment.oldKitchenPlans)}),error:null});case _customerView.GET_FAILURE:case _customerView.UPDATE_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _customerView.CLEAR:return defaultState;default:return state;}};var defaultMenuVisibility=false;var menuVisibility=function menuVisibility(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultMenuVisibility;var action=arguments[1];switch(action.type){case _customerView.TOGGLE_MENU:return!!action.show;case _customerView.CLEAR:return defaultMenuVisibility;default:return state;}};var customerView=(0,_redux.combineReducers)({order:order,showMenu:menuVisibility});exports.default=customerView;

/***/ }),
/* 902 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('overEvery', __webpack_require__(904));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(391),
    createOver = __webpack_require__(905);

/**
 * Creates a function that checks if **all** of the `predicates` return
 * truthy when invoked with the arguments it receives.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {...(Function|Function[])} [predicates=[_.identity]]
 *  The predicates to check.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var func = _.overEvery([Boolean, isFinite]);
 *
 * func('1');
 * // => true
 *
 * func(null);
 * // => false
 *
 * func(NaN);
 * // => false
 */
var overEvery = createOver(arrayEvery);

module.exports = overEvery;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(147),
    arrayMap = __webpack_require__(46),
    baseIteratee = __webpack_require__(24),
    baseRest = __webpack_require__(83),
    baseUnary = __webpack_require__(63),
    flatRest = __webpack_require__(118);

/**
 * Creates a function like `_.over`.
 *
 * @private
 * @param {Function} arrayFunc The function to iterate over iteratees.
 * @returns {Function} Returns the new over function.
 */
function createOver(arrayFunc) {
  return flatRest(function(iteratees) {
    iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
    return baseRest(function(args) {
      var thisArg = this;
      return arrayFunc(iteratees, function(iteratee) {
        return apply(iteratee, thisArg, args);
      });
    });
  });
}

module.exports = createOver;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(391),
    baseEvery = __webpack_require__(907),
    baseIteratee = __webpack_require__(24),
    isArray = __webpack_require__(18),
    isIterateeCall = __webpack_require__(98);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(80);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('sum', __webpack_require__(909), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var baseSum = __webpack_require__(385),
    identity = __webpack_require__(62);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? baseSum(array, identity)
    : 0;
}

module.exports = sum;


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(911),
    baseEach = __webpack_require__(80),
    baseIteratee = __webpack_require__(24),
    baseReduce = __webpack_require__(912),
    isArray = __webpack_require__(18);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 911 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 912 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('startsWith', __webpack_require__(914));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(392),
    baseToString = __webpack_require__(117),
    toInteger = __webpack_require__(58),
    toString = __webpack_require__(79);

/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = toString(string);
  position = position == null
    ? 0
    : baseClamp(toInteger(position), 0, string.length);

  target = baseToString(target);
  return string.slice(position, position + target.length) == target;
}

module.exports = startsWith;


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('pickBy', __webpack_require__(369));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(238);


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('intersection', __webpack_require__(918));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(46),
    baseIntersection = __webpack_require__(919),
    baseRest = __webpack_require__(83),
    castArrayLikeObject = __webpack_require__(920);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(163),
    arrayIncludes = __webpack_require__(149),
    arrayIncludesWith = __webpack_require__(233),
    arrayMap = __webpack_require__(46),
    baseUnary = __webpack_require__(63),
    cacheHas = __webpack_require__(164);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(171);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('slice', __webpack_require__(922));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(239),
    isIterateeCall = __webpack_require__(98),
    toInteger = __webpack_require__(58);

/**
 * Creates a slice of `array` from `start` up to, but not including, `end`.
 *
 * **Note:** This method is used instead of
 * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
 * returned.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function slice(array, start, end) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
    start = 0;
    end = length;
  }
  else {
    start = start == null ? 0 : toInteger(start);
    end = end === undefined ? length : toInteger(end);
  }
  return baseSlice(array, start, end);
}

module.exports = slice;


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('round', __webpack_require__(924));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var createRound = __webpack_require__(925);

/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = createRound('round');

module.exports = round;


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(36),
    toInteger = __webpack_require__(58),
    toNumber = __webpack_require__(151),
    toString = __webpack_require__(79);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = root.isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = toNumber(number);
    precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (toString(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (toString(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

module.exports = createRound;


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('clamp', __webpack_require__(927));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(392),
    toNumber = __webpack_require__(151);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('add', __webpack_require__(929));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

var createMathOperation = __webpack_require__(930);

/**
 * Adds two numbers.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {number} augend The first number in an addition.
 * @param {number} addend The second number in an addition.
 * @returns {number} Returns the total.
 * @example
 *
 * _.add(6, 4);
 * // => 10
 */
var add = createMathOperation(function(augend, addend) {
  return augend + addend;
}, 0);

module.exports = add;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

var baseToNumber = __webpack_require__(931),
    baseToString = __webpack_require__(117);

/**
 * Creates a function that performs a mathematical operation on two values.
 *
 * @private
 * @param {Function} operator The function to perform the operation.
 * @param {number} [defaultValue] The value used for `undefined` arguments.
 * @returns {Function} Returns the new mathematical operation function.
 */
function createMathOperation(operator, defaultValue) {
  return function(value, other) {
    var result;
    if (value === undefined && other === undefined) {
      return defaultValue;
    }
    if (value !== undefined) {
      result = value;
    }
    if (other !== undefined) {
      if (result === undefined) {
        return other;
      }
      if (typeof value == 'string' || typeof other == 'string') {
        value = baseToString(value);
        other = baseToString(other);
      } else {
        value = baseToNumber(value);
        other = baseToNumber(other);
      }
      result = operator(value, other);
    }
    return result;
  };
}

module.exports = createMathOperation;


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(76);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/**
 * The base implementation of `_.toNumber` which doesn't ensure correct
 * conversions of binary, hexadecimal, or octal string values.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 */
function baseToNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  return +value;
}

module.exports = baseToNumber;


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _uniqBy2=__webpack_require__(120);var _uniqBy3=_interopRequireDefault(_uniqBy2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _orderList=__webpack_require__(398);var _priceHelpers=__webpack_require__(85);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _orderList.GET_REQUEST:return true;case _orderList.GET_SUCCESS:case _orderList.GET_FAILURE:return false;default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderList.GET_SUCCESS:return null;case _orderList.GET_FAILURE:return action.error;default:return state;}};var archived=function archived(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _orderList.FILTER:return action.archived;default:return state;}};var query=function query(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderList.FILTER:return action.query;default:return state;}};var projectId=function projectId(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderList.FILTER:return action.projectId;default:return state;}};var salesUserId=function salesUserId(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderList.FILTER:return action.salesUserId;default:return state;}};var orderState=function orderState(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _orderList.FILTER:return action.orderState;default:return state;}};var filter=(0,_redux.combineReducers)({archived:archived,orderState:orderState,salesUserId:salesUserId,query:query,projectId:projectId});var orders=function orders(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderList.GET_SUCCESS:return(0,_flow3.default)((0,_filter3.default)(function(o){return o.apartment.project.archived===null;}),(0,_map3.default)(function(o){return _extends({},o,{totalPrice:(0,_priceHelpers.totalPrice)(o)});}))(action.orders);default:return state;}};var isArchived=(0,_filter3.default)(function(o){return(0,_isString3.default)(o.archived);});var notArchived=(0,_filter3.default)({archived:null});var mapProjects=(0,_flow3.default)((0,_map3.default)('apartment.project'),notArchived,(0,_uniqBy3.default)('id'));var projects=function projects(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderList.GET_SUCCESS:return mapProjects(action.orders);default:return state;}};var filterProjects=function filterProjects(projectId){return(0,_filter3.default)({apartment:{projectId:projectId}});};var filterSalesUsers=function filterSalesUsers(salesUserId){return(0,_filter3.default)({salesUserId:salesUserId});};var filterOrderStates=function filterOrderStates(state){return(0,_filter3.default)({state:state});};var filteredOrders=function filteredOrders(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _orderList.GET_SUCCESS:case _orderList.FILTER:case _orderList.SORT:return(0,_flow3.default)(state.filter.archived?isArchived:notArchived,state.filter.orderState?filterOrderStates(state.filter.orderState-1):_identity3.default,state.filter.projectId?filterProjects(state.filter.projectId):_identity3.default,state.filter.salesUserId?filterSalesUsers(state.filter.salesUserId):_identity3.default,state.sorter)(state.orders);default:return state.filteredOrders;}};var salesUsers=function salesUsers(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _orderList.GET_SUCCESS:return action.salesUsers;default:return state;}};var sorter=function sorter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_identity3.default;var action=arguments[1];switch(action.type){case _orderList.SORT:return action.sorter;default:return state;}};var reducers=(0,_redux.combineReducers)({salesUsers:salesUsers,filteredOrders:function filteredOrders(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return s;},isFetching:isFetching,error:error,filter:filter,orders:orders,projects:projects,sorter:sorter});var orderList=function orderList(state,action){var newState=reducers(state,action);return _extends({},newState,{filteredOrders:filteredOrders(newState,action)});};exports.default=orderList;

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _omitBy2=__webpack_require__(230);var _omitBy3=_interopRequireDefault(_omitBy2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _customRowView=__webpack_require__(399);var _form=__webpack_require__(17);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var customRowHasLoaded=function customRowHasLoaded(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_GET_SUCCESS:case _customRowView.CUSTOM_ROW_GET_FAILURE:return true;case _customRowView.CLEAR:return false;default:return state;}};var customRowIsFetching=function customRowIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_GET_REQUEST:case _customRowView.CUSTOM_ROW_CREATE_REQUEST:case _customRowView.CUSTOM_ROW_UPDATE_REQUEST:case _customRowView.CUSTOM_ROW_REMOVE_REQUEST:return true;case _customRowView.CUSTOM_ROW_GET_SUCCESS:case _customRowView.CUSTOM_ROW_GET_FAILURE:case _customRowView.CUSTOM_ROW_CREATE_SUCCESS:case _customRowView.CUSTOM_ROW_CREATE_FAILURE:case _customRowView.CUSTOM_ROW_UPDATE_SUCCESS:case _customRowView.CUSTOM_ROW_UPDATE_FAILURE:case _customRowView.CUSTOM_ROW_REMOVE_SUCCESS:case _customRowView.CUSTOM_ROW_REMOVE_FAILURE:case _customRowView.CLEAR:return false;default:return state;}};var customRowDataIsFetching=function customRowDataIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_DATA_GET_REQUEST:return true;case _customRowView.CUSTOM_ROW_DATA_GET_SUCCESS:case _customRowView.CUSTOM_ROW_DATA_GET_FAILURE:case _customRowView.CLEAR:return false;default:return state;}};var defaultCustomRowState={active:null,files:{}};var customRow=function customRow(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultCustomRowState;var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_GET_SUCCESS:case _customRowView.CUSTOM_ROW_CREATE_SUCCESS:case _customRowView.CUSTOM_ROW_UPDATE_SUCCESS:return _extends({},state,{active:action.row,files:{image:action.row.image}});case _customRowView.CUSTOM_ROW_REMOVE_FILE:return _extends({},state,{files:_extends({},state.files,_defineProperty({},action.name,null))});case _customRowView.CUSTOM_ROW_ADD_FILE:return _extends({},state,{files:_extends({},state.files,_defineProperty({},action.name,action.metadata))});case _customRowView.RESET:return _extends({},state,{files:state.active?{image:state.active.image}:{}});case _customRowView.CUSTOM_ROW_REMOVE_SUCCESS:case _customRowView.CLEAR:return defaultCustomRowState;default:return state;}};var order=function order(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_GET_SUCCESS:return action.order;case _customRowView.CLEAR:return null;default:return state;}};var customRowError=function customRowError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_GET_SUCCESS:case _customRowView.CUSTOM_ROW_CREATE_SUCCESS:case _customRowView.CUSTOM_ROW_UPDATE_SUCCESS:case _customRowView.CUSTOM_ROW_REMOVE_SUCCESS:case _customRowView.CLEAR:return null;case _customRowView.CUSTOM_ROW_CREATE_FAILURE:case _customRowView.CUSTOM_ROW_UPDATE_FAILURE:case _customRowView.CUSTOM_ROW_GET_FAILURE:case _customRowView.CUSTOM_ROW_REMOVE_FAILURE:return action.error;default:return state;}};var customRowUploadIds=function customRowUploadIds(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_UPLOAD_FILE:return _extends({},state,_defineProperty({},action.name,action.tempId));case _customRowView.CUSTOM_ROW_ABORT_FILE_UPLOAD:return(0,_omitBy3.default)(function(u){return u===action.tempId;},state);case _customRowView.CLEAR:return{};default:return state;}};var customRowisDirty=function customRowisDirty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _form.SET_DIRTY:return action.form==='customRow'?action.dirty:state;case _customRowView.CUSTOM_ROW_GET_SUCCESS:case _customRowView.CUSTOM_ROW_UPDATE_SUCCESS:case _customRowView.CUSTOM_ROW_CREATE_SUCCESS:case _customRowView.CUSTOM_ROW_REMOVE_SUCCESS:case _customRowView.CLEAR:return false;default:return state;}};var notArchived=(0,_filter3.default)({archived:null});var includeId=function includeId(id){return(0,_filter3.default)(function(t){return t.id===id||!t.archived;});};var filterSuppliers=function filterSuppliers(customRow){return customRow&&!!customRow.supplierId?includeId(customRow.supplierId):notArchived;};var defaultSupplierState={list:[],filteredList:[]};var suppliers=function suppliers(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_DATA_GET_SUCCESS:return _extends({},state.suppliers,{list:action.suppliers,filteredList:filterSuppliers(state.customRow.active)(action.suppliers)});case _customRowView.CUSTOM_ROW_UPDATE_SUCCESS:return _extends({},state.suppliers,{filteredList:filterSuppliers(state.customRow.active)(state.suppliers.list)});default:return state.suppliers;}};var filterProductTypes=function filterProductTypes(customRow){return customRow&&!!customRow.productTypeId?includeId(customRow.productTypeId):notArchived;};var defaultProductTypesState={list:[],filteredList:[]};var productTypes=function productTypes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_DATA_GET_SUCCESS:return _extends({},state.productTypes,{list:action.productTypes,filteredList:filterProductTypes(state.customRow.active)(action.productTypes)});case _customRowView.CUSTOM_ROW_UPDATE_SUCCESS:return _extends({},state.productTypes,{filteredList:filterProductTypes(state.customRow.active)(state.productTypes.list)});default:return state.productTypes;}};var filterWorkerTypes=function filterWorkerTypes(customRow){return customRow&&!!customRow.workerTypeId?includeId(customRow.workerTypeId):notArchived;};var defaultWorkerTypesState={list:[],filteredList:[]};var workerTypes=function workerTypes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_DATA_GET_SUCCESS:return _extends({},state.workerTypes,{list:action.workerTypes,filteredList:filterWorkerTypes(state.customRow.active)(action.workerTypes)});case _customRowView.CUSTOM_ROW_UPDATE_SUCCESS:return _extends({},state.workerTypes,{filteredList:filterWorkerTypes(state.customRow.active)(state.workerTypes.list)});default:return state.workerTypes;}};var filterRoomTypes=function filterRoomTypes(customRow){return customRow&&!!customRow.roomTypeId?includeId(customRow.roomTypeId):notArchived;};var defaultRoomTypesState={list:[],filteredList:[]};var roomTypes=function roomTypes(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_DATA_GET_SUCCESS:return _extends({},state.roomTypes,{list:action.roomTypes,filteredList:filterRoomTypes(state.customRow.active)(action.roomTypes)});case _customRowView.CUSTOM_ROW_UPDATE_SUCCESS:return _extends({},state.roomTypes,{filteredList:filterRoomTypes(state.customRow.active)(state.roomTypes.list)});default:return state.roomTypes;}};var filterRooms=function filterRooms(customRow){return customRow&&!!customRow.room?includeId(customRow.room):notArchived;};var defaultRoomsState={list:[],filteredList:[]};var rooms=function rooms(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _customRowView.CUSTOM_ROW_DATA_GET_SUCCESS:return _extends({},state.rooms,{list:action.rooms,filteredList:filterRooms(state.customRow.active)(action.rooms)});case _customRowView.CUSTOM_ROW_UPDATE_SUCCESS:return _extends({},state.rooms,{filteredList:filterRooms(state.customRow.active)(state.rooms.list)});default:return state.rooms;}};var reducers=(0,_redux.combineReducers)({customRow:customRow,order:order,uploadIds:customRowUploadIds,isFetching:customRowIsFetching,dataIsFetching:customRowDataIsFetching,error:customRowError,isDirty:customRowisDirty,hasLoaded:customRowHasLoaded,suppliers:function suppliers(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultSupplierState;return s;},productTypes:function productTypes(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultProductTypesState;return s;},workerTypes:function workerTypes(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultWorkerTypesState;return s;},roomTypes:function roomTypes(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultRoomTypesState;return s;},rooms:function rooms(){var s=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultRoomsState;return s;}});var customRowView=function customRowView(state,action){var newState=reducers(state,action);return _extends({},newState,{suppliers:suppliers(newState,action),productTypes:productTypes(newState,action),workerTypes:workerTypes(newState,action),roomTypes:roomTypes(newState,action),rooms:rooms(newState,action)});};exports.default=customRowView;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _uniqBy2=__webpack_require__(120);var _uniqBy3=_interopRequireDefault(_uniqBy2);var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _isEqual2=__webpack_require__(400);var _isEqual3=_interopRequireDefault(_isEqual2);var _get2=__webpack_require__(122);var _get3=_interopRequireDefault(_get2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _purchaseOrderList=__webpack_require__(401);var _orderStates=__webpack_require__(69);var _priceHelpers=__webpack_require__(85);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _purchaseOrderList.GET_REQUEST:return true;case _purchaseOrderList.GET_SUCCESS:case _purchaseOrderList.GET_FAILURE:return false;default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _purchaseOrderList.GET_SUCCESS:return null;case _purchaseOrderList.GET_FAILURE:return action.error;default:return state;}};var mapOrders=(0,_map3.default)(function(o){return _extends({},o,{totalPrice:(0,_priceHelpers.totalPrice)(o)});});var filterByProjectId=function filterByProjectId(projectId){return(0,_filter3.default)((0,_flow3.default)((0,_get3.default)('apartment.projectId'),(0,_isEqual3.default)(projectId)));};var notArchived=(0,_filter3.default)({archived:null});var filterOrders=function filterOrders(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},projectId=_ref.projectId,isPurchased=_ref.isPurchased;var filterFunc=(0,_flow3.default)(notArchived,isPurchased?(0,_filter3.default)(function(o){return o.state>_orderStates.CONFIRMED;}):(0,_filter3.default)({state:_orderStates.CONFIRMED}));if(projectId){filterFunc=(0,_flow3.default)(filterFunc,filterByProjectId(projectId));}return filterFunc;};var defaultOrdersState={list:[],filteredList:[],filters:{query:'',isPurchased:false,projectId:null},sorter:_identity3.default};var orders=function orders(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultOrdersState;var action=arguments[1];switch(action.type){case _purchaseOrderList.GET_SUCCESS:{var _orders=mapOrders(action.orders);return _extends({},state,{list:_orders,filteredList:(0,_flow3.default)(filterOrders(state.filters),state.sorter)(_orders)});}case _purchaseOrderList.FILTER_PROJECT_ID:{var filters=_extends({},state.filters,{projectId:action.projectId});return _extends({},state,{filters:filters,filteredList:(0,_flow3.default)(filterOrders(filters),state.sorter)(state.list)});}case _purchaseOrderList.FILTER_PURCHASED:{var _filters=_extends({},state.filters,{isPurchased:action.purchased});return _extends({},state,{filters:_filters,filteredList:(0,_flow3.default)(filterOrders(_filters),state.sorter)(state.list)});}case _purchaseOrderList.FILTER_QUERY:return _extends({},state,{filters:_extends({},state.filters,{query:action.query})});case _purchaseOrderList.SORT:return _extends({},state,{sorter:action.sorter,filteredList:(0,_flow3.default)(filterOrders(state.filters),action.sorter)(state.list)});default:return state;}};var mapProjects=(0,_flow3.default)((0,_map3.default)('apartment.project'),(0,_uniqBy3.default)('id'));var projects=function projects(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _purchaseOrderList.GET_SUCCESS:return mapProjects(action.orders);default:return state;}};var sorter=function sorter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_identity3.default;var action=arguments[1];switch(action.type){case _purchaseOrderList.SORT:return action.sorter;default:return state;}};var purchaseOrderList=(0,_redux.combineReducers)({isFetching:isFetching,error:error,orders:orders,projects:projects,sorter:sorter});exports.default=purchaseOrderList;

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.additionalRowsByRoom=undefined;var _uniqBy2=__webpack_require__(120);var _uniqBy3=_interopRequireDefault(_uniqBy2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _keyBy2=__webpack_require__(167);var _keyBy3=_interopRequireDefault(_keyBy2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _reduce2=__webpack_require__(123);var _reduce3=_interopRequireDefault(_reduce2);var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _purchaseOrderView=__webpack_require__(402);var _configTemplateView=__webpack_require__(124);var _helpers=__webpack_require__(397);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var active=function active(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _purchaseOrderView.GET_SUCCESS:case _purchaseOrderView.UPDATE_SUCCESS:return _extends({},action.order);case _purchaseOrderView.GET_REQUEST:case _purchaseOrderView.CLEAR:return null;default:return state;}};var additionalRowsByRoom=exports.additionalRowsByRoom=function additionalRowsByRoom(rows,rooms,additionalRows,linkedRows){var productRows=(0,_flow3.default)((0,_helpers.rowsToProductRows)(rooms),(0,_sortBy3.default)(['room.sortIndex']))(additionalRows);var linkedProductRows=(0,_flow3.default)((0,_helpers.rowsToProductRows)(rooms),(0,_sortBy3.default)(['room.sortIndex']))(linkedRows);return(0,_flow3.default)((0,_reduce3.default)(function(list,room){var roomProductRows=(0,_filter3.default)(function(r){return r.room.id===room.id;},productRows);var roomLinkedProductRows=(0,_filter3.default)(function(r){return r.room.id===room.id;},linkedProductRows);if(roomProductRows.length||roomLinkedProductRows.length){return[].concat(_toConsumableArray(list),[_extends({},room,{productRows:roomProductRows,linkedProductRows:roomLinkedProductRows})]);}return list;},[]),_configTemplateView.sortByIndex)(rooms);};var defaultRowsState={rooms:[],rows:[],rowsById:{},extraRows:[],extraRowsById:{},allRowsByRoom:[]};var rows=function rows(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultRowsState;var action=arguments[1];switch(action.type){case _purchaseOrderView.GET_SUCCESS:return _extends({},state,{rooms:action.rooms,rows:action.order.rows,rowsById:(0,_keyBy3.default)('id',action.order.rows),extraRows:action.order.extraRows,extraRowsById:(0,_keyBy3.default)('id',action.order.extraRows),allRowsByRoom:(0,_helpers.productRowsByRoom)(action.rooms,action.order.rows,action.order.extraRows)});case _purchaseOrderView.ORDER_ROW_UPDATE_SUCCESS:return _extends({},state,{rowsById:(0,_keyBy3.default)('id',action.rows),allRowsByRoom:(0,_helpers.productRowsByRoom)(state.rooms,action.rows,state.extraRows)});case _purchaseOrderView.EXTRA_ROW_UPDATE_SUCCESS:{var extraRows=(0,_filter3.default)(function(r){return r.id!==action.row.id;},state.extraRows).concat([action.row]);return _extends({},state,{extraRows:extraRows,extraRowsById:(0,_keyBy3.default)('id',extraRows),allRowsByRoom:(0,_helpers.productRowsByRoom)(state.rooms,state.rows,extraRows)});}case _purchaseOrderView.GET_REQUEST:case _purchaseOrderView.CLEAR:return defaultRowsState;default:return state;}};var defaultAdditionalRows={rows:[],rooms:[],additionalRows:[],linkedRows:[],allRowsByRoom:[]};var additionalRows=function additionalRows(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultAdditionalRows;var action=arguments[1];switch(action.type){case _purchaseOrderView.GET_SUCCESS:return _extends({},state,{rows:action.order.rows,rooms:action.rooms,additionalRows:action.order.additionalRows,linkedRows:action.order.linkedAdditionalRows,allRowsByRoom:additionalRowsByRoom(action.order.rows,action.rooms,action.order.additionalRows,action.order.linkedAdditionalRows)});case _purchaseOrderView.ADDITIONAL_ROW_CREATE_SUCCESS:{var _additionalRows2=[].concat(_toConsumableArray(state.additionalRows),[action.row]);return _extends({},state,{additionalRows:_additionalRows2,allRowsByRoom:additionalRowsByRoom(state.rows,state.rooms,_additionalRows2,state.linkedRows)});}case _purchaseOrderView.ADDITIONAL_ROW_UPDATE_SUCCESS:{var _additionalRows3=(0,_filter3.default)(function(r){return r.id!==action.row.id;},state.additionalRows).concat([action.row]);return _extends({},state,{additionalRows:_additionalRows3,allRowsByRoom:additionalRowsByRoom(state.rows,state.rooms,_additionalRows3,state.linkedRows)});}case _purchaseOrderView.ADDITIONAL_ROW_REMOVE_SUCCESS:var _additionalRows=(0,_filter3.default)(function(r){return r.id!==action.id;},state.additionalRows);return _extends({},state,{additionalRows:_additionalRows,allRowsByRoom:additionalRowsByRoom(state.rows,state.rooms,_additionalRows,state.linkedRows)});case _purchaseOrderView.LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS:{var _linkedRows=(0,_filter3.default)(function(r){return r.id!==action.row.id;},state.linkedRows).concat([action.row]);return _extends({},state,{linkedRows:_linkedRows,allRowsByRoom:additionalRowsByRoom(state.rows,state.rooms,state.additionalRows,_linkedRows)});}case _purchaseOrderView.LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS:var linkedRows=(0,_filter3.default)(function(r){return r.id!==action.id;},state.linkedRows);return _extends({},state,{linkedRows:linkedRows,allRowsByRoom:additionalRowsByRoom(state.rows,state.rooms,state.additionalRows,linkedRows)});case _purchaseOrderView.CLEAR:return defaultAdditionalRows;default:return state;}};var customRows=function customRows(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _purchaseOrderView.GET_SUCCESS:return action.order.customRows;case _purchaseOrderView.CLEAR:return[];default:return state;}};var rooms=function rooms(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _purchaseOrderView.GET_SUCCESS:return[].concat(_toConsumableArray(action.rooms));case _purchaseOrderView.GET_REQUEST:case _purchaseOrderView.CLEAR:return[];default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _purchaseOrderView.GET_REQUEST:case _purchaseOrderView.UPDATE_REQUEST:case _purchaseOrderView.GET_SUCCESS:case _purchaseOrderView.UPDATE_SUCCESS:case _purchaseOrderView.ADDITIONAL_ROW_REMOVE_REQUEST:case _purchaseOrderView.ADDITIONAL_ROW_REMOVE_SUCCESS:case _purchaseOrderView.LINKED_ADDITIONAL_ROW_REMOVE_REQUEST:case _purchaseOrderView.LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS:case _purchaseOrderView.CLEAR:return null;case _purchaseOrderView.GET_FAILURE:case _purchaseOrderView.UPDATE_FAILURE:case _purchaseOrderView.ADDITIONAL_ROW_REMOVE_FAILURE:case _purchaseOrderView.LINKED_ADDITIONAL_ROW_REMOVE_FAILURE:return action.error;default:return state;}};var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _purchaseOrderView.GET_REQUEST:case _purchaseOrderView.UPDATE_REQUEST:case _purchaseOrderView.ADDITIONAL_ROW_REMOVE_REQUEST:case _purchaseOrderView.LINKED_ADDITIONAL_ROW_REMOVE_REQUEST:return true;case _purchaseOrderView.GET_SUCCESS:case _purchaseOrderView.UPDATE_SUCCESS:case _purchaseOrderView.GET_FAILURE:case _purchaseOrderView.UPDATE_FAILURE:case _purchaseOrderView.ADDITIONAL_ROW_REMOVE_SUCCESS:case _purchaseOrderView.ADDITIONAL_ROW_REMOVE_FAILURE:case _purchaseOrderView.LINKED_ADDITIONAL_ROW_REMOVE_SUCCESS:case _purchaseOrderView.LINKED_ADDITIONAL_ROW_REMOVE_FAILURE:case _purchaseOrderView.CLEAR:return false;default:return state;}};var productsIsFetching=function productsIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _purchaseOrderView.PRODUCTS_REQUEST:return true;case _purchaseOrderView.PRODUCTS_SUCCESS:case _purchaseOrderView.PRODUCTS_FAILURE:case _purchaseOrderView.CLEAR:return false;default:return state;}};var productList=function productList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _purchaseOrderView.PRODUCTS_SUCCESS:return action.products;case _purchaseOrderView.CLEAR:return[];default:return state;}};var products=(0,_redux.combineReducers)({isFetching:productsIsFetching,list:productList});var variantsIsFetching=function variantsIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _purchaseOrderView.VARIANTS_REQUEST:return true;case _purchaseOrderView.VARIANTS_SUCCESS:case _purchaseOrderView.VARIANTS_FAILURE:case _purchaseOrderView.CLEAR:return false;default:return state;}};var variantList=function variantList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _purchaseOrderView.VARIANTS_SUCCESS:return action.variants;case _purchaseOrderView.CLEAR:return[];default:return state;}};var variants=(0,_redux.combineReducers)({isFetching:variantsIsFetching,list:variantList});var activeAdditionalRow=function activeAdditionalRow(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _purchaseOrderView.SET_ACTIVE_ADDITIONAL_ROW:return action.row;case _purchaseOrderView.ADDITIONAL_ROW_CREATE_SUCCESS:case _purchaseOrderView.ADDITIONAL_ROW_UPDATE_SUCCESS:case _purchaseOrderView.CLEAR:return null;default:return state;}};var additionalRowError=function additionalRowError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _purchaseOrderView.ADDITIONAL_ROW_CREATE_SUCCESS:case _purchaseOrderView.SET_ACTIVE_ADDITIONAL_ROW:case _purchaseOrderView.CLEAR:return null;case _purchaseOrderView.ADDITIONAL_ROW_CREATE_FAILURE:case _purchaseOrderView.ADDITIONAL_ROW_UPDATE_FAILURE:return action.error;default:return state;}};var additionalRowIsFetching=function additionalRowIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _purchaseOrderView.ADDITIONAL_ROW_CREATE_REQUEST:case _purchaseOrderView.ADDITIONAL_ROW_UPDATE_REQUEST:return true;case _purchaseOrderView.ADDITIONAL_ROW_CREATE_SUCCESS:case _purchaseOrderView.ADDITIONAL_ROW_CREATE_FAILURE:case _purchaseOrderView.ADDITIONAL_ROW_UPDATE_SUCCESS:case _purchaseOrderView.ADDITIONAL_ROW_UPDATE_FAILURE:case _purchaseOrderView.CLEAR:return false;default:return state;}};var additionalRow=(0,_redux.combineReducers)({error:additionalRowError,isFetching:additionalRowIsFetching,active:activeAdditionalRow});var activeLinkedAdditionalRow=function activeLinkedAdditionalRow(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _purchaseOrderView.SET_ACTIVE_LINKED_ADDITIONAL_ROW:return action.row;case _purchaseOrderView.LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS:case _purchaseOrderView.CLEAR:return null;default:return state;}};var linkedAdditionalRowError=function linkedAdditionalRowError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _purchaseOrderView.SET_ACTIVE_LINKED_ADDITIONAL_ROW:case _purchaseOrderView.CLEAR:return null;case _purchaseOrderView.LINKED_ADDITIONAL_ROW_UPDATE_FAILURE:return action.error;default:return state;}};var linkedAdditionalRowIsFetching=function linkedAdditionalRowIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _purchaseOrderView.LINKED_ADDITIONAL_ROW_UPDATE_REQUEST:return true;case _purchaseOrderView.LINKED_ADDITIONAL_ROW_UPDATE_SUCCESS:case _purchaseOrderView.LINKED_ADDITIONAL_ROW_UPDATE_FAILURE:case _purchaseOrderView.CLEAR:return false;default:return state;}};var linkedAdditionalRow=(0,_redux.combineReducers)({error:linkedAdditionalRowError,isFetching:linkedAdditionalRowIsFetching,active:activeLinkedAdditionalRow});var noteRowIsExtra=function noteRowIsExtra(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _purchaseOrderView.SET_NOTE_ROW:return action.isExtra;case _purchaseOrderView.CLEAR:return false;default:return state;}};var noteRowActive=function noteRowActive(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _purchaseOrderView.SET_NOTE_ROW:return action.row;case _purchaseOrderView.EXTRA_ROW_UPDATE_SUCCESS:case _purchaseOrderView.ORDER_ROW_UPDATE_SUCCESS:case _purchaseOrderView.CLEAR:return null;default:return state;}};var noteRowError=function noteRowError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _purchaseOrderView.EXTRA_ROW_UPDATE_FAILURE:case _purchaseOrderView.ORDER_ROW_UPDATE_FAILURE:return action.error;case _purchaseOrderView.EXTRA_ROW_UPDATE_SUCCESS:case _purchaseOrderView.ORDER_ROW_UPDATE_SUCCESS:case _purchaseOrderView.SET_NOTE_ROW:case _purchaseOrderView.CLEAR:return null;default:return state;}};var noteRowIsFetching=function noteRowIsFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _purchaseOrderView.ORDER_ROW_UPDATE_REQUEST:case _purchaseOrderView.EXTRA_ROW_UPDATE_REQUEST:return true;case _purchaseOrderView.ORDER_ROW_UPDATE_SUCCESS:case _purchaseOrderView.ORDER_ROW_UPDATE_FAILURE:case _purchaseOrderView.EXTRA_ROW_UPDATE_SUCCESS:case _purchaseOrderView.EXTRA_ROW_UPDATE_FAILURE:case _purchaseOrderView.CLEAR:return false;default:return state;}};var noteRow=(0,_redux.combineReducers)({isExtra:noteRowIsExtra,active:noteRowActive,error:noteRowError,isFetching:noteRowIsFetching});var defaultReportFilterState={includePlans:false,supplierId:null};var defaultReportDialogState={filter:defaultReportFilterState,isVisible:false,suppliers:[]};var reportDialog=function reportDialog(state,action){switch(action.type){case _purchaseOrderView.TOGGLE_REPORT_DIALOG:{var isVisible=!!action.show&&!!state.active;return!!isVisible?{isVisible:isVisible,filter:defaultReportFilterState,suppliers:(0,_flow3.default)((0,_filter3.default)(function(x){return!!x&&!!x.id;}),(0,_map3.default)(function(x){return x.supplier;}),(0,_filter3.default)(function(x){return!!x&&!!x.id;}),(0,_uniqBy3.default)('id'),(0,_sortBy3.default)([function(x){return x.name;}]))([].concat(_toConsumableArray((0,_map3.default)(function(x){return x.product;},state.rows.rows)),_toConsumableArray((0,_map3.default)(function(x){return x.product;},state.rows.extraRows)),_toConsumableArray(state.customRows)))}:defaultReportDialogState;}case _purchaseOrderView.UPDATE_REPORT_FILTER:{return _extends({},state.reportDialog,{filter:!!state.reportDialog.isVisible?_extends({},state.reportDialog.filter,{includePlans:!!action.includePlans,supplierId:action.supplierId}):defaultReportFilterState});}case _purchaseOrderView.CLEAR:return defaultReportDialogState;default:return state.reportDialog;}};var reducers=(0,_redux.combineReducers)({active:active,rows:rows,additionalRows:additionalRows,customRows:customRows,error:error,isFetching:isFetching,products:products,variants:variants,additionalRow:additionalRow,linkedAdditionalRow:linkedAdditionalRow,rooms:rooms,noteRow:noteRow,reportDialog:function reportDialog(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultReportDialogState;return state;}});var purchaseOrderView=function purchaseOrderView(state,action){var newState=reducers(state,action);return _extends({},newState,{reportDialog:reportDialog(newState,action)});};exports.default=purchaseOrderView;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _reject2=__webpack_require__(68);var _reject3=_interopRequireDefault(_reject2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _apartmentConfigView=__webpack_require__(82);var _form=__webpack_require__(17);var _configTemplateView=__webpack_require__(124);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/*:: import type {
  ConfigTemplateState as ApartmentConfigState,
  Exact,
  ProductsState,
  ProductSlotState,
  ProductTypesState,
  ProjectsState,
  RoomState,
  RoomsState,
  RoomTemplatesState,
  RoomTypesState,
} from './configTemplateView';*//*:: type ProjectState = {
  active: ?any,
  apartmentConfigs: any[],
  configTemplates: any[],
};*//*:: export type State_ = {
  apartmentConfig: ApartmentConfigState,
  products: ProductsState,
  productSlot: ProductSlotState,
  productTypes: ProductTypesState,
  project: ProjectState,
  room: RoomState,
  rooms: RoomsState,
  roomTypes: RoomTypesState,
  projects: ProjectsState,
  roomTemplates: RoomTemplatesState,
};*//*:: type State = {
  apartmentConfig: Exact<ApartmentConfigState>,
  products: ProductsState,
  productSlot: Exact<ProductSlotState>,
  productTypes: ProductTypesState,
  project: Exact<ProjectState>,
  room: Exact<RoomState>,
  rooms: RoomsState,
  roomTypes: RoomTypesState,
  projects: ProjectsState,
  roomTemplates: RoomTemplatesState,
};*/var defaultApartmentConfigState/*: ApartmentConfigState*/={active:null,error:null,isDirty:false,isFetching:false};var defaultProductSlotState/*: ProductSlotState*/={active:null,dialog:_configTemplateView.defaultDialogState,error:null,isDirty:false,isFetching:false,roomId:null};var defaultProjectState/*: ProjectState*/={active:null,apartmentConfigs:[],configTemplates:[]};var defaultRoomState/*: RoomState*/={active:null,error:null,isDirty:false,isFetching:false};var defaultRoomsState/*: RoomsState*/=[];var defaultRoomTypesState/*: RoomTypesState*/=[];var defaultProductTypesState/*: ProductTypesState*/=[];var defaultProductsState/*: ProductsState*/=[];var defaultProjectsState/*: ProjectsState*/=[];var defaultRoomTemplatesState/*: RoomTemplatesState*/=[];var defaultState/*: State_*/={apartmentConfig:defaultApartmentConfigState,productSlot:defaultProductSlotState,project:defaultProjectState,room:defaultRoomState,rooms:defaultRoomsState,roomTypes:defaultRoomTypesState,productTypes:defaultProductTypesState,products:defaultProductsState,projects:defaultProjectsState,roomTemplates:defaultRoomTemplatesState};var apartmentConfigView=function apartmentConfigView()/*: Exact<State>*/{var state/*: State_*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action/*: any*/=arguments[1];switch(action.type){case _apartmentConfigView.CREATE_REQUEST:case _apartmentConfigView.UPDATE_REQUEST:return _extends({},state,{apartmentConfig:_extends({},state.apartmentConfig,{error:null,isFetching:true})});case _apartmentConfigView.GET_REQUEST:return _extends({},defaultState,{apartmentConfig:_extends({},defaultApartmentConfigState,{error:null,isFetching:true})});case _apartmentConfigView.CREATE_FAILURE:case _apartmentConfigView.GET_FAILURE:case _apartmentConfigView.UPDATE_FAILURE:return _extends({},state,{apartmentConfig:_extends({},state.apartmentConfig,{error:action.error,isFetching:false})});case _apartmentConfigView.CREATE_SUCCESS:return _extends({},state,{apartmentConfig:{active:action.apartmentConfig||null,error:null,isDirty:false,isFetching:false},rooms:action.apartmentConfig?(0,_configTemplateView.sortRoomList)(action.apartmentConfig.rooms):[]});case _apartmentConfigView.UPDATE_SUCCESS:return _extends({},state,{apartmentConfig:{active:action.apartmentConfig||null,error:null,isDirty:false,isFetching:false}});case _apartmentConfigView.GET_SUCCESS:return _extends({},state,{apartmentConfig:{active:action.apartmentConfig||null,error:null,isDirty:false,isFetching:false},products:action.products,productTypes:action.productTypes,project:{active:action.project||null,apartmentConfigs:action.apartmentConfigs||[],configTemplates:action.configTemplates||[]},rooms:action.apartmentConfig?(0,_configTemplateView.sortRoomList)(action.apartmentConfig.rooms):[],roomTypes:action.roomTypes,projects:action.projects,roomTemplates:action.roomTemplates});case _apartmentConfigView.ROOM_CREATE_REQUEST:case _apartmentConfigView.ROOM_UPDATE_REQUEST:case _apartmentConfigView.ROOMS_UPDATE_REQUEST:return _extends({},state,{room:_extends({},state.room,{error:null,isFetching:true})});case _apartmentConfigView.ROOM_CREATE_FAILURE:case _apartmentConfigView.ROOM_UPDATE_FAILURE:case _apartmentConfigView.ROOMS_UPDATE_FAILURE:return _extends({},state,{room:_extends({},state.room,{error:action.error,isFetching:false})});case _apartmentConfigView.ROOM_CREATE_SUCCESS:return _extends({},state,{room:_extends({},state.room,{active:action.room,error:null,isDirty:false,isFetching:false}),rooms:(0,_configTemplateView.sortRoomList)([].concat(_toConsumableArray(state.rooms),[action.room]))});case _apartmentConfigView.ROOM_UPDATE_SUCCESS:return _extends({},state,{room:_extends({},state.room,{active:action.room,error:null,isDirty:false,isFetching:false}),rooms:(0,_configTemplateView.sortRoomList)([].concat(_toConsumableArray((0,_reject3.default)({id:action.room.id},state.rooms)),[action.room]))});case _apartmentConfigView.ROOMS_UPDATE_SUCCESS:return _extends({},state,{room:{active:!!state.room.active?(0,_find3.default)({id:state.room.active.id},action.rooms):state.room.active,error:null,isDirty:false,isFetching:false},rooms:(0,_configTemplateView.sortRoomList)(action.rooms)});case _apartmentConfigView.PRODUCT_SLOT_UPDATE_REQUEST:case _apartmentConfigView.PRODUCT_SLOT_CREATE_REQUEST:case _apartmentConfigView.PRODUCT_SLOTS_UPDATE_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{error:null,isFetching:true})});case _apartmentConfigView.PRODUCT_SLOT_UPDATE_FAILURE:case _apartmentConfigView.PRODUCT_SLOT_CREATE_FAILURE:case _apartmentConfigView.PRODUCT_SLOTS_UPDATE_FAILURE:return _extends({},state,{productSlot:_extends({},state.productSlot,{error:action.error,isFetching:false})});case _apartmentConfigView.PRODUCT_SLOT_CREATE_SUCCESS:{var _productSlot=action.productSlot,roomId=action.roomId;var currentRoom=_extends({},(0,_find3.default)({id:roomId},state.rooms));currentRoom.productSlots=currentRoom.productSlots?[].concat(_toConsumableArray(currentRoom.productSlots),[_productSlot]):[_productSlot];return _extends({},state,{productSlot:_extends({},state.productSlot,{active:_productSlot,dialog:(0,_configTemplateView.prepareDialog)(state.productSlot.dialog,action),error:null,isDirty:false,isFetching:false,roomId:action.roomId}),rooms:(0,_configTemplateView.sortRoomList)([].concat(_toConsumableArray((0,_reject3.default)({id:currentRoom.id},state.rooms)),[currentRoom]))});}case _apartmentConfigView.PRODUCT_SLOT_UPDATE_SUCCESS:{var _productSlot2=action.productSlot;var _currentRoom=_extends({},(0,_find3.default)(function(r){return(0,_some3.default)({id:_productSlot2.id},r.productSlots);},state.rooms));_currentRoom.productSlots=[].concat(_toConsumableArray((0,_reject3.default)({id:_productSlot2.id},_currentRoom.productSlots)),[_productSlot2]);return _extends({},state,{productSlot:_extends({},state.productSlot,{active:_productSlot2,dialog:(0,_configTemplateView.prepareDialog)(state.productSlot.dialog,action),error:null,isDirty:false,isFetching:false}),rooms:(0,_configTemplateView.sortRoomList)([].concat(_toConsumableArray((0,_reject3.default)({id:_currentRoom.id},state.rooms)),[_currentRoom]))});}case _apartmentConfigView.PRODUCT_SLOTS_UPDATE_SUCCESS:return _extends({},state,{productSlot:_extends({},state.productSlot,{active:!!state.productSlot.active?(0,_find3.default)({id:state.productSlot.active.id},action.productSlots):state.productSlot.active,dialog:!!state.productSlot.active?(0,_configTemplateView.prepareDialog)(state.productSlot.dialog,_extends({},action,{productSlot:(0,_find3.default)({id:state.productSlot.active.id},action.productSlots)||state.productSlot.active})):state.productSlot.dialog,error:null,isDirty:false,isFetching:false}),rooms:(0,_configTemplateView.sortRoomList)([].concat(_toConsumableArray((0,_reject3.default)({id:action.roomId},state.rooms)),[_extends({},(0,_find3.default)({id:action.roomId},state.rooms),{productSlots:(0,_configTemplateView.sortByIndex)(action.productSlots)})]))});case _apartmentConfigView.OPEN_DIALOG_FAILURE:case _apartmentConfigView.NAVIGATE_TO_VARIANT_FAILURE:case _apartmentConfigView.TOGGLE_VARIANT_FAILURE:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.handleError)(state.productSlot.dialog,action)})});case _apartmentConfigView.OPEN_DIALOG_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.openDialogRequest)(state.productSlot.dialog,action)})});case _apartmentConfigView.NAVIGATE_TO_VARIANT_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.navigateToVariantRequest)(state.productSlot.dialog,action)})});case _apartmentConfigView.TOGGLE_VARIANT_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.toggleVariantRequest)(state.productSlot.dialog,action)})});case _apartmentConfigView.OPEN_DIALOG_SUCCESS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.openDialog)(state.productSlot.dialog,action,state.productSlot.active)})});case _apartmentConfigView.NAVIGATE_TO_VARIANT_SUCCESS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.navigateToVariant)(state.productSlot.dialog,action,state.productSlot.active)})});case _apartmentConfigView.POP_DIALOG_NAVIGATION:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.popNavigation)(state.productSlot.dialog,action)})});case _apartmentConfigView.TOGGLE_VARIANT_SUCCESS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.toggleVariant)(state.productSlot.dialog,action,state.productSlot.active)})});case _apartmentConfigView.UPDATE_RELATED_VARIANT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.updateRelatedVariant)(state.productSlot.dialog,action)})});case _apartmentConfigView.SET_STANDARD_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.setStandardProduct)(state.productSlot.dialog,action)})});case _apartmentConfigView.CLEAR_STANDARD_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.clearStandardProduct)(state.productSlot.dialog,action)})});case _apartmentConfigView.CLOSE_DIALOG:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.closeDialog)(state.productSlot.dialog,action)})});case _apartmentConfigView.RESET:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.resetDialog)(state.productSlot.dialog,action,state.productSlot.active)})});case _apartmentConfigView.TOGGLE_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.toggleProduct)(state.productSlot.dialog,action)})});case _apartmentConfigView.CHECK_ALL_VARIANTS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.checkAllVariants)(state.productSlot.dialog,action)})});case _apartmentConfigView.CHECK_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.checkProduct)(state.productSlot.dialog,action)})});case _apartmentConfigView.UPDATE_VARIANTS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.updateVariants)(state.productSlot.dialog,action)})});case _apartmentConfigView.UPDATE_VARIANTS_FOR_TYPE:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.updateVariantsForType)(state.productSlot.dialog,action)})});case _apartmentConfigView.SELECT_ROOM:return _extends({},state,{productSlot:defaultProductSlotState,room:_extends({},state.room,{active:action.room})});case _apartmentConfigView.SELECT_PRODUCT_SLOT:return _extends({},state,{productSlot:_extends({},state.productSlot,{active:action.productSlot,dialog:(0,_configTemplateView.prepareDialog)(state.productSlot.dialog,action),error:null,isDirty:false,roomId:action.roomId}),room:defaultRoomState});case _form.SET_DIRTY:return _extends({},state,{apartmentConfig:_extends({},state.apartmentConfig,{isDirty:action.form==='apartmentConfig'?!!action.dirty:state.apartmentConfig.isDirty}),productSlot:_extends({},state.productSlot,{isDirty:action.form==='apartmentConfigProductSlot'?!!action.dirty:state.productSlot.isDirty}),room:_extends({},state.room,{isDirty:action.form==='apartmentConfigRoom'?!!action.dirty:state.room.isDirty})});case _apartmentConfigView.CLEAR:return defaultState;default:return state;}};exports.default=apartmentConfigView;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _sumBy2=__webpack_require__(121);var _sumBy3=_interopRequireDefault(_sumBy2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _redux=__webpack_require__(15);var _configTemplateList=__webpack_require__(403);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _configTemplateList.FAILURE:return action.error;case _configTemplateList.SUCCESS:return null;default:return state;}};var archived=function archived(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _configTemplateList.FILTER:return action.archived;default:return state;}};var query=function query(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _configTemplateList.FILTER:return action.query;default:return state;}};var filter=(0,_redux.combineReducers)({archived:archived,query:query});var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _configTemplateList.REQUEST:return true;case _configTemplateList.SUCCESS:case _configTemplateList.FAILURE:return false;default:return state;}};var list=function list(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _configTemplateList.SUCCESS:return(0,_map3.default)(function(i){var totalSlots=(0,_sumBy3.default)('productSlots.length',i.rooms);return _extends({},i,{slots:totalSlots});},action.configTemplates);default:return state;}};var isArchived=(0,_filter3.default)(function(t){return(0,_isString3.default)(t.archived);});var notArchived=(0,_filter3.default)({archived:null});var filteredList=function filteredList(){var _ref=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{},archived=_ref.filter.archived,list=_ref.list,filtered=_ref.filteredList,sorter=_ref.sorter;var action=arguments[1];switch(action.type){case _configTemplateList.SUCCESS:case _configTemplateList.FILTER:case _configTemplateList.SORT:return(0,_flow3.default)(archived?isArchived:notArchived,sorter)(list);default:return filtered;}};var sorter=function sorter(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_identity3.default;var action=arguments[1];switch(action.type){case _configTemplateList.SORT:return action.sorter;default:return state;}};var reducers=(0,_redux.combineReducers)({filteredList:function filteredList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return state;},error:error,filter:filter,isFetching:isFetching,list:list,sorter:sorter});var configTemplateList=function configTemplateList(state,action){var newState=reducers(state,action);return _extends({},newState,{filteredList:filteredList(newState,action)});};exports.default=configTemplateList;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _redux=__webpack_require__(15);var _supplierView=__webpack_require__(404);var _form=__webpack_require__(17);var active=function active(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _supplierView.GET_SUCCESS:case _supplierView.UPDATE_SUCCESS:case _supplierView.CREATE_SUCCESS:return action.supplier;case _supplierView.GET_REQUEST:case _supplierView.CLEAR:return null;default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _supplierView.GET_FAILURE:case _supplierView.UPDATE_FAILURE:case _supplierView.CREATE_FAILURE:return action.error;case _supplierView.GET_REQUEST:case _supplierView.GET_SUCCESS:case _supplierView.UPDATE_REQUEST:case _supplierView.UPDATE_SUCCESS:case _supplierView.CREATE_REQUEST:case _supplierView.CREATE_SUCCESS:return null;default:return state;}};var isDirty=function isDirty(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _form.SET_DIRTY:return action.form==='supplier'?action.dirty:state;case _supplierView.GET_SUCCESS:case _supplierView.UPDATE_SUCCESS:case _supplierView.CREATE_SUCCESS:case _supplierView.CLEAR:return false;default:return state;}};var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _supplierView.GET_REQUEST:case _supplierView.UPDATE_REQUEST:case _supplierView.CREATE_REQUEST:return true;case _supplierView.GET_SUCCESS:case _supplierView.GET_FAILURE:case _supplierView.UPDATE_SUCCESS:case _supplierView.UPDATE_FAILURE:case _supplierView.CREATE_SUCCESS:case _supplierView.CREATE_FAILURE:return false;default:return state;}};var supplierView=(0,_redux.combineReducers)({active:active,error:error,isDirty:isDirty,isFetching:isFetching});exports.default=supplierView;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _supplierList=__webpack_require__(405);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultState={isFetching:false,suppliers:[],error:null,filteredList:[],filter:{archived:false,query:null},sorter:_identity3.default};var isArchived=(0,_filter3.default)(function(s){return(0,_isString3.default)(s.archived);});var notArchived=(0,_filter3.default)({archived:null});var suppliersList=function suppliersList(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action=arguments[1];switch(action.type){case _supplierList.GET_REQUEST:return _extends({},state,{isFetching:true,error:null});case _supplierList.GET_SUCCESS:return _extends({},state,{filteredList:(0,_flow3.default)(state.filter.archived?isArchived:notArchived,state.sorter)(action.suppliers),isFetching:false,suppliers:action.suppliers,error:null});case _supplierList.GET_FAILURE:return _extends({},state,{isFetching:false,error:action.error});case _supplierList.FILTER:return _extends({},state,{filteredList:(0,_flow3.default)(action.archived?isArchived:notArchived,state.sorter)(state.suppliers),filter:{archived:action.archived,query:action.query}});case _supplierList.SORT:return _extends({},state,{sorter:action.sorter,filteredList:(0,_flow3.default)(state.filter.archived?isArchived:notArchived,action.sorter)(state.suppliers)});default:return state;}};exports.default=suppliersList;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _actionConfirmation=__webpack_require__(406);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var actionConfirmation=function actionConfirmation(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case _actionConfirmation.TOGGLE_DIALOG:return _extends({},state,_defineProperty({},action.id,!!action.show));default:return state;}};exports.default=actionConfirmation;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _redux=__webpack_require__(15);var _activation=__webpack_require__(407);//  weak
var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _activation.GET_USER_REQUEST:case _activation.ACTIVATION_REQUEST:return true;case _activation.GET_USER_SUCCESS:case _activation.GET_USER_FAILURE:case _activation.ACTIVATION_SUCCESS:case _activation.ACTIVATION_FAILURE:return false;default:return state;}};var tokenError=function tokenError(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _activation.GET_USER_FAILURE:return action.error;case _activation.GET_USER_REQUEST:case _activation.GET_USER_SUCCESS:return null;default:return state;}};var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _activation.ACTIVATION_FAILURE:return action.error;case _activation.ACTIVATION_REQUEST:case _activation.ACTIVATION_SUCCESS:return null;default:return state;}};var user=function user(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _activation.GET_USER_SUCCESS:return action.user;case _activation.GET_USER_REQUEST:return null;default:return state;}};var isActivated=function isActivated(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _activation.ACTIVATION_SUCCESS:return true;default:return state;}};var activation=(0,_redux.combineReducers)({isActivated:isActivated,user:user,error:error,tokenError:tokenError,isFetching:isFetching});exports.default=activation;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _sumBy2=__webpack_require__(121);var _sumBy3=_interopRequireDefault(_sumBy2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _exportsView=__webpack_require__(408);var _redux=__webpack_require__(15);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var defaultFilterOptionsState={projects:[],suppliers:[],productTypes:[],workerTypes:[],roomTypes:[],isFetching:false};var filterOptions=function filterOptions(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultFilterOptionsState;var action=arguments[1];switch(action.type){case _exportsView.GET_FILTERS_SUCCESS:return _extends({},state,action.data,{isFetching:false,error:null});case _exportsView.GET_FILTERS_REQUEST:return _extends({},state,{isFetching:true,error:null});case _exportsView.GET_FILTERS_FAILURE:return _extends({},state,{isFetching:true,error:action.error});default:return state;}};var defaultCurrentSelectionState={rows:[],projects:[],suppliers:[],productTypes:[],workerTypes:[],roomTypes:[],assortments:[],downloadUri:null,isFetching:false,totalQuantity:0,totalPrice:0};var currentSelection=function currentSelection(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultCurrentSelectionState;var action=arguments[1];switch(action.type){case _exportsView.GET_FILTERS_SUCCESS:return defaultCurrentSelectionState;case _exportsView.FETCH_DATA_SUCCESS:return _extends({},state,action.data,{totalQuantity:(0,_sumBy3.default)('quantity',action.data.rows),totalPrice:(0,_sumBy3.default)('price',action.data.rows),isFetching:false,error:null});case _exportsView.FETCH_DATA_REQUEST:return _extends({},state,{isFetching:true,error:null});case _exportsView.FETCH_DATA_FAILURE:return _extends({},state,{isFetching:false,error:action.error});default:return state;}};exports.default=(0,_redux.combineReducers)({currentSelection:currentSelection,filterOptions:filterOptions});

/***/ }),
/* 943 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

module.exports = join;


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _head2=__webpack_require__(237);var _head3=_interopRequireDefault(_head2);var _getOr2=__webpack_require__(205);var _getOr3=_interopRequireDefault(_getOr2);var _redux=__webpack_require__(15);var _salesView=__webpack_require__(409);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var error=function error(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _salesView.PROJECTS_REQUEST:case _salesView.PROJECTS_SUCCESS:return null;case _salesView.PROJECTS_FAILURE:return action.error;default:return state;}};var isFetching=function isFetching(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case _salesView.PROJECTS_REQUEST:return true;case _salesView.PROJECTS_SUCCESS:case _salesView.PROJECTS_FAILURE:return false;default:return state;}};var projects=function projects(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case _salesView.PROJECTS_REQUEST:return[];case _salesView.PROJECTS_SUCCESS:return action.projects;default:return state;}};var projectId=function projectId(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case _salesView.FILTER:return action.projectId;case _salesView.PROJECTS_SUCCESS:return state||(0,_getOr3.default)(null,'id',(0,_head3.default)(action.projects));default:return state;}};exports.default=(0,_redux.combineReducers)({error:error,isFetching:isFetching,projects:projects,projectId:projectId});

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _purchaseReportView=__webpack_require__(410);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {
  Apartment,
  Entity,
  Project,
  PurchaseReportAction,
} from '../actions/purchaseReportView';*//*:: import type {Exact} from './configTemplateView';*//*:: export type PurchaseReportState = {
  apartmentIds: number[],
  apartments: Apartment[],
  error: ?any,
  isFetching: boolean,
  projectId: ?number,
  projects: Project[],
  supplierId: ?number,
  suppliers: Entity[],
  includePlans: boolean,
}*/var defaultState/*: PurchaseReportState*/={apartmentIds:[],apartments:[],error:null,isFetching:false,projectId:null,projects:[],supplierId:null,suppliers:[],includePlans:false,linebreakPerApartment:false};var purchaseReportView=function purchaseReportView()/*: Exact<PurchaseReportState>*/{var state/*: PurchaseReportState*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action/*: PurchaseReportAction*/=arguments[1];switch(action.type){case _purchaseReportView.DATA_REQUEST:return _extends({},state,{isFetching:true});case _purchaseReportView.DATA_SUCCESS:return _extends({},state,{isFetching:false,apartmentIds:[],apartments:[],projectId:null,projects:(0,_sortBy3.default)([function(x){return x.name;}],action.data.projects),supplierId:null,suppliers:(0,_sortBy3.default)([function(x){return x.name;}],action.data.suppliers),includePlans:false,linebreakPerApartment:false});case _purchaseReportView.DATA_FAILURE:return _extends({},state,{error:action.error,isFetching:false});case _purchaseReportView.FILTER:var newProject=state.projectId!==action.projectId;var _apartments=state.apartments;if(!!newProject){var project=(0,_find3.default)({id:action.projectId},state.projects);_apartments=!!project?project.apartments:[];}var _apartmentIds=newProject?[]:action.apartmentIds;return _extends({},state,{apartmentIds:_apartmentIds,apartments:(0,_sortBy3.default)([function(x){return x.objectId;}],_apartments),projectId:action.projectId,supplierId:action.supplierId,includePlans:_apartmentIds.length===1?!!action.includePlans:false,linebreakPerApartment:_apartmentIds.length===0||_apartmentIds.length>1?!!action.linebreakPerApartment:false});default:return state;}};exports.default=purchaseReportView;

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _siteManagerReportView=__webpack_require__(411);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {
  Apartment,
  Project,
} from '../actions/purchaseReportView';*//*:: import type {SiteManagerReportAction} from '../actions/siteManagerReportView';*//*:: import type {ErrorDto} from '../dtos';*//*:: import type {Exact} from './configTemplateView';*//*:: export type SiteManagerReportState = {
  apartmentIds: number[],
  apartments: Apartment[],
  error: ?ErrorDto,
  isFetching: boolean,
  projectId: ?number,
  projects: Project[],
  includePlans: boolean
}*/var defaultState/*: SiteManagerReportState*/={apartmentIds:[],apartments:[],error:null,isFetching:false,projectId:null,projects:[],includePlans:false};var siteManagerReportView=function siteManagerReportView()/*: Exact<SiteManagerReportState>*/{var state/*: SiteManagerReportState*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action/*: SiteManagerReportAction*/=arguments[1];switch(action.type){case _siteManagerReportView.DATA_REQUEST:return _extends({},state,{isFetching:true});case _siteManagerReportView.DATA_SUCCESS:return _extends({},state,{isFetching:false,apartmentIds:[],apartments:[],projectId:null,projects:(0,_sortBy3.default)([function(x){return x.name;}],action.projects),includePlans:false});case _siteManagerReportView.DATA_FAILURE:return _extends({},state,{error:action.error,isFetching:false});case _siteManagerReportView.FILTER:var newProject=state.projectId!==action.projectId;var _apartments=state.apartments;if(!!newProject){var project=(0,_find3.default)({id:action.projectId},state.projects);_apartments=!!project?project.apartments:[];}return _extends({},state,{apartmentIds:newProject?[]:action.apartmentIds,apartments:(0,_sortBy3.default)([function(x){return x.objectId;}],_apartments),projectId:action.projectId,includePlans:!!action.includePlans});default:return state;}};exports.default=siteManagerReportView;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isString2=__webpack_require__(48);var _isString3=_interopRequireDefault(_isString2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _identity2=__webpack_require__(37);var _identity3=_interopRequireDefault(_identity2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _roomTemplateList=__webpack_require__(412);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/*:: import type {
  RoomTemplateListAction,
} from '../actions/roomTemplateList';*//*:: import type {
  ErrorDto,
  RoomTemplateDto,
} from '../dtos';*//*:: import type {
  Exact,
} from './configTemplateView';*//*:: export type FilterState = {
  archived: boolean,
  query: ?string,
};*//*:: export type State_ = {
  filteredList: RoomTemplateDto[],
  list: RoomTemplateDto[],
  error: ?ErrorDto,
  isFetching: boolean,
  filter: FilterState,
  sorter: Function,
};*//*:: export type State = {
  filteredList: RoomTemplateDto[],
  list: RoomTemplateDto[],
  error: ?ErrorDto,
  isFetching: boolean,
  filter: Exact<FilterState>,
  sorter: Function,
};*/var defaultState/*: State_*/={filteredList:[],list:[],error:null,isFetching:false,filter:{archived:false,query:null},sorter:_identity3.default};var isArchived=(0,_filter3.default)(function(t){return(0,_isString3.default)(t.archived);});var notArchived=(0,_filter3.default)({archived:null});var roomTemplateList=function roomTemplateList()/*: State*/{var state/*: State_*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action/*: RoomTemplateListAction*/=arguments[1];switch(action.type){case _roomTemplateList.REQUEST:return _extends({},state,{isFetching:true});case _roomTemplateList.SUCCESS:var _list=[].concat(_toConsumableArray(action.roomTemplates));return _extends({},state,{error:null,filteredList:(0,_flow3.default)(!!state.filter.archived?isArchived:notArchived,state.sorter)(_list),isFetching:false,list:_list});case _roomTemplateList.FAILURE:return _extends({},state,{error:action.error,isFetching:false});case _roomTemplateList.FILTER:return _extends({},state,{filter:{archived:!!action.archived,query:action.query},filteredList:(0,_flow3.default)(!!action.archived?isArchived:notArchived,state.sorter)(state.list)});case _roomTemplateList.SORT:return _extends({},state,{sorter:action.sorter,filteredList:(0,_flow3.default)(!!state.filter.archived?isArchived:notArchived,action.sorter)(state.list)});default:return state;}};exports.default=roomTemplateList;

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _isUndefined2=__webpack_require__(949);var _isUndefined3=_interopRequireDefault(_isUndefined2);var _reject2=__webpack_require__(68);var _reject3=_interopRequireDefault(_reject2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _roomTemplateView=__webpack_require__(413);var _form=__webpack_require__(17);var _uuid=__webpack_require__(53);var _uuid2=_interopRequireDefault(_uuid);var _configTemplateView=__webpack_require__(124);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/*:: import type {
  RoomTemplateViewAction,
} from '../actions/roomTemplateView';*//*:: import type {
  FormAction,
} from '../actions/form';*//*:: import type {
  ConfigTemplateState as RoomTemplateViewState,
  DialogState,
  Exact,
  ProductsState,
  ProductTypesState,
  ProjectsState,
  RoomTypesState,
} from './configTemplateView';*//*:: import type {
  ErrorDto,
  ProductSlotDto,
  RoomTemplateDto,
} from '../dtos';*//*:: export type RoomTemplatesState = RoomTemplateDto[];*//*:: export type ProductSlotsState = ProductSlotDto[];*//*:: export type ProductSlotState = {
  active: ?any,
  dialog: DialogState,
  error: ?ErrorDto,
  isDirty: bool,
  isFetching: bool,
};*//*:: export type State_ = {
  roomTemplate: RoomTemplateViewState,
  products: ProductsState,
  productSlot: ProductSlotState,
  productTypes: ProductTypesState,
  productSlots: ProductSlotsState,
  roomTypes: RoomTypesState,
  roomTemplates: RoomTemplatesState,
  projects: ProjectsState,
};*//*:: type State = {
  roomTemplate: Exact<RoomTemplateViewState>,
  products: ProductsState,
  productSlot: Exact<ProductSlotState>,
  productTypes: ProductTypesState,
  productSlots: ProductSlotsState,
  roomTypes: RoomTypesState,
  roomTemplates: RoomTemplatesState,
  projects: ProjectsState,
};*/var defaultRoomTemplateState/*: RoomTemplateViewState*/={active:null,error:null,isDirty:false,isFetching:false};var defaultProductSlotState/*: ProductSlotState*/={active:null,dialog:_configTemplateView.defaultDialogState,error:null,isDirty:false,isFetching:false};var defaultRoomTemplatesState/*: RoomTemplatesState*/=[];var defaultProjectsState/*: ProjectsState*/=[];var defaultProductSlotsState/*: ProductSlotsState*/=[];var defaultRoomTypesState/*: RoomTypesState*/=[];var defaultProductTypesState/*: ProductTypesState*/=[];var defaultProductsState/*: ProductsState*/=[];var defaultState/*: State_*/={roomTemplate:defaultRoomTemplateState,products:defaultProductsState,productSlot:defaultProductSlotState,productTypes:defaultProductTypesState,productSlots:defaultProductSlotsState,roomTypes:defaultRoomTypesState,roomTemplates:defaultRoomTemplatesState,projects:defaultProjectsState};var roomTemplateView=function roomTemplateView()/*: Exact<State>*/{var state/*: State_*/=arguments.length>0&&arguments[0]!==undefined?arguments[0]:defaultState;var action/*: RoomTemplateViewAction | FormAction*/=arguments[1];switch(action.type){case _roomTemplateView.GET_REQUEST:return _extends({},state,{roomTemplate:_extends({},state.roomTemplate,{active:null,error:null,isFetching:true}),products:defaultProductsState,productTypes:defaultProductTypesState,roomTypes:defaultRoomTypesState});case _roomTemplateView.CREATE_REQUEST:case _roomTemplateView.UPDATE_REQUEST:return _extends({},state,{roomTemplate:_extends({},state.roomTemplate,{error:null,isFetching:true})});case _roomTemplateView.CREATE_FAILURE:case _roomTemplateView.GET_FAILURE:case _roomTemplateView.UPDATE_FAILURE:return _extends({},state,{roomTemplate:_extends({},state.roomTemplate,{error:action.error,isFetching:false})});case _roomTemplateView.CREATE_SUCCESS:return _extends({},state,{roomTemplate:_extends({},state.roomTemplate,{active:action.roomTemplate,error:null,isDirty:false,isFetching:false}),productSlots:action.roomTemplate?(0,_configTemplateView.sortRoomList)(action.roomTemplate.productSlots):[]});case _roomTemplateView.GET_SUCCESS:{var _projects=action.projects||[];return _extends({},state,{roomTemplate:_extends({},state.roomTemplate,{active:action.roomTemplate,error:null,isDirty:false,isFetching:false}),products:action.products,productTypes:action.productTypes,productSlots:action.roomTemplate?(0,_configTemplateView.sortRoomList)(action.roomTemplate.productSlots):[],roomTypes:action.roomTypes,roomTemplates:action.roomTemplates||[],projects:_projects});}case _roomTemplateView.UPDATE_SUCCESS:return _extends({},state,{roomTemplate:_extends({},state.roomTemplate,{active:action.roomTemplate,error:null,isDirty:false,isFetching:false})});case _roomTemplateView.CLOSE_DIALOG:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.closeDialog)(state.productSlot.dialog,action)})});case _roomTemplateView.RESET:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.resetDialog)(state.productSlot.dialog,action,state.productSlot.active)})});case _roomTemplateView.NAVIGATE_TO_VARIANT_FAILURE:case _roomTemplateView.OPEN_DIALOG_FAILURE:case _roomTemplateView.TOGGLE_VARIANT_FAILURE:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.handleError)(state.productSlot.dialog,action)})});case _roomTemplateView.NAVIGATE_TO_VARIANT_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.navigateToVariantRequest)(state.productSlot.dialog,action)})});case _roomTemplateView.NAVIGATE_TO_VARIANT_SUCCESS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.navigateToVariant)(state.productSlot.dialog,action,state.productSlot.active)})});case _roomTemplateView.OPEN_DIALOG_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.openDialogRequest)(state.productSlot.dialog,action)})});case _roomTemplateView.OPEN_DIALOG_SUCCESS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.openDialog)(state.productSlot.dialog,action,state.productSlot.active)})});case _roomTemplateView.POP_DIALOG_NAVIGATION:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.popNavigation)(state.productSlot.dialog,action)})});case _roomTemplateView.SET_STANDARD_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.setStandardProduct)(state.productSlot.dialog,action)})});case _roomTemplateView.CLEAR_STANDARD_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.clearStandardProduct)(state.productSlot.dialog,action)})});case _roomTemplateView.TOGGLE_VARIANT_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.toggleVariantRequest)(state.productSlot.dialog,action)})});case _roomTemplateView.TOGGLE_VARIANT_SUCCESS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.toggleVariant)(state.productSlot.dialog,action,state.productSlot.active)})});case _roomTemplateView.UPDATE_RELATED_VARIANT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.updateRelatedVariant)(state.productSlot.dialog,action)})});case _roomTemplateView.TOGGLE_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.toggleProduct)(state.productSlot.dialog,action)})});case _roomTemplateView.CHECK_ALL_VARIANTS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.checkAllVariants)(state.productSlot.dialog,action)})});case _roomTemplateView.CHECK_PRODUCT:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.checkProduct)(state.productSlot.dialog,action)})});case _roomTemplateView.PRODUCT_SLOT_CREATE_REQUEST:case _roomTemplateView.PRODUCT_SLOT_UPDATE_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{error:null,isFetching:true})});case _roomTemplateView.PRODUCT_SLOT_CREATE_FAILURE:case _roomTemplateView.PRODUCT_SLOT_UPDATE_FAILURE:return _extends({},state,{productSlot:_extends({},state.productSlot,{error:action.error,isFetching:false})});case _roomTemplateView.PRODUCT_SLOT_CREATE_SUCCESS:{var _productSlot=action.productSlot;return _extends({},state,{productSlot:_extends({},state.productSlot,{active:_productSlot,dialog:(0,_configTemplateView.prepareDialog)(state.productSlot.dialog,action),error:null,isDirty:false,isFetching:false}),productSlots:(0,_configTemplateView.sortByIndex)([].concat(_toConsumableArray((0,_reject3.default)(function(x){return(0,_isUndefined3.default)(x.id);},state.productSlots)),[_productSlot]))});}case _roomTemplateView.PRODUCT_SLOT_UPDATE_SUCCESS:{var _productSlot2=action.productSlot;return _extends({},state,{productSlot:_extends({},state.productSlot,{active:_productSlot2,dialog:(0,_configTemplateView.prepareDialog)(state.productSlot.dialog,action),error:null,isDirty:false,isFetching:false}),productSlots:(0,_configTemplateView.sortByIndex)([].concat(_toConsumableArray((0,_reject3.default)({id:_productSlot2.id},state.productSlots)),[_productSlot2]))});}case _roomTemplateView.SELECT_PRODUCT_SLOT:return _extends({},state,{productSlot:_extends({},state.productSlot,{active:action.productSlot||{uuid:_uuid2.default.v4(),advanced:false},dialog:(0,_configTemplateView.prepareDialog)(state.productSlot.dialog,action)})});case _form.SET_DIRTY:return _extends({},state,{roomTemplate:_extends({},state.roomTemplate,{isDirty:action.form==='roomTemplate'?action.dirty:state.roomTemplate.isDirty}),productSlot:_extends({},state.productSlot,{isDirty:action.form==='roomTemplateProductSlot'?action.dirty:state.productSlot.isDirty})});case _roomTemplateView.UPDATE_VARIANTS:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.updateVariants)(state.productSlot.dialog,action)})});case _roomTemplateView.UPDATE_VARIANTS_FOR_TYPE:return _extends({},state,{productSlot:_extends({},state.productSlot,{dialog:(0,_configTemplateView.updateVariantsForType)(state.productSlot.dialog,action)})});case _roomTemplateView.PRODUCT_SLOTS_UPDATE_REQUEST:return _extends({},state,{productSlot:_extends({},state.productSlot,{error:null,isFetching:true})});case _roomTemplateView.PRODUCT_SLOTS_UPDATE_FAILURE:return _extends({},state,{productSlot:_extends({},state.productSlot,{error:action.error,isFetching:false})});case _roomTemplateView.PRODUCT_SLOTS_UPDATE_SUCCESS:{var _productSlot3=_extends({},(0,_find3.default)({id:action.productSlotId},action.productSlots))||state.productSlot.active;return _extends({},state,{productSlot:_extends({},state.productSlot,{active:_productSlot3,dialog:(0,_configTemplateView.prepareDialog)(state.productSlot.dialog,_extends({},action,{productSlot:_productSlot3})),error:null,isDirty:false,isFetching:false}),productSlots:(0,_configTemplateView.sortByIndex)([].concat(_toConsumableArray(action.productSlots)))});}case _roomTemplateView.CLEAR:return defaultState;default:return state;}};exports.default=roomTemplateView;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('isUndefined', __webpack_require__(950), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 950 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

module.exports = isUndefined;


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _App=__webpack_require__(952);var _App2=_interopRequireDefault(_App);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  isAuthenticated: boolean,
};*/var _ref2=_react2.default.createElement(_App2.default,null);var _ref3=_react2.default.createElement(_reactRouterDom.Redirect,{to:'/login'});var AuthenticationWrapper=function AuthenticationWrapper(_ref){var isAuthenticated=_ref.isAuthenticated;return isAuthenticated?_ref2:_ref3;};exports.default=(0,_reactRedux.connect)(function(_ref4){var isAuthenticated=_ref4.auth.isAuthenticated;return{isAuthenticated:isAuthenticated};},function(){return{};})(AuthenticationWrapper);

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _roles=__webpack_require__(49);var _auth=__webpack_require__(57);var _AdminContainer=__webpack_require__(953);var _AdminContainer2=_interopRequireDefault(_AdminContainer);var _CustomerContainer=__webpack_require__(1340);var _CustomerContainer2=_interopRequireDefault(_CustomerContainer);var _SiteManagerContainer=__webpack_require__(1348);var _SiteManagerContainer2=_interopRequireDefault(_SiteManagerContainer);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);__webpack_require__(1350);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  currentUser: ?any,
  getSelf: Function,
};*/var _ref=_react2.default.createElement(_AdminContainer2.default,{pathname:'/admin'});var _ref2=_react2.default.createElement(_SiteManagerContainer2.default,null);var _ref3=_react2.default.createElement(_LoadingIndicator2.default,{isLoading:true});var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);return _possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).apply(this,arguments));}_createClass(App,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.currentUser){this.props.getSelf();}}},{key:'render',value:function render(){var currentUser=this.props.currentUser;return _react2.default.createElement('div',{className:'App'},currentUser&&currentUser.role===_roles.ADMIN&&_ref,currentUser&&(currentUser.role===_roles.CUSTOMER||currentUser.role===_roles.DEMO)&&_react2.default.createElement(_CustomerContainer2.default,{user:currentUser}),currentUser&&currentUser.role===_roles.SITE_MANAGER&&_ref2,!currentUser&&_ref3);}}]);return App;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref4){var currentUser=_ref4.auth.currentUser;return{currentUser:currentUser};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{getSelf:function getSelf(){return dispatch((0,_auth.getSelf)());}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(App);

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toInteger2=__webpack_require__(954);var _toInteger3=_interopRequireDefault(_toInteger2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};//  weak
var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _ApartmentContainer=__webpack_require__(955);var _ApartmentContainer2=_interopRequireDefault(_ApartmentContainer);var _ApartmentConfigContainer=__webpack_require__(1079);var _ApartmentConfigContainer2=_interopRequireDefault(_ApartmentConfigContainer);var _UsersContainer=__webpack_require__(1094);var _UsersContainer2=_interopRequireDefault(_UsersContainer);var _UserContainer=__webpack_require__(1137);var _UserContainer2=_interopRequireDefault(_UserContainer);var _WorkerTypesContainer=__webpack_require__(1140);var _WorkerTypesContainer2=_interopRequireDefault(_WorkerTypesContainer);var _WorkerTypeContainer=__webpack_require__(1141);var _WorkerTypeContainer2=_interopRequireDefault(_WorkerTypeContainer);var _ProjectCreationContainer=__webpack_require__(1143);var _ProjectCreationContainer2=_interopRequireDefault(_ProjectCreationContainer);var _ProjectEditingContainer=__webpack_require__(1146);var _ProjectEditingContainer2=_interopRequireDefault(_ProjectEditingContainer);var _ProjectsContainer=__webpack_require__(1151);var _ProjectsContainer2=_interopRequireDefault(_ProjectsContainer);var _ProductTypesContainer=__webpack_require__(1154);var _ProductTypesContainer2=_interopRequireDefault(_ProductTypesContainer);var _ProductTypeContainer=__webpack_require__(1155);var _ProductTypeContainer2=_interopRequireDefault(_ProductTypeContainer);var _ProductContainer=__webpack_require__(1157);var _ProductContainer2=_interopRequireDefault(_ProductContainer);var _ProductsContainer=__webpack_require__(1174);var _ProductsContainer2=_interopRequireDefault(_ProductsContainer);var _RoomTypesContainer=__webpack_require__(1175);var _RoomTypesContainer2=_interopRequireDefault(_RoomTypesContainer);var _RoomTypeContainer=__webpack_require__(1176);var _RoomTypeContainer2=_interopRequireDefault(_RoomTypeContainer);var _DeviationsContainer=__webpack_require__(1178);var _DeviationsContainer2=_interopRequireDefault(_DeviationsContainer);var _ExportsContainer=__webpack_require__(1179);var _ExportsContainer2=_interopRequireDefault(_ExportsContainer);var _SalesContainer=__webpack_require__(1180);var _SalesContainer2=_interopRequireDefault(_SalesContainer);var _PurchaseOrderReportContainer=__webpack_require__(178);var _PurchaseOrderReportContainer2=_interopRequireDefault(_PurchaseOrderReportContainer);var _SiteManagerReportContainer=__webpack_require__(481);var _SiteManagerReportContainer2=_interopRequireDefault(_SiteManagerReportContainer);var _DeviationContainer=__webpack_require__(1182);var _DeviationContainer2=_interopRequireDefault(_DeviationContainer);var _SuppliersContainer=__webpack_require__(1184);var _SuppliersContainer2=_interopRequireDefault(_SuppliersContainer);var _SupplierContainer=__webpack_require__(1185);var _SupplierContainer2=_interopRequireDefault(_SupplierContainer);var _AdminNavbar=__webpack_require__(482);var _AdminNavbar2=_interopRequireDefault(_AdminNavbar);var _auth=__webpack_require__(57);var _OrdersContainer=__webpack_require__(483);var _OrdersContainer2=_interopRequireDefault(_OrdersContainer);var _OrderContainer=__webpack_require__(1188);var _OrderContainer2=_interopRequireDefault(_OrderContainer);var _CustomRowContainer=__webpack_require__(1264);var _CustomRowContainer2=_interopRequireDefault(_CustomRowContainer);var _AdminCustomerContainer=__webpack_require__(1266);var _AdminCustomerContainer2=_interopRequireDefault(_AdminCustomerContainer);var _PurchaseOrderContainer=__webpack_require__(1316);var _PurchaseOrderContainer2=_interopRequireDefault(_PurchaseOrderContainer);var _PurchaseOrdersContainer=__webpack_require__(1325);var _PurchaseOrdersContainer2=_interopRequireDefault(_PurchaseOrdersContainer);var _ConfigTemplatesContainer=__webpack_require__(1326);var _ConfigTemplatesContainer2=_interopRequireDefault(_ConfigTemplatesContainer);var _ConfigTemplateContainer=__webpack_require__(1327);var _ConfigTemplateContainer2=_interopRequireDefault(_ConfigTemplateContainer);var _RoomTemplatesContainer=__webpack_require__(1332);var _RoomTemplatesContainer2=_interopRequireDefault(_RoomTemplatesContainer);var _RoomTemplateContainer=__webpack_require__(1333);var _RoomTemplateContainer2=_interopRequireDefault(_RoomTemplateContainer);__webpack_require__(1339);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  location: { pathname: string },
  onLogoutClick: Function,
};*/var _ref2=_react2.default.createElement('div',{className:'MenuItem-label'},'Projekt');var _ref3=_react2.default.createElement('div',{className:'MenuItem-label'},'Best\xE4llningar');var _ref4=_react2.default.createElement('div',{className:'MenuItem-label'},'Ink\xF6p');var _ref5=_react2.default.createElement('hr',null);var _ref6=_react2.default.createElement('div',{className:'MenuItem-label'},'Produkter');var _ref7=_react2.default.createElement('div',{className:'MenuItem-label'},'Produkttyper');var _ref8=_react2.default.createElement('div',{className:'MenuItem-label'},'Yrkeskategorier');var _ref9=_react2.default.createElement('div',{className:'MenuItem-label'},'Rumstyper');var _ref10=_react2.default.createElement('div',{className:'MenuItem-label'},'Leverant\xF6rer');var _ref11=_react2.default.createElement('hr',null);var _ref12=_react2.default.createElement('div',{className:'MenuItem-label'},'Konfigurationsmallar');var _ref13=_react2.default.createElement('div',{className:'MenuItem-label'},'Rumsmallar');var _ref14=_react2.default.createElement('div',{className:'MenuItem-label'},'Anv\xE4ndare');var _ref15=_react2.default.createElement('div',{className:'MenuItem-label'},'Avvikelser');var _ref16=_react2.default.createElement('hr',null);var _ref17=_react2.default.createElement('div',{className:'MenuItem-label'},'Produktrapport');var _ref18=_react2.default.createElement('div',{className:'MenuItem-label'},'Ekonomirapport');var _ref19=_react2.default.createElement('div',{className:'MenuItem-label'},'Ink\xF6psrapport');var _ref20=_react2.default.createElement('div',{className:'MenuItem-label'},'Platschefsrapport');var _ref48=_react2.default.createElement(_OrdersContainer2.default,{readonly:false});var AdminContainer=function AdminContainer(_ref){var _ref$location=_ref.location;_ref$location=_ref$location===undefined?{}:_ref$location;var _ref$location$pathnam=_ref$location.pathname,pathname=_ref$location$pathnam===undefined?'':_ref$location$pathnam,onLogoutClick=_ref.onLogoutClick;return _react2.default.createElement(_reactRouterDom.BrowserRouter,null,_react2.default.createElement('div',{className:'AdminContainer'},_react2.default.createElement(_AdminNavbar2.default,{onLogoutClick:onLogoutClick}),_react2.default.createElement('div',{className:'row content'},_react2.default.createElement('div',{className:'shrink column'},_react2.default.createElement('div',{className:'Sidebar'},_react2.default.createElement('div',{className:'Sidebar-content'},_react2.default.createElement('div',{className:'AdminMenu'},_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/projects',className:'AdminMenu-item',activeClassName:'active'},_ref2),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/orders',className:'AdminMenu-item',activeClassName:'active'},_ref3),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/purchaseorders',className:'AdminMenu-item',activeClassName:'active'},_ref4),_ref5,_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/products',className:'AdminMenu-item',activeClassName:'active'},_ref6),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/productTypes',className:'AdminMenu-item',activeClassName:'active'},_ref7),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/workertypes',className:'AdminMenu-item',activeClassName:'active'},_ref8),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/roomTypes',className:'AdminMenu-item',activeClassName:'active'},_ref9),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/suppliers',className:'AdminMenu-item',activeClassName:'active'},_ref10),_ref11,_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/configtemplates',className:'AdminMenu-item',activeClassName:'active'},_ref12),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/roomtemplates',className:'AdminMenu-item',activeClassName:'active'},_ref13),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/users',className:'AdminMenu-item',activeClassName:'active'},_ref14),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/deviations',className:'AdminMenu-item',activeClassName:'active'},_ref15),_ref16,_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/exports',className:'AdminMenu-item',activeClassName:'active'},_ref17),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/sales',className:'AdminMenu-item',activeClassName:'active'},_ref18),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/purchasereport',className:'AdminMenu-item',activeClassName:'active'},_ref19),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/sitemanagerreport',className:'AdminMenu-item',activeClassName:'active'},_ref20))))),_react2.default.createElement('div',{className:'small-12 large-expand column flex'},_react2.default.createElement(_reactRouterDom.Switch,null,_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/apartments/:id(\\d+)',render:function render(_ref21){var params=_ref21.match.params;return _react2.default.createElement(_ApartmentContainer2.default,{params:params,resourcePath:pathname+'/apartments',projectPath:pathname+'/projects/'+params.projectId});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/configtemplates',exact:true,component:_ConfigTemplatesContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/configtemplates/new',exact:true,render:function render(_ref22){var params=_ref22.match.params;return _react2.default.createElement(_ConfigTemplateContainer2.default,{params:params,prevPath:pathname+'/configtemplates'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/configtemplates/:id(\\d+)',render:function render(_ref23){var params=_ref23.match.params;return _react2.default.createElement(_ConfigTemplateContainer2.default,{params:params,prevPath:pathname+'/configtemplates'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/roomtemplates',exact:true,component:_RoomTemplatesContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/roomtemplates/new',exact:true,render:function render(_ref24){var params=_ref24.match.params;return _react2.default.createElement(_RoomTemplateContainer2.default,{params:params,prevPath:pathname+'/roomtemplates'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/roomtemplates/:id(\\d+)',render:function render(_ref25){var params=_ref25.match.params;return _react2.default.createElement(_RoomTemplateContainer2.default,{params:params,prevPath:pathname+'/roomtemplates'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/users',exact:true,component:_UsersContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/users/new',exact:true,render:function render(_ref26){var params=_ref26.match.params;return _react2.default.createElement(_UserContainer2.default,{params:params,prevPath:pathname+'/users'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/users/:id(\\d+)',render:function render(_ref27){var params=_ref27.match.params;return _react2.default.createElement(_UserContainer2.default,{params:params,prevPath:pathname+'/users'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/projects',exact:true,component:_ProjectsContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/projects/new',exact:true,render:function render(_ref28){var params=_ref28.match.params;return _react2.default.createElement(_ProjectCreationContainer2.default,{params:params,prevPath:pathname+'/projects'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/projects/:projectId(\\d+)/apartments/new',render:function render(_ref29){var params=_ref29.match.params;return _react2.default.createElement(_ApartmentContainer2.default,{params:params,projectId:(0,_toInteger3.default)(params.projectId),resourcePath:pathname+'/projects/'+params.projectId+'/apartments',projectPath:pathname+'/projects/'+params.projectId});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/projects/:projectId(\\d+)/apartments/:id(\\d+)',render:function render(_ref30){var params=_ref30.match.params;return _react2.default.createElement(_ApartmentContainer2.default,{params:params,orderPath:pathname+'/orders',resourcePath:pathname+'/projects/'+params.projectId+'/apartments',projectPath:pathname+'/projects/'+params.projectId});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/projects/:projectId(\\d+)/apartmentconfigurations/new',render:function render(_ref31){var params=_ref31.match.params;return _react2.default.createElement(_ApartmentConfigContainer2.default,{params:params,projectId:params.projectId,resourcePath:pathname+'/projects/'+params.projectId+'/apartmentconfigurations'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/projects/:projectId(\\d+)/apartmentconfigurations/:id(\\d+)',render:function render(_ref32){var params=_ref32.match.params;return _react2.default.createElement(_ApartmentConfigContainer2.default,{params:params,prevPath:pathname+'/projects/'+params.projectId,resourcePath:pathname+'/projects/'+params.projectId+'/apartmentconfigurations'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/projects/:id(\\d+)',render:function render(_ref33){var params=_ref33.match.params;return _react2.default.createElement(_ProjectEditingContainer2.default,{params:params,prevPath:pathname+'/projects'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/productTypes',exact:true,component:_ProductTypesContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/productTypes/new',exact:true,render:function render(_ref34){var params=_ref34.match.params;return _react2.default.createElement(_ProductTypeContainer2.default,{params:params,prevPath:pathname+'/productTypes'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/productTypes/:id(\\d+)',render:function render(_ref35){var params=_ref35.match.params;return _react2.default.createElement(_ProductTypeContainer2.default,{params:params,prevPath:pathname+'/productTypes'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/products',exact:true,component:_ProductsContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/products/new',exact:true,render:function render(_ref36){var params=_ref36.match.params;return _react2.default.createElement(_ProductContainer2.default,{key:'new',params:params,copy:false,resourcePath:pathname+'/products'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/products/:id(\\d+)/variants/:variantId(\\d+)',render:function render(_ref37){var params=_ref37.match.params;return _react2.default.createElement(_ProductContainer2.default,{key:'notcopy',params:params,copy:false,resourcePath:pathname+'/products'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/products/:id(\\d+)/copy',render:function render(_ref38){var params=_ref38.match.params;return _react2.default.createElement(_ProductContainer2.default,{key:'copy',params:_extends({},params),copy:true,resourcePath:pathname+'/products'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/products/:id(\\d+)',render:function render(_ref39){var params=_ref39.match.params;return _react2.default.createElement(_ProductContainer2.default,{key:'notcopy',params:params,copy:false,resourcePath:pathname+'/products'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/workertypes',exact:true,component:_WorkerTypesContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/workertypes/new',exact:true,render:function render(_ref40){var params=_ref40.match.params;return _react2.default.createElement(_WorkerTypeContainer2.default,{params:params,prevPath:pathname+'/workertypes'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/workertypes/:id(\\d+)',render:function render(_ref41){var params=_ref41.match.params;return _react2.default.createElement(_WorkerTypeContainer2.default,{params:params,prevPath:pathname+'/workertypes'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/roomTypes',exact:true,component:_RoomTypesContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/roomTypes/new',exact:true,render:function render(_ref42){var params=_ref42.match.params;return _react2.default.createElement(_RoomTypeContainer2.default,{params:params,prevPath:pathname+'/roomTypes'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/roomTypes/:id(\\d+)',render:function render(_ref43){var params=_ref43.match.params;return _react2.default.createElement(_RoomTypeContainer2.default,{params:params,prevPath:pathname+'/roomTypes'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/deviations',exact:true,component:_DeviationsContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/deviations/new',exact:true,render:function render(_ref44){var params=_ref44.match.params;return _react2.default.createElement(_DeviationContainer2.default,{params:params,prevPath:pathname+'/deviations'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/deviations/:id(\\d+)',render:function render(_ref45){var params=_ref45.match.params;return _react2.default.createElement(_DeviationContainer2.default,{params:params,prevPath:pathname+'/deviations'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/suppliers',exact:true,component:_SuppliersContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/suppliers/new',exact:true,render:function render(_ref46){var params=_ref46.match.params;return _react2.default.createElement(_SupplierContainer2.default,{params:params,prevPath:pathname+'/suppliers'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/suppliers/:id(\\d+)',render:function render(_ref47){var params=_ref47.match.params;return _react2.default.createElement(_SupplierContainer2.default,{params:params,prevPath:pathname+'/suppliers'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/orders',exact:true,component:function component(){return _ref48;}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/orders/new',exact:true,render:function render(_ref49){var params=_ref49.match.params;return _react2.default.createElement(_OrderContainer2.default,{params:params,prevPath:pathname+'/orders'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/orders/:orderId(\\d+)/customrows/new',render:function render(_ref50){var params=_ref50.match.params;return _react2.default.createElement(_CustomRowContainer2.default,{params:params,orderId:(0,_toInteger3.default)(params.orderId),prevPath:pathname+'/orders/'+params.orderId,resourcePath:pathname+'/orders/'+params.orderId+'/customrows'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/orders/:orderId(\\d+)/customrows/:id(\\d+)',render:function render(_ref51){var params=_ref51.match.params;return _react2.default.createElement(_CustomRowContainer2.default,{params:params,orderId:(0,_toInteger3.default)(params.orderId),prevPath:pathname+'/orders/'+params.orderId,resourcePath:pathname+'/orders/'+params.orderId+'/customrows'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/orders/:orderId(\\d+)/customerorder',render:function render(_ref52){var params=_ref52.match.params;return _react2.default.createElement(_AdminCustomerContainer2.default,{orderId:params.orderId});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/orders/:id(\\d+)',render:function render(_ref53){var params=_ref53.match.params;return _react2.default.createElement(_OrderContainer2.default,{params:params,prevPath:pathname+'/orders'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/purchaseorders',exact:true,component:_PurchaseOrdersContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/purchaseorders/:id(\\d+)',render:function render(_ref54){var params=_ref54.match.params;return _react2.default.createElement(_PurchaseOrderContainer2.default,{params:params,prevPath:pathname+'/purchaseorders'});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/exports',exact:true,component:_ExportsContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/sales',exact:true,component:_SalesContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/purchasereport',exact:true,component:_PurchaseOrderReportContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/sitemanagerreport',exact:true,component:_SiteManagerReportContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{render:function render(){return _react2.default.createElement(_reactRouterDom.Redirect,{to:pathname+'/projects'});}}))))));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLogoutClick:function onLogoutClick(){return dispatch((0,_auth.logout)());}};};exports.default=(0,_reactRedux.connect)(function(){return{};},mapDispatchToProps)(AdminContainer);

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('toInteger', __webpack_require__(58), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _mapValues2=__webpack_require__(66);var _mapValues3=_interopRequireDefault(_mapValues2);var _toNumber2=__webpack_require__(84);var _toNumber3=_interopRequireDefault(_toNumber2);var _pick2=__webpack_require__(86);var _pick3=_interopRequireDefault(_pick2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(958);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _reduxForm=__webpack_require__(4);var _apartmentView=__webpack_require__(235);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _ApartmentForm=__webpack_require__(963);var _ApartmentForm2=_interopRequireDefault(_ApartmentForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _ApartmentDeviationList=__webpack_require__(1022);var _ApartmentDeviationList2=_interopRequireDefault(_ApartmentDeviationList);var _ApartmentDeviationDialogContainer=__webpack_require__(1024);var _ApartmentDeviationDialogContainer2=_interopRequireDefault(_ApartmentDeviationDialogContainer);var _CopyApartmentDialog=__webpack_require__(1046);var _CopyApartmentDialog2=_interopRequireDefault(_CopyApartmentDialog);var _FileDropzone=__webpack_require__(128);var _FileDropzone2=_interopRequireDefault(_FileDropzone);var _BreadcrumbsContainer=__webpack_require__(459);var _BreadcrumbsContainer2=_interopRequireDefault(_BreadcrumbsContainer);var _FileList=__webpack_require__(1056);var _FileList2=_interopRequireDefault(_FileList);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);var _RenameFileDialog=__webpack_require__(1077);var _RenameFileDialog2=_interopRequireDefault(_RenameFileDialog);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var copyApartmentValidation={objectId:{rule:'string|required',label:'Lägenhetsnummer'}};var apartmentValidation={objectId:{rule:'string|required',label:'Lägenhetsnummer'},floor:{rule:'string',label:'Plan'},area:{rule:'numeric',label:'Yta'},address:{rule:'string|required',label:'Adress'},zipCode:{rule:'string|required',label:'Postnummer'},city:{rule:'string|required',label:'Stad'}};var fileRenameValidation={name:{rule:'string|required|max:255',label:'Filnamn'}};var notArchived=(0,_filter3.default)({archived:null});var includeId=function includeId(id){return(0,_filter3.default)(function(t){return t.id===id||!t.archived;});};var filterConfigurations=function filterConfigurations(apartment){return apartment?includeId(apartment.apartmentConfigId):notArchived;};/*:: export type Props = {
  history: Object,
  setDirty: typeof setDirty,
  reset: typeof reset,
  resetForm: typeof resetForm,
  isDirty: boolean,
  apartment: ?any,
  apartmentFormValues: any,
  apartmentFormIsValid: boolean,
  project: ?any,
  deviations: any[],
  apartmentDeviations: any[],
  configurations: any[],
  isFetching: boolean,
  params: any,
  error: ?any,
  orderPath: ?string,
  projectPath: string,
  resourcePath: string,
  fetchData: (_: {id?: any, projectId?: any}) => any,
  updateApartment: typeof updateApartment,
  touch: typeof touch,
  clear: typeof clear,
  openApartmentDeviation: typeof openApartmentDeviation,
  removeApartmentDeviation: typeof removeApartmentDeviation,
  projectId: ?number,
  apartmentUploads: Object,
  uploads: Object,
  abortAllUploads: typeof abortAllUploads,
  apartmentFiles: Object,
  createApartment: typeof createApartment,
  addFile: typeof addFile,
  removeFile: typeof removeFile,
  abortUpload: typeof abortUpload,
  toggleCopyDialog: typeof toggleCopyDialog,
  showCopyDialog: boolean,
  fileRenameFormValues: any,
  fileRenameFormIsValid: boolean,
  toggleRenameDialog: typeof toggleRenameDialog,
  showRenameDialog: false | 'contract' | 'floorPlan' | 'kitchenPlan',
  updateFile: typeof updateFile,
  deleteFile: typeof deleteFile,
  apartments: any[],
};*/var _ref2=_react2.default.createElement('hr',null);var _ref3=_react2.default.createElement(_ApartmentDeviationDialogContainer2.default,null);var _ref4=_react2.default.createElement('label',{className:'headlabel'},'Arkiverade dokument');var _ref5=_react2.default.createElement('label',{className:'description'},'Nedan listas arkiverade dokument. Dokument arkiveras automatiskt, och listas nedan, n\xE4r de skrivs \xF6ver av en ny uppladdning.');var ApartmentContainer=function(_Component){_inherits(ApartmentContainer,_Component);function ApartmentContainer(){_classCallCheck(this,ApartmentContainer);return _possibleConstructorReturn(this,(ApartmentContainer.__proto__||Object.getPrototypeOf(ApartmentContainer)).apply(this,arguments));}_createClass(ApartmentContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData({id:this.props.params.id,projectId:this.props.projectId});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.abortAllUploads(this.props.apartmentUploads);this.props.clear();}},{key:'setDirty',value:function setDirty(){var _props=this.props,setDirty=_props.setDirty,isDirty=_props.isDirty;if(!isDirty){setDirty(true,'apartment');}}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('apartment');setDirty(false,'apartment');}},{key:'copy',value:function copy(_ref){var objectId=_ref.objectId;var _props3=this.props,apartment=_props3.apartment,createApartment=_props3.createApartment;if(!!apartment){var newApartment=_extends({},apartment,{objectId:objectId,contract:null});createApartment(apartment.projectId,newApartment);}}},{key:'save',value:function save(){var _props4=this.props,apartment=_props4.apartment,apartmentFormValues=_props4.apartmentFormValues,apartmentFormIsValid=_props4.apartmentFormIsValid,apartmentFiles=_props4.apartmentFiles,createApartment=_props4.createApartment,updateApartment=_props4.updateApartment,apartmentDeviations=_props4.apartmentDeviations,projectId=_props4.projectId,touch=_props4.touch;var apartmentFields=(0,_keys3.default)(apartmentValidation);touch.apply(undefined,['apartment'].concat(_toConsumableArray(apartmentFields)));if(!apartmentFormIsValid){return;}var data=_extends({},apartmentFormValues,apartmentFiles,{deviations:apartmentDeviations});if(!apartment&&projectId){createApartment(projectId,data);}else if(!!apartment){updateApartment(apartment.id,data);}}},{key:'saveFile',value:function saveFile(){var _props5=this.props,fileRenameFormValues=_props5.fileRenameFormValues,fileRenameFormIsValid=_props5.fileRenameFormIsValid,apartmentFiles=_props5.apartmentFiles,updateFile=_props5.updateFile,touch=_props5.touch,showRenameDialog=_props5.showRenameDialog;if(!showRenameDialog){return;}var fileRenameFields=(0,_keys3.default)(fileRenameValidation);touch.apply(undefined,['fileRename'].concat(_toConsumableArray(fileRenameFields)));var file=apartmentFiles[showRenameDialog];if(!fileRenameFormIsValid||!file){return;}var data=(0,_pick3.default)(fileRenameFields,fileRenameFormValues);updateFile(file.id,showRenameDialog,data);}},{key:'render',value:function render(){var _this2=this;var _props6=this.props,history=_props6.history,isDirty=_props6.isDirty,id=_props6.params.id,project=_props6.project,orderPath=_props6.orderPath,projectPath=_props6.projectPath,resourcePath=_props6.resourcePath,apartment=_props6.apartment,error=_props6.error,isFetching=_props6.isFetching,updateApartment=_props6.updateApartment,apartmentDeviations=_props6.apartmentDeviations,deviations=_props6.deviations,configurations=_props6.configurations,openApartmentDeviation=_props6.openApartmentDeviation,removeApartmentDeviation=_props6.removeApartmentDeviation,addFile=_props6.addFile,removeFile=_props6.removeFile,abortUpload=_props6.abortUpload,apartmentFiles=_props6.apartmentFiles,apartmentUploads=_props6.apartmentUploads,uploads=_props6.uploads,apartmentFormValues=_props6.apartmentFormValues,toggleCopyDialog=_props6.toggleCopyDialog,showCopyDialog=_props6.showCopyDialog,fileRenameFormValues=_props6.fileRenameFormValues,toggleRenameDialog=_props6.toggleRenameDialog,showRenameDialog=_props6.showRenameDialog,deleteFile=_props6.deleteFile,apartments=_props6.apartments,clear=_props6.clear,fetchData=_props6.fetchData,projectId=_props6.projectId;return _react2.default.createElement('div',{className:'relative ApartmentContainer'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:apartment,list:apartments,prevPath:resourcePath,clear:clear,fetchData:function(_fetchData){function fetchData(_x){return _fetchData.apply(this,arguments);}fetchData.toString=function(){return _fetchData.toString();};return fetchData;}(function(id){return fetchData({id:id,projectId:projectId});})}),_react2.default.createElement('div',null,_react2.default.createElement(_BreadcrumbsContainer2.default,{project:project}),_react2.default.createElement('div',{className:'content-title'},apartment&&apartment.objectId||'Ny lägenhet')))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},apartment&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveApartment',className:'secondary button',message:'Vill du verkligen '+(apartment.archived?'av':'')+'arkivera den h\xE4r l\xE4genheten?',buttonText:apartment.archived?'Avarkivera':'Arkivera',action:function action(){return updateApartment(apartment.id,{archived:!apartment.archived});}})),apartment&&_react2.default.createElement('button',{type:'button',className:'secondary button',onClick:function onClick(){return toggleCopyDialog(true);}},'Skapa kopia'))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),!showCopyDialog&&_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column small-8'},apartment&&!!apartment.orderId&&orderPath?_react2.default.createElement(_ApartmentForm2.default,{initialValues:apartment,apartment:apartment,formValues:apartmentFormValues,configurations:filterConfigurations(apartment)(configurations),onUserChange:function onUserChange(){return _this2.setDirty();},onOpenOrder:function onOpenOrder(){return history.push(orderPath+'/'+apartment.orderId);},validate:function validate(values){return(0,_validator2.default)(apartmentValidation,values);}}):_react2.default.createElement(_ApartmentForm2.default,{initialValues:apartment,configurations:filterConfigurations(apartment)(configurations),onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(apartmentValidation,values);}})),_react2.default.createElement('div',{className:'column small-4'},_react2.default.createElement(_FileDropzone2.default,{label:'Best\xE4llningsunderlag',file:apartmentFiles.contract,upload:uploads.contract,onUpload:function onUpload(f){addFile('contract',f);_this2.setDirty();},onUploadAbort:function onUploadAbort(){abortUpload(apartmentUploads.contract);_this2.setDirty();},onRemove:function onRemove(){removeFile('contract');_this2.setDirty();}}),_react2.default.createElement(_FileDropzone2.default,{label:'Planritning',file:apartmentFiles.floorPlan,upload:uploads.floorPlan,editable:!isDirty,onEdit:function onEdit(){return toggleRenameDialog('floorPlan');},onUpload:function onUpload(f){addFile('floorPlan',f);_this2.setDirty();},onUploadAbort:function onUploadAbort(){abortUpload(apartmentUploads.floorPlan);_this2.setDirty();},onRemove:function onRemove(){removeFile('floorPlan');_this2.setDirty();}}),_react2.default.createElement(_FileDropzone2.default,{label:'K\xF6ksritning',file:apartmentFiles.kitchenPlan,upload:uploads.kitchenPlan,editable:!isDirty,onEdit:function onEdit(){return toggleRenameDialog('kitchenPlan');},onUpload:function onUpload(f){addFile('kitchenPlan',f);_this2.setDirty();},onUploadAbort:function onUploadAbort(){abortUpload(apartmentUploads.kitchenPlan);_this2.setDirty();},onRemove:function onRemove(){removeFile('kitchenPlan');_this2.setDirty();}})))),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},!!apartmentFormValues&&_react2.default.createElement('button',{onClick:function onClick(){return history.push(projectPath+'/apartmentconfigurations/'+apartmentFormValues.apartmentConfigId);},type:'button',className:'button small expanded'},'\xD6ppna konfiguration')),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_ApartmentDeviationList2.default,{list:apartmentDeviations,deviations:deviations,onSelectItem:function onSelectItem(d){return openApartmentDeviation(d);},onRemoveItem:function onRemoveItem(d){return removeApartmentDeviation(d.id);}}),_ref2,_react2.default.createElement('button',{onClick:function onClick(){return openApartmentDeviation();},type:'button',className:'button small expanded'},'L\xE4gg till'),_ref3))),apartment&&_react2.default.createElement('div',{className:'content-section box'},_ref4,_ref5,_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-4 column'},_react2.default.createElement(_FileList2.default,{label:'Arkiverade best\xE4llningsunderlag',list:apartment.oldContracts,disabled:isDirty,onRemove:function onRemove(file){return deleteFile(apartment.id,file);}})),_react2.default.createElement('div',{className:'small-4 column'},_react2.default.createElement(_FileList2.default,{label:'Arkiverade planritningar',list:apartment.oldFloorPlans,disabled:isDirty,onRemove:function onRemove(file){return deleteFile(apartment.id,file);}})),_react2.default.createElement('div',{className:'small-4 column'},_react2.default.createElement(_FileList2.default,{label:'Arkiverade k\xF6ksritningar',list:apartment.oldKitchenPlans,disabled:isDirty,onRemove:function onRemove(file){return deleteFile(apartment.id,file);}})))),apartment&&apartment.id!==(0,_toNumber3.default)(id)&&_react2.default.createElement(_reactRouterDom.Redirect,{to:resourcePath+'/'+apartment.id}),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}),showCopyDialog&&!!apartment&&_react2.default.createElement(_CopyApartmentDialog2.default,{apartment:apartment,isLoading:isFetching,error:error,onSubmit:function onSubmit(values){return _this2.copy(values);},validate:function validate(values){return(0,_validator2.default)(copyApartmentValidation,values);},onClose:function onClose(){return toggleCopyDialog(false);}}),showRenameDialog&&!!apartmentFiles[showRenameDialog]&&_react2.default.createElement(_RenameFileDialog2.default,{error:error,file:apartmentFiles[showRenameDialog],formValues:fileRenameFormValues,isLoading:isFetching,onSubmit:function onSubmit(){return _this2.saveFile();},onClose:function onClose(){return toggleRenameDialog(false);},validate:function validate(values){return(0,_validator2.default)(fileRenameValidation,values);}}));}}]);return ApartmentContainer;}(_react.Component);var getUploads=function getUploads(uploads,files){return(0,_mapValues3.default)(function(u){return files.byId[u];},uploads)||{};};var mapStateToProps=function mapStateToProps(_ref6){var _ref6$apartmentView=_ref6.apartmentView,_ref6$apartmentView$a=_ref6$apartmentView.apartment,apartment=_ref6$apartmentView$a.active,error=_ref6$apartmentView$a.error,isDirty=_ref6$apartmentView$a.isDirty,isFetching=_ref6$apartmentView$a.isFetching,apartmentDeviations=_ref6$apartmentView$a.deviations,apartmentFiles=_ref6$apartmentView$a.files,apartmentUploads=_ref6$apartmentView$a.uploads,project=_ref6$apartmentView.project.active,deviations=_ref6$apartmentView.deviations.list,configurations=_ref6$apartmentView.configurations.list,showCopyDialog=_ref6$apartmentView.copyDialogVisibility,showRenameDialog=_ref6$apartmentView.fileRenameDialogVisibility,apartments=_ref6.projectView.filteredApartments,form=_ref6.form,files=_ref6.files;return{isDirty:isDirty,apartment:apartment,project:project,apartmentDeviations:apartmentDeviations,configurations:configurations,error:error,isFetching:isFetching,deviations:deviations,apartmentFiles:apartmentFiles,apartmentUploads:apartmentUploads,showCopyDialog:showCopyDialog,uploads:getUploads(apartmentUploads,files),apartmentFormIsValid:(0,_reduxForm.isValid)('apartment')({form:form}),apartmentFormValues:(0,_reduxForm.getFormValues)('apartment')({form:form}),showRenameDialog:showRenameDialog,fileRenameFormIsValid:(0,_reduxForm.isValid)('fileRename')({form:form}),fileRenameFormValues:(0,_reduxForm.getFormValues)('fileRename')({form:form}),apartments:apartments};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'apartment'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_apartmentView.reset)());},fetchData:function fetchData(_ref7){var id=_ref7.id,projectId=_ref7.projectId;dispatch((0,_apartmentView.fetchDeviations)());if(id){dispatch((0,_apartmentView.fetchApartment)(id));}else if(projectId){dispatch((0,_apartmentView.fetchProject)(projectId));dispatch((0,_apartmentView.fetchApartmentConfigurations)(projectId));}},createApartment:function createApartment(projectId,data){return dispatch((0,_apartmentView.createApartment)(projectId,data));},updateApartment:function updateApartment(id,data){return dispatch((0,_apartmentView.updateApartment)(id,data));},openApartmentDeviation:function openApartmentDeviation(deviation){return dispatch((0,_apartmentView.openApartmentDeviation)(deviation));},removeApartmentDeviation:function removeApartmentDeviation(deviationId){return dispatch((0,_apartmentView.removeApartmentDeviation)(deviationId));},removeFile:function removeFile(name){return dispatch((0,_apartmentView.removeFile)(name));},abortUpload:function abortUpload(tempId){return dispatch((0,_apartmentView.abortUpload)(tempId));},abortAllUploads:function abortAllUploads(uploads){return dispatch((0,_apartmentView.abortAllUploads)(uploads));},addFile:function addFile(name,_ref8){var _ref9=_toArray(_ref8),file=_ref9[0],rest=_ref9.slice(1);if(file){dispatch((0,_apartmentView.addFile)(name,file));}},toggleCopyDialog:function toggleCopyDialog(show){return dispatch((0,_apartmentView.toggleCopyDialog)(show));},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},clear:function clear(){return dispatch((0,_apartmentView.clear)());},updateFile:function updateFile(id,name/*: 'contract' | 'floorPlan' | 'kitchenPlan'*/,data){return dispatch((0,_apartmentView.updateFile)(id,name,data));},toggleRenameDialog:function toggleRenameDialog(show/*: false | 'contract' | 'floorPlan' | 'kitchenPlan'*/){return dispatch((0,_apartmentView.toggleRenameDialog)(show));},deleteFile:function deleteFile(apartmentId,file){return dispatch((0,_apartmentView.deleteFile)(apartmentId,file));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ApartmentContainer));

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(957),
    flatRest = __webpack_require__(118);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(370),
    hasIn = __webpack_require__(356);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 958 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 959 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('isNumber', __webpack_require__(961), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 962 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _DecimalFormInput=__webpack_require__(70);var _DecimalFormInput2=_interopRequireDefault(_DecimalFormInput);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  configurations: any[],
  apartment?: any,
  formValues?: any,
  onOpenOrder?: Function,
  onUserChange: Function,
};*/var _ref2=_react2.default.createElement('label',null,'Aktiv best\xE4llning');var _ref3=_react2.default.createElement('span',null,'Ingen best\xE4llning p\xE5 l\xE4genheten');var _ref4=_react2.default.createElement('div',{className:'callout warning text-center'},'\xC4ndring av l\xE4genhetskonfiguration kommer att rensa ev. produktval');var ApartmentForm=function ApartmentForm(_ref){var configurations=_ref.configurations,apartment=_ref.apartment,formValues=_ref.formValues,onUserChange=_ref.onUserChange,onOpenOrder=_ref.onOpenOrder;return _react2.default.createElement('div',{className:'ApartmentForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'objectId',label:'L\xE4genhetsnummer',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'floor',label:'Plan',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'area',label:'Yta (kvm)',onChange:onUserChange,component:_DecimalFormInput2.default}),_react2.default.createElement(_reduxForm.Field,{name:'apartmentConfigId',label:'L\xE4genhetskonfiguration',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:configurations})),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'address',label:'Adress',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'zipCode',label:'Postnummer',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'city',label:'Stad',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement('div',null,_ref2,!!onOpenOrder?_react2.default.createElement('button',{onClick:function onClick(){return onOpenOrder&&onOpenOrder();},type:'button',className:'expanded button'},'\xD6ppna aktiv best\xE4llning'):_ref3))),apartment&&apartment.id&&formValues&&formValues.apartmentConfigId!==apartment.apartmentConfigId&&_ref4));};exports.default=(0,_reduxForm.reduxForm)({form:'apartment',enableReinitialize:true})(ApartmentForm);

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(965);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(966), __esModule: true };

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(967);
module.exports = __webpack_require__(56).Object.assign;


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(87);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(969) });


/***/ }),
/* 968 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(127);
var gOPS = __webpack_require__(248);
var pIE = __webpack_require__(174);
var toObject = __webpack_require__(175);
var IObject = __webpack_require__(419);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(101)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(102);
var toLength = __webpack_require__(971);
var toAbsoluteIndex = __webpack_require__(972);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(244);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(244);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(974), __esModule: true };

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(975);
module.exports = __webpack_require__(56).Object.getPrototypeOf;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(175);
var $getPrototypeOf = __webpack_require__(421);

__webpack_require__(422)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(978);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(979), __esModule: true };

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(980);
var $Object = __webpack_require__(56).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(87);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(89), 'Object', { defineProperty: __webpack_require__(88).f });


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(423);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(983), __esModule: true };

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(984);
__webpack_require__(989);
module.exports = __webpack_require__(253).f('iterator');


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(985)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(424)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(244);
var defined = __webpack_require__(243);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(251);
var descriptor = __webpack_require__(172);
var setToStringTag = __webpack_require__(252);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(100)(IteratorPrototype, __webpack_require__(103)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(88);
var anObject = __webpack_require__(125);
var getKeys = __webpack_require__(127);

module.exports = __webpack_require__(89) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(71).document;
module.exports = document && document.documentElement;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(990);
var global = __webpack_require__(71);
var hide = __webpack_require__(100);
var Iterators = __webpack_require__(250);
var TO_STRING_TAG = __webpack_require__(103)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(991);
var step = __webpack_require__(992);
var Iterators = __webpack_require__(250);
var toIObject = __webpack_require__(102);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(424)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 991 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 992 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(994), __esModule: true };

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(995);
__webpack_require__(1000);
__webpack_require__(1001);
__webpack_require__(1002);
module.exports = __webpack_require__(56).Symbol;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(71);
var has = __webpack_require__(90);
var DESCRIPTORS = __webpack_require__(89);
var $export = __webpack_require__(87);
var redefine = __webpack_require__(425);
var META = __webpack_require__(996).KEY;
var $fails = __webpack_require__(101);
var shared = __webpack_require__(246);
var setToStringTag = __webpack_require__(252);
var uid = __webpack_require__(173);
var wks = __webpack_require__(103);
var wksExt = __webpack_require__(253);
var wksDefine = __webpack_require__(254);
var enumKeys = __webpack_require__(997);
var isArray = __webpack_require__(998);
var anObject = __webpack_require__(125);
var toIObject = __webpack_require__(102);
var toPrimitive = __webpack_require__(242);
var createDesc = __webpack_require__(172);
var _create = __webpack_require__(251);
var gOPNExt = __webpack_require__(999);
var $GOPD = __webpack_require__(427);
var $DP = __webpack_require__(88);
var $keys = __webpack_require__(127);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(426).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(174).f = $propertyIsEnumerable;
  __webpack_require__(248).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(249)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(100)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(173)('meta');
var isObject = __webpack_require__(126);
var has = __webpack_require__(90);
var setDesc = __webpack_require__(88).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(101)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(127);
var gOPS = __webpack_require__(248);
var pIE = __webpack_require__(174);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(420);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(102);
var gOPN = __webpack_require__(426).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1000 */
/***/ (function(module, exports) {



/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(254)('asyncIterator');


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(254)('observable');


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1004);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1008);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(423);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1005), __esModule: true };

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1006);
module.exports = __webpack_require__(56).Object.setPrototypeOf;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(87);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1007).set });


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(126);
var anObject = __webpack_require__(125);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(415)(Function.call, __webpack_require__(427).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1009), __esModule: true };

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1010);
var $Object = __webpack_require__(56).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(87);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(251) });


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = __webpack_require__(1012);

var _keys2 = _interopRequireDefault(_keys);

exports.noop = noop;
exports.returnTrue = returnTrue;
exports.charIsNumber = charIsNumber;
exports.escapeRegExp = escapeRegExp;
exports.splitDecimal = splitDecimal;
exports.fixLeadingZero = fixLeadingZero;
exports.limitToScale = limitToScale;
exports.roundToPrecision = roundToPrecision;
exports.omit = omit;
exports.setCaretPosition = setCaretPosition;
exports.findChangedIndex = findChangedIndex;
exports.clamp = clamp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// basic noop function
function noop() {}
function returnTrue() {
  return true;
}

function charIsNumber(char) {
  return !!(char || '').match(/\d/);
}

function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}

//spilt a float number into different parts beforeDecimal, afterDecimal, and negation
function splitDecimal(numStr) {
  var allowNegative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var hasNagation = numStr[0] === '-';
  var addNegation = hasNagation && allowNegative;
  numStr = numStr.replace('-', '');

  var parts = numStr.split('.');
  var beforeDecimal = parts[0];
  var afterDecimal = parts[1] || '';

  return {
    beforeDecimal: beforeDecimal,
    afterDecimal: afterDecimal,
    hasNagation: hasNagation,
    addNegation: addNegation
  };
}

function fixLeadingZero(numStr) {
  if (!numStr) return numStr;
  var isNegative = numStr[0] === '-';
  if (isNegative) numStr = numStr.substring(1, numStr.length);
  var parts = numStr.split('.');
  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
  var afterDecimal = parts[1] || '';

  return '' + (isNegative ? '-' : '') + beforeDecimal + (afterDecimal ? '.' + afterDecimal : '');
}

/**
 * limit decimal numbers to given scale
 * Not used .fixedTo because that will break with big numbers
 */
function limitToScale(numStr, scale, fixedDecimalScale) {
  var str = '';
  var filler = fixedDecimalScale ? '0' : '';
  for (var i = 0; i <= scale - 1; i++) {
    str += numStr[i] || filler;
  }
  return str;
}

/**
 * This method is required to round prop value to given scale.
 * Not used .round or .fixedTo because that will break with big numbers
 */
function roundToPrecision(numStr, scale, fixedDecimalScale) {
  //if number is empty don't do anything return empty string
  if (numStr === '') return '';

  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;

  var _splitDecimal = splitDecimal(numStr),
      beforeDecimal = _splitDecimal.beforeDecimal,
      afterDecimal = _splitDecimal.afterDecimal,
      hasNagation = _splitDecimal.hasNagation;

  var roundedDecimalParts = parseFloat('0.' + (afterDecimal || '0')).toFixed(scale).split('.');
  var intPart = beforeDecimal.split('').reverse().reduce(function (roundedStr, current, idx) {
    if (roundedStr.length > idx) {
      return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
    }
    return current + roundedStr;
  }, roundedDecimalParts[0]);

  var decimalPart = limitToScale(roundedDecimalParts[1] || '', Math.min(scale, afterDecimal.length), fixedDecimalScale);
  var negation = hasNagation ? '-' : '';
  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
  return '' + negation + intPart + decimalSeparator + decimalPart;
}

function omit(obj, keyMaps) {
  var filteredObj = {};
  (0, _keys2.default)(obj).forEach(function (key) {
    if (!keyMaps[key]) filteredObj[key] = obj[key];
  });
  return filteredObj;
}

/** set the caret positon in an input field **/
function setCaretPosition(el, caretPos) {
  el.value = el.value;
  // ^ this is used to not only get "focus", but
  // to make sure we don't have it everything -selected-
  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
  if (el !== null) {
    if (el.createTextRange) {
      var range = el.createTextRange();
      range.move('character', caretPos);
      range.select();
      return true;
    }
    // (el.selectionStart === 0 added for Firefox bug)
    if (el.selectionStart || el.selectionStart === 0) {
      el.focus();
      el.setSelectionRange(caretPos, caretPos);
      return true;
    }

    // fail city, fortunately this never happens (as far as I've tested) :)
    el.focus();
    return false;
  }
}

/**
  Given previous value and newValue it returns the index
  start - end to which values have changed.
  This function makes assumption about only consecutive
  characters are changed which is correct assumption for caret input.
*/
function findChangedIndex(prevValue, newValue) {
  var i = 0,
      j = 0;
  var prevLength = prevValue.length;
  var newLength = newValue.length;
  while (prevValue[i] === newValue[i] && i < prevLength) {
    i++;
  } //check what has been changed from last
  while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i) {
    j++;
  }

  return { start: i, end: prevLength - j };
}

/*
  Returns a number whose value is limited to the given range
*/
function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
}

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1013), __esModule: true };

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1014);
module.exports = __webpack_require__(56).Object.keys;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(175);
var $keys = __webpack_require__(127);

__webpack_require__(422)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: '_' + Math.random().toString(36).substr(2, 12)
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyle = this.input && window.getComputedStyle(this.input);
			if (!inputStyle) {
				return;
			}
			var widthNode = this.sizer;
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.fontWeight = inputStyle.fontWeight;
			widthNode.style.fontStyle = inputStyle.fontStyle;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			widthNode.style.textTransform = inputStyle.textTransform;
			if (this.props.placeholder) {
				var placeholderNode = this.placeHolderSizer;
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.fontWeight = inputStyle.fontWeight;
				placeholderNode.style.fontStyle = inputStyle.fontStyle;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
				placeholderNode.style.textTransform = inputStyle.textTransform;
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth + 'px';
			inputStyle.boxSizing = 'content-box';

			var inputProps = _objectWithoutProperties(this.props, []);

			inputProps.className = this.props.inputClassName;
			inputProps.style = inputStyle;
			// ensure props meant for `AutosizeInput` don't end up on the `input`
			delete inputProps.inputClassName;
			delete inputProps.inputStyle;
			delete inputProps.minWidth;
			delete inputProps.onAutosize;
			delete inputProps.placeholderIsMinWidth;
			delete inputProps.inputRef;
			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				_react2.default.createElement('style', { dangerouslySetInnerHTML: {
						__html: ['input#' + this.state.id + '::-ms-clear {display: none;}'].join('\n')
					} }),
				_react2.default.createElement('input', _extends({ id: this.state.id }, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

;

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(newValue) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1
};

exports.default = AutosizeInput;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = arrowRenderer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return _react2.default.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: _propTypes2.default.func
};

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = clearRenderer;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clearRenderer() {
	return _react2.default.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Option = function (_React$Component) {
	_inherits(Option, _React$Component);

	function Option(props) {
		_classCallCheck(this, Option);

		var _this = _possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	_createClass(Option, [{
		key: 'blockEvent',
		value: function blockEvent(event) {
			event.preventDefault();
			event.stopPropagation();
			if (event.target.tagName !== 'A' || !('href' in event.target)) {
				return;
			}
			if (event.target.target) {
				window.open(event.target.href, event.target.target);
			} else {
				window.location.href = event.target.href;
			}
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove(event) {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart(event) {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = (0, _classnames2.default)(this.props.className, option.className);

			return option.disabled ? _react2.default.createElement(
				'div',
				{ className: className,
					onMouseDown: this.blockEvent,
					onClick: this.blockEvent },
				this.props.children
			) : _react2.default.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);

	return Option;
}(_react2.default.Component);

;

Option.propTypes = {
	children: _propTypes2.default.node,
	className: _propTypes2.default.string, // className (based on mouse position)
	instancePrefix: _propTypes2.default.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: _propTypes2.default.bool, // the option is disabled
	isFocused: _propTypes2.default.bool, // the option is focused
	isSelected: _propTypes2.default.bool, // the option is selected
	onFocus: _propTypes2.default.func, // method to handle mouseEnter on option element
	onSelect: _propTypes2.default.func, // method to handle click on option element
	onUnfocus: _propTypes2.default.func, // method to handle mouseLeave on option element
	option: _propTypes2.default.object.isRequired, // object that is base for that option
	optionIndex: _propTypes2.default.number // index of the option, used to generate unique ids for aria
};

exports.default = Option;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Select = __webpack_require__(176);

var _Select2 = _interopRequireDefault(_Select);

var _Async = __webpack_require__(433);

var _Async2 = _interopRequireDefault(_Async);

var _Creatable = __webpack_require__(434);

var _Creatable2 = _interopRequireDefault(_Creatable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function reduce(obj) {
	var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	return Object.keys(obj).reduce(function (props, key) {
		var value = obj[key];
		if (value !== undefined) props[key] = value;
		return props;
	}, props);
}

var AsyncCreatableSelect = function (_React$Component) {
	_inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		_classCallCheck(this, AsyncCreatableSelect);

		return _possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	_createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return _react2.default.createElement(
				_Async2.default,
				this.props,
				function (asyncProps) {
					return _react2.default.createElement(
						_Creatable2.default,
						_this2.props,
						function (creatableProps) {
							return _react2.default.createElement(_Select2.default, _extends({}, reduce(asyncProps, reduce(creatableProps, {})), {
								onInputChange: function onInputChange(input) {
									creatableProps.onInputChange(input);
									return asyncProps.onInputChange(input);
								},
								ref: function ref(_ref) {
									_this2.select = _ref;
									creatableProps.ref(_ref);
									asyncProps.ref(_ref);
								}
							}));
						}
					);
				}
			);
		}
	}]);

	return AsyncCreatableSelect;
}(_react2.default.Component);

;

exports.default = AsyncCreatableSelect;

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _getOr2=__webpack_require__(205);var _getOr3=_interopRequireDefault(_getOr2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1023);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var getDeviationName=(0,_getOr3.default)('','name');/*:: export type Props = {
  list: any[],
  deviations: any[],
  onSelectItem: Function,
  onRemoveItem: Function,
};*/var _ref2=_react2.default.createElement('label',null,'Avvikelser');var _ref3=_react2.default.createElement('div',{className:'empty-item'},'Inga avvikelser');var _ref4=_react2.default.createElement('i',{className:'fa fa-trash'});var _ref5=_react2.default.createElement('i',{className:'fa fa-pencil'});var ApartmentDeviationList=function ApartmentDeviationList(_ref){var list=_ref.list,deviations=_ref.deviations,onSelectItem=_ref.onSelectItem,onRemoveItem=_ref.onRemoveItem;return _react2.default.createElement('div',{className:'ApartmentDeviationList'},_ref2,_react2.default.createElement('div',{className:'deviation-list'},(!list||!list.length)&&_ref3,!!(list&&list.length)&&(0,_map3.default)(function(d){return _react2.default.createElement('div',{key:d.id,className:'row no-row-margins item'},_react2.default.createElement('button',{onClick:function onClick(){return onSelectItem(d);},type:'button',className:'button column warning'},getDeviationName((0,_find3.default)({id:d.id},deviations)||{})),_react2.default.createElement('button',{onClick:function onClick(){return onRemoveItem(d);},type:'button',className:'button column shrink'},_ref4),_react2.default.createElement('button',{onClick:function onClick(){return onSelectItem(d);},type:'button',className:'button column shrink'},_ref5));},list)));};exports.default=ApartmentDeviationList;

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _reduxForm=__webpack_require__(4);var _apartmentView=__webpack_require__(235);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _ApartmentDeviationForm=__webpack_require__(1044);var _ApartmentDeviationForm2=_interopRequireDefault(_ApartmentDeviationForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var apartmentDeviationValidation={id:{rule:'numeric|required',label:'Avvikelsetyp'},reason:{rule:'string|required',label:'Beskrivning'}};/*:: export type Props = {
  active: ?any,
  show: boolean,
  deviations: any[],
  apartmentDeviations: any[],
  apartmentDeviationFormIsValid: boolean,
  apartmentDeviationFormValues: any,
  closeApartmentDeviation: Function,
  addApartmentDeviation: Function,
  updateApartmentDeviation: Function,
  touch: Function,
};*/var ApartmentDeviationDialogContainer=function(_Component){_inherits(ApartmentDeviationDialogContainer,_Component);function ApartmentDeviationDialogContainer(){_classCallCheck(this,ApartmentDeviationDialogContainer);return _possibleConstructorReturn(this,(ApartmentDeviationDialogContainer.__proto__||Object.getPrototypeOf(ApartmentDeviationDialogContainer)).apply(this,arguments));}_createClass(ApartmentDeviationDialogContainer,[{key:'onSaveDevationRelation',value:function onSaveDevationRelation(){var _props=this.props,active=_props.active,apartmentDeviationFormValues=_props.apartmentDeviationFormValues,apartmentDeviationFormIsValid=_props.apartmentDeviationFormIsValid,touch=_props.touch,addApartmentDeviation=_props.addApartmentDeviation,updateApartmentDeviation=_props.updateApartmentDeviation,closeApartmentDeviation=_props.closeApartmentDeviation;var apartmentDeviationKeys=(0,_keys3.default)(apartmentDeviationValidation);touch.apply(undefined,['apartmentDeviation'].concat(_toConsumableArray(apartmentDeviationKeys)));if(!apartmentDeviationFormIsValid){return;}if(active){updateApartmentDeviation(active.id,apartmentDeviationFormValues);}else{addApartmentDeviation(apartmentDeviationFormValues);}closeApartmentDeviation();}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,active=_props2.active,show=_props2.show,deviations=_props2.deviations,apartmentDeviations=_props2.apartmentDeviations,closeApartmentDeviation=_props2.closeApartmentDeviation;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:function onClose(){return closeApartmentDeviation();},show:show},_react2.default.createElement(_ApartmentDeviationForm2.default,{initialValues:active,deviations:deviations,apartmentDeviations:apartmentDeviations,validate:function validate(values){return(0,_validator2.default)(apartmentDeviationValidation,values);}}),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:function onClick(){return _this2.onSaveDevationRelation();}},active?'Uppdatera':'Lägg till'),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:function onClick(){return closeApartmentDeviation();}},'Avbryt')));}}]);return ApartmentDeviationDialogContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$apartmentView=_ref.apartmentView,apartmentDeviations=_ref$apartmentView.apartment.deviations,_ref$apartmentView$de=_ref$apartmentView.deviation,active=_ref$apartmentView$de.active,show=_ref$apartmentView$de.show,deviations=_ref$apartmentView.deviations.list,form=_ref.form;return{active:active,show:show,deviations:deviations,apartmentDeviations:apartmentDeviations,apartmentDeviationFormIsValid:(0,_reduxForm.isValid)('apartmentDeviation')({form:form}),apartmentDeviationFormValues:(0,_reduxForm.getFormValues)('apartmentDeviation')({form:form})};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{closeApartmentDeviation:function closeApartmentDeviation(){return dispatch((0,_apartmentView.closeApartmentDeviation)());},addApartmentDeviation:function addApartmentDeviation(deviation){return dispatch((0,_apartmentView.addApartmentDeviation)(deviation));},updateApartmentDeviation:function updateApartmentDeviation(id,deviation){return dispatch((0,_apartmentView.updateApartmentDeviation)(id,deviation));},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ApartmentDeviationDialogContainer);

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('isBoolean', __webpack_require__(1026), __webpack_require__(29));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

var isBuffer = __webpack_require__(1028)

module.exports = flatten
flatten.flatten = flatten
flatten.unflatten = unflatten

function flatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var maxDepth = opts.maxDepth
  var output = {}

  function step (object, prev, currentDepth) {
    currentDepth = currentDepth || 1
    Object.keys(object).forEach(function (key) {
      var value = object[key]
      var isarray = opts.safe && Array.isArray(value)
      var type = Object.prototype.toString.call(value)
      var isbuffer = isBuffer(value)
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      var newKey = prev
        ? prev + delimiter + key
        : key

      if (!isarray && !isbuffer && isobject && Object.keys(value).length &&
        (!opts.maxDepth || currentDepth < maxDepth)) {
        return step(value, newKey, currentDepth + 1)
      }

      output[newKey] = value
    })
  }

  step(target)

  return output
}

function unflatten (target, opts) {
  opts = opts || {}

  var delimiter = opts.delimiter || '.'
  var overwrite = opts.overwrite || false
  var result = {}

  var isbuffer = isBuffer(target)
  if (isbuffer || Object.prototype.toString.call(target) !== '[object Object]') {
    return target
  }

  // safely ensure that the key is
  // an integer.
  function getkey (key) {
    var parsedKey = Number(key)

    return (
      isNaN(parsedKey) ||
      key.indexOf('.') !== -1 ||
      opts.object
    ) ? key
      : parsedKey
  }

  var sortedKeys = Object.keys(target).sort(function (keyA, keyB) {
    return keyA.length - keyB.length
  })

  sortedKeys.forEach(function (key) {
    var split = key.split(delimiter)
    var key1 = getkey(split.shift())
    var key2 = getkey(split[0])
    var recipient = result

    while (key2 !== undefined) {
      var type = Object.prototype.toString.call(recipient[key1])
      var isobject = (
        type === '[object Object]' ||
        type === '[object Array]'
      )

      // do not write over falsey, non-undefined values if overwrite is false
      if (!overwrite && !isobject && typeof recipient[key1] !== 'undefined') {
        return
      }

      if ((overwrite && !isobject) || (!overwrite && recipient[key1] == null)) {
        recipient[key1] = (
          typeof key2 === 'number' &&
          !opts.object ? [] : {}
        )
      }

      recipient = recipient[key1]
      if (split.length > 0) {
        key1 = getkey(split.shift())
        key2 = getkey(split[0])
      }
    }

    // unflatten again for 'messy objects'
    recipient[key1] = unflatten(target[key], opts)
  })

  return result
}


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

var Rules = __webpack_require__(1030);
var Lang = __webpack_require__(1031);
var Errors = __webpack_require__(1034);
var Attributes = __webpack_require__(435);
var AsyncResolvers = __webpack_require__(1035);

var Validator = function (input, rules, customMessages) {
  var lang = Validator.getDefaultLang();
  this.input = input || {};

  this.messages = Lang._make(lang);
  this.messages._setCustom(customMessages);
  this.setAttributeFormatter(Validator.prototype.attributeFormatter);

  this.errors = new Errors();
  this.errorCount = 0;

  this.hasAsync = false;
  this.rules = this._parseRules(rules);
};

Validator.prototype = {

  constructor: Validator,

  /**
   * Default language
   *
   * @type {string}
   */
  lang: 'en',

  /**
   * Numeric based rules
   *
   * @type {array}
   */
  numericRules: ['integer', 'numeric'],

  /**
   * Attribute formatter.
   *
   * @type {function}
   */
  attributeFormatter: Attributes.formatter,

  /**
   * Run validator
   *
   * @return {boolean} Whether it passes; true = passes, false = fails
   */
  check: function () {
    var self = this;

    for (var attribute in this.rules) {
      var attributeRules = this.rules[attribute];
      var inputValue = this._objectPath(this.input, attribute);

      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
        continue;
      }

      for (var i = 0, len = attributeRules.length, rule, ruleOptions, rulePassed; i < len; i++) {
        ruleOptions = attributeRules[i];
        rule = this.getRule(ruleOptions.name);

        if (!this._isValidatable(rule, inputValue)) {
          continue;
        }

        rulePassed = rule.validate(inputValue, ruleOptions.value, attribute);
        if (!rulePassed) {
          this._addFailure(rule);
        }

        if (this._shouldStopValidating(attribute, rulePassed)) {
          break;
        }
      }
    }

    return this.errorCount === 0;
  },

  /**
   * Run async validator
   *
   * @param {function} passes
   * @param {function} fails
   * @return {void}
   */
  checkAsync: function (passes, fails) {
    var _this = this;
    passes = passes || function () {};
    fails = fails || function () {};

    var failsOne = function (rule, message) {
      _this._addFailure(rule, message);
    };

    var resolvedAll = function (allPassed) {
      if (allPassed) {
        passes();
      } else {
        fails();
      }
    };

    var asyncResolvers = new AsyncResolvers(failsOne, resolvedAll);

    var validateRule = function (inputValue, ruleOptions, attribute, rule) {
      return function () {
        var resolverIndex = asyncResolvers.add(rule);
        rule.validate(inputValue, ruleOptions.value, attribute, function () {
          asyncResolvers.resolve(resolverIndex);
        });
      };
    };

    for (var attribute in this.rules) {
      var attributeRules = this.rules[attribute];
      var inputValue = this._objectPath(this.input, attribute);

      if (this._hasRule(attribute, ['sometimes']) && !this._suppliedWithData(attribute)) {
        continue;
      }

      for (var i = 0, len = attributeRules.length, rule, ruleOptions; i < len; i++) {
        ruleOptions = attributeRules[i];

        rule = this.getRule(ruleOptions.name);

        if (!this._isValidatable(rule, inputValue)) {
          continue;
        }

        validateRule(inputValue, ruleOptions, attribute, rule)();
      }
    }

    asyncResolvers.enableFiring();
    asyncResolvers.fire();
  },

  /**
   * Add failure and error message for given rule
   *
   * @param {Rule} rule
   */
  _addFailure: function (rule) {
    var msg = this.messages.render(rule);
    this.errors.add(rule.attribute, msg);
    this.errorCount++;
  },

  /**
   * Flatten nested object, normalizing { foo: { bar: 1 } } into: { 'foo.bar': 1 }
   *
   * @param  {object} nested object
   * @return {object} flattened object
   */
  _flattenObject: function (obj) {
    var flattened = {};

    function recurse(current, property) {
      if (!property && Object.getOwnPropertyNames(current).length === 0) {
        return;
      }
      if (Object(current) !== current || Array.isArray(current)) {
        flattened[property] = current;
      } else {
        var isEmpty = true;
        for (var p in current) {
          isEmpty = false;
          recurse(current[p], property ? property + "." + p : p);
        }
        if (isEmpty) {
          flattened[property] = {};
        }
      }
    }
    if (obj) {
      recurse(obj);
    }
    return flattened;
  },

  /**
   * Extract value from nested object using string path with dot notation
   *
   * @param  {object} object to search in
   * @param  {string} path inside object
   * @return {any|void} value under the path
   */
  _objectPath: function (obj, path) {
    if (Object.prototype.hasOwnProperty.call(obj, path)) {
      return obj[path];
    }

    var keys = path.replace(/\[(\w+)\]/g, ".$1").replace(/^\./, "").split(".");
    var copy = {};
    for (var attr in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, attr)) {
        copy[attr] = obj[attr];
      }
    }

    for (var i = 0, l = keys.length; i < l; i++) {
      if (Object.hasOwnProperty.call(copy, keys[i])) {
        copy = copy[keys[i]];
      } else {
        return;
      }
    }
    return copy;
  },

  /**
   * Parse rules, normalizing format into: { attribute: [{ name: 'age', value: 3 }] }
   *
   * @param  {object} rules
   * @return {object}
   */
  _parseRules: function (rules) {

    var parsedRules = {};
    rules = this._flattenObject(rules);

    for (var attribute in rules) {

      var rulesArray = rules[attribute];

      this._parseRulesCheck(attribute, rulesArray, parsedRules);
    }
    return parsedRules;


  },

  _parseRulesCheck: function (attribute, rulesArray, parsedRules, wildCardValues) {
    if (attribute.indexOf('*') > -1) {
      this._parsedRulesRecurse(attribute, rulesArray, parsedRules, wildCardValues);
    } else {
      this._parseRulesDefault(attribute, rulesArray, parsedRules, wildCardValues);
    }
  },

  _parsedRulesRecurse: function (attribute, rulesArray, parsedRules, wildCardValues) {
    var parentPath = attribute.substr(0, attribute.indexOf('*') - 1);
    var propertyValue = this._objectPath(this.input, parentPath);

    if (propertyValue) {
      for (var propertyNumber = 0; propertyNumber < propertyValue.length; propertyNumber++) {
        var workingValues = wildCardValues ? wildCardValues.slice() : [];
        workingValues.push(propertyNumber);
        this._parseRulesCheck(attribute.replace('*', propertyNumber), rulesArray, parsedRules, workingValues);
      }
    }
  },

  _parseRulesDefault: function (attribute, rulesArray, parsedRules, wildCardValues) {
    var attributeRules = [];

    if (rulesArray instanceof Array) {
      rulesArray = this._prepareRulesArray(rulesArray);
    }

    if (typeof rulesArray === 'string') {
      rulesArray = rulesArray.split('|');
    }

    for (var i = 0, len = rulesArray.length, rule; i < len; i++) {
      rule = typeof rulesArray[i] === 'string' ? this._extractRuleAndRuleValue(rulesArray[i]) : rulesArray[i];
      if (rule.value) {
        rule.value = this._replaceWildCards(rule.value, wildCardValues);
        this._replaceWildCardsMessages(wildCardValues);
      }

      if (Rules.isAsync(rule.name)) {
        this.hasAsync = true;
      }
      attributeRules.push(rule);
    }

    parsedRules[attribute] = attributeRules;
  },

  _replaceWildCards: function (path, nums) {

    if (!nums) {
      return path;
    }

    var path2 = path;
    nums.forEach(function (value) {
      var pos = path2.indexOf('*');
      if (pos === -1) {
        return path2;
      }
      path2 = path2.substr(0, pos) + value + path2.substr(pos + 1);
    });
    return path2;
  },

  _replaceWildCardsMessages: function (nums) {
    var customMessages = this.messages.customMessages;
    var self = this;
    Object.keys(customMessages).forEach(function (key) {
      if (nums) {
        var newKey = self._replaceWildCards(key, nums);
        customMessages[newKey] = customMessages[key];
      }
    });

    this.messages._setCustom(customMessages);
  },
  /**
   * Prepare rules if it comes in Array. Check for objects. Need for type validation.
   *
   * @param  {array} rulesArray
   * @return {array}
   */
  _prepareRulesArray: function (rulesArray) {
    var rules = [];

    for (var i = 0, len = rulesArray.length; i < len; i++) {
      if (typeof rulesArray[i] === 'object') {
        for (var rule in rulesArray[i]) {
          rules.push({
            name: rule,
            value: rulesArray[i][rule]
          });
        }
      } else {
        rules.push(rulesArray[i]);
      }
    }

    return rules;
  },

  /**
   * Determines if the attribute is supplied with the original data object.
   *
   * @param  {array} attribute
   * @return {boolean}
   */
  _suppliedWithData: function (attribute) {
    return this.input.hasOwnProperty(attribute);
  },

  /**
   * Extract a rule and a value from a ruleString (i.e. min:3), rule = min, value = 3
   *
   * @param  {string} ruleString min:3
   * @return {object} object containing the name of the rule and value
   */
  _extractRuleAndRuleValue: function (ruleString) {
    var rule = {},
      ruleArray;

    rule.name = ruleString;

    if (ruleString.indexOf(':') >= 0) {
      ruleArray = ruleString.split(':');
      rule.name = ruleArray[0];
      rule.value = ruleArray.slice(1).join(":");
    }

    return rule;
  },

  /**
   * Determine if attribute has any of the given rules
   *
   * @param  {string}  attribute
   * @param  {array}   findRules
   * @return {boolean}
   */
  _hasRule: function (attribute, findRules) {
    var rules = this.rules[attribute] || [];
    for (var i = 0, len = rules.length; i < len; i++) {
      if (findRules.indexOf(rules[i].name) > -1) {
        return true;
      }
    }
    return false;
  },

  /**
   * Determine if attribute has any numeric-based rules.
   *
   * @param  {string}  attribute
   * @return {Boolean}
   */
  _hasNumericRule: function (attribute) {
    return this._hasRule(attribute, this.numericRules);
  },

  /**
   * Determine if rule is validatable
   *
   * @param  {Rule}   rule
   * @param  {mixed}  value
   * @return {boolean}
   */
  _isValidatable: function (rule, value) {
    if (Rules.isImplicit(rule.name)) {
      return true;
    }

    return this.getRule('required').validate(value);
  },

  /**
   * Determine if we should stop validating.
   *
   * @param  {string} attribute
   * @param  {boolean} rulePassed
   * @return {boolean}
   */
  _shouldStopValidating: function (attribute, rulePassed) {

    var stopOnAttributes = this.stopOnAttributes;
    if (typeof stopOnAttributes === 'undefined' || stopOnAttributes === false || rulePassed === true) {
      return false;
    }

    if (stopOnAttributes instanceof Array) {
      return stopOnAttributes.indexOf(attribute) > -1;
    }

    return true;
  },

  /**
   * Set custom attribute names.
   *
   * @param {object} attributes
   * @return {void}
   */
  setAttributeNames: function (attributes) {
    this.messages._setAttributeNames(attributes);
  },

  /**
   * Set the attribute formatter.
   *
   * @param {fuction} func
   * @return {void}
   */
  setAttributeFormatter: function (func) {
    this.messages._setAttributeFormatter(func);
  },

  /**
   * Get validation rule
   *
   * @param  {string} name
   * @return {Rule}
   */
  getRule: function (name) {
    return Rules.make(name, this);
  },

  /**
   * Stop on first error.
   *
   * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
   * @return {void}
   */
  stopOnError: function (attributes) {
    this.stopOnAttributes = attributes;
  },

  /**
   * Determine if validation passes
   *
   * @param {function} passes
   * @return {boolean|undefined}
   */
  passes: function (passes) {
    var async = this._checkAsync('passes', passes);
    if (async) {
      return this.checkAsync(passes);
    }
    return this.check();
  },

  /**
   * Determine if validation fails
   *
   * @param {function} fails
   * @return {boolean|undefined}
   */
  fails: function (fails) {
    var async = this._checkAsync('fails', fails);
    if (async) {
      return this.checkAsync(function () {}, fails);
    }
    return !this.check();
  },

  /**
   * Check if validation should be called asynchronously
   *
   * @param  {string}   funcName Name of the caller
   * @param  {function} callback
   * @return {boolean}
   */
  _checkAsync: function (funcName, callback) {
    var hasCallback = typeof callback === 'function';
    if (this.hasAsync && !hasCallback) {
      throw funcName + ' expects a callback when async rules are being tested.';
    }

    return this.hasAsync || hasCallback;
  }

};

/**
 * Set messages for language
 *
 * @param {string} lang
 * @param {object} messages
 * @return {this}
 */
Validator.setMessages = function (lang, messages) {
  Lang._set(lang, messages);
  return this;
};

/**
 * Get messages for given language
 *
 * @param  {string} lang
 * @return {Messages}
 */
Validator.getMessages = function (lang) {
  return Lang._get(lang);
};

/**
 * Set default language to use
 *
 * @param {string} lang
 * @return {void}
 */
Validator.useLang = function (lang) {
  this.prototype.lang = lang;
};

/**
 * Get default language
 *
 * @return {string}
 */
Validator.getDefaultLang = function () {
  return this.prototype.lang;
};

/**
 * Set the attribute formatter.
 *
 * @param {fuction} func
 * @return {void}
 */
Validator.setAttributeFormatter = function (func) {
  this.prototype.attributeFormatter = func;
};

/**
 * Stop on first error.
 *
 * @param  {boolean|array} An array of attributes or boolean true/false for all attributes.
 * @return {void}
 */
Validator.stopOnError = function (attributes) {
  this.prototype.stopOnAttributes = attributes;
};

/**
 * Register custom validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.register = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.register(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register custom validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerImplicit = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.registerImplicit(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register asynchronous validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerAsync = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.registerAsync(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register asynchronous validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerAsyncImplicit = function (name, fn, message) {
  var lang = Validator.getDefaultLang();
  Rules.registerAsyncImplicit(name, fn);
  Lang._setRuleMessage(lang, name, message);
};

/**
 * Register validator for missed validation rule
 *
 * @param  {string}   name
 * @param  {function} fn
 * @param  {string}   message
 * @return {void}
 */
Validator.registerMissedRuleValidator = function(fn, message) {
  Rules.registerMissedRuleValidator(fn, message);
};

module.exports = Validator;


/***/ }),
/* 1030 */
/***/ (function(module, exports) {

function leapYear(year) {
  return ((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0);
}

function isValidDate(inDate) {
    var valid = true;

    // reformat if supplied as mm.dd.yyyy (period delimiter)
    if (typeof inDate === 'string') {
      var pos = inDate.indexOf('.');
      if ((pos > 0 && pos <= 6)) {
        inDate = inDate.replace(/\./g, '-');
      }
    }

    var testDate = new Date(inDate);
    var yr = testDate.getFullYear();
    var mo = testDate.getMonth();
    var day = testDate.getDate();

    var daysInMonth = [31, (leapYear(yr) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    if (yr < 1000) { return false; }
    if (isNaN(mo)) { return false; }
    if (mo + 1 > 12) { return false; }
    if (isNaN(day)) { return false; }
    if (day > daysInMonth[mo]) { return false; }

    return valid;
}

var rules = {

  required: function(val) {
    var str;

    if (val === undefined || val === null) {
      return false;
    }

    str = String(val).replace(/\s/g, "");
    return str.length > 0 ? true : false;
  },

  required_if: function(val, req, attribute) {
    req = this.getParameters();
    if (this.validator._objectPath(this.validator.input, req[0]) === req[1]) {
      return this.validator.getRule('required').validate(val);
    }

    return true;
  },

  required_unless: function(val, req, attribute) {
    req = this.getParameters();
    if (this.validator._objectPath(this.validator.input, req[0]) !== req[1]) {
      return this.validator.getRule('required').validate(val);
    }

    return true;
  },

  required_with: function(val, req, attribute) {
    if (this.validator._objectPath(this.validator.input, req)) {
      return this.validator.getRule('required').validate(val);
    }

    return true;
  },

  required_with_all: function(val, req, attribute) {

    req = this.getParameters();

    for(var i = 0; i < req.length; i++) {
      if (!this.validator._objectPath(this.validator.input, req[i])) {
        return true;
      }
    }

    return this.validator.getRule('required').validate(val);
  },

  required_without: function(val, req, attribute) {

    if (this.validator._objectPath(this.validator.input, req)) {
      return true;
    }

    return this.validator.getRule('required').validate(val);
  },

  required_without_all: function(val, req, attribute) {

    req = this.getParameters();

    for(var i = 0; i < req.length; i++) {
      if (this.validator._objectPath(this.validator.input, req[i])) {
        return true;
      }
    }

    return this.validator.getRule('required').validate(val);
  },

  'boolean': function (val) {
    return (
      val === true ||
      val === false ||
      val === 0 ||
      val === 1 ||
      val === '0' ||
      val === '1' ||
      val === 'true' ||
      val === 'false'
    );
  },

  // compares the size of strings
  // with numbers, compares the value
  size: function(val, req, attribute) {
    if (val) {
      req = parseFloat(req);

      var size = this.getSize();

      return size === req;
    }

    return true;
  },

  string: function(val, req, attribute) {
    return typeof val === 'string';
  },

  sometimes: function(val) {
    return true;
  },

  /**
   * Compares the size of strings or the value of numbers if there is a truthy value
   */
  min: function(val, req, attribute) {
    var size = this.getSize();
    return size >= req;
  },

  /**
   * Compares the size of strings or the value of numbers if there is a truthy value
   */
  max: function(val, req, attribute) {
    var size = this.getSize();
    return size <= req;
  },

  between: function(val, req, attribute) {
    req = this.getParameters();
    var size = this.getSize();
    var min = parseFloat(req[0], 10);
    var max = parseFloat(req[1], 10);
    return size >= min && size <= max;
  },

  email: function(val) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(val);
  },

  numeric: function(val) {
    var num;

    num = Number(val); // tries to convert value to a number. useful if value is coming from form element

    if (typeof num === 'number' && !isNaN(num) && typeof val !== 'boolean') {
      return true;
    } else {
      return false;
    }
  },

  array: function(val) {
    return val instanceof Array;
  },

  url: function(url) {
    return (/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i).test(url);
  },

  alpha: function(val) {
    return (/^[a-zA-Z]+$/).test(val);
  },

  alpha_dash: function(val) {
    return (/^[a-zA-Z0-9_\-]+$/).test(val);
  },

  alpha_num: function(val) {
    return (/^[a-zA-Z0-9]+$/).test(val);
  },

  same: function(val, req) {
    var val1 = this.validator._flattenObject(this.validator.input)[req];
    var val2 = val;

    if (val1 === val2) {
      return true;
    }

    return false;
  },

  different: function(val, req) {
    var val1 = this.validator._flattenObject(this.validator.input)[req];
    var val2 = val;

    if (val1 !== val2) {
      return true;
    }

    return false;
  },

  "in": function(val, req) {
    var list, i;

    if (val) {
      list = this.getParameters();
    }

    if (val && !(val instanceof Array)) {
      var localValue = val;

      for (i = 0; i < list.length; i++) {
        if (typeof list[i] === 'string') {
          localValue = String(val);
        }

        if (localValue === list[i]) {
          return true;
        }
      }

      return false;
    }

    if (val && val instanceof Array) {
      for (i = 0; i < val.length; i++) {
        if (list.indexOf(val[i]) < 0) {
          return false;
        }
      }
    }

    return true;
  },

  not_in: function(val, req) {
    var list = this.getParameters();
    var len = list.length;
    var returnVal = true;

    for (var i = 0; i < len; i++) {
      var localValue = val;

      if (typeof list[i] === 'string') {
        localValue = String(val);
      }

      if (localValue === list[i]) {
        returnVal = false;
        break;
      }
    }

    return returnVal;
  },

  accepted: function(val) {
    if (val === 'on' || val === 'yes' || val === 1 || val === '1' || val === true) {
      return true;
    }

    return false;
  },

  confirmed: function(val, req, key) {
    var confirmedKey = key + '_confirmation';

    if (this.validator.input[confirmedKey] === val) {
      return true;
    }

    return false;
  },

  integer: function(val) {
    return String(parseInt(val, 10)) === String(val);
  },

  digits: function(val, req) {
    var numericRule = this.validator.getRule('numeric');
    if (numericRule.validate(val) && String(val).length === parseInt(req)) {
      return true;
    }

    return false;
  },

  regex: function(val, req) {
    var mod = /[g|i|m]{1,3}$/;
    var flag = req.match(mod);
    flag = flag ? flag[0] : "";
    req = req.replace(mod, "").slice(1, -1);
    req = new RegExp(req, flag);
    return !!val.match(req);
  },

  date: function(val, format) {
    return isValidDate(val);
  },

  present: function(val) {
    return typeof val !== 'undefined';
  },

  after: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() < new Date(val2).getTime()) {
      return true;
    }

    return false;
  },

   after_or_equal: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() <= new Date(val2).getTime()) {
      return true;
    }

    return false;
  },

  before: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() > new Date(val2).getTime()) {
      return true;
    }

    return false;
  },

   before_or_equal: function(val, req){
    var val1 = this.validator.input[req];
    var val2 = val;

    if(!isValidDate(val1)){ return false;}
    if(!isValidDate(val2)){ return false;}

    if (new Date(val1).getTime() >= new Date(val2).getTime()) {
      return true;
    }

    return false;
  }


};

var missedRuleValidator = function() {
  throw new Error('Validator `' + this.name + '` is not defined!');
};
var missedRuleMessage;

function Rule(name, fn, async) {
  this.name = name;
  this.fn = fn;
  this.passes = null;
  this._customMessage = undefined;
  this.async = async;
}

Rule.prototype = {

  /**
   * Validate rule
   *
   * @param  {mixed} inputValue
   * @param  {mixed} ruleValue
   * @param  {string} attribute
   * @param  {function} callback
   * @return {boolean|undefined}
   */
  validate: function(inputValue, ruleValue, attribute, callback) {
    var _this = this;
    this._setValidatingData(attribute, inputValue, ruleValue);
    if (typeof callback === 'function') {
      this.callback = callback;
      var handleResponse = function(passes, message) {
        _this.response(passes, message);
      };

      if (this.async) {
        return this._apply(inputValue, ruleValue, attribute, handleResponse);
      } else {
        return handleResponse(this._apply(inputValue, ruleValue, attribute));
      }
    }
    return this._apply(inputValue, ruleValue, attribute);
  },

  /**
   * Apply validation function
   *
   * @param  {mixed} inputValue
   * @param  {mixed} ruleValue
   * @param  {string} attribute
   * @param  {function} callback
   * @return {boolean|undefined}
   */
  _apply: function(inputValue, ruleValue, attribute, callback) {
    var fn = this.isMissed() ? missedRuleValidator : this.fn;

    return fn.apply(this, [inputValue, ruleValue, attribute, callback]);
  },

  /**
   * Set validating data
   *
   * @param {string} attribute
   * @param {mixed} inputValue
   * @param {mixed} ruleValue
   * @return {void}
   */
  _setValidatingData: function(attribute, inputValue, ruleValue) {
    this.attribute = attribute;
    this.inputValue = inputValue;
    this.ruleValue = ruleValue;
  },

  /**
   * Get parameters
   *
   * @return {array}
   */
  getParameters: function() {
    var value = [];

    if (typeof this.ruleValue === 'string') {
      value = this.ruleValue.split(',');
    }

    if (typeof this.ruleValue === 'number') {
      value.push(this.ruleValue);
    }

    if (this.ruleValue instanceof Array) {
      value = this.ruleValue;
    }

    return value;
  },

  /**
   * Get true size of value
   *
   * @return {integer|float}
   */
  getSize: function() {
    var value = this.inputValue;

    if (value instanceof Array) {
      return value.length;
    }

    if (typeof value === 'number') {
      return value;
    }

    if (this.validator._hasNumericRule(this.attribute)) {
      return parseFloat(value, 10);
    }

    return value.length;
  },

  /**
   * Get the type of value being checked; numeric or string.
   *
   * @return {string}
   */
  _getValueType: function() {

    if (typeof this.inputValue === 'number' || this.validator._hasNumericRule(this.attribute)) {
      return 'numeric';
    }

    return 'string';
  },

  /**
   * Set the async callback response
   *
   * @param  {boolean|undefined} passes  Whether validation passed
   * @param  {string|undefined} message Custom error message
   * @return {void}
   */
  response: function(passes, message) {
    this.passes = (passes === undefined || passes === true);
    this._customMessage = message;
    this.callback(this.passes, message);
  },

  /**
   * Set validator instance
   *
   * @param {Validator} validator
   * @return {void}
   */
  setValidator: function(validator) {
    this.validator = validator;
  },

  /**
   * Check if rule is missed
   *
   * @return {boolean}
   */
  isMissed: function() {
    return typeof this.fn !== 'function';
  },

  get customMessage() {
    return this.isMissed() ? missedRuleMessage : this._customMessage;
  }
};

var manager = {

  /**
   * List of async rule names
   *
   * @type {Array}
   */
  asyncRules: [],

  /**
   * Implicit rules (rules to always validate)
   *
   * @type {Array}
   */
  implicitRules: ['required', 'required_if', 'required_unless', 'required_with', 'required_with_all', 'required_without', 'required_without_all', 'accepted', 'present'],

  /**
   * Get rule by name
   *
   * @param  {string} name
   * @param {Validator}
   * @return {Rule}
   */
  make: function(name, validator) {
    var async = this.isAsync(name);
    var rule = new Rule(name, rules[name], async);
    rule.setValidator(validator);
    return rule;
  },

  /**
   * Determine if given rule is async
   *
   * @param  {string}  name
   * @return {boolean}
   */
  isAsync: function(name) {
    for (var i = 0, len = this.asyncRules.length; i < len; i++) {
      if (this.asyncRules[i] === name) {
        return true;
      }
    }
    return false;
  },

  /**
   * Determine if rule is implicit (should always validate)
   *
   * @param {string} name
   * @return {boolean}
   */
  isImplicit: function(name) {
    return this.implicitRules.indexOf(name) > -1;
  },

  /**
   * Register new rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  register: function(name, fn) {
    rules[name] = fn;
  },

    /**
   * Register new implicit rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerImplicit: function(name, fn) {
    this.register(name, fn);
    this.implicitRules.push(name);
  },

  /**
   * Register async rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerAsync: function(name, fn) {
    this.register(name, fn);
    this.asyncRules.push(name);
  },

  /**
   * Register implicit async rule
   *
   * @param  {string}   name
   * @param  {function} fn
   * @return {void}
   */
  registerAsyncImplicit: function(name, fn) {
    this.registerImplicit(name, fn);
    this.asyncRules.push(name);
  },

  registerMissedRuleValidator: function(fn, message) {
    missedRuleValidator = fn;
    missedRuleMessage = message;
  }
};



module.exports = manager;


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var require;var Messages = __webpack_require__(1032);

__webpack_require__(255);

var require_method = require;

var container = {

  messages: {},

  /**
   * Set messages for language
   *
   * @param {string} lang
   * @param {object} rawMessages
   * @return {void}
   */
  _set: function(lang, rawMessages) {
    this.messages[lang] = rawMessages;
  },

  /**
   * Set message for given language's rule.
   *
   * @param {string} lang
   * @param {string} attribute
   * @param {string|object} message
   * @return {void}
   */
  _setRuleMessage: function(lang, attribute, message) {
    this._load(lang);
    if (message === undefined) {
      message = this.messages[lang].def;
    }

    this.messages[lang][attribute] = message;
  },

  /**
   * Load messages (if not already loaded)
   *
   * @param  {string} lang
   * @return {void}
   */
  _load: function(lang) {
    if (!this.messages[lang]) {
      try {
        var rawMessages = __webpack_require__(1033)("./" + lang);
        this._set(lang, rawMessages);
      } catch (e) {}
    }
  },

  /**
   * Get raw messages for language
   *
   * @param  {string} lang
   * @return {object}
   */
  _get: function(lang) {
    this._load(lang);
    return this.messages[lang];
  },

  /**
   * Make messages for given language
   *
   * @param  {string} lang
   * @return {Messages}
   */
  _make: function(lang) {
    this._load(lang);
    return new Messages(lang, this.messages[lang]);
  }

};

module.exports = container;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var Attributes = __webpack_require__(435);

var Messages = function(lang, messages) {
  this.lang = lang;
  this.messages = messages;
  this.customMessages = {};
  this.attributeNames = {};
};

Messages.prototype = {
  constructor: Messages,

  /**
   * Set custom messages
   *
   * @param {object} customMessages
   * @return {void}
   */
  _setCustom: function(customMessages) {
    this.customMessages = customMessages || {};
  },

  /**
   * Set custom attribute names.
   *
   * @param {object} attributes
   */
  _setAttributeNames: function(attributes) {
    this.attributeNames = attributes;
  },

  /**
   * Set the attribute formatter.
   *
   * @param {fuction} func
   * @return {void}
   */
  _setAttributeFormatter: function(func) {
    this.attributeFormatter = func;
  },

  /**
   * Get attribute name to display.
   *
   * @param  {string} attribute
   * @return {string}
   */
  _getAttributeName: function(attribute) {
    var name = attribute;
    if (this.attributeNames.hasOwnProperty(attribute)) {
      return this.attributeNames[attribute];
    } else if (this.messages.attributes.hasOwnProperty(attribute)) {
      name = this.messages.attributes[attribute];
    }

    if (this.attributeFormatter) {
      name = this.attributeFormatter(name);
    }

    return name;
  },

  /**
   * Get all messages
   *
   * @return {object}
   */
  all: function() {
    return this.messages;
  },

  /**
   * Render message
   *
   * @param  {Rule} rule
   * @return {string}
   */
  render: function(rule) {
    if (rule.customMessage) {
      return rule.customMessage;
    }
    var template = this._getTemplate(rule);

    var message;
    if (Attributes.replacements[rule.name]) {
      message = Attributes.replacements[rule.name].apply(this, [template, rule]);
    } else {
      message = this._replacePlaceholders(rule, template, {});
    }

    return message;
  },

  /**
   * Get the template to use for given rule
   *
   * @param  {Rule} rule
   * @return {string}
   */
  _getTemplate: function(rule) {

    var messages = this.messages;
    var template = messages.def;
    var customMessages = this.customMessages;
    var formats = [rule.name + '.' + rule.attribute, rule.name];

    for (var i = 0, format; i < formats.length; i++) {
      format = formats[i];
      if (customMessages.hasOwnProperty(format)) {
        template = customMessages[format];
        break;
      } else if (messages.hasOwnProperty(format)) {
        template = messages[format];
        break;
      }
    }

    if (typeof template === 'object') {
      template = template[rule._getValueType()];
    }

    return template;
  },

  /**
   * Replace placeholders in the template using the data object
   *
   * @param  {Rule} rule
   * @param  {string} template
   * @param  {object} data
   * @return {string}
   */
  _replacePlaceholders: function(rule, template, data) {
    var message, attribute;

    data.attribute = this._getAttributeName(rule.attribute);
    data[rule.name] = data[rule.name] || rule.getParameters().join(',');

    if (typeof template === 'string' && typeof data === 'object') {
      message = template;

      for (attribute in data) {
        message = message.replace(new RegExp(':' + attribute, 'g'), data[attribute]);
      }
    }

    return message;
  }

};

module.exports = Messages;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./de": 436,
	"./de.js": 436,
	"./el": 437,
	"./el.js": 437,
	"./en": 255,
	"./en.js": 255,
	"./es": 438,
	"./es.js": 438,
	"./fa": 439,
	"./fa.js": 439,
	"./fr": 440,
	"./fr.js": 440,
	"./it": 441,
	"./it.js": 441,
	"./ja": 442,
	"./ja.js": 442,
	"./nb_NO": 443,
	"./nb_NO.js": 443,
	"./nl": 444,
	"./nl.js": 444,
	"./pl": 445,
	"./pl.js": 445,
	"./pt": 446,
	"./pt.js": 446,
	"./ru": 447,
	"./ru.js": 447,
	"./tr": 448,
	"./tr.js": 448,
	"./ua": 449,
	"./ua.js": 449,
	"./vi": 450,
	"./vi.js": 450,
	"./zh": 451,
	"./zh.js": 451,
	"./zh_TW": 452,
	"./zh_TW.js": 452
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1033;

/***/ }),
/* 1034 */
/***/ (function(module, exports) {

var Errors = function() {
  this.errors = {};
};

Errors.prototype = {
  constructor: Errors,

  /**
   * Add new error message for given attribute
   *
   * @param  {string} attribute
   * @param  {string} message
   * @return {void}
   */
  add: function(attribute, message) {
    if (!this.has(attribute)) {
      this.errors[attribute] = [];
    }

    if (this.errors[attribute].indexOf(message) === -1) {
      this.errors[attribute].push(message);
    }
  },

  /**
   * Returns an array of error messages for an attribute, or an empty array
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {array} An array of error messages
   */
  get: function(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute];
    }

    return [];
  },

  /**
   * Returns the first error message for an attribute, false otherwise
   *
   * @param  {string} attribute A key in the data object being validated
   * @return {string|false} First error message or false
   */
  first: function(attribute) {
    if (this.has(attribute)) {
      return this.errors[attribute][0];
    }

    return false;
  },

  /**
   * Get all error messages from all failing attributes
   *
   * @return {Object} Failed attribute names for keys and an array of messages for values
   */
  all: function() {
    return this.errors;
  },

  /**
   * Determine if there are any error messages for an attribute
   *
   * @param  {string}  attribute A key in the data object being validated
   * @return {boolean}
   */
  has: function(attribute) {
    if (this.errors.hasOwnProperty(attribute)) {
      return true;
    }

    return false;
  }
};

module.exports = Errors;


/***/ }),
/* 1035 */
/***/ (function(module, exports) {

function AsyncResolvers(onFailedOne, onResolvedAll) {
  this.onResolvedAll = onResolvedAll;
  this.onFailedOne = onFailedOne;
  this.resolvers = {};
  this.resolversCount = 0;
  this.passed = [];
  this.failed = [];
  this.firing = false;
}

AsyncResolvers.prototype = {

  /**
   * Add resolver
   *
   * @param {Rule} rule
   * @return {integer}
   */
  add: function(rule) {
    var index = this.resolversCount;
    this.resolvers[index] = rule;
    this.resolversCount++;
    return index;
  },

  /**
   * Resolve given index
   *
   * @param  {integer} index
   * @return {void}
   */
  resolve: function(index) {
    var rule = this.resolvers[index];
    if (rule.passes === true) {
      this.passed.push(rule);
    } else if (rule.passes === false) {
      this.failed.push(rule);
      this.onFailedOne(rule);
    }

    this.fire();
  },

  /**
   * Determine if all have been resolved
   *
   * @return {boolean}
   */
  isAllResolved: function() {
    return (this.passed.length + this.failed.length) === this.resolversCount;
  },

  /**
   * Attempt to fire final all resolved callback if completed
   *
   * @return {void}
   */
  fire: function() {

    if (!this.firing) {
      return;
    }

    if (this.isAllResolved()) {
      this.onResolvedAll(this.failed.length === 0);
    }

  },

  /**
   * Enable firing
   *
   * @return {void}
   */
  enableFiring: function() {
    this.firing = true;
  }

};

module.exports = AsyncResolvers;


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var validationErrors={accepted:':attribute måste vara godkännt.',alpha:':attribute får bara innehålla bokstäver.',alpha_dash:':attribute får bara innehålla alfanumeriska tecken, bindestreck och understreck.',alpha_num:':attribute måste vara alfanumeriskt.',between:':attribute måste vara mellan :min och :max.',confirmed:':attribute överensstämmer inte.',email:':attribute är inte en korrekt e-postadress.',date:':attribute är inte ett korrekt datum.',def:':attribute innehåller fel.',digits:':attribute måste vara :digits siffror.',different:':attribute och :different måste vara annorlunda.','in':':attribute är inte korrekt val.',integer:':attribute får bara innehålla siffror.',min:{numeric:':attribute måste vara högre än :min.',string:':attribute måste vara längre än :min tecken.'},max:{numeric:':attribute får inte vara högre än :max.',string:':attribute får inte vara längre än :max tecken.'},not_in:'Det valda :attribute är ogiltigt.',numeric:':attribute måste vara ett nummer.',required:':attribute måste vara ifyllt.',required_if:':attribute måste vara ifyllt när :other är :value.',required_without:':attribute måste vara ifyllt när :field är tomt',same:':attribute och :same måste matcha.',size:{numeric:':attribute måste vara :size.',string:':attribute måste vara :size tecken långt.'},string:':attribute får bara innehålla text.',url:':attribute har ett felaktigt format.',regex:':attribute har ett felaktigt format.',archivable:':attribute måste vara ett datum eller ett booleskt värde',attributes:{}};exports.validationErrors=validationErrors;

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(1039);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(72);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(1040);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(454);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(456);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (!_safeHTMLElement.canUseDOM) return;
      var isOpen = newProps.isOpen;
      // Stop unnecessary renders if modal is remaining closed

      if (!this.props.isOpen && !isOpen) return;

      var currentParent = getParentElement(this.props.parentSelector);
      var newParent = getParentElement(newProps.parentSelector);

      if (newParent !== currentParent) {
        currentParent.removeChild(this.node);
        newParent.appendChild(this.node);
      }

      !isReact16 && this.renderPortal(newProps);
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(newProps) {
      if (!_safeHTMLElement.canUseDOM) return;
      if (newProps.portalClassName !== this.props.portalClassName) {
        this.node.className = newProps.portalClassName;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
exports.default = Modal;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(1041);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(1042);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(454);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _refCount = __webpack_require__(455);

var refCount = _interopRequireWildcard(_refCount);

var _bodyClassList = __webpack_require__(1043);

var bodyClassList = _interopRequireWildcard(_bodyClassList);

var _safeHTMLElement = __webpack_require__(456);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setFocusAfterRender = function (focus) {
      _this.focusAfterRender = _this.props.shouldFocusAfterRender && focus;
    };

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
    };

    _this.setContentRef = function (content) {
      _this.content = content;
    };

    _this.afterClose = function () {
      // Remove body class
      bodyClassList.remove(_this.props.bodyOpenClassName);

      if (_this.shouldReturnFocus()) {
        focusManager.returnFocus();
        focusManager.teardownScopedFocus();
      }
    };

    _this.shouldReturnFocus = function () {
      // Don't restore focus to the element that had focus prior to
      // the modal's display if:
      // 1. Focus was never shifted to the modal in the first place
      //    (shouldFocusAfterRender = false)
      // 2. Explicit direction to not restore focus
      return _this.props.shouldFocusAfterRender || _this.props.shouldReturnFocusAfterClose;
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.shouldReturnFocus()) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      _this.beforeClose();
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.preventDefault();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
      _this.moveFromContentToOverlay = null;
    };

    _this.handleOverlayOnMouseUp = function () {
      if (_this.moveFromContentToOverlay === null) {
        _this.shouldClose = false;
      }
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function () {
      _this.moveFromContentToOverlay = false;
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
      _this.moveFromContentToOverlay = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.ariaAttributes = function (items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc["aria-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Focus needs to be set when mounting and already open
      if (this.props.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(newProps) {
      if (false) {
        if (newProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }
      // Focus only needs to be set once when the modal is being opened
      if (!this.props.isOpen && newProps.isOpen) {
        this.setFocusAfterRender(true);
        this.open();
      } else if (this.props.isOpen && !newProps.isOpen) {
        this.close();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.focusAfterRender) {
        this.focusContent();
        this.setFocusAfterRender(false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove body class
      bodyClassList.remove(this.props.bodyOpenClassName);
      this.beforeClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          bodyOpenClassName = _props.bodyOpenClassName;
      // Add body class

      bodyClassList.add(bodyOpenClassName);
      // Add aria-hidden to appElement
      if (ariaHideApp) {
        ariaAppHider.hide(appElement);
      }
    }
  }, {
    key: "beforeClose",
    value: function beforeClose() {
      var _props2 = this.props,
          appElement = _props2.appElement,
          ariaHideApp = _props2.ariaHideApp;
      // Reset aria-hidden attribute if all modals have been removed

      if (ariaHideApp && refCount.totalCount() < 1) {
        ariaAppHider.show(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          overlayClassName = _props3.overlayClassName,
          defaultStyles = _props3.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          onMouseUp: this.handleOverlayOnMouseUp
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.ariaAttributes(this.props.aria || {})),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  }
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(453);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    toFocus = focusLaterElements.pop();
    toFocus.focus();
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(453);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);
  if (!tabbable.length) {
    event.preventDefault();
    return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = finalTabbable === document.activeElement ||
  // handle immediate shift+tab after opening with mouse
  node === document.activeElement;
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
}
module.exports = exports["default"];

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.remove = remove;

var _refCount = __webpack_require__(455);

var refCount = _interopRequireWildcard(_refCount);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function add(bodyClass) {
  // Increment class(es) on refCount tracker and add class(es) to body
  bodyClass.split(" ").map(refCount.add).forEach(function (className) {
    return document.body.classList.add(className);
  });
}

function remove(bodyClass) {
  var classListMap = refCount.get();
  // Decrement class(es) from the refCount tracker
  // and remove unused class(es) from body
  bodyClass.split(" ").map(refCount.remove).filter(function (className) {
    return classListMap[className] === 0;
  }).forEach(function (className) {
    return document.body.classList.remove(className);
  });
}

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  deviations: any[],
  apartmentDeviations: any[],
};*/var _ref2=_react2.default.createElement(_reduxForm.Field,{name:'reason',label:'Beskrivning',component:_TextAreaFormInput2.default});var ApartmentDeviationForm=function ApartmentDeviationForm(_ref){var deviations=_ref.deviations,apartmentDeviations=_ref.apartmentDeviations;return _react2.default.createElement('div',{className:'ApartmentDeviationForm'},_react2.default.createElement(_reduxForm.Field,{name:'id',label:'Avvikelsetyp',normalize:function normalize(value){return value?value.id:null;},component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:(0,_map3.default)(function(d){return _extends({},d,{disabled:(0,_some3.default)({id:d.id},apartmentDeviations)});},deviations)}),_ref2);};exports.default=(0,_reduxForm.reduxForm)({form:'apartmentDeviation',enableReinitialize:true})(ApartmentDeviationForm);

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _CopyArticleForm=__webpack_require__(1047);var _CopyArticleForm2=_interopRequireDefault(_CopyArticleForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  apartment: Object,
  validate: Function,
  isLoading: boolean,
  error: ?any,
  onSubmit: Function,
  onClose: Function,
};*/var CopyApartmentDialog=function CopyApartmentDialog(_ref){var apartment=_ref.apartment,validate=_ref.validate,isLoading=_ref.isLoading,error=_ref.error,onSubmit=_ref.onSubmit,onClose=_ref.onClose;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:onClose,className:'CopyApartmentDialog',show:true},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isLoading}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_CopyArticleForm2.default,{initialValues:apartment,onSubmit:onSubmit,validate:validate}),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onClose},'Avbryt')));};exports.default=CopyApartmentDialog;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  handleSubmit: Function,
};*/var _ref2=_react2.default.createElement(_reduxForm.Field,{name:'objectId',label:'Nytt l\xE4genhetsnummer',component:_BasicFormInput2.default,type:'text'});var _ref3=_react2.default.createElement('button',{type:'submit',className:'button success expanded'},'Skapa kopia');var CopyArticleForm=function CopyArticleForm(_ref){var handleSubmit=_ref.handleSubmit;return _react2.default.createElement('div',{className:'CopyArticleForm'},_react2.default.createElement('form',{onSubmit:handleSubmit},_ref2,_ref3));};exports.default=(0,_reduxForm.reduxForm)({form:'copyApartment'})(CopyArticleForm);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportMultiple; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getDataTransferItems;
/* harmony export (immutable) */ __webpack_exports__["b"] = fileAccepted;
/* harmony export (immutable) */ __webpack_exports__["c"] = fileMatchSize;
/* harmony export (immutable) */ __webpack_exports__["a"] = allFilesAccepted;
/* harmony export (immutable) */ __webpack_exports__["e"] = onDocumentDragOver;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept__ = __webpack_require__(1049);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_attr_accept___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_attr_accept__);


var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;

function getDataTransferItems(event) {
  var dataTransferItemsList = [];
  if (event.dataTransfer) {
    var dt = event.dataTransfer;
    if (dt.files && dt.files.length) {
      dataTransferItemsList = dt.files;
    } else if (dt.items && dt.items.length) {
      // During the drag even the dataTransfer.files is null
      // but Chrome implements some drag store, which is accesible via dataTransfer.items
      dataTransferItemsList = dt.items;
    }
  } else if (event.target && event.target.files) {
    dataTransferItemsList = event.target.files;
  }
  // Convert from DataTransferItemsList to the native Array
  return Array.prototype.slice.call(dataTransferItemsList);
}

// Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted
function fileAccepted(file, accept) {
  return file.type === 'application/x-moz-file' || __WEBPACK_IMPORTED_MODULE_0_attr_accept___default()(file, accept);
}

function fileMatchSize(file, maxSize, minSize) {
  return file.size <= maxSize && file.size >= minSize;
}

function allFilesAccepted(files, accept) {
  return files.every(function (file) {
    return fileAccepted(file, accept);
  });
}

// allow the entire document to be a drag target
function onDocumentDragOver(evt) {
  evt.preventDefault();
}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  rejected: {
    borderStyle: 'solid',
    borderColor: '#c66',
    backgroundColor: '#eee'
  },
  disabled: {
    opacity: 0.5
  },
  active: {
    borderStyle: 'solid',
    borderColor: '#6c6',
    backgroundColor: '#eee'
  },
  default: {
    width: 200,
    height: 200,
    borderWidth: 2,
    borderColor: '#666',
    borderStyle: 'dashed',
    borderRadius: 5
  }
});

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1052);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fileUrl=_request.apiBase+'/files';/*:: export type Props = {
  file?: any,
  previewSize?: any,
  onClickEmpty?: Function,
};*/var _ref2=_react2.default.createElement('i',{className:'fa fa-file-image-o'});var FilePreview=function FilePreview(_ref){var file=_ref.file,_ref$previewSize=_ref.previewSize,previewSize=_ref$previewSize===undefined?{w:440,h:148}:_ref$previewSize,onClickEmpty=_ref.onClickEmpty;return _react2.default.createElement('div',{className:'FilePreview'},!file&&_react2.default.createElement('div',{className:'no-image',onClick:function onClick(){return onClickEmpty&&onClickEmpty();}},_ref2),file&&_react2.default.createElement('img',{src:fileUrl+'/preview/'+file.id+'/'+previewSize.w+'x'+previewSize.h,alt:''}));};exports.default=FilePreview;

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _toLower2=__webpack_require__(65);var _toLower3=_interopRequireDefault(_toLower2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _FormattedDate=__webpack_require__(460);var _FormattedDate2=_interopRequireDefault(_FormattedDate);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _request=__webpack_require__(6);__webpack_require__(1058);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fileUrl=_request.apiBase+'/files';/*:: export type Props = {
  list: any[],
  label: string,
  onRemove?: Function,
  disabled?: boolean,
};*/var _ref2=_react2.default.createElement('i',{className:'fa fa-trash fa-fw'});var FileList=function FileList(_ref){var label=_ref.label,list=_ref.list,onRemove=_ref.onRemove,_ref$disabled=_ref.disabled,disabled=_ref$disabled===undefined?false:_ref$disabled;return _react2.default.createElement('div',{className:'FileList'},_react2.default.createElement('label',null,label),_react2.default.createElement('div',{className:'file-list'},(!list||!list.length)&&_react2.default.createElement('div',{className:'empty-item'},'Inga ',(0,_toLower3.default)(label)),!!(list&&list.length)&&(0,_map3.default)(function(f){return _react2.default.createElement('div',{key:f.id,className:'row no-row-margins expand'},_react2.default.createElement('a',{href:fileUrl+'/'+f.id+'?download',target:'_blank',className:'column item text-truncate'},_react2.default.createElement(_FormattedDate2.default,{className:'item-date',value:f.archived}),_react2.default.createElement('span',{className:'item-name'},f.name+f.extension)),!!onRemove&&!disabled&&_react2.default.createElement(_ActionConfirmation2.default,{id:'removeFile-'+f.id,wrapperClassName:'shrink',className:'tiny',message:'Vill du verkligen ta bort den h\xE4r filen? (g\xE5r ej att \xE5ngra)',action:function action(){return onRemove&&onRemove(f);}},_ref2));},list)));};exports.default=FileList;

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1061)();
}


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1062);
var invariant = __webpack_require__(1063);
var ReactPropTypesSecret = __webpack_require__(1064);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */
  target.hide = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
  };

  /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */
  target.rebuild = function () {
    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
  };

  /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */
  target.show = function (target) {
    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
  };

  target.prototype.globalRebuild = function () {
    if (this.mount) {
      this.unbindListener();
      this.bindListener();
    }
  };

  target.prototype.globalShow = function (event) {
    if (this.mount) {
      // Create a fake event, specific show will limit the type to `solid`
      // only `float` type cares e.clientX e.clientY
      var e = { currentTarget: event.detail.target };
      this.showTooltip(e, true);
    }
  };

  target.prototype.globalHide = function (event) {
    if (this.mount) {
      var hasTarget = event && event.detail && event.detail.target && true || false;
      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
    }
  };
};

var _constant = __webpack_require__(461);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
  // Compatibale with IE
  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
  var event = void 0;

  if (typeof window.CustomEvent === 'function') {
    event = new window.CustomEvent(eventName, { detail: opts });
  } else {
    event = document.createEvent('Event');
    event.initEvent(eventName, false, true);
    event.detail = opts;
  }

  window.dispatchEvent(event);
}; /**
    * Static methods for react-tooltip
    */

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindWindowEvents = function (resizeHide) {
    // ReactTooltip.hide
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);

    // ReactTooltip.rebuild
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);

    // ReactTooltip.show
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);

    // Resize
    if (resizeHide) {
      window.removeEventListener('resize', this.onWindowResize);
      window.addEventListener('resize', this.onWindowResize, false);
    }
  };

  target.prototype.unbindWindowEvents = function () {
    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
    window.removeEventListener('resize', this.onWindowResize);
  };

  /**
   * invoked by resize event of window
   */
  target.prototype.onWindowResize = function () {
    if (!this.mount) return;
    this.hideTooltip();
  };
};

var _constant = __webpack_require__(461);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCustomEvent = function (ele) {
    var event = this.state.event;

    return event || !!ele.getAttribute('data-event');
  };

  /* Bind listener for custom event */
  target.prototype.customBindListener = function (ele) {
    var _this = this;

    var _state = this.state,
        event = _state.event,
        eventOff = _state.eventOff;

    var dataEvent = ele.getAttribute('data-event') || event;
    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;

    dataEvent.split(' ').forEach(function (event) {
      ele.removeEventListener(event, customListener);
      customListener = checkStatus.bind(_this, dataEventOff);
      ele.addEventListener(event, customListener, false);
    });
    if (dataEventOff) {
      dataEventOff.split(' ').forEach(function (event) {
        ele.removeEventListener(event, _this.hideTooltip);
        ele.addEventListener(event, _this.hideTooltip, false);
      });
    }
  };

  /* Unbind listener for custom event */
  target.prototype.customUnbindListener = function (ele) {
    var _state2 = this.state,
        event = _state2.event,
        eventOff = _state2.eventOff;

    var dataEvent = event || ele.getAttribute('data-event');
    var dataEventOff = eventOff || ele.getAttribute('data-event-off');

    ele.removeEventListener(dataEvent, customListener);
    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
  };
};

/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */

var checkStatus = function checkStatus(dataEventOff, e) {
  var show = this.state.show;
  var id = this.props.id;

  var dataIsCapture = e.currentTarget.getAttribute('data-iscapture');
  var isCapture = dataIsCapture && dataIsCapture === 'true' || this.props.isCapture;
  var currentItem = e.currentTarget.getAttribute('currentItem');

  if (!isCapture) e.stopPropagation();
  if (show && currentItem === 'true') {
    if (!dataEventOff) this.hideTooltip(e);
  } else {
    e.currentTarget.setAttribute('currentItem', 'true');
    setUntargetItems(e.currentTarget, this.getTargetArray(id));
    this.showTooltip(e);
  }
};

var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
  for (var i = 0; i < targetArray.length; i++) {
    if (currentTarget !== targetArray[i]) {
      targetArray[i].setAttribute('currentItem', 'false');
    } else {
      targetArray[i].setAttribute('currentItem', 'true');
    }
  }
};

var customListener = void 0;

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.isCapture = function (currentTarget) {
    var dataIsCapture = currentTarget.getAttribute('data-iscapture');
    return dataIsCapture && dataIsCapture === 'true' || this.props.isCapture || false;
  };
};

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.getEffect = function (currentTarget) {
    var dataEffect = currentTarget.getAttribute('data-effect');
    return dataEffect || this.props.effect || 'float';
  };
};

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (target) {
  target.prototype.bindRemovalTracker = function () {
    var _this = this;

    var MutationObserver = getMutationObserverClass();
    if (MutationObserver == null) return;

    var observer = new MutationObserver(function (mutations) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var mutation = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = mutation.removedNodes[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var element = _step2.value;

              if (element === _this.state.currentTarget) {
                _this.hideTooltip();
                return;
              }
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    });

    observer.observe(window.document, { childList: true, subtree: true });

    this.removalTracker = observer;
  };

  target.prototype.unbindRemovalTracker = function () {
    if (this.removalTracker) {
      this.removalTracker.disconnect();
      this.removalTracker = null;
    }
  };
};

/**
 * Tracking target removing from DOM.
 * It's nessesary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */

// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var getMutationObserverClass = function getMutationObserverClass() {
  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (e, target, node, place, effect, offset) {
  var tipWidth = node.clientWidth;
  var tipHeight = node.clientHeight;

  var _getCurrentOffset = getCurrentOffset(e, target, effect),
      mouseX = _getCurrentOffset.mouseX,
      mouseY = _getCurrentOffset.mouseY;

  var defaultOffset = getDefaultPosition(effect, target.clientWidth, target.clientHeight, tipWidth, tipHeight);

  var _calculateOffset = calculateOffset(offset),
      extraOffset_X = _calculateOffset.extraOffset_X,
      extraOffset_Y = _calculateOffset.extraOffset_Y;

  var windowWidth = window.innerWidth;
  var windowHeight = window.innerHeight;

  var _getParent = getParent(node),
      parentTop = _getParent.parentTop,
      parentLeft = _getParent.parentLeft;

  // Get the edge offset of the tooltip


  var getTipOffsetLeft = function getTipOffsetLeft(place) {
    var offset_X = defaultOffset[place].l;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetRight = function getTipOffsetRight(place) {
    var offset_X = defaultOffset[place].r;
    return mouseX + offset_X + extraOffset_X;
  };
  var getTipOffsetTop = function getTipOffsetTop(place) {
    var offset_Y = defaultOffset[place].t;
    return mouseY + offset_Y + extraOffset_Y;
  };
  var getTipOffsetBottom = function getTipOffsetBottom(place) {
    var offset_Y = defaultOffset[place].b;
    return mouseY + offset_Y + extraOffset_Y;
  };

  // Judge if the tooltip has over the window(screen)
  var outsideVertical = function outsideVertical() {
    var result = false;
    var newPlace = void 0;
    if (getTipOffsetTop('left') < 0 && getTipOffsetBottom('left') <= windowHeight && getTipOffsetBottom('bottom') <= windowHeight) {
      result = true;
      newPlace = 'bottom';
    } else if (getTipOffsetBottom('left') > windowHeight && getTipOffsetTop('left') >= 0 && getTipOffsetTop('top') >= 0) {
      result = true;
      newPlace = 'top';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideLeft = function outsideLeft() {
    var _outsideVertical = outsideVertical(),
        result = _outsideVertical.result,
        newPlace = _outsideVertical.newPlace; // Deal with vertical as first priority


    if (result && outsideHorizontal().result) {
      return { result: false // No need to change, if change to vertical will out of space
      };
    }
    if (!result && getTipOffsetLeft('left') < 0 && getTipOffsetRight('right') <= windowWidth) {
      result = true; // If vertical ok, but let out of side and right won't out of side
      newPlace = 'right';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideRight = function outsideRight() {
    var _outsideVertical2 = outsideVertical(),
        result = _outsideVertical2.result,
        newPlace = _outsideVertical2.newPlace;

    if (result && outsideHorizontal().result) {
      return { result: false // No need to change, if change to vertical will out of space
      };
    }
    if (!result && getTipOffsetRight('right') > windowWidth && getTipOffsetLeft('left') >= 0) {
      result = true;
      newPlace = 'left';
    }
    return { result: result, newPlace: newPlace };
  };

  var outsideHorizontal = function outsideHorizontal() {
    var result = false;
    var newPlace = void 0;
    if (getTipOffsetLeft('top') < 0 && getTipOffsetRight('top') <= windowWidth && getTipOffsetRight('right') <= windowWidth) {
      result = true;
      newPlace = 'right';
    } else if (getTipOffsetRight('top') > windowWidth && getTipOffsetLeft('top') >= 0 && getTipOffsetLeft('left') >= 0) {
      result = true;
      newPlace = 'left';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideTop = function outsideTop() {
    var _outsideHorizontal = outsideHorizontal(),
        result = _outsideHorizontal.result,
        newPlace = _outsideHorizontal.newPlace;

    if (result && outsideVertical().result) {
      return { result: false };
    }
    if (!result && getTipOffsetTop('top') < 0 && getTipOffsetBottom('bottom') <= windowHeight) {
      result = true;
      newPlace = 'bottom';
    }
    return { result: result, newPlace: newPlace };
  };
  var outsideBottom = function outsideBottom() {
    var _outsideHorizontal2 = outsideHorizontal(),
        result = _outsideHorizontal2.result,
        newPlace = _outsideHorizontal2.newPlace;

    if (result && outsideVertical().result) {
      return { result: false };
    }
    if (!result && getTipOffsetBottom('bottom') > windowHeight && getTipOffsetTop('top') >= 0) {
      result = true;
      newPlace = 'top';
    }
    return { result: result, newPlace: newPlace };
  };

  // Return new state to change the placement to the reverse if possible
  var outsideLeftResult = outsideLeft();
  var outsideRightResult = outsideRight();
  var outsideTopResult = outsideTop();
  var outsideBottomResult = outsideBottom();

  if (place === 'left' && outsideLeftResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideLeftResult.newPlace }
    };
  } else if (place === 'right' && outsideRightResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideRightResult.newPlace }
    };
  } else if (place === 'top' && outsideTopResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideTopResult.newPlace }
    };
  } else if (place === 'bottom' && outsideBottomResult.result) {
    return {
      isNewState: true,
      newState: { place: outsideBottomResult.newPlace }
    };
  }

  // Return tooltip offset position
  return {
    isNewState: false,
    position: {
      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
    }
  };
};

// Get current mouse offset
var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
  var boundingClientRect = currentTarget.getBoundingClientRect();
  var targetTop = boundingClientRect.top;
  var targetLeft = boundingClientRect.left;
  var targetWidth = currentTarget.clientWidth;
  var targetHeight = currentTarget.clientHeight;

  if (effect === 'float') {
    return {
      mouseX: e.clientX,
      mouseY: e.clientY
    };
  }
  return {
    mouseX: targetLeft + targetWidth / 2,
    mouseY: targetTop + targetHeight / 2
  };
};

// List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {OBject} {left: {Number}, top: {Number}}
 */
var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
  var top = void 0;
  var right = void 0;
  var bottom = void 0;
  var left = void 0;
  var disToMouse = 3;
  var triangleHeight = 2;
  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip

  if (effect === 'float') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(tipHeight + disToMouse + triangleHeight),
      b: -disToMouse
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: disToMouse + cursorHeight,
      b: tipHeight + disToMouse + triangleHeight + cursorHeight
    };
    left = {
      l: -(tipWidth + disToMouse + triangleHeight),
      r: -disToMouse,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: disToMouse,
      r: tipWidth + disToMouse + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  } else if (effect === 'solid') {
    top = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: -(targetHeight / 2 + tipHeight + triangleHeight),
      b: -(targetHeight / 2)
    };
    bottom = {
      l: -(tipWidth / 2),
      r: tipWidth / 2,
      t: targetHeight / 2,
      b: targetHeight / 2 + tipHeight + triangleHeight
    };
    left = {
      l: -(tipWidth + targetWidth / 2 + triangleHeight),
      r: -(targetWidth / 2),
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
    right = {
      l: targetWidth / 2,
      r: tipWidth + targetWidth / 2 + triangleHeight,
      t: -(tipHeight / 2),
      b: tipHeight / 2
    };
  }

  return { top: top, bottom: bottom, left: left, right: right };
};

// Consider additional offset into position calculation
var calculateOffset = function calculateOffset(offset) {
  var extraOffset_X = 0;
  var extraOffset_Y = 0;

  if (Object.prototype.toString.apply(offset) === '[object String]') {
    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
  }
  for (var key in offset) {
    if (key === 'top') {
      extraOffset_Y -= parseInt(offset[key], 10);
    } else if (key === 'bottom') {
      extraOffset_Y += parseInt(offset[key], 10);
    } else if (key === 'left') {
      extraOffset_X -= parseInt(offset[key], 10);
    } else if (key === 'right') {
      extraOffset_X += parseInt(offset[key], 10);
    }
  }

  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
};

// Get the offset of the parent elements
var getParent = function getParent(currentTarget) {
  var currentParent = currentTarget;
  while (currentParent) {
    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
    currentParent = currentParent.parentElement;
  }

  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;

  return { parentTop: parentTop, parentLeft: parentLeft };
};

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (tip, children, getContent, multiline) {
  if (children) return children;
  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
  if (getContent === null) return null; // Tip not exist and childern is null or undefined

  var regexp = /<br\s*\/?>/;
  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
    // No trim(), so that user can keep their input
    return tip;
  }

  // Multiline tooltip content
  return tip.split(regexp).map(function (d, i) {
    return _react2.default.createElement(
      'span',
      { key: i, className: 'multi-line' },
      d
    );
  });
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseAria = parseAria;
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */
function parseAria(props) {
  var ariaObj = {};
  Object.keys(props).filter(function (prop) {
    // aria-xxx and role is acceptable
    return (/(^aria-\w+$|^role$)/.test(prop)
    );
  }).forEach(function (prop) {
    ariaObj[prop] = props[prop];
  });

  return ariaObj;
}

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nodeList) {
  var length = nodeList.length;
  if (nodeList.hasOwnProperty) {
    return Array.prototype.slice.call(nodeList);
  }
  return new Array(length).fill().map(function (index) {
    return nodeList[index];
  });
};

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _RenameFileForm=__webpack_require__(1078);var _RenameFileForm2=_interopRequireDefault(_RenameFileForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  error: ?any,
  formValues: any,
  isLoading: boolean,
  onClose: Function,
  onSubmit: Function,
  file: any,
  validate: Function,
};*/var RenameFileDialog=function RenameFileDialog(_ref){var error=_ref.error,formValues=_ref.formValues,isLoading=_ref.isLoading,onClose=_ref.onClose,onSubmit=_ref.onSubmit,file=_ref.file,validate=_ref.validate;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:onClose,className:'RenameFileDialog',show:true},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isLoading}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_RenameFileForm2.default,{initialValues:file,formValues:formValues,validate:validate}),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onSubmit},'Spara'),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onClose},'Avbryt')));};exports.default=RenameFileDialog;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _ref=_react2.default.createElement('div',{className:'RenameFileForm'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Filnamn',component:_TextAreaFormInput2.default}));var RenameFileForm=function RenameFileForm(){return _ref;};exports.default=(0,_reduxForm.reduxForm)({form:'fileRename',enableReinitialize:true})(RenameFileForm);

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _findIndex2=__webpack_require__(99);var _findIndex3=_interopRequireDefault(_findIndex2);var _pick2=__webpack_require__(86);var _pick3=_interopRequireDefault(_pick2);var _toNumber2=__webpack_require__(84);var _toNumber3=_interopRequireDefault(_toNumber2);var _toPairs2=__webpack_require__(259);var _toPairs3=_interopRequireDefault(_toPairs2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _values2=__webpack_require__(67);var _values3=_interopRequireDefault(_values2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _uuid=__webpack_require__(53);var _uuid2=_interopRequireDefault(_uuid);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _reduxForm=__webpack_require__(4);var _apartmentConfigView=__webpack_require__(82);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);var _ApartmentConfigForm=__webpack_require__(1084);var _ApartmentConfigForm2=_interopRequireDefault(_ApartmentConfigForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _BreadcrumbsContainer=__webpack_require__(459);var _BreadcrumbsContainer2=_interopRequireDefault(_BreadcrumbsContainer);var _Rooms=__webpack_require__(462);var _Rooms2=_interopRequireDefault(_Rooms);var _ApartmentConfigRoomForm=__webpack_require__(1086);var _ApartmentConfigRoomForm2=_interopRequireDefault(_ApartmentConfigRoomForm);var _ApartmentConfigProductSlotForm=__webpack_require__(1088);var _ApartmentConfigProductSlotForm2=_interopRequireDefault(_ApartmentConfigProductSlotForm);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);__webpack_require__(1093);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: import type {State_ as ApartmentConfigViewState} from '../../reducers/apartmentConfigView';*//*:: import type {
  ApartmentConfigDto,
  ConfigTemplateDto,
  ErrorDto,
  LimitedProjectDto,
  ProductDto,
  ProductSlotDto,
  ProductTypeDto,
  ProjectDto,
  RoomDto,
  RoomTemplateDto,
  RoomTypeDto,
} from '../../dtos';*/var apartmentConfigValidation={name:{rule:'string|required',label:'Namn'},apartmentId:{rule:'numeric',label:'Lägenhet'}};var basedOnConfigValidation={basedOnConfigId:{rule:'numeric|required',label:'Lägenhetskonfiguration'}};var basedOnTemplateValidation={basedOnTemplateId:{rule:'numeric|required',label:'Konfigurationsmall'}};var getBasedOnValidation=function getBasedOnValidation(values){return values&&values.rooms==='CONFIG'?basedOnConfigValidation:values&&values.rooms==='TEMPLATE'?basedOnTemplateValidation:{};};var getApartmentConfigValidation=function getApartmentConfigValidation(values){return _extends({},apartmentConfigValidation,getBasedOnValidation(values));};var roomValidation={name:{rule:'string|required',label:'Namn'}};var basicRoomValidation={roomTypeId:{rule:'numeric|required',label:'Rumstyp'}};var basedOnRoomValidation={basedOnRoomId:{rule:'numeric|required',label:'Rum'}};var basedOnRoomTemplateValidation={basedOnTemplateId:{rule:'numeric|required',label:'Rumsmall'}};var getRoomBasedOnValidation=function getRoomBasedOnValidation(values){return values&&values.slots==='ROOM'?basedOnRoomValidation:values&&values.slots==='TEMPLATE'?basedOnRoomTemplateValidation:basicRoomValidation;};var getRoomValidation=function getRoomValidation(values){return _extends({},roomValidation,getRoomBasedOnValidation(values));};var productSlotValidation={name:{rule:'string|required',label:'Namn'},unit:{rule:'string',label:'Enhet'},quantity:{rule:'numeric|min:0',label:'Antal'},productTypeId:{rule:'numeric|required',label:'Produkttyp'}};/*:: export type Props = {
  setDirty: typeof setDirty,
  reset: typeof reset,
  resetForm: typeof resetForm,
  isApartmentConfigDirty: boolean,
  isProductSlotDirty: boolean,
  isRoomDirty: boolean,
  fetchData: typeof fetchData,
  updateApartmentConfig: typeof updateApartmentConfig,
  createApartmentConfig: typeof createApartmentConfig,
  clear: typeof clear,
  isFetching: boolean,
  resourcePath: string,
  apartmentConfig: ?ApartmentConfigDto,
  project: ?ProjectDto,
  apartments: ?object[],
  room: ?RoomDto,
  roomError: ?ErrorDto,
  roomIsFetching: boolean,
  productSlot: ?ProductSlotDto,
  productSlotRoomId: ?number,
  productSlotError: ?ErrorDto,
  productSlotIsFetching: boolean,
  roomTypes: ?RoomTypeDto[],
  productTypes: ?ProductTypeDto[],
  products: ?ProductDto[],
  apartmentConfigs: any[],
  configTemplates: ConfigTemplateDto[],
  params: any,
  error: ?ErrorDto,
  projectId: ?string,
  roomFormValues: any,
  roomFormIsValid: boolean,
  touch: typeof touch,
  productSlotFormValues: any,
  productSlotFormIsValid: boolean,
  apartmentConfigFormValues: any,
  apartmentConfigFormIsValid: boolean,
  updateRoom: typeof updateRoom,
  createRoom: typeof createRoom,
  updateProductSlot: typeof updateProductSlot,
  createProductSlot: typeof createProductSlot,
  selectRoom: typeof selectRoom,
  selectProductSlot: typeof selectProductSlot,
  rooms: RoomDto[],
  roomsError: ?ErrorDto,
  roomsIsFetching: boolean,
  openDialog: typeof openDialog,
  closeDialog: typeof closeDialog,
  dialogError: ?ErrorDto,
  dialogIsFetching: boolean,
  showDialog: boolean,
  navigateToVariant: typeof navigateToVariant,
  popDialogNavigation: typeof popDialogNavigation,
  dialogNavigation: ?any,
  updateRelatedVariant: typeof updateRelatedVariant,
  toggleVariant: typeof toggleVariant,
  setStandardProduct: typeof setStandardProduct,
  modifiedData: Object,
  standardProductId: ?number,
  toggleProduct: typeof toggleProduct,
  sharedChecked: ?boolean,
  checkAllVariants: typeof checkAllVariants,
  clearStandardProduct: typeof clearStandardProduct,
  checkProduct: typeof checkProduct,
  updateVariants: typeof updateVariants,
  updateRooms: typeof updateRooms,
  updateProductSlots: typeof updateProductSlots,
  updateVariantsForType: typeof updateVariantsForType,
  projects: LimitedProjectDto[],
  roomTemplates: RoomTemplateDto[],
  projectConfigs: ApartmentConfigDto[],
};*/var ApartmentConfigContainer=function(_Component){_inherits(ApartmentConfigContainer,_Component);function ApartmentConfigContainer(){_classCallCheck(this,ApartmentConfigContainer);return _possibleConstructorReturn(this,(ApartmentConfigContainer.__proto__||Object.getPrototypeOf(ApartmentConfigContainer)).apply(this,arguments));}_createClass(ApartmentConfigContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData({id:this.props.params.id,projectId:this.props.projectId});}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clear();}},{key:'setDirty',value:function setDirty(form/*: 'apartmentConfig' | 'apartmentConfigRoom' | 'apartmentConfigProductSlot'*/){var _props=this.props,setDirty=_props.setDirty,isApartmentConfigDirty=_props.isApartmentConfigDirty,isRoomDirty=_props.isRoomDirty,isProductSlotDirty=_props.isProductSlotDirty;if(form==='apartmentConfig'){if(isApartmentConfigDirty){return;}}else if(form==='apartmentConfigRoom'){if(isRoomDirty){return;}}else if(form==='apartmentConfigProductSlot'){if(isProductSlotDirty){return;}}else{return;}setDirty(true,form);}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('apartmentConfig');resetForm('apartmentConfigRoom');resetForm('apartmentConfigProductSlot');setDirty(false,'apartmentConfig');setDirty(false,'apartmentConfigRoom');setDirty(false,'apartmentConfigProductSlot');}},{key:'validateRoomForm',value:function validateRoomForm(){var _props3=this.props,roomFormIsValid=_props3.roomFormIsValid,roomFormValues=_props3.roomFormValues,touch=_props3.touch;var roomFields=(0,_keys3.default)(getRoomValidation(roomFormValues));touch.apply(undefined,['apartmentConfigRoom'].concat(_toConsumableArray(roomFields)));return roomFormIsValid;}},{key:'validateProductSlotForm',value:function validateProductSlotForm(){var _props4=this.props,productSlotFormIsValid=_props4.productSlotFormIsValid,touch=_props4.touch;var productSlotFields=(0,_keys3.default)(productSlotValidation);touch.apply(undefined,['apartmentConfigProductSlot'].concat(_toConsumableArray(productSlotFields)));return productSlotFormIsValid;}},{key:'save',value:function save(){var _props5=this.props,apartmentConfig=_props5.apartmentConfig,apartmentConfigFormValues=_props5.apartmentConfigFormValues,apartmentConfigFormIsValid=_props5.apartmentConfigFormIsValid,createApartmentConfig=_props5.createApartmentConfig,updateApartmentConfig=_props5.updateApartmentConfig,updateRoom=_props5.updateRoom,createRoom=_props5.createRoom,updateProductSlot=_props5.updateProductSlot,createProductSlot=_props5.createProductSlot,projectId=_props5.projectId,touch=_props5.touch,roomFormValues=_props5.roomFormValues,room=_props5.room,productSlot=_props5.productSlot,productSlotRoomId=_props5.productSlotRoomId,productSlotFormValues=_props5.productSlotFormValues,modifiedData=_props5.modifiedData,standardProductId=_props5.standardProductId,closeDialog=_props5.closeDialog;var apartmentConfigFields=(0,_keys3.default)(!apartmentConfig&&projectId?getApartmentConfigValidation(apartmentConfigFormValues):apartmentConfigValidation);touch.apply(undefined,['apartmentConfig'].concat(_toConsumableArray(apartmentConfigFields)));if(!apartmentConfigFormIsValid){return;}closeDialog();if(room){if(!this.validateRoomForm()){return;}if(room.id){updateRoom(room.id,roomFormValues);}else if(!!apartmentConfig){createRoom(apartmentConfig.id,roomFormValues);}}if(productSlot){if(!this.validateProductSlotForm()){return;}if(productSlot.id){updateProductSlot(productSlot.id,_extends({},productSlotFormValues,{standardProductId:standardProductId,config:(0,_flow3.default)(_values3.default,(0,_filter3.default)('checked'),(0,_map3.default)(function(c){return _extends({},c,{standardProducts:(0,_flow3.default)(_toPairs3.default,(0,_map3.default)(function(_ref){var _ref2=_slicedToArray(_ref,2),productTypeId=_ref2[0],productId=_ref2[1];return{productId:productId,productTypeId:(0,_toNumber3.default)(productTypeId)};}),(0,_filter3.default)(function(x){return!!x.productId;}))(c.standardProducts)});}))(modifiedData)}));}else{createProductSlot(productSlotRoomId,productSlotFormValues);}}if(!apartmentConfig&&projectId){createApartmentConfig(projectId,(0,_pick3.default)(apartmentConfigFields,apartmentConfigFormValues));}else if(!!apartmentConfig){updateApartmentConfig(apartmentConfig.id,apartmentConfigFormValues);}}},{key:'render',value:function render(){var _this2=this;var _props6=this.props,isApartmentConfigDirty=_props6.isApartmentConfigDirty,isRoomDirty=_props6.isRoomDirty,isProductSlotDirty=_props6.isProductSlotDirty,id=_props6.params.id,apartmentConfig=_props6.apartmentConfig,apartmentConfigs=_props6.apartmentConfigs,configTemplates=_props6.configTemplates,apartmentConfigFormValues=_props6.apartmentConfigFormValues,rooms=_props6.rooms,roomsError=_props6.roomsError,roomsIsFetching=_props6.roomsIsFetching,project=_props6.project,apartments=_props6.apartments,room=_props6.room,roomError=_props6.roomError,roomIsFetching=_props6.roomIsFetching,productSlot=_props6.productSlot,productSlotRoomId=_props6.productSlotRoomId,productSlotFormValues=_props6.productSlotFormValues,productSlotError=_props6.productSlotError,productSlotIsFetching=_props6.productSlotIsFetching,roomTypes=_props6.roomTypes,productTypes=_props6.productTypes,products=_props6.products,error=_props6.error,isFetching=_props6.isFetching,updateApartmentConfig=_props6.updateApartmentConfig,updateRoom=_props6.updateRoom,updateProductSlot=_props6.updateProductSlot,resourcePath=_props6.resourcePath,selectRoom=_props6.selectRoom,selectProductSlot=_props6.selectProductSlot,openDialog=_props6.openDialog,closeDialog=_props6.closeDialog,dialogError=_props6.dialogError,dialogIsFetching=_props6.dialogIsFetching,showDialog=_props6.showDialog,navigateToVariant=_props6.navigateToVariant,popDialogNavigation=_props6.popDialogNavigation,dialogNavigation=_props6.dialogNavigation,updateRelatedVariant=_props6.updateRelatedVariant,toggleVariant=_props6.toggleVariant,setStandardProduct=_props6.setStandardProduct,modifiedData=_props6.modifiedData,toggleProduct=_props6.toggleProduct,sharedChecked=_props6.sharedChecked,checkAllVariants=_props6.checkAllVariants,clearStandardProduct=_props6.clearStandardProduct,checkProduct=_props6.checkProduct,updateVariants=_props6.updateVariants,_updateRooms=_props6.updateRooms,_updateProductSlots=_props6.updateProductSlots,updateVariantsForType=_props6.updateVariantsForType,projects=_props6.projects,roomTemplates=_props6.roomTemplates,roomFormValues=_props6.roomFormValues,projectConfigs=_props6.projectConfigs,clear=_props6.clear,_fetchData=_props6.fetchData,projectId=_props6.projectId;var _ref3=_react2.default.createElement(_ServerError2.default,{error:roomError});var _ref4=_react2.default.createElement(_ServerError2.default,{error:productSlotError});return _react2.default.createElement('div',{className:'ApartmentConfigContainer relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:apartmentConfig,list:projectConfigs,prevPath:resourcePath,clear:clear,fetchData:function fetchData(id){return _fetchData({id:id,projectId:projectId});}}),_react2.default.createElement('div',null,_react2.default.createElement(_BreadcrumbsContainer2.default,{project:project}),_react2.default.createElement('div',{className:'content-title'},apartmentConfig&&apartmentConfig.name||'Ny lägenhetskonfiguration')))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},apartmentConfig&&_react2.default.createElement(_DisableContent2.default,{disabled:isApartmentConfigDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveApartmentConfig',className:'secondary button',message:'Vill du verkligen '+(apartmentConfig.archived?'av':'')+'arkivera den h\xE4r konfigurationen?',buttonText:apartmentConfig.archived?'Avarkivera':'Arkivera',action:function action(){return updateApartmentConfig(apartmentConfig.id,{archived:!apartmentConfig.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching||roomIsFetching||productSlotIsFetching||roomsIsFetching}),_react2.default.createElement(_ServerError2.default,{error:error||roomsError}),(apartmentConfig&&!apartmentConfig.demo||!apartmentConfig)&&_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_ApartmentConfigForm2.default,{initialValues:apartmentConfig||{rooms:'NONE'},apartments:apartments,apartmentConfig:apartmentConfig,apartmentConfigs:apartmentConfigs,configTemplates:configTemplates,formValues:apartmentConfigFormValues,onUserChange:function onUserChange(){return _this2.setDirty('apartmentConfig');},validate:function validate(values){return(0,_validator2.default)(getApartmentConfigValidation(values),values);}})),apartmentConfig&&apartmentConfig.id&&_react2.default.createElement('div',{className:'content-section rooms-section'},_react2.default.createElement('div',{className:'row no-row-margins'},_react2.default.createElement('div',{className:'box-side-tabs shrink'},_react2.default.createElement(_DisableContent2.default,{disabled:isRoomDirty||isProductSlotDirty},_react2.default.createElement(_Rooms2.default,{onSelectRoom:function onSelectRoom(r){return selectRoom(r);},onSelectProductSlot:function onSelectProductSlot(roomId,p){return selectProductSlot(roomId,p);},onAddRoom:function onAddRoom(){return selectRoom({});},onAddProductSlot:function onAddProductSlot(roomId){return selectProductSlot(roomId,{uuid:_uuid2.default.v4(),advanced:false});},selectedRoom:room,selectedProductSlot:productSlot,selectedProductSlotRoomId:productSlotRoomId,rooms:(0,_filter3.default)({archived:null},rooms)}))),_react2.default.createElement('div',{className:'box expand'},room&&!productSlot&&function(){var roomIndex=(0,_findIndex3.default)({id:room.id},rooms);return _react2.default.createElement('div',null,_ref3,_react2.default.createElement(_ApartmentConfigRoomForm2.default,{roomTemplates:roomTemplates,projects:projects,formValues:roomFormValues,initialValues:!!room.id?room:{slots:'NONE'},room:room,onArchive:function onArchive(){return updateRoom(room.id,{archived:!room.archived});},roomTypes:roomTypes,onUserChange:function onUserChange(){return _this2.setDirty('apartmentConfigRoom');},validate:function validate(values){return(0,_validator2.default)(getRoomValidation(values),values);},isDirty:isRoomDirty,updateRooms:function updateRooms(sortDirection/*: 'up' | 'down'*/){return _updateRooms(apartmentConfig.id,room.id,sortDirection);},sortDownDisabled:isRoomDirty||roomIndex===rooms.length-1,sortUpDisabled:isRoomDirty||roomIndex<=0}));}(),productSlot&&!room&&function(){var slotRoom=(0,_find3.default)({id:productSlotRoomId},rooms);var allSlots=!!slotRoom?slotRoom.productSlots:[];var slotIndex=(0,_findIndex3.default)({id:productSlot.id},allSlots);return _react2.default.createElement('div',null,_ref4,_react2.default.createElement(_ApartmentConfigProductSlotForm2.default,{initialValues:productSlot,formValues:productSlotFormValues,productSlot:productSlot,productTypes:productTypes,room:slotRoom,products:products,onArchive:function onArchive(){return updateProductSlot(productSlot.id,{archived:!productSlot.archived});},onUserChange:function onUserChange(){return _this2.setDirty('apartmentConfigProductSlot');},validate:function validate(values){return(0,_validator2.default)(productSlotValidation,values);},openDialog:openDialog,closeDialog:closeDialog,dialogError:dialogError,dialogIsFetching:dialogIsFetching,dialogNavigation:dialogNavigation,showDialog:showDialog,navigateToVariant:navigateToVariant,popDialogNavigation:popDialogNavigation,updateRelatedVariant:updateRelatedVariant,toggleVariant:toggleVariant,setStandardProduct:setStandardProduct,modifiedData:modifiedData,toggleProduct:toggleProduct,sharedChecked:sharedChecked,checkAllVariants:checkAllVariants,clearStandardProduct:clearStandardProduct,isDirty:isProductSlotDirty,checkProduct:checkProduct,updateVariants:updateVariants,updateVariantsForType:updateVariantsForType,updateProductSlots:function updateProductSlots(sortDirection/*: 'up' | 'down'*/){if(!!slotRoom){_updateProductSlots(slotRoom.id,productSlot.id,sortDirection);}},sortDownDisabled:isProductSlotDirty||slotIndex===allSlots.length-1,sortUpDisabled:isProductSlotDirty||slotIndex<=0}));}()))),apartmentConfig&&apartmentConfig.id!==(0,_toNumber3.default)(id)&&_react2.default.createElement(_reactRouterDom.Redirect,{to:resourcePath+'/'+apartmentConfig.id}),(isApartmentConfigDirty||isRoomDirty||isProductSlotDirty)&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return ApartmentConfigContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref5){var _ref5$apartmentConfig=_ref5.apartmentConfigView,_ref5$apartmentConfig2=_ref5$apartmentConfig.apartmentConfig,apartmentConfig=_ref5$apartmentConfig2.active,error=_ref5$apartmentConfig2.error,isApartmentConfigDirty=_ref5$apartmentConfig2.isDirty,isFetching=_ref5$apartmentConfig2.isFetching,rooms=_ref5$apartmentConfig.rooms,_ref5$apartmentConfig3=_ref5$apartmentConfig.project,apartmentConfigs=_ref5$apartmentConfig3.apartmentConfigs,configTemplates=_ref5$apartmentConfig3.configTemplates,project=_ref5$apartmentConfig3.active,_ref5$apartmentConfig4=_ref5$apartmentConfig.room,room=_ref5$apartmentConfig4.active,roomError=_ref5$apartmentConfig4.error,isRoomDirty=_ref5$apartmentConfig4.isDirty,roomIsFetching=_ref5$apartmentConfig4.isFetching,_ref5$apartmentConfig5=_ref5$apartmentConfig.productSlot,productSlot=_ref5$apartmentConfig5.active,productSlotRoomId=_ref5$apartmentConfig5.roomId,productSlotError=_ref5$apartmentConfig5.error,isProductSlotDirty=_ref5$apartmentConfig5.isDirty,productSlotIsFetching=_ref5$apartmentConfig5.isFetching,_ref5$apartmentConfig6=_ref5$apartmentConfig5.dialog,dialogError=_ref5$apartmentConfig6.error,dialogIsFetching=_ref5$apartmentConfig6.isFetching,showDialog=_ref5$apartmentConfig6.show,dialogNavigation=_ref5$apartmentConfig6.navigation,modifiedData=_ref5$apartmentConfig6.modifiedData,standardProductId=_ref5$apartmentConfig6.standardProductId,sharedChecked=_ref5$apartmentConfig6.sharedChecked,roomTypes=_ref5$apartmentConfig.roomTypes,productTypes=_ref5$apartmentConfig.productTypes,products=_ref5$apartmentConfig.products,projects=_ref5$apartmentConfig.projects,roomTemplates=_ref5$apartmentConfig.roomTemplates,projectConfigs=_ref5.projectView.project.apartmentConfigurations,form=_ref5.form;return{apartmentConfig:apartmentConfig,apartmentConfigs:apartmentConfigs,configTemplates:configTemplates,rooms:rooms,project:project,apartments:project?project.apartments:[],room:room,roomError:roomError,roomIsFetching:roomIsFetching,productSlot:productSlot,productSlotRoomId:productSlotRoomId,productSlotError:productSlotError,productSlotIsFetching:productSlotIsFetching,error:error,isApartmentConfigDirty:isApartmentConfigDirty,isRoomDirty:isRoomDirty,isProductSlotDirty:isProductSlotDirty,isFetching:isFetching,roomTypes:roomTypes,productTypes:productTypes,products:products,apartmentConfigFormIsValid:(0,_reduxForm.isValid)('apartmentConfig')({form:form}),apartmentConfigFormValues:(0,_reduxForm.getFormValues)('apartmentConfig')({form:form}),roomFormIsValid:(0,_reduxForm.isValid)('apartmentConfigRoom')({form:form}),roomFormValues:(0,_reduxForm.getFormValues)('apartmentConfigRoom')({form:form}),productSlotFormIsValid:(0,_reduxForm.isValid)('apartmentConfigProductSlot')({form:form}),productSlotFormValues:(0,_reduxForm.getFormValues)('apartmentConfigProductSlot')({form:form}),dialogError:dialogError,dialogIsFetching:dialogIsFetching,showDialog:showDialog,dialogNavigation:dialogNavigation,modifiedData:modifiedData,standardProductId:standardProductId,sharedChecked:sharedChecked,projects:projects,roomTemplates:roomTemplates,projectConfigs:projectConfigs};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty,form){return dispatch((0,_form.setDirty)(dirty,form));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_apartmentConfigView.reset)());},fetchData:function fetchData(_ref6){var id=_ref6.id,projectId=_ref6.projectId;return dispatch((0,_apartmentConfigView.fetchData)(id,projectId));},updateApartmentConfig:function updateApartmentConfig(id,data){return dispatch((0,_apartmentConfigView.updateApartmentConfig)(id,data));},createApartmentConfig:function createApartmentConfig(projectId,data){return dispatch((0,_apartmentConfigView.createApartmentConfig)(projectId,data));},updateRoom:function updateRoom(id,data){return dispatch((0,_apartmentConfigView.updateRoom)(id,data));},createRoom:function createRoom(configId,data){return dispatch((0,_apartmentConfigView.createRoom)(configId,data));},updateProductSlot:function updateProductSlot(id,data){return dispatch((0,_apartmentConfigView.updateProductSlot)(id,data));},createProductSlot:function createProductSlot(roomId,data){return dispatch((0,_apartmentConfigView.createProductSlot)(roomId,data));},selectRoom:function selectRoom(room){return dispatch((0,_apartmentConfigView.selectRoom)(room));},selectProductSlot:function selectProductSlot(roomId,productSlot){return dispatch((0,_apartmentConfigView.selectProductSlot)(roomId,productSlot));},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},clear:function clear(){return dispatch((0,_apartmentConfigView.clear)());},openDialog:function openDialog(productTypeId,rootName){return dispatch((0,_apartmentConfigView.openDialog)(productTypeId,rootName));},closeDialog:function closeDialog(){return dispatch((0,_apartmentConfigView.closeDialog)());},navigateToVariant:function navigateToVariant(variant){return dispatch((0,_apartmentConfigView.navigateToVariant)(variant));},popDialogNavigation:function popDialogNavigation(depth){return dispatch((0,_apartmentConfigView.popDialogNavigation)(depth));},updateRelatedVariant:function updateRelatedVariant(variant,data){return dispatch((0,_apartmentConfigView.updateRelatedVariant)(variant,data));},toggleVariant:function toggleVariant(variant,expand){return dispatch((0,_apartmentConfigView.toggleVariant)(variant,expand));},setStandardProduct:function setStandardProduct(product,productType){return dispatch((0,_apartmentConfigView.setStandardProduct)(product,productType));},toggleProduct:function toggleProduct(product){return dispatch((0,_apartmentConfigView.toggleProduct)(product));},checkAllVariants:function checkAllVariants(checked){return dispatch((0,_apartmentConfigView.checkAllVariants)(checked));},clearStandardProduct:function clearStandardProduct(productType){return dispatch((0,_apartmentConfigView.clearStandardProduct)(productType));},checkProduct:function checkProduct(productId,checked){return dispatch((0,_apartmentConfigView.checkProduct)(productId,checked));},updateVariants:function updateVariants(productId,data){return dispatch((0,_apartmentConfigView.updateVariants)(productId,data));},updateRooms:function updateRooms(apartmentConfigId,roomId,sortDirection/*: 'up' | 'down'*/){return dispatch((0,_apartmentConfigView.updateRooms)(apartmentConfigId,roomId,sortDirection));},updateProductSlots:function updateProductSlots(roomId,productSlotId,sortDirection/*: 'up' | 'down'*/){return dispatch((0,_apartmentConfigView.updateProductSlots)(roomId,productSlotId,sortDirection));},updateVariantsForType:function updateVariantsForType(productTypeId,data){return dispatch((0,_apartmentConfigView.updateVariantsForType)(productTypeId,data));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ApartmentConfigContainer);

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

var createToPairs = __webpack_require__(1081),
    keys = __webpack_require__(59);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

var baseToPairs = __webpack_require__(1082),
    getTag = __webpack_require__(77),
    mapToArray = __webpack_require__(352),
    setToPairs = __webpack_require__(1083);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(46);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),
/* 1083 */
/***/ (function(module, exports) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  apartmentConfig: ?any,
  apartmentConfigs: any[],
  configTemplates: any[],
  formValues: any,
  onUserChange: Function,
  apartments: any[],
};*/var _ref2=_react2.default.createElement('label',null,'L\xE4genhet');var _ref3=_react2.default.createElement('label',null,'Rum');var _ref4=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'rooms',component:'input',type:'radio',value:'NONE'}),' L\xE4gg till manuellt');var _ref5=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'rooms',component:'input',type:'radio',value:'CONFIG'}),' Kopiera fr\xE5n konfiguration');var _ref6=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'rooms',component:'input',type:'radio',value:'TEMPLATE'}),' Basera p\xE5 mall');var ApartmentConfigForm=function ApartmentConfigForm(_ref){var apartmentConfig=_ref.apartmentConfig,apartmentConfigs=_ref.apartmentConfigs,configTemplates=_ref.configTemplates,formValues=_ref.formValues,onUserChange=_ref.onUserChange,apartments=_ref.apartments;return _react2.default.createElement('div',{className:'ApartmentConfigForm'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),(!apartmentConfig||!apartmentConfig.id)&&_react2.default.createElement('div',{onChange:onUserChange},_ref2,_react2.default.createElement(_reduxForm.Field,{name:'apartmentId',component:_SelectFormInput2.default,clearable:true,normalize:function normalize(value){return value?value.id:null;},placeholder:'V\xE4lj l\xE4genhet',valueKey:'id',labelKey:'objectId',options:(0,_filter3.default)(function(a){return a.state===0&&!a.hasOrders;},apartments)}),_ref3,_ref4,_ref5,_react2.default.createElement(_reduxForm.Field,{name:'basedOnConfigId',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value.id:null;},disabled:!formValues||formValues.rooms!=='CONFIG',placeholder:'V\xE4lj konfiguration',valueKey:'id',labelKey:'name',options:apartmentConfigs}),_ref6,_react2.default.createElement(_reduxForm.Field,{name:'basedOnTemplateId',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value.id:null;},disabled:!formValues||formValues.rooms!=='TEMPLATE',placeholder:'V\xE4lj mall',valueKey:'id',labelKey:'name',options:configTemplates})))));};exports.default=(0,_reduxForm.reduxForm)({form:'apartmentConfig',enableReinitialize:true})(ApartmentConfigForm);

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reduxForm=__webpack_require__(4);var _RoomForm=__webpack_require__(463);var _RoomForm2=_interopRequireDefault(_RoomForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_reduxForm.reduxForm)({form:'apartmentConfigRoom',enableReinitialize:true})(_RoomForm2.default);

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reduxForm=__webpack_require__(4);var _ProductSlotForm=__webpack_require__(260);var _ProductSlotForm2=_interopRequireDefault(_ProductSlotForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_reduxForm.reduxForm)({form:'apartmentConfigProductSlot',enableReinitialize:true})(_ProductSlotForm2.default);

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(119),
    baseIteratee = __webpack_require__(24),
    baseRest = __webpack_require__(83),
    baseUniq = __webpack_require__(232),
    isArrayLikeObject = __webpack_require__(171),
    last = __webpack_require__(261);

/**
 * This method is like `_.union` except that it accepts `iteratee` which is
 * invoked for each element of each `arrays` to generate the criterion by
 * which uniqueness is computed. Result values are chosen from the first
 * array in which the value occurs. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.unionBy([2.1], [1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
var unionBy = baseRest(function(arrays) {
  var iteratee = last(arrays);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2));
});

module.exports = unionBy;


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _flatMap2=__webpack_require__(54);var _flatMap3=_interopRequireDefault(_flatMap2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _Checkbox=__webpack_require__(465);var _Checkbox2=_interopRequireDefault(_Checkbox);var _reactNumberFormat=__webpack_require__(414);var _reactNumberFormat2=_interopRequireDefault(_reactNumberFormat);var _reactTooltip=__webpack_require__(91);var _reactTooltip2=_interopRequireDefault(_reactTooltip);var _Button=__webpack_require__(258);var _Button2=_interopRequireDefault(_Button);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1091);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var mapWithIndex=_map3.default.convert({cap:false});var hasChecked=function hasChecked(modifiedData){return function(v){return!!(modifiedData[v.uuid]||{}).checked;};};/*:: export type ReadonlyVariantProps = {
  variant: Object,
  toggleVariant: Function,
  modifiedData: Object,
};*/var _ref2=_react2.default.createElement('div',{className:'shrink column'},_react2.default.createElement('i',{className:'fa fa-plus disabled'}));var ReadonlyVariant=function ReadonlyVariant(_ref){var variant=_ref.variant,toggleVariant=_ref.toggleVariant,modifiedData=_ref.modifiedData;var variantData=modifiedData[variant.uuid]||{};return _react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'row variant-row'},!!variant.hasRelated?_react2.default.createElement('div',{className:'shrink column',onClick:function onClick(){return toggleVariant(variant,!variantData.expanded);}},_react2.default.createElement('i',{className:'fa fa-'+(!!variantData.expanded?'minus':'plus')})):_ref2,_react2.default.createElement('div',{className:'small-5 column'},variant.name,' (',variant.itemNumber,')'),_react2.default.createElement('div',{className:'small-3 column'},!!variantData.quantity&&'Antal: '+variantData.quantity),_react2.default.createElement('div',{className:'small-3 column'},!!variantData.unit&&'Enhet: '+variantData.unit)),!!variantData.expanded&&!!variantData.related&&!!variantData.related.length&&function(){var checked=hasChecked(modifiedData);var checkedProducts=(0,_filter3.default)(function(p){return(0,_some3.default)(checked,p.variants);},variantData.related);return _react2.default.createElement('div',{className:'row related-row'},_react2.default.createElement('div',{className:'column'},(0,_map3.default)(function(p){return _react2.default.createElement(ReadonlyProduct,{key:p.id,product:p,toggleVariant:toggleVariant,modifiedData:modifiedData});},!!checkedProducts.length?checkedProducts:variantData.related)));}()));};/*:: export type ReadonlyProductProps = {
  product: Object,
  toggleVariant: Function,
  modifiedData: Object,
};*/var _ref4=_react2.default.createElement('div',{className:'shrink column'},_react2.default.createElement('i',{className:'fa fa-plus disabled'}));var ReadonlyProduct=function ReadonlyProduct(_ref3){var product=_ref3.product,toggleVariant=_ref3.toggleVariant,modifiedData=_ref3.modifiedData;var checkedVariants=(0,_filter3.default)(hasChecked(modifiedData),product.variants);return _react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'row readonly-product-row'},_ref4,_react2.default.createElement('div',{className:'column'},product.name)),_react2.default.createElement('div',{className:'row variants-row'},_react2.default.createElement('div',{className:'column'},(0,_map3.default)(function(v){return _react2.default.createElement(ReadonlyVariant,{key:v.uuid,variant:v,toggleVariant:toggleVariant,modifiedData:modifiedData});},!!checkedVariants.length?checkedVariants:product.variants)))));};/*:: export type VariantProps = {
  variant: Object,
  navigateToVariant: Function,
  updateRelatedVariant: Function,
  toggleVariant: Function,
  modifiedData: Object,
  isStandard: boolean,
  mainVariantId: number,
};*/var _ref6=_react2.default.createElement('div',{className:'shrink column'},_react2.default.createElement('i',{className:'fa fa-plus disabled'}));var _ref7=_react2.default.createElement('span',null,'Kan ej v\xE4lja bort varianten d\xE5 det \xE4r en visningsartikel');var _ref8=_react2.default.createElement('div',{className:'price-label'},'Avvikande pris');var _ref9=_react2.default.createElement('i',{className:'fa fa-cog fa-lg'});var _ref10=_react2.default.createElement('span',null,'Varianten m\xE5ste vara valbar f\xF6r att kunna konfigureras');var Variant=function Variant(_ref5){var variant=_ref5.variant,navigateToVariant=_ref5.navigateToVariant,updateRelatedVariant=_ref5.updateRelatedVariant,toggleVariant=_ref5.toggleVariant,modifiedData=_ref5.modifiedData,isStandard=_ref5.isStandard,mainVariantId=_ref5.mainVariantId;var variantData=modifiedData[variant.uuid]||{};var checkDisabled=!!isStandard&&mainVariantId===variant.id;return _react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'row variant-row center-vert'},!!variant.hasRelated?_react2.default.createElement('div',{className:'shrink column',onClick:function onClick(){return toggleVariant(variant,!variantData.expanded);}},_react2.default.createElement('i',{className:'fa fa-'+(!!variantData.expanded?'minus':'plus')})):_ref6,_react2.default.createElement('div',{className:'small-4 column'},variant.name,' (',variant.itemNumber,')'),_react2.default.createElement('div',{className:'small-2 column'},_react2.default.createElement('div',{'data-tip':true,'data-for':'checked-disabled-tip-'+variant.id},_react2.default.createElement(_Checkbox2.default,{name:'variant-'+variant.id+'-enabled',checked:!!variantData.checked,disabled:checkDisabled,onChange:function onChange(e){return updateRelatedVariant(variant,{checked:e.target.checked});},id:'variant-'+variant.id+'-enabled'}),_react2.default.createElement('label',{htmlFor:'variant-'+variant.id+'-enabled'},'Valbar'),!!checkDisabled&&_react2.default.createElement(_reactTooltip2.default,{id:'checked-disabled-tip-'+variant.id,effect:'solid'},_ref7))),_react2.default.createElement('div',{className:'small-2 column price-input'},_ref8,_react2.default.createElement(_reactNumberFormat2.default,{value:variantData.customPrice,onValueChange:function onValueChange(val,evt){updateRelatedVariant(variant,{checked:true,customPrice:(0,_isEmpty3.default)(val.value)?null:val.floatValue});},decimalSeparator:',',decimalScale:5,placeholder:variant.sellingPrice})),_react2.default.createElement('div',{className:'column'},!!variant.hasRelated&&_react2.default.createElement('div',{'data-tip':true,'data-for':'config-disabled-tip-'+variant.id},_react2.default.createElement('button',{type:'button',className:'button small',disabled:!variantData.checked,onClick:function onClick(){return navigateToVariant(variant);}},_ref9),!variantData.checked&&_react2.default.createElement(_reactTooltip2.default,{id:'config-disabled-tip-'+variant.id,effect:'solid'},_ref10)))),!!variantData.expanded&&!!variantData.related&&!!variantData.related.length&&function(){var checked=hasChecked(modifiedData);var checkedProducts=(0,_filter3.default)(function(p){return(0,_some3.default)(checked,p.variants);},variantData.related);return _react2.default.createElement('div',{className:'row related-row'},_react2.default.createElement('div',{className:'column'},(0,_map3.default)(function(p){return _react2.default.createElement(ReadonlyProduct,{key:p.id,product:p,toggleVariant:toggleVariant,modifiedData:modifiedData});},!!checkedProducts.length?checkedProducts:variantData.related)));}()));};/*:: export type ProductProps = {
  product: Object,
  productType: Object,
  navigateToVariant: Function,
  updateRelatedVariant: Function,
  toggleVariant: Function,
  setStandardProduct: Function,
  modifiedData: Object,
  navigationStack: Object,
  toggleProduct: Function,
  isStandard: boolean,
  clearStandardProduct: Function,
  checkProduct: Function,
  updateVariants: Function,
};*/var _ref12=_react2.default.createElement('div',{className:'quantity-unit-label'},'Antal');var _ref13=_react2.default.createElement('div',{className:'quantity-unit-label'},'Enhet');var Product=function Product(_ref11){var product=_ref11.product,productType=_ref11.productType,navigateToVariant=_ref11.navigateToVariant,updateRelatedVariant=_ref11.updateRelatedVariant,toggleVariant=_ref11.toggleVariant,setStandardProduct=_ref11.setStandardProduct,modifiedData=_ref11.modifiedData,navigationStack=_ref11.navigationStack,toggleProduct=_ref11.toggleProduct,isStandard=_ref11.isStandard,clearStandardProduct=_ref11.clearStandardProduct,checkProduct=_ref11.checkProduct,updateVariants=_ref11.updateVariants;var selectionCount=(0,_filter3.default)(function(v){return!!modifiedData[v.uuid]&&!!modifiedData[v.uuid].checked;},product.variants).length;var firstWithQuantity=(0,_flow3.default)((0,_map3.default)(function(v){return modifiedData[v.uuid];}),(0,_filter3.default)(function(v){return!!v&&v.quantity!==null;}))(product.variants);var firstQuantity=!!firstWithQuantity.length?firstWithQuantity[0].quantity:null;var firstWithUnit=(0,_flow3.default)((0,_map3.default)(function(v){return modifiedData[v.uuid];}),(0,_filter3.default)(function(v){return!!v&&!!v.unit;}))(product.variants);var firstUnit=!!firstWithUnit.length?firstWithUnit[0].unit||'':'';return _react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'row center-vert'},_react2.default.createElement('div',{className:'shrink column product-toggle',onClick:function onClick(){return toggleProduct(product);}},_react2.default.createElement('i',{className:'fa fa-'+(!!product.expanded?'minus':'plus')})),_react2.default.createElement('div',{className:'shrink column product-standard'},_react2.default.createElement(_Checkbox2.default,{name:'product-'+product.id+'-standard',checked:!!isStandard,onChange:function onChange(e){if(!!e.target.checked){setStandardProduct(product,productType);}else{clearStandardProduct(productType);}},id:'product-'+product.id+'-standard'}),_react2.default.createElement('label',{htmlFor:'product-'+product.id+'-standard'},'Standard')),_react2.default.createElement('div',{className:'shrink column product-checked'},_react2.default.createElement(_Checkbox2.default,{name:'product-'+product.id+'-enabled',checked:selectionCount===product.variants.length?true:selectionCount>0?null:false,onChange:function onChange(e){return checkProduct(product.id,!!e.target.checked);},id:'product-'+product.id+'-enabled'}),_react2.default.createElement('label',{htmlFor:'product-'+product.id+'-enabled'},'V\xE4lj alla')),_react2.default.createElement('div',{className:'small-4 column product-name'},product.name),_react2.default.createElement('div',{className:'small-1 column'},_ref12,_react2.default.createElement(_reactNumberFormat2.default,{value:firstQuantity,onValueChange:function onValueChange(val,evt){updateVariants(product.id,{checked:true,quantity:(0,_isEmpty3.default)(val.value)?null:val.floatValue});},decimalSeparator:',',decimalScale:5,placeholder:'Antal'})),_react2.default.createElement('div',{className:'small-2 column'},_ref13,_react2.default.createElement('input',{type:'text',placeholder:'Enhet',value:firstUnit,onChange:function onChange(e){return updateVariants(product.id,{checked:true,unit:e.target.value});}}))),!!product.expanded&&_react2.default.createElement('div',{className:'row variants-row'},_react2.default.createElement('div',{className:'column'},(0,_map3.default)(function(v){return _react2.default.createElement(Variant,{key:v.id,variant:v,navigateToVariant:navigateToVariant,updateRelatedVariant:updateRelatedVariant,toggleVariant:toggleVariant,setStandardProduct:setStandardProduct,modifiedData:modifiedData,isStandard:isStandard,mainVariantId:product.mainVariantId});},product.variants)))));};/*:: export type ProductTypeProps = {
  productType: Object,
  navigateToVariant: Function,
  updateRelatedVariant: Function,
  toggleVariant: Function,
  setStandardProduct: Function,
  modifiedData: Object,
  navigationStack: Object,
  toggleProduct: Function,
  clearStandardProduct: Function,
  isLast: boolean,
  checkProduct: Function,
  updateVariants: Function,
  updateVariantsForType: Function,
};*/var _ref15=_react2.default.createElement('div',{className:'shrink column filler-col'});var _ref16=_react2.default.createElement('div',{className:'quantity-unit-label'},'Antal');var _ref17=_react2.default.createElement('div',{className:'quantity-unit-label'},'Enhet');var _ref18=_react2.default.createElement('span',null,'\xC4ndringar i detta f\xE4lt \xE5terspeglas i alla produkter nedan f\xF6r denna produkttyp');var ProductType=function ProductType(_ref14){var productType=_ref14.productType,navigateToVariant=_ref14.navigateToVariant,updateRelatedVariant=_ref14.updateRelatedVariant,toggleVariant=_ref14.toggleVariant,setStandardProduct=_ref14.setStandardProduct,modifiedData=_ref14.modifiedData,navigationStack=_ref14.navigationStack,toggleProduct=_ref14.toggleProduct,clearStandardProduct=_ref14.clearStandardProduct,isLast=_ref14.isLast,checkProduct=_ref14.checkProduct,updateVariants=_ref14.updateVariants,updateVariantsForType=_ref14.updateVariantsForType;var allVariants=(0,_flatMap3.default)(function(p){return p.variants;},productType.products);var firstWithQuantity=(0,_flow3.default)((0,_map3.default)(function(v){return modifiedData[v.uuid];}),(0,_filter3.default)(function(v){return!!v&&v.quantity!==null;}))(allVariants);var firstQuantity=!!firstWithQuantity.length?firstWithQuantity[0].quantity:null;var firstWithUnit=(0,_flow3.default)((0,_map3.default)(function(v){return modifiedData[v.uuid];}),(0,_filter3.default)(function(v){return!!v&&!!v.unit;}))(allVariants);var firstUnit=!!firstWithUnit.length?firstWithUnit[0].unit||'':'';return _react2.default.createElement('div',{className:(0,_classnames2.default)({row:true,'product-type-separator':!isLast})},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'row product-type-row center-vert'},_react2.default.createElement('div',{className:'small-4 column product-type-name'},productType.name),_ref15,_react2.default.createElement('div',{className:'small-1 column small-offset-2','data-tip':true,'data-for':'type-override-tip-'+productType.id},_ref16,_react2.default.createElement(_reactNumberFormat2.default,{value:firstQuantity,onValueChange:function onValueChange(val,evt){updateVariantsForType(productType.id,{checked:true,quantity:(0,_isEmpty3.default)(val.value)?null:val.floatValue});},decimalSeparator:',',decimalScale:5,placeholder:'Antal'})),_react2.default.createElement('div',{className:'small-2 column','data-tip':true,'data-for':'type-override-tip-'+productType.id},_ref17,_react2.default.createElement('input',{type:'text',placeholder:'Enhet',value:firstUnit,onChange:function onChange(e){return updateVariantsForType(productType.id,{checked:true,unit:e.target.value});}})),_react2.default.createElement(_reactTooltip2.default,{id:'type-override-tip-'+productType.id,effect:'solid'},_ref18)),_react2.default.createElement('div',{className:'row products-row'},_react2.default.createElement('div',{className:'column'},(0,_map3.default)(function(p){return _react2.default.createElement(Product,{key:p.id,product:p,isStandard:navigationStack.standardProducts[productType.id]===p.id,productType:productType,navigateToVariant:navigateToVariant,updateRelatedVariant:updateRelatedVariant,toggleVariant:toggleVariant,setStandardProduct:setStandardProduct,modifiedData:modifiedData,navigationStack:navigationStack,toggleProduct:toggleProduct,clearStandardProduct:clearStandardProduct,checkProduct:checkProduct,updateVariants:updateVariants});},productType.products)))));};/*:: export type BreadcrumbProps = {
  stack: Object,
  popDialogNavigation: Function,
  depth: number,
};*/var Breadcrumb=function Breadcrumb(_ref19){var stack=_ref19.stack,popDialogNavigation=_ref19.popDialogNavigation,depth=_ref19.depth;return _react2.default.createElement('span',null,!!stack.previous&&_react2.default.createElement(Breadcrumb,{stack:stack.previous,popDialogNavigation:popDialogNavigation,depth:depth+1}),!!stack.previous&&' / ',_react2.default.createElement('a',{href:'',onClick:function onClick(evt){evt.preventDefault();popDialogNavigation(depth);}},stack.name));};/*:: export type BreadcrumbRootProps = {
  stack: Object,
  popDialogNavigation: Function,
};*/var BreadcrumbRoot=function BreadcrumbRoot(_ref20){var stack=_ref20.stack,popDialogNavigation=_ref20.popDialogNavigation;return _react2.default.createElement('span',null,_react2.default.createElement(_Button2.default,{icon:'chevron-left',disabled:!stack.previous,onClick:function onClick(){return popDialogNavigation(1);}}),_react2.default.createElement('span',null,!!stack.previous&&_react2.default.createElement(Breadcrumb,{stack:stack.previous,popDialogNavigation:popDialogNavigation,depth:1}),!!stack.previous&&' / ',_react2.default.createElement('span',{className:'current-stack'},stack.name)));};/*:: export type AdvancedProductSlotDialogProps = {
  isFetching: boolean,
  error: ?any,
  onClose: Function,
  navigateToVariant: Function,
  updateRelatedVariant: Function,
  popDialogNavigation: Function,
  navigationStack: Object,
  toggleVariant: Function,
  setStandardProduct: Function,
  modifiedData: Object,
  toggleProduct: Function,
  sharedChecked: ?boolean,
  checkAllVariants: Function,
  clearStandardProduct: Function,
  checkProduct: Function,
  updateVariants: Function,
  updateVariantsForType: Function,
};*/var _ref22=_react2.default.createElement('div',{className:'shrink column'},_react2.default.createElement('div',{className:'separator'}));var _ref23=_react2.default.createElement('label',{htmlFor:'check-all'},'V\xE4lj alla');var AdvancedProductSlotDialog=function AdvancedProductSlotDialog(_ref21){var isFetching=_ref21.isFetching,error=_ref21.error,onClose=_ref21.onClose,navigateToVariant=_ref21.navigateToVariant,popDialogNavigation=_ref21.popDialogNavigation,navigationStack=_ref21.navigationStack,updateRelatedVariant=_ref21.updateRelatedVariant,toggleVariant=_ref21.toggleVariant,setStandardProduct=_ref21.setStandardProduct,modifiedData=_ref21.modifiedData,toggleProduct=_ref21.toggleProduct,sharedChecked=_ref21.sharedChecked,checkAllVariants=_ref21.checkAllVariants,clearStandardProduct=_ref21.clearStandardProduct,checkProduct=_ref21.checkProduct,updateVariants=_ref21.updateVariants,updateVariantsForType=_ref21.updateVariantsForType;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:onClose,className:'AdvancedProductSlotDialog',show:true,showCloseButton:true,size:'large'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'dialog-title'},_react2.default.createElement(BreadcrumbRoot,{stack:navigationStack,popDialogNavigation:popDialogNavigation})),!!navigationStack.active&&_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'row variants-row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'row variant-row'},_ref22,_react2.default.createElement('div',{className:'small-offset-4 column'},_react2.default.createElement(_Checkbox2.default,{checked:sharedChecked,onChange:function onChange(e){return checkAllVariants(e.target.checked);},id:'check-all'}),_ref23)))))))),mapWithIndex(function(t,index){return _react2.default.createElement(ProductType,{key:t.id,productType:t,navigateToVariant:navigateToVariant,updateRelatedVariant:updateRelatedVariant,toggleVariant:toggleVariant,setStandardProduct:setStandardProduct,modifiedData:modifiedData,navigationStack:navigationStack,toggleProduct:toggleProduct,clearStandardProduct:clearStandardProduct,checkProduct:checkProduct,updateVariants:updateVariants,updateVariantsForType:updateVariantsForType,isLast:index===navigationStack.active.length-1});},navigationStack.active),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column dialog-toolbar'},_react2.default.createElement('button',{type:'button',className:'button',onClick:onClose},'St\xE4ng')))));};exports.default=AdvancedProductSlotDialog;

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _userList=__webpack_require__(381);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);var _roles=__webpack_require__(49);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: import type {UserListState} from '../../reducers/userList';*/var checkMark=_react2.default.createElement('i',{className:'fa fa-check'});var columns=[{property:'username',header:{label:'Användarnamn'}},{property:'person.name',header:{label:'Namn'}},{property:'person.phone',header:{label:'Telefon'}},{property:'email',header:{label:'Email'}},{property:'projectName',header:{label:'Projekt'}},{property:'notified',header:{label:'Notifierad'},cell:{formatters:[function(notified){return notified?checkMark:'';}]}}];/*:: export type Props = {
  history: Object,
  fetchUsers: Function,
  filterUsers: Function,
  location: { pathname: string },
  filter: {
    archived: boolean,
    project: ?number,
    query: ?string,
  },
  projects: any[],
  users: any[],
  isFetching: boolean,
  sortItems: typeof sortItems,
};*/var UsersContainer=function(_Component){_inherits(UsersContainer,_Component);function UsersContainer(){_classCallCheck(this,UsersContainer);return _possibleConstructorReturn(this,(UsersContainer.__proto__||Object.getPrototypeOf(UsersContainer)).apply(this,arguments));}_createClass(UsersContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchUsers();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,filter=_props.filter,projects=_props.projects,users=_props.users,filterUsers=_props.filterUsers,pathname=_props.location.pathname,isFetching=_props.isFetching,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'UsersContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:function onClear(e){return filterUsers('',filter.project,filter.archived);},onChange:function onChange(e){return filterUsers(e.target.value,filter.project,filter.archived);}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa ny'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:filter.project||null,onBlur:_noop3.default,onChange:function onChange(project){return filterUsers(filter.query,project?project.id:null,filter.archived);}},label:'Projekt',meta:{},valueKey:'id',labelKey:'name',clearable:true,options:projects,isLoading:isFetching})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:function onChange(archived){return filterUsers(filter.query,filter.project,archived?archived.value:false);}},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement(_AdminList2.default,{query:filter.query,columns:columns,rows:users,onSort:sortItems,onRowSelected:function onRowSelected(row){return history.push(pathname+'/'+row.id);}}))));}}]);return UsersContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$userList=_ref.userList,users=_ref$userList.filteredUsers,filter=_ref$userList.filter,projects=_ref$userList.projects,isFetching=_ref$userList.isFetching;return{filter:filter,users:(0,_filter3.default)(function(u){return u.role!==_roles.DEMO;},users),projects:projects,isFetching:isFetching};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchUsers:function fetchUsers(){return dispatch((0,_userList.fetchUsers)());},filterUsers:function filterUsers(query,project,archived){return dispatch((0,_userList.filterUsers)(query,project,archived));},sortItems:function sortItems(sorter){return dispatch((0,_userList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(UsersContainer));

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _provider = __webpack_require__(1096);

Object.defineProperty(exports, 'Provider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_provider).default;
  }
});

var _header = __webpack_require__(1097);

Object.defineProperty(exports, 'Header', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_header).default;
  }
});

var _body = __webpack_require__(1102);

Object.defineProperty(exports, 'Body', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_body).default;
  }
});

var _bodyRow = __webpack_require__(470);

Object.defineProperty(exports, 'BodyRow', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_bodyRow).default;
  }
});

var _evaluateFormatters = __webpack_require__(262);

Object.defineProperty(exports, 'evaluateFormatters', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_evaluateFormatters).default;
  }
});

var _evaluateTransforms = __webpack_require__(263);

Object.defineProperty(exports, 'evaluateTransforms', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_evaluateTransforms).default;
  }
});

var _mergeProps = __webpack_require__(177);

Object.defineProperty(exports, 'mergeProps', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mergeProps).default;
  }
});

var _columnsAreEqual = __webpack_require__(471);

Object.defineProperty(exports, 'columnsAreEqual', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_columnsAreEqual).default;
  }
});

var _resolveRowKey = __webpack_require__(472);

Object.defineProperty(exports, 'resolveRowKey', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_resolveRowKey).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _types = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var componentDefaults = _types.tableDefaults.components;

// TODO: shouldComponentUpdate

var Provider = function (_React$Component) {
  _inherits(Provider, _React$Component);

  function Provider() {
    _classCallCheck(this, Provider);

    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
  }

  _createClass(Provider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _props = this.props,
          columns = _props.columns,
          components = _props.components;


      return {
        columns: columns,
        components: {
          table: components.table || componentDefaults.table,
          header: _extends({}, componentDefaults.header, components.header),
          body: _extends({}, componentDefaults.body, components.body)
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          columns = _props2.columns,
          components = _props2.components,
          children = _props2.children,
          props = _objectWithoutProperties(_props2, ['columns', 'components', 'children']);

      return _react2.default.createElement(components.table || _types.tableDefaults.components.table, props, children);
    }
  }]);

  return Provider;
}(_react2.default.Component);

exports.default = Provider;

 false ? Provider.propTypes = _extends({}, _types.tableTypes, {
  children: _propTypes2.default.any
}) : void 0;
Provider.defaultProps = _extends({}, _types.tableDefaults);
Provider.childContextTypes = _types.tableContextTypes;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _types = __webpack_require__(129);

var _headerRow = __webpack_require__(1098);

var _headerRow2 = _interopRequireDefault(_headerRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_React$Component) {
  _inherits(Header, _React$Component);

  // eslint-disable-line max-len, react/prefer-stateless-function
  function Header(props) {
    _classCallCheck(this, Header);

    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));

    _this.ref = null;
    return _this;
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          headerRows = _props.headerRows,
          onRow = _props.onRow,
          props = _objectWithoutProperties(_props, ['children', 'headerRows', 'onRow']);

      var _context = this.context,
          components = _context.components,
          columns = _context.columns;


      props.ref = function (header) {
        _this2.ref = header;
      };

      // If headerRows aren't passed, default to bodyColumns as header rows
      return _react2.default.createElement(components.header.wrapper, props, [(headerRows || [columns]).map(function (rowData, rowIndex) {
        return _react2.default.createElement(_headerRow2.default, {
          key: rowIndex + '-header-row',
          components: components.header,
          onRow: onRow,
          rowData: rowData,
          rowIndex: rowIndex
        });
      })].concat(children));
    }
  }, {
    key: 'getRef',
    value: function getRef() {
      return this.ref;
    }
  }]);

  return Header;
}(_react2.default.Component);

 false ? Header.propTypes = _types.tableHeaderTypes : void 0;
Header.contextTypes = _types.tableHeaderContextTypes;

exports.default = Header;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _evaluateFormatters = __webpack_require__(262);

var _evaluateFormatters2 = _interopRequireDefault(_evaluateFormatters);

var _evaluateTransforms = __webpack_require__(263);

var _evaluateTransforms2 = _interopRequireDefault(_evaluateTransforms);

var _mergeProps = __webpack_require__(177);

var _mergeProps2 = _interopRequireDefault(_mergeProps);

var _types = __webpack_require__(129);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HeaderRow = function HeaderRow(_ref) {
  var rowData = _ref.rowData,
      rowIndex = _ref.rowIndex,
      components = _ref.components,
      onRow = _ref.onRow;
  return _react2.default.createElement(components.row, onRow(rowData, { rowIndex: rowIndex }), rowData.map(function (column, columnIndex) {
    var property = column.property,
        _column$header = column.header,
        header = _column$header === undefined ? {} : _column$header,
        _column$props = column.props,
        props = _column$props === undefined ? {} : _column$props;

    var evaluatedProperty = property || header && header.property;
    var label = header.label,
        _header$transforms = header.transforms,
        transforms = _header$transforms === undefined ? [] : _header$transforms,
        _header$formatters = header.formatters,
        formatters = _header$formatters === undefined ? [] : _header$formatters;

    var extraParameters = {
      columnIndex: columnIndex,
      property: evaluatedProperty,
      column: column
    };
    var transformedProps = (0, _evaluateTransforms2.default)(transforms, label, extraParameters);

    if (!transformedProps) {
      console.warn('Table.Header - Failed to receive a transformed result'); // eslint-disable-line max-len, no-console
    }

    return _react2.default.createElement(components.cell, _extends({
      key: columnIndex + '-header'
    }, (0, _mergeProps2.default)(props, header && header.props, transformedProps)), transformedProps.children || (0, _evaluateFormatters2.default)(formatters)(label, extraParameters));
  }));
};
HeaderRow.defaultProps = _types.tableHeaderRowDefaults;
 false ? HeaderRow.propTypes = _types.tableHeaderRowTypes : void 0;

exports.default = HeaderRow;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(466),
    createAssigner = __webpack_require__(469);

/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */
var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
  baseMerge(object, source, srcIndex, customizer);
});

module.exports = mergeWith;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(467),
    cloneBuffer = __webpack_require__(341),
    cloneTypedArray = __webpack_require__(348),
    copyArray = __webpack_require__(111),
    initCloneObject = __webpack_require__(349),
    isArguments = __webpack_require__(115),
    isArray = __webpack_require__(18),
    isArrayLikeObject = __webpack_require__(171),
    isBuffer = __webpack_require__(116),
    isFunction = __webpack_require__(52),
    isObject = __webpack_require__(45),
    isPlainObject = __webpack_require__(224),
    isTypedArray = __webpack_require__(152),
    safeGet = __webpack_require__(468),
    toPlainObject = __webpack_require__(1101);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(94),
    keysIn = __webpack_require__(161);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction2 = __webpack_require__(52);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _isEqual2 = __webpack_require__(240);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _types = __webpack_require__(129);

var _bodyRow = __webpack_require__(470);

var _bodyRow2 = _interopRequireDefault(_bodyRow);

var _resolveRowKey = __webpack_require__(472);

var _resolveRowKey2 = _interopRequireDefault(_resolveRowKey);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Body = function (_React$Component) {
  _inherits(Body, _React$Component);

  function Body(props) {
    _classCallCheck(this, Body);

    var _this = _possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).call(this, props));

    _this.ref = null;
    return _this;
  }

  _createClass(Body, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      // eslint-disable-line no-unused-vars
      // Skip checking props against `onRow` since that can be bound at render().
      // That's not particularly good practice but you never know how the users
      // prefer to define the handler.

      // Check for wrapper based override.
      var components = nextContext.components;


      if (components && components.body && components.body.wrapper.shouldComponentUpdate) {
        if ((0, _isFunction3.default)(components.body.wrapper.shouldComponentUpdate)) {
          return components.body.wrapper.shouldComponentUpdate.call(this, nextProps, nextState, nextContext);
        }

        return true;
      }

      return !((0, _isEqual3.default)(omitOnRow(this.props), omitOnRow(nextProps)) && (0, _isEqual3.default)(this.context, nextContext));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onRow = _props.onRow,
          rows = _props.rows,
          rowKey = _props.rowKey,
          props = _objectWithoutProperties(_props, ['onRow', 'rows', 'rowKey']);

      var _context = this.context,
          columns = _context.columns,
          components = _context.components;


      props.ref = function (body) {
        _this2.ref = body;
      };

      return _react2.default.createElement(components.body.wrapper, props, rows.map(function (rowData, index) {
        var rowIndex = rowData._index || index;
        var key = (0, _resolveRowKey2.default)({ rowData: rowData, rowIndex: rowIndex, rowKey: rowKey });

        return _react2.default.createElement(_bodyRow2.default, {
          key: key,
          components: components.body,
          onRow: onRow,
          rowKey: key,
          rowIndex: rowIndex,
          rowData: rowData,
          columns: columns
        });
      }));
    }
  }, {
    key: 'getRef',
    value: function getRef() {
      return this.ref;
    }
  }]);

  return Body;
}(_react2.default.Component);

 false ? Body.propTypes = _types.tableBodyTypes : void 0;
Body.defaultProps = _types.tableBodyDefaults;
Body.contextTypes = _types.tableBodyContextTypes;

function omitOnRow(props) {
  var onRow = props.onRow,
      ret = _objectWithoutProperties(props, ['onRow']); // eslint-disable-line no-unused-vars

  return ret;
}

exports.default = Body;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(162);

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
}

module.exports = isEqualWith;


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _byColumn = __webpack_require__(1105);

Object.defineProperty(exports, 'byColumn', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_byColumn).default;
  }
});

var _byColumns = __webpack_require__(1106);

Object.defineProperty(exports, 'byColumns', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_byColumns).default;
  }
});

var _byColumnsPrioritizeLastSorted = __webpack_require__(1107);

Object.defineProperty(exports, 'byColumnsPrioritizeLastSorted', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_byColumnsPrioritizeLastSorted).default;
  }
});

var _header = __webpack_require__(1108);

Object.defineProperty(exports, 'header', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_header).default;
  }
});

var _sorter = __webpack_require__(1109);

Object.defineProperty(exports, 'sorter', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sorter).default;
  }
});

var _reset = __webpack_require__(1111);

Object.defineProperty(exports, 'reset', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_reset).default;
  }
});

var _sort = __webpack_require__(1112);

Object.defineProperty(exports, 'sort', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sort).default;
  }
});

var _strategies = __webpack_require__(474);

Object.defineProperty(exports, 'strategies', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_strategies).default;
  }
});

var _order = __webpack_require__(475);

Object.defineProperty(exports, 'order', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_order).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defaultOrder = __webpack_require__(264);

var _defaultOrder2 = _interopRequireDefault(_defaultOrder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var byColumn = function byColumn(_ref) {
  var sortingColumns = _ref.sortingColumns,
      _ref$sortingOrder = _ref.sortingOrder,
      sortingOrder = _ref$sortingOrder === undefined ? _defaultOrder2.default : _ref$sortingOrder,
      _ref$selectedColumn = _ref.selectedColumn,
      selectedColumn = _ref$selectedColumn === undefined ? -1 : _ref$selectedColumn;

  var sort = sortingOrder.FIRST;

  if (selectedColumn < 0) {
    return sortingColumns;
  }

  if (sortingColumns && {}.hasOwnProperty.call(sortingColumns, selectedColumn)) {
    sort = sortingOrder[sortingColumns[selectedColumn].direction];

    if (!sort) {
      return {};
    }
  }

  return _defineProperty({}, selectedColumn, {
    direction: sort,
    position: 0
  });
};

exports.default = byColumn;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cloneDeep2 = __webpack_require__(473);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _defaultOrder = __webpack_require__(264);

var _defaultOrder2 = _interopRequireDefault(_defaultOrder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var byColumns = function byColumns(_ref) {
  var sortingColumns = _ref.sortingColumns,
      _ref$sortingOrder = _ref.sortingOrder,
      sortingOrder = _ref$sortingOrder === undefined ? _defaultOrder2.default : _ref$sortingOrder,
      _ref$selectedColumn = _ref.selectedColumn,
      selectedColumn = _ref$selectedColumn === undefined ? -1 : _ref$selectedColumn;

  var newSortingColumns = {};

  if (selectedColumn < 0) {
    return sortingColumns;
  }

  if (!sortingColumns) {
    return _defineProperty({}, selectedColumn, {
      direction: sortingOrder.FIRST,
      position: 0
    });
  } else if ({}.hasOwnProperty.call(sortingColumns, selectedColumn)) {
    // Clone to avoid mutating the original structure
    newSortingColumns = (0, _cloneDeep3.default)(sortingColumns);

    var newSort = sortingOrder[newSortingColumns[selectedColumn].direction];

    if (newSort) {
      newSortingColumns[selectedColumn] = {
        direction: newSort,
        position: newSortingColumns[selectedColumn].position
      };
    } else {
      var oldPosition = newSortingColumns[selectedColumn].position;

      delete newSortingColumns[selectedColumn];

      // Update position of columns after the deleted one
      Object.keys(newSortingColumns).forEach(function (k) {
        var v = newSortingColumns[k];

        if (v.position > oldPosition) {
          v.position -= 1;
        }
      });
    }

    return newSortingColumns;
  }

  return _extends({}, sortingColumns, _defineProperty({}, selectedColumn, {
    direction: sortingOrder.FIRST,
    position: Object.keys(sortingColumns).length
  }));
};

exports.default = byColumns;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cloneDeep2 = __webpack_require__(473);

var _cloneDeep3 = _interopRequireDefault(_cloneDeep2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _defaultOrder = __webpack_require__(264);

var _defaultOrder2 = _interopRequireDefault(_defaultOrder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var byColumnsPrioritizeLastSorted = function byColumnsPrioritizeLastSorted(_ref) {
  var sortingColumns = _ref.sortingColumns,
      _ref$sortingOrder = _ref.sortingOrder,
      sortingOrder = _ref$sortingOrder === undefined ? _defaultOrder2.default : _ref$sortingOrder,
      _ref$selectedColumn = _ref.selectedColumn,
      selectedColumn = _ref$selectedColumn === undefined ? -1 : _ref$selectedColumn;

  var newSortingColumns = {};

  if (selectedColumn < 0) {
    return sortingColumns;
  }

  if (!sortingColumns) {
    return _defineProperty({}, selectedColumn, {
      direction: sortingOrder.FIRST,
      position: 0
    });
  } else if ({}.hasOwnProperty.call(sortingColumns, selectedColumn)) {
    // Clone to avoid mutating the original structure
    newSortingColumns = (0, _cloneDeep3.default)(sortingColumns);

    var newSort = sortingOrder[newSortingColumns[selectedColumn].direction];
    var oldPosition = newSortingColumns[selectedColumn].position;

    if (newSort) {
      // sort direction is being updated
      // demote all previously higher-priority columns by 1
      // by incrementing their position
      Object.keys(newSortingColumns).forEach(function (k) {
        var v = newSortingColumns[k];

        if (v.position < oldPosition) {
          v.position += 1;
        }
      });
      newSortingColumns[selectedColumn] = {
        direction: newSort,
        position: 0
      };
    } else {
      delete newSortingColumns[selectedColumn];

      // Update position of columns after the deleted one
      Object.keys(newSortingColumns).forEach(function (k) {
        var v = newSortingColumns[k];

        if (v.position > oldPosition) {
          v.position -= 1;
        }
      });
    }

    return newSortingColumns;
  }

  // clone and insert new column at position 0, increment all others
  newSortingColumns = (0, _cloneDeep3.default)(sortingColumns);
  Object.keys(newSortingColumns).forEach(function (k) {
    var v = newSortingColumns[k];
    v.position += 1;
  });

  return _extends({}, newSortingColumns, _defineProperty({}, selectedColumn, {
    direction: sortingOrder.FIRST,
    position: 0
  }));
};

exports.default = byColumnsPrioritizeLastSorted;

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/prop-types */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _defaultStrategy = __webpack_require__(130);

var _defaultStrategy2 = _interopRequireDefault(_defaultStrategy);

var _order = __webpack_require__(475);

var _order2 = _interopRequireDefault(_order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var header = function header(_ref) {
  var sortable = _ref.sortable,
      getSortingColumns = _ref.getSortingColumns,
      _ref$props = _ref.props,
      props = _ref$props === undefined ? {
    container: {},
    value: {},
    order: {}
  } : _ref$props,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === undefined ? _defaultStrategy2.default : _ref$strategy;

  if (!getSortingColumns) {
    throw new Error('header - Missing getSortingColumns!');
  }

  return function (value, extra) {
    return _react2.default.createElement(
      'div',
      _extends({
        className: 'sort-container'
      }, props.container),
      _react2.default.createElement(
        'span',
        _extends({
          className: 'sort-value'
        }, props.value),
        value
      ),
      (0, _order2.default)({
        getSortingColumns: getSortingColumns,
        props: props.order,
        strategy: strategy
      })(value, extra),
      sortable ? _react2.default.createElement('span', sortable(value, extra)) : null
    );
  };
};

exports.default = header;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _result = __webpack_require__(1110);

var _result2 = _interopRequireDefault(_result);

var _get = __webpack_require__(96);

var _get2 = _interopRequireDefault(_get);

var _defaultStrategy = __webpack_require__(130);

var _defaultStrategy2 = _interopRequireDefault(_defaultStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// sorter === lodash orderBy
// https://lodash.com/docs#orderBy
var sorter = function sorter() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      columns = _ref.columns,
      sortingColumns = _ref.sortingColumns,
      sort = _ref.sort,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === undefined ? _defaultStrategy2.default : _ref$strategy;

  return function (data) {
    if (!columns) {
      throw new Error('sort.sorter - Missing columns!');
    }

    if (!sortingColumns) {
      return data;
    }

    var columnIndexList = new Array(sortingColumns.length);
    var orderList = new Array(sortingColumns.length);

    Object.keys(sortingColumns).forEach(function (sortingColumnKey) {
      var realColumn = strategy.getColumn(columns, sortingColumnKey) || {};
      var sortingColumn = sortingColumns[sortingColumnKey];

      columnIndexList[sortingColumn.position] = function (row) {
        var property = realColumn.property;
        var value = row[property];
        // Pick resolved value by convention
        var resolvedValue = (0, _get2.default)(row, '_' + property, value);

        return (0, _result2.default)(resolvedValue, 'toLowerCase', resolvedValue);
      };

      orderList[sortingColumn.position] = sortingColumn.direction;
    });

    return sort(data, columnIndexList, orderList);
  };
};

exports.default = sorter;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(78),
    isFunction = __webpack_require__(52),
    toKey = __webpack_require__(64);

/**
 * This method is like `_.get` except that if the resolved value is a
 * function it's invoked with the `this` binding of its parent object and
 * its result is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to resolve.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
 *
 * _.result(object, 'a[0].b.c1');
 * // => 3
 *
 * _.result(object, 'a[0].b.c2');
 * // => 4
 *
 * _.result(object, 'a[0].b.c3', 'default');
 * // => 'default'
 *
 * _.result(object, 'a[0].b.c3', _.constant('default'));
 * // => 'default'
 */
function result(object, path, defaultValue) {
  path = castPath(path, object);

  var index = -1,
      length = path.length;

  // Ensure the loop is entered when path is empty.
  if (!length) {
    length = 1;
    object = undefined;
  }
  while (++index < length) {
    var value = object == null ? undefined : object[toKey(path[index])];
    if (value === undefined) {
      index = length;
      value = defaultValue;
    }
    object = isFunction(value) ? value.call(object) : value;
  }
  return object;
}

module.exports = result;


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _defaultStrategy = __webpack_require__(130);

var _defaultStrategy2 = _interopRequireDefault(_defaultStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var reset = function reset(_ref) {
  var _ref$event = _ref.event,
      event = _ref$event === undefined ? 'onDoubleClick' : _ref$event,
      _ref$getSortingColumn = _ref.getSortingColumns,
      getSortingColumns = _ref$getSortingColumn === undefined ? function () {
    return [];
  } : _ref$getSortingColumn,
      _ref$onReset = _ref.onReset,
      onReset = _ref$onReset === undefined ? function () {} : _ref$onReset,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === undefined ? _defaultStrategy2.default : _ref$strategy;
  return function (value, extra) {
    return _defineProperty({}, event, function () {
      var sortingColumns = getSortingColumns();

      if (!sortingColumns || !Object.keys(sortingColumns).length) {
        return;
      }

      var field = extra[strategy.fieldName];

      var position = sortingColumns[field].position;
      var newSortingColumns = {};

      delete sortingColumns[field];

      Object.keys(sortingColumns).forEach(function (k) {
        var column = sortingColumns[k];

        if (column.position > position) {
          newSortingColumns[k] = _extends({}, column, {
            position: column.position - 1
          });
        } else {
          newSortingColumns[k] = column;
        }
      });

      onReset({
        sortingColumns: newSortingColumns
      });
    });
  };
};

exports.default = reset;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(19);

var _classnames2 = _interopRequireDefault(_classnames);

var _defaultStrategy = __webpack_require__(130);

var _defaultStrategy2 = _interopRequireDefault(_defaultStrategy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var sort = function sort() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$event = _ref.event,
      event = _ref$event === undefined ? 'onClick' : _ref$event,
      _ref$getSortingColumn = _ref.getSortingColumns,
      getSortingColumns = _ref$getSortingColumn === undefined ? function () {
    return [];
  } : _ref$getSortingColumn,
      _ref$onSort = _ref.onSort,
      onSort = _ref$onSort === undefined ? function () {} : _ref$onSort,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === undefined ? _defaultStrategy2.default : _ref$strategy;

  return function (_value, extra) {
    var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var className = _ref2.className,
        props = _objectWithoutProperties(_ref2, ['className']);

    var sortingColumns = getSortingColumns();
    var field = extra[strategy.fieldName];
    var headerClass = 'sort sort-none';

    // Check against undefined to allow zero
    if (sortingColumns[field] !== undefined) {
      headerClass = 'sort sort-' + sortingColumns[field].direction;
    }

    return _extends({}, props, _defineProperty({
      className: (0, _classnames2.default)(className, headerClass)
    }, event, function () {
      return onSort(field);
    }));
  };
};

exports.default = sort;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _resolve = __webpack_require__(1114);

Object.defineProperty(exports, 'resolve', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_resolve).default;
  }
});

var _nested = __webpack_require__(1115);

Object.defineProperty(exports, 'nested', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_nested).default;
  }
});

var _byFunction = __webpack_require__(1118);

Object.defineProperty(exports, 'byFunction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_byFunction).default;
  }
});

var _countRowSpan = __webpack_require__(476);

Object.defineProperty(exports, 'countRowSpan', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_countRowSpan).default;
  }
});

var _columnChildren = __webpack_require__(1119);

Object.defineProperty(exports, 'columnChildren', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_columnChildren).default;
  }
});

var _headerRows = __webpack_require__(1120);

Object.defineProperty(exports, 'headerRows', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_headerRows).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function resolve(_ref) {
  var columns = _ref.columns,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? function () {
    return function (rowData) {
      return rowData;
    };
  } : _ref$method,
      _ref$indexKey = _ref.indexKey,
      indexKey = _ref$indexKey === undefined ? '_index' : _ref$indexKey;

  if (!columns) {
    throw new Error('resolve - Missing columns!');
  }

  return function () {
    var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var methodsByColumnIndex = columns.map(function (column) {
      return method({ column: column });
    });

    return rows.map(function (rowData, rowIndex) {
      var ret = {};

      columns.forEach(function (column, columnIndex) {
        var result = methodsByColumnIndex[columnIndex](rowData);

        delete result.undefined;

        ret = _extends(_defineProperty({}, indexKey, rowIndex), rowData, ret, result);
      });

      return ret;
    });
  };
}

exports.default = resolve;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isFunction2 = __webpack_require__(52);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _has2 = __webpack_require__(1116);

var _has3 = _interopRequireDefault(_has2);

var _get2 = __webpack_require__(96);

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function nested(_ref) {
  var column = _ref.column;

  return function (rowData) {
    var property = column.property;


    if (!property) {
      return {};
    }

    // if users provide a custom getter instead of a
    // path for _.get, use that getter ...
    if ((0, _isFunction3.default)(property)) {
      return _extends({}, rowData, _defineProperty({}, property, property(rowData)));
    }

    // ... otherwise, make sure property exists, then _.get it
    if (!(0, _has3.default)(rowData, property)) {
      return {};
    }

    return _extends({}, rowData, _defineProperty({}, property, (0, _get3.default)(rowData, property)));
  };
}

exports.default = nested;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(1117),
    hasPath = __webpack_require__(357);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 1117 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get2 = __webpack_require__(96);

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function byFunction(path) {
  return function (_ref) {
    var _ref$column = _ref.column,
        column = _ref$column === undefined ? {} : _ref$column;
    return function (rowData) {
      var property = column.property;


      if (!property) {
        return rowData;
      }

      var value = rowData[property];
      var resolver = (0, _get3.default)(column, path);
      var ret = _extends({}, rowData, _defineProperty({}, property, value));

      if (resolver) {
        ret['_' + property] = resolver(value, {
          property: property,
          rowData: rowData
        });
      }

      return ret;
    };
  };
}

exports.default = byFunction;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function columnChildren(_ref) {
  var columns = _ref.columns,
      _ref$childrenField = _ref.childrenField,
      childrenField = _ref$childrenField === undefined ? 'children' : _ref$childrenField;

  if (!columns) {
    throw new Error('resolve.columnChildren - Missing columns!');
  }

  var ret = [];

  columns.forEach(function (column) {
    // If a column has children, skip cell specific configuration
    if (column[childrenField] && column[childrenField].length) {
      ret = ret.concat(columnChildren({
        columns: column[childrenField],
        childrenField: childrenField
      }));
    } else {
      ret.push(column);
    }
  });

  return ret;
}

exports.default = columnChildren;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = __webpack_require__(1121);

var _omit3 = _interopRequireDefault(_omit2);

var _countRowSpan = __webpack_require__(476);

var _countRowSpan2 = _interopRequireDefault(_countRowSpan);

var _countColSpan = __webpack_require__(1125);

var _countColSpan2 = _interopRequireDefault(_countColSpan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function resolveHeaderRows(_ref) {
  var columns = _ref.columns,
      _ref$childrenField = _ref.childrenField,
      childrenField = _ref$childrenField === undefined ? 'children' : _ref$childrenField;

  var resolvedChildren = [];

  var ret = columns.map(function (column) {
    var children = column[childrenField];
    var col = (0, _omit3.default)(column, [childrenField]);

    if (children && children.length) {
      resolveHeaderRows({ columns: children, childrenField: childrenField }).forEach(function (cells, depth) {
        resolvedChildren[depth] = [].concat(_toConsumableArray(resolvedChildren[depth] || []), _toConsumableArray(cells));
      });

      return Object.assign({}, col, {
        props: Object.assign({
          colSpan: (0, _countColSpan2.default)(children, 0)
        }, col.props)
      });
    }

    return Object.assign({}, col, {
      props: Object.assign({
        rowSpan: (0, _countRowSpan2.default)(columns)
      }, col.props)
    });
  });

  return resolvedChildren.length ? [ret].concat(resolvedChildren) : [ret];
}

exports.default = resolveHeaderRows;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(46),
    baseClone = __webpack_require__(155),
    baseUnset = __webpack_require__(1122),
    castPath = __webpack_require__(78),
    copyObject = __webpack_require__(94),
    customOmitClone = __webpack_require__(1124),
    flatRest = __webpack_require__(118),
    getAllKeysIn = __webpack_require__(222);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(78),
    last = __webpack_require__(261),
    parent = __webpack_require__(1123),
    toKey = __webpack_require__(64);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(165),
    baseSlice = __webpack_require__(239);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(224);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
function countColSpan(columns, returnCount) {
  var count = returnCount;
  if (columns && columns.length > 0) {
    columns.forEach(function (column) {
      if (column.children && column.children.length > 0) {
        count = countColSpan(column.children, count);
      } else {
        count += 1;
      }
    });
  }
  return count;
}

exports.default = countColSpan;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1127);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _merge = __webpack_require__(1132);

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultTags = {
  container: {
    tag: 'div',
    props: {}
  },
  segment: {
    tag: 'div',
    props: {}
  },
  ellipsis: {
    tag: 'div',
    props: {
      children: '…'
    }
  },
  link: {
    tag: 'span',
    props: {}
  }
};

var Context = function (_React$Component) {
  _inherits(Context, _React$Component);

  function Context() {
    _classCallCheck(this, Context);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Context).apply(this, arguments));
  }

  _createClass(Context, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        segments: this.props.segments,
        onSelect: this.props.onSelect,
        tags: this.tags
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var onSelect = _props.onSelect;
      var segments = _props.segments;
      var tags = _props.tags;

      var props = _objectWithoutProperties(_props, ['onSelect', 'segments', 'tags']); // eslint-disable-line max-len, no-unused-vars


      var Container = this.tags.container;

      return _react2.default.createElement(
        Container.tag,
        _extends({}, Container.props, props),
        this.props.children
      );
    }
  }, {
    key: 'tags',
    get: function get() {
      return (0, _merge2.default)({}, defaultTags, this.props.tags);
    }
  }]);

  return Context;
}(_react2.default.Component);

Context.propTypes = {
  children: _propTypes2.default.any,
  onSelect: _propTypes2.default.func,
  segments: _propTypes2.default.object,
  tags: _propTypes2.default.object
};
Context.childContextTypes = {
  onSelect: _propTypes2.default.func,
  segments: _propTypes2.default.object,
  tags: _propTypes2.default.object
};

var Segment = function (_React$Component2) {
  _inherits(Segment, _React$Component2);

  function Segment() {
    _classCallCheck(this, Segment);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Segment).apply(this, arguments));
  }

  _createClass(Segment, [{
    key: 'render',
    value: function render() {
      var context = this.context;
      var _props2 = this.props;
      var field = _props2.field;

      var props = _objectWithoutProperties(_props2, ['field']);

      var segments = context.segments;
      var onSelect = context.onSelect;
      var tags = context.tags;
      var Tag = tags.segment.tag;
      var Link = tags.link.tag;
      var pages = segments[field];

      return _react2.default.createElement(
        Tag,
        _extends({}, tags.segment.props, props),
        pages.map(function (page) {
          return _react2.default.createElement(
            Link,
            _extends({}, tags.link.props, {
              key: 'page-' + page,
              onClick: function onClick(e) {
                return onSelect(page, e);
              } }),
            page
          );
        })
      );
    }
  }]);

  return Segment;
}(_react2.default.Component);

Segment.propTypes = {
  field: _propTypes2.default.string.isRequired
};
Segment.contextTypes = {
  onSelect: _propTypes2.default.func,
  segments: _propTypes2.default.object,
  tags: _propTypes2.default.object
};

var Button = function (_React$Component3) {
  _inherits(Button, _React$Component3);

  function Button() {
    _classCallCheck(this, Button);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Button).apply(this, arguments));
  }

  _createClass(Button, [{
    key: 'render',
    value: function render() {
      var context = this.context;
      var _props3 = this.props;
      var page = _props3.page;
      var children = _props3.children;

      var props = _objectWithoutProperties(_props3, ['page', 'children']);

      var onSelect = context.onSelect;
      var tags = context.tags;
      var Tag = tags.segment.tag;
      var Link = tags.link.tag;

      return _react2.default.createElement(
        Tag,
        _extends({}, tags.segment.props, props),
        _react2.default.createElement(
          Link,
          _extends({}, tags.link.props, {
            onClick: function onClick(e) {
              return onSelect(page, e);
            } }),
          children
        )
      );
    }
  }]);

  return Button;
}(_react2.default.Component);

Button.propTypes = {
  children: _propTypes2.default.any,
  page: _propTypes2.default.number.isRequired
};
Button.contextTypes = {
  onSelect: _propTypes2.default.func,
  tags: _propTypes2.default.object
};

var Ellipsis = function (_React$Component4) {
  _inherits(Ellipsis, _React$Component4);

  function Ellipsis() {
    _classCallCheck(this, Ellipsis);

    return _possibleConstructorReturn(this, Object.getPrototypeOf(Ellipsis).apply(this, arguments));
  }

  _createClass(Ellipsis, [{
    key: 'render',
    value: function render() {
      var context = this.context;
      var _props4 = this.props;
      var previousField = _props4.previousField;
      var nextField = _props4.nextField;

      var props = _objectWithoutProperties(_props4, ['previousField', 'nextField']);

      var segments = context.segments;
      var tags = context.tags;
      var Tag = tags.ellipsis.tag;
      var previousPages = segments[previousField];
      var nextPages = segments[nextField];
      var showEllipsis = nextPages[0] - previousPages.slice(-1)[0] > 1;

      if (showEllipsis) {
        return _react2.default.createElement(Tag, _extends({}, tags.ellipsis.props, props));
      }

      return null;
    }
  }]);

  return Ellipsis;
}(_react2.default.Component);

Ellipsis.propTypes = {
  children: _propTypes2.default.any,
  previousField: _propTypes2.default.string.isRequired,
  nextField: _propTypes2.default.string.isRequired
};
Ellipsis.contextTypes = {
  segments: _propTypes2.default.object,
  tags: _propTypes2.default.object
};

exports.default = {
  Context: Context,
  Segment: Segment,
  Button: Button,
  Ellipsis: Ellipsis
};

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1128)();
}


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1129);
var invariant = __webpack_require__(1130);
var ReactPropTypesSecret = __webpack_require__(1131);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(466),
    createAssigner = __webpack_require__(469);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (o) {
  var pages = o.pages;
  var page = Math.min(Math.max(o.page, 1), pages);
  var previousPages = o.sidePages ?
    range(Math.max(page - o.sidePages, 1), page) : [];
  var nextPages = o.sidePages ?
    range(page + 1, Math.min(page + o.sidePages + 1, pages)) : [];
  var beginPages = o.beginPages ? range(1, Math.min(o.beginPages, pages) + 1) : [];
  var endPages = o.endPages ? range(Math.max(pages - o.endPages + 1, 0), pages + 1) : [];

  return {
    beginPages: difference(beginPages, range(page, Math.max(pages, o.beginPages) + 1)),
    previousPages: difference(previousPages, beginPages),
    centerPage: [page],
    nextPages: difference(nextPages, endPages),
    endPages: difference(endPages, range(0, page + 1))
  };
};

function range(a, b) {
  var len = b ? b : a;
  var ret = [];
  var i = b ? a : 0;

  for (; i < len; i++) {
    ret.push(i);
  }

  return ret;
}

function difference(a, b) {
  return a.filter(function (v) {
    return b.indexOf(v) < 0;
  });
}


/***/ }),
/* 1134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _reduxForm=__webpack_require__(4);var _userView=__webpack_require__(380);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _UserForm=__webpack_require__(1138);var _UserForm2=_interopRequireDefault(_UserForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createValidation={'person.name':{rule:'string|required',label:'Namn'},'person.address':{rule:'string',label:'Adress'},'person.phone':{rule:'string',label:'Telefon'},'person.mobile':{rule:'string',label:'Mobiltelefon'},username:{rule:'string|required',label:'Användarnamn'},password:{rule:'string|confirmed|required',label:'Lösenord'},password_confirmation:{rule:'string|required',label:'Repeterat lösenord'},role:{rule:'numeric|required',label:'Roll'}};var editValidation={'person.name':{rule:'string|required',label:'Namn'},'person.address':{rule:'string',label:'Adress'},'person.phone':{rule:'string',label:'Telefon'},'person.mobile':{rule:'string',label:'Mobiltelefon'},role:{rule:'numeric|required',label:'Roll'},username:{rule:'string|required',label:'Användarnamn'},password:{rule:'string|confirmed',label:'Lösenord'},password_confirmation:{rule:'string',label:'Repeterat lösenord'},archived:{rule:'archivable',label:'Arkiverad'}};/*:: export type Props = {
  setDirty: Function,
  reset: Function,
  resetForm: Function,
  isDirty: boolean,
  fetchUser: Function,
  updateUser: Function,
  createUser: Function,
  clearUser: Function,
  sendActiviationLink: Function,
  isFetching: boolean,
  prevPath: string,
  user?: any,
  userFormValues?: any,
  userFormIsValid?: boolean,
  params: any,
  error?: any,
  touch: Function,
  users: any[],
};*/var UserContainer=function(_Component){_inherits(UserContainer,_Component);function UserContainer(){_classCallCheck(this,UserContainer);return _possibleConstructorReturn(this,(UserContainer.__proto__||Object.getPrototypeOf(UserContainer)).apply(this,arguments));}_createClass(UserContainer,[{key:'componentWillMount',value:function componentWillMount(){var id=this.props.params.id;if(id){this.props.fetchUser(id);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clearUser();}},{key:'setDirty',value:function setDirty(){var _props=this.props,setDirty=_props.setDirty,isDirty=_props.isDirty;if(!isDirty){setDirty(true);}}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('user');setDirty(false);}},{key:'save',value:function save(){var _props3=this.props,user=_props3.user,createUser=_props3.createUser,touch=_props3.touch,updateUser=_props3.updateUser,userFormIsValid=_props3.userFormIsValid,userFormValues=_props3.userFormValues;var create=!user;var userKeys=(0,_keys3.default)(create?createValidation:editValidation);touch.apply(undefined,['user'].concat(_toConsumableArray(userKeys)));if(!userFormIsValid){return;}if(create){createUser(userFormValues);}else if(!!user){updateUser(user.id,userFormValues);}}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,isDirty=_props4.isDirty,id=_props4.params.id,user=_props4.user,error=_props4.error,isFetching=_props4.isFetching,updateUser=_props4.updateUser,prevPath=_props4.prevPath,sendActiviationLink=_props4.sendActiviationLink,users=_props4.users,clearUser=_props4.clearUser,fetchUser=_props4.fetchUser;return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:user,list:users,prevPath:prevPath,clear:clearUser,fetchData:fetchUser}),_react2.default.createElement('div',{className:'content-title'},user&&user.username||'Ny användare'))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},user&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveUser',className:'secondary button',message:'Vill du verkligen '+(user.archived?'av':'')+'arkivera den h\xE4r anv\xE4ndaren?',buttonText:user.archived?'Avarkivera':'Arkivera',action:function action(){return updateUser(id,{archived:!user.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},id?_react2.default.createElement(_UserForm2.default,{initialValues:user,user:user,onActivation:function onActivation(){return sendActiviationLink(id);},onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(editValidation,values);}}):user?_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath}):_react2.default.createElement(_UserForm2.default,{onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(createValidation,values);}})),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return UserContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$userView=_ref.userView,isDirty=_ref$userView.isDirty,user=_ref$userView.active,error=_ref$userView.error,isFetching=_ref$userView.isFetching,users=_ref.userList.filteredUsers,form=_ref.form;return{isDirty:isDirty,user:user,error:error,userFormIsValid:(0,_reduxForm.isValid)('user')({form:form}),userFormValues:(0,_reduxForm.getFormValues)('user')({form:form}),isFetching:isFetching,users:users};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'user'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_userView.reset)());},fetchUser:function fetchUser(id){return dispatch((0,_userView.fetchUser)(id));},updateUser:function updateUser(id,data){return dispatch((0,_userView.updateUser)(id,data));},createUser:function createUser(data){return dispatch((0,_userView.createUser)(data));},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},clearUser:function clearUser(){return dispatch((0,_userView.clearUser)());},sendActiviationLink:function sendActiviationLink(userId){return dispatch((0,_userView.sendActiviationLink)(userId));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(UserContainer);

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _roles=__webpack_require__(49);__webpack_require__(1139);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  user: ?any,
  onUserChange: Function,
  onActivation?: Function,
};*/var _ref2=_react2.default.createElement('label',null,'Aktiveringsl\xE4nk skickad');var UserForm=function UserForm(_ref){var onUserChange=_ref.onUserChange,onActivation=_ref.onActivation,user=_ref.user;return _react2.default.createElement('div',{className:'UserForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_reduxForm.Field,{name:'person.name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'person.address',label:'Adress',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'person.phone',label:'Telefon',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'person.mobile',label:'Mobiltelefon',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'username',label:'Anv\xE4ndarnamn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'email',label:'Email',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'password',label:'L\xF6senord',onChange:onUserChange,component:_BasicFormInput2.default,type:'password'}),_react2.default.createElement(_reduxForm.Field,{name:'password_confirmation',label:'Repetera l\xF6senord',onChange:onUserChange,component:_BasicFormInput2.default,type:'password'}),_react2.default.createElement(_reduxForm.Field,{name:'role',label:'Roll',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'label',options:_roles.roles}),!!user&&_react2.default.createElement('div',null,_ref2,_react2.default.createElement('div',{className:'input-margin'},user.notified?'Ja':'Nej')),!!onActivation&&_react2.default.createElement('button',{className:'button',type:'button',onClick:onActivation},'Skicka aktiveringsl\xE4nk'))));};exports.default=(0,_reduxForm.reduxForm)({form:'user',enableReinitialize:true})(UserForm);

/***/ }),
/* 1139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _workerTypeList=__webpack_require__(383);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=[{property:'name',header:{label:'Namn'}}];/*:: export type Props = {
  history: Object,
  fetchWorkerTypes: Function,
  filterWorkerTypes: Function,
  location: { pathname: string },
  filter: {
    archived: boolean,
    query?: string,
  },
  workerTypes: any[],
  isFetching: boolean,
  sortItems: typeof sortItems,
};*/var WorkerTypesContainer=function(_Component){_inherits(WorkerTypesContainer,_Component);function WorkerTypesContainer(){_classCallCheck(this,WorkerTypesContainer);return _possibleConstructorReturn(this,(WorkerTypesContainer.__proto__||Object.getPrototypeOf(WorkerTypesContainer)).apply(this,arguments));}_createClass(WorkerTypesContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchWorkerTypes();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,filter=_props.filter,workerTypes=_props.workerTypes,filterWorkerTypes=_props.filterWorkerTypes,pathname=_props.location.pathname,isFetching=_props.isFetching,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'WorkerTypesContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:function onClear(e){return filterWorkerTypes('',filter.archived);},onChange:function onChange(e){return filterWorkerTypes(e.target.value,filter.archived);}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa ny'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:function onChange(archived){return filterWorkerTypes(filter.query,archived?archived.value:false);}},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),workerTypes&&_react2.default.createElement('div',{className:'box'},_react2.default.createElement(_AdminList2.default,{query:filter.query,columns:columns,rows:workerTypes,onSort:sortItems,onRowSelected:function onRowSelected(row){return history.push(pathname+'/'+row.id);}}))));}}]);return WorkerTypesContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$workerTypeList=_ref.workerTypeList,filter=_ref$workerTypeList.filter,isFetching=_ref$workerTypeList.isFetching,workerTypes=_ref$workerTypeList.filteredList;return{isFetching:isFetching,filter:filter,workerTypes:workerTypes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchWorkerTypes:function fetchWorkerTypes(){return dispatch((0,_workerTypeList.fetchWorkerTypes)());},filterWorkerTypes:function filterWorkerTypes(query,archived){return dispatch((0,_workerTypeList.filterWorkerTypes)(query,archived));},sortItems:function sortItems(sorter){return dispatch((0,_workerTypeList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(WorkerTypesContainer));

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _workerTypeView=__webpack_require__(382);var _reduxForm=__webpack_require__(4);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _WorkerTypeForm=__webpack_require__(1142);var _WorkerTypeForm2=_interopRequireDefault(_WorkerTypeForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var validation={name:{rule:'string|required',label:'Namn'}};/*:: export type Props = {
  setDirty: Function,
  reset: Function,
  touch: Function,
  resetForm: Function,
  workerTypeFormValues?: any,
  workerTypeFormIsValid?: boolean,
  isDirty: boolean,
  fetchWorkerType: Function,
  updateWorkerType: Function,
  createWorkerType: Function,
  clearWorkerType: Function,
  isFetching: boolean,
  prevPath: string,
  workerType?: any,
  params: any,
  error?: any,
  workerTypes: any[],
};*/var WorkerTypeContainer=function(_Component){_inherits(WorkerTypeContainer,_Component);function WorkerTypeContainer(){_classCallCheck(this,WorkerTypeContainer);return _possibleConstructorReturn(this,(WorkerTypeContainer.__proto__||Object.getPrototypeOf(WorkerTypeContainer)).apply(this,arguments));}_createClass(WorkerTypeContainer,[{key:'componentWillMount',value:function componentWillMount(){var id=this.props.params.id;if(id){this.props.fetchWorkerType(id);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clearWorkerType();}},{key:'setDirty',value:function setDirty(){var _props=this.props,setDirty=_props.setDirty,isDirty=_props.isDirty;if(!isDirty){setDirty(true);}}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('workerType');setDirty(false);}},{key:'save',value:function save(){var _props3=this.props,workerTypeFormValues=_props3.workerTypeFormValues,touch=_props3.touch,workerTypeFormIsValid=_props3.workerTypeFormIsValid,workerType=_props3.workerType,updateWorkerType=_props3.updateWorkerType,createWorkerType=_props3.createWorkerType;var workerTypeKeys=(0,_keys3.default)(validation);touch.apply(undefined,['workerType'].concat(_toConsumableArray(workerTypeKeys)));if(!workerTypeFormIsValid){return;}if(!workerType){createWorkerType(workerTypeFormValues);}else{updateWorkerType(workerType.id,workerTypeFormValues);}}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,isDirty=_props4.isDirty,id=_props4.params.id,workerType=_props4.workerType,error=_props4.error,isFetching=_props4.isFetching,updateWorkerType=_props4.updateWorkerType,prevPath=_props4.prevPath,workerTypes=_props4.workerTypes,clearWorkerType=_props4.clearWorkerType,fetchWorkerType=_props4.fetchWorkerType;return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:workerType,list:workerTypes,prevPath:prevPath,clear:clearWorkerType,fetchData:fetchWorkerType}),_react2.default.createElement('div',{className:'content-title'},workerType&&workerType.name||'Ny yrkeskategori'))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},workerType&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveWorkerType',className:'secondary button',message:'Vill du verkligen '+(workerType.archived?'av':'')+'arkivera den h\xE4r yrkeskategorien?',buttonText:workerType.archived?'Avarkivera':'Arkivera',action:function action(){return updateWorkerType(workerType.id,{archived:!workerType.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},id?_react2.default.createElement(_WorkerTypeForm2.default,{initialValues:workerType,onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(validation,values);}}):workerType?_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath}):_react2.default.createElement(_WorkerTypeForm2.default,{onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(validation,values);}})),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return WorkerTypeContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$workerTypeView=_ref.workerTypeView,workerType=_ref$workerTypeView.active,error=_ref$workerTypeView.error,isDirty=_ref$workerTypeView.isDirty,isFetching=_ref$workerTypeView.isFetching,workerTypes=_ref.workerTypeList.filteredList,form=_ref.form;return{error:error,isDirty:isDirty,isFetching:isFetching,workerType:workerType,workerTypeFormIsValid:(0,_reduxForm.isValid)('workerType')({form:form}),workerTypeFormValues:(0,_reduxForm.getFormValues)('workerType')({form:form}),workerTypes:workerTypes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'workerType'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_workerTypeView.reset)());},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},fetchWorkerType:function fetchWorkerType(id){return dispatch((0,_workerTypeView.fetchWorkerType)(id));},updateWorkerType:function updateWorkerType(id,data){return dispatch((0,_workerTypeView.updateWorkerType)(id,data));},createWorkerType:function createWorkerType(data){return dispatch((0,_workerTypeView.createWorkerType)(data));},clearWorkerType:function clearWorkerType(){return dispatch((0,_workerTypeView.clearWorkerType)());}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(WorkerTypeContainer);

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  onUserChange: Function,
};*/var WorkerTypeForm=function WorkerTypeForm(_ref){var onUserChange=_ref.onUserChange;return _react2.default.createElement('div',{className:'WorkerTypeForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}))));};exports.default=(0,_reduxForm.reduxForm)({form:'workerType',enableReinitialize:true})(WorkerTypeForm);

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _mapValues2=__webpack_require__(66);var _mapValues3=_interopRequireDefault(_mapValues2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _projectView=__webpack_require__(234);var _form=__webpack_require__(17);var _FileDropzone=__webpack_require__(128);var _FileDropzone2=_interopRequireDefault(_FileDropzone);var _RoomTypeImages=__webpack_require__(478);var _RoomTypeImages2=_interopRequireDefault(_RoomTypeImages);var _ProjectForm=__webpack_require__(479);var _ProjectForm2=_interopRequireDefault(_ProjectForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createValidation={name:{rule:'string|required',label:'Namn'},propertyNumber:{rule:'string|required',label:'Fastighetsnummer'},propertyDescription:{rule:'string|required',label:'Fastighetsbeteckning'}};/*:: export type Props = {
  isFetchingRoomTypes: boolean,
  activeRoomType: ?any,
  roomTypes: any[],
  projectFiles: Object,
  projectFileUploads: Object,
  projectFilesUploadIds: Object,
  roomTypeImages: any[],
  roomTypeImageUploads: Object,
  roomTypeImagesUploadIds: Object,
  fetchRoomTypes: Function,
  uploadProjectFile: Function,
  removeProjectFile: Function,
  uploadRoomTypeImage: Function,
  removeRoomTypeImage: Function,
  abortFileUpload: Function,
  abortAllUploads: Function,
  setActiveRoomType: Function,
  isFetching: boolean,
  prevPath: string,
  project: ?any,
  error: ?any,
  projectFormValues: any,
  projectFormIsValid: boolean,
  createProject: Function,
  touch: Function,
  clear: Function,
  resetForm: Function,
  setDirty: Function,
  reset: Function,
  isDirty: boolean,
};*/var _ref=_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,null),_react2.default.createElement('div',{className:'content-title'},'Nytt projekt'))));var _ref2=_react2.default.createElement('div',{className:'column small-6'});var ProjectCreationContainer=function(_Component){_inherits(ProjectCreationContainer,_Component);function ProjectCreationContainer(){_classCallCheck(this,ProjectCreationContainer);return _possibleConstructorReturn(this,(ProjectCreationContainer.__proto__||Object.getPrototypeOf(ProjectCreationContainer)).apply(this,arguments));}_createClass(ProjectCreationContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchRoomTypes();}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.abortAllUploads(this.props.projectFilesUploadIds,this.props.roomTypeImagesUploadIds);this.props.clear();}},{key:'setDirty',value:function setDirty(){var _props=this.props,setDirty=_props.setDirty,isDirty=_props.isDirty;if(!isDirty){setDirty(true);}}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('project');setDirty(false);}},{key:'save',value:function save(){var _props3=this.props,projectFiles=_props3.projectFiles,roomTypeImages=_props3.roomTypeImages,projectFormValues=_props3.projectFormValues,projectFormIsValid=_props3.projectFormIsValid,createProject=_props3.createProject,touch=_props3.touch;var projectFields=(0,_keys3.default)(createValidation);touch.apply(undefined,['project'].concat(_toConsumableArray(projectFields)));if(!projectFormIsValid){return;}var data=_extends({},projectFormValues,projectFiles,{images:roomTypeImages});createProject(data);}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,activeRoomType=_props4.activeRoomType,isFetchingRoomTypes=_props4.isFetchingRoomTypes,roomTypes=_props4.roomTypes,projectFiles=_props4.projectFiles,projectFileUploads=_props4.projectFileUploads,uploadProjectFile=_props4.uploadProjectFile,abortFileUpload=_props4.abortFileUpload,removeProjectFile=_props4.removeProjectFile,setActiveRoomType=_props4.setActiveRoomType,roomTypeImages=_props4.roomTypeImages,roomTypeImageUploads=_props4.roomTypeImageUploads,uploadRoomTypeImage=_props4.uploadRoomTypeImage,removeRoomTypeImage=_props4.removeRoomTypeImage,project=_props4.project,error=_props4.error,isFetching=_props4.isFetching,prevPath=_props4.prevPath,isDirty=_props4.isDirty;return _react2.default.createElement('div',{className:'relative'},_ref,_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching||isFetchingRoomTypes}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column small-6'},_react2.default.createElement(_ProjectForm2.default,{onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(createValidation,values);}}),project&&_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath})),_react2.default.createElement('div',{className:'column small-6'},_react2.default.createElement(_FileDropzone2.default,{label:'Cover image',accept:'image/png, image/jpg, image/jpeg, image/bmp',preview:true,file:projectFiles.coverImage,upload:projectFileUploads.coverImage,onUpload:function onUpload(f){return uploadProjectFile('coverImage',f);},onUploadAbort:function onUploadAbort(u){return abortFileUpload(u.tempId);},onRemove:function onRemove(){return removeProjectFile('coverImage');},onChange:function onChange(){return _this2.setDirty();}}),_react2.default.createElement(_FileDropzone2.default,{label:'Broschyr',file:projectFiles.brochure,upload:projectFileUploads.brochure,onUpload:function onUpload(f){return uploadProjectFile('brochure',f);},onUploadAbort:function onUploadAbort(u){return abortFileUpload(u.tempId);},onRemove:function onRemove(){return removeProjectFile('brochure');},onChange:function onChange(){return _this2.setDirty();}})))),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'row'},_ref2,_react2.default.createElement('div',{className:'column small-6'},_react2.default.createElement(_RoomTypeImages2.default,{activeRoomType:activeRoomType,roomTypes:roomTypes,images:roomTypeImages,uploads:roomTypeImageUploads,onRoomTypeSelect:function onRoomTypeSelect(r){return setActiveRoomType(r);},onUploadAbort:function onUploadAbort(u){return abortFileUpload(u.tempId);},onUpload:function onUpload(f){_this2.setDirty();if(!!activeRoomType){uploadRoomTypeImage(activeRoomType.id,f);}},onRemove:function onRemove(i){_this2.setDirty();removeRoomTypeImage(i.id);}})))),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return ProjectCreationContainer;}(_react.Component);var getProjectFileUploads=function getProjectFileUploads(uploadIds,files){return(0,_mapValues3.default)(function(id){return files.byId[id];},uploadIds)||{};};var getRoomTypeImagesUploads=function getRoomTypeImagesUploads(uploadIds,files){return(0,_mapValues3.default)((0,_map3.default)(function(u){return files.byId[u];}),uploadIds)||{};};var mapStateToProps=function mapStateToProps(_ref3){var _ref3$projectView=_ref3.projectView,_ref3$projectView$pro=_ref3$projectView.project,projectFiles=_ref3$projectView$pro.files,roomTypeImages=_ref3$projectView$pro.roomTypeImages,project=_ref3$projectView$pro.active,error=_ref3$projectView$pro.error,isFetching=_ref3$projectView$pro.isFetching,_ref3$projectView$roo=_ref3$projectView.roomTypes,roomTypes=_ref3$projectView$roo.list,isFetchingRoomTypes=_ref3$projectView$roo.isFetching,activeRoomType=_ref3$projectView.roomType.active,_ref3$projectView$upl=_ref3$projectView.uploadIds,projectFilesUploadIds=_ref3$projectView$upl.projectFiles,roomTypeImagesUploadIds=_ref3$projectView$upl.roomTypeImages,isDirty=_ref3$projectView.isDirty,files=_ref3.files,form=_ref3.form;return{project:project,error:error,isFetching:isFetching,isFetchingRoomTypes:isFetchingRoomTypes,roomTypes:roomTypes,projectFiles:projectFiles,projectFilesUploadIds:projectFilesUploadIds,activeRoomType:activeRoomType,roomTypeImages:roomTypeImages,roomTypeImagesUploadIds:roomTypeImagesUploadIds,roomTypeImageUploads:getRoomTypeImagesUploads(roomTypeImagesUploadIds,files),projectFileUploads:getProjectFileUploads(projectFilesUploadIds,files),projectFormIsValid:(0,_reduxForm.isValid)('project')({form:form}),projectFormValues:(0,_reduxForm.getFormValues)('project')({form:form}),isDirty:isDirty};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchRoomTypes:function fetchRoomTypes(){return dispatch((0,_projectView.fetchRoomTypes)());},removeProjectFile:function removeProjectFile(name){return dispatch((0,_projectView.removeProjectFile)(name));},abortFileUpload:function abortFileUpload(tempId){return dispatch((0,_projectView.abortFileUpload)(tempId));},abortAllUploads:function abortAllUploads(uploads,roomTypeImageUploads){return dispatch((0,_projectView.abortAllUploads)(uploads,roomTypeImageUploads));},uploadProjectFile:function uploadProjectFile(name,_ref4){var _ref5=_toArray(_ref4),file=_ref5[0],rest=_ref5.slice(1);if(file){dispatch((0,_projectView.uploadProjectFile)(name,file));}},uploadRoomTypeImage:function uploadRoomTypeImage(roomTypeId,_ref6){var _ref7=_toArray(_ref6),file=_ref7[0],rest=_ref7.slice(1);if(file){dispatch((0,_projectView.uploadRoomTypeImage)(roomTypeId,file));}},removeRoomTypeImage:function removeRoomTypeImage(fileId){return dispatch((0,_projectView.removeRoomTypeImage)(fileId));},setActiveRoomType:function setActiveRoomType(roomType){return dispatch((0,_projectView.setActiveRoomType)(roomType));},createProject:function createProject(data){return dispatch((0,_projectView.createProject)(data));},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},clear:function clear(){return dispatch((0,_projectView.clear)());},setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'project'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_projectView.reset)());}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ProjectCreationContainer);

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDropzone=__webpack_require__(257);var _reactDropzone2=_interopRequireDefault(_reactDropzone);var _FileUpload=__webpack_require__(458);var _FileUpload2=_interopRequireDefault(_FileUpload);__webpack_require__(1145);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fileUrl=_request.apiBase+'/files';/*:: export type Props = {
  images: any[],
  uploads: any[],
  onUpload: Function,
  onRemove: Function,
  onUploadAbort: Function,
};*/var _ref=_react2.default.createElement('i',{className:'fa fa-trash'});var ImagesDropzone=function(_Component){_inherits(ImagesDropzone,_Component);function ImagesDropzone(){_classCallCheck(this,ImagesDropzone);return _possibleConstructorReturn(this,(ImagesDropzone.__proto__||Object.getPrototypeOf(ImagesDropzone)).apply(this,arguments));}_createClass(ImagesDropzone,[{key:'openDropzone',value:function openDropzone(){if(this._dropzone){this._dropzone.open();}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,images=_props.images,uploads=_props.uploads,onUpload=_props.onUpload,onRemove=_props.onRemove,onUploadAbort=_props.onUploadAbort;return _react2.default.createElement('div',{className:'ImagesDropzone'},_react2.default.createElement(_reactDropzone2.default,{onDrop:function onDrop(files){return onUpload(files);},disableClick:true,multiple:false,accept:'image/*',ref:function ref(_ref2){return _this2._dropzone=_ref2;},className:'zone'},(0,_map3.default)(function(image){return _react2.default.createElement('div',{key:image.id,className:'image'},_react2.default.createElement('div',{className:'row no-row-margins align-middle expand'},_react2.default.createElement('div',{className:'image-thumb column shrink'},_react2.default.createElement('img',{src:fileUrl+'/preview/'+image.id+'/100x100',alt:image.name})),_react2.default.createElement('a',{href:fileUrl+'/'+image.id+'?download',target:'_blank',className:'file-name column text-truncate'},image.name+image.extension),_react2.default.createElement('button',{onClick:function onClick(){return onRemove(image);},type:'button',className:'button column shrink'},_ref)));},images),(0,_map3.default)(function(upload){return upload.progress<100&&_react2.default.createElement(_FileUpload2.default,{key:upload.id,upload:upload,onUploadAbort:function(_onUploadAbort){function onUploadAbort(){return _onUploadAbort.apply(this,arguments);}onUploadAbort.toString=function(){return _onUploadAbort.toString();};return onUploadAbort;}(function(){return onUploadAbort(upload);})});},uploads)),_react2.default.createElement('button',{onClick:function onClick(){return _this2.openDropzone();},type:'button',className:'button expanded'},'Ladda upp ny bild'));}}]);return ImagesDropzone;}(_react.Component);exports.default=ImagesDropzone;

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _mapValues2=__webpack_require__(66);var _mapValues3=_interopRequireDefault(_mapValues2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(1147);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _reduxForm=__webpack_require__(4);var _projectView=__webpack_require__(234);var _form=__webpack_require__(17);var _FileDropzone=__webpack_require__(128);var _FileDropzone2=_interopRequireDefault(_FileDropzone);var _ProjectForm=__webpack_require__(479);var _ProjectForm2=_interopRequireDefault(_ProjectForm);var _ProjectProductsForm=__webpack_require__(1148);var _ProjectProductsForm2=_interopRequireDefault(_ProjectProductsForm);var _ApartmentConfigList=__webpack_require__(1149);var _ApartmentConfigList2=_interopRequireDefault(_ApartmentConfigList);var _RoomTypeImages=__webpack_require__(478);var _RoomTypeImages2=_interopRequireDefault(_RoomTypeImages);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var apartmentColumns=[{property:'objectId',header:{label:'Lägenhetsnummer'}},{property:'area',header:{label:'Yta'}},{property:'address',header:{label:'Adress'}}];var projectValidation={name:{rule:'string|required',label:'Namn'},propertyNumber:{rule:'string|required',label:'Fastighetsnummer'},propertyDescription:{rule:'string|required',label:'Fastighetsbeteckning'},description:{rule:'string',label:'Beskrivning'}};/*:: export type Props = {
  history: Object,
  project: ?any,
  apartments: ?any[],
  apartmentConfigurations: any[],
  demoApartmentConfig: Object,
  activeRoomType: ?any,
  projectFormValues: any,
  projectFormIsValid: boolean,
  projectProductsFormValues: any,
  products: any[],
  roomTypes: any[],
  projectFiles: Object,
  projectFileUploads: Object,
  projectFilesUploadIds: Object,
  roomTypeImages: any[],
  roomTypeImageUploads: Object,
  roomTypeImagesUploadIds: Object,
  isFetching: boolean,
  isFetchingRoomTypes: boolean,
  isFetchingProducts: boolean,
  params: any,
  error: ?any,
  prevPath: string,
  query: ?string,
  fetchData: (id: number) => any,
  updateProject: typeof updateProject,
  uploadProjectFile: typeof uploadProjectFile,
  removeProjectFile: typeof removeProjectFile,
  uploadRoomTypeImage: typeof uploadRoomTypeImage,
  removeRoomTypeImage: typeof removeRoomTypeImage,
  abortFileUpload: typeof abortFileUpload,
  abortAllUploads: typeof abortAllUploads,
  filterApartments: typeof filterApartments,
  setActiveRoomType: typeof setActiveRoomType,
  touch: typeof touch,
  clear: typeof clear,
  resetForm: typeof resetForm,
  setDirty: (dirty: boolean) => any,
  reset: typeof reset,
  isDirty: boolean,
  sendActivationLinks: typeof sendActivationLinks,
  projects: any[],
  filteredApartments: any[],
  sortItems: typeof sortItems,
  notifyLinkCopied: () => any,
};*/var _ref=_react2.default.createElement('hr',null);var _ref2=_react2.default.createElement('hr',null);var _ref3=_react2.default.createElement('label',null,'L\xE4genheter');var ProjectEditingContainer=function(_Component){_inherits(ProjectEditingContainer,_Component);function ProjectEditingContainer(){_classCallCheck(this,ProjectEditingContainer);return _possibleConstructorReturn(this,(ProjectEditingContainer.__proto__||Object.getPrototypeOf(ProjectEditingContainer)).apply(this,arguments));}_createClass(ProjectEditingContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData(this.props.params.id);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var _props=this.props,projectFilesUploadIds=_props.projectFilesUploadIds,roomTypeImagesUploadIds=_props.roomTypeImagesUploadIds,abortAllUploads=_props.abortAllUploads,clear=_props.clear;abortAllUploads(projectFilesUploadIds,roomTypeImagesUploadIds);clear();}},{key:'setDirty',value:function setDirty(){var _props2=this.props,setDirty=_props2.setDirty,isDirty=_props2.isDirty;if(!isDirty){setDirty(true);}}},{key:'reset',value:function reset(){var _props3=this.props,setDirty=_props3.setDirty,reset=_props3.reset,resetForm=_props3.resetForm;reset();resetForm('project');resetForm('projectProducts');setDirty(false);}},{key:'save',value:function save(){var _props4=this.props,project=_props4.project,projectFormValues=_props4.projectFormValues,projectFormIsValid=_props4.projectFormIsValid,projectProductsFormValues=_props4.projectProductsFormValues,updateProject=_props4.updateProject,projectFiles=_props4.projectFiles,roomTypeImages=_props4.roomTypeImages,touch=_props4.touch;var projectFields=(0,_keys3.default)(projectValidation);touch.apply(undefined,['project'].concat(_toConsumableArray(projectFields)));if(!projectFormIsValid){return;}var data=_extends({},projectFormValues,projectFiles,{images:roomTypeImages});if(projectProductsFormValues){data.blacklistedProducts=projectProductsFormValues.blacklistedProducts;}if(!!project){updateProject(project.id,data);}}},{key:'render',value:function render(){var _this2=this;var _props5=this.props,history=_props5.history,id=_props5.params.id,prevPath=_props5.prevPath,query=_props5.query,project=_props5.project,apartments=_props5.apartments,activeRoomType=_props5.activeRoomType,error=_props5.error,isFetching=_props5.isFetching,isFetchingRoomTypes=_props5.isFetchingRoomTypes,isFetchingProducts=_props5.isFetchingProducts,updateProject=_props5.updateProject,products=_props5.products,apartmentConfigurations=_props5.apartmentConfigurations,demoApartmentConfig=_props5.demoApartmentConfig,roomTypes=_props5.roomTypes,projectFiles=_props5.projectFiles,projectFileUploads=_props5.projectFileUploads,uploadProjectFile=_props5.uploadProjectFile,abortFileUpload=_props5.abortFileUpload,removeProjectFile=_props5.removeProjectFile,filterApartments=_props5.filterApartments,setActiveRoomType=_props5.setActiveRoomType,roomTypeImages=_props5.roomTypeImages,roomTypeImageUploads=_props5.roomTypeImageUploads,uploadRoomTypeImage=_props5.uploadRoomTypeImage,removeRoomTypeImage=_props5.removeRoomTypeImage,isDirty=_props5.isDirty,sendActivationLinks=_props5.sendActivationLinks,projects=_props5.projects,clear=_props5.clear,fetchData=_props5.fetchData,sortItems=_props5.sortItems,filteredApartments=_props5.filteredApartments,notifyLinkCopied=_props5.notifyLinkCopied;return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:project,list:projects,prevPath:prevPath,clear:clear,fetchData:fetchData}),_react2.default.createElement('div',{className:'content-title'},project&&project.name))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},project&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},!!apartments&&!!apartments.length&&_react2.default.createElement(_ActionConfirmation2.default,{id:'sendActivationLinks',className:'button',message:'\xC4r du s\xE4ker p\xE5 att du vill skicka aktiveringsl\xE4nkar till alla anv\xE4ndare som inte \xE4nnu f\xE5tt en?',buttonText:'Skicka aktiveringsl\xE4nkar',action:function action(){return sendActivationLinks(project.id);}}),_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveProject',className:'secondary button',message:'Vill du verkligen '+(project.archived?'av':'')+'arkivera det h\xE4r projektet?',buttonText:project.archived?'Avarkivera':'Arkivera',action:function action(){return updateProject(project.id,{archived:!project.archived});}}))))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching||isFetchingRoomTypes||isFetchingProducts}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column small-6'},_react2.default.createElement(_ProjectForm2.default,{initialValues:project,onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(projectValidation,values);}})),_react2.default.createElement('div',{className:'column small-6'},_react2.default.createElement(_FileDropzone2.default,{label:'Cover image',accept:'image/png, image/jpg, image/jpeg, image/bmp',preview:true,file:projectFiles.coverImage,upload:projectFileUploads.coverImage,onUpload:function onUpload(f){return uploadProjectFile('coverImage',f);},onUploadAbort:function onUploadAbort(u){return abortFileUpload(u.tempId);},onRemove:function onRemove(){return removeProjectFile('coverImage');},onChange:function onChange(){return _this2.setDirty();}}),_react2.default.createElement(_FileDropzone2.default,{label:'Broschyr',file:projectFiles.brochure,upload:projectFileUploads.brochure,onUpload:function onUpload(f){return uploadProjectFile('brochure',f);},onUploadAbort:function onUploadAbort(u){return abortFileUpload(u.tempId);},onRemove:function onRemove(){return removeProjectFile('brochure');},onChange:function onChange(){return _this2.setDirty();}}),_ref,_react2.default.createElement('button',{type:'button',onClick:function onClick(){return history.push(prevPath+'/'+id+'/apartmentconfigurations/'+demoApartmentConfig.id);},className:'button w-100'},'\xD6ppna demokonfiguration'),project&&_react2.default.createElement('div',{className:'demoContainer'},_react2.default.createElement('input',{id:'demo-url',type:'text',readOnly:true,value:location.origin+'/demo/'+project.demoPath}),_react2.default.createElement('button',{type:'button',className:'demo-url-text button',onClick:function onClick(){/* Get the text field */var copyText=document.getElementById('demo-url');/* Select the text field */copyText.select();copyText.setSelectionRange(0,99999);/*For mobile devices*//* Copy the text inside the text field */document.execCommand('copy');/* Unfocus the text box when we are done */copyText.blur();/* Alert the copied text */// alert(`Copied the text: ${copyText.value}`);
notifyLinkCopied();}},'Kopiera'))))),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column small-6'},_react2.default.createElement(_ApartmentConfigList2.default,{list:apartmentConfigurations,onSelectItem:function onSelectItem(c){return history.push(prevPath+'/'+id+'/apartmentconfigurations/'+c.id);}}),_ref2,_react2.default.createElement('button',{onClick:function onClick(){return history.push(prevPath+'/'+id+'/apartmentconfigurations/new');},type:'button',className:'button small expanded'},'Skapa ny')),_react2.default.createElement('div',{className:'column small-6'},_react2.default.createElement(_RoomTypeImages2.default,{activeRoomType:activeRoomType,roomTypes:roomTypes,images:roomTypeImages,uploads:roomTypeImageUploads,onRoomTypeSelect:function onRoomTypeSelect(r){return setActiveRoomType(r);},onUploadAbort:function onUploadAbort(u){return abortFileUpload(u.tempId);},onUpload:function onUpload(f){_this2.setDirty();if(!!activeRoomType){uploadRoomTypeImage(activeRoomType.id,f);}},onRemove:function onRemove(i){_this2.setDirty();removeRoomTypeImage(i.id);}})))),_react2.default.createElement('div',{className:'content-section box'},_ref3,_react2.default.createElement('div',{className:'row align-middle'},apartments&&!!apartments.length&&_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:query||'',onClear:function onClear(e){return filterApartments('');},onChange:function onChange(e){return filterApartments(e.target.value);}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(prevPath+'/'+id+'/apartments/new');}},'Skapa ny'))),apartments&&!!apartments.length&&_react2.default.createElement(_AdminList2.default,{onRowSelected:function onRowSelected(row){return history.push(prevPath+'/'+id+'/apartments/'+row.id);},onSort:sortItems,columns:apartmentColumns,rows:filteredApartments})),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column small-12'},_react2.default.createElement(_ProjectProductsForm2.default,{products:products,onUserChange:function onUserChange(){return _this2.setDirty();},initialValues:project})))),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return ProjectEditingContainer;}(_react.Component);var getProjectFileUploads=function getProjectFileUploads(uploadIds,files){return(0,_mapValues3.default)(function(id){return files.byId[id];},uploadIds)||{};};var getRoomTypeImagesUploads=function getRoomTypeImagesUploads(uploadIds,files){return(0,_mapValues3.default)((0,_map3.default)(function(u){return files.byId[u];}),uploadIds)||{};};var mapStateToProps=function mapStateToProps(_ref4){var _ref4$projectView=_ref4.projectView,_ref4$projectView$pro=_ref4$projectView.project,project=_ref4$projectView$pro.active,error=_ref4$projectView$pro.error,isFetching=_ref4$projectView$pro.isFetching,apartments=_ref4$projectView$pro.apartments,apartmentConfigurations=_ref4$projectView$pro.apartmentConfigurations,projectFiles=_ref4$projectView$pro.files,roomTypeImages=_ref4$projectView$pro.roomTypeImages,_ref4$projectView$pro2=_ref4$projectView.products,products=_ref4$projectView$pro2.list,isFetchingProducts=_ref4$projectView$pro2.isFetching,roomTypes=_ref4$projectView.filteredRoomTypes,isFetchingRoomTypes=_ref4$projectView.roomTypes.isFetching,activeRoomType=_ref4$projectView.roomType.active,_ref4$projectView$upl=_ref4$projectView.uploadIds,projectFilesUploadIds=_ref4$projectView$upl.projectFiles,roomTypeImagesUploadIds=_ref4$projectView$upl.roomTypeImages,query=_ref4$projectView.apartmentsFilter.query,isDirty=_ref4$projectView.isDirty,filteredApartments=_ref4$projectView.filteredApartments,projects=_ref4.projectList.filteredList,form=_ref4.form,files=_ref4.files;return{project:project,error:error,isFetching:isFetching,isFetchingRoomTypes:isFetchingRoomTypes,isFetchingProducts:isFetchingProducts,apartments:apartments,apartmentConfigurations:(0,_filter3.default)({'demo':false},apartmentConfigurations),demoApartmentConfig:(0,_find3.default)('demo',apartmentConfigurations),products:products,roomTypes:roomTypes,projectFiles:projectFiles,projectFilesUploadIds:projectFilesUploadIds,activeRoomType:activeRoomType,roomTypeImages:roomTypeImages,roomTypeImagesUploadIds:roomTypeImagesUploadIds,query:query,roomTypeImageUploads:getRoomTypeImagesUploads(roomTypeImagesUploadIds,files),projectFileUploads:getProjectFileUploads(projectFilesUploadIds,files),projectFormIsValid:(0,_reduxForm.isValid)('project')({form:form}),projectFormValues:(0,_reduxForm.getFormValues)('project')({form:form}),projectProductsFormValues:(0,_reduxForm.getFormValues)('projectProducts')({form:form}),isDirty:isDirty,projects:projects,filteredApartments:(0,_filter3.default)({'demo':false},filteredApartments)};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchData:function fetchData(id){dispatch((0,_projectView.fetchProducts)());dispatch((0,_projectView.fetchRoomTypes)());if(id){dispatch((0,_projectView.fetchProject)(id));}},updateProject:function updateProject(id,data){return dispatch((0,_projectView.updateProject)(id,data));},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},removeProjectFile:function removeProjectFile(name){return dispatch((0,_projectView.removeProjectFile)(name));},abortFileUpload:function abortFileUpload(tempId){return dispatch((0,_projectView.abortFileUpload)(tempId));},abortAllUploads:function abortAllUploads(uploads,roomTypeImageUploads){return dispatch((0,_projectView.abortAllUploads)(uploads,roomTypeImageUploads));},uploadProjectFile:function uploadProjectFile(name,_ref5){var _ref6=_toArray(_ref5),file=_ref6[0],rest=_ref6.slice(1);if(file){dispatch((0,_projectView.uploadProjectFile)(name,file));}},uploadRoomTypeImage:function uploadRoomTypeImage(roomTypeId,_ref7){var _ref8=_toArray(_ref7),file=_ref8[0],rest=_ref8.slice(1);if(file){dispatch((0,_projectView.uploadRoomTypeImage)(roomTypeId,file));}},removeRoomTypeImage:function removeRoomTypeImage(fileId){return dispatch((0,_projectView.removeRoomTypeImage)(fileId));},filterApartments:function filterApartments(query){return dispatch((0,_projectView.filterApartments)(query));},setActiveRoomType:function setActiveRoomType(roomType){return dispatch((0,_projectView.setActiveRoomType)(roomType));},clear:function clear(){return dispatch((0,_projectView.clear)());},setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'project'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_projectView.reset)());},sendActivationLinks:function sendActivationLinks(projectId/*: number*/){return dispatch((0,_projectView.sendActivationLinks)(projectId));},sortItems:function sortItems(sorter){return dispatch((0,_projectView.sortItems)(sorter));},notifyLinkCopied:function notifyLinkCopied(){return dispatch((0,_projectView.notifyLinkCopied)());}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ProjectEditingContainer));

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  products: any[],
  onUserChange: Function,
};*/var ProjectProductsForm=function ProjectProductsForm(_ref){var products=_ref.products,onUserChange=_ref.onUserChange;return _react2.default.createElement('div',{className:'ProjectProductsForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_reduxForm.Field,{name:'blacklistedProducts',label:'Otill\xE5tna produkter',onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:products,multi:true})))));};exports.default=(0,_reduxForm.reduxForm)({form:'projectProducts',enableReinitialize:true})(ProjectProductsForm);

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1150);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  list: any[],
  onSelectItem: Function,
};*/var _ref2=_react2.default.createElement('label',null,'L\xE4genhetskonfigurationer');var _ref3=_react2.default.createElement('div',{className:'empty-item'},'Inga konfigurationer');var ApartmentConfigList=function ApartmentConfigList(_ref){var list=_ref.list,onSelectItem=_ref.onSelectItem;return _react2.default.createElement('div',{className:'ApartmentConfigList'},_ref2,_react2.default.createElement('div',{className:'list'},(!list||!list.length)&&_ref3,!!(list&&list.length)&&(0,_map3.default)(function(d){return _react2.default.createElement('div',{key:d.id,className:'row no-row-margins item'},_react2.default.createElement('button',{onClick:function onClick(){return onSelectItem(d);},type:'button',className:'button column item-label'},d.name));},list)));};exports.default=ApartmentConfigList;

/***/ }),
/* 1150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _ImportProjectsDialogContainer=__webpack_require__(1152);var _ImportProjectsDialogContainer2=_interopRequireDefault(_ImportProjectsDialogContainer);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _projectList=__webpack_require__(228);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=[{property:'name',header:{label:'Namn'}},{property:'propertyNumber',header:{label:'Fastighetsnummer'}},{property:'apartments.length',header:{label:'Lägenheter'}}];/*:: export type Props = {
  history: Object,
  fetchProjects: typeof fetchProjects,
  filterProjects: typeof filterProjects,
  toggleImportDialog: typeof toggleImportDialog,
  isFetching: boolean,
  location: { pathname: string },
  filter: {
    archived: boolean,
    query?: string,
  },
  projects?: any[],
  sortItems: typeof sortItems,
};*/var _ref=_react2.default.createElement(_ImportProjectsDialogContainer2.default,null);var ProjectsContainer=function(_Component){_inherits(ProjectsContainer,_Component);function ProjectsContainer(){_classCallCheck(this,ProjectsContainer);return _possibleConstructorReturn(this,(ProjectsContainer.__proto__||Object.getPrototypeOf(ProjectsContainer)).apply(this,arguments));}_createClass(ProjectsContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchProjects();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,filter=_props.filter,projects=_props.projects,filterProjects=_props.filterProjects,toggleImportDialog=_props.toggleImportDialog,pathname=_props.location.pathname,isFetching=_props.isFetching,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'ProjectsContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:function onClear(e){return filterProjects(_extends({},filter,{query:''}));},onChange:function onChange(e){return filterProjects(_extends({},filter,{query:e.target.value}));}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa nytt')),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'success button',onClick:function onClick(){return toggleImportDialog(true);}},'Importera'),_ref)),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:function onChange(archived){return filterProjects(_extends({},filter,{archived:archived?archived.value:false}));}},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),projects&&_react2.default.createElement('div',{className:'box'},_react2.default.createElement(_AdminList2.default,{columns:columns,rows:projects,onSort:sortItems,onRowSelected:function onRowSelected(row){return history.push(pathname+'/'+row.id);}}))));}}]);return ProjectsContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var _ref2$projectList=_ref2.projectList,projects=_ref2$projectList.filteredList,filter=_ref2$projectList.filter,isFetching=_ref2$projectList.isFetching;return{filter:filter,projects:projects,isFetching:isFetching};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{toggleImportDialog:function toggleImportDialog(show){return dispatch((0,_projectList.toggleImportDialog)(show));},fetchProjects:function fetchProjects(){return dispatch((0,_projectList.fetchProjects)());},filterProjects:function filterProjects(filter){return dispatch((0,_projectList.filterProjects)(filter));},sortItems:function sortItems(sorter){return dispatch((0,_projectList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ProjectsContainer));

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _projectList=__webpack_require__(228);var _FileDropzone=__webpack_require__(128);var _FileDropzone2=_interopRequireDefault(_FileDropzone);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);__webpack_require__(1153);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  abortUpload: Function,
  error: ?any,
  importProjects: Function,
  isFetching: boolean,
  removeFile: Function,
  show: boolean,
  tempFile: ?any,
  tempUploadId: ?string,
  toggleImportDialog: Function,
  uploadedFile: ?any,
  uploadFile: Function,
};*/var _ref=_react2.default.createElement('div',{className:'update-comment'},'H\xE4r kan du importera nya projekt samt uppdatera existerande.',_react2.default.createElement('br',null),'Vid import av existerande projekt uppdateras detta med nya anv\xE4ndare.');var ImportProjectsDialogContainer=function(_Component){_inherits(ImportProjectsDialogContainer,_Component);function ImportProjectsDialogContainer(){_classCallCheck(this,ImportProjectsDialogContainer);return _possibleConstructorReturn(this,(ImportProjectsDialogContainer.__proto__||Object.getPrototypeOf(ImportProjectsDialogContainer)).apply(this,arguments));}_createClass(ImportProjectsDialogContainer,[{key:'onCloseDialog',value:function onCloseDialog(){this.props.toggleImportDialog(false);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,error=_props.error,importProjects=_props.importProjects,isFetching=_props.isFetching,removeFile=_props.removeFile,show=_props.show,tempFile=_props.tempFile,tempUploadId=_props.tempUploadId,abortUpload=_props.abortUpload,uploadedFile=_props.uploadedFile,uploadFile=_props.uploadFile;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:function onClose(){return _this2.onCloseDialog();},show:show},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row ImportProjectsDialogContainer'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_FileDropzone2.default,{label:'Excelfil',accept:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',file:uploadedFile,upload:tempFile,onRemove:function onRemove(){return removeFile();},onUpload:function onUpload(f){return uploadFile(f);},onUploadAbort:function onUploadAbort(){return abortUpload(tempUploadId);}}),_ref,uploadedFile&&_react2.default.createElement('button',{type:'button',className:'success expanded button',onClick:function onClick(){return importProjects(uploadedFile);}},'Importera'),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:function onClick(){return _this2.onCloseDialog();}},'St\xE4ng')))));}}]);return ImportProjectsDialogContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var _ref2$projectList$imp=_ref2.projectList.imported,error=_ref2$projectList$imp.error,isFetching=_ref2$projectList$imp.isFetching,show=_ref2$projectList$imp.show,tempUploadId=_ref2$projectList$imp.tempUploadId,uploadedFile=_ref2$projectList$imp.uploadedFile,byId=_ref2.files.byId;return{error:error,isFetching:isFetching,show:show,tempUploadId:tempUploadId,tempFile:tempUploadId?byId[tempUploadId]:null,uploadedFile:uploadedFile};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{abortUpload:function abortUpload(tempId){return dispatch((0,_projectList.abortUpload)(tempId));},importProjects:function importProjects(file){if(file){dispatch((0,_projectList.importProjects)(file));}},removeFile:function removeFile(){return dispatch((0,_projectList.removeFile)());},toggleImportDialog:function toggleImportDialog(show){return dispatch((0,_projectList.toggleImportDialog)(show));},uploadFile:function uploadFile(_ref3){var _ref4=_toArray(_ref3),file=_ref4[0],rest=_ref4.slice(1);if(file){dispatch((0,_projectList.uploadFile)(file));}}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ImportProjectsDialogContainer);

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _productTypeList=__webpack_require__(377);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=[{property:'name',header:{label:'Namn'}}];/*:: export type Props = {
  history: Object,
  fetchProductTypes: Function,
  filterProductTypes: Function,
  location: { pathname: string },
  filter: {
    archived: boolean,
    query?: string,
  },
  productTypes: any[],
  isFetching: boolean,
  sortItems: typeof sortItems,
};*/var ProductTypesContainer=function(_Component){_inherits(ProductTypesContainer,_Component);function ProductTypesContainer(){_classCallCheck(this,ProductTypesContainer);return _possibleConstructorReturn(this,(ProductTypesContainer.__proto__||Object.getPrototypeOf(ProductTypesContainer)).apply(this,arguments));}_createClass(ProductTypesContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchProductTypes();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,filter=_props.filter,productTypes=_props.productTypes,filterProductTypes=_props.filterProductTypes,pathname=_props.location.pathname,isFetching=_props.isFetching,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'ProductTypesContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:function onClear(e){return filterProductTypes('',filter.archived);},onChange:function onChange(e){return filterProductTypes(e.target.value,filter.archived);}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa ny'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:function onChange(archived){return filterProductTypes(filter.query,archived?archived.value:false);}},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),productTypes&&_react2.default.createElement('div',{className:'box'},_react2.default.createElement(_AdminList2.default,{query:filter.query,columns:columns,rows:productTypes,onSort:sortItems,onRowSelected:function onRowSelected(row){return history.push(pathname+'/'+row.id);}}))));}}]);return ProductTypesContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$productTypeList=_ref.productTypeList,filter=_ref$productTypeList.filter,isFetching=_ref$productTypeList.isFetching,productTypes=_ref$productTypeList.filteredList;return{filter:filter,productTypes:productTypes,isFetching:isFetching};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchProductTypes:function fetchProductTypes(){return dispatch((0,_productTypeList.fetchProductTypes)());},filterProductTypes:function filterProductTypes(query,archived){return dispatch((0,_productTypeList.filterProductTypes)(query,archived));},sortItems:function sortItems(sorter){return dispatch((0,_productTypeList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ProductTypesContainer));

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _productTypeView=__webpack_require__(376);var _reduxForm=__webpack_require__(4);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _ProductTypeForm=__webpack_require__(1156);var _ProductTypeForm2=_interopRequireDefault(_ProductTypeForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createValidation={name:{rule:'string|required',label:'Namn'}};var editValidation={name:{rule:'string|required',label:'Namn'},archived:{rule:'archivable',label:'Arkiverad'}};/*:: export type Props = {
  setDirty: Function,
  reset: Function,
  touch: Function,
  resetForm: Function,
  productTypeFormValues: any,
  productTypeFormIsValid: boolean,
  isDirty: boolean,
  fetchProductType: Function,
  updateProductType: Function,
  createProductType: Function,
  clearProductType: Function,
  isFetching: boolean,
  prevPath: string,
  productType: ?any,
  params: any,
  error: ?any,
  productTypes: any[],
};*/var ProductTypeContainer=function(_Component){_inherits(ProductTypeContainer,_Component);function ProductTypeContainer(){_classCallCheck(this,ProductTypeContainer);return _possibleConstructorReturn(this,(ProductTypeContainer.__proto__||Object.getPrototypeOf(ProductTypeContainer)).apply(this,arguments));}_createClass(ProductTypeContainer,[{key:'componentWillMount',value:function componentWillMount(){var id=this.props.params.id;if(id){this.props.fetchProductType(id);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clearProductType();}},{key:'setDirty',value:function setDirty(){var _props=this.props,setDirty=_props.setDirty,isDirty=_props.isDirty;if(!isDirty){setDirty(true);}}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('productType');setDirty(false);}},{key:'save',value:function save(){var _props3=this.props,productTypeFormValues=_props3.productTypeFormValues,touch=_props3.touch,productTypeFormIsValid=_props3.productTypeFormIsValid,productType=_props3.productType,updateProductType=_props3.updateProductType,createProductType=_props3.createProductType;var create=!productType;var productTypeKeys=(0,_keys3.default)(create?createProductType:updateProductType);touch.apply(undefined,['productType'].concat(_toConsumableArray(productTypeKeys)));if(!productTypeFormIsValid){return;}if(!productType){createProductType(productTypeFormValues);}else{updateProductType(productType.id,productTypeFormValues);}}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,isDirty=_props4.isDirty,id=_props4.params.id,productType=_props4.productType,error=_props4.error,isFetching=_props4.isFetching,updateProductType=_props4.updateProductType,prevPath=_props4.prevPath,clearProductType=_props4.clearProductType,fetchProductType=_props4.fetchProductType,productTypes=_props4.productTypes;return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:productType,list:productTypes,prevPath:prevPath,clear:clearProductType,fetchData:fetchProductType}),_react2.default.createElement('div',{className:'content-title'},productType&&productType.name||'Ny produkttyp'))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},productType&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveProductType',className:'secondary button',message:'Vill du verkligen '+(productType.archived?'av':'')+'arkivera den h\xE4r produkttypen?',buttonText:productType.archived?'Avarkivera':'Arkivera',action:function action(){return updateProductType(productType.id,{archived:!productType.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},id?_react2.default.createElement(_ProductTypeForm2.default,{initialValues:productType,onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(editValidation,values);}}):productType?_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath}):_react2.default.createElement(_ProductTypeForm2.default,{onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(createValidation,values);}})),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return ProductTypeContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$productTypeView=_ref.productTypeView,productType=_ref$productTypeView.active,error=_ref$productTypeView.error,isDirty=_ref$productTypeView.isDirty,isFetching=_ref$productTypeView.isFetching,productTypes=_ref.productTypeList.filteredList,form=_ref.form;return{error:error,isDirty:isDirty,isFetching:isFetching,productType:productType,productTypeFormIsValid:(0,_reduxForm.isValid)('productType')({form:form}),productTypeFormValues:(0,_reduxForm.getFormValues)('productType')({form:form}),productTypes:productTypes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'productType'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_productTypeView.reset)());},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},fetchProductType:function fetchProductType(id){return dispatch((0,_productTypeView.fetchProductType)(id));},updateProductType:function updateProductType(id,data){return dispatch((0,_productTypeView.updateProductType)(id,data));},createProductType:function createProductType(data){return dispatch((0,_productTypeView.createProductType)(data));},clearProductType:function clearProductType(){return dispatch((0,_productTypeView.clearProductType)());}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ProductTypeContainer);

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  onUserChange: Function,
};*/var ProductTypeForm=function ProductTypeForm(_ref){var onUserChange=_ref.onUserChange;return _react2.default.createElement('div',{className:'ProductTypeForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}))));};exports.default=(0,_reduxForm.reduxForm)({form:'productType',enableReinitialize:true})(ProductTypeForm);

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _toNumber2=__webpack_require__(84);var _toNumber3=_interopRequireDefault(_toNumber2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _flatMap2=__webpack_require__(54);var _flatMap3=_interopRequireDefault(_flatMap2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _reduxForm=__webpack_require__(4);var _productView=__webpack_require__(169);var _form=__webpack_require__(17);var _ProductForm=__webpack_require__(1158);var _ProductForm2=_interopRequireDefault(_ProductForm);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);var _ProductVariantForm=__webpack_require__(1160);var _ProductVariantForm2=_interopRequireDefault(_ProductVariantForm);var _ProductVariantImages=__webpack_require__(1165);var _ProductVariantImages2=_interopRequireDefault(_ProductVariantImages);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _FormTabs=__webpack_require__(1169);var _FormTabs2=_interopRequireDefault(_FormTabs);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _LinkedAdditionalVariantsContainer=__webpack_require__(1171);var _LinkedAdditionalVariantsContainer2=_interopRequireDefault(_LinkedAdditionalVariantsContainer);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);__webpack_require__(1173);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var productValidation={name:{rule:'string|required',label:'Artikelnamn'},productTypeId:{rule:'numeric|required',label:'Produkttyp'}};var variantValidation={name:{rule:'string|required',label:'Namn'},itemNumber:{rule:'string|required',label:'Artikelnummer'},externalItemNumber:{rule:'string',label:'Externt artikelnummer'},externalDescription:{rule:'string',label:'Extern beskrivning'},internalDescription:{rule:'string',label:'Intern beskrivning'},color:{rule:'string',label:'Färg'},sizeWidth:{rule:'numeric',label:'Bredd'},sizeHeight:{rule:'numeric',label:'Höjd'},sizeDepth:{rule:'numeric',label:'Djup'},buyingPrice:{rule:'numeric',label:'Inköpspris'},sellingPrice:{rule:'numeric|required',label:'Försäljningspris'}};var mapRelated=(0,_flatMap3.default)(function(_ref){var productTypeId=_ref.id,productTypeName=_ref.name,products=_ref.products;return(0,_flatMap3.default)(function(_ref2){var productId=_ref2.id,productName=_ref2.name,variants=_ref2.variants;return(0,_flow3.default)((0,_filter3.default)('selected'),(0,_map3.default)(function(_ref3){var id=_ref3.id,name=_ref3.name;return{id:id,name:name,productId:productId,productName:productName,productTypeId:productTypeId,productTypeName:productTypeName,selected:true};}))(variants);},products);});/*:: export type Props = {
  filteredVariants: any[],
  includeArchived: boolean,
  filterArchived: typeof filterArchived,
  updateProduct: typeof updateProduct,
  createProduct: typeof createProduct,
  setActiveVariant: typeof setActiveVariant,
  setActiveVariantLinkedAdditionalVariant: Function,
  addVariantLinkedAdditionalVariant: typeof addVariantLinkedAdditionalVariant,
  updateVariantLinkedAdditionalVariant: typeof updateVariantLinkedAdditionalVariant,
  removeVariantLinkedAdditionalVariant: typeof removeVariantLinkedAdditionalVariant,
  setActiveProductLinkedAdditionalVariant: Function,
  addProductLinkedAdditionalVariant: typeof addProductLinkedAdditionalVariant,
  updateProductLinkedAdditionalVariant: typeof updateProductLinkedAdditionalVariant,
  removeProductLinkedAdditionalVariant: typeof removeProductLinkedAdditionalVariant,
  activeVariant: ?any,
  variantError: ?any,
  suppliersError: ?any,
  roomTypesError: ?any,
  workerTypesError: ?any,
  productTypesError: ?any,
  variantImage: typeof variantImage,
  setDefaultVariantImage: typeof setDefaultVariantImage,
  images: any[],
  imagesInProgress: any[],
  activeImage: ?any,
  productLinkedAdditionalVariants: any[],
  variantLinkedAdditionalVariants: any[],
  variants: any[],
  roomTypes: any[],
  workerTypes: any[],
  filteredRelatedProductTypes: any[],
  filteredProductTypes: any[],
  relatedProductType: ?{ id: number },
  setRelatedProductType: typeof setRelatedProductType,
  addRelatedProductType: typeof addRelatedProductType,
  isFetching: boolean,
  productIsDirty: boolean,
  variantIsDirty: boolean,
  variantIsFetching: boolean,
  suppliersIsFetching: boolean,
  roomTypesIsFetching: boolean,
  workerTypesIsFetching: boolean,
  productTypesIsFetching: boolean,
  resourcePath: string,
  fetchData: (id: any, variantId: any, copy: any) => any,
  toggleReplacementDialog: typeof toggleReplacementDialog,
  clear: typeof clear,
  product: ?any,
  productFormValues: any,
  productFormIsValid: boolean,
  variantFormValues: any,
  variantFormIsValid: boolean,
  params: any,
  error: ?any,
  updateProductVariant: typeof updateProductVariant,
  setActiveVariantImage: typeof setActiveVariantImage,
  resetForm: typeof resetForm,
  removeImage: typeof removeVariantImage,
  touch: typeof touch,
  suppliers: any[],
  setDirty: typeof setDirty,
  relatedError: ?any,
  relatedFetching: boolean,
  related: any[],
  relatedProductSelected: typeof relatedProductSelected,
  relatedVariantSelected: typeof relatedVariantSelected,
  relatedProductToggle: typeof relatedProductToggle,
  relatedProductTypeToggle: typeof relatedProductTypeToggle,
  reset: typeof reset,
  sharedRelated: any[],
  sharedRelatedProductSelected: typeof sharedRelatedProductSelected,
  sharedRelatedVariantSelected: typeof sharedRelatedVariantSelected,
  sharedRelatedProductToggle: typeof sharedRelatedProductToggle,
  sharedRelatedProductTypeToggle: typeof sharedRelatedProductTypeToggle,
  filteredSharedRelatedProductTypes: any[],
  sharedRelatedProductType: ?{ id: number },
  setSharedRelatedProductType: typeof setSharedRelatedProductType,
  addSharedRelatedProductType: typeof addSharedRelatedProductType,
  allRelated: Object,
  updateProductVariants: typeof updateProductVariants,
  relatedProductTypeSelected: typeof relatedProductTypeSelected,
  sharedRelatedProductTypeSelected: typeof sharedRelatedProductTypeSelected,
  removeProductType: typeof removeProductType,
  sharedRemoveProductType: typeof sharedRemoveProductType,
  unlockShared: typeof unlockShared,
  hasVariantDiffs: boolean,
  history: Object,
  activeProductLinkedAdditionalVariant: ?any,
  activeVariantLinkedAdditionalVariant: ?any,
  copy: boolean,
};*/var _ref4=_react2.default.createElement(_Navigation2.default,{hideNavigation:true});var _ref5=_react2.default.createElement('span',{className:'box-section-title'},'Kopplade till\xE4ggsprodukter');var _ref6=_react2.default.createElement('span',{className:'box-section-title'},'Kopplade till\xE4ggsprodukter');var ProductContainer=function(_Component){_inherits(ProductContainer,_Component);function ProductContainer(){_classCallCheck(this,ProductContainer);return _possibleConstructorReturn(this,(ProductContainer.__proto__||Object.getPrototypeOf(ProductContainer)).apply(this,arguments));}_createClass(ProductContainer,[{key:'componentWillMount',value:function componentWillMount(){if(!!this.props.params.variantId){// eslint-disable-next-line
this.props.history.replace(this.props.resourcePath+'/'+this.props.params.id);}this.props.fetchData(this.props.params.id,this.props.params.variantId,this.props.copy);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clear();}},{key:'setDirty',value:function setDirty(form/*: 'product' | 'productVariant'*/){var _props=this.props,setDirty=_props.setDirty,productIsDirty=_props.productIsDirty,variantIsDirty=_props.variantIsDirty;if(form==='product'&&!productIsDirty){setDirty(true,form);}else if(form==='productVariant'&&!variantIsDirty){setDirty(true,form);}}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('product');resetForm('productVariant');setDirty(false,'product');setDirty(false,'productVariant');}},{key:'save',value:function save(copy){var _props3=this.props,productFormValues=_props3.productFormValues,variantFormValues=_props3.variantFormValues,touch=_props3.touch,variantFormIsValid=_props3.variantFormIsValid,productFormIsValid=_props3.productFormIsValid,product=_props3.product,activeVariant=_props3.activeVariant,images=_props3.images,variantLinkedAdditionalVariants=_props3.variantLinkedAdditionalVariants,productLinkedAdditionalVariants=_props3.productLinkedAdditionalVariants,related=_props3.related,updateProduct=_props3.updateProduct,createProduct=_props3.createProduct,updateProductVariants=_props3.updateProductVariants,allRelated=_props3.allRelated,variants=_props3.variants;var productKeys=(0,_keys3.default)(productValidation);var variantKeys=(0,_keys3.default)(variantValidation);touch.apply(undefined,['product'].concat(_toConsumableArray(productKeys)));touch.apply(undefined,['productVariant'].concat(_toConsumableArray(variantKeys)));if(!variantFormIsValid||!productFormIsValid){return;}var mainRelated=mapRelated(related);if(!product||copy){createProduct(_extends({},productFormValues,{linkedAdditionalVariants:productLinkedAdditionalVariants,mainVariant:_extends({},variantFormValues,{related:mainRelated,images:images,linkedAdditionalVariants:variantLinkedAdditionalVariants}),copy:copy}));}else{updateProduct(product.id,_extends({},productFormValues,{linkedAdditionalVariants:productLinkedAdditionalVariants}));updateProductVariants(product.id,[].concat(_toConsumableArray((0,_map3.default)(function(v){return!!activeVariant&&v.id===activeVariant.id?_extends({},variantFormValues,{related:mainRelated,images:images,linkedAdditionalVariants:variantLinkedAdditionalVariants}):_extends({},v,{related:mapRelated(allRelated[v.id]||[])});},variants)),_toConsumableArray(!activeVariant?[_extends({},variantFormValues,{related:mainRelated,images:images,linkedAdditionalVariants:variantLinkedAdditionalVariants})]:[])));}}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,id=_props4.params.id,filteredVariants=_props4.filteredVariants,includeArchived=_props4.includeArchived,filterArchived=_props4.filterArchived,product=_props4.product,error=_props4.error,variantError=_props4.variantError,suppliersError=_props4.suppliersError,roomTypesError=_props4.roomTypesError,workerTypesError=_props4.workerTypesError,productTypesError=_props4.productTypesError,isFetching=_props4.isFetching,variantIsFetching=_props4.variantIsFetching,suppliersIsFetching=_props4.suppliersIsFetching,roomTypesIsFetching=_props4.roomTypesIsFetching,workerTypesIsFetching=_props4.workerTypesIsFetching,productTypesIsFetching=_props4.productTypesIsFetching,resourcePath=_props4.resourcePath,variants=_props4.variants,setActiveVariant=_props4.setActiveVariant,setActiveVariantImage=_props4.setActiveVariantImage,setDefaultVariantImage=_props4.setDefaultVariantImage,setRelatedProductType=_props4.setRelatedProductType,variantImage=_props4.variantImage,removeImage=_props4.removeImage,images=_props4.images,imagesInProgress=_props4.imagesInProgress,activeImage=_props4.activeImage,productLinkedAdditionalVariants=_props4.productLinkedAdditionalVariants,variantLinkedAdditionalVariants=_props4.variantLinkedAdditionalVariants,activeVariant=_props4.activeVariant,roomTypes=_props4.roomTypes,workerTypes=_props4.workerTypes,filteredRelatedProductTypes=_props4.filteredRelatedProductTypes,filteredProductTypes=_props4.filteredProductTypes,relatedProductType=_props4.relatedProductType,updateProduct=_props4.updateProduct,updateProductVariant=_props4.updateProductVariant,toggleReplacementDialog=_props4.toggleReplacementDialog,setActiveVariantLinkedAdditionalVariant=_props4.setActiveVariantLinkedAdditionalVariant,addVariantLinkedAdditionalVariant=_props4.addVariantLinkedAdditionalVariant,updateVariantLinkedAdditionalVariant=_props4.updateVariantLinkedAdditionalVariant,removeVariantLinkedAdditionalVariant=_props4.removeVariantLinkedAdditionalVariant,setActiveProductLinkedAdditionalVariant=_props4.setActiveProductLinkedAdditionalVariant,addProductLinkedAdditionalVariant=_props4.addProductLinkedAdditionalVariant,updateProductLinkedAdditionalVariant=_props4.updateProductLinkedAdditionalVariant,removeProductLinkedAdditionalVariant=_props4.removeProductLinkedAdditionalVariant,suppliers=_props4.suppliers,productIsDirty=_props4.productIsDirty,relatedError=_props4.relatedError,relatedFetching=_props4.relatedFetching,related=_props4.related,_relatedProductSelected=_props4.relatedProductSelected,_relatedVariantSelected=_props4.relatedVariantSelected,_relatedProductToggle=_props4.relatedProductToggle,_relatedProductTypeToggle=_props4.relatedProductTypeToggle,_addRelatedProductType=_props4.addRelatedProductType,variantIsDirty=_props4.variantIsDirty,sharedRelated=_props4.sharedRelated,sharedRelatedProductSelected=_props4.sharedRelatedProductSelected,sharedRelatedVariantSelected=_props4.sharedRelatedVariantSelected,sharedRelatedProductToggle=_props4.sharedRelatedProductToggle,sharedRelatedProductTypeToggle=_props4.sharedRelatedProductTypeToggle,addSharedRelatedProductType=_props4.addSharedRelatedProductType,setSharedRelatedProductType=_props4.setSharedRelatedProductType,filteredSharedRelatedProductTypes=_props4.filteredSharedRelatedProductTypes,sharedRelatedProductType=_props4.sharedRelatedProductType,_relatedProductTypeSelected=_props4.relatedProductTypeSelected,sharedRelatedProductTypeSelected=_props4.sharedRelatedProductTypeSelected,_removeProductType=_props4.removeProductType,sharedRemoveProductType=_props4.sharedRemoveProductType,unlockShared=_props4.unlockShared,hasVariantDiffs=_props4.hasVariantDiffs,activeProductLinkedAdditionalVariant=_props4.activeProductLinkedAdditionalVariant,activeVariantLinkedAdditionalVariant=_props4.activeVariantLinkedAdditionalVariant,copy=_props4.copy;return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_ref4,_react2.default.createElement('div',{className:'content-title'},copy?'Kopiera produkt':product&&product.name||'Ny produkt'))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},!copy&&product&&_react2.default.createElement(_DisableContent2.default,{disabled:productIsDirty},_react2.default.createElement('button',{className:'secondary button',type:'button',onClick:function onClick(){_this2.props.history.push(_this2.props.resourcePath+'/'+_this2.props.params.id+'/copy');// setDirty(true, 'product');
// setDirty(true, 'productVariant');
}},'Kopiera'),_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveProduct',className:'secondary button',message:'Vill du verkligen '+(product.archived?'av':'')+'arkivera den h\xE4r produkten?',buttonText:product.archived?'Avarkivera':'Arkivera',action:function action(){return updateProduct(product.id,{archived:!product.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching||variantIsFetching||suppliersIsFetching||roomTypesIsFetching||workerTypesIsFetching||productTypesIsFetching||relatedFetching}),_react2.default.createElement(_ServerError2.default,{error:error||suppliersError||roomTypesError||workerTypesError||productTypesError||relatedError}),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'box-section'},_react2.default.createElement(_ProductForm2.default,{related:sharedRelated,relatedProductTypes:filteredSharedRelatedProductTypes,relatedProductType:sharedRelatedProductType,setRelatedProductType:setSharedRelatedProductType,relatedProductSelected:function relatedProductSelected(id,productType,selected){sharedRelatedProductSelected(id,productType,selected);_this2.setDirty('productVariant');},relatedVariantSelected:function relatedVariantSelected(id,productType,selected){sharedRelatedVariantSelected(id,productType,selected);_this2.setDirty('productVariant');},relatedProductToggle:sharedRelatedProductToggle,relatedProductTypeToggle:sharedRelatedProductTypeToggle,addRelatedProductType:function addRelatedProductType(type){addSharedRelatedProductType(type);_this2.setDirty('productVariant');},initialValues:product,roomTypes:roomTypes,workerTypes:workerTypes,productTypes:filteredProductTypes,variants:(0,_map3.default)(function(v){return _extends({},v,{name:!!v.archived?v.name+' (arkiverad)':v.name});},filteredVariants),suppliers:suppliers,onUserChange:function onUserChange(){return _this2.setDirty('product');},validate:function validate(values){return(0,_validator2.default)(productValidation,values);},relatedProductTypeSelected:function relatedProductTypeSelected(productType,selected){sharedRelatedProductTypeSelected(productType,selected);_this2.setDirty('productVariant');},removeProductType:function removeProductType(id){sharedRemoveProductType(id);_this2.setDirty('productVariant');},hasVariantDiffs:hasVariantDiffs,unlockShared:unlockShared})),_react2.default.createElement('div',{className:'box-section'},_ref5,_react2.default.createElement(_LinkedAdditionalVariantsContainer2.default,{active:activeProductLinkedAdditionalVariant,existing:productLinkedAdditionalVariants,setActive:setActiveProductLinkedAdditionalVariant,addAdditional:function addAdditional(a){addProductLinkedAdditionalVariant(a);_this2.setDirty('product');},updateAdditional:function updateAdditional(a){updateProductLinkedAdditionalVariant(a);_this2.setDirty('product');},removeAdditional:function removeAdditional(a){removeProductLinkedAdditionalVariant(a);_this2.setDirty('product');}}))),_react2.default.createElement(_ServerError2.default,{error:variantError}),_react2.default.createElement('div',{className:'content-section'},_react2.default.createElement('div',{className:'row no-row-margins'},_react2.default.createElement('div',{className:'box-side-tabs shrink'},_react2.default.createElement(_DisableContent2.default,{disabled:variantIsDirty},_react2.default.createElement(_FormTabs2.default,{includeArchived:includeArchived,onArchivedChanged:filterArchived,onSelect:function onSelect(t){return setActiveVariant((0,_find3.default)({id:t.id},variants));},onAdd:function onAdd(){return setActiveVariant(null);},title:'Varianter',tabs:(0,_map3.default)(function(v){return{id:v.id,label:!!v.archived?v.name+' (arkiverad)':v.name,active:activeVariant&&activeVariant.id===v.id};},includeArchived?variants:filteredVariants)}))),_react2.default.createElement('div',{className:'box expand'},_react2.default.createElement('div',{className:'row align-justify align-middle box-header'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('span',{className:'box-title'},activeVariant&&activeVariant.name||'Ny variant')),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},activeVariant&&_react2.default.createElement(_DisableContent2.default,{disabled:variantIsDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveProductVariant',className:'secondary button',message:'Vill du verkligen '+(activeVariant.archived?'av':'')+'arkivera den h\xE4r varianten?',buttonText:activeVariant.archived?'Avarkivera':'Arkivera',action:function action(){return updateProductVariant(activeVariant.id,{archived:!activeVariant.archived});}})))),_react2.default.createElement('div',{className:'box-section'},_react2.default.createElement(_ProductVariantForm2.default,{toggleReplacementDialog:toggleReplacementDialog,initialValues:activeVariant,activeVariant:activeVariant,productTypes:filteredRelatedProductTypes,relatedProductType:relatedProductType,setRelatedProductType:setRelatedProductType,related:related,relatedProductSelected:function relatedProductSelected(id,productType,selected){var variantId=!!activeVariant?activeVariant.id:0;_relatedProductSelected(variantId,id,selected);_this2.setDirty('productVariant');},relatedVariantSelected:function relatedVariantSelected(id,productType,selected){var variantId=!!activeVariant?activeVariant.id:0;_relatedVariantSelected(variantId,id,selected);_this2.setDirty('productVariant');},relatedProductToggle:function relatedProductToggle(product){var variantId=!!activeVariant?activeVariant.id:0;_relatedProductToggle(variantId,product);},relatedProductTypeToggle:function relatedProductTypeToggle(type){var variantId=!!activeVariant?activeVariant.id:0;_relatedProductTypeToggle(variantId,type);},addRelatedProductType:function addRelatedProductType(type){var variantId=!!activeVariant?activeVariant.id:0;_addRelatedProductType(variantId,type);_this2.setDirty('productVariant');},onUserChange:function onUserChange(){return _this2.setDirty('productVariant');},validate:function validate(values){return(0,_validator2.default)(variantValidation,values);},relatedProductTypeSelected:function relatedProductTypeSelected(productType,selected){var variantId=!!activeVariant?activeVariant.id:0;_relatedProductTypeSelected(variantId,productType.id,selected);_this2.setDirty('productVariant');},removeProductType:function removeProductType(id){var variantId=!!activeVariant?activeVariant.id:0;_removeProductType(variantId,id);_this2.setDirty('productVariant');}})),_react2.default.createElement('div',{className:'box-section'},_ref6,_react2.default.createElement(_LinkedAdditionalVariantsContainer2.default,{active:activeVariantLinkedAdditionalVariant,existing:variantLinkedAdditionalVariants,setActive:setActiveVariantLinkedAdditionalVariant,addAdditional:function addAdditional(a){addVariantLinkedAdditionalVariant(a);_this2.setDirty('productVariant');},updateAdditional:function updateAdditional(a){updateVariantLinkedAdditionalVariant(a);_this2.setDirty('productVariant');},removeAdditional:function removeAdditional(a){removeVariantLinkedAdditionalVariant(a);_this2.setDirty('productVariant');}})),_react2.default.createElement('div',{className:'box-section'},_react2.default.createElement(_ProductVariantImages2.default,{images:images,imagesInProgress:imagesInProgress,activeImage:activeImage,activeVariant:activeVariant,onActiveImage:setActiveVariantImage,onDefaultImage:function onDefaultImage(image){setDefaultVariantImage(image);_this2.setDirty('productVariant');},onDrop:function onDrop(variantId,data){variantImage(variantId,data);_this2.setDirty('productVariant');},onRemoveImage:function onRemoveImage(variantId,imageId){removeImage(variantId,imageId);_this2.setDirty('productVariant');}}))))),(productIsDirty||variantIsDirty)&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching||variantIsFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){_this2.save(copy);}}),product&&product.id!==(0,_toNumber3.default)(id)&&_react2.default.createElement(_reactRouterDom.Redirect,{to:resourcePath+'/'+product.id}));}}]);return ProductContainer;}(_react.Component);var getImagesInProgress=function getImagesInProgress(activeVariant,imageUploads,files){var _ref7=activeVariant||{},_ref7$id=_ref7.id,id=_ref7$id===undefined?0:_ref7$id;if(!imageUploads[id]){return[];}return(0,_flow3.default)((0,_map3.default)(function(i){return files.byId[i];}),(0,_filter3.default)(function(i){return!!i&&!i.metadata;}))(imageUploads[id]);};var mapStateToProps=function mapStateToProps(_ref8){var _ref8$productView=_ref8.productView,_ref8$productView$pro=_ref8$productView.product,activeProduct=_ref8$productView$pro.active,includeArchived=_ref8$productView$pro.includeArchived,filteredVariants=_ref8$productView$pro.filteredVariants,variants=_ref8$productView$pro.variants,error=_ref8$productView$pro.error,productIsDirty=_ref8$productView$pro.isDirty,isFetching=_ref8$productView$pro.isFetching,sharedRelatedProductType=_ref8$productView$pro.relatedProductType,productLinkedAdditionalVariants=_ref8$productView$pro.linkedAdditionalVariants,_ref8$productView$sup=_ref8$productView.suppliers,suppliers=_ref8$productView$sup.filteredList,suppliersError=_ref8$productView$sup.error,suppliersIsFetching=_ref8$productView$sup.isFetching,_ref8$productView$roo=_ref8$productView.roomTypes,roomTypes=_ref8$productView$roo.list,roomTypesError=_ref8$productView$roo.error,roomTypesIsFetching=_ref8$productView$roo.isFetching,_ref8$productView$wor=_ref8$productView.workerTypes,workerTypes=_ref8$productView$wor.list,workerTypesError=_ref8$productView$wor.error,workerTypesIsFetching=_ref8$productView$wor.isFetching,_ref8$productView$pro2=_ref8$productView.productTypes,filteredRelatedProductTypes=_ref8$productView$pro2.relatedList,filteredProductTypes=_ref8$productView$pro2.filteredList,productTypesError=_ref8$productView$pro2.error,productTypesIsFetching=_ref8$productView$pro2.isFetching,filteredSharedRelatedProductTypes=_ref8$productView$pro2.sharedRelatedList,_ref8$productView$var=_ref8$productView.variant,relatedProductType=_ref8$productView$var.relatedProductType,_ref8$productView$var2=_ref8$productView$var.related,relatedError=_ref8$productView$var2.error,relatedFetching=_ref8$productView$var2.isFetching,related=_ref8$productView$var2.list,sharedRelated=_ref8$productView$var2.shared,hasVariantDiffs=_ref8$productView$var2.hasVariantDiffs,activeVariant=_ref8$productView$var.active,activeImage=_ref8$productView$var.activeImage,images=_ref8$productView$var.images,uploads=_ref8$productView$var.uploads,variantLinkedAdditionalVariants=_ref8$productView$var.linkedAdditionalVariants,variantError=_ref8$productView$var.error,variantIsDirty=_ref8$productView$var.isDirty,variantIsFetching=_ref8$productView$var.isFetching,activeProductLinkedAdditionalVariant=_ref8$productView.activeProductLinkedAdditionalVariant,activeVariantLinkedAdditionalVariant=_ref8$productView.activeVariantLinkedAdditionalVariant,form=_ref8.form,files=_ref8.files;return{product:activeProduct,variants:variants,filteredVariants:filteredVariants,includeArchived:includeArchived,activeVariant:activeVariant,activeImage:activeImage,images:images,imagesInProgress:getImagesInProgress(activeVariant,uploads,files),productLinkedAdditionalVariants:productLinkedAdditionalVariants,variantLinkedAdditionalVariants:variantLinkedAdditionalVariants,error:error,variantError:variantError,suppliersError:suppliersError,roomTypesError:roomTypesError,workerTypesError:workerTypesError,productTypesError:productTypesError,isFetching:isFetching,variantIsFetching:variantIsFetching,suppliersIsFetching:suppliersIsFetching,roomTypesIsFetching:roomTypesIsFetching,workerTypesIsFetching:workerTypesIsFetching,productTypesIsFetching:productTypesIsFetching,variantFormIsValid:(0,_reduxForm.isValid)('productVariant')({form:form}),productFormIsValid:(0,_reduxForm.isValid)('product')({form:form}),variantFormValues:(0,_reduxForm.getFormValues)('productVariant')({form:form}),productFormValues:(0,_reduxForm.getFormValues)('product')({form:form}),roomTypes:roomTypes,workerTypes:workerTypes,filteredRelatedProductTypes:filteredRelatedProductTypes,filteredProductTypes:filteredProductTypes,relatedError:relatedError,relatedFetching:relatedFetching,related:related[!!activeVariant?activeVariant.id:0]||[],relatedProductType:relatedProductType,suppliers:suppliers,productIsDirty:productIsDirty,variantIsDirty:variantIsDirty,sharedRelated:sharedRelated,sharedRelatedProductType:sharedRelatedProductType,filteredSharedRelatedProductTypes:filteredSharedRelatedProductTypes,allRelated:related,hasVariantDiffs:hasVariantDiffs,activeProductLinkedAdditionalVariant:activeProductLinkedAdditionalVariant,activeVariantLinkedAdditionalVariant:activeVariantLinkedAdditionalVariant};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{relatedProductSelected:function relatedProductSelected(variantId,id,selected){return dispatch((0,_productView.relatedProductSelected)(variantId,id,selected));},relatedVariantSelected:function relatedVariantSelected(variantId,id,selected){return dispatch((0,_productView.relatedVariantSelected)(variantId,id,selected));},relatedProductToggle:function relatedProductToggle(variantId,id){return dispatch((0,_productView.relatedProductToggle)(variantId,id));},relatedProductTypeToggle:function relatedProductTypeToggle(variantId,id){return dispatch((0,_productView.relatedProductTypeToggle)(variantId,id));},setRelatedProductType:function setRelatedProductType(productType){return dispatch((0,_productView.setRelatedProductType)(productType));},addRelatedProductType:function addRelatedProductType(variantId,productType){return dispatch((0,_productView.addRelatedProductType)(variantId,productType));},filterArchived:function filterArchived(includeArchived){return dispatch((0,_productView.filterArchived)(includeArchived));},updateProduct:function updateProduct(id,data){return dispatch((0,_productView.updateProduct)(id,data));},createProduct:function createProduct(data){return dispatch((0,_productView.createProduct)(data));},updateProductVariant:function updateProductVariant(id,data){return dispatch((0,_productView.updateProductVariant)(id,data));},clear:function clear(){return dispatch((0,_productView.clear)());},setActiveVariant:function setActiveVariant(data){return dispatch((0,_productView.setActiveVariant)(data));},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},variantImage:function variantImage(variantId,_ref9){var _ref10=_toArray(_ref9),file=_ref10[0],rest=_ref10.slice(1);if(file){dispatch((0,_productView.variantImage)(variantId,file));}},setDefaultVariantImage:function setDefaultVariantImage(image){return dispatch((0,_productView.setDefaultVariantImage)(image));},setActiveVariantImage:function setActiveVariantImage(image){return dispatch((0,_productView.setActiveVariantImage)(image));},removeImage:function removeImage(variantId,imageId){return dispatch((0,_productView.removeVariantImage)(variantId,imageId));},fetchData:function fetchData(id,variantId,copy){dispatch((0,_productView.fetchRoomTypes)());dispatch((0,_productView.fetchWorkerTypes)());dispatch((0,_productView.fetchProductTypes)());dispatch((0,_productView.fetchSuppliers)());if(id||copy){dispatch((0,_productView.fetchProduct)(id,variantId,copy));}},toggleReplacementDialog:function toggleReplacementDialog(show){return dispatch((0,_productView.toggleReplacementDialog)(show));},setActiveVariantLinkedAdditionalVariant:function setActiveVariantLinkedAdditionalVariant(additional){return dispatch((0,_productView.setActiveVariantLinkedAdditionalVariant)(additional));},addVariantLinkedAdditionalVariant:function addVariantLinkedAdditionalVariant(additional){return dispatch((0,_productView.addVariantLinkedAdditionalVariant)(additional));},updateVariantLinkedAdditionalVariant:function updateVariantLinkedAdditionalVariant(additional){return dispatch((0,_productView.updateVariantLinkedAdditionalVariant)(additional));},removeVariantLinkedAdditionalVariant:function removeVariantLinkedAdditionalVariant(additional){return dispatch((0,_productView.removeVariantLinkedAdditionalVariant)(additional));},setActiveProductLinkedAdditionalVariant:function setActiveProductLinkedAdditionalVariant(additional){return dispatch((0,_productView.setActiveProductLinkedAdditionalVariant)(additional));},addProductLinkedAdditionalVariant:function addProductLinkedAdditionalVariant(additional){return dispatch((0,_productView.addProductLinkedAdditionalVariant)(additional));},updateProductLinkedAdditionalVariant:function updateProductLinkedAdditionalVariant(additional){return dispatch((0,_productView.updateProductLinkedAdditionalVariant)(additional));},removeProductLinkedAdditionalVariant:function removeProductLinkedAdditionalVariant(additional){return dispatch((0,_productView.removeProductLinkedAdditionalVariant)(additional));},setDirty:function setDirty(dirty,form){return dispatch((0,_form.setDirty)(dirty,form));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_productView.reset)());},sharedRelatedProductSelected:function sharedRelatedProductSelected(id,productType,selected){return dispatch((0,_productView.sharedRelatedProductSelected)(id,productType,selected));},sharedRelatedVariantSelected:function sharedRelatedVariantSelected(id,productType,selected){return dispatch((0,_productView.sharedRelatedVariantSelected)(id,productType,selected));},sharedRelatedProductToggle:function sharedRelatedProductToggle(id){return dispatch((0,_productView.sharedRelatedProductToggle)(id));},sharedRelatedProductTypeToggle:function sharedRelatedProductTypeToggle(id){return dispatch((0,_productView.sharedRelatedProductTypeToggle)(id));},setSharedRelatedProductType:function setSharedRelatedProductType(productType){return dispatch((0,_productView.setSharedRelatedProductType)(productType));},addSharedRelatedProductType:function addSharedRelatedProductType(productType){return dispatch((0,_productView.addSharedRelatedProductType)(productType));},updateProductVariants:function updateProductVariants(id,data){return dispatch((0,_productView.updateProductVariants)(id,data));},relatedProductTypeSelected:function relatedProductTypeSelected(variantId,id,selected){return dispatch((0,_productView.relatedProductTypeSelected)(variantId,id,selected));},sharedRelatedProductTypeSelected:function sharedRelatedProductTypeSelected(productType,selected){return dispatch((0,_productView.sharedRelatedProductTypeSelected)(productType,selected));},removeProductType:function removeProductType(variantId,id){return dispatch((0,_productView.removeProductType)(variantId,id));},sharedRemoveProductType:function sharedRemoveProductType(id){return dispatch((0,_productView.sharedRemoveProductType)(id));},unlockShared:function unlockShared(){return dispatch((0,_productView.unlockShared)());}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ProductContainer));

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);var _assortments=__webpack_require__(55);var _RelatedVariantsInput=__webpack_require__(480);var _RelatedVariantsInput2=_interopRequireDefault(_RelatedVariantsInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  productTypes: any[],
  workerTypes: any[],
  roomTypes: any[],
  onUserChange: Function,
  variants: any[],
  suppliers: any[],
  relatedProductTypes: any[],
  relatedProductType: ?{ id: number },
  related: any[],
  relatedProductSelected: Function,
  relatedVariantSelected: Function,
  relatedProductToggle: Function,
  relatedProductTypeToggle: Function,
  addRelatedProductType: Function,
  setRelatedProductType: Function,
  relatedProductTypeSelected: Function,
  removeProductType: Function,
  unlockShared: Function,
  hasVariantDiffs: boolean,
};*/var ProductForm=function ProductForm(_ref){var productTypes=_ref.productTypes,workerTypes=_ref.workerTypes,roomTypes=_ref.roomTypes,variants=_ref.variants,suppliers=_ref.suppliers,onUserChange=_ref.onUserChange,relatedProductTypes=_ref.relatedProductTypes,relatedProductType=_ref.relatedProductType,related=_ref.related,relatedProductSelected=_ref.relatedProductSelected,relatedVariantSelected=_ref.relatedVariantSelected,relatedProductToggle=_ref.relatedProductToggle,relatedProductTypeToggle=_ref.relatedProductTypeToggle,addRelatedProductType=_ref.addRelatedProductType,setRelatedProductType=_ref.setRelatedProductType,relatedProductTypeSelected=_ref.relatedProductTypeSelected,removeProductType=_ref.removeProductType,unlockShared=_ref.unlockShared,hasVariantDiffs=_ref.hasVariantDiffs;return _react2.default.createElement('div',{className:'ProductForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'productTypeId',label:'Produkttyp',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:productTypes}),_react2.default.createElement(_reduxForm.Field,{name:'supplierId',label:'Leverant\xF6r',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:suppliers}),_react2.default.createElement(_reduxForm.Field,{name:'workerTypes',label:'Yrkeskategorier',onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:workerTypes,multi:true}),_react2.default.createElement(_reduxForm.Field,{name:'roomTypes',label:'Rumstyper',onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:roomTypes,multi:true})),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'externalDescription',label:'Produktbeskrivning',onChange:onUserChange,component:_TextAreaFormInput2.default}),_react2.default.createElement(_reduxForm.Field,{name:'internalDescription',label:'Intern beskrivning',onChange:onUserChange,component:_TextAreaFormInput2.default}))),_react2.default.createElement('div',{className:'row'},variants&&_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'mainVariantId',label:'Visningsartikel',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:variants})),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'assortment',label:'Sortiment',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'label',options:_assortments.assortments}))),_react2.default.createElement('div',{className:'row related-row'},_react2.default.createElement('div',{className:'small-12 column'},_react2.default.createElement(_reduxForm.Field,{name:'related',label:'Kombinationsprodukt',productTypes:relatedProductTypes,relatedProductType:relatedProductType,setRelatedProductType:setRelatedProductType,addRelatedProductType:addRelatedProductType,related:related,productSelected:relatedProductSelected,variantSelected:relatedVariantSelected,productToggle:relatedProductToggle,productTypeToggle:relatedProductTypeToggle,productTypeSelected:relatedProductTypeSelected,removeProductType:removeProductType,component:_RelatedVariantsInput2.default,hasVariantDiffs:hasVariantDiffs,unlockShared:unlockShared})))));};exports.default=(0,_reduxForm.reduxForm)({form:'product',enableReinitialize:true})(ProductForm);

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _priceHelpers=__webpack_require__(85);var _DecimalFormInput=__webpack_require__(70);var _DecimalFormInput2=_interopRequireDefault(_DecimalFormInput);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);var _ReplacementFormInput=__webpack_require__(1161);var _ReplacementFormInput2=_interopRequireDefault(_ReplacementFormInput);var _RelatedVariantsInput=__webpack_require__(480);var _RelatedVariantsInput2=_interopRequireDefault(_RelatedVariantsInput);__webpack_require__(1164);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  productTypes: any[],
  relatedProductType: ?{ id: number },
  related: any[],
  relatedProductSelected: Function,
  relatedVariantSelected: Function,
  relatedProductToggle: Function,
  relatedProductTypeToggle: Function,
  addRelatedProductType: Function,
  setRelatedProductType: Function,
  toggleReplacementDialog: Function,
  setActiveAdditional: Function,
  onUserChange: Function,
  activeVariant: ?any,
  relatedProductTypeSelected: Function,
  removeProductType: Function,
};*/var ProductVariantForm=function ProductVariantForm(_ref){var toggleReplacementDialog=_ref.toggleReplacementDialog,setActiveAdditional=_ref.setActiveAdditional,activeVariant=_ref.activeVariant,onUserChange=_ref.onUserChange,productTypes=_ref.productTypes,relatedProductType=_ref.relatedProductType,related=_ref.related,relatedProductSelected=_ref.relatedProductSelected,relatedVariantSelected=_ref.relatedVariantSelected,relatedProductToggle=_ref.relatedProductToggle,relatedProductTypeToggle=_ref.relatedProductTypeToggle,addRelatedProductType=_ref.addRelatedProductType,setRelatedProductType=_ref.setRelatedProductType,relatedProductTypeSelected=_ref.relatedProductTypeSelected,removeProductType=_ref.removeProductType;return _react2.default.createElement('div',{className:'ProductVariantForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'itemNumber',label:'Internt artikelnummer',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'externalItemNumber',label:'Externt artikelnummer',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'buyingPrice',label:'Ink\xF6pspris exklusive moms',onChangeTransform:_priceHelpers.addVAT,valueTransform:_priceHelpers.removeVAT,onChange:onUserChange,component:_DecimalFormInput2.default}),_react2.default.createElement(_reduxForm.Field,{name:'buyingPrice',label:'Ink\xF6pspris inklusive moms',onChange:onUserChange,component:_DecimalFormInput2.default}),_react2.default.createElement(_reduxForm.Field,{name:'sellingPrice',label:'S\xE4ljpris exklusive moms',onChangeTransform:_priceHelpers.addVAT,valueTransform:_priceHelpers.removeVAT,onChange:onUserChange,component:_DecimalFormInput2.default}),_react2.default.createElement(_reduxForm.Field,{name:'sellingPrice',label:'S\xE4ljpris inklusive moms',onChange:onUserChange,component:_DecimalFormInput2.default})),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'color',label:'F\xE4rg',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'sizeWidth',label:'Bredd (cm)',onChange:onUserChange,component:_DecimalFormInput2.default}),_react2.default.createElement(_reduxForm.Field,{name:'sizeHeight',label:'H\xF6jd (cm)',onChange:onUserChange,component:_DecimalFormInput2.default}),_react2.default.createElement(_reduxForm.Field,{name:'sizeDepth',label:'Djup (cm)',onChange:onUserChange,component:_DecimalFormInput2.default}),activeVariant&&_react2.default.createElement(_reduxForm.Field,{name:'replacement',label:'Ers\xE4ttningsprodukt',toggleReplacementDialog:toggleReplacementDialog,onChange:onUserChange,component:_ReplacementFormInput2.default}))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'externalDescription',label:'Extern beskrivning',onChange:onUserChange,component:_TextAreaFormInput2.default})),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'internalDescription',label:'Intern beskrivning',onChange:onUserChange,component:_TextAreaFormInput2.default}))),_react2.default.createElement('div',{className:'row related-row'},_react2.default.createElement('div',{className:'small-12 column'},_react2.default.createElement(_reduxForm.Field,{name:'related',label:'Kombinationsprodukt',productTypes:productTypes,relatedProductType:relatedProductType,setRelatedProductType:setRelatedProductType,addRelatedProductType:addRelatedProductType,related:related,productSelected:relatedProductSelected,variantSelected:relatedVariantSelected,productToggle:relatedProductToggle,productTypeToggle:relatedProductTypeToggle,productTypeSelected:relatedProductTypeSelected,removeProductType:removeProductType,component:_RelatedVariantsInput2.default})))));};exports.default=(0,_reduxForm.reduxForm)({form:'productVariant',enableReinitialize:true})(ProductVariantForm);

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _ReplacementDialogContainer=__webpack_require__(1162);var _ReplacementDialogContainer2=_interopRequireDefault(_ReplacementDialogContainer);__webpack_require__(1163);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  input: any,
  label: string,
  meta: any,
  toggleReplacementDialog: Function,
};*/var _ref2=_react2.default.createElement('span',null,'Ingen ers\xE4ttnigsprodukt');var _ref3=_react2.default.createElement('i',{className:'fa fa-pencil'});var _ref4=_react2.default.createElement('i',{className:'fa fa-trash'});var _ref5=_react2.default.createElement('i',{className:'fa fa-folder-open-o'});var ReplacementFormInput=function ReplacementFormInput(_ref){var input=_ref.input,label=_ref.label,_ref$meta=_ref.meta,touched=_ref$meta.touched,error=_ref$meta.error,toggleReplacementDialog=_ref.toggleReplacementDialog;var hasReplacement=input.value&&input.value.productId&&input.value.variantId;var replacementProductUrl='/products/'+input.value.productId;return _react2.default.createElement('div',{className:'ReplacementFormInput'},_react2.default.createElement('label',{className:(0,_classnames2.default)({'is-invalid-label':touched&&error})},label),_react2.default.createElement('div',{className:'row no-row-margins'},_react2.default.createElement('button',{onClick:function onClick(){return toggleReplacementDialog(true);},type:'button',title:input.value.productName+' - '+input.value.variantName,className:(0,_classnames2.default)({'button column replacement':true,'warning':hasReplacement,'secondary hollow':!hasReplacement})},hasReplacement&&_react2.default.createElement('span',null,input.value.productName,' - ',input.value.variantName),!hasReplacement&&_ref2),_react2.default.createElement('button',{onClick:function onClick(){return toggleReplacementDialog(true);},type:'button',title:'Redigera',className:'button column shrink'},_ref3),hasReplacement&&_react2.default.createElement('button',{onClick:function onClick(){return input.onChange(null);},type:'button',title:'Ta bort',className:'button column shrink'},_ref4),hasReplacement&&_react2.default.createElement('button',{onClick:function onClick(){return window.location.assign(replacementProductUrl);},type:'button',title:'G\xE5 till ers\xE4ttnigsprodukt',className:'button column shrink'},_ref5),_react2.default.createElement(_ReplacementDialogContainer2.default,{replacement:!(0,_isEmpty3.default)(input.value)?input.value:null,setReplacement:function setReplacement(replacement){return input.onChange(replacement);}}),touched&&error&&_react2.default.createElement('span',{className:'form-error is-visible'},error)));};exports.default=ReplacementFormInput;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _productView=__webpack_require__(169);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  fetchReplacementProducts: Function,
  fetchReplacementVariants: Function,
  toggleReplacementDialog: Function,
  setReplacement: Function,
  show: boolean,
  variants: any[],
  products: any[],
  variantsIsFetching: boolean,
  productsIsFetching: boolean,
  replacement?: any,
};*/var ReplacementDialogContainer=function(_Component){_inherits(ReplacementDialogContainer,_Component);function ReplacementDialogContainer(){_classCallCheck(this,ReplacementDialogContainer);return _possibleConstructorReturn(this,(ReplacementDialogContainer.__proto__||Object.getPrototypeOf(ReplacementDialogContainer)).apply(this,arguments));}_createClass(ReplacementDialogContainer,[{key:'setProduct',value:function setProduct(product){if(!product){return;}this.props.fetchReplacementVariants(product.id);this.props.setReplacement({productId:product.id,productName:product.name,variantId:null,variantName:null});}},{key:'setVariant',value:function setVariant(variant){if(!variant){return;}this.props.setReplacement(_extends({},this.props.replacement,{variantId:variant.id,variantName:variant.name}));}},{key:'onCloseDialog',value:function onCloseDialog(){var replacement=this.props.replacement;if(!replacement||!replacement.productId||!replacement.variantId){this.props.setReplacement(null);}this.props.toggleReplacementDialog(false);}},{key:'onOpenDialog',value:function onOpenDialog(){var _props=this.props,replacement=_props.replacement,fetchReplacementProducts=_props.fetchReplacementProducts,fetchReplacementVariants=_props.fetchReplacementVariants;fetchReplacementProducts();if(replacement&&replacement.productId){fetchReplacementVariants(replacement.productId);}}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,replacement=_props2.replacement,show=_props2.show,products=_props2.products,variants=_props2.variants,variantsIsFetching=_props2.variantsIsFetching,productsIsFetching=_props2.productsIsFetching;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:function onClose(){return _this2.onCloseDialog();},onOpen:function onOpen(){return _this2.onOpenDialog();},show:show},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:variantsIsFetching||productsIsFetching}),_react2.default.createElement(_SelectFormInput2.default,{input:{value:replacement?replacement.productId:null,onBlur:_noop3.default,onChange:function onChange(product){return _this2.setProduct(product);}},label:'Produkt',meta:{},valueKey:'id',labelKey:'name',options:products}),_react2.default.createElement(_SelectFormInput2.default,{input:{value:replacement?replacement.variantId:null,onBlur:_noop3.default,onChange:function onChange(variant){return _this2.setVariant(variant);}},label:'Variant',meta:{},valueKey:'id',labelKey:'name',options:variants}),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:function onClick(){return _this2.onCloseDialog();}},'St\xE4ng')));}}]);return ReplacementDialogContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$productView$repl=_ref.productView.replacement,show=_ref$productView$repl.show,_ref$productView$repl2=_ref$productView$repl.products,productsIsFetching=_ref$productView$repl2.isFetching,products=_ref$productView$repl2.list,_ref$productView$repl3=_ref$productView$repl.variants,variantsIsFetching=_ref$productView$repl3.isFetching,variants=_ref$productView$repl3.list;return{show:show,variants:variants,products:products,variantsIsFetching:variantsIsFetching,productsIsFetching:productsIsFetching};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchReplacementProducts:function fetchReplacementProducts(){return dispatch((0,_productView.fetchReplacementProducts)());},fetchReplacementVariants:function fetchReplacementVariants(id){return dispatch((0,_productView.fetchReplacementVariants)(id));},toggleReplacementDialog:function toggleReplacementDialog(show){return dispatch((0,_productView.toggleReplacementDialog)(show));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ReplacementDialogContainer);

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _head2=__webpack_require__(237);var _head3=_interopRequireDefault(_head2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactDropzone=__webpack_require__(257);var _reactDropzone2=_interopRequireDefault(_reactDropzone);var _VariantImage=__webpack_require__(1166);var _VariantImage2=_interopRequireDefault(_VariantImage);__webpack_require__(1168);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fileUrl=_request.apiBase+'/files';/*:: export type Props = {
  onDrop: Function,
  onActiveImage: Function,
  onDefaultImage: Function,
  onRemoveImage: Function,
  images: any[],
  imagesInProgress: any[],
  activeImage?: any,
  activeVariant?: any,
};*/var _ref2=_react2.default.createElement('label',null,'Standardbild');var _ref3=_react2.default.createElement('label',null,'Variantbilder');var _ref4=_react2.default.createElement('span',null,'Sl\xE4pp en bild h\xE4r f\xF6r att ladda upp');var ProductVariantImages=function(_Component){_inherits(ProductVariantImages,_Component);function ProductVariantImages(){_classCallCheck(this,ProductVariantImages);return _possibleConstructorReturn(this,(ProductVariantImages.__proto__||Object.getPrototypeOf(ProductVariantImages)).apply(this,arguments));}_createClass(ProductVariantImages,[{key:'openDropzone',value:function openDropzone(){if(this._dropzone){this._dropzone.open();}}},{key:'render',value:function render(){var _this2=this;var _props=this.props,images=_props.images,imagesInProgress=_props.imagesInProgress,activeVariant=_props.activeVariant,activeImage=_props.activeImage,onDrop=_props.onDrop,onActiveImage=_props.onActiveImage,onDefaultImage=_props.onDefaultImage,onRemoveImage=_props.onRemoveImage;var _ref=activeVariant||{},_ref$id=_ref.id,variantId=_ref$id===undefined?0:_ref$id;var defaultImage=(0,_find3.default)('isDefault',images);var currentImage=activeImage||defaultImage||(0,_head3.default)(images);var url=void 0,name=void 0;if(currentImage){url=fileUrl+'/preview/'+currentImage.id+'/340';name=currentImage.name;}return _react2.default.createElement('div',{className:'ProductVariantImages'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_ref2,_react2.default.createElement('div',{className:'ProductVariantImages-preview'},currentImage&&_react2.default.createElement('img',{className:'ProductVariantImages-preview-image',src:url,alt:name}),currentImage&&_react2.default.createElement('button',{onClick:function onClick(){return onDefaultImage(currentImage);},disabled:defaultImage&&currentImage.id===defaultImage.id,type:'button',className:'button ProductVariantImages-default-button'},'S\xE4tt standardbild'))),_react2.default.createElement('div',{className:'small-6 column'},_ref3,_react2.default.createElement(_reactDropzone2.default,{onDrop:function(_onDrop){function onDrop(_x){return _onDrop.apply(this,arguments);}onDrop.toString=function(){return _onDrop.toString();};return onDrop;}(function(files){return onDrop(variantId,files);}),disableClick:true,multiple:false,accept:'image/*',ref:function ref(_ref5){return _this2._dropzone=_ref5;},className:'ProductVariantImages-Dropzone'},images.length||imagesInProgress.length?_react2.default.createElement('ul',{className:'ProductVariantImages-menu'},!!images.length&&(0,_map3.default)(function(image){return _react2.default.createElement(_VariantImage2.default,{classes:{active:currentImage&&image.id===currentImage.id},key:image.id,name:image.name,url:fileUrl+'/preview/'+image.id+'/20',onActiveImage:function(_onActiveImage){function onActiveImage(){return _onActiveImage.apply(this,arguments);}onActiveImage.toString=function(){return _onActiveImage.toString();};return onActiveImage;}(function(){return onActiveImage(image);}),onRemoveImage:function(_onRemoveImage){function onRemoveImage(){return _onRemoveImage.apply(this,arguments);}onRemoveImage.toString=function(){return _onRemoveImage.toString();};return onRemoveImage;}(function(){return onRemoveImage(variantId,image.id);})});},images),!!imagesInProgress.length&&(0,_map3.default)(function(image){return _react2.default.createElement(_VariantImage2.default,{classes:{'has-error':!!image.error},key:image.tempId,name:image.file.name,url:image.file.preview,onRemoveImage:function(_onRemoveImage2){function onRemoveImage(){return _onRemoveImage2.apply(this,arguments);}onRemoveImage.toString=function(){return _onRemoveImage2.toString();};return onRemoveImage;}(function(){return onRemoveImage(variantId,image.tempId,true);})});},imagesInProgress)):_ref4),_react2.default.createElement('button',{onClick:function onClick(){return _this2.openDropzone();},type:'button',className:'button ProductVariantImages-new-button'},'Ladda upp ny bild'))));}}]);return ProductVariantImages;}(_react.Component);exports.default=ProductVariantImages;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1167);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  classes?: any,
  name: string,
  url: string,
  onRemoveImage: Function,
  onActiveImage?: Function,
};*/var _ref2=_react2.default.createElement('i',{className:'fa fa-close'});var VariantImage=function VariantImage(_ref){var _ref$classes=_ref.classes,classes=_ref$classes===undefined?{}:_ref$classes,name=_ref.name,url=_ref.url,onActiveImage=_ref.onActiveImage,onRemoveImage=_ref.onRemoveImage;return _react2.default.createElement('li',{className:(0,_classnames2.default)(_extends({'VariantImage':true},classes))},_react2.default.createElement('div',{className:'VariantImage-thumb'},_react2.default.createElement('img',{src:url,alt:name})),_react2.default.createElement('a',{className:'VariantImage-thumb-link',onClick:function onClick(){return onActiveImage&&onActiveImage();}},name),_react2.default.createElement('button',{className:'VariantImage-remove-button',onClick:function onClick(){return onRemoveImage();}},_ref2));};exports.default=VariantImage;

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1170);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  title: string,
  tabs: any[],
  includeArchived: boolean,
  onArchivedChanged: Function,
  onSelect: Function,
  onAdd: Function,
};*/var _ref2=_react2.default.createElement('hr',null);var FormTabs=function FormTabs(_ref){var title=_ref.title,tabs=_ref.tabs,onSelect=_ref.onSelect,onAdd=_ref.onAdd,onArchivedChanged=_ref.onArchivedChanged,includeArchived=_ref.includeArchived;return _react2.default.createElement('div',{className:'FormTabs'},_react2.default.createElement('div',{className:'title'},_react2.default.createElement('span',null,title)),_react2.default.createElement('div',null,_react2.default.createElement('input',{className:'archive-toggle',value:includeArchived,type:'checkbox',onChange:function onChange(e){return onArchivedChanged(!!e.target.checked);}}),'Visa arkiverade'),(0,_map3.default)(function(t){return _react2.default.createElement('div',{className:(0,_classnames2.default)({'form-tab':true,active:t.active}),onClick:function onClick(){return onSelect(t);},key:t.id},t.label);},tabs),_ref2,_react2.default.createElement('div',{className:'tools'},_react2.default.createElement('button',{onClick:function onClick(){return onAdd();},type:'button',className:'button small expanded'},'L\xE4gg till')));};exports.default=FormTabs;

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _reactRedux=__webpack_require__(2);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _productView=__webpack_require__(169);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _LinkedAdditionalVariantForm=__webpack_require__(1172);var _LinkedAdditionalVariantForm2=_interopRequireDefault(_LinkedAdditionalVariantForm);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var additionalValidation={product:{rule:'required',label:'Produkt'},productVariant:{rule:'required',label:'Variant'},quantity:{rule:'numeric|min:0|required',label:'Antal'}};var additionalColumns=[{property:'productVariant.name',header:{label:'Variant'}},{property:'product.name',header:{label:'Produkt'}},{property:'quantity',header:{label:'Antal'}},{property:'note',header:{label:'Kommentar'}}];/*:: export type Props = {
  setActive: Function,
  fetchAdditionalProducts: Function,
  fetchAdditionalVariants: Function,
  active: any,
  variants: any[],
  products: any[],
  existing: any[],
  variantsIsFetching: boolean,
  productsIsFetching: boolean,
  addAdditional: Function,
  updateAdditional: Function,
  removeAdditional: Function,
  additionalFormValues: any,
  additionalFormIsValid: boolean,
  touch: typeof touch,
};*/var LinkedAdditionalVariantsContainer=function(_Component){_inherits(LinkedAdditionalVariantsContainer,_Component);function LinkedAdditionalVariantsContainer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LinkedAdditionalVariantsContainer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LinkedAdditionalVariantsContainer.__proto__||Object.getPrototypeOf(LinkedAdditionalVariantsContainer)).call.apply(_ref,[this].concat(args))),_this),_this.handleSelectProductId=function(id){_this.props.fetchAdditionalVariants(id);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LinkedAdditionalVariantsContainer,[{key:'closeDialog',value:function closeDialog(){this.props.setActive(null);}},{key:'onOpenDialog',value:function onOpenDialog(){this.props.fetchAdditionalProducts();}},{key:'save',value:function save(){var _props=this.props,active=_props.active,touch=_props.touch,additionalFormValues=_props.additionalFormValues,additionalFormIsValid=_props.additionalFormIsValid,addAdditional=_props.addAdditional,updateAdditional=_props.updateAdditional;var keys=(0,_keys3.default)(additionalValidation);touch.apply(undefined,['linkedAdditionalVariant'].concat(_toConsumableArray(keys)));if(!additionalFormIsValid){return;}if(!active.productVariant){addAdditional(additionalFormValues);}else{updateAdditional(additionalFormValues);}this.closeDialog();}},{key:'remove',value:function remove(additional){this.props.removeAdditional(additional);this.closeDialog();}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,active=_props2.active,products=_props2.products,variants=_props2.variants,variantsIsFetching=_props2.variantsIsFetching,productsIsFetching=_props2.productsIsFetching,existing=_props2.existing,setActive=_props2.setActive;return _react2.default.createElement('div',{className:'LinkedAdditionalVariantsContainer'},_react2.default.createElement(_AdminList2.default,{rowKey:function rowKey(_ref2){var rowData=_ref2.rowData;return rowData.productVariant.id;},onRowSelected:function onRowSelected(row){return setActive(row);},columns:additionalColumns,rows:existing}),_react2.default.createElement('button',{onClick:function onClick(){return setActive({});},type:'button',className:'button small'},'L\xE4gg till till\xE4ggsprodukt'),_react2.default.createElement(_ModalDialog2.default,{onClose:function onClose(){return _this2.closeDialog();},onOpen:function onOpen(){return _this2.onOpenDialog();},show:!!active},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:variantsIsFetching||productsIsFetching}),_react2.default.createElement(_LinkedAdditionalVariantForm2.default,{initialValues:active,editing:!!active&&!!active.productVariant,existing:existing,products:products,variants:variants,onSelectProduct:this.handleSelectProductId,validate:function validate(values){return(0,_validator2.default)(additionalValidation,values);}}),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:function onClick(){return _this2.save();}},'Spara'),active&&active.productVariant&&_react2.default.createElement('button',{type:'button',className:'expanded warning button',onClick:function onClick(){return _this2.remove(active);}},'Ta bort'),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:function onClick(){return _this2.closeDialog();}},'St\xE4ng')));}}]);return LinkedAdditionalVariantsContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref3){var _ref3$productView$lin=_ref3.productView.linkedAdditionalVariantDialog,_ref3$productView$lin2=_ref3$productView$lin.products,productsIsFetching=_ref3$productView$lin2.isFetching,products=_ref3$productView$lin2.list,_ref3$productView$lin3=_ref3$productView$lin.variants,variantsIsFetching=_ref3$productView$lin3.isFetching,variants=_ref3$productView$lin3.list,form=_ref3.form;return{variants:variants,products:products,variantsIsFetching:variantsIsFetching,productsIsFetching:productsIsFetching,additionalFormIsValid:(0,_reduxForm.isValid)('linkedAdditionalVariant')({form:form}),additionalFormValues:(0,_reduxForm.getFormValues)('linkedAdditionalVariant')({form:form})};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchAdditionalProducts:function fetchAdditionalProducts(){return dispatch((0,_productView.fetchAdditionalProducts)());},fetchAdditionalVariants:function fetchAdditionalVariants(id){return dispatch((0,_productView.fetchAdditionalVariants)(id));},touch:function touch(form){for(var _len2=arguments.length,fields=Array(_len2>1?_len2-1:0),_key2=1;_key2<_len2;_key2++){fields[_key2-1]=arguments[_key2];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(LinkedAdditionalVariantsContainer);

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);var _DecimalFormInput=__webpack_require__(70);var _DecimalFormInput2=_interopRequireDefault(_DecimalFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  editing: boolean,
  existing: any[],
  products: any[],
  variants: any[],
  change: Function,
  onSelectProduct: Function,
};*/var _ref2=_react2.default.createElement(_reduxForm.Field,{name:'quantity',label:'Antal',component:_DecimalFormInput2.default});var _ref3=_react2.default.createElement(_reduxForm.Field,{name:'note',label:'Anteckning',component:_TextAreaFormInput2.default});var LinkedAdditionalVariantForm=function LinkedAdditionalVariantForm(_ref){var editing=_ref.editing,existing=_ref.existing,products=_ref.products,variants=_ref.variants,change=_ref.change,onSelectProduct=_ref.onSelectProduct;return _react2.default.createElement('div',{className:'LinkedAdditionalVariantForm'},_react2.default.createElement(_reduxForm.Field,{name:'product',label:'Produkt',disabled:editing,deleteRemoves:false,normalize:function normalize(value){var id=value?value.id:null;change('variant',null);onSelectProduct(id);return value;},component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:products}),_react2.default.createElement(_reduxForm.Field,{name:'productVariant',label:'Variant',disabled:editing,deleteRemoves:false,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:(0,_map3.default)(function(v){return _extends({},v,{disabled:(0,_some3.default)(function(e){return e.productVariant.id===v.id;},existing)});},variants)}),_ref2,_ref3);};exports.default=(0,_reduxForm.reduxForm)({form:'linkedAdditionalVariant',enableReinitialize:true})(LinkedAdditionalVariantForm);

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _productList=__webpack_require__(388);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);var _reactTooltip=__webpack_require__(91);var _reactTooltip2=_interopRequireDefault(_reactTooltip);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _ref2=_react2.default.createElement('i',{className:'fa fa-code-fork'});var hasRelatedFormatter=function hasRelatedFormatter(variant){return function(hasRelated,_ref){var rowIndex=_ref.rowIndex;return!!hasRelated?_react2.default.createElement('div',{'data-tip':true,'data-for':'has-related-tip-'+rowIndex},_react2.default.createElement(_reactTooltip2.default,{id:'has-related-tip-'+rowIndex,effect:'solid'},_react2.default.createElement('span',null,!!variant?'Varianten tillhör':'Detta är',' en kombinationsprodukt')),_ref2):'';};};var variantColumns=[{property:'externalItemNumber',header:{label:'Artikelnummer'}},{property:'name',header:{label:'Namn'}},{property:'product.productType.name',header:{label:'Produkttyp'}},{property:'sellingPrice',header:{label:'Pris'}},{property:'hasRelated',header:{label:''},cell:{formatters:[hasRelatedFormatter(true)]}}];var productColumns=[{property:'mainVariant.externalItemNumber',header:{label:'Artikelnummer'}},{property:'name',header:{label:'Namn'}},{property:'productType.name',header:{label:'Produkttyp'}},{property:'mainVariant.sellingPrice',header:{label:'Pris'}},{property:'hasRelated',header:{label:''},cell:{formatters:[hasRelatedFormatter(false)]}}];/*:: export type Props = {
  history: Object,
  fetchData: Function,
  filterProducts: Function,
  location: { pathname: string },
  list: any[],
  productTypes: any[],
  productTypesIsFetching: boolean,
  filter: {
    archived: boolean,
    productType: ?number,
    query: ?string,
    showVariants: boolean,
  },
  isFetching: boolean,
  sortItems: typeof sortItems,
};*/var ProductsContainer=function(_Component){_inherits(ProductsContainer,_Component);function ProductsContainer(){_classCallCheck(this,ProductsContainer);return _possibleConstructorReturn(this,(ProductsContainer.__proto__||Object.getPrototypeOf(ProductsContainer)).apply(this,arguments));}_createClass(ProductsContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,filter=_props.filter,productTypes=_props.productTypes,filterProducts=_props.filterProducts,productTypesIsFetching=_props.productTypesIsFetching,pathname=_props.location.pathname,isFetching=_props.isFetching,list=_props.list,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'ProductsContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:function onClear(e){return filterProducts(_extends({},filter,{query:''}));},onChange:function onChange(e){return filterProducts(_extends({},filter,{query:e.target.value}));}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa ny'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:filter.productType||null,onBlur:_noop3.default,onChange:function onChange(type){return filterProducts(_extends({},filter,{productType:type?type.id:null}));}},label:'Produkttyp',meta:{},valueKey:'id',labelKey:'name',clearable:true,options:productTypes,isLoading:productTypesIsFetching})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:function onChange(archived){return filterProducts(_extends({},filter,{archived:archived?archived.value:false}));}},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.showVariants,onBlur:_noop3.default,onChange:function onChange(show){return filterProducts(_extends({},filter,{showVariants:show?show.value:false}));}},label:'Visa varianter',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),list&&_react2.default.createElement(_AdminList2.default,{columns:filter.showVariants?variantColumns:productColumns,rows:list,onSort:sortItems,onRowSelected:function onRowSelected(row){var path=pathname+'/';if(!!filter.showVariants){path+=row.product.id+'/variants/'+row.id;}else{path+=row.id;}history.push(path);}})));}}]);return ProductsContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref3){var _ref3$productList=_ref3.productList,filter=_ref3$productList.filter,isFetching=_ref3$productList.isFetching,list=_ref3$productList.filteredList,_ref3$productList$pro=_ref3$productList.productTypes,productTypesIsFetching=_ref3$productList$pro.isFetching,productTypes=_ref3$productList$pro.list;return{filter:filter,isFetching:isFetching,list:list,productTypes:productTypes,productTypesIsFetching:productTypesIsFetching};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchData:function fetchData(){dispatch((0,_productList.fetchProducts)());dispatch((0,_productList.fetchProductTypes)());},filterProducts:function filterProducts(filter){return dispatch((0,_productList.filterProducts)(filter));},sortItems:function sortItems(sorter){return dispatch((0,_productList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ProductsContainer));

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _roomTypeList=__webpack_require__(379);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=[{property:'name',header:{label:'Namn'}},{property:'identifier',header:{label:'Kod'}}];/*:: export type Props = {
  history: Object,
  fetchRoomTypes: Function,
  filterRoomTypes: Function,
  location: { pathname: string },
  filter: {
    archived: boolean,
    query?: string,
  },
  roomTypes?: any[],
  isFetching: boolean,
  sortItems: typeof sortItems,
};*/var RoomTypesContainer=function(_Component){_inherits(RoomTypesContainer,_Component);function RoomTypesContainer(){_classCallCheck(this,RoomTypesContainer);return _possibleConstructorReturn(this,(RoomTypesContainer.__proto__||Object.getPrototypeOf(RoomTypesContainer)).apply(this,arguments));}_createClass(RoomTypesContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchRoomTypes();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,filter=_props.filter,roomTypes=_props.roomTypes,filterRoomTypes=_props.filterRoomTypes,pathname=_props.location.pathname,isFetching=_props.isFetching,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'RoomTypesContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:function onClear(e){return filterRoomTypes('',filter.archived);},onChange:function onChange(e){return filterRoomTypes(e.target.value,filter.archived);}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa ny'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:function onChange(archived){return filterRoomTypes(filter.query,archived?archived.value:false);}},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),roomTypes&&_react2.default.createElement('div',{className:'box'},_react2.default.createElement(_AdminList2.default,{query:filter.query,columns:columns,rows:roomTypes,onSort:sortItems,onRowSelected:function onRowSelected(row){return history.push(pathname+'/'+row.id);}}))));}}]);return RoomTypesContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$roomTypeList=_ref.roomTypeList,filter=_ref$roomTypeList.filter,isFetching=_ref$roomTypeList.isFetching,roomTypes=_ref$roomTypeList.filteredList;return{isFetching:isFetching,roomTypes:roomTypes,filter:filter};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchRoomTypes:function fetchRoomTypes(){return dispatch((0,_roomTypeList.fetchRoomTypes)());},filterRoomTypes:function filterRoomTypes(query,archived){return dispatch((0,_roomTypeList.filterRoomTypes)(query,archived));},sortItems:function sortItems(sorter){return dispatch((0,_roomTypeList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(RoomTypesContainer));

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _roomTypeView=__webpack_require__(378);var _reduxForm=__webpack_require__(4);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _RoomTypeForm=__webpack_require__(1177);var _RoomTypeForm2=_interopRequireDefault(_RoomTypeForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createValidation={name:{rule:'string|required',label:'Namn'}};var editValidation={name:{rule:'string|required',label:'Namn'},archived:{rule:'archivable',label:'Arkiverad'}};/*:: export type Props = {
  setDirty: Function,
  reset: Function,
  touch: Function,
  resetForm: Function,
  roomTypeFormValues?: any,
  roomTypeFormIsValid?: boolean,
  isDirty: boolean,
  fetchRoomType: Function,
  updateRoomType: Function,
  createRoomType: Function,
  clearRoomType: Function,
  isFetching: boolean,
  prevPath: string,
  roomType?: any,
  params: any,
  error?: any,
  roomTypes: any[],
};*/var RoomTypeContainer=function(_Component){_inherits(RoomTypeContainer,_Component);function RoomTypeContainer(){_classCallCheck(this,RoomTypeContainer);return _possibleConstructorReturn(this,(RoomTypeContainer.__proto__||Object.getPrototypeOf(RoomTypeContainer)).apply(this,arguments));}_createClass(RoomTypeContainer,[{key:'componentWillMount',value:function componentWillMount(){var id=this.props.params.id;if(id){this.props.fetchRoomType(id);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clearRoomType();}},{key:'setDirty',value:function setDirty(){var _props=this.props,setDirty=_props.setDirty,isDirty=_props.isDirty;if(!isDirty){setDirty(true);}}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('roomType');setDirty(false);}},{key:'save',value:function save(){var _props3=this.props,roomTypeFormValues=_props3.roomTypeFormValues,touch=_props3.touch,roomTypeFormIsValid=_props3.roomTypeFormIsValid,roomType=_props3.roomType,updateRoomType=_props3.updateRoomType,createRoomType=_props3.createRoomType;var create=!roomType;var roomTypeKeys=(0,_keys3.default)(create?createValidation:editValidation);touch.apply(undefined,['roomType'].concat(_toConsumableArray(roomTypeKeys)));if(!roomTypeFormIsValid){return;}if(!roomType){createRoomType(roomTypeFormValues);}else{updateRoomType(roomType.id,roomTypeFormValues);}}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,isDirty=_props4.isDirty,id=_props4.params.id,roomType=_props4.roomType,error=_props4.error,isFetching=_props4.isFetching,updateRoomType=_props4.updateRoomType,prevPath=_props4.prevPath,clearRoomType=_props4.clearRoomType,fetchRoomType=_props4.fetchRoomType,roomTypes=_props4.roomTypes;var validation={};if(!id){validation.required=true;}return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:roomType,list:roomTypes,prevPath:prevPath,clear:clearRoomType,fetchData:fetchRoomType}),_react2.default.createElement('div',{className:'content-title'},roomType&&roomType.name||'Ny rumstyp'))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},roomType&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveRoomType',className:'secondary button',message:'Vill du verkligen '+(roomType.archived?'av':'')+'arkivera den h\xE4r rumstypen?',buttonText:roomType.archived?'Avarkivera':'Arkivera',action:function action(){return updateRoomType(roomType.id,{archived:!roomType.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},id?_react2.default.createElement(_RoomTypeForm2.default,{initialValues:roomType,onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(editValidation,values);}}):roomType?_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath}):_react2.default.createElement(_RoomTypeForm2.default,{onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(createValidation,values);}})),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return RoomTypeContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$roomTypeView=_ref.roomTypeView,roomType=_ref$roomTypeView.active,error=_ref$roomTypeView.error,isFetching=_ref$roomTypeView.isFetching,isDirty=_ref$roomTypeView.isDirty,roomTypes=_ref.roomTypeList.filteredList,form=_ref.form;return{error:error,isDirty:isDirty,isFetching:isFetching,roomType:roomType,roomTypeFormIsValid:(0,_reduxForm.isValid)('roomType')({form:form}),roomTypeFormValues:(0,_reduxForm.getFormValues)('roomType')({form:form}),roomTypes:roomTypes};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'roomType'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_roomTypeView.reset)());},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},fetchRoomType:function fetchRoomType(id){return dispatch((0,_roomTypeView.fetchRoomType)(id));},updateRoomType:function updateRoomType(id,data){return dispatch((0,_roomTypeView.updateRoomType)(id,data));},createRoomType:function createRoomType(data){return dispatch((0,_roomTypeView.createRoomType)(data));},clearRoomType:function clearRoomType(){return dispatch((0,_roomTypeView.clearRoomType)());}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(RoomTypeContainer);

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  onUserChange: Function,
};*/var RoomTypeForm=function RoomTypeForm(_ref){var onUserChange=_ref.onUserChange;return _react2.default.createElement('div',{className:'RoomTypeForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'identifier',label:'Kod',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}))));};exports.default=(0,_reduxForm.reduxForm)({form:'roomType',enableReinitialize:true})(RoomTypeForm);

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _deviationList=__webpack_require__(375);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=[{property:'name',header:{label:'Namn'}}];/*:: export type Props = {
  history: Object,
  fetchDeviations: Function,
  filterDeviations: Function,
  location: { pathname: string },
  filter: {
    archived: boolean,
    query: ?string,
  },
  deviations: any[],
  isFetching: boolean,
  sortItems: typeof sortItems,
};*/var DeviationsContainer=function(_Component){_inherits(DeviationsContainer,_Component);function DeviationsContainer(){_classCallCheck(this,DeviationsContainer);return _possibleConstructorReturn(this,(DeviationsContainer.__proto__||Object.getPrototypeOf(DeviationsContainer)).apply(this,arguments));}_createClass(DeviationsContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchDeviations();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,filter=_props.filter,deviations=_props.deviations,filterDeviations=_props.filterDeviations,pathname=_props.location.pathname,isFetching=_props.isFetching,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'DeviationsContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:function onClear(e){return filterDeviations('',filter.archived);},onChange:function onChange(e){return filterDeviations(e.target.value,filter.archived);}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa ny'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:function onChange(archived){return filterDeviations(filter.query,archived?archived.value:false);}},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),deviations&&_react2.default.createElement('div',{className:'box'},_react2.default.createElement(_AdminList2.default,{query:filter.query,columns:columns,rows:deviations,onSort:sortItems,onRowSelected:function onRowSelected(row){return history.push(pathname+'/'+row.id);}}))));}}]);return DeviationsContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$deviationList=_ref.deviationList,deviations=_ref$deviationList.filteredList,filter=_ref$deviationList.filter,isFetching=_ref$deviationList.isFetching;return{filter:filter,deviations:deviations,isFetching:isFetching};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchDeviations:function fetchDeviations(){return dispatch((0,_deviationList.fetchDeviations)());},filterDeviations:function filterDeviations(query,archived){return dispatch((0,_deviationList.filterDeviations)(query,archived));},sortItems:function sortItems(sorter){return dispatch((0,_deviationList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DeviationsContainer));

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _exportsView=__webpack_require__(408);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _assortments=__webpack_require__(55);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=[{property:'product',header:{label:'Produkt'}},{property:'variant',header:{label:'Variant'}},{property:'itemNumber',header:{label:'Internt artikelnummer'}},{property:'externalItemNumber',header:{label:'Externt artikelnummer'}},{property:'quantity',header:{label:'Antal'}},{property:'price',header:{label:'Pris totalt'}}];/*:: export type Props = {
  isFetching: boolean,
  fetchFilters: Function,
  fetchData: Function,
  currentSelection: Object,
  filters: Object,
  isProjectSelected: boolean,
};*/var ExportsContainer=function(_Component){_inherits(ExportsContainer,_Component);function ExportsContainer(){_classCallCheck(this,ExportsContainer);return _possibleConstructorReturn(this,(ExportsContainer.__proto__||Object.getPrototypeOf(ExportsContainer)).apply(this,arguments));}_createClass(ExportsContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchFilters();}},{key:'render',value:function render(){var _props=this.props,isFetching=_props.isFetching,filters=_props.filters,currentSelection=_props.currentSelection,fetchData=_props.fetchData,isProjectSelected=_props.isProjectSelected;return _react2.default.createElement('div',{className:'ExportsContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:currentSelection.projects,onBlur:_noop3.default,onChange:function onChange(val){return fetchData(_extends({},currentSelection,{projects:val}));}},label:'Projekt',placeholder:'V\xE4lj projekt',meta:{},valueKey:'id',labelKey:'name',multi:true,options:filters.projects,clearable:false,isLoading:false})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:currentSelection.suppliers,onBlur:_noop3.default,onChange:function onChange(val){return fetchData(_extends({},currentSelection,{suppliers:val}));}},label:'Leverant\xF6rer',placeholder:'Alla',meta:{},valueKey:'id',labelKey:'name',clearable:true,multi:true,disabled:!isProjectSelected,options:filters.suppliers,isLoading:false})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:currentSelection.workerTypes,onBlur:_noop3.default,onChange:function onChange(val){return fetchData(_extends({},currentSelection,{workerTypes:val}));}},label:'Yrkeskategori',placeholder:'Alla',meta:{},valueKey:'id',labelKey:'name',clearable:true,multi:true,disabled:!isProjectSelected,options:filters.workerTypes,isLoading:false}))),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:currentSelection.roomTypes,onBlur:_noop3.default,onChange:function onChange(val){return fetchData(_extends({},currentSelection,{roomTypes:val}));}},label:'Rumstyp',placeholder:'Alla',meta:{},valueKey:'id',labelKey:'name',clearable:true,multi:true,disabled:!isProjectSelected,options:filters.roomTypes,isLoading:false})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:currentSelection.productTypes,onBlur:_noop3.default,onChange:function onChange(val){return fetchData(_extends({},currentSelection,{productTypes:val}));}},label:'Produkttyp',placeholder:'Alla',meta:{},valueKey:'id',labelKey:'name',clearable:true,multi:true,disabled:!isProjectSelected,options:filters.productTypes,isLoading:false})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:currentSelection.assortments,onBlur:_noop3.default,onChange:function onChange(val){return fetchData(_extends({},currentSelection,{assortments:val}));}},label:'Sortiment',placeholder:'Alla',meta:{},valueKey:'id',labelKey:'label',multi:true,disabled:!isProjectSelected,options:[_assortments.assortments[0],_assortments.assortments[2]],clearable:true,isLoading:false}))),_react2.default.createElement('div',{className:'row align-right'},_react2.default.createElement('div',{className:'column shrink'},currentSelection.rows.length>0&&currentSelection.downloadUri&&_react2.default.createElement('a',{href:currentSelection.downloadUri,target:'_blank',className:'button success'},'Ladda ner'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement(_AdminList2.default,{columns:columns,footer:[].concat(_toConsumableArray(Array(4)),[currentSelection.totalQuantity,currentSelection.totalPrice]),rows:currentSelection.rows,rowKey:'itemNumber',pagination:false})));}}]);return ExportsContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$exportsView=_ref.exportsView,filterOptions=_ref$exportsView.filterOptions,currentSelection=_ref$exportsView.currentSelection;return{isFetching:filterOptions.isFetching||currentSelection.isFetching,isProjectSelected:currentSelection.projects!==null&&currentSelection.projects.length>0,filters:filterOptions,currentSelection:currentSelection};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchFilters:function fetchFilters(){return dispatch((0,_exportsView.fetchFilters)());},fetchData:function fetchData(filters){return dispatch((0,_exportsView.fetchData)(filters));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ExportsContainer);

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _request=__webpack_require__(6);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _salesView=__webpack_require__(409);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  isFetching: boolean,
  fetchProjects: Function,
  filter: Function,
  projectId: ?number,
  projects: any[],
};*/var SalesContainer=function(_Component){_inherits(SalesContainer,_Component);function SalesContainer(){_classCallCheck(this,SalesContainer);return _possibleConstructorReturn(this,(SalesContainer.__proto__||Object.getPrototypeOf(SalesContainer)).apply(this,arguments));}_createClass(SalesContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchProjects();}},{key:'render',value:function render(){var _props=this.props,filter=_props.filter,isFetching=_props.isFetching,projects=_props.projects,projectId=_props.projectId;return _react2.default.createElement('div',{className:'SalesContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:projectId,onBlur:_noop3.default,onChange:function onChange(project){return filter(project?project.id:null);}},placeholder:'V\xE4lj projekt',meta:{},valueKey:'id',labelKey:'name',multi:false,options:projects,clearable:false,isLoading:isFetching})),!!projects.length&&!!projectId&&_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('a',{href:_request.apiBase+'/dataexports/sales/'+projectId,target:'_blank',className:'button success'},'Ladda ner'))));}}]);return SalesContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$salesView=_ref.salesView,isFetching=_ref$salesView.isFetching,projects=_ref$salesView.projects,projectId=_ref$salesView.projectId;return{isFetching:isFetching,projects:projects,projectId:projectId};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchProjects:function fetchProjects(){return dispatch((0,_salesView.fetchProjects)());},filter:function filter(projectId){return dispatch((0,_salesView.filter)(projectId));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(SalesContainer);

/***/ }),
/* 1181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _deviationView=__webpack_require__(374);var _reduxForm=__webpack_require__(4);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _DeviationForm=__webpack_require__(1183);var _DeviationForm2=_interopRequireDefault(_DeviationForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var deviationValidation={name:{rule:'string|required',label:'Namn'}};/*:: export type Props = {
  setDirty: Function,
  reset: Function,
  touch: Function,
  resetForm: Function,
  deviationFormValues: any,
  deviationFormIsValid: boolean,
  isDirty: boolean,
  fetchDeviation: Function,
  updateDeviation: Function,
  createDeviation: Function,
  clearDeviation: Function,
  isFetching: boolean,
  prevPath: string,
  deviation: ?any,
  params: any,
  error: ?any,
  deviations: any[],
};*/var DeviationContainer=function(_Component){_inherits(DeviationContainer,_Component);function DeviationContainer(){_classCallCheck(this,DeviationContainer);return _possibleConstructorReturn(this,(DeviationContainer.__proto__||Object.getPrototypeOf(DeviationContainer)).apply(this,arguments));}_createClass(DeviationContainer,[{key:'componentWillMount',value:function componentWillMount(){var id=this.props.params.id;if(id){this.props.fetchDeviation(id);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clearDeviation();}},{key:'setDirty',value:function setDirty(){var _props=this.props,setDirty=_props.setDirty,isDirty=_props.isDirty;if(!isDirty){setDirty(true);}}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('deviation');setDirty(false);}},{key:'save',value:function save(){var _props3=this.props,deviationFormValues=_props3.deviationFormValues,touch=_props3.touch,deviationFormIsValid=_props3.deviationFormIsValid,deviation=_props3.deviation,updateDeviation=_props3.updateDeviation,createDeviation=_props3.createDeviation;var deviationKeys=(0,_keys3.default)(deviationValidation);touch.apply(undefined,['deviation'].concat(_toConsumableArray(deviationKeys)));if(!deviationFormIsValid){return;}if(!deviation){createDeviation(deviationFormValues);}else{updateDeviation(deviation.id,deviationFormValues);}}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,isDirty=_props4.isDirty,id=_props4.params.id,deviation=_props4.deviation,error=_props4.error,isFetching=_props4.isFetching,updateDeviation=_props4.updateDeviation,prevPath=_props4.prevPath,clearDeviation=_props4.clearDeviation,fetchDeviation=_props4.fetchDeviation,deviations=_props4.deviations;return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:deviation,list:deviations,prevPath:prevPath,clear:clearDeviation,fetchData:fetchDeviation}),_react2.default.createElement('div',{className:'content-title'},deviation&&deviation.name||'Ny avvikelse'))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},deviation&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveDeviation',className:'secondary button',message:'Vill du verkligen '+(deviation.archived?'av':'')+'arkivera den h\xE4r avvikelsen?',buttonText:deviation.archived?'Avarkivera':'Arkivera',action:function action(){return updateDeviation(deviation.id,{archived:!deviation.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},id?_react2.default.createElement(_DeviationForm2.default,{initialValues:deviation,deviation:deviation,onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(deviationValidation,values);}}):deviation?_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath}):_react2.default.createElement(_DeviationForm2.default,{onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(deviationValidation,values);}})),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return DeviationContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$deviationView=_ref.deviationView,isDirty=_ref$deviationView.isDirty,deviation=_ref$deviationView.active,error=_ref$deviationView.error,isFetching=_ref$deviationView.isFetching,deviations=_ref.deviationList.filteredList,form=_ref.form;return{isDirty:isDirty,deviationFormIsValid:(0,_reduxForm.isValid)('deviation')({form:form}),deviationFormValues:(0,_reduxForm.getFormValues)('deviation')({form:form}),deviation:deviation,error:error,isFetching:isFetching,deviations:deviations};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'deviation'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_deviationView.reset)());},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},fetchDeviation:function fetchDeviation(id){return dispatch((0,_deviationView.fetchDeviation)(id));},updateDeviation:function updateDeviation(id,data){return dispatch((0,_deviationView.updateDeviation)(id,data));},createDeviation:function createDeviation(data){return dispatch((0,_deviationView.createDeviation)(data));},clearDeviation:function clearDeviation(){return dispatch((0,_deviationView.clearDeviation)());}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(DeviationContainer);

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  onUserChange: Function,
};*/var DeviationForm=function DeviationForm(_ref){var onUserChange=_ref.onUserChange;return _react2.default.createElement('div',{className:'DeviationForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-12 column'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'})))));};exports.default=(0,_reduxForm.reduxForm)({form:'deviation',enableReinitialize:true})(DeviationForm);

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _supplierList=__webpack_require__(405);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=[{property:'name',header:{label:'Namn'}},{property:'contact',header:{label:'Kontakt'}},{property:'phone',header:{label:'Telefon'}},{property:'email',header:{label:'Email'}}];/*:: export type Props = {
  history: Object,
  fetchSuppliers: Function,
  filterSuppliers: Function,
  location: { pathname: string },
  filter: {
    archived: boolean,
    query?: string,
  },
  suppliers?: any[],
  isFetching: boolean,
  sortItems: typeof sortItems,
};*/var SuppliersContainer=function(_Component){_inherits(SuppliersContainer,_Component);function SuppliersContainer(){_classCallCheck(this,SuppliersContainer);return _possibleConstructorReturn(this,(SuppliersContainer.__proto__||Object.getPrototypeOf(SuppliersContainer)).apply(this,arguments));}_createClass(SuppliersContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchSuppliers();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,filter=_props.filter,suppliers=_props.suppliers,filterSuppliers=_props.filterSuppliers,pathname=_props.location.pathname,isFetching=_props.isFetching,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'SuppliersContainer relative'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:function onClear(e){return filterSuppliers('',filter.archived);},onChange:function onChange(e){return filterSuppliers(e.target.value,filter.archived);}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa ny'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:function onChange(archived){return filterSuppliers(filter.query,archived?archived.value:false);}},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),suppliers&&_react2.default.createElement('div',{className:'box'},_react2.default.createElement(_AdminList2.default,{query:filter.query,columns:columns,rows:suppliers,onSort:sortItems,onRowSelected:function onRowSelected(row){return history.push(pathname+'/'+row.id);}}))));}}]);return SuppliersContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$supplierList=_ref.supplierList,suppliers=_ref$supplierList.filteredList,filter=_ref$supplierList.filter,isFetching=_ref$supplierList.isFetching;return{filter:filter,suppliers:suppliers,isFetching:isFetching};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchSuppliers:function fetchSuppliers(){return dispatch((0,_supplierList.fetchSuppliers)());},filterSuppliers:function filterSuppliers(query,archived){return dispatch((0,_supplierList.filterSuppliers)(query,archived));},sortItems:function sortItems(sorter){return dispatch((0,_supplierList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(SuppliersContainer));

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _supplierView=__webpack_require__(404);var _reduxForm=__webpack_require__(4);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _SupplierForm=__webpack_require__(1186);var _SupplierForm2=_interopRequireDefault(_SupplierForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createValidation={name:{rule:'string|required',label:'Namn'},identifier:{rule:'string|required',label:'Org nr'}};var editValidation={name:{rule:'string|required',label:'Namn'},identifier:{rule:'string|required',label:'Org nr'},archived:{rule:'archivable',label:'Arkiverad'}};/*:: export type Props = {
  setDirty: Function,
  reset: Function,
  touch: Function,
  resetForm: Function,
  supplierFormValues?: any,
  supplierFormIsValid?: boolean,
  isDirty: boolean,
  fetchSupplier: Function,
  updateSupplier: Function,
  createSupplier: Function,
  clearSupplier: Function,
  isFetching: boolean,
  prevPath: string,
  supplier?: any,
  params: any,
  error?: any,
  suppliers: any[],
};*/var SupplierContainer=function(_Component){_inherits(SupplierContainer,_Component);function SupplierContainer(){_classCallCheck(this,SupplierContainer);return _possibleConstructorReturn(this,(SupplierContainer.__proto__||Object.getPrototypeOf(SupplierContainer)).apply(this,arguments));}_createClass(SupplierContainer,[{key:'componentWillMount',value:function componentWillMount(){var id=this.props.params.id;if(id){this.props.fetchSupplier(id);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clearSupplier();}},{key:'setDirty',value:function setDirty(){var _props=this.props,setDirty=_props.setDirty,isDirty=_props.isDirty;if(!isDirty){setDirty(true);}}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('supplier');setDirty(false);}},{key:'save',value:function save(){var _props3=this.props,supplierFormValues=_props3.supplierFormValues,touch=_props3.touch,supplierFormIsValid=_props3.supplierFormIsValid,supplier=_props3.supplier,updateSupplier=_props3.updateSupplier,createSupplier=_props3.createSupplier;var create=!supplier;var supplierKeys=(0,_keys3.default)(create?createValidation:editValidation);touch.apply(undefined,['supplier'].concat(_toConsumableArray(supplierKeys)));if(!supplierFormIsValid){return;}if(!supplier){createSupplier(supplierFormValues);}else{updateSupplier(supplier.id,supplierFormValues);}}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,isDirty=_props4.isDirty,id=_props4.params.id,supplier=_props4.supplier,error=_props4.error,isFetching=_props4.isFetching,updateSupplier=_props4.updateSupplier,prevPath=_props4.prevPath,clearSupplier=_props4.clearSupplier,fetchSupplier=_props4.fetchSupplier,suppliers=_props4.suppliers;return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:supplier,list:suppliers,prevPath:prevPath,clear:clearSupplier,fetchData:fetchSupplier}),_react2.default.createElement('div',{className:'content-title'},supplier&&supplier.name||'Ny leverantör'))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},supplier&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveSupplier',className:'secondary button',message:'Vill du verkligen '+(supplier.archived?'av':'')+'arkivera den h\xE4r leverant\xF6ren?',buttonText:supplier.archived?'Avarkivera':'Arkivera',action:function action(){return updateSupplier(supplier.id,{archived:!supplier.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},id?_react2.default.createElement(_SupplierForm2.default,{initialValues:supplier,onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(editValidation,values);}}):supplier?_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath}):_react2.default.createElement(_SupplierForm2.default,{onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(createValidation,values);}})),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return SupplierContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$supplierView=_ref.supplierView,isDirty=_ref$supplierView.isDirty,supplier=_ref$supplierView.active,error=_ref$supplierView.error,isFetching=_ref$supplierView.isFetching,suppliers=_ref.supplierList.filteredList,form=_ref.form;return{isDirty:isDirty,supplierFormIsValid:(0,_reduxForm.isValid)('supplier')({form:form}),supplierFormValues:(0,_reduxForm.getFormValues)('supplier')({form:form}),supplier:supplier,error:error,isFetching:isFetching,suppliers:suppliers};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'supplier'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_supplierView.reset)());},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},fetchSupplier:function fetchSupplier(id){return dispatch((0,_supplierView.fetchSupplier)(id));},updateSupplier:function updateSupplier(id,data){return dispatch((0,_supplierView.updateSupplier)(id,data));},createSupplier:function createSupplier(data){return dispatch((0,_supplierView.createSupplier)(data));},clearSupplier:function clearSupplier(){return dispatch((0,_supplierView.clearSupplier)());}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(SupplierContainer);

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  onUserChange: Function,
};*/var SupplierForm=function SupplierForm(_ref){var onUserChange=_ref.onUserChange;return _react2.default.createElement('div',{className:'supplierForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'identifier',label:'Org nr',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'address',label:'Adress',onChange:onUserChange,component:_TextAreaFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'contact',label:'Kontakt',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'phone',label:'Telefonnummer',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'email',label:'Email',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'note',label:'Notering',onChange:onUserChange,component:_TextAreaFormInput2.default,type:'text'}))));};exports.default=(0,_reduxForm.reduxForm)({form:'supplier',enableReinitialize:true})(SupplierForm);

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _pick2=__webpack_require__(86);var _pick3=_interopRequireDefault(_pick2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _reduxForm=__webpack_require__(4);var _orderView=__webpack_require__(396);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _OrderForm=__webpack_require__(1189);var _OrderForm2=_interopRequireDefault(_OrderForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _ProductRowDialog=__webpack_require__(486);var _ProductRowDialog2=_interopRequireDefault(_ProductRowDialog);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _orderStates=__webpack_require__(69);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);var _ProductRowList=__webpack_require__(487);var _ProductRowList2=_interopRequireDefault(_ProductRowList);var _OrderRowNoteDialog=__webpack_require__(488);var _OrderRowNoteDialog2=_interopRequireDefault(_OrderRowNoteDialog);var _OrderCommentDialog=__webpack_require__(1261);var _OrderCommentDialog2=_interopRequireDefault(_OrderCommentDialog);var _moment=__webpack_require__(256);var _moment2=_interopRequireDefault(_moment);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var orderValidation={apartmentId:{rule:'numeric|required',label:'Lägenhet'},projectId:{rule:'numeric|required',label:'Projekt'},salesUserId:{rule:'numeric|required',label:'Säljare'},userId:{rule:'numeric|required',label:'Kund'}};var noteRowValidation={note:{rule:'string',label:'Anteckning'}};var orderCommentValidation={workerTypeId:{rule:'numeric|required_without:roomTypeId',label:'Yrkeskategori'},roomTypeId:{rule:'numeric|required_without:workerTypeId',label:'Rumstyp'},note:{rule:'string|required',label:'Kommentar'}};var extraRowValidation={roomId:{rule:'numeric|required',label:'Rum'},product:{rule:'required',label:'Produkt'},productVariant:{rule:'required',label:'Variant'},quantity:{rule:'numeric|min:0|required',label:'Antal'}};var orderCommentColumns=[{property:'roomType.name',header:{label:'Rumstyp'},props:{style:{width:200}}},{property:'workerType.name',header:{label:'Yrkeskategori'},props:{style:{width:200}}},{property:'note',header:{label:'Kommentar'}}];var customRowColumns=[{property:'name',header:{label:'Namn'}},{property:'totalSellingPrice',header:{label:'Pris'}},{property:'quantity',header:{label:'Antal'}}];var orderChangeColumns=[{property:'type',cell:{formatters:[function(val){switch(val){case'add':return'Tillagd';case'remove':return'Borttagen';case'update':return'Ändrad';default:return val;}}]},header:{label:'Typ'}},{property:'user',cell:{formatters:[function(val){return val?val.email:'-';}]},header:{label:'Email'}},{property:'productSlot',cell:{formatters:[function(val){return val?val.room.name:'-';}]},header:{label:'Rum'}},{property:'oldVariant',cell:{formatters:[function(val){return val?val.product.name+' - '+val.name:'-';}]},header:{label:'Från'}},{property:'newVariant',cell:{formatters:[function(val){return val?val.product.name+' - '+val.name:'-';}]},header:{label:'Till'}},{property:'created',cell:{formatters:[function(val){return(0,_moment2.default)(val).format('YYYY-MM-DD');}]},header:{label:'Tid'}}];/*:: export type Props = {
  history: Object,
  orderComplete: boolean,
  updateOrderRows: typeof updateOrderRows,
  clearOrderRows:  typeof clearOrderRows,
  setDirty: (dirty: boolean) => any,
  reset: typeof reset,
  resetForm: typeof resetForm,
  isDirty: boolean,
  order: ?any,
  apartments: Object,
  clear: typeof clear,
  createOrder: typeof createOrder,
  error: ?any,
  fetchData: typeof fetchData,
  isFetching: boolean,
  params: any,
  prevPath: string,
  projects: any[],
  updateOrder: typeof updateOrder,
  users: any[],
  salesUsers: any[],
  specialProducts: Object,
  productTypes: any[],
  orderFormValues: any,
  orderFormIsValid: boolean,
  touch: typeof touch,
  customRows: any[],
  rows: any[],
  noteRow: ?any,
  noteRowError: ?any,
  noteRowIsFetching: boolean,
  noteRowIsExtra: boolean,
  noteRowFormValues: any,
  noteRowFormIsValid: boolean,
  setNoteRow: typeof setNoteRow,
  updateOrderRow: typeof updateOrderRow,
  orderComment: ?any,
  orderCommentError: ?any,
  orderCommentIsFetching: boolean,
  orderCommentFormValues: any,
  orderCommentFormIsValid: boolean,
  setActiveComment: typeof setActiveComment,
  addOrderComment: typeof addOrderComment,
  updateOrderComment: typeof updateOrderComment,
  removeOrderComment: typeof removeOrderComment,
  extraRows: any[],
  allRowsByRoom: any[],
  extraRowFormValues: any,
  extraRowFormIsValid: boolean,
  extraRow: ?any,
  extraRowError: ?any,
  extraRowIsFetching: boolean,
  setActiveExtraRow: typeof setActiveExtraRow,
  createExtraRow: typeof createExtraRow,
  updateExtraRow: typeof updateExtraRow,
  removeExtraRow: typeof removeExtraRow,
  fetchExtraRowProducts: typeof fetchActiveExtraRowProducts,
  extraRowProducts: any[],
  extraRowProductsAreFetching: boolean,
  fetchExtraRowVariants: typeof fetchActiveExtraRowVariants,
  extraRowVariants: any[],
  extraRowVariantsAreFetching: boolean,
  rooms: any[],
  roomTypes: any[],
  workerTypes: any[],
  suppliers: any[],
  reportFilter: {
    includePlans: boolean,
    supplierId: ?number,
  },
  updateReportFilter: typeof updateReportFilter,
  userOrderFilter: {
    includePlans: boolean,
  },
  updateUserOrderFilter: typeof updateUserOrderFilter,
  orders: any[],
  orderTotalPrice: number,
};*/var _ref=_react2.default.createElement('div',{className:'box-title'},'Kommentar f\xF6r rum och yrkeskategori');var _ref2=_react2.default.createElement('div',{className:'box-title'},'Produkter');var _ref3=_react2.default.createElement('span',{className:'box-title'},'Friprodukter');var _ref4=_react2.default.createElement('div',{className:'box-title'},'Order f\xF6r\xE4ndringar');var OrderContainer=function(_Component){_inherits(OrderContainer,_Component);function OrderContainer(){_classCallCheck(this,OrderContainer);return _possibleConstructorReturn(this,(OrderContainer.__proto__||Object.getPrototypeOf(OrderContainer)).apply(this,arguments));}_createClass(OrderContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData(this.props.params.id);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clear();}},{key:'setDirty',value:function setDirty(){var _props=this.props,setDirty=_props.setDirty,isDirty=_props.isDirty;if(!isDirty){setDirty(true);}}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('order');setDirty(false);}},{key:'save',value:function save(){var _props3=this.props,orderFormValues=_props3.orderFormValues,touch=_props3.touch,orderFormIsValid=_props3.orderFormIsValid,order=_props3.order,updateOrder=_props3.updateOrder,createOrder=_props3.createOrder;var keys=(0,_keys3.default)(orderValidation);touch.apply(undefined,['order'].concat(_toConsumableArray(keys)));if(!orderFormIsValid){return;}if(!order){createOrder(orderFormValues);}else{updateOrder(order.id,orderFormValues);}}},{key:'saveRowNote',value:function saveRowNote(){var _props4=this.props,noteRowIsExtra=_props4.noteRowIsExtra,noteRowFormValues=_props4.noteRowFormValues,noteRowFormIsValid=_props4.noteRowFormIsValid,noteRow=_props4.noteRow,updateOrderRow=_props4.updateOrderRow,updateExtraRow=_props4.updateExtraRow,touch=_props4.touch;var keys=(0,_keys3.default)(noteRowValidation);touch.apply(undefined,['noteRow'].concat(_toConsumableArray(keys)));if(!noteRowFormIsValid||!noteRow){return;}var data=(0,_pick3.default)(['note'],noteRowFormValues);if(noteRowIsExtra){updateExtraRow(noteRow.id,data);}else{updateOrderRow(noteRow.id,data);}}},{key:'saveOrderComment',value:function saveOrderComment(){var _props5=this.props,order=_props5.order,orderComment=_props5.orderComment,orderCommentFormIsValid=_props5.orderCommentFormIsValid,orderCommentFormValues=_props5.orderCommentFormValues,addOrderComment=_props5.addOrderComment,updateOrderComment=_props5.updateOrderComment,touch=_props5.touch;var keys=(0,_keys3.default)(orderCommentValidation);touch.apply(undefined,['orderComment'].concat(_toConsumableArray(keys)));if(!orderCommentFormIsValid||!order||!orderComment){return;}var data=(0,_pick3.default)(keys,orderCommentFormValues);if(!!orderComment.id){updateOrderComment(orderComment.id,data);}else{addOrderComment(order.id,data);}}},{key:'saveExtraRow',value:function saveExtraRow(){var _props6=this.props,extraRowFormValues=_props6.extraRowFormValues,extraRowFormIsValid=_props6.extraRowFormIsValid,order=_props6.order,extraRow=_props6.extraRow,createExtraRow=_props6.createExtraRow,updateExtraRow=_props6.updateExtraRow,touch=_props6.touch;var keys=(0,_keys3.default)(extraRowValidation);touch.apply(undefined,['productRow'].concat(_toConsumableArray(keys)));if(!extraRowFormIsValid){return;}var data=_extends({},extraRowFormValues,{productVariantId:extraRowFormValues.productVariant.id});if(extraRow&&!extraRow.id&&!!order){createExtraRow(order.id,data);}else if(!!extraRow){updateExtraRow(extraRow.id,data);}}},{key:'render',value:function render(){var _this2=this;var _props7=this.props,history=_props7.history,orderComplete=_props7.orderComplete,updateOrderRows=_props7.updateOrderRows,isDirty=_props7.isDirty,order=_props7.order,apartments=_props7.apartments,error=_props7.error,isFetching=_props7.isFetching,id=_props7.params.id,prevPath=_props7.prevPath,projects=_props7.projects,specialProducts=_props7.specialProducts,productTypes=_props7.productTypes,updateOrder=_props7.updateOrder,users=_props7.users,salesUsers=_props7.salesUsers,customRows=_props7.customRows,rows=_props7.rows,noteRow=_props7.noteRow,noteRowError=_props7.noteRowError,noteRowIsFetching=_props7.noteRowIsFetching,noteRowFormValues=_props7.noteRowFormValues,setNoteRow=_props7.setNoteRow,orderComment=_props7.orderComment,orderCommentError=_props7.orderCommentError,orderCommentIsFetching=_props7.orderCommentIsFetching,orderCommentFormValues=_props7.orderCommentFormValues,setActiveComment=_props7.setActiveComment,removeOrderComment=_props7.removeOrderComment,roomTypes=_props7.roomTypes,workerTypes=_props7.workerTypes,suppliers=_props7.suppliers,reportFilter=_props7.reportFilter,updateReportFilter=_props7.updateReportFilter,userOrderFilter=_props7.userOrderFilter,updateUserOrderFilter=_props7.updateUserOrderFilter,orders=_props7.orders,clear=_props7.clear,fetchData=_props7.fetchData,extraRows=_props7.extraRows,allRowsByRoom=_props7.allRowsByRoom,extraRowFormValues=_props7.extraRowFormValues,extraRow=_props7.extraRow,extraRowError=_props7.extraRowError,extraRowIsFetching=_props7.extraRowIsFetching,setActiveExtraRow=_props7.setActiveExtraRow,removeExtraRow=_props7.removeExtraRow,fetchExtraRowProducts=_props7.fetchExtraRowProducts,extraRowProducts=_props7.extraRowProducts,extraRowProductsAreFetching=_props7.extraRowProductsAreFetching,fetchExtraRowVariants=_props7.fetchExtraRowVariants,extraRowVariants=_props7.extraRowVariants,extraRowVariantsAreFetching=_props7.extraRowVariantsAreFetching,rooms=_props7.rooms,orderTotalPrice=_props7.orderTotalPrice,clearOrderRows=_props7.clearOrderRows;return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:order,list:orders,prevPath:prevPath,clear:clear,fetchData:fetchData}),_react2.default.createElement('div',{className:'content-title'},order&&'Beställning'||'Ny beställning'))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},order&&_react2.default.createElement(_DisableContent2.default,{disabled:isDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveOrder',className:'secondary button',message:'Vill du verkligen '+(order.archived?'av':'')+'arkivera den h\xE4r best\xE4llningen?',buttonText:order.archived?'Avarkivera':'Arkivera',action:function action(){return updateOrder(order.id,{archived:!order.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching||extraRowProductsAreFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},id?_react2.default.createElement(_OrderForm2.default,{rows:rows,updateOrder:updateOrder,updateOrderRows:updateOrderRows,clearOrderRows:clearOrderRows,orderComplete:orderComplete,initialValues:order,order:order,apartments:apartments,projects:projects,users:users,salesUsers:salesUsers,specialProducts:specialProducts,productTypes:productTypes,onOpenCustomerOrder:function onOpenCustomerOrder(){return history.push(prevPath+'/'+id+'/customerorder');},onOpenCustomerApartment:function onOpenCustomerApartment(){return history.push('/projects/'+order.apartment.projectId+'/apartments/'+order.apartmentId);},suppliers:suppliers,reportFilter:reportFilter,updateReportFilter:updateReportFilter,userOrderFilter:userOrderFilter,updateUserOrderFilter:updateUserOrderFilter,onUserChange:function onUserChange(){return _this2.setDirty();},orderTotalPrice:orderTotalPrice,validate:function validate(values){return(0,_validator2.default)(orderValidation,values);}}):order?_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath}):_react2.default.createElement(_OrderForm2.default,{rows:rows,updateOrder:updateOrder,updateOrderRows:updateOrderRows,clearOrderRows:clearOrderRows,orderComplete:orderComplete,apartments:apartments,projects:projects,users:users,salesUsers:salesUsers,specialProducts:specialProducts,productTypes:productTypes,onUserChange:function onUserChange(){return _this2.setDirty();},suppliers:suppliers,reportFilter:reportFilter,updateReportFilter:updateReportFilter,userOrderFilter:userOrderFilter,updateUserOrderFilter:updateUserOrderFilter,orderTotalPrice:orderTotalPrice,validate:function validate(values){return(0,_validator2.default)(orderValidation,values);}})),order&&_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'content-section'},_ref,_react2.default.createElement(_AdminList2.default,{onRowSelected:function onRowSelected(row){return setActiveComment(row);},columns:orderCommentColumns,rows:order.comments}),_react2.default.createElement('button',{onClick:function onClick(){return setActiveComment({});},type:'button',className:'button small'},'L\xE4gg till kommentar'))),order&&_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'content-section'},_ref2,_react2.default.createElement(_ProductRowList2.default,{allRowsByRoom:allRowsByRoom,onSelectRow:function onSelectRow(row){return setNoteRow(row,false);},onSelectExtraRow:function onSelectExtraRow(row){if(order.state===_orderStates.NEW){setActiveExtraRow(row);}else{setNoteRow(row,true);}},onRemoveExtraRow:function onRemoveExtraRow(row){return removeExtraRow(row.id);},canRemoveExtraRows:order.state===_orderStates.NEW}),order.state===_orderStates.NEW&&_react2.default.createElement('button',{onClick:function onClick(){return setActiveExtraRow({});},type:'button',className:'button small'},'L\xE4gg till produkt')),_react2.default.createElement('div',{className:'content-section'},_ref3,_react2.default.createElement(_AdminList2.default,{onRowSelected:function onRowSelected(row){return history.push(prevPath+'/'+id+'/customrows/'+row.id);},columns:customRowColumns,rows:customRows}),order.state===_orderStates.NEW&&_react2.default.createElement('button',{onClick:function onClick(){return history.push(prevPath+'/'+id+'/customrows/new');},type:'button',className:'button small'},'L\xE4gg till friprodukt'))),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}),extraRow&&_react2.default.createElement(_ProductRowDialog2.default,{existingRows:extraRows,products:extraRowProducts,variants:extraRowVariants,activeRow:extraRow,rooms:rooms,error:extraRowError,isLoading:extraRowIsFetching||extraRowVariantsAreFetching,formValues:extraRowFormValues,onSave:function onSave(){return _this2.saveExtraRow();},onSelectProduct:function onSelectProduct(productId){return fetchExtraRowVariants(productId);},onClose:function onClose(){return setActiveExtraRow(null);},validate:function validate(values){return(0,_validator2.default)(extraRowValidation,values);},onOpen:fetchExtraRowProducts,combineProduct:true}),noteRow&&_react2.default.createElement(_OrderRowNoteDialog2.default,{orderRow:noteRow,error:noteRowError,isLoading:noteRowIsFetching,formValues:noteRowFormValues,onSave:function onSave(){return _this2.saveRowNote();},onClose:function onClose(){return setNoteRow(null);},validate:function validate(values){return(0,_validator2.default)(noteRowValidation,values);}}),orderComment&&_react2.default.createElement(_OrderCommentDialog2.default,{orderComment:orderComment,roomTypes:roomTypes,workerTypes:workerTypes,error:orderCommentError,isLoading:orderCommentIsFetching,formValues:orderCommentFormValues,onSave:function onSave(){return _this2.saveOrderComment();},onClose:function onClose(){return setActiveComment(null);},onRemove:function onRemove(){return removeOrderComment(orderComment.id);},validate:function validate(values){return(0,_validator2.default)(orderCommentValidation,values);}}),order&&order.hasBeenLocked&&_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'content-section'},_ref4,_react2.default.createElement(_AdminList2.default,{columns:orderChangeColumns,rows:order.changes,sortColumnIndex:4}))));}}]);return OrderContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref5){var _ref5$orderView=_ref5.orderView,orderComplete=_ref5$orderView.orderComplete,isDirty=_ref5$orderView.isDirty,active=_ref5$orderView.active,_ref5$orderView$apart=_ref5$orderView.apartments,apartments=_ref5$orderView$apart.byProjectId,projects=_ref5$orderView$apart.projects,_ref5$orderView$speci=_ref5$orderView.specialProducts,specialProducts=_ref5$orderView$speci.byProductTypeId,productTypes=_ref5$orderView$speci.productTypes,customRows=_ref5$orderView.customRows.list,_ref5$orderView$extra=_ref5$orderView.extraRow,extraRow=_ref5$orderView$extra.active,extraRowError=_ref5$orderView$extra.error,extraRowIsFetching=_ref5$orderView$extra.isFetching,_ref5$orderView$activ=_ref5$orderView.activeExtraRowProducts,extraRowProductsAreFetching=_ref5$orderView$activ.isFetching,extraRowProducts=_ref5$orderView$activ.list,_ref5$orderView$activ2=_ref5$orderView.activeExtraRowVariants,extraRowVariantsAreFetching=_ref5$orderView$activ2.isFetching,extraRowVariants=_ref5$orderView$activ2.list,error=_ref5$orderView.error,isFetching=_ref5$orderView.isFetching,users=_ref5$orderView.users,salesUsers=_ref5$orderView.salesUsers,rooms=_ref5$orderView.rooms,_ref5$orderView$rows=_ref5$orderView.rows,rows=_ref5$orderView$rows.rows,extraRows=_ref5$orderView$rows.extraRows,allRowsByRoom=_ref5$orderView$rows.allRowsByRoom,_ref5$orderView$noteR=_ref5$orderView.noteRow,noteRow=_ref5$orderView$noteR.active,noteRowError=_ref5$orderView$noteR.error,noteRowIsFetching=_ref5$orderView$noteR.isFetching,noteRowIsExtra=_ref5$orderView$noteR.isExtra,_ref5$orderView$order=_ref5$orderView.orderComment,orderComment=_ref5$orderView$order.active,orderCommentError=_ref5$orderView$order.error,orderCommentIsFetching=_ref5$orderView$order.isFetching,roomTypes=_ref5$orderView$order.roomTypes,workerTypes=_ref5$orderView$order.workerTypes,suppliers=_ref5$orderView.suppliers,reportFilter=_ref5$orderView.reportFilter,userOrderFilter=_ref5$orderView.userOrderFilter,orderTotalPrice=_ref5$orderView.orderTotalPrice,orders=_ref5.orderList.filteredOrders,form=_ref5.form;return{orderComplete:orderComplete,isDirty:isDirty,order:active,apartments:apartments,specialProducts:specialProducts,productTypes:productTypes,customRows:customRows,error:error,isFetching:isFetching,orderFormIsValid:(0,_reduxForm.isValid)('order')({form:form}),orderFormValues:(0,_reduxForm.getFormValues)('order')({form:form}),projects:projects,users:users,salesUsers:salesUsers,rows:rows,noteRow:noteRow,noteRowError:noteRowError,noteRowIsFetching:noteRowIsFetching,noteRowIsExtra:noteRowIsExtra,noteRowFormIsValid:(0,_reduxForm.isValid)('noteRow')({form:form}),noteRowFormValues:(0,_reduxForm.getFormValues)('noteRow')({form:form}),orderComment:orderComment,orderCommentError:orderCommentError,orderCommentIsFetching:orderCommentIsFetching,orderCommentFormIsValid:(0,_reduxForm.isValid)('orderComment')({form:form}),orderCommentFormValues:(0,_reduxForm.getFormValues)('orderComment')({form:form}),roomTypes:roomTypes,workerTypes:workerTypes,suppliers:suppliers,reportFilter:reportFilter,userOrderFilter:userOrderFilter,orders:orders,allRowsByRoom:allRowsByRoom,extraRow:extraRow,extraRowError:extraRowError,extraRowIsFetching:extraRowIsFetching,extraRowProducts:extraRowProducts,extraRowProductsAreFetching:extraRowProductsAreFetching,extraRowVariants:extraRowVariants,extraRowVariantsAreFetching:extraRowVariantsAreFetching,extraRowFormIsValid:(0,_reduxForm.isValid)('productRow')({form:form}),extraRowFormValues:(0,_reduxForm.getFormValues)('productRow')({form:form}),rooms:rooms,orderTotalPrice:orderTotalPrice};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'order'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_orderView.reset)());},updateOrder:function updateOrder(id,data){return dispatch((0,_orderView.updateOrder)(id,data));},updateOrderRows:function updateOrderRows(id,data){return dispatch((0,_orderView.updateOrderRows)(id,data));},clearOrderRows:function clearOrderRows(id,data){return dispatch((0,_orderView.clearOrderRows)(id));},createOrder:function createOrder(data){return dispatch((0,_orderView.createOrder)(data));},clear:function clear(){return dispatch((0,_orderView.clear)());},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},fetchData:function fetchData(orderId){return dispatch((0,_orderView.fetchData)(orderId));},setNoteRow:function setNoteRow(row,isExtra){return dispatch((0,_orderView.setNoteRow)(row,isExtra));},updateOrderRow:function updateOrderRow(id,data){return dispatch((0,_orderView.updateOrderRow)(id,data));},setActiveComment:function setActiveComment(comment){return dispatch((0,_orderView.setActiveComment)(comment));},addOrderComment:function addOrderComment(id,data){return dispatch((0,_orderView.addOrderComment)(id,data));},updateOrderComment:function updateOrderComment(id,data){return dispatch((0,_orderView.updateOrderComment)(id,data));},removeOrderComment:function removeOrderComment(id){return dispatch((0,_orderView.removeOrderComment)(id));},updateReportFilter:function updateReportFilter(supplierId/*: ?number*/,includePlans/*: boolean*/){return dispatch((0,_orderView.updateReportFilter)(supplierId,includePlans));},updateUserOrderFilter:function updateUserOrderFilter(includePlans/*: boolean*/){return dispatch((0,_orderView.updateUserOrderFilter)(includePlans));},setActiveExtraRow:function setActiveExtraRow(row){return dispatch((0,_orderView.setActiveExtraRow)(row));},createExtraRow:function createExtraRow(orderId,data){return dispatch((0,_orderView.createExtraRow)(orderId,data));},updateExtraRow:function updateExtraRow(id,data){return dispatch((0,_orderView.updateExtraRow)(id,data));},removeExtraRow:function removeExtraRow(id){return dispatch((0,_orderView.removeExtraRow)(id));},fetchExtraRowVariants:function fetchExtraRowVariants(id){return dispatch((0,_orderView.fetchActiveExtraRowVariants)(id));},fetchExtraRowProducts:function fetchExtraRowProducts(id){return dispatch((0,_orderView.fetchActiveExtraRowProducts)());}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(OrderContainer));

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _OrderApartmentInput=__webpack_require__(1190);var _OrderApartmentInput2=_interopRequireDefault(_OrderApartmentInput);var _FormattedPrice=__webpack_require__(131);var _FormattedPrice2=_interopRequireDefault(_FormattedPrice);var _orderStates=__webpack_require__(69);var _DecimalFormInput=__webpack_require__(70);var _DecimalFormInput2=_interopRequireDefault(_DecimalFormInput);var _SpecialProductsInput=__webpack_require__(1253);var _SpecialProductsInput2=_interopRequireDefault(_SpecialProductsInput);var _request=__webpack_require__(6);var _PurchaseOrderReportContainer=__webpack_require__(178);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);__webpack_require__(1257);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var fileUrl=_request.apiBase+'/files';/*:: export type Props = {
  orderComplete: boolean,
  orderTotalPrice: number,
  updateOrder: Function,
  updateOrderRows: Function,
  clearOrderRows: Function,
  apartments: Object,
  projects: any[],
  users: any[],
  salesUsers: any[],
  specialProducts: Object,
  productTypes: any[],
  order: ?any,
  onOpenCustomerOrder?: Function,
  onOpenCustomerApartment?: Function,
  onUserChange: Function,
  suppliers: any[],
  reportFilter: {
    includePlans: boolean,
    supplierId: ?number,
  },
  updateReportFilter: Function,
  userOrderFilter: {
    includePlans: boolean,
  },
  updateUserOrderFilter: Function,
};*/var _ref=_react2.default.createElement('label',null,'Totalpris (efter ev. rabatt)');var _ref2=_react2.default.createElement('div',{className:'small-6 column'});var _ref3=_react2.default.createElement('label',null,'\xA0');var _ref4=_react2.default.createElement('label',null,'Best\xE4llningsunderlag');var _ref5=_react2.default.createElement('i',{className:'fa fa-download'});var _ref6=_react2.default.createElement('label',null,'Ink\xF6psrapport');var _ref7=_react2.default.createElement('i',{className:'fa fa-download'});var OrderForm=function OrderForm(props/*: Props*/){var orderComplete=props.orderComplete,updateOrder=props.updateOrder,updateOrderRows=props.updateOrderRows,clearOrderRows=props.clearOrderRows,apartments=props.apartments,projects=props.projects,users=props.users,order=props.order,specialProducts=props.specialProducts,productTypes=props.productTypes,onOpenCustomerOrder=props.onOpenCustomerOrder,onOpenCustomerApartment=props.onOpenCustomerApartment,salesUsers=props.salesUsers,onUserChange=props.onUserChange,suppliers=props.suppliers,reportFilter=props.reportFilter,updateReportFilter=props.updateReportFilter,userOrderFilter=props.userOrderFilter,updateUserOrderFilter=props.updateUserOrderFilter,orderTotalPrice=props.orderTotalPrice;var userList=users;if(order&&!!order.user){userList=[].concat(_toConsumableArray(userList),[order.user]);}return _react2.default.createElement('div',{className:'OrderForm'},_react2.default.createElement('form',null,_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Fields,{names:['apartment','apartmentId','projectId'],change:onUserChange,component:_OrderApartmentInput2.default,disabled:!!order,apartments:apartments,projects:projects})),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement('div',null,_react2.default.createElement(_reduxForm.Field,{name:'userId',label:'Kund',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,disabled:!!order,component:_SelectFormInput2.default,valueKey:'id',labelKey:'username',options:userList}),_react2.default.createElement(_reduxForm.Field,{name:'state',label:'Status',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,disabled:true,component:_SelectFormInput2.default,valueKey:'id',labelKey:'label',options:_orderStates.states})))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'discount',label:'Rabatt',onChange:onUserChange,component:_DecimalFormInput2.default})),!!order&&_react2.default.createElement('div',{className:'small-6 column'},_ref,_react2.default.createElement('div',{className:'readonly-text-control'},_react2.default.createElement(_FormattedPrice2.default,{value:orderTotalPrice})))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{type:'text',name:'discountComment',label:'Rabattkommentar',onChange:onUserChange,component:_BasicFormInput2.default})),_ref2),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{type:'text',name:'additionalCustomerName',label:'Ytterliggare kund - namn',onChange:onUserChange,component:_BasicFormInput2.default})),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{type:'text',name:'additionalCustomerEmail',label:'Ytterliggare kund - email',onChange:onUserChange,component:_BasicFormInput2.default}))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{type:'text',name:'additionalCustomerPhone',label:'Ytterliggare kund - telefon',onChange:onUserChange,component:_BasicFormInput2.default})),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{type:'text',name:'additionalCustomerMobile',label:'Ytterliggare kund - mobiltelefon',onChange:onUserChange,component:_BasicFormInput2.default}))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'salesUserId',label:'S\xE4ljare',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'username',options:salesUsers})),!!order&&_react2.default.createElement('div',{className:'small-6 column'},_ref3,!orderComplete&&_react2.default.createElement(_ActionConfirmation2.default,{id:'fillStandard',className:'expanded warning column shrink',message:'Vill du verkligen fylla resterande produktplatser med standardval?',buttonText:'Fyll med standardval',action:function action(){return updateOrderRows(order.id,{standard:true});}}),order.state===_orderStates.NEW&&!!order.rows.length&&_react2.default.createElement(_ActionConfirmation2.default,{id:'clearRows',className:'expanded warning column shrink',message:'Vill du verkligen rensa alla val som redan gjorts?',buttonText:'Rensa alla val',action:function action(){return clearOrderRows(order.id);}}),order.state===_orderStates.NEW&&_react2.default.createElement(_ActionConfirmation2.default,{id:'lockOrder',className:'expanded success column shrink',message:'Vill du verkligen l\xE5sa best\xE4llningen?',buttonText:'L\xE5s best\xE4llning',action:function action(){return updateOrder(order.id,{state:_orderStates.COMPLETED});},disabled:!orderComplete}),order.state===_orderStates.COMPLETED&&_react2.default.createElement(_ActionConfirmation2.default,{id:'unlockOrder',className:'expanded alert column shrink',message:'Vill du verkligen l\xE5sa upp best\xE4llningen?',buttonText:'L\xE5s upp best\xE4llning',action:function action(){return updateOrder(order.id,{state:_orderStates.NEW});}}),order.state===_orderStates.COMPLETED&&_react2.default.createElement(_ActionConfirmation2.default,{id:'confirmPurchase',className:'expanded success column shrink',messages:['Är de aktuella plan- och köksritningarna kopplade?','Vill du verkligen bekräfta beställningen för inköp?'],buttonText:'Bekr\xE4fta f\xF6r ink\xF6p',action:function action(){return updateOrder(order.id,{state:_orderStates.CONFIRMED});}}),order.state===_orderStates.CONFIRMED&&_react2.default.createElement(_ActionConfirmation2.default,{id:'cancelPurchase',className:'expanded alert column shrink',message:'Vill du verkligen avbryta best\xE4llningen f\xF6r ink\xF6p?',buttonText:'Avbryt f\xF6r ink\xF6p',action:function action(){return updateOrder(order.id,{state:_orderStates.COMPLETED});}}))),_react2.default.createElement('div',{className:'row'},!!onOpenCustomerApartment&&_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement('button',{onClick:function onClick(){return onOpenCustomerApartment&&onOpenCustomerApartment();},type:'button',className:'expanded button'},'\xD6ppna l\xE4genhet')),!!onOpenCustomerOrder&&_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement('button',{onClick:function onClick(){return onOpenCustomerOrder&&onOpenCustomerOrder();},type:'button',className:'expanded button'},'\xD6ppna kundorder'))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'specialProducts',label:'Specialprodukter',onChange:onUserChange,component:_SpecialProductsInput2.default,specialProducts:specialProducts,productTypes:productTypes}))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'comment',label:'Best\xE4llningskommentar',onChange:onUserChange,component:_TextAreaFormInput2.default})),!!order&&_react2.default.createElement('div',{className:'small-6 column'},_ref4,_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!userOrderFilter.includePlans,onBlur:_noop3.default,onChange:function onChange(includePlans){return updateUserOrderFilter(includePlans?includePlans.value:false);}},label:'Inkludera ritningar',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}),_react2.default.createElement('div',{className:'row no-row-margins expand FileDropzone'},_react2.default.createElement('a',{href:fileUrl+'/export/orders/'+order.id+'/user/order_'+order.id+'_user_export.pdf'+(!!userOrderFilter.includePlans?'?withPlans=1':''),target:'_blank',className:'file column text-truncate'},'H\xE4mta best\xE4llningsunderlag'),_react2.default.createElement('a',{href:fileUrl+'/export/orders/'+order.id+'/user'+(!!userOrderFilter.includePlans?'?withPlans=1':''),target:'_blank',className:'button column shrink'},_ref5)),order.state>_orderStates.COMPLETED&&_react2.default.createElement('div',null,_ref6,_react2.default.createElement(_SelectFormInput2.default,{input:{value:reportFilter.supplierId,onBlur:_noop3.default,onChange:function onChange(supplier){return updateReportFilter(supplier?supplier.id:null,reportFilter.includePlans);}},placeholder:'V\xE4lj leverant\xF6r',meta:{},valueKey:'id',labelKey:'name',multi:false,options:suppliers,clearable:true}),_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!reportFilter.includePlans,onBlur:_noop3.default,onChange:function onChange(includePlans){return updateReportFilter(reportFilter.supplierId,includePlans?includePlans.value:false);}},label:'Inkludera ritningar',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}),_react2.default.createElement('div',{className:'row no-row-margins expand FileDropzone'},_react2.default.createElement('a',{href:(0,_PurchaseOrderReportContainer.getUrl)(order.apartment.projectId,order.apartmentId,reportFilter.supplierId,true,reportFilter.includePlans),target:'_blank',className:'file column text-truncate'},'H\xE4mta ink\xF6psrapport'),_react2.default.createElement('a',{href:(0,_PurchaseOrderReportContainer.getUrl)(order.apartment.projectId,order.apartmentId,reportFilter.supplierId,false,reportFilter.includePlans),target:'_blank',className:'button column shrink'},_ref7)))))));};exports.default=(0,_reduxForm.reduxForm)({form:'order',enableReinitialize:true})(OrderForm);

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/*:: export type Props = {
  apartment: Object,
  apartmentId: Object,
  projectId: Object,
  apartments: Object,
  projects: any[],
  disabled: boolean,
  change: Function,
};*/var OrderApartmentInput=function OrderApartmentInput(_ref){var apartment=_ref.apartment,apartmentId=_ref.apartmentId,projectId=_ref.projectId,apartments=_ref.apartments,projects=_ref.projects,disabled=_ref.disabled,_onChange=_ref.change;var apartmentList=[];if(!!projectId.input.value){apartmentList=apartments[projectId.input.value]||[];if(!!apartment.input.value){apartmentList=[].concat(_toConsumableArray(apartmentList),[apartment.input.value]);}}var projectList=projects;if(!!apartment.input.value&&!!apartment.input.value.project){projectList=[].concat(_toConsumableArray(projectList),[apartment.input.value.project]);}return _react2.default.createElement('div',null,_react2.default.createElement(_SelectFormInput2.default,{input:{value:projectId.input.value||null,onBlur:_noop3.default,onChange:function onChange(project){projectId.input.onChange(project?project.id:null);if(!!apartmentId.input.value){apartmentId.input.onChange(null);}if(_onChange){_onChange();}}},disabled:!!disabled,label:'Projekt',meta:projectId.meta,valueKey:'id',labelKey:'name',options:projectList}),_react2.default.createElement(_SelectFormInput2.default,{input:{value:apartmentId.input.value||null,onBlur:function onBlur(apartment){return apartmentId.input.onBlur(apartment?apartment.id:null);},onChange:function onChange(apartment){apartmentId.input.onChange(apartment?apartment.id:null);if(_onChange){_onChange();}}},disabled:!!disabled||!projectId.input.value,label:'L\xE4genhet',meta:apartmentId.meta,valueKey:'id',labelKey:'objectId',options:apartmentList}));};exports.default=OrderApartmentInput;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * numbro.js
 * version : 1.11.0
 * author : Företagsplatsen AB
 * license : MIT
 * http://www.foretagsplatsen.se
 */

(function () {
    'use strict';

    /************************************
        Constants
    ************************************/

    var numbro,
        VERSION = '1.11.0',
        binarySuffixes = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'],
        decimalSuffixes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
        bytes = {
            general: { scale: 1024, suffixes: decimalSuffixes, marker: 'bd' },
            binary:  { scale: 1024, suffixes: binarySuffixes, marker: 'b' },
            decimal: { scale: 1000, suffixes: decimalSuffixes, marker: 'd' }
        },
        // general must be before the others because it reuses their characters!
        byteFormatOrder = [ bytes.general, bytes.binary, bytes.decimal ],
    // internal storage for culture config files
        cultures = {},
    // Todo: Remove in 2.0.0
        languages = cultures,
        currentCulture = 'en-US',
        zeroFormat = null,
        defaultFormat = '0,0',
        defaultCurrencyFormat = '0$',
        // check for nodeJS
        hasModule = (typeof module !== 'undefined' && module.exports),
    // default culture
        enUS = {
            delimiters: {
                thousands: ',',
                decimal: '.'
            },
            abbreviations: {
                thousand: 'k',
                million: 'm',
                billion: 'b',
                trillion: 't'
            },
            ordinal: function(number) {
                var b = number % 10;
                return (~~(number % 100 / 10) === 1) ? 'th' :
                    (b === 1) ? 'st' :
                        (b === 2) ? 'nd' :
                            (b === 3) ? 'rd' : 'th';
            },
            currency: {
                symbol: '$',
                position: 'prefix'
            },
            defaults: {
                currencyFormat: ',0000 a'
            },
            formats: {
                fourDigits: '0000 a',
                fullWithTwoDecimals: '$ ,0.00',
                fullWithTwoDecimalsNoCurrency: ',0.00'
            }
        };

    /************************************
        Constructors
    ************************************/


    // Numbro prototype object
    function Numbro(number) {
        this._value = number;
    }

    function numberLength(number) {
        if (number === 0) { return 1; }
        return Math.floor(Math.log(Math.abs(number)) / Math.LN10) + 1;
    }

    function zeroes(count) {
        var i, ret = '';

        for (i = 0; i < count; i++) {
            ret += '0';
        }

        return ret;
    }
    /**
     * Implementation of toFixed() for numbers with exponents
     * This function may return negative representations for zero values e.g. "-0.0"
     */
    function toFixedLargeSmall(value, precision) {
        var mantissa,
            beforeDec,
            afterDec,
            exponent,
            prefix,
            endStr,
            zerosStr,
            str;

        str = value.toString();

        mantissa = str.split('e')[0];
        exponent = str.split('e')[1];

        beforeDec = mantissa.split('.')[0];
        afterDec = mantissa.split('.')[1] || '';

        if (+exponent > 0) {
            // exponent is positive - add zeros after the numbers
            str = beforeDec + afterDec + zeroes(exponent - afterDec.length);
        } else {
            // exponent is negative

            if (+beforeDec < 0) {
                prefix = '-0';
            } else {
                prefix = '0';
            }

            // tack on the decimal point if needed
            if (precision > 0) {
                prefix += '.';
            }

            zerosStr = zeroes((-1 * exponent) - 1);
            // substring off the end to satisfy the precision
            endStr = (zerosStr + Math.abs(beforeDec) + afterDec).substr(0, precision);
            str = prefix + endStr;
        }

        // only add percision 0's if the exponent is positive
        if (+exponent > 0 && precision > 0) {
            str += '.' + zeroes(precision);
        }

        return str;
    }

    /**
     * Implementation of toFixed() that treats floats more like decimals
     *
     * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
     * problems for accounting- and finance-related software.
     *
     * Also removes negative signs for zero-formatted numbers. e.g. -0.01 w/ precision 1 -> 0.0
     */
    function toFixed(value, precision, roundingFunction, optionals) {
        var power = Math.pow(10, precision),
            optionalsRegExp,
            output;

        if (value.toString().indexOf('e') > -1) {
            // toFixed returns scientific notation for numbers above 1e21 and below 1e-7
            output = toFixedLargeSmall(value, precision);
            // remove the leading negative sign if it exists and should not be present (e.g. -0.00)
            if (output.charAt(0) === '-' && +output >= 0) {
                output = output.substr(1); // chop off the '-'
            }
        }
        else {
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + precision) / power).toFixed(precision);
        }

        if (optionals) {
            optionalsRegExp = new RegExp('0{1,' + optionals + '}$');
            output = output.replace(optionalsRegExp, '');
        }

        return output;
    }

    /************************************
        Formatting
    ************************************/

    // determine what type of formatting we need to do
    function formatNumbro(n, format, roundingFunction) {
        var output,
            escapedFormat = format.replace(/\{[^\{\}]*\}/g, '');

        // figure out what kind of format we are dealing with
        if (escapedFormat.indexOf('$') > -1) { // currency!!!!!
            output = formatCurrency(n, cultures[currentCulture].currency.symbol, format, roundingFunction);
        } else if (escapedFormat.indexOf('%') > -1) { // percentage
            output = formatPercentage(n, format, roundingFunction);
        } else if (escapedFormat.indexOf(':') > -1) { // time
            output = formatTime(n, format);
        } else { // plain ol' numbers or bytes
            output = formatNumber(n._value, format, roundingFunction);
        }

        // return string
        return output;
    }

    // revert to number
    function unformatNumbro(n, string) {
        var stringOriginal = string,
            thousandRegExp,
            millionRegExp,
            billionRegExp,
            trillionRegExp,
            bytesMultiplier = false,
            power;

        if (string.indexOf(':') > -1) {
            n._value = unformatTime(string);
        } else {
            if (string === zeroFormat) {
                n._value = 0;
            } else {
                if (cultures[currentCulture].delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(cultures[currentCulture].delimiters.decimal, '.');
                }

                // see if abbreviations are there so that we can multiply to the correct number
                thousandRegExp = new RegExp('[^a-zA-Z]' + cultures[currentCulture].abbreviations.thousand +
                    '(?:\\)|(\\' + cultures[currentCulture].currency.symbol + ')?(?:\\))?)?$');
                millionRegExp = new RegExp('[^a-zA-Z]' + cultures[currentCulture].abbreviations.million +
                    '(?:\\)|(\\' + cultures[currentCulture].currency.symbol + ')?(?:\\))?)?$');
                billionRegExp = new RegExp('[^a-zA-Z]' + cultures[currentCulture].abbreviations.billion +
                    '(?:\\)|(\\' + cultures[currentCulture].currency.symbol + ')?(?:\\))?)?$');
                trillionRegExp = new RegExp('[^a-zA-Z]' + cultures[currentCulture].abbreviations.trillion +
                    '(?:\\)|(\\' + cultures[currentCulture].currency.symbol + ')?(?:\\))?)?$');

                // see if bytes are there so that we can multiply to the correct number
                for (power = 1; power < binarySuffixes.length && !bytesMultiplier; ++power) {
                    if (string.indexOf(binarySuffixes[power]) > -1) {
                        bytesMultiplier = Math.pow(1024, power);
                    } else if (string.indexOf(decimalSuffixes[power]) > -1) {
                        bytesMultiplier = Math.pow(1000, power);
                    }
                }

                var str = string.replace(/[^0-9\.]+/g, '');
                if (str === '') {
                    // An empty string is not a number.
                    n._value = NaN;

                } else {
                    // do some math to create our number
                    n._value = ((bytesMultiplier) ? bytesMultiplier : 1) *
                        ((stringOriginal.match(thousandRegExp)) ? Math.pow(10, 3) : 1) *
                        ((stringOriginal.match(millionRegExp)) ? Math.pow(10, 6) : 1) *
                        ((stringOriginal.match(billionRegExp)) ? Math.pow(10, 9) : 1) *
                        ((stringOriginal.match(trillionRegExp)) ? Math.pow(10, 12) : 1) *
                        ((string.indexOf('%') > -1) ? 0.01 : 1) *
                        (((string.split('-').length +
                            Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2) ? 1 : -1) *
                        Number(str);

                    // round if we are talking about bytes
                    n._value = (bytesMultiplier) ? Math.ceil(n._value) : n._value;
                }
            }
        }
        return n._value;
    }

    function formatCurrency(n, currencySymbol, originalFormat, roundingFunction) {
        var format = originalFormat,
            symbolIndex = format.indexOf('$'),
            openParenIndex = format.indexOf('('),
            plusSignIndex = format.indexOf('+'),
            minusSignIndex = format.indexOf('-'),
            space = '',
            decimalSeparator = '',
            spliceIndex,
            output;

        if(format.indexOf('$') === -1){
            // Use defaults instead of the format provided
            if (cultures[currentCulture].currency.position === 'infix') {
                decimalSeparator = currencySymbol;
                if (cultures[currentCulture].currency.spaceSeparated) {
                    decimalSeparator = ' ' + decimalSeparator + ' ';
                }
            } else if (cultures[currentCulture].currency.spaceSeparated) {
                space = ' ';
            }
        } else {
            // check for space before or after currency
            if (format.indexOf(' $') > -1) {
                space = ' ';
                format = format.replace(' $', '');
            } else if (format.indexOf('$ ') > -1) {
                space = ' ';
                format = format.replace('$ ', '');
            } else {
                format = format.replace('$', '');
            }
        }

        // Format The Number
        output = formatNumber(n._value, format, roundingFunction, decimalSeparator);

        if (originalFormat.indexOf('$') === -1) {
            // Use defaults instead of the format provided
            switch (cultures[currentCulture].currency.position) {
                case 'postfix':
                    if (output.indexOf(')') > -1) {
                        output = output.split('');
                        output.splice(-1, 0, space + currencySymbol);
                        output = output.join('');
                    } else {
                        output = output + space + currencySymbol;
                    }
                    break;
                case 'infix':
                    break;
                case 'prefix':
                    if (output.indexOf('(') > -1 || output.indexOf('-') > -1) {
                        output = output.split('');
                        spliceIndex = Math.max(openParenIndex, minusSignIndex) + 1;

                        output.splice(spliceIndex, 0, currencySymbol + space);
                        output = output.join('');
                    } else {
                        output = currencySymbol + space + output;
                    }
                    break;
                default:
                    throw Error('Currency position should be among ["prefix", "infix", "postfix"]');
            }
        } else {
            // position the symbol
            if (symbolIndex <= 1) {
                if (output.indexOf('(') > -1 || output.indexOf('+') > -1 || output.indexOf('-') > -1) {
                    output = output.split('');
                    spliceIndex = 1;
                    if (symbolIndex < openParenIndex || symbolIndex < plusSignIndex || symbolIndex < minusSignIndex) {
                        // the symbol appears before the "(", "+" or "-"
                        spliceIndex = 0;
                    }
                    output.splice(spliceIndex, 0, currencySymbol + space);
                    output = output.join('');
                } else {
                    output = currencySymbol + space + output;
                }
            } else {
                if (output.indexOf(')') > -1) {
                    output = output.split('');
                    output.splice(-1, 0, space + currencySymbol);
                    output = output.join('');
                } else {
                    output = output + space + currencySymbol;
                }
            }
        }

        return output;
    }

    function formatForeignCurrency(n, foreignCurrencySymbol, originalFormat, roundingFunction) {
        return formatCurrency(n, foreignCurrencySymbol, originalFormat, roundingFunction);
    }

    function formatPercentage(n, format, roundingFunction) {
        var space = '',
            output,
            value = n._value * 100;

        // check for space before %
        if (format.indexOf(' %') > -1) {
            space = ' ';
            format = format.replace(' %', '');
        } else {
            format = format.replace('%', '');
        }

        output = formatNumber(value, format, roundingFunction);

        if (output.indexOf(')') > -1) {
            output = output.split('');
            output.splice(-1, 0, space + '%');
            output = output.join('');
        } else {
            output = output + space + '%';
        }

        return output;
    }

    function formatTime(n) {
        var hours = Math.floor(n._value / 60 / 60),
            minutes = Math.floor((n._value - (hours * 60 * 60)) / 60),
            seconds = Math.round(n._value - (hours * 60 * 60) - (minutes * 60));
        return hours + ':' +
            ((minutes < 10) ? '0' + minutes : minutes) + ':' +
            ((seconds < 10) ? '0' + seconds : seconds);
    }

    function unformatTime(string) {
        var timeArray = string.split(':'),
            seconds = 0;
        // turn hours and minutes into seconds and add them all up
        if (timeArray.length === 3) {
            // hours
            seconds = seconds + (Number(timeArray[0]) * 60 * 60);
            // minutes
            seconds = seconds + (Number(timeArray[1]) * 60);
            // seconds
            seconds = seconds + Number(timeArray[2]);
        } else if (timeArray.length === 2) {
            // minutes
            seconds = seconds + (Number(timeArray[0]) * 60);
            // seconds
            seconds = seconds + Number(timeArray[1]);
        }
        return Number(seconds);
    }

    function formatByteUnits (value, suffixes, scale) {
        var suffix = suffixes[0],
            power,
            min,
            max,
            abs = Math.abs(value);

        if (abs >= scale) {
            for (power = 1; power < suffixes.length; ++power) {
                min = Math.pow(scale, power);
                max = Math.pow(scale, power + 1);

                if (abs >= min && abs < max) {
                    suffix = suffixes[power];
                    value = value / min;
                    break;
                }
            }

            // values greater than or equal to [scale] YB never set the suffix
            if (suffix === suffixes[0]) {
                value = value / Math.pow(scale, suffixes.length - 1);
                suffix = suffixes[suffixes.length - 1];
            }
        }

        return { value: value, suffix: suffix };
    }

    function formatNumber (value, format, roundingFunction, sep) {
        var negP = false,
            signed = false,
            optDec = false,
            abbr = '',
            abbrK = false, // force abbreviation to thousands
            abbrM = false, // force abbreviation to millions
            abbrB = false, // force abbreviation to billions
            abbrT = false, // force abbreviation to trillions
            abbrForce = false, // force abbreviation
            bytes = '',
            byteFormat,
            units,
            ord = '',
            abs = Math.abs(value),
            totalLength,
            length,
            minimumPrecision,
            pow,
            w,
            intPrecision,
            precision,
            prefix,
            postfix,
            thousands,
            d = '',
            forcedNeg = false,
            neg = false,
            indexOpenP,
            indexMinus,
            paren = '',
            minlen,
            i;

        // check if number is zero and a custom zero format has been set
        if (value === 0 && zeroFormat !== null) {
            return zeroFormat;
        }

        if (!isFinite(value)) {
            return '' + value;
        }

        if (format.indexOf('{') === 0) {
            var end = format.indexOf('}');
            if (end === -1) {
                throw Error('Format should also contain a "}"');
            }
            prefix = format.slice(1, end);
            format = format.slice(end + 1);
        } else {
            prefix = '';
        }

        if (format.indexOf('}') === format.length - 1 && format.length) {
            var start = format.indexOf('{');
            if (start === -1) {
                throw Error('Format should also contain a "{"');
            }
            postfix = format.slice(start + 1, -1);
            format = format.slice(0, start + 1);
        } else {
            postfix = '';
        }

        // check for min length
        var info;
        if (format.indexOf('.') === -1) {
            info = format.match(/([0-9]+).*/);
        } else {
            info = format.match(/([0-9]+)\..*/);
        }
        minlen = info === null ? -1 : info[1].length;

        // see if we should use parentheses for negative number or if we should prefix with a sign
        // if both are present we default to parentheses
        if (format.indexOf('-') !== -1) {
            forcedNeg = true;
        }
        if (format.indexOf('(') > -1) {
            negP = true;
            format = format.slice(1, -1);
        } else if (format.indexOf('+') > -1) {
            signed = true;
            format = format.replace(/\+/g, '');
        }

        // see if abbreviation is wanted
        if (format.indexOf('a') > -1) {
            intPrecision = format.split('.')[0].match(/[0-9]+/g) || ['0'];
            intPrecision = parseInt(intPrecision[0], 10);

            // check if abbreviation is specified
            abbrK = format.indexOf('aK') >= 0;
            abbrM = format.indexOf('aM') >= 0;
            abbrB = format.indexOf('aB') >= 0;
            abbrT = format.indexOf('aT') >= 0;
            abbrForce = abbrK || abbrM || abbrB || abbrT;

            // check for space before abbreviation
            if (format.indexOf(' a') > -1) {
                abbr = ' ';
                format = format.replace(' a', '');
            } else {
                format = format.replace('a', '');
            }

            totalLength = numberLength(value);
            minimumPrecision = totalLength % 3;
            minimumPrecision = minimumPrecision === 0 ? 3 : minimumPrecision;

            if (intPrecision && abs !== 0) {
                pow = 3 * ~~((Math.min(intPrecision, totalLength) - minimumPrecision) / 3);
                abs = abs / Math.pow(10, pow);
            }

            if (totalLength !== intPrecision) {
                if (abs >= Math.pow(10, 12) && !abbrForce || abbrT) {
                    // trillion
                    abbr = abbr + cultures[currentCulture].abbreviations.trillion;
                    value = value / Math.pow(10, 12);
                } else if (abs < Math.pow(10, 12) && abs >= Math.pow(10, 9) && !abbrForce || abbrB) {
                    // billion
                    abbr = abbr + cultures[currentCulture].abbreviations.billion;
                    value = value / Math.pow(10, 9);
                } else if (abs < Math.pow(10, 9) && abs >= Math.pow(10, 6) && !abbrForce || abbrM) {
                    // million
                    abbr = abbr + cultures[currentCulture].abbreviations.million;
                    value = value / Math.pow(10, 6);
                } else if (abs < Math.pow(10, 6) && abs >= Math.pow(10, 3) && !abbrForce || abbrK) {
                    // thousand
                    abbr = abbr + cultures[currentCulture].abbreviations.thousand;
                    value = value / Math.pow(10, 3);
                }
            }

            length = numberLength(value);
            if (intPrecision && length < intPrecision && format.indexOf('.') === -1) {
                format += '[.]';
                format += zeroes(intPrecision - length);
            }
        }

        // see if we are formatting
        //   binary-decimal bytes (1024 MB), binary bytes (1024 MiB), or decimal bytes (1000 MB)
        for (i = 0; i < byteFormatOrder.length; ++i) {
            byteFormat = byteFormatOrder[i];

            if (format.indexOf(byteFormat.marker) > -1) {
                // check for space before
                if (format.indexOf(' ' + byteFormat.marker) >-1) {
                    bytes = ' ';
                }

                // remove the marker (with the space if it had one)
                format = format.replace(bytes + byteFormat.marker, '');

                units = formatByteUnits(value, byteFormat.suffixes, byteFormat.scale);

                value = units.value;
                bytes = bytes + units.suffix;

                break;
            }
        }

        // see if ordinal is wanted
        if (format.indexOf('o') > -1) {
            // check for space before
            if (format.indexOf(' o') > -1) {
                ord = ' ';
                format = format.replace(' o', '');
            } else {
                format = format.replace('o', '');
            }

            if (cultures[currentCulture].ordinal) {
                ord = ord + cultures[currentCulture].ordinal(value);
            }
        }

        if (format.indexOf('[.]') > -1) {
            optDec = true;
            format = format.replace('[.]', '.');
        }

        precision = format.split('.')[1];
        thousands = format.indexOf(',');

        if (precision) {
            var dSplit = [];

            if (precision.indexOf('*') !== -1) {
                d = value.toString();
                dSplit = d.split('.');
                if (dSplit.length > 1) {
                    d = toFixed(value, dSplit[1].length, roundingFunction);
                }
            } else {
                if (precision.indexOf('[') > -1) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    d = toFixed(value, (precision[0].length + precision[1].length), roundingFunction,
                        precision[1].length);
                } else {
                    d = toFixed(value, precision.length, roundingFunction);
                }
            }

            dSplit = d.split('.');
            w = dSplit[0];

            if (dSplit.length > 1 && dSplit[1].length) {
                var p = sep ? abbr + sep : cultures[currentCulture].delimiters.decimal;
                d = p + dSplit[1];
            } else {
                d = '';
            }

            if (optDec && Number(d.slice(1)) === 0) {
                d = '';
            }
        } else {
            w = toFixed(value, 0, roundingFunction);
        }

        // format number
        if (w.indexOf('-') > -1) {
            w = w.slice(1);
            neg = true;
        }

        if (w.length < minlen) {
            w = zeroes(minlen - w.length) + w;
        }

        if (thousands > -1) {
            w = w.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' +
                cultures[currentCulture].delimiters.thousands);
        }

        if (format.indexOf('.') === 0) {
            w = '';
        }

        indexOpenP = format.indexOf('(');
        indexMinus = format.indexOf('-');

        if (indexOpenP < indexMinus) {
            paren = ((negP && neg) ? '(' : '') + (((forcedNeg && neg) || (!negP && neg)) ? '-' : '');
        } else {
            paren = (((forcedNeg && neg) || (!negP && neg)) ? '-' : '') + ((negP && neg) ? '(' : '');
        }

        return prefix +
            paren + ((!neg && signed && value !== 0) ? '+' : '') +
            w + d +
            ((ord) ? ord : '') +
            ((abbr && !sep) ? abbr : '') +
            ((bytes) ? bytes : '') +
            ((negP && neg) ? ')' : '') +
            postfix;
    }

    /************************************
        Top Level Functions
    ************************************/

    numbro = function(input) {
        if (numbro.isNumbro(input)) {
            input = input.value();
        } else if (typeof input === 'string' || typeof input === 'number') {
            input = numbro.fn.unformat(input);
        } else {
            input = NaN;
        }

        return new Numbro(Number(input));
    };

    // version number
    numbro.version = VERSION;

    // compare numbro object
    numbro.isNumbro = function(obj) {
        return obj instanceof Numbro;
    };

    /**
     * This function allow the user to set a new language with a fallback if
     * the language does not exist. If no fallback language is provided,
     * it fallbacks to english.
     *
     * @deprecated Since in version 1.6.0. It will be deleted in version 2.0
     * `setCulture` should be used instead.
     */
    numbro.setLanguage = function(newLanguage, fallbackLanguage) {
        console.warn('`setLanguage` is deprecated since version 1.6.0. Use `setCulture` instead');
        var key = newLanguage,
            prefix = newLanguage.split('-')[0],
            matchingLanguage = null;
        if (!languages[key]) {
            Object.keys(languages).forEach(function(language) {
                if (!matchingLanguage && language.split('-')[0] === prefix) {
                    matchingLanguage = language;
                }
            });
            key = matchingLanguage || fallbackLanguage || 'en-US';
        }
        chooseCulture(key);
    };

    /**
     * This function allow the user to set a new culture with a fallback if
     * the culture does not exist. If no fallback culture is provided,
     * it falls back to "en-US".
     */
    numbro.setCulture = function(newCulture, fallbackCulture) {
        var key = newCulture,
            suffix = newCulture.split('-')[1],
            matchingCulture = null;
        if (!cultures[key]) {
            if (suffix) {
                Object.keys(cultures).forEach(function(language) {
                    if (!matchingCulture && language.split('-')[1] === suffix) {
                        matchingCulture = language;
                    }
                });
            }

            key = matchingCulture || fallbackCulture || 'en-US';
        }
        chooseCulture(key);
    };

    /**
     * This function will load languages and then set the global language.  If
     * no arguments are passed in, it will simply return the current global
     * language key.
     *
     * @deprecated Since in version 1.6.0. It will be deleted in version 2.0
     * `culture` should be used instead.
     */
    numbro.language = function(key, values) {
        console.warn('`language` is deprecated since version 1.6.0. Use `culture` instead');

        if (!key) {
            return currentCulture;
        }

        if (key && !values) {
            if (!languages[key]) {
                throw new Error('Unknown language : ' + key);
            }
            chooseCulture(key);
        }

        if (values || !languages[key]) {
            setCulture(key, values);
        }

        return numbro;
    };

    /**
     * This function will load cultures and then set the global culture.  If
     * no arguments are passed in, it will simply return the current global
     * culture code.
     */
    numbro.culture = function(code, values) {
        if (!code) {
            return currentCulture;
        }

        if (code && !values) {
            if (!cultures[code]) {
                throw new Error('Unknown culture : ' + code);
            }
            chooseCulture(code);
        }

        if (values || !cultures[code]) {
            setCulture(code, values);
        }

        return numbro;
    };

    /**
     * This function provides access to the loaded language data.  If
     * no arguments are passed in, it will simply return the current
     * global language object.
     *
     * @deprecated Since in version 1.6.0. It will be deleted in version 2.0
     * `culture` should be used instead.
     */
    numbro.languageData = function(key) {
        console.warn('`languageData` is deprecated since version 1.6.0. Use `cultureData` instead');

        if (!key) {
            return languages[currentCulture];
        }

        if (!languages[key]) {
            throw new Error('Unknown language : ' + key);
        }

        return languages[key];
    };

    /**
     * This function provides access to the loaded culture data.  If
     * no arguments are passed in, it will simply return the current
     * global culture object.
     */
    numbro.cultureData = function(code) {
        if (!code) {
            return cultures[currentCulture];
        }

        if (!cultures[code]) {
            throw new Error('Unknown culture : ' + code);
        }

        return cultures[code];
    };

    numbro.culture('en-US', enUS);

    /**
     * @deprecated Since in version 1.6.0. It will be deleted in version 2.0
     * `cultures` should be used instead.
     */
    numbro.languages = function() {
        console.warn('`languages` is deprecated since version 1.6.0. Use `cultures` instead');

        return languages;
    };

    numbro.cultures = function() {
        return cultures;
    };

    numbro.zeroFormat = function(format) {
        zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numbro.defaultFormat = function(format) {
        defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numbro.defaultCurrencyFormat = function (format) {
        defaultCurrencyFormat = typeof(format) === 'string' ? format : '0$';
    };

    numbro.validate = function(val, culture) {

        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            cultureData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';
            if (console.warn) {
                console.warn('Numbro.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //replace the initial '+' or '-' sign if present
        val = val.replace(/^[+-]?/, '');

        //if val is just digits return true
        if ( !! val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numbro.cultureData
        try {
            //check if the culture is understood by numbro. if not, default it to current culture
            cultureData = numbro.cultureData(culture);
        } catch (e) {
            cultureData = numbro.cultureData(numbro.culture());
        }

        //setup the delimiters and currency symbol based on culture
        _currSymbol = cultureData.currency.symbol;
        _abbrObj = cultureData.abbreviations;
        _decimalSep = cultureData.delimiters.decimal;
        if (cultureData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = cultureData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d\.\,]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million &&
                    temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0] === '') {
                        // for values without leading zero eg. .984
                        return (!_valArray[0].match(_thousandRegEx) &&
                            !!_valArray[1].match(/^\d+$/));

                    } else if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) &&
                            !_valArray[0].match(_thousandRegEx) &&
                            !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) &&
                            !_valArray[0].match(_thousandRegEx) &&
                            !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };

    /**
     * * @deprecated Since in version 1.6.0. It will be deleted in version 2.0
     * `loadCulturesInNode` should be used instead.
     */
    numbro.loadLanguagesInNode = function() {
        console.warn('`loadLanguagesInNode` is deprecated since version 1.6.0. Use `loadCulturesInNode` instead');

        numbro.loadCulturesInNode();
    };

    numbro.loadCulturesInNode = function() {
        // TODO: Rename the folder in 2.0.0
        var cultures = __webpack_require__(1193);

        for(var langLocaleCode in cultures) {
            if(langLocaleCode) {
                numbro.culture(langLocaleCode, cultures[langLocaleCode]);
            }
        }
    };

    /************************************
        Helpers
    ************************************/

    function setCulture(code, values) {
        cultures[code] = values;
    }

    function chooseCulture(code) {
        currentCulture = code;
        var defaults = cultures[code].defaults;
        if (defaults && defaults.format) {
            numbro.defaultFormat(defaults.format);
        }
        if (defaults && defaults.currencyFormat) {
            numbro.defaultCurrencyFormat(defaults.currencyFormat);
        }
    }

    function inNodejsRuntime() {
        return (typeof process !== 'undefined') &&
            (process.browser === undefined) &&
            process.title &&
            (
                process.title.indexOf('node') !== -1 ||
                process.title.indexOf('meteor-tool') > 0 ||
                process.title === 'grunt' ||
                process.title === 'gulp'
            ) &&
            ("function" !== 'undefined');
    }

    /************************************
        Floating-point helpers
    ************************************/

    // The floating-point helper functions and implementation
    // borrows heavily from sinful.js: http://guipn.github.io/sinful.js/

    /**
     * Array.prototype.reduce for browsers that don't support it
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce#Compatibility
     */
    if ('function' !== typeof Array.prototype.reduce) {
        Array.prototype.reduce = function(callback, optInitialValue) {

            if (null === this || 'undefined' === typeof this) {
                // At the moment all modern browsers, that support strict mode, have
                // native implementation of Array.prototype.reduce. For instance, IE8
                // does not support strict mode, so this check is actually useless.
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if ('function' !== typeof callback) {
                throw new TypeError(callback + ' is not a function');
            }

            var index,
                value,
                length = this.length >>> 0,
                isValueSet = false;

            if (1 < arguments.length) {
                value = optInitialValue;
                isValueSet = true;
            }

            for (index = 0; length > index; ++index) {
                if (this.hasOwnProperty(index)) {
                    if (isValueSet) {
                        value = callback(value, this[index], index, this);
                    } else {
                        value = this[index];
                        isValueSet = true;
                    }
                }
            }

            if (!isValueSet) {
                throw new TypeError('Reduce of empty array with no initial value');
            }

            return value;
        };
    }


    /**
     * Computes the multiplier necessary to make x >= 1,
     * effectively eliminating miscalculations caused by
     * finite precision.
     */
    function multiplier(x) {
        var parts = x.toString().split('.');
        if (parts.length < 2) {
            return 1;
        }
        return Math.pow(10, parts[1].length);
    }

    /**
     * Given a variable number of arguments, returns the maximum
     * multiplier that must be used to normalize an operation involving
     * all of them.
     */
    function correctionFactor() {
        var args = Array.prototype.slice.call(arguments);
        return args.reduce(function(prev, next) {
            var mp = multiplier(prev),
                mn = multiplier(next);
            return mp > mn ? mp : mn;
        }, -Infinity);
    }

    /************************************
        Numbro Prototype
    ************************************/


    numbro.fn = Numbro.prototype = {

        clone: function() {
            return numbro(this);
        },

        format: function(inputString, roundingFunction) {
            return formatNumbro(this,
                inputString ? inputString : defaultFormat,
                (roundingFunction !== undefined) ? roundingFunction : Math.round
            );
        },

        formatCurrency: function(inputString, roundingFunction) {
            return formatCurrency(this,
                cultures[currentCulture].currency.symbol,
                inputString ? inputString : defaultCurrencyFormat,
                (roundingFunction !== undefined) ? roundingFunction : Math.round
            );
        },

        formatForeignCurrency: function(currencySymbol, inputString, roundingFunction) {
            return formatForeignCurrency(this,
                currencySymbol,
                inputString ? inputString : defaultCurrencyFormat,
                (roundingFunction !== undefined) ? roundingFunction : Math.round
            );
        },

        unformat: function(inputString) {
            if (typeof inputString === 'number') {
                return inputString;
            } else if (typeof inputString === 'string') {
                var result = unformatNumbro(this, inputString);

                // Any unparseable string (represented as NaN in the result) is
                // converted into undefined.
                return isNaN(result) ? undefined : result;
            } else {
                return undefined;
            }
        },

        binaryByteUnits: function() {
            return formatByteUnits(this._value, bytes.binary.suffixes, bytes.binary.scale).suffix;
        },

        byteUnits: function() {
            return formatByteUnits(this._value, bytes.general.suffixes, bytes.general.scale).suffix;
        },

        decimalByteUnits: function() {
            return formatByteUnits(this._value, bytes.decimal.suffixes, bytes.decimal.scale).suffix;
        },

        value: function() {
            return this._value;
        },

        valueOf: function() {
            return this._value;
        },

        set: function(value) {
            this._value = Number(value);
            return this;
        },

        add: function(value) {
            var corrFactor = correctionFactor.call(null, this._value, value);

            function cback(accum, curr) {
                return accum + corrFactor * curr;
            }
            this._value = [this._value, value].reduce(cback, 0) / corrFactor;
            return this;
        },

        subtract: function(value) {
            var corrFactor = correctionFactor.call(null, this._value, value);

            function cback(accum, curr) {
                return accum - corrFactor * curr;
            }
            this._value = [value].reduce(cback, this._value * corrFactor) / corrFactor;
            return this;
        },

        multiply: function(value) {
            function cback(accum, curr) {
                var corrFactor = correctionFactor(accum, curr),
                    result = accum * corrFactor;
                result *= curr * corrFactor;
                result /= corrFactor * corrFactor;
                return result;
            }
            this._value = [this._value, value].reduce(cback, 1);
            return this;
        },

        divide: function(value) {
            function cback(accum, curr) {
                var corrFactor = correctionFactor(accum, curr);
                return (accum * corrFactor) / (curr * corrFactor);
            }
            this._value = [this._value, value].reduce(cback);
            return this;
        },

        difference: function(value) {
            return Math.abs(numbro(this._value).subtract(value).value());
        }

    };

    /************************************
        Exposing Numbro
    ************************************/

    if (inNodejsRuntime()) {
        //Todo: Rename the folder in 2.0.0
        numbro.loadCulturesInNode();
    }

    // CommonJS module is defined
    if (hasModule) {
        module.exports = numbro;
    } else {
        /*global ender:false */
        if (typeof ender === 'undefined') {
            // here, `this` means `window` in the browser, or `global` on the server
            // add `numbro` as a global object via a string identifier,
            // for Closure Compiler 'advanced' mode
            this.numbro = numbro;
        }

        /*global define:false */
        if (true) {
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
                return numbro;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        }
    }

}.call(typeof window === 'undefined' ? this : window));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1192)))

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

/* jshint sub: true */
exports['bg'] = __webpack_require__(1194);
exports['cs-CZ'] = __webpack_require__(1195);
exports['da-DK'] = __webpack_require__(1196);
exports['de-AT'] = __webpack_require__(1197);
exports['de-CH'] = __webpack_require__(1198);
exports['de-DE'] = __webpack_require__(1199);
exports['de-LI'] = __webpack_require__(1200);
exports['el'] = __webpack_require__(1201);
exports['en-AU'] = __webpack_require__(1202);
exports['en-GB'] = __webpack_require__(1203);
exports['en-IE'] = __webpack_require__(1204);
exports['en-NZ'] = __webpack_require__(1205);
exports['en-ZA'] = __webpack_require__(1206);
exports['es-AR'] = __webpack_require__(1207);
exports['es-CL'] = __webpack_require__(1208);
exports['es-CO'] = __webpack_require__(1209);
exports['es-CR'] = __webpack_require__(1210);
exports['es-ES'] = __webpack_require__(1211);
exports['es-NI'] = __webpack_require__(1212);
exports['es-PE'] = __webpack_require__(1213);
exports['es-PR'] = __webpack_require__(1214);
exports['es-SV'] = __webpack_require__(1215);
exports['et-EE'] = __webpack_require__(1216);
exports['fa-IR'] = __webpack_require__(1217);
exports['fi-FI'] = __webpack_require__(1218);
exports['fil-PH'] = __webpack_require__(1219);
exports['fr-CA'] = __webpack_require__(1220);
exports['fr-CH'] = __webpack_require__(1221);
exports['fr-FR'] = __webpack_require__(1222);
exports['he-IL'] = __webpack_require__(1223);
exports['hu-HU'] = __webpack_require__(1224);
exports['id'] = __webpack_require__(1225);
exports['it-CH'] = __webpack_require__(1226);
exports['it-IT'] = __webpack_require__(1227);
exports['ja-JP'] = __webpack_require__(1228);
exports['ko-KR'] = __webpack_require__(1229);
exports['lv-LV'] = __webpack_require__(1230);
exports['nb-NO'] = __webpack_require__(1231);
exports['nb'] = __webpack_require__(1232);
exports['nl-BE'] = __webpack_require__(1233);
exports['nl-NL'] = __webpack_require__(1234);
exports['nn'] = __webpack_require__(1235);
exports['pl-PL'] = __webpack_require__(1236);
exports['pt-BR'] = __webpack_require__(1237);
exports['pt-PT'] = __webpack_require__(1238);
exports['ro-RO'] = __webpack_require__(1239);
exports['ro'] = __webpack_require__(1240);
exports['ru-RU'] = __webpack_require__(1241);
exports['ru-UA'] = __webpack_require__(1242);
exports['sk-SK'] = __webpack_require__(1243);
exports['sl'] = __webpack_require__(1244);
exports['sr-Cyrl-RS'] = __webpack_require__(1245);
exports['sv-SE'] = __webpack_require__(485);
exports['th-TH'] = __webpack_require__(1246);
exports['tr-TR'] = __webpack_require__(1247);
exports['uk-UA'] = __webpack_require__(1248);
exports['zh-CN'] = __webpack_require__(1249);
exports['zh-MO'] = __webpack_require__(1250);
exports['zh-SG'] = __webpack_require__(1251);
exports['zh-TW'] = __webpack_require__(1252);

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Bulgarian
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'bg',
        cultureCode: 'bg',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'И',
            million: 'А',
            billion: 'M',
            trillion: 'T'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'лв.'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        this.numbro.culture('bg', language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1195 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Czech
 * locale: Czech Republic
 * author : Jan Pesa : https://github.com/smajl (based on work from Anatoli Papirovski : https://github.com/apapirovski)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'cs-CZ',
        cultureCode: 'cs-CZ',
        delimiters: {
            thousands: '\u00a0',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'mld.',
            trillion: 'bil.'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'Kč',
            position: 'postfix',
            spaceSeparated: true
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1196 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Danish
 * locale: Denmark
 * author : Michael Storgaard : https://github.com/mstorgaard
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'da-DK',
        cultureCode: 'da-DK',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mio',
            billion: 'mia',
            trillion: 'b'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'kr',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : German
 * locale: Austria
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'de-AT',
        cultureCode: 'de-AT',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1198 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : German
 * locale: Switzerland
 * author : Michael Piefel : https://github.com/piefel (based on work from Marco Krage : https://github.com/sinky)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'de-CH',
        cultureCode: 'de-CH',
        delimiters: {
            thousands: '\'',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'CHF',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1199 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : German
 * locale: Germany
 * author : Marco Krage : https://github.com/sinky
 *
 * Generally useful in Germany, Austria, Luxembourg, Belgium
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'de-DE',
        cultureCode: 'de-DE',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€',
            position: 'postfix',
            spaceSeparated: true
        },
        defaults: {
            currencyFormat: ',4'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1200 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : German
 * locale: Liechtenstein
 * author : Michael Piefel : https://github.com/piefel (based on work from Marco Krage : https://github.com/sinky)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'de-LI',
        cultureCode: 'de-LI',
        delimiters: {
            thousands: '\'',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'CHF',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1201 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Greek (el)
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'el',
        cultureCode: 'el',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'χ',
            million: 'ε',
            billion: 'δ',
            trillion: 'τ'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture('el', language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1202 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : English
 * locale: Australia
 * author : Benedikt Huss : https://github.com/ben305
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'en-AU',
        cultureCode: 'en-AU',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: '$ ,0.00',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: '$ ,0'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1203 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : English
 * locale: United Kingdom of Great Britain and Northern Ireland
 * author : Dan Ristic : https://github.com/dristic
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'en-GB',
        cultureCode: 'en-GB',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '£',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: '$ ,0.00',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: '$ ,0'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1204 */
/***/ (function(module, exports) {

/*!
+ * numbro.js language configuration
 * language : English
 * locale: Ireland
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'en-IE',
        cultureCode: 'en-IE',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                    (b === 2) ? 'nd' :
                        (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture('en-gb', language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1205 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : English
 * locale: New Zealand
 * author : Benedikt Huss : https://github.com/ben305
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'en-NZ',
        cultureCode: 'en-NZ',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: '$ ,0.00',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: '$ ,0'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1206 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : English
 * locale: South Africa
 * author : Stewart Scott https://github.com/stewart42
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'en-ZA',
        cultureCode: 'en-ZA',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: 'R',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: '$ ,0.00',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: '$ ,0'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1207 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Spanish
 * locale: Argentina
 * author : Hernan Garcia : https://github.com/hgarcia
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'es-AR',
        cultureCode: 'es-AR',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                (b === 7 || b === 0) ? 'mo' :
        (b === 8) ? 'vo' :
        (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '$',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1208 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Spanish
 * locale: Chile
 * author : Gwyn Judd : https://github.com/gwynjudd
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'es-CL',
        cultureCode: 'es-CL',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '$',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: '$0,0'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1209 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Spanish
 * locale: Colombia
 * author : Gwyn Judd : https://github.com/gwynjudd
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'es-CO',
        cultureCode: 'es-CO',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '€',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1210 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Spanish
 * locale: Costa Rica
 * author : Gwyn Judd : https://github.com/gwynjudd
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'es-CR',
        cultureCode: 'es-CR',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '₡',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1211 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Spanish
 * locale: Spain
 * author : Hernan Garcia : https://github.com/hgarcia
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'es-ES',
        cultureCode: 'es-ES',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '€',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1212 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Spanish
 * locale: Nicaragua
 * author : Gwyn Judd : https://github.com/gwynjudd
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'es-NI',
        cultureCode: 'es-NI',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: 'C$',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1213 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Spanish
 * locale: Peru
 * author : Gwyn Judd : https://github.com/gwynjudd
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'es-PE',
        cultureCode: 'es-PE',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: 'S/.',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1214 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Spanish
 * locale: Puerto Rico
 * author : Gwyn Judd : https://github.com/gwynjudd
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'es-PR',
        cultureCode: 'es-PR',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '$',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1215 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Spanish
 * locale: El Salvador
 * author : Gwyn Judd : https://github.com/gwynjudd
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'es-SV',
        cultureCode: 'es-SV',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '$',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Estonian
 * locale: Estonia
 * author : Illimar Tambek : https://github.com/ragulka
 *
 * Note: in Estonian, abbreviations are always separated
 * from numbers with a space
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'et-EE',
        cultureCode: 'et-EE',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: ' tuh',
            million: ' mln',
            billion: ' mld',
            trillion: ' trl'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1217 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Farsi
 * locale: Iran
 * author : neo13 : https://github.com/neo13
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'fa-IR',
        cultureCode: 'fa-IR',
        delimiters: {
            thousands: '،',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'هزار',
            million: 'میلیون',
            billion: 'میلیارد',
            trillion: 'تریلیون'
        },
        ordinal: function () {
            return 'ام';
        },
        currency: {
            symbol: '﷼'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1218 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Finnish
 * locale: Finland
 * author : Sami Saada : https://github.com/samitheberber
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'fi-FI',
        cultureCode: 'fi-FI',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'M',
            billion: 'G',
            trillion: 'T'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1219 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Filipino (Pilipino)
 * locale: Philippines
 * author : Michael Abadilla : https://github.com/mjmaix
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'fil-PH',
        cultureCode: 'fil-PH',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '₱'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1220 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : French
 * locale: Canada
 * author : Léo Renaud-Allaire : https://github.com/renaudleo
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'fr-CA',
        cultureCode: 'fr-CA',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'M',
            billion: 'G',
            trillion: 'T'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'ème';
        },
        currency: {
            symbol: '$',
            position: 'postfix',
            spaceSeparated : true
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: '$ ,0.00',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: '$ ,0'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1221 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : French
 * locale: Switzerland
 * author : Adam Draper : https://github.com/adamwdraper
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'fr-CH',
        cultureCode: 'fr-CH',
        delimiters: {
            thousands: ' ',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'ème';
        },
        currency: {
            symbol: 'CHF',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : French
 * locale: France
 * author : Adam Draper : https://github.com/adamwdraper
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'fr-FR',
        cultureCode: 'fr-FR',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'ème';
        },
        currency: {
            symbol: '€',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Hebrew
 * locale : IL
 * author : Eli Zehavi : https://github.com/eli-zehavi
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'he-IL',
        cultureCode: 'he-IL',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'אלף',
            million: 'מליון',
            billion: 'בליון',
            trillion: 'טריליון'
        },
        currency: {
            symbol: '₪',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: '₪ ,0.00',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: '₪ ,0'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));



/***/ }),
/* 1224 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Hungarian
 * locale: Hungary
 * author : Peter Bakondy : https://github.com/pbakondy
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'hu-HU',
        cultureCode: 'hu-HU',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'E',  // ezer
            million: 'M',   // millió
            billion: 'Mrd', // milliárd
            trillion: 'T'   // trillió
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: ' Ft',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1225 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Indonesian
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'id',
        cultureCode: 'id',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'r',
            million: 'j',
            billion: 'm',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'Rp'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture('id', language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1226 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Italian
 * locale: Switzerland
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'it-CH',
        cultureCode: 'it-CH',
        delimiters: {
            thousands: '\'',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'mila',
            million: 'mil',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '°';
        },
        currency: {
            symbol: 'CHF'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture('it-CH', language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Italian
 * locale: Italy
 * author : Giacomo Trombi : http://cinquepunti.it
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'it-IT',
        cultureCode: 'it-IT',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mila',
            million: 'mil',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return 'º';
        },
        currency: {
            symbol: '€',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1228 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Japanese
 * locale: Japan
 * author : teppeis : https://github.com/teppeis
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'ja-JP',
        cultureCode: 'ja-JP',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十億',
            trillion: '兆'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '¥',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: '$ ,0.00',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: '$ ,0'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1229 */
/***/ (function(module, exports) {

﻿/*!
 * numbro.js language configuration
 * language : Korean
 * author (numbro.js Version): Randy Wilander : https://github.com/rocketedaway
 * author (numeral.js Version) : Rich Daley : https://github.com/pedantic-git
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'ko-KR',
        cultureCode: 'ko-KR',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '천',
            million: '백만',
            billion: '십억',
            trillion: '일조'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '₩'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1230 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Latvian
 * locale: Latvia
 * author : Lauris Bukšis-Haberkorns : https://github.com/Lafriks
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'lv-LV',
        cultureCode: 'lv-LV',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: ' tūkst.',
            million: ' milj.',
            billion: ' mljrd.',
            trillion: ' trilj.'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };
    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1231 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language: Norwegian Bokmål
 * locale: Norway
 * author : Benjamin Van Ryseghem
 */
(function() {
    'use strict';

    var language = {
        langLocaleCode: 'nb-NO',
        cultureCode: 'nb-NO',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 't',
            million: 'M',
            billion: 'md',
            trillion: 't'
        },
        currency: {
            symbol: 'kr',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1232 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Norwegian Bokmål (nb)
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'nb',
        cultureCode: 'nb',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 't',
            million: 'mil',
            billion: 'mia',
            trillion: 'b'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'kr'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture('nb', language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1233 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Dutch
 * locale: Belgium
 * author : Dieter Luypaert : https://github.com/moeriki
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'nl-BE',
        cultureCode: 'nl-BE',
        delimiters: {
            thousands: ' ',
            decimal  : ','
        },
        abbreviations: {
            thousand : 'k',
            million  : 'mln',
            billion  : 'mld',
            trillion : 'bln'
        },
        ordinal : function (number) {
            var remainder = number % 100;
            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
        },
        currency: {
            symbol: '€',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Dutch
 * locale: Netherlands
 * author : Dave Clayton : https://github.com/davedx
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'nl-NL',
        cultureCode: 'nl-NL',
        delimiters: {
            thousands: '.',
            decimal  : ','
        },
        abbreviations: {
            thousand : 'k',
            million  : 'mln',
            billion  : 'mrd',
            trillion : 'bln'
        },
        ordinal : function (number) {
            var remainder = number % 100;
            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
        },
        currency: {
            symbol: '€',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1235 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Norwegian Nynorsk (nn)
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'nn',
        cultureCode: 'nn',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 't',
            million: 'mil',
            billion: 'mia',
            trillion: 'b'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'kr'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.language) {
        window.numbro.language('nn', language);
    }
}());


/***/ }),
/* 1236 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Polish
 * locale : Poland
 * author : Dominik Bulaj : https://github.com/dominikbulaj
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'pl-PL',
        cultureCode: 'pl-PL',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tys.',
            million: 'mln',
            billion: 'mld',
            trillion: 'bln'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: ' zł',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1237 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Portuguese
 * locale : Brazil
 * author : Ramiro Varandas Jr : https://github.com/ramirovjr
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'pt-BR',
        cultureCode: 'pt-BR',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mil',
            million: 'milhões',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return 'º';
        },
        currency: {
            symbol: 'R$',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1238 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Portuguese
 * locale : Portugal
 * author : Diogo Resende : https://github.com/dresende
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'pt-PT',
        cultureCode: 'pt-PT',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function () {
            return 'º';
        },
        currency: {
            symbol: '€',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1239 */
/***/ (function(module, exports) {

/*!
 * numeral.js language configuration
 * language : Romanian
 * author : Andrei Alecu https://github.com/andreialecu
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'ro-RO',
        cultureCode: 'ro-RO',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mii',
            million: 'mil',
            billion: 'mld',
            trillion: 'bln'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: ' lei',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1240 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Romanian (ro)
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'ro',
        cultureCode: 'ro',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mie',
            million: 'mln',
            billion: 'mld',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'RON'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture('ro', language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1241 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Russian
 * locale : Russsia
 * author : Anatoli Papirovski : https://github.com/apapirovski
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'ru-RU',
        cultureCode: 'ru-RU',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            // not ideal, but since in Russian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '.';
        },
        currency: {
            symbol: 'руб.',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1242 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Russian
 * locale : Ukraine
 * author : Anatoli Papirovski : https://github.com/apapirovski
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'ru-UA',
        cultureCode: 'ru-UA',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            // not ideal, but since in Russian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '.';
        },
        currency: {
            symbol: '\u20B4',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1243 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Slovak
 * locale : Slovakia
 * author : Jan Pesa : https://github.com/smajl (based on work from Ahmed Al Hafoudh : http://www.freevision.sk)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'sk-SK',
        cultureCode: 'sk-SK',
        delimiters: {
            thousands: '\u00a0',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'mld.',
            trillion: 'bil.'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€',
            position: 'postfix',
            spaceSeparated: true
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1244 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Slovene
 * locale: Slovenia
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'sl',
        cultureCode: 'sl',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture('sl', language);
    }
}());


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Serbian (sr)
 * country : Serbia (Cyrillic)
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'sr-Cyrl-RS',
        cultureCode: 'sr-Cyrl-RS',
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'RSD'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture('sr-Cyrl-RS', language);
    }
}());


/***/ }),
/* 1246 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Thai
 * locale : Thailand
 * author : Sathit Jittanupat : https://github.com/jojosati
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'th-TH',
        cultureCode: 'th-TH',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'พัน',
            million: 'ล้าน',
            billion: 'พันล้าน',
            trillion: 'ล้านล้าน'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '฿',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1247 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Turkish
 * locale : Turkey
 * author : Ecmel Ercan : https://github.com/ecmel,
 *          Erhan Gundogan : https://github.com/erhangundogan,
 *          Burak Yiğit Kaya: https://github.com/BYK
 */
(function() {
    'use strict';

    var suffixes = {
            1: '\'inci',
            5: '\'inci',
            8: '\'inci',
            70: '\'inci',
            80: '\'inci',

            2: '\'nci',
            7: '\'nci',
            20: '\'nci',
            50: '\'nci',

            3: '\'üncü',
            4: '\'üncü',
            100: '\'üncü',

            6: '\'ncı',

            9: '\'uncu',
            10: '\'uncu',
            30: '\'uncu',

            60: '\'ıncı',
            90: '\'ıncı'
        },
        language = {
            langLocaleCode: 'tr-TR',
            cultureCode: 'tr-TR',
            delimiters: {
                thousands: '.',
                decimal: ','
            },
            abbreviations: {
                thousand: 'bin',
                million: 'milyon',
                billion: 'milyar',
                trillion: 'trilyon'
            },
            ordinal: function(number) {
                if (number === 0) {  // special case for zero
                    return '\'ıncı';
                }

                var a = number % 10,
                    b = number % 100 - a,
                    c = number >= 100 ? 100 : null;

                return suffixes[a] || suffixes[b] || suffixes[c];
            },
            currency: {
                symbol: '\u20BA',
                position: 'postfix'
            },
            defaults: {
                currencyFormat: ',4 a'
            },
            formats: {
                fourDigits: '4 a',
                fullWithTwoDecimals: ',0.00 $',
                fullWithTwoDecimalsNoCurrency: ',0.00',
                fullWithNoDecimals: ',0 $'
            }
        };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1248 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Ukrainian
 * locale : Ukraine
 * author : Michael Piefel : https://github.com/piefel (with help from Tetyana Kuzmenko)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'uk-UA',
        cultureCode: 'uk-UA',
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тис.',
            million: 'млн',
            billion: 'млрд',
            trillion: 'блн'
        },
        ordinal: function () {
            // not ideal, but since in Ukrainian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '';
        },
        currency: {
            symbol: '\u20B4',
            position: 'postfix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: ',0.00 $',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: ',0 $'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : simplified chinese
 * locale : China
 * author : badplum : https://github.com/badplum
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'zh-CN',
        cultureCode: 'zh-CN',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十亿',
            trillion: '兆'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '¥',
            position: 'prefix'
        },
        defaults: {
            currencyFormat: ',4 a'
        },
        formats: {
            fourDigits: '4 a',
            fullWithTwoDecimals: '$ ,0.00',
            fullWithTwoDecimalsNoCurrency: ',0.00',
            fullWithNoDecimals: '$ ,0'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1250 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Chinese traditional
 * locale: Macau
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'zh-MO',
        cultureCode: 'zh-MO',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百萬',
            billion: '十億',
            trillion: '兆'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'MOP'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture('zh-MO', language);
    }
}());


/***/ }),
/* 1251 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Chinese simplified
 * locale: Singapore
 * author : Tim McIntosh (StayinFront NZ)
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'zh-SG',
        cultureCode: 'zh-SG',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十亿',
            trillion: '兆'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '$'
        }
    };

    // Node
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture('zh-SG', language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

/*!
 * numbro.js language configuration
 * language : Chinese (Taiwan)
 * author (numbro.js Version): Randy Wilander : https://github.com/rocketedaway
 * author (numeral.js Version) : Rich Daley : https://github.com/pedantic-git
 */
(function () {
    'use strict';

    var language = {
        langLocaleCode: 'zh-TW',
        cultureCode: 'zh-TW',
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百萬',
            billion: '十億',
            trillion: '兆'
        },
        ordinal: function () {
            return '第';
        },
        currency: {
            symbol: 'NT$'
        }
    };

    // CommonJS
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = language;
    }
    // Browser
    if (typeof window !== 'undefined' && window.numbro && window.numbro.culture) {
        window.numbro.culture(language.cultureCode, language);
    }
}.call(typeof window === 'undefined' ? this : window));


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _unionBy2=__webpack_require__(464);var _unionBy3=_interopRequireDefault(_unionBy2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _reject2=__webpack_require__(68);var _reject3=_interopRequireDefault(_reject2);var _differenceBy2=__webpack_require__(1254);var _differenceBy3=_interopRequireDefault(_differenceBy2);var _pick2=__webpack_require__(86);var _pick3=_interopRequireDefault(_pick2);var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  input: any,
  label: string,
  specialProducts: Object,
  productTypes: any[],
};*/var _ref4=_react2.default.createElement('span',null,'Inga specialprodukter tillg\xE4ngliga');var SpecialProductsInput=function SpecialProductsInput(_ref){var input=_ref.input,label=_ref.label,specialProducts=_ref.specialProducts,productTypes=_ref.productTypes;return _react2.default.createElement('div',null,_react2.default.createElement('label',null,label),_react2.default.createElement('div',null,!(0,_isEmpty3.default)(productTypes)?(0,_map3.default)(function(productType){var options=specialProducts[productType.id];var value=(0,_filter3.default)(function(_ref2){var id=_ref2.id;return!!(0,_find3.default)({id:id},options);},input.value);return _react2.default.createElement(_SelectFormInput2.default,{key:productType.id,input:{value:value,onBlur:_noop3.default,onChange:function onChange(val){var selected=(0,_map3.default)((0,_pick3.default)(['id']),val);var removed=(0,_differenceBy3.default)('id',value,selected);var withoutRemoved=(0,_reject3.default)(function(_ref3){var id=_ref3.id;return(0,_some3.default)({id:id},removed);},input.value);input.onChange((0,_unionBy3.default)('id',selected,withoutRemoved));}},meta:{},label:productType.name,multi:true,valueKey:'id',labelKey:'name',options:options});},productTypes):_ref4));};exports.default=SpecialProductsInput;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('differenceBy', __webpack_require__(1255));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var baseDifference = __webpack_require__(1256),
    baseFlatten = __webpack_require__(119),
    baseIteratee = __webpack_require__(24),
    baseRest = __webpack_require__(83),
    isArrayLikeObject = __webpack_require__(171),
    last = __webpack_require__(261);

/**
 * This method is like `_.difference` except that it accepts `iteratee` which
 * is invoked for each element of `array` and `values` to generate the criterion
 * by which they're compared. The order and references of result values are
 * determined by the first array. The iteratee is invoked with one argument:
 * (value).
 *
 * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
 * // => [1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
 * // => [{ 'x': 2 }]
 */
var differenceBy = baseRest(function(array, values) {
  var iteratee = last(values);
  if (isArrayLikeObject(iteratee)) {
    iteratee = undefined;
  }
  return isArrayLikeObject(array)
    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), baseIteratee(iteratee, 2))
    : [];
});

module.exports = differenceBy;


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(163),
    arrayIncludes = __webpack_require__(149),
    arrayIncludesWith = __webpack_require__(233),
    arrayMap = __webpack_require__(46),
    baseUnary = __webpack_require__(63),
    cacheHas = __webpack_require__(164);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

module.exports = baseDifference;


/***/ }),
/* 1257 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _flatMap2=__webpack_require__(54);var _flatMap3=_interopRequireDefault(_flatMap2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);var _DecimalFormInput=__webpack_require__(70);var _DecimalFormInput2=_interopRequireDefault(_DecimalFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var filterByRoomTypeId=function filterByRoomTypeId(roomId,rooms,products){var room=(0,_find3.default)({id:roomId},rooms);return!!room?(0,_filter3.default)(function(p){return!p.roomTypes.length||(0,_some3.default)({id:room.roomTypeId},p.roomTypes);},products):products;};var productVariantByRoomTypeId=function productVariantByRoomTypeId(roomId,rooms,products){var room=(0,_find3.default)({id:roomId},rooms);var productList=!!room?(0,_filter3.default)(function(p){return p.archived===null&&(!p.roomTypes.length||(0,_some3.default)({id:room.roomTypeId},p.roomTypes));},products):products;var combined=(0,_flatMap3.default)(function(p){var notArchived=(0,_filter3.default)(function(pv){return pv.archived===null;},p.variants);return(0,_map3.default)(function(pv){return{key:pv.id,item:pv,name:p.name+' - '+pv.name};},notArchived);},productList);return(0,_sortBy3.default)(['name'],combined);};/*:: export type Props = {
  existingRows: any[],
  products: any[],
  variants: any[],
  rooms: any[],
  activeRow: any,
  formValues: ?any,
  change: Function,
  onSelectProduct: Function,
  combineProduct: Boolean
};*/var _ref2=_react2.default.createElement(_reduxForm.Field,{name:'quantity',label:'Antal',component:_DecimalFormInput2.default});var _ref3=_react2.default.createElement(_reduxForm.Field,{name:'note',label:'Anteckning',component:_TextAreaFormInput2.default});var ProductRowForm=function ProductRowForm(_ref){var activeRow=_ref.activeRow,products=_ref.products,variants=_ref.variants,rooms=_ref.rooms,existingRows=_ref.existingRows,change=_ref.change,onSelectProduct=_ref.onSelectProduct,formValues=_ref.formValues,combineProduct=_ref.combineProduct;return _react2.default.createElement('div',null,_react2.default.createElement(_reduxForm.Field,{name:'roomId',label:'Rum',disabled:!!activeRow.id,normalize:function normalize(value){var id=value?value.id:null;change('product',null);change('productVariant',null);change('productCombo',null);return id;},component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:rooms}),formValues&&formValues.roomId&&_react2.default.createElement('div',null,combineProduct?_react2.default.createElement(_reduxForm.Field,{name:'productVariant',label:'Produkt Variant',disabled:!!activeRow.id,normalize:function normalize(value){return value.item;},component:_SelectFormInput2.default,valueKey:'key',labelKey:'name',options:productVariantByRoomTypeId(formValues.roomId,rooms,products)}):_react2.default.createElement('div',null,_react2.default.createElement(_reduxForm.Field,{name:'product',label:'Produkt',disabled:!!activeRow.id,normalize:function normalize(value){var id=value?value.id:null;change('productVariant',null);onSelectProduct(id);return value;},component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:filterByRoomTypeId(formValues.roomId,rooms,products)}),_react2.default.createElement(_reduxForm.Field,{name:'productVariant',label:'Variant',disabled:!!activeRow.id||!formValues||!formValues.product,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:(0,_map3.default)(function(v){return _extends({},v,{disabled:!!formValues&&!!formValues.roomId&&(0,_some3.default)({productVariantId:v.id,roomId:formValues.roomId},existingRows)});},variants)})),_ref2,_ref3));};exports.default=(0,_reduxForm.reduxForm)({form:'productRow',enableReinitialize:true})(ProductRowForm);

/***/ }),
/* 1259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _ref=_react2.default.createElement('div',{className:'OrderRowNoteForm'},_react2.default.createElement(_reduxForm.Field,{name:'note',label:'Anteckning',component:_TextAreaFormInput2.default}));var OrderRowNoteForm=function OrderRowNoteForm(){return _ref;};exports.default=(0,_reduxForm.reduxForm)({form:'noteRow',enableReinitialize:true})(OrderRowNoteForm);

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _OrderCommentForm=__webpack_require__(1262);var _OrderCommentForm2=_interopRequireDefault(_OrderCommentForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);__webpack_require__(1263);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  error: ?any,
  formValues: any,
  isLoading: boolean,
  onClose: () => any,
  onRemove: () => any,
  onSave: () => any,
  orderComment: any,
  roomTypes: any[],
  validate: Function,
  workerTypes: any[],
};*/var OrderCommentDialog=function OrderCommentDialog(_ref){var error=_ref.error,formValues=_ref.formValues,isLoading=_ref.isLoading,onClose=_ref.onClose,onRemove=_ref.onRemove,onSave=_ref.onSave,orderComment=_ref.orderComment,roomTypes=_ref.roomTypes,validate=_ref.validate,workerTypes=_ref.workerTypes;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:onClose,className:'OrderCommentDialog',show:true},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isLoading}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_OrderCommentForm2.default,{formValues:formValues,initialValues:orderComment,roomTypes:roomTypes,validate:validate,workerTypes:workerTypes}),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onSave},'Spara'),!!orderComment&&!!orderComment.id&&_react2.default.createElement(_ActionConfirmation2.default,{action:function action(){return onRemove();},buttonText:'Ta bort',className:'expanded warning',id:'removeOrderComment',message:'Vill du verkligen ta bort den h\xE4r kommentaren?'}),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onClose},'Avbryt')));};exports.default=OrderCommentDialog;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  roomTypes: any[],
  workerTypes: any[],
};*/var _ref2=_react2.default.createElement(_reduxForm.Field,{name:'note',label:'Kommentar',component:_TextAreaFormInput2.default});var OrderCommentForm=function OrderCommentForm(_ref){var roomTypes=_ref.roomTypes,workerTypes=_ref.workerTypes;return _react2.default.createElement('div',{className:'OrderCommentForm'},_react2.default.createElement(_reduxForm.Field,{name:'workerTypeId',label:'Yrkeskategori',normalize:function normalize(value){return value?value.id:null;},clearable:true,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:workerTypes}),_react2.default.createElement(_reduxForm.Field,{name:'roomTypeId',label:'Rumstyp',normalize:function normalize(value){return value?value.id:null;},clearable:true,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:roomTypes}),_ref2);};exports.default=(0,_reduxForm.reduxForm)({form:'orderComment',enableReinitialize:true})(OrderCommentForm);

/***/ }),
/* 1263 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _mapValues2=__webpack_require__(66);var _mapValues3=_interopRequireDefault(_mapValues2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _customRowView=__webpack_require__(399);var _reduxForm=__webpack_require__(4);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _CustomRowForm=__webpack_require__(1265);var _CustomRowForm2=_interopRequireDefault(_CustomRowForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _Button=__webpack_require__(258);var _Button2=_interopRequireDefault(_Button);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _orderStates=__webpack_require__(69);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var customRowValidation={name:{rule:'string|required',label:'Namn'},workerTypes:{rule:'required',label:'Yrkeskategorier'},supplierId:{rule:'numeric|required',label:'Leverantör'},room:{rule:'required',label:'Rum'},externalItemNumber:{rule:'string',label:'Externt artikelnummer'},externalDescription:{rule:'string',label:'Beskrivning'},internalDescription:{rule:'string',label:'Beskrivning'},quantity:{rule:'numeric|min:0',label:'Antal'},price:{rule:'numeric',label:'Försäljningspris'}};/*:: export type Props = {
  clear: Function,
  setDirty: Function,
  reset: Function,
  touch: Function,
  resetForm: Function,
  isDirty: boolean,
  resourcePath: string,
  prevPath: string,
  params: any,
  orderId: number,
  fetchData: Function,
  fetchCustomRow: Function,
  customRow: ?any,
  customRowError: ?any,
  customRowHasLoaded: boolean,
  isFetching: boolean,
  createCustomRow: Function,
  updateCustomRow: Function,
  removeCustomRow: Function,
  customRowFormValues: any,
  customRowFormIsValid: boolean,
  customRowFiles: Object,
  customRowUploads: Object,
  customRowUploadFile: Function,
  customRowAbortFileUpload: Function,
  customRowRemoveFile: Function,
  suppliers: any[],
  productTypes: any[],
  workerTypes: any[],
  roomTypes: any[],
  rooms: any[],
  order: ?any,
};*/var _ref=_react2.default.createElement(_Button2.default,{icon:'chevron-left'});var CustomRowContainer=function(_Component){_inherits(CustomRowContainer,_Component);function CustomRowContainer(){_classCallCheck(this,CustomRowContainer);return _possibleConstructorReturn(this,(CustomRowContainer.__proto__||Object.getPrototypeOf(CustomRowContainer)).apply(this,arguments));}_createClass(CustomRowContainer,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,orderId=_props.orderId,id=_props.params.id;this.props.fetchData(orderId);if(id){this.props.fetchCustomRow(id,orderId);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clear();}},{key:'setDirty',value:function setDirty(){var _props2=this.props,setDirty=_props2.setDirty,isDirty=_props2.isDirty;if(!isDirty){setDirty(true);}}},{key:'reset',value:function reset(){var _props3=this.props,setDirty=_props3.setDirty,reset=_props3.reset,resetForm=_props3.resetForm;reset();resetForm('customRow');setDirty(false);}},{key:'save',value:function save(){var _props4=this.props,customRowFormValues=_props4.customRowFormValues,customRowFormIsValid=_props4.customRowFormIsValid,orderId=_props4.orderId,customRow=_props4.customRow,createCustomRow=_props4.createCustomRow,updateCustomRow=_props4.updateCustomRow,customRowFiles=_props4.customRowFiles,touch=_props4.touch;var keys=(0,_keys3.default)(customRowValidation);touch.apply(undefined,['customRow'].concat(_toConsumableArray(keys)));if(!customRowFormIsValid){return;}var data=_extends({},customRowFormValues,customRowFiles);if(!customRow){createCustomRow(orderId,data);}else{updateCustomRow(customRow.id,data);}}},{key:'render',value:function render(){var _this2=this;var _props5=this.props,isDirty=_props5.isDirty,id=_props5.params.id,prevPath=_props5.prevPath,isFetching=_props5.isFetching,customRow=_props5.customRow,customRowError=_props5.customRowError,customRowHasLoaded=_props5.customRowHasLoaded,customRowFiles=_props5.customRowFiles,customRowUploads=_props5.customRowUploads,customRowUploadFile=_props5.customRowUploadFile,customRowAbortFileUpload=_props5.customRowAbortFileUpload,customRowRemoveFile=_props5.customRowRemoveFile,removeCustomRow=_props5.removeCustomRow,resourcePath=_props5.resourcePath,suppliers=_props5.suppliers,productTypes=_props5.productTypes,workerTypes=_props5.workerTypes,roomTypes=_props5.roomTypes,rooms=_props5.rooms,order=_props5.order;return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_ref,_react2.default.createElement('div',{className:'content-title'},customRow&&customRow.name||'Ny friprodukt'))),customRow&&!!order&&order.state===_orderStates.NEW&&_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},_react2.default.createElement(_ActionConfirmation2.default,{id:'removeCustomRow',className:'danger button',message:'Vill du verkligen ta bort den här friprodukten?',buttonText:'Ta bort',action:function action(){return removeCustomRow(customRow.id);}}))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement(_ServerError2.default,{error:customRowError}),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_CustomRowForm2.default,{showRoomTypes:customRowHasLoaded&&customRow&&!customRow.room,customRowFiles:customRowFiles,customRowFileUploads:customRowUploads,suppliers:suppliers,productTypes:productTypes,roomTypes:roomTypes,rooms:rooms,workerTypes:workerTypes,onUploadFile:customRowUploadFile,onRemoveFile:customRowRemoveFile,onFileUploadAbort:customRowAbortFileUpload,initialValues:customRow,onUserChange:function onUserChange(){return _this2.setDirty();},validate:function validate(values){return(0,_validator2.default)(customRowValidation,values);}}),!id&&customRow&&_react2.default.createElement(_reactRouterDom.Redirect,{to:resourcePath+'/'+customRow.id}),customRowHasLoaded&&!customRow&&_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath})),isDirty&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return CustomRowContainer;}(_react.Component);var getCustomRowUploads=function getCustomRowUploads(uploadIds,files){return(0,_mapValues3.default)(function(id){return files.byId[id];},uploadIds)||{};};var mapStateToProps=function mapStateToProps(_ref2){var _ref2$customRowView=_ref2.customRowView,_ref2$customRowView$c=_ref2$customRowView.customRow,customRow=_ref2$customRowView$c.active,customRowFiles=_ref2$customRowView$c.files,customRowUploadIds=_ref2$customRowView.uploadIds,customRowError=_ref2$customRowView.error,customRowIsFetching=_ref2$customRowView.isFetching,customRowDataIsFetching=_ref2$customRowView.dataIsFetching,isDirty=_ref2$customRowView.isDirty,customRowHasLoaded=_ref2$customRowView.hasLoaded,suppliers=_ref2$customRowView.suppliers.filteredList,productTypes=_ref2$customRowView.productTypes.filteredList,workerTypes=_ref2$customRowView.workerTypes.filteredList,roomTypes=_ref2$customRowView.roomTypes.filteredList,rooms=_ref2$customRowView.rooms.filteredList,order=_ref2$customRowView.order,form=_ref2.form,files=_ref2.files;return{isDirty:isDirty,customRowFormIsValid:(0,_reduxForm.isValid)('customRow')({form:form}),customRowFormValues:(0,_reduxForm.getFormValues)('customRow')({form:form}),customRow:customRow,customRowFiles:customRowFiles,customRowUploads:getCustomRowUploads(customRowUploadIds,files),customRowError:customRowError,isFetching:customRowIsFetching||customRowDataIsFetching,customRowHasLoaded:customRowHasLoaded,suppliers:suppliers,productTypes:productTypes,workerTypes:workerTypes,roomTypes:roomTypes,rooms:rooms,order:order};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty){return dispatch((0,_form.setDirty)(dirty,'customRow'));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_customRowView.reset)());},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},clear:function clear(){return dispatch((0,_customRowView.clear)());},fetchCustomRow:function fetchCustomRow(customRowId,orderId){return dispatch((0,_customRowView.fetchCustomRow)(customRowId,orderId));},fetchData:function fetchData(orderId){return dispatch((0,_customRowView.fetchData)(orderId));},createCustomRow:function createCustomRow(orderId,data){return dispatch((0,_customRowView.createCustomRow)(orderId,data));},updateCustomRow:function updateCustomRow(id,data){return dispatch((0,_customRowView.updateCustomRow)(id,data));},removeCustomRow:function removeCustomRow(id){return dispatch((0,_customRowView.removeCustomRow)(id));},customRowRemoveFile:function customRowRemoveFile(name){return dispatch((0,_customRowView.customRowRemoveFile)(name));},customRowUploadFile:function customRowUploadFile(name,_ref3){var _ref4=_toArray(_ref3),file=_ref4[0],rest=_ref4.slice(1);if(file){dispatch((0,_customRowView.customRowUploadFile)(name,file));}},customRowAbortFileUpload:function customRowAbortFileUpload(tempId){return dispatch((0,_customRowView.customRowAbortFileUpload)(tempId));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(CustomRowContainer);

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);var _DecimalFormInput=__webpack_require__(70);var _DecimalFormInput2=_interopRequireDefault(_DecimalFormInput);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _priceHelpers=__webpack_require__(85);var _FileDropzone=__webpack_require__(128);var _FileDropzone2=_interopRequireDefault(_FileDropzone);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  showRoomTypes: Boolean,
  onUserChange: Function,
  customRowFiles: Object,
  suppliers: any[],
  productTypes: any[],
  workerTypes: any[],
  roomTypes: any[],
  rooms: any[],
  customRowFileUploads: Object,
  onUploadFile: Function,
  onFileUploadAbort: Function,
  onRemoveFile: Function,
};*/var _ref2=_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'}),_react2.default.createElement('div',{className:'small-6 column'}));var CustomRowForm=function CustomRowForm(_ref){var showRoomTypes=_ref.showRoomTypes,customRowFiles=_ref.customRowFiles,suppliers=_ref.suppliers,productTypes=_ref.productTypes,workerTypes=_ref.workerTypes,roomTypes=_ref.roomTypes,rooms=_ref.rooms,customRowFileUploads=_ref.customRowFileUploads,onUploadFile=_ref.onUploadFile,onFileUploadAbort=_ref.onFileUploadAbort,onRemoveFile=_ref.onRemoveFile,onUserChange=_ref.onUserChange;return _react2.default.createElement('div',{className:'CustomRowForm'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',component:_BasicFormInput2.default,onChange:onUserChange,type:'text'}),_react2.default.createElement(_reduxForm.Field,{name:'productTypeId',label:'Produkttyp',normalize:function normalize(value){return value?value.id:null;},component:_SelectFormInput2.default,onChange:onUserChange,valueKey:'id',labelKey:'name',options:productTypes}),_react2.default.createElement(_reduxForm.Field,{name:'workerTypes',label:'Yrkeskategorier',component:_SelectFormInput2.default,onChange:onUserChange,valueKey:'id',labelKey:'name',options:workerTypes,multi:true}),showRoomTypes?_react2.default.createElement(_reduxForm.Field,{name:'roomTypes',label:'Rumstyper',component:_SelectFormInput2.default,onChange:onUserChange,valueKey:'id',labelKey:'name',options:roomTypes,multi:true}):null,_react2.default.createElement(_reduxForm.Field,{name:'room',label:'Rum',component:_SelectFormInput2.default,onChange:onUserChange,valueKey:'id',labelKey:'name',options:rooms,multi:false}),_react2.default.createElement(_reduxForm.Field,{name:'supplierId',label:'Leverant\xF6r',normalize:function normalize(value){return value?value.id:null;},component:_SelectFormInput2.default,onChange:onUserChange,valueKey:'id',labelKey:'name',options:suppliers}),_react2.default.createElement(_reduxForm.Field,{name:'externalItemNumber',label:'Externt artikelnummer',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),_react2.default.createElement(_FileDropzone2.default,{label:'Image',accept:'image/png, image/jpg, image/jpeg, image/bmp',preview:true,file:customRowFiles.image,upload:customRowFileUploads.image,onUpload:function onUpload(f){return onUploadFile('image',f);},onUploadAbort:function onUploadAbort(u){return onFileUploadAbort(u);},onRemove:function onRemove(){return onRemoveFile('image');},onChange:onUserChange})),_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'externalDescription',label:'Produktbeskrivning',component:_TextAreaFormInput2.default,onChange:onUserChange}),_react2.default.createElement(_reduxForm.Field,{name:'internalDescription',label:'Intern beskrivning',component:_TextAreaFormInput2.default,onChange:onUserChange}),_react2.default.createElement(_reduxForm.Field,{name:'quantity',label:'Antal',component:_DecimalFormInput2.default,onChange:onUserChange}),_react2.default.createElement(_reduxForm.Field,{name:'totalBuyingPrice',label:'Ink\xF6pspris ink. moms (OBS! Ange totalkostnaden f\xF6r samtliga antal!)',component:_DecimalFormInput2.default,onChange:onUserChange}),_react2.default.createElement(_reduxForm.Field,{name:'totalSellingPrice',label:'S\xE4ljpris ex. moms (OBS! Ange totalkostnaden f\xF6r samtliga antal!)',onChangeTransform:_priceHelpers.addVAT,valueTransform:_priceHelpers.removeVAT,component:_DecimalFormInput2.default,onChange:onUserChange}),_react2.default.createElement(_reduxForm.Field,{name:'totalSellingPrice',label:'S\xE4ljpris ink. moms (OBS! Ange totalkostnaden f\xF6r samtliga antal!)',component:_DecimalFormInput2.default,onChange:onUserChange}))),_ref2);};exports.default=(0,_reduxForm.reduxForm)({form:'customRow',enableReinitialize:true})(CustomRowForm);

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _customerView=__webpack_require__(170);var _CustomerOrderContainer=__webpack_require__(489);var _CustomerOrderContainer2=_interopRequireDefault(_CustomerOrderContainer);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);__webpack_require__(1315);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  orderId: string,
  apartment?: any,
  order?: any,
  project?: any,
  isFetching?: boolean,
  error?: any,
  fetchOrder: Function,
  clear: Function,
  updateOrder: Function,
};*/var _ref=_react2.default.createElement(_Navigation2.default,null);var _ref2=_react2.default.createElement(_LoadingIndicator2.default,{isLoading:true,isGlobal:true});var AdminCustomerContainer=function(_Component){_inherits(AdminCustomerContainer,_Component);function AdminCustomerContainer(){_classCallCheck(this,AdminCustomerContainer);return _possibleConstructorReturn(this,(AdminCustomerContainer.__proto__||Object.getPrototypeOf(AdminCustomerContainer)).apply(this,arguments));}_createClass(AdminCustomerContainer,[{key:'componentWillMount',value:function componentWillMount(){var _props=this.props,orderId=_props.orderId,fetchOrder=_props.fetchOrder;fetchOrder(orderId);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clear();}},{key:'render',value:function render(){var _props2=this.props,project=_props2.project,order=_props2.order,apartment=_props2.apartment,isFetching=_props2.isFetching,updateOrder=_props2.updateOrder,error=_props2.error;return _react2.default.createElement('div',{className:'AdminCustomerContainer'},order&&apartment&&_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_ref,_react2.default.createElement('div',{className:'content-title'},'Kundorder - ',order.user.username)))),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_CustomerOrderContainer2.default,{showHeader:false,order:order,project:project,apartment:apartment,updateOrder:updateOrder})),isFetching&&_ref2);}}]);return AdminCustomerContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref3){var _ref3$customerView=_ref3.customerView,_ref3$customerView$or=_ref3$customerView.order,order=_ref3$customerView$or.order,project=_ref3$customerView$or.project,apartment=_ref3$customerView$or.apartment,error=_ref3$customerView$or.error,isFetching=_ref3$customerView$or.isFetching,showMenu=_ref3$customerView.showMenu;return{order:order,project:project,apartment:apartment,error:error,isFetching:isFetching,showMenu:showMenu};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchOrder:function fetchOrder(id){return dispatch((0,_customerView.fetchOrder)(id));},toggleMenu:function toggleMenu(show){return dispatch((0,_customerView.toggleMenu)(show));},clear:function clear(){return dispatch((0,_customerView.clear)());},updateOrder:function updateOrder(id,state){return dispatch((0,_customerView.updateOrder)(id,state));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(AdminCustomerContainer);

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  handleSubmit: Function,
};*/var _ref2=_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_reduxForm.Field,{name:'message',label:'Meddelande/Fr\xE5ga',component:_TextAreaFormInput2.default}),_react2.default.createElement('button',{type:'submit',className:'button success column shrink'},'Skicka'));var HelpForm=function HelpForm(_ref){var handleSubmit=_ref.handleSubmit;return _react2.default.createElement('div',{className:'HelpForm'},_react2.default.createElement('form',{onSubmit:handleSubmit},_ref2));};exports.default=(0,_reduxForm.reduxForm)({form:'helpform'})(HelpForm);

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _Paginator=__webpack_require__(477);var _Paginator2=_interopRequireDefault(_Paginator);var _CustomerProductCard=__webpack_require__(490);var _CustomerProductCard2=_interopRequireDefault(_CustomerProductCard);__webpack_require__(1285);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var amountOfPages=function amountOfPages(variants,_ref){var perPage=_ref.perPage;return Math.ceil(variants.length/perPage);};var paginate=function paginate(variants,_ref2){var page=_ref2.page,perPage=_ref2.perPage;var pages=amountOfPages(variants,{perPage:perPage});var currentPage=page<=pages?page:1;var beginSlice=(currentPage-1)*perPage;var endSlice=beginSlice+perPage;return variants.slice(beginSlice,endSlice);};/*:: export type Props = {
  products: any[],
  pagination: Object,
  isLoading: boolean,
  onOpenProduct: Function,
  onSelectProduct: Function,
  onRemoveProduct: Function,
  setPage: Function,
  showAll: Function,
  enabled: boolean,
  activeSelection: any,
  userRole: Number,
};*/var _ref5=_react2.default.createElement('div',{className:'empty-list-label'},'Inga produkter');var CustomerProductList=function CustomerProductList(_ref3){var products=_ref3.products,pagination=_ref3.pagination,showAll=_ref3.showAll,isLoading=_ref3.isLoading,onOpenProduct=_ref3.onOpenProduct,onSelectProduct=_ref3.onSelectProduct,onRemoveProduct=_ref3.onRemoveProduct,setPage=_ref3.setPage,enabled=_ref3.enabled,activeSelection=_ref3.activeSelection,userRole=_ref3.userRole;var variants=[];var withOptions=(0,_flow3.default)((0,_map3.default)(function(x){return _extends({},x,{variantOptions:(0,_CustomerProductCard.getVariantOptions)(activeSelection,enabled,x.product,x.variant)});}),(0,_filter3.default)(function(x){return x.variantOptions.variantEnabled;}))(products);if(!pagination.showAll){variants=paginate(withOptions,pagination);}else{variants=withOptions;}return _react2.default.createElement('div',{className:'CustomerProductList'},_react2.default.createElement('div',{className:'product-list'},(0,_map3.default)(function(_ref4){var variant=_ref4.variant,product=_ref4.product,variantOptions=_ref4.variantOptions;return _react2.default.createElement('div',{key:variant.id,className:'product'},_react2.default.createElement(_CustomerProductCard2.default,{product:product,variant:variant,onOpenProduct:onOpenProduct,onSelectProduct:onSelectProduct,onRemoveProduct:onRemoveProduct,enabled:enabled,variantOptions:variantOptions,activeSelection:activeSelection,userRole:userRole}));},variants),!products.length&&!isLoading&&_ref5),!pagination.showAll&&amountOfPages(products,pagination)>1&&_react2.default.createElement('div',{className:'product-list-pagination'},_react2.default.createElement(_Paginator2.default,{pagination:pagination,pages:amountOfPages(products,pagination),onSelect:setPage}),_react2.default.createElement('div',{onClick:function onClick(){return showAll();},className:'show-all'},'Visa alla')));};exports.default=CustomerProductList;

/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



////////////////////////////////////////////////////////////////////////////////
// Helpers

// Merge objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

function _class(obj) { return Object.prototype.toString.call(obj); }
function isString(obj) { return _class(obj) === '[object String]'; }
function isObject(obj) { return _class(obj) === '[object Object]'; }
function isRegExp(obj) { return _class(obj) === '[object RegExp]'; }
function isFunction(obj) { return _class(obj) === '[object Function]'; }


function escapeRE(str) { return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&'); }

////////////////////////////////////////////////////////////////////////////////


var defaultOptions = {
  fuzzyLink: true,
  fuzzyEmail: true,
  fuzzyIP: false
};


function isOptionsObj(obj) {
  return Object.keys(obj || {}).reduce(function (acc, k) {
    return acc || defaultOptions.hasOwnProperty(k);
  }, false);
}


var defaultSchemas = {
  'http:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.http) {
        // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.http =  new RegExp(
          '^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i'
        );
      }
      if (self.re.http.test(tail)) {
        return tail.match(self.re.http)[0].length;
      }
      return 0;
    }
  },
  'https:':  'http:',
  'ftp:':    'http:',
  '//':      {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.no_http) {
      // compile lazily, because "host"-containing variables can change on tlds update.
        self.re.no_http =  new RegExp(
          '^' +
          self.re.src_auth +
          // Don't allow single-level domains, because of false positives like '//test'
          // with code comments
          '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' +
          self.re.src_port +
          self.re.src_host_terminator +
          self.re.src_path,

          'i'
        );
      }

      if (self.re.no_http.test(tail)) {
        // should not be `://` & `///`, that protects from errors in protocol name
        if (pos >= 3 && text[pos - 3] === ':') { return 0; }
        if (pos >= 3 && text[pos - 3] === '/') { return 0; }
        return tail.match(self.re.no_http)[0].length;
      }
      return 0;
    }
  },
  'mailto:': {
    validate: function (text, pos, self) {
      var tail = text.slice(pos);

      if (!self.re.mailto) {
        self.re.mailto =  new RegExp(
          '^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i'
        );
      }
      if (self.re.mailto.test(tail)) {
        return tail.match(self.re.mailto)[0].length;
      }
      return 0;
    }
  }
};

/*eslint-disable max-len*/

// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';

// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var tlds_default = 'biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф'.split('|');

/*eslint-enable max-len*/

////////////////////////////////////////////////////////////////////////////////

function resetScanCache(self) {
  self.__index__ = -1;
  self.__text_cache__   = '';
}

function createValidator(re) {
  return function (text, pos) {
    var tail = text.slice(pos);

    if (re.test(tail)) {
      return tail.match(re)[0].length;
    }
    return 0;
  };
}

function createNormalizer() {
  return function (match, self) {
    self.normalize(match);
  };
}

// Schemas compiler. Build regexps.
//
function compile(self) {

  // Load & clone RE patterns.
  var re = self.re = assign({}, __webpack_require__(1270));

  // Define dynamic patterns
  var tlds = self.__tlds__.slice();

  if (!self.__tlds_replaced__) {
    tlds.push(tlds_2ch_src_re);
  }
  tlds.push(re.src_xn);

  re.src_tlds = tlds.join('|');

  function untpl(tpl) { return tpl.replace('%TLDS%', re.src_tlds); }

  re.email_fuzzy      = RegExp(untpl(re.tpl_email_fuzzy), 'i');
  re.link_fuzzy       = RegExp(untpl(re.tpl_link_fuzzy), 'i');
  re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
  re.host_fuzzy_test  = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');

  //
  // Compile each schema
  //

  var aliases = [];

  self.__compiled__ = {}; // Reset compiled data

  function schemaError(name, val) {
    throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
  }

  Object.keys(self.__schemas__).forEach(function (name) {
    var val = self.__schemas__[name];

    // skip disabled methods
    if (val === null) { return; }

    var compiled = { validate: null, link: null };

    self.__compiled__[name] = compiled;

    if (isObject(val)) {
      if (isRegExp(val.validate)) {
        compiled.validate = createValidator(val.validate);
      } else if (isFunction(val.validate)) {
        compiled.validate = val.validate;
      } else {
        schemaError(name, val);
      }

      if (isFunction(val.normalize)) {
        compiled.normalize = val.normalize;
      } else if (!val.normalize) {
        compiled.normalize = createNormalizer();
      } else {
        schemaError(name, val);
      }

      return;
    }

    if (isString(val)) {
      aliases.push(name);
      return;
    }

    schemaError(name, val);
  });

  //
  // Compile postponed aliases
  //

  aliases.forEach(function (alias) {
    if (!self.__compiled__[self.__schemas__[alias]]) {
      // Silently fail on missed schemas to avoid errons on disable.
      // schemaError(alias, self.__schemas__[alias]);
      return;
    }

    self.__compiled__[alias].validate =
      self.__compiled__[self.__schemas__[alias]].validate;
    self.__compiled__[alias].normalize =
      self.__compiled__[self.__schemas__[alias]].normalize;
  });

  //
  // Fake record for guessed links
  //
  self.__compiled__[''] = { validate: null, normalize: createNormalizer() };

  //
  // Build schema condition
  //
  var slist = Object.keys(self.__compiled__)
                      .filter(function (name) {
                        // Filter disabled & fake schemas
                        return name.length > 0 && self.__compiled__[name];
                      })
                      .map(escapeRE)
                      .join('|');
  // (?!_) cause 1.5x slowdown
  self.re.schema_test   = RegExp('(^|(?!_)(?:[><]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
  self.re.schema_search = RegExp('(^|(?!_)(?:[><]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');

  self.re.pretest       = RegExp(
                            '(' + self.re.schema_test.source + ')|' +
                            '(' + self.re.host_fuzzy_test.source + ')|' +
                            '@',
                            'i');

  //
  // Cleanup
  //

  resetScanCache(self);
}

/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/
function Match(self, shift) {
  var start = self.__index__,
      end   = self.__last_index__,
      text  = self.__text_cache__.slice(start, end);

  /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/
  this.schema    = self.__schema__.toLowerCase();
  /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/
  this.index     = start + shift;
  /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/
  this.lastIndex = end + shift;
  /**
   * Match#raw -> String
   *
   * Matched string.
   **/
  this.raw       = text;
  /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/
  this.text      = text;
  /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/
  this.url       = text;
}

function createMatch(self, shift) {
  var match = new Match(self, shift);

  self.__compiled__[match.schema].normalize(match, self);

  return match;
}


/**
 * class LinkifyIt
 **/

/**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/
function LinkifyIt(schemas, options) {
  if (!(this instanceof LinkifyIt)) {
    return new LinkifyIt(schemas, options);
  }

  if (!options) {
    if (isOptionsObj(schemas)) {
      options = schemas;
      schemas = {};
    }
  }

  this.__opts__           = assign({}, defaultOptions, options);

  // Cache last tested result. Used to skip repeating steps on next `match` call.
  this.__index__          = -1;
  this.__last_index__     = -1; // Next scan position
  this.__schema__         = '';
  this.__text_cache__     = '';

  this.__schemas__        = assign({}, defaultSchemas, schemas);
  this.__compiled__       = {};

  this.__tlds__           = tlds_default;
  this.__tlds_replaced__  = false;

  this.re = {};

  compile(this);
}


/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/
LinkifyIt.prototype.add = function add(schema, definition) {
  this.__schemas__[schema] = definition;
  compile(this);
  return this;
};


/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/
LinkifyIt.prototype.set = function set(options) {
  this.__opts__ = assign(this.__opts__, options);
  return this;
};


/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/
LinkifyIt.prototype.test = function test(text) {
  // Reset scan cache
  this.__text_cache__ = text;
  this.__index__      = -1;

  if (!text.length) { return false; }

  var m, ml, me, len, shift, next, re, tld_pos, at_pos;

  // try to scan for link with schema - that's the most simple rule
  if (this.re.schema_test.test(text)) {
    re = this.re.schema_search;
    re.lastIndex = 0;
    while ((m = re.exec(text)) !== null) {
      len = this.testSchemaAt(text, m[2], re.lastIndex);
      if (len) {
        this.__schema__     = m[2];
        this.__index__      = m.index + m[1].length;
        this.__last_index__ = m.index + m[0].length + len;
        break;
      }
    }
  }

  if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
    // guess schemaless links
    tld_pos = text.search(this.re.host_fuzzy_test);
    if (tld_pos >= 0) {
      // if tld is located after found link - no need to check fuzzy pattern
      if (this.__index__ < 0 || tld_pos < this.__index__) {
        if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {

          shift = ml.index + ml[1].length;

          if (this.__index__ < 0 || shift < this.__index__) {
            this.__schema__     = '';
            this.__index__      = shift;
            this.__last_index__ = ml.index + ml[0].length;
          }
        }
      }
    }
  }

  if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
    // guess schemaless emails
    at_pos = text.indexOf('@');
    if (at_pos >= 0) {
      // We can't skip this check, because this cases are possible:
      // 192.168.1.1@gmail.com, my.in@example.com
      if ((me = text.match(this.re.email_fuzzy)) !== null) {

        shift = me.index + me[1].length;
        next  = me.index + me[0].length;

        if (this.__index__ < 0 || shift < this.__index__ ||
            (shift === this.__index__ && next > this.__last_index__)) {
          this.__schema__     = 'mailto:';
          this.__index__      = shift;
          this.__last_index__ = next;
        }
      }
    }
  }

  return this.__index__ >= 0;
};


/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/
LinkifyIt.prototype.pretest = function pretest(text) {
  return this.re.pretest.test(text);
};


/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/
LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
  // If not supported schema check requested - terminate
  if (!this.__compiled__[schema.toLowerCase()]) {
    return 0;
  }
  return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};


/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/
LinkifyIt.prototype.match = function match(text) {
  var shift = 0, result = [];

  // Try to take previous element from cache, if .test() called before
  if (this.__index__ >= 0 && this.__text_cache__ === text) {
    result.push(createMatch(this, shift));
    shift = this.__last_index__;
  }

  // Cut head if cache was used
  var tail = shift ? text.slice(shift) : text;

  // Scan string until end reached
  while (this.test(tail)) {
    result.push(createMatch(this, shift));

    tail = tail.slice(this.__last_index__);
    shift += this.__last_index__;
  }

  if (result.length) {
    return result;
  }

  return null;
};


/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/
LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
  list = Array.isArray(list) ? list : [ list ];

  if (!keepOld) {
    this.__tlds__ = list.slice();
    this.__tlds_replaced__ = true;
    compile(this);
    return this;
  }

  this.__tlds__ = this.__tlds__.concat(list)
                                  .sort()
                                  .filter(function (el, idx, arr) {
                                    return el !== arr[idx - 1];
                                  })
                                  .reverse();

  compile(this);
  return this;
};

/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/
LinkifyIt.prototype.normalize = function normalize(match) {

  // Do minimal possible changes by default. Need to collect feedback prior
  // to move forward https://github.com/markdown-it/linkify-it/issues/1

  if (!match.schema) { match.url = 'http://' + match.url; }

  if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) {
    match.url = 'mailto:' + match.url;
  }
};


module.exports = LinkifyIt;


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Use direct extract instead of `regenerate` to reduse browserified size
var src_Any = exports.src_Any = __webpack_require__(1271).source;
var src_Cc  = exports.src_Cc = __webpack_require__(1272).source;
var src_Z   = exports.src_Z  = __webpack_require__(1273).source;
var src_P   = exports.src_P  = __webpack_require__(1274).source;

// \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
var src_ZPCc = exports.src_ZPCc = [ src_Z, src_P, src_Cc ].join('|');

// \p{\Z\Cc} (white spaces + control)
var src_ZCc = exports.src_ZCc = [ src_Z, src_Cc ].join('|');

// All possible word characters (everything without punctuation, spaces & controls)
// Defined via punctuation & spaces to save space
// Should be something like \p{\L\N\S\M} (\w but without `_`)
var src_pseudo_letter       = '(?:(?!>|<|' + src_ZPCc + ')' + src_Any + ')';
// The same as abothe but without [0-9]
// var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';

////////////////////////////////////////////////////////////////////////////////

var src_ip4 = exports.src_ip4 =

  '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';

// Prohibit [@/] in user/pass to avoid wrong domain fetch.
exports.src_auth    = '(?:(?:(?!' + src_ZCc + '|[@/]).)+@)?';

var src_port = exports.src_port =

  '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';

var src_host_terminator = exports.src_host_terminator =

  '(?=$|>|<|' + src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + src_ZPCc + '))';

var src_path = exports.src_path =

  '(?:' +
    '[/?#]' +
      '(?:' +
        '(?!' + src_ZCc + '|[()[\\]{}.,"\'?!\\-<>]).|' +
        '\\[(?:(?!' + src_ZCc + '|\\]).)*\\]|' +
        '\\((?:(?!' + src_ZCc + '|[)]).)*\\)|' +
        '\\{(?:(?!' + src_ZCc + '|[}]).)*\\}|' +
        '\\"(?:(?!' + src_ZCc + '|["]).)+\\"|' +
        "\\'(?:(?!" + src_ZCc + "|[']).)+\\'|" +
        "\\'(?=" + src_pseudo_letter + ').|' +  // allow `I'm_king` if no pair found
        '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
                                   // - english
                                   // - percent-encoded
                                   // - parts of file path
                                   // until more examples found.
        '\\.(?!' + src_ZCc + '|[.]).|' +
        '\\-(?!--(?:[^-]|$))(?:-*)|' +  // `---` => long dash, terminate
        '\\,(?!' + src_ZCc + ').|' +      // allow `,,,` in paths
        '\\!(?!' + src_ZCc + '|[!]).|' +
        '\\?(?!' + src_ZCc + '|[?]).' +
      ')+' +
    '|\\/' +
  ')?';

var src_email_name = exports.src_email_name =

  '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';

var src_xn = exports.src_xn =

  'xn--[a-z0-9\\-]{1,59}';

// More to read about domain names
// http://serverfault.com/questions/638260/

var src_domain_root = exports.src_domain_root =

  // Allow letters & digits (http://test1)
  '(?:' +
    src_xn +
    '|' +
    src_pseudo_letter + '{1,63}' +
  ')';

var src_domain = exports.src_domain =

  '(?:' +
    src_xn +
    '|' +
    '(?:' + src_pseudo_letter + ')' +
    '|' +
    // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + src_pseudo_letter + '(?:-(?!-)|' + src_pseudo_letter + '){0,61}' + src_pseudo_letter + ')' +
  ')';

var src_host = exports.src_host =

  '(?:' +
  // Don't need IP check, because digits are already allowed in normal domain names
  //   src_ip4 +
  // '|' +
    '(?:(?:(?:' + src_domain + ')\\.)*' + src_domain_root + ')' +
  ')';

var tpl_host_fuzzy = exports.tpl_host_fuzzy =

  '(?:' +
    src_ip4 +
  '|' +
    '(?:(?:(?:' + src_domain + ')\\.)+(?:%TLDS%))' +
  ')';

var tpl_host_no_ip_fuzzy = exports.tpl_host_no_ip_fuzzy =

  '(?:(?:(?:' + src_domain + ')\\.)+(?:%TLDS%))';

exports.src_host_strict =

  src_host + src_host_terminator;

var tpl_host_fuzzy_strict = exports.tpl_host_fuzzy_strict =

  tpl_host_fuzzy + src_host_terminator;

exports.src_host_port_strict =

  src_host + src_port + src_host_terminator;

var tpl_host_port_fuzzy_strict = exports.tpl_host_port_fuzzy_strict =

  tpl_host_fuzzy + src_port + src_host_terminator;

var tpl_host_port_no_ip_fuzzy_strict = exports.tpl_host_port_no_ip_fuzzy_strict =

  tpl_host_no_ip_fuzzy + src_port + src_host_terminator;


////////////////////////////////////////////////////////////////////////////////
// Main rules

// Rude test fuzzy links by host, for quick deny
exports.tpl_host_fuzzy_test =

  'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + src_ZPCc + '|>|$))';

exports.tpl_email_fuzzy =

    '(^|<|>|\\(|' + src_ZCc + ')(' + src_email_name + '@' + tpl_host_fuzzy_strict + ')';

exports.tpl_link_fuzzy =
    // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|]|' + src_ZPCc + '))' +
    '((?![$+<=>^`|])' + tpl_host_port_fuzzy_strict + src_path + ')';

exports.tpl_link_no_ip_fuzzy =
    // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|]|' + src_ZPCc + '))' +
    '((?![$+<=>^`|])' + tpl_host_port_no_ip_fuzzy_strict + src_path + ')';


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

module.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/

/***/ }),
/* 1272 */
/***/ (function(module, exports) {

module.exports=/[\0-\x1F\x7F-\x9F]/

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

module.exports=/[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E44\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

module.exports = [
  "aaa",
  "aarp",
  "abarth",
  "abb",
  "abbott",
  "abbvie",
  "abc",
  "able",
  "abogado",
  "abudhabi",
  "ac",
  "academy",
  "accenture",
  "accountant",
  "accountants",
  "aco",
  "active",
  "actor",
  "ad",
  "adac",
  "ads",
  "adult",
  "ae",
  "aeg",
  "aero",
  "aetna",
  "af",
  "afamilycompany",
  "afl",
  "africa",
  "ag",
  "agakhan",
  "agency",
  "ai",
  "aig",
  "aigo",
  "airbus",
  "airforce",
  "airtel",
  "akdn",
  "al",
  "alfaromeo",
  "alibaba",
  "alipay",
  "allfinanz",
  "allstate",
  "ally",
  "alsace",
  "alstom",
  "am",
  "americanexpress",
  "americanfamily",
  "amex",
  "amfam",
  "amica",
  "amsterdam",
  "analytics",
  "android",
  "anquan",
  "anz",
  "ao",
  "aol",
  "apartments",
  "app",
  "apple",
  "aq",
  "aquarelle",
  "ar",
  "arab",
  "aramco",
  "archi",
  "army",
  "arpa",
  "art",
  "arte",
  "as",
  "asda",
  "asia",
  "associates",
  "at",
  "athleta",
  "attorney",
  "au",
  "auction",
  "audi",
  "audible",
  "audio",
  "auspost",
  "author",
  "auto",
  "autos",
  "avianca",
  "aw",
  "aws",
  "ax",
  "axa",
  "az",
  "azure",
  "ba",
  "baby",
  "baidu",
  "banamex",
  "bananarepublic",
  "band",
  "bank",
  "bar",
  "barcelona",
  "barclaycard",
  "barclays",
  "barefoot",
  "bargains",
  "baseball",
  "basketball",
  "bauhaus",
  "bayern",
  "bb",
  "bbc",
  "bbt",
  "bbva",
  "bcg",
  "bcn",
  "bd",
  "be",
  "beats",
  "beauty",
  "beer",
  "bentley",
  "berlin",
  "best",
  "bestbuy",
  "bet",
  "bf",
  "bg",
  "bh",
  "bharti",
  "bi",
  "bible",
  "bid",
  "bike",
  "bing",
  "bingo",
  "bio",
  "biz",
  "bj",
  "black",
  "blackfriday",
  "blanco",
  "blockbuster",
  "blog",
  "bloomberg",
  "blue",
  "bm",
  "bms",
  "bmw",
  "bn",
  "bnl",
  "bnpparibas",
  "bo",
  "boats",
  "boehringer",
  "bofa",
  "bom",
  "bond",
  "boo",
  "book",
  "booking",
  "boots",
  "bosch",
  "bostik",
  "boston",
  "bot",
  "boutique",
  "box",
  "br",
  "bradesco",
  "bridgestone",
  "broadway",
  "broker",
  "brother",
  "brussels",
  "bs",
  "bt",
  "budapest",
  "bugatti",
  "build",
  "builders",
  "business",
  "buy",
  "buzz",
  "bv",
  "bw",
  "by",
  "bz",
  "bzh",
  "ca",
  "cab",
  "cafe",
  "cal",
  "call",
  "calvinklein",
  "cam",
  "camera",
  "camp",
  "cancerresearch",
  "canon",
  "capetown",
  "capital",
  "capitalone",
  "car",
  "caravan",
  "cards",
  "care",
  "career",
  "careers",
  "cars",
  "cartier",
  "casa",
  "case",
  "caseih",
  "cash",
  "casino",
  "cat",
  "catering",
  "catholic",
  "cba",
  "cbn",
  "cbre",
  "cbs",
  "cc",
  "cd",
  "ceb",
  "center",
  "ceo",
  "cern",
  "cf",
  "cfa",
  "cfd",
  "cg",
  "ch",
  "chanel",
  "channel",
  "chase",
  "chat",
  "cheap",
  "chintai",
  "chloe",
  "christmas",
  "chrome",
  "chrysler",
  "church",
  "ci",
  "cipriani",
  "circle",
  "cisco",
  "citadel",
  "citi",
  "citic",
  "city",
  "cityeats",
  "ck",
  "cl",
  "claims",
  "cleaning",
  "click",
  "clinic",
  "clinique",
  "clothing",
  "cloud",
  "club",
  "clubmed",
  "cm",
  "cn",
  "co",
  "coach",
  "codes",
  "coffee",
  "college",
  "cologne",
  "com",
  "comcast",
  "commbank",
  "community",
  "company",
  "compare",
  "computer",
  "comsec",
  "condos",
  "construction",
  "consulting",
  "contact",
  "contractors",
  "cooking",
  "cookingchannel",
  "cool",
  "coop",
  "corsica",
  "country",
  "coupon",
  "coupons",
  "courses",
  "cr",
  "credit",
  "creditcard",
  "creditunion",
  "cricket",
  "crown",
  "crs",
  "cruise",
  "cruises",
  "csc",
  "cu",
  "cuisinella",
  "cv",
  "cw",
  "cx",
  "cy",
  "cymru",
  "cyou",
  "cz",
  "dabur",
  "dad",
  "dance",
  "data",
  "date",
  "dating",
  "datsun",
  "day",
  "dclk",
  "dds",
  "de",
  "deal",
  "dealer",
  "deals",
  "degree",
  "delivery",
  "dell",
  "deloitte",
  "delta",
  "democrat",
  "dental",
  "dentist",
  "desi",
  "design",
  "dev",
  "dhl",
  "diamonds",
  "diet",
  "digital",
  "direct",
  "directory",
  "discount",
  "discover",
  "dish",
  "diy",
  "dj",
  "dk",
  "dm",
  "dnp",
  "do",
  "docs",
  "doctor",
  "dodge",
  "dog",
  "doha",
  "domains",
  "dot",
  "download",
  "drive",
  "dtv",
  "dubai",
  "duck",
  "dunlop",
  "duns",
  "dupont",
  "durban",
  "dvag",
  "dvr",
  "dz",
  "earth",
  "eat",
  "ec",
  "eco",
  "edeka",
  "edu",
  "education",
  "ee",
  "eg",
  "email",
  "emerck",
  "energy",
  "engineer",
  "engineering",
  "enterprises",
  "epost",
  "epson",
  "equipment",
  "er",
  "ericsson",
  "erni",
  "es",
  "esq",
  "estate",
  "esurance",
  "et",
  "etisalat",
  "eu",
  "eurovision",
  "eus",
  "events",
  "everbank",
  "exchange",
  "expert",
  "exposed",
  "express",
  "extraspace",
  "fage",
  "fail",
  "fairwinds",
  "faith",
  "family",
  "fan",
  "fans",
  "farm",
  "farmers",
  "fashion",
  "fast",
  "fedex",
  "feedback",
  "ferrari",
  "ferrero",
  "fi",
  "fiat",
  "fidelity",
  "fido",
  "film",
  "final",
  "finance",
  "financial",
  "fire",
  "firestone",
  "firmdale",
  "fish",
  "fishing",
  "fit",
  "fitness",
  "fj",
  "fk",
  "flickr",
  "flights",
  "flir",
  "florist",
  "flowers",
  "fly",
  "fm",
  "fo",
  "foo",
  "food",
  "foodnetwork",
  "football",
  "ford",
  "forex",
  "forsale",
  "forum",
  "foundation",
  "fox",
  "fr",
  "free",
  "fresenius",
  "frl",
  "frogans",
  "frontdoor",
  "frontier",
  "ftr",
  "fujitsu",
  "fujixerox",
  "fun",
  "fund",
  "furniture",
  "futbol",
  "fyi",
  "ga",
  "gal",
  "gallery",
  "gallo",
  "gallup",
  "game",
  "games",
  "gap",
  "garden",
  "gb",
  "gbiz",
  "gd",
  "gdn",
  "ge",
  "gea",
  "gent",
  "genting",
  "george",
  "gf",
  "gg",
  "ggee",
  "gh",
  "gi",
  "gift",
  "gifts",
  "gives",
  "giving",
  "gl",
  "glade",
  "glass",
  "gle",
  "global",
  "globo",
  "gm",
  "gmail",
  "gmbh",
  "gmo",
  "gmx",
  "gn",
  "godaddy",
  "gold",
  "goldpoint",
  "golf",
  "goo",
  "goodhands",
  "goodyear",
  "goog",
  "google",
  "gop",
  "got",
  "gov",
  "gp",
  "gq",
  "gr",
  "grainger",
  "graphics",
  "gratis",
  "green",
  "gripe",
  "group",
  "gs",
  "gt",
  "gu",
  "guardian",
  "gucci",
  "guge",
  "guide",
  "guitars",
  "guru",
  "gw",
  "gy",
  "hair",
  "hamburg",
  "hangout",
  "haus",
  "hbo",
  "hdfc",
  "hdfcbank",
  "health",
  "healthcare",
  "help",
  "helsinki",
  "here",
  "hermes",
  "hgtv",
  "hiphop",
  "hisamitsu",
  "hitachi",
  "hiv",
  "hk",
  "hkt",
  "hm",
  "hn",
  "hockey",
  "holdings",
  "holiday",
  "homedepot",
  "homegoods",
  "homes",
  "homesense",
  "honda",
  "honeywell",
  "horse",
  "hospital",
  "host",
  "hosting",
  "hot",
  "hoteles",
  "hotels",
  "hotmail",
  "house",
  "how",
  "hr",
  "hsbc",
  "ht",
  "htc",
  "hu",
  "hughes",
  "hyatt",
  "hyundai",
  "ibm",
  "icbc",
  "ice",
  "icu",
  "id",
  "ie",
  "ieee",
  "ifm",
  "ikano",
  "il",
  "im",
  "imamat",
  "imdb",
  "immo",
  "immobilien",
  "in",
  "industries",
  "infiniti",
  "info",
  "ing",
  "ink",
  "institute",
  "insurance",
  "insure",
  "int",
  "intel",
  "international",
  "intuit",
  "investments",
  "io",
  "ipiranga",
  "iq",
  "ir",
  "irish",
  "is",
  "iselect",
  "ismaili",
  "ist",
  "istanbul",
  "it",
  "itau",
  "itv",
  "iveco",
  "iwc",
  "jaguar",
  "java",
  "jcb",
  "jcp",
  "je",
  "jeep",
  "jetzt",
  "jewelry",
  "jio",
  "jlc",
  "jll",
  "jm",
  "jmp",
  "jnj",
  "jo",
  "jobs",
  "joburg",
  "jot",
  "joy",
  "jp",
  "jpmorgan",
  "jprs",
  "juegos",
  "juniper",
  "kaufen",
  "kddi",
  "ke",
  "kerryhotels",
  "kerrylogistics",
  "kerryproperties",
  "kfh",
  "kg",
  "kh",
  "ki",
  "kia",
  "kim",
  "kinder",
  "kindle",
  "kitchen",
  "kiwi",
  "km",
  "kn",
  "koeln",
  "komatsu",
  "kosher",
  "kp",
  "kpmg",
  "kpn",
  "kr",
  "krd",
  "kred",
  "kuokgroup",
  "kw",
  "ky",
  "kyoto",
  "kz",
  "la",
  "lacaixa",
  "ladbrokes",
  "lamborghini",
  "lamer",
  "lancaster",
  "lancia",
  "lancome",
  "land",
  "landrover",
  "lanxess",
  "lasalle",
  "lat",
  "latino",
  "latrobe",
  "law",
  "lawyer",
  "lb",
  "lc",
  "lds",
  "lease",
  "leclerc",
  "lefrak",
  "legal",
  "lego",
  "lexus",
  "lgbt",
  "li",
  "liaison",
  "lidl",
  "life",
  "lifeinsurance",
  "lifestyle",
  "lighting",
  "like",
  "lilly",
  "limited",
  "limo",
  "lincoln",
  "linde",
  "link",
  "lipsy",
  "live",
  "living",
  "lixil",
  "lk",
  "loan",
  "loans",
  "locker",
  "locus",
  "loft",
  "lol",
  "london",
  "lotte",
  "lotto",
  "love",
  "lpl",
  "lplfinancial",
  "lr",
  "ls",
  "lt",
  "ltd",
  "ltda",
  "lu",
  "lundbeck",
  "lupin",
  "luxe",
  "luxury",
  "lv",
  "ly",
  "ma",
  "macys",
  "madrid",
  "maif",
  "maison",
  "makeup",
  "man",
  "management",
  "mango",
  "market",
  "marketing",
  "markets",
  "marriott",
  "marshalls",
  "maserati",
  "mattel",
  "mba",
  "mc",
  "mcd",
  "mcdonalds",
  "mckinsey",
  "md",
  "me",
  "med",
  "media",
  "meet",
  "melbourne",
  "meme",
  "memorial",
  "men",
  "menu",
  "meo",
  "metlife",
  "mg",
  "mh",
  "miami",
  "microsoft",
  "mil",
  "mini",
  "mint",
  "mit",
  "mitsubishi",
  "mk",
  "ml",
  "mlb",
  "mls",
  "mm",
  "mma",
  "mn",
  "mo",
  "mobi",
  "mobile",
  "mobily",
  "moda",
  "moe",
  "moi",
  "mom",
  "monash",
  "money",
  "monster",
  "montblanc",
  "mopar",
  "mormon",
  "mortgage",
  "moscow",
  "moto",
  "motorcycles",
  "mov",
  "movie",
  "movistar",
  "mp",
  "mq",
  "mr",
  "ms",
  "msd",
  "mt",
  "mtn",
  "mtr",
  "mu",
  "museum",
  "mutual",
  "mv",
  "mw",
  "mx",
  "my",
  "mz",
  "na",
  "nab",
  "nadex",
  "nagoya",
  "name",
  "nationwide",
  "natura",
  "navy",
  "nba",
  "nc",
  "ne",
  "nec",
  "net",
  "netbank",
  "netflix",
  "network",
  "neustar",
  "new",
  "newholland",
  "news",
  "next",
  "nextdirect",
  "nexus",
  "nf",
  "nfl",
  "ng",
  "ngo",
  "nhk",
  "ni",
  "nico",
  "nike",
  "nikon",
  "ninja",
  "nissan",
  "nissay",
  "nl",
  "no",
  "nokia",
  "northwesternmutual",
  "norton",
  "now",
  "nowruz",
  "nowtv",
  "np",
  "nr",
  "nra",
  "nrw",
  "ntt",
  "nu",
  "nyc",
  "nz",
  "obi",
  "observer",
  "off",
  "office",
  "okinawa",
  "olayan",
  "olayangroup",
  "oldnavy",
  "ollo",
  "om",
  "omega",
  "one",
  "ong",
  "onl",
  "online",
  "onyourside",
  "ooo",
  "open",
  "oracle",
  "orange",
  "org",
  "organic",
  "origins",
  "osaka",
  "otsuka",
  "ott",
  "ovh",
  "pa",
  "page",
  "pamperedchef",
  "panasonic",
  "panerai",
  "paris",
  "pars",
  "partners",
  "parts",
  "party",
  "passagens",
  "pay",
  "pccw",
  "pe",
  "pet",
  "pf",
  "pfizer",
  "pg",
  "ph",
  "pharmacy",
  "philips",
  "phone",
  "photo",
  "photography",
  "photos",
  "physio",
  "piaget",
  "pics",
  "pictet",
  "pictures",
  "pid",
  "pin",
  "ping",
  "pink",
  "pioneer",
  "pizza",
  "pk",
  "pl",
  "place",
  "play",
  "playstation",
  "plumbing",
  "plus",
  "pm",
  "pn",
  "pnc",
  "pohl",
  "poker",
  "politie",
  "porn",
  "post",
  "pr",
  "pramerica",
  "praxi",
  "press",
  "prime",
  "pro",
  "prod",
  "productions",
  "prof",
  "progressive",
  "promo",
  "properties",
  "property",
  "protection",
  "pru",
  "prudential",
  "ps",
  "pt",
  "pub",
  "pw",
  "pwc",
  "py",
  "qa",
  "qpon",
  "quebec",
  "quest",
  "qvc",
  "racing",
  "radio",
  "raid",
  "re",
  "read",
  "realestate",
  "realtor",
  "realty",
  "recipes",
  "red",
  "redstone",
  "redumbrella",
  "rehab",
  "reise",
  "reisen",
  "reit",
  "reliance",
  "ren",
  "rent",
  "rentals",
  "repair",
  "report",
  "republican",
  "rest",
  "restaurant",
  "review",
  "reviews",
  "rexroth",
  "rich",
  "richardli",
  "ricoh",
  "rightathome",
  "ril",
  "rio",
  "rip",
  "rmit",
  "ro",
  "rocher",
  "rocks",
  "rodeo",
  "rogers",
  "room",
  "rs",
  "rsvp",
  "ru",
  "rugby",
  "ruhr",
  "run",
  "rw",
  "rwe",
  "ryukyu",
  "sa",
  "saarland",
  "safe",
  "safety",
  "sakura",
  "sale",
  "salon",
  "samsclub",
  "samsung",
  "sandvik",
  "sandvikcoromant",
  "sanofi",
  "sap",
  "sapo",
  "sarl",
  "sas",
  "save",
  "saxo",
  "sb",
  "sbi",
  "sbs",
  "sc",
  "sca",
  "scb",
  "schaeffler",
  "schmidt",
  "scholarships",
  "school",
  "schule",
  "schwarz",
  "science",
  "scjohnson",
  "scor",
  "scot",
  "sd",
  "se",
  "seat",
  "secure",
  "security",
  "seek",
  "select",
  "sener",
  "services",
  "ses",
  "seven",
  "sew",
  "sex",
  "sexy",
  "sfr",
  "sg",
  "sh",
  "shangrila",
  "sharp",
  "shaw",
  "shell",
  "shia",
  "shiksha",
  "shoes",
  "shop",
  "shopping",
  "shouji",
  "show",
  "showtime",
  "shriram",
  "si",
  "silk",
  "sina",
  "singles",
  "site",
  "sj",
  "sk",
  "ski",
  "skin",
  "sky",
  "skype",
  "sl",
  "sling",
  "sm",
  "smart",
  "smile",
  "sn",
  "sncf",
  "so",
  "soccer",
  "social",
  "softbank",
  "software",
  "sohu",
  "solar",
  "solutions",
  "song",
  "sony",
  "soy",
  "space",
  "spiegel",
  "spot",
  "spreadbetting",
  "sr",
  "srl",
  "srt",
  "st",
  "stada",
  "staples",
  "star",
  "starhub",
  "statebank",
  "statefarm",
  "statoil",
  "stc",
  "stcgroup",
  "stockholm",
  "storage",
  "store",
  "stream",
  "studio",
  "study",
  "style",
  "su",
  "sucks",
  "supplies",
  "supply",
  "support",
  "surf",
  "surgery",
  "suzuki",
  "sv",
  "swatch",
  "swiftcover",
  "swiss",
  "sx",
  "sy",
  "sydney",
  "symantec",
  "systems",
  "sz",
  "tab",
  "taipei",
  "talk",
  "taobao",
  "target",
  "tatamotors",
  "tatar",
  "tattoo",
  "tax",
  "taxi",
  "tc",
  "tci",
  "td",
  "tdk",
  "team",
  "tech",
  "technology",
  "tel",
  "telecity",
  "telefonica",
  "temasek",
  "tennis",
  "teva",
  "tf",
  "tg",
  "th",
  "thd",
  "theater",
  "theatre",
  "tiaa",
  "tickets",
  "tienda",
  "tiffany",
  "tips",
  "tires",
  "tirol",
  "tj",
  "tjmaxx",
  "tjx",
  "tk",
  "tkmaxx",
  "tl",
  "tm",
  "tmall",
  "tn",
  "to",
  "today",
  "tokyo",
  "tools",
  "top",
  "toray",
  "toshiba",
  "total",
  "tours",
  "town",
  "toyota",
  "toys",
  "tr",
  "trade",
  "trading",
  "training",
  "travel",
  "travelchannel",
  "travelers",
  "travelersinsurance",
  "trust",
  "trv",
  "tt",
  "tube",
  "tui",
  "tunes",
  "tushu",
  "tv",
  "tvs",
  "tw",
  "tz",
  "ua",
  "ubank",
  "ubs",
  "uconnect",
  "ug",
  "uk",
  "unicom",
  "university",
  "uno",
  "uol",
  "ups",
  "us",
  "uy",
  "uz",
  "va",
  "vacations",
  "vana",
  "vanguard",
  "vc",
  "ve",
  "vegas",
  "ventures",
  "verisign",
  "versicherung",
  "vet",
  "vg",
  "vi",
  "viajes",
  "video",
  "vig",
  "viking",
  "villas",
  "vin",
  "vip",
  "virgin",
  "visa",
  "vision",
  "vista",
  "vistaprint",
  "viva",
  "vivo",
  "vlaanderen",
  "vn",
  "vodka",
  "volkswagen",
  "volvo",
  "vote",
  "voting",
  "voto",
  "voyage",
  "vu",
  "vuelos",
  "wales",
  "walmart",
  "walter",
  "wang",
  "wanggou",
  "warman",
  "watch",
  "watches",
  "weather",
  "weatherchannel",
  "webcam",
  "weber",
  "website",
  "wed",
  "wedding",
  "weibo",
  "weir",
  "wf",
  "whoswho",
  "wien",
  "wiki",
  "williamhill",
  "win",
  "windows",
  "wine",
  "winners",
  "wme",
  "wolterskluwer",
  "woodside",
  "work",
  "works",
  "world",
  "wow",
  "ws",
  "wtc",
  "wtf",
  "xbox",
  "xerox",
  "xfinity",
  "xihuan",
  "xin",
  "कॉम", // xn--11b4c3d
  "セール", // xn--1ck2e1b
  "佛山", // xn--1qqw23a
  "慈善", // xn--30rr7y
  "集团", // xn--3bst00m
  "在线", // xn--3ds443g
  "한국", // xn--3e0b707e
  "大众汽车", // xn--3oq18vl8pn36a
  "点看", // xn--3pxu8k
  "คอม", // xn--42c2d9a
  "ভারত", // xn--45brj9c
  "八卦", // xn--45q11c
  "موقع", // xn--4gbrim
  "বাংলা", // xn--54b7fta0cc
  "公益", // xn--55qw42g
  "公司", // xn--55qx5d
  "香格里拉", // xn--5su34j936bgsg
  "网站", // xn--5tzm5g
  "移动", // xn--6frz82g
  "我爱你", // xn--6qq986b3xl
  "москва", // xn--80adxhks
  "қаз", // xn--80ao21a
  "католик", // xn--80aqecdr1a
  "онлайн", // xn--80asehdb
  "сайт", // xn--80aswg
  "联通", // xn--8y0a063a
  "срб", // xn--90a3ac
  "бг", // xn--90ae
  "бел", // xn--90ais
  "קום", // xn--9dbq2a
  "时尚", // xn--9et52u
  "微博", // xn--9krt00a
  "淡马锡", // xn--b4w605ferd
  "ファッション", // xn--bck1b9a5dre4c
  "орг", // xn--c1avg
  "नेट", // xn--c2br7g
  "ストア", // xn--cck2b3b
  "삼성", // xn--cg4bki
  "சிங்கப்பூர்", // xn--clchc0ea0b2g2a9gcd
  "商标", // xn--czr694b
  "商店", // xn--czrs0t
  "商城", // xn--czru2d
  "дети", // xn--d1acj3b
  "мкд", // xn--d1alf
  "ею", // xn--e1a4c
  "ポイント", // xn--eckvdtc9d
  "新闻", // xn--efvy88h
  "工行", // xn--estv75g
  "家電", // xn--fct429k
  "كوم", // xn--fhbei
  "中文网", // xn--fiq228c5hs
  "中信", // xn--fiq64b
  "中国", // xn--fiqs8s
  "中國", // xn--fiqz9s
  "娱乐", // xn--fjq720a
  "谷歌", // xn--flw351e
  "భారత్", // xn--fpcrj9c3d
  "ලංකා", // xn--fzc2c9e2c
  "電訊盈科", // xn--fzys8d69uvgm
  "购物", // xn--g2xx48c
  "クラウド", // xn--gckr3f0f
  "ભારત", // xn--gecrj9c
  "通販", // xn--gk3at1e
  "भारत", // xn--h2brj9c
  "网店", // xn--hxt814e
  "संगठन", // xn--i1b6b1a6a2e
  "餐厅", // xn--imr513n
  "网络", // xn--io0a7i
  "ком", // xn--j1aef
  "укр", // xn--j1amh
  "香港", // xn--j6w193g
  "诺基亚", // xn--jlq61u9w7b
  "食品", // xn--jvr189m
  "飞利浦", // xn--kcrx77d1x4a
  "台湾", // xn--kprw13d
  "台灣", // xn--kpry57d
  "手表", // xn--kpu716f
  "手机", // xn--kput3i
  "мон", // xn--l1acc
  "الجزائر", // xn--lgbbat1ad8j
  "عمان", // xn--mgb9awbf
  "ارامكو", // xn--mgba3a3ejt
  "ایران", // xn--mgba3a4f16a
  "العليان", // xn--mgba7c0bbn0a
  "امارات", // xn--mgbaam7a8h
  "بازار", // xn--mgbab2bd
  "پاکستان", // xn--mgbai9azgqp6j
  "الاردن", // xn--mgbayh7gpa
  "موبايلي", // xn--mgbb9fbpob
  "بھارت", // xn--mgbbh1a71e
  "المغرب", // xn--mgbc0a9azcg
  "ابوظبي", // xn--mgbca7dzdo
  "السعودية", // xn--mgberp4a5d4ar
  "كاثوليك", // xn--mgbi4ecexp
  "سودان", // xn--mgbpl2fh
  "همراه", // xn--mgbt3dhd
  "عراق", // xn--mgbtx2b
  "مليسيا", // xn--mgbx4cd0ab
  "澳門", // xn--mix891f
  "닷컴", // xn--mk1bu44c
  "政府", // xn--mxtq1m
  "شبكة", // xn--ngbc5azd
  "بيتك", // xn--ngbe9e0a
  "عرب", // xn--ngbrx
  "გე", // xn--node
  "机构", // xn--nqv7f
  "组织机构", // xn--nqv7fs00ema
  "健康", // xn--nyqy26a
  "ไทย", // xn--o3cw4h
  "سورية", // xn--ogbpf8fl
  "рус", // xn--p1acf
  "рф", // xn--p1ai
  "珠宝", // xn--pbt977c
  "تونس", // xn--pgbs0dh
  "大拿", // xn--pssy2u
  "みんな", // xn--q9jyb4c
  "グーグル", // xn--qcka1pmc
  "ελ", // xn--qxam
  "世界", // xn--rhqv96g
  "書籍", // xn--rovu88b
  "ਭਾਰਤ", // xn--s9brj9c
  "网址", // xn--ses554g
  "닷넷", // xn--t60b56a
  "コム", // xn--tckwe
  "天主教", // xn--tiq49xqyj
  "游戏", // xn--unup4y
  "vermögensberater", // xn--vermgensberater-ctb
  "vermögensberatung", // xn--vermgensberatung-pwb
  "企业", // xn--vhquv
  "信息", // xn--vuq861b
  "嘉里大酒店", // xn--w4r85el8fhu5dnra
  "嘉里", // xn--w4rs40l
  "مصر", // xn--wgbh1c
  "قطر", // xn--wgbl6a
  "广东", // xn--xhq521b
  "இலங்கை", // xn--xkc2al3hye2a
  "இந்தியா", // xn--xkc2dl3a5ee0h
  "հայ", // xn--y9a3aq
  "新加坡", // xn--yfro4i67o
  "فلسطين", // xn--ygbi2ammx
  "政务", // xn--zfr164b
  "xperia",
  "xxx",
  "xyz",
  "yachts",
  "yahoo",
  "yamaxun",
  "yandex",
  "ye",
  "yodobashi",
  "yoga",
  "yokohama",
  "you",
  "youtube",
  "yt",
  "yun",
  "za",
  "zappos",
  "zara",
  "zero",
  "zip",
  "zippo",
  "zm",
  "zone",
  "zuerich",
  "zw"
];


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('split', __webpack_require__(1277));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(117),
    castSlice = __webpack_require__(491),
    hasUnicode = __webpack_require__(492),
    isIterateeCall = __webpack_require__(98),
    isRegExp = __webpack_require__(1278),
    stringToArray = __webpack_require__(493),
    toString = __webpack_require__(79);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(1279),
    baseUnary = __webpack_require__(63),
    nodeUtil = __webpack_require__(153);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(47),
    isObjectLike = __webpack_require__(33);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 1280 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 1281 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 1282 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLinkify=__webpack_require__(179);var _reactLinkify2=_interopRequireDefault(_reactLinkify);__webpack_require__(1287);var _CustomerProductImage=__webpack_require__(265);var _CustomerProductImage2=_interopRequireDefault(_CustomerProductImage);var _FormattedPrice=__webpack_require__(131);var _FormattedPrice2=_interopRequireDefault(_FormattedPrice);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  customProducts: any[],
};*/var CustomerCustomProductList=function CustomerCustomProductList(_ref){var customProducts=_ref.customProducts;return _react2.default.createElement('div',{className:'CustomerCustomProductList'},(0,_map3.default)(function(product){return _react2.default.createElement('div',{key:product.id,className:'product'},_react2.default.createElement('div',{className:'product-container'},_react2.default.createElement('div',{className:'column medium-3 relative product-image'},_react2.default.createElement(_CustomerProductImage2.default,{file:product.image})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'name'},product.name),_react2.default.createElement('div',{className:'section quantity'},'Antal: ',product.quantity),_react2.default.createElement('div',{className:'section price'},_react2.default.createElement('span',null,'Totalpris: ',_react2.default.createElement(_FormattedPrice2.default,{value:product.totalSellingPrice}))),!(0,_isEmpty3.default)(product.externalDescription)&&_react2.default.createElement('div',{className:'section description'},_react2.default.createElement(_reactLinkify2.default,{properties:{target:'_blank'}},_react2.default.createElement('p',{className:'preserve-whitespace'},product.externalDescription))))));},customProducts));};exports.default=CustomerCustomProductList;

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _every2=__webpack_require__(238);var _every3=_interopRequireDefault(_every2);var _some2=__webpack_require__(25);var _some3=_interopRequireDefault(_some2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1290);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _customerOrderView=__webpack_require__(236);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type IconProps = {
  fixedWidth?: boolean,
  isComplete: boolean,
  isOptional: boolean,
  isOrdered: boolean,
  isPartial?: boolean,
  isDisabled?: boolean,
};*/var Icon=function Icon(_ref){var _ref$fixedWidth=_ref.fixedWidth,fixedWidth=_ref$fixedWidth===undefined?false:_ref$fixedWidth,isComplete=_ref.isComplete,isOptional=_ref.isOptional,isOrdered=_ref.isOrdered,isPartial=_ref.isPartial,_ref$isDisabled=_ref.isDisabled,isDisabled=_ref$isDisabled===undefined?false:_ref$isDisabled;return _react2.default.createElement('i',{className:(0,_classnames2.default)({'fa':true,'fa-fw':!!fixedWidth,'ordered':!isDisabled&&!!isOrdered&&!isPartial,'partial':!isDisabled&&!!isOrdered&&!!isPartial,'fa-check':!isDisabled&&!!isComplete&&!!isOptional,'fa-check-circle-o':!isDisabled&&!!isComplete&&!isOptional,'fa-plus':!isDisabled&&!isComplete&&!!isOptional,'fa-circle-o':!isDisabled&&!isComplete&&!isOptional})});};/*:: export type RoomLabelProps = {
  room: Object,
  active: boolean,
  expanded: boolean,
  onClick: Function,
};*/var RoomLabel=function RoomLabel(_ref2){var room=_ref2.room,active=_ref2.active,expanded=_ref2.expanded,onClick=_ref2.onClick;return _react2.default.createElement('div',{onClick:onClick,title:room.isOptional===true?'Endast tillvalsprodukter, måste ej väljas':'',className:(0,_classnames2.default)({'CustomerProductSlotList-room-label':true,active:active})},_react2.default.createElement('div',{className:'CustomerProductSlotList-room-check'},_react2.default.createElement(Icon,{isComplete:room.isComplete,isOptional:room.isOptional,isOrdered:room.isComplete})),_react2.default.createElement('div',{className:'CustomerProductSlotList-room-title'},room.name),_react2.default.createElement('div',{className:'CustomerProductSlotList-expanded'},_react2.default.createElement('i',{className:(0,_classnames2.default)({'fa fa-fw':true,'fa-angle-down':expanded,'fa-angle-right':!expanded})})));};/*:: export type SlotLabelProps = {
  slot: Object,
  active: boolean,
  isComplete: boolean,
  isOptional: boolean,
  isOrdered: boolean,
  isPartial?: boolean,
  isDisabled?: boolean,
  isHidden?: boolean,
  onClick: Function,
};*/var SlotLabel=function SlotLabel(_ref3){var slot=_ref3.slot,active=_ref3.active,isComplete=_ref3.isComplete,isOptional=_ref3.isOptional,isOrdered=_ref3.isOrdered,isPartial=_ref3.isPartial,_ref3$isDisabled=_ref3.isDisabled,isDisabled=_ref3$isDisabled===undefined?false:_ref3$isDisabled,_ref3$isHidden=_ref3.isHidden,isHidden=_ref3$isHidden===undefined?false:_ref3$isHidden,onClick=_ref3.onClick;return _react2.default.createElement('div',{onClick:onClick,title:!!isDisabled?'Kan först väljas när val av föregående produkt är gjord':!!isPartial?'Det finns fler val att göra baserat på detta val':!!isOptional?'Tillvalsprodukt, måste ej väljas':'',className:(0,_classnames2.default)({'CustomerProductSlotList-slot-label':true,active:active})},_react2.default.createElement('div',{className:'CustomerProductSlotList-slot-check'},!isHidden&&_react2.default.createElement(Icon,{fixedWidth:true,isDisabled:isDisabled,isComplete:isComplete,isOptional:isOptional,isOrdered:isOrdered,isPartial:isPartial})),_react2.default.createElement('div',{className:'CustomerProductSlotList-slot-title'},slot.name));};/*:: export type AdvancedSlotProps = {
  config: any[],
  slot: Object,
  onClick: Function,
  orderRowBySlotId: any,
  isTop?: boolean,
  activeSelection: Object,
};*/var AdvancedSlot=function AdvancedSlot(_ref4){var config=_ref4.config,slot=_ref4.slot,onClick=_ref4.onClick,orderRowBySlotId=_ref4.orderRowBySlotId,_ref4$isTop=_ref4.isTop,isTop=_ref4$isTop===undefined?false:_ref4$isTop,activeSelection=_ref4.activeSelection;return _react2.default.createElement('div',{className:(0,_classnames2.default)({'advanced-slot':!isTop})},(0,_flow3.default)((0,_filter3.default)(function(c){return!c.isHidden;}),(0,_map3.default)(function(_ref5){var c=_ref5.config,children=_ref5.children,isComplete=_ref5.isComplete,isOptional=_ref5.isOptional,isOrdered=_ref5.isOrdered,isPartial=_ref5.isPartial,isDisabled=_ref5.isDisabled,isHidden=_ref5.isHidden;return _react2.default.createElement('div',{key:c.id},_react2.default.createElement(SlotLabel,{slot:isTop?slot:c,active:!!activeSelection.config&&activeSelection.config.uuid===c.uuid,isComplete:isComplete&&!isPartial,isOptional:isOptional,isOrdered:isOrdered,isPartial:isPartial,isDisabled:isDisabled,isHidden:isHidden,onClick:function(_onClick){function onClick(){return _onClick.apply(this,arguments);}onClick.toString=function(){return _onClick.toString();};return onClick;}(function(){return onClick(c);})}),!!c.children.length&&!!activeSelection.slot&&activeSelection.slot.id===slot.id&&_react2.default.createElement(AdvancedSlot,{slot:slot,config:children,onClick:onClick,orderRowBySlotId:orderRowBySlotId,activeSelection:activeSelection}));}))(config));};var mapConfig=function mapConfig(slot,orderRowBySlotId,isParentOrdered){var isTop=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;return function(c){var hasOrderRow=!!(0,_some3.default)(function(r){return r.productSlotId===slot.id&&(0,_some3.default)({id:r.configId},c.configs);},orderRowBySlotId);var isOrdered=hasOrderRow;var isComplete=isOrdered;var isOptional=true;var isDisabled=false;var isHidden=false;if(isTop){isOptional=!slot.standardProductId;}else{var parentConfig=(0,_customerOrderView.getParentConfig)(orderRowBySlotId,c,slot);isOptional=!parentConfig||!(0,_some3.default)({productTypeId:c.id},parentConfig.standardProducts);isComplete=!!isComplete||isOptional&&(!parentConfig||!(0,_some3.default)({parentId:parentConfig.id},slot.config));isOrdered=isOrdered||isComplete&&isParentOrdered;isDisabled=!parentConfig||!(0,_some3.default)({parentId:parentConfig.id},c.configs);isHidden=!isParentOrdered||isComplete&&!hasOrderRow;}var children=(0,_map3.default)(mapConfig(slot,orderRowBySlotId,isOrdered||isComplete&&isParentOrdered),c.children);var isPartial=isComplete&&!(0,_every3.default)(function(c){return(c.isComplete||c.isOptional)&&!c.isPartial;},children);return{config:c,children:children,isComplete:isComplete,isOptional:isOptional,isOrdered:isOrdered,isPartial:isPartial,isHidden:isHidden,isDisabled:isDisabled};};};/*:: export type CustomerProductSlotListProps = {
  rooms: any[],
  expanedRooms: Object,
  orderRowBySlotId: Object,
  onRoomClick: Function,
  onSlotClick: Function,
  onAdvancedClick: Function,
  activeSelection: Object,
};*/var CustomerProductSlotList=function CustomerProductSlotList(_ref6){var rooms=_ref6.rooms,expanedRooms=_ref6.expanedRooms,orderRowBySlotId=_ref6.orderRowBySlotId,onRoomClick=_ref6.onRoomClick,onSlotClick=_ref6.onSlotClick,onAdvancedClick=_ref6.onAdvancedClick,activeSelection=_ref6.activeSelection;return _react2.default.createElement('div',{className:'CustomerProductSlotList'},(0,_map3.default)(function(r){return _react2.default.createElement('div',{key:r.id,className:'CustomerProductSlotList-room'},_react2.default.createElement(RoomLabel,{room:r,active:!!activeSelection.room&&activeSelection.room.id===r.id,expanded:!!expanedRooms[r.id],onClick:function onClick(){onRoomClick(r.id);var firstSlot=r.productSlots[0];if(!!firstSlot){if(!!firstSlot.advanced){onAdvancedClick(r,firstSlot,firstSlot.configTree[0]);}else{onSlotClick(r,firstSlot);}}}}),!!expanedRooms[r.id]&&_react2.default.createElement('div',{className:'CustomerProductSlotList-product-slots'},(0,_map3.default)(function(s){if(!!s.advanced){return _react2.default.createElement(AdvancedSlot,{key:s.id,config:(0,_map3.default)(mapConfig(s,orderRowBySlotId,false,true),s.configTree),slot:s,activeSelection:activeSelection,orderRowBySlotId:orderRowBySlotId,onClick:function onClick(t){return onAdvancedClick(r,s,t);},isTop:true});}else{var _isComplete=!!orderRowBySlotId[s.id+'__'];return _react2.default.createElement(SlotLabel,{key:s.id,slot:s,active:!!activeSelection.slot&&activeSelection.slot.id===s.id,isComplete:_isComplete,isOptional:!s.defaultProductId,isOrdered:_isComplete,onClick:function onClick(){return onSlotClick(r,s);}});}},r.productSlots)));},rooms));};exports.default=CustomerProductSlotList;

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _isEmpty2=__webpack_require__(30);var _isEmpty3=_interopRequireDefault(_isEmpty2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLinkify=__webpack_require__(179);var _reactLinkify2=_interopRequireDefault(_reactLinkify);var _priceHelpers=__webpack_require__(85);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _CustomerImageGallery=__webpack_require__(1292);var _CustomerImageGallery2=_interopRequireDefault(_CustomerImageGallery);var _FormattedPrice=__webpack_require__(131);var _FormattedPrice2=_interopRequireDefault(_FormattedPrice);var _CustomerProductOrderButton=__webpack_require__(494);var _CustomerProductOrderButton2=_interopRequireDefault(_CustomerProductOrderButton);__webpack_require__(1309);var _CustomerProductCard=__webpack_require__(490);var _roles=__webpack_require__(49);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  product: Object,
  variant: Object,
  activeImage: ?any,
  onSelectProduct: Function,
  onRemoveProduct: Function,
  onImageSelect: Function,
  onClose: Function,
  enabled: boolean,
  activeSelection: Object,
  userRole: Number,
};*/var _ref2=_react2.default.createElement('div',null,'Den h\xE4r produkten har ersatts av:');var _ref3=_react2.default.createElement('div',{className:'section'},_react2.default.createElement('div',{className:'callout warning text-center'},_react2.default.createElement('div',null,'Den h\xE4r produkten har utg\xE5tt')));var _ref4=_react2.default.createElement('div',{className:'label'},'Standard');var _ref5=_react2.default.createElement('td',null,'F\xE4rg');var _ref6=_react2.default.createElement('td',null,'Bredd');var _ref7=_react2.default.createElement('td',null,'H\xF6jd');var _ref8=_react2.default.createElement('td',null,'Djup');var _ref9=_react2.default.createElement('div',{className:'ribbon'},_react2.default.createElement('i',{className:'fa fa-check-circle-o'}));var CustomerProductDialog=function CustomerProductDialog(_ref){var product=_ref.product,variant=_ref.variant,activeImage=_ref.activeImage,onSelectProduct=_ref.onSelectProduct,onRemoveProduct=_ref.onRemoveProduct,onImageSelect=_ref.onImageSelect,onClose=_ref.onClose,enabled=_ref.enabled,activeSelection=_ref.activeSelection,userRole=_ref.userRole;var _getVariantOptions=(0,_CustomerProductCard.getVariantOptions)(activeSelection,enabled,product,variant),variantEnabled=_getVariantOptions.variantEnabled,isDefault=_getVariantOptions.isDefault,isSelected=_getVariantOptions.isSelected,variantConfig=_getVariantOptions.variantConfig,showWarning=_getVariantOptions.showWarning;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:function(_onClose){function onClose(){return _onClose.apply(this,arguments);}onClose.toString=function(){return _onClose.toString();};return onClose;}(function(){return onClose();}),showCloseButton:true,className:'CustomerProductDialog',show:true},_react2.default.createElement('div',{className:'product-container'},_react2.default.createElement('div',{className:'column medium-7 relative'},_react2.default.createElement('div',{className:'row product-images'},_react2.default.createElement('div',{className:'image-gallery'},_react2.default.createElement(_CustomerImageGallery2.default,{activeImage:activeImage,onImageSelect:onImageSelect,images:variant.images})))),_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'name'},product.name,' - ',variant.name),_react2.default.createElement('div',{className:'product-info'},variant.replacement&&_react2.default.createElement('div',{className:'section'},_react2.default.createElement('div',{className:'callout warning text-center'},_ref2,_react2.default.createElement('div',null,variant.replacement.productName,' - ',variant.replacement.variantName))),!variant.replacement&&(product.archived||variant.archived)&&_ref3,_react2.default.createElement('div',{className:'section'},isDefault&&_ref4,_react2.default.createElement('div',{className:'itemNumber'},'Artnr. ',variant.itemNumber)),!isDefault&&(!activeSelection.slot.advanced||!!variantConfig)&&_react2.default.createElement('div',{className:'section price'},_react2.default.createElement('span',null,'Pris: ',_react2.default.createElement(_FormattedPrice2.default,{value:(0,_priceHelpers.productPrice)(variant,activeSelection.slot,activeSelection.orderRow,variantConfig,activeSelection.config),unit:(0,_priceHelpers.productUnit)(variant,activeSelection.slot,activeSelection.orderRow,variantConfig,activeSelection.config)}))),(!(0,_isEmpty3.default)(variant.externalDescription)||!(0,_isEmpty3.default)(product.externalDescription))&&_react2.default.createElement(_reactLinkify2.default,{className:'section description',properties:{target:'_blank'}},!(0,_isEmpty3.default)(product.externalDescription)&&_react2.default.createElement('p',{className:'preserve-whitespace'},product.externalDescription),!(0,_isEmpty3.default)(variant.externalDescription)&&_react2.default.createElement('p',{className:'preserve-whitespace'},variant.externalDescription)),(!(0,_isEmpty3.default)(variant.color)||!!variant.sizeWidth||!!variant.sizeHeight||!!variant.sizeDepth)&&_react2.default.createElement('div',{className:'section specifications'},_react2.default.createElement('table',null,_react2.default.createElement('tbody',null,!(0,_isEmpty3.default)(variant.color)&&_react2.default.createElement('tr',null,_ref5,_react2.default.createElement('td',null,variant.color)),!!variant.sizeWidth&&_react2.default.createElement('tr',null,_ref6,_react2.default.createElement('td',null,variant.sizeWidth,' cm')),!!variant.sizeHeight&&_react2.default.createElement('tr',null,_ref7,_react2.default.createElement('td',null,variant.sizeHeight,' cm')),!!variant.sizeDepth&&_react2.default.createElement('tr',null,_ref8,_react2.default.createElement('td',null,variant.sizeDepth,' cm'))))),userRole!==_roles.DEMO&&_react2.default.createElement('div',{className:'section'},_react2.default.createElement(_CustomerProductOrderButton2.default,{isOrdered:isSelected,onSelectProduct:function(_onSelectProduct){function onSelectProduct(){return _onSelectProduct.apply(this,arguments);}onSelectProduct.toString=function(){return _onSelectProduct.toString();};return onSelectProduct;}(function(){return onSelectProduct(variant);}),onRemoveProduct:function(_onRemoveProduct){function onRemoveProduct(){return _onRemoveProduct.apply(this,arguments);}onRemoveProduct.toString=function(){return _onRemoveProduct.toString();};return onRemoveProduct;}(function(){return onRemoveProduct(variant);}),enabled:variantEnabled,showWarning:showWarning}))))),userRole!==_roles.DEMO&&isSelected&&_ref9));};exports.default=CustomerProductDialog;

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _indexOf2=__webpack_require__(1293);var _indexOf3=_interopRequireDefault(_indexOf2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);var _reactImageLightbox=__webpack_require__(1295);var _reactImageLightbox2=_interopRequireDefault(_reactImageLightbox);__webpack_require__(1307);var _request=__webpack_require__(6);var _CustomerProductImage=__webpack_require__(265);var _CustomerProductImage2=_interopRequireDefault(_CustomerProductImage);__webpack_require__(1308);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var fileUrl=_request.apiBase+'/files';/*:: export type Props = {
  images: any[],
  activeImage: ?any,
  onImageSelect: Function,
};*//*:: export type State = {
  isOpen: boolean,
};*/var CustomerImageGallery=function(_Component){_inherits(CustomerImageGallery,_Component);function CustomerImageGallery(props/*: Props*/){_classCallCheck(this,CustomerImageGallery);var _this=_possibleConstructorReturn(this,(CustomerImageGallery.__proto__||Object.getPrototypeOf(CustomerImageGallery)).call(this,props));_this.state={isOpen:false};return _this;}_createClass(CustomerImageGallery,[{key:'render',value:function render(){var _this2=this;var _props=this.props,images=_props.images,activeImage=_props.activeImage,onImageSelect=_props.onImageSelect;var isOpen=this.state.isOpen;var photoIndex=(0,_indexOf3.default)(activeImage,images);var nextImage=void 0,prevImage=void 0;if(photoIndex>-1){nextImage=images[(photoIndex+1)%images.length];prevImage=images[(photoIndex+images.length-1)%images.length];}return _react2.default.createElement('div',{className:'CustomerImageGallery'},_react2.default.createElement('div',{className:'preview expand'},_react2.default.createElement(_CustomerProductImage2.default,{file:activeImage,onClick:function onClick(){return _this2.setState({isOpen:true});},size:'240h',showOverlay:true})),images.length>1&&_react2.default.createElement('div',{className:'image-list shrink'},(0,_map3.default)(function(i){return _react2.default.createElement('div',{key:i.id,onClick:function onClick(){return onImageSelect(i);},className:(0,_classnames2.default)({image:true,active:!!activeImage&&activeImage.id===i.id})},_react2.default.createElement(_CustomerProductImage2.default,{file:i}));},images)),isOpen&&!!activeImage&&_react2.default.createElement(_reactImageLightbox2.default,{mainSrc:fileUrl+'/preview/'+activeImage.id+'/1000',nextSrc:!!nextImage?fileUrl+'/preview/'+nextImage.id+'/1000':null,prevSrc:!!prevImage?fileUrl+'/preview/'+prevImage.id+'/1000':null,imagePadding:100,wrapperClassName:'lightbox-wrap',enableZoom:false,onCloseRequest:function onCloseRequest(){return _this2.setState({isOpen:false});},onMovePrevRequest:function onMovePrevRequest(){if(!!prevImage){onImageSelect(prevImage);}},onMoveNextRequest:function onMoveNextRequest(){if(!!nextImage){onImageSelect(nextImage);}}}));}}]);return CustomerImageGallery;}(_react.Component);exports.default=CustomerImageGallery;

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('indexOf', __webpack_require__(1294));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(112),
    toInteger = __webpack_require__(58);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Gets the index at which the first occurrence of `value` is found in `array`
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. If `fromIndex` is negative, it's used as the
 * offset from the end of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 * @example
 *
 * _.indexOf([1, 2, 1, 2], 2);
 * // => 1
 *
 * // Search from the `fromIndex`.
 * _.indexOf([1, 2, 1, 2], 2, 2);
 * // => 3
 */
function indexOf(array, value, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseIndexOf(array, value, index);
}

module.exports = indexOf;


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

!function(root, factory) {
     true ? module.exports = factory() : "function" == typeof define && define.amd ? define([], factory) : "object" == typeof exports ? exports.ReactImageLightbox = factory() : root.ReactImageLightbox = factory();
}(window, function() {
    /******/
    return function(modules) {
        // webpackBootstrap
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/
        /******/ // The require function
        /******/        function __webpack_require__(moduleId) {
            /******/
            /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) 
            /******/ return installedModules[moduleId].exports;
            /******/
            /******/ // Create a new module (and put it into the cache)
            /******/            var module = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: !1,
                /******/ exports: {}
                /******/            };
            /******/
            /******/ // Execute the module function
            /******/            
            /******/
            /******/ // Return the exports of the module
            /******/ return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            /******/
            /******/ // Flag the module as loaded
            /******/ module.l = !0, module.exports;
            /******/        }
        /******/
        /******/
        /******/ // expose the modules object (__webpack_modules__)
        /******/        
        /******/
        /******/
        /******/ // Load entry module and return exports
        /******/ return __webpack_require__.m = modules, 
        /******/
        /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules, 
        /******/
        /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ __webpack_require__.o(exports, name) || 
            /******/ Object.defineProperty(exports, name, {
                /******/ configurable: !1,
                /******/ enumerable: !0,
                /******/ get: getter
                /******/            })
            /******/;
        }, 
        /******/
        /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ Object.defineProperty(exports, "__esModule", {
                value: !0
            });
            /******/        }, 
        /******/
        /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module) {
            /******/ var getter = module && module.__esModule ? 
            /******/ function() {
                return module.default;
            } : 
            /******/ function() {
                return module;
            };
            /******/            
            /******/ return __webpack_require__.d(getter, "a", getter), getter;
            /******/        }, 
        /******/
        /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, 
        /******/
        /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 1);
        /******/    }
    /************************************************************************/
    /******/ ([ 
    /* 0 */
    /***/ function(module, exports) {
        var g;
        // This works in non-strict mode
                g = function() {
            return this;
        }();
        try {
            // This works if eval is allowed (see CSP)
            g = g || Function("return this")() || (0, eval)("this");
        } catch (e) {
            // This works if the window reference is available
            "object" == typeof window && (g = window);
        }
        // g can still be undefined, but nothing to do about it...
        // We return undefined, instead of nothing here, so it's
        // easier to handle this case. if(!global) { ...}
                module.exports = g;
    }, 
    /* 1 */
    /***/ function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var obj, _reactImageLightbox = __webpack_require__(2), _reactImageLightbox2 = (obj = _reactImageLightbox) && obj.__esModule ? obj : {
            default: obj
        };
        exports.default = _reactImageLightbox2.default;
    }, 
    /* 2 */
    /***/ function(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */        
        /* WEBPACK VAR INJECTION */ (function(global) {
            Object.defineProperty(exports, "__esModule", {
                value: !0
            });
            var _extends = Object.assign || function(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = arguments[i];
                    for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
                }
                return target;
            }, _slicedToArray = function() {
                return function(arr, i) {
                    if (Array.isArray(arr)) return arr;
                    if (Symbol.iterator in Object(arr)) return function(arr, i) {
                        var _arr = [], _n = !0, _d = !1, _e = void 0;
                        try {
                            for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), 
                            !i || _arr.length !== i); _n = !0) ;
                        } catch (err) {
                            _d = !0, _e = err;
                        } finally {
                            try {
                                !_n && _i.return && _i.return();
                            } finally {
                                if (_d) throw _e;
                            }
                        }
                        return _arr;
                    }(arr, i);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }(), _createClass = function() {
                function defineProperties(target, props) {
                    for (var i = 0; i < props.length; i++) {
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                        "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
                    Constructor;
                };
            }(), _react = __webpack_require__(3), _react2 = _interopRequireDefault(_react), _propTypes2 = _interopRequireDefault(__webpack_require__(4)), _reactModal2 = _interopRequireDefault(__webpack_require__(5)), _util = __webpack_require__(6), _constant = __webpack_require__(7);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _toConsumableArray(arr) {
                if (Array.isArray(arr)) {
                    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
                    return arr2;
                }
                return Array.from(arr);
            }
            function _defineProperty(obj, key, value) {
                return key in obj ? Object.defineProperty(obj, key, {
                    value: value,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : obj[key] = value, obj;
            }
            __webpack_require__(8);
            var ReactImageLightbox = function(_Component) {
                function ReactImageLightbox(props) {
                    !function(instance, Constructor) {
                        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
                    }(this, ReactImageLightbox);
                    var _this = function(self, call) {
                        if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return !call || "object" != typeof call && "function" != typeof call ? self : call;
                    }(this, (ReactImageLightbox.__proto__ || Object.getPrototypeOf(ReactImageLightbox)).call(this, props));
                    return _this.state = {
                        //-----------------------------
                        // Animation
                        //-----------------------------
                        // Lightbox is closing
                        // When Lightbox is mounted, if animation is enabled it will open with the reverse of the closing animation
                        isClosing: !props.animationDisabled,
                        // Component parts should animate (e.g., when images are moving, or image is being zoomed)
                        shouldAnimate: !1,
                        //-----------------------------
                        // Zoom settings
                        //-----------------------------
                        // Zoom level of image
                        zoomLevel: _constant.MIN_ZOOM_LEVEL,
                        //-----------------------------
                        // Image position settings
                        //-----------------------------
                        // Horizontal offset from center
                        offsetX: 0,
                        // Vertical offset from center
                        offsetY: 0,
                        // image load error for srcType
                        loadErrorStatus: {}
                    }, _this.closeIfClickInner = _this.closeIfClickInner.bind(_this), _this.handleImageDoubleClick = _this.handleImageDoubleClick.bind(_this), 
                    _this.handleImageMouseWheel = _this.handleImageMouseWheel.bind(_this), _this.handleKeyInput = _this.handleKeyInput.bind(_this), 
                    _this.handleMouseUp = _this.handleMouseUp.bind(_this), _this.handleMouseDown = _this.handleMouseDown.bind(_this), 
                    _this.handleMouseMove = _this.handleMouseMove.bind(_this), _this.handleOuterMousewheel = _this.handleOuterMousewheel.bind(_this), 
                    _this.handleTouchStart = _this.handleTouchStart.bind(_this), _this.handleTouchMove = _this.handleTouchMove.bind(_this), 
                    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this), _this.handlePointerEvent = _this.handlePointerEvent.bind(_this), 
                    _this.handleCaptionMousewheel = _this.handleCaptionMousewheel.bind(_this), _this.handleWindowResize = _this.handleWindowResize.bind(_this), 
                    _this.handleZoomInButtonClick = _this.handleZoomInButtonClick.bind(_this), _this.handleZoomOutButtonClick = _this.handleZoomOutButtonClick.bind(_this), 
                    _this.requestClose = _this.requestClose.bind(_this), _this.requestMoveNext = _this.requestMoveNext.bind(_this), 
                    _this.requestMovePrev = _this.requestMovePrev.bind(_this), _this;
                }
                return function(subClass, superClass) {
                    if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                    subClass.prototype = Object.create(superClass && superClass.prototype, {
                        constructor: {
                            value: subClass,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
                }(ReactImageLightbox, _react.Component), _createClass(ReactImageLightbox, null, [ {
                    key: "isTargetMatchImage",
                    value: function(target) {
                        return target && /ril-image-current/.test(target.className);
                    }
                }, {
                    key: "parseMouseEvent",
                    value: function(mouseEvent) {
                        return {
                            id: "mouse",
                            source: _constant.SOURCE_MOUSE,
                            x: parseInt(mouseEvent.clientX, 10),
                            y: parseInt(mouseEvent.clientY, 10)
                        };
                    }
                }, {
                    key: "parseTouchPointer",
                    value: function(touchPointer) {
                        return {
                            id: touchPointer.identifier,
                            source: _constant.SOURCE_TOUCH,
                            x: parseInt(touchPointer.clientX, 10),
                            y: parseInt(touchPointer.clientY, 10)
                        };
                    }
                }, {
                    key: "parsePointerEvent",
                    value: function(pointerEvent) {
                        return {
                            id: pointerEvent.pointerId,
                            source: _constant.SOURCE_POINTER,
                            x: parseInt(pointerEvent.clientX, 10),
                            y: parseInt(pointerEvent.clientY, 10)
                        };
                    }
                    // Request to transition to the previous image
                                }, {
                    key: "getTransform",
                    value: function(_ref) {
                        var _ref$x = _ref.x, x = void 0 === _ref$x ? 0 : _ref$x, _ref$y = _ref.y, y = void 0 === _ref$y ? 0 : _ref$y, _ref$zoom = _ref.zoom, zoom = void 0 === _ref$zoom ? 1 : _ref$zoom, width = _ref.width, targetWidth = _ref.targetWidth, nextX = x, windowWidth = (0, 
                        _util.getWindowWidth)();
                        width > windowWidth && (nextX += (windowWidth - width) / 2);
                        var scaleFactor = zoom * (targetWidth / width);
                        return {
                            transform: "translate3d(" + nextX + "px," + y + "px,0) scale3d(" + scaleFactor + "," + scaleFactor + ",1)"
                        };
                    }
                } ]), _createClass(ReactImageLightbox, [ {
                    key: "componentWillMount",
                    value: function() {
                        // Timeouts - always clear it before umount
                        this.timeouts = [], 
                        // Current action
                        this.currentAction = _constant.ACTION_NONE, 
                        // Events source
                        this.eventsSource = _constant.SOURCE_ANY, 
                        // Empty pointers list
                        this.pointerList = [], 
                        // Prevent inner close
                        this.preventInnerClose = !1, this.preventInnerCloseTimeout = null, 
                        // Used to disable animation when changing props.mainSrc|nextSrc|prevSrc
                        this.keyPressed = !1, 
                        // Used to store load state / dimensions of images
                        this.imageCache = {}, 
                        // Time the last keydown event was called (used in keyboard action rate limiting)
                        this.lastKeyDownTime = 0, 
                        // Used for debouncing window resize event
                        this.resizeTimeout = null, 
                        // Used to determine when actions are triggered by the scroll wheel
                        this.wheelActionTimeout = null, this.resetScrollTimeout = null, this.scrollX = 0, 
                        this.scrollY = 0, 
                        // Used in panning zoomed images
                        this.moveStartX = 0, this.moveStartY = 0, this.moveStartOffsetX = 0, this.moveStartOffsetY = 0, 
                        // Used to swipe
                        this.swipeStartX = 0, this.swipeStartY = 0, this.swipeEndX = 0, this.swipeEndY = 0, 
                        // Used to pinch
                        this.pinchTouchList = null, this.pinchDistance = 0, 
                        // Used to differentiate between images with identical src
                        this.keyCounter = 0, 
                        // Used to detect a move when all src's remain unchanged (four or more of the same image in a row)
                        this.moveRequested = !1, this.props.animationDisabled || 
                        // Make opening animation play
                        this.setState({
                            isClosing: !1
                        });
                    }
                }, {
                    key: "componentDidMount",
                    value: function() {
                        var _this2 = this;
                        // Prevents cross-origin errors when using a cross-origin iframe
                                                this.windowContext = (0, _util.getHighestSafeWindowContext)(), 
                        this.listeners = {
                            resize: this.handleWindowResize,
                            mouseup: this.handleMouseUp,
                            touchend: this.handleTouchEnd,
                            touchcancel: this.handleTouchEnd,
                            pointerdown: this.handlePointerEvent,
                            pointermove: this.handlePointerEvent,
                            pointerup: this.handlePointerEvent,
                            pointercancel: this.handlePointerEvent
                        }, Object.keys(this.listeners).forEach(function(type) {
                            _this2.windowContext.addEventListener(type, _this2.listeners[type]);
                        }), this.loadAllImages();
                    }
                }, {
                    key: "componentWillReceiveProps",
                    value: function(nextProps) {
                        var _this3 = this, sourcesChanged = !1, prevSrcDict = {}, nextSrcDict = {};
                        // Iterate through the source types for prevProps and nextProps to
                        //  determine if any of the sources changed
                                                this.getSrcTypes().forEach(function(srcType) {
                            _this3.props[srcType.name] !== nextProps[srcType.name] && (sourcesChanged = !0, 
                            prevSrcDict[_this3.props[srcType.name]] = !0, nextSrcDict[nextProps[srcType.name]] = !0);
                        }), (sourcesChanged || this.moveRequested) && (
                        // Reset the loaded state for images not rendered next
                        Object.keys(prevSrcDict).forEach(function(prevSrc) {
                            !(prevSrc in nextSrcDict) && prevSrc in _this3.imageCache && (_this3.imageCache[prevSrc].loaded = !1);
                        }), this.moveRequested = !1, 
                        // Load any new images
                        this.loadAllImages(nextProps));
                    }
                }, {
                    key: "shouldComponentUpdate",
                    value: function() {
                        // Wait for move...
                        return !this.moveRequested;
                    }
                }, {
                    key: "componentWillUnmount",
                    value: function() {
                        var _this4 = this;
                        this.didUnmount = !0, Object.keys(this.listeners).forEach(function(type) {
                            _this4.windowContext.removeEventListener(type, _this4.listeners[type]);
                        }), this.timeouts.forEach(function(tid) {
                            return clearTimeout(tid);
                        });
                    }
                }, {
                    key: "setTimeout",
                    value: function(_setTimeout) {
                        function setTimeout(_x, _x2) {
                            return _setTimeout.apply(this, arguments);
                        }
                        return setTimeout.toString = function() {
                            return _setTimeout.toString();
                        }, setTimeout;
                    }(function(func, time) {
                        var _this5 = this, id = setTimeout(function() {
                            _this5.timeouts = _this5.timeouts.filter(function(tid) {
                                return tid !== id;
                            }), func();
                        }, time);
                        return this.timeouts.push(id), id;
                    })
                }, {
                    key: "setPreventInnerClose",
                    value: function() {
                        var _this6 = this;
                        this.preventInnerCloseTimeout && this.clearTimeout(this.preventInnerCloseTimeout), 
                        this.preventInnerClose = !0, this.preventInnerCloseTimeout = this.setTimeout(function() {
                            _this6.preventInnerClose = !1, _this6.preventInnerCloseTimeout = null;
                        }, 100);
                    }
                    // Get info for the best suited image to display with the given srcType
                                }, {
                    key: "getBestImageForType",
                    value: function(srcType) {
                        var imageSrc = this.props[srcType], fitSizes = {};
                        if (this.isImageLoaded(imageSrc)) 
                        // Use full-size image if available
                        fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height); else {
                            if (!this.isImageLoaded(this.props[srcType + "Thumbnail"])) return null;
                            // Fall back to using thumbnail if the image has not been loaded
                            imageSrc = this.props[srcType + "Thumbnail"], fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height, !0);
                        }
                        return {
                            src: imageSrc,
                            height: this.imageCache[imageSrc].height,
                            width: this.imageCache[imageSrc].width,
                            targetHeight: fitSizes.height,
                            targetWidth: fitSizes.width
                        };
                    }
                    // Get sizing for when an image is larger than the window
                                }, {
                    key: "getFitSizes",
                    value: function(width, height, stretch) {
                        var boxSize = this.getLightboxRect(), maxHeight = boxSize.height - 2 * this.props.imagePadding, maxWidth = boxSize.width - 2 * this.props.imagePadding;
                        return stretch || (maxHeight = Math.min(maxHeight, height), maxWidth = Math.min(maxWidth, width)), 
                        maxWidth / maxHeight > width / height ? {
                            width: width * maxHeight / height,
                            height: maxHeight
                        } : {
                            width: maxWidth,
                            height: height * maxWidth / width
                        };
                    }
                }, {
                    key: "getMaxOffsets",
                    value: function() {
                        var zoomLevel = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state.zoomLevel, currentImageInfo = this.getBestImageForType("mainSrc");
                        if (null === currentImageInfo) return {
                            maxX: 0,
                            minX: 0,
                            maxY: 0,
                            minY: 0
                        };
                        var boxSize = this.getLightboxRect(), zoomMultiplier = this.getZoomMultiplier(zoomLevel), maxX = 0, maxY = 0;
                        return {
                            maxX: 
                            // if there is still blank space in the X dimension, don't limit except to the opposite edge
                            maxX = zoomMultiplier * currentImageInfo.width - boxSize.width < 0 ? (boxSize.width - zoomMultiplier * currentImageInfo.width) / 2 : (zoomMultiplier * currentImageInfo.width - boxSize.width) / 2,
                            maxY: 
                            // if there is still blank space in the Y dimension, don't limit except to the opposite edge
                            maxY = zoomMultiplier * currentImageInfo.height - boxSize.height < 0 ? (boxSize.height - zoomMultiplier * currentImageInfo.height) / 2 : (zoomMultiplier * currentImageInfo.height - boxSize.height) / 2,
                            minX: -1 * maxX,
                            minY: -1 * maxY
                        };
                    }
                    // Get image src types
                                }, {
                    key: "getSrcTypes",
                    value: function() {
                        return [ {
                            name: "mainSrc",
                            keyEnding: "i" + this.keyCounter
                        }, {
                            name: "mainSrcThumbnail",
                            keyEnding: "t" + this.keyCounter
                        }, {
                            name: "nextSrc",
                            keyEnding: "i" + (this.keyCounter + 1)
                        }, {
                            name: "nextSrcThumbnail",
                            keyEnding: "t" + (this.keyCounter + 1)
                        }, {
                            name: "prevSrc",
                            keyEnding: "i" + (this.keyCounter - 1)
                        }, {
                            name: "prevSrcThumbnail",
                            keyEnding: "t" + (this.keyCounter - 1)
                        } ];
                    }
                    /**
     * Get sizing when the image is scaled
     */                }, {
                    key: "getZoomMultiplier",
                    value: function() {
                        var zoomLevel = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state.zoomLevel;
                        return Math.pow(_constant.ZOOM_RATIO, zoomLevel);
                    }
                    /**
     * Get the size of the lightbox in pixels
     */                }, {
                    key: "getLightboxRect",
                    value: function() {
                        return this.outerEl ? this.outerEl.getBoundingClientRect() : {
                            width: (0, _util.getWindowWidth)(),
                            height: (0, _util.getWindowHeight)(),
                            top: 0,
                            right: 0,
                            bottom: 0,
                            left: 0
                        };
                    }
                }, {
                    key: "clearTimeout",
                    value: function(_clearTimeout) {
                        function clearTimeout(_x3) {
                            return _clearTimeout.apply(this, arguments);
                        }
                        return clearTimeout.toString = function() {
                            return _clearTimeout.toString();
                        }, clearTimeout;
                    }(function(id) {
                        this.timeouts = this.timeouts.filter(function(tid) {
                            return tid !== id;
                        }), clearTimeout(id);
                    })
                }, {
                    key: "changeZoom",
                    value: function(zoomLevel, clientX, clientY) {
                        // Ignore if zoom disabled
                        if (this.props.enableZoom) {
                            // Constrain zoom level to the set bounds
                            var nextZoomLevel = Math.max(_constant.MIN_ZOOM_LEVEL, Math.min(_constant.MAX_ZOOM_LEVEL, zoomLevel));
                            // Ignore requests that don't change the zoom level
                                                        if (nextZoomLevel !== this.state.zoomLevel) if (nextZoomLevel !== _constant.MIN_ZOOM_LEVEL) {
                                var imageBaseSize = this.getBestImageForType("mainSrc");
                                if (null !== imageBaseSize) {
                                    var currentZoomMultiplier = this.getZoomMultiplier(), nextZoomMultiplier = this.getZoomMultiplier(nextZoomLevel), boxRect = this.getLightboxRect(), pointerX = void 0 !== clientX ? clientX - boxRect.left : boxRect.width / 2, pointerY = void 0 !== clientY ? clientY - boxRect.top : boxRect.height / 2, currentImageOffsetX = (boxRect.width - imageBaseSize.width * currentZoomMultiplier) / 2, currentImageOffsetY = (boxRect.height - imageBaseSize.height * currentZoomMultiplier) / 2, nextImageRealOffsetX = pointerX - (pointerX - (currentImageOffsetX - this.state.offsetX)) / currentZoomMultiplier * nextZoomMultiplier, nextImageRealOffsetY = pointerY - (pointerY - (currentImageOffsetY - this.state.offsetY)) / currentZoomMultiplier * nextZoomMultiplier, nextOffsetX = (boxRect.width - imageBaseSize.width * nextZoomMultiplier) / 2 - nextImageRealOffsetX, nextOffsetY = (boxRect.height - imageBaseSize.height * nextZoomMultiplier) / 2 - nextImageRealOffsetY;
                                    // When zooming out, limit the offset so things don't get left askew
                                    if (this.currentAction !== _constant.ACTION_PINCH) {
                                        var maxOffsets = this.getMaxOffsets();
                                        this.state.zoomLevel > nextZoomLevel && (nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, nextOffsetX)), 
                                        nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, nextOffsetY)));
                                    }
                                    this.setState({
                                        zoomLevel: nextZoomLevel,
                                        offsetX: nextOffsetX,
                                        offsetY: nextOffsetY
                                    });
                                }
                            } else 
                            // Snap back to center if zoomed all the way out
                            this.setState({
                                zoomLevel: nextZoomLevel,
                                offsetX: 0,
                                offsetY: 0
                            });
                        }
                    }
                }, {
                    key: "closeIfClickInner",
                    value: function(event) {
                        !this.preventInnerClose && event.target.className.search(/\bril-inner\b/) > -1 && this.requestClose(event);
                    }
                    /**
     * Handle user keyboard actions
     */                }, {
                    key: "handleKeyInput",
                    value: function(event) {
                        // Ignore key input during animations
                        if (event.stopPropagation(), !this.isAnimating()) 
                        // Allow slightly faster navigation through the images when user presses keys repeatedly
                        if ("keyup" !== event.type) {
                            var keyCode = event.which || event.keyCode, currentTime = new Date();
                            // Ignore key presses that happen too close to each other (when rapid fire key pressing or holding down the key)
                            // But allow it if it's a lightbox closing action
                                                        if (!(currentTime.getTime() - this.lastKeyDownTime < this.props.keyRepeatLimit && keyCode !== _constant.KEYS.ESC)) switch (this.lastKeyDownTime = currentTime.getTime(), 
                            keyCode) {
                              // ESC key closes the lightbox
                                case _constant.KEYS.ESC:
                                event.preventDefault(), this.requestClose(event);
                                break;

                                // Left arrow key moves to previous image
                                                              case _constant.KEYS.LEFT_ARROW:
                                if (!this.props.prevSrc) return;
                                event.preventDefault(), this.keyPressed = !0, this.requestMovePrev(event);
                                break;

                                // Right arrow key moves to next image
                                                              case _constant.KEYS.RIGHT_ARROW:
                                if (!this.props.nextSrc) return;
                                event.preventDefault(), this.keyPressed = !0, this.requestMoveNext(event);
                            }
                        } else this.lastKeyDownTime -= this.props.keyRepeatKeyupBonus;
                    }
                    /**
     * Handle a mouse wheel event over the lightbox container
     */                }, {
                    key: "handleOuterMousewheel",
                    value: function(event) {
                        var _this7 = this;
                        // Prevent scrolling of the background
                                                event.preventDefault(), event.stopPropagation();
                        var xThreshold = _constant.WHEEL_MOVE_X_THRESHOLD, actionDelay = 0;
                        // Prevent rapid-fire zoom behavior
                        if (this.clearTimeout(this.resetScrollTimeout), this.resetScrollTimeout = this.setTimeout(function() {
                            _this7.scrollX = 0, _this7.scrollY = 0;
                        }, 300), null === this.wheelActionTimeout && !this.isAnimating()) {
                            if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
                                // handle horizontal scrolls with image moves
                                this.scrollY = 0, this.scrollX += event.deltaX;
                                var bigLeapX = xThreshold / 2;
                                // If the scroll amount has accumulated sufficiently, or a large leap was taken
                                                                this.scrollX >= xThreshold || event.deltaX >= bigLeapX ? (
                                // Scroll right moves to next
                                this.requestMoveNext(event), actionDelay = 500, this.scrollX = 0) : (this.scrollX <= -1 * xThreshold || event.deltaX <= -1 * bigLeapX) && (
                                // Scroll left moves to previous
                                this.requestMovePrev(event), actionDelay = 500, this.scrollX = 0);
                            }
                            // Allow successive actions after the set delay
                                                        0 !== actionDelay && (this.wheelActionTimeout = this.setTimeout(function() {
                                _this7.wheelActionTimeout = null;
                            }, actionDelay));
                        }
                    }
                }, {
                    key: "handleImageMouseWheel",
                    value: function(event) {
                        event.preventDefault();
                        var yThreshold = _constant.WHEEL_MOVE_Y_THRESHOLD;
                        if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
                            // If the vertical scroll amount was large enough, perform a zoom
                            if (event.stopPropagation(), Math.abs(event.deltaY) < yThreshold) return;
                            this.scrollX = 0, this.scrollY += event.deltaY, this.changeZoom(this.state.zoomLevel - event.deltaY, event.clientX, event.clientY);
                        }
                    }
                    /**
     * Handle a double click on the current image
     */                }, {
                    key: "handleImageDoubleClick",
                    value: function(event) {
                        this.state.zoomLevel > _constant.MIN_ZOOM_LEVEL ? 
                        // A double click when zoomed in zooms all the way out
                        this.changeZoom(_constant.MIN_ZOOM_LEVEL, event.clientX, event.clientY) : 
                        // A double click when zoomed all the way out zooms in
                        this.changeZoom(this.state.zoomLevel + _constant.ZOOM_BUTTON_INCREMENT_SIZE, event.clientX, event.clientY);
                    }
                }, {
                    key: "shouldHandleEvent",
                    value: function(source) {
                        if (this.eventsSource === source) return !0;
                        if (this.eventsSource === _constant.SOURCE_ANY) return this.eventsSource = source, 
                        !0;
                        switch (source) {
                          case _constant.SOURCE_MOUSE:
                            return !1;

                          case _constant.SOURCE_TOUCH:
                            return this.eventsSource = _constant.SOURCE_TOUCH, this.filterPointersBySource(), 
                            !0;

                          case _constant.SOURCE_POINTER:
                            return this.eventsSource === _constant.SOURCE_MOUSE && (this.eventsSource = _constant.SOURCE_POINTER, 
                            this.filterPointersBySource(), !0);

                          default:
                            return !1;
                        }
                    }
                }, {
                    key: "addPointer",
                    value: function(pointer) {
                        this.pointerList.push(pointer);
                    }
                }, {
                    key: "removePointer",
                    value: function(pointer) {
                        this.pointerList = this.pointerList.filter(function(_ref2) {
                            return _ref2.id !== pointer.id;
                        });
                    }
                }, {
                    key: "filterPointersBySource",
                    value: function() {
                        var _this8 = this;
                        this.pointerList = this.pointerList.filter(function(_ref3) {
                            return _ref3.source === _this8.eventsSource;
                        });
                    }
                }, {
                    key: "handleMouseDown",
                    value: function(event) {
                        this.shouldHandleEvent(_constant.SOURCE_MOUSE) && ReactImageLightbox.isTargetMatchImage(event.target) && (this.addPointer(ReactImageLightbox.parseMouseEvent(event)), 
                        this.multiPointerStart(event));
                    }
                }, {
                    key: "handleMouseMove",
                    value: function(event) {
                        this.shouldHandleEvent(_constant.SOURCE_MOUSE) && this.multiPointerMove(event, [ ReactImageLightbox.parseMouseEvent(event) ]);
                    }
                }, {
                    key: "handleMouseUp",
                    value: function(event) {
                        this.shouldHandleEvent(_constant.SOURCE_MOUSE) && (this.removePointer(ReactImageLightbox.parseMouseEvent(event)), 
                        this.multiPointerEnd(event));
                    }
                }, {
                    key: "handlePointerEvent",
                    value: function(event) {
                        if (this.shouldHandleEvent(_constant.SOURCE_POINTER)) switch (event.type) {
                          case "pointerdown":
                            ReactImageLightbox.isTargetMatchImage(event.target) && (this.addPointer(ReactImageLightbox.parsePointerEvent(event)), 
                            this.multiPointerStart(event));
                            break;

                          case "pointermove":
                            this.multiPointerMove(event, [ ReactImageLightbox.parsePointerEvent(event) ]);
                            break;

                          case "pointerup":
                          case "pointercancel":
                            this.removePointer(ReactImageLightbox.parsePointerEvent(event)), this.multiPointerEnd(event);
                        }
                    }
                }, {
                    key: "handleTouchStart",
                    value: function(event) {
                        var _this9 = this;
                        this.shouldHandleEvent(_constant.SOURCE_TOUCH) && ReactImageLightbox.isTargetMatchImage(event.target) && ([].forEach.call(event.changedTouches, function(eventTouch) {
                            return _this9.addPointer(ReactImageLightbox.parseTouchPointer(eventTouch));
                        }), this.multiPointerStart(event));
                    }
                }, {
                    key: "handleTouchMove",
                    value: function(event) {
                        this.shouldHandleEvent(_constant.SOURCE_TOUCH) && this.multiPointerMove(event, [].map.call(event.changedTouches, function(eventTouch) {
                            return ReactImageLightbox.parseTouchPointer(eventTouch);
                        }));
                    }
                }, {
                    key: "handleTouchEnd",
                    value: function(event) {
                        var _this10 = this;
                        this.shouldHandleEvent(_constant.SOURCE_TOUCH) && ([].map.call(event.changedTouches, function(touch) {
                            return _this10.removePointer(ReactImageLightbox.parseTouchPointer(touch));
                        }), this.multiPointerEnd(event));
                    }
                }, {
                    key: "decideMoveOrSwipe",
                    value: function(pointer) {
                        this.state.zoomLevel <= _constant.MIN_ZOOM_LEVEL ? this.handleSwipeStart(pointer) : this.handleMoveStart(pointer);
                    }
                }, {
                    key: "multiPointerStart",
                    value: function(event) {
                        switch (this.handleEnd(null), this.pointerList.length) {
                          case 1:
                            event.preventDefault(), this.decideMoveOrSwipe(this.pointerList[0]);
                            break;

                          case 2:
                            event.preventDefault(), this.handlePinchStart(this.pointerList);
                        }
                    }
                }, {
                    key: "multiPointerMove",
                    value: function(event, pointerList) {
                        switch (this.currentAction) {
                          case _constant.ACTION_MOVE:
                            event.preventDefault(), this.handleMove(pointerList[0]);
                            break;

                          case _constant.ACTION_SWIPE:
                            event.preventDefault(), this.handleSwipe(pointerList[0]);
                            break;

                          case _constant.ACTION_PINCH:
                            event.preventDefault(), this.handlePinch(pointerList);
                        }
                    }
                }, {
                    key: "multiPointerEnd",
                    value: function(event) {
                        switch (this.currentAction !== _constant.ACTION_NONE && (this.setPreventInnerClose(), 
                        this.handleEnd(event)), this.pointerList.length) {
                          case 0:
                            this.eventsSource = _constant.SOURCE_ANY;
                            break;

                          case 1:
                            event.preventDefault(), this.decideMoveOrSwipe(this.pointerList[0]);
                            break;

                          case 2:
                            event.preventDefault(), this.handlePinchStart(this.pointerList);
                        }
                    }
                }, {
                    key: "handleEnd",
                    value: function(event) {
                        switch (this.currentAction) {
                          case _constant.ACTION_MOVE:
                            this.handleMoveEnd(event);
                            break;

                          case _constant.ACTION_SWIPE:
                            this.handleSwipeEnd(event);
                            break;

                          case _constant.ACTION_PINCH:
                            this.handlePinchEnd(event);
                        }
                    }
                    // Handle move start over the lightbox container
                    // This happens:
                    // - On a mouseDown event
                    // - On a touchstart event
                                }, {
                    key: "handleMoveStart",
                    value: function(_ref4) {
                        var clientX = _ref4.x, clientY = _ref4.y;
                        this.props.enableZoom && (this.currentAction = _constant.ACTION_MOVE, this.moveStartX = clientX, 
                        this.moveStartY = clientY, this.moveStartOffsetX = this.state.offsetX, this.moveStartOffsetY = this.state.offsetY);
                    }
                    // Handle dragging over the lightbox container
                    // This happens:
                    // - After a mouseDown and before a mouseUp event
                    // - After a touchstart and before a touchend event
                                }, {
                    key: "handleMove",
                    value: function(_ref5) {
                        var clientX = _ref5.x, clientY = _ref5.y, newOffsetX = this.moveStartX - clientX + this.moveStartOffsetX, newOffsetY = this.moveStartY - clientY + this.moveStartOffsetY;
                        this.state.offsetX === newOffsetX && this.state.offsetY === newOffsetY || this.setState({
                            offsetX: newOffsetX,
                            offsetY: newOffsetY
                        });
                    }
                }, {
                    key: "handleMoveEnd",
                    value: function() {
                        var _this11 = this;
                        this.currentAction = _constant.ACTION_NONE, this.moveStartX = 0, this.moveStartY = 0, 
                        this.moveStartOffsetX = 0, this.moveStartOffsetY = 0;
                        // Snap image back into frame if outside max offset range
                        var maxOffsets = this.getMaxOffsets(), nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, this.state.offsetX)), nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, this.state.offsetY));
                        nextOffsetX === this.state.offsetX && nextOffsetY === this.state.offsetY || (this.setState({
                            offsetX: nextOffsetX,
                            offsetY: nextOffsetY,
                            shouldAnimate: !0
                        }), this.setTimeout(function() {
                            _this11.setState({
                                shouldAnimate: !1
                            });
                        }, this.props.animationDuration));
                    }
                }, {
                    key: "handleSwipeStart",
                    value: function(_ref6) {
                        var clientX = _ref6.x, clientY = _ref6.y;
                        this.currentAction = _constant.ACTION_SWIPE, this.swipeStartX = clientX, this.swipeStartY = clientY, 
                        this.swipeEndX = clientX, this.swipeEndY = clientY;
                    }
                }, {
                    key: "handleSwipe",
                    value: function(_ref7) {
                        var clientX = _ref7.x, clientY = _ref7.y;
                        this.swipeEndX = clientX, this.swipeEndY = clientY;
                    }
                }, {
                    key: "handleSwipeEnd",
                    value: function(event) {
                        var xDiff = this.swipeEndX - this.swipeStartX, xDiffAbs = Math.abs(xDiff), yDiffAbs = Math.abs(this.swipeEndY - this.swipeStartY);
                        if (this.currentAction = _constant.ACTION_NONE, this.swipeStartX = 0, this.swipeStartY = 0, 
                        this.swipeEndX = 0, this.swipeEndY = 0, !(!event || this.isAnimating() || xDiffAbs < 1.5 * yDiffAbs)) {
                            if (xDiffAbs < _constant.MIN_SWIPE_DISTANCE) if (xDiffAbs < this.getLightboxRect().width / 4) return;
                            xDiff > 0 && this.props.prevSrc ? (event.preventDefault(), this.requestMovePrev()) : xDiff < 0 && this.props.nextSrc && (event.preventDefault(), 
                            this.requestMoveNext());
                        }
                    }
                }, {
                    key: "calculatePinchDistance",
                    value: function() {
                        var _ref8 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.pinchTouchList, _ref9 = _slicedToArray(_ref8, 2), a = _ref9[0], b = _ref9[1];
                        return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
                    }
                }, {
                    key: "calculatePinchCenter",
                    value: function() {
                        var _ref10 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.pinchTouchList, _ref11 = _slicedToArray(_ref10, 2), a = _ref11[0], b = _ref11[1];
                        return {
                            x: a.x - (a.x - b.x) / 2,
                            y: a.y - (a.y - b.y) / 2
                        };
                    }
                }, {
                    key: "handlePinchStart",
                    value: function(pointerList) {
                        this.props.enableZoom && (this.currentAction = _constant.ACTION_PINCH, this.pinchTouchList = pointerList.map(function(_ref12) {
                            return {
                                id: _ref12.id,
                                x: _ref12.x,
                                y: _ref12.y
                            };
                        }), this.pinchDistance = this.calculatePinchDistance());
                    }
                }, {
                    key: "handlePinch",
                    value: function(pointerList) {
                        this.pinchTouchList = this.pinchTouchList.map(function(oldPointer) {
                            for (var i = 0; i < pointerList.length; i += 1) if (pointerList[i].id === oldPointer.id) return pointerList[i];
                            return oldPointer;
                        });
                        var newDistance = this.calculatePinchDistance(), zoomLevel = this.state.zoomLevel + newDistance - this.pinchDistance;
                        this.pinchDistance = newDistance;
                        var _calculatePinchCenter = this.calculatePinchCenter(this.pinchTouchList), clientX = _calculatePinchCenter.x, clientY = _calculatePinchCenter.y;
                        this.changeZoom(zoomLevel, clientX, clientY);
                    }
                }, {
                    key: "handlePinchEnd",
                    value: function() {
                        this.currentAction = _constant.ACTION_NONE, this.pinchTouchList = null, this.pinchDistance = 0;
                    }
                    // Handle the window resize event
                                }, {
                    key: "handleWindowResize",
                    value: function() {
                        this.clearTimeout(this.resizeTimeout), this.resizeTimeout = this.setTimeout(this.forceUpdate.bind(this), 100);
                    }
                }, {
                    key: "handleZoomInButtonClick",
                    value: function() {
                        this.changeZoom(this.state.zoomLevel + _constant.ZOOM_BUTTON_INCREMENT_SIZE);
                    }
                }, {
                    key: "handleZoomOutButtonClick",
                    value: function() {
                        this.changeZoom(this.state.zoomLevel - _constant.ZOOM_BUTTON_INCREMENT_SIZE);
                    }
                }, {
                    key: "handleCaptionMousewheel",
                    value: function(event) {
                        if (event.stopPropagation(), this.caption) {
                            var height = this.caption.getBoundingClientRect().height, _caption = this.caption, scrollHeight = _caption.scrollHeight, scrollTop = _caption.scrollTop;
                            (event.deltaY > 0 && height + scrollTop >= scrollHeight || event.deltaY < 0 && scrollTop <= 0) && event.preventDefault();
                        }
                    }
                    // Detach key and mouse input events
                                }, {
                    key: "isAnimating",
                    value: function() {
                        return this.state.shouldAnimate || this.state.isClosing;
                    }
                    // Check if image is loaded
                                }, {
                    key: "isImageLoaded",
                    value: function(imageSrc) {
                        return imageSrc && imageSrc in this.imageCache && this.imageCache[imageSrc].loaded;
                    }
                    // Load image from src and call callback with image width and height on load
                                }, {
                    key: "loadImage",
                    value: function(srcType, imageSrc, done) {
                        var _this12 = this;
                        // Return the image info if it is already cached
                                                if (this.isImageLoaded(imageSrc)) this.setTimeout(function() {
                            done();
                        }, 1); else {
                            var inMemoryImage = new global.Image();
                            this.props.imageCrossOrigin && (inMemoryImage.crossOrigin = this.props.imageCrossOrigin), 
                            inMemoryImage.onerror = function(errorEvent) {
                                _this12.props.onImageLoadError(imageSrc, srcType, errorEvent), 
                                // failed to load so set the state loadErrorStatus
                                _this12.setState(function(prevState) {
                                    return {
                                        loadErrorStatus: _extends({}, prevState.loadErrorStatus, _defineProperty({}, srcType, !0))
                                    };
                                }), done(errorEvent);
                            }, inMemoryImage.onload = function() {
                                _this12.props.onImageLoad(imageSrc, srcType, inMemoryImage), _this12.imageCache[imageSrc] = {
                                    loaded: !0,
                                    width: inMemoryImage.width,
                                    height: inMemoryImage.height
                                }, done();
                            }, inMemoryImage.src = imageSrc;
                        }
                    }
                    // Load all images and their thumbnails
                                }, {
                    key: "loadAllImages",
                    value: function() {
                        var _this13 = this, props = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props;
                        // Load the images
                        this.getSrcTypes().forEach(function(srcType) {
                            var type = srcType.name;
                            // there is no error when we try to load it initially
                                                        props[type] && _this13.state.loadErrorStatus[type] && _this13.setState(function(prevState) {
                                return {
                                    loadErrorStatus: _extends({}, prevState.loadErrorStatus, _defineProperty({}, type, !1))
                                };
                            }), 
                            // Load unloaded images
                            props[type] && !_this13.isImageLoaded(props[type]) && _this13.loadImage(type, props[type], function(srcType, imageSrc) {
                                return function(err) {
                                    // Give up showing image on error
                                    err || _this13.props[srcType] !== imageSrc || _this13.didUnmount || 
                                    // Force rerender with the new image
                                    _this13.forceUpdate();
                                    // Don't rerender if the src is not the same as when the load started
                                    // or if the component has unmounted
                                                                };
                            }(type, props[type]));
                        });
                    }
                    // Request that the lightbox be closed
                                }, {
                    key: "requestClose",
                    value: function(event) {
                        var _this14 = this, closeLightbox = function() {
                            return _this14.props.onCloseRequest(event);
                        };
                        // Call the parent close request
                                                this.props.animationDisabled || "keydown" === event.type && !this.props.animationOnKeyInput ? 
                        // No animation
                        closeLightbox() : (
                        // With animation
                        // Start closing animation
                        this.setState({
                            isClosing: !0
                        }), 
                        // Perform the actual closing at the end of the animation
                        this.setTimeout(closeLightbox, this.props.animationDuration));
                    }
                }, {
                    key: "requestMove",
                    value: function(direction, event) {
                        var _this15 = this, nextState = {
                            zoomLevel: _constant.MIN_ZOOM_LEVEL,
                            offsetX: 0,
                            offsetY: 0
                        };
                        // Reset the zoom level on image move
                                                // Enable animated states
                        this.props.animationDisabled || this.keyPressed && !this.props.animationOnKeyInput || (nextState.shouldAnimate = !0, 
                        this.setTimeout(function() {
                            return _this15.setState({
                                shouldAnimate: !1
                            });
                        }, this.props.animationDuration)), this.keyPressed = !1, this.moveRequested = !0, 
                        "prev" === direction ? (this.keyCounter -= 1, this.setState(nextState), this.props.onMovePrevRequest(event)) : (this.keyCounter += 1, 
                        this.setState(nextState), this.props.onMoveNextRequest(event));
                    }
                    // Request to transition to the next image
                                }, {
                    key: "requestMoveNext",
                    value: function(event) {
                        this.requestMove("next", event);
                    }
                    // Request to transition to the previous image
                                }, {
                    key: "requestMovePrev",
                    value: function(event) {
                        this.requestMove("prev", event);
                    }
                }, {
                    key: "render",
                    value: function() {
                        var _this16 = this, _props = this.props, animationDisabled = _props.animationDisabled, animationDuration = _props.animationDuration, clickOutsideToClose = _props.clickOutsideToClose, discourageDownloads = _props.discourageDownloads, enableZoom = _props.enableZoom, imageTitle = _props.imageTitle, nextSrc = _props.nextSrc, prevSrc = _props.prevSrc, toolbarButtons = _props.toolbarButtons, reactModalStyle = _props.reactModalStyle, _onAfterOpen = _props.onAfterOpen, imageCrossOrigin = _props.imageCrossOrigin, reactModalProps = _props.reactModalProps, _state = this.state, zoomLevel = _state.zoomLevel, offsetX = _state.offsetX, offsetY = _state.offsetY, isClosing = _state.isClosing, loadErrorStatus = _state.loadErrorStatus, boxSize = this.getLightboxRect(), transitionStyle = {};
                        // Transition settings for sliding animations
                        !animationDisabled && this.isAnimating() && (transitionStyle = _extends({}, transitionStyle, {
                            transition: "transform " + animationDuration + "ms"
                        }));
                        // Key endings to differentiate between images with the same src
                                                var keyEndings = {};
                        this.getSrcTypes().forEach(function(_ref13) {
                            var name = _ref13.name, keyEnding = _ref13.keyEnding;
                            keyEndings[name] = keyEnding;
                        });
                        // Images to be displayed
                        var images = [], addImage = function(srcType, imageClass, transforms) {
                            // Ignore types that have no source defined for their full size image
                            if (_this16.props[srcType]) {
                                var bestImageInfo = _this16.getBestImageForType(srcType), imageStyle = _extends({}, transitionStyle, ReactImageLightbox.getTransform(_extends({}, transforms, bestImageInfo)));
                                zoomLevel > _constant.MIN_ZOOM_LEVEL && (imageStyle.cursor = "move");
                                // support IE 9 and 11
                                                                // when error on one of the loads then push custom error stuff
                                if (null === bestImageInfo && (object = loadErrorStatus, Object.keys(object).some(function(key) {
                                    return object[key];
                                }))) images.push(_react2.default.createElement("div", {
                                    className: imageClass + " ril__image ril-errored",
                                    style: imageStyle,
                                    key: _this16.props[srcType] + keyEndings[srcType]
                                }, _react2.default.createElement("div", {
                                    className: "ril__errorContainer"
                                }, _this16.props.imageLoadErrorMessage))); else if (null !== bestImageInfo) {
                                    var object, imageSrc = bestImageInfo.src;
                                    discourageDownloads ? (imageStyle.backgroundImage = "url('" + imageSrc + "')", images.push(_react2.default.createElement("div", {
                                        className: imageClass + " ril__image ril__imageDiscourager",
                                        onDoubleClick: _this16.handleImageDoubleClick,
                                        onWheel: _this16.handleImageMouseWheel,
                                        style: imageStyle,
                                        key: imageSrc + keyEndings[srcType]
                                    }, _react2.default.createElement("div", {
                                        className: "ril-download-blocker ril__downloadBlocker"
                                    })))) : images.push(_react2.default.createElement("img", _extends({}, imageCrossOrigin ? {
                                        crossOrigin: imageCrossOrigin
                                    } : {}, {
                                        className: imageClass + " ril__image",
                                        onDoubleClick: _this16.handleImageDoubleClick,
                                        onWheel: _this16.handleImageMouseWheel,
                                        onDragStart: function(e) {
                                            return e.preventDefault();
                                        },
                                        style: imageStyle,
                                        src: imageSrc,
                                        key: imageSrc + keyEndings[srcType],
                                        alt: "string" == typeof imageTitle ? imageTitle : (0, _util.translate)("Image"),
                                        draggable: !1
                                    })));
                                } else {
                                    var loadingIcon = _react2.default.createElement("div", {
                                        className: "ril-loading-circle ril__loadingCircle ril__loadingContainer__icon"
                                    }, [].concat(_toConsumableArray(new Array(12))).map(function(_, index) {
                                        return _react2.default.createElement("div", {
                                            // eslint-disable-next-line react/no-array-index-key
                                            key: index,
                                            className: "ril-loading-circle-point ril__loadingCirclePoint"
                                        });
                                    }));
                                    // Fall back to loading icon if the thumbnail has not been loaded
                                                                        images.push(_react2.default.createElement("div", {
                                        className: imageClass + " ril__image ril-not-loaded",
                                        style: imageStyle,
                                        key: _this16.props[srcType] + keyEndings[srcType]
                                    }, _react2.default.createElement("div", {
                                        className: "ril__loadingContainer"
                                    }, loadingIcon)));
                                }
                            }
                        }, zoomMultiplier = this.getZoomMultiplier();
                        // Next Image (displayed on the right)
                        addImage("nextSrc", "ril-image-next ril__imageNext", {
                            x: boxSize.width
                        }), 
                        // Main Image
                        addImage("mainSrc", "ril-image-current", {
                            x: -1 * offsetX,
                            y: -1 * offsetY,
                            zoom: zoomMultiplier
                        }), 
                        // Previous Image (displayed on the left)
                        addImage("prevSrc", "ril-image-prev ril__imagePrev", {
                            x: -1 * boxSize.width
                        });
                        var modalStyle = {
                            overlay: _extends({
                                zIndex: 1e3,
                                backgroundColor: "transparent"
                            }, reactModalStyle.overlay),
                            content: _extends({
                                backgroundColor: "transparent",
                                overflow: "hidden",
                                // Needed, otherwise keyboard shortcuts scroll the page
                                border: "none",
                                borderRadius: 0,
                                padding: 0,
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0
                            }, reactModalStyle.content)
                        };
                        return _react2.default.createElement(_reactModal2.default, _extends({
                            isOpen: !0,
                            onRequestClose: clickOutsideToClose ? this.requestClose : void 0,
                            onAfterOpen: function() {
                                // Focus on the div with key handlers
                                _this16.outerEl && _this16.outerEl.focus(), _onAfterOpen();
                            },
                            style: modalStyle,
                            contentLabel: (0, _util.translate)("Lightbox"),
                            appElement: void 0 !== global.window ? global.window.document.body : void 0
                        }, reactModalProps), _react2.default.createElement("div", {
                            // eslint-disable-line jsx-a11y/no-static-element-interactions
                            // Floating modal with closing animations
                            className: "ril-outer ril__outer ril__outerAnimating " + this.props.wrapperClassName + " " + (isClosing ? "ril-closing ril__outerClosing" : ""),
                            style: {
                                transition: "opacity " + animationDuration + "ms",
                                animationDuration: animationDuration + "ms",
                                animationDirection: isClosing ? "normal" : "reverse"
                            },
                            ref: function(el) {
                                _this16.outerEl = el;
                            },
                            onWheel: this.handleOuterMousewheel,
                            onMouseMove: this.handleMouseMove,
                            onMouseDown: this.handleMouseDown,
                            onTouchStart: this.handleTouchStart,
                            onTouchMove: this.handleTouchMove,
                            tabIndex: "-1",
                            onKeyDown: this.handleKeyInput,
                            onKeyUp: this.handleKeyInput
                        }, _react2.default.createElement("div", {
                            // eslint-disable-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
                            // Image holder
                            className: "ril-inner ril__inner",
                            onClick: clickOutsideToClose ? this.closeIfClickInner : void 0
                        }, images), prevSrc && _react2.default.createElement("button", {
                            // Move to previous image button
                            type: "button",
                            className: "ril-prev-button ril__navButtons ril__navButtonPrev",
                            key: "prev",
                            "aria-label": this.props.prevLabel,
                            onClick: this.isAnimating() ? void 0 : this.requestMovePrev
                        }), nextSrc && _react2.default.createElement("button", {
                            // Move to next image button
                            type: "button",
                            className: "ril-next-button ril__navButtons ril__navButtonNext",
                            key: "next",
                            "aria-label": this.props.nextLabel,
                            onClick: this.isAnimating() ? void 0 : this.requestMoveNext
                        }), _react2.default.createElement("div", {
                            // Lightbox toolbar
                            className: "ril-toolbar ril__toolbar"
                        }, _react2.default.createElement("ul", {
                            className: "ril-toolbar-left ril__toolbarSide ril__toolbarLeftSide"
                        }, _react2.default.createElement("li", {
                            className: "ril-toolbar__item ril__toolbarItem"
                        }, _react2.default.createElement("span", {
                            className: "ril-toolbar__item__child ril__toolbarItemChild"
                        }, imageTitle))), _react2.default.createElement("ul", {
                            className: "ril-toolbar-right ril__toolbarSide ril__toolbarRightSide"
                        }, toolbarButtons && toolbarButtons.map(function(button, i) {
                            return _react2.default.createElement("li", {
                                key: "button_" + (i + 1),
                                className: "ril-toolbar__item ril__toolbarItem"
                            }, button);
                        }), enableZoom && _react2.default.createElement("li", {
                            className: "ril-toolbar__item ril__toolbarItem"
                        }, _react2.default.createElement("button", {
                            // Lightbox zoom in button
                            type: "button",
                            key: "zoom-in",
                            "aria-label": this.props.zoomInLabel,
                            className: [ "ril-zoom-in", "ril__toolbarItemChild", "ril__builtinButton", "ril__zoomInButton" ].concat(_toConsumableArray(zoomLevel === _constant.MAX_ZOOM_LEVEL ? [ "ril__builtinButtonDisabled" ] : [])).join(" "),
                            disabled: this.isAnimating() || zoomLevel === _constant.MAX_ZOOM_LEVEL,
                            onClick: this.isAnimating() || zoomLevel === _constant.MAX_ZOOM_LEVEL ? void 0 : this.handleZoomInButtonClick
                        })), enableZoom && _react2.default.createElement("li", {
                            className: "ril-toolbar__item ril__toolbarItem"
                        }, _react2.default.createElement("button", {
                            // Lightbox zoom out button
                            type: "button",
                            key: "zoom-out",
                            "aria-label": this.props.zoomOutLabel,
                            className: [ "ril-zoom-out", "ril__toolbarItemChild", "ril__builtinButton", "ril__zoomOutButton" ].concat(_toConsumableArray(zoomLevel === _constant.MIN_ZOOM_LEVEL ? [ "ril__builtinButtonDisabled" ] : [])).join(" "),
                            disabled: this.isAnimating() || zoomLevel === _constant.MIN_ZOOM_LEVEL,
                            onClick: this.isAnimating() || zoomLevel === _constant.MIN_ZOOM_LEVEL ? void 0 : this.handleZoomOutButtonClick
                        })), _react2.default.createElement("li", {
                            className: "ril-toolbar__item ril__toolbarItem"
                        }, _react2.default.createElement("button", {
                            // Lightbox close button
                            type: "button",
                            key: "close",
                            "aria-label": this.props.closeLabel,
                            className: "ril-close ril-toolbar__item__child ril__toolbarItemChild ril__builtinButton ril__closeButton",
                            onClick: this.isAnimating() ? void 0 : this.requestClose
                        })))), this.props.imageCaption && 
                        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                        _react2.default.createElement("div", {
                            // Image caption
                            onWheel: this.handleCaptionMousewheel,
                            onMouseDown: function(event) {
                                return event.stopPropagation();
                            },
                            className: "ril-caption ril__caption",
                            ref: function(el) {
                                _this16.caption = el;
                            }
                        }, _react2.default.createElement("div", {
                            className: "ril-caption-content ril__captionContent"
                        }, this.props.imageCaption))));
                    }
                } ]), ReactImageLightbox;
            }();
            ReactImageLightbox.propTypes = {
                //-----------------------------
                // Image sources
                //-----------------------------
                // Main display image url
                mainSrc: _propTypes2.default.string.isRequired,
                // eslint-disable-line react/no-unused-prop-types
                // Previous display image url (displayed to the left)
                // If left undefined, movePrev actions will not be performed, and the button not displayed
                prevSrc: _propTypes2.default.string,
                // Next display image url (displayed to the right)
                // If left undefined, moveNext actions will not be performed, and the button not displayed
                nextSrc: _propTypes2.default.string,
                //-----------------------------
                // Image thumbnail sources
                //-----------------------------
                // Thumbnail image url corresponding to props.mainSrc
                mainSrcThumbnail: _propTypes2.default.string,
                // eslint-disable-line react/no-unused-prop-types
                // Thumbnail image url corresponding to props.prevSrc
                prevSrcThumbnail: _propTypes2.default.string,
                // eslint-disable-line react/no-unused-prop-types
                // Thumbnail image url corresponding to props.nextSrc
                nextSrcThumbnail: _propTypes2.default.string,
                // eslint-disable-line react/no-unused-prop-types
                //-----------------------------
                // Event Handlers
                //-----------------------------
                // Close window event
                // Should change the parent state such that the lightbox is not rendered
                onCloseRequest: _propTypes2.default.func.isRequired,
                // Move to previous image event
                // Should change the parent state such that props.prevSrc becomes props.mainSrc,
                //  props.mainSrc becomes props.nextSrc, etc.
                onMovePrevRequest: _propTypes2.default.func,
                // Move to next image event
                // Should change the parent state such that props.nextSrc becomes props.mainSrc,
                //  props.mainSrc becomes props.prevSrc, etc.
                onMoveNextRequest: _propTypes2.default.func,
                // Called when an image fails to load
                // (imageSrc: string, srcType: string, errorEvent: object): void
                onImageLoadError: _propTypes2.default.func,
                // Called when image successfully loads
                onImageLoad: _propTypes2.default.func,
                // Open window event
                onAfterOpen: _propTypes2.default.func,
                //-----------------------------
                // Download discouragement settings
                //-----------------------------
                // Enable download discouragement (prevents [right-click -> Save Image As...])
                discourageDownloads: _propTypes2.default.bool,
                //-----------------------------
                // Animation settings
                //-----------------------------
                // Disable all animation
                animationDisabled: _propTypes2.default.bool,
                // Disable animation on actions performed with keyboard shortcuts
                animationOnKeyInput: _propTypes2.default.bool,
                // Animation duration (ms)
                animationDuration: _propTypes2.default.number,
                //-----------------------------
                // Keyboard shortcut settings
                //-----------------------------
                // Required interval of time (ms) between key actions
                // (prevents excessively fast navigation of images)
                keyRepeatLimit: _propTypes2.default.number,
                // Amount of time (ms) restored after each keyup
                // (makes rapid key presses slightly faster than holding down the key to navigate images)
                keyRepeatKeyupBonus: _propTypes2.default.number,
                //-----------------------------
                // Image info
                //-----------------------------
                // Image title
                imageTitle: _propTypes2.default.node,
                // Image caption
                imageCaption: _propTypes2.default.node,
                // Optional crossOrigin attribute
                imageCrossOrigin: _propTypes2.default.string,
                //-----------------------------
                // Lightbox style
                //-----------------------------
                // Set z-index style, etc., for the parent react-modal (format: https://github.com/reactjs/react-modal#styles )
                reactModalStyle: _propTypes2.default.shape({}),
                // Padding (px) between the edge of the window and the lightbox
                imagePadding: _propTypes2.default.number,
                wrapperClassName: _propTypes2.default.string,
                //-----------------------------
                // Other
                //-----------------------------
                // Array of custom toolbar buttons
                toolbarButtons: _propTypes2.default.arrayOf(_propTypes2.default.node),
                // When true, clicks outside of the image close the lightbox
                clickOutsideToClose: _propTypes2.default.bool,
                // Set to false to disable zoom functionality and hide zoom buttons
                enableZoom: _propTypes2.default.bool,
                // Override props set on react-modal (https://github.com/reactjs/react-modal)
                reactModalProps: _propTypes2.default.shape({}),
                // Aria-labels
                nextLabel: _propTypes2.default.string,
                prevLabel: _propTypes2.default.string,
                zoomInLabel: _propTypes2.default.string,
                zoomOutLabel: _propTypes2.default.string,
                closeLabel: _propTypes2.default.string,
                imageLoadErrorMessage: _propTypes2.default.node
            }, ReactImageLightbox.defaultProps = {
                imageTitle: null,
                imageCaption: null,
                toolbarButtons: null,
                reactModalProps: {},
                animationDisabled: !1,
                animationDuration: 300,
                animationOnKeyInput: !1,
                clickOutsideToClose: !0,
                closeLabel: "Close lightbox",
                discourageDownloads: !1,
                enableZoom: !0,
                imagePadding: 10,
                imageCrossOrigin: null,
                keyRepeatKeyupBonus: 40,
                keyRepeatLimit: 180,
                mainSrcThumbnail: null,
                nextLabel: "Next image",
                nextSrc: null,
                nextSrcThumbnail: null,
                onAfterOpen: function() {},
                onImageLoadError: function() {},
                onImageLoad: function() {},
                onMoveNextRequest: function() {},
                onMovePrevRequest: function() {},
                prevLabel: "Previous image",
                prevSrc: null,
                prevSrcThumbnail: null,
                reactModalStyle: {},
                wrapperClassName: "",
                zoomInLabel: "Zoom in",
                zoomOutLabel: "Zoom out",
                imageLoadErrorMessage: "This image failed to load"
            }, exports.default = ReactImageLightbox;
        }).call(this, __webpack_require__(0))
        /***/;
    }, 
    /* 3 */
    /***/ function(module, exports) {
        module.exports = __webpack_require__(0);
        /***/    }, 
    /* 4 */
    /***/ function(module, exports) {
        module.exports = __webpack_require__(266);
        /***/    }, 
    /* 5 */
    /***/ function(module, exports) {
        module.exports = __webpack_require__(1300);
        /***/    }, 
    /* 6 */
    /***/ function(module, exports, __webpack_require__) {
        "use strict";
        /* WEBPACK VAR INJECTION */        
        /* WEBPACK VAR INJECTION */ (function(global) {
            Object.defineProperty(exports, "__esModule", {
                value: !0
            }), exports.translate = 
            /**
 * Placeholder for future translate functionality
 */
            function(str) {
                var replaceStrings = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                if (!str) return "";
                var translated = str;
                replaceStrings && Object.keys(replaceStrings).forEach(function(placeholder) {
                    translated = translated.replace(placeholder, replaceStrings[placeholder]);
                });
                return translated;
            }, exports.getWindowWidth = function() {
                return void 0 !== global.window ? global.window.innerWidth : 0;
            }, exports.getWindowHeight = function() {
                return void 0 !== global.window ? global.window.innerHeight : 0;
            }
            // Get the highest window context that isn't cross-origin
            // (When in an iframe)
            , exports.getHighestSafeWindowContext = function getHighestSafeWindowContext() {
                var self = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : global.window.self;
                // If we reached the top level, return self
                                if (self === global.window.top) return self;
                var getOrigin = function(href) {
                    return href.match(/(.*\/\/.*?)(\/|$)/)[1];
                };
                // If parent is the same origin, we can move up one context
                // Reference: https://stackoverflow.com/a/21965342/1601953
                                if (getOrigin(self.location.href) === getOrigin(self.document.referrer)) return getHighestSafeWindowContext(self.parent);
                // If a different origin, we consider the current level
                // as the top reachable one
                                return self;
            }
            /* WEBPACK VAR INJECTION */;
        }).call(this, __webpack_require__(0))
        /***/;
    }, 
    /* 7 */
    /***/ function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        // Min image zoom level
        exports.MIN_ZOOM_LEVEL = 0, exports.MAX_ZOOM_LEVEL = 300, exports.ZOOM_RATIO = 1.007, 
        exports.ZOOM_BUTTON_INCREMENT_SIZE = 100, exports.WHEEL_MOVE_X_THRESHOLD = 200, 
        exports.WHEEL_MOVE_Y_THRESHOLD = 1, exports.KEYS = {
            ESC: 27,
            LEFT_ARROW: 37,
            RIGHT_ARROW: 39
        }, exports.ACTION_NONE = 0, exports.ACTION_MOVE = 1, exports.ACTION_SWIPE = 2, exports.ACTION_PINCH = 3, 
        exports.ACTION_ROTATE = 4, exports.SOURCE_ANY = 0, exports.SOURCE_MOUSE = 1, exports.SOURCE_TOUCH = 2, 
        exports.SOURCE_POINTER = 3, exports.MIN_SWIPE_DISTANCE = 200;
        // Max image zoom level
        }, 
    /* 8 */
    /***/ function(module, exports) {
        // removed by extract-text-webpack-plugin
        /***/}
    /******/ ]);
});

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1297);
var invariant = __webpack_require__(1298);
var ReactPropTypesSecret = __webpack_require__(1299);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Modal = __webpack_require__(1301);

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Modal2.default;
module.exports = exports["default"];

/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bodyOpenClassName = exports.portalClassName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(72);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(266);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ModalPortal = __webpack_require__(1302);

var _ModalPortal2 = _interopRequireDefault(_ModalPortal);

var _ariaAppHider = __webpack_require__(497);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _safeHTMLElement = __webpack_require__(267);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

var _reactLifecyclesCompat = __webpack_require__(1306);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var portalClassName = exports.portalClassName = "ReactModalPortal";
var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";

var isReact16 = _reactDom2.default.createPortal !== undefined;
var createPortal = isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = function (_Component) {
  _inherits(Modal, _Component);

  function Modal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
      var parent = getParentElement(_this.props.parentSelector);
      parent.removeChild(_this.node);
    }, _this.portalRef = function (ref) {
      _this.portal = ref;
    }, _this.renderPortal = function (props) {
      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
      _this.portalRef(portal);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Modal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_safeHTMLElement.canUseDOM) return;

      if (!isReact16) {
        this.node = document.createElement("div");
      }
      this.node.className = this.props.portalClassName;

      var parent = getParentElement(this.props.parentSelector);
      parent.appendChild(this.node);

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      var prevParent = getParentElement(prevProps.parentSelector);
      var nextParent = getParentElement(this.props.parentSelector);
      return { prevParent: prevParent, nextParent: nextParent };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, _, snapshot) {
      if (!_safeHTMLElement.canUseDOM) return;
      var _props = this.props,
          isOpen = _props.isOpen,
          portalClassName = _props.portalClassName;


      if (prevProps.portalClassName !== portalClassName) {
        this.node.className = portalClassName;
      }

      // Stop unnecessary renders if modal is remaining closed
      if (!prevProps.isOpen && !isOpen) return;

      var prevParent = snapshot.prevParent,
          nextParent = snapshot.nextParent;

      if (nextParent !== prevParent) {
        prevParent.removeChild(this.node);
        nextParent.appendChild(this.node);
      }

      !isReact16 && this.renderPortal(this.props);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;

      var state = this.portal.state;
      var now = Date.now();
      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);

      if (closesAt) {
        if (!state.beforeClose) {
          this.portal.closeWithTimeout();
        }

        setTimeout(this.removePortal, closesAt - now);
      } else {
        this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!_safeHTMLElement.canUseDOM || !isReact16) {
        return null;
      }

      if (!this.node && isReact16) {
        this.node = document.createElement("div");
      }

      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
        ref: this.portalRef,
        defaultStyles: Modal.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function setAppElement(element) {
      ariaAppHider.setElement(element);
    }

    /* eslint-disable react/no-unused-prop-types */

    /* eslint-enable react/no-unused-prop-types */

  }]);

  return Modal;
}(_react.Component);

Modal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  portalClassName: _propTypes2.default.string,
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
    base: _propTypes2.default.string.isRequired,
    afterOpen: _propTypes2.default.string.isRequired,
    beforeClose: _propTypes2.default.string.isRequired
  })]),
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  ariaHideApp: _propTypes2.default.bool,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  parentSelector: _propTypes2.default.func,
  aria: _propTypes2.default.object,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func
};
Modal.defaultProps = {
  isOpen: false,
  portalClassName: portalClassName,
  bodyOpenClassName: bodyOpenClassName,
  ariaHideApp: true,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: true,
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  shouldReturnFocusAfterClose: true,
  parentSelector: function parentSelector() {
    return document.body;
  }
};
Modal.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};


(0, _reactLifecyclesCompat.polyfill)(Modal);

exports.default = Modal;

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(266);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _focusManager = __webpack_require__(1303);

var focusManager = _interopRequireWildcard(_focusManager);

var _scopeTab = __webpack_require__(1304);

var _scopeTab2 = _interopRequireDefault(_scopeTab);

var _ariaAppHider = __webpack_require__(497);

var ariaAppHider = _interopRequireWildcard(_ariaAppHider);

var _classList = __webpack_require__(1305);

var classList = _interopRequireWildcard(_classList);

var _safeHTMLElement = __webpack_require__(267);

var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: "ReactModal__Overlay",
  content: "ReactModal__Content"
};

var TAB_KEY = 9;
var ESC_KEY = 27;

var ariaHiddenInstances = 0;

var ModalPortal = function (_Component) {
  _inherits(ModalPortal, _Component);

  function ModalPortal(props) {
    _classCallCheck(this, ModalPortal);

    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));

    _this.setOverlayRef = function (overlay) {
      _this.overlay = overlay;
      _this.props.overlayRef && _this.props.overlayRef(overlay);
    };

    _this.setContentRef = function (content) {
      _this.content = content;
      _this.props.contentRef && _this.props.contentRef(content);
    };

    _this.afterClose = function () {
      var _this$props = _this.props,
          appElement = _this$props.appElement,
          ariaHideApp = _this$props.ariaHideApp,
          htmlOpenClassName = _this$props.htmlOpenClassName,
          bodyOpenClassName = _this$props.bodyOpenClassName;

      // Remove classes.

      classList.remove(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);

      // Reset aria-hidden attribute if all modals have been removed
      if (ariaHideApp && ariaHiddenInstances > 0) {
        ariaHiddenInstances -= 1;

        if (ariaHiddenInstances === 0) {
          ariaAppHider.show(appElement);
        }
      }

      if (_this.props.shouldFocusAfterRender) {
        if (_this.props.shouldReturnFocusAfterClose) {
          focusManager.returnFocus();
          focusManager.teardownScopedFocus();
        } else {
          focusManager.popWithoutFocus();
        }
      }
    };

    _this.open = function () {
      _this.beforeOpen();
      if (_this.state.afterOpen && _this.state.beforeClose) {
        clearTimeout(_this.closeTimer);
        _this.setState({ beforeClose: false });
      } else {
        if (_this.props.shouldFocusAfterRender) {
          focusManager.setupScopedFocus(_this.node);
          focusManager.markForFocusLater();
        }

        _this.setState({ isOpen: true }, function () {
          _this.setState({ afterOpen: true });

          if (_this.props.isOpen && _this.props.onAfterOpen) {
            _this.props.onAfterOpen();
          }
        });
      }
    };

    _this.close = function () {
      if (_this.props.closeTimeoutMS > 0) {
        _this.closeWithTimeout();
      } else {
        _this.closeWithoutTimeout();
      }
    };

    _this.focusContent = function () {
      return _this.content && !_this.contentHasFocus() && _this.content.focus();
    };

    _this.closeWithTimeout = function () {
      var closesAt = Date.now() + _this.props.closeTimeoutMS;
      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
      });
    };

    _this.closeWithoutTimeout = function () {
      _this.setState({
        beforeClose: false,
        isOpen: false,
        afterOpen: false,
        closesAt: null
      }, _this.afterClose);
    };

    _this.handleKeyDown = function (event) {
      if (event.keyCode === TAB_KEY) {
        (0, _scopeTab2.default)(_this.content, event);
      }

      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
        event.stopPropagation();
        _this.requestClose(event);
      }
    };

    _this.handleOverlayOnClick = function (event) {
      if (_this.shouldClose === null) {
        _this.shouldClose = true;
      }

      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
        if (_this.ownerHandlesClose()) {
          _this.requestClose(event);
        } else {
          _this.focusContent();
        }
      }
      _this.shouldClose = null;
    };

    _this.handleContentOnMouseUp = function () {
      _this.shouldClose = false;
    };

    _this.handleOverlayOnMouseDown = function (event) {
      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
        event.preventDefault();
      }
    };

    _this.handleContentOnClick = function () {
      _this.shouldClose = false;
    };

    _this.handleContentOnMouseDown = function () {
      _this.shouldClose = false;
    };

    _this.requestClose = function (event) {
      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
    };

    _this.ownerHandlesClose = function () {
      return _this.props.onRequestClose;
    };

    _this.shouldBeClosed = function () {
      return !_this.state.isOpen && !_this.state.beforeClose;
    };

    _this.contentHasFocus = function () {
      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
    };

    _this.buildClassName = function (which, additional) {
      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
        base: CLASS_NAMES[which],
        afterOpen: CLASS_NAMES[which] + "--after-open",
        beforeClose: CLASS_NAMES[which] + "--before-close"
      };
      var className = classNames.base;
      if (_this.state.afterOpen) {
        className = className + " " + classNames.afterOpen;
      }
      if (_this.state.beforeClose) {
        className = className + " " + classNames.beforeClose;
      }
      return typeof additional === "string" && additional ? className + " " + additional : className;
    };

    _this.ariaAttributes = function (items) {
      return Object.keys(items).reduce(function (acc, name) {
        acc["aria-" + name] = items[name];
        return acc;
      }, {});
    };

    _this.state = {
      afterOpen: false,
      beforeClose: false
    };

    _this.shouldClose = null;
    _this.moveFromContentToOverlay = null;
    return _this;
  }

  _createClass(ModalPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isOpen) {
        this.open();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (false) {
        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
          // eslint-disable-next-line no-console
          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
        }
      }

      if (this.props.isOpen && !prevProps.isOpen) {
        this.open();
      } else if (!this.props.isOpen && prevProps.isOpen) {
        this.close();
      }

      // Focus only needs to be set once when the modal is being opened
      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
        this.focusContent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.afterClose();
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "beforeOpen",
    value: function beforeOpen() {
      var _props = this.props,
          appElement = _props.appElement,
          ariaHideApp = _props.ariaHideApp,
          htmlOpenClassName = _props.htmlOpenClassName,
          bodyOpenClassName = _props.bodyOpenClassName;

      // Add classes.

      classList.add(document.body, bodyOpenClassName);

      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);

      if (ariaHideApp) {
        ariaHiddenInstances += 1;
        ariaAppHider.hide(appElement);
      }
    }

    // Don't steal focus from inner elements

  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          overlayClassName = _props2.overlayClassName,
          defaultStyles = _props2.defaultStyles;

      var contentStyles = className ? {} : defaultStyles.content;
      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;

      return this.shouldBeClosed() ? null : _react2.default.createElement(
        "div",
        {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", overlayClassName),
          style: _extends({}, overlayStyles, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown,
          "aria-modal": "true"
        },
        _react2.default.createElement(
          "div",
          _extends({
            ref: this.setContentRef,
            style: _extends({}, contentStyles, this.props.style.content),
            className: this.buildClassName("content", className),
            tabIndex: "-1",
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleContentOnMouseDown,
            onMouseUp: this.handleContentOnMouseUp,
            onClick: this.handleContentOnClick,
            role: this.props.role,
            "aria-label": this.props.contentLabel
          }, this.ariaAttributes(this.props.aria || {}), {
            "data-testid": this.props.testId
          }),
          this.props.children
        )
      );
    }
  }]);

  return ModalPortal;
}(_react.Component);

ModalPortal.defaultProps = {
  style: {
    overlay: {},
    content: {}
  },
  defaultStyles: {}
};
ModalPortal.propTypes = {
  isOpen: _propTypes2.default.bool.isRequired,
  defaultStyles: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  style: _propTypes2.default.shape({
    content: _propTypes2.default.object,
    overlay: _propTypes2.default.object
  }),
  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  bodyOpenClassName: _propTypes2.default.string,
  htmlOpenClassName: _propTypes2.default.string,
  ariaHideApp: _propTypes2.default.bool,
  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
  onAfterOpen: _propTypes2.default.func,
  onRequestClose: _propTypes2.default.func,
  closeTimeoutMS: _propTypes2.default.number,
  shouldFocusAfterRender: _propTypes2.default.bool,
  shouldCloseOnOverlayClick: _propTypes2.default.bool,
  shouldReturnFocusAfterClose: _propTypes2.default.bool,
  role: _propTypes2.default.string,
  contentLabel: _propTypes2.default.string,
  aria: _propTypes2.default.object,
  children: _propTypes2.default.node,
  shouldCloseOnEsc: _propTypes2.default.bool,
  overlayRef: _propTypes2.default.func,
  contentRef: _propTypes2.default.func,
  testId: _propTypes2.default.string
};
exports.default = ModalPortal;
module.exports = exports["default"];

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleBlur = handleBlur;
exports.handleFocus = handleFocus;
exports.markForFocusLater = markForFocusLater;
exports.returnFocus = returnFocus;
exports.popWithoutFocus = popWithoutFocus;
exports.setupScopedFocus = setupScopedFocus;
exports.teardownScopedFocus = teardownScopedFocus;

var _tabbable = __webpack_require__(496);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur() {
  needToFocus = true;
}

function handleFocus() {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function () {
      if (modalElement.contains(document.activeElement)) {
        return;
      }
      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
      el.focus();
    }, 0);
  }
}

function markForFocusLater() {
  focusLaterElements.push(document.activeElement);
}

/* eslint-disable no-console */
function returnFocus() {
  var toFocus = null;
  try {
    if (focusLaterElements.length !== 0) {
      toFocus = focusLaterElements.pop();
      toFocus.focus();
    }
    return;
  } catch (e) {
    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
  }
}
/* eslint-enable no-console */

function popWithoutFocus() {
  focusLaterElements.length > 0 && focusLaterElements.pop();
}

function setupScopedFocus(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener("blur", handleBlur, false);
    document.addEventListener("focus", handleFocus, true);
  } else {
    window.attachEvent("onBlur", handleBlur);
    document.attachEvent("onFocus", handleFocus);
  }
}

function teardownScopedFocus() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("focus", handleFocus);
  } else {
    window.detachEvent("onBlur", handleBlur);
    document.detachEvent("onFocus", handleFocus);
  }
}

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scopeTab;

var _tabbable = __webpack_require__(496);

var _tabbable2 = _interopRequireDefault(_tabbable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function scopeTab(node, event) {
  var tabbable = (0, _tabbable2.default)(node);

  if (!tabbable.length) {
    // Do nothing, since there are no elements that can receive focus.
    event.preventDefault();
    return;
  }

  var shiftKey = event.shiftKey;
  var head = tabbable[0];
  var tail = tabbable[tabbable.length - 1];

  // proceed with default browser behavior on tab.
  // Focus on last element on shift + tab.
  if (node === document.activeElement) {
    if (!shiftKey) return;
    target = tail;
  }

  var target;
  if (tail === document.activeElement && !shiftKey) {
    target = head;
  }

  if (head === document.activeElement && shiftKey) {
    target = tail;
  }

  if (target) {
    event.preventDefault();
    target.focus();
    return;
  }

  // Safari radio issue.
  //
  // Safari does not move the focus to the radio button,
  // so we need to force it to really walk through all elements.
  //
  // This is very error prone, since we are trying to guess
  // if it is a safari browser from the first occurence between
  // chrome or safari.
  //
  // The chrome user agent contains the first ocurrence
  // as the 'chrome/version' and later the 'safari/version'.
  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;

  // If we are not in safari desktop, let the browser control
  // the focus
  if (!isSafariDesktop) return;

  var x = tabbable.indexOf(document.activeElement);

  if (x > -1) {
    x += shiftKey ? -1 : 1;
  }

  event.preventDefault();

  tabbable[x].focus();
}
module.exports = exports["default"];

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dumpClassLists = dumpClassLists;
var htmlClassList = {};
var docBodyClassList = {};

function dumpClassLists() {
  if (false) {
    var classes = document.getElementsByTagName("html")[0].className;
    var buffer = "Show tracked classes:\n\n";

    buffer += "<html /> (" + classes + "):\n";
    for (var x in htmlClassList) {
      buffer += "  " + x + " " + htmlClassList[x] + "\n";
    }

    classes = document.body.className;

    // eslint-disable-next-line max-len
    buffer += "\n\ndoc.body (" + classes + "):\n";
    for (var _x in docBodyClassList) {
      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
    }

    buffer += "\n";

    // eslint-disable-next-line no-console
    console.log(buffer);
  }
}

/**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var incrementReference = function incrementReference(poll, className) {
  if (!poll[className]) {
    poll[className] = 0;
  }
  poll[className] += 1;
  return className;
};

/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */
var decrementReference = function decrementReference(poll, className) {
  if (poll[className]) {
    poll[className] -= 1;
  }
  return className;
};

/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */
var trackClass = function trackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    incrementReference(poll, className);
    classListRef.add(className);
  });
};

/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */
var untrackClass = function untrackClass(classListRef, poll, classes) {
  classes.forEach(function (className) {
    decrementReference(poll, className);
    poll[className] === 0 && classListRef.remove(className);
  });
};

/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var add = exports.add = function add(element, classString) {
  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */
var remove = exports.remove = function remove(element, classString) {
  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
};

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 1307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1311);var _FormattedPrice=__webpack_require__(131);var _FormattedPrice2=_interopRequireDefault(_FormattedPrice);var _roles=__webpack_require__(49);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var mapWithIndex=_map3.default.convert({cap:false});/*:: export type Props = {
  roomPrices: any[],
  additionalTotalPrice: {
    open: boolean,
    price: number,
  },
  discount: number,
  totalPrice: number,
  toggleRoomPrice: number => void,
  toggleAdditionalPrice: () => void,
  togglePrices: () => void,
  customRows: any[],
  expanded: boolean,
  userRole: number,
};*/var _ref2=_react2.default.createElement('div',{className:'CustomerOrderPrice-total-label'},'Dina tillval');var _ref3=_react2.default.createElement('div',{className:'CustomerOrderPrice-discount-label'},'Rabatt');var CustomerOrderPrice=function CustomerOrderPrice(_ref){var roomPrices=_ref.roomPrices,discount=_ref.discount,additionalTotalPrice=_ref.additionalTotalPrice,totalPrice=_ref.totalPrice,toggleRoomPrice=_ref.toggleRoomPrice,toggleAdditionalPrice=_ref.toggleAdditionalPrice,togglePrices=_ref.togglePrices,customRows=_ref.customRows,expanded=_ref.expanded,userRole=_ref.userRole;return[].concat(_toConsumableArray(!!expanded?[_react2.default.createElement('div',{key:0,onClick:togglePrices,className:'CustomerOrderPrice-wrapper'})]:[]),[_react2.default.createElement('div',{key:1,className:'CustomerOrderPrice'},userRole!==_roles.DEMO&&_react2.default.createElement('div',{onClick:togglePrices,className:(0,_classnames2.default)({'CustomerOrderPrice-top':true,'clickable':true,'is-open':!!expanded})},_react2.default.createElement('div',{className:'CustomerOrderPrice-total'},_ref2,_react2.default.createElement('div',{className:'CustomerOrderPrice-total-price'},_react2.default.createElement(_FormattedPrice2.default,{value:totalPrice}))),_react2.default.createElement('div',{className:'CustomerOrderPrice-chevron'},_react2.default.createElement('i',{className:(0,_classnames2.default)({'fa':true,'fa-angle-down':!!expanded,'fa-angle-right':!expanded})}))),!!expanded&&_react2.default.createElement('div',{className:'CustomerOrderPrice-expanded'},mapWithIndex(function(r,idx){return[_react2.default.createElement('div',{key:r.id,onClick:function onClick(){if(!!r.prices.orderRows&&!!r.prices.orderRows.length){toggleRoomPrice(r.id);}},className:(0,_classnames2.default)({'CustomerOrderPrice-room':true,'is-open':!!r.open,'clickable':!!r.prices.orderRows&&!!r.prices.orderRows.length,'even':idx%2===0})},_react2.default.createElement('div',{className:'CustomerOrderPrice-room-label'},r.name,!!r.prices.orderRows.length&&_react2.default.createElement('i',{className:(0,_classnames2.default)({'fa':true,'fa-angle-down':!!r.open,'fa-angle-right':!r.open})})),_react2.default.createElement('div',{className:'CustomerOrderPrice-room-price'},_react2.default.createElement(_FormattedPrice2.default,{value:r.prices.totalPrice})))].concat(_toConsumableArray(r.open?(0,_map3.default)(function(x){return _react2.default.createElement('div',{key:x.id,className:(0,_classnames2.default)({'CustomerOrderPrice-product':true,'even':idx%2===0})},_react2.default.createElement('div',{className:'CustomerOrderPrice-product-label'},x.name),_react2.default.createElement('div',{className:'CustomerOrderPrice-product-price'},_react2.default.createElement(_FormattedPrice2.default,{value:x.totalPrice})));},r.prices.orderRows):[]));},roomPrices),!!additionalTotalPrice.price&&_react2.default.createElement('div',{key:-1,onClick:function onClick(){if(!!customRows&&!!customRows.length){toggleAdditionalPrice();}},className:(0,_classnames2.default)({'CustomerOrderPrice-appended':true,'is-open':!!additionalTotalPrice.open,'clickable':!!customRows&&!!customRows.length,'even':roomPrices.length%2===0})},_react2.default.createElement('div',{className:'CustomerOrderPrice-appended-label'},'Extra tillvalsprodukter',!!customRows&&!!customRows.length&&_react2.default.createElement('i',{className:(0,_classnames2.default)({'fa':true,'fa-angle-down':!!additionalTotalPrice.open,'fa-angle-right':!additionalTotalPrice.open})})),_react2.default.createElement('div',{className:'CustomerOrderPrice-appended-price'},_react2.default.createElement(_FormattedPrice2.default,{value:additionalTotalPrice.price}))),!!additionalTotalPrice.open&&!!customRows&&!!customRows.length&&(0,_map3.default)(function(x){return _react2.default.createElement('div',{key:x.id,className:(0,_classnames2.default)({'CustomerOrderPrice-product':true,'even':roomPrices.length%2===0})},_react2.default.createElement('div',{className:'CustomerOrderPrice-product-label'},x.name),_react2.default.createElement('div',{className:'CustomerOrderPrice-product-price'},_react2.default.createElement(_FormattedPrice2.default,{value:x.totalSellingPrice})));},customRows),!!discount&&_react2.default.createElement('div',{key:-3,className:(0,_classnames2.default)({'CustomerOrderPrice-discount':true,'even':(roomPrices.length+(!!additionalTotalPrice.price?1:0))%2===0})},_ref3,_react2.default.createElement('div',{className:'CustomerOrderPrice-discount-price'},'- ',_react2.default.createElement(_FormattedPrice2.default,{value:discount})))))]);};exports.default=CustomerOrderPrice;

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var easeOutQuad=function easeOutQuad(x,t,b,c,d){return-c*(t/=d)*(t-2)+b;};var getScrollTop=function getScrollTop(){return!!document.documentElement?document.documentElement.scrollTop:!!document.body?document.body.scrollTop:0;};var setScrollTop=function setScrollTop(position){if(!!document.documentElement&&!!document.body){document.documentElement.scrollTop=document.body.scrollTop=position;}};var getOffsetTop=function getOffsetTop(element){return element.getBoundingClientRect().top+getScrollTop();};exports.default=function(id/*: ?string*/){var element=!!id?document.getElementById(id):document.body;if(!element){return;}var start=getScrollTop();var to=getOffsetTop(element);var change=to-start;var animateFn=function animateFn(){var elapsedTime=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var increment=20;var elapsed=elapsedTime+increment;var position=easeOutQuad(null,elapsed,start,change,400);setScrollTop(position);if(elapsed<400){setTimeout(function(){animateFn(elapsed);},increment);}};animateFn();};

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _pick2=__webpack_require__(86);var _pick3=_interopRequireDefault(_pick2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reduxForm=__webpack_require__(4);var _purchaseOrderView=__webpack_require__(402);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _ProductRowList=__webpack_require__(487);var _ProductRowList2=_interopRequireDefault(_ProductRowList);var _AdditionalRowList=__webpack_require__(1317);var _AdditionalRowList2=_interopRequireDefault(_AdditionalRowList);var _OrderCustomProductList=__webpack_require__(1319);var _OrderCustomProductList2=_interopRequireDefault(_OrderCustomProductList);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _ProductRowDialog=__webpack_require__(486);var _ProductRowDialog2=_interopRequireDefault(_ProductRowDialog);var _LinkedAdditionalRowDialog=__webpack_require__(1321);var _LinkedAdditionalRowDialog2=_interopRequireDefault(_LinkedAdditionalRowDialog);var _OrderRelationLinks=__webpack_require__(1323);var _OrderRelationLinks2=_interopRequireDefault(_OrderRelationLinks);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);var _OrderRowNoteDialog=__webpack_require__(488);var _OrderRowNoteDialog2=_interopRequireDefault(_OrderRowNoteDialog);var _PurchaseReportDialog=__webpack_require__(1324);var _PurchaseReportDialog2=_interopRequireDefault(_PurchaseReportDialog);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _orderStates=__webpack_require__(69);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var additionalRowValidation={roomId:{rule:'numeric|required',label:'Rum'},product:{rule:'required',label:'Produkt'},productVariant:{rule:'required',label:'Variant'},quantity:{rule:'numeric|min:0|required',label:'Antal'}};var linkedAdditionalRowValidation={quantity:{rule:'numeric|min:0|required',label:'Antal'},note:{rule:'string',label:'Anteckning'}};var noteRowValidation={note:{rule:'string',label:'Anteckning'}};/*:: export type Props = {
  prevPath: string,
  order: ?any,
  rooms: any[],
  products: any[],
  rowsById: any,
  extraRowsById: any,
  allRowsByRoom: any[],
  customRows: any[],
  additionalRows: any[],
  allAdditionalRowsByRoom: any[],
  clear: typeof clear,
  error: ?any,
  fetchData: (id: ?any) => any,
  fetchVariants: typeof fetchVariants,
  isFetching: boolean,
  params: any,
  updateOrder: typeof updateOrder,
  touch: typeof touch,
  productsAreFetching: boolean,
  additionalRowFormValues: any,
  additionalRowFormIsValid: boolean,
  additionalRow: ?any,
  setAdditionalProductRow: typeof setAdditionalProductRow,
  setLinkedAdditionalRow: typeof setLinkedAdditionalRow,
  createAdditionalRow: typeof createAdditionalRow,
  updateAdditionalRow: typeof updateAdditionalRow,
  removeAdditionalRow: typeof removeAdditionalRow,
  variants: any[],
  variantsAreFetching: boolean,
  additionalRowError: ?any,
  additionalRowIsFetching: boolean,
  linkedAdditionalRow: ?any,
  linkedAdditionalRowError: ?any,
  linkedAdditionalRowIsFetching: boolean,
  linkedAdditionalRowFormValues: any,
  linkedAdditionalRowFormIsValid: boolean,
  updateLinkedAdditionalRow: typeof updateLinkedAdditionalRow,
  removeLinkedAdditionalRow: typeof removeLinkedAdditionalRow,
  noteRow: ?any,
  noteRowError: ?any,
  noteRowIsFetching: boolean,
  noteRowIsExtra: boolean,
  noteRowFormValues: any,
  noteRowFormIsValid: boolean,
  setNoteRow: typeof setNoteRow,
  updateOrderRow: typeof updateOrderRow,
  updateExtraRow: typeof updateExtraRow,
  toggleReportDialog: typeof toggleReportDialog,
  reportDialogVisibility: boolean,
  suppliers: any[],
  reportFilter: {
    includePlans: boolean,
    supplierId: ?number,
  },
  updateReportFilter: typeof updateReportFilter,
  orders: any[],
};*/var _ref=_react2.default.createElement('div',{className:'box-title'},'Produkter');var _ref2=_react2.default.createElement('div',{className:'box-title'},'Friprodukter');var _ref3=_react2.default.createElement('div',{className:'box-title'},'Till\xE4ggsprodukter');var OrderContainer=function(_Component){_inherits(OrderContainer,_Component);function OrderContainer(){_classCallCheck(this,OrderContainer);return _possibleConstructorReturn(this,(OrderContainer.__proto__||Object.getPrototypeOf(OrderContainer)).apply(this,arguments));}_createClass(OrderContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData(this.props.params.id);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clear();}},{key:'saveLinkedAdditionalRow',value:function saveLinkedAdditionalRow(){var _props=this.props,linkedAdditionalRowFormValues=_props.linkedAdditionalRowFormValues,linkedAdditionalRowFormIsValid=_props.linkedAdditionalRowFormIsValid,linkedAdditionalRow=_props.linkedAdditionalRow,updateLinkedAdditionalRow=_props.updateLinkedAdditionalRow,touch=_props.touch;var keys=(0,_keys3.default)(linkedAdditionalRowValidation);touch.apply(undefined,['linkedAdditionalRow'].concat(_toConsumableArray(keys)));if(!linkedAdditionalRowFormIsValid||!linkedAdditionalRow){return;}var data=_extends({},linkedAdditionalRowFormValues,{productVariantId:linkedAdditionalRowFormValues.productVariant.id});updateLinkedAdditionalRow(linkedAdditionalRow.id,data);}},{key:'saveAdditionalRow',value:function saveAdditionalRow(){var _props2=this.props,additionalRowFormValues=_props2.additionalRowFormValues,additionalRowFormIsValid=_props2.additionalRowFormIsValid,order=_props2.order,additionalRow=_props2.additionalRow,createAdditionalRow=_props2.createAdditionalRow,updateAdditionalRow=_props2.updateAdditionalRow,touch=_props2.touch;var keys=(0,_keys3.default)(additionalRowValidation);touch.apply(undefined,['productRow'].concat(_toConsumableArray(keys)));if(!additionalRowFormIsValid){return;}var data=_extends({},additionalRowFormValues,{productVariantId:additionalRowFormValues.productVariant.id});if(additionalRow&&!additionalRow.id&&!!order){createAdditionalRow(order.id,data);}else if(!!additionalRow){updateAdditionalRow(additionalRow.id,data);}}},{key:'saveNoteRow',value:function saveNoteRow(){var _props3=this.props,noteRowIsExtra=_props3.noteRowIsExtra,noteRowFormValues=_props3.noteRowFormValues,noteRowFormIsValid=_props3.noteRowFormIsValid,noteRow=_props3.noteRow,updateOrderRow=_props3.updateOrderRow,updateExtraRow=_props3.updateExtraRow,touch=_props3.touch;var keys=(0,_keys3.default)(noteRowValidation);touch.apply(undefined,['noteRow'].concat(_toConsumableArray(keys)));if(!noteRowFormIsValid||!noteRow){return;}var data=(0,_pick3.default)(['note'],noteRowFormValues);if(noteRowIsExtra){updateExtraRow(noteRow.id,data);}else{updateOrderRow(noteRow.id,data);}}},{key:'render',value:function render(){var _this2=this;var _props4=this.props,order=_props4.order,allRowsByRoom=_props4.allRowsByRoom,rowsById=_props4.rowsById,extraRowsById=_props4.extraRowsById,additionalRows=_props4.additionalRows,customRows=_props4.customRows,rooms=_props4.rooms,additionalRow=_props4.additionalRow,allAdditionalRowsByRoom=_props4.allAdditionalRowsByRoom,additionalRowIsFetching=_props4.additionalRowIsFetching,additionalRowError=_props4.additionalRowError,linkedAdditionalRow=_props4.linkedAdditionalRow,linkedAdditionalRowIsFetching=_props4.linkedAdditionalRowIsFetching,linkedAdditionalRowError=_props4.linkedAdditionalRowError,products=_props4.products,productsAreFetching=_props4.productsAreFetching,variants=_props4.variants,variantsAreFetching=_props4.variantsAreFetching,additionalRowFormValues=_props4.additionalRowFormValues,error=_props4.error,isFetching=_props4.isFetching,fetchVariants=_props4.fetchVariants,setAdditionalProductRow=_props4.setAdditionalProductRow,setLinkedAdditionalRow=_props4.setLinkedAdditionalRow,removeAdditionalRow=_props4.removeAdditionalRow,removeLinkedAdditionalRow=_props4.removeLinkedAdditionalRow,updateOrder=_props4.updateOrder,noteRow=_props4.noteRow,noteRowError=_props4.noteRowError,noteRowIsFetching=_props4.noteRowIsFetching,noteRowFormValues=_props4.noteRowFormValues,setNoteRow=_props4.setNoteRow,toggleReportDialog=_props4.toggleReportDialog,reportDialogVisibility=_props4.reportDialogVisibility,suppliers=_props4.suppliers,reportFilter=_props4.reportFilter,updateReportFilter=_props4.updateReportFilter,orders=_props4.orders,clear=_props4.clear,fetchData=_props4.fetchData,prevPath=_props4.prevPath;return _react2.default.createElement('div',{className:'relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:order,list:orders,prevPath:prevPath,clear:clear,fetchData:fetchData}),_react2.default.createElement('div',{className:'content-title'},order&&'Beställning'||'Ny beställning',' ',order&&' | '+_orderStates.stateLabels[order.state]))),order&&_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},order.state===_orderStates.CONFIRMED&&_react2.default.createElement(_ActionConfirmation2.default,{id:'finishOrder',className:'success',message:'Vill du verkligen markera best\xE4llningen som klar?',buttonText:'Markera som klar',action:function action(){return updateOrder(order.id,{state:_orderStates.CLOSED});}}),order.state===_orderStates.CLOSED&&_react2.default.createElement(_ActionConfirmation2.default,{id:'revertOrder',className:'alert',message:'Vill du verkligen markera best\xE4llningen som oavslutad?',buttonText:'Markera som oavslutad',action:function action(){return updateOrder(order.id,{state:_orderStates.CONFIRMED});}}),_react2.default.createElement('button',{type:'button',className:'button',onClick:function onClick(){return toggleReportDialog(true);}},'Ladda ner ink\xF6psrapport'))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching||productsAreFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),order&&_react2.default.createElement('div',null,_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_OrderRelationLinks2.default,{project:order.apartment.project,apartment:order.apartment,user:order.user})),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement('div',{className:'content-section'},_ref,_react2.default.createElement(_ProductRowList2.default,{allRowsByRoom:allRowsByRoom,onSelectRow:function onSelectRow(row){setNoteRow(row,false);},onSelectExtraRow:function onSelectExtraRow(row){setNoteRow(row,true);}})),_react2.default.createElement('div',{className:'content-section'},_ref2,_react2.default.createElement(_OrderCustomProductList2.default,{products:customRows})),_react2.default.createElement('div',{className:'content-section'},_ref3,_react2.default.createElement(_AdditionalRowList2.default,{allRowsByRoom:allAdditionalRowsByRoom,rowsById:rowsById,extraRowsById:extraRowsById,onSelectRow:function onSelectRow(row){return setAdditionalProductRow(row);},onRemoveRow:function onRemoveRow(row){return removeAdditionalRow(row.id);},onSelectVariantRow:function onSelectVariantRow(row){return setLinkedAdditionalRow(row);},onRemoveVariantRow:function onRemoveVariantRow(row){return removeLinkedAdditionalRow(row.id);}}),_react2.default.createElement('button',{onClick:function onClick(){return setAdditionalProductRow({});},type:'button',className:'button small'},'L\xE4gg till till\xE4ggsprodukt')))),additionalRow&&_react2.default.createElement(_ProductRowDialog2.default,{existingRows:additionalRows,products:products,variants:variants,activeRow:additionalRow,rooms:rooms,error:additionalRowError,isLoading:additionalRowIsFetching||variantsAreFetching,formValues:additionalRowFormValues,onSave:function onSave(){return _this2.saveAdditionalRow();},onSelectProduct:function onSelectProduct(productId){return fetchVariants(productId);},onClose:function onClose(){return setAdditionalProductRow(null);},onOpen:undefined,validate:function validate(values){return(0,_validator2.default)(additionalRowValidation,values);}}),linkedAdditionalRow&&_react2.default.createElement(_LinkedAdditionalRowDialog2.default,{linkedAdditionalRow:linkedAdditionalRow,error:linkedAdditionalRowError,isLoading:linkedAdditionalRowIsFetching,onSave:function onSave(){return _this2.saveLinkedAdditionalRow();},onClose:function onClose(){return setLinkedAdditionalRow(null);},validate:function validate(values){return(0,_validator2.default)(linkedAdditionalRowValidation,values);}}),noteRow&&_react2.default.createElement(_OrderRowNoteDialog2.default,{orderRow:noteRow,error:noteRowError,isLoading:noteRowIsFetching,formValues:noteRowFormValues,onSave:function onSave(){return _this2.saveNoteRow();},onClose:function onClose(){return setNoteRow(null);},validate:function validate(values){return(0,_validator2.default)(noteRowValidation,values);}}),reportDialogVisibility&&!!order&&_react2.default.createElement(_PurchaseReportDialog2.default,{order:order,suppliers:suppliers,filter:reportFilter,updateFilter:updateReportFilter,onClose:function onClose(){return toggleReportDialog(false);}}));}}]);return OrderContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref4){var _ref4$purchaseOrderVi=_ref4.purchaseOrderView,order=_ref4$purchaseOrderVi.active,_ref4$purchaseOrderVi2=_ref4$purchaseOrderVi.rows,rowsById=_ref4$purchaseOrderVi2.rowsById,extraRowsById=_ref4$purchaseOrderVi2.extraRowsById,allRowsByRoom=_ref4$purchaseOrderVi2.allRowsByRoom,_ref4$purchaseOrderVi3=_ref4$purchaseOrderVi.additionalRows,additionalRows=_ref4$purchaseOrderVi3.additionalRows,allAdditionalRowsByRoom=_ref4$purchaseOrderVi3.allRowsByRoom,customRows=_ref4$purchaseOrderVi.customRows,rooms=_ref4$purchaseOrderVi.rooms,_ref4$purchaseOrderVi4=_ref4$purchaseOrderVi.additionalRow,additionalRow=_ref4$purchaseOrderVi4.active,additionalRowError=_ref4$purchaseOrderVi4.error,additionalRowIsFetching=_ref4$purchaseOrderVi4.isFetching,_ref4$purchaseOrderVi5=_ref4$purchaseOrderVi.linkedAdditionalRow,linkedAdditionalRow=_ref4$purchaseOrderVi5.active,linkedAdditionalRowError=_ref4$purchaseOrderVi5.error,linkedAdditionalRowIsFetching=_ref4$purchaseOrderVi5.isFetching,_ref4$purchaseOrderVi6=_ref4$purchaseOrderVi.products,productsAreFetching=_ref4$purchaseOrderVi6.isFetching,products=_ref4$purchaseOrderVi6.list,_ref4$purchaseOrderVi7=_ref4$purchaseOrderVi.variants,variantsAreFetching=_ref4$purchaseOrderVi7.isFetching,variants=_ref4$purchaseOrderVi7.list,error=_ref4$purchaseOrderVi.error,isFetching=_ref4$purchaseOrderVi.isFetching,_ref4$purchaseOrderVi8=_ref4$purchaseOrderVi.noteRow,noteRow=_ref4$purchaseOrderVi8.active,noteRowError=_ref4$purchaseOrderVi8.error,noteRowIsFetching=_ref4$purchaseOrderVi8.isFetching,noteRowIsExtra=_ref4$purchaseOrderVi8.isExtra,_ref4$purchaseOrderVi9=_ref4$purchaseOrderVi.reportDialog,reportDialogVisibility=_ref4$purchaseOrderVi9.isVisible,suppliers=_ref4$purchaseOrderVi9.suppliers,reportFilter=_ref4$purchaseOrderVi9.filter,orders=_ref4.purchaseOrderList.orders.filteredList,form=_ref4.form;return{order:order,rowsById:rowsById,extraRowsById:extraRowsById,allRowsByRoom:allRowsByRoom,additionalRows:additionalRows,allAdditionalRowsByRoom:allAdditionalRowsByRoom,customRows:customRows,rooms:rooms,additionalRow:additionalRow,additionalRowIsFetching:additionalRowIsFetching,additionalRowError:additionalRowError,linkedAdditionalRow:linkedAdditionalRow,linkedAdditionalRowIsFetching:linkedAdditionalRowIsFetching,linkedAdditionalRowError:linkedAdditionalRowError,products:products,productsAreFetching:productsAreFetching,variants:variants,variantsAreFetching:variantsAreFetching,error:error,isFetching:isFetching,additionalRowFormIsValid:(0,_reduxForm.isValid)('productRow')({form:form}),additionalRowFormValues:(0,_reduxForm.getFormValues)('productRow')({form:form}),linkedAdditionalRowFormIsValid:(0,_reduxForm.isValid)('linkedAdditionalRow')({form:form}),linkedAdditionalRowFormValues:(0,_reduxForm.getFormValues)('linkedAdditionalRow')({form:form}),noteRow:noteRow,noteRowError:noteRowError,noteRowIsFetching:noteRowIsFetching,noteRowIsExtra:noteRowIsExtra,noteRowFormIsValid:(0,_reduxForm.isValid)('noteRow')({form:form}),noteRowFormValues:(0,_reduxForm.getFormValues)('noteRow')({form:form}),reportDialogVisibility:reportDialogVisibility,suppliers:suppliers,reportFilter:reportFilter,orders:orders};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{updateOrder:function updateOrder(id,data){return dispatch((0,_purchaseOrderView.updateOrder)(id,data));},createAdditionalRow:function createAdditionalRow(orderId,data){return dispatch((0,_purchaseOrderView.createAdditionalRow)(orderId,data));},updateAdditionalRow:function updateAdditionalRow(id,data){return dispatch((0,_purchaseOrderView.updateAdditionalRow)(id,data));},removeAdditionalRow:function removeAdditionalRow(id){return dispatch((0,_purchaseOrderView.removeAdditionalRow)(id));},setAdditionalProductRow:function setAdditionalProductRow(additionalRow){return dispatch((0,_purchaseOrderView.setAdditionalProductRow)(additionalRow));},setLinkedAdditionalRow:function setLinkedAdditionalRow(row){return dispatch((0,_purchaseOrderView.setLinkedAdditionalRow)(row));},updateLinkedAdditionalRow:function updateLinkedAdditionalRow(id,data){return dispatch((0,_purchaseOrderView.updateLinkedAdditionalRow)(id,data));},removeLinkedAdditionalRow:function removeLinkedAdditionalRow(id){return dispatch((0,_purchaseOrderView.removeLinkedAdditionalRow)(id));},clear:function clear(){return dispatch((0,_purchaseOrderView.clear)());},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},fetchVariants:function fetchVariants(id){return dispatch((0,_purchaseOrderView.fetchVariants)(id));},fetchData:function fetchData(id){dispatch((0,_purchaseOrderView.fetchProducts)());if(id){dispatch((0,_purchaseOrderView.fetchOrderData)(id));}},setNoteRow:function setNoteRow(row,isExtra){return dispatch((0,_purchaseOrderView.setNoteRow)(row,isExtra));},updateOrderRow:function updateOrderRow(id,data){return dispatch((0,_purchaseOrderView.updateOrderRow)(id,data));},updateExtraRow:function updateExtraRow(id,data){return dispatch((0,_purchaseOrderView.updateExtraRow)(id,data));},toggleReportDialog:function toggleReportDialog(show/*: boolean*/){return dispatch((0,_purchaseOrderView.toggleReportDialog)(show));},updateReportFilter:function updateReportFilter(supplierId/*: ?number*/,includePlans/*: boolean*/){return dispatch((0,_purchaseOrderView.updateReportFilter)(supplierId,includePlans));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(OrderContainer);

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _sortBy2=__webpack_require__(43);var _sortBy3=_interopRequireDefault(_sortBy2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1318);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _reactTooltip=__webpack_require__(91);var _reactTooltip2=_interopRequireDefault(_reactTooltip);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}/*:: export type RowProps = {
  row: any,
  uniqueRowName: string,
  onSelect: Function,
  onRemove: Function,
  isLinked: boolean,
  rowsById: any,
  extraRowsById: any,
};*/var _ref2=_react2.default.createElement('i',{className:'fa fa-trash'});var _ref3=_react2.default.createElement('i',{className:'fa fa-comment-o'});var AdditionalRowListRow=function AdditionalRowListRow(_ref){var row=_ref.row,onSelect=_ref.onSelect,onRemove=_ref.onRemove,isLinked=_ref.isLinked,uniqueRowName=_ref.uniqueRowName,rowsById=_ref.rowsById,extraRowsById=_ref.extraRowsById;var hasNote=!!row.note;var linkedRow=isLinked?row.orderRowId?rowsById[row.orderRowId]:extraRowsById[row.extraOrderRowId]:null;return[_react2.default.createElement('tr',{key:uniqueRowName,onClick:function onClick(){return onSelect(row);},className:'AdditionalRowList-product-row'},_react2.default.createElement('td',{rowSpan:hasNote?2:1},isLinked&&linkedRow&&_react2.default.createElement('div',null,_react2.default.createElement(_reactTooltip2.default,{id:uniqueRowName,effect:'solid'},_react2.default.createElement('span',null,'Tillh\xF6r: (',linkedRow.productVariant.itemNumber,') ',linkedRow.product.name,' - ',linkedRow.productVariant.name)),_react2.default.createElement('i',{className:'fa fa-link','data-tip':true,'data-for':uniqueRowName}))),_react2.default.createElement('td',null,row.productVariant.itemNumber),_react2.default.createElement('td',{className:'AdditionalRowList-name'},row.product.name,' - ',row.productVariant.name),_react2.default.createElement('td',null,row.productVariant.externalItemNumber),_react2.default.createElement('td',null,row.quantity),_react2.default.createElement('td',{onClick:function onClick(e){return e.stopPropagation();}},_react2.default.createElement(_ActionConfirmation2.default,{id:uniqueRowName,className:'secondary AdditionalRowList-remove-button',message:'Vill du verkligen ta bort den h\xE4r raden?',action:function action(){return onRemove(row);}},_ref2)))].concat(_toConsumableArray(hasNote?[_react2.default.createElement('tr',{key:'row-comment-'+row.id,onClick:function onClick(){return onSelect(row);},className:'AdditionalRowList-comment'},_react2.default.createElement('td',{colSpan:'6'},_ref3,_react2.default.createElement('span',{className:'comment-text'},row.note)))]:[]));};/*:: export type Props = {
  allRowsByRoom: any[],
  rowsById: any,
  extraRowsById: any,
  onSelectRow: Function,
  onRemoveRow: Function,
  onSelectVariantRow: Function,
  onRemoveVariantRow: Function,
};*/var _ref5=_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null),_react2.default.createElement('th',null,'Artikelnr.'),_react2.default.createElement('th',null,'Namn'),_react2.default.createElement('th',null,'Ext. artikelnr.'),_react2.default.createElement('th',null,'Antal'),_react2.default.createElement('th',null)));var _ref6=_react2.default.createElement('div',{className:'callout secondary'},'Inga till\xE4ggsprodukter');var AdditionalRowList=function AdditionalRowList(_ref4){var allRowsByRoom=_ref4.allRowsByRoom,rowsById=_ref4.rowsById,extraRowsById=_ref4.extraRowsById,onSelectRow=_ref4.onSelectRow,onRemoveRow=_ref4.onRemoveRow,onSelectVariantRow=_ref4.onSelectVariantRow,onRemoveVariantRow=_ref4.onRemoveVariantRow;return _react2.default.createElement('div',{className:'AdditionalRowList'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('table',{className:'table'},_ref5,_react2.default.createElement('tbody',null,(0,_map3.default)(function(room){return[_react2.default.createElement('tr',{key:'room-'+room.id},_react2.default.createElement('td',{className:'AdditionalRowList-room',colSpan:'6'},room.name))].concat(_toConsumableArray((0,_flow3.default)((0,_sortBy3.default)(['productVariant.itemNumber','id']),(0,_map3.default)(function(row){return _react2.default.createElement(AdditionalRowListRow,{key:'linkedProductRows-'+row.id,uniqueRowName:'linkedProductRows-'+row.id,rowsById:rowsById,extraRowsById:extraRowsById,row:row,onSelect:onSelectVariantRow,onRemove:onRemoveVariantRow,isLinked:true});}))(room.linkedProductRows)),_toConsumableArray((0,_flow3.default)((0,_sortBy3.default)(['productVariant.itemNumber','id']),(0,_map3.default)(function(row){return _react2.default.createElement(AdditionalRowListRow,{key:'productRows-'+row.id,uniqueRowName:'productRows-'+row.id,rowsById:rowsById,extraRowsById:extraRowsById,row:row,onSelect:onSelectRow,onRemove:onRemoveRow,isLinked:false});}))(room.productRows)));},allRowsByRoom))),!allRowsByRoom.length&&_ref6)));};exports.default=AdditionalRowList;

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _get2=__webpack_require__(122);var _get3=_interopRequireDefault(_get2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);__webpack_require__(1320);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  products: any[],
};*/var _ref2=_react2.default.createElement('thead',null,_react2.default.createElement('tr',null,_react2.default.createElement('th',null,'Namn'),_react2.default.createElement('th',null,'Leverant\xF6r'),_react2.default.createElement('th',null,'Ext. artikelnr.'),_react2.default.createElement('th',null,'Antal')));var _ref3=_react2.default.createElement('div',{className:'callout secondary'},'Inga friprodukter');var OrderCustomProductList=function OrderCustomProductList(_ref){var products=_ref.products;return _react2.default.createElement('div',{className:'OrderCustomProductList'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('table',{className:'table'},_ref2,_react2.default.createElement('tbody',null,(0,_map3.default)(function(row){return _react2.default.createElement('tr',{key:row.id,className:'OrderCustomProductList-product-row'},_react2.default.createElement('td',{className:'ProductRowList-name'},row.name),_react2.default.createElement('td',{className:'OrderCustomProductList-supplier'},(0,_get3.default)('supplier.name',row)),_react2.default.createElement('td',null,row.externalItemNumber),_react2.default.createElement('td',null,row.quantity));},products))),!products.length&&_ref3)));};exports.default=OrderCustomProductList;

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _LinkedAdditionalRowForm=__webpack_require__(1322);var _LinkedAdditionalRowForm2=_interopRequireDefault(_LinkedAdditionalRowForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  linkedAdditionalRow: Object,
  validate: Function,
  isLoading: boolean,
  error: ?any,
  onSave: Function,
  onClose: Function,
};*/var LinkedAdditionalRowDialog=function LinkedAdditionalRowDialog(_ref){var linkedAdditionalRow=_ref.linkedAdditionalRow,validate=_ref.validate,isLoading=_ref.isLoading,error=_ref.error,onSave=_ref.onSave,onClose=_ref.onClose;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:onClose,className:'LinkedAdditionalRowDialog',show:true},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isLoading}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_LinkedAdditionalRowForm2.default,{initialValues:linkedAdditionalRow,validate:validate}),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onSave},'Uppdatera'),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onClose},'Avbryt')));};exports.default=LinkedAdditionalRowDialog;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _TextAreaFormInput=__webpack_require__(42);var _TextAreaFormInput2=_interopRequireDefault(_TextAreaFormInput);var _DecimalFormInput=__webpack_require__(70);var _DecimalFormInput2=_interopRequireDefault(_DecimalFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var _ref=_react2.default.createElement(_reduxForm.Field,{name:'quantity',label:'Antal',component:_DecimalFormInput2.default});var _ref2=_react2.default.createElement(_reduxForm.Field,{name:'note',label:'Anteckning',component:_TextAreaFormInput2.default});var LinkedAdditionalRowForm=function LinkedAdditionalRowForm(){return _react2.default.createElement('div',{className:'LinkedAdditionalRowForm'},_react2.default.createElement(_reduxForm.Field,{name:'product',label:'Produkt',disabled:true,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:[]}),_react2.default.createElement(_reduxForm.Field,{name:'productVariant',label:'Variant',disabled:true,deleteRemoves:false,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:[]}),_ref,_ref2);};exports.default=(0,_reduxForm.reduxForm)({form:'linkedAdditionalRow',enableReinitialize:true})(LinkedAdditionalRowForm);

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(10);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  project: Object,
  apartment: Object,
  user: Object,
};*/var _ref2=_react2.default.createElement('label',null,'Projekt');var _ref3=_react2.default.createElement('label',null,'L\xE4genhet');var _ref4=_react2.default.createElement('label',null,'Kund');var OrderRelationLinks=function OrderRelationLinks(_ref){var project=_ref.project,apartment=_ref.apartment,user=_ref.user;return _react2.default.createElement('div',{className:'OrderRelationLinks row'},_react2.default.createElement('div',{className:'column'},_ref2,_react2.default.createElement(_reactRouterDom.Link,{className:'entity-item',to:'/projects/'+project.id},project.name)),_react2.default.createElement('div',{className:'column'},_ref3,_react2.default.createElement(_reactRouterDom.Link,{className:'entity-item',to:'/apartments/'+apartment.id},apartment.objectId)),_react2.default.createElement('div',{className:'column'},_ref4,_react2.default.createElement(_reactRouterDom.Link,{className:'entity-item',to:'/users/'+user.id},user.person.name)));};exports.default=OrderRelationLinks;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _ModalDialog=__webpack_require__(39);var _ModalDialog2=_interopRequireDefault(_ModalDialog);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _PurchaseOrderReportContainer=__webpack_require__(178);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  onClose: Function,
  order: any,
  suppliers: any[],
  filter: {
    includePlans: boolean,
    supplierId: ?number,
  },
  updateFilter: Function,
};*/var _ref2=_react2.default.createElement('h4',null,'Ink\xF6psrapport');var PurchaseReportDialog=function PurchaseReportDialog(_ref){var onClose=_ref.onClose,order=_ref.order,suppliers=_ref.suppliers,filter=_ref.filter,updateFilter=_ref.updateFilter;return _react2.default.createElement('div',null,_react2.default.createElement(_ModalDialog2.default,{onClose:onClose,className:'PurchaseReportDialog',show:true},_ref2,_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:filter.supplierId,onBlur:_noop3.default,onChange:function onChange(supplier){return updateFilter(supplier?supplier.id:null,filter.includePlans);}},placeholder:'V\xE4lj leverant\xF6r',meta:{},valueKey:'id',labelKey:'name',multi:false,options:suppliers,clearable:true}))),_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.includePlans,onBlur:_noop3.default,onChange:function onChange(includePlans){return updateFilter(filter.supplierId,includePlans?includePlans.value:false);}},label:'Inkludera ritningar',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),_react2.default.createElement('a',{href:(0,_PurchaseOrderReportContainer.getUrl)(order.apartment.projectId,order.apartmentId,filter.supplierId,true,filter.includePlans),onClick:function onClick(){onClose();return true;},target:'_blank',className:'expanded button success'},'Ladda ner'),_react2.default.createElement('button',{type:'button',className:'expanded button',onClick:onClose},'St\xE4ng')));};exports.default=PurchaseReportDialog;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _tableHelpers=__webpack_require__(484);var _purchaseOrderList=__webpack_require__(401);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var purchasedFilter=[{label:'Väntar på inköp',value:false},{label:'Inköp klart',value:true}];var columns=[{property:'apartment.project.name',header:{label:'Projekt'}},{property:'apartment.objectId',header:{label:'Lägenhet'}},{property:'user.person.name',header:{label:'Kund'}},{property:'totalPrice',header:{label:'Värde'}},{property:'state',header:{label:'Status'},cell:{formatters:[_tableHelpers.formatOrderState]}}];/*:: export type Props = {
  history: Object,
  error?: any,
  fetchOrders: Function,
  filters: Object,
  filterByProjectId: Function,
  filterByQuery: Function,
  filterByPurchased: Function,
  isFetching: boolean,
  orders: any[],
  location: { pathname: string },
  projects: any[],
  sortItems: typeof sortItems,
};*/var PurchaseOrdersContainer=function(_Component){_inherits(PurchaseOrdersContainer,_Component);function PurchaseOrdersContainer(){_classCallCheck(this,PurchaseOrdersContainer);return _possibleConstructorReturn(this,(PurchaseOrdersContainer.__proto__||Object.getPrototypeOf(PurchaseOrdersContainer)).apply(this,arguments));}_createClass(PurchaseOrdersContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchOrders();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,error=_props.error,filters=_props.filters,isFetching=_props.isFetching,orders=_props.orders,pathname=_props.location.pathname,projects=_props.projects,filterByProjectId=_props.filterByProjectId,filterByQuery=_props.filterByQuery,filterByPurchased=_props.filterByPurchased,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'OrdersContainer relative'},_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filters.query||'',onClear:function onClear(e){return filterByQuery('');},onChange:function onChange(e){return filterByQuery(e.target.value);}}))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},projects&&_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:filters.projectId||null,onBlur:_noop3.default,onChange:function onChange(project){return filterByProjectId(project?project.id:null);}},label:'Projekt',meta:{},valueKey:'id',labelKey:'name',clearable:true,options:projects,placeholder:'Alla'})),_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:filters.isPurchased,onBlur:_noop3.default,onChange:function onChange(purchased){return filterByPurchased(purchased?purchased.value:false);}},label:'Status',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:purchasedFilter}))),orders&&_react2.default.createElement(_AdminList2.default,{query:filters.query,columns:columns,rows:orders,onSort:sortItems,onRowSelected:function onRowSelected(row){return history.push(pathname+'/'+row.id);}})));}}]);return PurchaseOrdersContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$purchaseOrderLis=_ref.purchaseOrderList,error=_ref$purchaseOrderLis.error,isFetching=_ref$purchaseOrderLis.isFetching,_ref$purchaseOrderLis2=_ref$purchaseOrderLis.orders,orders=_ref$purchaseOrderLis2.filteredList,filters=_ref$purchaseOrderLis2.filters,projects=_ref$purchaseOrderLis.projects;return{error:error,isFetching:isFetching,orders:orders,projects:projects,filters:filters};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchOrders:function fetchOrders(){return dispatch((0,_purchaseOrderList.fetchOrders)());},filterByQuery:function filterByQuery(query){return dispatch((0,_purchaseOrderList.filterByQuery)(query));},filterByProjectId:function filterByProjectId(projectId){return dispatch((0,_purchaseOrderList.filterByProjectId)(projectId));},filterByPurchased:function filterByPurchased(purchased){return dispatch((0,_purchaseOrderList.filterByPurchased)(purchased));},sortItems:function sortItems(sorter){return dispatch((0,_purchaseOrderList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(PurchaseOrdersContainer));

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _configTemplateList=__webpack_require__(403);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var columns=[{property:'name',header:{label:'Namn'}},{property:'rooms.length',header:{label:'Rum'}},{property:'slots',header:{label:'Produktplatser'}}];/*:: export type Props = {
  history: Object,
  configTemplates: any[],
  error: ?any,
  fetchConfigTemplates: Function,
  filter: {
    archived: boolean,
    query?: string,
  },
  filterConfigTemplates: Function,
  isFetching: boolean,
  location: { pathname: string },
  sortItems: typeof sortItems,
};*/var ConfigTemplatesContainer=function(_Component){_inherits(ConfigTemplatesContainer,_Component);function ConfigTemplatesContainer(){_classCallCheck(this,ConfigTemplatesContainer);return _possibleConstructorReturn(this,(ConfigTemplatesContainer.__proto__||Object.getPrototypeOf(ConfigTemplatesContainer)).apply(this,arguments));}_createClass(ConfigTemplatesContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchConfigTemplates();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,configTemplates=_props.configTemplates,error=_props.error,filter=_props.filter,filterConfigTemplates=_props.filterConfigTemplates,isFetching=_props.isFetching,pathname=_props.location.pathname,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'ConfigTemplatesContainer relative'},_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:function onClear(e){return filterConfigTemplates('',filter.archived);},onChange:function onChange(e){return filterConfigTemplates(e.target.value,filter.archived);}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa ny'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:function onChange(archived){return filterConfigTemplates(filter.query,archived?archived.value:false);}},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),configTemplates&&_react2.default.createElement(_AdminList2.default,{query:filter.query,columns:columns,rows:configTemplates,onSort:sortItems,onRowSelected:function onRowSelected(row){return history.push(pathname+'/'+row.id);}})));}}]);return ConfigTemplatesContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$configTemplateLi=_ref.configTemplateList,error=_ref$configTemplateLi.error,filter=_ref$configTemplateLi.filter,isFetching=_ref$configTemplateLi.isFetching,configTemplates=_ref$configTemplateLi.filteredList;return{configTemplates:configTemplates,error:error,filter:filter,isFetching:isFetching};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchConfigTemplates:function fetchConfigTemplates(){return dispatch((0,_configTemplateList.fetchConfigTemplates)());},filterConfigTemplates:function filterConfigTemplates(query,archived){return dispatch((0,_configTemplateList.filterConfigTemplates)(query,archived));},sortItems:function sortItems(sorter){return dispatch((0,_configTemplateList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ConfigTemplatesContainer));

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _find2=__webpack_require__(20);var _find3=_interopRequireDefault(_find2);var _findIndex2=__webpack_require__(99);var _findIndex3=_interopRequireDefault(_findIndex2);var _pick2=__webpack_require__(86);var _pick3=_interopRequireDefault(_pick2);var _toNumber2=__webpack_require__(84);var _toNumber3=_interopRequireDefault(_toNumber2);var _toPairs2=__webpack_require__(259);var _toPairs3=_interopRequireDefault(_toPairs2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _values2=__webpack_require__(67);var _values3=_interopRequireDefault(_values2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _reduxForm=__webpack_require__(4);var _configTemplateView=__webpack_require__(394);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);var _ConfigTemplateForm=__webpack_require__(1328);var _ConfigTemplateForm2=_interopRequireDefault(_ConfigTemplateForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _Rooms=__webpack_require__(462);var _Rooms2=_interopRequireDefault(_Rooms);var _ConfigTemplateRoomForm=__webpack_require__(1329);var _ConfigTemplateRoomForm2=_interopRequireDefault(_ConfigTemplateRoomForm);var _ConfigTemplateProductSlotForm=__webpack_require__(1330);var _ConfigTemplateProductSlotForm2=_interopRequireDefault(_ConfigTemplateProductSlotForm);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);__webpack_require__(1331);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: import type {
  ModifiedState,
  NavigationState,
  State_ as ConfigTemplateViewState,
} from '../../reducers/configTemplateView';*//*:: import type {
  ConfigTemplateDto,
  ErrorDto,
  LimitedProjectDto,
  ProductDto,
  ProductSlotDto,
  ProductTypeDto,
  RoomDto,
  RoomTemplateDto,
  RoomTypeDto,
} from '../../dtos';*/var configTemplateValidation={name:{rule:'string|required',label:'Namn'}};var basedOnConfigValidation={basedOnConfigId:{rule:'numeric|required',label:'Lägenhetskonfiguration'}};var basedOnTemplateValidation={basedOnTemplateId:{rule:'numeric|required',label:'Konfigurationsmall'}};var getBasedOnValidation=function getBasedOnValidation(values){return values&&values.rooms==='CONFIG'?basedOnConfigValidation:values&&values.rooms==='TEMPLATE'?basedOnTemplateValidation:{};};var getConfigTemplateValidation=function getConfigTemplateValidation(values){return _extends({},configTemplateValidation,getBasedOnValidation(values));};var roomValidation={name:{rule:'string|required',label:'Namn'}};var basicRoomValidation={roomTypeId:{rule:'numeric|required',label:'Rumstyp'}};var basedOnRoomValidation={basedOnRoomId:{rule:'numeric|required',label:'Rum'}};var basedOnRoomTemplateValidation={basedOnTemplateId:{rule:'numeric|required',label:'Rumsmall'}};var getRoomBasedOnValidation=function getRoomBasedOnValidation(values){return values&&values.slots==='ROOM'?basedOnRoomValidation:values&&values.slots==='TEMPLATE'?basedOnRoomTemplateValidation:basicRoomValidation;};var getRoomValidation=function getRoomValidation(values){return _extends({},roomValidation,getRoomBasedOnValidation(values));};var productSlotValidation={name:{rule:'string|required',label:'Namn'},productTypeId:{rule:'numeric|required',label:'Produkttyp'},unit:{rule:'string',label:'Enhet'},quantity:{rule:'numeric|min:0',label:'Antal'}};/*:: export type Props = {
  setDirty: typeof setDirty,
  reset: typeof reset,
  resetForm: typeof resetForm,
  isConfigTemplateDirty: boolean,
  isProductSlotDirty: boolean,
  isRoomDirty: boolean,
  clear: typeof clear,
  configTemplate: ?ConfigTemplateDto,
  configTemplateFormIsValid: boolean,
  configTemplateFormValues: any,
  createConfigTemplate: typeof createConfigTemplate,
  createProductSlot: typeof createProductSlot,
  createRoom: typeof createRoom,
  error: ?ErrorDto,
  fetchData: typeof fetchData,
  isFetching: boolean,
  params: any,
  prevPath: string,
  products: ?ProductDto[],
  productSlot: ?ProductSlotDto,
  productSlotError: ?ErrorDto,
  productSlotFormIsValid: boolean,
  productSlotFormValues: any,
  productSlotIsFetching: boolean,
  productSlotRoomId: ?number,
  productTypes: ?ProductTypeDto[],
  room: ?RoomDto,
  roomError: ?ErrorDto,
  roomFormIsValid: boolean,
  roomFormValues: any,
  roomIsFetching: boolean,
  rooms: RoomDto[],
  roomTypes: ?RoomTypeDto[],
  selectProductSlot: typeof selectProductSlot,
  selectRoom: typeof selectRoom,
  touch: typeof touch,
  updateConfigTemplate: typeof updateConfigTemplate,
  updateProductSlot: typeof updateProductSlot,
  updateRoom: typeof updateRoom,
  openDialog: typeof openDialog,
  closeDialog: typeof closeDialog,
  dialogError: ?ErrorDto,
  dialogIsFetching: boolean,
  showDialog: boolean,
  navigateToVariant: typeof navigateToVariant,
  popDialogNavigation: typeof popDialogNavigation,
  dialogNavigation: ?NavigationState,
  updateRelatedVariant: typeof updateRelatedVariant,
  toggleVariant: typeof toggleVariant,
  setStandardProduct: typeof setStandardProduct,
  modifiedData: ModifiedState,
  standardProductId: ?number,
  toggleProduct: typeof toggleProduct,
  sharedChecked: ?boolean,
  checkAllVariants: typeof checkAllVariants,
  clearStandardProduct: typeof clearStandardProduct,
  checkProduct: typeof checkProduct,
  updateVariants: typeof updateVariants,
  updateRooms: typeof updateRooms,
  updateProductSlots: typeof updateProductSlots,
  updateVariantsForType: typeof updateVariantsForType,
  configTemplates: any[],
  projects: LimitedProjectDto[],
  roomTemplates: RoomTemplateDto[],
  configTemplateList: ConfigTemplateDto[],
};*/var ConfigTemplateContainer=function(_Component){_inherits(ConfigTemplateContainer,_Component);function ConfigTemplateContainer(){_classCallCheck(this,ConfigTemplateContainer);return _possibleConstructorReturn(this,(ConfigTemplateContainer.__proto__||Object.getPrototypeOf(ConfigTemplateContainer)).apply(this,arguments));}_createClass(ConfigTemplateContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData(this.props.params.id);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clear();}},{key:'setDirty',value:function setDirty(form/*: 'configTemplate' | 'configTemplateRoom' | 'configTemplateProductSlot'*/){var _props=this.props,setDirty=_props.setDirty,isConfigTemplateDirty=_props.isConfigTemplateDirty,isRoomDirty=_props.isRoomDirty,isProductSlotDirty=_props.isProductSlotDirty;if(form==='configTemplate'){if(isConfigTemplateDirty){return;}}else if(form==='configTemplateRoom'){if(isRoomDirty){return;}}else if(form==='configTemplateProductSlot'){if(isProductSlotDirty){return;}}else{return;}setDirty(true,form);}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('configTemplate');resetForm('configTemplateRoom');resetForm('configTemplateProductSlot');setDirty(false,'configTemplate');setDirty(false,'configTemplateRoom');setDirty(false,'configTemplateProductSlot');}},{key:'validateRoomForm',value:function validateRoomForm(){var _props3=this.props,roomFormIsValid=_props3.roomFormIsValid,roomFormValues=_props3.roomFormValues,touch=_props3.touch;var roomFields=(0,_keys3.default)(getRoomValidation(roomFormValues));touch.apply(undefined,['configTemplateRoom'].concat(_toConsumableArray(roomFields)));return roomFormIsValid;}},{key:'validateProductSlotForm',value:function validateProductSlotForm(){var _props4=this.props,productSlotFormIsValid=_props4.productSlotFormIsValid,touch=_props4.touch;var productSlotFields=(0,_keys3.default)(productSlotValidation);touch.apply(undefined,['configTemplateProductSlot'].concat(_toConsumableArray(productSlotFields)));return productSlotFormIsValid;}},{key:'save',value:function save(){var _props5=this.props,configTemplate=_props5.configTemplate,configTemplateFormIsValid=_props5.configTemplateFormIsValid,configTemplateFormValues=_props5.configTemplateFormValues,createConfigTemplate=_props5.createConfigTemplate,createProductSlot=_props5.createProductSlot,createRoom=_props5.createRoom,productSlot=_props5.productSlot,productSlotFormValues=_props5.productSlotFormValues,productSlotRoomId=_props5.productSlotRoomId,room=_props5.room,roomFormValues=_props5.roomFormValues,touch=_props5.touch,updateConfigTemplate=_props5.updateConfigTemplate,updateProductSlot=_props5.updateProductSlot,updateRoom=_props5.updateRoom,modifiedData=_props5.modifiedData,standardProductId=_props5.standardProductId,closeDialog=_props5.closeDialog;var configTemplateFields=(0,_keys3.default)(!configTemplate?getConfigTemplateValidation(configTemplateFormValues):configTemplateValidation);touch.apply(undefined,['configTemplate'].concat(_toConsumableArray(configTemplateFields)));if(!configTemplateFormIsValid){return;}closeDialog();if(room){if(!this.validateRoomForm()){return;}if(room.id){updateRoom(room.id,roomFormValues);}else if(!!configTemplate){createRoom(configTemplate.id,roomFormValues);}}if(productSlot){if(!this.validateProductSlotForm()){return;}if(productSlot.id){updateProductSlot(productSlot.id,_extends({},productSlotFormValues,{standardProductId:standardProductId,config:(0,_flow3.default)(_values3.default,(0,_filter3.default)('checked'),(0,_map3.default)(function(c){return _extends({},c,{standardProducts:(0,_flow3.default)(_toPairs3.default,(0,_map3.default)(function(_ref){var _ref2=_slicedToArray(_ref,2),productTypeId=_ref2[0],productId=_ref2[1];return{productId:productId,productTypeId:(0,_toNumber3.default)(productTypeId)};}),(0,_filter3.default)(function(x){return!!x.productId;}))(c.standardProducts)});}))(modifiedData)}));}else if(!!productSlotRoomId){createProductSlot(productSlotRoomId,productSlotFormValues);}}if(!configTemplate){createConfigTemplate((0,_pick3.default)(configTemplateFields,configTemplateFormValues));}else{updateConfigTemplate(configTemplate.id,configTemplateFormValues);}}},{key:'render',value:function render(){var _this2=this;var _props6=this.props,isConfigTemplateDirty=_props6.isConfigTemplateDirty,isRoomDirty=_props6.isRoomDirty,isProductSlotDirty=_props6.isProductSlotDirty,configTemplate=_props6.configTemplate,error=_props6.error,isFetching=_props6.isFetching,id=_props6.params.id,prevPath=_props6.prevPath,products=_props6.products,productSlot=_props6.productSlot,productSlotError=_props6.productSlotError,productSlotFormValues=_props6.productSlotFormValues,productSlotIsFetching=_props6.productSlotIsFetching,productSlotRoomId=_props6.productSlotRoomId,productTypes=_props6.productTypes,room=_props6.room,roomError=_props6.roomError,roomIsFetching=_props6.roomIsFetching,rooms=_props6.rooms,roomTypes=_props6.roomTypes,selectProductSlot=_props6.selectProductSlot,selectRoom=_props6.selectRoom,updateConfigTemplate=_props6.updateConfigTemplate,updateProductSlot=_props6.updateProductSlot,updateRoom=_props6.updateRoom,openDialog=_props6.openDialog,closeDialog=_props6.closeDialog,dialogError=_props6.dialogError,dialogIsFetching=_props6.dialogIsFetching,showDialog=_props6.showDialog,navigateToVariant=_props6.navigateToVariant,popDialogNavigation=_props6.popDialogNavigation,dialogNavigation=_props6.dialogNavigation,updateRelatedVariant=_props6.updateRelatedVariant,toggleVariant=_props6.toggleVariant,setStandardProduct=_props6.setStandardProduct,modifiedData=_props6.modifiedData,toggleProduct=_props6.toggleProduct,sharedChecked=_props6.sharedChecked,checkAllVariants=_props6.checkAllVariants,clearStandardProduct=_props6.clearStandardProduct,checkProduct=_props6.checkProduct,updateVariants=_props6.updateVariants,_updateRooms=_props6.updateRooms,_updateProductSlots=_props6.updateProductSlots,updateVariantsForType=_props6.updateVariantsForType,configTemplateFormValues=_props6.configTemplateFormValues,configTemplates=_props6.configTemplates,projects=_props6.projects,roomTemplates=_props6.roomTemplates,roomFormValues=_props6.roomFormValues,configTemplateList=_props6.configTemplateList,clear=_props6.clear,fetchData=_props6.fetchData;var _ref3=_react2.default.createElement(_ServerError2.default,{error:roomError});var _ref4=_react2.default.createElement(_ServerError2.default,{error:productSlotError});return _react2.default.createElement('div',{className:'ConfigTemplateContainer relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:configTemplate,list:configTemplateList,prevPath:prevPath,clear:clear,fetchData:fetchData}),_react2.default.createElement('div',{className:'content-title'},configTemplate&&configTemplate.name||'Ny konfiguration'))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},configTemplate&&_react2.default.createElement(_DisableContent2.default,{disabled:isConfigTemplateDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveConfigTemplate',className:'secondary button',message:'Vill du verkligen '+(configTemplate.archived?'av':'')+'arkivera den h\xE4r konfigurationen?',buttonText:configTemplate.archived?'Avarkivera':'Arkivera',action:function action(){return updateConfigTemplate(configTemplate.id,{archived:!configTemplate.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching||roomIsFetching||productSlotIsFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_ConfigTemplateForm2.default,{initialValues:configTemplate||{rooms:'NONE'},configTemplate:configTemplate,configTemplates:configTemplates,projects:projects,formValues:configTemplateFormValues,onUserChange:function onUserChange(){return _this2.setDirty('configTemplate');},validate:function validate(values){return(0,_validator2.default)(getConfigTemplateValidation(values),values);}})),configTemplate&&configTemplate.id&&_react2.default.createElement('div',{className:'content-section rooms-section'},_react2.default.createElement('div',{className:'row no-row-margins'},_react2.default.createElement('div',{className:'box-side-tabs shrink'},_react2.default.createElement(_DisableContent2.default,{disabled:isRoomDirty||isProductSlotDirty},_react2.default.createElement(_Rooms2.default,{onSelectRoom:function onSelectRoom(r){return selectRoom(r);},onSelectProductSlot:function onSelectProductSlot(roomId,p){return selectProductSlot(roomId,p);},onAddRoom:function onAddRoom(){return selectRoom(null);},onAddProductSlot:function onAddProductSlot(roomId){return selectProductSlot(roomId,null);},selectedRoom:room,selectedProductSlot:productSlot,selectedProductSlotRoomId:productSlotRoomId,rooms:(0,_filter3.default)({archived:null},rooms)}))),_react2.default.createElement('div',{className:'box expand'},room&&!productSlot&&function(){var roomIndex=(0,_findIndex3.default)({id:room.id},rooms);return _react2.default.createElement('div',null,_ref3,_react2.default.createElement(_ConfigTemplateRoomForm2.default,{roomTemplates:roomTemplates,projects:projects,formValues:roomFormValues,initialValues:!!room.id?room:{slots:'NONE'},room:room,onArchive:function onArchive(){return updateRoom(room.id,{archived:!room.archived});},roomTypes:roomTypes,onUserChange:function onUserChange(){return _this2.setDirty('configTemplateRoom');},validate:function validate(values){return(0,_validator2.default)(getRoomValidation(values),values);},isDirty:isRoomDirty,updateRooms:function updateRooms(sortDirection/*: 'up' | 'down'*/){return _updateRooms(configTemplate.id,room.id,sortDirection);},sortDownDisabled:roomIndex===rooms.length-1,sortUpDisabled:roomIndex<=0}));}(),productSlot&&!room&&function(){var slotRoom=(0,_find3.default)({id:productSlotRoomId},rooms);var allSlots=!!slotRoom?slotRoom.productSlots:[];var slotIndex=(0,_findIndex3.default)({id:productSlot.id},allSlots);return _react2.default.createElement('div',null,_ref4,_react2.default.createElement(_ConfigTemplateProductSlotForm2.default,{initialValues:productSlot,formValues:productSlotFormValues,productSlot:productSlot,productTypes:productTypes,room:(0,_find3.default)({id:productSlotRoomId},rooms),products:products,onArchive:function onArchive(){return updateProductSlot(productSlot.id,{archived:!productSlot.archived});},onUserChange:function onUserChange(){return _this2.setDirty('configTemplateProductSlot');},validate:function validate(values){return(0,_validator2.default)(productSlotValidation,values);},openDialog:openDialog,closeDialog:closeDialog,dialogError:dialogError,dialogIsFetching:dialogIsFetching,dialogNavigation:dialogNavigation,showDialog:showDialog,navigateToVariant:navigateToVariant,popDialogNavigation:popDialogNavigation,updateRelatedVariant:updateRelatedVariant,toggleVariant:toggleVariant,setStandardProduct:setStandardProduct,modifiedData:modifiedData,toggleProduct:toggleProduct,sharedChecked:sharedChecked,checkAllVariants:checkAllVariants,clearStandardProduct:clearStandardProduct,isDirty:isProductSlotDirty,checkProduct:checkProduct,updateVariants:updateVariants,updateVariantsForType:updateVariantsForType,updateProductSlots:function updateProductSlots(sortDirection/*: 'up' | 'down'*/){if(!!slotRoom){_updateProductSlots(slotRoom.id,productSlot.id,sortDirection);}},sortDownDisabled:isProductSlotDirty||slotIndex===allSlots.length-1,sortUpDisabled:isProductSlotDirty||slotIndex<=0}));}()))),configTemplate&&configTemplate.id!==(0,_toNumber3.default)(id)&&_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath+'/'+configTemplate.id}),(isConfigTemplateDirty||isRoomDirty||isProductSlotDirty)&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return ConfigTemplateContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref5){var _ref5$configTemplateV=_ref5.configTemplateView,_ref5$configTemplateV2=_ref5$configTemplateV.configTemplate,configTemplate=_ref5$configTemplateV2.active,error=_ref5$configTemplateV2.error,isConfigTemplateDirty=_ref5$configTemplateV2.isDirty,isFetching=_ref5$configTemplateV2.isFetching,rooms=_ref5$configTemplateV.rooms,_ref5$configTemplateV3=_ref5$configTemplateV.room,room=_ref5$configTemplateV3.active,roomError=_ref5$configTemplateV3.error,isRoomDirty=_ref5$configTemplateV3.isDirty,roomIsFetching=_ref5$configTemplateV3.isFetching,_ref5$configTemplateV4=_ref5$configTemplateV.productSlot,productSlot=_ref5$configTemplateV4.active,productSlotRoomId=_ref5$configTemplateV4.roomId,productSlotError=_ref5$configTemplateV4.error,isProductSlotDirty=_ref5$configTemplateV4.isDirty,productSlotIsFetching=_ref5$configTemplateV4.isFetching,_ref5$configTemplateV5=_ref5$configTemplateV4.dialog,dialogError=_ref5$configTemplateV5.error,dialogIsFetching=_ref5$configTemplateV5.isFetching,showDialog=_ref5$configTemplateV5.show,dialogNavigation=_ref5$configTemplateV5.navigation,modifiedData=_ref5$configTemplateV5.modifiedData,standardProductId=_ref5$configTemplateV5.standardProductId,sharedChecked=_ref5$configTemplateV5.sharedChecked,roomTypes=_ref5$configTemplateV.roomTypes,productTypes=_ref5$configTemplateV.productTypes,products=_ref5$configTemplateV.products,configTemplates=_ref5$configTemplateV.configTemplates,projects=_ref5$configTemplateV.projects,roomTemplates=_ref5$configTemplateV.roomTemplates,configTemplateList=_ref5.configTemplateList.filteredList,form=_ref5.form;return{configTemplate:configTemplate,rooms:rooms,room:room,roomError:roomError,roomIsFetching:roomIsFetching,productSlot:productSlot,productSlotRoomId:productSlotRoomId,productSlotError:productSlotError,productSlotIsFetching:productSlotIsFetching,error:error,isConfigTemplateDirty:isConfigTemplateDirty,isRoomDirty:isRoomDirty,isProductSlotDirty:isProductSlotDirty,isFetching:isFetching,roomTypes:roomTypes,productTypes:productTypes,products:products,configTemplateFormIsValid:(0,_reduxForm.isValid)('configTemplate')({form:form}),configTemplateFormValues:(0,_reduxForm.getFormValues)('configTemplate')({form:form}),roomFormIsValid:(0,_reduxForm.isValid)('configTemplateRoom')({form:form}),roomFormValues:(0,_reduxForm.getFormValues)('configTemplateRoom')({form:form}),productSlotFormIsValid:(0,_reduxForm.isValid)('configTemplateProductSlot')({form:form}),productSlotFormValues:(0,_reduxForm.getFormValues)('configTemplateProductSlot')({form:form}),dialogError:dialogError,dialogIsFetching:dialogIsFetching,showDialog:showDialog,dialogNavigation:dialogNavigation,modifiedData:modifiedData,standardProductId:standardProductId,sharedChecked:sharedChecked,configTemplates:configTemplates,projects:projects,roomTemplates:roomTemplates,configTemplateList:configTemplateList};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty,form){return dispatch((0,_form.setDirty)(dirty,form));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_configTemplateView.reset)());},fetchData:function fetchData(id){return dispatch((0,_configTemplateView.fetchData)(id));},updateConfigTemplate:function updateConfigTemplate(id,data){return dispatch((0,_configTemplateView.updateConfigTemplate)(id,data));},createConfigTemplate:function createConfigTemplate(data){return dispatch((0,_configTemplateView.createConfigTemplate)(data));},updateRoom:function updateRoom(id,data){return dispatch((0,_configTemplateView.updateRoom)(id,data));},createRoom:function createRoom(configId,data){return dispatch((0,_configTemplateView.createRoom)(configId,data));},updateProductSlot:function updateProductSlot(id,data){return dispatch((0,_configTemplateView.updateProductSlot)(id,data));},createProductSlot:function createProductSlot(roomId,data){return dispatch((0,_configTemplateView.createProductSlot)(roomId,data));},selectRoom:function selectRoom(room){return dispatch((0,_configTemplateView.selectRoom)(room));},selectProductSlot:function selectProductSlot(roomId,productSlot){return dispatch((0,_configTemplateView.selectProductSlot)(roomId,productSlot));},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},clear:function clear(){return dispatch((0,_configTemplateView.clear)());},openDialog:function openDialog(productTypeId,rootName){return dispatch((0,_configTemplateView.openDialog)(productTypeId,rootName));},closeDialog:function closeDialog(){return dispatch((0,_configTemplateView.closeDialog)());},navigateToVariant:function navigateToVariant(variant){return dispatch((0,_configTemplateView.navigateToVariant)(variant));},popDialogNavigation:function popDialogNavigation(depth){return dispatch((0,_configTemplateView.popDialogNavigation)(depth));},updateRelatedVariant:function updateRelatedVariant(variant,data){return dispatch((0,_configTemplateView.updateRelatedVariant)(variant,data));},toggleVariant:function toggleVariant(variant,expand){return dispatch((0,_configTemplateView.toggleVariant)(variant,expand));},setStandardProduct:function setStandardProduct(product,productType){return dispatch((0,_configTemplateView.setStandardProduct)(product,productType));},toggleProduct:function toggleProduct(product){return dispatch((0,_configTemplateView.toggleProduct)(product));},checkAllVariants:function checkAllVariants(checked){return dispatch((0,_configTemplateView.checkAllVariants)(checked));},clearStandardProduct:function clearStandardProduct(productType){return dispatch((0,_configTemplateView.clearStandardProduct)(productType));},checkProduct:function checkProduct(productId,checked){return dispatch((0,_configTemplateView.checkProduct)(productId,checked));},updateVariants:function updateVariants(productId,data){return dispatch((0,_configTemplateView.updateVariants)(productId,data));},updateRooms:function updateRooms(configId,roomId,sortDirection/*: 'up' | 'down'*/){return dispatch((0,_configTemplateView.updateRooms)(configId,roomId,sortDirection));},updateProductSlots:function updateProductSlots(roomId,productSlotId,sortDirection/*: 'up' | 'down'*/){return dispatch((0,_configTemplateView.updateProductSlots)(roomId,productSlotId,sortDirection));},updateVariantsForType:function updateVariantsForType(productTypeId,data){return dispatch((0,_configTemplateView.updateVariantsForType)(productTypeId,data));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ConfigTemplateContainer);

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {
  ConfigTemplateDto,
  LimitedProjectDto,
} from '../../dtos';*//*:: export type Props = {
  configTemplate: ?any,
  projects: LimitedProjectDto[],
  configTemplates: ConfigTemplateDto[],
  formValues: any,
  onUserChange: Function,
};*/var _ref2=_react2.default.createElement('label',null,'Rum');var _ref3=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'rooms',component:'input',type:'radio',value:'NONE'}),' L\xE4gg till manuellt');var _ref4=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'rooms',component:'input',type:'radio',value:'CONFIG'}),' Kopiera fr\xE5n konfiguration');var _ref5=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'rooms',component:'input',type:'radio',value:'TEMPLATE'}),' Basera p\xE5 mall');var ConfigTemplateForm=function ConfigTemplateForm(_ref){var configTemplate=_ref.configTemplate,projects=_ref.projects,configTemplates=_ref.configTemplates,formValues=_ref.formValues,onUserChange=_ref.onUserChange;return _react2.default.createElement('div',{className:'ConfigTemplateForm'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),(!configTemplate||!configTemplate.id)&&_react2.default.createElement('div',{onChange:onUserChange},_ref2,_ref3,_ref4,_react2.default.createElement(_reduxForm.Field,{name:'project',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value:null;},disabled:!formValues||formValues.rooms!=='CONFIG',placeholder:'V\xE4lj projekt',valueKey:'id',labelKey:'name',options:projects}),_react2.default.createElement(_reduxForm.Field,{name:'basedOnConfigId',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value.id:null;},disabled:!formValues||formValues.rooms!=='CONFIG'||!formValues.project,placeholder:'V\xE4lj konfiguration',valueKey:'id',labelKey:'name',options:!!formValues&&!!formValues.project?formValues.project.apartmentConfigs:[]}),_ref5,_react2.default.createElement(_reduxForm.Field,{name:'basedOnTemplateId',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value.id:null;},disabled:!formValues||formValues.rooms!=='TEMPLATE',placeholder:'V\xE4lj mall',valueKey:'id',labelKey:'name',options:configTemplates})))));};exports.default=(0,_reduxForm.reduxForm)({form:'configTemplate',enableReinitialize:true})(ConfigTemplateForm);

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reduxForm=__webpack_require__(4);var _RoomForm=__webpack_require__(463);var _RoomForm2=_interopRequireDefault(_RoomForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_reduxForm.reduxForm)({form:'configTemplateRoom',enableReinitialize:true})(_RoomForm2.default);

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reduxForm=__webpack_require__(4);var _ProductSlotForm=__webpack_require__(260);var _ProductSlotForm2=_interopRequireDefault(_ProductSlotForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_reduxForm.reduxForm)({form:'configTemplateProductSlot',enableReinitialize:true})(_ProductSlotForm2.default);

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _noop2=__webpack_require__(22);var _noop3=_interopRequireDefault(_noop2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _AdminList=__webpack_require__(35);var _AdminList2=_interopRequireDefault(_AdminList);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _SearchField=__webpack_require__(44);var _SearchField2=_interopRequireDefault(_SearchField);var _roomTemplateList=__webpack_require__(412);var _booleanValues=__webpack_require__(41);var _booleanValues2=_interopRequireDefault(_booleanValues);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: import type {
  FilterState as RoomTemplateFilterState,
  State_ as RoomTemplateListState,
} from '../../reducers/roomTemplateList';*/var columns=[{property:'name',header:{label:'Namn'}},{property:'productSlots.length',header:{label:'Produktplatser'}}];/*:: export type Props = {
  history: Object,
  roomTemplates: any[],
  error: ?any,
  fetchRoomTemplates: Function,
  filter: RoomTemplateFilterState,
  filterRoomTemplates: Function,
  isFetching: boolean,
  location: { pathname: string },
  sortItems: typeof sortItems,
};*/var RoomTemplatesContainer=function(_Component){_inherits(RoomTemplatesContainer,_Component);function RoomTemplatesContainer(){_classCallCheck(this,RoomTemplatesContainer);return _possibleConstructorReturn(this,(RoomTemplatesContainer.__proto__||Object.getPrototypeOf(RoomTemplatesContainer)).apply(this,arguments));}_createClass(RoomTemplatesContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchRoomTemplates();}},{key:'render',value:function render(){var _props=this.props,history=_props.history,roomTemplates=_props.roomTemplates,error=_props.error,filter=_props.filter,filterRoomTemplates=_props.filterRoomTemplates,isFetching=_props.isFetching,pathname=_props.location.pathname,sortItems=_props.sortItems;return _react2.default.createElement('div',{className:'RoomTemplatesContainer relative'},_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}),_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SearchField2.default,{value:filter.query||'',onClear:function onClear(e){return filterRoomTemplates('',filter.archived);},onChange:function onChange(e){return filterRoomTemplates(e.target.value,filter.archived);}})),_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('button',{type:'button',className:'primary button',onClick:function onClick(){return history.push(pathname+'/new');}},'Skapa ny'))),_react2.default.createElement('div',{className:'box'},_react2.default.createElement('div',{className:'row align-middle'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_SelectFormInput2.default,{input:{value:!!filter.archived,onBlur:_noop3.default,onChange:function onChange(archived){return filterRoomTemplates(filter.query,archived?archived.value:false);}},label:'Arkiverade',meta:{},valueKey:'value',labelKey:'label',clearable:false,options:_booleanValues2.default}))),roomTemplates&&_react2.default.createElement(_AdminList2.default,{query:filter.query,columns:columns,rows:roomTemplates,onSort:sortItems,onRowSelected:function onRowSelected(row){return history.push(pathname+'/'+row.id);}})));}}]);return RoomTemplatesContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref){var _ref$roomTemplateList=_ref.roomTemplateList,error=_ref$roomTemplateList.error,filter=_ref$roomTemplateList.filter,isFetching=_ref$roomTemplateList.isFetching,roomTemplates=_ref$roomTemplateList.filteredList;return{roomTemplates:roomTemplates,error:error,filter:filter,isFetching:isFetching};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchRoomTemplates:function fetchRoomTemplates(){return dispatch((0,_roomTemplateList.fetchRoomTemplates)());},filterRoomTemplates:function filterRoomTemplates(query,archived){return dispatch((0,_roomTemplateList.filterRoomTemplates)(query,archived));},sortItems:function sortItems(sorter){return dispatch((0,_roomTemplateList.sortItems)(sorter));}};};exports.default=(0,_reactRouterDom.withRouter)((0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(RoomTemplatesContainer));

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _findIndex2=__webpack_require__(99);var _findIndex3=_interopRequireDefault(_findIndex2);var _pick2=__webpack_require__(86);var _pick3=_interopRequireDefault(_pick2);var _toNumber2=__webpack_require__(84);var _toNumber3=_interopRequireDefault(_toNumber2);var _toPairs2=__webpack_require__(259);var _toPairs3=_interopRequireDefault(_toPairs2);var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _values2=__webpack_require__(67);var _values3=_interopRequireDefault(_values2);var _flow2=__webpack_require__(14);var _flow3=_interopRequireDefault(_flow2);var _keys2=__webpack_require__(26);var _keys3=_interopRequireDefault(_keys2);var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _reduxForm=__webpack_require__(4);var _roomTemplateView=__webpack_require__(413);var _form=__webpack_require__(17);var _SaveMenu=__webpack_require__(38);var _SaveMenu2=_interopRequireDefault(_SaveMenu);var _DisableContent=__webpack_require__(40);var _DisableContent2=_interopRequireDefault(_DisableContent);var _RoomTemplateForm=__webpack_require__(1334);var _RoomTemplateForm2=_interopRequireDefault(_RoomTemplateForm);var _ServerError=__webpack_require__(16);var _ServerError2=_interopRequireDefault(_ServerError);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);var _ProductSlots=__webpack_require__(1335);var _ProductSlots2=_interopRequireDefault(_ProductSlots);var _RoomTemplateProductSlotForm=__webpack_require__(1337);var _RoomTemplateProductSlotForm2=_interopRequireDefault(_RoomTemplateProductSlotForm);var _ActionConfirmation=__webpack_require__(21);var _ActionConfirmation2=_interopRequireDefault(_ActionConfirmation);var _Navigation=__webpack_require__(34);var _Navigation2=_interopRequireDefault(_Navigation);__webpack_require__(1338);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: import type {
  State_ as RoomTemplateViewState,
} from '../../reducers/roomTemplateView';*//*:: import type {
  State_ as RoomTemplateListState,
} from '../../reducers/roomTemplateList';*//*:: import type {
  ModifiedState,
  NavigationState,
} from '../../reducers/configTemplateView';*//*:: import type {
  RoomTemplateDto,
  ErrorDto,
  ProductDto,
  ProductSlotDto,
  ProductTypeDto,
  RoomTypeDto,
} from '../../dtos';*/var roomTemplateValidation={name:{rule:'string|required',label:'Namn'}};var basicValidation={roomTypeId:{rule:'numeric|required',label:'Rumstyp'}};var basedOnRoomValidation={basedOnRoomId:{rule:'numeric|required',label:'Rum'}};var basedOnTemplateValidation={basedOnTemplateId:{rule:'numeric|required',label:'Rumsmall'}};var getBasedOnValidation=function getBasedOnValidation(values){return values&&values.slots==='ROOM'?basedOnRoomValidation:values&&values.slots==='TEMPLATE'?basedOnTemplateValidation:basicValidation;};var getRoomTemplateValidation=function getRoomTemplateValidation(values){return _extends({},roomTemplateValidation,getBasedOnValidation(values));};var productSlotValidation={name:{rule:'string|required',label:'Namn'},productTypeId:{rule:'numeric|required',label:'Produkttyp'},unit:{rule:'string',label:'Enhet'},quantity:{rule:'numeric|min:0',label:'Antal'}};/*:: export type Props = {
  setDirty: typeof setDirty,
  reset: typeof reset,
  resetForm: typeof resetForm,
  isRoomTemplateDirty: boolean,
  isProductSlotDirty: boolean,
  clear: typeof clear,
  roomTemplate: ?RoomTemplateDto,
  roomTemplateFormIsValid: boolean,
  roomTemplateFormValues: any,
  createRoomTemplate: typeof createRoomTemplate,
  createProductSlot: typeof createProductSlot,
  error: ?ErrorDto,
  fetchData: typeof fetchData,
  isFetching: boolean,
  params: any,
  prevPath: string,
  products: ?ProductDto[],
  productSlot: ?ProductSlotDto,
  productSlotError: ?ErrorDto,
  productSlotFormIsValid: boolean,
  productSlotFormValues: any,
  productSlotIsFetching: boolean,
  productTypes: ?ProductTypeDto[],
  productSlots: ProductSlotDto[],
  roomTypes: ?RoomTypeDto[],
  selectProductSlot: typeof selectProductSlot,
  touch: typeof touch,
  updateRoomTemplate: typeof updateRoomTemplate,
  updateProductSlot: typeof updateProductSlot,
  openDialog: typeof openDialog,
  closeDialog: typeof closeDialog,
  dialogError: ?ErrorDto,
  dialogIsFetching: boolean,
  showDialog: boolean,
  navigateToVariant: typeof navigateToVariant,
  popDialogNavigation: typeof popDialogNavigation,
  dialogNavigation: ?NavigationState,
  updateRelatedVariant: typeof updateRelatedVariant,
  toggleVariant: typeof toggleVariant,
  setStandardProduct: typeof setStandardProduct,
  modifiedData: ModifiedState,
  standardProductId: ?number,
  toggleProduct: typeof toggleProduct,
  sharedChecked: ?boolean,
  checkAllVariants: typeof checkAllVariants,
  clearStandardProduct: typeof clearStandardProduct,
  checkProduct: typeof checkProduct,
  updateVariants: typeof updateVariants,
  updateProductSlots: typeof updateProductSlots,
  updateVariantsForType: typeof updateVariantsForType,
  roomTemplates: any[],
  projects: any[],
  roomTemplateList: RoomTemplateDto[],
};*/var RoomTemplateContainer=function(_Component){_inherits(RoomTemplateContainer,_Component);function RoomTemplateContainer(){_classCallCheck(this,RoomTemplateContainer);return _possibleConstructorReturn(this,(RoomTemplateContainer.__proto__||Object.getPrototypeOf(RoomTemplateContainer)).apply(this,arguments));}_createClass(RoomTemplateContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData(this.props.params.id);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clear();}},{key:'setDirty',value:function setDirty(form/*: 'roomTemplate' | 'roomTemplateProductSlot'*/){var _props=this.props,setDirty=_props.setDirty,isRoomTemplateDirty=_props.isRoomTemplateDirty,isProductSlotDirty=_props.isProductSlotDirty;if(form==='roomTemplate'){if(isRoomTemplateDirty){return;}}else if(form==='roomTemplateProductSlot'){if(isProductSlotDirty){return;}}else{return;}setDirty(true,form);}},{key:'reset',value:function reset(){var _props2=this.props,setDirty=_props2.setDirty,reset=_props2.reset,resetForm=_props2.resetForm;reset();resetForm('roomTemplate');resetForm('roomTemplateProductSlot');setDirty(false,'roomTemplate');setDirty(false,'roomTemplateProductSlot');}},{key:'validateProductSlotForm',value:function validateProductSlotForm(){var _props3=this.props,productSlotFormIsValid=_props3.productSlotFormIsValid,touch=_props3.touch;var productSlotFields=(0,_keys3.default)(productSlotValidation);touch.apply(undefined,['roomTemplateProductSlot'].concat(_toConsumableArray(productSlotFields)));return productSlotFormIsValid;}},{key:'save',value:function save(){var _props4=this.props,roomTemplate=_props4.roomTemplate,roomTemplateFormIsValid=_props4.roomTemplateFormIsValid,roomTemplateFormValues=_props4.roomTemplateFormValues,createRoomTemplate=_props4.createRoomTemplate,createProductSlot=_props4.createProductSlot,productSlot=_props4.productSlot,productSlotFormValues=_props4.productSlotFormValues,touch=_props4.touch,updateRoomTemplate=_props4.updateRoomTemplate,updateProductSlot=_props4.updateProductSlot,modifiedData=_props4.modifiedData,standardProductId=_props4.standardProductId,closeDialog=_props4.closeDialog;var roomTemplateFields=(0,_keys3.default)(!roomTemplate?getRoomTemplateValidation(roomTemplateFormValues):getRoomTemplateValidation());touch.apply(undefined,['roomTemplate'].concat(_toConsumableArray(roomTemplateFields)));if(!roomTemplateFormIsValid){return;}closeDialog();if(productSlot){if(!this.validateProductSlotForm()){return;}if(productSlot.id){updateProductSlot(productSlot.id,_extends({},productSlotFormValues,{standardProductId:standardProductId,config:(0,_flow3.default)(_values3.default,(0,_filter3.default)('checked'),(0,_map3.default)(function(c){return _extends({},c,{standardProducts:(0,_flow3.default)(_toPairs3.default,(0,_map3.default)(function(_ref){var _ref2=_slicedToArray(_ref,2),productTypeId=_ref2[0],productId=_ref2[1];return{productId:productId,productTypeId:(0,_toNumber3.default)(productTypeId)};}),(0,_filter3.default)(function(x){return!!x.productId;}))(c.standardProducts)});}))(modifiedData)}));}else if(!!roomTemplate&&!!roomTemplate.id){createProductSlot(roomTemplate.id,productSlotFormValues);}}if(!roomTemplate){createRoomTemplate((0,_pick3.default)(roomTemplateFields,roomTemplateFormValues));}else{updateRoomTemplate(roomTemplate.id,roomTemplateFormValues);}}},{key:'render',value:function render(){var _this2=this;var _props5=this.props,isRoomTemplateDirty=_props5.isRoomTemplateDirty,isProductSlotDirty=_props5.isProductSlotDirty,roomTemplate=_props5.roomTemplate,error=_props5.error,isFetching=_props5.isFetching,id=_props5.params.id,prevPath=_props5.prevPath,products=_props5.products,productSlot=_props5.productSlot,productSlotError=_props5.productSlotError,productSlotFormValues=_props5.productSlotFormValues,productSlotIsFetching=_props5.productSlotIsFetching,productTypes=_props5.productTypes,productSlots=_props5.productSlots,roomTypes=_props5.roomTypes,selectProductSlot=_props5.selectProductSlot,updateRoomTemplate=_props5.updateRoomTemplate,updateProductSlot=_props5.updateProductSlot,openDialog=_props5.openDialog,closeDialog=_props5.closeDialog,dialogError=_props5.dialogError,dialogIsFetching=_props5.dialogIsFetching,showDialog=_props5.showDialog,navigateToVariant=_props5.navigateToVariant,popDialogNavigation=_props5.popDialogNavigation,dialogNavigation=_props5.dialogNavigation,updateRelatedVariant=_props5.updateRelatedVariant,toggleVariant=_props5.toggleVariant,setStandardProduct=_props5.setStandardProduct,modifiedData=_props5.modifiedData,toggleProduct=_props5.toggleProduct,sharedChecked=_props5.sharedChecked,checkAllVariants=_props5.checkAllVariants,clearStandardProduct=_props5.clearStandardProduct,checkProduct=_props5.checkProduct,updateVariants=_props5.updateVariants,_updateProductSlots=_props5.updateProductSlots,updateVariantsForType=_props5.updateVariantsForType,roomTemplateFormValues=_props5.roomTemplateFormValues,roomTemplates=_props5.roomTemplates,projects=_props5.projects,clear=_props5.clear,fetchData=_props5.fetchData,roomTemplateList=_props5.roomTemplateList;var _ref3=_react2.default.createElement(_ServerError2.default,{error:productSlotError});return _react2.default.createElement('div',{className:'RoomTemplateContainer relative'},_react2.default.createElement('div',{className:'row align-justify align-middle content-header'},_react2.default.createElement('div',{className:'column shrink'},_react2.default.createElement('div',{className:'row no-row-margins align-middle'},_react2.default.createElement(_Navigation2.default,{current:roomTemplate,list:roomTemplateList,prevPath:prevPath,clear:clear,fetchData:fetchData}),_react2.default.createElement('div',{className:'content-title'},roomTemplate&&roomTemplate.name||'Ny konfiguration'))),_react2.default.createElement('div',{className:'column shrink horizontal-button-list'},roomTemplate&&_react2.default.createElement(_DisableContent2.default,{disabled:isRoomTemplateDirty},_react2.default.createElement(_ActionConfirmation2.default,{id:'archiveConfigTemplate',className:'secondary button',message:'Vill du verkligen '+(roomTemplate.archived?'av':'')+'arkivera den h\xE4r konfigurationen?',buttonText:roomTemplate.archived?'Avarkivera':'Arkivera',action:function action(){return updateRoomTemplate(roomTemplate.id,{archived:!roomTemplate.archived});}})))),_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching||productSlotIsFetching}),_react2.default.createElement(_ServerError2.default,{error:error}),_react2.default.createElement('div',{className:'content-section box'},_react2.default.createElement(_RoomTemplateForm2.default,{initialValues:roomTemplate||{slots:'NONE'},roomTemplate:roomTemplate,roomTemplates:roomTemplates,roomTypes:roomTypes,projects:projects,formValues:roomTemplateFormValues,onUserChange:function onUserChange(){return _this2.setDirty('roomTemplate');},validate:function validate(values){return(0,_validator2.default)(getRoomTemplateValidation(values),values);}})),roomTemplate&&roomTemplate.id&&_react2.default.createElement('div',{className:'content-section slots-section'},_react2.default.createElement('div',{className:'row no-row-margins'},_react2.default.createElement('div',{className:'box-side-tabs shrink'},_react2.default.createElement(_DisableContent2.default,{disabled:isProductSlotDirty},_react2.default.createElement(_ProductSlots2.default,{onSelectProductSlot:function onSelectProductSlot(p){return selectProductSlot(p);},onAddProductSlot:function onAddProductSlot(){return selectProductSlot(null);},selectedProductSlot:productSlot,productSlots:productSlots}))),_react2.default.createElement('div',{className:'box expand'},productSlot&&function(){var slotIndex=(0,_findIndex3.default)({id:productSlot.id},productSlots);return _react2.default.createElement('div',null,_ref3,_react2.default.createElement(_RoomTemplateProductSlotForm2.default,{initialValues:productSlot,formValues:productSlotFormValues,productSlot:productSlot,productTypes:productTypes,room:roomTemplate,products:products,onArchive:function onArchive(){return updateProductSlot(productSlot.id,{archived:!productSlot.archived});},onUserChange:function onUserChange(){return _this2.setDirty('roomTemplateProductSlot');},validate:function validate(values){return(0,_validator2.default)(productSlotValidation,values);},openDialog:openDialog,closeDialog:closeDialog,dialogError:dialogError,dialogIsFetching:dialogIsFetching,dialogNavigation:dialogNavigation,showDialog:showDialog,navigateToVariant:navigateToVariant,popDialogNavigation:popDialogNavigation,updateRelatedVariant:updateRelatedVariant,toggleVariant:toggleVariant,setStandardProduct:setStandardProduct,modifiedData:modifiedData,toggleProduct:toggleProduct,sharedChecked:sharedChecked,checkAllVariants:checkAllVariants,clearStandardProduct:clearStandardProduct,isDirty:isProductSlotDirty,checkProduct:checkProduct,updateVariants:updateVariants,updateVariantsForType:updateVariantsForType,updateProductSlots:function updateProductSlots(sortDirection/*: 'up' | 'down'*/){_updateProductSlots(roomTemplate.id,productSlot.id,sortDirection);},sortDownDisabled:isProductSlotDirty||slotIndex===productSlots.length-1,sortUpDisabled:isProductSlotDirty||slotIndex<=0}));}()))),roomTemplate&&roomTemplate.id!==(0,_toNumber3.default)(id)&&_react2.default.createElement(_reactRouterDom.Redirect,{to:prevPath+'/'+roomTemplate.id}),(isRoomTemplateDirty||isProductSlotDirty)&&_react2.default.createElement(_SaveMenu2.default,{isLoading:isFetching,onDiscard:function onDiscard(){return _this2.reset();},onSave:function onSave(){return _this2.save();}}));}}]);return RoomTemplateContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref4){var _ref4$roomTemplateVie=_ref4.roomTemplateView,_ref4$roomTemplateVie2=_ref4$roomTemplateVie.roomTemplate,roomTemplate=_ref4$roomTemplateVie2.active,error=_ref4$roomTemplateVie2.error,isRoomTemplateDirty=_ref4$roomTemplateVie2.isDirty,isFetching=_ref4$roomTemplateVie2.isFetching,productSlots=_ref4$roomTemplateVie.productSlots,_ref4$roomTemplateVie3=_ref4$roomTemplateVie.productSlot,productSlot=_ref4$roomTemplateVie3.active,productSlotError=_ref4$roomTemplateVie3.error,isProductSlotDirty=_ref4$roomTemplateVie3.isDirty,productSlotIsFetching=_ref4$roomTemplateVie3.isFetching,_ref4$roomTemplateVie4=_ref4$roomTemplateVie3.dialog,dialogError=_ref4$roomTemplateVie4.error,dialogIsFetching=_ref4$roomTemplateVie4.isFetching,showDialog=_ref4$roomTemplateVie4.show,dialogNavigation=_ref4$roomTemplateVie4.navigation,modifiedData=_ref4$roomTemplateVie4.modifiedData,standardProductId=_ref4$roomTemplateVie4.standardProductId,sharedChecked=_ref4$roomTemplateVie4.sharedChecked,roomTypes=_ref4$roomTemplateVie.roomTypes,productTypes=_ref4$roomTemplateVie.productTypes,products=_ref4$roomTemplateVie.products,roomTemplates=_ref4$roomTemplateVie.roomTemplates,projects=_ref4$roomTemplateVie.projects,roomTemplateList=_ref4.roomTemplateList.filteredList,form=_ref4.form;return{roomTemplate:roomTemplate,productSlots:productSlots,productSlot:productSlot,productSlotError:productSlotError,productSlotIsFetching:productSlotIsFetching,error:error,isRoomTemplateDirty:isRoomTemplateDirty,isProductSlotDirty:isProductSlotDirty,isFetching:isFetching,roomTypes:roomTypes,productTypes:productTypes,products:products,roomTemplateFormIsValid:(0,_reduxForm.isValid)('roomTemplate')({form:form}),roomTemplateFormValues:(0,_reduxForm.getFormValues)('roomTemplate')({form:form}),productSlotFormIsValid:(0,_reduxForm.isValid)('roomTemplateProductSlot')({form:form}),productSlotFormValues:(0,_reduxForm.getFormValues)('roomTemplateProductSlot')({form:form}),dialogError:dialogError,dialogIsFetching:dialogIsFetching,showDialog:showDialog,dialogNavigation:dialogNavigation,modifiedData:modifiedData,standardProductId:standardProductId,sharedChecked:sharedChecked,roomTemplates:roomTemplates,projects:projects,roomTemplateList:roomTemplateList};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{setDirty:function setDirty(dirty,form){return dispatch((0,_form.setDirty)(dirty,form));},resetForm:function resetForm(form){return dispatch((0,_reduxForm.reset)(form));},reset:function reset(){return dispatch((0,_roomTemplateView.reset)());},fetchData:function fetchData(id){return dispatch((0,_roomTemplateView.fetchData)(id));},updateRoomTemplate:function updateRoomTemplate(id,data){return dispatch((0,_roomTemplateView.updateRoomTemplate)(id,data));},createRoomTemplate:function createRoomTemplate(data){return dispatch((0,_roomTemplateView.createRoomTemplate)(data));},updateProductSlot:function updateProductSlot(id,data){return dispatch((0,_roomTemplateView.updateProductSlot)(id,data));},createProductSlot:function createProductSlot(roomId,data){return dispatch((0,_roomTemplateView.createProductSlot)(roomId,data));},selectProductSlot:function selectProductSlot(productSlot){return dispatch((0,_roomTemplateView.selectProductSlot)(productSlot));},touch:function touch(form){for(var _len=arguments.length,fields=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){fields[_key-1]=arguments[_key];}return dispatch(_reduxForm.touch.apply(undefined,[form].concat(fields)));},clear:function clear(){return dispatch((0,_roomTemplateView.clear)());},openDialog:function openDialog(productTypeId,rootName){return dispatch((0,_roomTemplateView.openDialog)(productTypeId,rootName));},closeDialog:function closeDialog(){return dispatch((0,_roomTemplateView.closeDialog)());},navigateToVariant:function navigateToVariant(variant){return dispatch((0,_roomTemplateView.navigateToVariant)(variant));},popDialogNavigation:function popDialogNavigation(depth){return dispatch((0,_roomTemplateView.popDialogNavigation)(depth));},updateRelatedVariant:function updateRelatedVariant(variant,data){return dispatch((0,_roomTemplateView.updateRelatedVariant)(variant,data));},toggleVariant:function toggleVariant(variant,expand){return dispatch((0,_roomTemplateView.toggleVariant)(variant,expand));},setStandardProduct:function setStandardProduct(product,productType){return dispatch((0,_roomTemplateView.setStandardProduct)(product,productType));},toggleProduct:function toggleProduct(product){return dispatch((0,_roomTemplateView.toggleProduct)(product));},checkAllVariants:function checkAllVariants(checked){return dispatch((0,_roomTemplateView.checkAllVariants)(checked));},clearStandardProduct:function clearStandardProduct(productType){return dispatch((0,_roomTemplateView.clearStandardProduct)(productType));},checkProduct:function checkProduct(productId,checked){return dispatch((0,_roomTemplateView.checkProduct)(productId,checked));},updateVariants:function updateVariants(productId,data){return dispatch((0,_roomTemplateView.updateVariants)(productId,data));},updateProductSlots:function updateProductSlots(roomId,productSlotId,sortDirection/*: 'up' | 'down'*/){return dispatch((0,_roomTemplateView.updateProductSlots)(roomId,productSlotId,sortDirection));},updateVariantsForType:function updateVariantsForType(productTypeId,data){return dispatch((0,_roomTemplateView.updateVariantsForType)(productTypeId,data));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(RoomTemplateContainer);

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _filter2=__webpack_require__(8);var _filter3=_interopRequireDefault(_filter2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _SelectFormInput=__webpack_require__(12);var _SelectFormInput2=_interopRequireDefault(_SelectFormInput);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {
  RoomTemplateDto,
  RoomTypeDto,
  LimitedProjectDto,
} from '../../dtos';*//*:: export type Props = {
  roomTemplate: ?any,
  roomTypes: RoomTypeDto[],
  projects: LimitedProjectDto[],
  roomTemplates: RoomTemplateDto[],
  formValues: any,
  onUserChange: Function,
};*/var notArchived=(0,_filter3.default)({archived:null});var includeRoomTemplate=function includeRoomTemplate(roomTemplate){return(0,_filter3.default)(function(t){return t.id===roomTemplate.roomTypeId||!t.archived;});};var filterRoomTemplates=function filterRoomTemplates(roomTemplate){return roomTemplate?includeRoomTemplate(roomTemplate):notArchived;};var _ref2=_react2.default.createElement('label',null,'Produktplatser');var _ref3=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'slots',component:'input',type:'radio',value:'NONE'}),' L\xE4gg till manuellt');var _ref4=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'slots',component:'input',type:'radio',value:'ROOM'}),' Kopiera fr\xE5n rum');var _ref5=_react2.default.createElement('label',null,_react2.default.createElement(_reduxForm.Field,{name:'slots',component:'input',type:'radio',value:'TEMPLATE'}),' Basera p\xE5 mall');var RoomTemplateForm=function RoomTemplateForm(_ref){var roomTemplate=_ref.roomTemplate,roomTypes=_ref.roomTypes,projects=_ref.projects,roomTemplates=_ref.roomTemplates,formValues=_ref.formValues,onUserChange=_ref.onUserChange;return _react2.default.createElement('div',{className:'RoomTemplateForm'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'small-6 column'},_react2.default.createElement(_reduxForm.Field,{name:'name',label:'Namn',onChange:onUserChange,component:_BasicFormInput2.default,type:'text'}),!!roomTemplate&&!!roomTemplate.id&&_react2.default.createElement(_reduxForm.Field,{name:'roomTypeId',label:'Rumstyp',normalize:function normalize(value){return value?value.id:null;},onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:filterRoomTemplates(roomTemplate)(roomTypes)}),(!roomTemplate||!roomTemplate.id)&&_react2.default.createElement('div',{onChange:onUserChange},_ref2,_ref3,_react2.default.createElement(_reduxForm.Field,{name:'roomTypeId',label:'Rumstyp',normalize:function normalize(value){return value?value.id:null;},disabled:!formValues||formValues.slots!=='NONE',onChange:onUserChange,component:_SelectFormInput2.default,valueKey:'id',labelKey:'name',options:roomTypes}),_ref4,_react2.default.createElement(_reduxForm.Field,{name:'project',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value:null;},disabled:!formValues||formValues.slots!=='ROOM',placeholder:'V\xE4lj projekt',valueKey:'id',labelKey:'name',options:projects}),_react2.default.createElement(_reduxForm.Field,{name:'config',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value:null;},disabled:!formValues||formValues.slots!=='ROOM'||!formValues.project,placeholder:'V\xE4lj konfiguration',valueKey:'id',labelKey:'name',options:!!formValues&&!!formValues.project?formValues.project.apartmentConfigs:[]}),_react2.default.createElement(_reduxForm.Field,{name:'basedOnRoomId',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value.id:null;},disabled:!formValues||formValues.slots!=='ROOM'||!formValues.project||!formValues.config,placeholder:'V\xE4lj rum',valueKey:'id',labelKey:'name',options:!!formValues&&!!formValues.config?formValues.config.rooms:[]}),_ref5,_react2.default.createElement(_reduxForm.Field,{name:'basedOnTemplateId',component:_SelectFormInput2.default,normalize:function normalize(value){return value?value.id:null;},disabled:!formValues||formValues.slots!=='TEMPLATE',placeholder:'V\xE4lj mall',valueKey:'id',labelKey:'name',options:roomTemplates})))));};exports.default=(0,_reduxForm.reduxForm)({form:'roomTemplate',enableReinitialize:true})(RoomTemplateForm);

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1336);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: import type {
  ProductSlotDto,
} from '../../dtos';*//*:: export type Props = {
  productSlots: ProductSlotDto[],
  selectedProductSlot: ?ProductSlotDto,
  onSelectProductSlot: (productSlot: ProductSlotDto) => any,
  onAddProductSlot: () => any,
};*/var _ref2=_react2.default.createElement('div',{className:'title'},_react2.default.createElement('span',null,'Produktplatser'));var _ref3=_react2.default.createElement('div',{className:'no-slot-label'},'Inga produktplatser');var ProductSlots=function ProductSlots(_ref){var productSlots=_ref.productSlots,onSelectProductSlot=_ref.onSelectProductSlot,onAddProductSlot=_ref.onAddProductSlot,selectedProductSlot=_ref.selectedProductSlot;return _react2.default.createElement('div',{className:'ProductSlots'},_ref2,_react2.default.createElement('div',{className:'slots'},(0,_map3.default)(function(s){return _react2.default.createElement('div',{key:s.id,className:'slot'},_react2.default.createElement('div',{className:(0,_classnames2.default)({active:selectedProductSlot&&selectedProductSlot.id===s.id,'slot-label':true}),onClick:function onClick(){return onSelectProductSlot(s);}},s.name));},productSlots),!productSlots.length&&_ref3),_react2.default.createElement('div',{className:'tools'},_react2.default.createElement('button',{onClick:function onClick(){return onAddProductSlot();},disabled:!!(selectedProductSlot&&!selectedProductSlot.id),type:'button',className:'button small expanded'},'L\xE4gg till produktplats')));};exports.default=ProductSlots;

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reduxForm=__webpack_require__(4);var _ProductSlotForm=__webpack_require__(260);var _ProductSlotForm2=_interopRequireDefault(_ProductSlotForm);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_reduxForm.reduxForm)({form:'roomTemplateProductSlot',enableReinitialize:true})(_ProductSlotForm2.default);

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(1341);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _auth=__webpack_require__(57);var _roles=__webpack_require__(49);var _customerView=__webpack_require__(170);var _CustomerNavbar=__webpack_require__(1342);var _CustomerNavbar2=_interopRequireDefault(_CustomerNavbar);var _CustomerApartment=__webpack_require__(1344);var _CustomerApartment2=_interopRequireDefault(_CustomerApartment);var _CustomerFileList=__webpack_require__(1346);var _CustomerFileList2=_interopRequireDefault(_CustomerFileList);var _CustomerOrderContainer=__webpack_require__(489);var _CustomerOrderContainer2=_interopRequireDefault(_CustomerOrderContainer);var _CoverImage=__webpack_require__(495);var _CoverImage2=_interopRequireDefault(_CoverImage);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  location: { pathname: string },
  user: Object,
  apartment: ?any,
  order: ?any,
  project: ?any,
  isFetching: boolean,
  showMenu: boolean,
  onLogoutClick: Function,
  toggleMenu: Function,
  fetchOrder: Function,
  clear: Function,
  updateOrder: Function,
  userRole: number,
};*/var _ref4=_react2.default.createElement(_LoadingIndicator2.default,{isLoading:true,isGlobal:true});var CustomerContainer=function(_Component){_inherits(CustomerContainer,_Component);function CustomerContainer(){_classCallCheck(this,CustomerContainer);return _possibleConstructorReturn(this,(CustomerContainer.__proto__||Object.getPrototypeOf(CustomerContainer)).apply(this,arguments));}_createClass(CustomerContainer,[{key:'componentWillMount',value:function componentWillMount(){var user=this.props.user;if(user){this.props.fetchOrder(user.orderId);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.props.clear();}},{key:'render',value:function render(){var _props=this.props,_props$location=_props.location;_props$location=_props$location===undefined?{}:_props$location;var _props$location$pathn=_props$location.pathname,pathname=_props$location$pathn===undefined?'':_props$location$pathn,onLogoutClick=_props.onLogoutClick,toggleMenu=_props.toggleMenu,project=_props.project,order=_props.order,apartment=_props.apartment,isFetching=_props.isFetching,showMenu=_props.showMenu,updateOrder=_props.updateOrder,userRole=_props.userRole;var _ref=_react2.default.createElement(_CustomerOrderContainer2.default,{order:order,project:project,apartment:apartment,updateOrder:updateOrder});var _ref2=_react2.default.createElement(_CustomerFileList2.default,{label:'Filer',apartment:apartment});var _ref3=_react2.default.createElement(_reactRouterDom.Redirect,{to:pathname});return _react2.default.createElement(_reactRouterDom.BrowserRouter,null,_react2.default.createElement('div',{className:'CustomerContainer'},order&&apartment&&project&&_react2.default.createElement('div',null,_react2.default.createElement(_CustomerNavbar2.default,{pathname:pathname,showMenu:showMenu,toggleMenu:toggleMenu,onLogoutClick:onLogoutClick,userRole:userRole}),project.coverImage&&_react2.default.createElement('div',{className:'project-cover-image'},_react2.default.createElement(_CoverImage2.default,{imageId:project.coverImage.id})),_react2.default.createElement('div',{className:'row content'},_react2.default.createElement('div',{className:'small-12 large-expand column'},_react2.default.createElement(_reactRouterDom.Switch,null,_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/',exact:true,render:function render(){return _react2.default.createElement(_CustomerApartment2.default,{project:project,showWarning:userRole!==_roles.DEMO,showDemoText:userRole===_roles.DEMO});}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/order',exact:true,render:function render(){return _ref;}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/files',exact:true,render:function render(){return _ref2;}}),_react2.default.createElement(_reactRouterDom.Route,{render:function render(){return _ref3;}}))))),isFetching&&_ref4));}}]);return CustomerContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref5){var userRole=_ref5.auth.currentUser.role,_ref5$customerView=_ref5.customerView,_ref5$customerView$or=_ref5$customerView.order,order=_ref5$customerView$or.order,project=_ref5$customerView$or.project,apartment=_ref5$customerView$or.apartment,isFetching=_ref5$customerView$or.isFetching,showMenu=_ref5$customerView.showMenu;return{order:order,project:project,apartment:apartment,isFetching:isFetching,showMenu:showMenu,userRole:userRole};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchOrder:function fetchOrder(id){return dispatch((0,_customerView.fetchOrder)(id));},onLogoutClick:function onLogoutClick(){return dispatch((0,_auth.logout)());},toggleMenu:function toggleMenu(show){return dispatch((0,_customerView.toggleMenu)(show));},clear:function clear(){return dispatch((0,_customerView.clear)());},updateOrder:function updateOrder(id,state){return dispatch((0,_customerView.updateOrder)(id,state));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(CustomerContainer);

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRouterDom=__webpack_require__(10);var _classnames=__webpack_require__(19);var _classnames2=_interopRequireDefault(_classnames);__webpack_require__(1343);var _logo=__webpack_require__(269);var _logo2=_interopRequireDefault(_logo);var _roles=__webpack_require__(49);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  history: Object,
  pathname: string,
  showMenu: boolean,
  toggleMenu: Function,
  onLogoutClick: Function,
  userRole: number,
};*/var _ref2=_react2.default.createElement('i',{className:'fa fa-bars'});var _ref3=_react2.default.createElement('img',{src:_logo2.default,alt:'H\xF6kerum'});var _ref4=_react2.default.createElement('div',{className:'CustomerNavbar-item-label'},'Hem');var _ref5=_react2.default.createElement('div',{className:'CustomerNavbar-item-label'},'Mina tillval');var _ref6=_react2.default.createElement('div',{className:'CustomerNavbar-item-label'},'Mina filer');var _ref7=_react2.default.createElement('div',{className:'CustomerNavbar-item-label'},'Logga ut');var CustomerNavbar=function CustomerNavbar(_ref){var pathname=_ref.pathname,showMenu=_ref.showMenu,toggleMenu=_ref.toggleMenu,onLogoutClick=_ref.onLogoutClick,history=_ref.history,userRole=_ref.userRole;return _react2.default.createElement('div',{className:'CustomerNavbar'},_react2.default.createElement('div',{className:'row fill-height'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('div',{className:'CustomerNavbar-menu'},_react2.default.createElement('div',{className:'CustomerNavbar-menu-toggle show-for-small-only',onClick:function onClick(){return toggleMenu(!showMenu);}},_ref2),_react2.default.createElement('a',{href:'',onClick:function onClick(evt){evt.preventDefault();history.push(pathname+'/');},className:'CustomerNavbar-logo'},_ref3),_react2.default.createElement('div',{className:(0,_classnames2.default)({'CustomerNavbar-navigation':true,'hide-for-small-only':!showMenu})},_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/',className:'CustomerNavbar-item',activeClassName:'active',exact:true},_ref4),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/order',className:'CustomerNavbar-item',activeClassName:'active'},_ref5),userRole!==_roles.DEMO&&_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/files',className:'CustomerNavbar-item',activeClassName:'active'},_ref6),_react2.default.createElement('a',{href:'',onClick:function onClick(evt){evt.preventDefault();onLogoutClick();},className:'CustomerNavbar-item'},_ref7))))));};exports.default=(0,_reactRouterDom.withRouter)(CustomerNavbar);

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactLinkify=__webpack_require__(179);var _reactLinkify2=_interopRequireDefault(_reactLinkify);var _request=__webpack_require__(6);var _WarningText=__webpack_require__(268);var _WarningText2=_interopRequireDefault(_WarningText);var _DemoInfoBox=__webpack_require__(498);var _DemoInfoBox2=_interopRequireDefault(_DemoInfoBox);__webpack_require__(1345);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fileUrl=_request.apiBase+'/files';/*:: export type Props = {
  project: Object,
  showWarning: Boolean,
  showDemoText: Boolean,
};*/var _ref2=_react2.default.createElement(_DemoInfoBox2.default,null);var _ref3=_react2.default.createElement(_WarningText2.default,null);var CustomerApartment=function CustomerApartment(_ref){var project=_ref.project,showWarning=_ref.showWarning,showDemoText=_ref.showDemoText;return _react2.default.createElement('div',{className:'CustomerApartment'},_react2.default.createElement('div',{className:'CustomerApartmentHeader w-100'},_react2.default.createElement('div',{className:'page-header',style:{alignSelf:'flex-end'}},_react2.default.createElement('div',{className:'page-title'},project.name)),_react2.default.createElement('div',{className:'f-11',style:{width:'55%',marginLeft:'30px'}},showDemoText&&_ref2)),_react2.default.createElement(_reactLinkify2.default,{properties:{target:'_blank'}},_react2.default.createElement('p',{className:'preserve-whitespace'},project.description)),project.brochure&&_react2.default.createElement('a',{href:fileUrl+'/'+project.brochure.id+'?download',target:'_blank',className:'file-link'},'Informationsbroschyr'),showWarning&&_ref3);};exports.default=CustomerApartment;

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _WarningText=__webpack_require__(268);var _WarningText2=_interopRequireDefault(_WarningText);__webpack_require__(1347);var _FormattedDate=__webpack_require__(460);var _FormattedDate2=_interopRequireDefault(_FormattedDate);var _request=__webpack_require__(6);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var fileUrl=_request.apiBase+'/files';var generateArchived=function generateArchived(label,oldItems){return!!(oldItems&&!!oldItems.length)&&_react2.default.createElement('div',null,_react2.default.createElement('label',null,'Arkiverade ',label),_react2.default.createElement('div',{className:'file-list'},(0,_map3.default)(function(f){return _react2.default.createElement('a',{href:fileUrl+'/'+f.id+'?download',target:'_blank',key:f.id,className:'item text-truncate'},_react2.default.createElement(_FormattedDate2.default,{className:'item-date',value:f.archived}),_react2.default.createElement('span',{className:'item-name'},f.name));},oldItems)));};var generateList=function generateList(singleLabel,multiLabel,currentItem,oldItems){return _react2.default.createElement('div',{className:'CustomerFileList'},_react2.default.createElement('label',{className:'headlabel'},singleLabel),_react2.default.createElement('div',{className:'file-list'},!currentItem&&_react2.default.createElement('div',{className:'empty-item'},singleLabel,' saknas')||_react2.default.createElement('a',{href:fileUrl+'/'+currentItem.id+'?download',target:'_blank',key:currentItem.id,className:'item text-truncate'},_react2.default.createElement('span',{className:'item-name'},currentItem.name))),generateArchived(multiLabel,oldItems));};/*:: export type Props = {
  apartment: any,
};*/var _ref2=_react2.default.createElement(_WarningText2.default,null);var CustomerFileList=function CustomerFileList(_ref){var apartment=_ref.apartment;return _react2.default.createElement('div',null,_react2.default.createElement('div',{className:'page-header'},_react2.default.createElement('div',{className:'page-title'},'Filer f\xF6r l\xE4genhet ',apartment.objectId)),generateList('Beställningsunderlag','Beställningsunderlag',apartment.contract,apartment.oldContracts),generateList('Planritning','Planritningar',apartment.floorPlan,apartment.oldFloorPlans),generateList('Köksritning','Köksritningar',apartment.kitchenPlan,apartment.oldKitchenPlans),_ref2);};exports.default=CustomerFileList;

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _PurchaseOrderReportContainer=__webpack_require__(178);var _PurchaseOrderReportContainer2=_interopRequireDefault(_PurchaseOrderReportContainer);var _SiteManagerReportContainer=__webpack_require__(481);var _SiteManagerReportContainer2=_interopRequireDefault(_SiteManagerReportContainer);var _AdminNavbar=__webpack_require__(482);var _AdminNavbar2=_interopRequireDefault(_AdminNavbar);var _auth=__webpack_require__(57);var _OrdersContainer=__webpack_require__(483);var _OrdersContainer2=_interopRequireDefault(_OrdersContainer);__webpack_require__(1349);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  location: { pathname: string },
  onLogoutClick: Function,
};*///  weak
// import _ from 'lodash/fp';
var _ref2=_react2.default.createElement('div',{className:'MenuItem-label'},'Platschefsrapport');var _ref3=_react2.default.createElement('div',{className:'MenuItem-label'},'Ink\xF6psrapport');var _ref4=_react2.default.createElement('div',{className:'MenuItem-label'},'Best\xE4llningar');var _ref5=_react2.default.createElement(_OrdersContainer2.default,{readonly:true});var SiteManagerContainer=function SiteManagerContainer(_ref){var _ref$location=_ref.location;_ref$location=_ref$location===undefined?{}:_ref$location;var _ref$location$pathnam=_ref$location.pathname,pathname=_ref$location$pathnam===undefined?'':_ref$location$pathnam,onLogoutClick=_ref.onLogoutClick;return _react2.default.createElement(_reactRouterDom.BrowserRouter,null,_react2.default.createElement('div',{className:'SiteManagerContainer'},_react2.default.createElement(_AdminNavbar2.default,{onLogoutClick:onLogoutClick}),_react2.default.createElement('div',{className:'row content'},_react2.default.createElement('div',{className:'shrink column'},_react2.default.createElement('div',{className:'Sidebar'},_react2.default.createElement('div',{className:'Sidebar-content'},_react2.default.createElement('div',{className:'SiteManagerMenu'},_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/sitemanagerreport',className:'SiteManagerMenu-item',activeClassName:'active'},_ref2),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/purchasereport',className:'SiteManagerMenu-item',activeClassName:'active'},_ref3),_react2.default.createElement(_reactRouterDom.NavLink,{to:pathname+'/orders',className:'SiteManagerMenu-item',activeClassName:'active'},_ref4))))),_react2.default.createElement('div',{className:'small-12 large-expand column flex'},_react2.default.createElement(_reactRouterDom.Switch,null,_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/orders',exact:true,component:function component(){return _ref5;}}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/purchasereport',exact:true,component:_PurchaseOrderReportContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{path:pathname+'/sitemanagerreport',exact:true,component:_SiteManagerReportContainer2.default}),_react2.default.createElement(_reactRouterDom.Route,{render:function render(){return _react2.default.createElement(_reactRouterDom.Redirect,{to:pathname+'/sitemanagerreport'});}}))))));};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{onLogoutClick:function onLogoutClick(){return dispatch((0,_auth.logout)());}};};exports.default=(0,_reactRedux.connect)(function(){return{};},mapDispatchToProps)(SiteManagerContainer);

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _auth=__webpack_require__(57);var _Login=__webpack_require__(1352);var _Login2=_interopRequireDefault(_Login);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  isAuthenticated: boolean,
  onLoginClick: Function,
};*/var _ref2=_react2.default.createElement(_reactRouterDom.Redirect,{to:'/'});var LoginContainer=function LoginContainer(_ref){var isAuthenticated=_ref.isAuthenticated,onLoginClick=_ref.onLoginClick;return isAuthenticated?_ref2:_react2.default.createElement(_Login2.default,{onLoginClick:onLoginClick});};exports.default=(0,_reactRedux.connect)(function(_ref3){var isAuthenticated=_ref3.auth.isAuthenticated;return{isAuthenticated:isAuthenticated};},function(dispatch){return{onLoginClick:function onLoginClick(username,password){return dispatch((0,_auth.login)(username,password));}};})(LoginContainer);

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _trim2=__webpack_require__(1353);var _trim3=_interopRequireDefault(_trim2);var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _bg=__webpack_require__(499);var _bg2=_interopRequireDefault(_bg);__webpack_require__(1357);var _logo=__webpack_require__(269);var _logo2=_interopRequireDefault(_logo);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  onLoginClick: Function,
};*/var _ref=_react2.default.createElement('img',{src:_logo2.default,className:'Login-logo',alt:'logo'});var _ref2=_react2.default.createElement('h1',null,'dina tillval');var _ref3=_react2.default.createElement('h2',null,'personliga val - f\xF6r din smakfulla nya bostad');var _ref4=_react2.default.createElement('p',null,'V\xE4lkommen till dina tillval!');var _ref7=_react2.default.createElement('button',{className:'button expanded',type:'submit'},'Logga in');var _ref8=_react2.default.createElement('span',{className:'Login-text'},'Inget konto - ',_react2.default.createElement('a',{href:'mailto:anki.hagstrom@hokerumbygg.se'},'kontakta v\xE5ra s\xE4ljare.'));var Login=function(_Component){_inherits(Login,_Component);function Login(){_classCallCheck(this,Login);return _possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).apply(this,arguments));}_createClass(Login,[{key:'render',value:function render(){var _this2=this;return _react2.default.createElement('div',{className:'Login'},_react2.default.createElement('div',{className:'Login-background',style:{backgroundImage:'url(\''+_bg2.default+'\')'}}),_react2.default.createElement('div',{className:'row align-center'},_react2.default.createElement('div',{className:'column'},_ref,_ref2,_ref3,_ref4,_react2.default.createElement('div',{className:'row align-center'},_react2.default.createElement('form',{role:'form',className:'Login-form column shrink',onSubmit:function onSubmit(e){return _this2.login(e);}},_react2.default.createElement('input',{type:'text',ref:function ref(_ref5){return _this2._username=_ref5;},name:'username',placeholder:'Anv\xE4ndarnamn',required:true}),_react2.default.createElement('input',{type:'password',ref:function ref(_ref6){return _this2._password=_ref6;},name:'password',placeholder:'L\xF6senord',required:true}),_ref7,_ref8)))));}},{key:'login',value:function login(e/*: Event*/){e.preventDefault();if(this._username&&this._password){var username=(0,_trim3.default)(this._username.value);var password=this._password.value;this.props.onLoginClick(username,password);}}}]);return Login;}(_react.Component);exports.default=Login;

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(3),
    func = convert('trim', __webpack_require__(1354));

func.placeholder = __webpack_require__(1);
module.exports = func;


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(117),
    castSlice = __webpack_require__(491),
    charsEndIndex = __webpack_require__(1355),
    charsStartIndex = __webpack_require__(1356),
    stringToArray = __webpack_require__(493),
    toString = __webpack_require__(79);

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return string.replace(reTrim, '');
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(112);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(112);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 1357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();__webpack_require__(1359);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _auth=__webpack_require__(57);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  projectName: String,
  isAuthenticated: Boolean,
  isFetching: Boolean,
  error: Object,
  loginDemoProject: Function,
};*/var _ref=_react2.default.createElement(_reactRouterDom.Redirect,{to:'/'});var _ref2=_react2.default.createElement('p',null,_react2.default.createElement('span',{className:'f-bold'},'Misslyckades logga in demo anv\xE4ndare'));var _ref3=_react2.default.createElement('br',null);var DemoRedirectContainer=function(_Component){_inherits(DemoRedirectContainer,_Component);function DemoRedirectContainer(){_classCallCheck(this,DemoRedirectContainer);return _possibleConstructorReturn(this,(DemoRedirectContainer.__proto__||Object.getPrototypeOf(DemoRedirectContainer)).apply(this,arguments));}_createClass(DemoRedirectContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.loginDemoProject(this.props.projectName);}},{key:'render',value:function render(){var _props=this.props,projectName=_props.projectName,isAuthenticated=_props.isAuthenticated,isFetching=_props.isFetching,error=_props.error;if(isFetching){return _react2.default.createElement('div',null,'Logging in demo user',_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isFetching}));}if(isAuthenticated){return _ref;}return _react2.default.createElement('div',{className:'demo-redirect-error-container'},_react2.default.createElement('div',{className:'callout alert w-100'},_ref2,_react2.default.createElement('p',null,'Projekt: ',projectName,_ref3,'Fel: ',error)));}}]);return DemoRedirectContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref4){var _ref4$auth=_ref4.auth,isAuthenticated=_ref4$auth.isAuthenticated,isFetching=_ref4$auth.isFetching,error=_ref4$auth.error;return{isAuthenticated:isAuthenticated,isFetching:isFetching,error:error};};exports.default=(0,_reactRedux.connect)(mapStateToProps,function(dispatch){return{loginDemoProject:function loginDemoProject(username,password){return dispatch((0,_auth.demoLogin)(username,password));}};})(DemoRedirectContainer);

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactRedux=__webpack_require__(2);var _reactRouterDom=__webpack_require__(10);var _activation=__webpack_require__(407);var _Activation=__webpack_require__(1361);var _Activation2=_interopRequireDefault(_Activation);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*:: export type Props = {
  token: string,
  user: ?any,
  isActivated: boolean,
  fetchData: Function,
  error: ?any,
  tokenError: ?any,
  isFetching: boolean,
  onActivation: Function,
};*/var _ref=_react2.default.createElement(_reactRouterDom.Redirect,{to:'/'});var ActivationContainer=function(_Component){_inherits(ActivationContainer,_Component);function ActivationContainer(){_classCallCheck(this,ActivationContainer);return _possibleConstructorReturn(this,(ActivationContainer.__proto__||Object.getPrototypeOf(ActivationContainer)).apply(this,arguments));}_createClass(ActivationContainer,[{key:'componentWillMount',value:function componentWillMount(){this.props.fetchData(this.props.token);}},{key:'render',value:function render(){var _props=this.props,token=_props.token,onActivation=_props.onActivation,isActivated=_props.isActivated,user=_props.user,isFetching=_props.isFetching,error=_props.error,tokenError=_props.tokenError;return isActivated||!!tokenError?_ref:_react2.default.createElement(_Activation2.default,{user:user,isLoading:isFetching,error:error,onActivation:function(_onActivation){function onActivation(_x){return _onActivation.apply(this,arguments);}onActivation.toString=function(){return _onActivation.toString();};return onActivation;}(function(values){return onActivation(token,values);})});}}]);return ActivationContainer;}(_react.Component);var mapStateToProps=function mapStateToProps(_ref2){var _ref2$activation=_ref2.activation,isActivated=_ref2$activation.isActivated,user=_ref2$activation.user,isFetching=_ref2$activation.isFetching,error=_ref2$activation.error,tokenError=_ref2$activation.tokenError;return{isActivated:isActivated,isFetching:isFetching,user:user,error:error,tokenError:tokenError};};var mapDispatchToProps=function mapDispatchToProps(dispatch){return{fetchData:function fetchData(token){return dispatch((0,_activation.fetchUser)(token));},onActivation:function onActivation(token,data){return dispatch((0,_activation.activate)(token,data));}};};exports.default=(0,_reactRedux.connect)(mapStateToProps,mapDispatchToProps)(ActivationContainer);

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _PasswordForm=__webpack_require__(1362);var _PasswordForm2=_interopRequireDefault(_PasswordForm);var _bg=__webpack_require__(499);var _bg2=_interopRequireDefault(_bg);var _logo=__webpack_require__(269);var _logo2=_interopRequireDefault(_logo);var _LoadingIndicator=__webpack_require__(7);var _LoadingIndicator2=_interopRequireDefault(_LoadingIndicator);__webpack_require__(1363);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  user: ?any,
  onActivation: Function,
  error: ?any,
  isLoading: boolean,
};*/var _ref2=_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement('img',{src:_logo2.default,className:'Activation-logo',alt:'logo'}),_react2.default.createElement('h1',null,'dina tillval'),_react2.default.createElement('p',{className:'Activation-info'},'V\xE4lj ett l\xF6senord f\xF6r ditt anv\xE4ndarkonto')));var _ref3=_react2.default.createElement('label',null,'Anv\xE4ndarnamn');var _ref4=_react2.default.createElement('div',{className:'row align-center'},_react2.default.createElement('div',{className:'column small-12 medium-10 large-7'},_react2.default.createElement('div',{className:'callout warning'},'Ett fel har intr\xE4ffat, v\xE4nligen f\xF6rs\xF6k igen. Har du forsatt problem s\xE5 kontakta oss!')));var Activation=function Activation(_ref){var user=_ref.user,onActivation=_ref.onActivation,isLoading=_ref.isLoading,error=_ref.error;return _react2.default.createElement('div',{className:'Activation'},_react2.default.createElement(_LoadingIndicator2.default,{isLoading:isLoading}),_react2.default.createElement('div',{className:'Activation-background',style:{backgroundImage:'url(\''+_bg2.default+'\')'}}),user&&!error&&_react2.default.createElement('div',null,_ref2,_react2.default.createElement('div',{className:'row align-center'},_react2.default.createElement('div',{className:'Form column box'},_react2.default.createElement('div',{className:'row'},_react2.default.createElement('div',{className:'column'},_ref3,_react2.default.createElement('p',null,user.username))),_react2.default.createElement('div',{className:'row align-center'},_react2.default.createElement('div',{className:'column'},_react2.default.createElement(_PasswordForm2.default,{onSubmit:onActivation})))))),!!error&&_ref4);};exports.default=Activation;

/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reduxForm=__webpack_require__(4);var _BasicFormInput=__webpack_require__(27);var _BasicFormInput2=_interopRequireDefault(_BasicFormInput);var _validator=__webpack_require__(28);var _validator2=_interopRequireDefault(_validator);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var validation={password_confirmation:{rule:'string|required|min:6|max:255',label:'Lösenord'},password:{rule:'string|required|confirmed|max:255',label:'Lösenord'}};/*:: export type Props = {
  handleSubmit: Function,
};*/var _ref2=_react2.default.createElement(_reduxForm.Field,{name:'password_confirmation',label:'L\xF6senord',component:_BasicFormInput2.default,type:'password'});var _ref3=_react2.default.createElement(_reduxForm.Field,{name:'password',label:'Repetera l\xF6senord',component:_BasicFormInput2.default,type:'password'});var _ref4=_react2.default.createElement('button',{type:'submit',className:'button success expanded'},'Spara');var PasswordForm=function PasswordForm(_ref){var handleSubmit=_ref.handleSubmit;return _react2.default.createElement('div',{className:'PasswordForm'},_react2.default.createElement('form',{onSubmit:handleSubmit},_ref2,_ref3,_ref4));};exports.default=(0,_reduxForm.reduxForm)({form:'password',validate:function validate(values){return(0,_validator2.default)(validation,values);}})(PasswordForm);

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _reactRedux=__webpack_require__(2);var _notification=__webpack_require__(23);var _Notifications=__webpack_require__(1365);var _Notifications2=_interopRequireDefault(_Notifications);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=(0,_reactRedux.connect)(function(_ref){var notifications=_ref.notifications;return{notifications:notifications};},function(dispatch){return{removeNotification:function removeNotification(id){return dispatch((0,_notification.removeNotification)(id));}};})(_Notifications2.default);

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});var _map2=__webpack_require__(5);var _map3=_interopRequireDefault(_map2);var _react=__webpack_require__(0);var _react2=_interopRequireDefault(_react);var _reactNotification=__webpack_require__(1366);__webpack_require__(1369);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}/*:: export type Props = {
  removeNotification: Function,
  notifications: any[],
};*/var _ref2=_react2.default.createElement('i',{className:'fa fa-close'});var Notifications=function Notifications(_ref){var removeNotification=_ref.removeNotification,notifications=_ref.notifications;return _react2.default.createElement('div',{className:'Notifications'},_react2.default.createElement(_reactNotification.NotificationStack,{notifications:(0,_map3.default)(function(n){return{message:n.message,key:n.id,action:_ref2,dismissAfter:2000,style:false,className:n.level,onClick:function onClick(){return removeNotification(n.id);}};},notifications),onDismiss:function onDismiss(n){return removeNotification(n.key);}}));};exports.default=Notifications;

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification = __webpack_require__(500);

Object.defineProperty(exports, 'Notification', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_notification).default;
  }
});

var _notificationStack = __webpack_require__(1367);

Object.defineProperty(exports, 'NotificationStack', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_notificationStack).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/jsx-no-bind */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(9);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stackedNotification = __webpack_require__(1368);

var _stackedNotification2 = _interopRequireDefault(_stackedNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function defaultBarStyleFactory(index, style) {
  return _extends({}, style, { bottom: 2 + index * 4 + 'rem' });
}

function defaultActionStyleFactory(index, style) {
  return _extends({}, style, {});
}

/**
* The notification list does not have any state, so use a
* pure function here. It just needs to return the stacked array
* of notification components.
*/
var NotificationStack = function NotificationStack(props) {
  return _react2.default.createElement(
    'div',
    { className: 'notification-list' },
    props.notifications.map(function (notification, index) {
      var isLast = index === 0 && props.notifications.length === 1;
      var dismissNow = isLast || !props.dismissInOrder;

      // Handle styles
      var barStyle = props.barStyleFactory(index, notification.barStyle, notification);
      var actionStyle = props.actionStyleFactory(index, notification.actionStyle, notification);
      var activeBarStyle = props.activeBarStyleFactory(index, notification.activeBarStyle, notification);

      // Allow onClick from notification stack or individual notifications
      var onClick = notification.onClick || props.onClick;
      var onDismiss = props.onDismiss;

      var dismissAfter = notification.dismissAfter;


      if (dismissAfter !== false) {
        if (dismissAfter == null) dismissAfter = props.dismissAfter;
        if (!dismissNow) dismissAfter += index * 1000;
      }

      return _react2.default.createElement(_stackedNotification2.default, _extends({}, notification, {
        key: notification.key,
        isLast: isLast,
        action: notification.action || props.action,
        dismissAfter: dismissAfter,
        onDismiss: onDismiss.bind(undefined, notification),
        onClick: onClick.bind(undefined, notification),
        activeBarStyle: activeBarStyle,
        barStyle: barStyle,
        actionStyle: actionStyle
      }));
    })
  );
};

/* eslint-disable react/no-unused-prop-types, react/forbid-prop-types */
NotificationStack.propTypes = {
  activeBarStyleFactory: _propTypes2.default.func,
  barStyleFactory: _propTypes2.default.func,
  actionStyleFactory: _propTypes2.default.func,
  dismissInOrder: _propTypes2.default.bool,
  notifications: _propTypes2.default.array.isRequired,
  onDismiss: _propTypes2.default.func.isRequired,
  onClick: _propTypes2.default.func,
  action: _propTypes2.default.string
};

NotificationStack.defaultProps = {
  activeBarStyleFactory: defaultBarStyleFactory,
  barStyleFactory: defaultBarStyleFactory,
  actionStyleFactory: defaultActionStyleFactory,
  dismissInOrder: true,
  dismissAfter: 1000,
  onClick: function onClick() {}
};
/* eslint-enable no-alert, no-console */

exports.default = NotificationStack;

/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _defaultPropTypes = __webpack_require__(501);

var _defaultPropTypes2 = _interopRequireDefault(_defaultPropTypes);

var _notification = __webpack_require__(500);

var _notification2 = _interopRequireDefault(_notification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StackedNotification = function (_Component) {
  _inherits(StackedNotification, _Component);

  function StackedNotification(props) {
    _classCallCheck(this, StackedNotification);

    var _this = _possibleConstructorReturn(this, (StackedNotification.__proto__ || Object.getPrototypeOf(StackedNotification)).call(this, props));

    _this.state = {
      isActive: false
    };

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(StackedNotification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.activeTimeout = setTimeout(this.setState.bind(this, {
        isActive: true
      }), 1);

      this.dismiss(this.props.dismissAfter);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dismissAfter !== this.props.dismissAfter) {
        this.dismiss(nextProps.dismissAfter);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.activeTimeout);
      clearTimeout(this.dismissTimeout);
    }
  }, {
    key: 'dismiss',
    value: function dismiss(dismissAfter) {
      if (dismissAfter === false) return;

      this.dismissTimeout = setTimeout(this.setState.bind(this, {
        isActive: false
      }), dismissAfter);
    }

    /*
    * @function handleClick
    * @description Bind deactivate Notification function to Notification click handler
    */

  }, {
    key: 'handleClick',
    value: function handleClick() {
      if (this.props.onClick && typeof this.props.onClick === 'function') {
        return this.props.onClick(this.setState.bind(this, { isActive: false }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_notification2.default, _extends({}, this.props, {
        onClick: this.handleClick,
        onDismiss: function onDismiss() {
          return setTimeout(_this2.props.onDismiss, 300);
        },
        isActive: this.state.isActive
      }));
    }
  }]);

  return StackedNotification;
}(_react.Component);

StackedNotification.propTypes = _defaultPropTypes2.default;

exports.default = StackedNotification;

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=register;exports.unregister=unregister;// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));var registerValidSW=function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});};var checkValidServiceWorker=function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});};function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.81453aaa.js